var kM = Object.defineProperty;
var FM = (_, s, r) => s in _ ? kM(_, s, { enumerable: !0, configurable: !0, writable: !0, value: r }) : _[s] = r;
var N = (_, s, r) => (FM(_, typeof s != "symbol" ? s + "" : s, r), r);
var nn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function wM(_) {
  return _ && _.__esModule && Object.prototype.hasOwnProperty.call(_, "default") ? _.default : _;
}
var lI = { exports: {} }, ZS = { exports: {} }, QS = { exports: {} }, qS = { exports: {} }, eh = { exports: {} }, _4;
function yh() {
  return _4 || (_4 = 1, function(_, s) {
    (function(r, i) {
      _.exports = i();
    })(nn, function() {
      var r = {}, i, a, p, E, h, L, y, V, Z, le, ce, ve, et, Te, Le, we, ot, pr, Zt, Je, Rt, Wr, Un, No, i_, Gr, ur, Cr, fe, vT, on, Ar, ii, tt, kr, oi, bo, ge, Vn, Gn, Fr, Hr, o_, dr, K, be, Ti, Be, b_, Tt, Sr, wi, C_, wr, Qt, O_, xr, T_, Hn, si, R_, Xr, li, k, I, R, B, Y, ie, ke, yt, y_, ea, ai, v_, Ut, $T, Co, WT, Bi, m, b, W, H, ee, me, Ge, qt, Yi, Pe, hr, It, vs, Ui, Oo, kT, xn, cp, $s, JE, pp, $_, s_, up, FT, ta, Ep, Ro, Ws, ra, na, jE, zE, Ap, ks, dp, Sp, ci, Fs, W_, hp, ws, Ip, Mp, mp, Pp, _a, ZE, Dp, Bs, ia, yo, Ys, Lp, QE, oa, Us, gp, l_, qE, eA, tA, fp, rA, nA, _A, Np, k_, Ta, bp, iA, oA, TA, vt, Ct, sA, lA, aA, Cp, cA, Vi, Op, pA, Lr, Gi, pi, vo, Vs, Tn, sa, $o, Gs, Hs, Rp, wT, Kr, yp, sn, vp, la, F_, xs, Wo, $t, Nn, BT, a_, Xs, $p, uA, Ks, aa, YT, ko, ca, pa, Wp, ua, Ea, kp, EA, Hi, Js, Fp, UT, Jr, Aa, VT, da, Sa, ui, wp, Bp, AA, dA, Fo, SA, Yp, ha, Ia, Ei, c_, js, Ma, ma, Xn, bn, zs, Up, xt, Pa, GT, wo, Bo, G, Q, J, Me, Ye, ut, sr, Pt, Da, hA, ln, Br, IA, Yo, an, Mt, St, MA, La, Kn, ga, mA, Zs, Uo, Ai, Vo, Vp, Go, fa, Na, Qs, ba, xi, Xi, qs, PA, Gp, Ca, HT, Ho, Oa, Ra, Hp, DA, cn, Ee, mt, Or, Wt, p_, xT, de, kt, el, xo, Xo, Ko, XT, Ki, xp, Xp, KT, JT, Kp, tl, Ji, ya, C, ji, rl, pn, nt, Jp, jp, nl, zi, zp, va, LA, gA, Zp, Cn, fA, NA, bA, CA, _l, u_, Qp, qp, OA, il, eu, Jn, RA, tu, On, ru, nu, _u, iu, ou, $a, ol, Tl, Tu, Wa, Jo, jT, su, ka, lu, E_, sl, Zi, un, Qi, ll, al, jo, di, Fa, wa, zT, au, cu, Ir, Ba, Ya, jn, cl, zo, Si, pl, gr, ZT, yA, vA, $A, Ua, WA, QT, pu, kA, uu, Zo, Eu, Au, Va, du, Su, hu, Iu, Ga, ul, Mu, El, Ha, mu, Pu, Ce;
      i = function(e, t, n, o) {
        if (!(e instanceof se) && typeof e != "string" || `${e}`.trim() === "")
          throw Error('Invalid type "' + e + '". The type must be a non-empty string or a Blockly.registry.Type.');
        if (e = `${e}`.toLowerCase(), typeof t != "string" || t.trim() === "")
          throw Error('Invalid name "' + t + '". The name must be a non-empty string.');
        const c = t.toLowerCase();
        if (!n)
          throw Error("Can not register a null value");
        let A = hi[e], D = xa[e];
        if (A || (A = hi[e] = /* @__PURE__ */ Object.create(null), D = xa[e] = /* @__PURE__ */ Object.create(null)), a(e, n), !o && A[c])
          throw Error('Name "' + c + '" with type "' + e + '" already registered.');
        A[c] = n, D[c] = t;
      }, a = function(e, t) {
        switch (e) {
          case String(se.FIELD):
            if (typeof t.fromJson != "function")
              throw Error('Type "' + e + '" must have a fromJson function');
        }
      }, p = function(e, t) {
        e = `${e}`.toLowerCase(), t = t.toLowerCase();
        const n = hi[e];
        n && n[t] ? (delete hi[e][t], delete xa[e][t]) : console.warn("Unable to unregister [" + t + "][" + e + "] from the registry.");
      }, E = function(e, t, n) {
        e = `${e}`.toLowerCase(), t = t.toLowerCase();
        const o = hi[e];
        if (!o || !o[t]) {
          if (t = "Unable to find [" + t + "][" + e + "] in the registry.", n)
            throw Error(t + " You must require or register a " + e + " plugin.");
          return console.warn(t), null;
        }
        return o[t];
      }, h = function(e, t) {
        return e = `${e}`.toLowerCase(), t = t.toLowerCase(), (e = hi[e]) ? !!e[t] : !1;
      }, L = function(e, t, n) {
        return E(e, t, n);
      }, y = function(e, t, n) {
        return E(e, t, n);
      }, V = function(e, t, n) {
        e = `${e}`.toLowerCase();
        var o = hi[e];
        if (!o) {
          if (o = `Unable to find [${e}] in the registry.`, n)
            throw Error(`${o} You must require or register a ${e} plugin.`);
          return console.warn(o), null;
        }
        if (!t)
          return o;
        e = xa[e], n = /* @__PURE__ */ Object.create(null);
        for (const c of Object.keys(o))
          n[e[c]] = o[c];
        return n;
      }, Z = function(e, t, n) {
        return t = t.plugins[String(e)] || w_, typeof t == "function" ? t : L(e, t, n);
      }, le = function(e) {
        return Qo[e] || null;
      }, ce = function() {
        const e = [];
        for (const t in Qo)
          e.push(Qo[t]);
        return e;
      }, ve = function(e) {
        Qo[e.id] = e;
      }, et = function(e) {
        delete Qo[e.id];
      }, Te = function() {
        return wA;
      }, Le = function(e) {
        wA = e;
      }, we = function() {
        return Xa;
      }, ot = function(e) {
        Xa = e;
      }, pr = function() {
        return qe;
      }, Zt = function(e) {
        qe = e;
      }, Je = function(e) {
        for (; e.options.parentWorkspace; )
          e = e.options.parentWorkspace;
        const t = e.getParentSvg(), n = e.getCachedParentSvgSize();
        var o = t.parentElement;
        if (o instanceof HTMLElement) {
          var c = o.offsetWidth;
          o = o.offsetHeight, n.width !== c && (t.setAttribute("width", c + "px"), e.setCachedParentSvgSize(c, null)), n.height !== o && (t.setAttribute("height", o + "px"), e.setCachedParentSvgSize(null, o)), e.resize();
        }
      }, Rt = function(e, t) {
        const n = /* @__PURE__ */ Object.create(null), o = e.getDescendants(!0);
        t && (e = e.getNextBlock()) && (e = o.indexOf(e), o.splice(e, o.length - e));
        for (let c = 0, A; A = o[c]; c++)
          n[A.type] ? n[A.type]++ : n[A.type] = 1;
        return n;
      }, Wr = function(e) {
        return function() {
          this.jsonInit(e);
        };
      }, Un = function(e) {
        BA.defineBlocksWithJsonArrayInternal(e);
      }, No = function(e) {
        r.defineBlocks$$module$build$src$core$common(r.createBlockDefinitionsFromJsonArray$$module$build$src$core$common(e));
      }, r.createBlockDefinitionsFromJsonArray$$module$build$src$core$common = function(e) {
        const t = {};
        for (let n = 0; n < e.length; n++) {
          const o = e[n];
          if (!o) {
            console.warn(`Block definition #${n} in JSON array is ${o}. Skipping`);
            continue;
          }
          const c = o.type;
          c ? t[c] = { init: Wr(o) } : console.warn(`Block definition #${n} in JSON array is missing a type attribute. Skipping.`);
        }
        return t;
      }, r.defineBlocks$$module$build$src$core$common = function(e) {
        for (const t of Object.keys(e)) {
          const n = e[t];
          t in jr && console.warn(`Block definiton "${t}" overwrites previous definition.`), jr[t] = n;
        }
      }, i_ = function() {
        return "blockly-" + (CS++).toString(36);
      }, Gr = function() {
        return YA.genUid();
      }, ur = function(e) {
        Ii = e;
      }, Cr = function() {
        return Ii;
      }, fe = function(e) {
        Al.fireInternal(e);
      }, vT = function(e) {
        if (tt()) {
          if (!tT.length)
            try {
              requestAnimationFrame(() => {
                setTimeout(on, 0);
              });
            } catch {
              setTimeout(on, 0);
            }
          tT.push(e);
        }
      }, on = function() {
        var e = Ar(tT, !0);
        tT.length = 0;
        for (let n = 0, o; o = e[n]; n++)
          if (o.workspaceId) {
            var t = le(o.workspaceId);
            t && t.fireChangeListener(o);
          }
        e = new Set(e.map((n) => n.workspaceId));
        for (const n of e) {
          if (!n || (e = le(n), !e))
            continue;
          e = e.getUndoStack();
          let o;
          for (t = e.length; 0 < t; t--) {
            const c = e[t - 1];
            if (c.group === "")
              break;
            if (o === void 0)
              o = c.group;
            else if (c.group !== o)
              break;
          }
          o && t != e.length - 1 && (t = e.splice(t, e.length - t), t = Ar(t, !0), e.push(...t));
        }
      }, Ar = function(e, t) {
        e = e.slice(), t || e.reverse();
        const n = [], o = /* @__PURE__ */ Object.create(null);
        for (let D = 0, $; $ = e[D]; D++)
          if (!$.isNull()) {
            var c = [$.isUiEvent ? ts : $.type, $.blockId, $.workspaceId].join(" "), A = o[c];
            const q = A ? A.event : null;
            A ? $.type === r.MOVE$$module$build$src$core$events$utils && A.index === D - 1 ? (c = $, q.newParentId = c.newParentId, q.newInputName = c.newInputName, q.newCoordinate = c.newCoordinate, c.reason && (q.reason ? (c = new Set(c.reason.concat(q.reason)), q.reason = Array.from(c)) : q.reason = c.reason), A.index = D) : $.type === r.CHANGE$$module$build$src$core$events$utils && $.element === q.element && $.name === q.name ? q.newValue = $.newValue : $.type === no ? (A = $, q.viewTop = A.viewTop, q.viewLeft = A.viewLeft, q.scale = A.scale, q.oldScale = A.oldScale) : ($.type !== B_ || q.type !== A_) && (o[c] = {
              event: $,
              index: D
            }, n.push($)) : (o[c] = { event: $, index: D }, n.push($));
          }
        e = n.filter(function(D) {
          return !D.isNull();
        }), t || e.reverse();
        for (let D = 1, $; $ = e[D]; D++)
          $.type === r.CHANGE$$module$build$src$core$events$utils && $.element === "mutation" && e.unshift(e.splice(D, 1)[0]);
        return e;
      }, ii = function() {
        for (let e = 0, t; t = tT[e]; e++)
          t.recordUndo = !1;
      }, r.disable$$module$build$src$core$events$utils = function() {
        es++;
      }, r.enable$$module$build$src$core$events$utils = function() {
        es--;
      }, tt = function() {
        return es === 0;
      }, r.getGroup$$module$build$src$core$events$utils = function() {
        return Lu;
      }, r.setGroup$$module$build$src$core$events$utils = function(e) {
        Al.setGroupInternal(e);
      }, kr = function(e) {
        Lu = typeof e == "boolean" ? e ? Gr() : "" : e;
      }, oi = function(e) {
        const t = [];
        e = e.getDescendants(!1);
        for (let n = 0, o; o = e[n]; n++)
          t[n] = o.id;
        return t;
      }, bo = function(e, t) {
        const n = ge(e.type);
        if (!n)
          throw Error("Unknown event type.");
        return n.fromJson(e, t);
      }, ge = function(e) {
        const t = L(se.EVENT, e);
        if (!t)
          throw Error(`Event type ${e} not found in registry.`);
        return t;
      }, Vn = function(e) {
        if ((e.type === r.MOVE$$module$build$src$core$events$utils || e.type === r.CREATE$$module$build$src$core$events$utils) && e.workspaceId) {
          var t = le(e.workspaceId);
          if (!e.blockId)
            throw Error("Encountered a blockEvent without a proper blockId");
          if (e = t.getBlockById(e.blockId)) {
            const n = Ii;
            try {
              Ii = !1;
              const o = e.getParent();
              if (o && o.isEnabled()) {
                const c = e.getDescendants(!1);
                for (let A = 0, D; D = c[A]; A++)
                  D.setEnabled(!0);
              } else if ((e.outputConnection || e.previousConnection) && !t.isDragging())
                do
                  e.setEnabled(!1), e = e.getNextBlock();
                while (e);
            } finally {
              Ii = n;
            }
          }
        }
      }, Gn = function(e) {
        return e.saveState !== void 0 && e.loadState !== void 0;
      }, Fr = function(e) {
        ({ document: dl = dl, DOMParser: fr = fr, XMLSerializer: An = An } = e), Ja = new fr(), ja = new An();
      }, r.createElement$$module$build$src$core$utils$xml = function(e) {
        return dl.createElementNS(UA, e);
      }, r.createTextNode$$module$build$src$core$utils$xml = function(e) {
        return dl.createTextNode(e);
      }, r.textToDom$$module$build$src$core$utils$xml = function(e) {
        let t = Ja.parseFromString(e, "text/xml");
        if (t && t.documentElement && !t.getElementsByTagName("parsererror").length)
          return t.documentElement;
        if ((t = Ja.parseFromString(e, "text/html")) && t.body.firstChild && t.body.firstChild.nodeName.toLowerCase() === "xml")
          return t.body.firstChild;
        throw Error(`DOMParser was unable to parse: ${e}`);
      }, Hr = function(e) {
        return o_(ja.serializeToString(e));
      }, o_ = function(e) {
        return e.replace(OS, (t) => `&#${t.charCodeAt(0)};`);
      }, dr = function(e, t, n, o) {
        e = e + " was deprecated in " + t + " and will be deleted in " + n + ".", o && (e += `
Use ` + o + " instead."), console.warn(e);
      }, K = function(e, t, n) {
        e = document.createElementNS(Sl, `${e}`);
        for (const o in t)
          e.setAttribute(o, `${t[o]}`);
        return n && n.appendChild(e), e;
      }, be = function(e, t) {
        return t = t.split(" "), t.every((n) => e.classList.contains(n)) ? !1 : (e.classList.add(...t), !0);
      }, Ti = function(e, t) {
        e.classList.remove(...t.split(" "));
      }, Be = function(e, t) {
        return t = t.split(" "), t.every((n) => !e.classList.contains(n)) ? !1 : (e.classList.remove(...t), !0);
      }, b_ = function(e, t) {
        return e.classList.contains(t);
      }, Tt = function(e) {
        return e && e.parentNode ? e.parentNode.removeChild(e) : null;
      }, Sr = function(e, t) {
        const n = t.nextSibling;
        if (t = t.parentNode, !t)
          throw Error("Reference node has no parent.");
        n ? t.insertBefore(e, n) : t.appendChild(e);
      }, wi = function(e, t) {
        return dr("Blockly.utils.dom.containsNode", "version 10", "version 11", 'Use native "contains" DOM method'), e.contains(t);
      }, C_ = function(e, t) {
        e.style.transform = t, e.style["-webkit-transform"] = t;
      }, wr = function() {
        gu++, Qr || (Qr = /* @__PURE__ */ Object.create(null));
      }, Qt = function() {
        gu--, gu || (Qr = null);
      }, O_ = function(e) {
        const t = e.textContent + `
` + e.className.baseVal;
        let n;
        if (Qr && (n = Qr[t]))
          return n;
        try {
          n = e.getComputedTextLength();
        } catch {
          return 8 * e.textContent.length;
        }
        return Qr && (Qr[t] = n), n;
      }, xr = function(e, t, n, o) {
        return T_(e, t + "pt", n, o);
      }, T_ = function(e, t, n, o) {
        const c = e.textContent;
        e = c + `
` + e.className.baseVal;
        var A;
        return Qr && (A = Qr[e]) || (hl || (A = document.createElement("canvas"), A.className = "blocklyComputeCanvas", document.body.appendChild(A), hl = A.getContext("2d")), hl.font = n + " " + t + " " + o, A = c ? hl.measureText(c).width : 0, Qr && (Qr[e] = A)), A;
      }, Hn = function(e, t, n, o) {
        const c = document.createElement("span");
        c.style.font = n + " " + t + " " + o, c.textContent = e, e = document.createElement("div"), e.style.width = "1px", e.style.height = "0", t = document.createElement("div"), t.setAttribute("style", "position: fixed; top: 0; left: 0; display: flex;"), t.appendChild(c), t.appendChild(e), document.body.appendChild(t), n = { height: 0, baseline: 0 };
        try {
          t.style.alignItems = "baseline", n.baseline = e.offsetTop - c.offsetTop, t.style.alignItems = "flex-end", n.height = e.offsetTop - c.offsetTop;
        } finally {
          document.body.removeChild(t);
        }
        return n;
      }, si = function(e, t) {
        fu(e, t);
      }, R_ = function(e) {
        fu = e;
      }, Xr = function(e, t) {
        Ml.confirmInternal(e, t);
      }, li = function(e, t) {
        Il(e, t);
      }, k = function(e) {
        Il = e;
      }, I = function(e, t, n) {
        za(e, t, n);
      }, R = function(e) {
        za = e;
      }, B = function(e) {
        return e.getVariableModel !== void 0;
      }, Y = function(e) {
        return e.getProcedureDef !== void 0;
      }, ie = function(e) {
        return e.getProcedureCall !== void 0 && e.renameProcedure !== void 0;
      }, r.allUsedVarModels$$module$build$src$core$variables = function(e) {
        e = e.getAllBlocks(!1);
        const t = /* @__PURE__ */ new Set();
        for (let n = 0; n < e.length; n++) {
          const o = e[n].getVarModels();
          if (o)
            for (let c = 0; c < o.length; c++) {
              const A = o[c];
              A.getId() && t.add(A);
            }
        }
        return Array.from(t.values());
      }, r.allDeveloperVariables$$module$build$src$core$variables = function(e) {
        e = e.getAllBlocks(!1);
        const t = /* @__PURE__ */ new Set();
        for (let o = 0, c; c = e[o]; o++) {
          var n = c.getDeveloperVariables;
          if (n) {
            n = n();
            for (let A = 0; A < n.length; A++)
              t.add(n[A]);
          }
        }
        return Array.from(t.values());
      }, ke = function(e) {
        let t = [];
        const n = document.createElement("button");
        return n.setAttribute("text", "%{BKY_NEW_VARIABLE}"), n.setAttribute("callbackKey", "CREATE_VARIABLE"), e.registerButtonCallback("CREATE_VARIABLE", function(o) {
          v_(o.getTargetWorkspace());
        }), t.push(n), e = yt(e), t = t.concat(e);
      }, yt = function(e) {
        e = e.getVariablesOfType("");
        const t = [];
        if (0 < e.length) {
          var n = e[e.length - 1];
          if (jr.variables_set) {
            var o = r.createElement$$module$build$src$core$utils$xml("block");
            o.setAttribute("type", "variables_set"), o.setAttribute("gap", jr.math_change ? "8" : "24"), o.appendChild(r.generateVariableFieldDom$$module$build$src$core$variables(n)), t.push(o);
          }
          if (jr.math_change && (o = r.createElement$$module$build$src$core$utils$xml("block"), o.setAttribute("type", "math_change"), o.setAttribute("gap", jr.variables_get ? "20" : "8"), o.appendChild(r.generateVariableFieldDom$$module$build$src$core$variables(n)), n = r.textToDom$$module$build$src$core$utils$xml('<value name="DELTA"><shadow type="math_number"><field name="NUM">1</field></shadow></value>'), o.appendChild(n), t.push(o)), jr.variables_get) {
            e.sort(rs.compareByName);
            for (let c = 0, A; A = e[c]; c++)
              n = r.createElement$$module$build$src$core$utils$xml("block"), n.setAttribute("type", "variables_get"), n.setAttribute("gap", "8"), n.appendChild(r.generateVariableFieldDom$$module$build$src$core$variables(A)), t.push(n);
          }
        }
        return t;
      }, y_ = function(e) {
        return bu.generateUniqueNameInternal(e);
      }, ea = function(e) {
        return ai(Qa.charAt(0), e.getAllVariableNames());
      }, ai = function(e, t) {
        if (!t.length)
          return e;
        const n = Qa;
        let o = "", c = n.indexOf(e);
        for (; ; ) {
          let A = !1;
          for (let D = 0; D < t.length; D++)
            if (t[D].toLowerCase() === e) {
              A = !0;
              break;
            }
          if (!A)
            break;
          c++, c === n.length && (c = 0, o = `${Number(o) + 1}`), e = n.charAt(c) + o;
        }
        return e;
      }, v_ = function(e, t, n) {
        function o(A) {
          Ut(r.Msg$$module$build$src$core$msg.NEW_VARIABLE_TITLE, A, function(D) {
            if (D) {
              var $ = Co(D, e);
              if ($) {
                if ($.type === c)
                  var q = r.Msg$$module$build$src$core$msg.VARIABLE_ALREADY_EXISTS.replace("%1", $.name);
                else
                  q = r.Msg$$module$build$src$core$msg.VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE, q = q.replace("%1", $.name).replace("%2", $.type);
                si(q, function() {
                  o(D);
                });
              } else
                e.createVariable(D, c), t && t(D);
            } else
              t && t(null);
          });
        }
        const c = n || "";
        o("");
      }, r.renameVariable$$module$build$src$core$variables = function(e, t, n) {
        function o(c) {
          const A = r.Msg$$module$build$src$core$msg.RENAME_VARIABLE_TITLE.replace("%1", t.name);
          Ut(A, c, function(D) {
            if (D) {
              var $ = $T(D, t.type, e), q = WT(t.name, D, e);
              if ($ || q) {
                var De = "";
                $ ? De = r.Msg$$module$build$src$core$msg.VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE.replace("%1", $.name).replace(
                  "%2",
                  $.type
                ) : q && (De = r.Msg$$module$build$src$core$msg.VARIABLE_ALREADY_EXISTS_FOR_A_PARAMETER.replace("%1", D).replace("%2", q)), si(De, function() {
                  o(D);
                });
              } else
                e.renameVariableById(t.getId(), D), n && n(D);
            } else
              n && n(null);
          });
        }
        o("");
      }, Ut = function(e, t, n) {
        I(e, t, function(o) {
          o && (o = o.replace(/[\s\xa0]+/g, " ").trim(), o === r.Msg$$module$build$src$core$msg.RENAME_VARIABLE || o === r.Msg$$module$build$src$core$msg.NEW_VARIABLE) && (o = null), n(o);
        });
      }, $T = function(e, t, n) {
        n = n.getVariableMap().getAllVariables(), e = e.toLowerCase();
        for (let o = 0, c; c = n[o]; o++)
          if (c.name.toLowerCase() === e && c.type !== t)
            return c;
        return null;
      }, Co = function(e, t) {
        t = t.getVariableMap().getAllVariables(), e = e.toLowerCase();
        for (let n = 0, o; o = t[n]; n++)
          if (o.name.toLowerCase() === e)
            return o;
        return null;
      }, WT = function(e, t, n) {
        return n.getProcedureMap().getProcedures().length ? Bi(e, t, n) : m(e, t, n);
      }, Bi = function(e, t, n) {
        e = e.toLowerCase(), t = t.toLowerCase(), n = n.getProcedureMap().getProcedures();
        for (const c of n) {
          var o = c.getParameters().filter(B).map((A) => A.getVariableModel().name);
          if (o && (n = o.some((A) => A.toLowerCase() === e), o = o.some((A) => A.toLowerCase() === t), n && o))
            return c.getName();
        }
        return null;
      }, m = function(e, t, n) {
        e = e.toLowerCase(), t = t.toLowerCase(), n = n.getAllBlocks(!1);
        for (const c of n) {
          if (!Y(c))
            continue;
          n = c.getProcedureDef();
          var o = n[1];
          const A = o.some((D) => D.toLowerCase() === e);
          if (o = o.some((D) => D.toLowerCase() === t), A && o)
            return n[0];
        }
        return null;
      }, r.generateVariableFieldDom$$module$build$src$core$variables = function(e) {
        const t = r.createElement$$module$build$src$core$utils$xml("field");
        return t.setAttribute("name", "VAR"), t.setAttribute("id", e.getId()), t.setAttribute("variabletype", e.type), e = r.createTextNode$$module$build$src$core$utils$xml(e.name), t.appendChild(e), t;
      }, r.getOrCreateVariablePackage$$module$build$src$core$variables = function(e, t, n, o) {
        let c = r.getVariable$$module$build$src$core$variables(e, t, n, o);
        return c || (c = b(e, t, n, o)), c;
      }, r.getVariable$$module$build$src$core$variables = function(e, t, n, o) {
        const c = e.getPotentialVariableMap();
        let A = null;
        if (t && (A = e.getVariableById(t), !A && c && (A = c.getVariableById(t)), A))
          return A;
        if (n) {
          if (o === void 0)
            throw Error("Tried to look up a variable by name without a type");
          A = e.getVariable(n, o), !A && c && (A = c.getVariable(n, o));
        }
        return A;
      }, b = function(e, t, n, o) {
        const c = e.getPotentialVariableMap();
        return n || (n = y_(e.isFlyout ? e.targetWorkspace : e)), c ? c.createVariable(n, o, t) : e.createVariable(n, o, t);
      }, W = function(e, t) {
        e = e.getAllVariables();
        const n = [];
        if (t.length !== e.length)
          for (let o = 0; o < e.length; o++) {
            const c = e[o];
            t.indexOf(c) === -1 && n.push(c);
          }
        return n;
      }, H = function(e, t) {
        ee(), Di = setTimeout(function() {
          t && t.handleRightClick(e);
        }, Cu);
      }, ee = function() {
        Di && (clearTimeout(Di), Di = 0);
      }, me = function() {
        ns = null;
      }, Ge = function(e) {
        return !e.type.startsWith("pointer") || e instanceof PointerEvent && Yi(e);
      }, qt = function(e) {
        return `${e.pointerId}`;
      }, Yi = function(e) {
        const t = qt(e);
        return ns ? ns === t : e.type === "pointerdown" ? (ns = t, !0) : !1;
      }, Pe = function(e, t, n, o, c) {
        function A($) {
          (c || Ge($)) && (n ? o.call(n, $) : o($));
        }
        const D = [];
        if (t in G_)
          for (let $ = 0; $ < G_[t].length; $++) {
            const q = G_[t][$];
            e.addEventListener(q, A, !1), D.push([e, q, A]);
          }
        else
          e.addEventListener(t, A, !1), D.push([e, t, A]);
        return D;
      }, hr = function(e, t, n, o) {
        function c(D) {
          n ? o.call(n, D) : o(D);
        }
        const A = [];
        if (t in G_)
          for (let D = 0; D < G_[t].length; D++) {
            const $ = G_[t][D];
            e.addEventListener($, c, !1), A.push([e, $, c]);
          }
        else
          e.addEventListener(t, c, !1), A.push([e, t, c]);
        return A;
      }, It = function(e) {
        const t = e[e.length - 1][2];
        for (; e.length; ) {
          const [n, o, c] = e.pop();
          n.removeEventListener(o, c, !1);
        }
        return t;
      }, vs = function(e) {
        if (e.target instanceof HTMLElement) {
          if (e.target.isContentEditable || e.target.getAttribute("data-is-text-input") === "true")
            return !0;
          if (e.target instanceof HTMLInputElement)
            return e = e.target, e.type === "text" || e.type === "number" || e.type === "email" || e.type === "password" || e.type === "search" || e.type === "tel" || e.type === "url";
          if (e.target instanceof HTMLTextAreaElement)
            return !0;
        }
        return !1;
      }, Ui = function(e) {
        return e.ctrlKey && Rr ? !0 : e.button === 2;
      }, Oo = function(e, t, n) {
        const o = t.createSVGPoint();
        return o.x = e.clientX, o.y = e.clientY, n || (n = t.getScreenCTM().inverse()), o.matrixTransform(n);
      }, kT = function(e) {
        switch (e.deltaMode) {
          default:
            return { x: e.deltaX, y: e.deltaY };
          case 1:
            return { x: e.deltaX * rc, y: e.deltaY * rc };
          case 2:
            return { x: e.deltaX * XA, y: e.deltaY * XA };
        }
      }, xn = function(e) {
        if (oT)
          throw Error("CSS already injected");
        nc += `
` + e;
      }, cp = function(e, t) {
        oT || (oT = !0, e && (e = t.replace(/[\\/]$/, ""), t = nc.replace(/<<<PATH>>>/g, e), nc = "", e = document.createElement("style"), e.id = "blockly-common-style", t = document.createTextNode(t), e.appendChild(t), document.head.insertBefore(e, document.head.firstChild)));
      }, $s = function(e) {
        return KA.getSizeInternal(e);
      }, JE = function(e) {
        if ($_(e, "display") !== "none")
          return pp(e);
        const t = e.style, n = t.display, o = t.visibility, c = t.position;
        t.visibility = "hidden", t.position = "absolute", t.display = "inline";
        const A = e.offsetWidth;
        return e = e.offsetHeight, t.display = n, t.position = c, t.visibility = o, new ht(A, e);
      }, pp = function(e) {
        return new ht(e.offsetWidth, e.offsetHeight);
      }, $_ = function(e, t) {
        return e = window.getComputedStyle(e), e[t] || e.getPropertyValue(t);
      }, s_ = function(e) {
        const t = new ae(0, 0);
        e = e.getBoundingClientRect();
        var n = document.documentElement;
        return n = new ae(window.pageXOffset || n.scrollLeft, window.pageYOffset || n.scrollTop), t.x = e.left + n.x, t.y = e.top + n.y, t;
      }, up = function() {
        const e = document.body, t = document.documentElement;
        return new ae(e.scrollLeft || t.scrollLeft, e.scrollTop || t.scrollTop);
      }, FT = function(e) {
        const t = parseFloat($_(e, "borderLeftWidth")), n = parseFloat($_(e, "borderRightWidth")), o = parseFloat($_(e, "borderTopWidth"));
        return e = parseFloat($_(e, "borderBottomWidth")), new Dt(o, e, t, n);
      }, ta = function(e, t, n) {
        e = Ep(e, t, n), t.scrollLeft = e.x, t.scrollTop = e.y;
      }, Ep = function(e, t, n) {
        var o = s_(e), c = s_(t), A = FT(t);
        const D = o.x - c.x - A.left;
        return o = o.y - c.y - A.top, c = pp(e), e = t.clientWidth - c.width, c = t.clientHeight - c.height, A = t.scrollLeft, t = t.scrollTop, n ? (A += D - e / 2, t += o - c / 2) : (A += Math.min(D, Math.max(D - e, 0)), t += Math.min(o, Math.max(o - c, 0))), new ae(A, t);
      }, Ro = function(e) {
        const t = new ae(0, 0);
        var n = e.x && e.getAttribute("x");
        const o = e.y && e.getAttribute("y");
        return n && (t.x = parseInt(n)), o && (t.y = parseInt(o)), (n = (n = e.getAttribute("transform")) && n.match(yu)) && (t.x += Number(n[1]), n[3] && (t.y += Number(n[3]))), (e = e.getAttribute("style")) && -1 < e.indexOf("translate") && (e = e.match(vu)) && (t.x += Number(e[1]), e[3] && (t.y += Number(e[3]))), t;
      }, Ws = function(e) {
        let t = 0, n = 0;
        for (; e; ) {
          const o = Ro(e);
          if (t += o.x, n += o.y, (" " + (e.getAttribute("class") || "") + " ").indexOf(" injectionDiv ") !== -1)
            break;
          e = e.parentNode;
        }
        return new ae(t, n);
      }, ra = function() {
        const e = up();
        return new Dt(e.y, document.documentElement.clientHeight + e.y, e.x, document.documentElement.clientWidth + e.x);
      }, na = function() {
        const e = document.documentElement, t = window;
        return new ae(t.pageXOffset || e.scrollLeft, t.pageYOffset || e.scrollTop);
      }, jE = function(e, t) {
        var n = t.x;
        t = t.y;
        const o = e.getInjectionDiv().getBoundingClientRect();
        return n = new ae(n - o.left, t - o.top), t = e.getOriginOffsetInPixels(), ae.difference(n, t).scale(1 / e.scale);
      }, zE = function(e, t) {
        const n = r.createElement$$module$build$src$core$utils$xml("xml");
        var o = Ap(r.allUsedVarModels$$module$build$src$core$variables(e));
        o.hasChildNodes() && n.appendChild(o), o = e.getTopComments(!0);
        for (let c = 0; c < o.length; c++)
          n.appendChild(o[c].toXmlWithXY(t));
        for (e = e.getTopBlocks(!0), o = 0; o < e.length; o++)
          n.appendChild(ks(e[o], t));
        return n;
      }, Ap = function(e) {
        const t = r.createElement$$module$build$src$core$utils$xml("variables");
        for (let n = 0; n < e.length; n++) {
          const o = e[n], c = r.createElement$$module$build$src$core$utils$xml("variable");
          c.appendChild(r.createTextNode$$module$build$src$core$utils$xml(o.name)), o.type && c.setAttribute("type", o.type), c.id = o.getId(), t.appendChild(c);
        }
        return t;
      }, ks = function(e, t) {
        if (e.isInsertionMarker() && (e = e.getChildren(!1)[0], !e))
          return new DocumentFragment();
        let n = 0;
        if (e.workspace.RTL && (n = e.workspace.getWidth()), t = ci(e, t), oa(t)) {
          const o = e.getRelativeToSurfaceXY();
          t.setAttribute("x", String(Math.round(e.workspace.RTL ? n - o.x : o.x))), t.setAttribute("y", String(Math.round(o.y)));
        }
        return t;
      }, dp = function(e) {
        if (e.isSerializable()) {
          const t = r.createElement$$module$build$src$core$utils$xml("field");
          return t.setAttribute("name", e.name || ""), e.toXml(t);
        }
        return null;
      }, Sp = function(e, t) {
        for (let n = 0; n < e.inputList.length; n++) {
          const o = e.inputList[n];
          for (let c = 0; c < o.fieldRow.length; c++) {
            const A = dp(o.fieldRow[c]);
            A && t.appendChild(A);
          }
        }
      }, ci = function(e, t) {
        if (e.isInsertionMarker())
          return (t = e.getChildren(!1)[0]) ? ci(t) : new DocumentFragment();
        const n = r.createElement$$module$build$src$core$utils$xml(e.isShadow() ? "shadow" : "block");
        if (n.setAttribute("type", e.type), t || (n.id = e.id), e.mutationToDom) {
          var o = e.mutationToDom();
          o && (o.hasChildNodes() || o.hasAttributes()) && n.appendChild(o);
        }
        if (Sp(e, n), o = e.getCommentText()) {
          var c = e.getIcon(mr.COMMENT), A = c.getBubbleSize();
          c = c.bubbleIsVisible();
          var D = r.createElement$$module$build$src$core$utils$xml("comment");
          D.appendChild(r.createTextNode$$module$build$src$core$utils$xml(o)), D.setAttribute("pinned", `${c}`), D.setAttribute("h", String(A.height)), D.setAttribute("w", String(A.width)), n.appendChild(D);
        }
        for (e.data && (o = r.createElement$$module$build$src$core$utils$xml("data"), o.appendChild(r.createTextNode$$module$build$src$core$utils$xml(e.data)), n.appendChild(o)), o = 0; o < e.inputList.length; o++) {
          A = e.inputList[o];
          var $ = void 0;
          if (c = !0, A.type !== r.inputTypes$$module$build$src$core$inputs$input_types.DUMMY) {
            D = A.connection.targetBlock(), A.type === r.inputTypes$$module$build$src$core$inputs$input_types.VALUE ? $ = r.createElement$$module$build$src$core$utils$xml("value") : A.type === r.inputTypes$$module$build$src$core$inputs$input_types.STATEMENT && ($ = r.createElement$$module$build$src$core$utils$xml("statement"));
            const De = A.connection.getShadowDom();
            !De || D && D.isShadow() || $.appendChild(Fs(
              De,
              t
            )), D && (D = ci(D, t), D.nodeType === dn.ELEMENT_NODE && ($.appendChild(D), c = !1)), $.setAttribute("name", A.name), c || n.appendChild($);
          }
        }
        e.inputsInline !== void 0 && e.inputsInline !== e.inputsInlineDefault && n.setAttribute("inline", String(e.inputsInline)), e.isCollapsed() && n.setAttribute("collapsed", "true"), e.isEnabled() || n.setAttribute("disabled", "true"), e.isDeletable() || e.isShadow() || n.setAttribute("deletable", "false"), e.isMovable() || e.isShadow() || n.setAttribute("movable", "false"), e.isEditable() || n.setAttribute("editable", "false"), $ = e.getNextBlock();
        let q;
        return $ && (o = ci($, t), o.nodeType === dn.ELEMENT_NODE && (q = r.createElement$$module$build$src$core$utils$xml("next"), q.appendChild(o), n.appendChild(q))), e = e.nextConnection && e.nextConnection.getShadowDom(), !e || $ && $.isShadow() || q.appendChild(Fs(e, t)), n;
      }, Fs = function(e, t) {
        let n = e = e.cloneNode(!0), o;
        for (; n; )
          if (t && n.nodeName === "shadow" && n.removeAttribute("id"), n.firstChild)
            n = n.firstChild;
          else {
            for (; n && !n.nextSibling; ) {
              o = n, n = n.parentNode;
              let c;
              o.nodeType === dn.TEXT_NODE && o.data.trim() === "" && ((c = n) == null ? void 0 : c.firstChild) !== o && Tt(o);
            }
            n && (o = n, n = n.nextSibling, o.nodeType === dn.TEXT_NODE && o.data.trim() === "" && Tt(o));
          }
        return e;
      }, W_ = function(e) {
        return Hr(e).replace(/<(\w+)([^<]*)\/>/g, "<$1$2></$1>");
      }, hp = function(e) {
        e = W_(e).split("<");
        let t = "";
        for (let n = 1; n < e.length; n++) {
          const o = e[n];
          o[0] === "/" && (t = t.substring(2)), e[n] = t + "<" + o, o[0] !== "/" && o.slice(-2) !== "/>" && (t += "  ");
        }
        return e = e.join(`
`), e = e.replace(/(<(\w+)\b[^>]*>[^\n]*)\n *<\/\2>/g, "$1</$2>"), e.replace(/^\n/, "");
      }, ws = function(e, t) {
        return t.setResizesEnabled(!1), t.clear(), e = r.domToWorkspace$$module$build$src$core$xml(e, t), t.setResizesEnabled(!0), e;
      }, r.domToWorkspace$$module$build$src$core$xml = function(e, t) {
        let n = 0;
        t.RTL && (n = t.getWidth());
        const o = [];
        wr();
        const c = r.getGroup$$module$build$src$core$events$utils();
        c || r.setGroup$$module$build$src$core$events$utils(!0), t.setResizesEnabled && t.setResizesEnabled(!1);
        let A = !0;
        try {
          for (let D = 0, $; $ = e.childNodes[D]; D++) {
            const q = $.nodeName.toLowerCase(), De = $;
            if (q === "block" || q === "shadow" && !Cr()) {
              const or = r.domToBlock$$module$build$src$core$xml(
                De,
                t
              );
              o.push(or.id);
              let Ft;
              const n_ = parseInt((Ft = De.getAttribute("x")) != null ? Ft : "10", 10);
              let Xc;
              const Kc = parseInt((Xc = De.getAttribute("y")) != null ? Xc : "10", 10);
              isNaN(n_) || isNaN(Kc) || or.moveBy(t.RTL ? n - n_ : n_, Kc, ["create"]), A = !1;
            } else {
              if (q === "shadow")
                throw TypeError("Shadow block cannot be a top-level block.");
              if (q === "comment")
                t.rendered ? yr.fromXmlRendered(De, t, n) : U_.fromXml(De, t);
              else if (q === "variables") {
                if (A)
                  Mp(
                    De,
                    t
                  );
                else
                  throw Error("'variables' tag must exist once before block and shadow tag elements in the workspace XML, but it was found in another location.");
                A = !1;
              }
            }
          }
        } finally {
          r.setGroup$$module$build$src$core$events$utils(c), Qt();
        }
        return t.setResizesEnabled && t.setResizesEnabled(!0), fe(new (ge(eT))(t)), o;
      }, Ip = function(e, t) {
        if (!t.getBlocksBoundingBox)
          return r.domToWorkspace$$module$build$src$core$xml(e, t);
        var n = t.getBlocksBoundingBox();
        if (e = r.domToWorkspace$$module$build$src$core$xml(e, t), n && n.top !== n.bottom) {
          var o = n.bottom;
          n = t.RTL ? n.right : n.left;
          var c = 1 / 0;
          let A = -1 / 0, D = 1 / 0;
          for (let $ = 0; $ < e.length; $++) {
            const q = t.getBlockById(e[$]).getRelativeToSurfaceXY();
            q.y < D && (D = q.y), q.x < c && (c = q.x), q.x > A && (A = q.x);
          }
          for (o = o - D + 10, n = t.RTL ? n - A : n - c, c = 0; c < e.length; c++)
            t.getBlockById(e[c]).moveBy(
              n,
              o,
              ["create"]
            );
        }
        return e;
      }, r.domToBlock$$module$build$src$core$xml = function(e, t) {
        r.disable$$module$build$src$core$events$utils();
        var n = t.getAllVariables();
        let o;
        try {
          if (o = Ys(e, t), t.rendered) {
            const c = o, A = o.getDescendants(!1);
            c.setConnectionTracking(!1);
            for (let D = A.length - 1; 0 <= D; D--)
              A[D].initSvg();
            for (let D = A.length - 1; 0 <= D; D--)
              A[D].render(!1);
            setTimeout(function() {
              c.disposed || c.setConnectionTracking(!0);
            }, 1), c.updateDisabled(), t.resizeContents();
          } else {
            const c = o.getDescendants(!1);
            for (let A = c.length - 1; 0 <= A; A--)
              c[A].initModel();
          }
        } finally {
          r.enable$$module$build$src$core$events$utils();
        }
        if (tt()) {
          for (e = W(t, n), t = 0; t < e.length; t++)
            n = e[t], fe(new (ge(mi))(n));
          fe(new (ge(r.CREATE$$module$build$src$core$events$utils))(o));
        }
        return o;
      }, Mp = function(e, t) {
        for (let o = 0; o < e.children.length; o++) {
          var n = e.children[o];
          const c = n.getAttribute("type"), A = n.getAttribute("id");
          if (n = n.textContent, !n)
            break;
          t.createVariable(n, c, A);
        }
      }, mp = function(e) {
        const t = { mutation: [], comment: [], data: [], field: [], input: [], next: [] };
        for (let n = 0; n < e.children.length; n++) {
          const o = e.children[n];
          if (o.nodeType !== dn.TEXT_NODE)
            switch (o.nodeName.toLowerCase()) {
              case "mutation":
                t.mutation.push(o);
                break;
              case "comment":
                t.comment.push(o);
                break;
              case "data":
                t.data.push(o);
                break;
              case "title":
              case "field":
                t.field.push(o);
                break;
              case "value":
              case "statement":
                t.input.push(o);
                break;
              case "next":
                t.next.push(o);
                break;
              default:
                console.warn("Ignoring unknown tag: " + o.nodeName);
            }
        }
        return t;
      }, Pp = function(e, t) {
        let n = !1;
        for (let o = 0; o < e.length; o++) {
          const c = e[o];
          t.domToMutation && (t.domToMutation(c), t.initSvg && (n = !0));
        }
        return n;
      }, _a = function(e, t) {
        for (let o = 0; o < e.length; o++) {
          var n = e[o];
          const c = n.textContent, A = n.getAttribute("pinned") === "true";
          let D;
          const $ = parseInt((D = n.getAttribute("w")) != null ? D : "50", 10);
          let q;
          n = parseInt((q = n.getAttribute("h")) != null ? q : "50", 10), t.setCommentText(c);
          const De = t.getIcon(mr.COMMENT);
          isNaN($) || isNaN(n) || De.setBubbleSize(new ht($, n)), De.setBubbleVisible(A), setTimeout(
            () => De.setBubbleVisible(A),
            1
          );
        }
      }, ZE = function(e, t) {
        for (let n = 0; n < e.length; n++)
          t.data = e[n].textContent;
      }, Dp = function(e, t) {
        for (let n = 0; n < e.length; n++) {
          const o = e[n], c = o.getAttribute("name");
          c ? Lp(t, c, o) : console.warn(`Ignoring unnamed field in block ${t.type}`);
        }
      }, Bs = function(e) {
        let t = null, n = null;
        for (let o = 0; o < e.childNodes.length; o++) {
          const c = e.childNodes[o];
          oa(c) && (c.nodeName.toLowerCase() === "block" ? t = c : c.nodeName.toLowerCase() === "shadow" && (n = c));
        }
        return { childBlockElement: t, childShadowElement: n };
      }, ia = function(e, t, n, o) {
        for (let A = 0; A < e.length; A++) {
          var c = e[A];
          const D = c.getAttribute("name"), $ = D ? n.getInput(D) : null;
          if (!$) {
            console.warn("Ignoring non-existent input " + D + " in block " + o);
            break;
          }
          if (c = Bs(c), c.childBlockElement) {
            if (!$.connection)
              throw TypeError("Input connection does not exist.");
            Ys(c.childBlockElement, t, $.connection, !1);
          }
          if (c.childShadowElement) {
            let q;
            (q = $.connection) == null || q.setShadowDom(c.childShadowElement);
          }
        }
      }, yo = function(e, t, n) {
        for (let o = 0; o < e.length; o++) {
          const c = Bs(e[o]);
          if (c.childBlockElement) {
            if (!n.nextConnection)
              throw TypeError("Next statement does not exist.");
            if (n.nextConnection.isConnected())
              throw TypeError("Next statement is already connected.");
            Ys(c.childBlockElement, t, n.nextConnection, !0);
          }
          c.childShadowElement && n.nextConnection && n.nextConnection.setShadowDom(c.childShadowElement);
        }
      }, Ys = function(e, t, n, o) {
        var c;
        const A = e.getAttribute("type");
        if (!A)
          throw TypeError("Block type unspecified: " + e.outerHTML);
        var D = (c = e.getAttribute("id")) != null ? c : void 0;
        c = t.newBlock(A, D), D = mp(e);
        const $ = Pp(D.mutation, c);
        if (_a(D.comment, c), ZE(D.data, c), n)
          if (o)
            if (c.previousConnection)
              n.connect(c.previousConnection);
            else
              throw TypeError("Next block does not have previous statement.");
          else if (c.outputConnection)
            n.connect(c.outputConnection);
          else if (c.previousConnection)
            n.connect(c.previousConnection);
          else
            throw TypeError("Child block does not have output or previous statement.");
        if (Dp(D.field, c), ia(D.input, t, c, A), yo(D.next, t, c), $ && c.initSvg(), (t = e.getAttribute("inline")) && c.setInputsInline(t === "true"), (t = e.getAttribute("disabled")) && c.setEnabled(t !== "true" && t !== "disabled"), (t = e.getAttribute("deletable")) && c.setDeletable(t === "true"), (t = e.getAttribute("movable")) && c.setMovable(t === "true"), (t = e.getAttribute("editable")) && c.setEditable(t === "true"), (t = e.getAttribute("collapsed")) && c.setCollapsed(t === "true"), e.nodeName.toLowerCase() === "shadow") {
          for (e = c.getChildren(!1), t = 0; t < e.length; t++)
            if (!e[t].isShadow())
              throw TypeError("Shadow block not allowed non-shadow child.");
          if (c.getVarModels().length)
            throw TypeError("Shadow blocks cannot have variable references.");
          c.setShadow(!0);
        }
        return c;
      }, Lp = function(e, t, n) {
        const o = e.getField(t);
        o ? o.fromXml(n) : console.warn("Ignoring non-existent field " + t + " in block " + e.type);
      }, QE = function(e) {
        for (let t = 0; t < e.childNodes.length; t++) {
          const n = e.childNodes[t];
          if (n.nodeName.toLowerCase() === "next") {
            e.removeChild(n);
            break;
          }
        }
      }, oa = function(e) {
        return e.nodeType === dn.ELEMENT_NODE;
      }, Us = function(e, t) {
        i(se.SERIALIZER, e, t);
      }, gp = function(e) {
        p(se.SERIALIZER, e);
      }, l_ = function(e, { addCoordinates: t = !1, addInputBlocks: n = !0, addNextBlocks: o = !0, doFullSerialization: c = !0 } = {}) {
        if (e.isInsertionMarker())
          return null;
        const A = { type: e.type, id: e.id };
        return t && eA(e, A), qE(e, A), tA(e, A), fp(e, A, c), rA(
          e,
          A,
          c
        ), n && nA(e, A, c), o && _A(e, A, c), A;
      }, qE = function(e, t) {
        e.isCollapsed() && (t.collapsed = !0), e.isEnabled() || (t.enabled = !1), e.isOwnDeletable() || (t.deletable = !1), e.isOwnMovable() || (t.movable = !1), e.isOwnEditable() || (t.editable = !1), e.inputsInline !== void 0 && e.inputsInline !== e.inputsInlineDefault && (t.inline = e.inputsInline), e.data && (t.data = e.data);
      }, eA = function(e, t) {
        const n = e.workspace;
        e = e.getRelativeToSurfaceXY(), t.x = Math.round(n.RTL ? n.getWidth() - e.x : e.x), t.y = Math.round(e.y);
      }, tA = function(e, t) {
        e.saveExtraState ? (e = e.saveExtraState(), e !== null && (t.extraState = e)) : e.mutationToDom && (e = e.mutationToDom(), e !== null && (t.extraState = W_(e).replace(' xmlns="https://developers.google.com/blockly/xml"', "")));
      }, fp = function(e, t, n) {
        const o = /* @__PURE__ */ Object.create(null);
        for (const c of e.getIcons())
          Gn(c) && (e = c.saveState(n)) && (o[c.getType().toString()] = e);
        Object.keys(o).length && (t.icons = o);
      }, rA = function(e, t, n) {
        const o = /* @__PURE__ */ Object.create(null);
        for (let c = 0; c < e.inputList.length; c++) {
          const A = e.inputList[c];
          for (let D = 0; D < A.fieldRow.length; D++) {
            const $ = A.fieldRow[D];
            $.isSerializable() && (o[$.name] = $.saveState(n));
          }
        }
        Object.keys(o).length && (t.fields = o);
      }, nA = function(e, t, n) {
        const o = /* @__PURE__ */ Object.create(null);
        for (let c = 0; c < e.inputList.length; c++) {
          const A = e.inputList[c];
          if (!A.connection)
            continue;
          const D = Np(A.connection, n);
          D && (o[A.name] = D);
        }
        Object.keys(o).length && (t.inputs = o);
      }, _A = function(e, t, n) {
        e.nextConnection && (e = Np(e.nextConnection, n)) && (t.next = e);
      }, Np = function(e, t) {
        const n = e.getShadowState(!0);
        if (e = e.targetBlock(), !n && !e)
          return null;
        const o = /* @__PURE__ */ Object.create(null);
        return n && (o.shadow = n), e && !e.isShadow() && (o.block = l_(e, { doFullSerialization: t })), o;
      }, k_ = function(e, t, { recordUndo: n = !1 } = {}) {
        return Ta(e, t, { recordUndo: n });
      }, Ta = function(e, t, { parentConnection: n, isShadow: o = !1, recordUndo: c = !1 } = {}) {
        const A = Cr();
        ur(c), (c = r.getGroup$$module$build$src$core$events$utils()) || r.setGroup$$module$build$src$core$events$utils(!0), r.disable$$module$build$src$core$events$utils();
        const D = bp(e, t, { parentConnection: n, isShadow: o });
        return r.enable$$module$build$src$core$events$utils(), fe(new (ge(r.CREATE$$module$build$src$core$events$utils))(D)), r.setGroup$$module$build$src$core$events$utils(c), ur(A), t.rendered && setTimeout(() => {
          D.disposed || D.setConnectionTracking(!0);
        }, 1), D;
      }, bp = function(e, t, { parentConnection: n, isShadow: o = !1 } = {}) {
        if (!e.type)
          throw new Wu(e);
        const c = t.newBlock(e.type, e.id);
        return c.setShadow(o), iA(c, e), oA(c, e), TA(c, e), vt(
          n,
          c,
          e
        ), Ct(c, e), sA(c, e), lA(c, e), aA(c, e), cA(c, t.rendered), c;
      }, iA = function(e, t) {
        let n = t.x === void 0 ? 0 : t.x;
        t = t.y === void 0 ? 0 : t.y;
        const o = e.workspace;
        n = o.RTL ? o.getWidth() - n : n, e.moveBy(n, t);
      }, oA = function(e, t) {
        t.collapsed && e.setCollapsed(!0), t.deletable === !1 && e.setDeletable(!1), t.movable === !1 && e.setMovable(!1), t.editable === !1 && e.setEditable(!1), t.enabled === !1 && e.setEnabled(!1), t.inline !== void 0 && e.setInputsInline(t.inline), t.data !== void 0 && (e.data = t.data);
      }, TA = function(e, t) {
        t.extraState && (e.loadExtraState ? e.loadExtraState(t.extraState) : e.domToMutation && e.domToMutation(r.textToDom$$module$build$src$core$utils$xml(t.extraState)));
      }, vt = function(e, t, n) {
        if (e) {
          if (e.getSourceBlock().isShadow() && !t.isShadow())
            throw new JA(n);
          if (e.type === r.inputTypes$$module$build$src$core$inputs$input_types.VALUE) {
            var o = t.outputConnection;
            if (!o)
              throw new hn("output", t, n);
          } else if (o = t.previousConnection, !o)
            throw new hn(
              "previous",
              t,
              n
            );
          if (!e.connect(o)) {
            const c = t.workspace.connectionChecker;
            throw new so(c.getErrorMessage(c.canConnectWithReason(o, e, !1), o, e), e.type === r.inputTypes$$module$build$src$core$inputs$input_types.VALUE ? "output connection" : "previous connection", t, n);
          }
        }
      }, Ct = function(e, t) {
        if (t.icons) {
          var n = Object.keys(t.icons);
          for (const c of n) {
            n = t.icons[c];
            var o = e.getIcon(c);
            if (!o) {
              if (o = L(se.ICON, c, !1), !o)
                throw new ku(c, e, t);
              o = new o(e), e.addIcon(o);
            }
            Gn(o) && o.loadState(n);
          }
        }
      }, sA = function(e, t) {
        if (t.fields) {
          var n = Object.keys(t.fields);
          for (let o = 0; o < n.length; o++) {
            const c = n[o], A = t.fields[c], D = e.getField(c);
            D ? D.loadState(A) : console.warn(`Ignoring non-existant field ${c} in block ${e.type}`);
          }
        }
      }, lA = function(e, t) {
        if (t.inputs) {
          var n = Object.keys(t.inputs);
          for (let o = 0; o < n.length; o++) {
            const c = n[o], A = e.getInput(c);
            if (!A || !A.connection)
              throw new hn(c, e, t);
            Cp(A.connection, t.inputs[c]);
          }
        }
      }, aA = function(e, t) {
        if (t.next) {
          if (!e.nextConnection)
            throw new hn("next", e, t);
          Cp(e.nextConnection, t.next);
        }
      }, Cp = function(e, t) {
        t.shadow && e.setShadowState(t.shadow), t.block && bp(t.block, e.getSourceBlock().workspace, { parentConnection: e });
      }, cA = function(e, t) {
        if (t) {
          e.setConnectionTracking(!1), e.initSvg(), e.render(!1);
          for (const n of e.getIcons())
            n.onLocationChange(e.getRelativeToSurfaceXY());
        } else
          e.initModel();
      }, Vi = function(e) {
        return e.bubbleIsVisible !== void 0 && e.setBubbleVisible !== void 0;
      }, Op = function(e, t) {
        if (!e || !t)
          throw Error("Cannot connect null connections.");
        e.targetConnection = t, t.targetConnection = e;
      }, pA = function(e, t) {
        let n = null;
        t = t.outputConnection;
        const o = t == null ? void 0 : t.getConnectionChecker();
        for (let c = 0, A; A = e.inputList[c]; c++) {
          const D = A.connection;
          let $;
          if (D && (($ = o) != null && $.canConnect(t, D, !1))) {
            if (n)
              return null;
            n = D;
          }
        }
        return n;
      }, Lr = function(e, t) {
        let n;
        for (; n = pA(e, t); )
          if (e = n.targetBlock(), !e || e.isShadow())
            return n;
        return null;
      }, Gi = function(e) {
        return e * Math.PI / 180;
      }, pi = function(e) {
        return 180 * e / Math.PI;
      }, vo = function(e, t, n) {
        if (n < e) {
          const o = n;
          n = e, e = o;
        }
        return Math.max(e, Math.min(t, n));
      }, Vs = function() {
        at || (at = document.createElement("div"), at.className = "blocklyDropDownDiv", (pr() || document.body).appendChild(at), ls = document.createElement("div"), ls.className = "blocklyDropDownContent", at.appendChild(ls), cT = document.createElement("div"), cT.className = "blocklyDropDownArrow", at.appendChild(cT), at.style.opacity = "0", at.style.transition = "transform " + ac + "s, opacity " + ac + "s", at.addEventListener("focusin", function() {
          be(at, "blocklyFocused");
        }), at.addEventListener("focusout", function() {
          Be(at, "blocklyFocused");
        }));
      }, Tn = function(e) {
        gl = e;
      }, sa = function() {
        return ao;
      }, $o = function() {
        return ls;
      }, Gs = function() {
        ls.textContent = "", ls.style.width = "";
      }, Hs = function(e, t) {
        at.style.backgroundColor = e, at.style.borderColor = t;
      }, Rp = function(e, t, n, o) {
        return sn(Kr(t), e, n, o);
      }, wT = function(e, t, n) {
        return nd = !0, sn(yp(e), e, t, n);
      }, Kr = function(e) {
        var t = e.getSvgRoot();
        const n = e.workspace.scale, o = e.height * n;
        return e = e.width * n, t = s_(t), new Dt(t.y, t.y + o, t.x, t.x + e);
      }, yp = function(e) {
        return e = e.getScaledBBox(), new Dt(e.top, e.bottom, e.left, e.right);
      }, sn = function(e, t, n, o) {
        const c = e.left + (e.right - e.left) / 2, A = e.bottom;
        e = e.top, o && (e += o), o = t.getSourceBlock();
        let D = o.workspace;
        for (; D.options.parentWorkspace; )
          D = D.options.parentWorkspace;
        return Tn(D.getParentSvg().parentNode), vp(t, o.RTL, c, A, c, e, n);
      }, vp = function(e, t, n, o, c, A, D) {
        return ao = e, lT = D || null, at.style.direction = t ? "rtl" : "ltr", e = Te(), aT = e.getRenderer().getClassName(), ss = e.getTheme().getClassName(), aT && be(
          at,
          aT
        ), ss && be(at, ss), Xs(n, o, c, A);
      }, la = function(e, t, n, o) {
        return e = Wo(e, n.left, n.right, o.width), { initialX: e.divX, initialY: t, finalX: e.divX, finalY: t + In, arrowX: e.arrowX, arrowY: -(Ll / 2 + Bu), arrowAtTop: !0, arrowVisible: !0 };
      }, F_ = function(e, t, n, o) {
        return e = Wo(e, n.left, n.right, o.width), { initialX: e.divX, initialY: t - o.height, finalX: e.divX, finalY: t - o.height - In, arrowX: e.arrowX, arrowY: o.height - 2 * Bu - Ll / 2, arrowAtTop: !1, arrowVisible: !0 };
      }, xs = function(e, t, n) {
        return e = Wo(e, t.left, t.right, n.width), { initialX: e.divX, initialY: 0, finalX: e.divX, finalY: 0, arrowAtTop: null, arrowX: null, arrowY: null, arrowVisible: !1 };
      }, Wo = function(e, t, n, o) {
        return t = vo(t, e - o / 2, n - o), e = e - Ll / 2 - t, n = rd, e = vo(n, e, o - n - Ll), { arrowX: e, divX: t };
      }, $t = function() {
        return !!ao;
      }, Nn = function(e, t) {
        return ao === e ? (t ? a_() : BT(), !0) : !1;
      }, BT = function() {
        at.style.transform = "translate(0, 0)", at.style.opacity = "0", Yu = setTimeout(function() {
          a_();
        }, 1e3 * ac), lT && (lT(), lT = null);
      }, a_ = function() {
        $t() && (Yu && clearTimeout(Yu), at.style.transform = "", at.style.left = "", at.style.top = "", at.style.opacity = "0", at.style.display = "none", at.style.backgroundColor = "", at.style.borderColor = "", lT && (lT(), lT = null), Gs(), ao = null, aT && (Be(
          at,
          aT
        ), aT = ""), ss && (Be(at, ss), ss = ""), Te().markFocused());
      }, Xs = function(e, t, n, o) {
        e = Uu.getPositionMetrics(e, t, n, o), e.arrowVisible ? (cT.style.display = "", cT.style.transform = "translate(" + e.arrowX + "px," + e.arrowY + "px) rotate(45deg)", cT.setAttribute("class", e.arrowAtTop ? "blocklyDropDownArrow blocklyArrowTop" : "blocklyDropDownArrow blocklyArrowBottom")) : cT.style.display = "none", t = Math.floor(e.initialX), n = Math.floor(e.initialY), o = Math.floor(e.finalX);
        const c = Math.floor(e.finalY);
        return at.style.left = t + "px", at.style.top = n + "px", at.style.display = "block", at.style.opacity = "1", at.style.transform = "translate(" + (o - t) + "px," + (c - n) + "px)", !!e.arrowAtTop;
      }, $p = function() {
        if (ao) {
          var e = ao.getSourceBlock();
          e = nd ? yp(ao) : Kr(e);
          const t = e.left + (e.right - e.left) / 2;
          Xs(t, e.bottom, t, e.top);
        } else
          BT();
      }, uA = function(e, t) {
        return dr("Blockly.utils.string.startsWith()", "April 2022", "April 2023", "Use built-in string.startsWith"), e.startsWith(t);
      }, Ks = function(e) {
        return e.length ? e.reduce(function(t, n) {
          return t.length < n.length ? t : n;
        }).length : 0;
      }, aa = function(e, t) {
        if (!e.length)
          return 0;
        if (e.length === 1)
          return e[0].length;
        let n = 0;
        t = t || Ks(e);
        let o;
        for (o = 0; o < t; o++) {
          for (var c = e[0][o], A = 1; A < e.length; A++)
            if (c !== e[A][o])
              return n;
          c === " " && (n = o + 1);
        }
        for (c = 1; c < e.length; c++)
          if ((A = e[c][o]) && A !== " ")
            return n;
        return t;
      }, YT = function(e, t) {
        if (!e.length)
          return 0;
        if (e.length === 1)
          return e[0].length;
        let n = 0;
        t = t || Ks(e);
        let o;
        for (o = 0; o < t; o++) {
          for (var c = e[0].substr(-o - 1, 1), A = 1; A < e.length; A++)
            if (c !== e[A].substr(-o - 1, 1))
              return n;
          c === " " && (n = o + 1);
        }
        for (c = 1; c < e.length; c++)
          if ((A = e[c].charAt(e[c].length - o - 1)) && A !== " ")
            return n;
        return t;
      }, r.wrap$$module$build$src$core$utils$string = function(e, t) {
        e = e.split(`
`);
        for (let n = 0; n < e.length; n++)
          e[n] = ko(e[n], t);
        return e.join(`
`);
      }, ko = function(e, t) {
        if (e.length <= t)
          return e;
        const n = e.trim().split(/\s+/);
        for (var o = 0; o < n.length; o++)
          n[o].length > t && (t = n[o].length);
        var c = -1 / 0;
        let A, D = 1;
        do {
          o = c, A = e, e = [], c = n.length / D;
          let $ = 1;
          for (let q = 0; q < n.length - 1; q++)
            $ < (q + 1.5) / c ? ($++, e[q] = !0) : e[q] = !1;
          e = pa(n, e, t), c = ca(n, e, t), e = Wp(n, e), D++;
        } while (c > o);
        return A;
      }, ca = function(e, t, n) {
        const o = [0], c = [];
        for (var A = 0; A < e.length; A++)
          o[o.length - 1] += e[A].length, t[A] === !0 ? (o.push(0), c.push(e[A].charAt(e[A].length - 1))) : t[A] === !1 && o[o.length - 1]++;
        for (e = Math.max(...o), t = 0, A = 0; A < o.length; A++)
          t -= 2 * Math.pow(Math.abs(n - o[A]), 1.5), t -= Math.pow(e - o[A], 1.5), ".?!".indexOf(c[A]) !== -1 ? t += n / 3 : ",;)]}".indexOf(c[A]) !== -1 && (t += n / 4);
        return 1 < o.length && o[o.length - 1] <= o[o.length - 2] && (t += 0.5), t;
      }, pa = function(e, t, n) {
        let o = ca(e, t, n), c;
        for (let A = 0; A < t.length - 1; A++) {
          if (t[A] === t[A + 1])
            continue;
          const D = [].concat(t);
          D[A] = !D[A], D[A + 1] = !D[A + 1];
          const $ = ca(e, D, n);
          $ > o && (o = $, c = D);
        }
        return c ? pa(e, c, n) : t;
      }, Wp = function(e, t) {
        const n = [];
        for (let o = 0; o < e.length; o++)
          n.push(e[o]), t[o] !== void 0 && n.push(t[o] ? `
` : " ");
        return n.join("");
      }, r.isNumber$$module$build$src$core$utils$string = function(e) {
        return /^\s*-?\d+(\.\d+)?\s*$/.test(e);
      }, ua = function(e) {
        cc = e;
      }, Ea = function() {
        return cc;
      }, kp = function() {
        return Nl;
      }, EA = function() {
        return rr;
      }, Hi = function(e) {
        if (e = Js(e)) {
          for (e = e.tooltip; typeof e == "function"; )
            e = e();
          if (typeof e != "string")
            throw Error("Tooltip function must return a string.");
          return e;
        }
        return "";
      }, Js = function(e) {
        for (; e && e.tooltip; ) {
          if (typeof e.tooltip == "string" || typeof e.tooltip == "function")
            return e;
          e = e.tooltip;
        }
        return null;
      }, Fp = function() {
        rr || (rr = document.createElement("div"), rr.className = "blocklyTooltipDiv", (pr() || document.body).appendChild(rr));
      }, UT = function(e) {
        e.mouseOverWrapper_ = hr(e, "pointerover", null, Aa), e.mouseOutWrapper_ = hr(e, "pointerout", null, VT), e.addEventListener("pointermove", da, !1);
      }, Jr = function(e) {
        e && (It(e.mouseOverWrapper_), It(e.mouseOutWrapper_), e.removeEventListener("pointermove", da));
      }, Aa = function(e) {
        as || (e = Js(e.currentTarget), Qn !== e && (ui(), bl = null, Qn = e), clearTimeout(id));
      }, VT = function(e) {
        as || (id = setTimeout(function() {
          bl = Qn = null, ui();
        }, 1), clearTimeout(uT), uT = 0);
      }, da = function(e) {
        if (Qn && Qn.tooltip && !as)
          if (Nl) {
            const t = Vu - e.pageX;
            e = Gu - e.pageY, Math.sqrt(t * t + e * e) > od && ui();
          } else
            bl !== Qn && (clearTimeout(uT), Vu = e.pageX, Gu = e.pageY, uT = setTimeout(SA, Td));
      }, Sa = function() {
        bl = Qn = null, ui();
      }, ui = function() {
        Nl && (Nl = !1, rr && (rr.style.display = "none")), uT && (clearTimeout(uT), uT = 0);
      }, wp = function() {
        ui(), as = !0;
      }, Bp = function() {
        as = !1;
      }, AA = function() {
        rr && Qn && (typeof cc == "function" ? cc(rr, Qn) : dA());
      }, dA = function() {
        var e = Hi(Qn);
        e = r.wrap$$module$build$src$core$utils$string(e, _d), e = e.split(`
`);
        for (let t = 0; t < e.length; t++) {
          const n = document.createElement("div");
          n.appendChild(document.createTextNode(e[t])), rr.appendChild(n);
        }
      }, Fo = function(e) {
        const t = document.documentElement.clientWidth, n = document.documentElement.clientHeight;
        let o = Vu;
        o = e ? o - (Hu + rr.offsetWidth) : o + Hu;
        let c = Gu + xu;
        return c + rr.offsetHeight > n + window.scrollY && (c -= rr.offsetHeight + 2 * xu), e ? o = Math.max(cs - window.scrollX, o) : o + rr.offsetWidth > t + window.scrollX - 2 * cs && (o = t - rr.offsetWidth - 2 * cs), { x: o, y: c };
      }, SA = function() {
        if (!as && (bl = Qn, rr)) {
          rr.textContent = "", AA();
          var e = Qn.RTL;
          rr.style.direction = e ? "rtl" : "ltr", rr.style.display = "block", Nl = !0;
          var { x: t, y: n } = Fo(e);
          rr.style.left = t + "px", rr.style.top = n + "px";
        }
      }, Yp = function() {
        return Xu;
      }, ha = function(e) {
        Xu = e;
      }, Ia = function() {
        return Ku;
      }, Ei = function(e) {
        Ku = e;
      }, c_ = function(e) {
        e = `${e}`.toLowerCase().trim();
        var t = sd[e];
        if (t || (t = e.substring(0, 2) === "0x" ? "#" + e.substring(2) : e, t = t[0] === "#" ? t : "#" + t, /^#[0-9a-f]{6}$/.test(t)))
          return t;
        if (/^#[0-9a-f]{3}$/.test(t))
          return ["#", t[1], t[1], t[2], t[2], t[3], t[3]].join("");
        var n = e.match(/^(?:rgb)?\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/);
        return n && (e = Number(n[1]), t = Number(n[2]), n = Number(n[3]), 0 <= e && 256 > e && 0 <= t && 256 > t && 0 <= n && 256 > n) ? js(
          e,
          t,
          n
        ) : null;
      }, js = function(e, t, n) {
        return t = e << 16 | t << 8 | n, 16 > e ? "#" + (16777216 | t).toString(16).substr(1) : "#" + t.toString(16);
      }, Ma = function(e) {
        return e = c_(e), e ? (e = parseInt(e.substr(1), 16), [e >> 16, e >> 8 & 255, e & 255]) : [0, 0, 0];
      }, ma = function(e, t, n) {
        let o = 0, c = 0, A = 0;
        if (t === 0)
          A = c = o = n;
        else {
          const D = Math.floor(e / 60), $ = e / 60 - D;
          e = n * (1 - t);
          const q = n * (1 - t * $);
          switch (t = n * (1 - t * (1 - $)), D) {
            case 1:
              o = q, c = n, A = e;
              break;
            case 2:
              o = e, c = n, A = t;
              break;
            case 3:
              o = e, c = q, A = n;
              break;
            case 4:
              o = t, c = e, A = n;
              break;
            case 5:
              o = n, c = e, A = q;
              break;
            case 6:
            case 0:
              o = n, c = t, A = e;
          }
        }
        return js(Math.floor(o), Math.floor(c), Math.floor(A));
      }, Xn = function(e, t, n) {
        return e = c_(e), !e || (t = c_(t), !t) ? null : (e = Ma(e), t = Ma(t), js(Math.round(t[0] + n * (e[0] - t[0])), Math.round(t[1] + n * (e[1] - t[1])), Math.round(t[2] + n * (e[2] - t[2]))));
      }, bn = function(e) {
        return ma(e, Xu, 255 * Ku);
      }, zs = function(e, t) {
        const n = [];
        var o = e.split("");
        o.push("");
        var c = 0;
        e = [];
        let A = null;
        for (let q = 0; q < o.length; q++) {
          var D = o[q];
          if (c === 0)
            D === "%" ? ((c = e.join("")) && n.push(c), e.length = 0, c = 1) : e.push(D);
          else if (c === 1)
            D === "%" ? (e.push(D), c = 0) : t && "0" <= D && "9" >= D ? (c = 2, A = D, (D = e.join("")) && n.push(D), e.length = 0) : D === "{" ? c = 3 : (e.push("%", D), c = 0);
          else if (c === 2)
            if ("0" <= D && "9" >= D)
              A += D;
            else {
              var $ = void 0;
              n.push(parseInt(($ = A) != null ? $ : "", 10)), q--, c = 0;
            }
          else
            c === 3 && (D === "" ? (e.splice(0, 0, "%{"), q--, c = 0) : D !== "}" ? e.push(D) : (c = e.join(""), /[A-Z]\w*/i.test(c) ? (D = c.toUpperCase(), (D = D.startsWith("BKY_") ? D.substring(4) : null) && D in r.Msg$$module$build$src$core$msg ? (c = r.Msg$$module$build$src$core$msg[D], typeof c == "string" ? Array.prototype.push.apply(n, zs(c, t)) : t ? n.push(`${c}`) : n.push(c)) : n.push("%{" + c + "}")) : n.push("%{" + c + "}"), c = e.length = 0));
        }
        for ((t = e.join("")) && n.push(t), $ = [], e.length = 0, o = 0; o < n.length; o++)
          typeof n[o] == "string" ? e.push(n[o]) : ((t = e.join("")) && $.push(t), e.length = 0, $.push(n[o]));
        return (t = e.join("")) && $.push(t), e.length = 0, $;
      }, Up = function(e) {
        return zs(e, !0);
      }, xt = function(e) {
        return typeof e != "string" ? e : (e = zs(e, !1), e.length ? String(e[0]) : "");
      }, Pa = function(e) {
        let t = !0;
        const n = r.Msg$$module$build$src$core$msg, o = e.match(/%{BKY_[A-Z]\w*}/gi);
        if (o)
          for (let c = 0; c < o.length; c++) {
            const A = o[c].toUpperCase();
            n[A.slice(6, -1)] === void 0 && (console.warn("No message string for " + o[c] + " in " + e), t = !1);
          }
        return t;
      }, GT = function(e) {
        const t = typeof e == "string" ? xt(e) : e;
        var n = Number(t);
        if (!isNaN(n) && 0 <= n && 360 >= n)
          return { hue: n, hex: ma(n, Yp(), 255 * Ia()) };
        if (n = c_(t))
          return { hue: null, hex: n };
        throw n = 'Invalid colour: "' + t + '"', e !== t && (n += ' (from "' + e + '")'), Error(n);
      }, wo = function() {
        return Mn;
      }, Bo = function(e) {
        Mn = e;
      }, G = function() {
        Mn || (Mn = document.createElement("div"), Mn.className = "blocklyWidgetDiv", (pr() || document.body).appendChild(Mn));
      }, Q = function(e, t, n) {
        J(), ps = e, pc = n, (e = Mn) && (e.style.direction = t ? "rtl" : "ltr", e.style.display = "block", t = Te(), ET = t.getRenderer().getClassName(), us = t.getTheme().getClassName(), ET && be(e, ET), us && be(e, us));
      }, J = function() {
        if (Me()) {
          ps = null;
          var e = Mn;
          e && (e.style.display = "none", e.style.left = "", e.style.top = "", pc && pc(), pc = null, e.textContent = "", ET && (Be(e, ET), ET = ""), us && (Be(e, us), us = ""), Te().markFocused());
        }
      }, Me = function() {
        return !!ps;
      }, Ye = function(e) {
        ps === e && J();
      }, ut = function(e, t, n) {
        Mn.style.left = e + "px", Mn.style.top = t + "px", Mn.style.height = n + "px";
      }, sr = function(e, t, n, o) {
        const c = Da(e, t, n);
        e = Pt(e, t, n, o), 0 > c ? ut(e, 0, n.height + c) : ut(e, c, n.height);
      }, Pt = function(e, t, n, o) {
        return o ? Math.min(Math.max(t.right - n.width, e.left), e.right - n.width) : Math.max(Math.min(t.left, e.right - n.width), e.left);
      }, Da = function(e, t, n) {
        return t.bottom + n.height >= e.bottom ? t.top - n.height : t.bottom;
      }, hA = function(e) {
        return !(e == null || !e.repositionForWindowResize);
      }, ln = function() {
        hA(ps) && ps.repositionForWindowResize() || J();
      }, Br = function(e, t) {
        i(se.FIELD, e, t);
      }, IA = function(e) {
        p(se.FIELD, e);
      }, r.fromJson$$module$build$src$core$field_registry = function(e) {
        return ld.fromJsonInternal(e);
      }, Yo = function(e) {
        const t = y(se.FIELD, e.type);
        if (t) {
          if (typeof t.fromJson != "function")
            throw new TypeError("returned Field was not a IRegistrableField");
          return t.fromJson(e);
        }
        return console.warn("Blockly could not create a field of type " + e.type + ". The field is probably not being registered. This could be because the file is not loaded, the field does not register itself (Issue #1584), or the registration is not being reached."), null;
      }, an = function(e, t) {
        e.setAttribute($S, t);
      }, Mt = function(e, t, n) {
        Array.isArray(n) && (n = n.join(" ")), e.setAttribute(vS + t, `${n}`);
      }, St = function(e) {
        let t = !1;
        const n = e.map(([D, $]) => typeof D == "string" ? [xt(D), $] : (t = !0, [D.alt !== null ? Object.assign({}, D, { alt: xt(D.alt) }) : Object.assign({}, D), $]));
        if (t || 2 > e.length)
          return { options: n };
        var o = n.map(([D]) => D), c = Ks(o);
        e = aa(
          o,
          c
        );
        const A = YT(o, c);
        return !e && !A || c <= e + A ? { options: n } : (c = e ? o[0].substring(0, e - 1) : void 0, o = A ? o[0].substr(1 - A) : void 0, { options: MA(n, e, A), prefix: c, suffix: o });
      }, MA = function(e, t, n) {
        return e.map(([o, c]) => [o.substring(t, o.length - n), c]);
      }, La = function(e) {
        if (!Array.isArray(e))
          throw TypeError("FieldDropdown options must be an array.");
        if (!e.length)
          throw TypeError("FieldDropdown options must not be an empty array.");
        let t = !1;
        for (let n = 0; n < e.length; n++) {
          const o = e[n];
          Array.isArray(o) ? typeof o[1] != "string" ? (t = !0, console.error("Invalid option[" + n + "]: Each FieldDropdown option id must be a string. Found " + o[1] + " in: ", o)) : o[0] && typeof o[0] != "string" && typeof o[0].src != "string" && (t = !0, console.error("Invalid option[" + n + "]: Each FieldDropdown option must have a string label or image description. Found" + o[0] + " in: ", o)) : (t = !0, console.error("Invalid option[" + n + "]: Each FieldDropdown option must be an array. Found: ", o));
        }
        if (t)
          throw TypeError("Found invalid FieldDropdown options.");
      }, Kn = function(e, t) {
        for (const n in t)
          e[n] = t[n] !== null && typeof t[n] == "object" ? Kn(e[n] || /* @__PURE__ */ Object.create(null), t[n]) : t[n];
        return e;
      }, ga = function(e) {
        return e ? ((e instanceof Element || typeof e == "string") && (e = Na(e), e = Vp(e)), mA(e), e) : null;
      }, mA = function(e) {
        const t = e.kind;
        if (e = e.contents, t && t !== cd && t !== zu)
          throw Error("Invalid toolbox kind " + t + ". Please supply either " + cd + " or " + zu);
        if (!e)
          throw Error("Toolbox must have a contents attribute.");
      }, Zs = function(e) {
        return e ? e.contents ? e.contents : Array.isArray(e) && 0 < e.length && !e[0].nodeType ? e : Go(e) : [];
      }, Uo = function(e) {
        return pd.hasCategoriesInternal(e);
      }, Ai = function(e) {
        if (!e)
          return !1;
        const t = e.kind;
        return t ? t === zu : !!e.contents.filter(function(n) {
          return n.kind.toUpperCase() === "CATEGORY";
        }).length;
      }, Vo = function(e) {
        return e && e.contents ? !!e.contents.filter(function(t) {
          return t.kind.toUpperCase() === "CATEGORY";
        }).length : !1;
      }, Vp = function(e) {
        const t = { contents: Go(e) };
        return e instanceof Node && fa(e, t), t;
      }, Go = function(e) {
        const t = [];
        let n = e.childNodes;
        n || (n = e);
        for (let o = 0, c; c = n[o]; o++) {
          if (!c.tagName)
            continue;
          e = {};
          const A = c.tagName.toUpperCase();
          e.kind = A, A === "BLOCK" ? e.blockxml = c : c.childNodes && 0 < c.childNodes.length && (e.contents = Go(c)), fa(c, e), t.push(e);
        }
        return t;
      }, fa = function(e, t) {
        for (let n = 0; n < e.attributes.length; n++) {
          const o = e.attributes[n];
          -1 < o.nodeName.indexOf("css-") ? (t.cssconfig = t.cssconfig || {}, t.cssconfig[o.nodeName.replace("css-", "")] = o.value) : t[o.nodeName] = o.value;
        }
      }, Na = function(e) {
        let t = null;
        if (e)
          if (typeof e == "string") {
            if (t = r.textToDom$$module$build$src$core$utils$xml(e), t.nodeName.toLowerCase() !== "xml")
              throw TypeError("Toolbox should be an <xml> document.");
          } else
            e instanceof Element && (t = e);
        return t;
      }, r.register$$module$build$src$core$extensions = function(e, t) {
        if (typeof e != "string" || e.trim() === "")
          throw Error('Error: Invalid extension name "' + e + '"');
        if (Es[e])
          throw Error('Error: Extension "' + e + '" is already registered.');
        if (typeof t != "function")
          throw Error('Error: Extension "' + e + '" must be a function');
        Es[e] = t;
      }, r.registerMixin$$module$build$src$core$extensions = function(e, t) {
        if (!t || typeof t != "object")
          throw Error('Error: Mixin "' + e + '" must be a object');
        r.register$$module$build$src$core$extensions(e, function() {
          this.mixin(t);
        });
      }, r.registerMutator$$module$build$src$core$extensions = function(e, t, n, o) {
        const c = 'Error when registering mutator "' + e + '": ';
        HT(c, t);
        const A = Gp(t, c);
        if (n && typeof n != "function")
          throw Error(c + 'Extension "' + e + '" is not a function');
        r.register$$module$build$src$core$extensions(e, function() {
          A && this.setMutator(new r.MutatorIcon$$module$build$src$core$icons$mutator_icon(o || [], this)), this.mixin(t), n && n.apply(this);
        });
      }, Qs = function(e) {
        ba(e) ? delete Es[e] : console.warn('No extension mapping for name "' + e + '" found to unregister');
      }, ba = function(e) {
        return !!Es[e];
      }, xi = function(e, t, n) {
        const o = Es[e];
        if (typeof o != "function")
          throw Error('Error: Extension "' + e + '" not found.');
        let c;
        if (n ? Xi(e, t) : c = Ho(t), o.apply(t), n)
          HT('Error after applying mutator "' + e + '": ', t);
        else if (!Oa(
          c,
          t
        ))
          throw Error('Error when applying extension "' + e + '": mutation properties changed when applying a non-mutator extension.');
      }, Xi = function(e, t) {
        if (Ho(t).length)
          throw Error('Error: tried to apply mutation "' + e + '" to a block that already has mutator functions.  Block id: ' + t.id);
      }, qs = function(e, t) {
        return Ca(e.mutationToDom, e.domToMutation, t + " mutationToDom/domToMutation");
      }, PA = function(e, t) {
        return Ca(e.saveExtraState, e.loadExtraState, t + " saveExtraState/loadExtraState");
      }, Gp = function(e, t) {
        return Ca(e.compose, e.decompose, t + " compose/decompose");
      }, Ca = function(e, t, n) {
        if (e && t) {
          if (typeof e != "function" || typeof t != "function")
            throw Error(n + " must be a function");
          return !0;
        }
        if (!e && !t)
          return !1;
        throw Error(n + "Must have both or neither functions");
      }, HT = function(e, t) {
        const n = qs(t, e), o = PA(t, e);
        if (!n && !o)
          throw Error(e + "Mutations must contain either XML hooks, or JSON hooks, or both");
        Gp(t, e);
      }, Ho = function(e) {
        const t = [];
        return e.domToMutation !== void 0 && t.push(e.domToMutation), e.mutationToDom !== void 0 && t.push(e.mutationToDom), e.saveExtraState !== void 0 && t.push(e.saveExtraState), e.loadExtraState !== void 0 && t.push(e.loadExtraState), e.compose !== void 0 && t.push(e.compose), e.decompose !== void 0 && t.push(e.decompose), t;
      }, Oa = function(e, t) {
        if (t = Ho(t), t.length !== e.length)
          return !1;
        for (let n = 0; n < t.length; n++)
          if (e[n] !== t[n])
            return !1;
        return !0;
      }, Ra = function(e) {
        if (typeof document != "object")
          throw Error("runAfterPageLoad() requires browser document.");
        if (document.readyState === "complete")
          e();
        else {
          const t = setInterval(function() {
            document.readyState === "complete" && (clearInterval(t), e());
          }, 10);
        }
      }, r.buildTooltipForDropdown$$module$build$src$core$extensions = function(e, t) {
        const n = [];
        return typeof document == "object" && Ra(function() {
          for (const o in t)
            Pa(t[o]);
        }), function() {
          this.type && n.indexOf(this.type) === -1 && (Hp(this, e, t), n.push(this.type)), this.setTooltip((function() {
            var o = String(this.getFieldValue(e));
            let c = t[o];
            return c === null ? n.indexOf(this.type) === -1 && (o = "No tooltip mapping for value " + o + " of field " + e, this.type !== null && (o += " of block type " + this.type), console.warn(o + ".")) : c = xt(c), c;
          }).bind(this));
        };
      }, Hp = function(e, t, n) {
        var o = e.getField(t);
        if (o instanceof X_ && !o.isOptionListDynamic()) {
          o = o.getOptions();
          for (let c = 0; c < o.length; c++) {
            const A = o[c][1];
            n[A] === null && console.warn("No tooltip mapping for value " + A + " of field " + t + " of block type " + e.type);
          }
        }
      }, r.buildTooltipWithFieldText$$module$build$src$core$extensions = function(e, t) {
        return typeof document == "object" && Ra(function() {
          Pa(e);
        }), function() {
          this.setTooltip((function() {
            const n = this.getField(t);
            return xt(e).replace("%1", n ? n.getText() : "");
          }).bind(this));
        };
      }, DA = function() {
        const e = this.tooltip;
        this.setTooltip((function() {
          const t = this.getParent();
          return t && t.getInputsInline() && t.tooltip || e;
        }).bind(this));
      }, cn = function(e, t) {
        return t = e.indexOf(t), t === -1 ? !1 : (e.splice(t, 1), !0);
      }, Ee = function(e, t) {
        return " " + e + "," + t + " ";
      }, mt = function(e, t) {
        return " " + e + t.join("");
      }, Or = function(e, t) {
        return " M " + e + "," + t + " ";
      }, Wt = function(e, t) {
        return " m " + e + "," + t + " ";
      }, p_ = function(e, t) {
        return " l " + e + "," + t + " ";
      }, xT = function(e) {
        return " l" + e.join("");
      }, de = function(e, t) {
        return " " + e + " " + t + " ";
      }, kt = function(e, t, n, o) {
        return e + " " + n + " " + n + " " + t + o;
      }, el = function(e, t) {
        i(se.ICON, e.toString(), t);
      }, xo = function(e) {
        p(se.ICON, e);
      }, Xo = function(e) {
        if (!(100 < e.getDescendants(!1).length)) {
          var t = e.workspace, n = e.getSvgRoot();
          t.getAudioManager().play("delete");
          var o = t.getSvgXY(n);
          n = n.cloneNode(!0), n.setAttribute("transform", "translate(" + o.x + "," + o.y + ")"), t.getParentSvg().appendChild(n), Ko(n, { x: o.x, y: o.y, width: e.width, height: e.height }, t.RTL, /* @__PURE__ */ new Date(), t.scale);
        }
      }, Ko = function(e, t, n, o, c) {
        const A = ((/* @__PURE__ */ new Date()).getTime() - o.getTime()) / 150;
        1 < A ? Tt(e) : (e.setAttribute("transform", "translate(" + (t.x + (n ? -1 : 1) * t.width * c / 2 * A) + "," + (t.y + t.height * c * A) + ") scale(" + (1 - A) * c + ")"), setTimeout(Ko, 10, e, t, n, o, c));
      }, XT = function(e) {
        const t = e.workspace, n = t.scale;
        if (t.getAudioManager().play("click"), !(1 > n)) {
          var o = t.getSvgXY(e.getSvgRoot());
          e.outputConnection ? (o.x += (e.RTL ? 3 : -3) * n, o.y += 13 * n) : e.previousConnection && (o.x += (e.RTL ? -23 : 23) * n, o.y += 3 * n), e = K(U.CIRCLE, { cx: o.x, cy: o.y, r: 0, fill: "none", stroke: "#888", "stroke-width": 10 }, t.getParentSvg()), Ki(
            e,
            /* @__PURE__ */ new Date(),
            n
          );
        }
      }, Ki = function(e, t, n) {
        const o = ((/* @__PURE__ */ new Date()).getTime() - t.getTime()) / 150;
        1 < o ? Tt(e) : (e.setAttribute("r", String(25 * o * n)), e.style.opacity = String(1 - o), yl = setTimeout(Ki, 10, e, t, n));
      }, xp = function(e) {
        if (KT(), e.workspace.getAudioManager().play("disconnect"), !(1 > e.workspace.scale)) {
          var t = e.getHeightWidth().height;
          t = Math.atan(10 / t) / Math.PI * 180, e.RTL || (t *= -1), vl = e, Xp(e, t, /* @__PURE__ */ new Date());
        }
      }, Xp = function(e, t, n) {
        const o = ((/* @__PURE__ */ new Date()).getTime() - n.getTime()) / 200;
        let c = "";
        1 >= o && (c = `skewX(${Math.round(Math.sin(o * Math.PI * 3) * (1 - o) * t)})`, yl = setTimeout(Xp, 10, e, t, n)), e.getSvgRoot().setAttribute("transform", `${e.getTranslation()} ${c}`);
      }, KT = function() {
        vl && (yl && (clearTimeout(yl), yl = null), vl.getSvgRoot().setAttribute("transform", vl.getTranslation()), vl = null);
      }, JT = function(e, t, n) {
        const o = n.getBoundingRectangle(), c = o.right - o.left, A = vo(t.top, o.top, t.top + t.height - (o.bottom - o.top)) - o.top;
        let D = t.left;
        return t = t.left + t.width - c, e.RTL ? D = Math.min(t, D) : t = Math.max(D, t), (e = vo(D, o.left, t) - o.left) || A ? (n.moveBy(e, A, ["inbounds"]), !0) : !1;
      }, Kp = function(e) {
        return (t) => {
          var n = e.getMetricsManager();
          if (n.hasFixedEdges() && !e.isDragging()) {
            var o;
            if (Ka.indexOf((o = t.type) != null ? o : "") !== -1) {
              o = n.getScrollMetrics(!0);
              const c = tl(e, t);
              c && (n = r.getGroup$$module$build$src$core$events$utils() || !1, r.setGroup$$module$build$src$core$events$utils(t.group), JT(
                e,
                o,
                c
              ) && !t.group && console.warn("Moved object in bounds but there was no event group. This may break undo."), r.setGroup$$module$build$src$core$events$utils(n));
            } else
              t.type === no && t.scale && t.oldScale && t.scale > t.oldScale && Ji(e);
          }
        };
      }, tl = function(e, t) {
        let n = null;
        switch (t.type) {
          case r.CREATE$$module$build$src$core$events$utils:
          case r.MOVE$$module$build$src$core$events$utils:
            (n = e.getBlockById(t.blockId)) && (n = n.getRootBlock());
            break;
          case Zr:
          case Zn:
            n = e.getCommentById(t.commentId);
        }
        return n;
      }, Ji = function(e) {
        var t = e.getMetricsManager();
        if (t.hasFixedEdges() && !e.isDragging()) {
          t = t.getScrollMetrics(!0);
          var n = e.getTopBoundedElements();
          for (let o = 0, c; c = n[o]; o++)
            JT(e, t, c);
        }
      }, ya = function(e) {
        return ji(e), ds || (ds = new Promise((t) => {
          window.requestAnimationFrame(() => {
            rl(), t();
          });
        })), ds;
      }, C = function() {
        return ds || Promise.resolve();
      }, ji = function(e) {
        Lc.add(e);
        const t = e.getParent();
        t ? ji(t) : Dc.add(e);
      }, rl = function() {
        const e = new Set([...Dc].map((t) => t.workspace));
        for (const t of Dc) {
          if (t.isDisposed() || t.getParent())
            continue;
          pn(t);
          const n = t.getRelativeToSurfaceXY();
          nt(t, n), Jp(
            t,
            n
          );
        }
        for (const t of e)
          t.resizeContents();
        Dc.clear(), Lc = /* @__PURE__ */ new Set(), ds = null;
      }, pn = function(e) {
        if (Lc.has(e)) {
          for (const t of e.getChildren(!1))
            pn(t);
          e.renderEfficiently();
        }
      }, nt = function(e, t) {
        for (const n of e.getConnections_(!1)) {
          e = n.moveToOffset(t);
          const o = n.targetBlock();
          n.isSuperior() && o && (e || Lc.has(o)) && nt(o, ae.sum(t, o.relativeCoords));
        }
      }, Jp = function(e, t) {
        if (e.getIcons) {
          for (const n of e.getIcons())
            n.onLocationChange(t);
          for (const n of e.getChildren(!1))
            Jp(n, ae.sum(t, n.relativeCoords));
        }
      }, jp = function(e, t) {
        const n = [];
        for (const o of e.getIcons())
          (!Vi(o) || o.bubbleIsVisible()) && (n.push({ location: t, icon: o }), o.onLocationChange(t));
        for (const o of e.getChildren(!1))
          n.push(...jp(o, ae.sum(t, o.relativeCoords)));
        return n;
      }, nl = function(e) {
        Kt.copyInternal(e);
      }, zi = function(e) {
        _r = e.toCopyData();
      }, zp = function() {
        if (!_r)
          return null;
        let e = _r.source;
        return e.isFlyout && (e = e.targetWorkspace), _r.typeCounts && e.isCapacityAvailable(_r.typeCounts) ? e.paste(_r.saveInfo) : null;
      }, va = function(e) {
        return Kt.duplicateInternal(e);
      }, LA = function(e) {
        const t = _r;
        nl(e);
        let n, o, c;
        return e = (c = (n = e.toCopyData()) == null || (o = n.source) == null ? void 0 : o.paste(_r.saveInfo)) != null ? c : null, _r = t, e;
      }, gA = function() {
        return I_;
      }, Zp = function(e) {
        I_ = e;
      }, Cn = function(e, t, n) {
        if (Q(Sd, n, u_), t.length) {
          var o = fA(t, n);
          gc = o, NA(o, e, n), setTimeout(function() {
            o.focus();
          }, 1), I_ = null;
        } else
          _l();
      }, fA = function(e, t) {
        const n = new Ju();
        n.setRole(mn.MENU);
        for (let o = 0; o < e.length; o++) {
          const c = e[o], A = new ju(c.text);
          A.setRightToLeft(t), A.setRole(mn.MENUITEM), n.addChild(A), A.setEnabled(c.enabled), c.enabled && A.onAction(function() {
            _l(), requestAnimationFrame(() => {
              setTimeout(
                () => {
                  c.callback(c.scope);
                },
                0
              );
            });
          }, {});
        }
        return n;
      }, NA = function(e, t, n) {
        const o = ra();
        t = new Dt(t.clientY + o.top, t.clientY + o.top, t.clientX + o.left, t.clientX + o.left), bA(e);
        const c = e.getSize();
        n && (t.left += c.width, t.right += c.width, o.left += c.width, o.right += c.width), sr(o, t, c, n), e.focus();
      }, bA = function(e) {
        var t = wo();
        if (!t)
          throw Error("Attempting to create a context menu when widget div is null");
        t = e.render(t), be(t, "blocklyContextMenu"), Pe(t, "contextmenu", null, CA), e.focus();
      }, CA = function(e) {
        e.preventDefault(), e.stopPropagation();
      }, _l = function() {
        Ye(Sd), I_ = null;
      }, u_ = function() {
        gc && (gc.dispose(), gc = null);
      }, r.callbackFactory$$module$build$src$core$contextmenu = function(e, t) {
        return () => {
          r.disable$$module$build$src$core$events$utils();
          let n;
          try {
            n = r.domToBlock$$module$build$src$core$xml(t, e.workspace);
            const o = e.getRelativeToSurfaceXY();
            o.x = e.RTL ? o.x - r.config$$module$build$src$core$config.snapRadius : o.x + r.config$$module$build$src$core$config.snapRadius, o.y += 2 * r.config$$module$build$src$core$config.snapRadius, n.moveBy(o.x, o.y);
          } finally {
            r.enable$$module$build$src$core$events$utils();
          }
          tt() && !n.isShadow() && fe(new (ge(r.CREATE$$module$build$src$core$events$utils))(n)), n.select();
        };
      }, Qp = function(e) {
        return { text: r.Msg$$module$build$src$core$msg.REMOVE_COMMENT, enabled: !0, callback: function() {
          r.setGroup$$module$build$src$core$events$utils(!0), e.dispose(), r.setGroup$$module$build$src$core$events$utils(!1);
        } };
      }, qp = function(e) {
        return { text: r.Msg$$module$build$src$core$msg.DUPLICATE_COMMENT, enabled: !0, callback: function() {
          va(e);
        } };
      }, OA = function(e, t) {
        const n = { enabled: !0 };
        return n.text = r.Msg$$module$build$src$core$msg.ADD_COMMENT, n.callback = function() {
          const o = new yr(e, r.Msg$$module$build$src$core$msg.WORKSPACE_COMMENT_DEFAULT_TEXT, yr.DEFAULT_SIZE, yr.DEFAULT_SIZE);
          var c = e.getInjectionDiv().getBoundingClientRect();
          c = new ae(t.clientX - c.left, t.clientY - c.top);
          const A = e.getOriginOffsetInPixels();
          c = ae.difference(c, A), c.scale(1 / e.scale), o.moveBy(c.x, c.y), e.rendered && (o.initSvg(), o.render(), o.select());
        }, n;
      }, il = function(e) {
        let t = e.outputConnection;
        return (!t || e.previousConnection && e.previousConnection.isConnected()) && (t = e.previousConnection), t;
      }, eu = function(e) {
        return e.isDynamic;
      }, Jn = function(e, t) {
        i(se.RENDERER, e, t);
      }, RA = function(e) {
        p(se.RENDERER, e);
      }, tu = function(e, t, n) {
        return e = new (L(se.RENDERER, e))(e), e.init(t, n), e;
      }, On = function() {
        ct.registry.register({ displayText() {
          return r.Msg$$module$build$src$core$msg.UNDO;
        }, preconditionFn(e) {
          return 0 < e.workspace.getUndoStack().length ? "enabled" : "disabled";
        }, callback(e) {
          e.workspace.undo(!1);
        }, scopeType: ct.ScopeType.WORKSPACE, id: "undoWorkspace", weight: 1 });
      }, ru = function() {
        ct.registry.register({ displayText() {
          return r.Msg$$module$build$src$core$msg.REDO;
        }, preconditionFn(e) {
          return 0 < e.workspace.getRedoStack().length ? "enabled" : "disabled";
        }, callback(e) {
          e.workspace.undo(!0);
        }, scopeType: ct.ScopeType.WORKSPACE, id: "redoWorkspace", weight: 2 });
      }, nu = function() {
        ct.registry.register({ displayText() {
          return r.Msg$$module$build$src$core$msg.CLEAN_UP;
        }, preconditionFn(e) {
          return e.workspace.isMovable() ? 1 < e.workspace.getTopBlocks(!1).length ? "enabled" : "disabled" : "hidden";
        }, callback(e) {
          e.workspace.cleanUp();
        }, scopeType: ct.ScopeType.WORKSPACE, id: "cleanWorkspace", weight: 3 });
      }, _u = function(e, t) {
        function n(A) {
          c--, A.setCollapsed(e), c === 0 && r.setGroup$$module$build$src$core$events$utils(!1);
        }
        let o = 0, c = 0;
        r.setGroup$$module$build$src$core$events$utils(!0);
        for (let A = 0; A < t.length; A++) {
          let D = t[A];
          for (; D; )
            c++, setTimeout(n.bind(null, D), o), D = D.getNextBlock(), o += 10;
        }
      }, iu = function() {
        ct.registry.register({ displayText() {
          return r.Msg$$module$build$src$core$msg.COLLAPSE_ALL;
        }, preconditionFn(e) {
          if (e.workspace.options.collapse) {
            e = e.workspace.getTopBlocks(!1);
            for (let t = 0; t < e.length; t++) {
              let n = e[t];
              for (; n; ) {
                if (!n.isCollapsed())
                  return "enabled";
                n = n.getNextBlock();
              }
            }
            return "disabled";
          }
          return "hidden";
        }, callback(e) {
          _u(
            !0,
            e.workspace.getTopBlocks(!0)
          );
        }, scopeType: ct.ScopeType.WORKSPACE, id: "collapseWorkspace", weight: 4 });
      }, ou = function() {
        ct.registry.register({ displayText() {
          return r.Msg$$module$build$src$core$msg.EXPAND_ALL;
        }, preconditionFn(e) {
          if (e.workspace.options.collapse) {
            e = e.workspace.getTopBlocks(!1);
            for (let t = 0; t < e.length; t++) {
              let n = e[t];
              for (; n; ) {
                if (n.isCollapsed())
                  return "enabled";
                n = n.getNextBlock();
              }
            }
            return "disabled";
          }
          return "hidden";
        }, callback(e) {
          _u(
            !1,
            e.workspace.getTopBlocks(!0)
          );
        }, scopeType: ct.ScopeType.WORKSPACE, id: "expandWorkspace", weight: 5 });
      }, $a = function(e, t) {
        if (e.isDeletable())
          Array.prototype.push.apply(t, e.getDescendants(!1));
        else {
          e = e.getChildren(!1);
          for (let n = 0; n < e.length; n++)
            $a(e[n], t);
        }
      }, ol = function(e) {
        const t = [];
        e = e.getTopBlocks(!0);
        for (let n = 0; n < e.length; n++)
          $a(e[n], t);
        return t;
      }, Tl = function(e, t) {
        t ? r.setGroup$$module$build$src$core$events$utils(t) : (r.setGroup$$module$build$src$core$events$utils(!0), t = r.getGroup$$module$build$src$core$events$utils());
        const n = e.shift();
        n && (n.isDeadOrDying() ? Tl(e, t) : (n.dispose(!1, !0), setTimeout(Tl, 10, e, t))), r.setGroup$$module$build$src$core$events$utils(!1);
      }, Tu = function() {
        ct.registry.register({
          displayText(e) {
            return e.workspace ? (e = ol(e.workspace).length, e === 1 ? r.Msg$$module$build$src$core$msg.DELETE_BLOCK : r.Msg$$module$build$src$core$msg.DELETE_X_BLOCKS.replace("%1", `${e}`)) : "";
          },
          preconditionFn(e) {
            return e.workspace && 0 < ol(e.workspace).length ? "enabled" : "disabled";
          },
          callback(e) {
            if (e.workspace) {
              e.workspace.cancelCurrentGesture();
              var t = ol(e.workspace);
              2 > t.length ? Tl(t) : Xr(r.Msg$$module$build$src$core$msg.DELETE_ALL_BLOCKS.replace("%1", String(t.length)), function(n) {
                n && Tl(t);
              });
            }
          },
          scopeType: ct.ScopeType.WORKSPACE,
          id: "workspaceDelete",
          weight: 6
        });
      }, Wa = function() {
        On(), ru(), nu(), iu(), ou(), Tu();
      }, Jo = function() {
        ct.registry.register({
          displayText() {
            return r.Msg$$module$build$src$core$msg.DUPLICATE_BLOCK;
          },
          preconditionFn(e) {
            return e = e.block, !e.isInFlyout && e.isDeletable() && e.isMovable() ? e.isDuplicatable() ? "enabled" : "disabled" : "hidden";
          },
          callback(e) {
            e.block && va(e.block);
          },
          scopeType: ct.ScopeType.BLOCK,
          id: "blockDuplicate",
          weight: 1
        });
      }, jT = function() {
        ct.registry.register({ displayText(e) {
          return e.block.hasIcon(br.TYPE) ? r.Msg$$module$build$src$core$msg.REMOVE_COMMENT : r.Msg$$module$build$src$core$msg.ADD_COMMENT;
        }, preconditionFn(e) {
          return e = e.block, !e.isInFlyout && e.workspace.options.comments && !e.isCollapsed() && e.isEditable() ? "enabled" : "hidden";
        }, callback(e) {
          e = e.block, e.hasIcon(br.TYPE) ? e.setCommentText(null) : e.setCommentText("");
        }, scopeType: ct.ScopeType.BLOCK, id: "blockComment", weight: 2 });
      }, su = function() {
        ct.registry.register({ displayText(e) {
          return e.block.getInputsInline() ? r.Msg$$module$build$src$core$msg.EXTERNAL_INPUTS : r.Msg$$module$build$src$core$msg.INLINE_INPUTS;
        }, preconditionFn(e) {
          if (e = e.block, !e.isInFlyout && e.isMovable() && !e.isCollapsed()) {
            for (let t = 1; t < e.inputList.length; t++)
              if (!(e.inputList[t - 1] instanceof $c || e.inputList[t] instanceof $c))
                return "enabled";
          }
          return "hidden";
        }, callback(e) {
          e.block.setInputsInline(!e.block.getInputsInline());
        }, scopeType: ct.ScopeType.BLOCK, id: "blockInline", weight: 3 });
      }, ka = function() {
        ct.registry.register({
          displayText(e) {
            return e.block.isCollapsed() ? r.Msg$$module$build$src$core$msg.EXPAND_BLOCK : r.Msg$$module$build$src$core$msg.COLLAPSE_BLOCK;
          },
          preconditionFn(e) {
            return e = e.block, !e.isInFlyout && e.isMovable() && e.workspace.options.collapse ? "enabled" : "hidden";
          },
          callback(e) {
            e.block.setCollapsed(!e.block.isCollapsed());
          },
          scopeType: ct.ScopeType.BLOCK,
          id: "blockCollapseExpand",
          weight: 4
        });
      }, lu = function() {
        ct.registry.register({ displayText(e) {
          return e.block.isEnabled() ? r.Msg$$module$build$src$core$msg.DISABLE_BLOCK : r.Msg$$module$build$src$core$msg.ENABLE_BLOCK;
        }, preconditionFn(e) {
          return e = e.block, !e.isInFlyout && e.workspace.options.disable && e.isEditable() ? e.getInheritedDisabled() ? "disabled" : "enabled" : "hidden";
        }, callback(e) {
          e = e.block;
          const t = r.getGroup$$module$build$src$core$events$utils();
          t || r.setGroup$$module$build$src$core$events$utils(!0), e.setEnabled(!e.isEnabled()), r.setGroup$$module$build$src$core$events$utils(t);
        }, scopeType: ct.ScopeType.BLOCK, id: "blockDisable", weight: 5 });
      }, E_ = function() {
        ct.registry.register({ displayText(e) {
          var t = e.block;
          return e = t.getDescendants(!1).length, (t = t.getNextBlock()) && (e -= t.getDescendants(!1).length), e === 1 ? r.Msg$$module$build$src$core$msg.DELETE_BLOCK : r.Msg$$module$build$src$core$msg.DELETE_X_BLOCKS.replace("%1", `${e}`);
        }, preconditionFn(e) {
          return !e.block.isInFlyout && e.block.isDeletable() ? "enabled" : "hidden";
        }, callback(e) {
          e.block && e.block.checkAndDelete();
        }, scopeType: ct.ScopeType.BLOCK, id: "blockDelete", weight: 6 });
      }, sl = function() {
        ct.registry.register({ displayText() {
          return r.Msg$$module$build$src$core$msg.HELP;
        }, preconditionFn(e) {
          return e = e.block, (typeof e.helpUrl == "function" ? e.helpUrl() : e.helpUrl) ? "enabled" : "hidden";
        }, callback(e) {
          e.block.showHelp();
        }, scopeType: ct.ScopeType.BLOCK, id: "blockHelp", weight: 7 });
      }, Zi = function() {
        Jo(), jT(), su(), ka(), lu(), E_(), sl();
      }, un = function() {
        Wa(), Zi();
      }, Qi = function(e) {
        return e.getProcedureModel !== void 0 && e.doProcedureUpdate !== void 0 && e.isProcedureDef !== void 0;
      }, ll = function(e) {
        return e.startPublishing !== void 0 && e.stopPublishing !== void 0;
      }, al = function(e) {
        const t = e.getProcedureMap().getProcedures().filter((o) => !o.getReturnTypes()).map((o) => [o.getName(), o.getParameters().map((c) => c.getName()), !1]);
        e.getBlocksByType("procedures_defnoreturn", !1).forEach((o) => {
          !Qi(o) && Y(o) && t.push(o.getProcedureDef());
        });
        const n = e.getProcedureMap().getProcedures().filter((o) => !!o.getReturnTypes()).map((o) => [o.getName(), o.getParameters().map((c) => c.getName()), !0]);
        return e.getBlocksByType("procedures_defreturn", !1).forEach((o) => {
          !Qi(o) && Y(o) && n.push(o.getProcedureDef());
        }), t.sort(jo), n.sort(jo), [t, n];
      }, jo = function(e, t) {
        return e[0].localeCompare(t[0], void 0, { sensitivity: "base" });
      }, r.findLegalName$$module$build$src$core$procedures = function(e, t) {
        if (t.isInFlyout)
          return e;
        for (e = e || r.Msg$$module$build$src$core$msg.UNNAMED_KEY || "unnamed"; !di(e, t.workspace, t); ) {
          const n = e.match(/^(.*?)(\d+)$/);
          e = n ? n[1] + (parseInt(n[2]) + 1) : e + "2";
        }
        return e;
      }, di = function(e, t, n) {
        return !Fa(e, t, n);
      }, Fa = function(e, t, n) {
        for (const o of t.getAllBlocks(!1))
          if (o !== n && Y(o) && r.Names$$module$build$src$core$names.equals(o.getProcedureDef()[0], e))
            return !0;
        n = n && Qi(n) ? n == null ? void 0 : n.getProcedureModel() : void 0;
        for (const o of t.getProcedureMap().getProcedures())
          if (o !== n && r.Names$$module$build$src$core$names.equals(
            o.getName(),
            e
          ))
            return !0;
        return !1;
      }, r.rename$$module$build$src$core$procedures = function(e) {
        var t = this.getSourceBlock();
        if (!t)
          throw new nr();
        e = e.trim();
        const n = r.findLegalName$$module$build$src$core$procedures(e, t);
        Qi(t) && !t.isInsertionMarker() && t.getProcedureModel().setName(n);
        const o = this.getValue();
        if (o !== e && o !== n)
          for (e = t.workspace.getAllBlocks(!1), t = 0; t < e.length; t++) {
            const c = e[t];
            c.renameProcedure && c.renameProcedure(o, n);
          }
        return n;
      }, wa = function(e) {
        function t(A, D) {
          for (let q = 0; q < A.length; q++) {
            var $ = A[q][0];
            const De = A[q][1], or = r.createElement$$module$build$src$core$utils$xml("block");
            or.setAttribute("type", D), or.setAttribute("gap", "16");
            const Ft = r.createElement$$module$build$src$core$utils$xml("mutation");
            for (Ft.setAttribute("name", $), or.appendChild(Ft), $ = 0; $ < De.length; $++) {
              const n_ = r.createElement$$module$build$src$core$utils$xml("arg");
              n_.setAttribute("name", De[$]), Ft.appendChild(n_);
            }
            n.push(or);
          }
        }
        const n = [];
        if (jr.procedures_defnoreturn) {
          var o = r.createElement$$module$build$src$core$utils$xml("block");
          o.setAttribute("type", "procedures_defnoreturn"), o.setAttribute("gap", "16");
          var c = r.createElement$$module$build$src$core$utils$xml("field");
          c.setAttribute("name", "NAME"), c.appendChild(r.createTextNode$$module$build$src$core$utils$xml(r.Msg$$module$build$src$core$msg.PROCEDURES_DEFNORETURN_PROCEDURE)), o.appendChild(c), n.push(o);
        }
        return jr.procedures_defreturn && (o = r.createElement$$module$build$src$core$utils$xml("block"), o.setAttribute("type", "procedures_defreturn"), o.setAttribute("gap", "16"), c = r.createElement$$module$build$src$core$utils$xml("field"), c.setAttribute("name", "NAME"), c.appendChild(r.createTextNode$$module$build$src$core$utils$xml(r.Msg$$module$build$src$core$msg.PROCEDURES_DEFRETURN_PROCEDURE)), o.appendChild(c), n.push(o)), jr.procedures_ifreturn && (o = r.createElement$$module$build$src$core$utils$xml("block"), o.setAttribute("type", "procedures_ifreturn"), o.setAttribute("gap", "16"), n.push(o)), n.length && n[n.length - 1].setAttribute("gap", "24"), e = al(e), t(e[0], "procedures_callnoreturn"), t(e[1], "procedures_callreturn"), n;
      }, zT = function(e) {
        var t = [], n = e.getBlocksByType("procedures_mutatorarg", !1);
        for (let A = 0, D; D = n[A]; A++)
          t.push(D.getFieldValue("NAME"));
        n = r.createElement$$module$build$src$core$utils$xml("xml");
        const o = r.createElement$$module$build$src$core$utils$xml("block");
        o.setAttribute("type", "procedures_mutatorarg");
        const c = r.createElement$$module$build$src$core$utils$xml("field");
        c.setAttribute("name", "NAME"), t = ai(
          r.DEFAULT_ARG$$module$build$src$core$procedures,
          t
        ), t = r.createTextNode$$module$build$src$core$utils$xml(t), c.appendChild(t), o.appendChild(c), n.appendChild(o), e.updateToolbox(n);
      }, au = function(e) {
        if (e.type === A_ && e.bubbleType === "mutator" && e.isOpen && e.blockId) {
          e = le(e.workspaceId).getBlockById(e.blockId);
          var t = e.type;
          (t === "procedures_defnoreturn" || t === "procedures_defreturn") && (e = e.getIcon(r.MutatorIcon$$module$build$src$core$icons$mutator_icon.TYPE).getWorkspace(), zT(e), e.addChangeListener(cu));
        }
      }, cu = function(e) {
        (e.type === r.CREATE$$module$build$src$core$events$utils || e.type === r.DELETE$$module$build$src$core$events$utils || e.type === r.CHANGE$$module$build$src$core$events$utils || e.type === Mi) && (e = le(e.workspaceId), zT(e));
      }, Ir = function(e, t) {
        return t.getAllBlocks(!1).filter((n) => Ba(n, e) || ie(n) && r.Names$$module$build$src$core$names.equals(n.getProcedureCall(), e));
      }, Ba = function(e, t) {
        return Qi(e) && !e.isProcedureDef() && e.getProcedureModel() && r.Names$$module$build$src$core$names.equals(e.getProcedureModel().getName(), t);
      }, r.mutateCallers$$module$build$src$core$procedures = function(e) {
        const t = Cr();
        var n = e.getProcedureDef()[0];
        const o = e.mutationToDom(!0);
        e = Ir(n, e.workspace);
        for (let A = 0, D; D = e[A]; A++) {
          n = (n = D.mutationToDom()) && Hr(n), D.domToMutation && D.domToMutation(o);
          var c = D.mutationToDom();
          c = c && Hr(c), n !== c && (ur(!1), fe(new (ge(r.CHANGE$$module$build$src$core$events$utils))(D, "mutation", null, n, c)), ur(t));
        }
      }, r.getDefinition$$module$build$src$core$procedures = function(e, t) {
        for (const n of t.getAllBlocks(!1))
          if (Qi(n) && n.isProcedureDef() && r.Names$$module$build$src$core$names.equals(n.getProcedureModel().getName(), e) || Y(n) && r.Names$$module$build$src$core$names.equals(n.getProcedureDef()[0], e))
            return n;
        return null;
      }, Ya = function(e) {
        v_(e.getTargetWorkspace(), void 0, "String");
      }, jn = function(e) {
        v_(e.getTargetWorkspace(), void 0, "Number");
      }, cl = function(e) {
        v_(e.getTargetWorkspace(), void 0, "Colour");
      }, zo = function(e) {
        let t = [], n = document.createElement("button");
        return n.setAttribute("text", r.Msg$$module$build$src$core$msg.NEW_STRING_VARIABLE), n.setAttribute("callbackKey", "CREATE_VARIABLE_STRING"), t.push(n), n = document.createElement("button"), n.setAttribute("text", r.Msg$$module$build$src$core$msg.NEW_NUMBER_VARIABLE), n.setAttribute("callbackKey", "CREATE_VARIABLE_NUMBER"), t.push(n), n = document.createElement("button"), n.setAttribute("text", r.Msg$$module$build$src$core$msg.NEW_COLOUR_VARIABLE), n.setAttribute("callbackKey", "CREATE_VARIABLE_COLOUR"), t.push(n), e.registerButtonCallback("CREATE_VARIABLE_STRING", Ya), e.registerButtonCallback("CREATE_VARIABLE_NUMBER", jn), e.registerButtonCallback("CREATE_VARIABLE_COLOUR", cl), e = Si(e), t = t.concat(e);
      }, Si = function(e) {
        e = e.getAllVariables();
        const t = [];
        if (0 < e.length) {
          if (jr.variables_set_dynamic) {
            var n = e[e.length - 1];
            const o = r.createElement$$module$build$src$core$utils$xml("block");
            o.setAttribute("type", "variables_set_dynamic"), o.setAttribute("gap", "24"), o.appendChild(r.generateVariableFieldDom$$module$build$src$core$variables(n)), t.push(o);
          }
          if (jr.variables_get_dynamic) {
            e.sort(rs.compareByName);
            for (let o = 0, c; c = e[o]; o++)
              n = r.createElement$$module$build$src$core$utils$xml("block"), n.setAttribute("type", "variables_get_dynamic"), n.setAttribute("gap", "8"), n.appendChild(r.generateVariableFieldDom$$module$build$src$core$variables(c)), t.push(n);
          }
        }
        return t;
      }, pl = function(e, t, n, o, c, A) {
        const D = A.scrollbar && A.scrollbar.canScrollVertically();
        return e.horizontal === fs.LEFT ? (n = c.absoluteMetrics.left + n, D && A.RTL && (n += Xt.scrollbarThickness)) : (n = c.absoluteMetrics.left + c.viewMetrics.width - t.width - n, D && !A.RTL && (n -= Xt.scrollbarThickness)), e.vertical === L_.TOP ? e = c.absoluteMetrics.top + o : (e = c.absoluteMetrics.top + c.viewMetrics.height - t.height - o, A.scrollbar && A.scrollbar.canScrollHorizontally() && (e -= Xt.scrollbarThickness)), new Dt(e, e + t.height, n, n + t.width);
      }, gr = function(e, t) {
        return { horizontal: t.toolboxMetrics.position === Ue.LEFT || e.horizontalLayout && !e.RTL ? fs.RIGHT : fs.LEFT, vertical: t.toolboxMetrics.position === Ue.BOTTOM ? L_.TOP : L_.BOTTOM };
      }, ZT = function(e, t, n, o) {
        const c = e.left, A = e.right - e.left, D = e.bottom - e.top;
        for (let $ = 0; $ < o.length; $++) {
          const q = o[$];
          e.intersects(q) && (e = n === Mo.UP ? q.top - D - t : q.bottom + t, e = new Dt(e, e + D, c, c + A), $ = -1);
        }
        return e;
      }, yA = function(e, t) {
        var n = null;
        n = typeof e == "string" ? document.getElementById(e) || document.querySelector(e) : e;
        let o;
        if (!document.contains(n) && document !== ((o = n) == null ? void 0 : o.ownerDocument))
          throw Error("Error: container is not in current document");
        e = new qn(t || {}), t = document.createElement("div"), t.className = "injectionDiv", t.tabIndex = 0, Mt(t, Ot.LABEL, r.Msg$$module$build$src$core$msg.WORKSPACE_ARIA_LABEL), n.appendChild(t), n = vA(t, e);
        const c = $A(n, e);
        return Ua(c), Le(c), Je(c), t.addEventListener("focusin", function() {
          Le(c);
        }), c;
      }, vA = function(e, t) {
        e.setAttribute("dir", "LTR"), cp(t.hasCss, t.pathToMedia), e = K(U.SVG, { xmlns: Sl, "xmlns:html": Pi, "xmlns:xlink": $n, version: "1.1", class: "blocklySvg", tabindex: "0" }, e);
        const n = K(
          U.DEFS,
          {},
          e
        ), o = String(Math.random()).substring(2);
        return t.gridPattern = LE.createDom(o, t.gridOptions, n), e;
      }, $A = function(e, t) {
        t.parentWorkspace = null, t = new g_(t);
        const n = t.options;
        t.scale = n.zoomOptions.startScale, e.appendChild(t.createDom("blocklyMainBackground"));
        var o = t.getInjectionDiv(), c = t.getRenderer().getClassName();
        return c && be(o, c), (c = t.getTheme().getClassName()) && be(o, c), !n.hasCategories && n.languageTree && (o = t.addFlyout(U.SVG), Sr(o, e)), n.hasTrashcan && t.addTrashcan(), n.zoomOptions && n.zoomOptions.controls && t.addZoomControls(), t.getThemeManager().subscribe(e, "workspaceBackgroundColour", "background-color"), t.translate(0, 0), t.addChangeListener(Kp(t)), Je(t), G(), Vs(), Fp(), t;
      }, Ua = function(e) {
        const t = e.options;
        var n = e.getParentSvg();
        if (Pe(n.parentNode, "contextmenu", null, function(o) {
          vs(o) || o.preventDefault();
        }), n = Pe(window, "resize", null, function() {
          ui(), e.hideComponents(!0), $p(), ln(), Je(e), Ji(e);
        }), e.setResizeHandlerWrapper(n), QT(), t.languageTree) {
          n = e.getToolbox();
          const o = e.getFlyout(!0);
          n ? n.init() : o && (o.init(e), o.show(t.languageTree), typeof o.scrollToStart == "function" && o.scrollToStart());
        }
        t.hasTrashcan && e.trashcan.init(), t.zoomOptions && t.zoomOptions.controls && e.zoomControls_.init(), t.moveOptions && t.moveOptions.scrollbars ? (e.scrollbar = new DE(e, t.moveOptions.scrollbars === !0 || !!t.moveOptions.scrollbars.horizontal, t.moveOptions.scrollbars === !0 || !!t.moveOptions.scrollbars.vertical, "blocklyMainWorkspaceScrollbar"), e.scrollbar.resize()) : e.setMetrics({ x: 0.5, y: 0.5 }), t.hasSounds && pu(t.pathToMedia, e);
      }, WA = function(e) {
        const t = Te();
        t && !(vs(e) || t.rendered && !t.isVisible()) && Et.registry.onKeyDown(t, e);
      }, QT = function() {
        Fd || (Pe(document, "scroll", null, function() {
          const e = ce();
          for (let t = 0, n; n = e[t]; t++)
            n instanceof g_ && n.updateInverseScreenCTM();
        }), Pe(document, "keydown", null, WA), hr(
          document,
          "touchend",
          null,
          ee
        ), hr(document, "touchcancel", null, ee), os && Pe(window, "orientationchange", document, function() {
          Je(Te());
        })), Fd = !0;
      }, pu = function(e, t) {
        function n() {
          for (; c.length; ) {
            const A = c.pop();
            A && It(A);
          }
          o.preload();
        }
        const o = t.getAudioManager();
        o.load([e + "click.mp3", e + "click.wav", e + "click.ogg"], "click"), o.load([e + "disconnect.wav", e + "disconnect.mp3", e + "disconnect.ogg"], "disconnect"), o.load([e + "delete.mp3", e + "delete.ogg", e + "delete.wav"], "delete");
        const c = [];
        c.push(Pe(document, "pointermove", null, n, !0)), c.push(Pe(document, "touchstart", null, n, !0));
      }, kA = function(e) {
        return e.getType !== void 0 && e.initView !== void 0 && e.dispose !== void 0 && e.getWeight !== void 0 && e.getSize !== void 0 && e.applyColour !== void 0 && e.hideForInsertionMarker !== void 0 && e.updateEditable !== void 0 && e.updateCollapsed !== void 0 && e.isShownWhenCollapsed !== void 0 && e.setOffsetInBlock !== void 0 && e.onLocationChange !== void 0 && e.onClick !== void 0;
      }, uu = function(e) {
        const t = { id: e.getId(), name: e.getName(), returnTypes: e.getReturnTypes() };
        return e.getParameters().length && (t.parameters = e.getParameters().map((n) => Zo(n))), t;
      }, Zo = function(e) {
        const t = { id: e.getId(), name: e.getName() };
        return e.getTypes().length && (t.types = e.getTypes()), t;
      }, Eu = function(e, t, n, o) {
        if (e = new e(o, n.name, n.id).setReturnTypes(n.returnTypes), !n.parameters)
          return e;
        for (const [c, A] of n.parameters.entries())
          e.insertParameter(Au(t, A, o), c);
        return e;
      }, Au = function(e, t, n) {
        return e = new e(n, t.name, t.id), t.types && e.setTypes(t.types), e;
      }, Va = function(e) {
        const t = /* @__PURE__ */ Object.create(null), n = V(se.SERIALIZER, !0);
        for (const o in n) {
          let c;
          const A = (c = n[o]) == null ? void 0 : c.save(e);
          A && (t[o] = A);
        }
        return t;
      }, du = function(e, t, { recordUndo: n = !1 } = {}) {
        var o = V(se.SERIALIZER, !0);
        if (o) {
          o = Object.entries(o).sort((A, D) => D[1].priority - A[1].priority);
          var c = Cr();
          ur(n), (n = r.getGroup$$module$build$src$core$events$utils()) || r.setGroup$$module$build$src$core$events$utils(!0), wr(), t instanceof g_ && t.setResizesEnabled(!1);
          for (const [, A] of o.reverse()) {
            let D;
            (D = A) == null || D.clear(t);
          }
          for (let [A, D] of o.reverse())
            if (e[A]) {
              let $;
              ($ = D) == null || $.load(e[A], t);
            }
          t instanceof g_ && t.setResizesEnabled(!0), Qt(), fe(new (ge(eT))(t)), r.setGroup$$module$build$src$core$events$utils(n), ur(c);
        }
      }, Su = function() {
        Et.registry.register({ name: Z_.ESCAPE, preconditionFn(e) {
          return !e.options.readOnly;
        }, callback(e) {
          return e.hideChaff(), !0;
        }, keyCodes: [je.ESC] });
      }, hu = function() {
        Et.registry.register({ name: Z_.DELETE, preconditionFn(e) {
          const t = we();
          return !e.options.readOnly && t != null && t.isDeletable();
        }, callback(e, t) {
          return t.preventDefault(), yi.inProgress() ? !1 : (we().checkAndDelete(), !0);
        }, keyCodes: [
          je.DELETE,
          je.BACKSPACE
        ] });
      }, Iu = function() {
        const e = Et.registry.createSerializedKey(je.C, [je.CTRL]), t = Et.registry.createSerializedKey(je.C, [je.ALT]), n = Et.registry.createSerializedKey(
          je.C,
          [je.META]
        );
        Et.registry.register({ name: Z_.COPY, preconditionFn(o) {
          const c = we();
          return !o.options.readOnly && !yi.inProgress() && c != null && c.isDeletable() && c.isMovable();
        }, callback(o, c) {
          return c.preventDefault(), o.hideChaff(), nl(we()), !0;
        }, keyCodes: [e, t, n] });
      }, Ga = function() {
        const e = Et.registry.createSerializedKey(je.X, [je.CTRL]), t = Et.registry.createSerializedKey(je.X, [je.ALT]), n = Et.registry.createSerializedKey(je.X, [je.META]);
        Et.registry.register({ name: Z_.CUT, preconditionFn(o) {
          const c = we();
          return !o.options.readOnly && !yi.inProgress() && c != null && c instanceof kn && c.isDeletable() && c.isMovable() && !c.workspace.isFlyout;
        }, callback() {
          const o = we();
          return o ? (nl(o), o.checkAndDelete(), !0) : !1;
        }, keyCodes: [e, t, n] });
      }, ul = function() {
        const e = Et.registry.createSerializedKey(je.V, [je.CTRL]), t = Et.registry.createSerializedKey(je.V, [je.ALT]), n = Et.registry.createSerializedKey(
          je.V,
          [je.META]
        );
        Et.registry.register({ name: Z_.PASTE, preconditionFn(o) {
          return !o.options.readOnly && !yi.inProgress();
        }, callback() {
          return !!zp();
        }, keyCodes: [e, t, n] });
      }, Mu = function() {
        const e = Et.registry.createSerializedKey(je.Z, [je.CTRL]), t = Et.registry.createSerializedKey(je.Z, [je.ALT]), n = Et.registry.createSerializedKey(
          je.Z,
          [je.META]
        );
        Et.registry.register({ name: Z_.UNDO, preconditionFn(o) {
          return !o.options.readOnly && !yi.inProgress();
        }, callback(o) {
          return o.hideChaff(), o.undo(!1), !0;
        }, keyCodes: [e, t, n] });
      }, El = function() {
        const e = Et.registry.createSerializedKey(je.Z, [je.SHIFT, je.CTRL]), t = Et.registry.createSerializedKey(je.Z, [
          je.SHIFT,
          je.ALT
        ]), n = Et.registry.createSerializedKey(je.Z, [je.SHIFT, je.META]), o = Et.registry.createSerializedKey(je.Y, [je.CTRL]);
        Et.registry.register({
          name: Z_.REDO,
          preconditionFn(c) {
            return !yi.inProgress() && !c.options.readOnly;
          },
          callback(c) {
            return c.hideChaff(), c.undo(!0), !0;
          },
          keyCodes: [e, t, n, o]
        });
      }, Ha = function() {
        Su(), hu(), Iu(), Ga(), ul(), Mu(), El();
      }, mu = function(e) {
        return e.isSelectable();
      }, Pu = function(e) {
        Te().hideChaff(e);
      }, Ce = Ce || {}, Ce.scope = {}, Ce.ASSUME_ES5 = !1, Ce.ASSUME_NO_NATIVE_MAP = !1, Ce.ASSUME_NO_NATIVE_SET = !1, Ce.SIMPLE_FROUND_POLYFILL = !1, Ce.ISOLATE_POLYFILLS = !1, Ce.FORCE_POLYFILL_PROMISE = !1, Ce.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION = !1, Ce.defineProperty = Ce.ASSUME_ES5 || typeof Object.defineProperties == "function" ? Object.defineProperty : function(e, t, n) {
        return e == Array.prototype || e == Object.prototype || (e[t] = n.value), e;
      }, Ce.getGlobal = function(e) {
        e = [typeof globalThis == "object" && globalThis, e, typeof window == "object" && window, typeof self == "object" && self, typeof nn == "object" && nn];
        for (var t = 0; t < e.length; ++t) {
          var n = e[t];
          if (n && n.Math == Math)
            return n;
        }
        throw Error("Cannot find global object");
      }, Ce.global = Ce.getGlobal(this), Ce.IS_SYMBOL_NATIVE = typeof Symbol == "function" && typeof Symbol("x") == "symbol", Ce.TRUST_ES6_POLYFILLS = !Ce.ISOLATE_POLYFILLS || Ce.IS_SYMBOL_NATIVE, Ce.polyfills = {}, Ce.propertyToPolyfillSymbol = {}, Ce.POLYFILL_PREFIX = "$jscp$", Ce.polyfill = function(e, t, n, o) {
        t && (Ce.ISOLATE_POLYFILLS ? Ce.polyfillIsolated(e, t, n, o) : Ce.polyfillUnisolated(e, t, n, o));
      }, Ce.polyfillUnisolated = function(e, t, n, o) {
        for (n = Ce.global, e = e.split("."), o = 0; o < e.length - 1; o++) {
          var c = e[o];
          if (!(c in n))
            return;
          n = n[c];
        }
        e = e[e.length - 1], o = n[e], t = t(o), t != o && t != null && Ce.defineProperty(n, e, { configurable: !0, writable: !0, value: t });
      }, Ce.polyfillIsolated = function(e, t, n, o) {
        var c = e.split(".");
        e = c.length === 1, o = c[0], o = !e && o in Ce.polyfills ? Ce.polyfills : Ce.global;
        for (var A = 0; A < c.length - 1; A++) {
          var D = c[A];
          if (!(D in o))
            return;
          o = o[D];
        }
        c = c[c.length - 1], n = Ce.IS_SYMBOL_NATIVE && n === "es6" ? o[c] : null, t = t(n), t != null && (e ? Ce.defineProperty(Ce.polyfills, c, { configurable: !0, writable: !0, value: t }) : t !== n && (Ce.propertyToPolyfillSymbol[c] === void 0 && (n = 1e9 * Math.random() >>> 0, Ce.propertyToPolyfillSymbol[c] = Ce.IS_SYMBOL_NATIVE ? Ce.global.Symbol(c) : Ce.POLYFILL_PREFIX + n + "$" + c), Ce.defineProperty(o, Ce.propertyToPolyfillSymbol[c], { configurable: !0, writable: !0, value: t })));
      }, Ce.polyfill("globalThis", function(e) {
        return e || Ce.global;
      }, "es_2020", "es3"), Ce.arrayIteratorImpl = function(e) {
        var t = 0;
        return function() {
          return t < e.length ? { done: !1, value: e[t++] } : { done: !0 };
        };
      }, Ce.arrayIterator = function(e) {
        return { next: Ce.arrayIteratorImpl(e) };
      }, Ce.initSymbol = function() {
      }, Ce.iteratorPrototype = function(e) {
        return e = { next: e }, e[Symbol.iterator] = function() {
          return this;
        }, e;
      }, Ce.iteratorFromArray = function(e, t) {
        e instanceof String && (e += "");
        var n = 0, o = !1, c = { next: function() {
          if (!o && n < e.length) {
            var A = n++;
            return { value: t(A, e[A]), done: !1 };
          }
          return o = !0, { done: !0, value: void 0 };
        } };
        return c[Symbol.iterator] = function() {
          return c;
        }, c;
      }, Ce.polyfill("Array.prototype.values", function(e) {
        return e || function() {
          return Ce.iteratorFromArray(this, function(t, n) {
            return n;
          });
        };
      }, "es8", "es3"), Ce.polyfill("Array.prototype.flat", function(e) {
        return e || function(t) {
          t = t === void 0 ? 1 : t;
          var n = [];
          return Array.prototype.forEach.call(this, function(o) {
            Array.isArray(o) && 0 < t ? (o = Array.prototype.flat.call(o, t - 1), n.push.apply(n, o)) : n.push(o);
          }), n;
        };
      }, "es9", "es5"), Ce.owns = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, Ce.polyfill("Object.entries", function(e) {
        return e || function(t) {
          var n = [], o;
          for (o in t)
            Ce.owns(t, o) && n.push([o, t[o]]);
          return n;
        };
      }, "es8", "es3"), Ce.polyfill("Object.values", function(e) {
        return e || function(t) {
          var n = [], o;
          for (o in t)
            Ce.owns(t, o) && n.push(t[o]);
          return n;
        };
      }, "es8", "es3");
      var En = En || {};
      En.global = globalThis || root, En.define = function(e, t) {
        return t;
      }, En.DEBUG = !1, En.DISALLOW_TEST_ONLY_CODE = !En.DEBUG, En.provide = function(e) {
      }, En.module = function(e) {
      }, En.module.get = function(e) {
      }, En.module.declareLegacyNamespace = function() {
      }, En.setTestOnly = function(e) {
        if (En.DISALLOW_TEST_ONLY_CODE)
          throw e = e || "", Error("Importing test-only code into non-debug environment" + (e ? ": " + e : "."));
      }, En.require = function(e) {
      }, En.requireType = function(e) {
      };
      var hi = /* @__PURE__ */ Object.create(null), FA = { typeMap: hi }, xa = /* @__PURE__ */ Object.create(null), w_ = "default", se = class {
        constructor(e) {
          this.name = e;
        }
        toString() {
          return this.name;
        }
      };
      se.CONNECTION_CHECKER = new se("connectionChecker"), se.CURSOR = new se("cursor"), se.EVENT = new se("event"), se.FIELD = new se("field"), se.INPUT = new se("input"), se.RENDERER = new se("renderer"), se.TOOLBOX = new se("toolbox"), se.THEME = new se("theme"), se.TOOLBOX_ITEM = new se("toolboxItem"), se.FLYOUTS_VERTICAL_TOOLBOX = new se("flyoutsVerticalToolbox"), se.FLYOUTS_HORIZONTAL_TOOLBOX = new se("flyoutsHorizontalToolbox"), se.METRICS_MANAGER = new se("metricsManager"), se.BLOCK_DRAGGER = new se("blockDragger"), se.SERIALIZER = new se("serializer"), se.ICON = new se("icon");
      var Rn = {};
      Rn.DEFAULT = w_, Rn.TEST_ONLY = FA, Rn.Type = se, Rn.getAllItems = V, Rn.getClass = L, Rn.getClassFromOptions = Z, Rn.getObject = y, Rn.hasItem = h, Rn.register = i, Rn.unregister = p;
      var jr = /* @__PURE__ */ Object.create(null), Qo = /* @__PURE__ */ Object.create(null), wA, Xa = null, qe, qT = [], BA = { defineBlocksWithJsonArrayInternal: No }, er = {};
      er.TEST_ONLY = BA, er.createBlockDefinitionsFromJsonArray = r.createBlockDefinitionsFromJsonArray$$module$build$src$core$common, er.defineBlocks = r.defineBlocks$$module$build$src$core$common, er.defineBlocksWithJsonArray = Un, er.draggingConnections = qT, er.getAllWorkspaces = ce, er.getBlockTypeCounts = Rt, er.getMainWorkspace = Te, er.getParentContainer = pr, er.getSelected = we, er.getWorkspaceById = le, er.registerWorkspace = ve, er.setMainWorkspace = Le, er.setParentContainer = Zt, er.setSelected = ot, er.svgResize = Je, er.unregisterWorkpace = et;
      var Du = "!#$%()*+,-./:;=?@[]^_`{|}~ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", YA = { genUid: () => {
        const e = Du.length, t = [];
        for (let n = 0; 20 > n; n++)
          t[n] = Du.charAt(Math.random() * e);
        return t.join("");
      } }, CS = 0, zr = {};
      zr.TEST_ONLY = YA, zr.genUid = Gr, zr.getNextUniqueId = i_;
      var Lu, Ii, es, Mi, mi, Mr, yn, ts, qi, zn, B_, eo, A_, to, ro, vn, no, Zr, _o, qo, Zn, eT, Ka, tT, Al, He;
      Lu = "", Ii = !0, es = 0, r.CREATE$$module$build$src$core$events$utils = "create", r.CREATE$$module$build$src$core$events$utils, r.DELETE$$module$build$src$core$events$utils = "delete", r.DELETE$$module$build$src$core$events$utils, r.CHANGE$$module$build$src$core$events$utils = "change", r.CHANGE$$module$build$src$core$events$utils, Mi = "block_field_intermediate_change", r.MOVE$$module$build$src$core$events$utils = "move", r.MOVE$$module$build$src$core$events$utils, mi = "var_create", Mr = "var_delete", yn = "var_rename", ts = "ui", qi = "drag", zn = "selected", B_ = "click", eo = "marker_move", A_ = "bubble_open", to = "trashcan_open", ro = "toolbox_item_select", vn = "theme_change", no = "viewport_change", Zr = "comment_create", _o = "comment_delete", qo = "comment_change", Zn = "comment_move", eT = "finished_loading", Ka = [r.CREATE$$module$build$src$core$events$utils, r.MOVE$$module$build$src$core$events$utils, Zr, Zn], tT = [], Al = { FIRE_QUEUE: tT, fireNow: on, fireInternal: vT, setGroupInternal: kr }, He = {}, He.BLOCK_CHANGE = r.CHANGE$$module$build$src$core$events$utils, He.BLOCK_CREATE = r.CREATE$$module$build$src$core$events$utils, He.BLOCK_DELETE = r.DELETE$$module$build$src$core$events$utils, He.BLOCK_DRAG = qi, He.BLOCK_FIELD_INTERMEDIATE_CHANGE = Mi, He.BLOCK_MOVE = r.MOVE$$module$build$src$core$events$utils, He.BUBBLE_OPEN = A_, He.BUMP_EVENTS = Ka, He.CHANGE = r.CHANGE$$module$build$src$core$events$utils, He.CLICK = B_, He.COMMENT_CHANGE = qo, He.COMMENT_CREATE = Zr, He.COMMENT_DELETE = _o, He.COMMENT_MOVE = Zn, He.CREATE = r.CREATE$$module$build$src$core$events$utils, He.DELETE = r.DELETE$$module$build$src$core$events$utils, He.FINISHED_LOADING = eT, He.MARKER_MOVE = eo, He.MOVE = r.MOVE$$module$build$src$core$events$utils, He.SELECTED = zn, He.TEST_ONLY = Al, He.THEME_CHANGE = vn, He.TOOLBOX_ITEM_SELECT = ro, He.TRASHCAN_OPEN = to, He.UI = ts, He.VAR_CREATE = mi, He.VAR_DELETE = Mr, He.VAR_RENAME = yn, He.VIEWPORT_CHANGE = no, He.clearPendingUndo = ii, He.disable = r.disable$$module$build$src$core$events$utils, He.disableOrphans = Vn, He.enable = r.enable$$module$build$src$core$events$utils, He.filter = Ar, He.fire = fe, He.fromJson = bo, He.get = ge, He.getDescendantIds = oi, He.getGroup = r.getGroup$$module$build$src$core$events$utils, He.getRecordUndo = Cr, He.isEnabled = tt, He.setGroup = r.setGroup$$module$build$src$core$events$utils, He.setRecordUndo = ur, function(e) {
        e[e.VALUE = 1] = "VALUE", e[e.STATEMENT = 3] = "STATEMENT", e[e.DUMMY = 5] = "DUMMY", e[e.CUSTOM = 6] = "CUSTOM";
      }(r.inputTypes$$module$build$src$core$inputs$input_types || (r.inputTypes$$module$build$src$core$inputs$input_types = {})), r.inputTypes$$module$build$src$core$inputs$input_types;
      var Ja = { parseFromString: function() {
        throw Error("DOMParser was not found in the global scope and was not properly injected using injectDependencies");
      } }, ja = { serializeToString: function() {
        throw Error("XMLSerializer was not foundin the global scope and was not properly injected using injectDependencies");
      } }, { document: dl, DOMParser: fr, XMLSerializer: An } = globalThis;
      fr && (Ja = new fr()), An && (ja = new An());
      var UA = "https://developers.google.com/blockly/xml", OS = /[\x00-\x09\x0B\x0C\x0E-\x1F]/g, Y_ = {};
      Y_.NAME_SPACE = UA, Y_.createElement = r.createElement$$module$build$src$core$utils$xml, Y_.createTextNode = r.createTextNode$$module$build$src$core$utils$xml, Y_.domToText = Hr, Y_.injectDependencies = Fr, Y_.textToDom = r.textToDom$$module$build$src$core$utils$xml;
      var mr = class {
        constructor(e) {
          this.name = e;
        }
        toString() {
          return this.name;
        }
        equals(e) {
          return this.name === e.toString();
        }
      };
      mr.MUTATOR = new mr("mutator"), mr.WARNING = new mr("warning"), mr.COMMENT = new mr("comment");
      var rT = {};
      rT.warn = dr;
      var Sl = "http://www.w3.org/2000/svg", Pi = "http://www.w3.org/1999/xhtml", $n = "http://www.w3.org/1999/xlink", dn;
      (function(e) {
        e[e.ELEMENT_NODE = 1] = "ELEMENT_NODE", e[e.TEXT_NODE = 3] = "TEXT_NODE", e[e.COMMENT_NODE = 8] = "COMMENT_NODE";
      })(dn || (dn = {}));
      var Qr = null, gu = 0, hl = null, lr = {};
      lr.HTML_NS = Pi, lr.NodeType = dn, lr.SVG_NS = Sl, lr.XLINK_NS = $n, lr.addClass = be, lr.containsNode = wi, lr.createSvgElement = K, lr.getFastTextWidth = xr, lr.getFastTextWidthWithSizeString = T_, lr.getTextWidth = O_, lr.hasClass = b_, lr.insertAfter = Sr, lr.measureFontMetrics = Hn, lr.removeClass = Be, lr.removeClasses = Ti, lr.removeNode = Tt, lr.setCssTransform = C_, lr.startTextWidthCache = wr, lr.stopTextWidthCache = Qt;
      var ht = class {
        constructor(e, t) {
          this.width = e, this.height = t;
        }
        static equals(e, t) {
          return e === t ? !0 : e && t ? e.width === t.width && e.height === t.height : !1;
        }
      }, fu = function(e, t) {
        window.alert(e), t && t();
      }, Il = function(e, t) {
        t(window.confirm(e));
      }, za = function(e, t, n) {
        n(window.prompt(e, t));
      }, Ml = { confirmInternal: li }, io = {};
      io.TEST_ONLY = Ml, io.alert = si, io.confirm = Xr, io.prompt = I, io.setAlert = R_, io.setConfirm = k, io.setPrompt = R;
      var Za, nT;
      r.Msg$$module$build$src$core$msg = /* @__PURE__ */ Object.create(null), Za = function(e) {
        Object.keys(e).forEach(function(t) {
          r.Msg$$module$build$src$core$msg[t] = e[t];
        });
      }, nT = {}, nT.Msg = r.Msg$$module$build$src$core$msg, nT.setLocale = Za;
      var _T = class {
        constructor() {
          this.workspaceId = void 0, this.isUiEvent = !1, this.type = "", this.group = r.getGroup$$module$build$src$core$events$utils(), this.recordUndo = Cr();
        }
        toJson() {
          return { type: this.type, group: this.group };
        }
        static fromJson(e, t, n) {
          return n.isBlank = !1, n.group = e.group || "", n.workspaceId = t.id, n;
        }
        isNull() {
          return !1;
        }
        run(e) {
        }
        getEventWorkspace_() {
          let e;
          if (this.workspaceId && (e = le(this.workspaceId)), !e)
            throw Error("Workspace is null. Event must have been generated from real Blockly events.");
          return e;
        }
      }, iT = class extends _T {
        constructor(e) {
          super(), this.isBlank = typeof e > "u", e && (this.varId = e.getId(), this.workspaceId = e.workspace.id);
        }
        toJson() {
          const e = super.toJson();
          if (!this.varId)
            throw Error("The var ID is undefined. Either pass a variable to the constructor, or call fromJson");
          return e.varId = this.varId, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new iT()), t.varId = e.varId, t;
        }
      }, Nu = class extends iT {
        constructor(e) {
          super(e), this.type = mi, e && (this.varType = e.type, this.varName = e.name);
        }
        toJson() {
          const e = super.toJson();
          if (this.varType === void 0)
            throw Error("The var type is undefined. Either pass a variable to the constructor, or call fromJson");
          if (!this.varName)
            throw Error("The var name is undefined. Either pass a variable to the constructor, or call fromJson");
          return e.varType = this.varType, e.varName = this.varName, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new Nu()), t.varType = e.varType, t.varName = e.varName, t;
        }
        run(e) {
          const t = this.getEventWorkspace_();
          if (!this.varId)
            throw Error("The var ID is undefined. Either pass a variable to the constructor, or call fromJson");
          if (!this.varName)
            throw Error("The var name is undefined. Either pass a variable to the constructor, or call fromJson");
          e ? t.createVariable(
            this.varName,
            this.varType,
            this.varId
          ) : t.deleteVariableById(this.varId);
        }
      };
      i(se.EVENT, mi, Nu);
      var rs = class {
        constructor(e, t, n, o) {
          this.workspace = e, this.name = t, this.type = n || "", this.id_ = o || Gr();
        }
        getId() {
          return this.id_;
        }
        static compareByName(e, t) {
          return e.name.localeCompare(t.name, void 0, { sensitivity: "base" });
        }
      }, d_ = "VARIABLE", Qa = "ijkmnopqrstuvwxyzabcdefgh", bu = { generateUniqueNameInternal: ea }, Er = {};
      Er.CATEGORY_NAME = d_, Er.TEST_ONLY = bu, Er.VAR_LETTER_OPTIONS = Qa, Er.allDeveloperVariables = r.allDeveloperVariables$$module$build$src$core$variables, Er.allUsedVarModels = r.allUsedVarModels$$module$build$src$core$variables, Er.createVariableButtonHandler = v_, Er.flyoutCategory = ke, Er.flyoutCategoryBlocks = yt, Er.generateUniqueName = y_, Er.generateUniqueNameFromOptions = ai, Er.generateVariableFieldDom = r.generateVariableFieldDom$$module$build$src$core$variables, Er.getAddedVariables = W, Er.getOrCreateVariablePackage = r.getOrCreateVariablePackage$$module$build$src$core$variables, Er.getVariable = r.getVariable$$module$build$src$core$variables, Er.nameUsedWithAnyType = Co, Er.nameUsedWithConflictingParam = WT, Er.promptName = Ut, Er.renameVariable = r.renameVariable$$module$build$src$core$variables;
      var ae = class {
        constructor(e, t) {
          this.x = e, this.y = t;
        }
        clone() {
          return new ae(this.x, this.y);
        }
        scale(e) {
          return this.x *= e, this.y *= e, this;
        }
        translate(e, t) {
          return this.x += e, this.y += t, this;
        }
        static equals(e, t) {
          return e === t ? !0 : e && t ? e.x === t.x && e.y === t.y : !1;
        }
        static distance(e, t) {
          const n = e.x - t.x;
          return e = e.y - t.y, Math.sqrt(n * n + e * e);
        }
        static magnitude(e) {
          return Math.sqrt(e.x * e.x + e.y * e.y);
        }
        static difference(e, t) {
          return new ae(e.x - t.x, e.y - t.y);
        }
        static sum(e, t) {
          return new ae(e.x + t.x, e.y + t.y);
        }
      }, U_ = class {
        constructor(e, t, n, o, c) {
          this.workspace = e, this.editable = this.movable = this.deletable = !0, this.disposed_ = !1, this.isComment = !0, this.id = c && !e.getCommentById(c) ? c : Gr(), e.addTopComment(this), this.xy_ = new ae(0, 0), this.height_ = n, this.width_ = o, this.RTL = e.RTL, this.content_ = t, U_.fireCreateEvent(this);
        }
        dispose() {
          this.disposed_ || (tt() && fe(new (ge(_o))(this)), this.workspace.removeTopComment(this), this.disposed_ = !0);
        }
        getHeight() {
          return this.height_;
        }
        setHeight(e) {
          this.height_ = e;
        }
        getWidth() {
          return this.width_;
        }
        setWidth(e) {
          this.width_ = e;
        }
        getRelativeToSurfaceXY() {
          return new ae(this.xy_.x, this.xy_.y);
        }
        moveBy(e, t) {
          const n = new (ge(Zn))(this);
          this.xy_.translate(e, t), n.recordNew(), fe(n);
        }
        isDeletable() {
          return this.deletable && !(this.workspace && this.workspace.options.readOnly);
        }
        setDeletable(e) {
          this.deletable = e;
        }
        isMovable() {
          return this.movable && !(this.workspace && this.workspace.options.readOnly);
        }
        setMovable(e) {
          this.movable = e;
        }
        isEditable() {
          return this.editable && !(this.workspace && this.workspace.options.readOnly);
        }
        setEditable(e) {
          this.editable = e;
        }
        getContent() {
          return this.content_;
        }
        setContent(e) {
          this.content_ !== e && (fe(new (ge(qo))(
            this,
            this.content_,
            e
          )), this.content_ = e);
        }
        toXmlWithXY(e) {
          return e = this.toXml(e), e.setAttribute("x", String(Math.round(this.xy_.x))), e.setAttribute("y", String(Math.round(this.xy_.y))), e.setAttribute("h", String(this.height_)), e.setAttribute("w", String(this.width_)), e;
        }
        toXml(e) {
          const t = r.createElement$$module$build$src$core$utils$xml("comment");
          return e || (t.id = this.id), t.textContent = this.getContent(), t;
        }
        static fireCreateEvent(e) {
          if (tt()) {
            const t = r.getGroup$$module$build$src$core$events$utils();
            t || r.setGroup$$module$build$src$core$events$utils(!0);
            try {
              fe(new (ge(Zr))(e));
            } finally {
              r.setGroup$$module$build$src$core$events$utils(t);
            }
          }
        }
        static fromXml(e, t) {
          var n = U_.parseAttributes(e);
          return t = new U_(t, n.content, n.h, n.w, n.id), n = e.getAttribute("x"), e = e.getAttribute("y"), n = n ? parseInt(n, 10) : NaN, e = e ? parseInt(e, 10) : NaN, isNaN(n) || isNaN(e) || t.moveBy(n, e), U_.fireCreateEvent(t), t;
        }
        static parseAttributes(e) {
          const t = e.getAttribute("h"), n = e.getAttribute("w"), o = e.getAttribute("x"), c = e.getAttribute("y"), A = e.getAttribute("id");
          if (!A)
            throw Error("No ID present in XML comment definition.");
          let D;
          return { id: A, h: t ? parseInt(t) : 100, w: n ? parseInt(n) : 100, x: o ? parseInt(o) : NaN, y: c ? parseInt(c) : NaN, content: (D = e.textContent) != null ? D : "" };
        }
      }, V_ = class extends _T {
        constructor(e) {
          super(), this.recordUndo = !1, this.isUiEvent = !0, this.isBlank = typeof e > "u", this.workspaceId = e || "";
        }
      }, S_ = class extends V_ {
        constructor(e, t, n) {
          super(n), this.type = zn, this.oldElementId = e ?? void 0, this.newElementId = t ?? void 0;
        }
        toJson() {
          const e = super.toJson();
          return e.oldElementId = this.oldElementId, e.newElementId = this.newElementId, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new S_()), t.oldElementId = e.oldElementId, t.newElementId = e.newElementId, t;
        }
      };
      i(se.EVENT, zn, S_);
      var Cu = 750, qa = "ontouchstart" in globalThis || !!(globalThis.document && document.documentElement && "ontouchstart" in document.documentElement) || !(!globalThis.navigator || !globalThis.navigator.maxTouchPoints && !globalThis.navigator.msMaxTouchPoints), ns = null, G_ = {
        mousedown: ["pointerdown"],
        mouseenter: ["pointerenter"],
        mouseleave: ["pointerleave"],
        mousemove: ["pointermove"],
        mouseout: ["pointerout"],
        mouseover: ["pointerover"],
        mouseup: ["pointerup", "pointercancel"],
        touchend: ["pointerup"],
        touchcancel: ["pointercancel"]
      }, Di = 0, ye = {};
      ye.TOUCH_ENABLED = qa, ye.TOUCH_MAP = G_, ye.checkTouchIdentifier = Yi, ye.clearTouchIdentifier = me, ye.getTouchIdentifierFromEvent = qt, ye.longStart = H, ye.longStop = ee, ye.shouldHandleEvent = Ge;
      var _s, ec, oo, VA, is, ml, Nr, GA, HA, Ou;
      (function(e) {
        function t(o) {
          return n.indexOf(o.toUpperCase()) !== -1;
        }
        _s = e;
        const n = _s.toUpperCase();
        ec = t("JavaFX"), oo = t("WebKit"), VA = t("Gecko") && !oo, is = t("Android"), e = globalThis.navigator && globalThis.navigator.maxTouchPoints, ml = t("iPad") || t("Macintosh") && 0 < e, Nr = t("iPhone") && !ml, GA = t("Macintosh"), HA = ml || is && !t("Mobile") || t("Silk"), Ou = !HA && (Nr || is);
      })(globalThis.navigator && globalThis.navigator.userAgent || "");
      var RS = _s, xA = ec, Ru = VA, tc = is, os = ml, H_ = Nr, Rr = GA, Pl = Ou, Li = {};
      Li.ANDROID = tc, Li.GECKO = Ru, Li.IPAD = os, Li.IPHONE = H_, Li.JavaFx = xA, Li.MAC = Rr, Li.MOBILE = Pl, Li.raw = RS;
      var rc = 40, XA = 125, gi = {};
      gi.bind = hr, gi.conditionalBind = Pe, gi.getScrollDeltaPixels = kT, gi.isRightButton = Ui, gi.isTargetInput = vs, gi.mouseToSvg = Oo, gi.unbind = It;
      var oT = !1, nc = `
.blocklySvg {
  background-color: #fff;
  outline: none;
  overflow: hidden;  /* IE overflows by default. */
  position: absolute;
  display: block;
}

.blocklyWidgetDiv {
  display: none;
  position: absolute;
  z-index: 99999;  /* big value for bootstrap3 compatibility */
}

.injectionDiv {
  height: 100%;
  position: relative;
  overflow: hidden;  /* So blocks in drag surface disappear at edges */
  touch-action: none;
}

.blocklyNonSelectable {
  user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
}

.blocklyBlockCanvas.blocklyCanvasTransitioning,
.blocklyBubbleCanvas.blocklyCanvasTransitioning {
  transition: transform .5s;
}

.blocklyTooltipDiv {
  background-color: #ffffc7;
  border: 1px solid #ddc;
  box-shadow: 4px 4px 20px 1px rgba(0,0,0,.15);
  color: #000;
  display: none;
  font: 9pt sans-serif;
  opacity: .9;
  padding: 2px;
  position: absolute;
  z-index: 100000;  /* big value for bootstrap3 compatibility */
}

.blocklyDropDownDiv {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1000;
  display: none;
  border: 1px solid;
  border-color: #dadce0;
  background-color: #fff;
  border-radius: 2px;
  padding: 4px;
  box-shadow: 0 0 3px 1px rgba(0,0,0,.3);
}

.blocklyDropDownDiv.blocklyFocused {
  box-shadow: 0 0 6px 1px rgba(0,0,0,.3);
}

.blocklyDropDownContent {
  max-height: 300px;  /* @todo: spec for maximum height. */
  overflow: auto;
  overflow-x: hidden;
  position: relative;
}

.blocklyDropDownArrow {
  position: absolute;
  left: 0;
  top: 0;
  width: 16px;
  height: 16px;
  z-index: -1;
  background-color: inherit;
  border-color: inherit;
}

.blocklyDropDownButton {
  display: inline-block;
  float: left;
  padding: 0;
  margin: 4px;
  border-radius: 4px;
  outline: none;
  border: 1px solid;
  transition: box-shadow .1s;
  cursor: pointer;
}

.blocklyArrowTop {
  border-top: 1px solid;
  border-left: 1px solid;
  border-top-left-radius: 4px;
  border-color: inherit;
}

.blocklyArrowBottom {
  border-bottom: 1px solid;
  border-right: 1px solid;
  border-bottom-right-radius: 4px;
  border-color: inherit;
}

.blocklyResizeSE {
  cursor: se-resize;
  fill: #aaa;
}

.blocklyResizeSW {
  cursor: sw-resize;
  fill: #aaa;
}

.blocklyResizeLine {
  stroke: #515A5A;
  stroke-width: 1;
}

.blocklyHighlightedConnectionPath {
  fill: none;
  stroke: #fc3;
  stroke-width: 4px;
}

.blocklyPathLight {
  fill: none;
  stroke-linecap: round;
  stroke-width: 1;
}

.blocklySelected>.blocklyPathLight {
  display: none;
}

.blocklyDraggable {
  cursor: grab;
  cursor: -webkit-grab;
}

.blocklyDragging {
  cursor: grabbing;
  cursor: -webkit-grabbing;
}

  /* Changes cursor on mouse down. Not effective in Firefox because of
     https://bugzilla.mozilla.org/show_bug.cgi?id=771241 */
.blocklyDraggable:active {
  cursor: grabbing;
  cursor: -webkit-grabbing;
}

.blocklyDragging.blocklyDraggingDelete {
  cursor: url("<<<PATH>>>/handdelete.cur"), auto;
}

.blocklyDragging>.blocklyPath,
.blocklyDragging>.blocklyPathLight {
  fill-opacity: .8;
  stroke-opacity: .8;
}

.blocklyDragging>.blocklyPathDark {
  display: none;
}

.blocklyDisabled>.blocklyPath {
  fill-opacity: .5;
  stroke-opacity: .5;
}

.blocklyDisabled>.blocklyPathLight,
.blocklyDisabled>.blocklyPathDark {
  display: none;
}

.blocklyInsertionMarker>.blocklyPath,
.blocklyInsertionMarker>.blocklyPathLight,
.blocklyInsertionMarker>.blocklyPathDark {
  fill-opacity: .2;
  stroke: none;
}

.blocklyMultilineText {
  font-family: monospace;
}

.blocklyNonEditableText>text {
  pointer-events: none;
}

.blocklyFlyout {
  position: absolute;
  z-index: 20;
}

.blocklyText text {
  cursor: default;
}

/*
  Don't allow users to select text.  It gets annoying when trying to
  drag a block and selected text moves instead.
*/
.blocklySvg text {
  user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
  cursor: inherit;
}

.blocklyHidden {
  display: none;
}

.blocklyFieldDropdown:not(.blocklyHidden) {
  display: block;
}

.blocklyIconGroup {
  cursor: default;
}

.blocklyIconGroup:not(:hover),
.blocklyIconGroupReadonly {
  opacity: .6;
}

.blocklyIconShape {
  fill: #00f;
  stroke: #fff;
  stroke-width: 1px;
}

.blocklyIconSymbol {
  fill: #fff;
}

.blocklyMinimalBody {
  margin: 0;
  padding: 0;
}

.blocklyHtmlInput {
  border: none;
  border-radius: 4px;
  height: 100%;
  margin: 0;
  outline: none;
  padding: 0;
  width: 100%;
  text-align: center;
  display: block;
  box-sizing: border-box;
}

/* Remove the increase and decrease arrows on the field number editor */
input.blocklyHtmlInput[type=number]::-webkit-inner-spin-button,
input.blocklyHtmlInput[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

.blocklyMainBackground {
  stroke-width: 1;
  stroke: #c6c6c6;  /* Equates to #ddd due to border being off-pixel. */
}

.blocklyMutatorBackground {
  fill: #fff;
  stroke: #ddd;
  stroke-width: 1;
}

.blocklyFlyoutBackground {
  fill: #ddd;
  fill-opacity: .8;
}

.blocklyMainWorkspaceScrollbar {
  z-index: 20;
}

.blocklyFlyoutScrollbar {
  z-index: 30;
}

.blocklyScrollbarHorizontal,
.blocklyScrollbarVertical {
  position: absolute;
  outline: none;
}

.blocklyScrollbarBackground {
  opacity: 0;
}

.blocklyScrollbarHandle {
  fill: #ccc;
}

.blocklyScrollbarBackground:hover+.blocklyScrollbarHandle,
.blocklyScrollbarHandle:hover {
  fill: #bbb;
}

/* Darken flyout scrollbars due to being on a grey background. */
/* By contrast, workspace scrollbars are on a white background. */
.blocklyFlyout .blocklyScrollbarHandle {
  fill: #bbb;
}

.blocklyFlyout .blocklyScrollbarBackground:hover+.blocklyScrollbarHandle,
.blocklyFlyout .blocklyScrollbarHandle:hover {
  fill: #aaa;
}

.blocklyInvalidInput {
  background: #faa;
}

.blocklyVerticalMarker {
  stroke-width: 3px;
  fill: rgba(255,255,255,.5);
  pointer-events: none;
}

.blocklyComputeCanvas {
  position: absolute;
  width: 0;
  height: 0;
}

.blocklyNoPointerEvents {
  pointer-events: none;
}

.blocklyContextMenu {
  border-radius: 4px;
  max-height: 100%;
}

.blocklyDropdownMenu {
  border-radius: 2px;
  padding: 0 !important;
}

.blocklyDropdownMenu .blocklyMenuItem {
  /* 28px on the left for icon or checkbox. */
  padding-left: 28px;
}

/* BiDi override for the resting state. */
.blocklyDropdownMenu .blocklyMenuItemRtl {
  /* Flip left/right padding for BiDi. */
  padding-left: 5px;
  padding-right: 28px;
}

.blocklyWidgetDiv .blocklyMenu {
  background: #fff;
  border: 1px solid transparent;
  box-shadow: 0 0 3px 1px rgba(0,0,0,.3);
  font: normal 13px Arial, sans-serif;
  margin: 0;
  outline: none;
  padding: 4px 0;
  position: absolute;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 100%;
  z-index: 20000;  /* Arbitrary, but some apps depend on it... */
}

.blocklyWidgetDiv .blocklyMenu.blocklyFocused {
  box-shadow: 0 0 6px 1px rgba(0,0,0,.3);
}

.blocklyDropDownDiv .blocklyMenu {
  background: inherit;  /* Compatibility with gapi, reset from goog-menu */
  border: inherit;  /* Compatibility with gapi, reset from goog-menu */
  font: normal 13px "Helvetica Neue", Helvetica, sans-serif;
  outline: none;
  position: relative;  /* Compatibility with gapi, reset from goog-menu */
  z-index: 20000;  /* Arbitrary, but some apps depend on it... */
}

/* State: resting. */
.blocklyMenuItem {
  border: none;
  color: #000;
  cursor: pointer;
  list-style: none;
  margin: 0;
  /* 7em on the right for shortcut. */
  min-width: 7em;
  padding: 6px 15px;
  white-space: nowrap;
}

/* State: disabled. */
.blocklyMenuItemDisabled {
  color: #ccc;
  cursor: inherit;
}

/* State: hover. */
.blocklyMenuItemHighlight {
  background-color: rgba(0,0,0,.1);
}

/* State: selected/checked. */
.blocklyMenuItemCheckbox {
  height: 16px;
  position: absolute;
  width: 16px;
}

.blocklyMenuItemSelected .blocklyMenuItemCheckbox {
  background: url(<<<PATH>>>/sprites.png) no-repeat -48px -16px;
  float: left;
  margin-left: -24px;
  position: static;  /* Scroll with the menu. */
}

.blocklyMenuItemRtl .blocklyMenuItemCheckbox {
  float: right;
  margin-right: -24px;
}
`, _c = {};
      _c.inject = cp, _c.register = xn;
      var Dt = class {
        constructor(e, t, n, o) {
          this.top = e, this.bottom = t, this.left = n, this.right = o;
        }
        getHeight() {
          return this.bottom - this.top;
        }
        getWidth() {
          return this.right - this.left;
        }
        contains(e, t) {
          return e >= this.left && e <= this.right && t >= this.top && t <= this.bottom;
        }
        intersects(e) {
          return !(this.left > e.right || this.right < e.left || this.top > e.bottom || this.bottom < e.top);
        }
      }, U = class {
        constructor(e) {
          this.tagName = e;
        }
        toString() {
          return this.tagName;
        }
      };
      U.ANIMATE = new U("animate"), U.CIRCLE = new U("circle"), U.CLIPPATH = new U("clipPath"), U.DEFS = new U("defs"), U.FECOMPOSITE = new U("feComposite"), U.FECOMPONENTTRANSFER = new U("feComponentTransfer"), U.FEFLOOD = new U("feFlood"), U.FEFUNCA = new U("feFuncA"), U.FEGAUSSIANBLUR = new U("feGaussianBlur"), U.FEPOINTLIGHT = new U("fePointLight"), U.FESPECULARLIGHTING = new U("feSpecularLighting"), U.FILTER = new U("filter"), U.FOREIGNOBJECT = new U("foreignObject"), U.G = new U("g"), U.IMAGE = new U("image"), U.LINE = new U("line"), U.PATH = new U("path"), U.PATTERN = new U("pattern"), U.POLYGON = new U("polygon"), U.RECT = new U("rect"), U.SVG = new U("svg"), U.TEXT = new U("text"), U.TSPAN = new U("tspan");
      var KA = { getSizeInternal: JE }, fi = {};
      fi.TEST_ONLY = KA, fi.getBorderBox = FT, fi.getComputedStyle = $_, fi.getContainerOffsetToScrollInto = Ep, fi.getPageOffset = s_, fi.getSize = $s, fi.getViewportPageOffset = up, fi.scrollIntoContainerView = ta;
      var yu = /translate\(\s*([-+\d.e]+)([ ,]\s*([-+\d.e]+)\s*)?/, vu = /transform:\s*translate(?:3d)?\(\s*([-+\d.e]+)\s*px([ ,]\s*([-+\d.e]+)\s*px)?/, yS = { XY_REGEX: yu, XY_STYLE_REGEX: vu }, Ni = {};
      Ni.TEST_ONLY = yS, Ni.getDocumentScroll = na, Ni.getInjectionDivXY = Ws, Ni.getRelativeXY = Ro, Ni.getViewportBBox = ra, Ni.screenToWsCoordinates = jE;
      var ar = 8, To = 3, $u = 2, yr = class extends U_ {
        constructor(e, t, n, o, c) {
          super(e, t, n, o, c), this.onMouseMoveWrapper = this.onMouseUpWrapper = null, this.eventsInit = !1, this.deleteIconBorder = this.deleteGroup = this.resizeGroup = this.foreignObject = this.svgHandleTarget = this.svgRectTarget = this.textarea = null, this.rendered = this.autoLayout = this.focused = !1, this.svgGroup = K(U.G, { class: "blocklyComment" }), this.workspace = e, this.svgRect_ = K(U.RECT, { class: "blocklyCommentRect", x: 0, y: 0, rx: To, ry: To }), this.svgGroup.appendChild(this.svgRect_), this.render();
        }
        dispose() {
          this.disposed_ || (we() === this && (this.unselect(), this.workspace.cancelCurrentGesture()), tt() && fe(new (ge(_o))(this)), Tt(this.svgGroup), this.disposeInternal(), r.disable$$module$build$src$core$events$utils(), super.dispose(), r.enable$$module$build$src$core$events$utils());
        }
        initSvg(e) {
          if (!this.workspace.rendered)
            throw TypeError("Workspace is headless.");
          this.workspace.options.readOnly || this.eventsInit || (Pe(this.svgRectTarget, "pointerdown", this, this.pathMouseDown), Pe(this.svgHandleTarget, "pointerdown", this, this.pathMouseDown)), this.eventsInit = !0, this.updateMovable(), this.getSvgRoot().parentNode || this.workspace.getBubbleCanvas().appendChild(this.getSvgRoot()), !e && this.textarea && this.textarea.select();
        }
        pathMouseDown(e) {
          const t = this.workspace.getGesture(e);
          t && t.handleBubbleStart(e, this);
        }
        showContextMenu(e) {
          throw Error("The implementation of showContextMenu should be monkey-patched in by blockly.ts");
        }
        select() {
          if (we() !== this) {
            var e = null;
            if (we()) {
              e = we().id, r.disable$$module$build$src$core$events$utils();
              try {
                we().unselect();
              } finally {
                r.enable$$module$build$src$core$events$utils();
              }
            }
            e = new (ge(zn))(e, this.id, this.workspace.id), fe(e), ot(this), this.addSelect();
          }
        }
        unselect() {
          if (we() === this) {
            var e = new (ge(zn))(this.id, null, this.workspace.id);
            fe(e), ot(null), this.removeSelect(), this.blurFocus();
          }
        }
        addSelect() {
          be(this.svgGroup, "blocklySelected"), this.setFocus();
        }
        removeSelect() {
          be(this.svgGroup, "blocklySelected"), this.blurFocus();
        }
        addFocus() {
          be(this.svgGroup, "blocklyFocused");
        }
        removeFocus() {
          Be(this.svgGroup, "blocklyFocused");
        }
        getRelativeToSurfaceXY() {
          let e = 0, t = 0, n = this.getSvgRoot();
          if (n)
            do {
              const o = Ro(n);
              e += o.x, t += o.y, n = n.parentNode;
            } while (n && n !== this.workspace.getBubbleCanvas() && n !== null);
          return this.xy_ = new ae(e, t);
        }
        moveBy(e, t) {
          const n = new (ge(Zn))(this), o = this.getRelativeToSurfaceXY();
          this.translate(o.x + e, o.y + t), this.xy_ = new ae(o.x + e, o.y + t), n.recordNew(), fe(n), this.workspace.resizeContents();
        }
        translate(e, t) {
          this.xy_ = new ae(e, t), this.getSvgRoot().setAttribute("transform", "translate(" + e + "," + t + ")");
        }
        moveDuringDrag(e) {
          e = `translate(${e.x}, ${e.y})`, this.getSvgRoot().setAttribute("transform", e);
        }
        moveTo(e, t) {
          this.translate(e, t);
        }
        clearTransformAttributes() {
          this.getSvgRoot().removeAttribute("transform");
        }
        getBoundingRectangle() {
          var e = this.getRelativeToSurfaceXY();
          const t = this.getHeightWidth(), n = e.y, o = e.y + t.height;
          let c;
          return this.RTL ? (c = e.x - t.width, e = e.x) : (c = e.x, e = e.x + t.width), new Dt(n, o, c, e);
        }
        updateMovable() {
          this.isMovable() ? be(this.svgGroup, "blocklyDraggable") : Be(this.svgGroup, "blocklyDraggable");
        }
        setMovable(e) {
          super.setMovable(e), this.updateMovable();
        }
        setEditable(e) {
          super.setEditable(e), this.textarea && (this.textarea.readOnly = !e);
        }
        setDragging(e) {
          e ? be(this.getSvgRoot(), "blocklyDragging") : Be(
            this.getSvgRoot(),
            "blocklyDragging"
          );
        }
        getSvgRoot() {
          return this.svgGroup;
        }
        getContent() {
          return this.textarea ? this.textarea.value : this.content_;
        }
        setContent(e) {
          super.setContent(e), this.textarea && (this.textarea.value = e);
        }
        setDeleteStyle(e) {
          e ? be(this.svgGroup, "blocklyDraggingDelete") : Be(this.svgGroup, "blocklyDraggingDelete");
        }
        setAutoLayout(e) {
        }
        toXmlWithXY(e) {
          let t = 0;
          this.workspace.RTL && (t = this.workspace.getWidth()), e = this.toXml(e);
          const n = this.getRelativeToSurfaceXY();
          return e.setAttribute("x", String(Math.round(this.workspace.RTL ? t - n.x : n.x))), e.setAttribute("y", String(Math.round(n.y))), e.setAttribute("h", String(this.getHeight())), e.setAttribute("w", String(this.getWidth())), e;
        }
        toCopyData() {
          return { saveInfo: this.toXmlWithXY(), source: this.workspace, typeCounts: null };
        }
        getHeightWidth() {
          return { width: this.getWidth(), height: this.getHeight() };
        }
        render() {
          if (!this.rendered) {
            var e = this.getHeightWidth(), t = this.createEditor();
            this.svgGroup.appendChild(t), this.svgHandleTarget = K(
              U.RECT,
              { class: "blocklyCommentHandleTarget", x: 0, y: 0 }
            ), this.svgGroup.appendChild(this.svgHandleTarget), this.svgRectTarget = K(U.RECT, { class: "blocklyCommentTarget", x: 0, y: 0, rx: To, ry: To }), this.svgGroup.appendChild(this.svgRectTarget), this.addResizeDom(), this.isDeletable() && this.addDeleteDom(), this.setSize(e.width, e.height), this.textarea.value = this.content_, this.rendered = !0, this.resizeGroup && Pe(this.resizeGroup, "pointerdown", this, this.resizeMouseDown), this.isDeletable() && (Pe(this.deleteGroup, "pointerdown", this, this.deleteMouseDown), Pe(this.deleteGroup, "pointerout", this, this.deleteMouseOut), Pe(
              this.deleteGroup,
              "pointerup",
              this,
              this.deleteMouseUp
            ));
          }
        }
        createEditor() {
          this.foreignObject = K(U.FOREIGNOBJECT, { x: 0, y: yr.TOP_OFFSET, class: "blocklyCommentForeignObject" });
          const e = document.createElementNS(Pi, "body");
          e.setAttribute("xmlns", Pi), e.className = "blocklyMinimalBody";
          const t = document.createElementNS(
            Pi,
            "textarea"
          );
          return t.className = "blocklyCommentTextarea", t.setAttribute("dir", this.RTL ? "RTL" : "LTR"), t.readOnly = !this.isEditable(), e.appendChild(t), this.textarea = t, this.foreignObject.appendChild(e), Pe(t, "wheel", this, function(n) {
            n.stopPropagation();
          }), Pe(t, "change", this, function(n) {
            this.setContent(t.value);
          }), this.foreignObject;
        }
        addResizeDom() {
          this.resizeGroup = K(
            U.G,
            { class: this.RTL ? "blocklyResizeSW" : "blocklyResizeSE" },
            this.svgGroup
          ), K(U.POLYGON, { points: `0,${ar} ${ar},${ar} ${ar},0` }, this.resizeGroup), K(
            U.LINE,
            { class: "blocklyResizeLine", x1: ar / 3, y1: ar - 1, x2: ar - 1, y2: ar / 3 },
            this.resizeGroup
          ), K(U.LINE, { class: "blocklyResizeLine", x1: 2 * ar / 3, y1: ar - 1, x2: ar - 1, y2: 2 * ar / 3 }, this.resizeGroup);
        }
        addDeleteDom() {
          this.deleteGroup = K(U.G, { class: "blocklyCommentDeleteIcon" }, this.svgGroup), this.deleteIconBorder = K(U.CIRCLE, { class: "blocklyDeleteIconShape", r: "7", cx: "7.5", cy: "7.5" }, this.deleteGroup), K(U.LINE, { x1: "5", y1: "10", x2: "10", y2: "5", stroke: "#fff", "stroke-width": "2" }, this.deleteGroup), K(U.LINE, { x1: "5", y1: "5", x2: "10", y2: "10", stroke: "#fff", "stroke-width": "2" }, this.deleteGroup);
        }
        resizeMouseDown(e) {
          this.unbindDragEvents(), Ui(e) || (this.workspace.startDrag(e, new ae(this.workspace.RTL ? -this.width_ : this.width_, this.height_)), this.onMouseUpWrapper = Pe(document, "pointerup", this, this.resizeMouseUp), this.onMouseMoveWrapper = Pe(document, "pointermove", this, this.resizeMouseMove), this.workspace.hideChaff()), e.stopPropagation();
        }
        deleteMouseDown(e) {
          this.deleteIconBorder && be(this.deleteIconBorder, "blocklyDeleteIconHighlighted"), e.stopPropagation();
        }
        deleteMouseOut(e) {
          this.deleteIconBorder && Be(this.deleteIconBorder, "blocklyDeleteIconHighlighted");
        }
        deleteMouseUp(e) {
          this.dispose(), e.stopPropagation();
        }
        unbindDragEvents() {
          this.onMouseUpWrapper && (It(this.onMouseUpWrapper), this.onMouseUpWrapper = null), this.onMouseMoveWrapper && (It(this.onMouseMoveWrapper), this.onMouseMoveWrapper = null);
        }
        resizeMouseUp(e) {
          me(), this.unbindDragEvents();
        }
        resizeMouseMove(e) {
          this.autoLayout = !1, e = this.workspace.moveDrag(e), this.setSize(this.RTL ? -e.x : e.x, e.y);
        }
        resizeComment() {
          const e = this.getHeightWidth(), t = yr.TOP_OFFSET, n = 2 * $u;
          let o;
          (o = this.foreignObject) == null || o.setAttribute("width", String(e.width));
          let c;
          if ((c = this.foreignObject) == null || c.setAttribute("height", String(e.height - t)), this.RTL) {
            let A;
            (A = this.foreignObject) == null || A.setAttribute("x", String(-e.width));
          }
          this.textarea && (this.textarea.style.width = e.width - n + "px", this.textarea.style.height = e.height - n - t + "px");
        }
        setSize(e, t) {
          e = Math.max(e, 45), t = Math.max(t, 20 + yr.TOP_OFFSET), this.width_ = e, this.height_ = t, this.svgRect_.setAttribute("width", `${e}`), this.svgRect_.setAttribute("height", `${t}`);
          let n;
          (n = this.svgRectTarget) == null || n.setAttribute("width", `${e}`);
          let o;
          (o = this.svgRectTarget) == null || o.setAttribute("height", `${t}`);
          let c;
          (c = this.svgHandleTarget) == null || c.setAttribute(
            "width",
            `${e}`
          );
          let A;
          if ((A = this.svgHandleTarget) == null || A.setAttribute("height", String(yr.TOP_OFFSET)), this.RTL) {
            this.svgRect_.setAttribute("transform", "scale(-1 1)");
            let D;
            (D = this.svgRectTarget) == null || D.setAttribute("transform", "scale(-1 1)");
          }
          if (this.resizeGroup)
            if (this.RTL) {
              this.resizeGroup.setAttribute("transform", "translate(" + (-e + ar) + "," + (t - ar) + ") scale(-1 1)");
              let D;
              (D = this.deleteGroup) == null || D.setAttribute("transform", "translate(" + (-e + ar) + "," + -ar + ") scale(-1 1)");
            } else {
              this.resizeGroup.setAttribute("transform", "translate(" + (e - ar) + "," + (t - ar) + ")");
              let D;
              (D = this.deleteGroup) == null || D.setAttribute("transform", "translate(" + (e - ar) + "," + -ar + ")");
            }
          this.resizeComment();
        }
        disposeInternal() {
          this.disposed_ = !0;
        }
        setFocus() {
          this.focused = !0, setTimeout(() => {
            this.disposed_ || (this.textarea.focus(), this.addFocus(), this.svgRectTarget && be(this.svgRectTarget, "blocklyCommentTargetFocused"), this.svgHandleTarget && be(this.svgHandleTarget, "blocklyCommentHandleTargetFocused"));
          }, 0);
        }
        blurFocus() {
          this.focused = !1, setTimeout(() => {
            this.disposed_ || (this.textarea.blur(), this.removeFocus(), this.svgRectTarget && Be(this.svgRectTarget, "blocklyCommentTargetFocused"), this.svgHandleTarget && Be(this.svgHandleTarget, "blocklyCommentHandleTargetFocused"));
          }, 0);
        }
        static fromXmlRendered(e, t, n) {
          r.disable$$module$build$src$core$events$utils();
          let o;
          try {
            const c = U_.parseAttributes(e);
            if (o = new yr(
              t,
              c.content,
              c.h,
              c.w,
              c.id
            ), t.rendered && (o.initSvg(!0), o.render()), !isNaN(c.x) && !isNaN(c.y))
              if (t.RTL) {
                const A = n || t.getWidth();
                o.moveBy(A - c.x, c.y);
              } else
                o.moveBy(c.x, c.y);
          } finally {
            r.enable$$module$build$src$core$events$utils();
          }
          return U_.fireCreateEvent(o), o;
        }
      };
      yr.DEFAULT_SIZE = 100, yr.TOP_OFFSET = 10, xn(`
.blocklyCommentForeignObject {
  position: relative;
  z-index: 0;
}

.blocklyCommentRect {
  fill: #E7DE8E;
  stroke: #bcA903;
  stroke-width: 1px;
}

.blocklyCommentTarget {
  fill: transparent;
  stroke: #bcA903;
}

.blocklyCommentTargetFocused {
  fill: none;
}

.blocklyCommentHandleTarget {
  fill: none;
}

.blocklyCommentHandleTargetFocused {
  fill: transparent;
}

.blocklyFocused>.blocklyCommentRect {
  fill: #B9B272;
  stroke: #B9B272;
}

.blocklySelected>.blocklyCommentTarget {
  stroke: #fc3;
  stroke-width: 3px;
}

.blocklyCommentDeleteIcon {
  cursor: pointer;
  fill: #000;
  display: none;
}

.blocklySelected > .blocklyCommentDeleteIcon {
  display: block;
}

.blocklyDeleteIconShape {
  fill: #000;
  stroke: #000;
  stroke-width: 1px;
}

.blocklyDeleteIconShape.blocklyDeleteIconHighlighted {
  stroke: #fc3;
}
`);
      var Sn = {};
      Sn.appendDomToWorkspace = Ip, Sn.blockToDom = ci, Sn.blockToDomWithXY = ks, Sn.clearWorkspaceAndLoadFromXml = ws, Sn.deleteNext = QE, Sn.domToBlock = r.domToBlock$$module$build$src$core$xml, Sn.domToPrettyText = hp, Sn.domToText = W_, Sn.domToVariables = Mp, Sn.domToWorkspace = r.domToWorkspace$$module$build$src$core$xml, Sn.variablesToDom = Ap, Sn.workspaceToDom = zE;
      var bi = class extends Error {
      }, Wu = class extends bi {
        constructor(e) {
          super("Expected to find a 'type' property, defining the block type"), this.state = e;
        }
      }, hn = class extends bi {
        constructor(e, t, n) {
          super(`The block ${t.toDevString()} is missing a(n) ${e}
connection`), this.block = t, this.state = n;
        }
      }, so = class extends bi {
        constructor(e, t, n, o) {
          super(`The block ${n.toDevString()} could not connect its
${t} to its parent, because: ${e}`), this.childBlock = n, this.childState = o;
        }
      }, JA = class extends bi {
        constructor(e) {
          super(`Encountered a real block which is defined as a child of a shadow
block. It is an invariant of Blockly that shadow blocks only have shadow
children`), this.state = e;
        }
      }, ku = class extends bi {
        constructor(e, t, n) {
          super(`Cannot add an icon of type '${e}' to the block ${t.toDevString()}, because there is no icon registered with type '${e}'. Make sure that all of your icons have been registered.`), this.block = t, this.state = n;
        }
      }, TT = {};
      TT.BadConnectionCheck = so, TT.DeserializationError = bi, TT.MissingBlockType = Wu, TT.MissingConnection = hn, TT.RealChildOfShadow = JA, TT.UnregisteredIcon = ku;
      var jA = 100, zA = 75, ZA = 50, ic = {};
      ic.BLOCKS = ZA, ic.PROCEDURES = zA, ic.VARIABLES = jA;
      var Fu = {};
      Fu.register = Us, Fu.unregister = gp;
      var QA = class {
        constructor() {
          this.priority = ZA;
        }
        save(e) {
          const t = [];
          for (const n of e.getTopBlocks(!1))
            (e = l_(n, { addCoordinates: !0, doFullSerialization: !1 })) && t.push(e);
          return t.length ? { languageVersion: 0, blocks: t } : null;
        }
        load(e, t) {
          e = e.blocks;
          for (const n of e)
            k_(
              n,
              t,
              { recordUndo: Cr() }
            );
        }
        clear(e) {
          for (const t of e.getTopBlocks(!1))
            t.dispose(!1);
        }
      };
      Us("blocks", new QA());
      var Dl = {};
      Dl.BlockSerializer = QA, Dl.append = k_, Dl.appendInternal = Ta, Dl.save = l_;
      var sT = class extends _T {
        constructor(e) {
          super(), this.isBlank = !e, e && (this.blockId = e.id, this.workspaceId = e.workspace.id);
        }
        toJson() {
          const e = super.toJson();
          if (!this.blockId)
            throw Error("The block ID is undefined. Either pass a block to the constructor, or call fromJson");
          return e.blockId = this.blockId, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new sT()), t.blockId = e.blockId, t;
        }
      }, wu = class extends sT {
        constructor(e) {
          super(e), this.type = r.CREATE$$module$build$src$core$events$utils, e && (e.isShadow() && (this.recordUndo = !1), this.xml = ks(e), this.ids = oi(e), this.json = l_(e, { addCoordinates: !0 }));
        }
        toJson() {
          const e = super.toJson();
          if (!this.xml)
            throw Error("The block XML is undefined. Either pass a block to the constructor, or call fromJson");
          if (!this.ids)
            throw Error("The block IDs are undefined. Either pass a block to the constructor, or call fromJson");
          if (!this.json)
            throw Error("The block JSON is undefined. Either pass a block to the constructor, or call fromJson");
          return e.xml = W_(this.xml), e.ids = this.ids, e.json = this.json, this.recordUndo || (e.recordUndo = this.recordUndo), e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new wu()), t.xml = r.textToDom$$module$build$src$core$utils$xml(e.xml), t.ids = e.ids, t.json = e.json, e.recordUndo !== void 0 && (t.recordUndo = e.recordUndo), t;
        }
        run(e) {
          const t = this.getEventWorkspace_();
          if (!this.json)
            throw Error("The block JSON is undefined. Either pass a block to the constructor, or call fromJson");
          if (!this.ids)
            throw Error("The block IDs are undefined. Either pass a block to the constructor, or call fromJson");
          if (e)
            k_(this.json, t);
          else
            for (e = 0; e < this.ids.length; e++) {
              const n = this.ids[e], o = t.getBlockById(n);
              o ? o.dispose(!1) : n === this.blockId && console.warn("Can't uncreate non-existent block: " + n);
            }
        }
      };
      i(se.EVENT, r.CREATE$$module$build$src$core$events$utils, wu);
      var qA = class extends _T {
        constructor(e) {
          super(), this.isBlank = !0, this.recordUndo = !1, this.type = eT, this.isBlank = !!e, e && (this.workspaceId = e.id);
        }
      };
      i(se.EVENT, eT, qA);
      var lo = class extends sT {
        constructor(e, t, n, o, c) {
          super(e), this.type = r.CHANGE$$module$build$src$core$events$utils, e && (this.element = t, this.name = n || void 0, this.oldValue = o, this.newValue = c);
        }
        toJson() {
          const e = super.toJson();
          if (!this.element)
            throw Error("The changed element is undefined. Either pass an element to the constructor, or call fromJson");
          return e.element = this.element, e.name = this.name, e.oldValue = this.oldValue, e.newValue = this.newValue, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new lo()), t.element = e.element, t.name = e.name, t.oldValue = e.oldValue, t.newValue = e.newValue, t;
        }
        isNull() {
          return this.oldValue === this.newValue;
        }
        run(e) {
          var t = this.getEventWorkspace_();
          if (!this.blockId)
            throw Error("The block ID is undefined. Either pass a block to the constructor, or call fromJson");
          if (t = t.getBlockById(this.blockId), !t)
            throw Error("The associated block is undefined. Either pass a block to the constructor, or call fromJson");
          var n = t.getIcon(mr.MUTATOR);
          switch (n && Vi(n) && n.bubbleIsVisible() && n.setBubbleVisible(!1), e = e ? this.newValue : this.oldValue, this.element) {
            case "field":
              (t = t.getField(this.name)) ? t.setValue(e) : console.warn("Can't set non-existent field: " + this.name);
              break;
            case "comment":
              t.setCommentText(e || null);
              break;
            case "collapsed":
              t.setCollapsed(!!e);
              break;
            case "disabled":
              t.setEnabled(!e);
              break;
            case "inline":
              t.setInputsInline(!!e);
              break;
            case "mutation":
              n = lo.getExtraBlockState_(t), t.loadExtraState ? t.loadExtraState(JSON.parse(e || "{}")) : t.domToMutation && t.domToMutation(r.textToDom$$module$build$src$core$utils$xml(e || "<mutation/>")), fe(new lo(t, "mutation", null, n, e));
              break;
            default:
              console.warn("Unknown change type: " + this.element);
          }
        }
        static getExtraBlockState_(e) {
          return e.saveExtraState ? (e = e.saveExtraState()) ? JSON.stringify(e) : "" : e.mutationToDom && (e = e.mutationToDom()) ? W_(e) : "";
        }
      };
      i(se.EVENT, r.CHANGE$$module$build$src$core$events$utils, lo);
      var oc = class extends sT {
        constructor(e) {
          if (super(e), this.type = r.DELETE$$module$build$src$core$events$utils, e) {
            if (e.getParent())
              throw Error("Connected blocks cannot be deleted.");
            e.isShadow() && (this.recordUndo = !1), this.oldXml = ks(e), this.ids = oi(e), this.wasShadow = e.isShadow(), this.oldJson = l_(
              e,
              { addCoordinates: !0 }
            );
          }
        }
        toJson() {
          const e = super.toJson();
          if (!this.oldXml)
            throw Error("The old block XML is undefined. Either pass a block to the constructor, or call fromJson");
          if (!this.ids)
            throw Error("The block IDs are undefined. Either pass a block to the constructor, or call fromJson");
          if (this.wasShadow === void 0)
            throw Error("Whether the block was a shadow is undefined. Either pass a block to the constructor, or call fromJson");
          if (!this.oldJson)
            throw Error("The old block JSON is undefined. Either pass a block to the constructor, or call fromJson");
          return e.oldXml = W_(this.oldXml), e.ids = this.ids, e.wasShadow = this.wasShadow, e.oldJson = this.oldJson, this.recordUndo || (e.recordUndo = this.recordUndo), e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new oc()), t.oldXml = r.textToDom$$module$build$src$core$utils$xml(e.oldXml), t.ids = e.ids, t.wasShadow = e.wasShadow || t.oldXml.tagName.toLowerCase() === "shadow", t.oldJson = e.oldJson, e.recordUndo !== void 0 && (t.recordUndo = e.recordUndo), t;
        }
        run(e) {
          const t = this.getEventWorkspace_();
          if (!this.ids)
            throw Error("The block IDs are undefined. Either pass a block to the constructor, or call fromJson");
          if (!this.oldJson)
            throw Error("The old block JSON is undefined. Either pass a block to the constructor, or call fromJson");
          if (e)
            for (e = 0; e < this.ids.length; e++) {
              const n = this.ids[e], o = t.getBlockById(n);
              o ? o.dispose(!1) : n === this.blockId && console.warn("Can't delete non-existent block: " + n);
            }
          else
            k_(
              this.oldJson,
              t
            );
        }
      };
      i(se.EVENT, r.DELETE$$module$build$src$core$events$utils, oc);
      var Ie;
      (function(e) {
        e[e.INPUT_VALUE = 1] = "INPUT_VALUE", e[e.OUTPUT_VALUE = 2] = "OUTPUT_VALUE", e[e.NEXT_STATEMENT = 3] = "NEXT_STATEMENT", e[e.PREVIOUS_STATEMENT = 4] = "PREVIOUS_STATEMENT";
      })(Ie || (Ie = {}));
      var lt = class {
        constructor(e, t) {
          this.type = t, this.targetConnection = null, this.disposed = !1, this.shadowDom = this.check = null, this.y = this.x = 0, this.shadowState = null, this.sourceBlock_ = e;
        }
        connect_(e) {
          const t = Ie.INPUT_VALUE, n = this.getSourceBlock();
          var o = e.getSourceBlock();
          e.isConnected() && e.disconnectInternal(!1);
          let c;
          if (this.isConnected()) {
            const D = this.stashShadowState(), $ = this.targetBlock();
            $.isShadow() ? $.dispose(!1) : (this.disconnectInternal(), c = $), this.applyShadowState(D);
          }
          let A;
          tt() && (A = new (ge(r.MOVE$$module$build$src$core$events$utils))(o), A.setReason(["connect"])), Op(this, e), o.setParent(n), A && (A.recordNew(), fe(A)), c && (e = this.type === t ? c.outputConnection : c.previousConnection) && ((o = lt.getConnectionForOrphanedConnection(
            o,
            e
          )) ? e.connect(o) : e.onFailedConnect(this));
        }
        dispose() {
          if (this.isConnected()) {
            this.setShadowStateInternal();
            const e = this.targetBlock();
            e && !e.isDeadOrDying() && e.unplug();
          }
          this.disposed = !0;
        }
        getSourceBlock() {
          return this.sourceBlock_;
        }
        isSuperior() {
          return this.type === Ie.INPUT_VALUE || this.type === Ie.NEXT_STATEMENT;
        }
        isConnected() {
          return !!this.targetConnection;
        }
        getConnectionChecker() {
          return this.sourceBlock_.workspace.connectionChecker;
        }
        onFailedConnect(e) {
        }
        connect(e) {
          if (this.targetConnection === e)
            return !0;
          if (this.getConnectionChecker().canConnect(this, e, !1)) {
            const t = r.getGroup$$module$build$src$core$events$utils();
            t || r.setGroup$$module$build$src$core$events$utils(!0), this.isSuperior() ? this.connect_(e) : e.connect_(this), r.setGroup$$module$build$src$core$events$utils(t);
          }
          return this.isConnected();
        }
        disconnect() {
          this.disconnectInternal();
        }
        disconnectInternal(e = !0) {
          const { parentConnection: t, childConnection: n } = this.getParentAndChildConnections();
          if (!t || !n)
            throw Error("Source connection not connected.");
          const o = r.getGroup$$module$build$src$core$events$utils();
          o || r.setGroup$$module$build$src$core$events$utils(!0);
          let c;
          tt() && (c = new (ge(r.MOVE$$module$build$src$core$events$utils))(n.getSourceBlock()), c.setReason(["disconnect"]));
          const A = this.targetConnection;
          A && (A.targetConnection = null), this.targetConnection = null, e && n.getSourceBlock().setParent(null), c && (c.recordNew(), fe(c)), n.getSourceBlock().isShadow() || t.respawnShadow_(), r.setGroup$$module$build$src$core$events$utils(o);
        }
        getParentAndChildConnections() {
          return this.targetConnection ? this.isSuperior() ? { parentConnection: this, childConnection: this.targetConnection } : { parentConnection: this.targetConnection, childConnection: this } : {};
        }
        respawnShadow_() {
          this.createShadowBlock(!0);
        }
        reconnect(e, t) {
          if (this.getSourceBlock().isDeadOrDying())
            return !1;
          var n;
          return t = (n = e.getInput(t)) == null ? void 0 : n.connection, n = this.targetBlock(), n && n !== e || !t || t.targetConnection === this ? !1 : (t.isConnected() && t.disconnect(), t.connect(this), !0);
        }
        targetBlock() {
          if (this.isConnected()) {
            let e, t;
            return (t = (e = this.targetConnection) == null ? void 0 : e.getSourceBlock()) != null ? t : null;
          }
          return null;
        }
        onCheckChanged_() {
          !this.isConnected() || this.targetConnection && this.getConnectionChecker().canConnect(this, this.targetConnection, !1) || (this.isSuperior() ? this.targetBlock() : this.sourceBlock_).unplug();
        }
        setCheck(e) {
          return e ? (Array.isArray(e) || (e = [e]), this.check = e, this.onCheckChanged_()) : this.check = null, this;
        }
        getCheck() {
          return this.check;
        }
        setShadowDom(e) {
          this.setShadowStateInternal({ shadowDom: e });
        }
        getShadowDom(e) {
          return e && this.targetBlock().isShadow() ? ci(this.targetBlock()) : this.shadowDom;
        }
        setShadowState(e) {
          this.setShadowStateInternal({ shadowState: e });
        }
        getShadowState(e) {
          return e && this.targetBlock() && this.targetBlock().isShadow() ? l_(this.targetBlock()) : this.shadowState;
        }
        neighbours(e) {
          return [];
        }
        getParentInput() {
          let e = null;
          const t = this.sourceBlock_.inputList;
          for (let n = 0; n < t.length; n++)
            if (t[n].connection === this) {
              e = t[n];
              break;
            }
          return e;
        }
        toString() {
          const e = this.sourceBlock_;
          if (!e)
            return "Orphan Connection";
          if (e.outputConnection === this)
            var t = "Output Connection of ";
          else if (e.previousConnection === this)
            t = "Previous Connection of ";
          else if (e.nextConnection === this)
            t = "Next Connection of ";
          else {
            t = null;
            for (let n = 0, o; o = e.inputList[n]; n++)
              if (o.connection === this) {
                t = o;
                break;
              }
            if (t)
              t = 'Input "' + t.name + '" connection on ';
            else
              return console.warn("Connection not actually connected to sourceBlock_"), "Orphan Connection";
          }
          return t + e.toDevString();
        }
        stashShadowState() {
          const e = this.getShadowDom(!0), t = this.getShadowState(!0);
          return this.shadowState = this.shadowDom = null, { shadowDom: e, shadowState: t };
        }
        applyShadowState({ shadowDom: e, shadowState: t }) {
          this.shadowDom = e, this.shadowState = t;
        }
        setShadowStateInternal({ shadowDom: e = null, shadowState: t = null } = {}) {
          this.shadowDom = e, this.shadowState = t, (e = this.targetBlock()) ? e.isShadow() ? (e.dispose(!1), this.getSourceBlock().isDeadOrDying() || (this.respawnShadow_(), this.targetBlock() && this.targetBlock().isShadow() && this.serializeShadow(this.targetBlock()))) : (e = this.createShadowBlock(!1), this.serializeShadow(e), e && e.dispose(!1)) : (this.respawnShadow_(), this.targetBlock() && this.targetBlock().isShadow() && this.serializeShadow(this.targetBlock()));
        }
        createShadowBlock(e) {
          var t = this.getSourceBlock();
          const n = this.getShadowState(), o = this.getShadowDom();
          if (t.isDeadOrDying() || !n && !o)
            return null;
          if (n)
            return t = Ta(n, t.workspace, { parentConnection: e ? this : void 0, isShadow: !0, recordUndo: !1 });
          if (o) {
            if (t = r.domToBlock$$module$build$src$core$xml(
              o,
              t.workspace
            ), e)
              if (this.type === Ie.INPUT_VALUE) {
                if (!t.outputConnection)
                  throw Error("Shadow block is missing an output connection");
                if (!this.connect(t.outputConnection))
                  throw Error("Could not connect shadow block to connection");
              } else if (this.type === Ie.NEXT_STATEMENT) {
                if (!t.previousConnection)
                  throw Error("Shadow block is missing previous connection");
                if (!this.connect(t.previousConnection))
                  throw Error("Could not connect shadow block to connection");
              } else
                throw Error("Cannot connect a shadow block to a previous/output connection");
            return t;
          }
          return null;
        }
        serializeShadow(e) {
          e && (this.shadowDom = ci(e), this.shadowState = l_(e));
        }
        static getConnectionForOrphanedConnection(e, t) {
          if (t.type === Ie.OUTPUT_VALUE)
            return Lr(e, t.getSourceBlock());
          e = e.lastConnectionInStack(!0);
          const n = t.getConnectionChecker();
          return e && n.canConnect(t, e, !1) ? e : null;
        }
      };
      lt.CAN_CONNECT = 0, lt.REASON_SELF_CONNECTION = 1, lt.REASON_WRONG_TYPE = 2, lt.REASON_TARGET_NULL = 3, lt.REASON_CHECKS_FAILED = 4, lt.REASON_DIFFERENT_WORKSPACES = 5, lt.REASON_SHADOW_PARENT = 6, lt.REASON_DRAG_CHECKS_FAILED = 7, lt.REASON_PREVIOUS_AND_OUTPUT = 8;
      var Ts = "_TEMP_COLLAPSED_INPUT", Tc = "_TEMP_COLLAPSED_FIELD", sc = {};
      sc.COLLAPSED_FIELD_NAME = Tc, sc.COLLAPSED_INPUT_NAME = Ts;
      var ed = class extends Error {
        constructor(e) {
          super(`Tried to append an icon of type ${e.getType()} when an icon of that type already exists on the block. Use getIcon to access the existing icon.`), this.icon = e;
        }
      }, td = {};
      td.DuplicateIconType = ed;
      var lc = {};
      lc.clamp = vo, lc.toDegrees = pi, lc.toRadians = Gi;
      var Ll = 16, Bu = 1, rd = 12, In = 16, ac = 0.25, Yu = null, lT = null, aT = "", ss = "", at, ls, cT, gl = null, ao = null, nd = null, Uu = { getBoundsInfo: function() {
        const e = s_(gl), t = $s(gl);
        return { left: e.x, right: e.x + t.width, top: e.y, bottom: e.y + t.height, width: t.width, height: t.height };
      }, getPositionMetrics: function(e, t, n, o) {
        const c = Uu.getBoundsInfo(), A = $s(at);
        return t + A.height < c.bottom ? la(e, t, c, A) : o - A.height > c.top ? F_(n, o, c, A) : t + A.height < document.documentElement.clientHeight ? la(e, t, c, A) : o - A.height > document.documentElement.clientTop ? F_(n, o, c, A) : xs(e, c, A);
      } }, tr = {};
      tr.ANIMATION_TIME = ac, tr.ARROW_HORIZONTAL_PADDING = rd, tr.ARROW_SIZE = Ll, tr.BORDER_SIZE = Bu, tr.PADDING_Y = In, tr.TEST_ONLY = Uu, tr.clearContent = Gs, tr.createDom = Vs, tr.getContentDiv = $o, tr.getOwner = sa, tr.getPositionX = Wo, tr.hide = BT, tr.hideIfOwner = Nn, tr.hideWithoutAnimation = a_, tr.isVisible = $t, tr.repositionForWindowResize = $p, tr.setBoundsElement = Tn, tr.setColour = Hs, tr.show = vp, tr.showPositionedByBlock = Rp, tr.showPositionedByField = wT;
      var fl = class {
        constructor(e) {
          this.workspace = e, this.cursorSvg_ = this.cursor_ = null, this.markers = /* @__PURE__ */ new Map(), this.markerSvg_ = null;
        }
        registerMarker(e, t) {
          this.markers.has(e) && this.unregisterMarker(e), t.setDrawer(this.workspace.getRenderer().makeMarkerDrawer(this.workspace, t)), this.setMarkerSvg(t.getDrawer().createDom()), this.markers.set(e, t);
        }
        unregisterMarker(e) {
          const t = this.markers.get(e);
          if (t)
            t.dispose(), this.markers.delete(e);
          else
            throw Error("Marker with ID " + e + " does not exist. Can only unregister markers that exist.");
        }
        getCursor() {
          return this.cursor_;
        }
        getMarker(e) {
          return this.markers.get(e) || null;
        }
        setCursor(e) {
          this.cursor_ && this.cursor_.getDrawer() && this.cursor_.getDrawer().dispose(), (this.cursor_ = e) && (e = this.workspace.getRenderer().makeMarkerDrawer(this.workspace, this.cursor_), this.cursor_.setDrawer(e), this.setCursorSvg(this.cursor_.getDrawer().createDom()));
        }
        setCursorSvg(e) {
          e ? (this.workspace.getBlockCanvas().appendChild(e), this.cursorSvg_ = e) : this.cursorSvg_ = null;
        }
        setMarkerSvg(e) {
          e ? this.workspace.getBlockCanvas() && (this.cursorSvg_ ? this.workspace.getBlockCanvas().insertBefore(e, this.cursorSvg_) : this.workspace.getBlockCanvas().appendChild(e)) : this.markerSvg_ = null;
        }
        updateMarkers() {
          this.workspace.keyboardAccessibilityMode && this.cursorSvg_ && this.workspace.getCursor().draw();
        }
        dispose() {
          const e = Object.keys(this.markers);
          for (let t = 0, n; n = e[t]; t++)
            this.unregisterMarker(n);
          this.markers.clear(), this.cursor_ && (this.cursor_.dispose(), this.cursor_ = null);
        }
      };
      fl.LOCAL_MARKER = "local_marker_1";
      var pT = {};
      pT.commonWordPrefix = aa, pT.commonWordSuffix = YT, pT.isNumber = r.isNumber$$module$build$src$core$utils$string, pT.shortestStringLength = Ks, pT.startsWith = uA, pT.wrap = r.wrap$$module$build$src$core$utils$string;
      var cc = void 0, Nl = !1, as = !1, _d = 50, id = 0, uT = 0, Vu = 0, Gu = 0, Qn = null, bl = null, Hu = 0, xu = 10, od = 10, Td = 750, cs = 5, rr = null, Pr = {};
      Pr.HOVER_MS = Td, Pr.LIMIT = _d, Pr.MARGINS = cs, Pr.OFFSET_X = Hu, Pr.OFFSET_Y = xu, Pr.RADIUS_OK = od, Pr.bindMouseEvents = UT, Pr.block = wp, Pr.createDom = Fp, Pr.dispose = Sa, Pr.getCustomTooltip = Ea, Pr.getDiv = EA, Pr.getTooltipOfObject = Hi, Pr.hide = ui, Pr.isVisible = kp, Pr.setCustomTooltip = ua, Pr.unbindMouseEvents = Jr, Pr.unblock = Bp;
      var Xu = 0.45, Ku = 0.65, sd = { aqua: "#00ffff", black: "#000000", blue: "#0000ff", fuchsia: "#ff00ff", gray: "#808080", green: "#008000", lime: "#00ff00", maroon: "#800000", navy: "#000080", olive: "#808000", purple: "#800080", red: "#ff0000", silver: "#c0c0c0", teal: "#008080", white: "#ffffff", yellow: "#ffff00" }, Yr = {};
      Yr.blend = Xn, Yr.getHsvSaturation = Yp, Yr.getHsvValue = Ia, Yr.hexToRgb = Ma, Yr.hsvToHex = ma, Yr.hueToHex = bn, Yr.names = sd, Yr.parse = c_, Yr.rgbToHex = js, Yr.setHsvSaturation = ha, Yr.setHsvValue = Ei;
      var Cl = {};
      Cl.checkMessageReferences = Pa, Cl.parseBlockColour = GT, Cl.replaceMessageReferences = xt, Cl.tokenizeInterpolation = Up;
      var ps = null, pc = null, ET = "", us = "", Mn, x_ = {};
      x_.createDom = G, x_.getDiv = wo, x_.hide = J, x_.hideIfOwner = Ye, x_.isVisible = Me, x_.positionWithAnchor = sr, x_.repositionForWindowResize = ln, x_.show = Q, x_.testOnly_setDiv = Bo;
      var _t = class {
        constructor(e, t, n) {
          this.DEFAULT_VALUE = null, this.name = void 0, this.constants_ = this.mouseDownWrapper_ = this.textContent_ = this.textElement_ = this.borderRect_ = this.fieldGroup_ = this.markerSvg_ = this.cursorSvg_ = this.tooltip_ = this.validator_ = null, this.disposed = !1, this.maxDisplayLength = 50, this.sourceBlock_ = null, this.enabled_ = this.visible_ = this.isDirty_ = !0, this.suffixField = this.prefixField = this.clickTarget_ = null, this.EDITABLE = !0, this.SERIALIZABLE = !1, this.CURSOR = "", this.value_ = "DEFAULT_VALUE" in new.target.prototype ? new.target.prototype.DEFAULT_VALUE : this.DEFAULT_VALUE, this.size_ = new ht(0, 0), e !== _t.SKIP_SETUP && (n && this.configure_(n), this.setValue(e), t && this.setValidator(t));
        }
        configure_(e) {
          e.tooltip && this.setTooltip(xt(e.tooltip));
        }
        setSourceBlock(e) {
          if (this.sourceBlock_)
            throw Error("Field already bound to a block");
          this.sourceBlock_ = e;
        }
        getConstants() {
          return !this.constants_ && this.sourceBlock_ && !this.sourceBlock_.isDeadOrDying() && this.sourceBlock_.workspace.rendered && (this.constants_ = this.sourceBlock_.workspace.getRenderer().getConstants()), this.constants_;
        }
        getSourceBlock() {
          return this.sourceBlock_;
        }
        init() {
          this.fieldGroup_ || (this.fieldGroup_ = K(U.G, {}), this.isVisible() || (this.fieldGroup_.style.display = "none"), this.sourceBlock_.getSvgRoot().appendChild(this.fieldGroup_), this.initView(), this.updateEditable(), this.setTooltip(this.tooltip_), this.bindEvents_(), this.initModel());
        }
        initView() {
          this.createBorderRect_(), this.createTextElement_();
        }
        initModel() {
        }
        createBorderRect_() {
          this.borderRect_ = K(U.RECT, { rx: this.getConstants().FIELD_BORDER_RECT_RADIUS, ry: this.getConstants().FIELD_BORDER_RECT_RADIUS, x: 0, y: 0, height: this.size_.height, width: this.size_.width, class: "blocklyFieldRect" }, this.fieldGroup_);
        }
        createTextElement_() {
          this.textElement_ = K(U.TEXT, { class: "blocklyText" }, this.fieldGroup_), this.getConstants().FIELD_TEXT_BASELINE_CENTER && this.textElement_.setAttribute("dominant-baseline", "central"), this.textContent_ = document.createTextNode(""), this.textElement_.appendChild(this.textContent_);
        }
        bindEvents_() {
          const e = this.getClickTarget_();
          if (!e)
            throw Error("A click target has not been set.");
          UT(e), this.mouseDownWrapper_ = Pe(e, "pointerdown", this, this.onMouseDown_);
        }
        fromXml(e) {
          this.setValue(e.textContent);
        }
        toXml(e) {
          return e.textContent = this.getValue(), e;
        }
        saveState(e) {
          return e = this.saveLegacyState(_t), e !== null ? e : this.getValue();
        }
        loadState(e) {
          this.loadLegacyState(_t, e) || this.setValue(e);
        }
        saveLegacyState(e) {
          return e.prototype.saveState === this.saveState && e.prototype.toXml !== this.toXml ? (e = r.createElement$$module$build$src$core$utils$xml("field"), e.setAttribute("name", this.name || ""), Hr(this.toXml(e)).replace(' xmlns="https://developers.google.com/blockly/xml"', "")) : null;
        }
        loadLegacyState(e, t) {
          return e.prototype.loadState === this.loadState && e.prototype.fromXml !== this.fromXml ? (this.fromXml(r.textToDom$$module$build$src$core$utils$xml(t)), !0) : !1;
        }
        dispose() {
          Nn(this), Ye(this);
          let e;
          (e = this.getSourceBlock()) != null && e.isDeadOrDying() || Tt(this.fieldGroup_), this.disposed = !0;
        }
        updateEditable() {
          const e = this.fieldGroup_, t = this.getSourceBlock();
          this.EDITABLE && e && t && (this.enabled_ && t.isEditable() ? (be(e, "blocklyEditableText"), Be(e, "blocklyNonEditableText"), e.style.cursor = this.CURSOR) : (be(e, "blocklyNonEditableText"), Be(e, "blocklyEditableText"), e.style.cursor = ""));
        }
        setEnabled(e) {
          this.enabled_ = e, this.updateEditable();
        }
        isEnabled() {
          return this.enabled_;
        }
        isClickable() {
          return this.enabled_ && !!this.sourceBlock_ && this.sourceBlock_.isEditable() && this.showEditor_ !== _t.prototype.showEditor_;
        }
        isCurrentlyEditable() {
          return this.enabled_ && this.EDITABLE && !!this.sourceBlock_ && this.sourceBlock_.isEditable();
        }
        isSerializable() {
          let e = !1;
          return this.name && (this.SERIALIZABLE ? e = !0 : this.EDITABLE && (console.warn("Detected an editable field that was not serializable. Please define SERIALIZABLE property as true on all editable custom fields. Proceeding with serialization."), e = !0)), e;
        }
        isVisible() {
          return this.visible_;
        }
        setVisible(e) {
          if (this.visible_ !== e) {
            this.visible_ = e;
            var t = this.fieldGroup_;
            t && (t.style.display = e ? "block" : "none");
          }
        }
        setValidator(e) {
          this.validator_ = e;
        }
        getValidator() {
          return this.validator_;
        }
        getSvgRoot() {
          return this.fieldGroup_;
        }
        getBorderRect() {
          if (!this.borderRect_)
            throw Error(`The border rectangle is ${this.borderRect_}.`);
          return this.borderRect_;
        }
        getTextElement() {
          if (!this.textElement_)
            throw Error(`The text element is ${this.textElement_}.`);
          return this.textElement_;
        }
        getTextContent() {
          if (!this.textContent_)
            throw Error(`The text content is ${this.textContent_}.`);
          return this.textContent_;
        }
        applyColour() {
        }
        render_() {
          this.textContent_ && (this.textContent_.nodeValue = this.getDisplayText_()), this.updateSize_();
        }
        showEditor(e) {
          this.isClickable() && this.showEditor_(e);
        }
        showEditor_(e) {
        }
        repositionForWindowResize() {
          return !1;
        }
        updateSize_(e) {
          const t = this.getConstants();
          e = e !== void 0 ? e : this.borderRect_ ? this.getConstants().FIELD_BORDER_RECT_X_PADDING : 0;
          let n = 2 * e, o = t.FIELD_TEXT_HEIGHT, c = 0;
          this.textElement_ && (c = xr(
            this.textElement_,
            t.FIELD_TEXT_FONTSIZE,
            t.FIELD_TEXT_FONTWEIGHT,
            t.FIELD_TEXT_FONTFAMILY
          ), n += c), this.borderRect_ && (o = Math.max(o, t.FIELD_BORDER_RECT_HEIGHT)), this.size_.height = o, this.size_.width = n, this.positionTextElement_(e, c), this.positionBorderRect_();
        }
        positionTextElement_(e, t) {
          if (this.textElement_) {
            var n = this.getConstants(), o = this.size_.height / 2, c;
            this.textElement_.setAttribute("x", String((c = this.getSourceBlock()) != null && c.RTL ? this.size_.width - t - e : e)), this.textElement_.setAttribute("y", String(n.FIELD_TEXT_BASELINE_CENTER ? o : o - n.FIELD_TEXT_HEIGHT / 2 + n.FIELD_TEXT_BASELINE));
          }
        }
        positionBorderRect_() {
          this.borderRect_ && (this.borderRect_.setAttribute("width", String(this.size_.width)), this.borderRect_.setAttribute("height", String(this.size_.height)), this.borderRect_.setAttribute("rx", String(this.getConstants().FIELD_BORDER_RECT_RADIUS)), this.borderRect_.setAttribute("ry", String(this.getConstants().FIELD_BORDER_RECT_RADIUS)));
        }
        getSize() {
          return this.isVisible() ? (this.isDirty_ ? (this.render_(), this.isDirty_ = !1) : this.visible_ && this.size_.width === 0 && (this.render_(), this.size_.width !== 0 && console.warn("Deprecated use of setting size_.width to 0 to rerender a field. Set field.isDirty_ to true instead.")), this.size_) : new ht(0, 0);
        }
        getScaledBBox() {
          let e;
          var t = this.getSourceBlock();
          if (!t)
            throw new nr();
          if (this.borderRect_) {
            var n = this.borderRect_.getBoundingClientRect();
            e = s_(this.borderRect_), t = n.width, n = n.height;
          } else {
            n = this.sourceBlock_.getHeightWidth();
            const o = t.workspace.scale;
            e = this.getAbsoluteXY_(), t = (n.width + 1) * o, n = (n.height + 1) * o, Ru ? (e.x += 1.5 * o, e.y += 1.5 * o) : (e.x -= 0.5 * o, e.y -= 0.5 * o);
          }
          return new Dt(e.y, e.y + n, e.x, e.x + t);
        }
        getDisplayText_() {
          let e = this.getText();
          return e ? (e.length > this.maxDisplayLength && (e = e.substring(0, this.maxDisplayLength - 2) + "…"), e = e.replace(/\s/g, _t.NBSP), this.sourceBlock_ && this.sourceBlock_.RTL && (e += "‏"), e) : _t.NBSP;
        }
        getText() {
          const e = this.getText_();
          return String(e !== null ? e : this.getValue());
        }
        getText_() {
          return null;
        }
        markDirty() {
          this.isDirty_ = !0, this.constants_ = null;
        }
        forceRerender() {
          this.isDirty_ = !0, this.sourceBlock_ && this.sourceBlock_.rendered && (this.sourceBlock_.queueRender(), this.sourceBlock_.bumpNeighbours());
        }
        setValue(e, t = !0) {
          if (e !== null) {
            var n = this.doClassValidation_(e);
            if (e = this.processValidation_(e, n), !(e instanceof Error)) {
              var o;
              n = (o = this.getValidator()) == null ? void 0 : o.call(
                this,
                e
              ), o = this.processValidation_(e, n), o instanceof Error || (e = this.sourceBlock_, e && e.disposed || (n = this.getValue(), n === o ? this.doValueUpdate_(o) : (this.doValueUpdate_(o), t && e && tt() && fe(new (ge(r.CHANGE$$module$build$src$core$events$utils))(e, "field", this.name || null, n, o)), this.isDirty_ && this.forceRerender())));
            }
          }
        }
        processValidation_(e, t) {
          return t === null ? (this.doValueInvalid_(e), this.isDirty_ && this.forceRerender(), Error()) : t === void 0 ? e : t;
        }
        getValue() {
          return this.value_;
        }
        doClassValidation_(e) {
          return e ?? null;
        }
        doValueUpdate_(e) {
          this.value_ = e, this.isDirty_ = !0;
        }
        doValueInvalid_(e) {
        }
        onMouseDown_(e) {
          this.sourceBlock_ && !this.sourceBlock_.isDeadOrDying() && (e = this.sourceBlock_.workspace.getGesture(e)) && e.setStartField(this);
        }
        setTooltip(e) {
          e || e === "" || (e = this.sourceBlock_);
          const t = this.getClickTarget_();
          t ? t.tooltip = e : this.tooltip_ = e;
        }
        getTooltip() {
          const e = this.getClickTarget_();
          return Hi(e || { tooltip: this.tooltip_ });
        }
        getClickTarget_() {
          return this.clickTarget_ || this.getSvgRoot();
        }
        getAbsoluteXY_() {
          return s_(this.getClickTarget_());
        }
        referencesVariables() {
          return !1;
        }
        refreshVariableName() {
        }
        getParentInput() {
          let e = null;
          const t = this.getSourceBlock();
          if (!t)
            throw new nr();
          const n = t.inputList;
          for (let o = 0; o < t.inputList.length; o++) {
            const c = n[o], A = c.fieldRow;
            for (let D = 0; D < A.length; D++)
              if (A[D] === this) {
                e = c;
                break;
              }
          }
          return e;
        }
        getFlipRtl() {
          return !1;
        }
        isTabNavigable() {
          return !1;
        }
        onShortcut(e) {
          return !1;
        }
        setCursorSvg(e) {
          if (e) {
            if (!this.fieldGroup_)
              throw Error(`The field group is ${this.fieldGroup_}.`);
            this.fieldGroup_.appendChild(e), this.cursorSvg_ = e;
          } else
            this.cursorSvg_ = null;
        }
        setMarkerSvg(e) {
          if (e) {
            if (!this.fieldGroup_)
              throw Error(`The field group is ${this.fieldGroup_}.`);
            this.fieldGroup_.appendChild(e), this.markerSvg_ = e;
          } else
            this.markerSvg_ = null;
        }
        updateMarkers_() {
          var e = this.getSourceBlock();
          if (!e)
            throw new nr();
          e = e.workspace, e.keyboardAccessibilityMode && this.cursorSvg_ && e.getCursor().draw(), e.keyboardAccessibilityMode && this.markerSvg_ && e.getMarker(fl.LOCAL_MARKER).draw();
        }
      };
      _t.NBSP = " ", _t.SKIP_SETUP = Symbol("SKIP_SETUP");
      var nr = class extends Error {
        constructor() {
          super("The field has not yet been attached to its input. Call appendField to attach it.");
        }
      }, ld = { fromJsonInternal: Yo }, Ol = {};
      Ol.TEST_ONLY = ld, Ol.fromJson = r.fromJson$$module$build$src$core$field_registry, Ol.register = Br, Ol.unregister = IA;
      var vS = "aria-", $S = "role", mn;
      (function(e) {
        e.GRID = "grid", e.GRIDCELL = "gridcell", e.GROUP = "group", e.LISTBOX = "listbox", e.MENU = "menu", e.MENUITEM = "menuitem", e.MENUITEMCHECKBOX = "menuitemcheckbox", e.OPTION = "option", e.PRESENTATION = "presentation", e.ROW = "row", e.TREE = "tree", e.TREEITEM = "treeitem";
      })(mn || (mn = {}));
      var Ot;
      (function(e) {
        e.ACTIVEDESCENDANT = "activedescendant", e.COLCOUNT = "colcount", e.DISABLED = "disabled", e.EXPANDED = "expanded", e.INVALID = "invalid", e.LABEL = "label", e.LABELLEDBY = "labelledby", e.LEVEL = "level", e.ORIENTATION = "orientation", e.POSINSET = "posinset", e.ROWCOUNT = "rowcount", e.SELECTED = "selected", e.SETSIZE = "setsize", e.VALUEMAX = "valuemax", e.VALUEMIN = "valuemin";
      })(Ot || (Ot = {}));
      var Rl = {};
      Rl.Role = mn, Rl.State = Ot, Rl.setRole = an, Rl.setState = Mt;
      var Ju = class {
        constructor() {
          this.menuItems = [], this.roleName = this.element = this.onKeyDownHandler = this.mouseLeaveHandler = this.mouseEnterHandler = this.clickHandler = this.mouseOverHandler = this.highlightedItem = this.openingCoords = null;
        }
        addChild(e) {
          this.menuItems.push(e);
        }
        render(e) {
          const t = document.createElement("div");
          t.className = "blocklyMenu goog-menu blocklyNonSelectable", t.tabIndex = 0, this.roleName && an(t, this.roleName), this.element = t;
          for (let n = 0, o; o = this.menuItems[n]; n++)
            t.appendChild(o.createDom());
          return this.mouseOverHandler = Pe(t, "pointerover", this, this.handleMouseOver, !0), this.clickHandler = Pe(t, "pointerup", this, this.handleClick, !0), this.mouseEnterHandler = Pe(t, "pointerenter", this, this.handleMouseEnter, !0), this.mouseLeaveHandler = Pe(
            t,
            "pointerleave",
            this,
            this.handleMouseLeave,
            !0
          ), this.onKeyDownHandler = Pe(t, "keydown", this, this.handleKeyEvent), e.appendChild(t), t;
        }
        getElement() {
          return this.element;
        }
        focus() {
          const e = this.getElement();
          e && (e.focus({ preventScroll: !0 }), be(e, "blocklyFocused"));
        }
        blur() {
          const e = this.getElement();
          e && (e.blur(), Be(e, "blocklyFocused"));
        }
        setRole(e) {
          this.roleName = e;
        }
        dispose() {
          this.mouseOverHandler && (It(this.mouseOverHandler), this.mouseOverHandler = null), this.clickHandler && (It(this.clickHandler), this.clickHandler = null), this.mouseEnterHandler && (It(this.mouseEnterHandler), this.mouseEnterHandler = null), this.mouseLeaveHandler && (It(this.mouseLeaveHandler), this.mouseLeaveHandler = null), this.onKeyDownHandler && (It(this.onKeyDownHandler), this.onKeyDownHandler = null);
          for (let e = 0, t; t = this.menuItems[e]; e++)
            t.dispose();
          this.element = null;
        }
        getMenuItem(e) {
          const t = this.getElement();
          for (; e && e !== t; ) {
            if (e.classList.contains("blocklyMenuItem")) {
              for (let n = 0, o; o = this.menuItems[n]; n++)
                if (o.getElement() === e)
                  return o;
            }
            e = e.parentElement;
          }
          return null;
        }
        setHighlighted(e) {
          var t = this.highlightedItem;
          t && (t.setHighlighted(!1), this.highlightedItem = null), e && (e.setHighlighted(!0), this.highlightedItem = e, t = this.getElement(), ta(
            e.getElement(),
            t
          ), Mt(t, Ot.ACTIVEDESCENDANT, e.getId()));
        }
        highlightNext() {
          const e = this.highlightedItem ? this.menuItems.indexOf(this.highlightedItem) : -1;
          this.highlightHelper(e, 1);
        }
        highlightPrevious() {
          const e = this.highlightedItem ? this.menuItems.indexOf(this.highlightedItem) : -1;
          this.highlightHelper(0 > e ? this.menuItems.length : e, -1);
        }
        highlightFirst() {
          this.highlightHelper(-1, 1);
        }
        highlightLast() {
          this.highlightHelper(this.menuItems.length, -1);
        }
        highlightHelper(e, t) {
          e += t;
          let n;
          for (; n = this.menuItems[e]; ) {
            if (n.isEnabled()) {
              this.setHighlighted(n);
              break;
            }
            e += t;
          }
        }
        handleMouseOver(e) {
          (e = this.getMenuItem(e.target)) && (e.isEnabled() ? this.highlightedItem !== e && this.setHighlighted(e) : this.setHighlighted(null));
        }
        handleClick(e) {
          const t = this.openingCoords;
          if (this.openingCoords = null, t && typeof e.clientX == "number") {
            const n = new ae(e.clientX, e.clientY);
            if (1 > ae.distance(t, n))
              return;
          }
          (e = this.getMenuItem(e.target)) && e.performAction();
        }
        handleMouseEnter(e) {
          this.focus();
        }
        handleMouseLeave(e) {
          this.getElement() && (this.blur(), this.setHighlighted(null));
        }
        handleKeyEvent(e) {
          if (this.menuItems.length && !(e.shiftKey || e.ctrlKey || e.metaKey || e.altKey)) {
            var t = this.highlightedItem;
            switch (e.key) {
              case "Enter":
              case " ":
                t && t.performAction();
                break;
              case "ArrowUp":
                this.highlightPrevious();
                break;
              case "ArrowDown":
                this.highlightNext();
                break;
              case "PageUp":
              case "Home":
                this.highlightFirst();
                break;
              case "PageDown":
              case "End":
                this.highlightLast();
                break;
              default:
                return;
            }
            e.preventDefault(), e.stopPropagation();
          }
        }
        getSize() {
          const e = this.getElement(), t = $s(e);
          return t.height = e.scrollHeight, t;
        }
      }, ju = class {
        constructor(e, t) {
          this.content = e, this.opt_value = t, this.enabled = !0, this.element = null, this.rightToLeft = !1, this.roleName = null, this.highlight = this.checked = this.checkable = !1, this.actionHandler = null;
        }
        createDom() {
          const e = document.createElement("div");
          e.id = i_(), this.element = e, e.className = "blocklyMenuItem goog-menuitem " + (this.enabled ? "" : "blocklyMenuItemDisabled goog-menuitem-disabled ") + (this.checked ? "blocklyMenuItemSelected goog-option-selected " : "") + (this.highlight ? "blocklyMenuItemHighlight goog-menuitem-highlight " : "") + (this.rightToLeft ? "blocklyMenuItemRtl goog-menuitem-rtl " : "");
          const t = document.createElement("div");
          if (t.className = "blocklyMenuItemContent goog-menuitem-content", this.checkable) {
            var n = document.createElement("div");
            n.className = "blocklyMenuItemCheckbox goog-menuitem-checkbox", t.appendChild(n);
          }
          return n = this.content, typeof this.content == "string" && (n = document.createTextNode(this.content)), t.appendChild(n), e.appendChild(t), this.roleName && an(e, this.roleName), Mt(e, Ot.SELECTED, this.checkable && this.checked || !1), Mt(e, Ot.DISABLED, !this.enabled), e;
        }
        dispose() {
          this.element = null;
        }
        getElement() {
          return this.element;
        }
        getId() {
          return this.element.id;
        }
        getValue() {
          let e;
          return (e = this.opt_value) != null ? e : null;
        }
        setRightToLeft(e) {
          this.rightToLeft = e;
        }
        setRole(e) {
          this.roleName = e;
        }
        setCheckable(e) {
          this.checkable = e;
        }
        setChecked(e) {
          this.checked = e;
        }
        setHighlighted(e) {
          this.highlight = e;
          const t = this.getElement();
          t && this.isEnabled() && (e ? (be(t, "blocklyMenuItemHighlight"), be(t, "goog-menuitem-highlight")) : (Be(t, "blocklyMenuItemHighlight"), Be(t, "goog-menuitem-highlight")));
        }
        isEnabled() {
          return this.enabled;
        }
        setEnabled(e) {
          this.enabled = e;
        }
        performAction() {
          this.isEnabled() && this.actionHandler && this.actionHandler(this);
        }
        onAction(e, t) {
          this.actionHandler = e.bind(t);
        }
      }, X_ = class extends _t {
        constructor(e, t, n) {
          super(_t.SKIP_SETUP), this.svgArrow = this.arrow = this.imageElement = this.menu_ = this.selectedMenuItem = null, this.SERIALIZABLE = !0, this.CURSOR = "default", this.clickTarget_ = this.suffixField = this.prefixField = this.generatedOptions = null, e !== _t.SKIP_SETUP && (Array.isArray(e) ? (La(e), e = St(e), this.menuGenerator_ = e.options, this.prefixField = e.prefix || null, this.suffixField = e.suffix || null) : this.menuGenerator_ = e, this.selectedOption = this.getOptions(!1)[0], n && this.configure_(n), this.setValue(this.selectedOption[1]), t && this.setValidator(t));
        }
        fromXml(e) {
          this.isOptionListDynamic() && this.getOptions(!1), this.setValue(e.textContent);
        }
        loadState(e) {
          this.loadLegacyState(X_, e) || (this.isOptionListDynamic() && this.getOptions(!1), this.setValue(e));
        }
        initView() {
          this.shouldAddBorderRect_() ? this.createBorderRect_() : this.clickTarget_ = this.sourceBlock_.getSvgRoot(), this.createTextElement_(), this.imageElement = K(U.IMAGE, {}, this.fieldGroup_), this.getConstants().FIELD_DROPDOWN_SVG_ARROW ? this.createSVGArrow_() : this.createTextArrow_(), this.borderRect_ && be(this.borderRect_, "blocklyDropdownRect");
        }
        shouldAddBorderRect_() {
          let e;
          return !this.getConstants().FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW || this.getConstants().FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW && !((e = this.getSourceBlock()) != null && e.isShadow());
        }
        createTextArrow_() {
          this.arrow = K(U.TSPAN, {}, this.textElement_);
          let e;
          this.arrow.appendChild(document.createTextNode((e = this.getSourceBlock()) != null && e.RTL ? X_.ARROW_CHAR + " " : " " + X_.ARROW_CHAR));
          let t;
          (t = this.getSourceBlock()) != null && t.RTL ? this.getTextElement().insertBefore(this.arrow, this.textContent_) : this.getTextElement().appendChild(this.arrow);
        }
        createSVGArrow_() {
          this.svgArrow = K(U.IMAGE, { height: this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE + "px", width: this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE + "px" }, this.fieldGroup_), this.svgArrow.setAttributeNS(
            $n,
            "xlink:href",
            this.getConstants().FIELD_DROPDOWN_SVG_ARROW_DATAURI
          );
        }
        showEditor_(e) {
          var t = this.getSourceBlock();
          if (!t)
            throw new nr();
          this.dropdownCreate(), this.menu_.openingCoords = e && typeof e.clientX == "number" ? new ae(e.clientX, e.clientY) : null, Gs(), e = this.menu_.render($o()), be(e, "blocklyDropdownMenu"), this.getConstants().FIELD_DROPDOWN_COLOURED_DIV && (e = t.isShadow() ? t.getParent().getColour() : t.getColour(), t = t.isShadow() ? t.getParent().style.colourTertiary : this.sourceBlock_.style.colourTertiary, Hs(e, t)), wT(this, this.dropdownDispose_.bind(this)), this.menu_.focus(), this.selectedMenuItem && (this.menu_.setHighlighted(this.selectedMenuItem), ta(
            this.selectedMenuItem.getElement(),
            $o(),
            !0
          )), this.applyColour();
        }
        dropdownCreate() {
          const e = this.getSourceBlock();
          if (!e)
            throw new nr();
          const t = new Ju();
          t.setRole(mn.LISTBOX), this.menu_ = t;
          const n = this.getOptions(!1);
          this.selectedMenuItem = null;
          for (let c = 0; c < n.length; c++) {
            const [A, D] = n[c];
            if (typeof A == "object") {
              var o = new Image(A.width, A.height);
              o.src = A.src, o.alt = A.alt || "";
            } else
              o = A;
            o = new ju(o, D), o.setRole(mn.OPTION), o.setRightToLeft(e.RTL), o.setCheckable(!0), t.addChild(o), o.setChecked(D === this.value_), D === this.value_ && (this.selectedMenuItem = o), o.onAction(this.handleMenuActionEvent, this);
          }
        }
        dropdownDispose_() {
          this.menu_ && this.menu_.dispose(), this.selectedMenuItem = this.menu_ = null, this.applyColour();
        }
        handleMenuActionEvent(e) {
          Nn(this, !0), this.onItemSelected_(
            this.menu_,
            e
          );
        }
        onItemSelected_(e, t) {
          this.setValue(t.getValue());
        }
        isOptionListDynamic() {
          return typeof this.menuGenerator_ == "function";
        }
        getOptions(e) {
          if (!this.menuGenerator_)
            throw TypeError("A menu generator was never defined.");
          return Array.isArray(this.menuGenerator_) ? this.menuGenerator_ : e && this.generatedOptions ? this.generatedOptions : (this.generatedOptions = this.menuGenerator_(), La(this.generatedOptions), this.generatedOptions);
        }
        doClassValidation_(e) {
          return this.getOptions(!0).some((t) => t[1] === e) ? e : (this.sourceBlock_ && console.warn("Cannot set the dropdown's value to an unavailable option. Block type: " + this.sourceBlock_.type + ", Field name: " + this.name + ", Value: " + e), null);
        }
        doValueUpdate_(e) {
          super.doValueUpdate_(e), e = this.getOptions(!0);
          for (let t = 0, n; n = e[t]; t++)
            n[1] === this.value_ && (this.selectedOption = n);
        }
        applyColour() {
          const e = this.sourceBlock_.style;
          this.borderRect_ && (this.borderRect_.setAttribute("stroke", e.colourTertiary), this.menu_ ? this.borderRect_.setAttribute("fill", e.colourTertiary) : this.borderRect_.setAttribute("fill", "transparent")), this.sourceBlock_ && this.arrow && (this.sourceBlock_.isShadow() ? this.arrow.style.fill = e.colourSecondary : this.arrow.style.fill = e.colourPrimary);
        }
        render_() {
          this.getTextContent().nodeValue = "", this.imageElement.style.display = "none";
          const e = this.selectedOption && this.selectedOption[0];
          e && typeof e == "object" ? this.renderSelectedImage(e) : this.renderSelectedText(), this.positionBorderRect_();
        }
        renderSelectedImage(e) {
          const t = this.getSourceBlock();
          if (!t)
            throw new nr();
          this.imageElement.style.display = "", this.imageElement.setAttributeNS($n, "xlink:href", e.src), this.imageElement.setAttribute("height", String(e.height)), this.imageElement.setAttribute("width", String(e.width));
          const n = Number(e.height);
          e = Number(e.width);
          var o = !!this.borderRect_;
          const c = Math.max(o ? this.getConstants().FIELD_DROPDOWN_BORDER_RECT_HEIGHT : 0, n + kS);
          o = o ? this.getConstants().FIELD_BORDER_RECT_X_PADDING : 0;
          let A;
          A = this.svgArrow ? this.positionSVGArrow(e + o, c / 2 - this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE / 2) : xr(this.arrow, this.getConstants().FIELD_TEXT_FONTSIZE, this.getConstants().FIELD_TEXT_FONTWEIGHT, this.getConstants().FIELD_TEXT_FONTFAMILY), this.size_.width = e + A + 2 * o, this.size_.height = c;
          let D = 0;
          t.RTL ? this.imageElement.setAttribute("x", `${o + A}`) : (D = e + A, this.getTextElement().setAttribute("text-anchor", "end"), this.imageElement.setAttribute("x", `${o}`)), this.imageElement.setAttribute(
            "y",
            String(c / 2 - n / 2)
          ), this.positionTextElement_(D + o, e + A);
        }
        renderSelectedText() {
          this.getTextContent().nodeValue = this.getDisplayText_();
          var e = this.getTextElement();
          be(e, "blocklyDropdownText"), e.setAttribute("text-anchor", "start");
          var t = !!this.borderRect_;
          e = Math.max(t ? this.getConstants().FIELD_DROPDOWN_BORDER_RECT_HEIGHT : 0, this.getConstants().FIELD_TEXT_HEIGHT);
          const n = xr(
            this.getTextElement(),
            this.getConstants().FIELD_TEXT_FONTSIZE,
            this.getConstants().FIELD_TEXT_FONTWEIGHT,
            this.getConstants().FIELD_TEXT_FONTFAMILY
          );
          t = t ? this.getConstants().FIELD_BORDER_RECT_X_PADDING : 0;
          let o = 0;
          this.svgArrow && (o = this.positionSVGArrow(n + t, e / 2 - this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE / 2)), this.size_.width = n + o + 2 * t, this.size_.height = e, this.positionTextElement_(t, n);
        }
        positionSVGArrow(e, t) {
          if (!this.svgArrow)
            return 0;
          const n = this.getSourceBlock();
          if (!n)
            throw new nr();
          const o = this.borderRect_ ? this.getConstants().FIELD_BORDER_RECT_X_PADDING : 0, c = this.getConstants().FIELD_DROPDOWN_SVG_ARROW_PADDING, A = this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE;
          return this.svgArrow.setAttribute("transform", "translate(" + (n.RTL ? o : e + c) + "," + t + ")"), A + c;
        }
        getText_() {
          if (!this.selectedOption)
            return null;
          const e = this.selectedOption[0];
          return typeof e == "object" ? e.alt : e;
        }
        static fromJson(e) {
          if (!e.options)
            throw Error("options are required for the dropdown field. The options property must be assigned an array of [humanReadableValue, languageNeutralValue] tuples.");
          return new this(e.options, void 0, e);
        }
      };
      X_.CHECKMARK_OVERHANG = 25, X_.MAX_MENU_HEIGHT_VH = 0.45, X_.ARROW_CHAR = "▾";
      var WS = 5, kS = 2 * WS;
      Br("field_dropdown", X_);
      var uc = class {
        constructor(e) {
          this.sourceBlock = e, this.offsetInBlock = new ae(0, 0), this.workspaceLocation = new ae(0, 0), this.svgRoot = null;
        }
        getType() {
          throw Error("Icons must implement getType");
        }
        initView(e) {
          if (!this.svgRoot) {
            var t = this.sourceBlock;
            this.svgRoot = K(U.G, { class: "blocklyIconGroup" }), t.getSvgRoot().appendChild(this.svgRoot), this.updateSvgRootOffset(), Pe(this.svgRoot, "pointerdown", this, e);
          }
        }
        dispose() {
          Tt(this.svgRoot);
        }
        getWeight() {
          return -1;
        }
        getSize() {
          return new ht(0, 0);
        }
        applyColour() {
        }
        updateEditable() {
        }
        updateCollapsed() {
          this.svgRoot && (this.sourceBlock.isCollapsed() ? this.svgRoot.style.display = "none" : this.svgRoot.style.display = "block", Vi(this) && this.setBubbleVisible(!1));
        }
        hideForInsertionMarker() {
          this.svgRoot && (this.svgRoot.style.display = "none");
        }
        isShownWhenCollapsed() {
          return !1;
        }
        setOffsetInBlock(e) {
          this.offsetInBlock = e, this.updateSvgRootOffset();
        }
        updateSvgRootOffset() {
          let e;
          (e = this.svgRoot) == null || e.setAttribute("transform", `translate(${this.offsetInBlock.x}, ${this.offsetInBlock.y})`);
        }
        onLocationChange(e) {
          this.workspaceLocation = ae.sum(e, this.offsetInBlock);
        }
        onClick() {
        }
        setVisible(e) {
          dr(
            "setVisible",
            "v10",
            "v11",
            "setBubbleVisible"
          ), Vi(this) && this.setBubbleVisible(e);
        }
      }, Xt = class {
        constructor(e, t, n, o, c) {
          this.workspace = e, this.horizontal = t, this.oldHostMetrics = null, this.ratio = 1, this.origin = new ae(0, 0), this.startDragHandle = this.handlePosition = this.handleLength = this.scrollbarLength = this.startDragMouse = 0, this.containerVisible = this.isHandleVisible = !0, this.position = new ae(0, 0), this.onMouseMoveWrapper_ = this.onMouseUpWrapper_ = null, this.pair = n || !1, this.margin = c !== void 0 ? c : Xt.DEFAULT_SCROLLBAR_MARGIN, e = "blocklyScrollbar" + (this.horizontal ? "Horizontal" : "Vertical"), o && (e += " " + o), this.outerSvg = K(U.SVG, { class: e }), o = K(U.G, {}, this.outerSvg), this.svgBackground = K(
            U.RECT,
            { class: "blocklyScrollbarBackground" },
            o
          ), e = Math.floor((Xt.scrollbarThickness - 5) / 2), this.svgHandle = K(U.RECT, { class: "blocklyScrollbarHandle", rx: e, ry: e }, o), this.workspace.getThemeManager().subscribe(this.svgHandle, "scrollbarColour", "fill"), this.workspace.getThemeManager().subscribe(this.svgHandle, "scrollbarOpacity", "fill-opacity"), Sr(
            this.outerSvg,
            this.workspace.getParentSvg()
          ), this.setInitialThickness(), t ? (this.lengthAttribute_ = "width", this.positionAttribute_ = "x") : (this.lengthAttribute_ = "height", this.positionAttribute_ = "y"), this.onMouseDownBarWrapper_ = Pe(this.svgBackground, "pointerdown", this, this.onMouseDownBar), this.onMouseDownHandleWrapper_ = Pe(this.svgHandle, "pointerdown", this, this.onMouseDownHandle);
        }
        setInitialThickness() {
          const e = Xt.scrollbarThickness;
          this.horizontal ? (this.svgBackground.setAttribute("height", String(e)), this.outerSvg.setAttribute("height", String(e)), this.svgHandle.setAttribute("height", String(e - 5)), this.svgHandle.setAttribute("y", "2.5")) : (this.svgBackground.setAttribute("width", String(e)), this.outerSvg.setAttribute("width", String(e)), this.svgHandle.setAttribute("width", String(e - 5)), this.svgHandle.setAttribute("x", "2.5"));
        }
        dispose() {
          this.cleanUp(), It(this.onMouseDownBarWrapper_), It(this.onMouseDownHandleWrapper_), Tt(this.outerSvg), this.workspace.getThemeManager().unsubscribe(this.svgHandle);
        }
        constrainHandleLength(e) {
          return e = 0 >= e || isNaN(e) ? 0 : Math.min(e, this.scrollbarLength);
        }
        setHandleLength(e) {
          this.handleLength = e, this.svgHandle.setAttribute(this.lengthAttribute_, String(this.handleLength));
        }
        constrainHandlePosition(e) {
          return e = 0 >= e || isNaN(e) ? 0 : Math.min(e, this.scrollbarLength - this.handleLength);
        }
        setHandlePosition(e) {
          this.handlePosition = e, this.svgHandle.setAttribute(
            this.positionAttribute_,
            String(this.handlePosition)
          );
        }
        setScrollbarLength(e) {
          this.scrollbarLength = e, this.outerSvg.setAttribute(this.lengthAttribute_, String(this.scrollbarLength)), this.svgBackground.setAttribute(this.lengthAttribute_, String(this.scrollbarLength));
        }
        setPosition(e, t) {
          this.position.x = e, this.position.y = t, C_(this.outerSvg, "translate(" + (this.position.x + this.origin.x) + "px," + (this.position.y + this.origin.y) + "px)");
        }
        resize(e) {
          !e && (e = this.workspace.getMetrics(), !e) || this.oldHostMetrics && Xt.metricsAreEquivalent(e, this.oldHostMetrics) || (this.horizontal ? this.resizeHorizontal(e) : this.resizeVertical(e), this.oldHostMetrics = e, this.updateMetrics());
        }
        requiresViewResize(e) {
          return this.oldHostMetrics ? this.oldHostMetrics.viewWidth !== e.viewWidth || this.oldHostMetrics.viewHeight !== e.viewHeight || this.oldHostMetrics.absoluteLeft !== e.absoluteLeft || this.oldHostMetrics.absoluteTop !== e.absoluteTop : !0;
        }
        resizeHorizontal(e) {
          this.requiresViewResize(e) ? this.resizeViewHorizontal(e) : this.resizeContentHorizontal(e);
        }
        resizeViewHorizontal(e) {
          var t = e.viewWidth - 2 * this.margin;
          this.pair && (t -= Xt.scrollbarThickness), this.setScrollbarLength(Math.max(0, t)), t = e.absoluteLeft + this.margin, this.pair && this.workspace.RTL && (t += Xt.scrollbarThickness), this.setPosition(t, e.absoluteTop + e.viewHeight - Xt.scrollbarThickness - this.margin), this.resizeContentHorizontal(e);
        }
        resizeContentHorizontal(e) {
          if (e.viewWidth >= e.scrollWidth)
            this.setHandleLength(this.scrollbarLength), this.setHandlePosition(0), this.pair || this.setVisible(!1);
          else {
            this.pair || this.setVisible(!0);
            var t = this.scrollbarLength * e.viewWidth / e.scrollWidth;
            t = this.constrainHandleLength(t), this.setHandleLength(t), t = e.scrollWidth - e.viewWidth;
            var n = this.scrollbarLength - this.handleLength;
            e = (e.viewLeft - e.scrollLeft) / t * n, e = this.constrainHandlePosition(e), this.setHandlePosition(e), this.ratio = n / t;
          }
        }
        resizeVertical(e) {
          this.requiresViewResize(e) ? this.resizeViewVertical(e) : this.resizeContentVertical(e);
        }
        resizeViewVertical(e) {
          let t = e.viewHeight - 2 * this.margin;
          this.pair && (t -= Xt.scrollbarThickness), this.setScrollbarLength(Math.max(0, t)), this.setPosition(this.workspace.RTL ? e.absoluteLeft + this.margin : e.absoluteLeft + e.viewWidth - Xt.scrollbarThickness - this.margin, e.absoluteTop + this.margin), this.resizeContentVertical(e);
        }
        resizeContentVertical(e) {
          if (e.viewHeight >= e.scrollHeight)
            this.setHandleLength(this.scrollbarLength), this.setHandlePosition(0), this.pair || this.setVisible(!1);
          else {
            this.pair || this.setVisible(!0);
            var t = this.scrollbarLength * e.viewHeight / e.scrollHeight;
            t = this.constrainHandleLength(t), this.setHandleLength(t), t = e.scrollHeight - e.viewHeight;
            var n = this.scrollbarLength - this.handleLength;
            e = (e.viewTop - e.scrollTop) / t * n, e = this.constrainHandlePosition(e), this.setHandlePosition(e), this.ratio = n / t;
          }
        }
        isVisible() {
          return this.isHandleVisible;
        }
        setContainerVisible(e) {
          const t = e !== this.containerVisible;
          this.containerVisible = e, t && this.updateDisplay_();
        }
        setVisible(e) {
          const t = e !== this.isVisible();
          if (this.pair)
            throw Error("Unable to toggle visibility of paired scrollbars.");
          this.isHandleVisible = e, t && this.updateDisplay_();
        }
        updateDisplay_() {
          this.containerVisible && this.isVisible() ? this.outerSvg.setAttribute("display", "block") : this.outerSvg.setAttribute("display", "none");
        }
        onMouseDownBar(e) {
          if (this.workspace.markFocused(), me(), this.cleanUp(), Ui(e))
            e.stopPropagation();
          else {
            var t = Oo(e, this.workspace.getParentSvg(), this.workspace.getInverseScreenCTM());
            t = this.horizontal ? t.x : t.y;
            var n = Ws(this.svgHandle);
            n = this.horizontal ? n.x : n.y;
            var o = this.handlePosition, c = 0.95 * this.handleLength;
            t <= n ? o -= c : t >= n + this.handleLength && (o += c), this.setHandlePosition(this.constrainHandlePosition(o)), this.updateMetrics(), e.stopPropagation(), e.preventDefault();
          }
        }
        onMouseDownHandle(e) {
          this.workspace.markFocused(), this.cleanUp(), Ui(e) ? e.stopPropagation() : (this.startDragHandle = this.handlePosition, this.startDragMouse = this.horizontal ? e.clientX : e.clientY, this.onMouseUpWrapper_ = Pe(document, "pointerup", this, this.onMouseUpHandle), this.onMouseMoveWrapper_ = Pe(document, "pointermove", this, this.onMouseMoveHandle), e.stopPropagation(), e.preventDefault());
        }
        onMouseMoveHandle(e) {
          this.setHandlePosition(this.constrainHandlePosition(this.startDragHandle + ((this.horizontal ? e.clientX : e.clientY) - this.startDragMouse))), this.updateMetrics();
        }
        onMouseUpHandle() {
          me(), this.cleanUp();
        }
        cleanUp() {
          this.workspace.hideChaff(!0), this.onMouseUpWrapper_ && (It(this.onMouseUpWrapper_), this.onMouseUpWrapper_ = null), this.onMouseMoveWrapper_ && (It(this.onMouseMoveWrapper_), this.onMouseMoveWrapper_ = null);
        }
        getRatio_() {
          let e = this.handlePosition / (this.scrollbarLength - this.handleLength);
          return isNaN(e) && (e = 0), e;
        }
        updateMetrics() {
          const e = this.getRatio_();
          this.horizontal ? this.workspace.setMetrics({ x: e }) : this.workspace.setMetrics({ y: e });
        }
        set(e, t) {
          this.setHandlePosition(this.constrainHandlePosition(e * this.ratio)), (t || t === void 0) && this.updateMetrics();
        }
        setOrigin(e, t) {
          this.origin = new ae(e, t);
        }
        static metricsAreEquivalent(e, t) {
          return e.viewWidth === t.viewWidth && e.viewHeight === t.viewHeight && e.viewLeft === t.viewLeft && e.viewTop === t.viewTop && e.absoluteTop === t.absoluteTop && e.absoluteLeft === t.absoluteLeft && e.scrollWidth === t.scrollWidth && e.scrollHeight === t.scrollHeight && e.scrollLeft === t.scrollLeft && e.scrollTop === t.scrollTop;
        }
      };
      Xt.scrollbarThickness = qa ? 25 : 15, Xt.DEFAULT_SCROLLBAR_MARGIN = 0.5;
      var Ec, Xe = class {
        constructor(e, t, n) {
          this.workspace = e, this.anchor = t, this.ownerRect = n, this.size = new ht(0, 0), this.colour = "#ffffff", this.disposed = !1, this.relativeLeft = this.relativeTop = 0, this.svgRoot = K(U.G, {}, e.getBubbleCanvas()), e = K(
            U.G,
            { filter: `url(#${this.workspace.getRenderer().getConstants().embossFilterId})` },
            this.svgRoot
          ), this.tail = K(U.PATH, {}, e), this.background = K(U.RECT, { class: "blocklyDraggable", x: 0, y: 0, rx: Xe.BORDER_WIDTH, ry: Xe.BORDER_WIDTH }, e), this.contentContainer = K(
            U.G,
            {},
            this.svgRoot
          ), Pe(this.background, "pointerdown", this, this.onMouseDown);
        }
        dispose() {
          Tt(this.svgRoot), this.disposed = !0;
        }
        setAnchorLocation(e, t = !1) {
          this.anchor = e, t ? this.positionByRect(this.ownerRect) : this.positionRelativeToAnchor(), this.renderTail();
        }
        setPositionRelativeToAnchor(e, t) {
          this.relativeLeft = e, this.relativeTop = t, this.positionRelativeToAnchor(), this.renderTail();
        }
        getSize() {
          return this.size;
        }
        setSize(e, t = !1) {
          e.width = Math.max(e.width, Xe.MIN_SIZE), e.height = Math.max(e.height, Xe.MIN_SIZE), this.size = e, this.background.setAttribute("width", `${e.width}`), this.background.setAttribute("height", `${e.height}`), t ? this.positionByRect(this.ownerRect) : this.positionRelativeToAnchor(), this.renderTail();
        }
        getColour() {
          return this.colour;
        }
        setColour(e) {
          this.colour = e, this.tail.setAttribute("fill", e), this.background.setAttribute("fill", e);
        }
        onMouseDown(e) {
          let t;
          (t = this.workspace.getGesture(e)) == null || t.handleBubbleStart(e, this);
        }
        positionRelativeToAnchor() {
          let e = this.anchor.x;
          e = this.workspace.RTL ? e - (this.relativeLeft + this.size.width) : e + this.relativeLeft, this.moveTo(e, this.relativeTop + this.anchor.y);
        }
        moveTo(e, t) {
          this.svgRoot.setAttribute("transform", `translate(${e}, ${t})`);
        }
        positionByRect(e = new Dt(0, 0, 0, 0)) {
          var t = this.workspace.getMetricsManager().getViewMetrics(!0), n = this.getOptimalRelativeLeft(t), o = this.getOptimalRelativeTop(t);
          const c = { x: n, y: -this.size.height - this.workspace.getRenderer().getConstants().MIN_BLOCK_HEIGHT }, A = { x: -this.size.width - 30, y: o };
          o = { x: e.getWidth(), y: o };
          var D = { x: n, y: e.getHeight() };
          n = e.getWidth() < e.getHeight() ? o : D, e = e.getWidth() < e.getHeight() ? D : o, o = this.getOverlap(c, t), D = this.getOverlap(A, t);
          const $ = this.getOverlap(n, t);
          t = this.getOverlap(e, t), t = Math.max(o, D, $, t), o === t ? (this.relativeLeft = c.x, this.relativeTop = c.y) : D === t ? (this.relativeLeft = A.x, this.relativeTop = A.y) : $ === t ? (this.relativeLeft = n.x, this.relativeTop = n.y) : (this.relativeLeft = e.x, this.relativeTop = e.y), this.positionRelativeToAnchor();
        }
        getOverlap(e, t) {
          var n = this.workspace.RTL ? this.anchor.x - e.x - this.size.width : e.x + this.anchor.x;
          return e = e.y + this.anchor.y, Math.max(0, Math.min(1, (Math.min(n + this.size.width, t.left + t.width) - Math.max(n, t.left)) * (Math.min(e + this.size.height, t.top + t.height) - Math.max(e, t.top)) / (this.size.width * this.size.height)));
        }
        getOptimalRelativeLeft(e) {
          let t = -this.size.width / 4;
          if (this.size.width > e.width)
            return t;
          if (e = this.getWorkspaceViewRect(e), this.workspace.RTL) {
            var n = this.anchor.x - t;
            n - this.size.width < e.left ? t = -(e.left - this.anchor.x + this.size.width) : n > e.right && (t = -(e.right - this.anchor.x));
          } else {
            n = t + this.anchor.x;
            const o = n + this.size.width;
            n < e.left ? t = e.left - this.anchor.x : o > e.right && (t = e.right - this.anchor.x - this.size.width);
          }
          return t;
        }
        getOptimalRelativeTop(e) {
          let t = -this.size.height / 4;
          if (this.size.height > e.height)
            return t;
          const n = this.anchor.y + t, o = n + this.size.height;
          return e = this.getWorkspaceViewRect(e), n < e.top ? t = e.top - this.anchor.y : o > e.bottom && (t = e.bottom - this.anchor.y - this.size.height), t;
        }
        getWorkspaceViewRect(e) {
          const t = e.top;
          let n = e.top + e.height, o = e.left;
          return e = e.left + e.width, n -= this.getScrollbarThickness(), this.workspace.RTL ? o -= this.getScrollbarThickness() : e -= this.getScrollbarThickness(), new Dt(t, n, o, e);
        }
        getScrollbarThickness() {
          return Xt.scrollbarThickness / this.workspace.scale;
        }
        renderTail() {
          const e = [];
          var t = this.size.width / 2, n = this.size.height / 2, o = -this.relativeLeft, c = -this.relativeTop;
          if (t === o && n === c)
            e.push("M " + t + "," + n);
          else {
            c -= n, o -= t, this.workspace.RTL && (o *= -1);
            var A = Math.sqrt(c * c + o * o), D = Math.acos(o / A);
            0 > c && (D = 2 * Math.PI - D);
            var $ = D + Math.PI / 2;
            $ > 2 * Math.PI && ($ -= 2 * Math.PI);
            var q = Math.sin($);
            const or = Math.cos($);
            let Ft = (this.size.width + this.size.height) / Xe.TAIL_THICKNESS;
            Ft = Math.min(Ft, this.size.width, this.size.height) / 4, $ = 1 - Xe.ANCHOR_RADIUS / A, o = t + $ * o, c = n + $ * c, $ = t + Ft * or;
            const n_ = n + Ft * q;
            t -= Ft * or, n -= Ft * q, q = Gi(this.workspace.RTL ? -Xe.TAIL_ANGLE : Xe.TAIL_ANGLE), q = D + q, q > 2 * Math.PI && (q -= 2 * Math.PI), D = Math.sin(q) * A / Xe.TAIL_BEND, A = Math.cos(q) * A / Xe.TAIL_BEND, e.push("M" + $ + "," + n_), e.push("C" + ($ + A) + "," + (n_ + D) + " " + o + "," + c + " " + o + "," + c), e.push("C" + o + "," + c + " " + (t + A) + "," + (n + D) + " " + t + "," + n);
          }
          e.push("z");
          let De;
          (De = this.tail) == null || De.setAttribute("d", e.join(" "));
        }
        bringToFront() {
          let e;
          const t = (e = this.svgRoot) == null ? void 0 : e.parentNode;
          return this.svgRoot && (t == null ? void 0 : t.lastChild) !== this.svgRoot ? (t == null || t.appendChild(this.svgRoot), !0) : !1;
        }
        getRelativeToSurfaceXY() {
          return new ae(this.workspace.RTL ? -this.relativeLeft + this.anchor.x - this.size.width : this.anchor.x + this.relativeLeft, this.anchor.y + this.relativeTop);
        }
        getSvgRoot() {
          return this.svgRoot;
        }
        moveDuringDrag(e) {
          this.moveTo(
            e.x,
            e.y
          ), this.relativeLeft = this.workspace.RTL ? this.anchor.x - e.x - this.size.width : e.x - this.anchor.x, this.relativeTop = e.y - this.anchor.y, this.renderTail();
        }
        setDragging(e) {
        }
        setDeleteStyle(e) {
        }
        isDeletable() {
          return !1;
        }
        showContextMenu(e) {
        }
      };
      Ec = Xe, Xe.BORDER_WIDTH = 6, Xe.DOUBLE_BORDER = 2 * Ec.BORDER_WIDTH, Xe.MIN_SIZE = Ec.DOUBLE_BORDER, Xe.TAIL_THICKNESS = 1, Xe.TAIL_ANGLE = 20, Xe.TAIL_BEND = 4, Xe.ANCHOR_RADIUS = 8;
      var ad = {};
      ad.deepMerge = Kn;
      var AT = class {
        constructor(e, t, n, o) {
          this.name = e, this.startHats = !1, this.blockStyles = t || /* @__PURE__ */ Object.create(null), this.categoryStyles = n || /* @__PURE__ */ Object.create(null), this.componentStyles = o || /* @__PURE__ */ Object.create(null), this.fontStyle = /* @__PURE__ */ Object.create(null), i(se.THEME, e, this, !0);
        }
        getClassName() {
          return this.name + "-theme";
        }
        setBlockStyle(e, t) {
          this.blockStyles[e] = t;
        }
        setCategoryStyle(e, t) {
          this.categoryStyles[e] = t;
        }
        getComponentStyle(e) {
          if (e = this.componentStyles[e], !e)
            return null;
          if (typeof e == "string") {
            const t = this.getComponentStyle(e);
            if (t)
              return t;
          }
          return `${e}`;
        }
        setComponentStyle(e, t) {
          this.componentStyles[e] = t;
        }
        setFontStyle(e) {
          this.fontStyle = e;
        }
        setStartHats(e) {
          this.startHats = e;
        }
        static defineTheme(e, t) {
          e = e.toLowerCase();
          const n = new AT(e);
          let o = t.base;
          if (o) {
            if (typeof o == "string") {
              let c;
              o = (c = y(se.THEME, o)) != null ? c : void 0;
            }
            o instanceof AT && (Kn(n, o), n.name = e);
          }
          return Kn(n.blockStyles, t.blockStyles), Kn(n.categoryStyles, t.categoryStyles), Kn(n.componentStyles, t.componentStyles), Kn(n.fontStyle, t.fontStyle), t.startHats !== null && (n.startHats = t.startHats), n;
        }
      }, FS = { colour_blocks: { colourPrimary: "20" }, list_blocks: { colourPrimary: "260" }, logic_blocks: { colourPrimary: "210" }, loop_blocks: { colourPrimary: "120" }, math_blocks: { colourPrimary: "230" }, procedure_blocks: { colourPrimary: "290" }, text_blocks: { colourPrimary: "160" }, variable_blocks: { colourPrimary: "330" }, variable_dynamic_blocks: { colourPrimary: "310" }, hat_blocks: { colourPrimary: "330", hat: "cap" } }, Ac = {
        colour_category: { colour: "20" },
        list_category: { colour: "260" },
        logic_category: { colour: "210" },
        loop_category: { colour: "120" },
        math_category: { colour: "230" },
        procedure_category: { colour: "290" },
        text_category: { colour: "160" },
        variable_category: { colour: "330" },
        variable_dynamic_category: { colour: "310" }
      }, dc = new AT("classic", FS, Ac), zu = "categoryToolbox", cd = "flyoutToolbox", Ue;
      (function(e) {
        e[e.TOP = 0] = "TOP", e[e.BOTTOM = 1] = "BOTTOM", e[e.LEFT = 2] = "LEFT", e[e.RIGHT = 3] = "RIGHT";
      })(Ue || (Ue = {}));
      var pd = { hasCategoriesInternal: Ai }, co = {};
      co.Position = Ue, co.TEST_ONLY = pd, co.convertFlyoutDefToJsonArray = Zs, co.convertToolboxDefToJson = ga, co.hasCategories = Uo, co.isCategoryCollapsible = Vo, co.parseToolboxTree = Na;
      var qn = class {
        constructor(e) {
          this.gridPattern = null, this.getMetrics = this.setMetrics = void 0;
          let t = null, n = !1;
          var o = !1, c = !1, A = !1, D = !1, $ = !1;
          const q = !!e.readOnly;
          if (!q) {
            var De;
            t = ga((De = e.toolbox) != null ? De : null), n = Uo(t), o = e.trashcan, o = o === void 0 ? n : o, c = e.collapse, c = c === void 0 ? n : c, A = e.comments, A = A === void 0 ? n : A, D = e.disable, D = D === void 0 ? n : D, $ = e.sounds, $ = $ === void 0 ? !0 : $;
          }
          De = e.maxTrashcanContents, o ? De === void 0 && (De = 32) : De = 0;
          const or = !!e.rtl;
          let Ft = e.horizontalLayout;
          Ft === void 0 && (Ft = !1);
          var n_ = e.toolboxPosition !== "end";
          n_ = Ft ? n_ ? Ue.TOP : Ue.BOTTOM : n_ === or ? Ue.RIGHT : Ue.LEFT;
          let Xc = e.css;
          Xc === void 0 && (Xc = !0);
          let Kc = "https://blockly-demo.appspot.com/static/media/";
          e.media ? Kc = e.media.endsWith("/") ? e.media : e.media + "/" : "path" in e && (dr("path", "Nov 2014", "Jul 2023", "media"), Kc = e.path + "media/");
          const e4 = e.oneBasedIndex, $M = e.renderer || "geras", WM = e.plugins || {};
          let zS = e.modalInputs;
          zS === void 0 && (zS = !0), this.RTL = or, this.oneBasedIndex = e4 === void 0 ? !0 : e4, this.collapse = c, this.comments = A, this.disable = D, this.readOnly = q, this.maxBlocks = e.maxBlocks || 1 / 0;
          let t4;
          this.maxInstances = (t4 = e.maxInstances) != null ? t4 : null, this.modalInputs = zS, this.pathToMedia = Kc, this.hasCategories = n, this.moveOptions = qn.parseMoveOptions_(
            e,
            n
          ), this.hasScrollbars = !!this.moveOptions.scrollbars, this.hasTrashcan = o, this.maxTrashcanContents = De, this.hasSounds = $, this.hasCss = Xc, this.horizontalLayout = Ft, this.languageTree = t, this.gridOptions = qn.parseGridOptions_(e), this.zoomOptions = qn.parseZoomOptions_(e), this.toolboxPosition = n_, this.theme = qn.parseThemeOptions_(e), this.renderer = $M;
          let r4;
          this.rendererOverrides = (r4 = e.rendererOverrides) != null ? r4 : null;
          let n4;
          this.parentWorkspace = (n4 = e.parentWorkspace) != null ? n4 : null, this.plugins = WM;
        }
        static parseMoveOptions_(e, t) {
          const n = e.move || {}, o = {};
          return n.scrollbars === void 0 && e.scrollbars === void 0 ? o.scrollbars = t : typeof n.scrollbars == "object" ? (o.scrollbars = { horizontal: !!n.scrollbars.horizontal, vertical: !!n.scrollbars.vertical }, o.scrollbars.horizontal && o.scrollbars.vertical ? o.scrollbars = !0 : o.scrollbars.horizontal || o.scrollbars.vertical || (o.scrollbars = !1)) : o.scrollbars = !!n.scrollbars || !!e.scrollbars, o.wheel = o.scrollbars && n.wheel !== void 0 ? !!n.wheel : typeof o.scrollbars == "object", o.drag = o.scrollbars ? n.drag === void 0 ? !0 : !!n.drag : !1, o;
        }
        static parseZoomOptions_(e) {
          e = e.zoom || {};
          const t = {};
          return t.controls = e.controls === void 0 ? !1 : !!e.controls, t.wheel = e.wheel === void 0 ? !1 : !!e.wheel, t.startScale = e.startScale === void 0 ? 1 : Number(e.startScale), t.maxScale = e.maxScale === void 0 ? 3 : Number(e.maxScale), t.minScale = e.minScale === void 0 ? 0.3 : Number(e.minScale), t.scaleSpeed = e.scaleSpeed === void 0 ? 1.2 : Number(e.scaleSpeed), t.pinch = e.pinch === void 0 ? t.wheel || t.controls : !!e.pinch, t;
        }
        static parseGridOptions_(e) {
          e = e.grid || {};
          const t = {};
          return t.spacing = Number(e.spacing) || 0, t.colour = e.colour || "#888", t.length = e.length === void 0 ? 1 : Number(e.length), t.snap = 0 < t.spacing && !!e.snap, t;
        }
        static parseThemeOptions_(e) {
          return e = e.theme || dc, typeof e == "string" ? y(se.THEME, e) : e instanceof AT ? e : AT.defineTheme(e.name || "builtin" + i_(), e);
        }
      }, Ci = class extends Xe {
        constructor(e, t, n, o) {
          super(t, n, o), this.workspace = t, this.anchor = n, this.ownerRect = o, this.autoLayout = !0, t = new qn(e), this.validateWorkspaceOptions(t), this.svgDialog = K(
            U.SVG,
            { x: Xe.BORDER_WIDTH, y: Xe.BORDER_WIDTH },
            this.contentContainer
          ), e.parentWorkspace = this.workspace, this.miniWorkspace = this.newWorkspaceSvg(new qn(e)), e = this.miniWorkspace.createDom("blocklyMutatorBackground"), this.svgDialog.appendChild(e), t.languageTree && (e.insertBefore(this.miniWorkspace.addFlyout(U.G), this.miniWorkspace.getCanvas()), e = this.miniWorkspace.getFlyout(), e == null || e.init(this.miniWorkspace), e == null || e.show(t.languageTree)), this.miniWorkspace.addChangeListener(this.onWorkspaceChange.bind(this));
          let c, A;
          (c = this.miniWorkspace.getFlyout()) == null || (A = c.getWorkspace()) == null || A.addChangeListener(this.onWorkspaceChange.bind(this)), this.updateBubbleSize();
        }
        dispose() {
          this.miniWorkspace.dispose(), super.dispose();
        }
        getWorkspace() {
          return this.miniWorkspace;
        }
        addWorkspaceChangeListener(e) {
          this.miniWorkspace.addChangeListener(e);
        }
        validateWorkspaceOptions(e) {
          if (e.hasCategories)
            throw Error("The miniworkspace bubble does not support toolboxes with categories");
          if (e.hasTrashcan)
            throw Error("The miniworkspace bubble does not support trashcans");
          if (e.zoomOptions.controls || e.zoomOptions.wheel || e.zoomOptions.pinch)
            throw Error("The miniworkspace bubble does not support zooming");
          if (e.moveOptions.scrollbars || e.moveOptions.wheel || e.moveOptions.drag)
            throw Error("The miniworkspace bubble does not scrolling/moving the workspace");
          if (e.horizontalLayout)
            throw Error("The miniworkspace bubble does not support horizontal layouts");
        }
        onWorkspaceChange() {
          this.bumpBlocksIntoBounds(), this.updateBubbleSize();
        }
        bumpBlocksIntoBounds() {
          if (!this.miniWorkspace.isDragging())
            for (const e of this.miniWorkspace.getTopBlocks(!1)) {
              const t = e.getRelativeToSurfaceXY();
              if (20 > t.y && e.moveBy(0, 20 - t.y), e.RTL) {
                let n = -20;
                const o = this.miniWorkspace.getFlyout();
                o && (n -= o.getWidth()), t.x > n && e.moveBy(n - t.x, 0);
              } else
                20 > t.x && e.moveBy(20 - t.x, 0);
            }
        }
        updateBubbleSize() {
          if (!this.miniWorkspace.isDragging()) {
            var e = this.getSize(), t = this.calculateWorkspaceSize();
            Math.abs(e.width - t.width) < Ci.MINIMUM_VIEW_CHANGE && Math.abs(e.height - t.height) < Ci.MINIMUM_VIEW_CHANGE || (this.svgDialog.setAttribute("width", `${t.width}px`), this.svgDialog.setAttribute("height", `${t.height}px`), this.miniWorkspace.setCachedParentSvgSize(t.width, t.height), this.miniWorkspace.RTL && this.miniWorkspace.getCanvas().setAttribute("transform", `translate(${t.width}, 0)`), this.setSize(new ht(t.width + Xe.DOUBLE_BORDER, t.height + Xe.DOUBLE_BORDER), this.autoLayout), this.miniWorkspace.resize(), this.miniWorkspace.recordDragTargets());
          }
        }
        calculateWorkspaceSize() {
          const e = this.miniWorkspace.getCanvas().getBBox();
          let t = e.width + e.x, n = e.height + Ci.MARGIN;
          const o = this.miniWorkspace.getFlyout();
          if (o) {
            const c = o.getWorkspace().getMetricsManager().getScrollMetrics();
            n = Math.max(n, c.height + 20), t += o.getWidth();
          }
          return this.miniWorkspace.RTL && (t = -e.x), t += Ci.MARGIN, new ht(
            t,
            n
          );
        }
        updateBlockStyles() {
          for (var e of this.miniWorkspace.getAllBlocks(!1))
            e.setStyle(e.getStyleName());
          let t;
          if (e = (t = this.miniWorkspace.getFlyout()) == null ? void 0 : t.getWorkspace())
            for (const n of e.getAllBlocks(!1))
              n.setStyle(n.getStyleName());
        }
        moveDuringDrag(e) {
          super.moveDuringDrag(e), this.autoLayout = !1;
        }
        moveTo(e, t) {
          super.moveTo(e, t), this.miniWorkspace.recordDragTargets();
        }
        newWorkspaceSvg(e) {
          throw Error("The implementation of newWorkspaceSvg should be monkey-patched in by blockly.ts");
        }
      };
      Ci.MINIMUM_VIEW_CHANGE = 10, Ci.MARGIN = 3 * Xe.DOUBLE_BORDER;
      var Sc, hc;
      Sc = 17, hc = 16, r.MutatorIcon$$module$build$src$core$icons$mutator_icon = class extends uc {
        constructor(e, t) {
          super(t), this.flyoutBlockTypes = e, this.sourceBlock = t, this.updateWorkspacePid = this.rootBlock = this.miniWorkspaceBubble = null;
        }
        getType() {
          return r.MutatorIcon$$module$build$src$core$icons$mutator_icon.TYPE;
        }
        initView(e) {
          this.svgRoot || (super.initView(e), K(U.RECT, {
            class: "blocklyIconShape",
            rx: "4",
            ry: "4",
            height: "16",
            width: "16"
          }, this.svgRoot), K(
            U.PATH,
            { class: "blocklyIconSymbol", d: "m4.203,7.296 0,1.368 -0.92,0.677 -0.11,0.41 0.9,1.559 0.41,0.11 1.043,-0.457 1.187,0.683 0.127,1.134 0.3,0.3 1.8,0 0.3,-0.299 0.127,-1.138 1.185,-0.682 1.046,0.458 0.409,-0.11 0.9,-1.559 -0.11,-0.41 -0.92,-0.677 0,-1.366 0.92,-0.677 0.11,-0.41 -0.9,-1.559 -0.409,-0.109 -1.046,0.458 -1.185,-0.682 -0.127,-1.138 -0.3,-0.299 -1.8,0 -0.3,0.3 -0.126,1.135 -1.187,0.682 -1.043,-0.457 -0.41,0.11 -0.899,1.559 0.108,0.409z" },
            this.svgRoot
          ), K(U.CIRCLE, { class: "blocklyIconShape", r: "2.7", cx: "8", cy: "8" }, this.svgRoot));
        }
        dispose() {
          super.dispose();
          let e;
          (e = this.miniWorkspaceBubble) == null || e.dispose();
        }
        getWeight() {
          return r.MutatorIcon$$module$build$src$core$icons$mutator_icon.WEIGHT;
        }
        getSize() {
          return new ht(Sc, Sc);
        }
        applyColour() {
          super.applyColour();
          let e;
          (e = this.miniWorkspaceBubble) == null || e.setColour(this.sourceBlock.style.colourPrimary);
          let t;
          (t = this.miniWorkspaceBubble) == null || t.updateBlockStyles();
        }
        updateCollapsed() {
          super.updateCollapsed(), this.sourceBlock.isCollapsed() && this.setBubbleVisible(!1);
        }
        onLocationChange(e) {
          super.onLocationChange(e);
          let t;
          (t = this.miniWorkspaceBubble) == null || t.setAnchorLocation(this.getAnchorLocation());
        }
        onClick() {
          super.onClick(), this.setBubbleVisible(!this.bubbleIsVisible());
        }
        bubbleIsVisible() {
          return !!this.miniWorkspaceBubble;
        }
        setBubbleVisible(e) {
          if (this.bubbleIsVisible() !== e) {
            if (e) {
              this.miniWorkspaceBubble = new Ci(this.getMiniWorkspaceConfig(), this.sourceBlock.workspace, this.getAnchorLocation(), this.getBubbleOwnerRect()), this.applyColour(), this.createRootBlock(), this.addSaveConnectionsListener();
              let t;
              (t = this.miniWorkspaceBubble) == null || t.addWorkspaceChangeListener(this.createMiniWorkspaceChangeListener());
            } else {
              let t;
              (t = this.miniWorkspaceBubble) == null || t.dispose(), this.miniWorkspaceBubble = null;
            }
            fe(new (ge(A_))(
              this.sourceBlock,
              e,
              "mutator"
            ));
          }
        }
        getMiniWorkspaceConfig() {
          let e;
          const t = { disable: !1, media: this.sourceBlock.workspace.options.pathToMedia, rtl: this.sourceBlock.RTL, renderer: this.sourceBlock.workspace.options.renderer, rendererOverrides: (e = this.sourceBlock.workspace.options.rendererOverrides) != null ? e : void 0 };
          return this.flyoutBlockTypes.length && (t.toolbox = { kind: "flyoutToolbox", contents: this.flyoutBlockTypes.map((n) => ({ kind: "block", type: n })) }), t;
        }
        getAnchorLocation() {
          const e = Sc / 2;
          return ae.sum(this.workspaceLocation, new ae(e, e));
        }
        getBubbleOwnerRect() {
          const e = this.sourceBlock.getSvgRoot().getBBox();
          return new Dt(e.y, e.y + e.height, e.x, e.x + e.width);
        }
        createRootBlock() {
          this.rootBlock = this.sourceBlock.decompose(this.miniWorkspaceBubble.getWorkspace());
          for (var e of this.rootBlock.getDescendants(!1))
            e.queueRender();
          this.rootBlock.setMovable(!1), this.rootBlock.setDeletable(!1);
          let t, n, o, c;
          e = (c = (t = this.miniWorkspaceBubble) == null || (n = t.getWorkspace()) == null || (o = n.getFlyout()) == null ? void 0 : o.getWidth()) != null ? c : 0, this.rootBlock.moveBy(this.rootBlock.RTL ? -(e + hc) : hc, hc);
        }
        addSaveConnectionsListener() {
          if (this.sourceBlock.saveConnections && this.rootBlock) {
            var e = () => {
              this.sourceBlock.saveConnections && this.rootBlock && this.sourceBlock.saveConnections(this.rootBlock);
            };
            e(), this.sourceBlock.workspace.addChangeListener(e);
          }
        }
        createMiniWorkspaceChangeListener() {
          return (e) => {
            r.MutatorIcon$$module$build$src$core$icons$mutator_icon.isIgnorableMutatorEvent(e) || this.updateWorkspacePid || (this.updateWorkspacePid = setTimeout(() => {
              this.updateWorkspacePid = null, this.recomposeSourceBlock();
            }, 0));
          };
        }
        static isIgnorableMutatorEvent(e) {
          return e.isUiEvent || e.type === r.CREATE$$module$build$src$core$events$utils || e.type === r.CHANGE$$module$build$src$core$events$utils && e.element === "disabled";
        }
        recomposeSourceBlock() {
          if (this.rootBlock) {
            var e = r.getGroup$$module$build$src$core$events$utils();
            e || r.setGroup$$module$build$src$core$events$utils(!0);
            var t = lo.getExtraBlockState_(this.sourceBlock);
            this.sourceBlock.compose(this.rootBlock);
            var n = lo.getExtraBlockState_(this.sourceBlock);
            t !== n && fe(new (ge(r.CHANGE$$module$build$src$core$events$utils))(
              this.sourceBlock,
              "mutation",
              null,
              t,
              n
            )), r.setGroup$$module$build$src$core$events$utils(e);
          }
        }
        getWorkspace() {
          let e;
          return (e = this.miniWorkspaceBubble) == null ? void 0 : e.getWorkspace();
        }
        static reconnect(e, t, n) {
          return dr("MutatorIcon.reconnect", "v10", "v11", "connection.reconnect"), e ? e.reconnect(t, n) : !1;
        }
        static findParentWs(e) {
          return dr("MutatorIcon.findParentWs", "v10", "v11", "workspace.getRootWorkspace"), e.getRootWorkspace();
        }
      }, r.MutatorIcon$$module$build$src$core$icons$mutator_icon.TYPE = mr.MUTATOR, r.MutatorIcon$$module$build$src$core$icons$mutator_icon.WEIGHT = 1, r.MutatorIcon$$module$build$src$core$icons$mutator_icon;
      var Es = /* @__PURE__ */ Object.create(null), Ic = { allExtensions: Es };
      r.register$$module$build$src$core$extensions("parent_tooltip_when_inline", DA);
      var e_ = {};
      e_.TEST_ONLY = Ic, e_.apply = xi, e_.buildTooltipForDropdown = r.buildTooltipForDropdown$$module$build$src$core$extensions, e_.buildTooltipWithFieldText = r.buildTooltipWithFieldText$$module$build$src$core$extensions, e_.isRegistered = ba, e_.register = r.register$$module$build$src$core$extensions, e_.registerMixin = r.registerMixin$$module$build$src$core$extensions, e_.registerMutator = r.registerMutator$$module$build$src$core$extensions, e_.runAfterPageLoad = Ra, e_.unregister = Qs, function(e) {
        e[e.LEFT = -1] = "LEFT", e[e.CENTRE = 0] = "CENTRE", e[e.RIGHT = 1] = "RIGHT";
      }(r.Align$$module$build$src$core$inputs$align || (r.Align$$module$build$src$core$inputs$align = {})), r.Align$$module$build$src$core$inputs$align;
      var Zu = {};
      Zu.removeElem = cn;
      var je;
      (function(e) {
        e[e.WIN_KEY_FF_LINUX = 0] = "WIN_KEY_FF_LINUX", e[e.MAC_ENTER = 3] = "MAC_ENTER", e[e.BACKSPACE = 8] = "BACKSPACE", e[e.TAB = 9] = "TAB", e[e.NUM_CENTER = 12] = "NUM_CENTER", e[e.ENTER = 13] = "ENTER", e[e.SHIFT = 16] = "SHIFT", e[e.CTRL = 17] = "CTRL", e[e.ALT = 18] = "ALT", e[e.PAUSE = 19] = "PAUSE", e[e.CAPS_LOCK = 20] = "CAPS_LOCK", e[e.ESC = 27] = "ESC", e[e.SPACE = 32] = "SPACE", e[e.PAGE_UP = 33] = "PAGE_UP", e[e.PAGE_DOWN = 34] = "PAGE_DOWN", e[e.END = 35] = "END", e[e.HOME = 36] = "HOME", e[e.LEFT = 37] = "LEFT", e[e.UP = 38] = "UP", e[e.RIGHT = 39] = "RIGHT", e[e.DOWN = 40] = "DOWN", e[e.PLUS_SIGN = 43] = "PLUS_SIGN", e[e.PRINT_SCREEN = 44] = "PRINT_SCREEN", e[e.INSERT = 45] = "INSERT", e[e.DELETE = 46] = "DELETE", e[e.ZERO = 48] = "ZERO", e[e.ONE = 49] = "ONE", e[e.TWO = 50] = "TWO", e[e.THREE = 51] = "THREE", e[e.FOUR = 52] = "FOUR", e[e.FIVE = 53] = "FIVE", e[e.SIX = 54] = "SIX", e[e.SEVEN = 55] = "SEVEN", e[e.EIGHT = 56] = "EIGHT", e[e.NINE = 57] = "NINE", e[e.FF_SEMICOLON = 59] = "FF_SEMICOLON", e[e.FF_EQUALS = 61] = "FF_EQUALS", e[e.FF_DASH = 173] = "FF_DASH", e[e.FF_HASH = 163] = "FF_HASH", e[e.QUESTION_MARK = 63] = "QUESTION_MARK", e[e.AT_SIGN = 64] = "AT_SIGN", e[e.A = 65] = "A", e[e.B = 66] = "B", e[e.C = 67] = "C", e[e.D = 68] = "D", e[e.E = 69] = "E", e[e.F = 70] = "F", e[e.G = 71] = "G", e[e.H = 72] = "H", e[e.I = 73] = "I", e[e.J = 74] = "J", e[e.K = 75] = "K", e[e.L = 76] = "L", e[e.M = 77] = "M", e[e.N = 78] = "N", e[e.O = 79] = "O", e[e.P = 80] = "P", e[e.Q = 81] = "Q", e[e.R = 82] = "R", e[e.S = 83] = "S", e[e.T = 84] = "T", e[e.U = 85] = "U", e[e.V = 86] = "V", e[e.W = 87] = "W", e[e.X = 88] = "X", e[e.Y = 89] = "Y", e[e.Z = 90] = "Z", e[e.META = 91] = "META", e[e.WIN_KEY_RIGHT = 92] = "WIN_KEY_RIGHT", e[e.CONTEXT_MENU = 93] = "CONTEXT_MENU", e[e.NUM_ZERO = 96] = "NUM_ZERO", e[e.NUM_ONE = 97] = "NUM_ONE", e[e.NUM_TWO = 98] = "NUM_TWO", e[e.NUM_THREE = 99] = "NUM_THREE", e[e.NUM_FOUR = 100] = "NUM_FOUR", e[e.NUM_FIVE = 101] = "NUM_FIVE", e[e.NUM_SIX = 102] = "NUM_SIX", e[e.NUM_SEVEN = 103] = "NUM_SEVEN", e[e.NUM_EIGHT = 104] = "NUM_EIGHT", e[e.NUM_NINE = 105] = "NUM_NINE", e[e.NUM_MULTIPLY = 106] = "NUM_MULTIPLY", e[e.NUM_PLUS = 107] = "NUM_PLUS", e[e.NUM_MINUS = 109] = "NUM_MINUS", e[e.NUM_PERIOD = 110] = "NUM_PERIOD", e[e.NUM_DIVISION = 111] = "NUM_DIVISION", e[e.F1 = 112] = "F1", e[e.F2 = 113] = "F2", e[e.F3 = 114] = "F3", e[e.F4 = 115] = "F4", e[e.F5 = 116] = "F5", e[e.F6 = 117] = "F6", e[e.F7 = 118] = "F7", e[e.F8 = 119] = "F8", e[e.F9 = 120] = "F9", e[e.F10 = 121] = "F10", e[e.F11 = 122] = "F11", e[e.F12 = 123] = "F12", e[e.NUMLOCK = 144] = "NUMLOCK", e[e.SCROLL_LOCK = 145] = "SCROLL_LOCK", e[e.FIRST_MEDIA_KEY = 166] = "FIRST_MEDIA_KEY", e[e.LAST_MEDIA_KEY = 183] = "LAST_MEDIA_KEY", e[e.SEMICOLON = 186] = "SEMICOLON", e[e.DASH = 189] = "DASH", e[e.EQUALS = 187] = "EQUALS", e[e.COMMA = 188] = "COMMA", e[e.PERIOD = 190] = "PERIOD", e[e.SLASH = 191] = "SLASH", e[e.APOSTROPHE = 192] = "APOSTROPHE", e[e.TILDE = 192] = "TILDE", e[e.SINGLE_QUOTE = 222] = "SINGLE_QUOTE", e[e.OPEN_SQUARE_BRACKET = 219] = "OPEN_SQUARE_BRACKET", e[e.BACKSLASH = 220] = "BACKSLASH", e[e.CLOSE_SQUARE_BRACKET = 221] = "CLOSE_SQUARE_BRACKET", e[e.WIN_KEY = 224] = "WIN_KEY", e[e.MAC_FF_META = 224] = "MAC_FF_META", e[e.MAC_WK_CMD_LEFT = 91] = "MAC_WK_CMD_LEFT", e[e.MAC_WK_CMD_RIGHT = 93] = "MAC_WK_CMD_RIGHT", e[e.WIN_IME = 229] = "WIN_IME", e[e.VK_NONAME = 252] = "VK_NONAME", e[e.PHANTOM = 255] = "PHANTOM";
      })(je || (je = {}));
      var h_ = {};
      h_.arc = kt, h_.curve = mt, h_.line = xT, h_.lineOnAxis = de, h_.lineTo = p_, h_.moveBy = Wt, h_.moveTo = Or, h_.point = Ee;
      var Bt = {};
      Bt.Coordinate = ae, Bt.KeyCodes = je, Bt.Rect = Dt, Bt.Size = ht, Bt.Svg = U, Bt.aria = Rl, Bt.array = Zu, Bt.browserEvents = gi, Bt.colour = Yr, Bt.deprecation = rT, Bt.dom = lr, Bt.extensions = e_, Bt.idGenerator = zr, Bt.math = lc, Bt.object = ad, Bt.parsing = Cl, Bt.string = pT, Bt.style = fi, Bt.svgMath = Ni, Bt.svgPaths = h_, Bt.toolbox = co, Bt.userAgent = Li, Bt.xml = Y_;
      var Mc = {};
      Mc.register = el, Mc.unregister = xo;
      var mc = class extends Xe {
        constructor(e, t, n, o) {
          super(t, n, o), this.text = e, this.workspace = t, this.anchor = n, this.ownerRect = o, this.paragraph = this.stringToSvg(e, this.contentContainer), this.updateBubbleSize();
        }
        getText() {
          return this.text;
        }
        setText(e) {
          this.text = e, Tt(this.paragraph), this.paragraph = this.stringToSvg(e, this.contentContainer), this.updateBubbleSize();
        }
        stringToSvg(e, t) {
          return t = this.createParagraph(t), e = this.createSpans(t, e), this.workspace.RTL && this.rightAlignSpans(t.getBBox().width, e), t;
        }
        createParagraph(e) {
          return K(U.TEXT, { class: "blocklyText blocklyBubbleText blocklyNoPointerEvents", y: Xe.BORDER_WIDTH }, e);
        }
        createSpans(e, t) {
          return t.split(`
`).map((n) => {
            const o = K(
              U.TSPAN,
              { dy: "1em", x: Xe.BORDER_WIDTH },
              e
            );
            return n = document.createTextNode(n), o.appendChild(n), o;
          });
        }
        rightAlignSpans(e, t) {
          for (const n of t)
            n.setAttribute("text-anchor", "end"), n.setAttribute("x", `${e + Xe.BORDER_WIDTH}`);
        }
        updateBubbleSize() {
          const e = this.paragraph.getBBox();
          this.setSize(
            new ht(e.width + 2 * Xe.BORDER_WIDTH, e.height + 2 * Xe.BORDER_WIDTH),
            !0
          );
        }
      }, Qu = class extends Xe {
        constructor(e, t, n) {
          super(e, t, n), this.workspace = e, this.anchor = t, this.ownerRect = n, this.resizePointerMoveListener = this.resizePointerUpListener = null, this.textChangeListeners = [], this.sizeChangeListeners = [], this.text = "", this.DEFAULT_SIZE = new ht(160 + Xe.DOUBLE_BORDER, 80 + Xe.DOUBLE_BORDER), this.MIN_SIZE = new ht(45 + Xe.DOUBLE_BORDER, 20 + Xe.DOUBLE_BORDER), { inputRoot: this.inputRoot, textArea: this.textArea } = this.createEditor(this.contentContainer), this.resizeGroup = this.createResizeHandle(this.svgRoot), this.setSize(this.DEFAULT_SIZE, !0);
        }
        getText() {
          return this.text;
        }
        setText(e) {
          this.text = e, this.textArea.value = e, this.onTextChange();
        }
        addTextChangeListener(e) {
          this.textChangeListeners.push(e);
        }
        addSizeChangeListener(e) {
          this.sizeChangeListeners.push(e);
        }
        createEditor(e) {
          e = K(U.FOREIGNOBJECT, { x: Xe.BORDER_WIDTH, y: Xe.BORDER_WIDTH }, e);
          const t = document.createElementNS(Pi, "body");
          t.setAttribute("xmlns", Pi), t.className = "blocklyMinimalBody";
          const n = document.createElementNS(Pi, "textarea");
          return n.className = "blocklyCommentTextarea", n.setAttribute("dir", this.workspace.RTL ? "RTL" : "LTR"), t.appendChild(n), e.appendChild(t), this.bindTextAreaEvents(n), setTimeout(() => {
            n.focus();
          }, 0), { inputRoot: e, textArea: n };
        }
        bindTextAreaEvents(e) {
          Pe(e, "wheel", this, (t) => {
            t.stopPropagation();
          }), Pe(e, "focus", this, this.onStartEdit, !0), Pe(e, "change", this, this.onTextChange);
        }
        createResizeHandle(e) {
          e = K(U.G, { class: this.workspace.RTL ? "blocklyResizeSW" : "blocklyResizeSE" }, e);
          const t = 2 * Xe.BORDER_WIDTH;
          return K(U.POLYGON, { points: `0,${t} ${t},${t} ${t},0` }, e), K(U.LINE, { class: "blocklyResizeLine", x1: t / 3, y1: t - 1, x2: t - 1, y2: t / 3 }, e), K(U.LINE, { class: "blocklyResizeLine", x1: 2 * t / 3, y1: t - 1, x2: t - 1, y2: 2 * t / 3 }, e), Pe(e, "pointerdown", this, this.onResizePointerDown), e;
        }
        setSize(e, t = !1) {
          e.width = Math.max(e.width, this.MIN_SIZE.width), e.height = Math.max(e.height, this.MIN_SIZE.height);
          const n = e.width - Xe.DOUBLE_BORDER, o = e.height - Xe.DOUBLE_BORDER;
          this.inputRoot.setAttribute("width", `${n}`), this.inputRoot.setAttribute("height", `${o}`), this.textArea.style.width = `${n - 4}px`, this.textArea.style.height = `${o - 4}px`, this.workspace.RTL ? this.resizeGroup.setAttribute("transform", `translate(${Xe.DOUBLE_BORDER}, ${o}) scale(-1 1)`) : this.resizeGroup.setAttribute("transform", `translate(${n}, ${o})`), super.setSize(e, t), this.onSizeChange();
        }
        getSize() {
          return super.getSize();
        }
        onResizePointerDown(e) {
          this.bringToFront(), Ui(e) || (this.workspace.startDrag(e, new ae(this.workspace.RTL ? -this.getSize().width : this.getSize().width, this.getSize().height)), this.resizePointerUpListener = Pe(document, "pointerup", this, this.onResizePointerUp), this.resizePointerMoveListener = Pe(document, "pointermove", this, this.onResizePointerMove), this.workspace.hideChaff()), e.stopPropagation();
        }
        onResizePointerUp(e) {
          me(), this.resizePointerUpListener && (It(this.resizePointerUpListener), this.resizePointerUpListener = null), this.resizePointerMoveListener && (It(this.resizePointerMoveListener), this.resizePointerMoveListener = null);
        }
        onResizePointerMove(e) {
          e = this.workspace.moveDrag(e), this.setSize(new ht(this.workspace.RTL ? -e.x : e.x, e.y), !1), this.onSizeChange();
        }
        onStartEdit() {
          this.bringToFront() && this.textArea.focus();
        }
        onTextChange() {
          this.text = this.textArea.value;
          for (const e of this.textChangeListeners)
            e();
        }
        onSizeChange() {
          for (const e of this.sizeChangeListeners)
            e();
        }
      };
      xn(`
.blocklyCommentTextarea {
  background-color: #fef49c;
  border: 0;
  display: block;
  margin: 0;
  outline: 0;
  padding: 3px;
  resize: none;
  text-overflow: hidden;
}
`);
      var qu = 17, ud = 160, Ed = 80, br = class extends uc {
        constructor(e) {
          super(e), this.sourceBlock = e, this.textBubble = this.textInputBubble = null, this.text = "", this.bubbleSize = new ht(
            ud,
            Ed
          ), this.bubbleVisiblity = !1;
        }
        getType() {
          return br.TYPE;
        }
        initView(e) {
          this.svgRoot || (super.initView(e), K(U.CIRCLE, { class: "blocklyIconShape", r: "8", cx: "8", cy: "8" }, this.svgRoot), K(
            U.PATH,
            { class: "blocklyIconSymbol", d: "m6.8,10h2c0.003,-0.617 0.271,-0.962 0.633,-1.266 2.875,-2.4050.607,-5.534 -3.765,-3.874v1.7c3.12,-1.657 3.698,0.118 2.336,1.25-1.201,0.998 -1.201,1.528 -1.204,2.19z" },
            this.svgRoot
          ), K(U.RECT, { class: "blocklyIconSymbol", x: "6.8", y: "10.78", height: "2", width: "2" }, this.svgRoot));
        }
        dispose() {
          super.dispose();
          let e;
          (e = this.textInputBubble) == null || e.dispose();
          let t;
          (t = this.textBubble) == null || t.dispose();
        }
        getWeight() {
          return br.WEIGHT;
        }
        getSize() {
          return new ht(qu, qu);
        }
        applyColour() {
          super.applyColour();
          const e = this.sourceBlock.style.colourPrimary;
          let t;
          (t = this.textInputBubble) == null || t.setColour(e);
          let n;
          (n = this.textBubble) == null || n.setColour(e);
        }
        updateEditable() {
          super.updateEditable(), this.bubbleIsVisible() && (this.setBubbleVisible(!1), this.setBubbleVisible(!0));
        }
        onLocationChange(e) {
          super.onLocationChange(e), e = this.getAnchorLocation();
          let t;
          (t = this.textInputBubble) == null || t.setAnchorLocation(e);
          let n;
          (n = this.textBubble) == null || n.setAnchorLocation(e);
        }
        setText(e) {
          this.text = e;
          let t;
          (t = this.textInputBubble) == null || t.setText(this.text);
          let n;
          (n = this.textBubble) == null || n.setText(this.text);
        }
        getText() {
          return this.text;
        }
        setBubbleSize(e) {
          this.bubbleSize = e;
          let t;
          (t = this.textInputBubble) == null || t.setSize(this.bubbleSize, !0);
        }
        getBubbleSize() {
          return this.bubbleSize;
        }
        saveState() {
          return this.text ? { text: this.text, pinned: this.bubbleIsVisible(), height: this.bubbleSize.height, width: this.bubbleSize.width } : null;
        }
        loadState(e) {
          let t;
          this.text = (t = e.text) != null ? t : "";
          let n, o;
          this.bubbleSize = new ht((n = e.width) != null ? n : ud, (o = e.height) != null ? o : Ed);
          let c;
          this.bubbleVisiblity = (c = e.pinned) != null ? c : !1, setTimeout(() => this.setBubbleVisible(this.bubbleVisiblity), 1);
        }
        onClick() {
          super.onClick(), this.setBubbleVisible(!this.bubbleIsVisible());
        }
        onTextChange() {
          this.textInputBubble && (this.text = this.textInputBubble.getText());
        }
        onSizeChange() {
          this.textInputBubble && (this.bubbleSize = this.textInputBubble.getSize());
        }
        bubbleIsVisible() {
          return this.bubbleVisiblity;
        }
        setBubbleVisible(e) {
          (!e || !this.textBubble && !this.textInputBubble) && (e || this.textBubble || this.textInputBubble) && (this.bubbleVisiblity = e, this.sourceBlock.rendered && !this.sourceBlock.isInFlyout && (e ? (this.sourceBlock.isEditable() ? this.showEditableBubble() : this.showNonEditableBubble(), this.applyColour()) : this.hideBubble(), fe(new (ge(A_))(this.sourceBlock, e, "comment"))));
        }
        showEditableBubble() {
          this.textInputBubble = new Qu(this.sourceBlock.workspace, this.getAnchorLocation(), this.getBubbleOwnerRect()), this.textInputBubble.setText(this.getText()), this.textInputBubble.setSize(this.bubbleSize, !0), this.textInputBubble.addTextChangeListener(() => this.onTextChange()), this.textInputBubble.addSizeChangeListener(() => this.onSizeChange());
        }
        showNonEditableBubble() {
          this.textBubble = new mc(
            this.getText(),
            this.sourceBlock.workspace,
            this.getAnchorLocation(),
            this.getBubbleOwnerRect()
          );
        }
        hideBubble() {
          let e;
          (e = this.textInputBubble) == null || e.dispose(), this.textInputBubble = null;
          let t;
          (t = this.textBubble) == null || t.dispose(), this.textBubble = null;
        }
        getAnchorLocation() {
          const e = qu / 2;
          return ae.sum(this.workspaceLocation, new ae(e, e));
        }
        getBubbleOwnerRect() {
          const e = this.sourceBlock.getSvgRoot().getBBox();
          return new Dt(
            e.y,
            e.y + e.height,
            e.x,
            e.x + e.width
          );
        }
      };
      br.TYPE = mr.COMMENT, br.WEIGHT = 3, el(br.TYPE, br);
      var K_ = class extends _t {
        constructor(e, t, n) {
          super(_t.SKIP_SETUP), this.class = null, this.EDITABLE = !1, this.maxDisplayLength = 1 / 0, e !== _t.SKIP_SETUP && (n ? this.configure_(n) : this.class = t || null, this.setValue(e));
        }
        configure_(e) {
          super.configure_(e), e.class && (this.class = e.class);
        }
        initView() {
          this.createTextElement_(), this.class && be(
            this.getTextElement(),
            this.class
          );
        }
        doClassValidation_(e) {
          return e == null ? null : `${e}`;
        }
        setClass(e) {
          this.textElement_ && (this.class && Be(this.textElement_, this.class), e && be(this.textElement_, e)), this.class = e;
        }
        static fromJson(e) {
          return new this(xt(e.text), void 0, e);
        }
      };
      Br("field_label", K_), K_.prototype.DEFAULT_VALUE = "";
      var Oi = class {
        constructor(e, t) {
          this.name = e, this.sourceBlock = t, this.fieldRow = [], this.align = r.Align$$module$build$src$core$inputs$input.LEFT, this.visible = !0, this.type = r.inputTypes$$module$build$src$core$inputs$input_types.CUSTOM, this.connection = null;
        }
        getSourceBlock() {
          return this.sourceBlock;
        }
        appendField(e, t) {
          return this.insertFieldAt(this.fieldRow.length, e, t), this;
        }
        insertFieldAt(e, t, n) {
          if (0 > e || e > this.fieldRow.length)
            throw Error("index " + e + " out of bounds.");
          return (t || t === "" && n) && (typeof t == "string" && (t = r.fromJson$$module$build$src$core$field_registry({ type: "field_label", text: t })), t.setSourceBlock(this.sourceBlock), this.sourceBlock.rendered && (t.init(), t.applyColour()), t.name = n, t.setVisible(this.isVisible()), t.prefixField && (e = this.insertFieldAt(e, t.prefixField)), this.fieldRow.splice(e, 0, t), e++, t.suffixField && (e = this.insertFieldAt(e, t.suffixField)), this.sourceBlock.rendered && (this.sourceBlock.queueRender(), this.sourceBlock.bumpNeighbours())), e;
        }
        removeField(e, t) {
          for (let n = 0, o; o = this.fieldRow[n]; n++)
            if (o.name === e)
              return o.dispose(), this.fieldRow.splice(n, 1), this.sourceBlock.rendered && (this.sourceBlock.queueRender(), this.sourceBlock.bumpNeighbours()), !0;
          if (t)
            return !1;
          throw Error('Field "' + e + '" not found.');
        }
        isVisible() {
          return this.visible;
        }
        setVisible(e) {
          let t = [];
          if (this.visible === e)
            return t;
          this.visible = e;
          for (let o = 0, c; c = this.fieldRow[o]; o++)
            c.setVisible(e);
          if (this.connection) {
            var n = this.connection;
            e ? t = n.startTrackingAll() : n.stopTrackingAll(), (n = n.targetBlock()) && (n.getSvgRoot().style.display = e ? "block" : "none");
          }
          return t;
        }
        markDirty() {
          for (let e = 0, t; t = this.fieldRow[e]; e++)
            t.markDirty();
        }
        setCheck(e) {
          if (!this.connection)
            throw Error("This input does not have a connection.");
          return this.connection.setCheck(e), this;
        }
        setAlign(e) {
          return this.align = e, this.sourceBlock.rendered && this.sourceBlock.queueRender(), this;
        }
        setShadowDom(e) {
          if (!this.connection)
            throw Error("This input does not have a connection.");
          return this.connection.setShadowDom(e), this;
        }
        getShadowDom() {
          if (!this.connection)
            throw Error("This input does not have a connection.");
          return this.connection.getShadowDom();
        }
        init() {
          if (this.sourceBlock.workspace.rendered)
            for (let e = 0; e < this.fieldRow.length; e++)
              this.fieldRow[e].init();
        }
        dispose() {
          for (let e = 0, t; t = this.fieldRow[e]; e++)
            t.dispose();
          this.connection && this.connection.dispose();
        }
        makeConnection(e) {
          return this.sourceBlock.makeConnection_(e);
        }
      }, eE;
      (function(e) {
        e = e.Align || (e.Align = {}), e[e.LEFT = -1] = "LEFT", e[e.CENTRE = 0] = "CENTRE", e[e.RIGHT = 1] = "RIGHT";
      })(Oi || (Oi = {})), r.Align$$module$build$src$core$inputs$input = Oi.Align, eE = {}, eE.Align = r.Align$$module$build$src$core$inputs$input, eE.Input = Oi;
      var t_ = class extends Oi {
        constructor(e, t) {
          super(e, t), this.name = e, this.type = r.inputTypes$$module$build$src$core$inputs$input_types.DUMMY;
        }
      }, tE;
      r.ValueInput$$module$build$src$core$inputs$value_input = class extends Oi {
        constructor(e, t) {
          if (!e)
            throw Error("Value inputs must have a non-empty name");
          super(e, t), this.name = e, this.type = r.inputTypes$$module$build$src$core$inputs$input_types.VALUE, this.connection = this.makeConnection(Ie.INPUT_VALUE);
        }
      }, tE = {}, tE.ValueInput = r.ValueInput$$module$build$src$core$inputs$value_input;
      var Wn = class extends Oi {
        constructor(e, t) {
          if (!e)
            throw Error("Statement inputs must have a non-empty name");
          super(e, t), this.name = e, this.type = r.inputTypes$$module$build$src$core$inputs$input_types.STATEMENT, this.connection = this.makeConnection(Ie.NEXT_STATEMENT);
        }
      }, As = class {
        constructor(e, t, n) {
          if (this.data = null, this.disposed = !1, this.hue_ = null, this.colour_ = "#000000", this.styleName_ = "", this.suppressPrefixSuffix = !1, this.previousConnection = this.nextConnection = this.outputConnection = null, this.inputList = [], this.icons = [], this.disabled = !1, this.tooltip = "", this.contextMenu = !0, this.parentBlock_ = null, this.childBlocks_ = [], this.editable_ = this.movable_ = this.deletable_ = !0, this.collapsed_ = this.isShadow_ = !1, this.outputShape_ = null, this.isInsertionMarker_ = this.disposing = !1, this.onchangeWrapper_ = this.helpUrl = this.rendered = null, this.statementInputCount = 0, this.workspace = e, this.id = n && !e.getBlockById(n) ? n : Gr(), e.setBlockById(this.id, this), this.xy_ = new ae(0, 0), this.isInFlyout = e.isFlyout, this.isInMutator = e.isMutator, this.RTL = e.RTL, t) {
            if (this.type = t, n = jr[t], !n || typeof n != "object")
              throw TypeError("Invalid block definition for type: " + t);
            Object.assign(this, n);
          }
          e.addTopBlock(this), e.addTypedBlock(this), new.target === As && this.doInit_();
        }
        doInit_() {
          const e = r.getGroup$$module$build$src$core$events$utils();
          e || r.setGroup$$module$build$src$core$events$utils(!0);
          const t = Cr();
          try {
            typeof this.init == "function" && (ur(!1), this.init(), ur(t)), tt() && fe(new (ge(r.CREATE$$module$build$src$core$events$utils))(this));
          } finally {
            r.setGroup$$module$build$src$core$events$utils(e), ur(t);
          }
          this.inputsInlineDefault = this.inputsInline, typeof this.onchange == "function" && this.setOnChange(this.onchange);
        }
        dispose(e) {
          this.isDeadOrDying() || (this.onchangeWrapper_ && this.workspace.removeChangeListener(this.onchangeWrapper_), this.unplug(e), tt() && fe(new (ge(r.DELETE$$module$build$src$core$events$utils))(this)), this.workspace.removeTopBlock(this), this.disposeInternal());
        }
        disposeInternal() {
          this.isDeadOrDying() || (this.onchangeWrapper_ && this.workspace.removeChangeListener(this.onchangeWrapper_), this.workspace.removeTypedBlock(this), this.workspace.removeBlockById(this.id), this.disposing = !0, typeof this.destroy == "function" && this.destroy(), this.childBlocks_.forEach((e) => e.disposeInternal()), this.inputList.forEach((e) => e.dispose()), this.inputList.length = 0, this.getConnections_(!0).forEach((e) => e.dispose()), this.disposed = !0);
        }
        isDeadOrDying() {
          return this.disposing || this.disposed;
        }
        initModel() {
          for (let e = 0, t; t = this.inputList[e]; e++)
            for (let n = 0, o; o = t.fieldRow[n]; n++)
              o.initModel && o.initModel();
        }
        unplug(e) {
          this.outputConnection && this.unplugFromRow_(e), this.previousConnection && this.unplugFromStack_(e);
        }
        unplugFromRow_(e) {
          let t = null, n;
          (n = this.outputConnection) != null && n.isConnected() && (t = this.outputConnection.targetConnection, this.outputConnection.disconnect()), t && e && (e = this.getOnlyValueConnection_()) && e.isConnected() && !e.targetBlock().isShadow() && (e = e.targetConnection, e == null || e.disconnect(), this.workspace.connectionChecker.canConnect(e, t, !1) ? t.connect(e) : e == null || e.onFailedConnect(t));
        }
        getOnlyValueConnection_() {
          let e = null;
          for (let t = 0; t < this.inputList.length; t++) {
            const n = this.inputList[t].connection;
            if (n && n.type === Ie.INPUT_VALUE && n.targetConnection) {
              if (e)
                return null;
              e = n;
            }
          }
          return e;
        }
        unplugFromStack_(e) {
          let t = null;
          var n;
          if ((n = this.previousConnection) != null && n.isConnected() && (t = this.previousConnection.targetConnection, this.previousConnection.disconnect()), n = this.getNextBlock(), e && n && !n.isShadow()) {
            let o, c;
            e = (c = (o = this.nextConnection) == null ? void 0 : o.targetConnection) != null ? c : null, e == null || e.disconnect(), t && this.workspace.connectionChecker.canConnect(t, e, !1) && t.connect(e);
          }
        }
        getConnections_(e) {
          e = [], this.outputConnection && e.push(this.outputConnection), this.previousConnection && e.push(this.previousConnection), this.nextConnection && e.push(this.nextConnection);
          for (let t = 0, n; n = this.inputList[t]; t++)
            n.connection && e.push(n.connection);
          return e;
        }
        lastConnectionInStack(e) {
          let t = this.nextConnection;
          for (; t; ) {
            const n = t.targetBlock();
            if (!n || e && n.isShadow())
              return t;
            t = n.nextConnection;
          }
          return null;
        }
        bumpNeighbours() {
        }
        getParent() {
          return this.parentBlock_;
        }
        getInputWithBlock(e) {
          for (let t = 0, n; n = this.inputList[t]; t++)
            if (n.connection && n.connection.targetBlock() === e)
              return n;
          return null;
        }
        getSurroundParent() {
          let e = this, t;
          do
            if (t = e, e = e.getParent(), !e)
              return null;
          while (e.getNextBlock() === t);
          return e;
        }
        getNextBlock() {
          return this.nextConnection && this.nextConnection.targetBlock();
        }
        getPreviousBlock() {
          return this.previousConnection && this.previousConnection.targetBlock();
        }
        getFirstStatementConnection() {
          for (let e = 0, t; t = this.inputList[e]; e++)
            if (t.connection && t.connection.type === Ie.NEXT_STATEMENT)
              return t.connection;
          return null;
        }
        getRootBlock() {
          let e, t = this;
          do
            e = t, t = e.parentBlock_;
          while (t);
          return e;
        }
        getTopStackBlock() {
          let e = this, t;
          do
            t = e.getPreviousBlock();
          while (t && t.getNextBlock() === e && (e = t));
          return e;
        }
        getChildren(e) {
          if (!e)
            return this.childBlocks_;
          e = [];
          for (let n = 0, o; o = this.inputList[n]; n++)
            if (o.connection) {
              var t = o.connection.targetBlock();
              t && e.push(t);
            }
          return (t = this.getNextBlock()) && e.push(t), e;
        }
        setParent(e) {
          if (e !== this.parentBlock_) {
            var t = this.previousConnection && this.previousConnection.targetBlock() || this.outputConnection && this.outputConnection.targetBlock(), n = !!t;
            if (n && e && t !== e)
              throw Error("Block connected to superior one that is not new parent.");
            if (!n && e)
              throw Error("Block not connected to new parent.");
            if (n && !e)
              throw Error("Cannot set parent to null while block is still connected to superior block.");
            this.parentBlock_ ? cn(this.parentBlock_.childBlocks_, this) : this.workspace.removeTopBlock(this), (this.parentBlock_ = e) ? e.childBlocks_.push(this) : this.workspace.addTopBlock(this);
          }
        }
        getDescendants(e) {
          const t = [this], n = this.getChildren(e);
          for (let o, c = 0; o = n[c]; c++)
            t.push(...o.getDescendants(e));
          return t;
        }
        isDeletable() {
          return this.deletable_ && !this.isShadow_ && !this.isDeadOrDying() && !this.workspace.options.readOnly;
        }
        isOwnDeletable() {
          return this.deletable_;
        }
        setDeletable(e) {
          this.deletable_ = e;
        }
        isMovable() {
          return this.movable_ && !this.isShadow_ && !this.isDeadOrDying() && !this.workspace.options.readOnly;
        }
        isOwnMovable() {
          return this.movable_;
        }
        setMovable(e) {
          this.movable_ = e;
        }
        isDuplicatable() {
          return this.workspace.hasBlockLimits() ? this.workspace.isCapacityAvailable(Rt(
            this,
            !0
          )) : !0;
        }
        isShadow() {
          return this.isShadow_;
        }
        setShadow(e) {
          this.isShadow_ = e;
        }
        isInsertionMarker() {
          return this.isInsertionMarker_;
        }
        setInsertionMarker(e) {
          this.isInsertionMarker_ = e;
        }
        isEditable() {
          return this.editable_ && !this.isDeadOrDying() && !this.workspace.options.readOnly;
        }
        isOwnEditable() {
          return this.editable_;
        }
        setEditable(e) {
          this.editable_ = e;
          for (let t = 0, n; n = this.inputList[t]; t++)
            for (let o = 0, c; c = n.fieldRow[o]; o++)
              c.updateEditable();
        }
        isDisposed() {
          return this.disposed;
        }
        getMatchingConnection(e, t) {
          const n = this.getConnections_(!0);
          if (e = e.getConnections_(!0), n.length !== e.length)
            throw Error("Connection lists did not match in length.");
          for (let o = 0; o < e.length; o++)
            if (e[o] === t)
              return n[o];
          return null;
        }
        setHelpUrl(e) {
          this.helpUrl = e;
        }
        setTooltip(e) {
          this.tooltip = e;
        }
        getTooltip() {
          return Hi(this);
        }
        getColour() {
          return this.colour_;
        }
        getStyleName() {
          return this.styleName_;
        }
        getHue() {
          return this.hue_;
        }
        setColour(e) {
          e = GT(e), this.hue_ = e.hue, this.colour_ = e.hex;
        }
        setStyle(e) {
          this.styleName_ = e;
        }
        setOnChange(e) {
          if (e && typeof e != "function")
            throw Error("onchange must be a function.");
          this.onchangeWrapper_ && this.workspace.removeChangeListener(this.onchangeWrapper_), this.onchange = e, this.onchangeWrapper_ = e.bind(this), this.workspace.addChangeListener(this.onchangeWrapper_);
        }
        getField(e) {
          if (typeof e != "string")
            throw TypeError("Block.prototype.getField expects a string with the field name but received " + (e === void 0 ? "nothing" : e + " of type " + typeof e) + " instead");
          for (let t = 0, n; n = this.inputList[t]; t++)
            for (let o = 0, c; c = n.fieldRow[o]; o++)
              if (c.name === e)
                return c;
          return null;
        }
        getVars() {
          const e = [];
          for (let t = 0, n; n = this.inputList[t]; t++)
            for (let o = 0, c; c = n.fieldRow[o]; o++)
              c.referencesVariables() && e.push(c.getValue());
          return e;
        }
        getVarModels() {
          const e = [];
          for (let t = 0, n; n = this.inputList[t]; t++)
            for (let o = 0, c; c = n.fieldRow[o]; o++)
              if (c.referencesVariables()) {
                const A = this.workspace.getVariableById(c.getValue());
                A && e.push(A);
              }
          return e;
        }
        updateVarName(e) {
          for (let t = 0, n; n = this.inputList[t]; t++)
            for (let o = 0, c; c = n.fieldRow[o]; o++)
              c.referencesVariables() && e.getId() === c.getValue() && c.refreshVariableName();
        }
        renameVarById(e, t) {
          for (let n = 0, o; o = this.inputList[n]; n++)
            for (let c = 0, A; A = o.fieldRow[c]; c++)
              A.referencesVariables() && e === A.getValue() && A.setValue(t);
        }
        getFieldValue(e) {
          return (e = this.getField(e)) ? e.getValue() : null;
        }
        setFieldValue(e, t) {
          const n = this.getField(t);
          if (!n)
            throw Error('Field "' + t + '" not found.');
          n.setValue(e);
        }
        setPreviousStatement(e, t) {
          if (e)
            t === void 0 && (t = null), this.previousConnection || (this.previousConnection = this.makeConnection_(Ie.PREVIOUS_STATEMENT)), this.previousConnection.setCheck(t);
          else if (this.previousConnection) {
            if (this.previousConnection.isConnected())
              throw Error("Must disconnect previous statement before removing connection.");
            this.previousConnection.dispose(), this.previousConnection = null;
          }
        }
        setNextStatement(e, t) {
          if (e)
            t === void 0 && (t = null), this.nextConnection || (this.nextConnection = this.makeConnection_(Ie.NEXT_STATEMENT)), this.nextConnection.setCheck(t);
          else if (this.nextConnection) {
            if (this.nextConnection.isConnected())
              throw Error("Must disconnect next statement before removing connection.");
            this.nextConnection.dispose(), this.nextConnection = null;
          }
        }
        setOutput(e, t) {
          if (e)
            t === void 0 && (t = null), this.outputConnection || (this.outputConnection = this.makeConnection_(Ie.OUTPUT_VALUE)), this.outputConnection.setCheck(t);
          else if (this.outputConnection) {
            if (this.outputConnection.isConnected())
              throw Error("Must disconnect output value before removing connection.");
            this.outputConnection.dispose(), this.outputConnection = null;
          }
        }
        setInputsInline(e) {
          this.inputsInline !== e && (fe(new (ge(r.CHANGE$$module$build$src$core$events$utils))(this, "inline", null, this.inputsInline, e)), this.inputsInline = e);
        }
        getInputsInline() {
          if (this.inputsInline !== void 0)
            return this.inputsInline;
          for (var e = 1; e < this.inputList.length; e++)
            if (this.inputList[e - 1] instanceof t_ && this.inputList[e] instanceof t_)
              return !1;
          for (e = 1; e < this.inputList.length; e++)
            if (this.inputList[e - 1] instanceof r.ValueInput$$module$build$src$core$inputs$value_input && this.inputList[e] instanceof t_)
              return !0;
          return !1;
        }
        setOutputShape(e) {
          this.outputShape_ = e;
        }
        getOutputShape() {
          return this.outputShape_;
        }
        isEnabled() {
          return !this.disabled;
        }
        setEnabled(e) {
          if (this.isEnabled() !== e) {
            const t = this.disabled;
            this.disabled = !e, fe(new (ge(r.CHANGE$$module$build$src$core$events$utils))(
              this,
              "disabled",
              null,
              t,
              !e
            ));
          }
        }
        getInheritedDisabled() {
          let e = this.getSurroundParent();
          for (; e; ) {
            if (e.disabled)
              return !0;
            e = e.getSurroundParent();
          }
          return !1;
        }
        isCollapsed() {
          return this.collapsed_;
        }
        setCollapsed(e) {
          this.collapsed_ !== e && (fe(new (ge(r.CHANGE$$module$build$src$core$events$utils))(this, "collapsed", null, this.collapsed_, e)), this.collapsed_ = e);
        }
        toString(e, t) {
          t = this.toTokens(t);
          for (let o = 2; o < t.length; o++)
            t[o - 2] === "(" && t[o] === ")" && (t[o - 2] = t[o - 1], t.splice(o - 1, 2));
          let n = "";
          return t = t.reduce((o, c) => (o = o + (n === "(" || c === ")" ? "" : " ") + c, n = c[c.length - 1], o), ""), t = t.trim() || "???", e && t.length > e && (t = t.substring(0, e - 3) + "..."), t;
        }
        toTokens(e = "?") {
          const t = [];
          for (const o of this.inputList)
            if (o.name != Ts) {
              for (const c of o.fieldRow)
                t.push(c.getText());
              if (o.connection) {
                const c = o.connection.targetBlock();
                if (c) {
                  var n = o.connection;
                  let A = n.getCheck();
                  !A && n.targetConnection && (A = n.targetConnection.getCheck()), (n = !!A && (A.indexOf("Boolean") !== -1 || A.indexOf("Number") !== -1)) && t.push("("), t.push(...c.toTokens(e)), n && t.push(")");
                } else
                  t.push(e);
              }
            }
          return t;
        }
        appendValueInput(e) {
          return this.appendInput(new r.ValueInput$$module$build$src$core$inputs$value_input(e, this));
        }
        appendStatementInput(e) {
          return this.statementInputCount++, this.appendInput(new Wn(e, this));
        }
        appendDummyInput(e = "") {
          return this.appendInput(new t_(
            e,
            this
          ));
        }
        appendInput(e) {
          return this.inputList.push(e), e;
        }
        appendInputFromRegistry(e, t) {
          return (e = L(se.INPUT, e, !1)) ? this.appendInput(new e(t, this)) : null;
        }
        jsonInit(e) {
          var t = e.type ? 'Block "' + e.type + '": ' : "";
          if (e.output && e.previousStatement)
            throw Error(t + "Must not have both an output and a previousStatement.");
          if (e.style && e.style.hat && (this.hat = e.style.hat, e.style = null), e.style && e.colour)
            throw Error(t + "Must not have both a colour and a style.");
          e.style ? this.jsonInitStyle_(e, t) : this.jsonInitColour_(e, t);
          for (var n = 0; e["message" + n] !== void 0; )
            this.interpolate_(e["message" + n], e["args" + n] || [], e["lastDummyAlign" + n], t), n++;
          if (e.inputsInline !== void 0 && this.setInputsInline(e.inputsInline), e.output !== void 0 && this.setOutput(!0, e.output), e.outputShape !== void 0 && this.setOutputShape(e.outputShape), e.previousStatement !== void 0 && this.setPreviousStatement(!0, e.previousStatement), e.nextStatement !== void 0 && this.setNextStatement(!0, e.nextStatement), e.tooltip !== void 0 && (n = xt(e.tooltip), this.setTooltip(n)), e.enableContextMenu !== void 0 && (this.contextMenu = !!e.enableContextMenu), e.suppressPrefixSuffix !== void 0 && (this.suppressPrefixSuffix = !!e.suppressPrefixSuffix), e.helpUrl !== void 0 && (n = xt(e.helpUrl), this.setHelpUrl(n)), typeof e.extensions == "string" && (console.warn(t + "JSON attribute 'extensions' should be an array of strings. Found raw string in JSON for '" + e.type + "' block."), e.extensions = [e.extensions]), e.mutator !== void 0 && xi(e.mutator, this, !0), e = e.extensions, Array.isArray(e))
            for (t = 0; t < e.length; t++)
              xi(e[t], this, !1);
        }
        jsonInitColour_(e, t) {
          if ("colour" in e)
            if (e.colour === void 0)
              console.warn(t + "Undefined colour value.");
            else {
              e = e.colour;
              try {
                this.setColour(e);
              } catch {
                console.warn(t + "Illegal colour value: ", e);
              }
            }
        }
        jsonInitStyle_(e, t) {
          e = e.style;
          try {
            this.setStyle(e);
          } catch {
            console.warn(t + "Style does not exist: ", e);
          }
        }
        mixin(e, t) {
          if (t !== void 0 && typeof t != "boolean")
            throw Error("opt_disableCheck must be a boolean if provided");
          if (!t) {
            t = [];
            for (const n in e)
              this[n] !== void 0 && t.push(n);
            if (t.length)
              throw Error("Mixin will overwrite block members: " + JSON.stringify(t));
          }
          Object.assign(this, e);
        }
        interpolate_(e, t, n, o) {
          e = Up(e), this.validateTokens_(e, t.length), t = this.interpolateArguments_(e, t, n), n = [];
          for (let c = 0, A; A = t[c]; c++)
            if (this.isInputKeyword_(A.type)) {
              if (e = this.inputFromJson_(A, o)) {
                for (let D = 0, $; $ = n[D]; D++)
                  e.appendField($[0], $[1]);
                n.length = 0;
              }
            } else
              (e = this.fieldFromJson_(A)) && n.push([e, A.name]);
        }
        validateTokens_(e, t) {
          const n = [];
          let o = 0;
          for (let c = 0; c < e.length; c++) {
            const A = e[c];
            if (typeof A == "number") {
              if (1 > A || A > t)
                throw Error('Block "' + this.type + '": Message index %' + A + " out of range.");
              if (n[A])
                throw Error('Block "' + this.type + '": Message index %' + A + " duplicated.");
              n[A] = !0, o++;
            }
          }
          if (o !== t)
            throw Error('Block "' + this.type + '": Message does not reference all ' + t + " arg(s).");
        }
        interpolateArguments_(e, t, n) {
          const o = [];
          for (let c = 0; c < e.length; c++) {
            let A = e[c];
            typeof A == "number" && (A = t[A - 1]), !(typeof A == "string" && (A = this.stringToFieldJson_(A), !A)) && o.push(A);
          }
          return (e = o.length) && !this.isInputKeyword_(o[e - 1].type) && (e = { type: "input_dummy" }, n && (e.align = n), o.push(e)), o;
        }
        fieldFromJson_(e) {
          const t = r.fromJson$$module$build$src$core$field_registry(e);
          return !t && e.alt ? typeof e.alt == "string" ? (e = this.stringToFieldJson_(e.alt)) ? this.fieldFromJson_(e) : null : this.fieldFromJson_(e.alt) : t;
        }
        inputFromJson_(e, t) {
          var n = { LEFT: r.Align$$module$build$src$core$inputs$align.LEFT, RIGHT: r.Align$$module$build$src$core$inputs$align.RIGHT, CENTRE: r.Align$$module$build$src$core$inputs$align.CENTRE, CENTER: r.Align$$module$build$src$core$inputs$align.CENTRE };
          let o;
          switch (e.type) {
            case "input_value":
              o = this.appendValueInput(e.name);
              break;
            case "input_statement":
              o = this.appendStatementInput(e.name);
              break;
            case "input_dummy":
              o = this.appendDummyInput(e.name);
              break;
            default:
              o = this.appendInputFromRegistry(
                e.type,
                e.name
              );
          }
          return o ? (e.check && o.setCheck(e.check), e.align && (n = n[e.align.toUpperCase()], n === void 0 ? console.warn(t + "Illegal align value: ", e.align) : o.setAlign(n)), o) : null;
        }
        isInputKeyword_(e) {
          return e === "input_value" || e === "input_statement" || e === "input_dummy" || h(se.INPUT, e);
        }
        stringToFieldJson_(e) {
          return (e = e.trim()) ? { type: "field_label", text: e } : null;
        }
        moveInputBefore(e, t) {
          if (e !== t) {
            var n = -1, o = t ? -1 : this.inputList.length;
            for (let c = 0, A; A = this.inputList[c]; c++)
              if (A.name === e) {
                if (n = c, o !== -1)
                  break;
              } else if (t && A.name === t && (o = c, n !== -1))
                break;
            if (n === -1)
              throw Error('Named input "' + e + '" not found.');
            if (o === -1)
              throw Error('Reference input "' + t + '" not found.');
            this.moveNumberedInputBefore(n, o);
          }
        }
        moveNumberedInputBefore(e, t) {
          if (e === t)
            throw Error("Can't move input to itself.");
          if (e >= this.inputList.length)
            throw RangeError("Input index " + e + " out of bounds.");
          if (t > this.inputList.length)
            throw RangeError("Reference input " + t + " out of bounds.");
          const n = this.inputList[e];
          this.inputList.splice(e, 1), e < t && t--, this.inputList.splice(t, 0, n);
        }
        removeInput(e, t) {
          for (let n = 0, o; o = this.inputList[n]; n++)
            if (o.name === e)
              return o instanceof Wn && this.statementInputCount--, o.dispose(), this.inputList.splice(n, 1), !0;
          if (t)
            return !1;
          throw Error("Input not found: " + e);
        }
        getInput(e) {
          for (let t = 0, n; n = this.inputList[t]; t++)
            if (n.name === e)
              return n;
          return null;
        }
        getInputTargetBlock(e) {
          return (e = this.getInput(e)) && e.connection && e.connection.targetBlock();
        }
        getCommentText() {
          let e, t;
          return (t = (e = this.getIcon(br.TYPE)) == null ? void 0 : e.getText()) != null ? t : null;
        }
        setCommentText(e) {
          var t;
          let n;
          const o = (n = (t = this.getIcon(br.TYPE)) == null ? void 0 : t.getText()) != null ? n : null;
          o !== e && (fe(new (ge(r.CHANGE$$module$build$src$core$events$utils))(this, "comment", null, o, e)), e !== null ? ((t = this.getIcon(br.TYPE)) || (t = this.addIcon(new br(this))), t.setText(e)) : this.removeIcon(br.TYPE));
        }
        setWarningText(e, t) {
        }
        setMutator(e) {
        }
        addIcon(e) {
          if (this.hasIcon(e.getType()))
            throw new ed(e);
          return this.icons.push(e), this.icons.sort((t, n) => t.getWeight() - n.getWeight()), e;
        }
        removeIcon(e) {
          if (!this.hasIcon(e))
            return !1;
          let t;
          return (t = this.getIcon(e)) == null || t.dispose(), this.icons = this.icons.filter((n) => !n.getType().equals(e)), !0;
        }
        hasIcon(e) {
          return this.icons.some((t) => t.getType().equals(e));
        }
        getIcon(e) {
          return e instanceof mr ? this.icons.find((t) => t.getType().equals(e)) : this.icons.find((t) => t.getType().toString() === e);
        }
        getIcons() {
          return [...this.icons];
        }
        getRelativeToSurfaceXY() {
          return this.xy_;
        }
        moveBy(e, t, n) {
          if (this.parentBlock_)
            throw Error("Block has parent");
          const o = new (ge(r.MOVE$$module$build$src$core$events$utils))(this);
          n && o.setReason(n), this.xy_.translate(e, t), o.recordNew(), fe(o);
        }
        makeConnection_(e) {
          return new lt(this, e);
        }
        allInputsFilled(e) {
          if (e === void 0 && (e = !0), !e && this.isShadow())
            return !1;
          for (let n = 0, o; o = this.inputList[n]; n++)
            if (o.connection) {
              var t = o.connection.targetBlock();
              if (!t || !t.allInputsFilled(e))
                return !1;
            }
          return (t = this.getNextBlock()) ? t.allInputsFilled(e) : !0;
        }
        toDevString() {
          let e = this.type ? '"' + this.type + '" block' : "Block";
          return this.id && (e += ' (id="' + this.id + '")'), e;
        }
      };
      As.COLLAPSED_INPUT_NAME = Ts, As.COLLAPSED_FIELD_NAME = Tc;
      var yl = null, vl = null, $l = {};
      $l.connectionUiEffect = XT, $l.disconnectUiEffect = xp, $l.disconnectUiStop = KT, $l.disposeUiEffect = Xo;
      var rE = class extends V_ {
        constructor(e, t, n) {
          super(e ? e.workspace.id : void 0), this.type = qi, e && (this.blockId = e.id, this.isStart = t, this.blocks = n);
        }
        toJson() {
          const e = super.toJson();
          if (this.isStart === void 0)
            throw Error("Whether this event is the start of a drag is undefined. Either pass the value to the constructor, or call fromJson");
          if (this.blockId === void 0)
            throw Error("The block ID is undefined. Either pass a block to the constructor, or call fromJson");
          return e.isStart = this.isStart, e.blockId = this.blockId, e.blocks = this.blocks, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new rE()), t.isStart = e.isStart, t.blockId = e.blockId, t.blocks = e.blocks, t;
        }
      };
      i(se.EVENT, qi, rE);
      var Pc = {};
      Pc.bumpIntoBounds = JT, Pc.bumpIntoBoundsHandler = Kp, Pc.bumpTopObjectsIntoBounds = Ji;
      var Dc = /* @__PURE__ */ new Set(), Lc = /* @__PURE__ */ new WeakSet(), ds = null, nE = {};
      nE.finishQueuedRenders = C, nE.queueRender = ya;
      var Ri = class {
        constructor(e) {
          this.name_ = e;
        }
        toString() {
          return this.name_;
        }
      };
      Ri.POSITIONABLE = new Ri("positionable"), Ri.DRAG_TARGET = new Ri("drag_target"), Ri.DELETE_AREA = new Ri("delete_area"), Ri.AUTOHIDEABLE = new Ri("autohideable");
      var Lt = class {
        constructor() {
          this.componentData = /* @__PURE__ */ new Map(), this.capabilityToComponentIds = /* @__PURE__ */ new Map();
        }
        addComponent(e, t) {
          const n = e.component.id;
          if (!t && this.componentData.has(n)) {
            var o;
            throw Error('Plugin "' + n + '" with capabilities "' + ((o = this.componentData.get(n)) == null ? void 0 : o.capabilities) + '" already added.');
          }
          for (this.componentData.set(n, e), t = [], o = 0; o < e.capabilities.length; o++) {
            const c = String(e.capabilities[o]).toLowerCase();
            if (t.push(c), this.capabilityToComponentIds.has(c)) {
              let A;
              (A = this.capabilityToComponentIds.get(c)) == null || A.push(n);
            } else
              this.capabilityToComponentIds.set(c, [n]);
          }
          this.componentData.get(n).capabilities = t;
        }
        removeComponent(e) {
          const t = this.componentData.get(e);
          if (t) {
            for (let n = 0; n < t.capabilities.length; n++) {
              const o = String(t.capabilities[n]).toLowerCase();
              cn(this.capabilityToComponentIds.get(o), e);
            }
            this.componentData.delete(e);
          }
        }
        addCapability(e, t) {
          if (!this.getComponent(e))
            throw Error('Cannot add capability, "' + t + '". Plugin "' + e + '" has not been added to the ComponentManager');
          if (this.hasCapability(e, t))
            console.warn('Plugin "' + e + 'already has capability "' + t + '"');
          else {
            t = `${t}`.toLowerCase();
            var n;
            (n = this.componentData.get(e)) == null || n.capabilities.push(t);
            var o;
            (o = this.capabilityToComponentIds.get(t)) == null || o.push(e);
          }
        }
        removeCapability(e, t) {
          if (!this.getComponent(e))
            throw Error('Cannot remove capability, "' + t + '". Plugin "' + e + '" has not been added to the ComponentManager');
          this.hasCapability(e, t) ? (t = `${t}`.toLowerCase(), cn(
            this.componentData.get(e).capabilities,
            t
          ), cn(this.capabilityToComponentIds.get(t), e)) : console.warn('Plugin "' + e + `doesn't have capability "` + t + '" to remove');
        }
        hasCapability(e, t) {
          return t = `${t}`.toLowerCase(), this.componentData.has(e) && this.componentData.get(e).capabilities.indexOf(t) !== -1;
        }
        getComponent(e) {
          let t;
          return (t = this.componentData.get(e)) == null ? void 0 : t.component;
        }
        getComponents(e, t) {
          if (e = `${e}`.toLowerCase(), e = this.capabilityToComponentIds.get(e), !e)
            return [];
          const n = [];
          if (t) {
            const o = [];
            e.forEach((c) => {
              o.push(this.componentData.get(c));
            }), o.sort(function(c, A) {
              return c.weight - A.weight;
            }), o.forEach(function(c) {
              n.push(c.component);
            });
          } else
            e.forEach((o) => {
              n.push(this.componentData.get(o).component);
            });
          return n;
        }
      };
      Lt.Capability = Ri;
      var _E, Ad;
      _E = 28, r.config$$module$build$src$core$config = { dragRadius: 5, flyoutDragRadius: 10, snapRadius: _E, connectingSnapRadius: _E, currentConnectionPreference: 8, bumpDelay: 250 }, Ad = {}, Ad.config = r.config$$module$build$src$core$config;
      var po = "The insertion marker manager tried to create a marker but the result is missing %1. If you are using a mutator, make sure your domToMutation method is properly defined.", $e = class {
        constructor(e) {
          this.activeCandidate = this.lastMarker = this.lastOnStack = null, this.wouldDeleteBlock = !1, this.fadedBlock = this.highlightedBlock = this.markerConnection = null, ot(e), this.topBlock = e, this.workspace = e.workspace, this.firstMarker = this.createMarkerBlock(this.topBlock), this.availableConnections = this.initAvailableConnections(), this.lastOnStack && (this.lastMarker = this.createMarkerBlock(this.lastOnStack.getSourceBlock()));
        }
        dispose() {
          this.availableConnections.length = 0, this.disposeInsertionMarker(this.firstMarker), this.disposeInsertionMarker(this.lastMarker);
        }
        updateAvailableConnections() {
          this.availableConnections = this.initAvailableConnections();
        }
        wouldConnectBlock() {
          return !!this.activeCandidate;
        }
        applyConnections() {
          if (this.activeCandidate) {
            r.disable$$module$build$src$core$events$utils(), this.hidePreview(), r.enable$$module$build$src$core$events$utils();
            var { local: e, closest: t } = this.activeCandidate;
            if (e.connect(t), this.topBlock.rendered) {
              const n = e.isSuperior() ? t : e, o = this.topBlock.getRootBlock();
              C().then(() => {
                XT(n.getSourceBlock()), setTimeout(() => {
                  o.bringToFront();
                }, 0);
              });
            }
          }
        }
        update(e, t) {
          const n = this.getCandidate(e);
          ((this.wouldDeleteBlock = this.shouldDelete(!!n, t)) || this.shouldUpdatePreviews(
            n,
            e
          )) && (r.disable$$module$build$src$core$events$utils(), this.maybeHidePreview(n), this.maybeShowPreview(n), r.enable$$module$build$src$core$events$utils());
        }
        createMarkerBlock(e) {
          var t = e.type;
          r.disable$$module$build$src$core$events$utils();
          let n;
          try {
            if (n = this.workspace.newBlock(t), n.setInsertionMarker(!0), e.saveExtraState) {
              var o = e.saveExtraState();
              o && n.loadExtraState && n.loadExtraState(o);
            } else if (e.mutationToDom) {
              const c = e.mutationToDom();
              c && n.domToMutation && n.domToMutation(c);
            }
            for (t = 0; t < e.inputList.length; t++) {
              const c = e.inputList[t];
              if (c.name === Ts)
                continue;
              const A = n.inputList[t];
              if (!A)
                throw Error(po.replace("%1", "an input"));
              for (o = 0; o < c.fieldRow.length; o++) {
                const D = c.fieldRow[o], $ = A.fieldRow[o];
                if (!$)
                  throw Error(po.replace("%1", "a field"));
                $.setValue(D.getValue());
              }
            }
            n.setCollapsed(e.isCollapsed()), n.setInputsInline(e.getInputsInline()), n.initSvg(), n.getSvgRoot().setAttribute("visibility", "hidden");
          } finally {
            r.enable$$module$build$src$core$events$utils();
          }
          return n;
        }
        initAvailableConnections() {
          const e = this.topBlock.getConnections_(!1), t = this.topBlock.lastConnectionInStack(!0);
          return t && t !== this.topBlock.nextConnection && (e.push(t), this.lastOnStack = t), e;
        }
        shouldUpdatePreviews(e, t) {
          if (!e)
            return !!this.activeCandidate;
          if (!this.activeCandidate)
            return !0;
          const { local: n, closest: o } = this.activeCandidate;
          if (o === e.closest && n === e.local)
            return !1;
          const c = n.x + t.x - o.x;
          return t = n.y + t.y - o.y, e.radius < Math.sqrt(c * c + t * t) - r.config$$module$build$src$core$config.currentConnectionPreference;
        }
        getCandidate(e) {
          this.markerConnection && this.markerConnection.isConnected() || this.updateAvailableConnections();
          let t = this.getStartRadius(), n = null;
          for (let o = 0; o < this.availableConnections.length; o++) {
            const c = this.availableConnections[o], A = c.closest(t, e);
            A.connection && (n = { closest: A.connection, local: c, radius: A.radius }, t = A.radius);
          }
          return n;
        }
        getStartRadius() {
          return this.activeCandidate ? r.config$$module$build$src$core$config.connectingSnapRadius : r.config$$module$build$src$core$config.snapRadius;
        }
        shouldDelete(e, t) {
          return t && this.workspace.getComponentManager().hasCapability(t.id, Lt.Capability.DELETE_AREA) ? t.wouldDelete(this.topBlock, e) : !1;
        }
        maybeShowPreview(e) {
          if (!this.wouldDeleteBlock && e) {
            var t = e.closest, n;
            t === ((n = this.activeCandidate) == null ? void 0 : n.closest) || t.getSourceBlock().isInsertionMarker() ? console.log("Trying to connect to an insertion marker") : (this.activeCandidate = e, this.showPreview(this.activeCandidate));
          }
        }
        showPreview(e) {
          const t = this.workspace.getRenderer();
          switch (t.getConnectionPreviewMethod(e.closest, e.local, this.topBlock)) {
            case $e.PREVIEW_TYPE.INPUT_OUTLINE:
              this.showInsertionInputOutline(e);
              break;
            case $e.PREVIEW_TYPE.INSERTION_MARKER:
              this.showInsertionMarker(e);
              break;
            case $e.PREVIEW_TYPE.REPLACEMENT_FADE:
              this.showReplacementFade(e);
          }
          t.shouldHighlightConnection(e.closest) && e.closest.highlight();
        }
        maybeHidePreview(e) {
          if (!e)
            this.hidePreview();
          else if (this.activeCandidate) {
            const t = this.activeCandidate.local !== e.local;
            (this.activeCandidate.closest !== e.closest || t || this.wouldDeleteBlock) && this.hidePreview();
          }
          this.activeCandidate = this.markerConnection = null;
        }
        hidePreview() {
          let e;
          const t = (e = this.activeCandidate) == null ? void 0 : e.closest;
          t && t.targetBlock() && this.workspace.getRenderer().shouldHighlightConnection(t) && t.unhighlight(), this.hideReplacementFade(), this.hideInsertionInputOutline(), this.hideInsertionMarker();
        }
        showInsertionMarker(e) {
          const { local: t, closest: n } = e;
          let o = (e = this.lastOnStack && t === this.lastOnStack) ? this.lastMarker : this.firstMarker;
          if (!o)
            throw Error("Cannot show the insertion marker because there is no insertion marker block");
          let c;
          try {
            c = o.getMatchingConnection(t.getSourceBlock(), t);
          } catch {
            if (e && this.lastOnStack ? (this.disposeInsertionMarker(this.lastMarker), o = this.lastMarker = this.createMarkerBlock(this.lastOnStack.getSourceBlock())) : (this.disposeInsertionMarker(this.firstMarker), o = this.firstMarker = this.createMarkerBlock(this.topBlock)), !o)
              throw Error("Cannot show the insertion marker because there is no insertion marker block");
            c = o.getMatchingConnection(t.getSourceBlock(), t);
          }
          if (!c)
            throw Error("Cannot show the insertion marker because there is no associated connection");
          if (c === this.markerConnection)
            throw Error("Made it to showInsertionMarker_ even though the marker isn't changing");
          o.render(), o.rendered = !0, o.getSvgRoot().setAttribute("visibility", "visible"), c && n && o.positionNearConnection(
            c,
            n
          ), n && c.connect(n), this.markerConnection = c;
        }
        hideInsertionMarker() {
          if (this.markerConnection) {
            var e = this.markerConnection, t = e.getSourceBlock(), n = t.outputConnection, o;
            if ((o = t.previousConnection) != null && o.targetConnection || n != null && n.targetConnection)
              t.unplug(!0);
            else {
              let c;
              (c = e.targetBlock()) == null || c.unplug(!1);
            }
            if (e.targetConnection)
              throw Error("markerConnection still connected at the end of disconnectInsertionMarker");
            this.markerConnection = null, (e = t.getSvgRoot()) && e.setAttribute(
              "visibility",
              "hidden"
            );
          }
        }
        showInsertionInputOutline(e) {
          e = e.closest, this.highlightedBlock = e.getSourceBlock(), this.highlightedBlock.highlightShapeForInput(e, !0);
        }
        hideInsertionInputOutline() {
          if (this.highlightedBlock) {
            if (!this.activeCandidate)
              throw Error("Cannot hide the insertion marker outline because there is no active candidate");
            this.highlightedBlock.highlightShapeForInput(this.activeCandidate.closest, !1), this.highlightedBlock = null;
          }
        }
        showReplacementFade(e) {
          if (this.fadedBlock = e.closest.targetBlock(), !this.fadedBlock)
            throw Error("Cannot show the replacement fade because the closest connection does not have a target block");
          this.fadedBlock.fadeForReplacement(!0);
        }
        hideReplacementFade() {
          this.fadedBlock && (this.fadedBlock.fadeForReplacement(!1), this.fadedBlock = null);
        }
        getInsertionMarkers() {
          const e = [];
          return this.firstMarker && e.push(this.firstMarker), this.lastMarker && e.push(this.lastMarker), e;
        }
        disposeInsertionMarker(e) {
          if (e) {
            r.disable$$module$build$src$core$events$utils();
            try {
              e.dispose();
            } finally {
              r.enable$$module$build$src$core$events$utils();
            }
          }
        }
      };
      (function(e) {
        e = e.PREVIEW_TYPE || (e.PREVIEW_TYPE = {}), e[e.INSERTION_MARKER = 0] = "INSERTION_MARKER", e[e.INPUT_OUTLINE = 1] = "INPUT_OUTLINE", e[e.REPLACEMENT_FADE = 2] = "REPLACEMENT_FADE";
      })($e || ($e = {})), $e.PREVIEW_TYPE;
      var dd = class {
        constructor(e, t) {
          this.dragTarget_ = null, this.wouldDeleteBlock_ = !1, this.draggingBlock_ = e, this.draggedConnectionManager_ = new $e(this.draggingBlock_), this.workspace_ = t, this.startXY_ = this.draggingBlock_.getRelativeToSurfaceXY(), this.dragIconData_ = jp(e, this.startXY_);
        }
        dispose() {
          this.dragIconData_.length = 0, this.draggedConnectionManager_ && this.draggedConnectionManager_.dispose();
        }
        startDrag(e, t) {
          r.getGroup$$module$build$src$core$events$utils() || r.setGroup$$module$build$src$core$events$utils(!0), this.fireDragStartEvent_(), this.workspace_.isMutator && this.draggingBlock_.bringToFront(), wr(), this.workspace_.setResizesEnabled(!1), KT(), this.shouldDisconnect_(t) && this.disconnectBlock_(t, e), this.draggingBlock_.setDragging(!0);
        }
        shouldDisconnect_(e) {
          return !!(this.draggingBlock_.getParent() || e && this.draggingBlock_.nextConnection && this.draggingBlock_.nextConnection.targetBlock());
        }
        disconnectBlock_(e, t) {
          this.draggingBlock_.unplug(e), e = this.pixelsToWorkspaceUnits_(t), e = ae.sum(this.startXY_, e), this.draggingBlock_.translate(e.x, e.y), xp(this.draggingBlock_), this.draggedConnectionManager_.updateAvailableConnections();
        }
        fireDragStartEvent_() {
          const e = new (ge(qi))(
            this.draggingBlock_,
            !0,
            this.draggingBlock_.getDescendants(!1)
          );
          fe(e);
        }
        drag(e, t) {
          t = this.pixelsToWorkspaceUnits_(t);
          var n = ae.sum(this.startXY_, t);
          this.draggingBlock_.moveDuringDrag(n), this.dragIcons_(t), n = this.dragTarget_, this.dragTarget_ = this.workspace_.getDragTarget(e), this.draggedConnectionManager_.update(t, this.dragTarget_), e = this.wouldDeleteBlock_, this.wouldDeleteBlock_ = this.draggedConnectionManager_.wouldDeleteBlock, e !== this.wouldDeleteBlock_ && this.updateCursorDuringBlockDrag_(), this.dragTarget_ !== n && (n && n.onDragExit(this.draggingBlock_), this.dragTarget_ && this.dragTarget_.onDragEnter(this.draggingBlock_)), this.dragTarget_ && this.dragTarget_.onDragOver(this.draggingBlock_);
        }
        endDrag(e, t) {
          this.drag(e, t), this.dragIconData_ = [], this.fireDragEndEvent_(), Qt(), KT(), e = null, this.dragTarget_ && this.dragTarget_.shouldPreventMove(this.draggingBlock_) || (e = this.getNewLocationAfterDrag_(t).delta), this.dragTarget_ && this.dragTarget_.onDrop(this.draggingBlock_), this.maybeDeleteBlock_() || (this.draggingBlock_.setDragging(!1), e ? this.updateBlockAfterMove_() : JT(this.draggingBlock_.workspace, this.workspace_.getMetricsManager().getScrollMetrics(!0), this.draggingBlock_)), this.workspace_.setResizesEnabled(!0), r.setGroup$$module$build$src$core$events$utils(!1);
        }
        getNewLocationAfterDrag_(e) {
          e = this.pixelsToWorkspaceUnits_(e);
          const t = ae.sum(this.startXY_, e);
          return { delta: e, newLocation: t };
        }
        maybeDeleteBlock_() {
          return this.wouldDeleteBlock_ ? (this.fireMoveEvent_(), this.draggingBlock_.dispose(!1, !0), qT.length = 0, !0) : !1;
        }
        updateBlockAfterMove_() {
          this.fireMoveEvent_(), this.draggedConnectionManager_.wouldConnectBlock() ? this.draggedConnectionManager_.applyConnections() : this.draggingBlock_.queueRender(), this.draggingBlock_.scheduleSnapAndBump();
        }
        fireDragEndEvent_() {
          const e = new (ge(qi))(this.draggingBlock_, !1, this.draggingBlock_.getDescendants(!1));
          fe(e);
        }
        updateToolboxStyle_(e) {
          const t = this.workspace_.getToolbox();
          if (t) {
            const n = this.draggingBlock_.isDeletable() ? "blocklyToolboxDelete" : "blocklyToolboxGrab";
            e && typeof t.removeStyle == "function" ? t.removeStyle(n) : e || typeof t.addStyle != "function" || t.addStyle(n);
          }
        }
        fireMoveEvent_() {
          if (!this.draggingBlock_.isDeadOrDying()) {
            var e = new (ge(r.MOVE$$module$build$src$core$events$utils))(this.draggingBlock_);
            e.setReason(["drag"]), e.oldCoordinate = this.startXY_, e.recordNew(), fe(e);
          }
        }
        updateCursorDuringBlockDrag_() {
          this.draggingBlock_.setDeleteStyle(this.wouldDeleteBlock_);
        }
        pixelsToWorkspaceUnits_(e) {
          return e = new ae(e.x / this.workspace_.scale, e.y / this.workspace_.scale), this.workspace_.isMutator && e.scale(1 / this.workspace_.options.parentWorkspace.scale), e;
        }
        dragIcons_(e) {
          for (const t of this.dragIconData_)
            t.icon.onLocationChange(ae.sum(t.location, e));
        }
        getInsertionMarkers() {
          return this.draggedConnectionManager_ && this.draggedConnectionManager_.getInsertionMarkers ? this.draggedConnectionManager_.getInsertionMarkers() : [];
        }
      };
      i(se.BLOCK_DRAGGER, w_, dd);
      var _r = null, Kt = { duplicateInternal: LA, copyInternal: zi }, Wl = {};
      Wl.TEST_ONLY = Kt, Wl.copy = nl, Wl.duplicate = va, Wl.paste = zp;
      var I_ = null, Sd = {}, gc = null, J_ = {};
      J_.callbackFactory = r.callbackFactory$$module$build$src$core$contextmenu, J_.commentDeleteOption = Qp, J_.commentDuplicateOption = qp, J_.dispose = u_, J_.getCurrentBlock = gA, J_.hide = _l, J_.setCurrentBlock = Zp, J_.show = Cn, J_.workspaceCommentOption = OA;
      var ct = class {
        constructor() {
          this.registry_ = /* @__PURE__ */ new Map(), this.reset();
        }
        reset() {
          this.registry_.clear();
        }
        register(e) {
          if (this.registry_.has(e.id))
            throw Error('Menu item with ID "' + e.id + '" is already registered.');
          this.registry_.set(e.id, e);
        }
        unregister(e) {
          if (!this.registry_.has(e))
            throw Error('Menu item with ID "' + e + '" not found.');
          this.registry_.delete(e);
        }
        getItem(e) {
          let t;
          return (t = this.registry_.get(e)) != null ? t : null;
        }
        getContextMenuOptions(e, t) {
          const n = [];
          for (const c of this.registry_.values())
            if (e === c.scopeType) {
              var o = c.preconditionFn(t);
              o !== "hidden" && (o = { text: typeof c.displayText == "function" ? c.displayText(t) : c.displayText, enabled: o === "enabled", callback: c.callback, scope: t, weight: c.weight }, n.push(o));
            }
          return n.sort(function(c, A) {
            return c.weight - A.weight;
          }), n;
        }
      };
      (function(e) {
        var t = e.ScopeType || (e.ScopeType = {});
        t.BLOCK = "block", t.WORKSPACE = "workspace", e.registry = new e();
      })(ct || (ct = {})), ct.ScopeType;
      var hd = 30, fc = !0, dT = [];
      dT[Ie.INPUT_VALUE] = Ie.OUTPUT_VALUE, dT[Ie.OUTPUT_VALUE] = Ie.INPUT_VALUE, dT[Ie.NEXT_STATEMENT] = Ie.PREVIOUS_STATEMENT, dT[Ie.PREVIOUS_STATEMENT] = Ie.NEXT_STATEMENT;
      var M_ = "RENAME_VARIABLE_ID", Nc = "DELETE_VARIABLE_ID", ne = class {
        constructor(e, t, n) {
          if (this.wsCoordinate = null, !t)
            throw Error("Cannot create a node without a location.");
          this.type = e, this.isConnectionLocation = ne.isConnectionType(e), this.location = t, this.processParams(n || null);
        }
        processParams(e) {
          e && e.wsCoordinate && (this.wsCoordinate = e.wsCoordinate);
        }
        getLocation() {
          return this.location;
        }
        getType() {
          return this.type;
        }
        getWsCoordinate() {
          return this.wsCoordinate;
        }
        isConnection() {
          return this.isConnectionLocation;
        }
        findNextForInput() {
          var e = this.location.getParentInput();
          const t = e.getSourceBlock();
          for (e = t.inputList.indexOf(e), e += 1; e < t.inputList.length; e++) {
            const n = t.inputList[e], o = n.fieldRow;
            for (let c = 0; c < o.length; c++) {
              const A = o[c];
              if (A.isClickable() || ne.NAVIGATE_ALL_FIELDS)
                return ne.createFieldNode(A);
            }
            if (n.connection)
              return ne.createInputNode(n);
          }
          return null;
        }
        findNextForField() {
          var e = this.location, t = e.getParentInput();
          const n = e.getSourceBlock();
          if (!n)
            throw Error("The current AST location is not associated with a block");
          var o = n.inputList.indexOf(t);
          for (e = t.fieldRow.indexOf(e) + 1; o < n.inputList.length; o++) {
            t = n.inputList[o];
            const c = t.fieldRow;
            for (; e < c.length; ) {
              if (c[e].isClickable() || ne.NAVIGATE_ALL_FIELDS)
                return ne.createFieldNode(c[e]);
              e++;
            }
            if (e = 0, t.connection)
              return ne.createInputNode(t);
          }
          return null;
        }
        findPrevForInput() {
          const e = this.location.getParentInput(), t = e.getSourceBlock();
          for (var n = t.inputList.indexOf(e); 0 <= n; n--) {
            var o = t.inputList[n];
            if (o.connection && o !== e)
              return ne.createInputNode(o);
            o = o.fieldRow;
            for (let c = o.length - 1; 0 <= c; c--) {
              const A = o[c];
              if (A.isClickable() || ne.NAVIGATE_ALL_FIELDS)
                return ne.createFieldNode(A);
            }
          }
          return null;
        }
        findPrevForField() {
          var e = this.location;
          const t = e.getParentInput(), n = e.getSourceBlock();
          if (!n)
            throw Error("The current AST location is not associated with a block");
          var o = n.inputList.indexOf(t);
          for (e = t.fieldRow.indexOf(e) - 1; 0 <= o; o--) {
            var c = n.inputList[o];
            if (c.connection && c !== t)
              return ne.createInputNode(c);
            for (c = c.fieldRow; -1 < e; ) {
              if (c[e].isClickable() || ne.NAVIGATE_ALL_FIELDS)
                return ne.createFieldNode(c[e]);
              e--;
            }
            0 <= o - 1 && (e = n.inputList[o - 1].fieldRow.length - 1);
          }
          return null;
        }
        navigateBetweenStacks(e) {
          var t = this.getLocation();
          if (t.getSourceBlock) {
            var n = t.getSourceBlock();
            n && (t = n);
          }
          if (!t || t.isDeadOrDying())
            return null;
          n = t.getRootBlock(), t = n.workspace.getTopBlocks(!0);
          for (let o = 0; o < t.length; o++)
            if (n.id === t[o].id)
              return e = o + (e ? 1 : -1), e === -1 || e === t.length ? null : ne.createStackNode(t[e]);
          throw Error("Couldn't find " + (e ? "next" : "previous") + " stack?!");
        }
        findTopASTNodeForBlock(e) {
          const t = il(e);
          return t ? ne.createConnectionNode(t) : ne.createBlockNode(e);
        }
        getOutAstNodeForBlock(e) {
          if (!e)
            return null;
          e = e.getTopStackBlock();
          const t = il(e);
          return t && t.targetConnection && t.targetConnection.getParentInput() ? ne.createInputNode(t.targetConnection.getParentInput()) : ne.createStackNode(e);
        }
        findFirstFieldOrInput(e) {
          e = e.inputList;
          for (let t = 0; t < e.length; t++) {
            const n = e[t], o = n.fieldRow;
            for (let c = 0; c < o.length; c++) {
              const A = o[c];
              if (A.isClickable() || ne.NAVIGATE_ALL_FIELDS)
                return ne.createFieldNode(A);
            }
            if (n.connection)
              return ne.createInputNode(n);
          }
          return null;
        }
        getSourceBlock() {
          return this.getType() === ne.types.BLOCK ? this.getLocation() : this.getType() === ne.types.STACK ? this.getLocation() : this.getType() === ne.types.WORKSPACE ? null : this.getLocation().getSourceBlock();
        }
        next() {
          switch (this.type) {
            case ne.types.STACK:
              return this.navigateBetweenStacks(!0);
            case ne.types.OUTPUT:
              return ne.createBlockNode(this.location.getSourceBlock());
            case ne.types.FIELD:
              return this.findNextForField();
            case ne.types.INPUT:
              return this.findNextForInput();
            case ne.types.BLOCK:
              const e = this.location.nextConnection;
              if (!e)
                break;
              return ne.createConnectionNode(e);
            case ne.types.PREVIOUS:
              return ne.createBlockNode(this.location.getSourceBlock());
            case ne.types.NEXT:
              return ne.createConnectionNode(this.location.targetConnection);
          }
          return null;
        }
        in() {
          switch (this.type) {
            case ne.types.WORKSPACE:
              const e = this.location.getTopBlocks(!0);
              if (0 < e.length)
                return ne.createStackNode(e[0]);
              break;
            case ne.types.STACK:
              return this.findTopASTNodeForBlock(this.location);
            case ne.types.BLOCK:
              return this.findFirstFieldOrInput(this.location);
            case ne.types.INPUT:
              return ne.createConnectionNode(this.location.targetConnection);
          }
          return null;
        }
        prev() {
          switch (this.type) {
            case ne.types.STACK:
              return this.navigateBetweenStacks(!1);
            case ne.types.FIELD:
              return this.findPrevForField();
            case ne.types.INPUT:
              return this.findPrevForInput();
            case ne.types.BLOCK:
              var e = il(this.location);
              if (!e)
                break;
              return ne.createConnectionNode(e);
            case ne.types.PREVIOUS:
              if ((e = this.location.targetConnection) && !e.getParentInput())
                return ne.createConnectionNode(e);
              break;
            case ne.types.NEXT:
              return ne.createBlockNode(this.location.getSourceBlock());
          }
          return null;
        }
        out() {
          switch (this.type) {
            case ne.types.STACK:
              var e = this.location, t = e.getRelativeToSurfaceXY();
              return t = new ae(t.x, t.y + ne.DEFAULT_OFFSET_Y), ne.createWorkspaceNode(
                e.workspace,
                t
              );
            case ne.types.OUTPUT:
              return e = this.location, (t = e.targetConnection) ? ne.createConnectionNode(t) : ne.createStackNode(e.getSourceBlock());
            case ne.types.FIELD:
              if (e = this.location.getSourceBlock(), !e)
                throw Error("The current AST location is not associated with a block");
              return ne.createBlockNode(e);
            case ne.types.INPUT:
              return ne.createBlockNode(this.location.getSourceBlock());
            case ne.types.BLOCK:
              return this.getOutAstNodeForBlock(this.location);
            case ne.types.PREVIOUS:
              return this.getOutAstNodeForBlock(this.location.getSourceBlock());
            case ne.types.NEXT:
              return this.getOutAstNodeForBlock(this.location.getSourceBlock());
          }
          return null;
        }
        static isConnectionType(e) {
          switch (e) {
            case ne.types.PREVIOUS:
            case ne.types.NEXT:
            case ne.types.INPUT:
            case ne.types.OUTPUT:
              return !0;
          }
          return !1;
        }
        static createFieldNode(e) {
          return e ? new ne(ne.types.FIELD, e) : null;
        }
        static createConnectionNode(e) {
          if (!e)
            return null;
          const t = e.type;
          return t === Ie.INPUT_VALUE || t === Ie.NEXT_STATEMENT && e.getParentInput() ? ne.createInputNode(e.getParentInput()) : t === Ie.NEXT_STATEMENT ? new ne(ne.types.NEXT, e) : t === Ie.OUTPUT_VALUE ? new ne(ne.types.OUTPUT, e) : t === Ie.PREVIOUS_STATEMENT ? new ne(
            ne.types.PREVIOUS,
            e
          ) : null;
        }
        static createInputNode(e) {
          return e && e.connection ? new ne(ne.types.INPUT, e.connection) : null;
        }
        static createBlockNode(e) {
          return e ? new ne(ne.types.BLOCK, e) : null;
        }
        static createStackNode(e) {
          return e ? new ne(
            ne.types.STACK,
            e
          ) : null;
        }
        static createWorkspaceNode(e, t) {
          return t && e ? new ne(ne.types.WORKSPACE, e, { wsCoordinate: t }) : null;
        }
        static createTopNode(e) {
          const t = il(e);
          return t ? ne.createConnectionNode(t) : ne.createBlockNode(e);
        }
      };
      ne.NAVIGATE_ALL_FIELDS = !1, ne.DEFAULT_OFFSET_Y = -20, function(e) {
        e = e.types || (e.types = {}), e.FIELD = "field", e.BLOCK = "block", e.INPUT = "input", e.OUTPUT = "output", e.NEXT = "next", e.PREVIOUS = "previous", e.STACK = "stack", e.WORKSPACE = "workspace";
      }(ne || (ne = {}));
      var Vt = class {
        constructor() {
          this.drawer = this.curNode = this.colour = null, this.type = "marker";
        }
        setDrawer(e) {
          this.drawer = e;
        }
        getDrawer() {
          return this.drawer;
        }
        getCurNode() {
          return this.curNode;
        }
        setCurNode(e) {
          const t = this.curNode;
          this.curNode = e, this.drawer && this.drawer.draw(t, this.curNode);
        }
        draw() {
          this.drawer && this.drawer.draw(this.curNode, this.curNode);
        }
        hide() {
          this.drawer && this.drawer.hide();
        }
        dispose() {
          this.getDrawer() && this.getDrawer().dispose();
        }
      }, Gt = class extends Vt {
        constructor() {
          super(), this.type = "cursor";
        }
        next() {
          var e = this.getCurNode();
          if (!e)
            return null;
          for (e = e.next(); e && e.next() && (e.getType() === ne.types.NEXT || e.getType() === ne.types.BLOCK); )
            e = e.next();
          return e && this.setCurNode(e), e;
        }
        in() {
          var e = this.getCurNode();
          if (!e)
            return null;
          (e.getType() === ne.types.PREVIOUS || e.getType() === ne.types.OUTPUT) && (e = e.next());
          let t, n;
          return (e = (n = (t = e) == null ? void 0 : t.in()) != null ? n : null) && this.setCurNode(e), e;
        }
        prev() {
          var e = this.getCurNode();
          if (!e)
            return null;
          for (e = e.prev(); e && e.prev() && (e.getType() === ne.types.NEXT || e.getType() === ne.types.BLOCK); )
            e = e.prev();
          return e && this.setCurNode(e), e;
        }
        out() {
          var e = this.getCurNode();
          return e ? ((e = e.out()) && e.getType() === ne.types.BLOCK && (e = e.prev() || e), e && this.setCurNode(e), e) : null;
        }
      };
      i(se.CURSOR, w_, Gt);
      var Ss = class extends Gt {
        constructor() {
          super();
        }
        next() {
          var e = this.getCurNode();
          return e ? ((e = this.getNextNode_(e, this.validNode_)) && this.setCurNode(e), e) : null;
        }
        in() {
          return this.next();
        }
        prev() {
          var e = this.getCurNode();
          return e ? ((e = this.getPreviousNode_(e, this.validNode_)) && this.setCurNode(e), e) : null;
        }
        out() {
          return this.prev();
        }
        getNextNode_(e, t) {
          if (!e)
            return null;
          const n = e.in() || e.next();
          return t(n) ? n : n ? this.getNextNode_(n, t) : (e = this.findSiblingOrParent(e.out()), t(e) ? e : e ? this.getNextNode_(e, t) : null);
        }
        getPreviousNode_(e, t) {
          if (!e)
            return null;
          let n = e.prev();
          return n = n ? this.getRightMostChild(n) : e.out(), t(n) ? n : n ? this.getPreviousNode_(n, t) : null;
        }
        validNode_(e) {
          let t = !1;
          return e = e && e.getType(), (e === ne.types.OUTPUT || e === ne.types.INPUT || e === ne.types.FIELD || e === ne.types.NEXT || e === ne.types.PREVIOUS || e === ne.types.WORKSPACE) && (t = !0), t;
        }
        findSiblingOrParent(e) {
          if (!e)
            return null;
          const t = e.next();
          return t || this.findSiblingOrParent(e.out());
        }
        getRightMostChild(e) {
          if (!e.in())
            return e;
          for (e = e.in(); e && e.next(); )
            e = e.next();
          return this.getRightMostChild(e);
        }
      };
      Ss.registrationName = "basicCursor", i(se.CURSOR, Ss.registrationName, Ss);
      var Id = class extends Ss {
        validNode_(e) {
          let t = !1;
          const n = e && e.getType();
          return e && (e = e.getLocation(), n === ne.types.FIELD && e && e.isTabNavigable() && e.isClickable() && (t = !0)), t;
        }
      }, iE = 10, qr = class extends lt {
        constructor(e, t) {
          super(e, t), this.targetConnection = this.highlightPath = null, this.db = e.workspace.connectionDBList[t], this.dbOpposite = e.workspace.connectionDBList[dT[t]], this.offsetInBlock = new ae(0, 0), this.trackedState = qr.TrackedState.WILL_TRACK;
        }
        dispose() {
          super.dispose(), this.trackedState === qr.TrackedState.TRACKED && this.db.removeConnection(this, this.y);
        }
        getSourceBlock() {
          return super.getSourceBlock();
        }
        targetBlock() {
          return super.targetBlock();
        }
        distanceFrom(e) {
          const t = this.x - e.x;
          return e = this.y - e.y, Math.sqrt(t * t + e * e);
        }
        bumpAwayFrom(e) {
          if (!this.sourceBlock_.workspace.isDragging()) {
            var t = this.sourceBlock_.getRootBlock();
            if (!t.isInFlyout) {
              var n = !1;
              if (!t.isMovable()) {
                if (t = e.getSourceBlock().getRootBlock(), !t.isMovable())
                  return;
                e = this, n = !0;
              }
              var o = we() == t;
              o || t.addSelect();
              var c = e.x + r.config$$module$build$src$core$config.snapRadius + Math.floor(Math.random() * iE) - this.x, A = e.y + r.config$$module$build$src$core$config.snapRadius + Math.floor(Math.random() * iE) - this.y;
              n && (A = -A), t.RTL && (c = e.x - r.config$$module$build$src$core$config.snapRadius - Math.floor(Math.random() * iE) - this.x), t.moveBy(c, A, ["bump"]), o || t.removeSelect();
            }
          }
        }
        moveTo(e, t) {
          let n = !1;
          return this.trackedState === qr.TrackedState.WILL_TRACK ? (this.db.addConnection(this, t), this.trackedState = qr.TrackedState.TRACKED, n = !0) : this.trackedState === qr.TrackedState.TRACKED && (this.db.removeConnection(this, this.y), this.db.addConnection(this, t), n = !0), this.x = e, this.y = t, n;
        }
        moveBy(e, t) {
          return this.moveTo(this.x + e, this.y + t);
        }
        moveToOffset(e) {
          return this.moveTo(e.x + this.offsetInBlock.x, e.y + this.offsetInBlock.y);
        }
        setOffsetInBlock(e, t) {
          this.offsetInBlock.x = e, this.offsetInBlock.y = t;
        }
        getOffsetInBlock() {
          return this.offsetInBlock;
        }
        tighten() {
          const e = this.targetConnection.x - this.x, t = this.targetConnection.y - this.y;
          if (e !== 0 || t !== 0) {
            const o = this.targetBlock();
            var n = o.getSvgRoot();
            if (!n)
              throw Error("block is not rendered.");
            n = Ro(n), o.translate(n.x - e, n.y - t), o.moveConnections(-e, -t);
          }
        }
        tightenEfficiently() {
          var e = this.targetConnection;
          const t = this.targetBlock();
          e && t && (e = ae.difference(this.offsetInBlock, e.offsetInBlock), t.translate(e.x, e.y));
        }
        closest(e, t) {
          return this.dbOpposite.searchForClosest(this, e, t);
        }
        highlight() {
          if (!this.highlightPath) {
            var e = this.sourceBlock_.workspace.getRenderer().getConstants(), t = e.shapeFor(this);
            this.type === Ie.INPUT_VALUE || this.type === Ie.OUTPUT_VALUE ? (e = e.TAB_OFFSET_FROM_TOP, t = Wt(0, -e) + de("v", e) + t.pathDown + de("v", e)) : (e = e.NOTCH_OFFSET_LEFT - e.CORNER_RADIUS, t = Wt(-e, 0) + de("h", e) + t.pathLeft + de("h", e)), e = this.offsetInBlock, this.highlightPath = K(U.PATH, { class: "blocklyHighlightedConnectionPath", d: t, transform: `translate(${e.x}, ${e.y})` + (this.sourceBlock_.RTL ? " scale(-1 1)" : "") }, this.sourceBlock_.getSvgRoot());
          }
        }
        unhighlight() {
          this.highlightPath && (Tt(this.highlightPath), this.highlightPath = null);
        }
        setTracking(e) {
          e && this.trackedState === qr.TrackedState.TRACKED || !e && this.trackedState === qr.TrackedState.UNTRACKED || this.sourceBlock_.isInFlyout || (e ? (this.db.addConnection(this, this.y), this.trackedState = qr.TrackedState.TRACKED) : (this.trackedState === qr.TrackedState.TRACKED && this.db.removeConnection(
            this,
            this.y
          ), this.trackedState = qr.TrackedState.UNTRACKED));
        }
        stopTrackingAll() {
          if (this.setTracking(!1), this.targetConnection) {
            const e = this.targetBlock().getDescendants(!1);
            for (let t = 0; t < e.length; t++) {
              const n = e[t], o = n.getConnections_(!0);
              for (let c = 0; c < o.length; c++)
                o[c].setTracking(!1);
              for (const c of n.getIcons())
                Vi(c) && c.setBubbleVisible(!1);
            }
          }
        }
        startTrackingAll() {
          this.setTracking(!0);
          let e = [];
          if (this.type !== Ie.INPUT_VALUE && this.type !== Ie.NEXT_STATEMENT)
            return e;
          const t = this.targetBlock();
          if (t) {
            let n;
            t.isCollapsed() ? (n = [], t.outputConnection && n.push(t.outputConnection), t.nextConnection && n.push(t.nextConnection), t.previousConnection && n.push(t.previousConnection)) : n = t.getConnections_(!0);
            for (let o = 0; o < n.length; o++)
              e.push(...n[o].startTrackingAll());
            e.length || (e = [t]);
          }
          return e;
        }
        onFailedConnect(e) {
          const t = this.getSourceBlock();
          if (Cr()) {
            const n = r.getGroup$$module$build$src$core$events$utils();
            setTimeout((function() {
              t.isDisposed() || t.getParent() || (r.setGroup$$module$build$src$core$events$utils(n), this.bumpAwayFrom(e), r.setGroup$$module$build$src$core$events$utils(!1));
            }).bind(this), r.config$$module$build$src$core$config.bumpDelay);
          }
        }
        disconnectInternal(e = !0) {
          const { parentConnection: t, childConnection: n } = this.getParentAndChildConnections();
          if (t && n) {
            var o = t.getSourceBlock(), c = n.getSourceBlock();
            super.disconnectInternal(e), o.rendered && o.queueRender(), c.rendered && (c.updateDisabled(), c.queueRender(), c.getSvgRoot().style.display = "block");
          }
        }
        respawnShadow_() {
          super.respawnShadow_();
          const e = this.targetBlock();
          e && (e.initSvg(), e.queueRender());
        }
        neighbours(e) {
          return this.dbOpposite.getNeighbours(this, e);
        }
        connect_(e) {
          super.connect_(e);
          var t = this.getSourceBlock();
          e = e.getSourceBlock();
          const n = t.rendered, o = e.rendered;
          n && t.updateDisabled(), o && e.updateDisabled(), n && o && (this.type === Ie.NEXT_STATEMENT || this.type === Ie.PREVIOUS_STATEMENT ? e.queueRender() : t.queueRender()), (t = t.getInputWithBlock(e)) && (t = t.isVisible(), e.getSvgRoot().style.display = t ? "block" : "none");
        }
        onCheckChanged_() {
          !this.isConnected() || this.targetConnection && this.getConnectionChecker().canConnect(this, this.targetConnection, !1) || ((this.isSuperior() ? this.targetBlock() : this.sourceBlock_).unplug(), this.sourceBlock_.bumpNeighbours());
        }
      };
      (function(e) {
        e = e.TrackedState || (e.TrackedState = {}), e[e.WILL_TRACK = -1] = "WILL_TRACK", e[e.UNTRACKED = 0] = "UNTRACKED", e[e.TRACKED = 1] = "TRACKED";
      })(qr || (qr = {})), qr.TrackedState;
      var oE = 17, m_ = class extends uc {
        constructor(e) {
          super(e), this.sourceBlock = e, this.textMap = /* @__PURE__ */ new Map(), this.textBubble = null;
        }
        getType() {
          return m_.TYPE;
        }
        initView(e) {
          this.svgRoot || (super.initView(e), K(
            U.PATH,
            { class: "blocklyIconShape", d: "M2,15Q-1,15 0.5,12L6.5,1.7Q8,-1 9.5,1.7L15.5,12Q17,15 14,15z" },
            this.svgRoot
          ), K(U.PATH, { class: "blocklyIconSymbol", d: "m7,4.8v3.16l0.27,2.27h1.46l0.27,-2.27v-3.16z" }, this.svgRoot), K(U.RECT, { class: "blocklyIconSymbol", x: "7", y: "11", height: "2", width: "2" }, this.svgRoot));
        }
        dispose() {
          super.dispose();
          let e;
          (e = this.textBubble) == null || e.dispose();
        }
        getWeight() {
          return m_.WEIGHT;
        }
        getSize() {
          return new ht(
            oE,
            oE
          );
        }
        applyColour() {
          super.applyColour();
          let e;
          (e = this.textBubble) == null || e.setColour(this.sourceBlock.style.colourPrimary);
        }
        updateCollapsed() {
        }
        isShownWhenCollapsed() {
          return !0;
        }
        onLocationChange(e) {
          super.onLocationChange(e);
          let t;
          (t = this.textBubble) == null || t.setAnchorLocation(this.getAnchorLocation());
        }
        addMessage(e, t) {
          if (this.textMap.get(t) === e)
            return this;
          e ? this.textMap.set(t, e) : this.textMap.delete(t);
          let n;
          return (n = this.textBubble) == null || n.setText(this.getText()), this;
        }
        getText() {
          return [...this.textMap.values()].join(`
`);
        }
        onClick() {
          super.onClick(), this.setBubbleVisible(!this.bubbleIsVisible());
        }
        bubbleIsVisible() {
          return !!this.textBubble;
        }
        setBubbleVisible(e) {
          if (this.bubbleIsVisible() !== e) {
            if (e)
              this.textBubble = new mc(this.getText(), this.sourceBlock.workspace, this.getAnchorLocation(), this.getBubbleOwnerRect()), this.applyColour();
            else {
              let t;
              (t = this.textBubble) == null || t.dispose(), this.textBubble = null;
            }
            fe(new (ge(A_))(
              this.sourceBlock,
              e,
              "warning"
            ));
          }
        }
        getAnchorLocation() {
          const e = oE / 2;
          return ae.sum(this.workspaceLocation, new ae(e, e));
        }
        getBubbleOwnerRect() {
          const e = this.sourceBlock.getSvgRoot().getBBox();
          return new Dt(e.y, e.y + e.height, e.x, e.x + e.width);
        }
      };
      m_.TYPE = mr.WARNING, m_.WEIGHT = 2;
      var kn = class extends As {
        constructor(e, t, n) {
          super(e, t, n), this.width = this.height = 0, this.warningTextDb = /* @__PURE__ */ new Map(), this.warning = this.mutator = null, this.eventsInit_ = this.renderIsInProgress_ = this.visuallyDisabled = this.rendered = !1, this.translation = "", this.bumpNeighboursPid = 0, this.relativeCoords = new ae(0, 0), this.workspace = e, this.svgGroup_ = K(
            U.G,
            {}
          ), this.style = e.getRenderer().getConstants().getBlockStyle(null), this.pathObject = e.getRenderer().makePathObject(this.svgGroup_, this.style), e = this.pathObject.svgPath, e.tooltip = this, UT(e), this.svgGroup_.setAttribute("data-id", this.id), this.doInit_();
        }
        initSvg() {
          if (!this.workspace.rendered)
            throw TypeError("Workspace is headless.");
          for (let t = 0, n; n = this.inputList[t]; t++)
            n.init();
          for (var e of this.getIcons())
            e.initView(this.createIconPointerDownListener(e)), e.updateEditable();
          this.applyColour(), this.pathObject.updateMovable(this.isMovable()), e = this.getSvgRoot(), this.workspace.options.readOnly || this.eventsInit_ || !e || Pe(e, "pointerdown", this, this.onMouseDown_), this.eventsInit_ = !0, e.parentNode || this.workspace.getCanvas().appendChild(e);
        }
        getColourSecondary() {
          return this.style.colourSecondary;
        }
        getColourTertiary() {
          return this.style.colourTertiary;
        }
        select() {
          if (this.isShadow() && this.getParent())
            this.getParent().select();
          else if (we() !== this) {
            var e = null;
            if (we()) {
              e = we().id, r.disable$$module$build$src$core$events$utils();
              try {
                we().unselect();
              } finally {
                r.enable$$module$build$src$core$events$utils();
              }
            }
            e = new (ge(zn))(e, this.id, this.workspace.id), fe(e), ot(this), this.addSelect();
          }
        }
        unselect() {
          if (we() === this) {
            var e = new (ge(zn))(this.id, null, this.workspace.id);
            e.workspaceId = this.workspace.id, fe(e), ot(null), this.removeSelect();
          }
        }
        setParent(e) {
          const t = this.parentBlock_;
          if (e !== t) {
            wr(), super.setParent(e), Qt();
            var n = this.getSvgRoot();
            if (!this.workspace.isClearing && n) {
              var o = this.getRelativeToSurfaceXY();
              e ? e.getSvgRoot().appendChild(n) : t && (this.workspace.getCanvas().appendChild(n), this.translate(o.x, o.y)), this.applyColour();
            }
          }
        }
        getRelativeToSurfaceXY() {
          let e = 0, t = 0, n = this.getSvgRoot();
          if (n)
            do {
              const o = Ro(n);
              e += o.x, t += o.y, n = n.parentNode;
            } while (n && n !== this.workspace.getCanvas());
          return new ae(e, t);
        }
        moveBy(e, t, n) {
          if (this.parentBlock_)
            throw Error("Block has parent");
          const o = tt();
          let c = null;
          o && (c = new (ge(r.MOVE$$module$build$src$core$events$utils))(this), n && c.setReason(n)), n = this.getRelativeToSurfaceXY(), this.translate(n.x + e, n.y + t), this.moveConnections(e, t), o && c && (c.recordNew(), fe(c)), this.workspace.resizeContents();
        }
        translate(e, t) {
          this.translation = `translate(${e}, ${t})`, this.relativeCoords = new ae(e, t), this.getSvgRoot().setAttribute(
            "transform",
            this.getTranslation()
          );
        }
        getTranslation() {
          return this.translation;
        }
        moveTo(e, t) {
          const n = this.getRelativeToSurfaceXY();
          this.moveBy(e.x - n.x, e.y - n.y, t);
        }
        moveDuringDrag(e) {
          this.translate(e.x, e.y), this.getSvgRoot().setAttribute("transform", this.getTranslation());
        }
        clearTransformAttributes_() {
          this.getSvgRoot().removeAttribute("transform");
        }
        snapToGrid() {
          if (!(this.isDeadOrDying() || this.workspace.isDragging() || this.getParent() || this.isInFlyout)) {
            var e = this.workspace.getGrid();
            if (e && e.shouldSnap()) {
              var t = e.getSpacing(), n = t / 2, o = this.getRelativeToSurfaceXY();
              e = Math.round(Math.round((o.x - n) / t) * t + n - o.x), t = Math.round(Math.round((o.y - n) / t) * t + n - o.y), (e || t) && this.moveBy(e, t, ["snap"]);
            }
          }
        }
        getBoundingRectangle() {
          const e = this.getRelativeToSurfaceXY(), t = this.getHeightWidth();
          let n, o;
          return this.RTL ? (n = e.x - t.width, o = e.x) : (n = e.x, o = e.x + t.width), new Dt(e.y, e.y + t.height, n, o);
        }
        markDirty() {
          this.pathObject.constants = this.workspace.getRenderer().getConstants();
          for (let e = 0, t; t = this.inputList[e]; e++)
            t.markDirty();
        }
        setCollapsed(e) {
          this.collapsed_ !== e && (super.setCollapsed(e), this.updateCollapsed_());
        }
        updateCollapsed_() {
          var e = this.isCollapsed();
          const t = Ts, n = Tc;
          for (let c = 0, A; A = this.inputList[c]; c++)
            A.name !== t && A.setVisible(!e);
          for (var o of this.getIcons())
            o.updateCollapsed();
          e ? (e = this.toString(hd), (o = this.getField(n)) ? o.setValue(e) : (this.getInput(t) || this.appendDummyInput(t)).appendField(
            new K_(e),
            n
          )) : (this.updateDisabled(), this.removeInput(t));
        }
        tab(e, t) {
          const n = new Id();
          n.setCurNode(ne.createFieldNode(e)), e = n.getCurNode(), t ? n.next() : n.prev(), (t = n.getCurNode()) && t !== e && (t.getLocation().showEditor(), this.workspace.keyboardAccessibilityMode && this.workspace.getCursor().setCurNode(t));
        }
        onMouseDown_(e) {
          const t = this.workspace.getGesture(e);
          t && t.handleBlockStart(e, this);
        }
        showHelp() {
          const e = typeof this.helpUrl == "function" ? this.helpUrl() : this.helpUrl;
          e && window.open(e);
        }
        generateContextMenu() {
          if (this.workspace.options.readOnly || !this.contextMenu)
            return null;
          const e = ct.registry.getContextMenuOptions(ct.ScopeType.BLOCK, { block: this });
          return this.customContextMenu && this.customContextMenu(e), e;
        }
        showContextMenu(e) {
          const t = this.generateContextMenu();
          t && t.length && (Cn(
            e,
            t,
            this.RTL
          ), Zp(this));
        }
        moveConnections(e, t) {
          if (this.rendered) {
            for (var n = this.getConnections_(!1), o = 0; o < n.length; o++)
              n[o].moveBy(e, t);
            n = this.getIcons(), o = this.getRelativeToSurfaceXY();
            for (var c of n)
              c.onLocationChange(o);
            for (c = 0; c < this.childBlocks_.length; c++)
              this.childBlocks_[c].moveConnections(e, t);
          }
        }
        setDragging(e) {
          e ? (this.translation = "", qT.push(...this.getConnections_(!0)), be(
            this.svgGroup_,
            "blocklyDragging"
          )) : (qT.length = 0, Be(this.svgGroup_, "blocklyDragging"));
          for (let t = 0; t < this.childBlocks_.length; t++)
            this.childBlocks_[t].setDragging(e);
        }
        setMovable(e) {
          super.setMovable(e), this.pathObject.updateMovable(e);
        }
        setEditable(e) {
          super.setEditable(e), e = this.getIcons();
          for (let t = 0; t < e.length; t++)
            e[t].updateEditable();
        }
        setShadow(e) {
          super.setShadow(e), this.applyColour();
        }
        setInsertionMarker(e) {
          this.isInsertionMarker_ !== e && (this.isInsertionMarker_ = e) && (this.setColour(this.workspace.getRenderer().getConstants().INSERTION_MARKER_COLOUR), this.pathObject.updateInsertionMarker(!0));
        }
        getSvgRoot() {
          return this.svgGroup_;
        }
        dispose(e, t) {
          this.isDeadOrDying() || (Sa(), _l(), t && this.rendered && (this.unplug(e), Xo(this)), super.dispose(!!e), Tt(this.svgGroup_));
        }
        disposeInternal() {
          this.isDeadOrDying() || (super.disposeInternal(), this.rendered = !1, we() === this && (this.unselect(), this.workspace.cancelCurrentGesture()), [...this.warningTextDb.values()].forEach((e) => clearTimeout(e)), this.warningTextDb.clear(), this.getIcons().forEach((e) => e.dispose()));
        }
        checkAndDelete() {
          this.workspace.isFlyout || (r.setGroup$$module$build$src$core$events$utils(!0), this.workspace.hideChaff(), this.outputConnection ? this.dispose(!1, !0) : this.dispose(!0, !0), r.setGroup$$module$build$src$core$events$utils(!1));
        }
        toCopyData() {
          return this.isInsertionMarker_ ? null : { saveInfo: l_(this, { addCoordinates: !0, addNextBlocks: !1 }), source: this.workspace, typeCounts: Rt(this, !0) };
        }
        applyColour() {
          this.pathObject.applyColour(this);
          const e = this.getIcons();
          for (let t = 0; t < e.length; t++)
            e[t].applyColour();
          for (let t = 0, n; n = this.inputList[t]; t++)
            for (let o = 0, c; c = n.fieldRow[o]; o++)
              c.applyColour();
        }
        updateDisabled() {
          const e = !this.isEnabled() || this.getInheritedDisabled();
          if (this.visuallyDisabled === e) {
            let t;
            (t = this.getNextBlock()) == null || t.updateDisabled();
          } else {
            this.applyColour(), this.visuallyDisabled = e;
            for (const t of this.getChildren(!1))
              t.updateDisabled();
          }
        }
        getCommentIcon() {
          dr("getCommentIcon", "v10", "v11", "getIcon");
          let e;
          return (e = this.getIcon(br.TYPE)) != null ? e : null;
        }
        setWarningText(e, t) {
          const n = t || "";
          if (n)
            this.warningTextDb.has(n) && (clearTimeout(this.warningTextDb.get(n)), this.warningTextDb.delete(n));
          else {
            for (var o of this.warningTextDb.values())
              clearTimeout(o);
            this.warningTextDb.clear();
          }
          if (this.workspace.isDragging())
            this.warningTextDb.set(n, setTimeout(() => {
              this.isDeadOrDying() || (this.warningTextDb.delete(n), this.setWarningText(e, n));
            }, 100));
          else if (this.isInFlyout && (e = null), t = this.getIcon(m_.TYPE), typeof e == "string") {
            o = this.getSurroundParent();
            let c = null;
            for (; o; )
              o.isCollapsed() && (c = o), o = o.getSurroundParent();
            c && c.setWarningText(
              r.Msg$$module$build$src$core$msg.COLLAPSED_WARNINGS_WARNING,
              kn.COLLAPSED_WARNING_ID
            ), t ? t.addMessage(e, n) : this.addIcon(new m_(this).addMessage(e, n));
          } else
            t && (n ? t.getText() || this.removeIcon(m_.TYPE) : this.removeIcon(m_.TYPE));
        }
        setMutator(e) {
          this.removeIcon(r.MutatorIcon$$module$build$src$core$icons$mutator_icon.TYPE), e && this.addIcon(e);
        }
        addIcon(e) {
          return super.addIcon(e), e instanceof m_ && (this.warning = e), e instanceof r.MutatorIcon$$module$build$src$core$icons$mutator_icon && (this.mutator = e), this.rendered && (e.initView(this.createIconPointerDownListener(e)), e.applyColour(), e.updateEditable(), this.render(), this.bumpNeighbours()), e;
        }
        createIconPointerDownListener(e) {
          return (t) => {
            this.isDeadOrDying() || (t = this.workspace.getGesture(t)) && t.setStartIcon(e);
          };
        }
        removeIcon(e) {
          const t = super.removeIcon(e);
          return e.equals(m_.TYPE) && (this.warning = null), e.equals(r.MutatorIcon$$module$build$src$core$icons$mutator_icon.TYPE) && (this.mutator = null), this.rendered && (this.render(), this.bumpNeighbours()), t;
        }
        setEnabled(e) {
          this.isEnabled() !== e && (super.setEnabled(e), this.rendered && !this.getInheritedDisabled() && this.updateDisabled());
        }
        setHighlighted(e) {
          this.rendered && this.pathObject.updateHighlighted(e);
        }
        addSelect() {
          this.pathObject.updateSelected(!0);
        }
        removeSelect() {
          this.pathObject.updateSelected(!1);
        }
        setDeleteStyle(e) {
          this.pathObject.updateDraggingDelete(e);
        }
        getColour() {
          return this.style.colourPrimary;
        }
        setColour(e) {
          super.setColour(e), e = this.workspace.getRenderer().getConstants().getBlockStyleForColour(this.colour_), this.pathObject.setStyle(e.style), this.style = e.style, this.styleName_ = e.name, this.applyColour();
        }
        setStyle(e) {
          const t = this.workspace.getRenderer().getConstants().getBlockStyle(e);
          if (this.styleName_ = e, t)
            this.hat = t.hat, this.pathObject.setStyle(t), this.colour_ = t.colourPrimary, this.style = t, this.applyColour();
          else
            throw Error("Invalid style name: " + e);
        }
        bringToFront() {
          let e = this;
          do {
            const t = e.getSvgRoot(), n = t.parentNode, o = n.childNodes;
            o[o.length - 1] !== t && n.appendChild(t), e = e.getParent();
          } while (e);
        }
        setPreviousStatement(e, t) {
          super.setPreviousStatement(e, t), this.rendered && (this.queueRender(), this.bumpNeighbours());
        }
        setNextStatement(e, t) {
          super.setNextStatement(e, t), this.rendered && (this.queueRender(), this.bumpNeighbours());
        }
        setOutput(e, t) {
          super.setOutput(e, t), this.rendered && (this.queueRender(), this.bumpNeighbours());
        }
        setInputsInline(e) {
          super.setInputsInline(e), this.rendered && (this.queueRender(), this.bumpNeighbours());
        }
        removeInput(e, t) {
          return e = super.removeInput(
            e,
            t
          ), this.rendered && (this.queueRender(), this.bumpNeighbours()), e;
        }
        moveNumberedInputBefore(e, t) {
          super.moveNumberedInputBefore(e, t), this.rendered && (this.queueRender(), this.bumpNeighbours());
        }
        appendInput(e) {
          return super.appendInput(e), this.rendered && (this.queueRender(), this.bumpNeighbours()), e;
        }
        setConnectionTracking(e) {
          if (this.previousConnection && this.previousConnection.setTracking(e), this.outputConnection && this.outputConnection.setTracking(e), this.nextConnection) {
            this.nextConnection.setTracking(e);
            var t = this.nextConnection.targetBlock();
            t && t.setConnectionTracking(e);
          }
          if (!this.collapsed_)
            for (t = 0; t < this.inputList.length; t++) {
              var n = this.inputList[t].connection;
              n && (n.setTracking(e), (n = n.targetBlock()) && n.setConnectionTracking(e));
            }
        }
        getConnections_(e) {
          const t = [];
          if ((e || this.rendered) && (this.outputConnection && t.push(this.outputConnection), this.previousConnection && t.push(this.previousConnection), this.nextConnection && t.push(this.nextConnection), e || !this.collapsed_))
            for (let n = 0, o; o = this.inputList[n]; n++)
              o.connection && t.push(o.connection);
          return t;
        }
        lastConnectionInStack(e) {
          return super.lastConnectionInStack(e);
        }
        getMatchingConnection(e, t) {
          return super.getMatchingConnection(e, t);
        }
        makeConnection_(e) {
          return new qr(this, e);
        }
        getNextBlock() {
          return super.getNextBlock();
        }
        getPreviousBlock() {
          return super.getPreviousBlock();
        }
        bumpNeighbours() {
          if (!this.bumpNeighboursPid) {
            var e = r.getGroup$$module$build$src$core$events$utils();
            this.bumpNeighboursPid = setTimeout(() => {
              const t = r.getGroup$$module$build$src$core$events$utils();
              r.setGroup$$module$build$src$core$events$utils(e), this.getRootBlock().bumpNeighboursInternal(), r.setGroup$$module$build$src$core$events$utils(t), this.bumpNeighboursPid = 0;
            }, r.config$$module$build$src$core$config.bumpDelay);
          }
        }
        bumpNeighboursInternal() {
          const e = this.getRootBlock();
          if (!(this.isDeadOrDying() || this.workspace.isDragging() || e.isInFlyout))
            for (const t of this.getConnections_(!1)) {
              if (t.isSuperior()) {
                let n;
                (n = t.targetBlock()) == null || n.bumpNeighboursInternal();
              }
              for (const n of t.neighbours(r.config$$module$build$src$core$config.snapRadius))
                n.getSourceBlock().getRootBlock() !== e && (t.isConnected() && n.isConnected() || (t.isSuperior() ? n.bumpAwayFrom(t) : t.bumpAwayFrom(n)));
            }
        }
        scheduleSnapAndBump() {
          const e = r.getGroup$$module$build$src$core$events$utils();
          setTimeout(() => {
            r.setGroup$$module$build$src$core$events$utils(e), this.snapToGrid(), r.setGroup$$module$build$src$core$events$utils(!1);
          }, r.config$$module$build$src$core$config.bumpDelay / 2), this.bumpNeighbours();
        }
        positionNearConnection(e, t) {
          e.type !== Ie.NEXT_STATEMENT && e.type !== Ie.INPUT_VALUE || this.moveBy(t.x - e.x, t.y - e.y);
        }
        getFirstStatementConnection() {
          return super.getFirstStatementConnection();
        }
        getChildren(e) {
          return super.getChildren(e);
        }
        queueRender() {
          return ya(this);
        }
        render(e) {
          if (!this.renderIsInProgress_) {
            this.renderIsInProgress_ = !0;
            try {
              if (this.rendered = !0, wr(), this.isEnabled() || this.updateDisabled(), this.isCollapsed() && this.updateCollapsed_(), this.workspace.getRenderer().render(this), this.updateConnectionAndIconLocations(), e !== !1) {
                const t = this.getParent();
                t ? t.render(!0) : this.workspace.resizeContents();
              }
              Qt(), this.updateMarkers_();
            } finally {
              this.renderIsInProgress_ = !1;
            }
          }
        }
        renderEfficiently() {
          this.rendered = !0, wr(), this.isCollapsed() && this.updateCollapsed_(), this.workspace.getRenderer().render(this), this.tightenChildrenEfficiently(), Qt(), this.updateMarkers_();
        }
        tightenChildrenEfficiently() {
          for (const e of this.inputList) {
            const t = e.connection;
            t && t.tightenEfficiently();
          }
          this.nextConnection && this.nextConnection.tightenEfficiently();
        }
        updateMarkers_() {
          this.workspace.keyboardAccessibilityMode && this.pathObject.cursorSvg && this.workspace.getCursor().draw(), this.workspace.keyboardAccessibilityMode && this.pathObject.markerSvg && this.workspace.getMarker(fl.LOCAL_MARKER).draw();
          for (const e of this.inputList)
            for (const t of e.fieldRow)
              t.updateMarkers_();
        }
        updateConnectionAndIconLocations() {
          const e = this.getRelativeToSurfaceXY();
          this.previousConnection && this.previousConnection.moveToOffset(e), this.outputConnection && this.outputConnection.moveToOffset(e);
          for (let t = 0; t < this.inputList.length; t++) {
            const n = this.inputList[t].connection;
            n && (n.moveToOffset(e), n.isConnected() && n.tighten());
          }
          this.nextConnection && (this.nextConnection.moveToOffset(e), this.nextConnection.isConnected() && this.nextConnection.tighten());
          for (const t of this.getIcons())
            t.onLocationChange(e);
        }
        setCursorSvg(e) {
          this.pathObject.setCursorSvg(e);
        }
        setMarkerSvg(e) {
          this.pathObject.setMarkerSvg(e);
        }
        getHeightWidth() {
          let e = this.height, t = this.width;
          var n = this.getNextBlock();
          if (n) {
            n = n.getHeightWidth();
            const o = this.workspace.getRenderer().getConstants().NOTCH_HEIGHT;
            e += n.height - o, t = Math.max(t, n.width);
          }
          return { height: e, width: t };
        }
        fadeForReplacement(e) {
          this.pathObject.updateReplacementFade(e);
        }
        highlightShapeForInput(e, t) {
          this.pathObject.updateShapeForInputHighlight(e, t);
        }
      };
      kn.INLINE = -1, kn.COLLAPSED_WARNING_ID = "TEMP_COLLAPSED_WARNING_";
      var hs = {};
      hs.Bubble = Xe, hs.MiniWorkspaceBubble = Ci, hs.TextBubble = mc, hs.TextInputBubble = Qu;
      var Is = class {
        constructor(e, t) {
          this.bubble = e, this.workspace = t, this.dragTarget_ = null, this.wouldDeleteBubble_ = !1, this.startXY_ = this.bubble.getRelativeToSurfaceXY();
        }
        startBubbleDrag() {
          r.getGroup$$module$build$src$core$events$utils() || r.setGroup$$module$build$src$core$events$utils(!0), this.workspace.setResizesEnabled(!1), this.bubble.setAutoLayout && this.bubble.setAutoLayout(!1), this.bubble.setDragging && this.bubble.setDragging(!0);
        }
        dragBubble(e, t) {
          t = this.pixelsToWorkspaceUnits_(t), t = ae.sum(this.startXY_, t), this.bubble.moveDuringDrag(t), t = this.dragTarget_, this.dragTarget_ = this.workspace.getDragTarget(e), e = this.wouldDeleteBubble_, this.wouldDeleteBubble_ = this.shouldDelete_(this.dragTarget_), e !== this.wouldDeleteBubble_ && this.updateCursorDuringBubbleDrag_(), this.dragTarget_ !== t && (t && t.onDragExit(this.bubble), this.dragTarget_ && this.dragTarget_.onDragEnter(this.bubble)), this.dragTarget_ && this.dragTarget_.onDragOver(this.bubble);
        }
        shouldDelete_(e) {
          return e && this.workspace.getComponentManager().hasCapability(e.id, Lt.Capability.DELETE_AREA) ? e.wouldDelete(this.bubble, !1) : !1;
        }
        updateCursorDuringBubbleDrag_() {
          this.bubble.setDeleteStyle(this.wouldDeleteBubble_);
        }
        endBubbleDrag(e, t) {
          this.dragBubble(e, t), this.dragTarget_ && this.dragTarget_.shouldPreventMove(this.bubble) ? e = this.startXY_ : (e = this.pixelsToWorkspaceUnits_(t), e = ae.sum(this.startXY_, e)), this.bubble.moveTo(
            e.x,
            e.y
          ), this.dragTarget_ && this.dragTarget_.onDrop(this.bubble), this.wouldDeleteBubble_ ? (this.fireMoveEvent_(), this.bubble.dispose()) : (this.bubble.setDragging && this.bubble.setDragging(!1), this.fireMoveEvent_()), this.workspace.setResizesEnabled(!0), r.setGroup$$module$build$src$core$events$utils(!1);
        }
        fireMoveEvent_() {
          if (this.bubble instanceof yr) {
            const e = new (ge(Zn))(this.bubble);
            e.setOldCoordinate(this.startXY_), e.recordNew(), fe(e);
          }
        }
        pixelsToWorkspaceUnits_(e) {
          return e = new ae(e.x / this.workspace.scale, e.y / this.workspace.scale), this.workspace.isMutator && e.scale(1 / this.workspace.options.parentWorkspace.scale), e;
        }
      }, bc = class {
        canConnect(e, t, n, o) {
          return this.canConnectWithReason(e, t, n, o) === lt.CAN_CONNECT;
        }
        canConnectWithReason(e, t, n, o) {
          const c = this.doSafetyChecks(e, t);
          return c !== lt.CAN_CONNECT ? c : this.doTypeChecks(e, t) ? n && !this.doDragChecks(e, t, o || 0) ? lt.REASON_DRAG_CHECKS_FAILED : lt.CAN_CONNECT : lt.REASON_CHECKS_FAILED;
        }
        getErrorMessage(e, t, n) {
          switch (e) {
            case lt.REASON_SELF_CONNECTION:
              return "Attempted to connect a block to itself.";
            case lt.REASON_DIFFERENT_WORKSPACES:
              return "Blocks not on same workspace.";
            case lt.REASON_WRONG_TYPE:
              return "Attempt to connect incompatible types.";
            case lt.REASON_TARGET_NULL:
              return "Target connection is null.";
            case lt.REASON_CHECKS_FAILED:
              return "Connection checks failed. " + (t + " expected " + t.getCheck() + ", found " + n.getCheck());
            case lt.REASON_SHADOW_PARENT:
              return "Connecting non-shadow to shadow block.";
            case lt.REASON_DRAG_CHECKS_FAILED:
              return "Drag checks failed.";
            case lt.REASON_PREVIOUS_AND_OUTPUT:
              return "Block would have an output and a previous connection.";
            default:
              return "Unknown connection failure: this should never happen!";
          }
        }
        doSafetyChecks(e, t) {
          if (!e || !t)
            return lt.REASON_TARGET_NULL;
          let n, o, c;
          return e.isSuperior() ? (n = e.getSourceBlock(), o = t.getSourceBlock(), c = t) : (o = e.getSourceBlock(), n = t.getSourceBlock(), c = e, e = t), n === o ? lt.REASON_SELF_CONNECTION : c.type !== dT[e.type] ? lt.REASON_WRONG_TYPE : n.workspace !== o.workspace ? lt.REASON_DIFFERENT_WORKSPACES : n.isShadow() && !o.isShadow() ? lt.REASON_SHADOW_PARENT : c.type === Ie.OUTPUT_VALUE && o.previousConnection && o.previousConnection.isConnected() || c.type === Ie.PREVIOUS_STATEMENT && o.outputConnection && o.outputConnection.isConnected() ? lt.REASON_PREVIOUS_AND_OUTPUT : lt.CAN_CONNECT;
        }
        doTypeChecks(e, t) {
          if (e = e.getCheck(), t = t.getCheck(), !e || !t)
            return !0;
          for (let n = 0; n < e.length; n++)
            if (t.indexOf(e[n]) !== -1)
              return !0;
          return !1;
        }
        doDragChecks(e, t, n) {
          if (e.distanceFrom(t) > n || t.getSourceBlock().isInsertionMarker())
            return !1;
          switch (t.type) {
            case Ie.PREVIOUS_STATEMENT:
              return this.canConnectToPrevious_(e, t);
            case Ie.OUTPUT_VALUE:
              if (t.isConnected() && !t.targetBlock().isInsertionMarker() || e.isConnected())
                return !1;
              break;
            case Ie.INPUT_VALUE:
              if (t.isConnected() && !t.targetBlock().isMovable() && !t.targetBlock().isShadow())
                return !1;
              break;
            case Ie.NEXT_STATEMENT:
              if (t.isConnected() && !e.getSourceBlock().nextConnection && !t.targetBlock().isShadow() && t.targetBlock().nextConnection || t.targetBlock() && !t.targetBlock().isMovable() && !t.targetBlock().isShadow())
                return !1;
              break;
            default:
              return !1;
          }
          return qT.indexOf(t) === -1;
        }
        canConnectToPrevious_(e, t) {
          return e.targetConnection || qT.indexOf(t) !== -1 ? !1 : t.targetConnection ? (e = t.targetBlock(), e.isInsertionMarker() ? !e.getPreviousBlock() : !1) : !0;
        }
      };
      i(se.CONNECTION_CHECKER, w_, bc);
      var Ms = class {
        constructor(e) {
          this.connectionChecker = e, this.connections = [];
        }
        addConnection(e, t) {
          t = this.calculateIndexForYPos(t), this.connections.splice(t, 0, e);
        }
        findIndexOfConnection(e, t) {
          if (!this.connections.length)
            return -1;
          const n = this.calculateIndexForYPos(t);
          if (n >= this.connections.length)
            return -1;
          t = e.y;
          let o = n;
          for (; 0 <= o && this.connections[o].y === t; ) {
            if (this.connections[o] === e)
              return o;
            o--;
          }
          for (o = n; o < this.connections.length && this.connections[o].y === t; ) {
            if (this.connections[o] === e)
              return o;
            o++;
          }
          return -1;
        }
        calculateIndexForYPos(e) {
          if (!this.connections.length)
            return 0;
          let t = 0, n = this.connections.length;
          for (; t < n; ) {
            const o = Math.floor((t + n) / 2);
            if (this.connections[o].y < e)
              t = o + 1;
            else if (this.connections[o].y > e)
              n = o;
            else {
              t = o;
              break;
            }
          }
          return t;
        }
        removeConnection(e, t) {
          if (e = this.findIndexOfConnection(e, t), e === -1)
            throw Error("Unable to find connection in connectionDB.");
          this.connections.splice(e, 1);
        }
        getNeighbours(e, t) {
          function n(De) {
            const or = c - o[De].x, Ft = A - o[De].y;
            return Math.sqrt(or * or + Ft * Ft) <= t && q.push(o[De]), Ft < t;
          }
          const o = this.connections, c = e.x, A = e.y;
          e = 0;
          let D = o.length - 2, $ = D;
          for (; e < $; )
            o[$].y < A ? e = $ : D = $, $ = Math.floor((e + D) / 2);
          const q = [];
          if (D = e = $, o.length) {
            for (; 0 <= e && n(e); )
              e--;
            do
              D++;
            while (D < o.length && n(D));
          }
          return q;
        }
        isInYRange(e, t, n) {
          return Math.abs(this.connections[e].y - t) <= n;
        }
        searchForClosest(e, t, n) {
          if (!this.connections.length)
            return { connection: null, radius: t };
          const o = e.y, c = e.x;
          e.x = c + n.x, e.y = o + n.y;
          var A = this.calculateIndexForYPos(e.y);
          n = null;
          let D = t, $, q = A - 1;
          for (; 0 <= q && this.isInYRange(q, e.y, t); )
            $ = this.connections[q], this.connectionChecker.canConnect(e, $, !0, D) && (n = $, D = $.distanceFrom(e)), q--;
          for (; A < this.connections.length && this.isInYRange(A, e.y, t); )
            $ = this.connections[A], this.connectionChecker.canConnect(e, $, !0, D) && (n = $, D = $.distanceFrom(e)), A++;
          return e.x = c, e.y = o, { connection: n, radius: D };
        }
        static init(e) {
          const t = [];
          return t[Ie.INPUT_VALUE] = new Ms(e), t[Ie.OUTPUT_VALUE] = new Ms(e), t[Ie.NEXT_STATEMENT] = new Ms(e), t[Ie.PREVIOUS_STATEMENT] = new Ms(e), t;
        }
      }, Cc = class extends sT {
        constructor(e, t, n, o) {
          super(e), this.type = Mi, this.recordUndo = !1, e && (this.name = t, this.oldValue = n, this.newValue = o);
        }
        toJson() {
          const e = super.toJson();
          if (!this.name)
            throw Error("The changed field name is undefined. Either pass a name to the constructor, or call fromJson.");
          return e.name = this.name, e.oldValue = this.oldValue, e.newValue = this.newValue, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new Cc()), t.name = e.name, t.oldValue = e.oldValue, t.newValue = e.newValue, t;
        }
        isNull() {
          return this.oldValue === this.newValue;
        }
      };
      i(se.EVENT, Mi, Cc);
      var ms = class extends sT {
        constructor(e) {
          super(e), this.type = r.MOVE$$module$build$src$core$events$utils, e && (e.isShadow() && (this.recordUndo = !1), e = this.currentLocation_(), this.oldParentId = e.parentId, this.oldInputName = e.inputName, this.oldCoordinate = e.coordinate);
        }
        toJson() {
          const e = super.toJson();
          return e.oldParentId = this.oldParentId, e.oldInputName = this.oldInputName, this.oldCoordinate && (e.oldCoordinate = `${Math.round(this.oldCoordinate.x)}, ${Math.round(this.oldCoordinate.y)}`), e.newParentId = this.newParentId, e.newInputName = this.newInputName, this.newCoordinate && (e.newCoordinate = `${Math.round(this.newCoordinate.x)}, ${Math.round(this.newCoordinate.y)}`), this.reason && (e.reason = this.reason), this.recordUndo || (e.recordUndo = this.recordUndo), e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new ms()), t.oldParentId = e.oldParentId, t.oldInputName = e.oldInputName, e.oldCoordinate && (n = e.oldCoordinate.split(","), t.oldCoordinate = new ae(Number(n[0]), Number(n[1]))), t.newParentId = e.newParentId, t.newInputName = e.newInputName, e.newCoordinate && (n = e.newCoordinate.split(","), t.newCoordinate = new ae(Number(n[0]), Number(n[1]))), e.reason !== void 0 && (t.reason = e.reason), e.recordUndo !== void 0 && (t.recordUndo = e.recordUndo), t;
        }
        recordNew() {
          const e = this.currentLocation_();
          this.newParentId = e.parentId, this.newInputName = e.inputName, this.newCoordinate = e.coordinate;
        }
        setReason(e) {
          this.reason = e;
        }
        currentLocation_() {
          var e = this.getEventWorkspace_();
          if (!this.blockId)
            throw Error("The block ID is undefined. Either pass a block to the constructor, or call fromJson");
          var t = e.getBlockById(this.blockId);
          if (!t)
            throw Error("The block associated with the block move event could not be found");
          e = {};
          const n = t.getParent();
          return n ? (e.parentId = n.id, (t = n.getInputWithBlock(t)) && (e.inputName = t.name)) : e.coordinate = t.getRelativeToSurfaceXY(), e;
        }
        isNull() {
          return this.oldParentId === this.newParentId && this.oldInputName === this.newInputName && ae.equals(this.oldCoordinate, this.newCoordinate);
        }
        run(e) {
          var t = this.getEventWorkspace_();
          if (!this.blockId)
            throw Error("The block ID is undefined. Either pass a block to the constructor, or call fromJson");
          var n = t.getBlockById(this.blockId);
          if (n) {
            var o = e ? this.newParentId : this.oldParentId, c = e ? this.newInputName : this.oldInputName;
            if (e = e ? this.newCoordinate : this.oldCoordinate, o) {
              var A = t.getBlockById(o);
              if (!A) {
                console.warn("Can't connect to non-existent block: " + o);
                return;
              }
            }
            if (n.getParent() && n.unplug(), e)
              c = n.getRelativeToSurfaceXY(), n.moveBy(e.x - c.x, e.y - c.y, this.reason);
            else {
              t = n.outputConnection, (!t || n.previousConnection && n.previousConnection.isConnected()) && (t = n.previousConnection);
              let D, $;
              n = ($ = t) == null ? void 0 : $.type, c ? (n = A.getInput(c)) && (D = n.connection) : n === Ie.PREVIOUS_STATEMENT && (D = A.nextConnection), D && t ? t.connect(D) : console.warn("Can't connect to non-existent input: " + c);
            }
          } else
            console.warn("Can't move non-existent block: " + this.blockId);
        }
      };
      i(se.EVENT, r.MOVE$$module$build$src$core$events$utils, ms);
      var en = class extends V_ {
        constructor(e, t, n) {
          super(e ? e.workspace.id : void 0), this.type = A_, e && (this.blockId = e.id, this.isOpen = t, this.bubbleType = n);
        }
        toJson() {
          const e = super.toJson();
          if (this.isOpen === void 0)
            throw Error("Whether this event is for opening the bubble is undefined. Either pass the value to the constructor, or call fromJson");
          if (!this.bubbleType)
            throw Error("The type of bubble is undefined. Either pass the value to the constructor, or call fromJson");
          return e.isOpen = this.isOpen, e.bubbleType = this.bubbleType, e.blockId = this.blockId || "", e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new en()), t.isOpen = e.isOpen, t.bubbleType = e.bubbleType, t.blockId = e.blockId, t;
        }
      }, uo;
      (function(e) {
        e.MUTATOR = "mutator", e.COMMENT = "comment", e.WARNING = "warning";
      })(uo || (uo = {})), i(se.EVENT, A_, en);
      var TE = class extends V_ {
        constructor(e, t, n) {
          t = e ? e.workspace.id : t, t === null && (t = void 0), super(t), this.type = B_, this.blockId = e ? e.id : void 0, this.targetType = n;
        }
        toJson() {
          const e = super.toJson();
          if (!this.targetType)
            throw Error("The click target type is undefined. Either pass a block to the constructor, or call fromJson");
          return e.targetType = this.targetType, e.blockId = this.blockId, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new TE()), t.targetType = e.targetType, t.blockId = e.blockId, t;
        }
      }, sE;
      (function(e) {
        e.BLOCK = "block", e.WORKSPACE = "workspace", e.ZOOM_CONTROLS = "zoom_controls";
      })(sE || (sE = {})), i(se.EVENT, B_, TE);
      var Eo = class extends _T {
        constructor(e) {
          super(), this.isBlank = !e, e && (this.commentId = e.id, this.workspaceId = e.workspace.id, this.group = r.getGroup$$module$build$src$core$events$utils(), this.recordUndo = Cr());
        }
        toJson() {
          const e = super.toJson();
          if (!this.commentId)
            throw Error("The comment ID is undefined. Either pass a comment to the constructor, or call fromJson");
          return e.commentId = this.commentId, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new Eo()), t.commentId = e.commentId, t;
        }
        static CommentCreateDeleteHelper(e, t) {
          var n = e.getEventWorkspace_();
          if (t) {
            if (t = r.createElement$$module$build$src$core$utils$xml("xml"), !e.xml)
              throw Error("Ecountered a comment event without proper xml");
            t.appendChild(e.xml), r.domToWorkspace$$module$build$src$core$xml(t, n);
          } else {
            if (!e.commentId)
              throw Error("The comment ID is undefined. Either pass a comment to the constructor, or call fromJson");
            (n = n.getCommentById(e.commentId)) ? n.dispose() : console.warn("Can't uncreate non-existent comment: " + e.commentId);
          }
        }
      }, lE = class extends Eo {
        constructor(e, t, n) {
          super(e), this.type = qo, e && (this.oldContents_ = typeof t > "u" ? "" : t, this.newContents_ = typeof n > "u" ? "" : n);
        }
        toJson() {
          const e = super.toJson();
          if (!this.oldContents_)
            throw Error("The old contents is undefined. Either pass a value to the constructor, or call fromJson");
          if (!this.newContents_)
            throw Error("The new contents is undefined. Either pass a value to the constructor, or call fromJson");
          return e.oldContents = this.oldContents_, e.newContents = this.newContents_, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new lE()), t.oldContents_ = e.oldContents, t.newContents_ = e.newContents, t;
        }
        isNull() {
          return this.oldContents_ === this.newContents_;
        }
        run(e) {
          var t = this.getEventWorkspace_();
          if (!this.commentId)
            throw Error("The comment ID is undefined. Either pass a comment to the constructor, or call fromJson");
          if (t = t.getCommentById(this.commentId)) {
            var n = e ? this.newContents_ : this.oldContents_;
            if (!n)
              throw Error(e ? "The new contents is undefined. Either pass a value to the constructor, or call fromJson" : "The old contents is undefined. Either pass a value to the constructor, or call fromJson");
            t.setContent(n);
          } else
            console.warn("Can't change non-existent comment: " + this.commentId);
        }
      };
      i(se.EVENT, qo, lE);
      var aE = class extends Eo {
        constructor(e) {
          super(e), this.type = Zr, e && (this.xml = e.toXmlWithXY());
        }
        toJson() {
          const e = super.toJson();
          if (!this.xml)
            throw Error("The comment XML is undefined. Either pass a comment to the constructor, or call fromJson");
          return e.xml = W_(this.xml), e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(
            e,
            t,
            n ?? new aE()
          ), t.xml = r.textToDom$$module$build$src$core$utils$xml(e.xml), t;
        }
        run(e) {
          Eo.CommentCreateDeleteHelper(this, e);
        }
      };
      i(se.EVENT, Zr, aE);
      var Oc = class extends Eo {
        constructor(e) {
          super(e), this.type = _o, e && (this.xml = e.toXmlWithXY());
        }
        run(e) {
          Eo.CommentCreateDeleteHelper(this, !e);
        }
        toJson() {
          const e = super.toJson();
          if (!this.xml)
            throw Error("The comment XML is undefined. Either pass a comment to the constructor, or call fromJson");
          return e.xml = W_(this.xml), e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new Oc()), t.xml = r.textToDom$$module$build$src$core$utils$xml(e.xml), t;
        }
      };
      i(se.EVENT, _o, Oc);
      var P_ = class extends Eo {
        constructor(e) {
          super(e), this.type = Zn, e && (this.comment_ = e, this.oldCoordinate_ = e.getRelativeToSurfaceXY());
        }
        recordNew() {
          if (this.newCoordinate_)
            throw Error("Tried to record the new position of a comment on the same event twice.");
          if (!this.comment_)
            throw Error("The comment is undefined. Pass a comment to the constructor if you want to use the record functionality");
          this.newCoordinate_ = this.comment_.getRelativeToSurfaceXY();
        }
        setOldCoordinate(e) {
          this.oldCoordinate_ = e;
        }
        toJson() {
          const e = super.toJson();
          if (!this.oldCoordinate_)
            throw Error("The old comment position is undefined. Either pass a comment to the constructor, or call fromJson");
          if (!this.newCoordinate_)
            throw Error("The new comment position is undefined. Either call recordNew, or call fromJson");
          return e.oldCoordinate = `${Math.round(this.oldCoordinate_.x)}, ${Math.round(this.oldCoordinate_.y)}`, e.newCoordinate = Math.round(this.newCoordinate_.x) + "," + Math.round(this.newCoordinate_.y), e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new P_()), n = e.oldCoordinate.split(","), t.oldCoordinate_ = new ae(Number(n[0]), Number(n[1])), n = e.newCoordinate.split(","), t.newCoordinate_ = new ae(Number(n[0]), Number(n[1])), t;
        }
        isNull() {
          return ae.equals(
            this.oldCoordinate_,
            this.newCoordinate_
          );
        }
        run(e) {
          var t = this.getEventWorkspace_();
          if (!this.commentId)
            throw Error("The comment ID is undefined. Either pass a comment to the constructor, or call fromJson");
          if (t = t.getCommentById(this.commentId)) {
            if (e = e ? this.newCoordinate_ : this.oldCoordinate_, !e)
              throw Error("Either oldCoordinate_ or newCoordinate_ is undefined. Either pass a comment to the constructor and call recordNew, or call fromJson");
            var n = t.getRelativeToSurfaceXY();
            t.moveBy(e.x - n.x, e.y - n.y);
          } else
            console.warn("Can't move non-existent comment: " + this.commentId);
        }
      };
      i(se.EVENT, Zn, P_);
      var Ke = class extends V_ {
        constructor(e, t, n, o) {
          let c = e ? e.workspace.id : void 0;
          o && o.getType() === ne.types.WORKSPACE && (c = o.getLocation().id), super(c), this.type = eo, this.blockId = e == null ? void 0 : e.id, this.oldNode = n || void 0, this.newNode = o, this.isCursor = t;
        }
        toJson() {
          const e = super.toJson();
          if (this.isCursor === void 0)
            throw Error("Whether this is a cursor event or not is undefined. Either pass a value to the constructor, or call fromJson");
          if (!this.newNode)
            throw Error("The new node is undefined. Either pass a node to the constructor, or call fromJson");
          return e.isCursor = this.isCursor, e.blockId = this.blockId, e.oldNode = this.oldNode, e.newNode = this.newNode, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new Ke()), t.isCursor = e.isCursor, t.blockId = e.blockId, t.oldNode = e.oldNode, t.newNode = e.newNode, t;
        }
      };
      i(se.EVENT, eo, Ke);
      var Rc = class extends V_ {
        constructor(e, t) {
          super(t), this.type = vn, this.themeName = e;
        }
        toJson() {
          const e = super.toJson();
          if (!this.themeName)
            throw Error("The theme name is undefined. Either pass a theme name to the constructor, or call fromJson");
          return e.themeName = this.themeName, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new Rc()), t.themeName = e.themeName, t;
        }
      };
      i(se.EVENT, vn, Rc);
      var Pn = class extends V_ {
        constructor(e, t, n) {
          super(n), this.type = ro, this.oldItem = e ?? void 0, this.newItem = t ?? void 0;
        }
        toJson() {
          const e = super.toJson();
          return e.oldItem = this.oldItem, e.newItem = this.newItem, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new Pn()), t.oldItem = e.oldItem, t.newItem = e.newItem, t;
        }
      };
      i(se.EVENT, ro, Pn);
      var yc = class extends V_ {
        constructor(e, t) {
          super(t), this.type = to, this.isOpen = e;
        }
        toJson() {
          const e = super.toJson();
          if (this.isOpen === void 0)
            throw Error("Whether this is already open or not is undefined. Either pass a value to the constructor, or call fromJson");
          return e.isOpen = this.isOpen, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new yc()), t.isOpen = e.isOpen, t;
        }
      };
      i(se.EVENT, to, yc);
      var cE = class extends iT {
        constructor(e) {
          super(e), this.type = Mr, e && (this.varType = e.type, this.varName = e.name);
        }
        toJson() {
          const e = super.toJson();
          if (this.varType === void 0)
            throw Error("The var type is undefined. Either pass a variable to the constructor, or call fromJson");
          if (!this.varName)
            throw Error("The var name is undefined. Either pass a variable to the constructor, or call fromJson");
          return e.varType = this.varType, e.varName = this.varName, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new cE()), t.varType = e.varType, t.varName = e.varName, t;
        }
        run(e) {
          const t = this.getEventWorkspace_();
          if (!this.varId)
            throw Error("The var ID is undefined. Either pass a variable to the constructor, or call fromJson");
          if (!this.varName)
            throw Error("The var name is undefined. Either pass a variable to the constructor, or call fromJson");
          e ? t.deleteVariableById(this.varId) : t.createVariable(this.varName, this.varType, this.varId);
        }
      };
      i(se.EVENT, Mr, cE);
      var At = class extends iT {
        constructor(e, t) {
          super(e), this.type = yn, e && (this.oldName = e.name, this.newName = typeof t > "u" ? "" : t);
        }
        toJson() {
          const e = super.toJson();
          if (!this.oldName)
            throw Error("The old var name is undefined. Either pass a variable to the constructor, or call fromJson");
          if (!this.newName)
            throw Error("The new var name is undefined. Either pass a value to the constructor, or call fromJson");
          return e.oldName = this.oldName, e.newName = this.newName, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new At()), t.oldName = e.oldName, t.newName = e.newName, t;
        }
        run(e) {
          const t = this.getEventWorkspace_();
          if (!this.varId)
            throw Error("The var ID is undefined. Either pass a variable to the constructor, or call fromJson");
          if (!this.oldName)
            throw Error("The old var name is undefined. Either pass a variable to the constructor, or call fromJson");
          if (!this.newName)
            throw Error("The new var name is undefined. Either pass a value to the constructor, or call fromJson");
          e ? t.renameVariableById(this.varId, this.newName) : t.renameVariableById(this.varId, this.oldName);
        }
      };
      i(se.EVENT, yn, At);
      var pE = class extends V_ {
        constructor(e, t, n, o, c) {
          super(o), this.type = no, this.viewTop = e, this.viewLeft = t, this.scale = n, this.oldScale = c;
        }
        toJson() {
          const e = super.toJson();
          if (this.viewTop === void 0)
            throw Error("The view top is undefined. Either pass a value to the constructor, or call fromJson");
          if (this.viewLeft === void 0)
            throw Error("The view left is undefined. Either pass a value to the constructor, or call fromJson");
          if (this.scale === void 0)
            throw Error("The scale is undefined. Either pass a value to the constructor, or call fromJson");
          if (this.oldScale === void 0)
            throw Error("The old scale is undefined. Either pass a value to the constructor, or call fromJson");
          return e.viewTop = this.viewTop, e.viewLeft = this.viewLeft, e.scale = this.scale, e.oldScale = this.oldScale, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new pE()), t.viewTop = e.viewTop, t.viewLeft = e.viewLeft, t.scale = e.scale, t.oldScale = e.oldScale, t;
        }
      };
      i(se.EVENT, no, pE), r.CHANGE$$module$build$src$core$events$utils, r.CREATE$$module$build$src$core$events$utils, r.DELETE$$module$build$src$core$events$utils, r.MOVE$$module$build$src$core$events$utils, r.CHANGE$$module$build$src$core$events$utils, r.CREATE$$module$build$src$core$events$utils, r.DELETE$$module$build$src$core$events$utils, r.MOVE$$module$build$src$core$events$utils, r.disable$$module$build$src$core$events$utils, r.enable$$module$build$src$core$events$utils, r.getGroup$$module$build$src$core$events$utils, r.setGroup$$module$build$src$core$events$utils;
      var he = {};
      he.Abstract = _T, he.BLOCK_CHANGE = r.CHANGE$$module$build$src$core$events$utils, he.BLOCK_CREATE = r.CREATE$$module$build$src$core$events$utils, he.BLOCK_DELETE = r.DELETE$$module$build$src$core$events$utils, he.BLOCK_DRAG = qi, he.BLOCK_FIELD_INTERMEDIATE_CHANGE = Mi, he.BLOCK_MOVE = r.MOVE$$module$build$src$core$events$utils, he.BUBBLE_OPEN = A_, he.BUMP_EVENTS = Ka, he.BlockBase = sT, he.BlockChange = lo, he.BlockCreate = wu, he.BlockDelete = oc, he.BlockDrag = rE, he.BlockFieldIntermediateChange = Cc, he.BlockMove = ms, he.BubbleOpen = en, he.BubbleType = uo, he.CHANGE = r.CHANGE$$module$build$src$core$events$utils, he.CLICK = B_, he.COMMENT_CHANGE = qo, he.COMMENT_CREATE = Zr, he.COMMENT_DELETE = _o, he.COMMENT_MOVE = Zn, he.CREATE = r.CREATE$$module$build$src$core$events$utils, he.Click = TE, he.ClickTarget = sE, he.CommentBase = Eo, he.CommentChange = lE, he.CommentCreate = aE, he.CommentDelete = Oc, he.CommentMove = P_, he.DELETE = r.DELETE$$module$build$src$core$events$utils, he.FINISHED_LOADING = eT, he.FinishedLoading = qA, he.MARKER_MOVE = eo, he.MOVE = r.MOVE$$module$build$src$core$events$utils, he.MarkerMove = Ke, he.SELECTED = zn, he.Selected = S_, he.THEME_CHANGE = vn, he.TOOLBOX_ITEM_SELECT = ro, he.TRASHCAN_OPEN = to, he.ThemeChange = Rc, he.ToolboxItemSelect = Pn, he.TrashcanOpen = yc, he.UI = ts, he.UiBase = V_, he.VAR_CREATE = mi, he.VAR_DELETE = Mr, he.VAR_RENAME = yn, he.VIEWPORT_CHANGE = no, he.VarBase = iT, he.VarCreate = Nu, he.VarDelete = cE, he.VarRename = At, he.ViewportChange = pE, he.clearPendingUndo = ii, he.disable = r.disable$$module$build$src$core$events$utils, he.disableOrphans = Vn, he.enable = r.enable$$module$build$src$core$events$utils, he.filter = Ar, he.fire = fe, he.fromJson = bo, he.get = ge, he.getDescendantIds = oi, he.getGroup = r.getGroup$$module$build$src$core$events$utils, he.getRecordUndo = Cr, he.isEnabled = tt, he.setGroup = r.setGroup$$module$build$src$core$events$utils, he.setRecordUndo = ur;
      var Ao = class {
        constructor() {
          this.NO_PADDING = 0, this.SMALL_PADDING = 3, this.MEDIUM_PADDING = 5, this.MEDIUM_LARGE_PADDING = 8, this.LARGE_PADDING = 10, this.TAB_HEIGHT = 15, this.TAB_OFFSET_FROM_TOP = 5, this.TAB_VERTICAL_OVERLAP = 2.5, this.TAB_WIDTH = 8, this.NOTCH_WIDTH = 15, this.NOTCH_HEIGHT = 4, this.MIN_BLOCK_WIDTH = 12, this.EMPTY_BLOCK_SPACER_HEIGHT = 16, this.CORNER_RADIUS = 8, this.NOTCH_OFFSET_LEFT = 15, this.STATEMENT_BOTTOM_SPACER = 0, this.STATEMENT_INPUT_PADDING_LEFT = 20, this.BETWEEN_STATEMENT_PADDING_Y = 4, this.ADD_START_HATS = !1, this.START_HAT_HEIGHT = 15, this.START_HAT_WIDTH = 100, this.SPACER_DEFAULT_HEIGHT = 15, this.MIN_BLOCK_HEIGHT = 24, this.EMPTY_INLINE_INPUT_PADDING = 14.5, this.EXTERNAL_VALUE_INPUT_PADDING = 2, this.JAGGED_TEETH_HEIGHT = 12, this.JAGGED_TEETH_WIDTH = 6, this.FIELD_TEXT_FONTSIZE = 11, this.FIELD_TEXT_FONTWEIGHT = "normal", this.FIELD_TEXT_FONTFAMILY = "sans-serif", this.FIELD_TEXT_BASELINE = this.FIELD_TEXT_HEIGHT = -1, this.FIELD_BORDER_RECT_RADIUS = 4, this.FIELD_BORDER_RECT_HEIGHT = 16, this.FIELD_BORDER_RECT_X_PADDING = 5, this.FIELD_BORDER_RECT_Y_PADDING = 3, this.FIELD_BORDER_RECT_COLOUR = "#fff", this.FIELD_DROPDOWN_SVG_ARROW = this.FIELD_DROPDOWN_COLOURED_DIV = this.FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW = !1, this.FIELD_DROPDOWN_SVG_ARROW_SIZE = 12, this.FIELD_COLOUR_FULL_BLOCK = this.FIELD_TEXTINPUT_BOX_SHADOW = !1, this.FIELD_COLOUR_DEFAULT_WIDTH = 26, this.defs = null, this.embossFilterId = "", this.embossFilter = null, this.disabledPatternId = "", this.disabledPattern = null, this.debugFilterId = "", this.cssNode = this.debugFilter = null, this.CURSOR_COLOUR = "#cc0a0a", this.MARKER_COLOUR = "#4286f4", this.CURSOR_WS_WIDTH = 100, this.WS_CURSOR_HEIGHT = 5, this.CURSOR_STACK_PADDING = 10, this.CURSOR_BLOCK_PADDING = 2, this.CURSOR_STROKE_WIDTH = 4, this.FULL_BLOCK_FIELDS = !1, this.INSERTION_MARKER_COLOUR = "#000000", this.INSERTION_MARKER_OPACITY = 0.2, this.SHAPES = { PUZZLE: 1, NOTCH: 2 }, this.TALL_INPUT_FIELD_OFFSET_Y = this.MEDIUM_PADDING, this.DUMMY_INPUT_SHADOW_MIN_HEIGHT = this.DUMMY_INPUT_MIN_HEIGHT = this.TAB_HEIGHT, this.STATEMENT_INPUT_NOTCH_OFFSET = this.NOTCH_OFFSET_LEFT, this.TOP_ROW_MIN_HEIGHT = this.MEDIUM_PADDING, this.TOP_ROW_PRECEDES_STATEMENT_MIN_HEIGHT = this.LARGE_PADDING, this.BOTTOM_ROW_MIN_HEIGHT = this.MEDIUM_PADDING, this.BOTTOM_ROW_AFTER_STATEMENT_MIN_HEIGHT = this.LARGE_PADDING, this.EMPTY_INLINE_INPUT_HEIGHT = this.TAB_HEIGHT + 11, this.EMPTY_STATEMENT_INPUT_HEIGHT = this.MIN_BLOCK_HEIGHT, this.START_POINT = Wt(0, 0), this.FIELD_TEXT_BASELINE_CENTER = !0, this.FIELD_DROPDOWN_BORDER_RECT_HEIGHT = this.FIELD_BORDER_RECT_HEIGHT, this.FIELD_DROPDOWN_SVG_ARROW_PADDING = this.FIELD_BORDER_RECT_X_PADDING, this.FIELD_DROPDOWN_SVG_ARROW_DATAURI = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMi43MSIgaGVpZ2h0PSI4Ljc5IiB2aWV3Qm94PSIwIDAgMTIuNzEgOC43OSI+PHRpdGxlPmRyb3Bkb3duLWFycm93PC90aXRsZT48ZyBvcGFjaXR5PSIwLjEiPjxwYXRoIGQ9Ik0xMi43MSwyLjQ0QTIuNDEsMi40MSwwLDAsMSwxMiw0LjE2TDguMDgsOC4wOGEyLjQ1LDIuNDUsMCwwLDEtMy40NSwwTDAuNzIsNC4xNkEyLjQyLDIuNDIsMCwwLDEsMCwyLjQ0LDIuNDgsMi40OCwwLDAsMSwuNzEuNzFDMSwwLjQ3LDEuNDMsMCw2LjM2LDBTMTEuNzUsMC40NiwxMiwuNzFBMi40NCwyLjQ0LDAsMCwxLDEyLjcxLDIuNDRaIiBmaWxsPSIjMjMxZjIwIi8+PC9nPjxwYXRoIGQ9Ik02LjM2LDcuNzlhMS40MywxLjQzLDAsMCwxLTEtLjQyTDEuNDIsMy40NWExLjQ0LDEuNDQsMCwwLDEsMC0yYzAuNTYtLjU2LDkuMzEtMC41Niw5Ljg3LDBhMS40NCwxLjQ0LDAsMCwxLDAsMkw3LjM3LDcuMzdBMS40MywxLjQzLDAsMCwxLDYuMzYsNy43OVoiIGZpbGw9IiNmZmYiLz48L3N2Zz4=", this.FIELD_COLOUR_DEFAULT_HEIGHT = this.FIELD_BORDER_RECT_HEIGHT, this.FIELD_CHECKBOX_X_OFFSET = this.FIELD_BORDER_RECT_X_PADDING - 3, this.randomIdentifier = String(Math.random()).substring(2);
        }
        init() {
          this.JAGGED_TEETH = this.makeJaggedTeeth(), this.NOTCH = this.makeNotch(), this.START_HAT = this.makeStartHat(), this.PUZZLE_TAB = this.makePuzzleTab(), this.INSIDE_CORNERS = this.makeInsideCorners(), this.OUTSIDE_CORNERS = this.makeOutsideCorners();
        }
        setTheme(e) {
          this.blockStyles = /* @__PURE__ */ Object.create(null);
          const t = e.blockStyles;
          for (const n in t)
            this.blockStyles[n] = this.validatedBlockStyle_(t[n]);
          this.setDynamicProperties_(e);
        }
        setDynamicProperties_(e) {
          this.setFontConstants_(e), this.setComponentConstants_(e), this.ADD_START_HATS = e.startHats !== void 0 ? e.startHats : this.ADD_START_HATS;
        }
        setFontConstants_(e) {
          e.fontStyle && e.fontStyle.family && (this.FIELD_TEXT_FONTFAMILY = e.fontStyle.family), e.fontStyle && e.fontStyle.weight && (this.FIELD_TEXT_FONTWEIGHT = e.fontStyle.weight), e.fontStyle && e.fontStyle.size && (this.FIELD_TEXT_FONTSIZE = e.fontStyle.size), e = Hn(
            "Hg",
            this.FIELD_TEXT_FONTSIZE + "pt",
            this.FIELD_TEXT_FONTWEIGHT,
            this.FIELD_TEXT_FONTFAMILY
          ), this.FIELD_TEXT_HEIGHT = e.height, this.FIELD_TEXT_BASELINE = e.baseline;
        }
        setComponentConstants_(e) {
          this.CURSOR_COLOUR = e.getComponentStyle("cursorColour") || this.CURSOR_COLOUR, this.MARKER_COLOUR = e.getComponentStyle("markerColour") || this.MARKER_COLOUR, this.INSERTION_MARKER_COLOUR = e.getComponentStyle("insertionMarkerColour") || this.INSERTION_MARKER_COLOUR, this.INSERTION_MARKER_OPACITY = Number(e.getComponentStyle("insertionMarkerOpacity")) || this.INSERTION_MARKER_OPACITY;
        }
        getBlockStyleForColour(e) {
          const t = "auto_" + e;
          return this.blockStyles[t] || (this.blockStyles[t] = this.createBlockStyle_(e)), { style: this.blockStyles[t], name: t };
        }
        getBlockStyle(e) {
          return this.blockStyles[e || ""] || (e && e.indexOf("auto_") === 0 ? this.getBlockStyleForColour(e.substring(5)).style : this.createBlockStyle_("#000000"));
        }
        createBlockStyle_(e) {
          return this.validatedBlockStyle_({ colourPrimary: e });
        }
        validatedBlockStyle_(e) {
          const t = {};
          return e && Object.assign(t, e), e = GT(t.colourPrimary || "#000"), t.colourPrimary = e.hex, t.colourSecondary = t.colourSecondary ? GT(t.colourSecondary).hex : this.generateSecondaryColour_(t.colourPrimary), t.colourTertiary = t.colourTertiary ? GT(t.colourTertiary).hex : this.generateTertiaryColour_(t.colourPrimary), t.hat = t.hat || "", t;
        }
        generateSecondaryColour_(e) {
          return Xn("#fff", e, 0.6) || e;
        }
        generateTertiaryColour_(e) {
          return Xn(
            "#fff",
            e,
            0.3
          ) || e;
        }
        dispose() {
          this.embossFilter && Tt(this.embossFilter), this.disabledPattern && Tt(this.disabledPattern), this.debugFilter && Tt(this.debugFilter), this.cssNode = null;
        }
        makeJaggedTeeth() {
          const e = this.JAGGED_TEETH_HEIGHT, t = this.JAGGED_TEETH_WIDTH, n = xT([Ee(t, e / 4), Ee(2 * -t, e / 2), Ee(t, e / 4)]);
          return { height: e, width: t, path: n };
        }
        makeStartHat() {
          const e = this.START_HAT_HEIGHT, t = this.START_HAT_WIDTH, n = mt("c", [Ee(30, -e), Ee(70, -e), Ee(t, 0)]);
          return { height: e, width: t, path: n };
        }
        makePuzzleTab() {
          function e(A) {
            A = A ? -1 : 1;
            const D = -A;
            var $ = n / 2;
            const q = $ + 2.5, De = $ + 0.5, or = Ee(
              -t,
              A * $
            );
            return $ = Ee(t, A * $), mt("c", [Ee(0, A * q), Ee(-t, D * De), or]) + mt("s", [Ee(t, 2.5 * D), $]);
          }
          const t = this.TAB_WIDTH, n = this.TAB_HEIGHT, o = e(!0), c = e(!1);
          return { type: this.SHAPES.PUZZLE, width: t, height: n, pathDown: c, pathUp: o };
        }
        makeNotch() {
          function e(D) {
            return xT([Ee(D * o, n), Ee(3 * D, 0), Ee(D * o, -n)]);
          }
          const t = this.NOTCH_WIDTH, n = this.NOTCH_HEIGHT, o = (t - 3) / 2, c = e(1), A = e(-1);
          return { type: this.SHAPES.NOTCH, width: t, height: n, pathLeft: c, pathRight: A };
        }
        makeInsideCorners() {
          const e = this.CORNER_RADIUS, t = kt("a", "0 0,0", e, Ee(-e, e)), n = kt("a", "0 0,0", e, Ee(
            e,
            e
          ));
          return { width: e, height: e, pathTop: t, pathBottom: n };
        }
        makeOutsideCorners() {
          const e = this.CORNER_RADIUS, t = Wt(0, e) + kt("a", "0 0,1", e, Ee(e, -e)), n = kt("a", "0 0,1", e, Ee(e, e)), o = kt("a", "0 0,1", e, Ee(-e, -e)), c = kt(
            "a",
            "0 0,1",
            e,
            Ee(-e, e)
          );
          return { topLeft: t, topRight: n, bottomRight: c, bottomLeft: o, rightHeight: e };
        }
        shapeFor(e) {
          switch (e.type) {
            case Ie.INPUT_VALUE:
            case Ie.OUTPUT_VALUE:
              return this.PUZZLE_TAB;
            case Ie.PREVIOUS_STATEMENT:
            case Ie.NEXT_STATEMENT:
              return this.NOTCH;
            default:
              throw Error("Unknown connection type");
          }
        }
        createDom(e, t, n) {
          this.injectCSS_(t, n), this.defs = K(U.DEFS, {}, e), e = K(U.FILTER, { id: "blocklyEmbossFilter" + this.randomIdentifier }, this.defs), K(U.FEGAUSSIANBLUR, { in: "SourceAlpha", stdDeviation: 1, result: "blur" }, e), t = K(
            U.FESPECULARLIGHTING,
            { in: "blur", surfaceScale: 1, specularConstant: 0.5, specularExponent: 10, "lighting-color": "white", result: "specOut" },
            e
          ), K(U.FEPOINTLIGHT, { x: -5e3, y: -1e4, z: 2e4 }, t), K(U.FECOMPOSITE, { in: "specOut", in2: "SourceAlpha", operator: "in", result: "specOut" }, e), K(
            U.FECOMPOSITE,
            { in: "SourceGraphic", in2: "specOut", operator: "arithmetic", k1: 0, k2: 1, k3: 1, k4: 0 },
            e
          ), this.embossFilterId = e.id, this.embossFilter = e, e = K(U.PATTERN, { id: "blocklyDisabledPattern" + this.randomIdentifier, patternUnits: "userSpaceOnUse", width: 10, height: 10 }, this.defs), K(U.RECT, { width: 10, height: 10, fill: "#aaa" }, e), K(
            U.PATH,
            { d: "M 0 0 L 10 10 M 10 0 L 0 10", stroke: "#cc0" },
            e
          ), this.disabledPatternId = e.id, this.disabledPattern = e, this.createDebugFilter();
        }
        createDebugFilter() {
          if (!this.debugFilter) {
            const e = K(U.FILTER, { id: "blocklyDebugFilter" + this.randomIdentifier, height: "160%", width: "180%", y: "-30%", x: "-40%" }, this.defs), t = K(
              U.FECOMPONENTTRANSFER,
              { result: "outBlur" },
              e
            );
            K(U.FEFUNCA, { type: "table", tableValues: "0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1" }, t), K(U.FEFLOOD, { "flood-color": "#ff0000", "flood-opacity": 0.5, result: "outColor" }, e), K(U.FECOMPOSITE, { in: "outColor", in2: "outBlur", operator: "in", result: "outGlow" }, e), this.debugFilterId = e.id, this.debugFilter = e;
          }
        }
        injectCSS_(e, t) {
          t = this.getCSS_(t), e = "blockly-renderer-style-" + e, this.cssNode = document.getElementById(e);
          const n = t.join(`
`);
          this.cssNode ? this.cssNode.firstChild.textContent = n : (t = document.createElement("style"), t.id = e, e = document.createTextNode(n), t.appendChild(e), document.head.insertBefore(t, document.head.firstChild), this.cssNode = t);
        }
        getCSS_(e) {
          return [
            `${e} .blocklyText, `,
            `${e} .blocklyFlyoutLabelText {`,
            `font: ${this.FIELD_TEXT_FONTWEIGHT} ${this.FIELD_TEXT_FONTSIZE}pt ${this.FIELD_TEXT_FONTFAMILY};`,
            "}",
            `${e} .blocklyText {`,
            "fill: #fff;",
            "}",
            `${e} .blocklyNonEditableText>rect,`,
            `${e} .blocklyEditableText>rect {`,
            `fill: ${this.FIELD_BORDER_RECT_COLOUR};`,
            "fill-opacity: .6;",
            "stroke: none;",
            "}",
            `${e} .blocklyNonEditableText>text,`,
            `${e} .blocklyEditableText>text {`,
            "fill: #000;",
            "}",
            `${e} .blocklyFlyoutLabelText {`,
            "fill: #000;",
            "}",
            `${e} .blocklyText.blocklyBubbleText {`,
            "fill: #000;",
            "}",
            `${e} .blocklyEditableText:not(.editing):hover>rect {`,
            "stroke: #fff;",
            "stroke-width: 2;",
            "}",
            `${e} .blocklyHtmlInput {`,
            `font-family: ${this.FIELD_TEXT_FONTFAMILY};`,
            `font-weight: ${this.FIELD_TEXT_FONTWEIGHT};`,
            "}",
            `${e} .blocklySelected>.blocklyPath {`,
            "stroke: #fc3;",
            "stroke-width: 3px;",
            "}",
            `${e} .blocklyHighlightedConnectionPath {`,
            "stroke: #fc3;",
            "}",
            `${e} .blocklyReplaceable .blocklyPath {`,
            "fill-opacity: .5;",
            "}",
            `${e} .blocklyReplaceable .blocklyPathLight,`,
            `${e} .blocklyReplaceable .blocklyPathDark {`,
            "display: none;",
            "}",
            `${e} .blocklyInsertionMarker>.blocklyPath {`,
            `fill-opacity: ${this.INSERTION_MARKER_OPACITY};`,
            "stroke: none;",
            "}"
          ];
        }
      }, Md = class extends Ao {
        constructor() {
          super(), this.GRID_UNIT = 4, this.CURSOR_COLOUR = "#ffa200", this.CURSOR_RADIUS = 5, this.JAGGED_TEETH_WIDTH = this.JAGGED_TEETH_HEIGHT = 0, this.START_HAT_HEIGHT = 22, this.START_HAT_WIDTH = 96, this.SHAPES = { HEXAGONAL: 1, ROUND: 2, SQUARE: 3, PUZZLE: 4, NOTCH: 5 }, this.SHAPE_IN_SHAPE_PADDING = {
            1: { 0: 5 * this.GRID_UNIT, 1: 2 * this.GRID_UNIT, 2: 5 * this.GRID_UNIT, 3: 5 * this.GRID_UNIT },
            2: { 0: 3 * this.GRID_UNIT, 1: 3 * this.GRID_UNIT, 2: 1 * this.GRID_UNIT, 3: 2 * this.GRID_UNIT },
            3: { 0: 2 * this.GRID_UNIT, 1: 2 * this.GRID_UNIT, 2: 2 * this.GRID_UNIT, 3: 2 * this.GRID_UNIT }
          }, this.FULL_BLOCK_FIELDS = !0, this.FIELD_TEXT_FONTWEIGHT = "bold", this.FIELD_TEXT_FONTFAMILY = '"Helvetica Neue", "Segoe UI", Helvetica, sans-serif', this.FIELD_COLOUR_FULL_BLOCK = this.FIELD_TEXTINPUT_BOX_SHADOW = this.FIELD_DROPDOWN_SVG_ARROW = this.FIELD_DROPDOWN_COLOURED_DIV = this.FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW = !0, this.SELECTED_GLOW_COLOUR = "#fff200", this.SELECTED_GLOW_SIZE = 0.5, this.REPLACEMENT_GLOW_COLOUR = "#fff200", this.REPLACEMENT_GLOW_SIZE = 2, this.selectedGlowFilterId = "", this.selectedGlowFilter = null, this.replacementGlowFilterId = "", this.SQUARED = this.ROUNDED = this.HEXAGONAL = this.replacementGlowFilter = null, this.SMALL_PADDING = this.GRID_UNIT, this.MEDIUM_PADDING = 2 * this.GRID_UNIT, this.MEDIUM_LARGE_PADDING = 3 * this.GRID_UNIT, this.LARGE_PADDING = 4 * this.GRID_UNIT, this.CORNER_RADIUS = 1 * this.GRID_UNIT, this.NOTCH_WIDTH = 9 * this.GRID_UNIT, this.NOTCH_HEIGHT = 2 * this.GRID_UNIT, this.STATEMENT_INPUT_NOTCH_OFFSET = this.NOTCH_OFFSET_LEFT = 3 * this.GRID_UNIT, this.MIN_BLOCK_WIDTH = 2 * this.GRID_UNIT, this.MIN_BLOCK_HEIGHT = 12 * this.GRID_UNIT, this.EMPTY_STATEMENT_INPUT_HEIGHT = 6 * this.GRID_UNIT, this.TOP_ROW_MIN_HEIGHT = this.CORNER_RADIUS, this.TOP_ROW_PRECEDES_STATEMENT_MIN_HEIGHT = this.LARGE_PADDING, this.BOTTOM_ROW_MIN_HEIGHT = this.CORNER_RADIUS, this.BOTTOM_ROW_AFTER_STATEMENT_MIN_HEIGHT = 6 * this.GRID_UNIT, this.STATEMENT_BOTTOM_SPACER = -this.NOTCH_HEIGHT, this.STATEMENT_INPUT_SPACER_MIN_WIDTH = 40 * this.GRID_UNIT, this.STATEMENT_INPUT_PADDING_LEFT = 4 * this.GRID_UNIT, this.EMPTY_INLINE_INPUT_PADDING = 4 * this.GRID_UNIT, this.EMPTY_INLINE_INPUT_HEIGHT = 8 * this.GRID_UNIT, this.DUMMY_INPUT_MIN_HEIGHT = 8 * this.GRID_UNIT, this.DUMMY_INPUT_SHADOW_MIN_HEIGHT = 6 * this.GRID_UNIT, this.CURSOR_WS_WIDTH = 20 * this.GRID_UNIT, this.FIELD_TEXT_FONTSIZE = 3 * this.GRID_UNIT, this.FIELD_BORDER_RECT_RADIUS = this.CORNER_RADIUS, this.FIELD_BORDER_RECT_X_PADDING = 2 * this.GRID_UNIT, this.FIELD_BORDER_RECT_Y_PADDING = 1.625 * this.GRID_UNIT, this.FIELD_BORDER_RECT_HEIGHT = 8 * this.GRID_UNIT, this.FIELD_DROPDOWN_BORDER_RECT_HEIGHT = 8 * this.GRID_UNIT, this.FIELD_DROPDOWN_SVG_ARROW_PADDING = this.FIELD_BORDER_RECT_X_PADDING, this.FIELD_COLOUR_DEFAULT_WIDTH = 2 * this.GRID_UNIT, this.FIELD_COLOUR_DEFAULT_HEIGHT = 4 * this.GRID_UNIT, this.FIELD_CHECKBOX_X_OFFSET = 1 * this.GRID_UNIT, this.MAX_DYNAMIC_CONNECTION_SHAPE_WIDTH = 12 * this.GRID_UNIT;
        }
        setFontConstants_(e) {
          super.setFontConstants_(e), this.FIELD_DROPDOWN_BORDER_RECT_HEIGHT = this.FIELD_BORDER_RECT_HEIGHT = this.FIELD_TEXT_HEIGHT + 2 * this.FIELD_BORDER_RECT_Y_PADDING;
        }
        init() {
          super.init(), this.HEXAGONAL = this.makeHexagonal(), this.ROUNDED = this.makeRounded(), this.SQUARED = this.makeSquared(), this.STATEMENT_INPUT_NOTCH_OFFSET = this.NOTCH_OFFSET_LEFT + this.INSIDE_CORNERS.rightWidth;
        }
        setDynamicProperties_(e) {
          super.setDynamicProperties_(e), this.SELECTED_GLOW_COLOUR = e.getComponentStyle("selectedGlowColour") || this.SELECTED_GLOW_COLOUR;
          const t = Number(e.getComponentStyle("selectedGlowSize"));
          this.SELECTED_GLOW_SIZE = t && !isNaN(t) ? t : this.SELECTED_GLOW_SIZE, this.REPLACEMENT_GLOW_COLOUR = e.getComponentStyle("replacementGlowColour") || this.REPLACEMENT_GLOW_COLOUR, this.REPLACEMENT_GLOW_SIZE = (e = Number(e.getComponentStyle("replacementGlowSize"))) && !isNaN(e) ? e : this.REPLACEMENT_GLOW_SIZE;
        }
        dispose() {
          super.dispose(), this.selectedGlowFilter && Tt(this.selectedGlowFilter), this.replacementGlowFilter && Tt(this.replacementGlowFilter);
        }
        makeStartHat() {
          const e = this.START_HAT_HEIGHT, t = this.START_HAT_WIDTH, n = mt("c", [Ee(
            25,
            -e
          ), Ee(71, -e), Ee(t, 0)]);
          return { height: e, width: t, path: n };
        }
        makeHexagonal() {
          function e(n, o, c) {
            var A = n / 2;
            return A = A > t ? t : A, c = c ? -1 : 1, n = (o ? -1 : 1) * n / 2, p_(-c * A, n) + p_(c * A, n);
          }
          const t = this.MAX_DYNAMIC_CONNECTION_SHAPE_WIDTH;
          return { type: this.SHAPES.HEXAGONAL, isDynamic: !0, width(n) {
            return n /= 2, n > t ? t : n;
          }, height(n) {
            return n;
          }, connectionOffsetY(n) {
            return n / 2;
          }, connectionOffsetX(n) {
            return -n;
          }, pathDown(n) {
            return e(n, !1, !1);
          }, pathUp(n) {
            return e(n, !0, !1);
          }, pathRightDown(n) {
            return e(n, !1, !0);
          }, pathRightUp(n) {
            return e(n, !1, !0);
          } };
        }
        makeRounded() {
          function e(o, c, A) {
            const D = o > n ? o - n : 0;
            return o = (o > n ? n : o) / 2, kt("a", "0 0,1", o, Ee((c ? -1 : 1) * o, (c ? -1 : 1) * o)) + de("v", (A ? 1 : -1) * D) + kt("a", "0 0,1", o, Ee((c ? 1 : -1) * o, (c ? -1 : 1) * o));
          }
          const t = this.MAX_DYNAMIC_CONNECTION_SHAPE_WIDTH, n = 2 * t;
          return { type: this.SHAPES.ROUND, isDynamic: !0, width(o) {
            return o /= 2, o > t ? t : o;
          }, height(o) {
            return o;
          }, connectionOffsetY(o) {
            return o / 2;
          }, connectionOffsetX(o) {
            return -o;
          }, pathDown(o) {
            return e(o, !1, !1);
          }, pathUp(o) {
            return e(o, !0, !1);
          }, pathRightDown(o) {
            return e(o, !1, !0);
          }, pathRightUp(o) {
            return e(o, !1, !0);
          } };
        }
        makeSquared() {
          function e(n, o, c) {
            return n -= 2 * t, kt("a", "0 0,1", t, Ee((o ? -1 : 1) * t, (o ? -1 : 1) * t)) + de("v", (c ? 1 : -1) * n) + kt("a", "0 0,1", t, Ee((o ? 1 : -1) * t, (o ? -1 : 1) * t));
          }
          const t = this.CORNER_RADIUS;
          return { type: this.SHAPES.SQUARE, isDynamic: !0, width(n) {
            return t;
          }, height(n) {
            return n;
          }, connectionOffsetY(n) {
            return n / 2;
          }, connectionOffsetX(n) {
            return -n;
          }, pathDown(n) {
            return e(n, !1, !1);
          }, pathUp(n) {
            return e(n, !0, !1);
          }, pathRightDown(n) {
            return e(n, !1, !0);
          }, pathRightUp(n) {
            return e(
              n,
              !1,
              !0
            );
          } };
        }
        shapeFor(e) {
          let t = e.getCheck();
          switch (!t && e.targetConnection && (t = e.targetConnection.getCheck()), e.type) {
            case Ie.INPUT_VALUE:
            case Ie.OUTPUT_VALUE:
              if (e = e.getSourceBlock().getOutputShape(), e !== null)
                switch (e) {
                  case this.SHAPES.HEXAGONAL:
                    return this.HEXAGONAL;
                  case this.SHAPES.ROUND:
                    return this.ROUNDED;
                  case this.SHAPES.SQUARE:
                    return this.SQUARED;
                }
              return t && t.indexOf("Boolean") !== -1 ? this.HEXAGONAL : t && t.indexOf("Number") !== -1 ? this.ROUNDED : (t && t.indexOf("String"), this.ROUNDED);
            case Ie.PREVIOUS_STATEMENT:
            case Ie.NEXT_STATEMENT:
              return this.NOTCH;
            default:
              throw Error("Unknown type");
          }
        }
        makeNotch() {
          function e(De) {
            return mt("c", [Ee(De * c / 2, 0), Ee(De * c * 3 / 4, D / 2), Ee(De * c, D)]) + xT([Ee(De * c, A)]) + mt("c", [Ee(De * c / 4, D / 2), Ee(De * c / 2, D), Ee(De * c, D)]) + de("h", De * o) + mt("c", [Ee(De * c / 2, 0), Ee(De * c * 3 / 4, -(D / 2)), Ee(De * c, -D)]) + xT([Ee(De * c, -A)]) + mt("c", [Ee(De * c / 4, -(D / 2)), Ee(De * c / 2, -D), Ee(De * c, -D)]);
          }
          const t = this.NOTCH_WIDTH, n = this.NOTCH_HEIGHT, o = t / 3, c = o / 3, A = n / 2, D = A / 2, $ = e(1), q = e(-1);
          return {
            type: this.SHAPES.NOTCH,
            width: t,
            height: n,
            pathLeft: $,
            pathRight: q
          };
        }
        makeInsideCorners() {
          const e = this.CORNER_RADIUS, t = kt("a", "0 0,0", e, Ee(-e, e)), n = kt("a", "0 0,1", e, Ee(-e, e)), o = kt("a", "0 0,0", e, Ee(e, e)), c = kt("a", "0 0,1", e, Ee(
            e,
            e
          ));
          return { width: e, height: e, pathTop: t, pathBottom: o, rightWidth: e, rightHeight: e, pathTopRight: n, pathBottomRight: c };
        }
        generateSecondaryColour_(e) {
          return Xn("#000", e, 0.15) || e;
        }
        generateTertiaryColour_(e) {
          return Xn("#000", e, 0.25) || e;
        }
        createDom(e, t, n) {
          super.createDom(e, t, n), e = K(U.DEFS, {}, e), t = K(
            U.FILTER,
            { id: "blocklySelectedGlowFilter" + this.randomIdentifier, height: "160%", width: "180%", y: "-30%", x: "-40%" },
            e
          ), K(U.FEGAUSSIANBLUR, { in: "SourceGraphic", stdDeviation: this.SELECTED_GLOW_SIZE }, t), n = K(U.FECOMPONENTTRANSFER, { result: "outBlur" }, t), K(U.FEFUNCA, {
            type: "table",
            tableValues: "0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1"
          }, n), K(U.FEFLOOD, { "flood-color": this.SELECTED_GLOW_COLOUR, "flood-opacity": 1, result: "outColor" }, t), K(U.FECOMPOSITE, { in: "outColor", in2: "outBlur", operator: "in", result: "outGlow" }, t), this.selectedGlowFilterId = t.id, this.selectedGlowFilter = t, e = K(
            U.FILTER,
            { id: "blocklyReplacementGlowFilter" + this.randomIdentifier, height: "160%", width: "180%", y: "-30%", x: "-40%" },
            e
          ), K(U.FEGAUSSIANBLUR, { in: "SourceGraphic", stdDeviation: this.REPLACEMENT_GLOW_SIZE }, e), t = K(U.FECOMPONENTTRANSFER, { result: "outBlur" }, e), K(U.FEFUNCA, {
            type: "table",
            tableValues: "0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1"
          }, t), K(U.FEFLOOD, { "flood-color": this.REPLACEMENT_GLOW_COLOUR, "flood-opacity": 1, result: "outColor" }, e), K(U.FECOMPOSITE, { in: "outColor", in2: "outBlur", operator: "in", result: "outGlow" }, e), K(U.FECOMPOSITE, {
            in: "SourceGraphic",
            in2: "outGlow",
            operator: "over"
          }, e), this.replacementGlowFilterId = e.id, this.replacementGlowFilter = e;
        }
        getCSS_(e) {
          return [
            `${e} .blocklyText,`,
            `${e} .blocklyFlyoutLabelText {`,
            `font: ${this.FIELD_TEXT_FONTWEIGHT} ${this.FIELD_TEXT_FONTSIZE}pt ${this.FIELD_TEXT_FONTFAMILY};`,
            "}",
            `${e} .blocklyText {`,
            "fill: #fff;",
            "}",
            `${e} .blocklyNonEditableText>rect:not(.blocklyDropdownRect),`,
            `${e} .blocklyEditableText>rect:not(.blocklyDropdownRect) {`,
            `fill: ${this.FIELD_BORDER_RECT_COLOUR};`,
            "}",
            `${e} .blocklyNonEditableText>text,`,
            `${e} .blocklyEditableText>text,`,
            `${e} .blocklyNonEditableText>g>text,`,
            `${e} .blocklyEditableText>g>text {`,
            "fill: #575E75;",
            "}",
            `${e} .blocklyFlyoutLabelText {`,
            "fill: #575E75;",
            "}",
            `${e} .blocklyText.blocklyBubbleText {`,
            "fill: #575E75;",
            "}",
            `${e} .blocklyDraggable:not(.blocklyDisabled)`,
            " .blocklyEditableText:not(.editing):hover>rect,",
            `${e} .blocklyDraggable:not(.blocklyDisabled)`,
            " .blocklyEditableText:not(.editing):hover>.blocklyPath {",
            "stroke: #fff;",
            "stroke-width: 2;",
            "}",
            `${e} .blocklyHtmlInput {`,
            `font-family: ${this.FIELD_TEXT_FONTFAMILY};`,
            `font-weight: ${this.FIELD_TEXT_FONTWEIGHT};`,
            "color: #575E75;",
            "}",
            `${e} .blocklyDropdownText {`,
            "fill: #fff !important;",
            "}",
            `${e}.blocklyWidgetDiv .goog-menuitem,`,
            `${e}.blocklyDropDownDiv .goog-menuitem {`,
            `font-family: ${this.FIELD_TEXT_FONTFAMILY};`,
            "}",
            `${e}.blocklyDropDownDiv .goog-menuitem-content {`,
            "color: #fff;",
            "}",
            `${e} .blocklyHighlightedConnectionPath {`,
            `stroke: ${this.SELECTED_GLOW_COLOUR};`,
            "}",
            `${e} .blocklyDisabled > .blocklyOutlinePath {`,
            `fill: url(#blocklyDisabledPattern${this.randomIdentifier})`,
            "}",
            `${e} .blocklyInsertionMarker>.blocklyPath {`,
            `fill-opacity: ${this.INSERTION_MARKER_OPACITY};`,
            "stroke: none;",
            "}"
          ];
        }
      }, wS = class {
        constructor() {
          this.NONE = 0, this.FIELD = 1, this.HAT = 2, this.ICON = 4, this.SPACER = 8, this.BETWEEN_ROW_SPACER = 16, this.IN_ROW_SPACER = 32, this.EXTERNAL_VALUE_INPUT = 64, this.INPUT = 128, this.INLINE_INPUT = 256, this.STATEMENT_INPUT = 512, this.CONNECTION = 1024, this.PREVIOUS_CONNECTION = 2048, this.NEXT_CONNECTION = 4096, this.OUTPUT_CONNECTION = 8192, this.CORNER = 16384, this.LEFT_SQUARE_CORNER = 32768, this.LEFT_ROUND_CORNER = 65536, this.RIGHT_SQUARE_CORNER = 131072, this.RIGHT_ROUND_CORNER = 262144, this.JAGGED_EDGE = 524288, this.ROW = 1048576, this.TOP_ROW = 2097152, this.BOTTOM_ROW = 4194304, this.INPUT_ROW = 8388608, this.LEFT_CORNER = this.LEFT_SQUARE_CORNER | this.LEFT_ROUND_CORNER, this.RIGHT_CORNER = this.RIGHT_SQUARE_CORNER | this.RIGHT_ROUND_CORNER, this.nextTypeValue_ = 16777216;
        }
        getType(e) {
          return Object.prototype.hasOwnProperty.call(this, e) || (this[e] = this.nextTypeValue_, this.nextTypeValue_ <<= 1), this[e];
        }
        isField(e) {
          return e.type & this.FIELD;
        }
        isHat(e) {
          return e.type & this.HAT;
        }
        isIcon(e) {
          return e.type & this.ICON;
        }
        isSpacer(e) {
          return e.type & this.SPACER;
        }
        isInRowSpacer(e) {
          return e.type & this.IN_ROW_SPACER;
        }
        isInput(e) {
          return e.type & this.INPUT;
        }
        isExternalInput(e) {
          return e.type & this.EXTERNAL_VALUE_INPUT;
        }
        isInlineInput(e) {
          return e.type & this.INLINE_INPUT;
        }
        isStatementInput(e) {
          return e.type & this.STATEMENT_INPUT;
        }
        isPreviousConnection(e) {
          return e.type & this.PREVIOUS_CONNECTION;
        }
        isNextConnection(e) {
          return e.type & this.NEXT_CONNECTION;
        }
        isPreviousOrNextConnection(e) {
          return e.type & (this.PREVIOUS_CONNECTION | this.NEXT_CONNECTION);
        }
        isLeftRoundedCorner(e) {
          return e.type & this.LEFT_ROUND_CORNER;
        }
        isRightRoundedCorner(e) {
          return e.type & this.RIGHT_ROUND_CORNER;
        }
        isLeftSquareCorner(e) {
          return e.type & this.LEFT_SQUARE_CORNER;
        }
        isRightSquareCorner(e) {
          return e.type & this.RIGHT_SQUARE_CORNER;
        }
        isCorner(e) {
          return e.type & this.CORNER;
        }
        isJaggedEdge(e) {
          return e.type & this.JAGGED_EDGE;
        }
        isRow(e) {
          return e.type & this.ROW;
        }
        isBetweenRowSpacer(e) {
          return e.type & this.BETWEEN_ROW_SPACER;
        }
        isTopRow(e) {
          return e.type & this.TOP_ROW;
        }
        isBottomRow(e) {
          return e.type & this.BOTTOM_ROW;
        }
        isTopOrBottomRow(e) {
          return e.type & (this.TOP_ROW | this.BOTTOM_ROW);
        }
        isInputRow(e) {
          return e.type & this.INPUT_ROW;
        }
      }, w = new wS(), j_ = class {
        constructor(e) {
          this.centerline = this.xPos = this.height = this.width = 0, this.constants_ = e, this.type = w.NONE, this.notchOffset = this.constants_.NOTCH_OFFSET_LEFT;
        }
      }, ST = class extends j_ {
        constructor(e, t) {
          super(e), this.connectionModel = t, this.shape = this.constants_.shapeFor(t), this.isDynamicShape = "isDynamic" in this.shape && this.shape.isDynamic, this.type |= w.CONNECTION;
        }
      }, kl = class {
        constructor(e, t) {
          this.inlinePath_ = this.outlinePath_ = "", this.block_ = e, this.info_ = t, this.topLeft_ = e.getRelativeToSurfaceXY(), this.constants_ = t.getRenderer().getConstants();
        }
        draw() {
          this.drawOutline_(), this.drawInternals_(), this.block_.pathObject.setPath(this.outlinePath_ + `
` + this.inlinePath_), this.info_.RTL && this.block_.pathObject.flipRTL(), this.recordSizeOnBlock_();
        }
        hideHiddenIcons_() {
          dr(
            "hideHiddenIcons_",
            "v10",
            "v11"
          );
        }
        recordSizeOnBlock_() {
          this.block_.height = this.info_.height, this.block_.width = this.info_.widthWithChildren;
        }
        drawOutline_() {
          this.drawTop_();
          for (let e = 1; e < this.info_.rows.length - 1; e++) {
            const t = this.info_.rows[e];
            t.hasJaggedEdge ? this.drawJaggedEdge_(t) : t.hasStatement ? this.drawStatementInput_(t) : t.hasExternalInput ? this.drawValueInput_(t) : this.drawRightSideRow_(t);
          }
          this.drawBottom_(), this.drawLeft_();
        }
        drawTop_() {
          const e = this.info_.topRow, t = e.elements;
          this.positionPreviousConnection_(), this.outlinePath_ += Wt(e.xPos, this.info_.startY);
          for (let n = 0, o; o = t[n]; n++)
            w.isLeftRoundedCorner(o) ? this.outlinePath_ += this.constants_.OUTSIDE_CORNERS.topLeft : w.isRightRoundedCorner(o) ? this.outlinePath_ += this.constants_.OUTSIDE_CORNERS.topRight : w.isPreviousConnection(o) && o instanceof ST ? this.outlinePath_ += o.shape.pathLeft : w.isHat(o) ? this.outlinePath_ += this.constants_.START_HAT.path : w.isSpacer(o) && (this.outlinePath_ += de("h", o.width));
          this.outlinePath_ += de("v", e.height);
        }
        drawJaggedEdge_(e) {
          this.outlinePath_ += this.constants_.JAGGED_TEETH.path + de(
            "v",
            e.height - this.constants_.JAGGED_TEETH.height
          );
        }
        drawValueInput_(e) {
          const t = e.getLastInput();
          this.positionExternalValueConnection_(e);
          const n = eu(t.shape) ? t.shape.pathDown(t.height) : t.shape.pathDown;
          this.outlinePath_ += de("H", t.xPos + t.width) + n + de("v", e.height - t.connectionHeight);
        }
        drawStatementInput_(e) {
          var t = e.getLastInput();
          if (t) {
            var n = t.xPos + t.notchOffset + t.shape.width;
            t = t.shape.pathRight + de("h", -(t.notchOffset - this.constants_.INSIDE_CORNERS.width)) + this.constants_.INSIDE_CORNERS.pathTop;
            var o = e.height - 2 * this.constants_.INSIDE_CORNERS.height;
            this.outlinePath_ += de("H", n) + t + de("v", o) + this.constants_.INSIDE_CORNERS.pathBottom + de("H", e.xPos + e.width), this.positionStatementInputConnection_(e);
          }
        }
        drawRightSideRow_(e) {
          this.outlinePath_ += de("V", e.yPos + e.height);
        }
        drawBottom_() {
          const e = this.info_.bottomRow, t = e.elements;
          this.positionNextConnection_();
          let n = 0, o = "";
          for (let c = t.length - 1, A; A = t[c]; c--)
            w.isNextConnection(A) && A instanceof ST ? o += A.shape.pathRight : w.isLeftSquareCorner(A) ? o += de(
              "H",
              e.xPos
            ) : w.isLeftRoundedCorner(A) ? o += this.constants_.OUTSIDE_CORNERS.bottomLeft : w.isRightRoundedCorner(A) ? (o += this.constants_.OUTSIDE_CORNERS.bottomRight, n = this.constants_.OUTSIDE_CORNERS.rightHeight) : w.isSpacer(A) && (o += de("h", -1 * A.width));
          this.outlinePath_ += de(
            "V",
            e.baseline - n
          ), this.outlinePath_ += o;
        }
        drawLeft_() {
          var e = this.info_.outputConnection;
          if (this.positionOutputConnection_(), e) {
            const t = e.connectionOffsetY + e.height;
            e = eu(e.shape) ? e.shape.pathUp(e.height) : e.shape.pathUp, this.outlinePath_ += de("V", t) + e;
          }
          this.outlinePath_ += "z";
        }
        drawInternals_() {
          for (let e = 0, t; t = this.info_.rows[e]; e++)
            for (let n = 0, o; o = t.elements[n]; n++)
              w.isInlineInput(o) ? this.drawInlineInput_(o) : (w.isIcon(o) || w.isField(o)) && this.layoutField_(o);
        }
        layoutField_(e) {
          const t = e.centerline - e.height / 2;
          let n = e.xPos;
          var o = "";
          this.info_.RTL && (n = -(n + e.width), e.flipRtl && (n += e.width, o = "scale(-1 1)")), w.isIcon(e) ? (o = e.icon, o.setOffsetInBlock(new ae(n, t)), this.info_.isInsertionMarker && o.hideForInsertionMarker()) : (e = e.field.getSvgRoot(), e.setAttribute("transform", "translate(" + n + "," + t + ")" + o), this.info_.isInsertionMarker && e.setAttribute("display", "none"));
        }
        drawInlineInput_(e) {
          const t = e.width, n = e.height, o = e.connectionOffsetY, c = e.connectionHeight + o;
          this.inlinePath_ += Or(e.xPos + e.connectionWidth, e.centerline - n / 2) + de("v", o) + e.shape.pathDown + de("v", n - c) + de("h", t - e.connectionWidth) + de("v", -n) + "z", this.positionInlineInputConnection_(e);
        }
        positionInlineInputConnection_(e) {
          const t = e.centerline - e.height / 2;
          if (e.connectionModel) {
            let n = e.xPos + e.connectionWidth + e.connectionOffsetX;
            this.info_.RTL && (n *= -1), e.connectionModel.setOffsetInBlock(n, t + e.connectionOffsetY);
          }
        }
        positionStatementInputConnection_(e) {
          const t = e.getLastInput();
          if (t != null && t.connectionModel) {
            let n = e.xPos + e.statementEdge + t.notchOffset;
            this.info_.RTL && (n *= -1), t.connectionModel.setOffsetInBlock(n, e.yPos);
          }
        }
        positionExternalValueConnection_(e) {
          const t = e.getLastInput();
          if (t && t.connectionModel) {
            let n = e.xPos + e.width;
            this.info_.RTL && (n *= -1), t.connectionModel.setOffsetInBlock(n, e.yPos);
          }
        }
        positionPreviousConnection_() {
          const e = this.info_.topRow;
          if (e.connection) {
            const t = e.xPos + e.notchOffset;
            e.connection.connectionModel.setOffsetInBlock(this.info_.RTL ? -t : t, 0);
          }
        }
        positionNextConnection_() {
          const e = this.info_.bottomRow;
          if (e.connection) {
            const t = e.connection, n = t.xPos;
            t.connectionModel.setOffsetInBlock(this.info_.RTL ? -n : n, e.baseline);
          }
        }
        positionOutputConnection_() {
          if (this.info_.outputConnection) {
            const e = this.info_.startX + this.info_.outputConnection.connectionOffsetX;
            this.block_.outputConnection.setOffsetInBlock(this.info_.RTL ? -e : e, this.info_.outputConnection.connectionOffsetY);
          }
        }
      }, md = class extends kl {
        constructor(e, t) {
          super(e, t);
        }
        draw() {
          const e = this.block_.pathObject;
          e.beginDrawing(), this.drawOutline_(), this.drawInternals_(), e.setPath(this.outlinePath_ + `
` + this.inlinePath_), this.info_.RTL && e.flipRTL(), this.recordSizeOnBlock_(), this.info_.outputConnection && (e.outputShapeType = this.info_.outputConnection.shape.type), e.endDrawing();
        }
        drawOutline_() {
          this.info_.outputConnection && this.info_.outputConnection.isDynamicShape && !this.info_.hasStatementInput && !this.info_.bottomRow.hasNextConnection ? (this.drawFlatTop_(), this.drawRightDynamicConnection_(), this.drawFlatBottom_(), this.drawLeftDynamicConnection_()) : super.drawOutline_();
        }
        drawLeft_() {
          this.info_.outputConnection && this.info_.outputConnection.isDynamicShape ? this.drawLeftDynamicConnection_() : super.drawLeft_();
        }
        drawRightSideRow_(e) {
          if (!(0 >= e.height)) {
            if (w.isSpacer(e)) {
              const o = e.precedesStatement;
              var t = e.followsStatement;
              if (o || t) {
                const c = this.constants_.INSIDE_CORNERS;
                var n = c.rightHeight;
                n = e.height - (o ? n : 0), t = t ? c.pathBottomRight : "", e = 0 < n ? de("V", e.yPos + n) : "", this.outlinePath_ += t + e + (o ? c.pathTopRight : "");
                return;
              }
            }
            this.outlinePath_ += de("V", e.yPos + e.height);
          }
        }
        drawRightDynamicConnection_() {
          if (!this.info_.outputConnection)
            throw Error("Cannot draw the output connection of a block that doesn't have one");
          this.outlinePath_ += this.info_.outputConnection.shape.pathRightDown(this.info_.outputConnection.height);
        }
        drawLeftDynamicConnection_() {
          if (!this.info_.outputConnection)
            throw Error("Cannot draw the output connection of a block that doesn't have one");
          this.positionOutputConnection_(), this.outlinePath_ += this.info_.outputConnection.shape.pathUp(this.info_.outputConnection.height), this.outlinePath_ += "z";
        }
        drawFlatTop_() {
          const e = this.info_.topRow;
          this.positionPreviousConnection_(), this.outlinePath_ += Wt(
            e.xPos,
            this.info_.startY
          ), this.outlinePath_ += de("h", e.width);
        }
        drawFlatBottom_() {
          const e = this.info_.bottomRow;
          this.positionNextConnection_(), this.outlinePath_ += de("V", e.baseline), this.outlinePath_ += de("h", -e.width);
        }
        drawInlineInput_(e) {
          this.positionInlineInputConnection_(e);
          const t = e.input.name;
          if (!e.connectedBlock && !this.info_.isInsertionMarker) {
            var n = e.width - 2 * e.connectionWidth;
            e = Or(e.xPos + e.connectionWidth, e.centerline - e.height / 2) + de("h", n) + e.shape.pathRightDown(e.height) + de("h", -n) + e.shape.pathUp(e.height) + "z", this.block_.pathObject.setOutlinePath(t, e);
          }
        }
        drawStatementInput_(e) {
          var t = e.getLastInput();
          const n = t.xPos + t.notchOffset + t.shape.width, o = this.constants_.INSIDE_CORNERS, c = t.shape.pathRight + de(
            "h",
            -(t.notchOffset - o.width)
          ) + o.pathTop, A = e.height - 2 * o.height;
          t = o.pathBottom + de("h", t.notchOffset - o.width) + (t.connectedBottomNextConnection ? "" : t.shape.pathLeft), this.outlinePath_ += de("H", n) + c + de("v", A) + t + de("H", e.xPos + e.width), this.positionStatementInputConnection_(e);
        }
      }, hT = class extends _t {
        constructor(e, t, n, o, c, A, D) {
          if (super(_t.SKIP_SETUP), this.imageElement = this.clickHandler = null, this.flipRtl = this.isDirty_ = this.EDITABLE = !1, this.altText = "", n = Number(xt(n)), t = Number(xt(t)), isNaN(n) || isNaN(t))
            throw Error("Height and width values of an image field must cast to numbers.");
          if (0 >= n || 0 >= t)
            throw Error("Height and width values of an image field must be greater than 0.");
          this.size_ = new ht(t, n + hT.Y_PADDING), this.imageHeight = n, typeof c == "function" && (this.clickHandler = c), e !== _t.SKIP_SETUP && (D ? this.configure_(D) : (this.flipRtl = !!A, this.altText = xt(o) || ""), this.setValue(xt(e)));
        }
        configure_(e) {
          super.configure_(e), e.flipRtl && (this.flipRtl = e.flipRtl), e.alt && (this.altText = xt(e.alt));
        }
        initView() {
          this.imageElement = K(U.IMAGE, { height: this.imageHeight + "px", width: this.size_.width + "px", alt: this.altText }, this.fieldGroup_), this.imageElement.setAttributeNS($n, "xlink:href", this.value_), this.clickHandler && (this.imageElement.style.cursor = "pointer");
        }
        updateSize_() {
        }
        doClassValidation_(e) {
          return typeof e != "string" ? null : e;
        }
        doValueUpdate_(e) {
          this.value_ = e, this.imageElement && this.imageElement.setAttributeNS($n, "xlink:href", this.value_);
        }
        getFlipRtl() {
          return this.flipRtl;
        }
        setAlt(e) {
          e !== this.altText && (this.altText = e || "", this.imageElement && this.imageElement.setAttribute("alt", this.altText));
        }
        showEditor_() {
          this.clickHandler && this.clickHandler(this);
        }
        setOnClickHandler(e) {
          this.clickHandler = e;
        }
        getText_() {
          return this.altText;
        }
        static fromJson(e) {
          if (!e.src || !e.width || !e.height)
            throw Error("src, width, and height values for an image field arerequired. The width and height must be non-zero.");
          return new this(e.src, e.width, e.height, void 0, void 0, void 0, e);
        }
      };
      hT.Y_PADDING = 1, Br("field_image", hT), hT.prototype.DEFAULT_VALUE = "";
      var Fl = class extends _t {
        constructor(e, t, n) {
          super(_t.SKIP_SETUP), this.spellcheck_ = !0, this.htmlInput_ = null, this.isTextValid_ = this.isBeingEdited_ = !1, this.onKeyInputWrapper_ = this.onKeyDownWrapper_ = this.valueWhenEditorWasOpened_ = null, this.fullBlockClickTarget_ = !1, this.workspace_ = null, this.SERIALIZABLE = !0, this.CURSOR = "text", e !== _t.SKIP_SETUP && (n && this.configure_(n), this.setValue(e), t && this.setValidator(t));
        }
        configure_(e) {
          super.configure_(e), e.spellcheck !== void 0 && (this.spellcheck_ = e.spellcheck);
        }
        initView() {
          const e = this.getSourceBlock();
          if (!e)
            throw new nr();
          if (this.getConstants().FULL_BLOCK_FIELDS) {
            let t = 0, n = 0;
            for (let o = 0, c; c = e.inputList[o]; o++) {
              for (let A = 0; c.fieldRow[A]; A++)
                t++;
              c.connection && n++;
            }
            this.fullBlockClickTarget_ = 1 >= t && e.outputConnection && !n;
          } else
            this.fullBlockClickTarget_ = !1;
          this.fullBlockClickTarget_ ? this.clickTarget_ = this.sourceBlock_.getSvgRoot() : this.createBorderRect_(), this.createTextElement_();
        }
        doValueInvalid_(e) {
          this.isBeingEdited_ && (this.isDirty_ = !0, this.isTextValid_ = !1, e = this.value_, this.value_ = this.htmlInput_.getAttribute("data-untyped-default-value"), this.sourceBlock_ && tt() && fe(new (ge(r.CHANGE$$module$build$src$core$events$utils))(this.sourceBlock_, "field", this.name || null, e, this.value_)));
        }
        doValueUpdate_(e) {
          this.isTextValid_ = this.isDirty_ = !0, this.value_ = e;
        }
        applyColour() {
          if (this.sourceBlock_ && this.getConstants().FULL_BLOCK_FIELDS) {
            var e = this.sourceBlock_;
            this.borderRect_ ? this.borderRect_.setAttribute("stroke", e.style.colourTertiary) : e.pathObject.svgPath.setAttribute("fill", this.getConstants().FIELD_BORDER_RECT_COLOUR);
          }
        }
        render_() {
          if (super.render_(), this.isBeingEdited_) {
            this.resizeEditor_();
            const e = this.htmlInput_;
            this.isTextValid_ ? (Be(e, "blocklyInvalidInput"), Mt(
              e,
              Ot.INVALID,
              !1
            )) : (be(e, "blocklyInvalidInput"), Mt(e, Ot.INVALID, !0));
          }
        }
        setSpellcheck(e) {
          e !== this.spellcheck_ && (this.spellcheck_ = e, this.htmlInput_ && this.htmlInput_.setAttribute("spellcheck", this.spellcheck_));
        }
        showEditor_(e, t = !1) {
          this.workspace_ = this.sourceBlock_.workspace, !t && this.workspace_.options.modalInputs && (Pl || tc || os) ? this.showPromptEditor_() : this.showInlineEditor_(t);
        }
        showPromptEditor_() {
          I(r.Msg$$module$build$src$core$msg.CHANGE_VALUE_TITLE, this.getText(), (e) => {
            e !== null && this.setValue(this.getValueFromEditorText_(e));
          });
        }
        showInlineEditor_(e) {
          const t = this.getSourceBlock();
          if (!t)
            throw new nr();
          Q(this, t.RTL, this.widgetDispose_.bind(this)), this.htmlInput_ = this.widgetCreate_(), this.isBeingEdited_ = !0, this.valueWhenEditorWasOpened_ = this.value_, e || (this.htmlInput_.focus({ preventScroll: !0 }), this.htmlInput_.select());
        }
        widgetCreate_() {
          var e = this.getSourceBlock();
          if (!e)
            throw new nr();
          r.setGroup$$module$build$src$core$events$utils(!0);
          const t = wo();
          var n = this.getClickTarget_();
          if (!n)
            throw Error("A click target has not been set.");
          be(
            n,
            "editing"
          ), n = document.createElement("input"), n.className = "blocklyHtmlInput", n.setAttribute("spellcheck", this.spellcheck_);
          const o = this.workspace_.getScale();
          var c = this.getConstants().FIELD_TEXT_FONTSIZE * o + "pt";
          return t.style.fontSize = c, n.style.fontSize = c, c = Fl.BORDERRADIUS * o + "px", this.fullBlockClickTarget_ && (c = this.getScaledBBox(), c = (c.bottom - c.top) / 2 + "px", e = e.getParent() ? e.getParent().style.colourTertiary : this.sourceBlock_.style.colourTertiary, n.style.border = 1 * o + "px solid " + e, t.style.borderRadius = c, t.style.transition = "box-shadow 0.25s ease 0s", this.getConstants().FIELD_TEXTINPUT_BOX_SHADOW && (t.style.boxShadow = "rgba(255, 255, 255, 0.3) 0 0 0 " + 4 * o + "px")), n.style.borderRadius = c, t.appendChild(n), n.value = n.defaultValue = this.getEditorText_(this.value_), n.setAttribute("data-untyped-default-value", String(this.value_)), this.resizeEditor_(), this.bindInputEvents_(n), n;
        }
        widgetDispose_() {
          this.isBeingEdited_ = !1, this.isTextValid_ = !0, this.forceRerender(), this.onFinishEditing_(this.value_), this.sourceBlock_ && tt() && this.valueWhenEditorWasOpened_ !== null && this.valueWhenEditorWasOpened_ !== this.value_ && (fe(new (ge(r.CHANGE$$module$build$src$core$events$utils))(this.sourceBlock_, "field", this.name || null, this.valueWhenEditorWasOpened_, this.value_)), this.valueWhenEditorWasOpened_ = null), r.setGroup$$module$build$src$core$events$utils(!1), this.unbindInputEvents_();
          var e = wo().style;
          if (e.width = "auto", e.height = "auto", e.fontSize = "", e.transition = "", e.boxShadow = "", this.htmlInput_ = null, e = this.getClickTarget_(), !e)
            throw Error("A click target has not been set.");
          Be(e, "editing");
        }
        onFinishEditing_(e) {
        }
        bindInputEvents_(e) {
          this.onKeyDownWrapper_ = Pe(e, "keydown", this, this.onHtmlInputKeyDown_), this.onKeyInputWrapper_ = Pe(e, "input", this, this.onHtmlInputChange_);
        }
        unbindInputEvents_() {
          this.onKeyDownWrapper_ && (It(this.onKeyDownWrapper_), this.onKeyDownWrapper_ = null), this.onKeyInputWrapper_ && (It(this.onKeyInputWrapper_), this.onKeyInputWrapper_ = null);
        }
        onHtmlInputKeyDown_(e) {
          e.key === "Enter" ? (J(), a_()) : e.key === "Escape" ? (this.setValue(this.htmlInput_.getAttribute("data-untyped-default-value")), J(), a_()) : e.key === "Tab" && (J(), a_(), this.sourceBlock_.tab(this, !e.shiftKey), e.preventDefault());
        }
        onHtmlInputChange_(e) {
          e = this.value_, this.setValue(this.getValueFromEditorText_(this.htmlInput_.value), !1), this.sourceBlock_ && tt() && this.value_ !== e && fe(new (ge(Mi))(
            this.sourceBlock_,
            this.name || null,
            e,
            this.value_
          )), C().then(() => {
            this.resizeEditor_();
          });
        }
        setEditorValue_(e, t = !0) {
          this.isDirty_ = !0, this.isBeingEdited_ && (this.htmlInput_.value = this.getEditorText_(e)), this.setValue(e, t);
        }
        resizeEditor_() {
          var e = this.getSourceBlock();
          if (!e)
            throw new nr();
          const t = wo(), n = this.getScaledBBox();
          t.style.width = n.right - n.left + "px", t.style.height = n.bottom - n.top + "px", e = new ae(e.RTL ? n.right - t.offsetWidth : n.left, n.top), t.style.left = e.x + "px", t.style.top = e.y + "px";
        }
        repositionForWindowResize() {
          const e = this.getSourceBlock();
          return e instanceof kn ? (JT(this.workspace_, this.workspace_.getMetricsManager().getViewMetrics(!0), e), this.resizeEditor_(), !0) : !1;
        }
        isTabNavigable() {
          return !0;
        }
        getText_() {
          return this.isBeingEdited_ && this.htmlInput_ ? this.htmlInput_.value : null;
        }
        getEditorText_(e) {
          return `${e}`;
        }
        getValueFromEditorText_(e) {
          return e;
        }
      };
      Fl.BORDERRADIUS = 4;
      var Ps = class extends Fl {
        constructor(e, t, n) {
          super(e, t, n);
        }
        doClassValidation_(e) {
          return e === void 0 ? null : `${e}`;
        }
        static fromJson(e) {
          return new this(xt(e.text), void 0, e);
        }
      };
      Br("field_input", Ps), Ps.prototype.DEFAULT_VALUE = "";
      var wl = class {
        constructor(e) {
          this.elements = [], this.xPos = this.yPos = this.widthWithConnectedBlocks = this.minWidth = this.minHeight = this.width = this.height = 0, this.hasStatement = this.hasExternalInput = !1, this.statementEdge = 0, this.hasJaggedEdge = this.hasDummyInput = this.hasInlineInput = !1, this.align = null, this.constants_ = e, this.type = w.ROW, this.notchOffset = this.constants_.NOTCH_OFFSET_LEFT;
        }
        getLastInput() {
          for (let e = this.elements.length - 1; 0 <= e; e--) {
            const t = this.elements[e];
            if (w.isInput(t))
              return t;
          }
          return null;
        }
        measure() {
          throw Error("Unexpected attempt to measure a base Row.");
        }
        startsWithElemSpacer() {
          return !0;
        }
        endsWithElemSpacer() {
          return !0;
        }
        getFirstSpacer() {
          for (let e = 0; e < this.elements.length; e++) {
            const t = this.elements[e];
            if (w.isSpacer(t))
              return t;
          }
          return null;
        }
        getLastSpacer() {
          for (let e = this.elements.length - 1; 0 <= e; e--) {
            const t = this.elements[e];
            if (w.isSpacer(t))
              return t;
          }
          return null;
        }
      }, uE = class extends wl {
        constructor(e) {
          super(e), this.hasNextConnection = !1, this.connection = null, this.baseline = this.descenderHeight = 0, this.type |= w.BOTTOM_ROW;
        }
        hasLeftSquareCorner(e) {
          return !!e.outputConnection || !!e.getNextBlock();
        }
        hasRightSquareCorner(e) {
          return !0;
        }
        measure() {
          let e = 0, t = 0, n = 0;
          for (let o = 0; o < this.elements.length; o++) {
            const c = this.elements[o];
            t += c.width, w.isSpacer(c) || (w.isNextConnection(c) ? n = Math.max(n, c.height) : e = Math.max(e, c.height));
          }
          this.width = Math.max(this.minWidth, t), this.height = Math.max(this.minHeight, e) + n, this.descenderHeight = n, this.widthWithConnectedBlocks = this.width;
        }
        startsWithElemSpacer() {
          return !1;
        }
        endsWithElemSpacer() {
          return !1;
        }
      }, So = class extends ST {
        constructor(e, t) {
          super(e, t.connection), this.input = t, this.connectionOffsetY = this.connectionOffsetX = 0, this.type |= w.INPUT, this.align = t.align, (this.connectedBlock = t.connection && t.connection.targetBlock() ? t.connection.targetBlock() : null) ? (e = this.connectedBlock.getHeightWidth(), this.connectedBlockWidth = e.width, this.connectedBlockHeight = e.height) : this.connectedBlockHeight = this.connectedBlockWidth = 0;
        }
      }, Ds = class extends So {
        constructor(e, t) {
          super(e, t), this.height = 0, this.type |= w.EXTERNAL_VALUE_INPUT, this.height = this.connectedBlock ? this.connectedBlockHeight - this.constants_.TAB_OFFSET_FROM_TOP - this.constants_.MEDIUM_PADDING : this.shape.height, this.width = this.shape.width + this.constants_.EXTERNAL_VALUE_INPUT_PADDING, this.connectionOffsetY = this.constants_.TAB_OFFSET_FROM_TOP, this.connectionHeight = this.shape.height, this.connectionWidth = this.shape.width;
        }
      }, Ls = class extends j_ {
        constructor(e, t, n) {
          super(e), this.field = t, this.parentInput = n, this.isEditable = t.EDITABLE, this.flipRtl = t.getFlipRtl(), this.type |= w.FIELD, e = this.field.getSize(), this.height = e.height, this.width = e.width;
        }
      }, Bl = class extends j_ {
        constructor(e) {
          super(e), this.type |= w.HAT, this.height = this.constants_.START_HAT.height, this.width = this.constants_.START_HAT.width, this.ascenderHeight = this.height;
        }
      }, Pd = class extends j_ {
        constructor(e, t) {
          super(e), this.icon = t, this.flipRtl = !1, this.isVisible = Vi(t) && t.bubbleIsVisible(), this.type |= w.ICON, e = t.getSize(), this.height = e.height, this.width = e.width;
        }
      }, Fn = class extends j_ {
        constructor(e, t) {
          super(e), this.type = this.type | w.SPACER | w.IN_ROW_SPACER, this.width = t, this.height = this.constants_.SPACER_DEFAULT_HEIGHT;
        }
      }, EE = class extends So {
        constructor(e, t) {
          super(e, t), this.type |= w.INLINE_INPUT, this.connectedBlock ? (this.width = this.connectedBlockWidth, this.height = this.connectedBlockHeight) : (this.height = this.constants_.EMPTY_INLINE_INPUT_HEIGHT, this.width = this.constants_.EMPTY_INLINE_INPUT_PADDING), this.connectionHeight = this.isDynamicShape ? this.shape.height(this.height) : this.shape.height, this.connectionWidth = this.isDynamicShape ? this.shape.width(this.height) : this.shape.width, this.connectedBlock || (this.width += this.connectionWidth * (this.isDynamicShape ? 2 : 1)), this.connectionOffsetY = "connectionOffsetY" in this.shape ? this.shape.connectionOffsetY(this.connectionHeight) : this.constants_.TAB_OFFSET_FROM_TOP, this.connectionOffsetX = "connectionOffsetX" in this.shape ? this.shape.connectionOffsetX(this.connectionWidth) : 0;
        }
      }, ir = class extends So {
        constructor(e, t) {
          super(e, t), this.type |= w.STATEMENT_INPUT, this.height = this.connectedBlock ? this.connectedBlockHeight + this.constants_.STATEMENT_BOTTOM_SPACER : this.constants_.EMPTY_STATEMENT_INPUT_HEIGHT, this.width = this.constants_.STATEMENT_INPUT_NOTCH_OFFSET + this.shape.width;
        }
      }, Ur = class extends wl {
        constructor(e) {
          super(e), this.connectedBlockWidths = 0, this.type |= w.INPUT_ROW;
        }
        measure() {
          this.width = this.minWidth, this.height = this.minHeight;
          let e = 0;
          for (let t = 0; t < this.elements.length; t++) {
            const n = this.elements[t];
            this.width += n.width, w.isInput(n) && n instanceof So && (w.isStatementInput(n) && n instanceof ir ? e += n.connectedBlockWidth : w.isExternalInput(n) && n instanceof Ds && n.connectedBlockWidth !== 0 && (e += n.connectedBlockWidth - n.connectionWidth)), w.isSpacer(n) || (this.height = Math.max(this.height, n.height));
          }
          this.connectedBlockWidths = e, this.widthWithConnectedBlocks = this.width + e;
        }
        endsWithElemSpacer() {
          return !this.hasExternalInput && !this.hasStatement;
        }
      }, Dd = class extends j_ {
        constructor(e) {
          super(e), this.type |= w.JAGGED_EDGE, this.height = this.constants_.JAGGED_TEETH.height, this.width = this.constants_.JAGGED_TEETH.width;
        }
      }, Ld = class extends ST {
        constructor(e, t) {
          super(e, t), this.type |= w.NEXT_CONNECTION, this.height = this.shape.height, this.width = this.shape.width;
        }
      }, gd = class extends ST {
        constructor(e, t) {
          super(e, t), this.connectionOffsetX = 0, this.type |= w.OUTPUT_CONNECTION, this.height = this.isDynamicShape ? 0 : this.shape.height, this.startX = this.width = this.isDynamicShape ? 0 : this.shape.width, this.connectionOffsetY = this.constants_.TAB_OFFSET_FROM_TOP;
        }
      }, AE = class extends ST {
        constructor(e, t) {
          super(e, t), this.type |= w.PREVIOUS_CONNECTION, this.height = this.shape.height, this.width = this.shape.width;
        }
      }, Yl = class extends j_ {
        constructor(e, t) {
          super(e), this.type = (t && t !== "left" ? w.RIGHT_ROUND_CORNER : w.LEFT_ROUND_CORNER) | w.CORNER, this.width = this.constants_.CORNER_RADIUS, this.height = this.constants_.CORNER_RADIUS / 2;
        }
      }, dE = class extends wl {
        constructor(e, t, n) {
          super(e), this.height = t, this.width = n, this.precedesStatement = this.followsStatement = !1, this.widthWithConnectedBlocks = 0, this.type = this.type | w.SPACER | w.BETWEEN_ROW_SPACER, this.elements = [new Fn(
            this.constants_,
            n
          )];
        }
        measure() {
        }
      }, Ul = class extends j_ {
        constructor(e, t) {
          super(e), this.type = (t && t !== "left" ? w.RIGHT_SQUARE_CORNER : w.LEFT_SQUARE_CORNER) | w.CORNER, this.width = this.height = this.constants_.NO_PADDING;
        }
      }, vc = class extends wl {
        constructor(e) {
          super(e), this.ascenderHeight = this.capline = 0, this.hasPreviousConnection = !1, this.connection = null, this.type |= w.TOP_ROW;
        }
        hasLeftSquareCorner(e) {
          const t = (e.hat ? e.hat === "cap" : this.constants_.ADD_START_HATS) && !e.outputConnection && !e.previousConnection, n = e.getPreviousBlock();
          return !!e.outputConnection || t || (n ? n.getNextBlock() === e : !1);
        }
        hasRightSquareCorner(e) {
          return !0;
        }
        measure() {
          let e = 0, t = 0, n = 0;
          for (let o = 0; o < this.elements.length; o++) {
            const c = this.elements[o];
            t += c.width, w.isSpacer(c) || (w.isHat(c) && c instanceof Bl ? n = Math.max(n, c.ascenderHeight) : e = Math.max(e, c.height));
          }
          this.width = Math.max(this.minWidth, t), this.height = Math.max(this.minHeight, e) + n, this.capline = this.ascenderHeight = n, this.widthWithConnectedBlocks = this.width;
        }
        startsWithElemSpacer() {
          return !1;
        }
        endsWithElemSpacer() {
          return !1;
        }
      }, gs = class {
        constructor(e, t) {
          this.statementEdge = this.width = this.widthWithChildren = this.height = 0, this.rows = [], this.inputRows = [], this.startY = this.startX = 0, this.renderer_ = e, this.block_ = t, this.constants_ = this.renderer_.getConstants(), this.outputConnection = t.outputConnection ? new gd(this.constants_, t.outputConnection) : null, this.isInline = t.getInputsInline() && !t.isCollapsed(), this.isCollapsed = t.isCollapsed(), this.isInsertionMarker = t.isInsertionMarker(), this.RTL = t.RTL, this.topRow = new vc(this.constants_), this.bottomRow = new uE(this.constants_);
        }
        getRenderer() {
          return this.renderer_;
        }
        measure() {
          this.createRows_(), this.addElemSpacing_(), this.addRowSpacing_(), this.computeBounds_(), this.alignRowElements_(), this.finalize_();
        }
        createRows_() {
          this.populateTopRow_(), this.rows.push(this.topRow);
          let e = new Ur(this.constants_);
          this.inputRows.push(e);
          var t = this.block_.getIcons();
          for (let n = 0, o; o = t[n]; n++) {
            const c = new Pd(this.constants_, o);
            this.isCollapsed && !o.isShownWhenCollapsed() || e.elements.push(c);
          }
          t = void 0;
          for (let n = 0, o; o = this.block_.inputList[n]; n++)
            if (o.isVisible()) {
              this.shouldStartNewRow_(o, t) && (this.rows.push(e), e = new Ur(this.constants_), this.inputRows.push(e));
              for (let c = 0, A; A = o.fieldRow[c]; c++)
                e.elements.push(new Ls(this.constants_, A, o));
              this.addInput_(o, e), t = o;
            }
          this.isCollapsed && (e.hasJaggedEdge = !0, e.elements.push(new Dd(this.constants_))), (e.elements.length || e.hasDummyInput) && this.rows.push(e), this.populateBottomRow_(), this.rows.push(this.bottomRow);
        }
        populateTopRow_() {
          var e = !!this.block_.previousConnection;
          const t = (this.block_.hat ? this.block_.hat === "cap" : this.constants_.ADD_START_HATS) && !this.outputConnection && !e;
          let n = this.topRow.hasLeftSquareCorner(this.block_) ? Ul : Yl;
          this.topRow.elements.push(new n(this.constants_)), t ? (e = new Bl(this.constants_), this.topRow.elements.push(e), this.topRow.capline = e.ascenderHeight) : e && (this.topRow.hasPreviousConnection = !0, this.topRow.connection = new AE(this.constants_, this.block_.previousConnection), this.topRow.elements.push(this.topRow.connection)), this.block_.inputList.length && this.block_.inputList[0] instanceof Wn && !this.block_.isCollapsed() ? this.topRow.minHeight = this.constants_.TOP_ROW_PRECEDES_STATEMENT_MIN_HEIGHT : this.topRow.minHeight = this.constants_.TOP_ROW_MIN_HEIGHT, n = this.topRow.hasRightSquareCorner(this.block_) ? Ul : Yl, this.topRow.elements.push(new n(this.constants_, "right"));
        }
        populateBottomRow_() {
          this.bottomRow.hasNextConnection = !!this.block_.nextConnection, this.bottomRow.minHeight = this.block_.inputList.length && this.block_.inputList[this.block_.inputList.length - 1] instanceof Wn ? this.constants_.BOTTOM_ROW_AFTER_STATEMENT_MIN_HEIGHT : this.constants_.BOTTOM_ROW_MIN_HEIGHT, this.bottomRow.hasLeftSquareCorner(this.block_) ? this.bottomRow.elements.push(new Ul(this.constants_)) : this.bottomRow.elements.push(new Yl(this.constants_)), this.bottomRow.hasNextConnection && (this.bottomRow.connection = new Ld(
            this.constants_,
            this.block_.nextConnection
          ), this.bottomRow.elements.push(this.bottomRow.connection)), this.bottomRow.hasRightSquareCorner(this.block_) ? this.bottomRow.elements.push(new Ul(this.constants_, "right")) : this.bottomRow.elements.push(new Yl(this.constants_, "right"));
        }
        addInput_(e, t) {
          this.isInline && e instanceof r.ValueInput$$module$build$src$core$inputs$value_input ? (t.elements.push(new EE(
            this.constants_,
            e
          )), t.hasInlineInput = !0) : e instanceof Wn ? (t.elements.push(new ir(this.constants_, e)), t.hasStatement = !0) : e instanceof r.ValueInput$$module$build$src$core$inputs$value_input ? (t.elements.push(new Ds(this.constants_, e)), t.hasExternalInput = !0) : e instanceof t_ && (t.minHeight = Math.max(t.minHeight, e.getSourceBlock() && e.getSourceBlock().isShadow() ? this.constants_.DUMMY_INPUT_SHADOW_MIN_HEIGHT : this.constants_.DUMMY_INPUT_MIN_HEIGHT), t.hasDummyInput = !0), t.align === null && (t.align = e.align);
        }
        shouldStartNewRow_(e, t) {
          return t ? e instanceof Wn || t instanceof Wn ? !0 : e instanceof r.ValueInput$$module$build$src$core$inputs$value_input || e instanceof t_ ? !this.isInline : !1 : !1;
        }
        addElemSpacing_() {
          for (let e = 0, t; t = this.rows[e]; e++) {
            const n = t.elements;
            if (t.elements = [], t.startsWithElemSpacer() && t.elements.push(new Fn(this.constants_, this.getInRowSpacing_(null, n[0]))), n.length) {
              for (let o = 0; o < n.length - 1; o++) {
                t.elements.push(n[o]);
                const c = this.getInRowSpacing_(n[o], n[o + 1]);
                t.elements.push(new Fn(this.constants_, c));
              }
              t.elements.push(n[n.length - 1]), t.endsWithElemSpacer() && t.elements.push(new Fn(this.constants_, this.getInRowSpacing_(n[n.length - 1], null)));
            }
          }
        }
        getInRowSpacing_(e, t) {
          if (!e && t && w.isStatementInput(t))
            return this.constants_.STATEMENT_INPUT_PADDING_LEFT;
          if (e && w.isInput(e) && !t) {
            if (w.isExternalInput(e))
              return this.constants_.NO_PADDING;
            if (w.isInlineInput(e))
              return this.constants_.LARGE_PADDING;
            if (w.isStatementInput(e))
              return this.constants_.NO_PADDING;
          }
          return e && w.isLeftSquareCorner(e) && t && (w.isPreviousConnection(t) || w.isNextConnection(t)) ? t.notchOffset : e && w.isLeftRoundedCorner(e) && t && (w.isPreviousConnection(t) || w.isNextConnection(t)) ? t.notchOffset - this.constants_.CORNER_RADIUS : this.constants_.MEDIUM_PADDING;
        }
        computeBounds_() {
          let e = 0, t = 0, n = 0;
          for (let c = 0, A; A = this.rows[c]; c++) {
            if (A.measure(), t = Math.max(t, A.width), A.hasStatement) {
              var o = A.getLastInput();
              let D, $;
              o = A.width - (($ = (D = o) == null ? void 0 : D.width) != null ? $ : 0), e = Math.max(e, o);
            }
            n = Math.max(n, A.widthWithConnectedBlocks);
          }
          this.statementEdge = e, this.width = t;
          for (let c = 0, A; A = this.rows[c]; c++)
            A.hasStatement && (A.statementEdge = this.statementEdge);
          this.widthWithChildren = Math.max(t, n), this.outputConnection && (this.startX = this.outputConnection.width, this.width += this.outputConnection.width, this.widthWithChildren += this.outputConnection.width);
        }
        alignRowElements_() {
          for (let t = 0, n; n = this.rows[t]; t++)
            if (n.hasStatement)
              this.alignStatementRow_(n);
            else {
              var e = n.width;
              e = this.getDesiredRowWidth_(n) - e, 0 < e && this.addAlignmentPadding_(n, e), w.isTopOrBottomRow(n) && (n.widthWithConnectedBlocks = n.width);
            }
        }
        getDesiredRowWidth_(e) {
          return this.width - this.startX;
        }
        addAlignmentPadding_(e, t) {
          const n = e.getFirstSpacer(), o = e.getLastSpacer();
          if ((e.hasExternalInput || e.hasStatement) && (e.widthWithConnectedBlocks += t), e.align === r.Align$$module$build$src$core$inputs$align.LEFT && o)
            o.width += t;
          else if (e.align === r.Align$$module$build$src$core$inputs$align.CENTRE && n && o)
            n.width += t / 2, o.width += t / 2;
          else if (e.align === r.Align$$module$build$src$core$inputs$align.RIGHT && n)
            n.width += t;
          else if (o)
            o.width += t;
          else
            return;
          e.width += t;
        }
        alignStatementRow_(e) {
          const t = e.getLastInput();
          if (t) {
            var n = e.width - t.width, o = this.statementEdge;
            n = o - n, 0 < n && this.addAlignmentPadding_(e, n), n = e.width, o = this.getDesiredRowWidth_(e), t.width += o - n, t.height = Math.max(t.height, e.height), e.width += o - n, e.widthWithConnectedBlocks = Math.max(e.width, this.statementEdge + e.connectedBlockWidths);
          }
        }
        addRowSpacing_() {
          const e = this.rows;
          this.rows = [];
          for (let t = 0; t < e.length; t++)
            this.rows.push(e[t]), t !== e.length - 1 && this.rows.push(this.makeSpacerRow_(
              e[t],
              e[t + 1]
            ));
        }
        makeSpacerRow_(e, t) {
          var n = this.getSpacerRowHeight_(e, t);
          const o = this.getSpacerRowWidth_(e, t);
          return n = new dE(this.constants_, n, o), e.hasStatement && (n.followsStatement = !0), t.hasStatement && (n.precedesStatement = !0), n;
        }
        getSpacerRowWidth_(e, t) {
          return this.width - this.startX;
        }
        getSpacerRowHeight_(e, t) {
          return this.constants_.MEDIUM_PADDING;
        }
        getElemCenterline_(e, t) {
          return w.isSpacer(t) ? e.yPos + t.height / 2 : w.isBottomRow(e) ? (e = e.yPos + e.height - e.descenderHeight, w.isNextConnection(t) ? e + t.height / 2 : e - t.height / 2) : w.isTopRow(e) ? w.isHat(t) ? e.capline - t.height / 2 : e.capline + t.height / 2 : e.yPos + e.height / 2;
        }
        recordElemPositions_(e) {
          let t = e.xPos;
          for (let n = 0, o; o = e.elements[n]; n++)
            w.isSpacer(o) && (o.height = e.height), o.xPos = t, o.centerline = this.getElemCenterline_(e, o), t += o.width;
        }
        finalize_() {
          let e = 0, t = 0;
          for (let n = 0, o; o = this.rows[n]; n++)
            o.yPos = t, o.xPos = this.startX, t += o.height, e = Math.max(e, o.widthWithConnectedBlocks), this.recordElemPositions_(o);
          if (this.outputConnection && this.block_.nextConnection) {
            const n = this.block_.nextConnection.targetBlock();
            n && (e = Math.max(e, n.getHeightWidth().width));
          }
          this.widthWithChildren = e + this.startX, this.height = t, this.startY = this.topRow.capline, this.bottomRow.baseline = t - this.bottomRow.descenderHeight;
        }
      }, fd = class extends uE {
        constructor(e) {
          super(e);
        }
        endsWithElemSpacer() {
          return !1;
        }
        hasLeftSquareCorner(e) {
          return !!e.outputConnection;
        }
        hasRightSquareCorner(e) {
          return !!e.outputConnection && !e.statementInputCount && !e.nextConnection;
        }
      }, $c = class extends ir {
        constructor(e, t) {
          if (super(e, t), this.connectedBottomNextConnection = !1, this.connectedBlock) {
            for (e = this.connectedBlock; t = e.getNextBlock(); )
              e = t;
            e.nextConnection || (this.height = this.connectedBlockHeight, this.connectedBottomNextConnection = !0);
          }
        }
      }, SE = class extends j_ {
        constructor(e) {
          super(e), this.width = this.height = 0, this.type |= w.getType("RIGHT_CONNECTION");
        }
      }, hE = class extends vc {
        constructor(e) {
          super(e);
        }
        endsWithElemSpacer() {
          return !1;
        }
        hasLeftSquareCorner(e) {
          const t = (e.hat ? e.hat === "cap" : this.constants_.ADD_START_HATS) && !e.outputConnection && !e.previousConnection;
          return !!e.outputConnection || t;
        }
        hasRightSquareCorner(e) {
          return !!e.outputConnection && !e.statementInputCount && !e.nextConnection;
        }
      }, Nd = class extends gs {
        constructor(e, t) {
          super(e, t), this.isInline = !0, this.renderer_ = e, this.constants_ = this.renderer_.getConstants(), this.topRow = new hE(this.constants_), this.bottomRow = new fd(this.constants_), this.isMultiRow = !t.getInputsInline() || t.isCollapsed(), this.hasStatementInput = 0 < t.statementInputCount, this.rightSide = this.outputConnection ? new SE(this.constants_) : null, this.rightAlignedDummyInputs = /* @__PURE__ */ new WeakMap();
        }
        getRenderer() {
          return this.renderer_;
        }
        measure() {
          this.createRows_(), this.addElemSpacing_(), this.addRowSpacing_(), this.adjustXPosition_(), this.computeBounds_(), this.alignRowElements_(), this.finalize_();
        }
        shouldStartNewRow_(e, t) {
          return t ? e instanceof Wn || t instanceof Wn ? !0 : e instanceof r.ValueInput$$module$build$src$core$inputs$value_input || e instanceof t_ ? !this.isInline || this.isMultiRow : !1 : !1;
        }
        getDesiredRowWidth_(e) {
          return e.hasStatement ? this.width - this.startX - (this.constants_.INSIDE_CORNERS.rightWidth || 0) : super.getDesiredRowWidth_(e);
        }
        getInRowSpacing_(e, t) {
          return e && t || !this.outputConnection || !this.outputConnection.isDynamicShape || this.hasStatementInput || this.bottomRow.hasNextConnection ? !e && t && w.isStatementInput(t) ? this.constants_.STATEMENT_INPUT_PADDING_LEFT : e && w.isLeftRoundedCorner(e) && t && (w.isPreviousConnection(t) || w.isNextConnection(t)) ? t.notchOffset - this.constants_.CORNER_RADIUS : e && w.isLeftSquareCorner(e) && t && w.isHat(t) ? this.constants_.NO_PADDING : this.constants_.MEDIUM_PADDING : this.constants_.NO_PADDING;
        }
        getSpacerRowHeight_(e, t) {
          if (w.isTopRow(e) && w.isBottomRow(t))
            return this.constants_.EMPTY_BLOCK_SPACER_HEIGHT;
          const n = w.isInputRow(e) && e.hasStatement, o = w.isInputRow(t) && t.hasStatement;
          return o || n ? (e = Math.max(this.constants_.NOTCH_HEIGHT, this.constants_.INSIDE_CORNERS.rightHeight || 0), o && n ? Math.max(e, this.constants_.DUMMY_INPUT_MIN_HEIGHT) : e) : w.isTopRow(e) ? e.hasPreviousConnection || this.outputConnection && !this.hasStatementInput ? this.constants_.NO_PADDING : Math.abs(this.constants_.NOTCH_HEIGHT - this.constants_.CORNER_RADIUS) : w.isBottomRow(t) ? this.outputConnection ? !t.hasNextConnection && this.hasStatementInput ? Math.abs(this.constants_.NOTCH_HEIGHT - this.constants_.CORNER_RADIUS) : this.constants_.NO_PADDING : Math.max(this.topRow.minHeight, Math.max(this.constants_.NOTCH_HEIGHT, this.constants_.CORNER_RADIUS)) - this.constants_.CORNER_RADIUS : this.constants_.MEDIUM_PADDING;
        }
        getSpacerRowWidth_(e, t) {
          const n = this.width - this.startX;
          return w.isInputRow(e) && e.hasStatement || w.isInputRow(t) && t.hasStatement ? Math.max(n, this.constants_.STATEMENT_INPUT_SPACER_MIN_WIDTH) : n;
        }
        getElemCenterline_(e, t) {
          if (e.hasStatement && !w.isSpacer(t) && !w.isStatementInput(t))
            return e.yPos + this.constants_.EMPTY_STATEMENT_INPUT_HEIGHT / 2;
          if (w.isInlineInput(t) && t instanceof So) {
            const n = t.connectedBlock;
            if (n && n.outputConnection && n.nextConnection)
              return e.yPos + n.height / 2;
          }
          return super.getElemCenterline_(e, t);
        }
        addInput_(e, t) {
          if (e instanceof t_ && t.hasDummyInput && t.align === r.Align$$module$build$src$core$inputs$align.LEFT && e.align === r.Align$$module$build$src$core$inputs$align.RIGHT)
            this.rightAlignedDummyInputs.set(t, e);
          else if (e instanceof Wn) {
            t.elements.push(new $c(
              this.constants_,
              e
            )), t.hasStatement = !0, t.align === null && (t.align = e.align);
            return;
          }
          super.addInput_(e, t);
        }
        addAlignmentPadding_(e, t) {
          if (this.rightAlignedDummyInputs.get(e)) {
            let n;
            for (let o = 0; o < e.elements.length; o++) {
              const c = e.elements[o];
              if (w.isSpacer(c) && (n = c), w.isField(c) && c instanceof Ls && c.parentInput === this.rightAlignedDummyInputs.get(e))
                break;
            }
            if (n) {
              n.width += t, e.width += t;
              return;
            }
          }
          super.addAlignmentPadding_(e, t);
        }
        adjustXPosition_() {
          const e = this.constants_.NOTCH_OFFSET_LEFT + this.constants_.NOTCH_WIDTH;
          let t = e;
          for (let c = 2; c < this.rows.length - 1; c += 2) {
            var n = this.rows[c - 1];
            const A = this.rows[c];
            var o = this.rows[c + 1];
            if (n = c === 2 ? !!this.topRow.hasPreviousConnection : !!n.followsStatement, o = c + 2 >= this.rows.length - 1 ? !!this.bottomRow.hasNextConnection : !!o.precedesStatement, w.isInputRow(A) && A.hasStatement) {
              A.measure();
              let D, $;
              t = A.width - (($ = (D = A.getLastInput()) == null ? void 0 : D.width) != null ? $ : 0) + e;
            } else if (n && (c === 2 || o) && w.isInputRow(A) && !A.hasStatement) {
              o = A.xPos, n = null;
              for (let D = 0; D < A.elements.length; D++) {
                const $ = A.elements[D];
                w.isSpacer($) && (n = $), n && (w.isField($) || w.isInput($)) && o < t && !(w.isField($) && $ instanceof Ls && ($.field instanceof K_ || $.field instanceof hT)) && (n.width += t - o), o += $.width;
              }
            }
          }
        }
        finalizeOutputConnection_() {
          if (this.outputConnection && this.outputConnection.isDynamicShape) {
            var e = this.outputConnection.shape;
            if ("isDynamic" in e && e.isDynamic) {
              for (var t = 0, n = 0; n < this.rows.length; n++) {
                const o = this.rows[n];
                o.yPos = t, t += o.height;
              }
              this.height = t, n = this.bottomRow.hasNextConnection ? this.height - this.bottomRow.descenderHeight : this.height, t = e.height(n), n = e.width(n), this.outputConnection.height = t, this.outputConnection.width = n, this.outputConnection.startX = n, this.outputConnection.connectionOffsetY = e.connectionOffsetY(t), this.outputConnection.connectionOffsetX = e.connectionOffsetX(n), e = 0, this.hasStatementInput || this.bottomRow.hasNextConnection || (e = n, this.rightSide.height = t, this.rightSide.width = e, this.rightSide.centerline = t / 2, this.rightSide.xPos = this.width + e), this.startX = n, this.width += n + e, this.widthWithChildren += n + e;
            }
          }
        }
        finalizeHorizontalAlignment_() {
          if (this.outputConnection && !this.hasStatementInput && !this.bottomRow.hasNextConnection) {
            for (var e = 0, t = 0; t < this.rows.length; t++) {
              var n = this.rows[t];
              if (!w.isInputRow(n))
                continue;
              e = n.elements[n.elements.length - 2];
              let o = this.getNegativeSpacing_(n.elements[1]), c = this.getNegativeSpacing_(e);
              e = o + c;
              const A = this.constants_.MIN_BLOCK_WIDTH + 2 * this.outputConnection.width;
              this.width - e < A && (e = this.width - A, o = e / 2, c = e / 2), n.elements.unshift(new Fn(this.constants_, -o)), n.elements.push(new Fn(this.constants_, -c));
            }
            if (e)
              for (this.width -= e, this.widthWithChildren -= e, this.rightSide.xPos -= e, t = 0; t < this.rows.length; t++)
                n = this.rows[t], w.isTopOrBottomRow(n) && (n.elements[1].width -= e), n.width -= e, n.widthWithConnectedBlocks -= e;
          }
        }
        getNegativeSpacing_(e) {
          if (!e || !this.outputConnection)
            return 0;
          const t = this.outputConnection.width;
          var n = this.outputConnection.shape.type;
          const o = this.constants_;
          if (this.isMultiRow && 1 < this.inputRows.length)
            switch (n) {
              case o.SHAPES.ROUND:
                return n = this.constants_.MAX_DYNAMIC_CONNECTION_SHAPE_WIDTH, n = this.height / 2 > n ? n : this.height / 2, t - n * (1 - Math.sin(Math.acos((n - this.constants_.SMALL_PADDING) / n)));
              default:
                return 0;
            }
          if (w.isInlineInput(e) && e instanceof So) {
            const c = e.connectedBlock;
            return e = c ? c.pathObject.outputShapeType : e.shape.type, e == null || c && c.outputConnection && (c.statementInputCount || c.nextConnection) || n === o.SHAPES.HEXAGONAL && n !== e ? 0 : t - this.constants_.SHAPE_IN_SHAPE_PADDING[n][e];
          }
          return w.isField(e) && e instanceof Ls ? n === o.SHAPES.ROUND && e.field instanceof Ps ? t - 2.75 * o.GRID_UNIT : t - this.constants_.SHAPE_IN_SHAPE_PADDING[n][0] : w.isIcon(e) ? this.constants_.SMALL_PADDING : 0;
        }
        finalizeVerticalAlignment_() {
          if (!this.outputConnection)
            for (let o = 2; o < this.rows.length - 1; o += 2) {
              const c = this.rows[o - 1], A = this.rows[o], D = this.rows[o + 1];
              var e = o === 2, t = o + 2 >= this.rows.length - 1 ? !!this.bottomRow.hasNextConnection : !!D.precedesStatement;
              if (e ? this.topRow.hasPreviousConnection : c.followsStatement) {
                var n = A.elements[1];
                if (n = A.elements.length === 3 && n instanceof Ls && (n.field instanceof K_ || n.field instanceof hT), !e && n)
                  c.height -= this.constants_.SMALL_PADDING, D.height -= this.constants_.SMALL_PADDING, A.height -= this.constants_.MEDIUM_PADDING;
                else if (!e && !t)
                  c.height += this.constants_.SMALL_PADDING;
                else if (t) {
                  for (e = !1, t = 0; t < A.elements.length; t++)
                    if (n = A.elements[t], n instanceof So && w.isInlineInput(n) && n.connectedBlock && !n.connectedBlock.isShadow() && 40 <= n.connectedBlock.getHeightWidth().height) {
                      e = !0;
                      break;
                    }
                  e && (c.height -= this.constants_.SMALL_PADDING, D.height -= this.constants_.SMALL_PADDING);
                }
              }
            }
        }
        finalize_() {
          this.finalizeOutputConnection_(), this.finalizeHorizontalAlignment_(), this.finalizeVerticalAlignment_(), super.finalize_(), this.rightSide && (this.widthWithChildren += this.rightSide.width);
        }
      }, BS = "blocklyCursor", YS = "blocklyMarker", US = 0.75, ho = class {
        constructor(e, t, n) {
          this.workspace = e, this.marker = n, this.markerSvgRect_ = this.markerSvgLine_ = this.markerInput_ = this.markerBlock_ = this.svgGroup_ = this.markerSvg_ = this.currentMarkerSvg = this.parent = null, this.constants_ = t, e = this.isCursor() ? this.constants_.CURSOR_COLOUR : this.constants_.MARKER_COLOUR, this.colour_ = n.colour || e;
        }
        getSvgRoot() {
          return this.svgGroup_;
        }
        getMarker() {
          return this.marker;
        }
        isCursor() {
          return this.marker.type === "cursor";
        }
        createDom() {
          const e = this.isCursor() ? BS : YS;
          return this.svgGroup_ = K(U.G, { class: e }), this.createDomInternal_(), this.svgGroup_;
        }
        setParent_(e) {
          this.isCursor() ? (this.parent && this.parent.setCursorSvg(null), e.setCursorSvg(this.getSvgRoot())) : (this.parent && this.parent.setMarkerSvg(null), e.setMarkerSvg(this.getSvgRoot())), this.parent = e;
        }
        draw(e, t) {
          if (t) {
            this.constants_ = this.workspace.getRenderer().getConstants();
            var n = this.isCursor() ? this.constants_.CURSOR_COLOUR : this.constants_.MARKER_COLOUR;
            this.colour_ = this.marker.colour || n, this.applyColour_(t), this.showAtLocation_(t), this.fireMarkerEvent(e, t), e = this.currentMarkerSvg.childNodes[0], e !== void 0 && e.beginElement && e.beginElement();
          } else
            this.hide();
        }
        showAtLocation_(e) {
          const t = e.getLocation().type;
          e.getType() === ne.types.BLOCK ? this.showWithBlock_(e) : e.getType() === ne.types.OUTPUT ? this.showWithOutput_(e) : t === Ie.INPUT_VALUE ? this.showWithInput_(e) : t === Ie.NEXT_STATEMENT ? this.showWithNext_(e) : e.getType() === ne.types.PREVIOUS ? this.showWithPrevious_(e) : e.getType() === ne.types.FIELD ? this.showWithField_(e) : e.getType() === ne.types.WORKSPACE ? this.showWithCoordinates_(e) : e.getType() === ne.types.STACK && this.showWithStack_(e);
        }
        showWithBlockPrevOutput(e) {
          e = e.getSourceBlock();
          const t = e.width;
          var n = e.height, o = n * US;
          const c = this.constants_.CURSOR_BLOCK_PADDING;
          e.previousConnection ? (n = this.constants_.shapeFor(e.previousConnection), this.positionPrevious_(t, c, o, n)) : e.outputConnection ? (o = this.constants_.shapeFor(e.outputConnection), this.positionOutput_(t, n, o)) : this.positionBlock_(t, c, o), this.setParent_(e), this.showCurrent_();
        }
        showWithBlock_(e) {
          this.showWithBlockPrevOutput(e);
        }
        showWithPrevious_(e) {
          this.showWithBlockPrevOutput(e);
        }
        showWithOutput_(e) {
          this.showWithBlockPrevOutput(e);
        }
        showWithCoordinates_(e) {
          var t = e.getWsCoordinate();
          e = t.x, t = t.y, this.workspace.RTL && (e -= this.constants_.CURSOR_WS_WIDTH), this.positionLine_(e, t, this.constants_.CURSOR_WS_WIDTH), this.setParent_(this.workspace), this.showCurrent_();
        }
        showWithField_(e) {
          e = e.getLocation();
          const t = e.getSize().width, n = e.getSize().height;
          this.positionRect_(0, 0, t, n), this.setParent_(e), this.showCurrent_();
        }
        showWithInput_(e) {
          e = e.getLocation();
          const t = e.getSourceBlock();
          this.positionInput_(e), this.setParent_(t), this.showCurrent_();
        }
        showWithNext_(e) {
          var t = e.getLocation();
          e = t.getSourceBlock();
          let n = 0;
          t = t.getOffsetInBlock().y;
          const o = e.getHeightWidth().width;
          this.workspace.RTL && (n = -o), this.positionLine_(n, t, o), this.setParent_(e), this.showCurrent_();
        }
        showWithStack_(e) {
          e = e.getLocation();
          var t = e.getHeightWidth();
          const n = t.width + this.constants_.CURSOR_STACK_PADDING;
          t = t.height + this.constants_.CURSOR_STACK_PADDING;
          const o = -this.constants_.CURSOR_STACK_PADDING / 2, c = -this.constants_.CURSOR_STACK_PADDING / 2;
          let A = o;
          this.workspace.RTL && (A = -(n + o)), this.positionRect_(A, c, n, t), this.setParent_(e), this.showCurrent_();
        }
        showCurrent_() {
          this.hide(), this.currentMarkerSvg && (this.currentMarkerSvg.style.display = "");
        }
        positionBlock_(e, t, n) {
          if (e = Wt(-t, n) + de("V", -t) + de("H", e + 2 * t) + de("V", n), !this.markerBlock_)
            throw Error("createDom should be called before positioning the marker");
          this.markerBlock_.setAttribute("d", e), this.workspace.RTL && this.flipRtl(this.markerBlock_), this.currentMarkerSvg = this.markerBlock_;
        }
        positionInput_(e) {
          const t = e.getOffsetInBlock().x, n = e.getOffsetInBlock().y;
          e = Or(0, 0) + this.constants_.shapeFor(e).pathDown, this.markerInput_.setAttribute("d", e), this.markerInput_.setAttribute("transform", "translate(" + t + "," + n + ")" + (this.workspace.RTL ? " scale(-1 1)" : "")), this.currentMarkerSvg = this.markerInput_;
        }
        positionLine_(e, t, n) {
          if (!this.markerSvgLine_)
            throw Error("createDom should be called before positioning the line");
          this.markerSvgLine_.setAttribute("x", `${e}`), this.markerSvgLine_.setAttribute("y", `${t}`), this.markerSvgLine_.setAttribute("width", `${n}`), this.currentMarkerSvg = this.markerSvgLine_;
        }
        positionOutput_(e, t, n) {
          if (!this.markerBlock_)
            throw Error("createDom should be called before positioning the output");
          e = Wt(e, 0) + de("h", -(e - n.width)) + de("v", this.constants_.TAB_OFFSET_FROM_TOP) + n.pathDown + de("V", t) + de("H", e), this.markerBlock_.setAttribute("d", e), this.workspace.RTL && this.flipRtl(this.markerBlock_), this.currentMarkerSvg = this.markerBlock_;
        }
        positionPrevious_(e, t, n, o) {
          if (!this.markerBlock_)
            throw Error("createDom should be called before positioning the previous connection marker");
          e = Wt(-t, n) + de(
            "V",
            -t
          ) + de("H", this.constants_.NOTCH_OFFSET_LEFT) + o.pathLeft + de("H", e + 2 * t) + de("V", n), this.markerBlock_.setAttribute("d", e), this.workspace.RTL && this.flipRtl(this.markerBlock_), this.currentMarkerSvg = this.markerBlock_;
        }
        positionRect_(e, t, n, o) {
          if (!this.markerSvgRect_)
            throw Error("createDom should be called before positioning the rect");
          this.markerSvgRect_.setAttribute(
            "x",
            `${e}`
          ), this.markerSvgRect_.setAttribute("y", `${t}`), this.markerSvgRect_.setAttribute("width", `${n}`), this.markerSvgRect_.setAttribute("height", `${o}`), this.currentMarkerSvg = this.markerSvgRect_;
        }
        flipRtl(e) {
          e.setAttribute("transform", "scale(-1 1)");
        }
        hide() {
          if (!(this.markerSvgLine_ && this.markerSvgRect_ && this.markerInput_ && this.markerBlock_))
            throw Error("createDom should be called before hiding the marker");
          this.markerSvgLine_.style.display = "none", this.markerSvgRect_.style.display = "none", this.markerInput_.style.display = "none", this.markerBlock_.style.display = "none";
        }
        fireMarkerEvent(e, t) {
          const n = t.getSourceBlock();
          e = new (ge(eo))(n, this.isCursor(), e, t), fe(e);
        }
        getBlinkProperties_() {
          return { attributeType: "XML", attributeName: "fill", dur: "1s", values: this.colour_ + ";transparent;transparent;", repeatCount: "indefinite" };
        }
        createDomInternal_() {
          if (this.markerSvg_ = K(
            U.G,
            { width: this.constants_.CURSOR_WS_WIDTH, height: this.constants_.WS_CURSOR_HEIGHT },
            this.svgGroup_
          ), this.markerSvgLine_ = K(U.RECT, { width: this.constants_.CURSOR_WS_WIDTH, height: this.constants_.WS_CURSOR_HEIGHT, style: "display: none" }, this.markerSvg_), this.markerSvgRect_ = K(
            U.RECT,
            { class: "blocklyVerticalMarker", rx: 10, ry: 10, style: "display: none" },
            this.markerSvg_
          ), this.markerInput_ = K(U.PATH, { transform: "", style: "display: none" }, this.markerSvg_), this.markerBlock_ = K(U.PATH, { transform: "", style: "display: none", fill: "none", "stroke-width": this.constants_.CURSOR_STROKE_WIDTH }, this.markerSvg_), this.isCursor()) {
            const e = this.getBlinkProperties_();
            K(
              U.ANIMATE,
              e,
              this.markerSvgLine_
            ), K(U.ANIMATE, e, this.markerInput_), K(U.ANIMATE, Object.assign({}, e, { attributeName: "stroke" }), this.markerBlock_);
          }
          return this.markerSvg_;
        }
        applyColour_(e) {
          if (!(this.markerSvgLine_ && this.markerSvgRect_ && this.markerInput_ && this.markerBlock_))
            throw Error("createDom should be called before applying color to the markerj");
          this.markerSvgLine_.setAttribute("fill", this.colour_), this.markerSvgRect_.setAttribute("stroke", this.colour_), this.markerInput_.setAttribute("fill", this.colour_), this.markerBlock_.setAttribute("stroke", this.colour_), this.isCursor() && (e = this.colour_ + ";transparent;transparent;", this.markerSvgLine_.firstElementChild.setAttribute("values", e), this.markerInput_.firstElementChild.setAttribute("values", e), this.markerBlock_.firstElementChild.setAttribute("values", e));
        }
        dispose() {
          this.svgGroup_ && Tt(this.svgGroup_);
        }
      }, bd = class extends ho {
        constructor(e, t, n) {
          super(e, t, n), this.markerCircle = null;
        }
        showWithInputOutput(e) {
          const t = e.getSourceBlock();
          e = e.getLocation().getOffsetInBlock(), this.positionCircle(e.x, e.y), this.setParent_(t), this.showCurrent_();
        }
        showWithOutput_(e) {
          this.showWithInputOutput(e);
        }
        showWithInput_(e) {
          this.showWithInputOutput(e);
        }
        showWithBlock_(e) {
          e = e.getLocation();
          const t = e.getHeightWidth();
          this.positionRect_(0, 0, t.width, t.height), this.setParent_(e), this.showCurrent_();
        }
        positionCircle(e, t) {
          let n;
          (n = this.markerCircle) == null || n.setAttribute("cx", `${e}`);
          let o;
          (o = this.markerCircle) == null || o.setAttribute("cy", `${t}`), this.currentMarkerSvg = this.markerCircle;
        }
        hide() {
          super.hide(), this.markerCircle && (this.markerCircle.style.display = "none");
        }
        createDomInternal_() {
          if (super.createDomInternal_(), this.markerCircle = K(
            U.CIRCLE,
            { r: this.constants_.CURSOR_RADIUS, style: "display: none", "stroke-width": this.constants_.CURSOR_STROKE_WIDTH },
            this.markerSvg_
          ), this.isCursor()) {
            const e = this.getBlinkProperties_();
            K(U.ANIMATE, e, this.markerCircle);
          }
          return this.markerSvg_;
        }
        applyColour_(e) {
          super.applyColour_(e);
          let t;
          (t = this.markerCircle) == null || t.setAttribute("fill", this.colour_);
          let n;
          if ((n = this.markerCircle) == null || n.setAttribute("stroke", this.colour_), this.isCursor()) {
            e = this.colour_ + ";transparent;transparent;";
            let o;
            (o = this.markerCircle) == null || o.firstElementChild.setAttribute("values", e);
          }
        }
      }, Wc = class {
        constructor(e, t, n) {
          this.markerSvg = this.cursorSvg = null, this.constants = n, this.style = t, this.svgRoot = e, this.svgPath = K(U.PATH, { class: "blocklyPath" }, this.svgRoot);
        }
        setPath(e) {
          this.svgPath.setAttribute("d", e);
        }
        flipRTL() {
          this.svgPath.setAttribute("transform", "scale(-1 1)");
        }
        setCursorSvg(e) {
          e ? (this.svgRoot.appendChild(e), this.cursorSvg = e) : this.cursorSvg = null;
        }
        setMarkerSvg(e) {
          e ? (this.cursorSvg ? this.svgRoot.insertBefore(e, this.cursorSvg) : this.svgRoot.appendChild(e), this.markerSvg = e) : this.markerSvg = null;
        }
        applyColour(e) {
          this.svgPath.setAttribute("stroke", this.style.colourTertiary), this.svgPath.setAttribute("fill", this.style.colourPrimary), this.updateShadow_(e.isShadow()), this.updateDisabled_(!e.isEnabled() || e.getInheritedDisabled());
        }
        setStyle(e) {
          this.style = e;
        }
        setClass_(e, t) {
          e && (t ? be(this.svgRoot, e) : Be(
            this.svgRoot,
            e
          ));
        }
        updateHighlighted(e) {
          e ? this.svgPath.setAttribute("filter", "url(#" + this.constants.embossFilterId + ")") : this.svgPath.setAttribute("filter", "none");
        }
        updateShadow_(e) {
          e && (this.svgPath.setAttribute("stroke", "none"), this.svgPath.setAttribute("fill", this.style.colourSecondary));
        }
        updateDisabled_(e) {
          this.setClass_("blocklyDisabled", e), e && this.svgPath.setAttribute("fill", "url(#" + this.constants.disabledPatternId + ")");
        }
        updateSelected(e) {
          this.setClass_("blocklySelected", e);
        }
        updateDraggingDelete(e) {
          this.setClass_(
            "blocklyDraggingDelete",
            e
          );
        }
        updateInsertionMarker(e) {
          this.setClass_("blocklyInsertionMarker", e);
        }
        updateMovable(e) {
          this.setClass_("blocklyDraggable", e);
        }
        updateReplacementFade(e) {
          this.setClass_("blocklyReplaceable", e);
        }
        updateShapeForInputHighlight(e, t) {
        }
      }, Cd = class extends Wc {
        constructor(e, t, n) {
          super(e, t, n), this.svgPathSelected = null, this.outlines = /* @__PURE__ */ new Map(), this.remainingOutlines = /* @__PURE__ */ new Set(), this.outputShapeType = null, this.constants = n;
        }
        setPath(e) {
          super.setPath(e), this.svgPathSelected && this.svgPathSelected.setAttribute("d", e);
        }
        applyColour(e) {
          super.applyColour(e);
          const t = e.getParent();
          e.isShadow() && t && this.svgPath.setAttribute("stroke", t.style.colourTertiary);
          for (const n of this.outlines.values())
            n.setAttribute("fill", this.style.colourTertiary);
        }
        flipRTL() {
          super.flipRTL();
          for (const e of this.outlines.values())
            e.setAttribute("transform", "scale(-1 1)");
        }
        updateSelected(e) {
          this.setClass_("blocklySelected", e), e ? this.svgPathSelected || (this.svgPathSelected = this.svgPath.cloneNode(!0), this.svgPathSelected.setAttribute("fill", "none"), this.svgPathSelected.setAttribute("filter", "url(#" + this.constants.selectedGlowFilterId + ")"), this.svgRoot.appendChild(this.svgPathSelected)) : this.svgPathSelected && (this.svgRoot.removeChild(this.svgPathSelected), this.svgPathSelected = null);
        }
        updateReplacementFade(e) {
          this.setClass_("blocklyReplaceable", e), e ? this.svgPath.setAttribute("filter", "url(#" + this.constants.replacementGlowFilterId + ")") : this.svgPath.removeAttribute("filter");
        }
        updateShapeForInputHighlight(e, t) {
          e = e.getParentInput().name, (e = this.getOutlinePath(e)) && (t ? e.setAttribute("filter", "url(#" + this.constants.replacementGlowFilterId + ")") : e.removeAttribute("filter"));
        }
        beginDrawing() {
          this.remainingOutlines.clear();
          for (const e of this.outlines.keys())
            this.remainingOutlines.add(e);
        }
        endDrawing() {
          if (this.remainingOutlines.size)
            for (const e of this.remainingOutlines)
              this.removeOutlinePath(e);
          this.remainingOutlines.clear();
        }
        setOutlinePath(e, t) {
          e = this.getOutlinePath(e), e.setAttribute("d", t), e.setAttribute("fill", this.style.colourTertiary);
        }
        getOutlinePath(e) {
          return this.outlines.has(e) || this.outlines.set(e, K(U.PATH, {
            class: "blocklyOutlinePath",
            d: ""
          }, this.svgRoot)), this.remainingOutlines.delete(e), this.outlines.get(e);
        }
        removeOutlinePath(e) {
          let t, n;
          (t = this.outlines.get(e)) == null || (n = t.parentNode) == null || n.removeChild(this.outlines.get(e)), this.outlines.delete(e);
        }
      }, Vl = class {
        constructor(e) {
          this.overrides = null, this.name = e;
        }
        getClassName() {
          return this.name + "-renderer";
        }
        init(e, t) {
          this.constants_ = this.makeConstants_(), t && (this.overrides = t, Object.assign(this.constants_, t)), this.constants_.setTheme(e), this.constants_.init();
        }
        createDom(e, t) {
          this.constants_.createDom(e, this.name + "-" + t.name, "." + this.getClassName() + "." + t.getClassName());
        }
        refreshDom(e, t) {
          const n = this.getConstants();
          n.dispose(), this.constants_ = this.makeConstants_(), this.overrides && Object.assign(this.constants_, this.overrides), this.constants_.randomIdentifier = n.randomIdentifier, this.constants_.setTheme(t), this.constants_.init(), this.createDom(e, t);
        }
        dispose() {
          this.constants_ && this.constants_.dispose();
        }
        makeConstants_() {
          return new Ao();
        }
        makeRenderInfo_(e) {
          return new gs(this, e);
        }
        makeDrawer_(e, t) {
          return new kl(
            e,
            t
          );
        }
        makeMarkerDrawer(e, t) {
          return new ho(e, this.getConstants(), t);
        }
        makePathObject(e, t) {
          return new Wc(e, t, this.constants_);
        }
        getConstants() {
          return this.constants_;
        }
        shouldHighlightConnection(e) {
          return !0;
        }
        orphanCanConnectAtEnd(e, t, n) {
          return !!lt.getConnectionForOrphanedConnection(e, n === Ie.OUTPUT_VALUE ? t.outputConnection : t.previousConnection);
        }
        getConnectionPreviewMethod(e, t, n) {
          return t.type === Ie.OUTPUT_VALUE || t.type === Ie.PREVIOUS_STATEMENT ? !e.isConnected() || this.orphanCanConnectAtEnd(n, e.targetBlock(), t.type) ? $e.PREVIEW_TYPE.INSERTION_MARKER : $e.PREVIEW_TYPE.REPLACEMENT_FADE : $e.PREVIEW_TYPE.INSERTION_MARKER;
        }
        render(e) {
          const t = this.makeRenderInfo_(e);
          t.measure(), this.makeDrawer_(e, t).draw();
        }
      }, dt = {};
      dt.BottomRow = uE, dt.Connection = ST, dt.ConstantProvider = Ao, dt.Drawer = kl, dt.ExternalValueInput = Ds, dt.Field = Ls, dt.Hat = Bl, dt.Icon = Pd, dt.InRowSpacer = Fn, dt.InlineInput = EE, dt.InputConnection = So, dt.InputRow = Ur, dt.JaggedEdge = Dd, dt.MarkerSvg = ho, dt.Measurable = j_, dt.NextConnection = Ld, dt.OutputConnection = gd, dt.PathObject = Wc, dt.PreviousConnection = AE, dt.RenderInfo = gs, dt.Renderer = Vl, dt.RoundCorner = Yl, dt.Row = wl, dt.SpacerRow = dE, dt.SquareCorner = Ul, dt.StatementInput = ir, dt.TopRow = vc, dt.Types = w, dt.init = tu, dt.register = Jn, dt.unregister = RA;
      var IE = class extends Vl {
        constructor(e) {
          super(e);
        }
        makeConstants_() {
          return new Md();
        }
        makeRenderInfo_(e) {
          return new Nd(this, e);
        }
        makeDrawer_(e, t) {
          return new md(e, t);
        }
        makeMarkerDrawer(e, t) {
          return new bd(
            e,
            this.getConstants(),
            t
          );
        }
        makePathObject(e, t) {
          return new Cd(e, t, this.getConstants());
        }
        getConstants() {
          return this.constants_;
        }
        shouldHighlightConnection(e) {
          return e.type !== Ie.INPUT_VALUE && e.type !== Ie.OUTPUT_VALUE;
        }
        getConnectionPreviewMethod(e, t, n) {
          return t.type === Ie.OUTPUT_VALUE ? e.isConnected() ? $e.PREVIEW_TYPE.REPLACEMENT_FADE : $e.PREVIEW_TYPE.INPUT_OUTLINE : super.getConnectionPreviewMethod(e, t, n);
        }
      };
      Jn("zelos", IE);
      var r_ = {};
      r_.BottomRow = fd, r_.ConstantProvider = Md, r_.Drawer = md, r_.MarkerSvg = bd, r_.PathObject = Cd, r_.RenderInfo = Nd, r_.Renderer = IE, r_.RightConnectionShape = SE, r_.StatementInput = $c, r_.TopRow = hE, un();
      var tn = {};
      tn.registerCleanup = nu, tn.registerCollapse = iu, tn.registerCollapseExpandBlock = ka, tn.registerComment = jT, tn.registerDefaultOptions = un, tn.registerDelete = E_, tn.registerDeleteAll = Tu, tn.registerDisable = lu, tn.registerDuplicate = Jo, tn.registerExpand = ou, tn.registerHelp = sl, tn.registerInline = su, tn.registerRedo = ru, tn.registerUndo = On;
      var Od = class {
        constructor() {
        }
        onDragEnter(e) {
        }
        onDragOver(e) {
        }
        onDragExit(e) {
        }
        onDrop(e) {
        }
        getClientRect() {
          return null;
        }
        shouldPreventMove(e) {
          return !1;
        }
      }, kc = class extends Od {
        constructor() {
          super(), this.wouldDelete_ = !1;
        }
        wouldDelete(e, t) {
          return e instanceof kn ? (e = !e.getParent() && e.isDeletable(), this.updateWouldDelete_(e && !t)) : this.updateWouldDelete_(e.isDeletable()), this.wouldDelete_;
        }
        updateWouldDelete_(e) {
          this.wouldDelete_ = e;
        }
      }, Qe = class extends Fl {
        constructor(e, t, n) {
          super(_t.SKIP_SETUP), this.clockwise = Qe.CLOCKWISE, this.offset = Qe.OFFSET, this.wrap = Qe.WRAP, this.round = Qe.ROUND, this.boundEvents = [], this.symbol_ = this.gauge = this.line = null, e !== _t.SKIP_SETUP && (n && this.configure_(n), this.setValue(e), t && this.setValidator(t));
        }
        configure_(e) {
          switch (super.configure_(e), e.mode) {
            case Fc.COMPASS:
              this.clockwise = !0, this.offset = 90;
              break;
            case Fc.PROTRACTOR:
              this.clockwise = !1, this.offset = 0;
          }
          e.clockwise && (this.clockwise = e.clockwise), e.offset && (this.offset = e.offset), e.wrap && (this.wrap = e.wrap), e.round && (this.round = e.round);
        }
        initView() {
          super.initView(), this.symbol_ = K(U.TSPAN, {}), this.symbol_.appendChild(document.createTextNode("°")), this.getTextElement().appendChild(this.symbol_);
        }
        render_() {
          super.render_(), this.updateGraph();
        }
        showEditor_(e) {
          super.showEditor_(e, Pl || tc || os), e = this.dropdownCreate(), $o().appendChild(e), this.sourceBlock_ instanceof kn && Hs(this.sourceBlock_.style.colourPrimary, this.sourceBlock_.style.colourTertiary), wT(this, this.dropdownDispose.bind(this)), this.updateGraph();
        }
        dropdownCreate() {
          const e = K(U.SVG, {
            xmlns: Sl,
            "xmlns:html": Pi,
            "xmlns:xlink": $n,
            version: "1.1",
            height: 2 * Qe.HALF + "px",
            width: 2 * Qe.HALF + "px",
            style: "touch-action: none"
          }), t = K(
            U.CIRCLE,
            { cx: Qe.HALF, cy: Qe.HALF, r: Qe.RADIUS, class: "blocklyAngleCircle" },
            e
          );
          this.gauge = K(U.PATH, { class: "blocklyAngleGauge" }, e), this.line = K(U.LINE, { x1: Qe.HALF, y1: Qe.HALF, class: "blocklyAngleLine" }, e);
          for (let n = 0; 360 > n; n += 15)
            K(U.LINE, { x1: Qe.HALF + Qe.RADIUS, y1: Qe.HALF, x2: Qe.HALF + Qe.RADIUS - (n % 45 === 0 ? 10 : 5), y2: Qe.HALF, class: "blocklyAngleMarks", transform: "rotate(" + n + "," + Qe.HALF + "," + Qe.HALF + ")" }, e);
          return this.boundEvents.push(Pe(
            e,
            "click",
            this,
            this.hide
          )), this.boundEvents.push(Pe(t, "pointerdown", this, this.onMouseMove_, !0)), this.boundEvents.push(Pe(t, "pointermove", this, this.onMouseMove_, !0)), e;
        }
        dropdownDispose() {
          for (const e of this.boundEvents)
            It(e);
          this.boundEvents.length = 0, this.line = this.gauge = null;
        }
        hide() {
          Nn(this), J();
        }
        onMouseMove_(e) {
          var t = this.gauge.ownerSVGElement.getBoundingClientRect();
          const n = e.clientX - t.left - Qe.HALF;
          e = e.clientY - t.top - Qe.HALF, t = Math.atan(-e / n), isNaN(t) || (t = pi(t), 0 > n ? t += 180 : 0 < e && (t += 360), t = this.clockwise ? this.offset + 360 - t : 360 - (this.offset - t), this.displayMouseOrKeyboardValue(t));
        }
        displayMouseOrKeyboardValue(e) {
          if (this.round && (e = Math.round(e / this.round) * this.round), e = this.wrapValue(e), e !== this.value_) {
            const t = this.value_;
            this.setEditorValue_(e, !1), this.sourceBlock_ && tt() && this.value_ !== t && fe(new (ge(Mi))(this.sourceBlock_, this.name || null, t, this.value_));
          }
        }
        updateGraph() {
          if (this.gauge && this.line) {
            var e = Number(this.getText()) + this.offset, t = Gi(e % 360);
            e = [
              "M ",
              Qe.HALF,
              ",",
              Qe.HALF
            ];
            var n = Qe.HALF, o = Qe.HALF;
            if (!isNaN(t)) {
              const c = Number(this.clockwise), A = Gi(this.offset), D = Math.cos(A) * Qe.RADIUS, $ = Math.sin(A) * -Qe.RADIUS;
              c && (t = 2 * A - t), n += Math.cos(t) * Qe.RADIUS, o -= Math.sin(t) * Qe.RADIUS, t = Math.abs(Math.floor((t - A) / Math.PI) % 2), c && (t = 1 - t), e.push(" l ", D, ",", $, " A ", Qe.RADIUS, ",", Qe.RADIUS, " 0 ", t, " ", c, " ", n, ",", o, " z");
            }
            this.gauge.setAttribute("d", e.join("")), this.line.setAttribute("x2", `${n}`), this.line.setAttribute("y2", `${o}`);
          }
        }
        onHtmlInputKeyDown_(e) {
          super.onHtmlInputKeyDown_(e);
          var t = this.getSourceBlock();
          if (!t)
            throw new nr();
          let n = 0;
          switch (e.key) {
            case "ArrowLeft":
              n = t.RTL ? 1 : -1;
              break;
            case "ArrowRight":
              n = t.RTL ? -1 : 1;
              break;
            case "ArrowDown":
              n = -1;
              break;
            case "ArrowUp":
              n = 1;
          }
          n && (t = this.getValue(), this.displayMouseOrKeyboardValue(t + n * this.round), e.preventDefault(), e.stopPropagation());
        }
        doClassValidation_(e) {
          return e = Number(e), isNaN(e) || !isFinite(e) ? null : this.wrapValue(e);
        }
        wrapValue(e) {
          return e %= 360, 0 > e && (e += 360), e > this.wrap && (e -= 360), e;
        }
        static fromJson(e) {
          return new this(e.angle, void 0, e);
        }
      };
      Qe.HALF = 50, Qe.RADIUS = Qe.HALF - 1, Qe.CLOCKWISE = !1, Qe.OFFSET = 0, Qe.WRAP = 360, Qe.ROUND = 15, Br("field_angle", Qe), Qe.prototype.DEFAULT_VALUE = 0, xn(`
.blocklyAngleCircle {
  stroke: #444;
  stroke-width: 1;
  fill: #ddd;
  fill-opacity: 0.8;
}

.blocklyAngleMarks {
  stroke: #444;
  stroke-width: 1;
}

.blocklyAngleGauge {
  fill: #f88;
  fill-opacity: 0.8;
  pointer-events: none;
}

.blocklyAngleLine {
  stroke: #f00;
  stroke-width: 2;
  stroke-linecap: round;
  pointer-events: none;
}
`);
      var Fc;
      (function(e) {
        e.COMPASS = "compass", e.PROTRACTOR = "protractor";
      })(Fc || (Fc = {}));
      var IT = class extends _t {
        constructor(e, t, n) {
          super(_t.SKIP_SETUP), this.SERIALIZABLE = !0, this.CURSOR = "default", this.value_ = this.value_, this.checkChar = IT.CHECK_CHAR, e !== _t.SKIP_SETUP && (n && this.configure_(n), this.setValue(e), t && this.setValidator(t));
        }
        configure_(e) {
          super.configure_(e), e.checkCharacter && (this.checkChar = e.checkCharacter);
        }
        saveState() {
          const e = this.saveLegacyState(IT);
          return e !== null ? e : this.getValueBoolean();
        }
        initView() {
          super.initView();
          const e = this.getTextElement();
          be(e, "blocklyCheckbox"), e.style.display = this.value_ ? "block" : "none";
        }
        render_() {
          this.textContent_ && (this.textContent_.nodeValue = this.getDisplayText_()), this.updateSize_(this.getConstants().FIELD_CHECKBOX_X_OFFSET);
        }
        getDisplayText_() {
          return this.checkChar;
        }
        setCheckCharacter(e) {
          this.checkChar = e || IT.CHECK_CHAR, this.forceRerender();
        }
        showEditor_() {
          this.setValue(!this.value_);
        }
        doClassValidation_(e) {
          return e === !0 || e === "TRUE" ? "TRUE" : e === !1 || e === "FALSE" ? "FALSE" : null;
        }
        doValueUpdate_(e) {
          this.value_ = this.convertValueToBool_(e), this.textElement_ && (this.textElement_.style.display = this.value_ ? "block" : "none");
        }
        getValue() {
          return this.value_ ? "TRUE" : "FALSE";
        }
        getValueBoolean() {
          return this.value_;
        }
        getText() {
          return String(this.convertValueToBool_(this.value_));
        }
        convertValueToBool_(e) {
          return typeof e == "string" ? e === "TRUE" : !!e;
        }
        static fromJson(e) {
          return new this(e.checked, void 0, e);
        }
      };
      IT.CHECK_CHAR = "✓", Br("field_checkbox", IT), IT.prototype.DEFAULT_VALUE = !1;
      var wn = class extends _t {
        constructor(e, t, n) {
          super(_t.SKIP_SETUP), this.highlightedIndex = this.picker = null, this.boundEvents = [], this.SERIALIZABLE = !0, this.CURSOR = "default", this.isDirty_ = !1, this.titles = this.colours = null, this.columns = 0, e !== _t.SKIP_SETUP && (n && this.configure_(n), this.setValue(e), t && this.setValidator(t));
        }
        configure_(e) {
          super.configure_(e), e.colourOptions && (this.colours = e.colourOptions), e.colourTitles && (this.titles = e.colourTitles), e.columns && (this.columns = e.columns);
        }
        initView() {
          this.size_ = new ht(this.getConstants().FIELD_COLOUR_DEFAULT_WIDTH, this.getConstants().FIELD_COLOUR_DEFAULT_HEIGHT), this.getConstants().FIELD_COLOUR_FULL_BLOCK ? this.sourceBlock_ instanceof kn && (this.clickTarget_ = this.sourceBlock_.getSvgRoot()) : (this.createBorderRect_(), this.getBorderRect().style.fillOpacity = "1");
        }
        applyColour() {
          this.getConstants().FIELD_COLOUR_FULL_BLOCK ? this.sourceBlock_ instanceof kn && (this.sourceBlock_.pathObject.svgPath.setAttribute("fill", this.getValue()), this.sourceBlock_.pathObject.svgPath.setAttribute("stroke", "#fff")) : this.borderRect_ && (this.borderRect_.style.fill = this.getValue());
        }
        doClassValidation_(e) {
          return typeof e != "string" ? null : c_(e);
        }
        doValueUpdate_(e) {
          this.value_ = e, this.borderRect_ ? this.borderRect_.style.fill = e : this.sourceBlock_ && this.sourceBlock_.rendered && this.sourceBlock_ instanceof kn && (this.sourceBlock_.pathObject.svgPath.setAttribute("fill", e), this.sourceBlock_.pathObject.svgPath.setAttribute("stroke", "#fff"));
        }
        getText() {
          let e = this.value_;
          return /^#(.)\1(.)\2(.)\3$/.test(e) && (e = "#" + e[1] + e[3] + e[5]), e;
        }
        setColours(e, t) {
          return this.colours = e, t && (this.titles = t), this;
        }
        setColumns(e) {
          return this.columns = e, this;
        }
        showEditor_() {
          this.dropdownCreate(), $o().appendChild(this.picker), wT(this, this.dropdownDispose.bind(this)), this.picker.focus({ preventScroll: !0 });
        }
        onClick(e) {
          e = (e = e.target) && e.getAttribute("data-colour"), e !== null && (this.setValue(e), Nn(this));
        }
        onKeyDown(e) {
          let t = !0;
          var n;
          switch (e.key) {
            case "ArrowUp":
              this.moveHighlightBy(0, -1);
              break;
            case "ArrowDown":
              this.moveHighlightBy(0, 1);
              break;
            case "ArrowLeft":
              this.moveHighlightBy(-1, 0);
              break;
            case "ArrowRight":
              this.moveHighlightBy(
                1,
                0
              );
              break;
            case "Enter":
              (n = this.getHighlighted()) && (n = n.getAttribute("data-colour"), n !== null && this.setValue(n)), a_();
              break;
            default:
              t = !1;
          }
          t && e.stopPropagation();
        }
        moveHighlightBy(e, t) {
          if (this.highlightedIndex) {
            var n = this.colours || wn.COLOURS, o = this.columns || wn.COLUMNS, c = this.highlightedIndex % o, A = Math.floor(this.highlightedIndex / o);
            c += e, A += t, 0 > e ? 0 > c && 0 < A ? (c = o - 1, A--) : 0 > c && (c = 0) : 0 < e ? c > o - 1 && A < Math.floor(n.length / o) - 1 ? (c = 0, A++) : c > o - 1 && c-- : 0 > t ? 0 > A && (A = 0) : 0 < t && A > Math.floor(n.length / o) - 1 && (A = Math.floor(n.length / o) - 1), this.setHighlightedCell(this.picker.childNodes[A].childNodes[c], A * o + c);
          }
        }
        onMouseMove(e) {
          const t = (e = e.target) && Number(e.getAttribute("data-index"));
          t !== null && t !== this.highlightedIndex && this.setHighlightedCell(e, t);
        }
        onMouseEnter() {
          let e;
          (e = this.picker) == null || e.focus({ preventScroll: !0 });
        }
        onMouseLeave() {
          var e;
          (e = this.picker) == null || e.blur(), (e = this.getHighlighted()) && Be(e, "blocklyColourHighlighted");
        }
        getHighlighted() {
          if (!this.highlightedIndex)
            return null;
          const e = this.columns || wn.COLUMNS, t = this.picker.childNodes[Math.floor(this.highlightedIndex / e)];
          return t ? t.childNodes[this.highlightedIndex % e] : null;
        }
        setHighlightedCell(e, t) {
          const n = this.getHighlighted();
          n && Be(n, "blocklyColourHighlighted"), be(e, "blocklyColourHighlighted"), this.highlightedIndex = t, (e = e.getAttribute("id")) && this.picker && Mt(this.picker, Ot.ACTIVEDESCENDANT, e);
        }
        dropdownCreate() {
          const e = this.columns || wn.COLUMNS, t = this.colours || wn.COLOURS, n = this.titles || wn.TITLES, o = this.getValue(), c = document.createElement("table");
          c.className = "blocklyColourTable", c.tabIndex = 0, c.dir = "ltr", an(c, mn.GRID), Mt(c, Ot.EXPANDED, !0), Mt(c, Ot.ROWCOUNT, Math.floor(t.length / e)), Mt(c, Ot.COLCOUNT, e);
          let A;
          for (let D = 0; D < t.length; D++) {
            D % e === 0 && (A = document.createElement("tr"), an(
              A,
              mn.ROW
            ), c.appendChild(A));
            const $ = document.createElement("td");
            A.appendChild($), $.setAttribute("data-colour", t[D]), $.title = n[D] || t[D], $.id = i_(), $.setAttribute("data-index", `${D}`), an($, mn.GRIDCELL), Mt($, Ot.LABEL, t[D]), Mt(
              $,
              Ot.SELECTED,
              t[D] === o
            ), $.style.backgroundColor = t[D], t[D] === o && ($.className = "blocklyColourSelected", this.highlightedIndex = D);
          }
          this.boundEvents.push(Pe(c, "pointerdown", this, this.onClick, !0)), this.boundEvents.push(Pe(c, "pointermove", this, this.onMouseMove, !0)), this.boundEvents.push(Pe(
            c,
            "pointerenter",
            this,
            this.onMouseEnter,
            !0
          )), this.boundEvents.push(Pe(c, "pointerleave", this, this.onMouseLeave, !0)), this.boundEvents.push(Pe(c, "keydown", this, this.onKeyDown, !1)), this.picker = c;
        }
        dropdownDispose() {
          for (const e of this.boundEvents)
            It(e);
          this.boundEvents.length = 0, this.highlightedIndex = this.picker = null;
        }
        static fromJson(e) {
          return new this(e.colour, void 0, e);
        }
      };
      wn.COLOURS = "#ffffff #cccccc #c0c0c0 #999999 #666666 #333333 #000000 #ffcccc #ff6666 #ff0000 #cc0000 #990000 #660000 #330000 #ffcc99 #ff9966 #ff9900 #ff6600 #cc6600 #993300 #663300 #ffff99 #ffff66 #ffcc66 #ffcc33 #cc9933 #996633 #663333 #ffffcc #ffff33 #ffff00 #ffcc00 #999900 #666600 #333300 #99ff99 #66ff99 #33ff33 #33cc00 #009900 #006600 #003300 #99ffff #33ffff #66cccc #00cccc #339999 #336666 #003333 #ccffff #66ffff #33ccff #3366ff #3333ff #000099 #000066 #ccccff #9999ff #6666cc #6633ff #6600cc #333399 #330099 #ffccff #ff99ff #cc66cc #cc33cc #993399 #663366 #330033".split(" "), wn.TITLES = [], wn.COLUMNS = 7, wn.prototype.DEFAULT_VALUE = wn.COLOURS[0], Br("field_colour", wn), xn(`
.blocklyColourTable {
  border-collapse: collapse;
  display: block;
  outline: none;
  padding: 1px;
}

.blocklyColourTable>tr>td {
  border: 0.5px solid #888;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block;
  height: 20px;
  padding: 0;
  width: 20px;
}

.blocklyColourTable>tr>td.blocklyColourHighlighted {
  border-color: #eee;
  box-shadow: 2px 2px 7px 2px rgba(0, 0, 0, 0.3);
  position: relative;
}

.blocklyColourSelected, .blocklyColourSelected:hover {
  border-color: #eee !important;
  outline: 1px solid #333;
  position: relative;
}
`);
      var Rd = class extends K_ {
        constructor(e, t, n) {
          super(String(e ?? ""), t, n), this.EDITABLE = !1, this.SERIALIZABLE = !0;
        }
        static fromJson(e) {
          return new this(xt(e.text), void 0, e);
        }
      };
      Br("field_label_serializable", Rd);
      var ME = class extends Ps {
        constructor(e, t, n) {
          super(_t.SKIP_SETUP), this.textGroup = null, this.maxLines_ = 1 / 0, this.isOverflowedY_ = !1, e !== _t.SKIP_SETUP && (n && this.configure_(n), this.setValue(e), t && this.setValidator(t));
        }
        configure_(e) {
          super.configure_(e), e.maxLines && this.setMaxLines(e.maxLines);
        }
        toXml(e) {
          return e.textContent = this.getValue().replace(
            /\n/g,
            "&#10;"
          ), e;
        }
        fromXml(e) {
          this.setValue(e.textContent.replace(/&#10;/g, `
`));
        }
        saveState() {
          const e = this.saveLegacyState(ME);
          return e !== null ? e : this.getValue();
        }
        loadState(e) {
          this.loadLegacyState(_t, e) || this.setValue(e);
        }
        initView() {
          this.createBorderRect_(), this.textGroup = K(U.G, { class: "blocklyEditableText" }, this.fieldGroup_);
        }
        getDisplayText_() {
          const e = this.getSourceBlock();
          if (!e)
            throw new nr();
          let t = this.getText();
          if (!t)
            return _t.NBSP;
          const n = t.split(`
`);
          t = "";
          const o = this.isOverflowedY_ ? this.maxLines_ : n.length;
          for (let c = 0; c < o; c++) {
            let A = n[c];
            A.length > this.maxDisplayLength ? A = A.substring(0, this.maxDisplayLength - 4) + "..." : this.isOverflowedY_ && c === o - 1 && (A = A.substring(0, A.length - 3) + "..."), A = A.replace(/\s/g, _t.NBSP), t += A, c !== o - 1 && (t += `
`);
          }
          return e.RTL && (t += "‏"), t;
        }
        doValueUpdate_(e) {
          super.doValueUpdate_(e), this.value_ !== null && (this.isOverflowedY_ = this.value_.split(`
`).length > this.maxLines_);
        }
        render_() {
          var e = this.getSourceBlock();
          if (!e)
            throw new nr();
          for (var t, n = this.textGroup; t = n.firstChild; )
            n.removeChild(t);
          t = this.getDisplayText_().split(`
`);
          let o = 0;
          for (let c = 0; c < t.length; c++) {
            const A = this.getConstants().FIELD_TEXT_HEIGHT + this.getConstants().FIELD_BORDER_RECT_Y_PADDING;
            K(
              U.TEXT,
              { class: "blocklyText blocklyMultilineText", x: this.getConstants().FIELD_BORDER_RECT_X_PADDING, y: o + this.getConstants().FIELD_BORDER_RECT_Y_PADDING, dy: this.getConstants().FIELD_TEXT_BASELINE },
              n
            ).appendChild(document.createTextNode(t[c])), o += A;
          }
          this.isBeingEdited_ && (n = this.htmlInput_, this.isOverflowedY_ ? be(n, "blocklyHtmlTextAreaInputOverflowedY") : Be(n, "blocklyHtmlTextAreaInputOverflowedY")), this.updateSize_(), this.isBeingEdited_ && (e.RTL ? setTimeout(this.resizeEditor_.bind(this), 0) : this.resizeEditor_(), e = this.htmlInput_, this.isTextValid_ ? (Be(e, "blocklyInvalidInput"), Mt(e, Ot.INVALID, !1)) : (be(e, "blocklyInvalidInput"), Mt(e, Ot.INVALID, !0)));
        }
        updateSize_() {
          var e = this.textGroup.childNodes;
          const t = this.getConstants().FIELD_TEXT_FONTSIZE, n = this.getConstants().FIELD_TEXT_FONTWEIGHT, o = this.getConstants().FIELD_TEXT_FONTFAMILY;
          let c = 0, A = 0;
          for (var D = 0; D < e.length; D++) {
            var $ = xr(e[D], t, n, o);
            $ > c && (c = $), A += this.getConstants().FIELD_TEXT_HEIGHT + (0 < D ? this.getConstants().FIELD_BORDER_RECT_Y_PADDING : 0);
          }
          if (this.isBeingEdited_) {
            for (e = String(this.value_).split(`
`), D = K(U.TEXT, { class: "blocklyText blocklyMultilineText" }), $ = 0; $ < e.length; $++) {
              e[$].length > this.maxDisplayLength && (e[$] = e[$].substring(0, this.maxDisplayLength)), D.textContent = e[$];
              const q = xr(D, t, n, o);
              q > c && (c = q);
            }
            c += this.htmlInput_.offsetWidth - this.htmlInput_.clientWidth;
          }
          this.borderRect_ && (A += 2 * this.getConstants().FIELD_BORDER_RECT_Y_PADDING, c += 2 * this.getConstants().FIELD_BORDER_RECT_X_PADDING, this.borderRect_.setAttribute("width", `${c}`), this.borderRect_.setAttribute("height", `${A}`)), this.size_.width = c, this.size_.height = A, this.positionBorderRect_();
        }
        showEditor_(e, t) {
          super.showEditor_(e, t), this.forceRerender();
        }
        widgetCreate_() {
          const e = wo(), t = this.workspace_.getScale(), n = document.createElement("textarea");
          n.className = "blocklyHtmlInput blocklyHtmlTextAreaInput", n.setAttribute("spellcheck", String(this.spellcheck_));
          var o = this.getConstants().FIELD_TEXT_FONTSIZE * t + "pt";
          e.style.fontSize = o, n.style.fontSize = o, n.style.borderRadius = Ps.BORDERRADIUS * t + "px", o = this.getConstants().FIELD_BORDER_RECT_X_PADDING * t;
          const c = this.getConstants().FIELD_BORDER_RECT_Y_PADDING * t / 2;
          return n.style.padding = c + "px " + o + "px " + c + "px " + o + "px", o = this.getConstants().FIELD_TEXT_HEIGHT + this.getConstants().FIELD_BORDER_RECT_Y_PADDING, n.style.lineHeight = o * t + "px", e.appendChild(n), n.value = n.defaultValue = this.getEditorText_(this.value_), n.setAttribute("data-untyped-default-value", String(this.value_)), n.setAttribute("data-old-value", ""), Ru ? setTimeout(this.resizeEditor_.bind(this), 0) : this.resizeEditor_(), this.bindInputEvents_(n), n;
        }
        setMaxLines(e) {
          typeof e == "number" && 0 < e && e !== this.maxLines_ && (this.maxLines_ = e, this.forceRerender());
        }
        getMaxLines() {
          return this.maxLines_;
        }
        onHtmlInputKeyDown_(e) {
          e.key !== "Enter" && super.onHtmlInputKeyDown_(e);
        }
        static fromJson(e) {
          return new this(xt(e.text), void 0, e);
        }
      };
      Br("field_multilinetext", ME), xn(`
.blocklyHtmlTextAreaInput {
  font-family: monospace;
  resize: none;
  overflow: hidden;
  height: 100%;
  text-align: left;
}

.blocklyHtmlTextAreaInputOverflowedY {
  overflow-y: scroll;
}
`);
      var mE = class extends Fl {
        constructor(e, t, n, o, c, A) {
          super(_t.SKIP_SETUP), this.min_ = -1 / 0, this.max_ = 1 / 0, this.precision_ = 0, this.decimalPlaces = null, this.spellcheck_ = !1, e !== _t.SKIP_SETUP && (A ? this.configure_(A) : this.setConstraints(t, n, o), this.setValue(e), c && this.setValidator(c));
        }
        configure_(e) {
          super.configure_(e), this.setMinInternal(e.min), this.setMaxInternal(e.max), this.setPrecisionInternal(e.precision);
        }
        setConstraints(e, t, n) {
          this.setMinInternal(e), this.setMaxInternal(t), this.setPrecisionInternal(n), this.setValue(this.getValue());
        }
        setMin(e) {
          this.setMinInternal(e), this.setValue(this.getValue());
        }
        setMinInternal(e) {
          e == null ? this.min_ = -1 / 0 : (e = Number(e), isNaN(e) || (this.min_ = e));
        }
        getMin() {
          return this.min_;
        }
        setMax(e) {
          this.setMaxInternal(e), this.setValue(this.getValue());
        }
        setMaxInternal(e) {
          e == null ? this.max_ = 1 / 0 : (e = Number(e), isNaN(e) || (this.max_ = e));
        }
        getMax() {
          return this.max_;
        }
        setPrecision(e) {
          this.setPrecisionInternal(e), this.setValue(this.getValue());
        }
        setPrecisionInternal(e) {
          this.precision_ = Number(e) || 0;
          let t = String(this.precision_);
          t.indexOf("e") !== -1 && (t = this.precision_.toLocaleString("en-US", { maximumFractionDigits: 20 }));
          const n = t.indexOf(".");
          this.decimalPlaces = n === -1 ? e ? 0 : null : t.length - n - 1;
        }
        getPrecision() {
          return this.precision_;
        }
        doClassValidation_(e) {
          return e === null || (e = `${e}`.replace(/O/gi, "0"), e = e.replace(/,/g, ""), e = e.replace(/infinity/i, "Infinity"), e = Number(e || 0), isNaN(e)) ? null : (e = Math.min(Math.max(
            e,
            this.min_
          ), this.max_), this.precision_ && isFinite(e) && (e = Math.round(e / this.precision_) * this.precision_), this.decimalPlaces !== null && (e = Number(e.toFixed(this.decimalPlaces))), e);
        }
        widgetCreate_() {
          const e = super.widgetCreate_();
          return -1 / 0 < this.min_ && (e.min = `${this.min_}`, Mt(e, Ot.VALUEMIN, this.min_)), 1 / 0 > this.max_ && (e.max = `${this.max_}`, Mt(
            e,
            Ot.VALUEMAX,
            this.max_
          )), e;
        }
        static fromJson(e) {
          return new this(e.value, void 0, void 0, void 0, void 0, e);
        }
      };
      Br("field_number", mE), mE.prototype.DEFAULT_VALUE = 0;
      var Gl = class extends X_ {
        constructor(e, t, n, o, c) {
          super(_t.SKIP_SETUP), this.defaultType = "", this.variableTypes = [], this.variable = null, this.SERIALIZABLE = !0, this.menuGenerator_ = Gl.dropdownCreate, this.defaultVariableName = typeof e == "string" ? e : "", this.size_ = new ht(0, 0), e !== _t.SKIP_SETUP && (c ? this.configure_(c) : this.setTypes(n, o), t && this.setValidator(t));
        }
        configure_(e) {
          super.configure_(e), this.setTypes(e.variableTypes, e.defaultType);
        }
        initModel() {
          var e = this.getSourceBlock();
          if (!e)
            throw new nr();
          this.variable || (e = r.getOrCreateVariablePackage$$module$build$src$core$variables(e.workspace, null, this.defaultVariableName, this.defaultType), this.doValueUpdate_(e.getId()));
        }
        shouldAddBorderRect_() {
          const e = this.getSourceBlock();
          if (!e)
            throw new nr();
          return super.shouldAddBorderRect_() && (!this.getConstants().FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW || e.type !== "variables_get");
        }
        fromXml(e) {
          var t = this.getSourceBlock();
          if (!t)
            throw new nr();
          const n = e.getAttribute("id"), o = e.textContent, c = e.getAttribute("variabletype") || e.getAttribute("variableType") || "";
          if (t = r.getOrCreateVariablePackage$$module$build$src$core$variables(t.workspace, n, o, c), c !== null && c !== t.type)
            throw Error("Serialized variable type with id '" + t.getId() + "' had type " + t.type + ", and does not match variable field that references it: " + W_(e) + ".");
          this.setValue(t.getId());
        }
        toXml(e) {
          return this.initModel(), e.id = this.variable.getId(), e.textContent = this.variable.name, this.variable.type && e.setAttribute("variabletype", this.variable.type), e;
        }
        saveState(e) {
          var t = this.saveLegacyState(Gl);
          return t !== null || (this.initModel(), t = { id: this.variable.getId() }, e && (t.name = this.variable.name, t.type = this.variable.type)), t;
        }
        loadState(e) {
          const t = this.getSourceBlock();
          if (!t)
            throw new nr();
          this.loadLegacyState(Gl, e) || (e = r.getOrCreateVariablePackage$$module$build$src$core$variables(t.workspace, e.id || null, e.name, e.type || ""), this.setValue(e.getId()));
        }
        setSourceBlock(e) {
          if (e.isShadow())
            throw Error("Variable fields are not allowed to exist on shadow blocks.");
          super.setSourceBlock(e);
        }
        getValue() {
          return this.variable ? this.variable.getId() : null;
        }
        getText() {
          return this.variable ? this.variable.name : "";
        }
        getVariable() {
          return this.variable;
        }
        getValidator() {
          return this.variable ? this.validator_ : null;
        }
        doClassValidation_(e) {
          if (e === null)
            return null;
          var t = this.getSourceBlock();
          if (!t)
            throw new nr();
          return t = r.getVariable$$module$build$src$core$variables(t.workspace, e), t ? (t = t.type, this.typeIsAllowed(t) ? e : (console.warn("Variable type doesn't match this field!  Type was " + t), null)) : (console.warn("Variable id doesn't point to a real variable! ID was " + e), null);
        }
        doValueUpdate_(e) {
          const t = this.getSourceBlock();
          if (!t)
            throw new nr();
          this.variable = r.getVariable$$module$build$src$core$variables(t.workspace, e), super.doValueUpdate_(e);
        }
        typeIsAllowed(e) {
          const t = this.getVariableTypes();
          if (!t)
            return !0;
          for (let n = 0; n < t.length; n++)
            if (e === t[n])
              return !0;
          return !1;
        }
        getVariableTypes() {
          var e = this.variableTypes;
          if (e === null && this.sourceBlock_ && !this.sourceBlock_.isDeadOrDying())
            return this.sourceBlock_.workspace.getVariableTypes();
          if (e = e || [""], e.length === 0)
            throw e = this.getText(), Error("'variableTypes' of field variable " + e + " was an empty list");
          return e;
        }
        setTypes(e = null, t = "") {
          if (Array.isArray(e)) {
            let n = !1;
            for (let o = 0; o < e.length; o++)
              e[o] === t && (n = !0);
            if (!n)
              throw Error("Invalid default type '" + t + "' in the definition of a FieldVariable");
          } else if (e !== null)
            throw Error("'variableTypes' was not an array in the definition of a FieldVariable");
          this.defaultType = t, this.variableTypes = e;
        }
        refreshVariableName() {
          this.forceRerender();
        }
        onItemSelected_(e, t) {
          if (e = t.getValue(), this.sourceBlock_ && !this.sourceBlock_.isDeadOrDying()) {
            if (e === M_) {
              r.renameVariable$$module$build$src$core$variables(this.sourceBlock_.workspace, this.variable);
              return;
            }
            if (e === Nc) {
              this.sourceBlock_.workspace.deleteVariableById(this.variable.getId());
              return;
            }
          }
          this.setValue(e);
        }
        referencesVariables() {
          return !0;
        }
        static fromJson(e) {
          return new this(
            xt(e.variable),
            void 0,
            void 0,
            void 0,
            e
          );
        }
        static dropdownCreate() {
          if (!this.variable)
            throw Error("Tried to call dropdownCreate on a variable field with no variable selected.");
          const e = this.getText();
          let t = [];
          if (this.sourceBlock_ && !this.sourceBlock_.isDeadOrDying())
            for (var n = this.getVariableTypes(), o = 0; o < n.length; o++) {
              const c = this.sourceBlock_.workspace.getVariablesOfType(n[o]);
              t = t.concat(c);
            }
          for (t.sort(rs.compareByName), n = [], o = 0; o < t.length; o++)
            n[o] = [t[o].name, t[o].getId()];
          return n.push([r.Msg$$module$build$src$core$msg.RENAME_VARIABLE, M_]), r.Msg$$module$build$src$core$msg.DELETE_VARIABLE && n.push([r.Msg$$module$build$src$core$msg.DELETE_VARIABLE.replace("%1", e), Nc]), n;
        }
      };
      Br("field_variable", Gl);
      var D_ = class {
        constructor(e, t, n, o) {
          this.workspace = e, this.targetWorkspace = t, this.isLabel_ = o, this.onMouseUpWrapper = null, this.height = this.width = 0, this.svgText = this.svgGroup = null, this.text = n.text, this.position = new ae(0, 0), this.callbackKey = n.callbackKey || n.callbackkey, this.cssClass = n["web-class"] || null, this.info = n;
        }
        createDom() {
          var e = this.isLabel_ ? "blocklyFlyoutLabel" : "blocklyFlyoutButton";
          this.cssClass && (e += " " + this.cssClass), this.svgGroup = K(U.G, { class: e }, this.workspace.getCanvas());
          let t;
          this.isLabel_ || (t = K(U.RECT, { class: "blocklyFlyoutButtonShadow", rx: D_.BORDER_RADIUS, ry: D_.BORDER_RADIUS, x: 1, y: 1 }, this.svgGroup)), e = K(
            U.RECT,
            { class: this.isLabel_ ? "blocklyFlyoutLabelBackground" : "blocklyFlyoutButtonBackground", rx: D_.BORDER_RADIUS, ry: D_.BORDER_RADIUS },
            this.svgGroup
          );
          const n = K(U.TEXT, { class: this.isLabel_ ? "blocklyFlyoutLabelText" : "blocklyText", x: 0, y: 0, "text-anchor": "middle" }, this.svgGroup);
          var o = xt(this.text);
          this.workspace.RTL && (o += "‏"), n.textContent = o, this.isLabel_ && (this.svgText = n, this.workspace.getThemeManager().subscribe(this.svgText, "flyoutForegroundColour", "fill"));
          const c = $_(n, "fontSize"), A = $_(n, "fontWeight"), D = $_(n, "fontFamily");
          if (this.width = T_(n, c, A, D), o = Hn(
            o,
            c,
            A,
            D
          ), this.height = o.height, !this.isLabel_) {
            this.width += 2 * D_.TEXT_MARGIN_X, this.height += 2 * D_.TEXT_MARGIN_Y;
            let $;
            ($ = t) == null || $.setAttribute("width", String(this.width));
            let q;
            (q = t) == null || q.setAttribute("height", String(this.height));
          }
          return e.setAttribute("width", String(this.width)), e.setAttribute("height", String(this.height)), n.setAttribute("x", String(this.width / 2)), n.setAttribute("y", String(this.height / 2 - o.height / 2 + o.baseline)), this.updateTransform(), this.onMouseUpWrapper = Pe(this.svgGroup, "pointerup", this, this.onMouseUp), this.svgGroup;
        }
        show() {
          this.updateTransform(), this.svgGroup.setAttribute("display", "block");
        }
        updateTransform() {
          this.svgGroup.setAttribute("transform", "translate(" + this.position.x + "," + this.position.y + ")");
        }
        moveTo(e, t) {
          this.position.x = e, this.position.y = t, this.updateTransform();
        }
        isLabel() {
          return this.isLabel_;
        }
        getPosition() {
          return this.position;
        }
        getButtonText() {
          return this.text;
        }
        getTargetWorkspace() {
          return this.targetWorkspace;
        }
        dispose() {
          this.onMouseUpWrapper && It(this.onMouseUpWrapper), this.svgGroup && Tt(this.svgGroup), this.svgText && this.workspace.getThemeManager().unsubscribe(this.svgText);
        }
        onMouseUp(e) {
          (e = this.targetWorkspace.getGesture(e)) && e.cancel(), this.isLabel_ && this.callbackKey ? console.warn("Labels should not have callbacks. Label text: " + this.text) : this.isLabel_ || this.callbackKey && this.targetWorkspace.getButtonCallback(this.callbackKey) ? this.isLabel_ || (e = this.targetWorkspace.getButtonCallback(this.callbackKey)) && e(this) : console.warn("Buttons should have callbacks. Button text: " + this.text);
        }
      };
      D_.TEXT_MARGIN_X = 5, D_.TEXT_MARGIN_Y = 2, D_.BORDER_RADIUS = 4, xn(`
.blocklyFlyoutButton {
  fill: #888;
  cursor: default;
}

.blocklyFlyoutButtonShadow {
  fill: #666;
}

.blocklyFlyoutButton:hover {
  fill: #aaa;
}

.blocklyFlyoutLabel {
  cursor: default;
}

.blocklyFlyoutLabelBackground {
  opacity: 0;
}
`);
      var PE = class {
        constructor(e) {
          this.workspace_ = e;
        }
        getDimensionsPx_(e) {
          let t = 0, n = 0;
          return e && (t = e.getWidth(), n = e.getHeight()), new ht(t, n);
        }
        getFlyoutMetrics(e) {
          return e = this.getDimensionsPx_(this.workspace_.getFlyout(e)), { width: e.width, height: e.height, position: this.workspace_.toolboxPosition };
        }
        getToolboxMetrics() {
          const e = this.getDimensionsPx_(this.workspace_.getToolbox());
          return { width: e.width, height: e.height, position: this.workspace_.toolboxPosition };
        }
        getSvgMetrics() {
          return this.workspace_.getCachedParentSvgSize();
        }
        getAbsoluteMetrics() {
          let e = 0;
          const t = this.getToolboxMetrics(), n = this.getFlyoutMetrics(!0), o = !!this.workspace_.getToolbox(), c = !!this.workspace_.getFlyout(!0);
          var A = o ? t.position : n.position, D = A === Ue.LEFT;
          return A = A === Ue.TOP, o && D ? e = t.width : c && D && (e = n.width), D = 0, o && A ? D = t.height : c && A && (D = n.height), { top: D, left: e };
        }
        getViewMetrics(e) {
          e = e ? this.workspace_.scale : 1;
          const t = this.getSvgMetrics(), n = this.getToolboxMetrics(), o = this.getFlyoutMetrics(!0), c = this.workspace_.getToolbox() ? n.position : o.position;
          return this.workspace_.getToolbox() ? c === Ue.TOP || c === Ue.BOTTOM ? t.height -= n.height : (c === Ue.LEFT || c === Ue.RIGHT) && (t.width -= n.width) : this.workspace_.getFlyout(!0) && (c === Ue.TOP || c === Ue.BOTTOM ? t.height -= o.height : (c === Ue.LEFT || c === Ue.RIGHT) && (t.width -= o.width)), { height: t.height / e, width: t.width / e, top: -this.workspace_.scrollY / e, left: -this.workspace_.scrollX / e };
        }
        getContentMetrics(e) {
          e = e ? 1 : this.workspace_.scale;
          const t = this.workspace_.getBlocksBoundingBox();
          return { height: (t.bottom - t.top) * e, width: (t.right - t.left) * e, top: t.top * e, left: t.left * e };
        }
        hasFixedEdges() {
          return !this.workspace_.isMovableHorizontally() || !this.workspace_.isMovableVertically();
        }
        getComputedFixedEdges_(e) {
          if (!this.hasFixedEdges())
            return {};
          const t = this.workspace_.isMovableHorizontally(), n = this.workspace_.isMovableVertically();
          e = e || this.getViewMetrics(!1);
          const o = {};
          return n || (o.top = e.top, o.bottom = e.top + e.height), t || (o.left = e.left, o.right = e.left + e.width), o;
        }
        getPaddedContent_(e, t) {
          const n = t.top + t.height, o = t.left + t.width, c = e.width;
          e = e.height;
          const A = c / 2, D = e / 2;
          return { top: Math.min(t.top - D, n - e), bottom: Math.max(n + D, t.top + e), left: Math.min(t.left - A, o - c), right: Math.max(o + A, t.left + c) };
        }
        getScrollMetrics(e, t, n) {
          e = e ? this.workspace_.scale : 1, t = t || this.getViewMetrics(!1);
          var o = n || this.getContentMetrics();
          n = this.getComputedFixedEdges_(t), t = this.getPaddedContent_(t, o), o = n.top !== void 0 ? n.top : t.top;
          const c = n.left !== void 0 ? n.left : t.left;
          return { top: o / e, left: c / e, width: ((n.right !== void 0 ? n.right : t.right) - c) / e, height: ((n.bottom !== void 0 ? n.bottom : t.bottom) - o) / e };
        }
        getUiMetrics() {
          return { viewMetrics: this.getViewMetrics(), absoluteMetrics: this.getAbsoluteMetrics(), toolboxMetrics: this.getToolboxMetrics() };
        }
        getMetrics() {
          const e = this.getToolboxMetrics(), t = this.getFlyoutMetrics(!0), n = this.getSvgMetrics(), o = this.getAbsoluteMetrics(), c = this.getViewMetrics(), A = this.getContentMetrics(), D = this.getScrollMetrics(!1, c, A);
          return {
            contentHeight: A.height,
            contentWidth: A.width,
            contentTop: A.top,
            contentLeft: A.left,
            scrollHeight: D.height,
            scrollWidth: D.width,
            scrollTop: D.top,
            scrollLeft: D.left,
            viewHeight: c.height,
            viewWidth: c.width,
            viewTop: c.top,
            viewLeft: c.left,
            absoluteTop: o.top,
            absoluteLeft: o.left,
            svgHeight: n.height,
            svgWidth: n.width,
            toolboxWidth: e.width,
            toolboxHeight: e.height,
            toolboxPosition: e.position,
            flyoutWidth: t.width,
            flyoutHeight: t.height
          };
        }
      };
      i(se.METRICS_MANAGER, w_, PE);
      var yd = class extends PE {
        constructor(e, t) {
          super(e), this.flyout_ = t;
        }
        getBoundingBox_() {
          let e;
          try {
            e = this.workspace_.getCanvas().getBBox();
          } catch {
            e = { height: 0, y: 0, width: 0, x: 0 };
          }
          return e;
        }
        getContentMetrics(e) {
          const t = this.getBoundingBox_();
          return e = e ? 1 : this.workspace_.scale, { height: t.height * e, width: t.width * e, top: t.y * e, left: t.x * e };
        }
        getScrollMetrics(e, t, n) {
          return t = n || this.getContentMetrics(), n = this.flyout_.MARGIN * this.workspace_.scale, e = e ? this.workspace_.scale : 1, { height: (t.height + 2 * n) / e, width: (t.width + t.left + n) / e, top: 0, left: 0 };
        }
      }, DE = class {
        constructor(e, t, n, o, c) {
          this.workspace = e, this.oldHostMetrics_ = this.corner_ = this.vScroll = this.hScroll = null, t = t === void 0 ? !0 : t, n = n === void 0 ? !0 : n;
          const A = t && n;
          t && (this.hScroll = new Xt(e, !0, A, o, c)), n && (this.vScroll = new Xt(e, !1, A, o, c)), A && (this.corner_ = K(U.RECT, {
            height: Xt.scrollbarThickness,
            width: Xt.scrollbarThickness,
            class: "blocklyScrollbarBackground"
          }), Sr(this.corner_, e.getBubbleCanvas()));
        }
        dispose() {
          Tt(this.corner_), this.oldHostMetrics_ = this.corner_ = null, this.hScroll && (this.hScroll.dispose(), this.hScroll = null), this.vScroll && (this.vScroll.dispose(), this.vScroll = null);
        }
        resize() {
          const e = this.workspace.getMetrics();
          if (e) {
            var t = !1, n = !1;
            if (this.oldHostMetrics_ && this.oldHostMetrics_.viewWidth === e.viewWidth && this.oldHostMetrics_.viewHeight === e.viewHeight && this.oldHostMetrics_.absoluteTop === e.absoluteTop && this.oldHostMetrics_.absoluteLeft === e.absoluteLeft ? (this.oldHostMetrics_ && this.oldHostMetrics_.scrollWidth === e.scrollWidth && this.oldHostMetrics_.viewLeft === e.viewLeft && this.oldHostMetrics_.scrollLeft === e.scrollLeft || (t = !0), this.oldHostMetrics_ && this.oldHostMetrics_.scrollHeight === e.scrollHeight && this.oldHostMetrics_.viewTop === e.viewTop && this.oldHostMetrics_.scrollTop === e.scrollTop || (n = !0)) : n = t = !0, t || n) {
              try {
                r.disable$$module$build$src$core$events$utils(), this.hScroll && t && this.hScroll.resize(e), this.vScroll && n && this.vScroll.resize(e);
              } finally {
                r.enable$$module$build$src$core$events$utils();
              }
              this.workspace.maybeFireViewportChangeEvent();
            }
            if (this.hScroll && this.vScroll) {
              if (!this.oldHostMetrics_ || this.oldHostMetrics_.viewWidth !== e.viewWidth || this.oldHostMetrics_.absoluteLeft !== e.absoluteLeft) {
                let o;
                (o = this.corner_) == null || o.setAttribute("x", String(this.vScroll.position.x));
              }
              if (!this.oldHostMetrics_ || this.oldHostMetrics_.viewHeight !== e.viewHeight || this.oldHostMetrics_.absoluteTop !== e.absoluteTop) {
                let o;
                (o = this.corner_) == null || o.setAttribute("y", String(this.hScroll.position.y));
              }
            }
            this.oldHostMetrics_ = e;
          }
        }
        canScrollHorizontally() {
          return !!this.hScroll;
        }
        canScrollVertically() {
          return !!this.vScroll;
        }
        setOrigin(e, t) {
          this.hScroll && this.hScroll.setOrigin(e, t), this.vScroll && this.vScroll.setOrigin(e, t);
        }
        set(e, t, n) {
          this.hScroll && this.hScroll.set(e, !1), this.vScroll && this.vScroll.set(t, !1), (n || n === void 0) && (e = {}, this.hScroll && (e.x = this.hScroll.getRatio_()), this.vScroll && (e.y = this.vScroll.getRatio_()), this.workspace.setMetrics(e));
        }
        setX(e) {
          this.hScroll && this.hScroll.set(e, !0);
        }
        setY(e) {
          this.vScroll && this.vScroll.set(e, !0);
        }
        setContainerVisible(e) {
          this.hScroll && this.hScroll.setContainerVisible(e), this.vScroll && this.vScroll.setContainerVisible(e);
        }
        isVisible() {
          let e = !1;
          return this.hScroll && (e = this.hScroll.isVisible()), this.vScroll && (e = e || this.vScroll.isVisible()), e;
        }
        resizeContent(e) {
          this.hScroll && this.hScroll.resizeContentHorizontal(e), this.vScroll && this.vScroll.resizeContentVertical(e);
        }
        resizeView(e) {
          this.hScroll && this.hScroll.resizeViewHorizontal(e), this.vScroll && this.vScroll.resizeViewVertical(e);
        }
      }, vd = class {
        constructor(e) {
          this.workspace = e, this.horizontalScrollEnabled_ = this.workspace.isMovableHorizontally(), this.verticalScrollEnabled_ = this.workspace.isMovableVertically(), this.startScrollXY_ = new ae(e.scrollX, e.scrollY);
        }
        dispose() {
          this.workspace = null;
        }
        startDrag() {
          we() && we().unselect();
        }
        endDrag(e) {
          this.drag(e);
        }
        drag(e) {
          if (e = ae.sum(this.startScrollXY_, e), this.horizontalScrollEnabled_ && this.verticalScrollEnabled_)
            this.workspace.scroll(e.x, e.y);
          else if (this.horizontalScrollEnabled_)
            this.workspace.scroll(e.x, this.workspace.scrollY);
          else if (this.verticalScrollEnabled_)
            this.workspace.scroll(this.workspace.scrollX, e.y);
          else
            throw new TypeError("Invalid state.");
        }
      }, VS = 5, GS = 6, yi = class {
        constructor(e, t) {
          this.creatorWorkspace = t, this.mouseDownXY = new ae(0, 0), this.startWorkspace_ = this.targetBlock = this.startBlock = this.startIcon = this.startField = this.startBubble = null, this.hasExceededDragRadius = !1, this.boundEvents = [], this.flyout = this.workspaceDragger = this.blockDragger = this.bubbleDragger = null, this.isMultiTouch_ = this.isEnding_ = this.gestureHasStarted = this.calledUpdateIsDragging = !1, this.cachedPoints = /* @__PURE__ */ new Map(), this.startDistance = this.previousScale = 0, this.currentDropdownOwner = this.isPinchZoomEnabled = null, this.mostRecentEvent = e, this.currentDragDeltaXY = new ae(0, 0), this.healStack = !fc;
        }
        dispose() {
          me(), Bp(), this.creatorWorkspace.clearGesture();
          for (const e of this.boundEvents)
            It(e);
          this.boundEvents.length = 0, this.blockDragger && this.blockDragger.dispose(), this.workspaceDragger && this.workspaceDragger.dispose();
        }
        updateFromEvent(e) {
          const t = new ae(e.clientX, e.clientY);
          this.updateDragDelta(t) && (this.updateIsDragging(), ee()), this.mostRecentEvent = e;
        }
        updateDragDelta(e) {
          return this.currentDragDeltaXY = ae.difference(
            e,
            this.mouseDownXY
          ), this.hasExceededDragRadius ? !1 : this.hasExceededDragRadius = ae.magnitude(this.currentDragDeltaXY) > (this.flyout ? r.config$$module$build$src$core$config.flyoutDragRadius : r.config$$module$build$src$core$config.dragRadius);
        }
        updateIsDraggingFromFlyout() {
          let e;
          if (!this.targetBlock || (e = this.flyout) == null || !e.isBlockCreatable(this.targetBlock))
            return !1;
          if (!this.flyout.targetWorkspace)
            throw Error(`Cannot update dragging from the flyout because the ' +
          'flyout's target workspace is undefined`);
          return !this.flyout.isScrollable() || this.flyout.isDragTowardWorkspace(this.currentDragDeltaXY) ? (this.startWorkspace_ = this.flyout.targetWorkspace, this.startWorkspace_.updateScreenCalculationsIfScrolled(), r.getGroup$$module$build$src$core$events$utils() || r.setGroup$$module$build$src$core$events$utils(!0), this.startBlock = null, this.targetBlock = this.flyout.createBlock(this.targetBlock), this.targetBlock.select(), !0) : !1;
        }
        updateIsDraggingBubble() {
          return this.startBubble ? (this.startDraggingBubble(), !0) : !1;
        }
        updateIsDraggingBlock() {
          if (!this.targetBlock)
            return !1;
          if (this.flyout) {
            if (this.updateIsDraggingFromFlyout())
              return this.startDraggingBlock(), !0;
          } else if (this.targetBlock.isMovable())
            return this.startDraggingBlock(), !0;
          return !1;
        }
        updateIsDraggingWorkspace() {
          if (!this.startWorkspace_)
            throw Error("Cannot update dragging the workspace because the start workspace is undefined");
          (this.flyout ? this.flyout.isScrollable() : this.startWorkspace_ && this.startWorkspace_.isDraggable()) && (this.workspaceDragger = new vd(this.startWorkspace_), this.workspaceDragger.startDrag());
        }
        updateIsDragging() {
          if (this.calledUpdateIsDragging)
            throw Error("updateIsDragging_ should only be called once per gesture.");
          this.calledUpdateIsDragging = !0, this.updateIsDraggingBubble() || this.updateIsDraggingBlock() || this.updateIsDraggingWorkspace();
        }
        startDraggingBlock() {
          this.blockDragger = new (Z(se.BLOCK_DRAGGER, this.creatorWorkspace.options, !0))(this.targetBlock, this.startWorkspace_), this.blockDragger.startDrag(this.currentDragDeltaXY, this.healStack), this.blockDragger.drag(this.mostRecentEvent, this.currentDragDeltaXY);
        }
        startDraggingBubble() {
          if (!this.startBubble)
            throw Error("Cannot update dragging the bubble because the start bubble is undefined");
          if (!this.startWorkspace_)
            throw Error("Cannot update dragging the bubble because the start workspace is undefined");
          this.bubbleDragger = new Is(this.startBubble, this.startWorkspace_), this.bubbleDragger.startBubbleDrag(), this.bubbleDragger.dragBubble(this.mostRecentEvent, this.currentDragDeltaXY);
        }
        doStart(e) {
          if (!this.startWorkspace_)
            throw Error("Cannot start the touch gesture becauase the start workspace is undefined");
          this.isPinchZoomEnabled = this.startWorkspace_.options.zoomOptions && this.startWorkspace_.options.zoomOptions.pinch, vs(e) ? this.cancel() : (this.gestureHasStarted = !0, KT(), this.startWorkspace_.updateScreenCalculationsIfScrolled(), this.startWorkspace_.isMutator && this.startWorkspace_.resize(), this.currentDropdownOwner = sa(), this.startWorkspace_.hideChaff(!!this.flyout), this.startWorkspace_.markFocused(), this.mostRecentEvent = e, wp(), this.targetBlock && this.targetBlock.select(), Ui(e) ? this.handleRightClick(e) : (e.type.toLowerCase() === "pointerdown" && e.pointerType !== "mouse" && H(
            e,
            this
          ), this.mouseDownXY = new ae(e.clientX, e.clientY), this.healStack = e.altKey || e.ctrlKey || e.metaKey, this.bindMouseEvents(e), this.isEnding_ || this.handleTouchStart(e)));
        }
        bindMouseEvents(e) {
          this.boundEvents.push(Pe(document, "pointerdown", null, this.handleStart.bind(this), !0)), this.boundEvents.push(Pe(document, "pointermove", null, this.handleMove.bind(this), !0)), this.boundEvents.push(Pe(document, "pointerup", null, this.handleUp.bind(this), !0)), e.preventDefault(), e.stopPropagation();
        }
        handleStart(e) {
          this.isDragging() || (this.handleTouchStart(e), this.isMultiTouch() && ee());
        }
        handleMove(e) {
          this.isDragging() && Ge(e) || !this.isMultiTouch() ? (this.updateFromEvent(e), this.workspaceDragger ? this.workspaceDragger.drag(this.currentDragDeltaXY) : this.blockDragger ? this.blockDragger.drag(this.mostRecentEvent, this.currentDragDeltaXY) : this.bubbleDragger && this.bubbleDragger.dragBubble(this.mostRecentEvent, this.currentDragDeltaXY), e.preventDefault(), e.stopPropagation()) : this.isMultiTouch() && (this.handleTouchMove(e), ee());
        }
        handleUp(e) {
          if (this.isDragging() || this.handleTouchEnd(e), !this.isMultiTouch() || this.isDragging()) {
            if (!Ge(e))
              return;
            if (this.updateFromEvent(e), ee(), this.isEnding_) {
              console.log("Trying to end a gesture recursively.");
              return;
            }
            this.isEnding_ = !0, this.bubbleDragger ? this.bubbleDragger.endBubbleDrag(e, this.currentDragDeltaXY) : this.blockDragger ? this.blockDragger.endDrag(e, this.currentDragDeltaXY) : this.workspaceDragger ? this.workspaceDragger.endDrag(this.currentDragDeltaXY) : this.isBubbleClick() ? this.doBubbleClick() : this.isFieldClick() ? this.doFieldClick() : this.isIconClick() ? this.doIconClick() : this.isBlockClick() ? this.doBlockClick() : this.isWorkspaceClick() && this.doWorkspaceClick(e);
          }
          e.preventDefault(), e.stopPropagation(), this.dispose();
        }
        handleTouchStart(e) {
          var t = qt(e);
          this.cachedPoints.set(t, this.getTouchPoint(e));
          var n = Array.from(this.cachedPoints.keys());
          n.length === 2 && (t = this.cachedPoints.get(n[0]), n = this.cachedPoints.get(n[1]), this.startDistance = ae.distance(t, n), this.isMultiTouch_ = !0, e.preventDefault());
        }
        handleTouchMove(e) {
          const t = qt(e);
          this.cachedPoints.set(t, this.getTouchPoint(e)), this.isPinchZoomEnabled && this.cachedPoints.size === 2 ? this.handlePinch(e) : this.handleMove(e);
        }
        handlePinch(e) {
          var t = Array.from(this.cachedPoints.keys()), n = this.cachedPoints.get(t[0]);
          if (t = this.cachedPoints.get(t[1]), n = ae.distance(n, t) / this.startDistance, 0 < this.previousScale && 1 / 0 > this.previousScale) {
            if (t = n - this.previousScale, t = 0 < t ? t * VS : t * GS, !this.startWorkspace_)
              throw Error("Cannot handle a pinch because the start workspace is undefined");
            const o = this.startWorkspace_, c = Oo(e, o.getParentSvg(), o.getInverseScreenCTM());
            o.zoom(c.x, c.y, t);
          }
          this.previousScale = n, e.preventDefault();
        }
        handleTouchEnd(e) {
          e = qt(e), this.cachedPoints.has(e) && this.cachedPoints.delete(e), 2 > this.cachedPoints.size && (this.cachedPoints.clear(), this.previousScale = 0);
        }
        getTouchPoint(e) {
          return this.startWorkspace_ ? new ae(e.pageX, e.pageY) : null;
        }
        isMultiTouch() {
          return this.isMultiTouch_;
        }
        cancel() {
          this.isEnding_ || (ee(), this.bubbleDragger ? this.bubbleDragger.endBubbleDrag(this.mostRecentEvent, this.currentDragDeltaXY) : this.blockDragger ? this.blockDragger.endDrag(this.mostRecentEvent, this.currentDragDeltaXY) : this.workspaceDragger && this.workspaceDragger.endDrag(this.currentDragDeltaXY), this.dispose());
        }
        handleRightClick(e) {
          this.targetBlock ? (this.bringBlockToFront(), this.targetBlock.workspace.hideChaff(!!this.flyout), this.targetBlock.showContextMenu(e)) : this.startBubble ? this.startBubble.showContextMenu(e) : this.startWorkspace_ && !this.flyout && (this.startWorkspace_.hideChaff(), this.startWorkspace_.showContextMenu(e)), e.preventDefault(), e.stopPropagation(), this.dispose();
        }
        handleWsStart(e, t) {
          if (this.gestureHasStarted)
            throw Error("Tried to call gesture.handleWsStart, but the gesture had already been started.");
          this.setStartWorkspace(t), this.mostRecentEvent = e, this.doStart(e);
        }
        fireWorkspaceClick(e) {
          fe(new (ge(B_))(null, e.id, "workspace"));
        }
        handleFlyoutStart(e, t) {
          if (this.gestureHasStarted)
            throw Error("Tried to call gesture.handleFlyoutStart, but the gesture had already been started.");
          this.setStartFlyout(t), this.handleWsStart(e, t.getWorkspace());
        }
        handleBlockStart(e, t) {
          if (this.gestureHasStarted)
            throw Error("Tried to call gesture.handleBlockStart, but the gesture had already been started.");
          this.setStartBlock(t), this.mostRecentEvent = e;
        }
        handleBubbleStart(e, t) {
          if (this.gestureHasStarted)
            throw Error("Tried to call gesture.handleBubbleStart, but the gesture had already been started.");
          this.setStartBubble(t), this.mostRecentEvent = e;
        }
        doBubbleClick() {
          this.startBubble instanceof yr && (this.startBubble.setFocus(), this.startBubble.select());
        }
        doFieldClick() {
          if (!this.startField)
            throw Error("Cannot do a field click because the start field is undefined");
          this.currentDropdownOwner !== this.startField && this.startField.showEditor(this.mostRecentEvent), this.bringBlockToFront();
        }
        doIconClick() {
          if (!this.startIcon)
            throw Error("Cannot do an icon click because the start icon is undefined");
          this.startIcon.onClick();
        }
        doBlockClick() {
          if (this.flyout && this.flyout.autoClose) {
            if (!this.targetBlock)
              throw Error("Cannot do a block click because the target block is undefined");
            this.targetBlock.isEnabled() && (r.getGroup$$module$build$src$core$events$utils() || r.setGroup$$module$build$src$core$events$utils(!0), this.flyout.createBlock(this.targetBlock).scheduleSnapAndBump());
          } else {
            if (!this.startWorkspace_)
              throw Error("Cannot do a block click because the start workspace is undefined");
            const e = new (ge(B_))(this.startBlock, this.startWorkspace_.id, "block");
            fe(e);
          }
          this.bringBlockToFront(), r.setGroup$$module$build$src$core$events$utils(!1);
        }
        doWorkspaceClick(e) {
          e = this.creatorWorkspace, we() && we().unselect(), this.fireWorkspaceClick(this.startWorkspace_ || e);
        }
        bringBlockToFront() {
          this.targetBlock && !this.flyout && this.targetBlock.bringToFront();
        }
        setStartField(e) {
          if (this.gestureHasStarted)
            throw Error("Tried to call gesture.setStartField, but the gesture had already been started.");
          this.startField || (this.startField = e);
        }
        setStartIcon(e) {
          if (this.gestureHasStarted)
            throw Error("Tried to call gesture.setStartIcon, but the gesture had already been started.");
          this.startIcon || (this.startIcon = e);
        }
        setStartBubble(e) {
          this.startBubble || (this.startBubble = e);
        }
        setStartBlock(e) {
          this.startBlock || this.startBubble || (this.startBlock = e, e.isInFlyout && e !== e.getRootBlock() ? this.setTargetBlock(e.getRootBlock()) : this.setTargetBlock(e));
        }
        setTargetBlock(e) {
          e.isShadow() ? this.setTargetBlock(e.getParent()) : this.targetBlock = e;
        }
        setStartWorkspace(e) {
          this.startWorkspace_ || (this.startWorkspace_ = e);
        }
        setStartFlyout(e) {
          this.flyout || (this.flyout = e);
        }
        isBubbleClick() {
          return !!this.startBubble && !this.hasExceededDragRadius;
        }
        isBlockClick() {
          return !!this.startBlock && !this.hasExceededDragRadius && !this.isFieldClick() && !this.isIconClick();
        }
        isFieldClick() {
          return (this.startField ? this.startField.isClickable() : !1) && !this.hasExceededDragRadius && (!this.flyout || !this.flyout.autoClose);
        }
        isIconClick() {
          return !!this.startIcon && !this.hasExceededDragRadius;
        }
        isWorkspaceClick() {
          return !this.startBlock && !this.startBubble && !this.startField && !this.hasExceededDragRadius;
        }
        isDragging() {
          return !!this.workspaceDragger || !!this.blockDragger || !!this.bubbleDragger;
        }
        hasStarted() {
          return this.gestureHasStarted;
        }
        getInsertionMarkers() {
          return this.blockDragger ? this.blockDragger.getInsertionMarkers() : [];
        }
        getCurrentDragger() {
          let e, t;
          return (t = (e = this.blockDragger) != null ? e : this.workspaceDragger) != null ? t : this.bubbleDragger;
        }
        static inProgress() {
          const e = ce();
          for (let t = 0, n; n = e[t]; t++)
            if (n.currentGesture_)
              return !0;
          return !1;
        }
      }, LE = class {
        constructor(e, t) {
          this.pattern = e;
          let n;
          this.spacing = (n = t.spacing) != null ? n : 0;
          let o;
          this.length = (o = t.length) != null ? o : 1, this.line2 = (this.line1 = e.firstChild) && this.line1.nextSibling;
          let c;
          this.snapToGrid = (c = t.snap) != null ? c : !1;
        }
        shouldSnap() {
          return this.snapToGrid;
        }
        getSpacing() {
          return this.spacing;
        }
        getPatternId() {
          return this.pattern.id;
        }
        update(e) {
          var t = this.spacing * e;
          this.pattern.setAttribute("width", `${t}`), this.pattern.setAttribute("height", `${t}`), t = Math.floor(this.spacing / 2) + 0.5;
          let n = t - this.length / 2, o = t + this.length / 2;
          t *= e, n *= e, o *= e, this.setLineAttributes(this.line1, e, n, o, t, t), this.setLineAttributes(this.line2, e, t, t, n, o);
        }
        setLineAttributes(e, t, n, o, c, A) {
          e && (e.setAttribute("stroke-width", `${t}`), e.setAttribute("x1", `${n}`), e.setAttribute("y1", `${c}`), e.setAttribute("x2", `${o}`), e.setAttribute("y2", `${A}`));
        }
        moveTo(e, t) {
          this.pattern.setAttribute("x", `${e}`), this.pattern.setAttribute("y", `${t}`);
        }
        static createDom(e, t, n) {
          e = K(
            U.PATTERN,
            { id: "blocklyGridPattern" + e, patternUnits: "userSpaceOnUse" },
            n
          );
          let o, c;
          if (0 < ((o = t.length) != null ? o : 1) && 0 < ((c = t.spacing) != null ? c : 0)) {
            K(U.LINE, { stroke: t.colour }, e);
            let A;
            (A = t.length) != null && A && K(U.LINE, { stroke: t.colour }, e);
          } else
            K(U.LINE, {}, e);
          return e;
        }
      };
      r.Names$$module$build$src$core$names = class {
        constructor(e, t) {
          this.db = /* @__PURE__ */ new Map(), this.dbReverse = /* @__PURE__ */ new Set(), this.variableMap = null, this.variablePrefix = t || "", this.reservedWords = new Set(e ? e.split(",") : []);
        }
        reset() {
          this.db.clear(), this.dbReverse.clear(), this.variableMap = null;
        }
        setVariableMap(e) {
          this.variableMap = e;
        }
        getNameForUserVariable(e) {
          return this.variableMap ? (e = this.variableMap.getVariableById(e)) ? e.name : null : (console.warn(`Deprecated call to Names.prototype.getName without defining a variable map. To fix, add the following code in your generator's init() function:
Blockly.YourGeneratorName.nameDB_.setVariableMap(workspace.getVariableMap());`), null);
        }
        populateVariables(e) {
          e = r.allUsedVarModels$$module$build$src$core$variables(e);
          for (let t = 0; t < e.length; t++)
            this.getName(e[t].getId(), r.NameType$$module$build$src$core$names.VARIABLE);
        }
        populateProcedures(e) {
          throw Error("The implementation of populateProcedures should be monkey-patched in by blockly.ts");
        }
        getName(e, t) {
          let n = e;
          t === r.NameType$$module$build$src$core$names.VARIABLE && (e = this.getNameForUserVariable(e)) && (n = e), e = n.toLowerCase();
          const o = t === r.NameType$$module$build$src$core$names.VARIABLE || t === r.NameType$$module$build$src$core$names.DEVELOPER_VARIABLE ? this.variablePrefix : "";
          this.db.has(t) || this.db.set(t, /* @__PURE__ */ new Map());
          const c = this.db.get(t);
          return c.has(e) ? o + c.get(e) : (t = this.getDistinctName(n, t), c.set(e, t.substr(o.length)), t);
        }
        getUserNames(e) {
          let t;
          return (e = (t = this.db.get(e)) == null ? void 0 : t.keys()) ? Array.from(e) : [];
        }
        getDistinctName(e, t) {
          e = this.safeName(e);
          let n = null, o, c;
          for (; this.dbReverse.has(e + ((o = n) != null ? o : "")) || this.reservedWords.has(e + ((c = n) != null ? c : "")); )
            n = n ? n + 1 : 2;
          let A;
          return e += (A = n) != null ? A : "", this.dbReverse.add(e), (t === r.NameType$$module$build$src$core$names.VARIABLE || t === r.NameType$$module$build$src$core$names.DEVELOPER_VARIABLE ? this.variablePrefix : "") + e;
        }
        safeName(e) {
          return e ? (e = encodeURI(e.replace(/ /g, "_")).replace(/[^\w]/g, "_"), "0123456789".indexOf(e[0]) !== -1 && (e = "my_" + e)) : e = r.Msg$$module$build$src$core$msg.UNNAMED_KEY || "unnamed", e;
        }
        static equals(e, t) {
          return e.toLowerCase() === t.toLowerCase();
        }
      }, function(e) {
        e = e.NameType || (e.NameType = {}), e.DEVELOPER_VARIABLE = "DEVELOPER_VARIABLE", e.VARIABLE = "VARIABLE", e.PROCEDURE = "PROCEDURE";
      }(r.Names$$module$build$src$core$names || (r.Names$$module$build$src$core$names = {})), r.NameType$$module$build$src$core$names = r.Names$$module$build$src$core$names.NameType, r.Names$$module$build$src$core$names.DEVELOPER_VARIABLE_TYPE = r.NameType$$module$build$src$core$names.DEVELOPER_VARIABLE, r.NameType$$module$build$src$core$names, r.Names$$module$build$src$core$names;
      var $d = class extends Map {
        constructor() {
          super();
        }
        set(e, t) {
          return this.get(e) === t ? this : (super.set(e, t), ll(t) && t.startPublishing(), this);
        }
        delete(e) {
          const t = this.get(e);
          return e = super.delete(e), e && (ll(t) && t.stopPublishing(), e);
        }
        clear() {
          if (this.size)
            for (const e of this.keys())
              this.delete(e);
        }
        add(e) {
          return this.set(
            e.getId(),
            e
          );
        }
        getProcedures() {
          return [...this.values()];
        }
      }, Io = {};
      Io.CommentIcon = br, Io.Icon = uc, Io.IconType = mr, Io.MutatorIcon = r.MutatorIcon$$module$build$src$core$icons$mutator_icon, Io.WarningIcon = m_, Io.exceptions = td, Io.registry = Mc;
      var wc, vr;
      wc = "PROCEDURE", r.DEFAULT_ARG$$module$build$src$core$procedures = "x", vr = {}, vr.CATEGORY_NAME = wc, vr.DEFAULT_ARG = r.DEFAULT_ARG$$module$build$src$core$procedures, vr.ObservableProcedureMap = $d, vr.allProcedures = al, vr.findLegalName = r.findLegalName$$module$build$src$core$procedures, vr.flyoutCategory = wa, vr.getCallers = Ir, vr.getDefinition = r.getDefinition$$module$build$src$core$procedures, vr.isNameUsed = Fa, vr.isProcedureBlock = Qi, vr.mutateCallers = r.mutateCallers$$module$build$src$core$procedures, vr.mutatorOpenListener = au, vr.rename = r.rename$$module$build$src$core$procedures;
      var Wd = class {
        constructor(e, t) {
          this.workspace = e, this.theme = t, this.subscribedWorkspaces_ = [], this.componentDB = /* @__PURE__ */ new Map();
        }
        getTheme() {
          return this.theme;
        }
        setTheme(e) {
          var t = this.theme;
          this.theme = e, (e = this.workspace.getInjectionDiv()) && (t && (t = t.getClassName()) && Be(e, t), (t = this.theme.getClassName()) && be(e, t));
          for (let n = 0, o; o = this.subscribedWorkspaces_[n]; n++)
            o.refreshTheme();
          for (const [
            n,
            o
          ] of this.componentDB)
            for (const c of o) {
              e = c.element, t = c.propertyName;
              const A = this.theme && this.theme.getComponentStyle(n);
              e.style.setProperty(t, A || "");
            }
          for (const n of this.subscribedWorkspaces_)
            n.hideChaff();
        }
        subscribeWorkspace(e) {
          this.subscribedWorkspaces_.push(e);
        }
        unsubscribeWorkspace(e) {
          if (!cn(this.subscribedWorkspaces_, e))
            throw Error("Cannot unsubscribe a workspace that hasn't been subscribed.");
        }
        subscribe(e, t, n) {
          this.componentDB.has(t) || this.componentDB.set(
            t,
            []
          ), this.componentDB.get(t).push({ element: e, propertyName: n }), t = this.theme && this.theme.getComponentStyle(t), e.style.setProperty(n, t || "");
        }
        unsubscribe(e) {
          if (e)
            for (const [t, n] of this.componentDB) {
              for (let o = n.length - 1; 0 <= o; o--)
                n[o].element === e && n.splice(o, 1);
              n.length || this.componentDB.delete(t);
            }
        }
        dispose() {
          this.subscribedWorkspaces_.length = 0, this.componentDB.clear();
        }
      }, Hl = "VARIABLE_DYNAMIC", vi = {};
      vi.CATEGORY_NAME = Hl, vi.flyoutCategory = zo, vi.flyoutCategoryBlocks = Si, vi.onCreateVariableButtonClick_Colour = cl, vi.onCreateVariableButtonClick_Number = jn, vi.onCreateVariableButtonClick_String = Ya;
      var Bc = class {
        constructor(e) {
          this.workspace = e, this.variableMap = /* @__PURE__ */ new Map();
        }
        clear() {
          for (const e of this.variableMap.values())
            for (; 0 < e.length; )
              this.deleteVariable(e[0]);
          if (this.variableMap.size !== 0)
            throw Error("Non-empty variable map");
        }
        renameVariable(e, t) {
          if (e.name !== t) {
            var n = this.getVariable(t, e.type), o = this.workspace.getAllBlocks(!1), c = r.getGroup$$module$build$src$core$events$utils();
            c || r.setGroup$$module$build$src$core$events$utils(!0);
            try {
              n && n.getId() !== e.getId() ? this.renameVariableWithConflict_(e, t, n, o) : this.renameVariableAndUses_(e, t, o);
            } finally {
              r.setGroup$$module$build$src$core$events$utils(c);
            }
          }
        }
        renameVariableById(e, t) {
          const n = this.getVariableById(e);
          if (!n)
            throw Error("Tried to rename a variable that didn't exist. ID: " + e);
          this.renameVariable(n, t);
        }
        renameVariableAndUses_(e, t, n) {
          for (fe(new (ge(yn))(e, t)), e.name = t, t = 0; t < n.length; t++)
            n[t].updateVarName(e);
        }
        renameVariableWithConflict_(e, t, n, o) {
          const c = e.type;
          for (t !== n.name && this.renameVariableAndUses_(n, t, o), t = 0; t < o.length; t++)
            o[t].renameVarById(e.getId(), n.getId());
          fe(new (ge(Mr))(e)), cn(this.variableMap.get(c), e);
        }
        createVariable(e, t, n) {
          var o = this.getVariable(e, t);
          if (o) {
            if (n && o.getId() !== n)
              throw Error('Variable "' + e + '" is already in use and its id is "' + o.getId() + '" which conflicts with the passed in id, "' + n + '".');
            return o;
          }
          if (n && this.getVariableById(n))
            throw Error('Variable id, "' + n + '", is already in use.');
          return o = n || Gr(), t = t || "", o = new rs(this.workspace, e, t, o), e = this.variableMap.get(t) || [], e.push(o), this.variableMap.delete(t), this.variableMap.set(t, e), fe(new (ge(mi))(o)), o;
        }
        deleteVariable(e) {
          const t = e.getId(), n = this.variableMap.get(e.type);
          if (n) {
            for (let o = 0; o < n.length; o++)
              if (n[o].getId() === t) {
                n.splice(o, 1), fe(new (ge(Mr))(e)), n.length === 0 && this.variableMap.delete(e.type);
                break;
              }
          }
        }
        deleteVariableById(e) {
          const t = this.getVariableById(e);
          if (t) {
            var n = t.name;
            const o = this.getVariableUsesById(e);
            for (let c = 0, A; A = o[c]; c++)
              if (A.type === "procedures_defnoreturn" || A.type === "procedures_defreturn") {
                e = String(A.getFieldValue("NAME")), n = r.Msg$$module$build$src$core$msg.CANNOT_DELETE_VARIABLE_PROCEDURE.replace("%1", n).replace("%2", e), si(n);
                return;
              }
            1 < o.length ? (n = r.Msg$$module$build$src$core$msg.DELETE_VARIABLE_CONFIRMATION.replace("%1", String(o.length)).replace("%2", n), Xr(n, (c) => {
              c && t && this.deleteVariableInternal(t, o);
            })) : this.deleteVariableInternal(t, o);
          } else
            console.warn("Can't delete non-existent variable: " + e);
        }
        deleteVariableInternal(e, t) {
          const n = r.getGroup$$module$build$src$core$events$utils();
          n || r.setGroup$$module$build$src$core$events$utils(!0);
          try {
            for (let o = 0; o < t.length; o++)
              t[o].dispose(!0);
            this.deleteVariable(e);
          } finally {
            r.setGroup$$module$build$src$core$events$utils(n);
          }
        }
        getVariable(e, t) {
          if (t = this.variableMap.get(t || "")) {
            for (let n = 0, o; o = t[n]; n++)
              if (r.Names$$module$build$src$core$names.equals(o.name, e))
                return o;
          }
          return null;
        }
        getVariableById(e) {
          for (const t of this.variableMap.values())
            for (const n of t)
              if (n.getId() === e)
                return n;
          return null;
        }
        getVariablesOfType(e) {
          return (e = this.variableMap.get(e || "")) ? e.slice() : [];
        }
        getVariableTypes(e) {
          const t = new Set(this.variableMap.keys());
          if (e && e.getPotentialVariableMap())
            for (const n of e.getPotentialVariableMap().variableMap.keys())
              t.add(n);
          return t.has("") || t.add(""), Array.from(t.values());
        }
        getAllVariables() {
          let e = [];
          for (const t of this.variableMap.values())
            e = e.concat(t);
          return e;
        }
        getAllVariableNames() {
          return Array.from(this.variableMap.values()).flat().map((e) => e.name);
        }
        getVariableUsesById(e) {
          const t = [], n = this.workspace.getAllBlocks(!1);
          for (let o = 0; o < n.length; o++) {
            const c = n[o].getVarModels();
            if (c)
              for (let A = 0; A < c.length; A++)
                c[A].getId() === e && t.push(n[o]);
          }
          return t;
        }
      }, xl = class {
        get isFlyout() {
          return this.internalIsFlyout;
        }
        get isMutator() {
          return this.internalIsMutator;
        }
        constructor(e) {
          this.isClearing = this.internalIsMutator = this.internalIsFlyout = this.rendered = !1, this.MAX_UNDO = 1024, this.connectionDBList = [], this.topBlocks = [], this.topComments = [], this.commentDB = /* @__PURE__ */ new Map(), this.listeners = [], this.undoStack_ = [], this.redoStack_ = [], this.blockDB = /* @__PURE__ */ new Map(), this.typedBlocksDB = /* @__PURE__ */ new Map(), this.procedureMap = new $d(), this.potentialVariableMap = null, this.id = Gr(), ve(this), this.options = e || new qn({}), this.RTL = !!this.options.RTL, this.horizontalLayout = !!this.options.horizontalLayout, this.toolboxPosition = this.options.toolboxPosition, this.connectionChecker = new (Z(se.CONNECTION_CHECKER, this.options, !0))(this), this.variableMap = new Bc(this);
        }
        dispose() {
          this.listeners.length = 0, this.clear(), et(this);
        }
        sortObjects_(e, t) {
          const n = Math.sin(Gi(xl.SCAN_ANGLE)) * (this.RTL ? -1 : 1);
          return e = e.getRelativeToSurfaceXY(), t = t.getRelativeToSurfaceXY(), e.y + n * e.x - (t.y + n * t.x);
        }
        addTopBlock(e) {
          this.topBlocks.push(e);
        }
        removeTopBlock(e) {
          if (!cn(
            this.topBlocks,
            e
          ))
            throw Error("Block not present in workspace's list of top-most blocks.");
        }
        getTopBlocks(e) {
          const t = [].concat(this.topBlocks);
          return e && 1 < t.length && t.sort(this.sortObjects_.bind(this)), t;
        }
        addTypedBlock(e) {
          this.typedBlocksDB.has(e.type) || this.typedBlocksDB.set(e.type, []), this.typedBlocksDB.get(e.type).push(e);
        }
        removeTypedBlock(e) {
          cn(this.typedBlocksDB.get(e.type), e), this.typedBlocksDB.get(e.type).length || this.typedBlocksDB.delete(e.type);
        }
        getBlocksByType(e, t) {
          return this.typedBlocksDB.has(e) ? (e = this.typedBlocksDB.get(e).slice(0), t && e && 1 < e.length && e.sort(this.sortObjects_.bind(this)), e.filter(function(n) {
            return !n.isInsertionMarker();
          })) : [];
        }
        addTopComment(e) {
          this.topComments.push(e), this.commentDB.has(e.id) && console.warn('Overriding an existing comment on this workspace, with id "' + e.id + '"'), this.commentDB.set(e.id, e);
        }
        removeTopComment(e) {
          if (!cn(this.topComments, e))
            throw Error("Comment not present in workspace's list of top-most comments.");
          this.commentDB.delete(e.id);
        }
        getTopComments(e) {
          const t = [].concat(this.topComments);
          return e && 1 < t.length && t.sort(this.sortObjects_.bind(this)), t;
        }
        getAllBlocks(e) {
          if (e) {
            var t = this.getTopBlocks(!0);
            e = [];
            for (let n = 0; n < t.length; n++)
              e.push(...t[n].getDescendants(!0));
          } else
            for (e = this.getTopBlocks(!1), t = 0; t < e.length; t++)
              e.push(...e[t].getChildren(!1));
          return e.filter(function(n) {
            return !n.isInsertionMarker();
          });
        }
        clear() {
          this.isClearing = !0;
          try {
            const e = r.getGroup$$module$build$src$core$events$utils();
            for (e || r.setGroup$$module$build$src$core$events$utils(!0); this.topBlocks.length; )
              this.topBlocks[0].dispose(!1);
            for (; this.topComments.length; )
              this.topComments[this.topComments.length - 1].dispose();
            r.setGroup$$module$build$src$core$events$utils(e), this.variableMap.clear(), this.potentialVariableMap && this.potentialVariableMap.clear();
          } finally {
            this.isClearing = !1;
          }
        }
        renameVariableById(e, t) {
          this.variableMap.renameVariableById(e, t);
        }
        createVariable(e, t, n) {
          return this.variableMap.createVariable(e, t, n);
        }
        getVariableUsesById(e) {
          return this.variableMap.getVariableUsesById(e);
        }
        deleteVariableById(e) {
          this.variableMap.deleteVariableById(e);
        }
        getVariable(e, t) {
          return this.variableMap.getVariable(e, t);
        }
        getVariableById(e) {
          return this.variableMap.getVariableById(e);
        }
        getVariablesOfType(e) {
          return this.variableMap.getVariablesOfType(e);
        }
        getVariableTypes() {
          return this.variableMap.getVariableTypes(this);
        }
        getAllVariables() {
          return this.variableMap.getAllVariables();
        }
        getAllVariableNames() {
          return this.variableMap.getAllVariableNames();
        }
        getWidth() {
          return 0;
        }
        newBlock(e, t) {
          throw Error("The implementation of newBlock should be monkey-patched in by blockly.ts");
        }
        remainingCapacity() {
          return isNaN(this.options.maxBlocks) ? 1 / 0 : this.options.maxBlocks - this.getAllBlocks(!1).length;
        }
        remainingCapacityOfType(e) {
          return this.options.maxInstances ? (this.options.maxInstances[e] !== void 0 ? this.options.maxInstances[e] : 1 / 0) - this.getBlocksByType(e, !1).length : 1 / 0;
        }
        isCapacityAvailable(e) {
          if (!this.hasBlockLimits())
            return !0;
          let t = 0;
          for (const n in e) {
            if (e[n] > this.remainingCapacityOfType(n))
              return !1;
            t += e[n];
          }
          return !(t > this.remainingCapacity());
        }
        hasBlockLimits() {
          return this.options.maxBlocks !== 1 / 0 || !!this.options.maxInstances;
        }
        getUndoStack() {
          return this.undoStack_;
        }
        getRedoStack() {
          return this.redoStack_;
        }
        undo(e) {
          var t = e ? this.redoStack_ : this.undoStack_, n = e ? this.undoStack_ : this.redoStack_;
          const o = t.pop();
          if (o) {
            for (var c = [o]; t.length && o.group && o.group === t[t.length - 1].group; ) {
              const A = t.pop();
              A && c.push(A);
            }
            for (t = 0; t < c.length; t++)
              n.push(c[t]);
            c = Ar(c, e), ur(!1);
            try {
              for (n = 0; n < c.length; n++)
                c[n].run(e);
            } finally {
              ur(!0);
            }
          }
        }
        clearUndo() {
          this.undoStack_.length = 0, this.redoStack_.length = 0, ii();
        }
        addChangeListener(e) {
          return this.listeners.push(e), e;
        }
        removeChangeListener(e) {
          cn(this.listeners, e);
        }
        fireChangeListener(e) {
          if (e.recordUndo)
            for (this.undoStack_.push(e), this.redoStack_.length = 0; this.undoStack_.length > this.MAX_UNDO && 0 <= this.MAX_UNDO; )
              this.undoStack_.shift();
          for (let t = 0; t < this.listeners.length; t++)
            (0, this.listeners[t])(e);
        }
        getBlockById(e) {
          return this.blockDB.get(e) || null;
        }
        setBlockById(e, t) {
          this.blockDB.set(e, t);
        }
        removeBlockById(e) {
          this.blockDB.delete(e);
        }
        getCommentById(e) {
          let t;
          return (t = this.commentDB.get(e)) != null ? t : null;
        }
        allInputsFilled(e) {
          const t = this.getTopBlocks(!1);
          for (let n = 0; n < t.length; n++)
            if (!t[n].allInputsFilled(e))
              return !1;
          return !0;
        }
        getPotentialVariableMap() {
          return this.potentialVariableMap;
        }
        createPotentialVariableMap() {
          this.potentialVariableMap = new Bc(this);
        }
        getVariableMap() {
          return this.variableMap;
        }
        setVariableMap(e) {
          this.variableMap = e;
        }
        getProcedureMap() {
          return this.procedureMap;
        }
        getRootWorkspace() {
          let e = null;
          const t = this.options.parentWorkspace;
          return this.isFlyout ? t && t.options && (e = t.options.parentWorkspace) : t && (e = t), e;
        }
        static getById(e) {
          return le(e);
        }
        static getAll() {
          return ce();
        }
      };
      xl.SCAN_ANGLE = 3;
      var HS = 100, kd = class {
        constructor(e) {
          this.parentWorkspace = e, this.sounds = /* @__PURE__ */ new Map(), this.lastSound_ = null;
        }
        dispose() {
          this.sounds.clear();
        }
        load(e, t) {
          if (e.length) {
            try {
              var n = new globalThis.Audio();
            } catch {
              return;
            }
            for (let c = 0; c < e.length; c++) {
              const A = e[c], D = A.match(/\.(\w+)$/);
              if (D && n.canPlayType("audio/" + D[1])) {
                var o = new globalThis.Audio(A);
                break;
              }
            }
            o && this.sounds.set(t, o);
          }
        }
        preload() {
          for (const e of this.sounds.values()) {
            e.volume = 0.01;
            const t = e.play();
            if (t !== void 0 ? t.then(e.pause).catch(function() {
            }) : e.pause(), os || H_)
              break;
          }
        }
        play(e, t) {
          var n = this.sounds.get(e);
          n ? (e = /* @__PURE__ */ new Date(), this.lastSound_ !== null && e.getTime() - this.lastSound_.getTime() < HS || (this.lastSound_ = e, n = os || tc ? n : n.cloneNode(), n.volume = t === void 0 ? 1 : t, n.play())) : this.parentWorkspace && this.parentWorkspace.getAudioManager().play(e, t);
        }
      }, L_;
      (function(e) {
        e[e.TOP = 0] = "TOP", e[e.BOTTOM = 1] = "BOTTOM";
      })(L_ || (L_ = {}));
      var fs;
      (function(e) {
        e[e.LEFT = 0] = "LEFT", e[e.RIGHT = 1] = "RIGHT";
      })(fs || (fs = {}));
      var Mo;
      (function(e) {
        e[e.UP = 0] = "UP", e[e.DOWN = 1] = "DOWN";
      })(Mo || (Mo = {}));
      var MT = {};
      MT.bumpDirection = Mo, MT.bumpPositionRect = ZT, MT.getCornerOppositeToolbox = gr, MT.getStartPositionRect = pl, MT.horizontalPosition = fs, MT.verticalPosition = L_;
      var gt = { width: 96, height: 124, url: "sprites.png" }, Yc = class {
        constructor(e) {
          this.workspace = e, this.id = "zoomControls", this.boundEvents = [], this.zoomResetGroup = this.zoomOutGroup = this.zoomInGroup = null, this.HEIGHT = this.WIDTH = 32, this.SMALL_SPACING = 2, this.LARGE_SPACING = 11, this.MARGIN_HORIZONTAL = this.MARGIN_VERTICAL = 20, this.svgGroup = null, this.top = this.left = 0, this.initialized = !1;
        }
        createDom() {
          this.svgGroup = K(U.G, {});
          const e = String(Math.random()).substring(2);
          return this.createZoomOutSvg(e), this.createZoomInSvg(e), this.workspace.isMovable() && this.createZoomResetSvg(e), this.svgGroup;
        }
        init() {
          this.workspace.getComponentManager().addComponent({ component: this, weight: 2, capabilities: [Lt.Capability.POSITIONABLE] }), this.initialized = !0;
        }
        dispose() {
          this.workspace.getComponentManager().removeComponent("zoomControls"), this.svgGroup && Tt(this.svgGroup);
          for (const e of this.boundEvents)
            It(e);
          this.boundEvents.length = 0;
        }
        getBoundingRectangle() {
          let e = this.SMALL_SPACING + 2 * this.HEIGHT;
          return this.zoomResetGroup && (e += this.LARGE_SPACING + this.HEIGHT), new Dt(this.top, this.top + e, this.left, this.left + this.WIDTH);
        }
        position(e, t) {
          if (this.initialized) {
            var n = gr(this.workspace, e), o = this.SMALL_SPACING + 2 * this.HEIGHT;
            if (this.zoomResetGroup && (o += this.LARGE_SPACING + this.HEIGHT), e = pl(
              n,
              new ht(this.WIDTH, o),
              this.MARGIN_HORIZONTAL,
              this.MARGIN_VERTICAL,
              e,
              this.workspace
            ), n = n.vertical, t = ZT(e, this.MARGIN_VERTICAL, n === L_.TOP ? Mo.DOWN : Mo.UP, t), n === L_.TOP) {
              var c = this.SMALL_SPACING + this.HEIGHT, A;
              (A = this.zoomInGroup) == null || A.setAttribute("transform", "translate(0, " + c + ")"), this.zoomResetGroup && this.zoomResetGroup.setAttribute("transform", "translate(0, " + (c + this.LARGE_SPACING + this.HEIGHT) + ")");
            } else {
              A = this.zoomResetGroup ? this.LARGE_SPACING + this.HEIGHT : 0;
              let $;
              ($ = this.zoomInGroup) == null || $.setAttribute("transform", "translate(0, " + A + ")"), A = A + this.SMALL_SPACING + this.HEIGHT, (c = this.zoomOutGroup) == null || c.setAttribute("transform", "translate(0, " + A + ")");
            }
            this.top = t.top, this.left = t.left;
            var D;
            (D = this.svgGroup) == null || D.setAttribute("transform", "translate(" + this.left + "," + this.top + ")");
          }
        }
        createZoomOutSvg(e) {
          this.zoomOutGroup = K(U.G, { class: "blocklyZoom" }, this.svgGroup);
          const t = K(U.CLIPPATH, { id: "blocklyZoomoutClipPath" + e }, this.zoomOutGroup);
          K(
            U.RECT,
            { width: 32, height: 32 },
            t
          ), K(U.IMAGE, { width: gt.width, height: gt.height, x: -64, y: -92, "clip-path": "url(#blocklyZoomoutClipPath" + e + ")" }, this.zoomOutGroup).setAttributeNS($n, "xlink:href", this.workspace.options.pathToMedia + gt.url), this.boundEvents.push(Pe(
            this.zoomOutGroup,
            "pointerdown",
            null,
            this.zoom.bind(this, -1)
          ));
        }
        createZoomInSvg(e) {
          this.zoomInGroup = K(U.G, { class: "blocklyZoom" }, this.svgGroup);
          const t = K(U.CLIPPATH, { id: "blocklyZoominClipPath" + e }, this.zoomInGroup);
          K(U.RECT, { width: 32, height: 32 }, t), K(
            U.IMAGE,
            { width: gt.width, height: gt.height, x: -32, y: -92, "clip-path": "url(#blocklyZoominClipPath" + e + ")" },
            this.zoomInGroup
          ).setAttributeNS($n, "xlink:href", this.workspace.options.pathToMedia + gt.url), this.boundEvents.push(Pe(this.zoomInGroup, "pointerdown", null, this.zoom.bind(this, 1)));
        }
        zoom(e, t) {
          this.workspace.markFocused(), this.workspace.zoomCenter(e), this.fireZoomEvent(), me(), t.stopPropagation(), t.preventDefault();
        }
        createZoomResetSvg(e) {
          this.zoomResetGroup = K(U.G, { class: "blocklyZoom" }, this.svgGroup);
          const t = K(U.CLIPPATH, { id: "blocklyZoomresetClipPath" + e }, this.zoomResetGroup);
          K(
            U.RECT,
            { width: 32, height: 32 },
            t
          ), K(U.IMAGE, { width: gt.width, height: gt.height, y: -92, "clip-path": "url(#blocklyZoomresetClipPath" + e + ")" }, this.zoomResetGroup).setAttributeNS($n, "xlink:href", this.workspace.options.pathToMedia + gt.url), this.boundEvents.push(Pe(
            this.zoomResetGroup,
            "pointerdown",
            null,
            this.resetZoom.bind(this)
          ));
        }
        resetZoom(e) {
          this.workspace.markFocused();
          const t = Math.log(this.workspace.options.zoomOptions.startScale / this.workspace.scale) / Math.log(this.workspace.options.zoomOptions.scaleSpeed);
          this.workspace.beginCanvasTransition(), this.workspace.zoomCenter(t), this.workspace.scrollCenter(), setTimeout(this.workspace.endCanvasTransition.bind(this.workspace), 500), this.fireZoomEvent(), me(), e.stopPropagation(), e.preventDefault();
        }
        fireZoomEvent() {
          const e = new (ge(B_))(null, this.workspace.id, "zoom_controls");
          fe(e);
        }
      };
      xn(`
.blocklyZoom>image, .blocklyZoom>svg>image {
  opacity: .4;
}

.blocklyZoom>image:hover, .blocklyZoom>svg>image:hover {
  opacity: .6;
}

.blocklyZoom>image:active, .blocklyZoom>svg>image:active {
  opacity: .8;
}
`);
      var xS = 20, g_ = class extends xl {
        constructor(e) {
          super(e), this.resizeHandlerWrapper = null, this.resizesEnabled = this.isVisible_ = this.rendered = !0, this.startScrollY = this.startScrollX = this.scrollY = this.scrollX = 0, this.dragDeltaXY = null, this.oldScale = this.scale = 1, this.oldLeft = this.oldTop = 0, this.inverseScreenCTM = this.targetWorkspace = this.configureContextMenu = this.lastRecordedPageScroll = this.injectionDiv = this.currentGesture_ = this.toolbox_ = this.flyout = this.scrollbar = this.trashcan = null, this.inverseScreenCTMDirty = !0, this.highlightedBlocks = [], this.toolboxCategoryCallbacks = /* @__PURE__ */ new Map(), this.flyoutButtonCallbacks = /* @__PURE__ */ new Map(), this.cachedParentSvg = null, this.keyboardAccessibilityMode = !1, this.topBoundedElements = [], this.dragTargetAreas = [], this.zoomControls_ = null, this.metricsManager = new (Z(se.METRICS_MANAGER, e, !0))(this), this.getMetrics = e.getMetrics || this.metricsManager.getMetrics.bind(this.metricsManager), this.setMetrics = e.setMetrics || g_.setTopLevelWorkspaceMetrics_, this.componentManager = new Lt(), this.connectionDBList = Ms.init(this.connectionChecker), this.audioManager = new kd(e.parentWorkspace), this.grid = this.options.gridPattern ? new LE(this.options.gridPattern, e.gridOptions) : null, this.markerManager = new fl(this), Er && ke && this.registerToolboxCategoryCallback(d_, ke), vi && zo && this.registerToolboxCategoryCallback(
            Hl,
            zo
          ), vr && wa && (this.registerToolboxCategoryCallback(wc, wa), this.addChangeListener(au)), this.themeManager_ = this.options.parentWorkspace ? this.options.parentWorkspace.getThemeManager() : new Wd(
            this,
            this.options.theme || dc
          ), this.themeManager_.subscribeWorkspace(this);
          let t;
          this.renderer = tu(this.options.renderer || "geras", this.getTheme(), (t = this.options.rendererOverrides) != null ? t : void 0), this.cachedParentSvgSize = new ht(0, 0);
        }
        getMarkerManager() {
          return this.markerManager;
        }
        getMetricsManager() {
          return this.metricsManager;
        }
        setMetricsManager(e) {
          this.metricsManager = e, this.getMetrics = this.metricsManager.getMetrics.bind(this.metricsManager);
        }
        getComponentManager() {
          return this.componentManager;
        }
        setCursorSvg(e) {
          this.markerManager.setCursorSvg(e);
        }
        setMarkerSvg(e) {
          this.markerManager.setMarkerSvg(e);
        }
        getMarker(e) {
          return this.markerManager ? this.markerManager.getMarker(e) : null;
        }
        getCursor() {
          return this.markerManager ? this.markerManager.getCursor() : null;
        }
        getRenderer() {
          return this.renderer;
        }
        getThemeManager() {
          return this.themeManager_;
        }
        getTheme() {
          return this.themeManager_.getTheme();
        }
        setTheme(e) {
          e || (e = dc), this.themeManager_.setTheme(e);
        }
        refreshTheme() {
          this.svgGroup_ && this.renderer.refreshDom(this.svgGroup_, this.getTheme()), this.updateBlockStyles_(this.getAllBlocks(!1).filter(function(t) {
            return !!t.getStyleName();
          })), this.refreshToolboxSelection(), this.toolbox_ && this.toolbox_.refreshTheme(), this.isVisible() && this.setVisible(!0);
          const e = new (ge(vn))(this.getTheme().name, this.id);
          fe(e);
        }
        updateBlockStyles_(e) {
          for (let t = 0, n; n = e[t]; t++) {
            const o = n.getStyleName();
            o && n.setStyle(o);
          }
        }
        getInverseScreenCTM() {
          if (this.inverseScreenCTMDirty) {
            const e = this.getParentSvg().getScreenCTM();
            e && (this.inverseScreenCTM = e.inverse(), this.inverseScreenCTMDirty = !1);
          }
          return this.inverseScreenCTM;
        }
        updateInverseScreenCTM() {
          this.inverseScreenCTMDirty = !0;
        }
        isVisible() {
          return this.isVisible_;
        }
        getSvgXY(e) {
          let t = 0, n = 0, o = 1;
          (this.getCanvas().contains(e) || this.getBubbleCanvas().contains(e)) && (o = this.scale);
          do {
            const c = Ro(e);
            (e === this.getCanvas() || e === this.getBubbleCanvas()) && (o = 1), t += c.x * o, n += c.y * o, e = e.parentNode;
          } while (e && e !== this.getParentSvg());
          return new ae(t, n);
        }
        getCachedParentSvgSize() {
          const e = this.cachedParentSvgSize;
          return new ht(e.width, e.height);
        }
        getOriginOffsetInPixels() {
          return Ws(this.getCanvas());
        }
        getInjectionDiv() {
          if (!this.injectionDiv) {
            let e = this.svgGroup_;
            for (; e; ) {
              if ((" " + (e.getAttribute("class") || "") + " ").indexOf(" injectionDiv ") !== -1) {
                this.injectionDiv = e;
                break;
              }
              e = e.parentNode;
            }
          }
          return this.injectionDiv;
        }
        getBlockCanvas() {
          return this.svgBlockCanvas_;
        }
        setResizeHandlerWrapper(e) {
          this.resizeHandlerWrapper = e;
        }
        createDom(e) {
          return this.svgGroup_ = K(U.G, { class: "blocklyWorkspace" }), e && (this.svgBackground_ = K(
            U.RECT,
            { height: "100%", width: "100%", class: e },
            this.svgGroup_
          ), e === "blocklyMainBackground" && this.grid ? this.svgBackground_.style.fill = "url(#" + this.grid.getPatternId() + ")" : this.themeManager_.subscribe(this.svgBackground_, "workspaceBackgroundColour", "fill")), this.svgBlockCanvas_ = K(U.G, { class: "blocklyBlockCanvas" }, this.svgGroup_), this.svgBubbleCanvas_ = K(
            U.G,
            { class: "blocklyBubbleCanvas" },
            this.svgGroup_
          ), this.isFlyout || (Pe(this.svgGroup_, "pointerdown", this, this.onMouseDown_, !1), document.body.addEventListener("wheel", function() {
          }), Pe(this.svgGroup_, "wheel", this, this.onMouseWheel_)), this.options.hasCategories && (this.toolbox_ = new (Z(se.TOOLBOX, this.options, !0))(this)), this.grid && this.grid.update(this.scale), this.recordDragTargets(), (e = Z(se.CURSOR, this.options)) && this.markerManager.setCursor(new e()), this.renderer.createDom(this.svgGroup_, this.getTheme()), this.svgGroup_;
        }
        dispose() {
          if (this.rendered = !1, this.currentGesture_ && this.currentGesture_.cancel(), this.svgGroup_ && Tt(this.svgGroup_), this.toolbox_ && (this.toolbox_.dispose(), this.toolbox_ = null), this.flyout && (this.flyout.dispose(), this.flyout = null), this.trashcan && (this.trashcan.dispose(), this.trashcan = null), this.scrollbar && (this.scrollbar.dispose(), this.scrollbar = null), this.zoomControls_ && this.zoomControls_.dispose(), this.audioManager && this.audioManager.dispose(), this.grid && (this.grid = null), this.renderer.dispose(), this.markerManager && this.markerManager.dispose(), super.dispose(), this.themeManager_ && (this.themeManager_.unsubscribeWorkspace(this), this.themeManager_.unsubscribe(this.svgBackground_), this.options.parentWorkspace || this.themeManager_.dispose()), this.connectionDBList.length = 0, this.toolboxCategoryCallbacks.clear(), this.flyoutButtonCallbacks.clear(), !this.options.parentWorkspace) {
            const e = this.getParentSvg();
            e && e.parentNode && Tt(e.parentNode);
          }
          this.resizeHandlerWrapper && (It(this.resizeHandlerWrapper), this.resizeHandlerWrapper = null);
        }
        addTrashcan() {
          this.trashcan = g_.newTrashcan(this);
          const e = this.trashcan.createDom();
          this.svgGroup_.insertBefore(e, this.svgBlockCanvas_);
        }
        static newTrashcan(e) {
          throw Error("The implementation of newTrashcan should be monkey-patched in by blockly.ts");
        }
        addZoomControls() {
          this.zoomControls_ = new Yc(this);
          const e = this.zoomControls_.createDom();
          this.svgGroup_.appendChild(e);
        }
        addFlyout(e) {
          const t = new qn({
            parentWorkspace: this,
            rtl: this.RTL,
            oneBasedIndex: this.options.oneBasedIndex,
            horizontalLayout: this.horizontalLayout,
            renderer: this.options.renderer,
            rendererOverrides: this.options.rendererOverrides,
            move: { scrollbars: !0 }
          });
          return t.toolboxPosition = this.options.toolboxPosition, this.flyout = this.horizontalLayout ? new (Z(se.FLYOUTS_HORIZONTAL_TOOLBOX, this.options, !0))(t) : new (Z(se.FLYOUTS_VERTICAL_TOOLBOX, this.options, !0))(t), this.flyout.autoClose = !1, this.flyout.getWorkspace().setVisible(!0), this.flyout.createDom(e);
        }
        getFlyout(e) {
          return this.flyout || e ? this.flyout : this.toolbox_ ? this.toolbox_.getFlyout() : null;
        }
        getToolbox() {
          return this.toolbox_;
        }
        updateScreenCalculations_() {
          this.updateInverseScreenCTM(), this.recordDragTargets();
        }
        resizeContents() {
          this.resizesEnabled && this.rendered && (this.scrollbar && this.scrollbar.resize(), this.updateInverseScreenCTM());
        }
        resize() {
          this.toolbox_ && this.toolbox_.position(), this.flyout && this.flyout.position();
          const e = this.componentManager.getComponents(
            Lt.Capability.POSITIONABLE,
            !0
          ), t = this.getMetricsManager().getUiMetrics(), n = [];
          for (let o = 0, c; c = e[o]; o++) {
            c.position(t, n);
            const A = c.getBoundingRectangle();
            A && n.push(A);
          }
          this.scrollbar && this.scrollbar.resize(), this.updateScreenCalculations_();
        }
        updateScreenCalculationsIfScrolled() {
          const e = na();
          ae.equals(this.lastRecordedPageScroll, e) || (this.lastRecordedPageScroll = e, this.updateScreenCalculations_());
        }
        getCanvas() {
          return this.svgBlockCanvas_;
        }
        setCachedParentSvgSize(e, t) {
          const n = this.getParentSvg();
          e != null && (this.cachedParentSvgSize.width = e, n.setAttribute("data-cached-width", `${e}`)), t != null && (this.cachedParentSvgSize.height = t, n.setAttribute("data-cached-height", `${t}`));
        }
        getBubbleCanvas() {
          return this.svgBubbleCanvas_;
        }
        getParentSvg() {
          if (!this.cachedParentSvg) {
            let e = this.svgGroup_;
            for (; e; ) {
              if (e.tagName === "svg") {
                this.cachedParentSvg = e;
                break;
              }
              e = e.parentNode;
            }
          }
          return this.cachedParentSvg;
        }
        maybeFireViewportChangeEvent() {
          if (tt()) {
            var e = this.scale, t = -this.scrollY, n = -this.scrollX;
            if (!(e === this.oldScale && 1 > Math.abs(t - this.oldTop) && 1 > Math.abs(n - this.oldLeft))) {
              var o = new (ge(no))(t, n, e, this.id, this.oldScale);
              this.oldScale = e, this.oldTop = t, this.oldLeft = n, fe(o);
            }
          }
        }
        translate(e, t) {
          const n = "translate(" + e + "," + t + ") scale(" + this.scale + ")";
          this.svgBlockCanvas_.setAttribute("transform", n), this.svgBubbleCanvas_.setAttribute(
            "transform",
            n
          ), this.grid && this.grid.moveTo(e, t), this.maybeFireViewportChangeEvent();
        }
        getWidth() {
          const e = this.getMetrics();
          return e ? e.viewWidth / this.scale : 0;
        }
        setVisible(e) {
          if (this.isVisible_ = e, this.svgGroup_)
            if (this.scrollbar && this.scrollbar.setContainerVisible(e), this.getFlyout() && this.getFlyout().setContainerVisible(e), this.getParentSvg().style.display = e ? "block" : "none", this.toolbox_ && this.toolbox_.setVisible(e), e) {
              e = this.getAllBlocks(!1);
              for (let t = e.length - 1; 0 <= t; t--)
                e[t].markDirty();
              this.render(), this.toolbox_ && this.toolbox_.position();
            } else
              this.hideChaff(!0);
        }
        render() {
          for (var e = this.getAllBlocks(!1), t = e.length - 1; 0 <= t; t--)
            e[t].queueRender();
          if (this.currentGesture_)
            for (e = this.currentGesture_.getInsertionMarkers(), t = 0; t < e.length; t++)
              e[t].render(!1);
          this.markerManager.updateMarkers();
        }
        highlightBlock(e, t) {
          if (t === void 0) {
            for (let n = 0, o; o = this.highlightedBlocks[n]; n++)
              o.setHighlighted(!1);
            this.highlightedBlocks.length = 0;
          }
          (e = e ? this.getBlockById(e) : null) && ((t = t === void 0 || t) ? this.highlightedBlocks.indexOf(e) === -1 && this.highlightedBlocks.push(e) : cn(this.highlightedBlocks, e), e.setHighlighted(t));
        }
        paste(e) {
          if (!this.rendered || !e.type && !e.tagName)
            return null;
          this.currentGesture_ && this.currentGesture_.cancel();
          const t = r.getGroup$$module$build$src$core$events$utils();
          t || r.setGroup$$module$build$src$core$events$utils(!0);
          let n;
          try {
            n = e.type ? this.pasteBlock_(null, e) : e.tagName.toLowerCase() === "comment" ? this.pasteWorkspaceComment_(e) : this.pasteBlock_(e, null);
          } finally {
            r.setGroup$$module$build$src$core$events$utils(t);
          }
          return n;
        }
        pasteBlock_(e, t) {
          r.disable$$module$build$src$core$events$utils();
          let n;
          try {
            let o = 0, c = 0;
            if (e) {
              n = r.domToBlock$$module$build$src$core$xml(e, this);
              let A;
              o = parseInt((A = e.getAttribute("x")) != null ? A : "0"), this.RTL && (o = -o);
              let D;
              c = parseInt((D = e.getAttribute("y")) != null ? D : "0");
            } else
              t && (n = k_(t, this), o = t.x || 10, this.RTL && (o = this.getWidth() - o), c = t.y || 10);
            if (!isNaN(o) && !isNaN(c)) {
              let A;
              do {
                A = !1;
                const D = this.getAllBlocks(!1);
                for (let $ = 0, q; q = D[$]; $++) {
                  const De = q.getRelativeToSurfaceXY();
                  if (1 >= Math.abs(o - De.x) && 1 >= Math.abs(c - De.y)) {
                    A = !0;
                    break;
                  }
                }
                if (!A) {
                  const $ = n.getConnections_(!1);
                  for (let q = 0, De; De = $[q]; q++)
                    if (De.closest(r.config$$module$build$src$core$config.snapRadius, new ae(o, c)).connection) {
                      A = !0;
                      break;
                    }
                }
                A && (o = this.RTL ? o - r.config$$module$build$src$core$config.snapRadius : o + r.config$$module$build$src$core$config.snapRadius, c += 2 * r.config$$module$build$src$core$config.snapRadius);
              } while (A);
              n.moveTo(new ae(
                o,
                c
              ));
            }
          } finally {
            r.enable$$module$build$src$core$events$utils();
          }
          return tt() && !n.isShadow() && fe(new (ge(r.CREATE$$module$build$src$core$events$utils))(n)), n.select(), n;
        }
        pasteWorkspaceComment_(e) {
          r.disable$$module$build$src$core$events$utils();
          let t;
          try {
            t = yr.fromXmlRendered(e, this);
            let n, o = parseInt((n = e.getAttribute("x")) != null ? n : "0"), c, A = parseInt((c = e.getAttribute("y")) != null ? c : "0");
            isNaN(o) || isNaN(A) || (this.RTL && (o = -o), t.moveBy(o + 50, A + 50));
          } finally {
            r.enable$$module$build$src$core$events$utils();
          }
          return tt() && U_.fireCreateEvent(t), t.select(), t;
        }
        refreshToolboxSelection() {
          const e = this.isFlyout ? this.targetWorkspace : this;
          e && !e.currentGesture_ && e.toolbox_ && e.toolbox_.getFlyout() && e.toolbox_.refreshSelection();
        }
        renameVariableById(e, t) {
          super.renameVariableById(e, t), this.refreshToolboxSelection();
        }
        deleteVariableById(e) {
          super.deleteVariableById(e), this.refreshToolboxSelection();
        }
        createVariable(e, t, n) {
          return e = super.createVariable(e, t, n), this.refreshToolboxSelection(), e;
        }
        recordDragTargets() {
          const e = this.componentManager.getComponents(Lt.Capability.DRAG_TARGET, !0);
          this.dragTargetAreas = [];
          for (let t = 0, n; n = e[t]; t++) {
            const o = n.getClientRect();
            o && this.dragTargetAreas.push({
              component: n,
              clientRect: o
            });
          }
        }
        newBlock(e, t) {
          throw Error("The implementation of newBlock should be monkey-patched in by blockly.ts");
        }
        getDragTarget(e) {
          for (let t = 0, n; n = this.dragTargetAreas[t]; t++)
            if (n.clientRect.contains(e.clientX, e.clientY))
              return n.component;
          return null;
        }
        onMouseDown_(e) {
          const t = this.getGesture(e);
          t && t.handleWsStart(e, this);
        }
        startDrag(e, t) {
          e = Oo(e, this.getParentSvg(), this.getInverseScreenCTM()), e.x /= this.scale, e.y /= this.scale, this.dragDeltaXY = ae.difference(
            t,
            e
          );
        }
        moveDrag(e) {
          return e = Oo(e, this.getParentSvg(), this.getInverseScreenCTM()), e.x /= this.scale, e.y /= this.scale, ae.sum(this.dragDeltaXY, e);
        }
        isDragging() {
          return this.currentGesture_ !== null && this.currentGesture_.isDragging();
        }
        isDraggable() {
          return this.options.moveOptions && this.options.moveOptions.drag;
        }
        isMovable() {
          return this.options.moveOptions && !!this.options.moveOptions.scrollbars || this.options.moveOptions && this.options.moveOptions.wheel || this.options.moveOptions && this.options.moveOptions.drag || this.options.zoomOptions && this.options.zoomOptions.wheel || this.options.zoomOptions && this.options.zoomOptions.pinch;
        }
        isMovableHorizontally() {
          const e = !!this.scrollbar;
          return this.isMovable() && (!e || e && this.scrollbar.canScrollHorizontally());
        }
        isMovableVertically() {
          const e = !!this.scrollbar;
          return this.isMovable() && (!e || e && this.scrollbar.canScrollVertically());
        }
        onMouseWheel_(e) {
          if (yi.inProgress())
            e.preventDefault(), e.stopPropagation();
          else {
            var t = this.options.zoomOptions && this.options.zoomOptions.wheel, n = this.options.moveOptions && this.options.moveOptions.wheel;
            if (t || n) {
              var o = kT(e);
              if (Rr)
                var c = e.metaKey;
              t && (e.ctrlKey || c || !n) ? (o = -o.y / 50, t = Oo(e, this.getParentSvg(), this.getInverseScreenCTM()), this.zoom(t.x, t.y, o)) : (t = this.scrollX - o.x, n = this.scrollY - o.y, e.shiftKey && !o.x && (t = this.scrollX - o.y, n = this.scrollY), this.scroll(t, n)), e.preventDefault();
            }
          }
        }
        getBlocksBoundingBox() {
          const e = this.getTopBoundedElements();
          if (!e.length)
            return new Dt(0, 0, 0, 0);
          const t = e[0].getBoundingRectangle();
          for (let o = 1; o < e.length; o++) {
            var n = e[o];
            n.isInsertionMarker && n.isInsertionMarker() || (n = n.getBoundingRectangle(), n.top < t.top && (t.top = n.top), n.bottom > t.bottom && (t.bottom = n.bottom), n.left < t.left && (t.left = n.left), n.right > t.right && (t.right = n.right));
          }
          return t;
        }
        cleanUp() {
          this.setResizesEnabled(!1), r.setGroup$$module$build$src$core$events$utils(!0);
          const e = this.getTopBlocks(!0);
          let t = 0;
          for (let n = 0, o; o = e[n]; n++) {
            if (!o.isMovable())
              continue;
            const c = o.getRelativeToSurfaceXY();
            o.moveBy(-c.x, t - c.y, ["cleanup"]), o.snapToGrid(), t = o.getRelativeToSurfaceXY().y + o.getHeightWidth().height + this.renderer.getConstants().MIN_BLOCK_HEIGHT;
          }
          r.setGroup$$module$build$src$core$events$utils(!1), this.setResizesEnabled(!0);
        }
        showContextMenu(e) {
          if (!this.options.readOnly && !this.isFlyout) {
            var t = ct.registry.getContextMenuOptions(
              ct.ScopeType.WORKSPACE,
              { workspace: this }
            );
            this.configureContextMenu && this.configureContextMenu(t, e), Cn(e, t, this.RTL);
          }
        }
        updateToolbox(e) {
          if (e = ga(e)) {
            if (!this.options.languageTree)
              throw Error("Existing toolbox is null.  Can't create new toolbox.");
            if (Uo(e)) {
              if (!this.toolbox_)
                throw Error("Existing toolbox has no categories.  Can't change mode.");
              this.options.languageTree = e, this.toolbox_.render(e);
            } else {
              if (!this.flyout)
                throw Error("Existing toolbox has categories.  Can't change mode.");
              this.options.languageTree = e, this.flyout.show(e);
            }
          } else if (this.options.languageTree)
            throw Error("Can't nullify an existing toolbox.");
        }
        markFocused() {
          this.options.parentWorkspace ? this.options.parentWorkspace.markFocused() : (Le(this), this.getParentSvg().focus({ preventScroll: !0 }));
        }
        zoom(e, t, n) {
          n = Math.pow(this.options.zoomOptions.scaleSpeed, n);
          const o = this.scale * n;
          if (this.scale !== o) {
            o > this.options.zoomOptions.maxScale ? n = this.options.zoomOptions.maxScale / this.scale : o < this.options.zoomOptions.minScale && (n = this.options.zoomOptions.minScale / this.scale);
            var c = this.getCanvas().getCTM(), A = this.getParentSvg().createSVGPoint();
            A.x = e, A.y = t, A = A.matrixTransform(c.inverse()), e = A.x, t = A.y, c = c.translate(e * (1 - n), t * (1 - n)).scale(n), this.scrollX = c.e, this.scrollY = c.f, this.setScale(o);
          }
        }
        zoomCenter(e) {
          var t = this.getMetrics();
          let n;
          this.flyout ? (n = t.svgWidth ? t.svgWidth / 2 : 0, t = t.svgHeight ? t.svgHeight / 2 : 0) : (n = t.viewWidth / 2 + t.absoluteLeft, t = t.viewHeight / 2 + t.absoluteTop), this.zoom(n, t, e);
        }
        zoomToFit() {
          if (this.isMovable()) {
            var e = this.getMetrics(), t = e.viewWidth;
            e = e.viewHeight;
            var n = this.getBlocksBoundingBox(), o = 2 * xS, c = n.right - n.left + o;
            if (n = n.bottom - n.top + o, c) {
              this.flyout && (this.horizontalLayout ? (e += this.flyout.getHeight(), n += this.flyout.getHeight() / this.scale) : (t += this.flyout.getWidth(), c += this.flyout.getWidth() / this.scale)), t /= c, e /= n, r.disable$$module$build$src$core$events$utils();
              try {
                this.setScale(Math.min(t, e)), this.scrollCenter();
              } finally {
                r.enable$$module$build$src$core$events$utils();
              }
              this.maybeFireViewportChangeEvent();
            }
          } else
            console.warn("Tried to move a non-movable workspace. This could result in blocks becoming inaccessible.");
        }
        beginCanvasTransition() {
          be(
            this.svgBlockCanvas_,
            "blocklyCanvasTransitioning"
          ), be(this.svgBubbleCanvas_, "blocklyCanvasTransitioning");
        }
        endCanvasTransition() {
          Be(this.svgBlockCanvas_, "blocklyCanvasTransitioning"), Be(this.svgBubbleCanvas_, "blocklyCanvasTransitioning");
        }
        scrollCenter() {
          if (this.isMovable()) {
            var e = this.getMetrics(), t = (e.scrollWidth - e.viewWidth) / 2, n = (e.scrollHeight - e.viewHeight) / 2;
            t = -t - e.scrollLeft, n = -n - e.scrollTop, this.scroll(
              t,
              n
            );
          } else
            console.warn("Tried to move a non-movable workspace. This could result in blocks becoming inaccessible.");
        }
        centerOnBlock(e, t) {
          if (this.isMovable()) {
            var n = e ? this.getBlockById(e) : null;
            if (n) {
              e = n.getRelativeToSurfaceXY(), n = t ? { height: n.height, width: n.width } : n.getHeightWidth();
              var o = this.scale;
              t = (e.x + (this.RTL ? -1 : 1) * n.width / 2) * o, e = (e.y + n.height / 2) * o, n = this.getMetrics(), this.scroll(-(t - n.viewWidth / 2), -(e - n.viewHeight / 2));
            }
          } else
            console.warn("Tried to move a non-movable workspace. This could result in blocks becoming inaccessible.");
        }
        setScale(e) {
          this.options.zoomOptions.maxScale && e > this.options.zoomOptions.maxScale ? e = this.options.zoomOptions.maxScale : this.options.zoomOptions.minScale && e < this.options.zoomOptions.minScale && (e = this.options.zoomOptions.minScale), this.scale = e, this.hideChaff(!1), (e = this.getFlyout(!1)) && e.isVisible() && (e.reflow(), this.recordDragTargets()), this.grid && this.grid.update(this.scale), e = this.getMetrics(), this.scrollX -= e.absoluteLeft, this.scrollY -= e.absoluteTop, e.viewLeft += e.absoluteLeft, e.viewTop += e.absoluteTop, this.scroll(this.scrollX, this.scrollY), this.scrollbar && (this.flyout ? this.scrollbar.resizeView(e) : this.scrollbar.resizeContent(e));
        }
        getScale() {
          return this.options.parentWorkspace ? this.options.parentWorkspace.getScale() : this.scale;
        }
        scroll(e, t) {
          this.hideChaff(!0);
          const n = this.getMetrics();
          e = Math.min(e, -n.scrollLeft), t = Math.min(t, -n.scrollTop);
          const o = n.scrollTop + Math.max(0, n.scrollHeight - n.viewHeight);
          e = Math.max(e, -(n.scrollLeft + Math.max(0, n.scrollWidth - n.viewWidth))), t = Math.max(t, -o), this.scrollX = e, this.scrollY = t, this.scrollbar && this.scrollbar.set(
            -(e + n.scrollLeft),
            -(t + n.scrollTop),
            !1
          ), e += n.absoluteLeft, t += n.absoluteTop, this.translate(e, t);
        }
        getBlockById(e) {
          return super.getBlockById(e);
        }
        getAllBlocks(e) {
          return super.getAllBlocks(e);
        }
        getTopBlocks(e) {
          return super.getTopBlocks(e);
        }
        addTopBlock(e) {
          this.addTopBoundedElement(e), super.addTopBlock(e);
        }
        removeTopBlock(e) {
          this.removeTopBoundedElement(e), super.removeTopBlock(e);
        }
        addTopComment(e) {
          this.addTopBoundedElement(e), super.addTopComment(e);
        }
        removeTopComment(e) {
          this.removeTopBoundedElement(e), super.removeTopComment(e);
        }
        getRootWorkspace() {
          return super.getRootWorkspace();
        }
        addTopBoundedElement(e) {
          this.topBoundedElements.push(e);
        }
        removeTopBoundedElement(e) {
          cn(
            this.topBoundedElements,
            e
          );
        }
        getTopBoundedElements() {
          return [].concat(this.topBoundedElements);
        }
        setResizesEnabled(e) {
          const t = !this.resizesEnabled && e;
          this.resizesEnabled = e, t && this.resizeContents();
        }
        clear() {
          this.setResizesEnabled(!1), super.clear(), this.topBoundedElements = [], this.setResizesEnabled(!0);
        }
        registerButtonCallback(e, t) {
          if (typeof t != "function")
            throw TypeError("Button callbacks must be functions.");
          this.flyoutButtonCallbacks.set(e, t);
        }
        getButtonCallback(e) {
          let t;
          return (t = this.flyoutButtonCallbacks.get(e)) != null ? t : null;
        }
        removeButtonCallback(e) {
          this.flyoutButtonCallbacks.delete(e);
        }
        registerToolboxCategoryCallback(e, t) {
          if (typeof t != "function")
            throw TypeError("Toolbox category callbacks must be functions.");
          this.toolboxCategoryCallbacks.set(e, t);
        }
        getToolboxCategoryCallback(e) {
          return this.toolboxCategoryCallbacks.get(e) || null;
        }
        removeToolboxCategoryCallback(e) {
          this.toolboxCategoryCallbacks.delete(e);
        }
        getGesture(e) {
          const t = e.type === "pointerdown", n = this.currentGesture_;
          return n ? t && n.hasStarted() ? (console.warn("Tried to start the same gesture twice."), n.cancel(), null) : n : t ? this.currentGesture_ = new yi(
            e,
            this
          ) : null;
        }
        clearGesture() {
          this.currentGesture_ = null;
        }
        cancelCurrentGesture() {
          this.currentGesture_ && this.currentGesture_.cancel();
        }
        getAudioManager() {
          return this.audioManager;
        }
        getGrid() {
          return this.grid;
        }
        hideChaff(e = !1) {
          ui(), J(), a_(), this.hideComponents(e);
        }
        hideComponents(e = !1) {
          this.getComponentManager().getComponents(
            Lt.Capability.AUTOHIDEABLE,
            !0
          ).forEach((t) => t.autoHide(e));
        }
        static setTopLevelWorkspaceMetrics_(e) {
          const t = this.getMetrics();
          typeof e.x == "number" && (this.scrollX = -(t.scrollLeft + (t.scrollWidth - t.viewWidth) * e.x)), typeof e.y == "number" && (this.scrollY = -(t.scrollTop + (t.scrollHeight - t.viewHeight) * e.y)), this.translate(this.scrollX + t.absoluteLeft, this.scrollY + t.absoluteTop);
        }
      }, Ns;
      (function(e) {
        e.BLOCK = "block", e.BUTTON = "button";
      })(Ns || (Ns = {}));
      var Uc = class extends kc {
        constructor(e) {
          super(), this.horizontalLayout = !1, this.boundEvents = [], this.filterWrapper = this.reflowWrapper = null, this.mats = [], this.buttons_ = [], this.listeners = [], this.permanentlyDisabled = [], this.recycledBlocks = [], this.autoClose = !0, this.isVisible_ = !1, this.containerVisible = !0, this.CORNER_RADIUS = 8, this.SCROLLBAR_MARGIN = 2.5, this.height_ = this.width_ = 0, this.dragAngleRange_ = 70, this.svgGroup_ = this.svgBackground_ = null, e.setMetrics = this.setMetrics_.bind(this), this.workspace_ = new g_(e), this.workspace_.setMetricsManager(new yd(this.workspace_, this)), this.workspace_.internalIsFlyout = !0, this.workspace_.setVisible(this.isVisible_), this.id = Gr(), this.RTL = !!e.RTL, this.toolboxPosition_ = e.toolboxPosition, this.tabWidth_ = this.workspace_.getRenderer().getConstants().TAB_WIDTH, this.rectMap_ = /* @__PURE__ */ new WeakMap(), this.MARGIN = this.CORNER_RADIUS, this.GAP_X = 3 * this.MARGIN, this.GAP_Y = 3 * this.MARGIN;
        }
        createDom(e) {
          return this.svgGroup_ = K(e, { class: "blocklyFlyout", style: "display: none" }), this.svgBackground_ = K(U.PATH, { class: "blocklyFlyoutBackground" }, this.svgGroup_), this.svgGroup_.appendChild(this.workspace_.createDom()), this.workspace_.getThemeManager().subscribe(
            this.svgBackground_,
            "flyoutBackgroundColour",
            "fill"
          ), this.workspace_.getThemeManager().subscribe(this.svgBackground_, "flyoutOpacity", "fill-opacity"), this.svgGroup_;
        }
        init(e) {
          this.targetWorkspace = e, this.workspace_.targetWorkspace = e, this.workspace_.scrollbar = new DE(this.workspace_, this.horizontalLayout, !this.horizontalLayout, "blocklyFlyoutScrollbar", this.SCROLLBAR_MARGIN), this.hide(), this.boundEvents.push(Pe(
            this.svgGroup_,
            "wheel",
            this,
            this.wheel_
          )), this.autoClose || (this.filterWrapper = this.filterForCapacity.bind(this), this.targetWorkspace.addChangeListener(this.filterWrapper)), this.boundEvents.push(Pe(this.svgBackground_, "pointerdown", this, this.onMouseDown)), this.workspace_.getGesture = this.targetWorkspace.getGesture.bind(this.targetWorkspace), this.workspace_.setVariableMap(this.targetWorkspace.getVariableMap()), this.workspace_.createPotentialVariableMap(), e.getComponentManager().addComponent({
            component: this,
            weight: 1,
            capabilities: [Lt.Capability.DELETE_AREA, Lt.Capability.DRAG_TARGET]
          });
        }
        dispose() {
          this.hide(), this.workspace_.getComponentManager().removeComponent(this.id);
          for (const e of this.boundEvents)
            It(e);
          this.boundEvents.length = 0, this.filterWrapper && this.targetWorkspace.removeChangeListener(this.filterWrapper), this.workspace_ && (this.workspace_.getThemeManager().unsubscribe(this.svgBackground_), this.workspace_.dispose()), this.svgGroup_ && Tt(this.svgGroup_);
        }
        getWidth() {
          return this.width_;
        }
        getHeight() {
          return this.height_;
        }
        getFlyoutScale() {
          return this.targetWorkspace.scale;
        }
        getWorkspace() {
          return this.workspace_;
        }
        isVisible() {
          return this.isVisible_;
        }
        setVisible(e) {
          const t = e !== this.isVisible();
          this.isVisible_ = e, t && (this.autoClose || this.workspace_.recordDragTargets(), this.updateDisplay());
        }
        setContainerVisible(e) {
          const t = e !== this.containerVisible;
          this.containerVisible = e, t && this.updateDisplay();
        }
        updateDisplay() {
          let e;
          e = this.containerVisible ? this.isVisible() : !1, this.svgGroup_ && (this.svgGroup_.style.display = e ? "block" : "none");
          let t;
          (t = this.workspace_.scrollbar) == null || t.setContainerVisible(e);
        }
        positionAt_(e, t, n, o) {
          let c;
          (c = this.svgGroup_) == null || c.setAttribute("width", `${e}`);
          let A;
          (A = this.svgGroup_) == null || A.setAttribute("height", `${t}`), this.workspace_.setCachedParentSvgSize(e, t), this.svgGroup_ && C_(this.svgGroup_, "translate(" + n + "px," + o + "px)"), (e = this.workspace_.scrollbar) && (e.setOrigin(n, o), e.resize(), e.hScroll && e.hScroll.setPosition(e.hScroll.position.x, e.hScroll.position.y), e.vScroll && e.vScroll.setPosition(e.vScroll.position.x, e.vScroll.position.y));
        }
        hide() {
          if (this.isVisible()) {
            this.setVisible(!1);
            for (const e of this.listeners)
              It(e);
            this.listeners.length = 0, this.reflowWrapper && (this.workspace_.removeChangeListener(this.reflowWrapper), this.reflowWrapper = null);
          }
        }
        show(e) {
          this.workspace_.setResizesEnabled(!1), this.hide(), this.clearOldBlocks(), typeof e == "string" && (e = this.getDynamicCategoryContents(e)), this.setVisible(!0), e = Zs(e), e = this.createFlyoutInfo(e), this.layout_(e.contents, e.gaps), this.horizontalLayout ? this.height_ = 0 : this.width_ = 0, this.workspace_.setResizesEnabled(!0), this.reflow(), this.filterForCapacity(), this.position(), this.reflowWrapper = this.reflow.bind(this), this.workspace_.addChangeListener(this.reflowWrapper), this.emptyRecycledBlocks();
        }
        createFlyoutInfo(e) {
          const t = [], n = [];
          this.permanentlyDisabled.length = 0;
          const o = this.horizontalLayout ? this.GAP_X : this.GAP_Y;
          for (const c of e) {
            if ("custom" in c) {
              e = this.getDynamicCategoryContents(c.custom), e = Zs(e);
              const { contents: A, gaps: D } = this.createFlyoutInfo(e);
              t.push(...A), n.push(...D);
            }
            switch (c.kind.toUpperCase()) {
              case "BLOCK":
                e = c;
                const A = this.createFlyoutBlock(e);
                t.push({ type: Ns.BLOCK, block: A }), this.addBlockGap(e, n, o);
                break;
              case "SEP":
                this.addSeparatorGap(c, n, o);
                break;
              case "LABEL":
                e = this.createButton(c, !0), t.push({ type: Ns.BUTTON, button: e }), n.push(o);
                break;
              case "BUTTON":
                e = this.createButton(c, !1), t.push({ type: Ns.BUTTON, button: e }), n.push(o);
            }
          }
          return { contents: t, gaps: n };
        }
        getDynamicCategoryContents(e) {
          if (e = this.workspace_.targetWorkspace.getToolboxCategoryCallback(e), typeof e != "function")
            throw TypeError("Couldn't find a callback function when opening a toolbox category.");
          return e(this.workspace_.targetWorkspace);
        }
        createButton(e, t) {
          return new D_(this.workspace_, this.targetWorkspace, e, t);
        }
        createFlyoutBlock(e) {
          let t;
          return e.blockxml ? (e = typeof e.blockxml == "string" ? r.textToDom$$module$build$src$core$utils$xml(e.blockxml) : e.blockxml, (t = this.getRecycledBlock(e.getAttribute("type"))) || (t = r.domToBlock$$module$build$src$core$xml(e, this.workspace_))) : (t = this.getRecycledBlock(e.type), t || (e.enabled === void 0 && (e.enabled = e.disabled !== "true" && e.disabled !== !0), t = k_(e, this.workspace_))), t.isEnabled() || this.permanentlyDisabled.push(t), t;
        }
        getRecycledBlock(e) {
          let t = -1;
          for (let n = 0; n < this.recycledBlocks.length; n++)
            if (this.recycledBlocks[n].type === e) {
              t = n;
              break;
            }
          return t === -1 ? void 0 : this.recycledBlocks.splice(t, 1)[0];
        }
        addBlockGap(e, t, n) {
          let o;
          e.gap ? o = parseInt(String(e.gap)) : e.blockxml && (e = typeof e.blockxml == "string" ? r.textToDom$$module$build$src$core$utils$xml(e.blockxml) : e.blockxml, o = parseInt(e.getAttribute("gap"))), t.push(!o || isNaN(o) ? n : o);
        }
        addSeparatorGap(e, t, n) {
          e = parseInt(String(e.gap)), !isNaN(e) && 0 < t.length ? t[t.length - 1] = e : t.push(n);
        }
        clearOldBlocks() {
          var e = this.workspace_.getTopBlocks(!1);
          for (let n = 0, o; o = e[n]; n++)
            this.blockIsRecyclable_(o) ? this.recycleBlock(o) : o.dispose(!1, !1);
          for (e = 0; e < this.mats.length; e++) {
            const n = this.mats[e];
            n && (Jr(n), Tt(n));
          }
          this.mats.length = 0;
          for (let n = 0, o; o = this.buttons_[n]; n++)
            o.dispose();
          this.buttons_.length = 0;
          let t;
          (t = this.workspace_.getPotentialVariableMap()) == null || t.clear();
        }
        emptyRecycledBlocks() {
          for (let e = 0; e < this.recycledBlocks.length; e++)
            this.recycledBlocks[e].dispose();
          this.recycledBlocks = [];
        }
        blockIsRecyclable_(e) {
          return !1;
        }
        recycleBlock(e) {
          const t = e.getRelativeToSurfaceXY();
          e.moveBy(-t.x, -t.y), this.recycledBlocks.push(e);
        }
        addBlockListeners_(e, t, n) {
          this.listeners.push(Pe(e, "pointerdown", null, this.blockMouseDown(t))), this.listeners.push(Pe(
            n,
            "pointerdown",
            null,
            this.blockMouseDown(t)
          )), this.listeners.push(hr(e, "pointerenter", t, t.addSelect)), this.listeners.push(hr(e, "pointerleave", t, t.removeSelect)), this.listeners.push(hr(n, "pointerenter", t, t.addSelect)), this.listeners.push(hr(n, "pointerleave", t, t.removeSelect));
        }
        blockMouseDown(e) {
          return (t) => {
            const n = this.targetWorkspace.getGesture(t);
            n && (n.setStartBlock(e), n.handleFlyoutStart(t, this));
          };
        }
        onMouseDown(e) {
          const t = this.targetWorkspace.getGesture(e);
          t && t.handleFlyoutStart(e, this);
        }
        isBlockCreatable(e) {
          return e.isEnabled();
        }
        createBlock(e) {
          let t = null;
          r.disable$$module$build$src$core$events$utils();
          var n = this.targetWorkspace.getAllVariables();
          this.targetWorkspace.setResizesEnabled(!1);
          try {
            t = this.placeNewBlock(e);
          } finally {
            r.enable$$module$build$src$core$events$utils();
          }
          if (this.targetWorkspace.hideChaff(), e = W(
            this.targetWorkspace,
            n
          ), tt()) {
            for (r.setGroup$$module$build$src$core$events$utils(!0), n = 0; n < e.length; n++) {
              const o = e[n];
              fe(new (ge(mi))(o));
            }
            fe(new (ge(r.CREATE$$module$build$src$core$events$utils))(t));
          }
          return this.autoClose ? this.hide() : this.filterForCapacity(), t;
        }
        initFlyoutButton_(e, t, n) {
          const o = e.createDom();
          e.moveTo(t, n), e.show(), this.listeners.push(Pe(o, "pointerdown", this, this.onMouseDown)), this.buttons_.push(e);
        }
        createRect_(e, t, n, o, c) {
          return t = K(U.RECT, { "fill-opacity": 0, x: t, y: n, height: o.height, width: o.width }), t.tooltip = e, UT(t), this.workspace_.getCanvas().insertBefore(t, e.getSvgRoot()), this.rectMap_.set(e, t), this.mats[c] = t;
        }
        moveRectToBlock_(e, t) {
          const n = t.getHeightWidth();
          e.setAttribute("width", String(n.width)), e.setAttribute("height", String(n.height)), t = t.getRelativeToSurfaceXY(), e.setAttribute("y", String(t.y)), e.setAttribute("x", String(this.RTL ? t.x - n.width : t.x));
        }
        filterForCapacity() {
          const e = this.workspace_.getTopBlocks(!1);
          for (let t = 0, n; n = e[t]; t++)
            if (this.permanentlyDisabled.indexOf(n) === -1) {
              const o = this.targetWorkspace.isCapacityAvailable(Rt(n));
              for (; n; )
                n.setEnabled(o), n = n.getNextBlock();
            }
        }
        reflow() {
          this.reflowWrapper && this.workspace_.removeChangeListener(this.reflowWrapper), this.reflowInternal_(), this.reflowWrapper && this.workspace_.addChangeListener(this.reflowWrapper);
        }
        isScrollable() {
          return this.workspace_.scrollbar ? this.workspace_.scrollbar.isVisible() : !1;
        }
        placeNewBlock(e) {
          var t = this.targetWorkspace;
          if (!e.getSvgRoot())
            throw Error("oldBlock is not rendered");
          const n = l_(e);
          return t.setResizesEnabled(!1), t = k_(
            n,
            t
          ), this.positionNewBlock(e, t), t;
        }
        positionNewBlock(e, t) {
          const n = this.targetWorkspace;
          var o = n.getOriginOffsetInPixels(), c = this.workspace_.getOriginOffsetInPixels();
          e = e.getRelativeToSurfaceXY(), e.scale(this.workspace_.scale), c = ae.sum(c, e), o = ae.difference(c, o), o.scale(1 / n.scale), t.moveTo(new ae(o.x, o.y));
        }
      };
      Uc.FlyoutItemType = Ns;
      var Vc = class extends Uc {
        constructor(e) {
          super(e), this.horizontalLayout = !0;
        }
        setMetrics_(e) {
          if (this.isVisible()) {
            var t = this.workspace_.getMetricsManager(), n = t.getScrollMetrics(), o = t.getViewMetrics();
            t = t.getAbsoluteMetrics(), typeof e.x == "number" && (this.workspace_.scrollX = -(n.left + (n.width - o.width) * e.x)), this.workspace_.translate(this.workspace_.scrollX + t.left, this.workspace_.scrollY + t.top);
          }
        }
        getX() {
          return 0;
        }
        getY() {
          if (!this.isVisible())
            return 0;
          var e = this.targetWorkspace.getMetricsManager();
          const t = e.getAbsoluteMetrics(), n = e.getViewMetrics();
          e = e.getToolboxMetrics();
          const o = this.toolboxPosition_ === Ue.TOP;
          return this.targetWorkspace.toolboxPosition === this.toolboxPosition_ ? this.targetWorkspace.getToolbox() ? o ? e.height : n.height - this.height_ : o ? 0 : n.height : o ? 0 : n.height + t.top - this.height_;
        }
        position() {
          if (this.isVisible() && this.targetWorkspace.isVisible()) {
            var e = this.targetWorkspace.getMetricsManager().getViewMetrics();
            this.width_ = e.width, this.setBackgroundPath(e.width - 2 * this.CORNER_RADIUS, this.height_ - this.CORNER_RADIUS), e = this.getX();
            var t = this.getY();
            this.positionAt_(this.width_, this.height_, e, t);
          }
        }
        setBackgroundPath(e, t) {
          const n = this.toolboxPosition_ === Ue.TOP, o = ["M 0," + (n ? 0 : this.CORNER_RADIUS)];
          n ? (o.push("h", e + 2 * this.CORNER_RADIUS), o.push("v", t), o.push("a", this.CORNER_RADIUS, this.CORNER_RADIUS, 0, 0, 1, -this.CORNER_RADIUS, this.CORNER_RADIUS), o.push("h", -e), o.push(
            "a",
            this.CORNER_RADIUS,
            this.CORNER_RADIUS,
            0,
            0,
            1,
            -this.CORNER_RADIUS,
            -this.CORNER_RADIUS
          )) : (o.push("a", this.CORNER_RADIUS, this.CORNER_RADIUS, 0, 0, 1, this.CORNER_RADIUS, -this.CORNER_RADIUS), o.push("h", e), o.push("a", this.CORNER_RADIUS, this.CORNER_RADIUS, 0, 0, 1, this.CORNER_RADIUS, this.CORNER_RADIUS), o.push("v", t), o.push("h", -e - 2 * this.CORNER_RADIUS)), o.push("z"), this.svgBackground_.setAttribute("d", o.join(" "));
        }
        scrollToStart() {
          let e;
          (e = this.workspace_.scrollbar) == null || e.setX(this.RTL ? 1 / 0 : 0);
        }
        wheel_(e) {
          var t = kT(e);
          if (t = t.x || t.y) {
            const n = this.workspace_.getMetricsManager(), o = n.getScrollMetrics();
            t = n.getViewMetrics().left - o.left + t;
            let c;
            (c = this.workspace_.scrollbar) == null || c.setX(t), J(), a_();
          }
          e.preventDefault(), e.stopPropagation();
        }
        layout_(e, t) {
          this.workspace_.scale = this.targetWorkspace.scale;
          const n = this.MARGIN;
          let o = n + this.tabWidth_;
          this.RTL && (e = e.reverse());
          for (let $ = 0, q; q = e[$]; $++)
            if (q.type === "block") {
              var c = q.block, A = c.getDescendants(!1);
              for (let or = 0, Ft; Ft = A[or]; or++)
                Ft.isInFlyout = !0;
              A = c.getSvgRoot();
              const De = c.getHeightWidth();
              var D = c.outputConnection ? this.tabWidth_ : 0;
              D = this.RTL ? o + De.width : o - D, c.moveBy(D, n), D = this.createRect_(c, D, n, De, $), o += De.width + t[$], this.addBlockListeners_(A, c, D);
            } else
              q.type === "button" && (c = q.button, this.initFlyoutButton_(c, o, n), o += c.width + t[$]);
        }
        isDragTowardWorkspace(e) {
          e = Math.atan2(e.y, e.x) / Math.PI * 180;
          const t = this.dragAngleRange_;
          return e < 90 + t && e > 90 - t || e > -90 - t && e < -90 + t;
        }
        getClientRect() {
          if (!this.svgGroup_ || this.autoClose || !this.isVisible())
            return null;
          const e = this.svgGroup_.getBoundingClientRect(), t = e.top;
          return this.toolboxPosition_ === Ue.TOP ? new Dt(-1e9, t + e.height, -1e9, 1e9) : new Dt(t, 1e9, -1e9, 1e9);
        }
        reflowInternal_() {
          this.workspace_.scale = this.getFlyoutScale();
          let e = 0;
          const t = this.workspace_.getTopBlocks(!1);
          for (let o = 0, c; c = t[o]; o++)
            e = Math.max(e, c.getHeightWidth().height);
          const n = this.buttons_;
          for (let o = 0, c; c = n[o]; o++)
            e = Math.max(e, c.height);
          if (e += 1.5 * this.MARGIN, e *= this.workspace_.scale, e += Xt.scrollbarThickness, this.height_ !== e) {
            for (let o = 0, c; c = t[o]; o++)
              this.rectMap_.has(c) && this.moveRectToBlock_(this.rectMap_.get(c), c);
            this.targetWorkspace.toolboxPosition !== this.toolboxPosition_ || this.toolboxPosition_ !== Ue.TOP || this.targetWorkspace.getToolbox() || this.targetWorkspace.translate(this.targetWorkspace.scrollX, this.targetWorkspace.scrollY + e), this.height_ = e, this.position(), this.targetWorkspace.recordDragTargets();
          }
        }
      };
      i(se.FLYOUTS_HORIZONTAL_TOOLBOX, w_, Vc);
      var gE = class extends Uc {
        constructor(e) {
          super(e);
        }
        setMetrics_(e) {
          if (this.isVisible()) {
            var t = this.workspace_.getMetricsManager(), n = t.getScrollMetrics(), o = t.getViewMetrics();
            t = t.getAbsoluteMetrics(), typeof e.y == "number" && (this.workspace_.scrollY = -(n.top + (n.height - o.height) * e.y)), this.workspace_.translate(this.workspace_.scrollX + t.left, this.workspace_.scrollY + t.top);
          }
        }
        getX() {
          if (!this.isVisible())
            return 0;
          var e = this.targetWorkspace.getMetricsManager();
          const t = e.getAbsoluteMetrics(), n = e.getViewMetrics();
          return e = e.getToolboxMetrics(), this.targetWorkspace.toolboxPosition === this.toolboxPosition_ ? this.targetWorkspace.getToolbox() ? this.toolboxPosition_ === Ue.LEFT ? e.width : n.width - this.width_ : this.toolboxPosition_ === Ue.LEFT ? 0 : n.width : this.toolboxPosition_ === Ue.LEFT ? 0 : n.width + t.left - this.width_;
        }
        getY() {
          return 0;
        }
        position() {
          if (this.isVisible() && this.targetWorkspace.isVisible()) {
            var e = this.targetWorkspace.getMetricsManager().getViewMetrics();
            this.height_ = e.height, this.setBackgroundPath(this.width_ - this.CORNER_RADIUS, e.height - 2 * this.CORNER_RADIUS), e = this.getX();
            var t = this.getY();
            this.positionAt_(this.width_, this.height_, e, t);
          }
        }
        setBackgroundPath(e, t) {
          const n = this.toolboxPosition_ === Ue.RIGHT;
          var o = e + this.CORNER_RADIUS;
          o = ["M " + (n ? o : 0) + ",0"], o.push("h", n ? -e : e), o.push(
            "a",
            this.CORNER_RADIUS,
            this.CORNER_RADIUS,
            0,
            0,
            n ? 0 : 1,
            n ? -this.CORNER_RADIUS : this.CORNER_RADIUS,
            this.CORNER_RADIUS
          ), o.push("v", Math.max(0, t)), o.push("a", this.CORNER_RADIUS, this.CORNER_RADIUS, 0, 0, n ? 0 : 1, n ? this.CORNER_RADIUS : -this.CORNER_RADIUS, this.CORNER_RADIUS), o.push("h", n ? e : -e), o.push("z"), this.svgBackground_.setAttribute("d", o.join(" "));
        }
        scrollToStart() {
          let e;
          (e = this.workspace_.scrollbar) == null || e.setY(0);
        }
        wheel_(e) {
          var t = kT(e);
          if (t.y) {
            const n = this.workspace_.getMetricsManager(), o = n.getScrollMetrics();
            t = n.getViewMetrics().top - o.top + t.y;
            let c;
            (c = this.workspace_.scrollbar) == null || c.setY(t), J(), a_();
          }
          e.preventDefault(), e.stopPropagation();
        }
        layout_(e, t) {
          this.workspace_.scale = this.targetWorkspace.scale;
          var n = this.MARGIN;
          const o = this.RTL ? n : n + this.tabWidth_;
          for (let $ = 0, q; q = e[$]; $++)
            if (q.type === "block") {
              var c = q.block, A = c.getDescendants(!1);
              for (let or = 0, Ft; Ft = A[or]; or++)
                Ft.isInFlyout = !0;
              A = c.getSvgRoot();
              const De = c.getHeightWidth();
              var D = c.outputConnection ? o - this.tabWidth_ : o;
              c.moveBy(D, n), D = this.createRect_(c, this.RTL ? D - De.width : D, n, De, $), this.addBlockListeners_(A, c, D), n += De.height + t[$];
            } else
              q.type === "button" && (c = q.button, this.initFlyoutButton_(c, o, n), n += c.height + t[$]);
        }
        isDragTowardWorkspace(e) {
          e = Math.atan2(e.y, e.x) / Math.PI * 180;
          const t = this.dragAngleRange_;
          return e < t && e > -t || e < -180 + t || e > 180 - t;
        }
        getClientRect() {
          if (!this.svgGroup_ || this.autoClose || !this.isVisible())
            return null;
          const e = this.svgGroup_.getBoundingClientRect(), t = e.left;
          return this.toolboxPosition_ === Ue.LEFT ? new Dt(-1e9, 1e9, -1e9, t + e.width) : new Dt(-1e9, 1e9, t, 1e9);
        }
        reflowInternal_() {
          this.workspace_.scale = this.getFlyoutScale();
          let e = 0;
          var t = this.workspace_.getTopBlocks(!1);
          for (let o = 0, c; c = t[o]; o++) {
            var n = c.getHeightWidth().width;
            c.outputConnection && (n -= this.tabWidth_), e = Math.max(e, n);
          }
          for (let o = 0, c; c = this.buttons_[o]; o++)
            e = Math.max(e, c.width);
          if (e += 1.5 * this.MARGIN + this.tabWidth_, e *= this.workspace_.scale, e += Xt.scrollbarThickness, this.width_ !== e) {
            for (let o = 0, c; c = t[o]; o++) {
              if (this.RTL) {
                n = c.getRelativeToSurfaceXY().x;
                let A = e / this.workspace_.scale - this.MARGIN;
                c.outputConnection || (A -= this.tabWidth_), c.moveBy(A - n, 0);
              }
              this.rectMap_.has(c) && this.moveRectToBlock_(this.rectMap_.get(c), c);
            }
            if (this.RTL)
              for (let o = 0, c; c = this.buttons_[o]; o++)
                t = c.getPosition().y, c.moveTo(e / this.workspace_.scale - c.width - this.MARGIN - this.tabWidth_, t);
            this.targetWorkspace.toolboxPosition !== this.toolboxPosition_ || this.toolboxPosition_ !== Ue.LEFT || this.targetWorkspace.getToolbox() || this.targetWorkspace.translate(this.targetWorkspace.scrollX + e, this.targetWorkspace.scrollY), this.width_ = e, this.position(), this.targetWorkspace.recordDragTargets();
          }
        }
      };
      gE.registryName = "verticalFlyout", i(se.FLYOUTS_VERTICAL_TOOLBOX, w_, gE);
      var Gc;
      r.CodeGenerator$$module$build$src$core$generator = class {
        constructor(e) {
          this.forBlock = /* @__PURE__ */ Object.create(null), this.FUNCTION_NAME_PLACEHOLDER_ = "{leCUI8hutHZI4480Dc}", this.STATEMENT_SUFFIX = this.STATEMENT_PREFIX = this.INFINITE_LOOP_TRAP = null, this.INDENT = "  ", this.COMMENT_WRAP = 60, this.ORDER_OVERRIDES = [], this.isInitialized = null, this.RESERVED_WORDS_ = "", this.definitions_ = /* @__PURE__ */ Object.create(null), this.functionNames_ = /* @__PURE__ */ Object.create(null), this.nameDB_ = void 0, this.name_ = e, this.FUNCTION_NAME_PLACEHOLDER_REGEXP_ = new RegExp(
            this.FUNCTION_NAME_PLACEHOLDER_,
            "g"
          );
        }
        workspaceToCode(e) {
          e || (console.warn("No workspace specified in workspaceToCode call.  Guessing."), e = Te());
          var t = [];
          this.init(e), e = e.getTopBlocks(!0);
          for (let n = 0, o; o = e[n]; n++) {
            let c = this.blockToCode(o);
            Array.isArray(c) && (c = c[0]), c && (o.outputConnection && (c = this.scrubNakedValue(c), this.STATEMENT_PREFIX && !o.suppressPrefixSuffix && (c = this.injectId(this.STATEMENT_PREFIX, o) + c), this.STATEMENT_SUFFIX && !o.suppressPrefixSuffix && (c += this.injectId(
              this.STATEMENT_SUFFIX,
              o
            ))), t.push(c));
          }
          return t = t.join(`
`), t = this.finish(t), t = t.replace(/^\s+\n/, ""), t = t.replace(/\n\s+$/, `
`), t = t.replace(/[ \t]+\n/g, `
`);
        }
        prefixLines(e, t) {
          return t + e.replace(/(?!\n$)\n/g, `
` + t);
        }
        allNestedComments(e) {
          const t = [];
          e = e.getDescendants(!0);
          for (let n = 0; n < e.length; n++) {
            const o = e[n].getCommentText();
            o && t.push(o);
          }
          return t.length && t.push(""), t.join(`
`);
        }
        blockToCode(e, t) {
          if (this.isInitialized === !1 && console.warn("CodeGenerator init was not called before blockToCode was called."), !e)
            return "";
          if (!e.isEnabled())
            return t ? "" : this.blockToCode(e.getNextBlock());
          if (e.isInsertionMarker())
            return t ? "" : this.blockToCode(e.getChildren(!1)[0]);
          var n = this.forBlock[e.type];
          if (!n && this[e.type] && (dr("block generator functions on CodeGenerator objects", "10.0", "11.0", "the .forBlock[blockType] dictionary"), n = this[e.type]), typeof n != "function")
            throw Error(`${this.name_} generator does not know how to generate codefor block type "${e.type}".`);
          if (n = n.call(e, e, this), Array.isArray(n)) {
            if (!e.outputConnection)
              throw TypeError("Expecting string from statement block: " + e.type);
            return [this.scrub_(e, n[0], t), n[1]];
          }
          if (typeof n == "string")
            return this.STATEMENT_PREFIX && !e.suppressPrefixSuffix && (n = this.injectId(this.STATEMENT_PREFIX, e) + n), this.STATEMENT_SUFFIX && !e.suppressPrefixSuffix && (n += this.injectId(this.STATEMENT_SUFFIX, e)), this.scrub_(e, n, t);
          if (n === null)
            return "";
          throw SyntaxError("Invalid code generated: " + n);
        }
        valueToCode(e, t, n) {
          if (isNaN(n))
            throw TypeError("Expecting valid order from block: " + e.type);
          var o = e.getInputTargetBlock(t);
          if (!o || (t = this.blockToCode(o), t === ""))
            return "";
          if (!Array.isArray(t))
            throw TypeError(`Expecting tuple from value block: ${o.type} See developers.google.com/blockly/guides/create-custom-blocks/generating-code for more information`);
          if (e = t[0], t = t[1], isNaN(t))
            throw TypeError("Expecting valid order from value block: " + o.type);
          if (!e)
            return "";
          o = !1;
          var c = Math.floor(n);
          const A = Math.floor(t);
          if (c <= A && (c !== A || c !== 0 && c !== 99)) {
            for (o = !0, c = 0; c < this.ORDER_OVERRIDES.length; c++)
              if (this.ORDER_OVERRIDES[c][0] === n && this.ORDER_OVERRIDES[c][1] === t) {
                o = !1;
                break;
              }
          }
          return o && (e = "(" + e + ")"), e;
        }
        statementToCode(e, t) {
          if (e = e.getInputTargetBlock(t), t = this.blockToCode(e), typeof t != "string")
            throw TypeError("Expecting code from statement block: " + (e && e.type));
          return t && (t = this.prefixLines(t, this.INDENT)), t;
        }
        addLoopTrap(e, t) {
          return this.INFINITE_LOOP_TRAP && (e = this.prefixLines(this.injectId(this.INFINITE_LOOP_TRAP, t), this.INDENT) + e), this.STATEMENT_SUFFIX && !t.suppressPrefixSuffix && (e = this.prefixLines(this.injectId(this.STATEMENT_SUFFIX, t), this.INDENT) + e), this.STATEMENT_PREFIX && !t.suppressPrefixSuffix && (e += this.prefixLines(this.injectId(this.STATEMENT_PREFIX, t), this.INDENT)), e;
        }
        injectId(e, t) {
          return t = t.id.replace(/\$/g, "$$$$"), e.replace(/%1/g, "'" + t + "'");
        }
        addReservedWords(e) {
          this.RESERVED_WORDS_ += e + ",";
        }
        provideFunction_(e, t) {
          if (!this.definitions_[e]) {
            const n = this.nameDB_.getDistinctName(e, r.NameType$$module$build$src$core$names.PROCEDURE);
            this.functionNames_[e] = n, Array.isArray(t) && (t = t.join(`
`)), t = t.trim().replace(this.FUNCTION_NAME_PLACEHOLDER_REGEXP_, n);
            let o;
            for (; o !== t; )
              o = t, t = t.replace(/^(( {2})*) {2}/gm, "$1\0");
            t = t.replace(/\0/g, this.INDENT), this.definitions_[e] = t;
          }
          return this.functionNames_[e];
        }
        init(e) {
          this.definitions_ = /* @__PURE__ */ Object.create(null), this.functionNames_ = /* @__PURE__ */ Object.create(null);
        }
        scrub_(e, t, n) {
          return t;
        }
        finish(e) {
          return this.definitions_ = /* @__PURE__ */ Object.create(null), this.functionNames_ = /* @__PURE__ */ Object.create(null), e;
        }
        scrubNakedValue(e) {
          return e;
        }
      }, Gc = {}, Gc.CodeGenerator = r.CodeGenerator$$module$build$src$core$generator;
      var Et = class {
        constructor() {
          this.shortcuts = /* @__PURE__ */ new Map(), this.keyMap = /* @__PURE__ */ new Map(), this.reset();
        }
        reset() {
          this.shortcuts.clear(), this.keyMap.clear();
        }
        register(e, t) {
          if (this.shortcuts.get(e.name) && !t)
            throw Error(`Shortcut named "${e.name}" already exists.`);
          if (this.shortcuts.set(e.name, e), (t = e.keyCodes) && 0 < t.length)
            for (let n = 0; n < t.length; n++)
              this.addKeyMapping(t[n], e.name, !!e.allowCollision);
        }
        unregister(e) {
          return this.shortcuts.get(e) ? (this.removeAllKeyMappings(e), this.shortcuts.delete(e), !0) : (console.warn(`Keyboard shortcut named "${e}" not found.`), !1);
        }
        addKeyMapping(e, t, n) {
          e = `${e}`;
          const o = this.keyMap.get(e);
          if (o && !n)
            throw Error(`Shortcut named "${t}" collides with shortcuts "${o}"`);
          o && n ? o.unshift(t) : this.keyMap.set(e, [t]);
        }
        removeKeyMapping(e, t, n) {
          const o = this.keyMap.get(e);
          if (!o)
            return n || console.warn(`No keyboard shortcut named "${t}" registered with key code "${e}"`), !1;
          const c = o.indexOf(t);
          return -1 < c ? (o.splice(c, 1), o.length === 0 && this.keyMap.delete(e), !0) : (n || console.warn(`No keyboard shortcut named "${t}" registered with key code "${e}"`), !1);
        }
        removeAllKeyMappings(e) {
          for (const t of this.keyMap.keys())
            this.removeKeyMapping(t, e, !0);
        }
        setKeyMap(e) {
          this.keyMap.clear();
          for (const t in e)
            this.keyMap.set(t, e[t]);
        }
        getKeyMap() {
          const e = /* @__PURE__ */ Object.create(null);
          for (const [t, n] of this.keyMap)
            e[t] = n;
          return e;
        }
        getRegistry() {
          const e = /* @__PURE__ */ Object.create(null);
          for (const [t, n] of this.shortcuts)
            e[t] = n;
          return Kn(/* @__PURE__ */ Object.create(null), e);
        }
        onKeyDown(e, t) {
          var n = this.serializeKeyEvent_(t);
          if (n = this.getShortcutNamesByKeyCode(n), !n)
            return !1;
          for (let o = 0, c; c = n[o]; o++) {
            const A = this.shortcuts.get(c);
            let D, $;
            if ((D = A) == null || !D.preconditionFn || ($ = A) != null && $.preconditionFn(e)) {
              let q, De;
              if ((q = A) != null && q.callback && ((De = A) != null && De.callback(e, t, A)))
                return !0;
            }
          }
          return !1;
        }
        getShortcutNamesByKeyCode(e) {
          return this.keyMap.get(e) || [];
        }
        getKeyCodesByShortcutName(e) {
          const t = [];
          for (const [n, o] of this.keyMap)
            -1 < o.indexOf(e) && t.push(n);
          return t;
        }
        serializeKeyEvent_(e) {
          let t = "";
          for (const n in Et.modifierKeys)
            e.getModifierState(n) && (t !== "" && (t += "+"), t += n);
          return t !== "" && e.keyCode ? t = t + "+" + e.keyCode : e.keyCode && (t = String(e.keyCode)), t;
        }
        checkModifiers_(e) {
          for (let t = 0, n; n = e[t]; t++)
            if (!(n in Et.modifierKeys))
              throw Error(n + " is not a valid modifier key.");
        }
        createSerializedKey(e, t) {
          let n = "";
          if (t) {
            this.checkModifiers_(t);
            for (const o in Et.modifierKeys)
              -1 < t.indexOf(Et.modifierKeys[o]) && (n !== "" && (n += "+"), n += o);
          }
          return n !== "" && e ? n = n + "+" + e : e && (n = `${e}`), n;
        }
      };
      Et.registry = new Et(), function(e) {
        e = e.modifierKeys || (e.modifierKeys = {}), e[e.Shift = 16] = "Shift", e[e.Control = 17] = "Control", e[e.Alt = 18] = "Alt", e[e.Meta = 91] = "Meta";
      }(Et || (Et = {}));
      var Fd = !1, mT = {};
      mT.Align = r.Align$$module$build$src$core$inputs$align, mT.DummyInput = t_, mT.Input = Oi, mT.StatementInput = Wn, mT.ValueInput = r.ValueInput$$module$build$src$core$inputs$value_input, mT.inputTypes = r.inputTypes$$module$build$src$core$inputs$input_types;
      var wd = class extends Ao {
        constructor() {
          super(), this.FIELD_TEXT_BASELINE_CENTER = !1, this.DARK_PATH_OFFSET = 1, this.MAX_BOTTOM_WIDTH = 30, this.STATEMENT_BOTTOM_SPACER = -this.NOTCH_HEIGHT / 2;
        }
        getCSS_(e) {
          return super.getCSS_(e).concat([
            `${e} .blocklyInsertionMarker>.blocklyPathLight,`,
            `${e} .blocklyInsertionMarker>.blocklyPathDark {`,
            `fill-opacity: ${this.INSERTION_MARKER_OPACITY};`,
            "stroke: none;",
            "}"
          ]);
        }
      }, fE = class {
        constructor(e) {
          this.inlineSteps_ = this.steps_ = "", this.info_ = e, this.RTL_ = this.info_.RTL, e = e.getRenderer(), this.constants_ = e.getConstants(), this.highlightConstants_ = e.getHighlightConstants(), this.highlightOffset = this.highlightConstants_.OFFSET, this.outsideCornerPaths_ = this.highlightConstants_.OUTSIDE_CORNER, this.insideCornerPaths_ = this.highlightConstants_.INSIDE_CORNER, this.puzzleTabPaths_ = this.highlightConstants_.PUZZLE_TAB, this.notchPaths_ = this.highlightConstants_.NOTCH, this.startPaths_ = this.highlightConstants_.START_HAT, this.jaggedTeethPaths_ = this.highlightConstants_.JAGGED_TEETH;
        }
        getPath() {
          return this.steps_ + `
` + this.inlineSteps_;
        }
        drawTopCorner(e) {
          this.steps_ += Wt(e.xPos, this.info_.startY);
          for (let t = 0, n; n = e.elements[t]; t++)
            w.isLeftSquareCorner(n) ? this.steps_ += this.highlightConstants_.START_POINT : w.isLeftRoundedCorner(n) ? this.steps_ += this.outsideCornerPaths_.topLeft(this.RTL_) : w.isPreviousConnection(n) ? this.steps_ += this.notchPaths_.pathLeft : w.isHat(n) ? this.steps_ += this.startPaths_.path(this.RTL_) : w.isSpacer(n) && n.width !== 0 && (this.steps_ += de("H", n.xPos + n.width - this.highlightOffset));
          this.steps_ += de(
            "H",
            e.xPos + e.width - this.highlightOffset
          );
        }
        drawJaggedEdge_(e) {
          this.info_.RTL && (this.steps_ += this.jaggedTeethPaths_.pathLeft + de("v", e.height - this.jaggedTeethPaths_.height - this.highlightOffset));
        }
        drawValueInput(e) {
          const t = e.getLastInput();
          if (this.RTL_) {
            const n = e.height - t.connectionHeight;
            this.steps_ += Or(t.xPos + t.width - this.highlightOffset, e.yPos) + this.puzzleTabPaths_.pathDown(this.RTL_) + de(
              "v",
              n
            );
          } else
            this.steps_ += Or(t.xPos + t.width, e.yPos) + this.puzzleTabPaths_.pathDown(this.RTL_);
        }
        drawStatementInput(e) {
          const t = e.getLastInput();
          if (t)
            if (this.RTL_) {
              const n = e.height - 2 * this.insideCornerPaths_.height;
              this.steps_ += Or(t.xPos, e.yPos) + this.insideCornerPaths_.pathTop(this.RTL_) + de("v", n) + this.insideCornerPaths_.pathBottom(this.RTL_) + p_(e.width - t.xPos - this.insideCornerPaths_.width, 0);
            } else
              this.steps_ += Or(t.xPos, e.yPos + e.height) + this.insideCornerPaths_.pathBottom(this.RTL_) + p_(e.width - t.xPos - this.insideCornerPaths_.width, 0);
        }
        drawRightSideRow(e) {
          const t = e.xPos + e.width - this.highlightOffset;
          e instanceof dE && e.followsStatement && (this.steps_ += de("H", t)), this.RTL_ && (this.steps_ += de("H", t), e.height > this.highlightOffset && (this.steps_ += de("V", e.yPos + e.height - this.highlightOffset)));
        }
        drawBottomRow(e) {
          if (this.RTL_)
            this.steps_ += de("V", e.baseline - this.highlightOffset);
          else {
            const t = this.info_.bottomRow.elements[0];
            w.isLeftSquareCorner(t) ? this.steps_ += Or(e.xPos + this.highlightOffset, e.baseline - this.highlightOffset) : w.isLeftRoundedCorner(t) && (this.steps_ += Or(e.xPos, e.baseline), this.steps_ += this.outsideCornerPaths_.bottomLeft());
          }
        }
        drawLeft() {
          var e = this.info_.outputConnection;
          e && (e = e.connectionOffsetY + e.height, this.RTL_ ? this.steps_ += Or(this.info_.startX, e) : (this.steps_ += Or(this.info_.startX + this.highlightOffset, this.info_.bottomRow.baseline - this.highlightOffset), this.steps_ += de("V", e)), this.steps_ += this.puzzleTabPaths_.pathUp(this.RTL_)), this.RTL_ || (e = this.info_.topRow, w.isLeftRoundedCorner(e.elements[0]) ? this.steps_ += de("V", this.outsideCornerPaths_.height) : this.steps_ += de("V", e.capline + this.highlightOffset));
        }
        drawInlineInput(e) {
          const t = this.highlightOffset, n = e.xPos + e.connectionWidth;
          var o = e.centerline - e.height / 2;
          const c = e.width - e.connectionWidth, A = o + t;
          this.RTL_ ? (o = e.connectionOffsetY - t, e = e.height - (e.connectionOffsetY + e.connectionHeight) + t, this.inlineSteps_ += Or(n - t, A) + de("v", o) + this.puzzleTabPaths_.pathDown(this.RTL_) + de("v", e) + de("h", c)) : this.inlineSteps_ += Or(e.xPos + e.width + t, A) + de("v", e.height) + de("h", -c) + Or(n, o + e.connectionOffsetY) + this.puzzleTabPaths_.pathDown(this.RTL_);
        }
      }, Bd = class extends kl {
        constructor(e, t) {
          super(e, t), this.highlighter_ = new fE(t);
        }
        draw() {
          this.drawOutline_(), this.drawInternals_();
          const e = this.block_.pathObject;
          e.setPath(this.outlinePath_ + `
` + this.inlinePath_), e.setHighlightPath(this.highlighter_.getPath()), this.info_.RTL && e.flipRTL(), this.recordSizeOnBlock_();
        }
        drawTop_() {
          this.highlighter_.drawTopCorner(this.info_.topRow), this.highlighter_.drawRightSideRow(this.info_.topRow), super.drawTop_();
        }
        drawJaggedEdge_(e) {
          this.highlighter_.drawJaggedEdge_(e), super.drawJaggedEdge_(e);
        }
        drawValueInput_(e) {
          this.highlighter_.drawValueInput(e), super.drawValueInput_(e);
        }
        drawStatementInput_(e) {
          this.highlighter_.drawStatementInput(e), super.drawStatementInput_(e);
        }
        drawRightSideRow_(e) {
          this.highlighter_.drawRightSideRow(e), this.outlinePath_ += de("H", e.xPos + e.width) + de(
            "V",
            e.yPos + e.height
          );
        }
        drawBottom_() {
          this.highlighter_.drawBottomRow(this.info_.bottomRow), super.drawBottom_();
        }
        drawLeft_() {
          this.highlighter_.drawLeft(), super.drawLeft_();
        }
        drawInlineInput_(e) {
          this.highlighter_.drawInlineInput(e), super.drawInlineInput_(e);
        }
        positionInlineInputConnection_(e) {
          const t = e.centerline - e.height / 2;
          if (e.connectionModel) {
            let n = e.xPos + e.connectionWidth + this.constants_.DARK_PATH_OFFSET;
            this.info_.RTL && (n *= -1), e.connectionModel.setOffsetInBlock(n, t + e.connectionOffsetY + this.constants_.DARK_PATH_OFFSET);
          }
        }
        positionStatementInputConnection_(e) {
          const t = e.getLastInput();
          if (t != null && t.connectionModel) {
            let n = e.xPos + e.statementEdge + t.notchOffset;
            n = this.info_.RTL ? -1 * n : n + this.constants_.DARK_PATH_OFFSET, t.connectionModel.setOffsetInBlock(n, e.yPos + this.constants_.DARK_PATH_OFFSET);
          }
        }
        positionExternalValueConnection_(e) {
          const t = e.getLastInput();
          if (t && t.connectionModel) {
            let n = e.xPos + e.width + this.constants_.DARK_PATH_OFFSET;
            this.info_.RTL && (n *= -1), t.connectionModel.setOffsetInBlock(n, e.yPos);
          }
        }
        positionNextConnection_() {
          const e = this.info_.bottomRow;
          if (e.connection) {
            const t = e.connection, n = t.xPos;
            t.connectionModel.setOffsetInBlock((this.info_.RTL ? -n : n) + this.constants_.DARK_PATH_OFFSET / 2, e.baseline + this.constants_.DARK_PATH_OFFSET);
          }
        }
      }, Yd = class {
        constructor(e) {
          this.OFFSET = 0.5, this.constantProvider = e, this.START_POINT = Wt(this.OFFSET, this.OFFSET);
        }
        init() {
          this.INSIDE_CORNER = this.makeInsideCorner(), this.OUTSIDE_CORNER = this.makeOutsideCorner(), this.PUZZLE_TAB = this.makePuzzleTab(), this.NOTCH = this.makeNotch(), this.JAGGED_TEETH = this.makeJaggedTeeth(), this.START_HAT = this.makeStartHat();
        }
        makeInsideCorner() {
          const e = this.constantProvider.CORNER_RADIUS, t = this.OFFSET, n = (1 - Math.SQRT1_2) * (e + t) - t, o = Wt(n, n) + kt("a", "0 0,0", e, Ee(-n - t, e - n)), c = kt("a", "0 0,0", e + t, Ee(e + t, e + t)), A = Wt(n, -n) + kt("a", "0 0,0", e + t, Ee(e - n, n + t));
          return { width: e + t, height: e, pathTop(D) {
            return D ? o : "";
          }, pathBottom(D) {
            return D ? c : A;
          } };
        }
        makeOutsideCorner() {
          const e = this.constantProvider.CORNER_RADIUS, t = this.OFFSET, n = (1 - Math.SQRT1_2) * (e - t) + t, o = Wt(n, n) + kt("a", "0 0,1", e - t, Ee(e - n, -n + t)), c = Wt(t, e) + kt("a", "0 0,1", e - t, Ee(e, -e + t)), A = -n, D = Wt(n, A) + kt("a", "0 0,1", e - t, Ee(-n + t, -A - e));
          return { height: e, topLeft($) {
            return $ ? o : c;
          }, bottomLeft() {
            return D;
          } };
        }
        makePuzzleTab() {
          const e = this.constantProvider.TAB_WIDTH, t = this.constantProvider.TAB_HEIGHT, n = Wt(-2, -t + 3.4) + p_(-0.45 * e, -2.1), o = de(
            "v",
            2.5
          ) + Wt(0.97 * -e, 2.5) + mt("q", [Ee(0.05 * -e, 10), Ee(0.3 * e, 9.5)]) + Wt(0.67 * e, -1.9) + de("v", 2.5), c = de("v", -1.5) + Wt(-0.92 * e, -0.5) + mt(
            "q",
            [Ee(-0.19 * e, -5.5), Ee(0, -11)]
          ) + Wt(0.92 * e, 1), A = Wt(-5, t - 0.7) + p_(0.46 * e, -2.1);
          return { width: e, height: t, pathUp(D) {
            return D ? n : c;
          }, pathDown(D) {
            return D ? o : A;
          } };
        }
        makeNotch() {
          return { pathLeft: de("h", this.OFFSET) + this.constantProvider.NOTCH.pathLeft };
        }
        makeJaggedTeeth() {
          return { pathLeft: p_(
            5.1,
            2.6
          ) + Wt(-10.2, 6.8) + p_(5.1, 2.6), height: 12, width: 10.2 };
        }
        makeStartHat() {
          const e = this.constantProvider.START_HAT.height, t = Wt(25, -8.7) + mt("c", [Ee(29.7, -6.2), Ee(57.2, -0.5), Ee(75, 8.7)]), n = mt(
            "c",
            [Ee(17.8, -9.2), Ee(45.3, -14.9), Ee(75, -8.7)]
          ) + Or(100.5, e + 0.5);
          return { path(o) {
            return o ? t : n;
          } };
        }
      }, Ud = class extends EE {
        constructor(e, t) {
          super(e, t), this.constants_ = e, this.connectedBlock && (this.width += this.constants_.DARK_PATH_OFFSET, this.height += this.constants_.DARK_PATH_OFFSET);
        }
      }, Hc = class extends ir {
        constructor(e, t) {
          super(e, t), this.constants_ = e, this.connectedBlock && (this.height += this.constants_.DARK_PATH_OFFSET);
        }
      }, xc = class extends gs {
        constructor(e, t) {
          super(e, t), this.renderer_ = e;
        }
        getRenderer() {
          return this.renderer_;
        }
        populateBottomRow_() {
          super.populateBottomRow_(), this.block_.inputList.length && this.block_.inputList[this.block_.inputList.length - 1] instanceof Wn || (this.bottomRow.minHeight = this.constants_.MEDIUM_PADDING - this.constants_.DARK_PATH_OFFSET);
        }
        addInput_(e, t) {
          this.isInline && e instanceof r.ValueInput$$module$build$src$core$inputs$value_input ? (t.elements.push(new Ud(this.constants_, e)), t.hasInlineInput = !0) : e instanceof Wn ? (t.elements.push(new Hc(this.constants_, e)), t.hasStatement = !0) : e instanceof r.ValueInput$$module$build$src$core$inputs$value_input ? (t.elements.push(new Ds(this.constants_, e)), t.hasExternalInput = !0) : e instanceof t_ && (t.minHeight = Math.max(t.minHeight, this.constants_.DUMMY_INPUT_MIN_HEIGHT), t.hasDummyInput = !0), this.isInline || t.align !== null || (t.align = e.align);
        }
        addElemSpacing_() {
          let e = !1;
          for (let n = 0, o; o = this.rows[n]; n++)
            o.hasExternalInput && (e = !0);
          for (let n = 0, o; o = this.rows[n]; n++) {
            var t = o.elements;
            if (o.elements = [], o.startsWithElemSpacer() && o.elements.push(new Fn(this.constants_, this.getInRowSpacing_(null, t[0]))), t.length) {
              for (let c = 0; c < t.length - 1; c++) {
                o.elements.push(t[c]);
                const A = this.getInRowSpacing_(t[c], t[c + 1]);
                o.elements.push(new Fn(this.constants_, A));
              }
              o.elements.push(t[t.length - 1]), o.endsWithElemSpacer() && (t = this.getInRowSpacing_(t[t.length - 1], null), e && o.hasDummyInput && (t += this.constants_.TAB_WIDTH), o.elements.push(new Fn(this.constants_, t)));
            }
          }
        }
        getInRowSpacing_(e, t) {
          if (!e)
            return t && w.isField(t) && t.isEditable ? this.constants_.MEDIUM_PADDING : t && w.isInlineInput(t) ? this.constants_.MEDIUM_LARGE_PADDING : t && w.isStatementInput(t) ? this.constants_.STATEMENT_INPUT_PADDING_LEFT : this.constants_.LARGE_PADDING;
          if (!w.isInput(e) && (!t || w.isStatementInput(t)))
            return w.isField(e) && e.isEditable ? this.constants_.MEDIUM_PADDING : w.isIcon(e) ? 2 * this.constants_.LARGE_PADDING + 1 : w.isHat(e) ? this.constants_.NO_PADDING : w.isPreviousOrNextConnection(e) ? this.constants_.LARGE_PADDING : w.isLeftRoundedCorner(e) ? this.constants_.MIN_BLOCK_WIDTH : w.isJaggedEdge(e) ? this.constants_.NO_PADDING : this.constants_.LARGE_PADDING;
          if (w.isInput(e) && !t) {
            if (w.isExternalInput(e))
              return this.constants_.NO_PADDING;
            if (w.isInlineInput(e))
              return this.constants_.LARGE_PADDING;
            if (w.isStatementInput(e))
              return this.constants_.NO_PADDING;
          }
          if (!w.isInput(e) && t && w.isInput(t)) {
            if (w.isField(e) && e.isEditable) {
              if (w.isInlineInput(t) || w.isExternalInput(t))
                return this.constants_.SMALL_PADDING;
            } else {
              if (w.isInlineInput(t) || w.isExternalInput(t))
                return this.constants_.MEDIUM_LARGE_PADDING;
              if (w.isStatementInput(t))
                return this.constants_.LARGE_PADDING;
            }
            return this.constants_.LARGE_PADDING - 1;
          }
          if (w.isIcon(e) && t && !w.isInput(t))
            return this.constants_.LARGE_PADDING;
          if (w.isInlineInput(e) && t && w.isField(t))
            return t.isEditable ? this.constants_.MEDIUM_PADDING : this.constants_.LARGE_PADDING;
          if (w.isLeftSquareCorner(e) && t) {
            if (w.isHat(t))
              return this.constants_.NO_PADDING;
            if (w.isPreviousConnection(t))
              return t.notchOffset;
            if (w.isNextConnection(t))
              return t.notchOffset + (this.RTL ? 1 : -1) * this.constants_.DARK_PATH_OFFSET / 2;
          }
          if (w.isLeftRoundedCorner(e) && t) {
            if (w.isPreviousConnection(t))
              return t.notchOffset - this.constants_.CORNER_RADIUS;
            if (w.isNextConnection(t))
              return t.notchOffset - this.constants_.CORNER_RADIUS + (this.RTL ? 1 : -1) * this.constants_.DARK_PATH_OFFSET / 2;
          }
          return w.isField(e) && t && w.isField(t) && e.isEditable === t.isEditable || t && w.isJaggedEdge(t) ? this.constants_.LARGE_PADDING : this.constants_.MEDIUM_PADDING;
        }
        getSpacerRowHeight_(e, t) {
          return w.isTopRow(e) && w.isBottomRow(t) ? this.constants_.EMPTY_BLOCK_SPACER_HEIGHT : w.isTopRow(e) || w.isBottomRow(t) ? this.constants_.NO_PADDING : e.hasExternalInput && t.hasExternalInput ? this.constants_.LARGE_PADDING : !e.hasStatement && t.hasStatement ? this.constants_.BETWEEN_STATEMENT_PADDING_Y : e.hasStatement && t.hasStatement || !e.hasStatement && t.hasDummyInput || e.hasDummyInput ? this.constants_.LARGE_PADDING : this.constants_.MEDIUM_PADDING;
        }
        getElemCenterline_(e, t) {
          if (w.isSpacer(t))
            return e.yPos + t.height / 2;
          if (w.isBottomRow(e))
            return e = e.yPos + e.height - e.descenderHeight, w.isNextConnection(t) ? e + t.height / 2 : e - t.height / 2;
          if (w.isTopRow(e))
            return w.isHat(t) ? e.capline - t.height / 2 : e.capline + t.height / 2;
          let n = e.yPos;
          return w.isField(t) || w.isIcon(t) ? (n += t.height / 2, (e.hasInlineInput || e.hasStatement) && t.height + this.constants_.TALL_INPUT_FIELD_OFFSET_Y <= e.height && (n += this.constants_.TALL_INPUT_FIELD_OFFSET_Y)) : n = w.isInlineInput(t) ? n + t.height / 2 : n + e.height / 2, n;
        }
        alignRowElements_() {
          if (this.isInline) {
            var e = 0, t = /* @__PURE__ */ new WeakMap(), n = null;
            for (let o = this.rows.length - 1, c; c = this.rows[o]; o--)
              t.set(c, e), w.isInputRow(c) && (c.hasStatement && this.alignStatementRow_(c), n && n.hasStatement && c.width < n.width ? t.set(c, n.width) : e = c.width, n = c);
            e = 0;
            for (let o = 0, c; c = this.rows[o]; o++)
              c.hasStatement ? e = this.getDesiredRowWidth_(c) : w.isSpacer(c) ? c.width = Math.max(e, t.get(c)) : (n = c.width, e = Math.max(e, t.get(c)) - n, 0 < e && this.addAlignmentPadding_(c, e), e = c.width);
          } else
            super.alignRowElements_();
        }
        getDesiredRowWidth_(e) {
          return this.isInline && e.hasStatement ? this.statementEdge + this.constants_.MAX_BOTTOM_WIDTH + this.startX : super.getDesiredRowWidth_(e);
        }
        finalize_() {
          let e = 0, t = 0;
          for (let o = 0, c; c = this.rows[o]; o++) {
            c.yPos = t, c.xPos = this.startX, t += c.height, e = Math.max(e, c.widthWithConnectedBlocks);
            var n = t - this.topRow.ascenderHeight;
            c === this.bottomRow && n < this.constants_.MIN_BLOCK_HEIGHT && (n = this.constants_.MIN_BLOCK_HEIGHT - n, this.bottomRow.height += n, t += n), this.recordElemPositions_(c);
          }
          this.outputConnection && this.block_.nextConnection && this.block_.nextConnection.isConnected() && (n = this.block_.nextConnection.targetBlock()) && (e = Math.max(e, n.getHeightWidth().width - this.constants_.DARK_PATH_OFFSET)), this.bottomRow.baseline = t - this.bottomRow.descenderHeight, this.widthWithChildren = e + this.startX + this.constants_.DARK_PATH_OFFSET, this.width += this.constants_.DARK_PATH_OFFSET, this.height = t + this.constants_.DARK_PATH_OFFSET, this.startY = this.topRow.capline;
        }
      }, Vd = class extends Wc {
        constructor(e, t, n) {
          super(e, t, n), this.constants = n, this.colourDark = "#000000", this.svgPathDark = K(U.PATH, { class: "blocklyPathDark", transform: "translate(1,1)" }), this.svgRoot.insertBefore(this.svgPathDark, this.svgPath), this.svgPathLight = K(
            U.PATH,
            { class: "blocklyPathLight" },
            this.svgRoot
          );
        }
        setPath(e) {
          this.svgPath.setAttribute("d", e), this.svgPathDark.setAttribute("d", e);
        }
        setHighlightPath(e) {
          this.svgPathLight.setAttribute("d", e);
        }
        flipRTL() {
          this.svgPath.setAttribute("transform", "scale(-1 1)"), this.svgPathLight.setAttribute("transform", "scale(-1 1)"), this.svgPathDark.setAttribute("transform", "translate(1,1) scale(-1 1)");
        }
        applyColour(e) {
          if (this.svgPathLight.style.display = "", this.svgPathDark.style.display = "", !this.style.colourTertiary)
            throw Error("The renderer did not properly initialize the tertiary colour of the block style");
          this.svgPathLight.setAttribute("stroke", this.style.colourTertiary), this.svgPathDark.setAttribute("fill", this.colourDark), super.applyColour(e), this.svgPath.setAttribute("stroke", "none");
        }
        setStyle(e) {
          this.style = e, this.colourDark = Xn("#000", this.style.colourPrimary, 0.2) || this.colourDark;
        }
        updateHighlighted(e) {
          e ? (this.svgPath.setAttribute("filter", "url(#" + this.constants.embossFilterId + ")"), this.svgPathLight.style.display = "none") : (this.svgPath.setAttribute("filter", "none"), this.svgPathLight.style.display = "inline");
        }
        updateShadow_(e) {
          if (e) {
            if (this.svgPathLight.style.display = "none", !this.style.colourSecondary)
              throw Error("The renderer did not properly initialize the secondary colour of the block style block style");
            this.svgPathDark.setAttribute("fill", this.style.colourSecondary), this.svgPath.setAttribute("stroke", "none"), this.svgPath.setAttribute("fill", this.style.colourSecondary);
          }
        }
        updateDisabled_(e) {
          super.updateDisabled_(e), e && this.svgPath.setAttribute("stroke", "none");
        }
      }, Gd = class extends Vl {
        constructor(e) {
          super(e), this.highlightConstants = null;
        }
        init(e, t) {
          super.init(e, t), this.highlightConstants = this.makeHighlightConstants_(), this.highlightConstants.init();
        }
        refreshDom(e, t) {
          super.refreshDom(e, t), this.getHighlightConstants().init();
        }
        makeConstants_() {
          return new wd();
        }
        makeRenderInfo_(e) {
          return new xc(
            this,
            e
          );
        }
        makeDrawer_(e, t) {
          return new Bd(e, t);
        }
        makePathObject(e, t) {
          return new Vd(e, t, this.getConstants());
        }
        makeHighlightConstants_() {
          return new Yd(this.getConstants());
        }
        getHighlightConstants() {
          if (!this.highlightConstants)
            throw Error("Cannot access the highlight constants because init has not been called");
          return this.highlightConstants;
        }
      };
      Jn("geras", Gd);
      var z_ = {};
      z_.ConstantProvider = wd, z_.Drawer = Bd, z_.HighlightConstantProvider = Yd, z_.Highlighter = fE, z_.InlineInput = Ud, z_.PathObject = Vd, z_.RenderInfo = xc, z_.Renderer = Gd, z_.StatementInput = Hc;
      var Hd = class extends Ao {
        constructor() {
          super(), dr("Blockly.minimalist.ConstantProvider", "v10", "v11", "Blockly.blockRendering.ConstantProvider");
        }
      }, xd = class extends kl {
        constructor(e, t) {
          super(e, t), dr("Blockly.minimalist.Drawer", "v10", "v11", "Blockly.blockRendering.Drawer");
        }
      }, Xd = class extends gs {
        constructor(e, t) {
          super(e, t), dr("Blockly.minimalist.RenderInfo", "v10", "v11", "Blockly.blockRendering.RenderInfo");
        }
        getRenderer() {
          return this.renderer_;
        }
      }, Kd = class extends Vl {
        constructor(e) {
          super(e), dr("Blockly.minimalist.Renderer", "v10", "v11", "Blockly.blockRendering.Renderer");
        }
        makeConstants_() {
          return new Hd();
        }
        makeRenderInfo_(e) {
          return new Xd(this, e);
        }
        makeDrawer_(e, t) {
          return new xd(
            e,
            t
          );
        }
      };
      Jn("minimalist", Kd);
      var Xl = {};
      Xl.ConstantProvider = Hd, Xl.Drawer = xd, Xl.RenderInfo = Xd, Xl.Renderer = Kd;
      var Jd = class extends gs {
        constructor(e, t) {
          super(e, t);
        }
        getRenderer() {
          return this.renderer_;
        }
        addElemSpacing_() {
          let e = !1;
          for (var t = 0; t < this.rows.length; t++)
            if (this.rows[t].hasExternalInput) {
              e = !0;
              break;
            }
          for (t = 0; t < this.rows.length; t++) {
            const o = this.rows[t];
            var n = o.elements;
            if (o.elements = [], o.startsWithElemSpacer() && o.elements.push(new Fn(
              this.constants_,
              this.getInRowSpacing_(null, n[0])
            )), n.length) {
              for (let c = 0; c < n.length - 1; c++) {
                o.elements.push(n[c]);
                const A = this.getInRowSpacing_(n[c], n[c + 1]);
                o.elements.push(new Fn(this.constants_, A));
              }
              o.elements.push(n[n.length - 1]), o.endsWithElemSpacer() && (n = this.getInRowSpacing_(n[n.length - 1], null), e && o.hasDummyInput && (n += this.constants_.TAB_WIDTH), o.elements.push(new Fn(
                this.constants_,
                n
              )));
            }
          }
        }
        getInRowSpacing_(e, t) {
          if (!e)
            return t && w.isField(t) && t.isEditable ? this.constants_.MEDIUM_PADDING : t && w.isInlineInput(t) ? this.constants_.MEDIUM_LARGE_PADDING : t && w.isStatementInput(t) ? this.constants_.STATEMENT_INPUT_PADDING_LEFT : this.constants_.LARGE_PADDING;
          if (!w.isInput(e) && !t)
            return w.isField(e) && e.isEditable ? this.constants_.MEDIUM_PADDING : w.isIcon(e) ? 2 * this.constants_.LARGE_PADDING + 1 : w.isHat(e) ? this.constants_.NO_PADDING : w.isPreviousOrNextConnection(e) ? this.constants_.LARGE_PADDING : w.isLeftRoundedCorner(e) ? this.constants_.MIN_BLOCK_WIDTH : w.isJaggedEdge(e) ? this.constants_.NO_PADDING : this.constants_.LARGE_PADDING;
          if (w.isInput(e) && !t) {
            if (w.isExternalInput(e))
              return this.constants_.NO_PADDING;
            if (w.isInlineInput(e))
              return this.constants_.LARGE_PADDING;
            if (w.isStatementInput(e))
              return this.constants_.NO_PADDING;
          }
          if (!w.isInput(e) && t && w.isInput(t)) {
            if (w.isField(e) && e.isEditable) {
              if (w.isInlineInput(t) || w.isExternalInput(t))
                return this.constants_.SMALL_PADDING;
            } else {
              if (w.isInlineInput(t) || w.isExternalInput(t))
                return this.constants_.MEDIUM_LARGE_PADDING;
              if (w.isStatementInput(t))
                return this.constants_.LARGE_PADDING;
            }
            return this.constants_.LARGE_PADDING - 1;
          }
          if (w.isIcon(e) && t && !w.isInput(t))
            return this.constants_.LARGE_PADDING;
          if (w.isInlineInput(e) && t && w.isField(t))
            return t.isEditable ? this.constants_.MEDIUM_PADDING : this.constants_.LARGE_PADDING;
          if (w.isLeftSquareCorner(e) && t) {
            if (w.isHat(t))
              return this.constants_.NO_PADDING;
            if (w.isPreviousConnection(t) || w.isNextConnection(t))
              return t.notchOffset;
          }
          return w.isLeftRoundedCorner(e) && t ? t.notchOffset - this.constants_.CORNER_RADIUS : w.isField(e) && t && w.isField(t) && e.isEditable === t.isEditable || t && w.isJaggedEdge(t) ? this.constants_.LARGE_PADDING : this.constants_.MEDIUM_PADDING;
        }
        getSpacerRowHeight_(e, t) {
          return w.isTopRow(e) && w.isBottomRow(t) ? this.constants_.EMPTY_BLOCK_SPACER_HEIGHT : w.isTopRow(e) || w.isBottomRow(t) ? this.constants_.NO_PADDING : e.hasExternalInput && t.hasExternalInput ? this.constants_.LARGE_PADDING : !e.hasStatement && t.hasStatement ? this.constants_.BETWEEN_STATEMENT_PADDING_Y : e.hasStatement && t.hasStatement || e.hasDummyInput || t.hasDummyInput ? this.constants_.LARGE_PADDING : this.constants_.MEDIUM_PADDING;
        }
        getElemCenterline_(e, t) {
          if (w.isSpacer(t))
            return e.yPos + t.height / 2;
          if (w.isBottomRow(e))
            return e = e.yPos + e.height - e.descenderHeight, w.isNextConnection(t) ? e + t.height / 2 : e - t.height / 2;
          if (w.isTopRow(e))
            return w.isHat(t) ? e.capline - t.height / 2 : e.capline + t.height / 2;
          let n = e.yPos;
          return n = w.isField(t) && e.hasStatement ? n + (this.constants_.TALL_INPUT_FIELD_OFFSET_Y + t.height / 2) : n + e.height / 2;
        }
        finalize_() {
          let e = 0, t = 0;
          for (var n = 0; n < this.rows.length; n++) {
            const c = this.rows[n];
            c.yPos = t, c.xPos = this.startX, t += c.height, e = Math.max(e, c.widthWithConnectedBlocks);
            var o = t - this.topRow.ascenderHeight;
            c === this.bottomRow && o < this.constants_.MIN_BLOCK_HEIGHT && (o = this.constants_.MIN_BLOCK_HEIGHT - o, this.bottomRow.height += o, t += o), this.recordElemPositions_(c);
          }
          this.outputConnection && this.block_.nextConnection && this.block_.nextConnection.isConnected() && (n = this.block_.nextConnection.targetBlock()) && (e = Math.max(e, n.getHeightWidth().width)), this.bottomRow.baseline = t - this.bottomRow.descenderHeight, this.widthWithChildren = e + this.startX, this.height = t, this.startY = this.topRow.capline;
        }
      }, jd = class extends Vl {
        constructor(e) {
          super(e);
        }
        makeRenderInfo_(e) {
          return new Jd(this, e);
        }
      };
      Jn("thrasos", jd);
      var NE = {};
      NE.RenderInfo = Jd, NE.Renderer = jd;
      var XS = class {
        constructor(e, t) {
          this.procedureModelClass = e, this.parameterModelClass = t, this.priority = zA;
        }
        save(e) {
          return e = e.getProcedureMap().getProcedures().map((t) => uu(t)), e.length ? e : null;
        }
        load(e, t) {
          const n = t.getProcedureMap();
          for (const o of e)
            n.add(Eu(
              this.procedureModelClass,
              this.parameterModelClass,
              o,
              t
            ));
        }
        clear(e) {
          e.getProcedureMap().clear();
        }
      }, bs = {};
      bs.ProcedureSerializer = XS, bs.loadParameter = Au, bs.loadProcedure = Eu, bs.saveParameter = Zo, bs.saveProcedure = uu;
      var zd = class {
        constructor() {
          this.priority = jA;
        }
        save(e) {
          const t = [];
          for (const n of e.getAllVariables())
            e = { name: n.name, id: n.getId() }, n.type && (e.type = n.type), t.push(e);
          return t.length ? t : null;
        }
        load(e, t) {
          for (const n of e)
            t.createVariable(n.name, n.type, n.id);
        }
        clear(e) {
          e.getVariableMap().clear();
        }
      };
      Us("variables", new zd());
      var Zd = {};
      Zd.VariableSerializer = zd;
      var bE = {};
      bE.load = du, bE.save = Va;
      var KS = { blocks: Dl, exceptions: TT, priorities: ic, procedures: bs, registry: Fu, variables: Zd, workspaces: bE }, Z_;
      (function(e) {
        e.ESCAPE = "escape", e.DELETE = "delete", e.COPY = "copy", e.CUT = "cut", e.PASTE = "paste", e.UNDO = "undo", e.REDO = "redo";
      })(Z_ || (Z_ = {})), Ha();
      var Q_ = {};
      Q_.names = Z_, Q_.registerCopy = Iu, Q_.registerCut = Ga, Q_.registerDefaultShortcuts = Ha, Q_.registerDelete = hu, Q_.registerEscape = Su, Q_.registerPaste = ul, Q_.registerRedo = El, Q_.registerUndo = Mu;
      var JS = {
        colour_blocks: { colourPrimary: "#CF63CF", colourSecondary: "#C94FC9", colourTertiary: "#BD42BD" },
        list_blocks: { colourPrimary: "#9966FF", colourSecondary: "#855CD6", colourTertiary: "#774DCB" },
        logic_blocks: { colourPrimary: "#4C97FF", colourSecondary: "#4280D7", colourTertiary: "#3373CC" },
        loop_blocks: { colourPrimary: "#0fBD8C", colourSecondary: "#0DA57A", colourTertiary: "#0B8E69" },
        math_blocks: { colourPrimary: "#59C059", colourSecondary: "#46B946", colourTertiary: "#389438" },
        procedure_blocks: { colourPrimary: "#FF6680", colourSecondary: "#FF4D6A", colourTertiary: "#FF3355" },
        text_blocks: { colourPrimary: "#FFBF00", colourSecondary: "#E6AC00", colourTertiary: "#CC9900" },
        variable_blocks: { colourPrimary: "#FF8C1A", colourSecondary: "#FF8000", colourTertiary: "#DB6E00" },
        variable_dynamic_blocks: { colourPrimary: "#FF8C1A", colourSecondary: "#FF8000", colourTertiary: "#DB6E00" },
        hat_blocks: { colourPrimary: "#4C97FF", colourSecondary: "#4280D7", colourTertiary: "#3373CC", hat: "cap" }
      }, jS = { colour_category: { colour: "#CF63CF" }, list_category: { colour: "#9966FF" }, logic_category: { colour: "#4C97FF" }, loop_category: { colour: "#0fBD8C" }, math_category: { colour: "#59C059" }, procedure_category: { colour: "#FF6680" }, text_category: { colour: "#FFBF00" }, variable_category: { colour: "#FF8C1A" }, variable_dynamic_category: { colour: "#FF8C1A" } }, T = new AT("zelos", JS, jS), l = {};
      l.Classic = dc, l.Zelos = T;
      var u = class {
        constructor(e, t, n) {
          this.id_ = e.toolboxitemid || i_(), this.level_ = (this.parent_ = n || null) ? this.parent_.getLevel() + 1 : 0, this.toolboxItemDef_ = e, this.parentToolbox_ = t, this.workspace_ = this.parentToolbox_.getWorkspace();
        }
        init() {
        }
        getDiv() {
          return null;
        }
        getClickTarget() {
          return null;
        }
        getId() {
          return this.id_;
        }
        getParent() {
          return null;
        }
        getLevel() {
          return this.level_;
        }
        isSelectable() {
          return !1;
        }
        isCollapsible() {
          return !1;
        }
        dispose() {
        }
        setVisible_(e) {
        }
      }, S = class extends u {
        constructor(e, t, n) {
          super(e, t, n), this.colour_ = this.name_ = "", this.labelDom_ = this.iconDom_ = this.rowContents_ = this.rowDiv_ = this.htmlDiv_ = null, this.isDisabled_ = this.isHidden_ = !1, this.flyoutItems_ = [], this.cssConfig_ = this.makeDefaultCssConfig_();
        }
        init() {
          this.parseCategoryDef_(this.toolboxItemDef_), this.parseContents_(this.toolboxItemDef_), this.createDom_(), this.toolboxItemDef_.hidden === "true" && this.hide();
        }
        makeDefaultCssConfig_() {
          return { container: "blocklyToolboxCategory", row: "blocklyTreeRow", rowcontentcontainer: "blocklyTreeRowContentContainer", icon: "blocklyTreeIcon", label: "blocklyTreeLabel", contents: "blocklyToolboxContents", selected: "blocklyTreeSelected", openicon: "blocklyTreeIconOpen", closedicon: "blocklyTreeIconClosed" };
        }
        parseContents_(e) {
          if ("custom" in e)
            this.flyoutItems_ = e.custom;
          else if (e = e.contents)
            for (let t = 0; t < e.length; t++) {
              const n = e[t];
              Array.isArray(this.flyoutItems_) && this.flyoutItems_.push(n);
            }
        }
        parseCategoryDef_(e) {
          this.name_ = "name" in e ? xt(e.name) : "", this.colour_ = this.getColour_(e), Object.assign(this.cssConfig_, e.cssconfig || e.cssConfig);
        }
        createDom_() {
          this.htmlDiv_ = this.createContainer_(), an(this.htmlDiv_, mn.TREEITEM), Mt(this.htmlDiv_, Ot.SELECTED, !1), Mt(
            this.htmlDiv_,
            Ot.LEVEL,
            this.level_ + 1
          ), this.rowDiv_ = this.createRowContainer_(), this.rowDiv_.style.pointerEvents = "auto", this.htmlDiv_.appendChild(this.rowDiv_), this.rowContents_ = this.createRowContentsContainer_(), this.rowContents_.style.pointerEvents = "none", this.rowDiv_.appendChild(this.rowContents_), this.iconDom_ = this.createIconDom_(), an(this.iconDom_, mn.PRESENTATION), this.rowContents_.appendChild(this.iconDom_), this.labelDom_ = this.createLabelDom_(this.name_), this.rowContents_.appendChild(this.labelDom_);
          const e = this.labelDom_.getAttribute("id");
          return e && Mt(this.htmlDiv_, Ot.LABELLEDBY, e), this.addColourBorder_(this.colour_), this.htmlDiv_;
        }
        createContainer_() {
          const e = document.createElement("div"), t = this.cssConfig_.container;
          return t && be(e, t), e;
        }
        createRowContainer_() {
          const e = document.createElement("div");
          var t = this.cssConfig_.row;
          return t && be(
            e,
            t
          ), t = `${S.nestedPadding * this.getLevel()}px`, this.workspace_.RTL ? e.style.paddingRight = t : e.style.paddingLeft = t, e;
        }
        createRowContentsContainer_() {
          const e = document.createElement("div"), t = this.cssConfig_.rowcontentcontainer;
          return t && be(e, t), e;
        }
        createIconDom_() {
          const e = document.createElement("span");
          if (!this.parentToolbox_.isHorizontal()) {
            const t = this.cssConfig_.icon;
            t && be(
              e,
              t
            );
          }
          return e.style.display = "inline-block", e;
        }
        createLabelDom_(e) {
          const t = document.createElement("span");
          return t.setAttribute("id", this.getId() + ".label"), t.textContent = e, (e = this.cssConfig_.label) && be(t, e), t;
        }
        refreshTheme() {
          this.colour_ = this.getColour_(this.toolboxItemDef_), this.addColourBorder_(this.colour_);
        }
        addColourBorder_(e) {
          e && (e = S.borderWidth + "px solid " + (e || "#ddd"), this.workspace_.RTL ? this.rowDiv_.style.borderRight = e : this.rowDiv_.style.borderLeft = e);
        }
        getColour_(e) {
          const t = e.categorystyle || e.categoryStyle;
          if ((e = e.colour) && t)
            console.warn('Toolbox category "' + this.name_ + '" must not have both a style and a colour');
          else {
            if (t)
              return this.getColourfromStyle_(t);
            if (e)
              return this.parseColour_(e);
          }
          return "";
        }
        getColourfromStyle_(e) {
          var t = this.workspace_.getTheme();
          if (e && t) {
            if ((t = t.categoryStyles[e]) && t.colour)
              return this.parseColour_(t.colour);
            console.warn('Style "' + e + '" must exist and contain a colour value');
          }
          return "";
        }
        getClickTarget() {
          return this.rowDiv_;
        }
        parseColour_(e) {
          if (e = xt(e), e == null || e === "")
            return "";
          var t = Number(e);
          return isNaN(t) ? (t = c_(e)) ? t : (console.warn('Toolbox category "' + this.name_ + '" has unrecognized colour attribute: ' + e), "") : bn(t);
        }
        openIcon_(e) {
          if (e) {
            var t = this.cssConfig_.closedicon;
            t && Ti(e, t), (t = this.cssConfig_.openicon) && be(
              e,
              t
            );
          }
        }
        closeIcon_(e) {
          if (e) {
            var t = this.cssConfig_.openicon;
            t && Ti(e, t), (t = this.cssConfig_.closedicon) && be(e, t);
          }
        }
        setVisible_(e) {
          this.htmlDiv_.style.display = e ? "block" : "none", this.isHidden_ = !e, this.parentToolbox_.getSelectedItem() === this && this.parentToolbox_.clearSelection();
        }
        hide() {
          this.setVisible_(!1);
        }
        show() {
          this.setVisible_(!0);
        }
        isVisible() {
          return !this.isHidden_ && this.allAncestorsExpanded_();
        }
        allAncestorsExpanded_() {
          let e = this;
          for (; e.getParent(); )
            if (e = e.getParent(), !e.isExpanded())
              return !1;
          return !0;
        }
        isSelectable() {
          return this.isVisible() && !this.isDisabled_;
        }
        onClick(e) {
        }
        setSelected(e) {
          if (this.rowDiv_) {
            var t = this.cssConfig_.selected;
            if (e) {
              const n = this.parseColour_(S.defaultBackgroundColour);
              this.rowDiv_.style.backgroundColor = this.colour_ || n, t && be(this.rowDiv_, t);
            } else
              this.rowDiv_.style.backgroundColor = "", t && Be(
                this.rowDiv_,
                t
              );
            Mt(this.htmlDiv_, Ot.SELECTED, e);
          }
        }
        setDisabled(e) {
          this.isDisabled_ = e, this.getDiv().setAttribute("disabled", `${e}`), e ? this.getDiv().setAttribute("disabled", "true") : this.getDiv().removeAttribute("disabled");
        }
        getName() {
          return this.name_;
        }
        getParent() {
          return this.parent_;
        }
        getDiv() {
          return this.htmlDiv_;
        }
        getContents() {
          return this.flyoutItems_;
        }
        updateFlyoutContents(e) {
          this.flyoutItems_ = [], this.toolboxItemDef_ = typeof e == "string" ? {
            kind: this.toolboxItemDef_.kind,
            custom: e,
            id: this.toolboxItemDef_.id,
            categorystyle: this.toolboxItemDef_.categorystyle,
            colour: this.toolboxItemDef_.colour,
            cssconfig: this.toolboxItemDef_.cssconfig,
            hidden: this.toolboxItemDef_.hidden
          } : {
            kind: this.toolboxItemDef_.kind,
            name: "name" in this.toolboxItemDef_ ? this.toolboxItemDef_.name : "",
            contents: Zs(e),
            id: this.toolboxItemDef_.id,
            categorystyle: this.toolboxItemDef_.categorystyle,
            colour: this.toolboxItemDef_.colour,
            cssconfig: this.toolboxItemDef_.cssconfig,
            hidden: this.toolboxItemDef_.hidden
          }, this.parseContents_(this.toolboxItemDef_);
        }
        dispose() {
          Tt(this.htmlDiv_);
        }
      };
      S.registrationName = "category", S.nestedPadding = 19, S.borderWidth = 8, S.defaultBackgroundColour = "#57e", xn(`
.blocklyTreeRow:not(.blocklyTreeSelected):hover {
  background-color: rgba(255, 255, 255, .2);
}

.blocklyToolboxDiv[layout="h"] .blocklyToolboxCategory {
  margin: 1px 5px 1px 0;
}

.blocklyToolboxDiv[dir="RTL"][layout="h"] .blocklyToolboxCategory {
  margin: 1px 0 1px 5px;
}

.blocklyTreeRow {
  height: 22px;
  line-height: 22px;
  margin-bottom: 3px;
  padding-right: 8px;
  white-space: nowrap;
}

.blocklyToolboxDiv[dir="RTL"] .blocklyTreeRow {
  margin-left: 8px;
  padding-right: 0;
}

.blocklyTreeIcon {
  background-image: url(<<<PATH>>>/sprites.png);
  height: 16px;
  vertical-align: middle;
  visibility: hidden;
  width: 16px;
}

.blocklyTreeIconClosed {
  background-position: -32px -1px;
}

.blocklyToolboxDiv[dir="RTL"] .blocklyTreeIconClosed {
  background-position: 0 -1px;
}

.blocklyTreeSelected>.blocklyTreeIconClosed {
  background-position: -32px -17px;
}

.blocklyToolboxDiv[dir="RTL"] .blocklyTreeSelected>.blocklyTreeIconClosed {
  background-position: 0 -17px;
}

.blocklyTreeIconOpen {
  background-position: -16px -1px;
}

.blocklyTreeSelected>.blocklyTreeIconOpen {
  background-position: -16px -17px;
}

.blocklyTreeLabel {
  cursor: default;
  font: 16px sans-serif;
  padding: 0 3px;
  vertical-align: middle;
}

.blocklyToolboxDelete .blocklyTreeLabel {
  cursor: url("<<<PATH>>>/handdelete.cur"), auto;
}

.blocklyTreeSelected .blocklyTreeLabel {
  color: #fff;
}
`), i(se.TOOLBOX_ITEM, S.registrationName, S);
      var P = class extends u {
        constructor(e, t) {
          super(e, t), this.cssConfig_ = { container: "blocklyTreeSeparator" }, this.htmlDiv_ = null, Object.assign(this.cssConfig_, e.cssconfig || e.cssConfig);
        }
        init() {
          this.createDom_();
        }
        createDom_() {
          const e = document.createElement("div"), t = this.cssConfig_.container;
          return t && be(e, t), this.htmlDiv_ = e;
        }
        getDiv() {
          return this.htmlDiv_;
        }
        dispose() {
          Tt(this.htmlDiv_);
        }
      };
      P.registrationName = "sep", xn(`
.blocklyTreeSeparator {
  border-bottom: solid #e5e5e5 1px;
  height: 0;
  margin: 5px 0;
}

.blocklyToolboxDiv[layout="h"] .blocklyTreeSeparator {
  border-right: solid #e5e5e5 1px;
  border-bottom: none;
  height: auto;
  margin: 0 5px 0 5px;
  padding: 5px 0;
  width: 0;
}
`), i(se.TOOLBOX_ITEM, P.registrationName, P);
      var O = class extends S {
        constructor(e, t, n) {
          super(e, t, n), this.subcategoriesDiv_ = null, this.expanded_ = !1, this.toolboxItems_ = [];
        }
        makeDefaultCssConfig_() {
          const e = super.makeDefaultCssConfig_();
          return e.contents = "blocklyToolboxContents", e;
        }
        parseContents_(e) {
          if ("custom" in e)
            this.flyoutItems_ = e.custom;
          else {
            const t = e.contents;
            if (t) {
              this.flyoutItems_ = [], e = !0;
              for (let n = 0; n < t.length; n++) {
                const o = t[n];
                !h(se.TOOLBOX_ITEM, o.kind) || o.kind.toLowerCase() === P.registrationName && e ? (this.flyoutItems_.push(o), e = !0) : (this.createToolboxItem_(o), e = !1);
              }
            }
          }
        }
        createToolboxItem_(e) {
          let t = e.kind;
          t.toUpperCase() === "CATEGORY" && Vo(e) && (t = O.registrationName), e = new (L(se.TOOLBOX_ITEM, t))(e, this.parentToolbox_, this), this.toolboxItems_.push(e);
        }
        init() {
          super.init(), this.setExpanded(this.toolboxItemDef_.expanded === "true" || this.toolboxItemDef_.expanded === !0);
        }
        createDom_() {
          super.createDom_();
          const e = this.getChildToolboxItems();
          return this.subcategoriesDiv_ = this.createSubCategoriesDom_(e), an(this.subcategoriesDiv_, mn.GROUP), this.htmlDiv_.appendChild(this.subcategoriesDiv_), this.closeIcon_(this.iconDom_), Mt(this.htmlDiv_, Ot.EXPANDED, !1), this.htmlDiv_;
        }
        createIconDom_() {
          const e = document.createElement("span");
          if (!this.parentToolbox_.isHorizontal()) {
            const t = this.cssConfig_.icon;
            t && be(e, t), e.style.visibility = "visible";
          }
          return e.style.display = "inline-block", e;
        }
        createSubCategoriesDom_(e) {
          const t = document.createElement("div");
          t.style.display = "none";
          var n = this.cssConfig_.contents;
          for (n && be(t, n), n = 0; n < e.length; n++) {
            const o = e[n];
            o.init();
            const c = o.getDiv();
            if (t.appendChild(c), o.getClickTarget) {
              let A;
              (A = o.getClickTarget()) == null || A.setAttribute("id", o.getId());
            }
          }
          return t;
        }
        setExpanded(e) {
          this.expanded_ !== e && ((this.expanded_ = e) ? (this.subcategoriesDiv_.style.display = "block", this.openIcon_(this.iconDom_)) : (this.subcategoriesDiv_.style.display = "none", this.closeIcon_(this.iconDom_)), Mt(
            this.htmlDiv_,
            Ot.EXPANDED,
            e
          ), this.parentToolbox_.handleToolboxItemResize());
        }
        setVisible_(e) {
          this.htmlDiv_.style.display = e ? "block" : "none";
          const t = this.getChildToolboxItems();
          for (let n = 0; n < t.length; n++)
            t[n].setVisible_(e);
          this.isHidden_ = !e, this.parentToolbox_.getSelectedItem() === this && this.parentToolbox_.clearSelection();
        }
        isExpanded() {
          return this.expanded_;
        }
        isCollapsible() {
          return !0;
        }
        onClick(e) {
          this.toggleExpanded();
        }
        toggleExpanded() {
          this.setExpanded(!this.expanded_);
        }
        getDiv() {
          return this.htmlDiv_;
        }
        getChildToolboxItems() {
          return this.toolboxItems_;
        }
      };
      O.registrationName = "collapsibleCategory", i(se.TOOLBOX_ITEM, O.registrationName, O);
      var v = class extends kc {
        constructor(e) {
          super(), this.id = "toolbox", this.contentsDiv_ = this.HtmlDiv = null, this.isVisible_ = !1, this.contents_ = [], this.height_ = this.width_ = 0, this.previouslySelectedItem_ = this.selectedItem_ = this.flyout_ = null, this.boundEvents_ = [], this.workspace_ = e, this.toolboxDef_ = e.options.languageTree || { contents: [] }, this.horizontalLayout_ = e.options.horizontalLayout, this.RTL = e.options.RTL, this.contentMap_ = /* @__PURE__ */ Object.create(null), this.toolboxPosition = e.options.toolboxPosition;
        }
        onShortcut(e) {
          return !1;
        }
        init() {
          var e = this.workspace_;
          const t = e.getParentSvg();
          this.flyout_ = this.createFlyout_(), this.HtmlDiv = this.createDom_(this.workspace_), Sr(this.flyout_.createDom("svg"), t), this.setVisible(!0), this.flyout_.init(e), this.render(this.toolboxDef_), e = e.getThemeManager(), e.subscribe(this.HtmlDiv, "toolboxBackgroundColour", "background-color"), e.subscribe(
            this.HtmlDiv,
            "toolboxForegroundColour",
            "color"
          ), this.workspace_.getComponentManager().addComponent({ component: this, weight: 1, capabilities: [Lt.Capability.AUTOHIDEABLE, Lt.Capability.DELETE_AREA, Lt.Capability.DRAG_TARGET] });
        }
        createDom_(e) {
          e = e.getParentSvg();
          const t = this.createContainer_();
          return this.contentsDiv_ = this.createContentsContainer_(), this.contentsDiv_.tabIndex = 0, an(
            this.contentsDiv_,
            mn.TREE
          ), t.appendChild(this.contentsDiv_), e.parentNode.insertBefore(t, e), this.attachEvents_(t, this.contentsDiv_), t;
        }
        createContainer_() {
          const e = document.createElement("div");
          return e.setAttribute("layout", this.isHorizontal() ? "h" : "v"), be(e, "blocklyToolboxDiv"), be(e, "blocklyNonSelectable"), e.setAttribute("dir", this.RTL ? "RTL" : "LTR"), e;
        }
        createContentsContainer_() {
          const e = document.createElement("div");
          return be(e, "blocklyToolboxContents"), this.isHorizontal() && (e.style.flexDirection = "row"), e;
        }
        attachEvents_(e, t) {
          e = Pe(e, "pointerdown", this, this.onClick_, !1), this.boundEvents_.push(e), t = Pe(t, "keydown", this, this.onKeyDown_, !1), this.boundEvents_.push(t);
        }
        onClick_(e) {
          if (Ui(e) || e.target === this.HtmlDiv)
            Te().hideChaff(!1);
          else {
            var t = e.target.getAttribute("id");
            t && (t = this.getToolboxItemById(t), t.isSelectable() && (this.setSelectedItem(t), t.onClick(e))), Te().hideChaff(!0);
          }
          me();
        }
        onKeyDown_(e) {
          let t = !1;
          switch (e.key) {
            case "ArrowDown":
              t = this.selectNext_();
              break;
            case "ArrowUp":
              t = this.selectPrevious_();
              break;
            case "ArrowLeft":
              t = this.selectParent_();
              break;
            case "ArrowRight":
              t = this.selectChild_();
              break;
            case "Enter":
            case " ":
              this.selectedItem_ && this.selectedItem_.isCollapsible() && (this.selectedItem_.toggleExpanded(), t = !0);
              break;
            default:
              t = !1;
          }
          !t && this.selectedItem_ && this.selectedItem_.onKeyDown && (t = this.selectedItem_.onKeyDown(e)), t && e.preventDefault();
        }
        createFlyout_() {
          const e = this.workspace_, t = new qn({ parentWorkspace: e, rtl: e.RTL, oneBasedIndex: e.options.oneBasedIndex, horizontalLayout: e.horizontalLayout, renderer: e.options.renderer, rendererOverrides: e.options.rendererOverrides, move: { scrollbars: !0 } });
          return t.toolboxPosition = e.options.toolboxPosition, new (e.horizontalLayout ? Z(se.FLYOUTS_HORIZONTAL_TOOLBOX, e.options, !0) : Z(se.FLYOUTS_VERTICAL_TOOLBOX, e.options, !0))(t);
        }
        render(e) {
          this.toolboxDef_ = e;
          for (let t = 0; t < this.contents_.length; t++) {
            const n = this.contents_[t];
            n && n.dispose();
          }
          this.contents_ = [], this.contentMap_ = /* @__PURE__ */ Object.create(null), this.renderContents_(e.contents), this.position(), this.handleToolboxItemResize();
        }
        renderContents_(e) {
          const t = document.createDocumentFragment();
          for (let n = 0; n < e.length; n++)
            this.createToolboxItem_(e[n], t);
          this.contentsDiv_.appendChild(t);
        }
        createToolboxItem_(e, t) {
          var n = e.kind;
          n.toUpperCase() === "CATEGORY" && Vo(e) && (n = O.registrationName), (n = L(
            se.TOOLBOX_ITEM,
            n.toLowerCase()
          )) && (e = new n(e, this), e.init(), this.addToolboxItem_(e), (n = e.getDiv()) && t.appendChild(n), e.getClickTarget() && e.getClickTarget().setAttribute("id", e.getId()));
        }
        addToolboxItem_(e) {
          if (this.contents_.push(e), this.contentMap_[e.getId()] = e, e.isCollapsible()) {
            e = e.getChildToolboxItems();
            for (let t = 0; t < e.length; t++)
              this.addToolboxItem_(e[t]);
          }
        }
        getToolboxItems() {
          return this.contents_;
        }
        addStyle(e) {
          e && this.HtmlDiv && be(this.HtmlDiv, e);
        }
        removeStyle(e) {
          e && this.HtmlDiv && Be(this.HtmlDiv, e);
        }
        getClientRect() {
          if (!this.HtmlDiv || !this.isVisible_)
            return null;
          var e = this.HtmlDiv.getBoundingClientRect();
          const t = e.top, n = t + e.height, o = e.left;
          return e = o + e.width, this.toolboxPosition === Ue.TOP ? new Dt(-1e7, n, -1e7, 1e7) : this.toolboxPosition === Ue.BOTTOM ? new Dt(t, 1e7, -1e7, 1e7) : this.toolboxPosition === Ue.LEFT ? new Dt(-1e7, 1e7, -1e7, e) : new Dt(-1e7, 1e7, o, 1e7);
        }
        wouldDelete(e, t) {
          return e instanceof kn ? this.updateWouldDelete_(!e.getParent() && e.isDeletable()) : this.updateWouldDelete_(e.isDeletable()), this.wouldDelete_;
        }
        onDragEnter(e) {
          this.updateCursorDeleteStyle_(!0);
        }
        onDragExit(e) {
          this.updateCursorDeleteStyle_(!1);
        }
        onDrop(e) {
          this.updateCursorDeleteStyle_(!1);
        }
        updateWouldDelete_(e) {
          e !== this.wouldDelete_ && (this.updateCursorDeleteStyle_(!1), this.wouldDelete_ = e, this.updateCursorDeleteStyle_(!0));
        }
        updateCursorDeleteStyle_(e) {
          const t = this.wouldDelete_ ? "blocklyToolboxDelete" : "blocklyToolboxGrab";
          e ? this.addStyle(t) : this.removeStyle(t);
        }
        getToolboxItemById(e) {
          return this.contentMap_[e] || null;
        }
        getWidth() {
          return this.width_;
        }
        getHeight() {
          return this.height_;
        }
        getFlyout() {
          return this.flyout_;
        }
        getWorkspace() {
          return this.workspace_;
        }
        getSelectedItem() {
          return this.selectedItem_;
        }
        getPreviouslySelectedItem() {
          return this.previouslySelectedItem_;
        }
        isHorizontal() {
          return this.horizontalLayout_;
        }
        position() {
          const e = this.workspace_.getMetrics(), t = this.HtmlDiv;
          t && (this.horizontalLayout_ ? (t.style.left = "0", t.style.height = "auto", t.style.width = "100%", this.height_ = t.offsetHeight, this.width_ = e.viewWidth, this.toolboxPosition === Ue.TOP ? t.style.top = "0" : t.style.bottom = "0") : (this.toolboxPosition === Ue.RIGHT ? t.style.right = "0" : t.style.left = "0", t.style.height = "100%", this.width_ = t.offsetWidth, this.height_ = e.viewHeight), this.flyout_.position());
        }
        handleToolboxItemResize() {
          const e = this.workspace_, t = this.HtmlDiv.getBoundingClientRect();
          e.translate(this.toolboxPosition === Ue.LEFT ? e.scrollX + t.width : e.scrollX, this.toolboxPosition === Ue.TOP ? e.scrollY + t.height : e.scrollY), Je(e);
        }
        clearSelection() {
          this.setSelectedItem(null);
        }
        refreshTheme() {
          for (let e = 0; e < this.contents_.length; e++) {
            const t = this.contents_[e];
            t.refreshTheme && t.refreshTheme();
          }
        }
        refreshSelection() {
          this.selectedItem_ && this.selectedItem_.isSelectable() && this.selectedItem_.getContents().length && this.flyout_.show(this.selectedItem_.getContents());
        }
        setVisible(e) {
          this.isVisible_ !== e && (this.HtmlDiv.style.display = e ? "block" : "none", this.isVisible_ = e, this.workspace_.recordDragTargets());
        }
        autoHide(e) {
          !e && this.flyout_ && this.flyout_.autoClose && this.clearSelection();
        }
        setSelectedItem(e) {
          const t = this.selectedItem_;
          !e && !t || e && !mu(e) || (this.shouldDeselectItem_(
            t,
            e
          ) && t !== null && this.deselectItem_(t), this.shouldSelectItem_(t, e) && e !== null && this.selectItem_(t, e), this.updateFlyout_(t, e), this.fireSelectEvent_(t, e));
        }
        shouldDeselectItem_(e, t) {
          return e !== null && (!e.isCollapsible() || e !== t);
        }
        shouldSelectItem_(e, t) {
          return t !== null && t !== e;
        }
        deselectItem_(e) {
          this.selectedItem_ = null, this.previouslySelectedItem_ = e, e.setSelected(!1), Mt(this.contentsDiv_, Ot.ACTIVEDESCENDANT, "");
        }
        selectItem_(e, t) {
          this.selectedItem_ = t, this.previouslySelectedItem_ = e, t.setSelected(!0), Mt(this.contentsDiv_, Ot.ACTIVEDESCENDANT, t.getId());
        }
        selectItemByPosition(e) {
          -1 < e && e < this.contents_.length && (e = this.contents_[e], e.isSelectable() && this.setSelectedItem(e));
        }
        updateFlyout_(e, t) {
          t && (e !== t || t.isCollapsible()) && t.getContents().length ? (this.flyout_.show(t.getContents()), this.flyout_.scrollToStart()) : this.flyout_.hide();
        }
        fireSelectEvent_(e, t) {
          const n = e && e.getName();
          let o = t && t.getName();
          e === t && (o = null), e = new (ge(ro))(n, o, this.workspace_.id), fe(e);
        }
        selectParent_() {
          return this.selectedItem_ ? this.selectedItem_.isCollapsible() && this.selectedItem_.isExpanded() ? (this.selectedItem_.toggleExpanded(), !0) : this.selectedItem_.getParent() && this.selectedItem_.getParent().isSelectable() ? (this.setSelectedItem(this.selectedItem_.getParent()), !0) : !1 : !1;
        }
        selectChild_() {
          if (!this.selectedItem_ || !this.selectedItem_.isCollapsible())
            return !1;
          const e = this.selectedItem_;
          return e.isExpanded() ? this.selectNext_() : e.toggleExpanded(), !0;
        }
        selectNext_() {
          if (!this.selectedItem_)
            return !1;
          let e = this.contents_.indexOf(this.selectedItem_) + 1;
          if (-1 < e && e < this.contents_.length) {
            let t = this.contents_[e];
            for (; t && !t.isSelectable(); )
              t = this.contents_[++e];
            if (t && t.isSelectable())
              return this.setSelectedItem(t), !0;
          }
          return !1;
        }
        selectPrevious_() {
          if (!this.selectedItem_)
            return !1;
          let e = this.contents_.indexOf(this.selectedItem_) - 1;
          if (-1 < e && e < this.contents_.length) {
            let t = this.contents_[e];
            for (; t && !t.isSelectable(); )
              t = this.contents_[--e];
            if (t && t.isSelectable())
              return this.setSelectedItem(t), !0;
          }
          return !1;
        }
        dispose() {
          this.workspace_.getComponentManager().removeComponent("toolbox"), this.flyout_.dispose();
          for (var e = 0; e < this.contents_.length; e++)
            this.contents_[e].dispose();
          for (e = 0; e < this.boundEvents_.length; e++)
            It(this.boundEvents_[e]);
          this.boundEvents_ = [], this.contents_ = [], this.HtmlDiv && (this.workspace_.getThemeManager().unsubscribe(this.HtmlDiv), Tt(this.HtmlDiv));
        }
      };
      xn(`
.blocklyToolboxDelete {
  cursor: url("<<<PATH>>>/handdelete.cur"), auto;
}

.blocklyToolboxGrab {
  cursor: url("<<<PATH>>>/handclosed.cur"), auto;
  cursor: grabbing;
  cursor: -webkit-grabbing;
}

/* Category tree in Toolbox. */
.blocklyToolboxDiv {
  background-color: #ddd;
  overflow-x: visible;
  overflow-y: auto;
  padding: 4px 0 4px 0;
  position: absolute;
  z-index: 70;  /* so blocks go under toolbox when dragging */
  -webkit-tap-highlight-color: transparent;  /* issue #1345 */
}

.blocklyToolboxContents {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}

.blocklyToolboxContents:focus {
  outline: none;
}
`), i(se.TOOLBOX, w_, v);
      var F = class extends kc {
        constructor(e) {
          super(), this.workspace = e, this.id = "trashcan", this.contents = [], this.flyout = null, this.isLidOpen = !1, this.minOpenness = 0, this.lidTask = this.svgLid = this.svgGroup = null, this.top = this.left = this.lidOpen = 0, this.initialized = !1, 0 >= this.workspace.options.maxTrashcanContents || (e = new qn({
            scrollbars: !0,
            parentWorkspace: this.workspace,
            rtl: this.workspace.RTL,
            oneBasedIndex: this.workspace.options.oneBasedIndex,
            renderer: this.workspace.options.renderer,
            rendererOverrides: this.workspace.options.rendererOverrides,
            move: { scrollbars: !0 }
          }), this.workspace.horizontalLayout ? (e.toolboxPosition = this.workspace.toolboxPosition === Ue.TOP ? Ue.BOTTOM : Ue.TOP, this.flyout = new (Z(
            se.FLYOUTS_HORIZONTAL_TOOLBOX,
            this.workspace.options,
            !0
          ))(e)) : (e.toolboxPosition = this.workspace.toolboxPosition === Ue.RIGHT ? Ue.LEFT : Ue.RIGHT, this.flyout = new (Z(se.FLYOUTS_VERTICAL_TOOLBOX, this.workspace.options, !0))(e)), this.workspace.addChangeListener(this.onDelete.bind(this)));
        }
        createDom() {
          this.svgGroup = K(
            U.G,
            { class: "blocklyTrash" }
          );
          let e;
          const t = String(Math.random()).substring(2);
          e = K(U.CLIPPATH, { id: "blocklyTrashBodyClipPath" + t }, this.svgGroup), K(U.RECT, { width: x, height: re, y: te }, e);
          const n = K(
            U.IMAGE,
            { width: gt.width, x: -We, height: gt.height, y: -ze, "clip-path": "url(#blocklyTrashBodyClipPath" + t + ")" },
            this.svgGroup
          );
          return n.setAttributeNS($n, "xlink:href", this.workspace.options.pathToMedia + gt.url), e = K(
            U.CLIPPATH,
            { id: "blocklyTrashLidClipPath" + t },
            this.svgGroup
          ), K(U.RECT, { width: x, height: te }, e), this.svgLid = K(U.IMAGE, {
            width: gt.width,
            x: -We,
            height: gt.height,
            y: -ze,
            "clip-path": "url(#blocklyTrashLidClipPath" + t + ")"
          }, this.svgGroup), this.svgLid.setAttributeNS($n, "xlink:href", this.workspace.options.pathToMedia + gt.url), hr(this.svgGroup, "pointerdown", this, this.blockMouseDownWhenOpenable), hr(this.svgGroup, "pointerup", this, this.click), hr(n, "pointerover", this, this.mouseOver), hr(
            n,
            "pointerout",
            this,
            this.mouseOut
          ), this.animateLid(), this.svgGroup;
        }
        init() {
          0 < this.workspace.options.maxTrashcanContents && (Sr(this.flyout.createDom(U.SVG), this.workspace.getParentSvg()), this.flyout.init(this.workspace)), this.workspace.getComponentManager().addComponent({ component: this, weight: 1, capabilities: [
            Lt.Capability.AUTOHIDEABLE,
            Lt.Capability.DELETE_AREA,
            Lt.Capability.DRAG_TARGET,
            Lt.Capability.POSITIONABLE
          ] }), this.initialized = !0, this.setLidOpen(!1);
        }
        dispose() {
          this.workspace.getComponentManager().removeComponent("trashcan"), this.svgGroup && Tt(this.svgGroup), this.lidTask && clearTimeout(this.lidTask);
        }
        hasContents() {
          return !!this.contents.length;
        }
        contentsIsOpen() {
          return !!this.flyout && this.flyout.isVisible();
        }
        openFlyout() {
          if (!this.contentsIsOpen()) {
            var e = this.contents.map(function(n) {
              return JSON.parse(n);
            }), t = this.workspace.getParentSvg().style;
            t.cursor = "wait", setTimeout(() => {
              let n;
              (n = this.flyout) == null || n.show(e), t.cursor = "";
            }, 10), this.fireUiEvent(!0);
          }
        }
        closeFlyout() {
          if (this.contentsIsOpen()) {
            var e;
            (e = this.flyout) == null || e.hide(), this.fireUiEvent(!1), this.workspace.recordDragTargets();
          }
        }
        autoHide(e) {
          !e && this.flyout && this.closeFlyout();
        }
        emptyContents() {
          this.hasContents() && (this.contents.length = 0, this.setMinOpenness(0), this.closeFlyout());
        }
        position(e, t) {
          if (this.initialized) {
            var n = gr(this.workspace, e);
            e = pl(n, new ht(x, re + te), Se, oe, e, this.workspace), t = ZT(
              e,
              oe,
              n.vertical === L_.TOP ? Mo.DOWN : Mo.UP,
              t
            ), this.top = t.top, this.left = t.left;
            var o;
            (o = this.svgGroup) == null || o.setAttribute("transform", "translate(" + this.left + "," + this.top + ")");
          }
        }
        getBoundingRectangle() {
          return new Dt(this.top, this.top + re + te, this.left, this.left + x);
        }
        getClientRect() {
          if (!this.svgGroup)
            return null;
          var e = this.svgGroup.getBoundingClientRect();
          const t = e.top + ze - Ne;
          return e = e.left + We - Ne, new Dt(t, t + te + re + 2 * Ne, e, e + x + 2 * Ne);
        }
        onDragOver(e) {
          this.setLidOpen(this.wouldDelete_);
        }
        onDragExit(e) {
          this.setLidOpen(!1);
        }
        onDrop(e) {
          setTimeout(this.setLidOpen.bind(this, !1), 100);
        }
        setLidOpen(e) {
          this.isLidOpen !== e && (this.lidTask && clearTimeout(this.lidTask), this.isLidOpen = e, this.animateLid());
        }
        animateLid() {
          const e = st;
          var t = 1 / (e + 1);
          this.lidOpen += this.isLidOpen ? t : -t, this.lidOpen = Math.min(Math.max(this.lidOpen, this.minOpenness), 1), this.setLidAngle(this.lidOpen * Ln), t = Dn + this.lidOpen * (rn - Dn), this.svgGroup && (this.svgGroup.style.opacity = `${t}`), this.lidOpen > this.minOpenness && 1 > this.lidOpen && (this.lidTask = setTimeout(this.animateLid.bind(this), it / e));
        }
        setLidAngle(e) {
          const t = this.workspace.toolboxPosition === Ue.RIGHT || this.workspace.horizontalLayout && this.workspace.RTL;
          let n;
          (n = this.svgLid) == null || n.setAttribute("transform", "rotate(" + (t ? -e : e) + "," + (t ? 4 : x - 4) + "," + (te - 2) + ")");
        }
        setMinOpenness(e) {
          this.minOpenness = e, this.isLidOpen || this.setLidAngle(e * Ln);
        }
        closeLid() {
          this.setLidOpen(!1);
        }
        click() {
          this.hasContents() && this.openFlyout();
        }
        fireUiEvent(e) {
          e = new (ge(to))(e, this.workspace.id), fe(e);
        }
        blockMouseDownWhenOpenable(e) {
          !this.contentsIsOpen() && this.hasContents() && e.stopPropagation();
        }
        mouseOver() {
          this.hasContents() && this.setLidOpen(!0);
        }
        mouseOut() {
          this.setLidOpen(!1);
        }
        onDelete(e) {
          if (!(0 >= this.workspace.options.maxTrashcanContents || e.type !== r.DELETE$$module$build$src$core$events$utils || e.type !== r.DELETE$$module$build$src$core$events$utils || e.wasShadow)) {
            if (!e.oldJson)
              throw Error("Encountered a delete event without proper oldJson");
            if (e = JSON.stringify(this.cleanBlockJson(e.oldJson)), this.contents.indexOf(e) === -1) {
              for (this.contents.unshift(e); this.contents.length > this.workspace.options.maxTrashcanContents; )
                this.contents.pop();
              this.setMinOpenness(Fe);
            }
          }
        }
        cleanBlockJson(e) {
          function t(n) {
            if (n) {
              if (delete n.id, delete n.x, delete n.y, delete n.enabled, n.icons && n.icons.comment) {
                var o = n.icons.comment;
                delete o.height, delete o.width, delete o.pinned;
              }
              o = n.inputs;
              for (var c in o) {
                var A = o[c];
                const D = A.block;
                A = A.shadow, D && t(D), A && t(A);
              }
              n.next && (c = n.next, n = c.block, c = c.shadow, n && t(n), c && t(c));
            }
          }
          return e = JSON.parse(JSON.stringify(e)), t(e), Object.assign({}, { kind: "BLOCK" }, e);
        }
      }, x = 47, re = 44, te = 16, oe = 20, Se = 20, Ne = 10, We = 0, ze = 32, Fe = 0.1, it = 80, st = 4, Dn = 0.4, rn = 0.8, Ln = 45, cr = "10.0.2", f_ = r.Align$$module$build$src$core$inputs$align.LEFT, $i = r.Align$$module$build$src$core$inputs$align.CENTRE, Qd = r.Align$$module$build$src$core$inputs$align.RIGHT, LM = Ie.INPUT_VALUE, gM = Ie.OUTPUT_VALUE, fM = Ie.NEXT_STATEMENT, NM = Ie.PREVIOUS_STATEMENT, bM = r.inputTypes$$module$build$src$core$inputs$input_types.DUMMY, CM = Ue.TOP, OM = Ue.BOTTOM, RM = Ue.LEFT, yM = Ue.RIGHT;
      xl.prototype.newBlock = function(e, t) {
        return new As(this, e, t);
      }, g_.prototype.newBlock = function(e, t) {
        return new kn(this, e, t);
      }, g_.newTrashcan = function(e) {
        return new F(e);
      }, yr.prototype.showContextMenu = function(e) {
        if (!this.workspace.options.readOnly) {
          var t = [];
          this.isDeletable() && this.isMovable() && (t.push(qp(this)), t.push(Qp(this))), Cn(e, t, this.RTL);
        }
      }, Ci.prototype.newWorkspaceSvg = function(e) {
        return new g_(e);
      }, r.Names$$module$build$src$core$names.prototype.populateProcedures = function(e) {
        e = al(e), e = e[0].concat(e[1]);
        for (let t = 0; t < e.length; t++)
          this.getName(e[t][0], r.Names$$module$build$src$core$names.NameType.PROCEDURE);
      };
      var vM = Ie, j = {};
      return j.ALIGN_CENTRE = $i, j.ALIGN_LEFT = f_, j.ALIGN_RIGHT = Qd, j.ASTNode = ne, j.BasicCursor = Ss, j.Block = As, j.BlockDragger = dd, j.BlockSvg = kn, j.Blocks = jr, j.Bubble = Xe, j.BubbleDragger = Is, j.COLLAPSED_FIELD_NAME = Tc, j.COLLAPSED_INPUT_NAME = Ts, j.COLLAPSE_CHARS = hd, j.CodeGenerator = r.CodeGenerator$$module$build$src$core$generator, j.CollapsibleToolboxCategory = O, j.ComponentManager = Lt, j.Connection = lt, j.ConnectionChecker = bc, j.ConnectionDB = Ms, j.ConnectionType = Ie, j.ContextMenu = J_, j.ContextMenuItems = tn, j.ContextMenuRegistry = ct, j.Css = _c, j.Cursor = Gt, j.DELETE_VARIABLE_ID = Nc, j.DRAG_STACK = fc, j.DUMMY_INPUT = bM, j.DeleteArea = kc, j.DragTarget = Od, j.DropDownDiv = tr, j.Events = he, j.Extensions = e_, j.Field = _t, j.FieldAngle = Qe, j.FieldCheckbox = IT, j.FieldColour = wn, j.FieldDropdown = X_, j.FieldImage = hT, j.FieldLabel = K_, j.FieldLabelSerializable = Rd, j.FieldMultilineInput = ME, j.FieldNumber = mE, j.FieldTextInput = Ps, j.FieldVariable = Gl, j.Flyout = Uc, j.FlyoutButton = D_, j.FlyoutMetricsManager = yd, j.Generator = r.CodeGenerator$$module$build$src$core$generator, j.Gesture = yi, j.Grid = LE, j.HorizontalFlyout = Vc, j.INPUT_VALUE = LM, j.Input = Oi, j.InsertionMarkerManager = $e, j.Marker = Vt, j.MarkerManager = fl, j.Menu = Ju, j.MenuItem = ju, j.MetricsManager = PE, j.Msg = r.Msg$$module$build$src$core$msg, j.NEXT_STATEMENT = fM, j.Names = r.Names$$module$build$src$core$names, j.OPPOSITE_TYPE = dT, j.OUTPUT_VALUE = gM, j.Options = qn, j.PREVIOUS_STATEMENT = NM, j.PROCEDURE_CATEGORY_NAME = wc, j.Procedures = vr, j.RENAME_VARIABLE_ID = M_, j.RenderedConnection = qr, j.Scrollbar = Xt, j.ScrollbarPair = DE, j.ShortcutItems = Q_, j.ShortcutRegistry = Et, j.TOOLBOX_AT_BOTTOM = OM, j.TOOLBOX_AT_LEFT = RM, j.TOOLBOX_AT_RIGHT = yM, j.TOOLBOX_AT_TOP = CM, j.TabNavigateCursor = Id, j.Theme = AT, j.ThemeManager = Wd, j.Themes = l, j.Toolbox = v, j.ToolboxCategory = S, j.ToolboxItem = u, j.ToolboxSeparator = P, j.Tooltip = Pr, j.Touch = ye, j.Trashcan = F, j.UnattachedFieldError = nr, j.VARIABLE_CATEGORY_NAME = d_, j.VARIABLE_DYNAMIC_CATEGORY_NAME = Hl, j.VERSION = cr, j.VariableMap = Bc, j.VariableModel = rs, j.Variables = Er, j.VariablesDynamic = vi, j.VerticalFlyout = gE, j.WidgetDiv = x_, j.Workspace = xl, j.WorkspaceAudio = kd, j.WorkspaceComment = U_, j.WorkspaceCommentSvg = yr, j.WorkspaceDragger = vd, j.WorkspaceSvg = g_, j.Xml = Sn, j.ZoomControls = Yc, j.blockAnimations = $l, j.blockRendering = dt, j.browserEvents = gi, j.bubbles = hs, j.bumpObjects = Pc, j.clipboard = Wl, j.common = er, j.config = r.config$$module$build$src$core$config, j.connectionTypes = vM, j.constants = sc, j.defineBlocksWithJsonArray = Un, j.dialog = io, j.fieldRegistry = Ol, j.geras = z_, j.getMainWorkspace = Te, j.getSelected = we, j.hasBubble = Vi, j.hideChaff = Pu, j.icons = Io, j.inject = yA, j.inputTypes = r.inputTypes$$module$build$src$core$inputs$input_types, j.inputs = mT, j.isIcon = kA, j.isObservable = ll, j.isSerializable = Gn, j.isVariableBackedParameterModel = B, j.minimalist = Xl, j.procedures = vr, j.registry = Rn, j.renderManagement = nE, j.serialization = KS, j.setLocale = Za, j.setParentContainer = Zt, j.svgResize = Je, j.thrasos = NE, j.uiPosition = MT, j.utils = Bt, j.zelos = r_, Object.defineProperties(j, { HSV_SATURATION: { get: function() {
        return rT.warn("Blockly.HSV_SATURATION", "version 10", "version 11", "Blockly.utils.colour.getHsvSaturation()"), Yr.getHsvSaturation();
      }, set: function(e) {
        rT.warn("Blockly.HSV_SATURATION", "version 10", "version 11", "Blockly.utils.colour.setHsvSaturation()"), Yr.setHsvSaturation(e);
      } }, HSV_VALUE: { get: function() {
        return rT.warn(
          "Blockly.HSV_VALUE",
          "version 10",
          "version 11",
          "Blockly.utils.colour.getHsvValue()"
        ), Yr.getHsvValue();
      }, set: function(e) {
        rT.warn("Blockly.HSV_VALUE", "version 10", "version 11", "Blockly.utils.colour.setHsvValue()"), Yr.setHsvValue(e);
      } } }), "Blockly" in globalThis || (globalThis.Blockly = { Msg: nT }), j.__namespace__ = r, j;
    });
  }(eh)), eh.exports;
}
var i4;
function BM() {
  return i4 || (i4 = 1, function(_, s) {
    (function(r, i) {
      _.exports = i(yh());
    })(nn, function(r) {
      /**
       * @license
       * Copyright 2020 Google LLC
       * SPDX-License-Identifier: Apache-2.0
       */
      return r;
    });
  }(qS)), qS.exports;
}
var o4;
function aI() {
  return o4 || (o4 = 1, function(_, s) {
    (function(r, i) {
      _.exports = i(BM());
    })(nn, function(r) {
      return r;
    });
  }(QS)), QS.exports;
}
var th = { exports: {} }, T4;
function YM() {
  return T4 || (T4 = 1, function(_, s) {
    (function(r, i) {
      _.exports = i();
    })(nn, function() {
      var r = r || { Msg: /* @__PURE__ */ Object.create(null) };
      return r.Msg.ADD_COMMENT = "Add Comment", r.Msg.CANNOT_DELETE_VARIABLE_PROCEDURE = "Can't delete the variable '%1' because it's part of the definition of the function '%2'", r.Msg.CHANGE_VALUE_TITLE = "Change value:", r.Msg.CLEAN_UP = "Clean up Blocks", r.Msg.COLLAPSED_WARNINGS_WARNING = "Collapsed blocks contain warnings.", r.Msg.COLLAPSE_ALL = "Collapse Blocks", r.Msg.COLLAPSE_BLOCK = "Collapse Block", r.Msg.COLOUR_BLEND_COLOUR1 = "colour 1", r.Msg.COLOUR_BLEND_COLOUR2 = "colour 2", r.Msg.COLOUR_BLEND_HELPURL = "https://meyerweb.com/eric/tools/color-blend/#:::rgbp", r.Msg.COLOUR_BLEND_RATIO = "ratio", r.Msg.COLOUR_BLEND_TITLE = "blend", r.Msg.COLOUR_BLEND_TOOLTIP = "Blends two colours together with a given ratio (0.0 - 1.0).", r.Msg.COLOUR_PICKER_HELPURL = "https://en.wikipedia.org/wiki/Color", r.Msg.COLOUR_PICKER_TOOLTIP = "Choose a colour from the palette.", r.Msg.COLOUR_RANDOM_HELPURL = "http://randomcolour.com", r.Msg.COLOUR_RANDOM_TITLE = "random colour", r.Msg.COLOUR_RANDOM_TOOLTIP = "Choose a colour at random.", r.Msg.COLOUR_RGB_BLUE = "blue", r.Msg.COLOUR_RGB_GREEN = "green", r.Msg.COLOUR_RGB_HELPURL = "https://www.december.com/html/spec/colorpercompact.html", r.Msg.COLOUR_RGB_RED = "red", r.Msg.COLOUR_RGB_TITLE = "colour with", r.Msg.COLOUR_RGB_TOOLTIP = "Create a colour with the specified amount of red, green, and blue. All values must be between 0 and 100.", r.Msg.CONTROLS_FLOW_STATEMENTS_HELPURL = "https://github.com/google/blockly/wiki/Loops#loop-termination-blocks", r.Msg.CONTROLS_FLOW_STATEMENTS_OPERATOR_BREAK = "break out of loop", r.Msg.CONTROLS_FLOW_STATEMENTS_OPERATOR_CONTINUE = "continue with next iteration of loop", r.Msg.CONTROLS_FLOW_STATEMENTS_TOOLTIP_BREAK = "Break out of the containing loop.", r.Msg.CONTROLS_FLOW_STATEMENTS_TOOLTIP_CONTINUE = "Skip the rest of this loop, and continue with the next iteration.", r.Msg.CONTROLS_FLOW_STATEMENTS_WARNING = "Warning: This block may only be used within a loop.", r.Msg.CONTROLS_FOREACH_HELPURL = "https://github.com/google/blockly/wiki/Loops#for-each", r.Msg.CONTROLS_FOREACH_TITLE = "for each item %1 in list %2", r.Msg.CONTROLS_FOREACH_TOOLTIP = "For each item in a list, set the variable '%1' to the item, and then do some statements.", r.Msg.CONTROLS_FOR_HELPURL = "https://github.com/google/blockly/wiki/Loops#count-with", r.Msg.CONTROLS_FOR_TITLE = "count with %1 from %2 to %3 by %4", r.Msg.CONTROLS_FOR_TOOLTIP = "Have the variable '%1' take on the values from the start number to the end number, counting by the specified interval, and do the specified blocks.", r.Msg.CONTROLS_IF_ELSEIF_TOOLTIP = "Add a condition to the if block.", r.Msg.CONTROLS_IF_ELSE_TOOLTIP = "Add a final, catch-all condition to the if block.", r.Msg.CONTROLS_IF_HELPURL = "https://github.com/google/blockly/wiki/IfElse", r.Msg.CONTROLS_IF_IF_TOOLTIP = "Add, remove, or reorder sections to reconfigure this if block.", r.Msg.CONTROLS_IF_MSG_ELSE = "else", r.Msg.CONTROLS_IF_MSG_ELSEIF = "else if", r.Msg.CONTROLS_IF_MSG_IF = "if", r.Msg.CONTROLS_IF_TOOLTIP_1 = "If a value is true, then do some statements.", r.Msg.CONTROLS_IF_TOOLTIP_2 = "If a value is true, then do the first block of statements. Otherwise, do the second block of statements.", r.Msg.CONTROLS_IF_TOOLTIP_3 = "If the first value is true, then do the first block of statements. Otherwise, if the second value is true, do the second block of statements.", r.Msg.CONTROLS_IF_TOOLTIP_4 = "If the first value is true, then do the first block of statements. Otherwise, if the second value is true, do the second block of statements. If none of the values are true, do the last block of statements.", r.Msg.CONTROLS_REPEAT_HELPURL = "https://en.wikipedia.org/wiki/For_loop", r.Msg.CONTROLS_REPEAT_INPUT_DO = "do", r.Msg.CONTROLS_REPEAT_TITLE = "repeat %1 times", r.Msg.CONTROLS_REPEAT_TOOLTIP = "Do some statements several times.", r.Msg.CONTROLS_WHILEUNTIL_HELPURL = "https://github.com/google/blockly/wiki/Loops#repeat", r.Msg.CONTROLS_WHILEUNTIL_OPERATOR_UNTIL = "repeat until", r.Msg.CONTROLS_WHILEUNTIL_OPERATOR_WHILE = "repeat while", r.Msg.CONTROLS_WHILEUNTIL_TOOLTIP_UNTIL = "While a value is false, then do some statements.", r.Msg.CONTROLS_WHILEUNTIL_TOOLTIP_WHILE = "While a value is true, then do some statements.", r.Msg.DELETE_ALL_BLOCKS = "Delete all %1 blocks?", r.Msg.DELETE_BLOCK = "Delete Block", r.Msg.DELETE_VARIABLE = "Delete the '%1' variable", r.Msg.DELETE_VARIABLE_CONFIRMATION = "Delete %1 uses of the '%2' variable?", r.Msg.DELETE_X_BLOCKS = "Delete %1 Blocks", r.Msg.DIALOG_CANCEL = "Cancel", r.Msg.DIALOG_OK = "OK", r.Msg.DISABLE_BLOCK = "Disable Block", r.Msg.DUPLICATE_BLOCK = "Duplicate", r.Msg.DUPLICATE_COMMENT = "Duplicate Comment", r.Msg.ENABLE_BLOCK = "Enable Block", r.Msg.EXPAND_ALL = "Expand Blocks", r.Msg.EXPAND_BLOCK = "Expand Block", r.Msg.EXTERNAL_INPUTS = "External Inputs", r.Msg.HELP = "Help", r.Msg.INLINE_INPUTS = "Inline Inputs", r.Msg.LISTS_CREATE_EMPTY_HELPURL = "https://github.com/google/blockly/wiki/Lists#create-empty-list", r.Msg.LISTS_CREATE_EMPTY_TITLE = "create empty list", r.Msg.LISTS_CREATE_EMPTY_TOOLTIP = "Returns a list, of length 0, containing no data records", r.Msg.LISTS_CREATE_WITH_CONTAINER_TITLE_ADD = "list", r.Msg.LISTS_CREATE_WITH_CONTAINER_TOOLTIP = "Add, remove, or reorder sections to reconfigure this list block.", r.Msg.LISTS_CREATE_WITH_HELPURL = "https://github.com/google/blockly/wiki/Lists#create-list-with", r.Msg.LISTS_CREATE_WITH_INPUT_WITH = "create list with", r.Msg.LISTS_CREATE_WITH_ITEM_TOOLTIP = "Add an item to the list.", r.Msg.LISTS_CREATE_WITH_TOOLTIP = "Create a list with any number of items.", r.Msg.LISTS_GET_INDEX_FIRST = "first", r.Msg.LISTS_GET_INDEX_FROM_END = "# from end", r.Msg.LISTS_GET_INDEX_FROM_START = "#", r.Msg.LISTS_GET_INDEX_GET = "get", r.Msg.LISTS_GET_INDEX_GET_REMOVE = "get and remove", r.Msg.LISTS_GET_INDEX_LAST = "last", r.Msg.LISTS_GET_INDEX_RANDOM = "random", r.Msg.LISTS_GET_INDEX_REMOVE = "remove", r.Msg.LISTS_GET_INDEX_TAIL = "", r.Msg.LISTS_GET_INDEX_TOOLTIP_GET_FIRST = "Returns the first item in a list.", r.Msg.LISTS_GET_INDEX_TOOLTIP_GET_FROM = "Returns the item at the specified position in a list.", r.Msg.LISTS_GET_INDEX_TOOLTIP_GET_LAST = "Returns the last item in a list.", r.Msg.LISTS_GET_INDEX_TOOLTIP_GET_RANDOM = "Returns a random item in a list.", r.Msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FIRST = "Removes and returns the first item in a list.", r.Msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FROM = "Removes and returns the item at the specified position in a list.", r.Msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_LAST = "Removes and returns the last item in a list.", r.Msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_RANDOM = "Removes and returns a random item in a list.", r.Msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_FIRST = "Removes the first item in a list.", r.Msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_FROM = "Removes the item at the specified position in a list.", r.Msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_LAST = "Removes the last item in a list.", r.Msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_RANDOM = "Removes a random item in a list.", r.Msg.LISTS_GET_SUBLIST_END_FROM_END = "to # from end", r.Msg.LISTS_GET_SUBLIST_END_FROM_START = "to #", r.Msg.LISTS_GET_SUBLIST_END_LAST = "to last", r.Msg.LISTS_GET_SUBLIST_HELPURL = "https://github.com/google/blockly/wiki/Lists#getting-a-sublist", r.Msg.LISTS_GET_SUBLIST_START_FIRST = "get sub-list from first", r.Msg.LISTS_GET_SUBLIST_START_FROM_END = "get sub-list from # from end", r.Msg.LISTS_GET_SUBLIST_START_FROM_START = "get sub-list from #", r.Msg.LISTS_GET_SUBLIST_TAIL = "", r.Msg.LISTS_GET_SUBLIST_TOOLTIP = "Creates a copy of the specified portion of a list.", r.Msg.LISTS_INDEX_FROM_END_TOOLTIP = "%1 is the last item.", r.Msg.LISTS_INDEX_FROM_START_TOOLTIP = "%1 is the first item.", r.Msg.LISTS_INDEX_OF_FIRST = "find first occurrence of item", r.Msg.LISTS_INDEX_OF_HELPURL = "https://github.com/google/blockly/wiki/Lists#getting-items-from-a-list", r.Msg.LISTS_INDEX_OF_LAST = "find last occurrence of item", r.Msg.LISTS_INDEX_OF_TOOLTIP = "Returns the index of the first/last occurrence of the item in the list. Returns %1 if item is not found.", r.Msg.LISTS_INLIST = "in list", r.Msg.LISTS_ISEMPTY_HELPURL = "https://github.com/google/blockly/wiki/Lists#is-empty", r.Msg.LISTS_ISEMPTY_TITLE = "%1 is empty", r.Msg.LISTS_ISEMPTY_TOOLTIP = "Returns true if the list is empty.", r.Msg.LISTS_LENGTH_HELPURL = "https://github.com/google/blockly/wiki/Lists#length-of", r.Msg.LISTS_LENGTH_TITLE = "length of %1", r.Msg.LISTS_LENGTH_TOOLTIP = "Returns the length of a list.", r.Msg.LISTS_REPEAT_HELPURL = "https://github.com/google/blockly/wiki/Lists#create-list-with", r.Msg.LISTS_REPEAT_TITLE = "create list with item %1 repeated %2 times", r.Msg.LISTS_REPEAT_TOOLTIP = "Creates a list consisting of the given value repeated the specified number of times.", r.Msg.LISTS_REVERSE_HELPURL = "https://github.com/google/blockly/wiki/Lists#reversing-a-list", r.Msg.LISTS_REVERSE_MESSAGE0 = "reverse %1", r.Msg.LISTS_REVERSE_TOOLTIP = "Reverse a copy of a list.", r.Msg.LISTS_SET_INDEX_HELPURL = "https://github.com/google/blockly/wiki/Lists#in-list--set", r.Msg.LISTS_SET_INDEX_INPUT_TO = "as", r.Msg.LISTS_SET_INDEX_INSERT = "insert at", r.Msg.LISTS_SET_INDEX_SET = "set", r.Msg.LISTS_SET_INDEX_TOOLTIP_INSERT_FIRST = "Inserts the item at the start of a list.", r.Msg.LISTS_SET_INDEX_TOOLTIP_INSERT_FROM = "Inserts the item at the specified position in a list.", r.Msg.LISTS_SET_INDEX_TOOLTIP_INSERT_LAST = "Append the item to the end of a list.", r.Msg.LISTS_SET_INDEX_TOOLTIP_INSERT_RANDOM = "Inserts the item randomly in a list.", r.Msg.LISTS_SET_INDEX_TOOLTIP_SET_FIRST = "Sets the first item in a list.", r.Msg.LISTS_SET_INDEX_TOOLTIP_SET_FROM = "Sets the item at the specified position in a list.", r.Msg.LISTS_SET_INDEX_TOOLTIP_SET_LAST = "Sets the last item in a list.", r.Msg.LISTS_SET_INDEX_TOOLTIP_SET_RANDOM = "Sets a random item in a list.", r.Msg.LISTS_SORT_HELPURL = "https://github.com/google/blockly/wiki/Lists#sorting-a-list", r.Msg.LISTS_SORT_ORDER_ASCENDING = "ascending", r.Msg.LISTS_SORT_ORDER_DESCENDING = "descending", r.Msg.LISTS_SORT_TITLE = "sort %1 %2 %3", r.Msg.LISTS_SORT_TOOLTIP = "Sort a copy of a list.", r.Msg.LISTS_SORT_TYPE_IGNORECASE = "alphabetic, ignore case", r.Msg.LISTS_SORT_TYPE_NUMERIC = "numeric", r.Msg.LISTS_SORT_TYPE_TEXT = "alphabetic", r.Msg.LISTS_SPLIT_HELPURL = "https://github.com/google/blockly/wiki/Lists#splitting-strings-and-joining-lists", r.Msg.LISTS_SPLIT_LIST_FROM_TEXT = "make list from text", r.Msg.LISTS_SPLIT_TEXT_FROM_LIST = "make text from list", r.Msg.LISTS_SPLIT_TOOLTIP_JOIN = "Join a list of texts into one text, separated by a delimiter.", r.Msg.LISTS_SPLIT_TOOLTIP_SPLIT = "Split text into a list of texts, breaking at each delimiter.", r.Msg.LISTS_SPLIT_WITH_DELIMITER = "with delimiter", r.Msg.LOGIC_BOOLEAN_FALSE = "false", r.Msg.LOGIC_BOOLEAN_HELPURL = "https://github.com/google/blockly/wiki/Logic#values", r.Msg.LOGIC_BOOLEAN_TOOLTIP = "Returns either true or false.", r.Msg.LOGIC_BOOLEAN_TRUE = "true", r.Msg.LOGIC_COMPARE_HELPURL = "https://en.wikipedia.org/wiki/Inequality_(mathematics)", r.Msg.LOGIC_COMPARE_TOOLTIP_EQ = "Return true if both inputs equal each other.", r.Msg.LOGIC_COMPARE_TOOLTIP_GT = "Return true if the first input is greater than the second input.", r.Msg.LOGIC_COMPARE_TOOLTIP_GTE = "Return true if the first input is greater than or equal to the second input.", r.Msg.LOGIC_COMPARE_TOOLTIP_LT = "Return true if the first input is smaller than the second input.", r.Msg.LOGIC_COMPARE_TOOLTIP_LTE = "Return true if the first input is smaller than or equal to the second input.", r.Msg.LOGIC_COMPARE_TOOLTIP_NEQ = "Return true if both inputs are not equal to each other.", r.Msg.LOGIC_NEGATE_HELPURL = "https://github.com/google/blockly/wiki/Logic#not", r.Msg.LOGIC_NEGATE_TITLE = "not %1", r.Msg.LOGIC_NEGATE_TOOLTIP = "Returns true if the input is false. Returns false if the input is true.", r.Msg.LOGIC_NULL = "null", r.Msg.LOGIC_NULL_HELPURL = "https://en.wikipedia.org/wiki/Nullable_type", r.Msg.LOGIC_NULL_TOOLTIP = "Returns null.", r.Msg.LOGIC_OPERATION_AND = "and", r.Msg.LOGIC_OPERATION_HELPURL = "https://github.com/google/blockly/wiki/Logic#logical-operations", r.Msg.LOGIC_OPERATION_OR = "or", r.Msg.LOGIC_OPERATION_TOOLTIP_AND = "Return true if both inputs are true.", r.Msg.LOGIC_OPERATION_TOOLTIP_OR = "Return true if at least one of the inputs is true.", r.Msg.LOGIC_TERNARY_CONDITION = "test", r.Msg.LOGIC_TERNARY_HELPURL = "https://en.wikipedia.org/wiki/%3F:", r.Msg.LOGIC_TERNARY_IF_FALSE = "if false", r.Msg.LOGIC_TERNARY_IF_TRUE = "if true", r.Msg.LOGIC_TERNARY_TOOLTIP = "Check the condition in 'test'. If the condition is true, returns the 'if true' value; otherwise returns the 'if false' value.", r.Msg.MATH_ADDITION_SYMBOL = "+", r.Msg.MATH_ARITHMETIC_HELPURL = "https://en.wikipedia.org/wiki/Arithmetic", r.Msg.MATH_ARITHMETIC_TOOLTIP_ADD = "Return the sum of the two numbers.", r.Msg.MATH_ARITHMETIC_TOOLTIP_DIVIDE = "Return the quotient of the two numbers.", r.Msg.MATH_ARITHMETIC_TOOLTIP_MINUS = "Return the difference of the two numbers.", r.Msg.MATH_ARITHMETIC_TOOLTIP_MULTIPLY = "Return the product of the two numbers.", r.Msg.MATH_ARITHMETIC_TOOLTIP_POWER = "Return the first number raised to the power of the second number.", r.Msg.MATH_ATAN2_HELPURL = "https://en.wikipedia.org/wiki/Atan2", r.Msg.MATH_ATAN2_TITLE = "atan2 of X:%1 Y:%2", r.Msg.MATH_ATAN2_TOOLTIP = "Return the arctangent of point (X, Y) in degrees from -180 to 180.", r.Msg.MATH_CHANGE_HELPURL = "https://en.wikipedia.org/wiki/Programming_idiom#Incrementing_a_counter", r.Msg.MATH_CHANGE_TITLE = "change %1 by %2", r.Msg.MATH_CHANGE_TOOLTIP = "Add a number to variable '%1'.", r.Msg.MATH_CONSTANT_HELPURL = "https://en.wikipedia.org/wiki/Mathematical_constant", r.Msg.MATH_CONSTANT_TOOLTIP = "Return one of the common constants: π (3.141…), e (2.718…), φ (1.618…), sqrt(2) (1.414…), sqrt(½) (0.707…), or ∞ (infinity).", r.Msg.MATH_CONSTRAIN_HELPURL = "https://en.wikipedia.org/wiki/Clamping_(graphics)", r.Msg.MATH_CONSTRAIN_TITLE = "constrain %1 low %2 high %3", r.Msg.MATH_CONSTRAIN_TOOLTIP = "Constrain a number to be between the specified limits (inclusive).", r.Msg.MATH_DIVISION_SYMBOL = "÷", r.Msg.MATH_IS_DIVISIBLE_BY = "is divisible by", r.Msg.MATH_IS_EVEN = "is even", r.Msg.MATH_IS_NEGATIVE = "is negative", r.Msg.MATH_IS_ODD = "is odd", r.Msg.MATH_IS_POSITIVE = "is positive", r.Msg.MATH_IS_PRIME = "is prime", r.Msg.MATH_IS_TOOLTIP = "Check if a number is an even, odd, prime, whole, positive, negative, or if it is divisible by certain number. Returns true or false.", r.Msg.MATH_IS_WHOLE = "is whole", r.Msg.MATH_MODULO_HELPURL = "https://en.wikipedia.org/wiki/Modulo_operation", r.Msg.MATH_MODULO_TITLE = "remainder of %1 ÷ %2", r.Msg.MATH_MODULO_TOOLTIP = "Return the remainder from dividing the two numbers.", r.Msg.MATH_MULTIPLICATION_SYMBOL = "×", r.Msg.MATH_NUMBER_HELPURL = "https://en.wikipedia.org/wiki/Number", r.Msg.MATH_NUMBER_TOOLTIP = "A number.", r.Msg.MATH_ONLIST_HELPURL = "", r.Msg.MATH_ONLIST_OPERATOR_AVERAGE = "average of list", r.Msg.MATH_ONLIST_OPERATOR_MAX = "max of list", r.Msg.MATH_ONLIST_OPERATOR_MEDIAN = "median of list", r.Msg.MATH_ONLIST_OPERATOR_MIN = "min of list", r.Msg.MATH_ONLIST_OPERATOR_MODE = "modes of list", r.Msg.MATH_ONLIST_OPERATOR_RANDOM = "random item of list", r.Msg.MATH_ONLIST_OPERATOR_STD_DEV = "standard deviation of list", r.Msg.MATH_ONLIST_OPERATOR_SUM = "sum of list", r.Msg.MATH_ONLIST_TOOLTIP_AVERAGE = "Return the average (arithmetic mean) of the numeric values in the list.", r.Msg.MATH_ONLIST_TOOLTIP_MAX = "Return the largest number in the list.", r.Msg.MATH_ONLIST_TOOLTIP_MEDIAN = "Return the median number in the list.", r.Msg.MATH_ONLIST_TOOLTIP_MIN = "Return the smallest number in the list.", r.Msg.MATH_ONLIST_TOOLTIP_MODE = "Return a list of the most common item(s) in the list.", r.Msg.MATH_ONLIST_TOOLTIP_RANDOM = "Return a random element from the list.", r.Msg.MATH_ONLIST_TOOLTIP_STD_DEV = "Return the standard deviation of the list.", r.Msg.MATH_ONLIST_TOOLTIP_SUM = "Return the sum of all the numbers in the list.", r.Msg.MATH_POWER_SYMBOL = "^", r.Msg.MATH_RANDOM_FLOAT_HELPURL = "https://en.wikipedia.org/wiki/Random_number_generation", r.Msg.MATH_RANDOM_FLOAT_TITLE_RANDOM = "random fraction", r.Msg.MATH_RANDOM_FLOAT_TOOLTIP = "Return a random fraction between 0.0 (inclusive) and 1.0 (exclusive).", r.Msg.MATH_RANDOM_INT_HELPURL = "https://en.wikipedia.org/wiki/Random_number_generation", r.Msg.MATH_RANDOM_INT_TITLE = "random integer from %1 to %2", r.Msg.MATH_RANDOM_INT_TOOLTIP = "Return a random integer between the two specified limits, inclusive.", r.Msg.MATH_ROUND_HELPURL = "https://en.wikipedia.org/wiki/Rounding", r.Msg.MATH_ROUND_OPERATOR_ROUND = "round", r.Msg.MATH_ROUND_OPERATOR_ROUNDDOWN = "round down", r.Msg.MATH_ROUND_OPERATOR_ROUNDUP = "round up", r.Msg.MATH_ROUND_TOOLTIP = "Round a number up or down.", r.Msg.MATH_SINGLE_HELPURL = "https://en.wikipedia.org/wiki/Square_root", r.Msg.MATH_SINGLE_OP_ABSOLUTE = "absolute", r.Msg.MATH_SINGLE_OP_ROOT = "square root", r.Msg.MATH_SINGLE_TOOLTIP_ABS = "Return the absolute value of a number.", r.Msg.MATH_SINGLE_TOOLTIP_EXP = "Return e to the power of a number.", r.Msg.MATH_SINGLE_TOOLTIP_LN = "Return the natural logarithm of a number.", r.Msg.MATH_SINGLE_TOOLTIP_LOG10 = "Return the base 10 logarithm of a number.", r.Msg.MATH_SINGLE_TOOLTIP_NEG = "Return the negation of a number.", r.Msg.MATH_SINGLE_TOOLTIP_POW10 = "Return 10 to the power of a number.", r.Msg.MATH_SINGLE_TOOLTIP_ROOT = "Return the square root of a number.", r.Msg.MATH_SUBTRACTION_SYMBOL = "-", r.Msg.MATH_TRIG_ACOS = "acos", r.Msg.MATH_TRIG_ASIN = "asin", r.Msg.MATH_TRIG_ATAN = "atan", r.Msg.MATH_TRIG_COS = "cos", r.Msg.MATH_TRIG_HELPURL = "https://en.wikipedia.org/wiki/Trigonometric_functions", r.Msg.MATH_TRIG_SIN = "sin", r.Msg.MATH_TRIG_TAN = "tan", r.Msg.MATH_TRIG_TOOLTIP_ACOS = "Return the arccosine of a number.", r.Msg.MATH_TRIG_TOOLTIP_ASIN = "Return the arcsine of a number.", r.Msg.MATH_TRIG_TOOLTIP_ATAN = "Return the arctangent of a number.", r.Msg.MATH_TRIG_TOOLTIP_COS = "Return the cosine of a degree (not radian).", r.Msg.MATH_TRIG_TOOLTIP_SIN = "Return the sine of a degree (not radian).", r.Msg.MATH_TRIG_TOOLTIP_TAN = "Return the tangent of a degree (not radian).", r.Msg.NEW_COLOUR_VARIABLE = "Create colour variable...", r.Msg.NEW_NUMBER_VARIABLE = "Create number variable...", r.Msg.NEW_STRING_VARIABLE = "Create string variable...", r.Msg.NEW_VARIABLE = "Create variable...", r.Msg.NEW_VARIABLE_TITLE = "New variable name:", r.Msg.NEW_VARIABLE_TYPE_TITLE = "New variable type:", r.Msg.ORDINAL_NUMBER_SUFFIX = "", r.Msg.PROCEDURES_ALLOW_STATEMENTS = "allow statements", r.Msg.PROCEDURES_BEFORE_PARAMS = "with:", r.Msg.PROCEDURES_CALLNORETURN_HELPURL = "https://en.wikipedia.org/wiki/Subroutine", r.Msg.PROCEDURES_CALLNORETURN_TOOLTIP = "Run the user-defined function '%1'.", r.Msg.PROCEDURES_CALLRETURN_HELPURL = "https://en.wikipedia.org/wiki/Subroutine", r.Msg.PROCEDURES_CALLRETURN_TOOLTIP = "Run the user-defined function '%1' and use its output.", r.Msg.PROCEDURES_CALL_BEFORE_PARAMS = "with:", r.Msg.PROCEDURES_CREATE_DO = "Create '%1'", r.Msg.PROCEDURES_DEFNORETURN_COMMENT = "Describe this function...", r.Msg.PROCEDURES_DEFNORETURN_DO = "", r.Msg.PROCEDURES_DEFNORETURN_HELPURL = "https://en.wikipedia.org/wiki/Subroutine", r.Msg.PROCEDURES_DEFNORETURN_PROCEDURE = "do something", r.Msg.PROCEDURES_DEFNORETURN_TITLE = "to", r.Msg.PROCEDURES_DEFNORETURN_TOOLTIP = "Creates a function with no output.", r.Msg.PROCEDURES_DEFRETURN_HELPURL = "https://en.wikipedia.org/wiki/Subroutine", r.Msg.PROCEDURES_DEFRETURN_RETURN = "return", r.Msg.PROCEDURES_DEFRETURN_TOOLTIP = "Creates a function with an output.", r.Msg.PROCEDURES_DEF_DUPLICATE_WARNING = "Warning: This function has duplicate parameters.", r.Msg.PROCEDURES_HIGHLIGHT_DEF = "Highlight function definition", r.Msg.PROCEDURES_IFRETURN_HELPURL = "http://c2.com/cgi/wiki?GuardClause", r.Msg.PROCEDURES_IFRETURN_TOOLTIP = "If a value is true, then return a second value.", r.Msg.PROCEDURES_IFRETURN_WARNING = "Warning: This block may be used only within a function definition.", r.Msg.PROCEDURES_MUTATORARG_TITLE = "input name:", r.Msg.PROCEDURES_MUTATORARG_TOOLTIP = "Add an input to the function.", r.Msg.PROCEDURES_MUTATORCONTAINER_TITLE = "inputs", r.Msg.PROCEDURES_MUTATORCONTAINER_TOOLTIP = "Add, remove, or reorder inputs to this function.", r.Msg.REDO = "Redo", r.Msg.REMOVE_COMMENT = "Remove Comment", r.Msg.RENAME_VARIABLE = "Rename variable...", r.Msg.RENAME_VARIABLE_TITLE = "Rename all '%1' variables to:", r.Msg.TEXT_APPEND_HELPURL = "https://github.com/google/blockly/wiki/Text#text-modification", r.Msg.TEXT_APPEND_TITLE = "to %1 append text %2", r.Msg.TEXT_APPEND_TOOLTIP = "Append some text to variable '%1'.", r.Msg.TEXT_CHANGECASE_HELPURL = "https://github.com/google/blockly/wiki/Text#adjusting-text-case", r.Msg.TEXT_CHANGECASE_OPERATOR_LOWERCASE = "to lower case", r.Msg.TEXT_CHANGECASE_OPERATOR_TITLECASE = "to Title Case", r.Msg.TEXT_CHANGECASE_OPERATOR_UPPERCASE = "to UPPER CASE", r.Msg.TEXT_CHANGECASE_TOOLTIP = "Return a copy of the text in a different case.", r.Msg.TEXT_CHARAT_FIRST = "get first letter", r.Msg.TEXT_CHARAT_FROM_END = "get letter # from end", r.Msg.TEXT_CHARAT_FROM_START = "get letter #", r.Msg.TEXT_CHARAT_HELPURL = "https://github.com/google/blockly/wiki/Text#extracting-text", r.Msg.TEXT_CHARAT_LAST = "get last letter", r.Msg.TEXT_CHARAT_RANDOM = "get random letter", r.Msg.TEXT_CHARAT_TAIL = "", r.Msg.TEXT_CHARAT_TITLE = "in text %1 %2", r.Msg.TEXT_CHARAT_TOOLTIP = "Returns the letter at the specified position.", r.Msg.TEXT_COUNT_HELPURL = "https://github.com/google/blockly/wiki/Text#counting-substrings", r.Msg.TEXT_COUNT_MESSAGE0 = "count %1 in %2", r.Msg.TEXT_COUNT_TOOLTIP = "Count how many times some text occurs within some other text.", r.Msg.TEXT_CREATE_JOIN_ITEM_TOOLTIP = "Add an item to the text.", r.Msg.TEXT_CREATE_JOIN_TITLE_JOIN = "join", r.Msg.TEXT_CREATE_JOIN_TOOLTIP = "Add, remove, or reorder sections to reconfigure this text block.", r.Msg.TEXT_GET_SUBSTRING_END_FROM_END = "to letter # from end", r.Msg.TEXT_GET_SUBSTRING_END_FROM_START = "to letter #", r.Msg.TEXT_GET_SUBSTRING_END_LAST = "to last letter", r.Msg.TEXT_GET_SUBSTRING_HELPURL = "https://github.com/google/blockly/wiki/Text#extracting-a-region-of-text", r.Msg.TEXT_GET_SUBSTRING_INPUT_IN_TEXT = "in text", r.Msg.TEXT_GET_SUBSTRING_START_FIRST = "get substring from first letter", r.Msg.TEXT_GET_SUBSTRING_START_FROM_END = "get substring from letter # from end", r.Msg.TEXT_GET_SUBSTRING_START_FROM_START = "get substring from letter #", r.Msg.TEXT_GET_SUBSTRING_TAIL = "", r.Msg.TEXT_GET_SUBSTRING_TOOLTIP = "Returns a specified portion of the text.", r.Msg.TEXT_INDEXOF_HELPURL = "https://github.com/google/blockly/wiki/Text#finding-text", r.Msg.TEXT_INDEXOF_OPERATOR_FIRST = "find first occurrence of text", r.Msg.TEXT_INDEXOF_OPERATOR_LAST = "find last occurrence of text", r.Msg.TEXT_INDEXOF_TITLE = "in text %1 %2 %3", r.Msg.TEXT_INDEXOF_TOOLTIP = "Returns the index of the first/last occurrence of the first text in the second text. Returns %1 if text is not found.", r.Msg.TEXT_ISEMPTY_HELPURL = "https://github.com/google/blockly/wiki/Text#checking-for-empty-text", r.Msg.TEXT_ISEMPTY_TITLE = "%1 is empty", r.Msg.TEXT_ISEMPTY_TOOLTIP = "Returns true if the provided text is empty.", r.Msg.TEXT_JOIN_HELPURL = "https://github.com/google/blockly/wiki/Text#text-creation", r.Msg.TEXT_JOIN_TITLE_CREATEWITH = "create text with", r.Msg.TEXT_JOIN_TOOLTIP = "Create a piece of text by joining together any number of items.", r.Msg.TEXT_LENGTH_HELPURL = "https://github.com/google/blockly/wiki/Text#text-modification", r.Msg.TEXT_LENGTH_TITLE = "length of %1", r.Msg.TEXT_LENGTH_TOOLTIP = "Returns the number of letters (including spaces) in the provided text.", r.Msg.TEXT_PRINT_HELPURL = "https://github.com/google/blockly/wiki/Text#printing-text", r.Msg.TEXT_PRINT_TITLE = "print %1", r.Msg.TEXT_PRINT_TOOLTIP = "Print the specified text, number or other value.", r.Msg.TEXT_PROMPT_HELPURL = "https://github.com/google/blockly/wiki/Text#getting-input-from-the-user", r.Msg.TEXT_PROMPT_TOOLTIP_NUMBER = "Prompt for user for a number.", r.Msg.TEXT_PROMPT_TOOLTIP_TEXT = "Prompt for user for some text.", r.Msg.TEXT_PROMPT_TYPE_NUMBER = "prompt for number with message", r.Msg.TEXT_PROMPT_TYPE_TEXT = "prompt for text with message", r.Msg.TEXT_REPLACE_HELPURL = "https://github.com/google/blockly/wiki/Text#replacing-substrings", r.Msg.TEXT_REPLACE_MESSAGE0 = "replace %1 with %2 in %3", r.Msg.TEXT_REPLACE_TOOLTIP = "Replace all occurances of some text within some other text.", r.Msg.TEXT_REVERSE_HELPURL = "https://github.com/google/blockly/wiki/Text#reversing-text", r.Msg.TEXT_REVERSE_MESSAGE0 = "reverse %1", r.Msg.TEXT_REVERSE_TOOLTIP = "Reverses the order of the characters in the text.", r.Msg.TEXT_TEXT_HELPURL = "https://en.wikipedia.org/wiki/String_(computer_science)", r.Msg.TEXT_TEXT_TOOLTIP = "A letter, word, or line of text.", r.Msg.TEXT_TRIM_HELPURL = "https://github.com/google/blockly/wiki/Text#trimming-removing-spaces", r.Msg.TEXT_TRIM_OPERATOR_BOTH = "trim spaces from both sides of", r.Msg.TEXT_TRIM_OPERATOR_LEFT = "trim spaces from left side of", r.Msg.TEXT_TRIM_OPERATOR_RIGHT = "trim spaces from right side of", r.Msg.TEXT_TRIM_TOOLTIP = "Return a copy of the text with spaces removed from one or both ends.", r.Msg.TODAY = "Today", r.Msg.UNDO = "Undo", r.Msg.UNNAMED_KEY = "unnamed", r.Msg.VARIABLES_DEFAULT_NAME = "item", r.Msg.VARIABLES_GET_CREATE_SET = "Create 'set %1'", r.Msg.VARIABLES_GET_HELPURL = "https://github.com/google/blockly/wiki/Variables#get", r.Msg.VARIABLES_GET_TOOLTIP = "Returns the value of this variable.", r.Msg.VARIABLES_SET = "set %1 to %2", r.Msg.VARIABLES_SET_CREATE_GET = "Create 'get %1'", r.Msg.VARIABLES_SET_HELPURL = "https://github.com/google/blockly/wiki/Variables#set", r.Msg.VARIABLES_SET_TOOLTIP = "Sets this variable to be equal to the input.", r.Msg.VARIABLE_ALREADY_EXISTS = "A variable named '%1' already exists.", r.Msg.VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE = "A variable named '%1' already exists for another type: '%2'.", r.Msg.VARIABLE_ALREADY_EXISTS_FOR_A_PARAMETER = "A variable named '%1' already exists as a parameter in the procedure '%2'.", r.Msg.WORKSPACE_ARIA_LABEL = "Blockly Workspace", r.Msg.WORKSPACE_COMMENT_DEFAULT_TEXT = "Say something...", r.Msg.CONTROLS_FOREACH_INPUT_DO = r.Msg.CONTROLS_REPEAT_INPUT_DO, r.Msg.CONTROLS_FOR_INPUT_DO = r.Msg.CONTROLS_REPEAT_INPUT_DO, r.Msg.CONTROLS_IF_ELSEIF_TITLE_ELSEIF = r.Msg.CONTROLS_IF_MSG_ELSEIF, r.Msg.CONTROLS_IF_ELSE_TITLE_ELSE = r.Msg.CONTROLS_IF_MSG_ELSE, r.Msg.CONTROLS_IF_IF_TITLE_IF = r.Msg.CONTROLS_IF_MSG_IF, r.Msg.CONTROLS_IF_MSG_THEN = r.Msg.CONTROLS_REPEAT_INPUT_DO, r.Msg.CONTROLS_WHILEUNTIL_INPUT_DO = r.Msg.CONTROLS_REPEAT_INPUT_DO, r.Msg.LISTS_CREATE_WITH_ITEM_TITLE = r.Msg.VARIABLES_DEFAULT_NAME, r.Msg.LISTS_GET_INDEX_HELPURL = r.Msg.LISTS_INDEX_OF_HELPURL, r.Msg.LISTS_GET_INDEX_INPUT_IN_LIST = r.Msg.LISTS_INLIST, r.Msg.LISTS_GET_SUBLIST_INPUT_IN_LIST = r.Msg.LISTS_INLIST, r.Msg.LISTS_INDEX_OF_INPUT_IN_LIST = r.Msg.LISTS_INLIST, r.Msg.LISTS_SET_INDEX_INPUT_IN_LIST = r.Msg.LISTS_INLIST, r.Msg.MATH_CHANGE_TITLE_ITEM = r.Msg.VARIABLES_DEFAULT_NAME, r.Msg.PROCEDURES_DEFRETURN_COMMENT = r.Msg.PROCEDURES_DEFNORETURN_COMMENT, r.Msg.PROCEDURES_DEFRETURN_DO = r.Msg.PROCEDURES_DEFNORETURN_DO, r.Msg.PROCEDURES_DEFRETURN_PROCEDURE = r.Msg.PROCEDURES_DEFNORETURN_PROCEDURE, r.Msg.PROCEDURES_DEFRETURN_TITLE = r.Msg.PROCEDURES_DEFNORETURN_TITLE, r.Msg.TEXT_APPEND_VARIABLE = r.Msg.VARIABLES_DEFAULT_NAME, r.Msg.TEXT_CREATE_JOIN_ITEM_TITLE_ITEM = r.Msg.VARIABLES_DEFAULT_NAME, r.Msg.LOGIC_HUE = "210", r.Msg.LOOPS_HUE = "120", r.Msg.MATH_HUE = "230", r.Msg.TEXTS_HUE = "160", r.Msg.LISTS_HUE = "260", r.Msg.COLOUR_HUE = "20", r.Msg.VARIABLES_HUE = "330", r.Msg.VARIABLES_DYNAMIC_HUE = "310", r.Msg.PROCEDURES_HUE = "290", r.Msg;
    });
  }(th)), th.exports;
}
var rh = { exports: {} }, nh = { exports: {} }, s4;
function UM() {
  return s4 || (s4 = 1, function(_, s) {
    (function(r, i) {
      _.exports = i(yh());
    })(nn, function(r) {
      var i = r.__namespace__, a = i.createBlockDefinitionsFromJsonArray$$module$build$src$core$common([{ type: "colour_picker", message0: "%1", args0: [{ type: "field_colour", name: "COLOUR", colour: "#ff0000" }], output: "Colour", helpUrl: "%{BKY_COLOUR_PICKER_HELPURL}", style: "colour_blocks", tooltip: "%{BKY_COLOUR_PICKER_TOOLTIP}", extensions: ["parent_tooltip_when_inline"] }, {
        type: "colour_random",
        message0: "%{BKY_COLOUR_RANDOM_TITLE}",
        output: "Colour",
        helpUrl: "%{BKY_COLOUR_RANDOM_HELPURL}",
        style: "colour_blocks",
        tooltip: "%{BKY_COLOUR_RANDOM_TOOLTIP}"
      }, { type: "colour_rgb", message0: "%{BKY_COLOUR_RGB_TITLE} %{BKY_COLOUR_RGB_RED} %1 %{BKY_COLOUR_RGB_GREEN} %2 %{BKY_COLOUR_RGB_BLUE} %3", args0: [{ type: "input_value", name: "RED", check: "Number", align: "RIGHT" }, { type: "input_value", name: "GREEN", check: "Number", align: "RIGHT" }, { type: "input_value", name: "BLUE", check: "Number", align: "RIGHT" }], output: "Colour", helpUrl: "%{BKY_COLOUR_RGB_HELPURL}", style: "colour_blocks", tooltip: "%{BKY_COLOUR_RGB_TOOLTIP}" }, {
        type: "colour_blend",
        message0: "%{BKY_COLOUR_BLEND_TITLE} %{BKY_COLOUR_BLEND_COLOUR1} %1 %{BKY_COLOUR_BLEND_COLOUR2} %2 %{BKY_COLOUR_BLEND_RATIO} %3",
        args0: [{ type: "input_value", name: "COLOUR1", check: "Colour", align: "RIGHT" }, { type: "input_value", name: "COLOUR2", check: "Colour", align: "RIGHT" }, { type: "input_value", name: "RATIO", check: "Number", align: "RIGHT" }],
        output: "Colour",
        helpUrl: "%{BKY_COLOUR_BLEND_HELPURL}",
        style: "colour_blocks",
        tooltip: "%{BKY_COLOUR_BLEND_TOOLTIP}"
      }]);
      i.defineBlocks$$module$build$src$core$common(a);
      var p = {};
      p.blocks = a;
      var E = i.createBlockDefinitionsFromJsonArray$$module$build$src$core$common([
        { type: "lists_create_empty", message0: "%{BKY_LISTS_CREATE_EMPTY_TITLE}", output: "Array", style: "list_blocks", tooltip: "%{BKY_LISTS_CREATE_EMPTY_TOOLTIP}", helpUrl: "%{BKY_LISTS_CREATE_EMPTY_HELPURL}" },
        {
          type: "lists_repeat",
          message0: "%{BKY_LISTS_REPEAT_TITLE}",
          args0: [{ type: "input_value", name: "ITEM" }, { type: "input_value", name: "NUM", check: "Number" }],
          output: "Array",
          style: "list_blocks",
          tooltip: "%{BKY_LISTS_REPEAT_TOOLTIP}",
          helpUrl: "%{BKY_LISTS_REPEAT_HELPURL}"
        },
        { type: "lists_reverse", message0: "%{BKY_LISTS_REVERSE_MESSAGE0}", args0: [{ type: "input_value", name: "LIST", check: "Array" }], output: "Array", inputsInline: !0, style: "list_blocks", tooltip: "%{BKY_LISTS_REVERSE_TOOLTIP}", helpUrl: "%{BKY_LISTS_REVERSE_HELPURL}" },
        { type: "lists_isEmpty", message0: "%{BKY_LISTS_ISEMPTY_TITLE}", args0: [{ type: "input_value", name: "VALUE", check: ["String", "Array"] }], output: "Boolean", style: "list_blocks", tooltip: "%{BKY_LISTS_ISEMPTY_TOOLTIP}", helpUrl: "%{BKY_LISTS_ISEMPTY_HELPURL}" },
        { type: "lists_length", message0: "%{BKY_LISTS_LENGTH_TITLE}", args0: [{ type: "input_value", name: "VALUE", check: ["String", "Array"] }], output: "Number", style: "list_blocks", tooltip: "%{BKY_LISTS_LENGTH_TOOLTIP}", helpUrl: "%{BKY_LISTS_LENGTH_HELPURL}" }
      ]), h = { init: function() {
        this.setHelpUrl(i.Msg$$module$build$src$core$msg.LISTS_CREATE_WITH_HELPURL), this.setStyle("list_blocks"), this.itemCount_ = 3, this.updateShape_(), this.setOutput(!0, "Array"), this.setMutator(new i.MutatorIcon$$module$build$src$core$icons$mutator_icon(
          ["lists_create_with_item"],
          this
        )), this.setTooltip(i.Msg$$module$build$src$core$msg.LISTS_CREATE_WITH_TOOLTIP);
      }, mutationToDom: function() {
        const I = i.createElement$$module$build$src$core$utils$xml("mutation");
        return I.setAttribute("items", String(this.itemCount_)), I;
      }, domToMutation: function(I) {
        if (I = I.getAttribute("items"), !I)
          throw new TypeError("element did not have items");
        this.itemCount_ = parseInt(I, 10), this.updateShape_();
      }, saveExtraState: function() {
        return { itemCount: this.itemCount_ };
      }, loadExtraState: function(I) {
        this.itemCount_ = I.itemCount, this.updateShape_();
      }, decompose: function(I) {
        const R = I.newBlock("lists_create_with_container");
        R.initSvg();
        let B = R.getInput("STACK").connection;
        for (let Y = 0; Y < this.itemCount_; Y++) {
          const ie = I.newBlock("lists_create_with_item");
          if (ie.initSvg(), !ie.previousConnection)
            throw Error("itemBlock has no previousConnection");
          B.connect(ie.previousConnection), B = ie.nextConnection;
        }
        return R;
      }, compose: function(I) {
        var R = I.getInputTargetBlock("STACK");
        for (I = []; R; )
          R.isInsertionMarker() || I.push(R.valueConnection_), R = R.getNextBlock();
        for (R = 0; R < this.itemCount_; R++) {
          const B = this.getInput("ADD" + R).connection.targetConnection;
          B && I.indexOf(B) === -1 && B.disconnect();
        }
        for (this.itemCount_ = I.length, this.updateShape_(), R = 0; R < this.itemCount_; R++) {
          let B;
          (B = I[R]) == null || B.reconnect(this, "ADD" + R);
        }
      }, saveConnections: function(I) {
        I = I.getInputTargetBlock("STACK");
        let R = 0;
        for (; I; ) {
          if (I.isInsertionMarker()) {
            I = I.getNextBlock();
            continue;
          }
          const B = this.getInput("ADD" + R);
          let Y;
          I.valueConnection_ = (Y = B) == null ? void 0 : Y.connection.targetConnection, I = I.getNextBlock(), R++;
        }
      }, updateShape_: function() {
        this.itemCount_ && this.getInput("EMPTY") ? this.removeInput("EMPTY") : this.itemCount_ || this.getInput("EMPTY") || this.appendDummyInput("EMPTY").appendField(i.Msg$$module$build$src$core$msg.LISTS_CREATE_EMPTY_TITLE);
        for (var I = 0; I < this.itemCount_; I++)
          if (!this.getInput("ADD" + I)) {
            const R = this.appendValueInput("ADD" + I).setAlign(i.Align$$module$build$src$core$inputs$align.RIGHT);
            I === 0 && R.appendField(i.Msg$$module$build$src$core$msg.LISTS_CREATE_WITH_INPUT_WITH);
          }
        for (I = this.itemCount_; this.getInput("ADD" + I); I++)
          this.removeInput("ADD" + I);
      } };
      E.lists_create_with = h;
      var L = { init: function() {
        this.setStyle("list_blocks"), this.appendDummyInput().appendField(i.Msg$$module$build$src$core$msg.LISTS_CREATE_WITH_CONTAINER_TITLE_ADD), this.appendStatementInput("STACK"), this.setTooltip(i.Msg$$module$build$src$core$msg.LISTS_CREATE_WITH_CONTAINER_TOOLTIP), this.contextMenu = !1;
      } };
      E.lists_create_with_container = L;
      var y = { init: function() {
        this.setStyle("list_blocks"), this.appendDummyInput().appendField(i.Msg$$module$build$src$core$msg.LISTS_CREATE_WITH_ITEM_TITLE), this.setPreviousStatement(!0), this.setNextStatement(!0), this.setTooltip(i.Msg$$module$build$src$core$msg.LISTS_CREATE_WITH_ITEM_TOOLTIP), this.contextMenu = !1;
      } };
      E.lists_create_with_item = y;
      var V = { init: function() {
        var I = [[i.Msg$$module$build$src$core$msg.LISTS_INDEX_OF_FIRST, "FIRST"], [i.Msg$$module$build$src$core$msg.LISTS_INDEX_OF_LAST, "LAST"]];
        if (this.setHelpUrl(i.Msg$$module$build$src$core$msg.LISTS_INDEX_OF_HELPURL), this.setStyle("list_blocks"), this.setOutput(!0, "Number"), this.appendValueInput("VALUE").setCheck("Array").appendField(i.Msg$$module$build$src$core$msg.LISTS_INDEX_OF_INPUT_IN_LIST), I = i.fromJson$$module$build$src$core$field_registry({
          type: "field_dropdown",
          options: I
        }), !I)
          throw Error("field_dropdown not found");
        this.appendValueInput("FIND").appendField(I, "END"), this.setInputsInline(!0), this.setTooltip(() => i.Msg$$module$build$src$core$msg.LISTS_INDEX_OF_TOOLTIP.replace("%1", this.workspace.options.oneBasedIndex ? "0" : "-1"));
      } };
      E.lists_indexOf = V;
      var Z = {
        init: function() {
          var I = [[i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_GET, "GET"], [i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_GET_REMOVE, "GET_REMOVE"], [i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_REMOVE, "REMOVE"]];
          this.WHERE_OPTIONS = [
            [i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_FROM_START, "FROM_START"],
            [i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_FROM_END, "FROM_END"],
            [i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_FIRST, "FIRST"],
            [i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_LAST, "LAST"],
            [i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_RANDOM, "RANDOM"]
          ], this.setHelpUrl(i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_HELPURL), this.setStyle("list_blocks"), I = i.fromJson$$module$build$src$core$field_registry({ type: "field_dropdown", options: I }), I.setValidator(function(R) {
            R = R === "REMOVE", this.getSourceBlock().updateStatement_(R);
          }), this.appendValueInput("VALUE").setCheck("Array").appendField(i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_INPUT_IN_LIST), this.appendDummyInput().appendField(I, "MODE").appendField("", "SPACE"), this.appendDummyInput("AT"), i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TAIL && this.appendDummyInput("TAIL").appendField(i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TAIL), this.setInputsInline(!0), this.setOutput(!0), this.updateAt_(!0), this.setTooltip(() => {
            const R = this.getFieldValue("MODE"), B = this.getFieldValue("WHERE");
            let Y = "";
            switch (R + " " + B) {
              case "GET FROM_START":
              case "GET FROM_END":
                Y = i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TOOLTIP_GET_FROM;
                break;
              case "GET FIRST":
                Y = i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TOOLTIP_GET_FIRST;
                break;
              case "GET LAST":
                Y = i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TOOLTIP_GET_LAST;
                break;
              case "GET RANDOM":
                Y = i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TOOLTIP_GET_RANDOM;
                break;
              case "GET_REMOVE FROM_START":
              case "GET_REMOVE FROM_END":
                Y = i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FROM;
                break;
              case "GET_REMOVE FIRST":
                Y = i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FIRST;
                break;
              case "GET_REMOVE LAST":
                Y = i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_LAST;
                break;
              case "GET_REMOVE RANDOM":
                Y = i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_RANDOM;
                break;
              case "REMOVE FROM_START":
              case "REMOVE FROM_END":
                Y = i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_FROM;
                break;
              case "REMOVE FIRST":
                Y = i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_FIRST;
                break;
              case "REMOVE LAST":
                Y = i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_LAST;
                break;
              case "REMOVE RANDOM":
                Y = i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_RANDOM;
            }
            return (B === "FROM_START" || B === "FROM_END") && (Y += "  " + (B === "FROM_START" ? i.Msg$$module$build$src$core$msg.LISTS_INDEX_FROM_START_TOOLTIP : i.Msg$$module$build$src$core$msg.LISTS_INDEX_FROM_END_TOOLTIP).replace("%1", this.workspace.options.oneBasedIndex ? "#1" : "#0")), Y;
          });
        },
        mutationToDom: function() {
          const I = i.createElement$$module$build$src$core$utils$xml("mutation");
          I.setAttribute("statement", String(!this.outputConnection));
          const R = this.getInput("AT") instanceof i.ValueInput$$module$build$src$core$inputs$value_input;
          return I.setAttribute("at", String(R)), I;
        },
        domToMutation: function(I) {
          const R = I.getAttribute("statement") === "true";
          this.updateStatement_(R), I = I.getAttribute("at") !== "false", this.updateAt_(I);
        },
        saveExtraState: function() {
          return this.outputConnection ? null : { isStatement: !0 };
        },
        loadExtraState: function(I) {
          I.isStatement ? this.updateStatement_(!0) : typeof I == "string" && this.domToMutation(i.textToDom$$module$build$src$core$utils$xml(I));
        },
        updateStatement_: function(I) {
          I !== !this.outputConnection && (this.unplug(!0, !0), I ? (this.setOutput(!1), this.setPreviousStatement(!0), this.setNextStatement(!0)) : (this.setPreviousStatement(!1), this.setNextStatement(!1), this.setOutput(!0)));
        },
        updateAt_: function(I) {
          this.removeInput("AT"), this.removeInput("ORDINAL", !0), I ? (this.appendValueInput("AT").setCheck("Number"), i.Msg$$module$build$src$core$msg.ORDINAL_NUMBER_SUFFIX && this.appendDummyInput("ORDINAL").appendField(i.Msg$$module$build$src$core$msg.ORDINAL_NUMBER_SUFFIX)) : this.appendDummyInput("AT");
          const R = i.fromJson$$module$build$src$core$field_registry({ type: "field_dropdown", options: this.WHERE_OPTIONS });
          R.setValidator(function(B) {
            const Y = B === "FROM_START" || B === "FROM_END";
            if (Y !== I) {
              const ie = this.getSourceBlock();
              return ie.updateAt_(Y), ie.setFieldValue(B, "WHERE"), null;
            }
          }), this.getInput("AT").appendField(R, "WHERE"), i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TAIL && this.moveInputBefore("TAIL", null);
        }
      };
      E.lists_getIndex = Z;
      var le = { init: function() {
        var I = [[i.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_SET, "SET"], [i.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_INSERT, "INSERT"]];
        this.WHERE_OPTIONS = [[i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_FROM_START, "FROM_START"], [i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_FROM_END, "FROM_END"], [i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_FIRST, "FIRST"], [i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_LAST, "LAST"], [
          i.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_RANDOM,
          "RANDOM"
        ]], this.setHelpUrl(i.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_HELPURL), this.setStyle("list_blocks"), this.appendValueInput("LIST").setCheck("Array").appendField(i.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_INPUT_IN_LIST), I = i.fromJson$$module$build$src$core$field_registry({ type: "field_dropdown", options: I }), this.appendDummyInput().appendField(I, "MODE").appendField("", "SPACE"), this.appendDummyInput("AT"), this.appendValueInput("TO").appendField(i.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_INPUT_TO), this.setInputsInline(!0), this.setPreviousStatement(!0), this.setNextStatement(!0), this.setTooltip(i.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_TOOLTIP), this.updateAt_(!0), this.setTooltip(() => {
          const R = this.getFieldValue("MODE"), B = this.getFieldValue("WHERE");
          let Y = "";
          switch (R + " " + B) {
            case "SET FROM_START":
            case "SET FROM_END":
              Y = i.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_TOOLTIP_SET_FROM;
              break;
            case "SET FIRST":
              Y = i.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_TOOLTIP_SET_FIRST;
              break;
            case "SET LAST":
              Y = i.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_TOOLTIP_SET_LAST;
              break;
            case "SET RANDOM":
              Y = i.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_TOOLTIP_SET_RANDOM;
              break;
            case "INSERT FROM_START":
            case "INSERT FROM_END":
              Y = i.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_TOOLTIP_INSERT_FROM;
              break;
            case "INSERT FIRST":
              Y = i.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_TOOLTIP_INSERT_FIRST;
              break;
            case "INSERT LAST":
              Y = i.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_TOOLTIP_INSERT_LAST;
              break;
            case "INSERT RANDOM":
              Y = i.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_TOOLTIP_INSERT_RANDOM;
          }
          return (B === "FROM_START" || B === "FROM_END") && (Y += "  " + i.Msg$$module$build$src$core$msg.LISTS_INDEX_FROM_START_TOOLTIP.replace("%1", this.workspace.options.oneBasedIndex ? "#1" : "#0")), Y;
        });
      }, mutationToDom: function() {
        const I = i.createElement$$module$build$src$core$utils$xml("mutation"), R = this.getInput("AT") instanceof i.ValueInput$$module$build$src$core$inputs$value_input;
        return I.setAttribute("at", String(R)), I;
      }, domToMutation: function(I) {
        I = I.getAttribute("at") !== "false", this.updateAt_(I);
      }, saveExtraState: function() {
        return null;
      }, loadExtraState: function() {
      }, updateAt_: function(I) {
        this.removeInput("AT"), this.removeInput("ORDINAL", !0), I ? (this.appendValueInput("AT").setCheck("Number"), i.Msg$$module$build$src$core$msg.ORDINAL_NUMBER_SUFFIX && this.appendDummyInput("ORDINAL").appendField(i.Msg$$module$build$src$core$msg.ORDINAL_NUMBER_SUFFIX)) : this.appendDummyInput("AT");
        const R = i.fromJson$$module$build$src$core$field_registry({
          type: "field_dropdown",
          options: this.WHERE_OPTIONS
        });
        R.setValidator(function(B) {
          const Y = B === "FROM_START" || B === "FROM_END";
          if (Y !== I) {
            const ie = this.getSourceBlock();
            return ie.updateAt_(Y), ie.setFieldValue(B, "WHERE"), null;
          }
        }), this.moveInputBefore("AT", "TO"), this.getInput("ORDINAL") && this.moveInputBefore("ORDINAL", "TO"), this.getInput("AT").appendField(R, "WHERE");
      } };
      E.lists_setIndex = le;
      var ce = { init: function() {
        this.WHERE_OPTIONS_1 = [[i.Msg$$module$build$src$core$msg.LISTS_GET_SUBLIST_START_FROM_START, "FROM_START"], [i.Msg$$module$build$src$core$msg.LISTS_GET_SUBLIST_START_FROM_END, "FROM_END"], [i.Msg$$module$build$src$core$msg.LISTS_GET_SUBLIST_START_FIRST, "FIRST"]], this.WHERE_OPTIONS_2 = [
          [i.Msg$$module$build$src$core$msg.LISTS_GET_SUBLIST_END_FROM_START, "FROM_START"],
          [i.Msg$$module$build$src$core$msg.LISTS_GET_SUBLIST_END_FROM_END, "FROM_END"],
          [i.Msg$$module$build$src$core$msg.LISTS_GET_SUBLIST_END_LAST, "LAST"]
        ], this.setHelpUrl(i.Msg$$module$build$src$core$msg.LISTS_GET_SUBLIST_HELPURL), this.setStyle("list_blocks"), this.appendValueInput("LIST").setCheck("Array").appendField(i.Msg$$module$build$src$core$msg.LISTS_GET_SUBLIST_INPUT_IN_LIST), this.appendDummyInput("AT1"), this.appendDummyInput("AT2"), i.Msg$$module$build$src$core$msg.LISTS_GET_SUBLIST_TAIL && this.appendDummyInput("TAIL").appendField(i.Msg$$module$build$src$core$msg.LISTS_GET_SUBLIST_TAIL), this.setInputsInline(!0), this.setOutput(!0, "Array"), this.updateAt_(1, !0), this.updateAt_(2, !0), this.setTooltip(i.Msg$$module$build$src$core$msg.LISTS_GET_SUBLIST_TOOLTIP);
      }, mutationToDom: function() {
        const I = i.createElement$$module$build$src$core$utils$xml("mutation");
        var R = this.getInput("AT1") instanceof i.ValueInput$$module$build$src$core$inputs$value_input;
        return I.setAttribute("at1", String(R)), R = this.getInput("AT2") instanceof i.ValueInput$$module$build$src$core$inputs$value_input, I.setAttribute("at2", String(R)), I;
      }, domToMutation: function(I) {
        const R = I.getAttribute("at1") === "true";
        I = I.getAttribute("at2") === "true", this.updateAt_(1, R), this.updateAt_(2, I);
      }, saveExtraState: function() {
        return null;
      }, loadExtraState: function() {
      }, updateAt_: function(I, R) {
        this.removeInput("AT" + I), this.removeInput("ORDINAL" + I, !0), R ? (this.appendValueInput("AT" + I).setCheck("Number"), i.Msg$$module$build$src$core$msg.ORDINAL_NUMBER_SUFFIX && this.appendDummyInput("ORDINAL" + I).appendField(i.Msg$$module$build$src$core$msg.ORDINAL_NUMBER_SUFFIX)) : this.appendDummyInput("AT" + I);
        const B = i.fromJson$$module$build$src$core$field_registry({ type: "field_dropdown", options: this["WHERE_OPTIONS_" + I] });
        B.setValidator(function(Y) {
          const ie = Y === "FROM_START" || Y === "FROM_END";
          if (ie !== R) {
            const ke = this.getSourceBlock();
            return ke.updateAt_(I, ie), ke.setFieldValue(Y, "WHERE" + I), null;
          }
        }), this.getInput("AT" + I).appendField(B, "WHERE" + I), I === 1 && (this.moveInputBefore("AT1", "AT2"), this.getInput("ORDINAL1") && this.moveInputBefore("ORDINAL1", "AT2")), i.Msg$$module$build$src$core$msg.LISTS_GET_SUBLIST_TAIL && this.moveInputBefore("TAIL", null);
      } };
      E.lists_getSublist = ce, E.lists_sort = { init: function() {
        this.jsonInit({
          message0: "%{BKY_LISTS_SORT_TITLE}",
          args0: [{ type: "field_dropdown", name: "TYPE", options: [["%{BKY_LISTS_SORT_TYPE_NUMERIC}", "NUMERIC"], ["%{BKY_LISTS_SORT_TYPE_TEXT}", "TEXT"], ["%{BKY_LISTS_SORT_TYPE_IGNORECASE}", "IGNORE_CASE"]] }, { type: "field_dropdown", name: "DIRECTION", options: [["%{BKY_LISTS_SORT_ORDER_ASCENDING}", "1"], ["%{BKY_LISTS_SORT_ORDER_DESCENDING}", "-1"]] }, { type: "input_value", name: "LIST", check: "Array" }],
          output: "Array",
          style: "list_blocks",
          tooltip: "%{BKY_LISTS_SORT_TOOLTIP}",
          helpUrl: "%{BKY_LISTS_SORT_HELPURL}"
        });
      } }, E.lists_split = {
        init: function() {
          const I = i.fromJson$$module$build$src$core$field_registry({ type: "field_dropdown", options: [[i.Msg$$module$build$src$core$msg.LISTS_SPLIT_LIST_FROM_TEXT, "SPLIT"], [i.Msg$$module$build$src$core$msg.LISTS_SPLIT_TEXT_FROM_LIST, "JOIN"]] });
          if (!I)
            throw Error("field_dropdown not found");
          I.setValidator((R) => {
            this.updateType_(R);
          }), this.setHelpUrl(i.Msg$$module$build$src$core$msg.LISTS_SPLIT_HELPURL), this.setStyle("list_blocks"), this.appendValueInput("INPUT").setCheck("String").appendField(
            I,
            "MODE"
          ), this.appendValueInput("DELIM").setCheck("String").appendField(i.Msg$$module$build$src$core$msg.LISTS_SPLIT_WITH_DELIMITER), this.setInputsInline(!0), this.setOutput(!0, "Array"), this.setTooltip(() => {
            const R = this.getFieldValue("MODE");
            if (R === "SPLIT")
              return i.Msg$$module$build$src$core$msg.LISTS_SPLIT_TOOLTIP_SPLIT;
            if (R === "JOIN")
              return i.Msg$$module$build$src$core$msg.LISTS_SPLIT_TOOLTIP_JOIN;
            throw Error("Unknown mode: " + R);
          });
        },
        updateType_: function(I) {
          if (this.getFieldValue("MODE") !== I) {
            const R = this.getInput("INPUT").connection;
            R.setShadowDom(null);
            const B = R.targetBlock();
            B && (R.disconnect(), B.isShadow() ? B.dispose(!1) : this.bumpNeighbours());
          }
          I === "SPLIT" ? (this.outputConnection.setCheck("Array"), this.getInput("INPUT").setCheck("String")) : (this.outputConnection.setCheck("String"), this.getInput("INPUT").setCheck("Array"));
        },
        mutationToDom: function() {
          const I = i.createElement$$module$build$src$core$utils$xml("mutation");
          return I.setAttribute("mode", this.getFieldValue("MODE")), I;
        },
        domToMutation: function(I) {
          this.updateType_(I.getAttribute("mode"));
        },
        saveExtraState: function() {
          return null;
        },
        loadExtraState: function() {
        }
      }, i.defineBlocks$$module$build$src$core$common(E);
      var ve = {};
      ve.blocks = E;
      var et = i.createBlockDefinitionsFromJsonArray$$module$build$src$core$common([
        { type: "logic_boolean", message0: "%1", args0: [{ type: "field_dropdown", name: "BOOL", options: [["%{BKY_LOGIC_BOOLEAN_TRUE}", "TRUE"], ["%{BKY_LOGIC_BOOLEAN_FALSE}", "FALSE"]] }], output: "Boolean", style: "logic_blocks", tooltip: "%{BKY_LOGIC_BOOLEAN_TOOLTIP}", helpUrl: "%{BKY_LOGIC_BOOLEAN_HELPURL}" },
        {
          type: "controls_if",
          message0: "%{BKY_CONTROLS_IF_MSG_IF} %1",
          args0: [{ type: "input_value", name: "IF0", check: "Boolean" }],
          message1: "%{BKY_CONTROLS_IF_MSG_THEN} %1",
          args1: [{ type: "input_statement", name: "DO0" }],
          previousStatement: null,
          nextStatement: null,
          style: "logic_blocks",
          helpUrl: "%{BKY_CONTROLS_IF_HELPURL}",
          suppressPrefixSuffix: !0,
          mutator: "controls_if_mutator",
          extensions: ["controls_if_tooltip"]
        },
        {
          type: "controls_ifelse",
          message0: "%{BKY_CONTROLS_IF_MSG_IF} %1",
          args0: [{ type: "input_value", name: "IF0", check: "Boolean" }],
          message1: "%{BKY_CONTROLS_IF_MSG_THEN} %1",
          args1: [{ type: "input_statement", name: "DO0" }],
          message2: "%{BKY_CONTROLS_IF_MSG_ELSE} %1",
          args2: [{ type: "input_statement", name: "ELSE" }],
          previousStatement: null,
          nextStatement: null,
          style: "logic_blocks",
          tooltip: "%{BKYCONTROLS_IF_TOOLTIP_2}",
          helpUrl: "%{BKY_CONTROLS_IF_HELPURL}",
          suppressPrefixSuffix: !0,
          extensions: ["controls_if_tooltip"]
        },
        {
          type: "logic_compare",
          message0: "%1 %2 %3",
          args0: [{ type: "input_value", name: "A" }, { type: "field_dropdown", name: "OP", options: [["=", "EQ"], ["≠", "NEQ"], ["‏<", "LT"], ["‏≤", "LTE"], ["‏>", "GT"], ["‏≥", "GTE"]] }, { type: "input_value", name: "B" }],
          inputsInline: !0,
          output: "Boolean",
          style: "logic_blocks",
          helpUrl: "%{BKY_LOGIC_COMPARE_HELPURL}",
          extensions: ["logic_compare", "logic_op_tooltip"]
        },
        { type: "logic_operation", message0: "%1 %2 %3", args0: [{ type: "input_value", name: "A", check: "Boolean" }, { type: "field_dropdown", name: "OP", options: [["%{BKY_LOGIC_OPERATION_AND}", "AND"], ["%{BKY_LOGIC_OPERATION_OR}", "OR"]] }, { type: "input_value", name: "B", check: "Boolean" }], inputsInline: !0, output: "Boolean", style: "logic_blocks", helpUrl: "%{BKY_LOGIC_OPERATION_HELPURL}", extensions: ["logic_op_tooltip"] },
        { type: "logic_negate", message0: "%{BKY_LOGIC_NEGATE_TITLE}", args0: [{ type: "input_value", name: "BOOL", check: "Boolean" }], output: "Boolean", style: "logic_blocks", tooltip: "%{BKY_LOGIC_NEGATE_TOOLTIP}", helpUrl: "%{BKY_LOGIC_NEGATE_HELPURL}" },
        { type: "logic_null", message0: "%{BKY_LOGIC_NULL}", output: null, style: "logic_blocks", tooltip: "%{BKY_LOGIC_NULL_TOOLTIP}", helpUrl: "%{BKY_LOGIC_NULL_HELPURL}" },
        {
          type: "logic_ternary",
          message0: "%{BKY_LOGIC_TERNARY_CONDITION} %1",
          args0: [{ type: "input_value", name: "IF", check: "Boolean" }],
          message1: "%{BKY_LOGIC_TERNARY_IF_TRUE} %1",
          args1: [{ type: "input_value", name: "THEN" }],
          message2: "%{BKY_LOGIC_TERNARY_IF_FALSE} %1",
          args2: [{ type: "input_value", name: "ELSE" }],
          output: null,
          style: "logic_blocks",
          tooltip: "%{BKY_LOGIC_TERNARY_TOOLTIP}",
          helpUrl: "%{BKY_LOGIC_TERNARY_HELPURL}",
          extensions: ["logic_ternary"]
        },
        { type: "controls_if_if", message0: "%{BKY_CONTROLS_IF_IF_TITLE_IF}", nextStatement: null, enableContextMenu: !1, style: "logic_blocks", tooltip: "%{BKY_CONTROLS_IF_IF_TOOLTIP}" },
        {
          type: "controls_if_elseif",
          message0: "%{BKY_CONTROLS_IF_ELSEIF_TITLE_ELSEIF}",
          previousStatement: null,
          nextStatement: null,
          enableContextMenu: !1,
          style: "logic_blocks",
          tooltip: "%{BKY_CONTROLS_IF_ELSEIF_TOOLTIP}"
        },
        { type: "controls_if_else", message0: "%{BKY_CONTROLS_IF_ELSE_TITLE_ELSE}", previousStatement: null, enableContextMenu: !1, style: "logic_blocks", tooltip: "%{BKY_CONTROLS_IF_ELSE_TOOLTIP}" }
      ]), Te = {
        EQ: "%{BKY_LOGIC_COMPARE_TOOLTIP_EQ}",
        NEQ: "%{BKY_LOGIC_COMPARE_TOOLTIP_NEQ}",
        LT: "%{BKY_LOGIC_COMPARE_TOOLTIP_LT}",
        LTE: "%{BKY_LOGIC_COMPARE_TOOLTIP_LTE}",
        GT: "%{BKY_LOGIC_COMPARE_TOOLTIP_GT}",
        GTE: "%{BKY_LOGIC_COMPARE_TOOLTIP_GTE}",
        AND: "%{BKY_LOGIC_OPERATION_TOOLTIP_AND}",
        OR: "%{BKY_LOGIC_OPERATION_TOOLTIP_OR}"
      };
      i.register$$module$build$src$core$extensions("logic_op_tooltip", i.buildTooltipForDropdown$$module$build$src$core$extensions("OP", Te));
      var Le = {
        elseifCount_: 0,
        elseCount_: 0,
        mutationToDom: function() {
          if (!this.elseifCount_ && !this.elseCount_)
            return null;
          const I = i.createElement$$module$build$src$core$utils$xml("mutation");
          return this.elseifCount_ && I.setAttribute("elseif", String(this.elseifCount_)), this.elseCount_ && I.setAttribute("else", "1"), I;
        },
        domToMutation: function(I) {
          this.elseifCount_ = parseInt(I.getAttribute("elseif"), 10) || 0, this.elseCount_ = parseInt(I.getAttribute("else"), 10) || 0, this.rebuildShape_();
        },
        saveExtraState: function() {
          if (!this.elseifCount_ && !this.elseCount_)
            return null;
          const I = /* @__PURE__ */ Object.create(null);
          return this.elseifCount_ && (I.elseIfCount = this.elseifCount_), this.elseCount_ && (I.hasElse = !0), I;
        },
        loadExtraState: function(I) {
          this.elseifCount_ = I.elseIfCount || 0, this.elseCount_ = I.hasElse ? 1 : 0, this.updateShape_();
        },
        decompose: function(I) {
          const R = I.newBlock("controls_if_if");
          R.initSvg();
          let B = R.nextConnection;
          for (let Y = 1; Y <= this.elseifCount_; Y++) {
            const ie = I.newBlock("controls_if_elseif");
            ie.initSvg(), B.connect(ie.previousConnection), B = ie.nextConnection;
          }
          return this.elseCount_ && (I = I.newBlock("controls_if_else"), I.initSvg(), B.connect(I.previousConnection)), R;
        },
        compose: function(I) {
          I = I.nextConnection.targetBlock(), this.elseCount_ = this.elseifCount_ = 0;
          const R = [null], B = [null];
          let Y = null;
          for (; I; ) {
            if (!I.isInsertionMarker())
              switch (I.type) {
                case "controls_if_elseif":
                  this.elseifCount_++, R.push(I.valueConnection_), B.push(I.statementConnection_);
                  break;
                case "controls_if_else":
                  this.elseCount_++, Y = I.statementConnection_;
                  break;
                default:
                  throw TypeError("Unknown block type: " + I.type);
              }
            I = I.getNextBlock();
          }
          this.updateShape_(), this.reconnectChildBlocks_(R, B, Y);
        },
        saveConnections: function(I) {
          I = I.nextConnection.targetBlock();
          let R = 1;
          for (; I; ) {
            if (!I.isInsertionMarker())
              switch (I.type) {
                case "controls_if_elseif":
                  var B = this.getInput("IF" + R);
                  const Y = this.getInput("DO" + R);
                  I.valueConnection_ = B && B.connection.targetConnection, I.statementConnection_ = Y && Y.connection.targetConnection, R++;
                  break;
                case "controls_if_else":
                  B = this.getInput("ELSE"), I.statementConnection_ = B && B.connection.targetConnection;
                  break;
                default:
                  throw TypeError("Unknown block type: " + I.type);
              }
            I = I.getNextBlock();
          }
        },
        rebuildShape_: function() {
          const I = [null], R = [null];
          let B = null;
          this.getInput("ELSE") && (B = this.getInput("ELSE").connection.targetConnection);
          for (let Y = 1; this.getInput("IF" + Y); Y++) {
            const ie = this.getInput("IF" + Y), ke = this.getInput("DO" + Y);
            I.push(ie.connection.targetConnection), R.push(ke.connection.targetConnection);
          }
          this.updateShape_(), this.reconnectChildBlocks_(I, R, B);
        },
        updateShape_: function() {
          this.getInput("ELSE") && this.removeInput("ELSE");
          for (var I = 1; this.getInput("IF" + I); I++)
            this.removeInput("IF" + I), this.removeInput("DO" + I);
          for (I = 1; I <= this.elseifCount_; I++)
            this.appendValueInput("IF" + I).setCheck("Boolean").appendField(i.Msg$$module$build$src$core$msg.CONTROLS_IF_MSG_ELSEIF), this.appendStatementInput("DO" + I).appendField(i.Msg$$module$build$src$core$msg.CONTROLS_IF_MSG_THEN);
          this.elseCount_ && this.appendStatementInput("ELSE").appendField(i.Msg$$module$build$src$core$msg.CONTROLS_IF_MSG_ELSE);
        },
        reconnectChildBlocks_: function(I, R, B) {
          for (let Y = 1; Y <= this.elseifCount_; Y++) {
            let ie;
            (ie = I[Y]) == null || ie.reconnect(this, "IF" + Y);
            let ke;
            (ke = R[Y]) == null || ke.reconnect(this, "DO" + Y);
          }
          B == null || B.reconnect(this, "ELSE");
        }
      };
      i.registerMutator$$module$build$src$core$extensions("controls_if_mutator", Le, null, ["controls_if_elseif", "controls_if_else"]);
      var we = function() {
        this.setTooltip((function() {
          if (this.elseifCount_ || this.elseCount_) {
            if (!this.elseifCount_ && this.elseCount_)
              return i.Msg$$module$build$src$core$msg.CONTROLS_IF_TOOLTIP_2;
            if (this.elseifCount_ && !this.elseCount_)
              return i.Msg$$module$build$src$core$msg.CONTROLS_IF_TOOLTIP_3;
            if (this.elseifCount_ && this.elseCount_)
              return i.Msg$$module$build$src$core$msg.CONTROLS_IF_TOOLTIP_4;
          } else
            return i.Msg$$module$build$src$core$msg.CONTROLS_IF_TOOLTIP_1;
          return "";
        }).bind(this));
      };
      i.register$$module$build$src$core$extensions("controls_if_tooltip", we);
      var ot = { onchange: function(I) {
        this.prevBlocks_ || (this.prevBlocks_ = [null, null]);
        var R = this.getInputTargetBlock("A");
        const B = this.getInputTargetBlock("B");
        R && B && !this.workspace.connectionChecker.doTypeChecks(R.outputConnection, B.outputConnection) && (i.setGroup$$module$build$src$core$events$utils(I.group), I = this.prevBlocks_[0], I !== R && (R.unplug(), !I || I.isDisposed() || I.isShadow() || this.getInput("A").connection.connect(I.outputConnection)), R = this.prevBlocks_[1], R !== B && (B.unplug(), !R || R.isDisposed() || R.isShadow() || this.getInput("B").connection.connect(R.outputConnection)), this.bumpNeighbours(), i.setGroup$$module$build$src$core$events$utils(!1)), this.prevBlocks_[0] = this.getInputTargetBlock("A"), this.prevBlocks_[1] = this.getInputTargetBlock("B");
      } }, pr = function() {
        this.mixin(ot);
      };
      i.register$$module$build$src$core$extensions("logic_compare", pr);
      var Zt = { prevParentConnection_: null, onchange: function(I) {
        const R = this.getInputTargetBlock("THEN"), B = this.getInputTargetBlock("ELSE"), Y = this.outputConnection.targetConnection;
        if ((R || B) && Y)
          for (let ie = 0; 2 > ie; ie++) {
            const ke = ie === 1 ? R : B;
            ke && !ke.workspace.connectionChecker.doTypeChecks(ke.outputConnection, Y) && (i.setGroup$$module$build$src$core$events$utils(I.group), Y === this.prevParentConnection_ ? (this.unplug(), Y.getSourceBlock().bumpNeighbours()) : (ke.unplug(), ke.bumpNeighbours()), i.setGroup$$module$build$src$core$events$utils(!1));
          }
        this.prevParentConnection_ = Y;
      } };
      i.registerMixin$$module$build$src$core$extensions("logic_ternary", Zt), i.defineBlocks$$module$build$src$core$common(et);
      var Je = i.createBlockDefinitionsFromJsonArray$$module$build$src$core$common([{ type: "controls_repeat_ext", message0: "%{BKY_CONTROLS_REPEAT_TITLE}", args0: [{ type: "input_value", name: "TIMES", check: "Number" }], message1: "%{BKY_CONTROLS_REPEAT_INPUT_DO} %1", args1: [{ type: "input_statement", name: "DO" }], previousStatement: null, nextStatement: null, style: "loop_blocks", tooltip: "%{BKY_CONTROLS_REPEAT_TOOLTIP}", helpUrl: "%{BKY_CONTROLS_REPEAT_HELPURL}" }, {
        type: "controls_repeat",
        message0: "%{BKY_CONTROLS_REPEAT_TITLE}",
        args0: [{ type: "field_number", name: "TIMES", value: 10, min: 0, precision: 1 }],
        message1: "%{BKY_CONTROLS_REPEAT_INPUT_DO} %1",
        args1: [{ type: "input_statement", name: "DO" }],
        previousStatement: null,
        nextStatement: null,
        style: "loop_blocks",
        tooltip: "%{BKY_CONTROLS_REPEAT_TOOLTIP}",
        helpUrl: "%{BKY_CONTROLS_REPEAT_HELPURL}"
      }, { type: "controls_whileUntil", message0: "%1 %2", args0: [
        { type: "field_dropdown", name: "MODE", options: [["%{BKY_CONTROLS_WHILEUNTIL_OPERATOR_WHILE}", "WHILE"], ["%{BKY_CONTROLS_WHILEUNTIL_OPERATOR_UNTIL}", "UNTIL"]] },
        { type: "input_value", name: "BOOL", check: "Boolean" }
      ], message1: "%{BKY_CONTROLS_REPEAT_INPUT_DO} %1", args1: [{ type: "input_statement", name: "DO" }], previousStatement: null, nextStatement: null, style: "loop_blocks", helpUrl: "%{BKY_CONTROLS_WHILEUNTIL_HELPURL}", extensions: ["controls_whileUntil_tooltip"] }, { type: "controls_for", message0: "%{BKY_CONTROLS_FOR_TITLE}", args0: [{ type: "field_variable", name: "VAR", variable: null }, { type: "input_value", name: "FROM", check: "Number", align: "RIGHT" }, {
        type: "input_value",
        name: "TO",
        check: "Number",
        align: "RIGHT"
      }, { type: "input_value", name: "BY", check: "Number", align: "RIGHT" }], message1: "%{BKY_CONTROLS_REPEAT_INPUT_DO} %1", args1: [{ type: "input_statement", name: "DO" }], inputsInline: !0, previousStatement: null, nextStatement: null, style: "loop_blocks", helpUrl: "%{BKY_CONTROLS_FOR_HELPURL}", extensions: ["contextMenu_newGetVariableBlock", "controls_for_tooltip"] }, { type: "controls_forEach", message0: "%{BKY_CONTROLS_FOREACH_TITLE}", args0: [{ type: "field_variable", name: "VAR", variable: null }, {
        type: "input_value",
        name: "LIST",
        check: "Array"
      }], message1: "%{BKY_CONTROLS_REPEAT_INPUT_DO} %1", args1: [{ type: "input_statement", name: "DO" }], previousStatement: null, nextStatement: null, style: "loop_blocks", helpUrl: "%{BKY_CONTROLS_FOREACH_HELPURL}", extensions: ["contextMenu_newGetVariableBlock", "controls_forEach_tooltip"] }, {
        type: "controls_flow_statements",
        message0: "%1",
        args0: [{ type: "field_dropdown", name: "FLOW", options: [["%{BKY_CONTROLS_FLOW_STATEMENTS_OPERATOR_BREAK}", "BREAK"], ["%{BKY_CONTROLS_FLOW_STATEMENTS_OPERATOR_CONTINUE}", "CONTINUE"]] }],
        previousStatement: null,
        style: "loop_blocks",
        helpUrl: "%{BKY_CONTROLS_FLOW_STATEMENTS_HELPURL}",
        suppressPrefixSuffix: !0,
        extensions: ["controls_flow_tooltip", "controls_flow_in_loop_check"]
      }]), Rt = { WHILE: "%{BKY_CONTROLS_WHILEUNTIL_TOOLTIP_WHILE}", UNTIL: "%{BKY_CONTROLS_WHILEUNTIL_TOOLTIP_UNTIL}" };
      i.register$$module$build$src$core$extensions("controls_whileUntil_tooltip", i.buildTooltipForDropdown$$module$build$src$core$extensions("MODE", Rt));
      var Wr = { BREAK: "%{BKY_CONTROLS_FLOW_STATEMENTS_TOOLTIP_BREAK}", CONTINUE: "%{BKY_CONTROLS_FLOW_STATEMENTS_TOOLTIP_CONTINUE}" };
      i.register$$module$build$src$core$extensions("controls_flow_tooltip", i.buildTooltipForDropdown$$module$build$src$core$extensions("FLOW", Wr));
      var Un = { customContextMenu: function(I) {
        if (!this.isInFlyout) {
          var R = this.getField("VAR").getVariable(), B = R.name;
          if (!this.isCollapsed() && B !== null) {
            R = i.generateVariableFieldDom$$module$build$src$core$variables(R);
            const Y = i.createElement$$module$build$src$core$utils$xml("block");
            Y.setAttribute("type", "variables_get"), Y.appendChild(R), I.push({
              enabled: !0,
              text: i.Msg$$module$build$src$core$msg.VARIABLES_SET_CREATE_GET.replace("%1", B),
              callback: i.callbackFactory$$module$build$src$core$contextmenu(this, Y)
            });
          }
        }
      } };
      i.registerMixin$$module$build$src$core$extensions("contextMenu_newGetVariableBlock", Un), i.register$$module$build$src$core$extensions("controls_for_tooltip", i.buildTooltipWithFieldText$$module$build$src$core$extensions("%{BKY_CONTROLS_FOR_TOOLTIP}", "VAR")), i.register$$module$build$src$core$extensions("controls_forEach_tooltip", i.buildTooltipWithFieldText$$module$build$src$core$extensions("%{BKY_CONTROLS_FOREACH_TOOLTIP}", "VAR"));
      var No = /* @__PURE__ */ new Set(["controls_repeat", "controls_repeat_ext", "controls_forEach", "controls_for", "controls_whileUntil"]), i_ = { getSurroundLoop: function() {
        let I = this;
        do {
          if (No.has(I.type))
            return I;
          I = I.getSurroundParent();
        } while (I);
        return null;
      }, onchange: function(I) {
        var R = this.workspace;
        if (R.isDragging && !R.isDragging() && I.type === i.MOVE$$module$build$src$core$events$utils && (R = !!this.getSurroundLoop(), this.setWarningText(R ? null : i.Msg$$module$build$src$core$msg.CONTROLS_FLOW_STATEMENTS_WARNING), !this.isInFlyout)) {
          const B = i.getGroup$$module$build$src$core$events$utils();
          i.setGroup$$module$build$src$core$events$utils(I.group), this.setEnabled(R), i.setGroup$$module$build$src$core$events$utils(B);
        }
      } };
      i.registerMixin$$module$build$src$core$extensions("controls_flow_in_loop_check", i_), i.defineBlocks$$module$build$src$core$common(Je);
      var Gr = {};
      Gr.blocks = Je, Gr.loopTypes = No;
      var ur = i.createBlockDefinitionsFromJsonArray$$module$build$src$core$common([
        { type: "math_number", message0: "%1", args0: [{ type: "field_number", name: "NUM", value: 0 }], output: "Number", helpUrl: "%{BKY_MATH_NUMBER_HELPURL}", style: "math_blocks", tooltip: "%{BKY_MATH_NUMBER_TOOLTIP}", extensions: ["parent_tooltip_when_inline"] },
        { type: "math_arithmetic", message0: "%1 %2 %3", args0: [{ type: "input_value", name: "A", check: "Number" }, { type: "field_dropdown", name: "OP", options: [[
          "%{BKY_MATH_ADDITION_SYMBOL}",
          "ADD"
        ], ["%{BKY_MATH_SUBTRACTION_SYMBOL}", "MINUS"], ["%{BKY_MATH_MULTIPLICATION_SYMBOL}", "MULTIPLY"], ["%{BKY_MATH_DIVISION_SYMBOL}", "DIVIDE"], ["%{BKY_MATH_POWER_SYMBOL}", "POWER"]] }, { type: "input_value", name: "B", check: "Number" }], inputsInline: !0, output: "Number", style: "math_blocks", helpUrl: "%{BKY_MATH_ARITHMETIC_HELPURL}", extensions: ["math_op_tooltip"] },
        { type: "math_single", message0: "%1 %2", args0: [{ type: "field_dropdown", name: "OP", options: [["%{BKY_MATH_SINGLE_OP_ROOT}", "ROOT"], [
          "%{BKY_MATH_SINGLE_OP_ABSOLUTE}",
          "ABS"
        ], ["-", "NEG"], ["ln", "LN"], ["log10", "LOG10"], ["e^", "EXP"], ["10^", "POW10"]] }, { type: "input_value", name: "NUM", check: "Number" }], output: "Number", style: "math_blocks", helpUrl: "%{BKY_MATH_SINGLE_HELPURL}", extensions: ["math_op_tooltip"] },
        { type: "math_trig", message0: "%1 %2", args0: [{ type: "field_dropdown", name: "OP", options: [["%{BKY_MATH_TRIG_SIN}", "SIN"], ["%{BKY_MATH_TRIG_COS}", "COS"], ["%{BKY_MATH_TRIG_TAN}", "TAN"], ["%{BKY_MATH_TRIG_ASIN}", "ASIN"], ["%{BKY_MATH_TRIG_ACOS}", "ACOS"], [
          "%{BKY_MATH_TRIG_ATAN}",
          "ATAN"
        ]] }, { type: "input_value", name: "NUM", check: "Number" }], output: "Number", style: "math_blocks", helpUrl: "%{BKY_MATH_TRIG_HELPURL}", extensions: ["math_op_tooltip"] },
        { type: "math_constant", message0: "%1", args0: [{ type: "field_dropdown", name: "CONSTANT", options: [["π", "PI"], ["e", "E"], ["φ", "GOLDEN_RATIO"], ["sqrt(2)", "SQRT2"], ["sqrt(½)", "SQRT1_2"], ["∞", "INFINITY"]] }], output: "Number", style: "math_blocks", tooltip: "%{BKY_MATH_CONSTANT_TOOLTIP}", helpUrl: "%{BKY_MATH_CONSTANT_HELPURL}" },
        {
          type: "math_number_property",
          message0: "%1 %2",
          args0: [{ type: "input_value", name: "NUMBER_TO_CHECK", check: "Number" }, { type: "field_dropdown", name: "PROPERTY", options: [["%{BKY_MATH_IS_EVEN}", "EVEN"], ["%{BKY_MATH_IS_ODD}", "ODD"], ["%{BKY_MATH_IS_PRIME}", "PRIME"], ["%{BKY_MATH_IS_WHOLE}", "WHOLE"], ["%{BKY_MATH_IS_POSITIVE}", "POSITIVE"], ["%{BKY_MATH_IS_NEGATIVE}", "NEGATIVE"], ["%{BKY_MATH_IS_DIVISIBLE_BY}", "DIVISIBLE_BY"]] }],
          inputsInline: !0,
          output: "Boolean",
          style: "math_blocks",
          tooltip: "%{BKY_MATH_IS_TOOLTIP}",
          mutator: "math_is_divisibleby_mutator"
        },
        { type: "math_change", message0: "%{BKY_MATH_CHANGE_TITLE}", args0: [{ type: "field_variable", name: "VAR", variable: "%{BKY_MATH_CHANGE_TITLE_ITEM}" }, { type: "input_value", name: "DELTA", check: "Number" }], previousStatement: null, nextStatement: null, style: "variable_blocks", helpUrl: "%{BKY_MATH_CHANGE_HELPURL}", extensions: ["math_change_tooltip"] },
        { type: "math_round", message0: "%1 %2", args0: [{ type: "field_dropdown", name: "OP", options: [
          ["%{BKY_MATH_ROUND_OPERATOR_ROUND}", "ROUND"],
          ["%{BKY_MATH_ROUND_OPERATOR_ROUNDUP}", "ROUNDUP"],
          ["%{BKY_MATH_ROUND_OPERATOR_ROUNDDOWN}", "ROUNDDOWN"]
        ] }, { type: "input_value", name: "NUM", check: "Number" }], output: "Number", style: "math_blocks", helpUrl: "%{BKY_MATH_ROUND_HELPURL}", tooltip: "%{BKY_MATH_ROUND_TOOLTIP}" },
        { type: "math_on_list", message0: "%1 %2", args0: [{ type: "field_dropdown", name: "OP", options: [["%{BKY_MATH_ONLIST_OPERATOR_SUM}", "SUM"], ["%{BKY_MATH_ONLIST_OPERATOR_MIN}", "MIN"], ["%{BKY_MATH_ONLIST_OPERATOR_MAX}", "MAX"], ["%{BKY_MATH_ONLIST_OPERATOR_AVERAGE}", "AVERAGE"], [
          "%{BKY_MATH_ONLIST_OPERATOR_MEDIAN}",
          "MEDIAN"
        ], ["%{BKY_MATH_ONLIST_OPERATOR_MODE}", "MODE"], ["%{BKY_MATH_ONLIST_OPERATOR_STD_DEV}", "STD_DEV"], ["%{BKY_MATH_ONLIST_OPERATOR_RANDOM}", "RANDOM"]] }, { type: "input_value", name: "LIST", check: "Array" }], output: "Number", style: "math_blocks", helpUrl: "%{BKY_MATH_ONLIST_HELPURL}", mutator: "math_modes_of_list_mutator", extensions: ["math_op_tooltip"] },
        {
          type: "math_modulo",
          message0: "%{BKY_MATH_MODULO_TITLE}",
          args0: [{ type: "input_value", name: "DIVIDEND", check: "Number" }, { type: "input_value", name: "DIVISOR", check: "Number" }],
          inputsInline: !0,
          output: "Number",
          style: "math_blocks",
          tooltip: "%{BKY_MATH_MODULO_TOOLTIP}",
          helpUrl: "%{BKY_MATH_MODULO_HELPURL}"
        },
        { type: "math_constrain", message0: "%{BKY_MATH_CONSTRAIN_TITLE}", args0: [{ type: "input_value", name: "VALUE", check: "Number" }, { type: "input_value", name: "LOW", check: "Number" }, { type: "input_value", name: "HIGH", check: "Number" }], inputsInline: !0, output: "Number", style: "math_blocks", tooltip: "%{BKY_MATH_CONSTRAIN_TOOLTIP}", helpUrl: "%{BKY_MATH_CONSTRAIN_HELPURL}" },
        {
          type: "math_random_int",
          message0: "%{BKY_MATH_RANDOM_INT_TITLE}",
          args0: [{ type: "input_value", name: "FROM", check: "Number" }, { type: "input_value", name: "TO", check: "Number" }],
          inputsInline: !0,
          output: "Number",
          style: "math_blocks",
          tooltip: "%{BKY_MATH_RANDOM_INT_TOOLTIP}",
          helpUrl: "%{BKY_MATH_RANDOM_INT_HELPURL}"
        },
        { type: "math_random_float", message0: "%{BKY_MATH_RANDOM_FLOAT_TITLE_RANDOM}", output: "Number", style: "math_blocks", tooltip: "%{BKY_MATH_RANDOM_FLOAT_TOOLTIP}", helpUrl: "%{BKY_MATH_RANDOM_FLOAT_HELPURL}" },
        { type: "math_atan2", message0: "%{BKY_MATH_ATAN2_TITLE}", args0: [{
          type: "input_value",
          name: "X",
          check: "Number"
        }, { type: "input_value", name: "Y", check: "Number" }], inputsInline: !0, output: "Number", style: "math_blocks", tooltip: "%{BKY_MATH_ATAN2_TOOLTIP}", helpUrl: "%{BKY_MATH_ATAN2_HELPURL}" }
      ]), Cr = {
        ADD: "%{BKY_MATH_ARITHMETIC_TOOLTIP_ADD}",
        MINUS: "%{BKY_MATH_ARITHMETIC_TOOLTIP_MINUS}",
        MULTIPLY: "%{BKY_MATH_ARITHMETIC_TOOLTIP_MULTIPLY}",
        DIVIDE: "%{BKY_MATH_ARITHMETIC_TOOLTIP_DIVIDE}",
        POWER: "%{BKY_MATH_ARITHMETIC_TOOLTIP_POWER}",
        ROOT: "%{BKY_MATH_SINGLE_TOOLTIP_ROOT}",
        ABS: "%{BKY_MATH_SINGLE_TOOLTIP_ABS}",
        NEG: "%{BKY_MATH_SINGLE_TOOLTIP_NEG}",
        LN: "%{BKY_MATH_SINGLE_TOOLTIP_LN}",
        LOG10: "%{BKY_MATH_SINGLE_TOOLTIP_LOG10}",
        EXP: "%{BKY_MATH_SINGLE_TOOLTIP_EXP}",
        POW10: "%{BKY_MATH_SINGLE_TOOLTIP_POW10}",
        SIN: "%{BKY_MATH_TRIG_TOOLTIP_SIN}",
        COS: "%{BKY_MATH_TRIG_TOOLTIP_COS}",
        TAN: "%{BKY_MATH_TRIG_TOOLTIP_TAN}",
        ASIN: "%{BKY_MATH_TRIG_TOOLTIP_ASIN}",
        ACOS: "%{BKY_MATH_TRIG_TOOLTIP_ACOS}",
        ATAN: "%{BKY_MATH_TRIG_TOOLTIP_ATAN}",
        SUM: "%{BKY_MATH_ONLIST_TOOLTIP_SUM}",
        MIN: "%{BKY_MATH_ONLIST_TOOLTIP_MIN}",
        MAX: "%{BKY_MATH_ONLIST_TOOLTIP_MAX}",
        AVERAGE: "%{BKY_MATH_ONLIST_TOOLTIP_AVERAGE}",
        MEDIAN: "%{BKY_MATH_ONLIST_TOOLTIP_MEDIAN}",
        MODE: "%{BKY_MATH_ONLIST_TOOLTIP_MODE}",
        STD_DEV: "%{BKY_MATH_ONLIST_TOOLTIP_STD_DEV}",
        RANDOM: "%{BKY_MATH_ONLIST_TOOLTIP_RANDOM}"
      };
      i.register$$module$build$src$core$extensions("math_op_tooltip", i.buildTooltipForDropdown$$module$build$src$core$extensions("OP", Cr));
      var fe = { mutationToDom: function() {
        const I = i.createElement$$module$build$src$core$utils$xml("mutation"), R = this.getFieldValue("PROPERTY") === "DIVISIBLE_BY";
        return I.setAttribute("divisor_input", String(R)), I;
      }, domToMutation: function(I) {
        I = I.getAttribute("divisor_input") === "true", this.updateShape_(I);
      }, updateShape_: function(I) {
        const R = this.getInput("DIVISOR");
        I ? R || this.appendValueInput("DIVISOR").setCheck("Number") : R && this.removeInput("DIVISOR");
      } }, vT = function() {
        this.getField("PROPERTY").setValidator(function(I) {
          I = I === "DIVISIBLE_BY", this.getSourceBlock().updateShape_(I);
        });
      };
      i.registerMutator$$module$build$src$core$extensions("math_is_divisibleby_mutator", fe, vT), i.register$$module$build$src$core$extensions("math_change_tooltip", i.buildTooltipWithFieldText$$module$build$src$core$extensions("%{BKY_MATH_CHANGE_TOOLTIP}", "VAR"));
      var on = { updateType_: function(I) {
        I === "MODE" ? this.outputConnection.setCheck("Array") : this.outputConnection.setCheck("Number");
      }, mutationToDom: function() {
        const I = i.createElement$$module$build$src$core$utils$xml("mutation");
        return I.setAttribute("op", this.getFieldValue("OP")), I;
      }, domToMutation: function(I) {
        if (I = I.getAttribute("op"), I === null)
          throw new TypeError("xmlElement had no op attribute");
        this.updateType_(I);
      } }, Ar = function() {
        this.getField("OP").setValidator((function(I) {
          this.updateType_(I);
        }).bind(this));
      };
      i.registerMutator$$module$build$src$core$extensions("math_modes_of_list_mutator", on, Ar), i.defineBlocks$$module$build$src$core$common(ur);
      var ii = {};
      ii.blocks = ur;
      var tt = {}, kr = {
        setStatements_: function(I) {
          this.hasStatements_ !== I && (I ? (this.appendStatementInput("STACK").appendField(i.Msg$$module$build$src$core$msg.PROCEDURES_DEFNORETURN_DO), this.getInput("RETURN") && this.moveInputBefore("STACK", "RETURN")) : this.removeInput("STACK", !0), this.hasStatements_ = I);
        },
        updateParams_: function() {
          let I = "";
          this.arguments_.length && (I = i.Msg$$module$build$src$core$msg.PROCEDURES_BEFORE_PARAMS + " " + this.arguments_.join(", ")), i.disable$$module$build$src$core$events$utils();
          try {
            this.setFieldValue(I, "PARAMS");
          } finally {
            i.enable$$module$build$src$core$events$utils();
          }
        },
        mutationToDom: function(I) {
          const R = i.createElement$$module$build$src$core$utils$xml("mutation");
          I && R.setAttribute("name", this.getFieldValue("NAME"));
          for (let B = 0; B < this.argumentVarModels_.length; B++) {
            const Y = i.createElement$$module$build$src$core$utils$xml("arg"), ie = this.argumentVarModels_[B];
            Y.setAttribute("name", ie.name), Y.setAttribute(
              "varid",
              ie.getId()
            ), I && this.paramIds_ && Y.setAttribute("paramId", this.paramIds_[B]), R.appendChild(Y);
          }
          return this.hasStatements_ || R.setAttribute("statements", "false"), R;
        },
        domToMutation: function(I) {
          this.arguments_ = [], this.argumentVarModels_ = [];
          for (let B = 0, Y; Y = I.childNodes[B]; B++)
            if (Y.nodeName.toLowerCase() === "arg") {
              var R = Y;
              const ie = R.getAttribute("name");
              R = R.getAttribute("varid") || R.getAttribute("varId"), this.arguments_.push(ie), R = i.getOrCreateVariablePackage$$module$build$src$core$variables(
                this.workspace,
                R,
                ie,
                ""
              ), R !== null ? this.argumentVarModels_.push(R) : console.log(`Failed to create a variable named "${ie}", ignoring.`);
            }
          this.updateParams_(), i.mutateCallers$$module$build$src$core$procedures(this), this.setStatements_(I.getAttribute("statements") !== "false");
        },
        saveExtraState: function() {
          if (!this.argumentVarModels_.length && this.hasStatements_)
            return null;
          const I = /* @__PURE__ */ Object.create(null);
          if (this.argumentVarModels_.length) {
            I.params = [];
            for (let R = 0; R < this.argumentVarModels_.length; R++)
              I.params.push({
                name: this.argumentVarModels_[R].name,
                id: this.argumentVarModels_[R].getId()
              });
          }
          return this.hasStatements_ || (I.hasStatements = !1), I;
        },
        loadExtraState: function(I) {
          if (this.arguments_ = [], this.argumentVarModels_ = [], I.params)
            for (let B = 0; B < I.params.length; B++) {
              var R = I.params[B];
              R = i.getOrCreateVariablePackage$$module$build$src$core$variables(this.workspace, R.id, R.name, ""), this.arguments_.push(R.name), this.argumentVarModels_.push(R);
            }
          this.updateParams_(), i.mutateCallers$$module$build$src$core$procedures(this), this.setStatements_(I.hasStatements !== !1);
        },
        decompose: function(I) {
          const R = i.createElement$$module$build$src$core$utils$xml("block");
          R.setAttribute("type", "procedures_mutatorcontainer");
          var B = i.createElement$$module$build$src$core$utils$xml("statement");
          B.setAttribute("name", "STACK"), R.appendChild(B);
          for (let ie = 0; ie < this.arguments_.length; ie++) {
            const ke = i.createElement$$module$build$src$core$utils$xml("block");
            ke.setAttribute("type", "procedures_mutatorarg");
            var Y = i.createElement$$module$build$src$core$utils$xml("field");
            Y.setAttribute(
              "name",
              "NAME"
            );
            const yt = i.createTextNode$$module$build$src$core$utils$xml(this.arguments_[ie]);
            Y.appendChild(yt), ke.appendChild(Y), Y = i.createElement$$module$build$src$core$utils$xml("next"), ke.appendChild(Y), B.appendChild(ke), B = Y;
          }
          return I = i.domToBlock$$module$build$src$core$xml(R, I), this.type === "procedures_defreturn" ? I.setFieldValue(this.hasStatements_, "STATEMENTS") : I.removeInput("STATEMENT_INPUT"), i.mutateCallers$$module$build$src$core$procedures(this), I;
        },
        compose: function(I) {
          this.arguments_ = [], this.paramIds_ = [], this.argumentVarModels_ = [];
          let R = I.getInputTargetBlock("STACK");
          for (; R && !R.isInsertionMarker(); ) {
            var B = R.getFieldValue("NAME");
            this.arguments_.push(B), B = this.workspace.getVariable(B, ""), this.argumentVarModels_.push(B), this.paramIds_.push(R.id), R = R.nextConnection && R.nextConnection.targetBlock();
          }
          if (this.updateParams_(), i.mutateCallers$$module$build$src$core$procedures(this), I = I.getFieldValue("STATEMENTS"), I !== null && (I = I === "TRUE", this.hasStatements_ !== I))
            if (I) {
              this.setStatements_(!0);
              var Y;
              (Y = this.statementConnection_) == null || Y.reconnect(this, "STACK"), this.statementConnection_ = null;
            } else
              Y = this.getInput("STACK").connection, (this.statementConnection_ = Y.targetConnection) && (Y = Y.targetBlock(), Y.unplug(), Y.bumpNeighbours()), this.setStatements_(!1);
        },
        getVars: function() {
          return this.arguments_;
        },
        getVarModels: function() {
          return this.argumentVarModels_;
        },
        renameVarById: function(I, R) {
          var B = this.workspace.getVariableById(I);
          if (B.type === "") {
            B = B.name, R = this.workspace.getVariableById(R);
            var Y = !1;
            for (let ie = 0; ie < this.argumentVarModels_.length; ie++)
              this.argumentVarModels_[ie].getId() === I && (this.arguments_[ie] = R.name, this.argumentVarModels_[ie] = R, Y = !0);
            Y && (this.displayRenamedVar_(B, R.name), i.mutateCallers$$module$build$src$core$procedures(this));
          }
        },
        updateVarName: function(I) {
          const R = I.name;
          let B = !1, Y;
          for (let ie = 0; ie < this.argumentVarModels_.length; ie++)
            this.argumentVarModels_[ie].getId() === I.getId() && (Y = this.arguments_[ie], this.arguments_[ie] = R, B = !0);
          B && (this.displayRenamedVar_(Y, R), i.mutateCallers$$module$build$src$core$procedures(this));
        },
        displayRenamedVar_: function(I, R) {
          this.updateParams_();
          var B = this.getIcon(i.MutatorIcon$$module$build$src$core$icons$mutator_icon.TYPE);
          if (B && B.bubbleIsVisible()) {
            B = B.getWorkspace().getAllBlocks(!1);
            for (let Y = 0, ie; ie = B[Y]; Y++)
              ie.type === "procedures_mutatorarg" && i.Names$$module$build$src$core$names.equals(I, ie.getFieldValue("NAME")) && ie.setFieldValue(R, "NAME");
          }
        },
        customContextMenu: function(I) {
          if (!this.isInFlyout) {
            var R = this.getFieldValue("NAME"), B = i.createElement$$module$build$src$core$utils$xml("mutation");
            B.setAttribute("name", R);
            for (var Y = 0; Y < this.arguments_.length; Y++) {
              var ie = i.createElement$$module$build$src$core$utils$xml("arg");
              ie.setAttribute("name", this.arguments_[Y]), B.appendChild(ie);
            }
            if (Y = i.createElement$$module$build$src$core$utils$xml("block"), Y.setAttribute("type", this.callType_), Y.appendChild(B), I.push({ enabled: !0, text: i.Msg$$module$build$src$core$msg.PROCEDURES_CREATE_DO.replace("%1", R), callback: i.callbackFactory$$module$build$src$core$contextmenu(this, Y) }), !this.isCollapsed())
              for (R = 0; R < this.argumentVarModels_.length; R++)
                B = this.argumentVarModels_[R], Y = i.generateVariableFieldDom$$module$build$src$core$variables(B), ie = i.createElement$$module$build$src$core$utils$xml("block"), ie.setAttribute("type", "variables_get"), ie.appendChild(Y), I.push({ enabled: !0, text: i.Msg$$module$build$src$core$msg.VARIABLES_SET_CREATE_GET.replace("%1", B.name), callback: i.callbackFactory$$module$build$src$core$contextmenu(this, ie) });
          }
        }
      };
      tt.procedures_defnoreturn = Object.assign({}, kr, { init: function() {
        var I = i.findLegalName$$module$build$src$core$procedures("", this);
        I = i.fromJson$$module$build$src$core$field_registry({ type: "field_input", text: I }), I.setValidator(i.rename$$module$build$src$core$procedures), I.setSpellcheck(!1), this.appendDummyInput().appendField(i.Msg$$module$build$src$core$msg.PROCEDURES_DEFNORETURN_TITLE).appendField(I, "NAME").appendField(
          "",
          "PARAMS"
        ), this.setMutator(new i.MutatorIcon$$module$build$src$core$icons$mutator_icon(["procedures_mutatorarg"], this)), (this.workspace.options.comments || this.workspace.options.parentWorkspace && this.workspace.options.parentWorkspace.options.comments) && i.Msg$$module$build$src$core$msg.PROCEDURES_DEFNORETURN_COMMENT && this.setCommentText(i.Msg$$module$build$src$core$msg.PROCEDURES_DEFNORETURN_COMMENT), this.setStyle("procedure_blocks"), this.setTooltip(i.Msg$$module$build$src$core$msg.PROCEDURES_DEFNORETURN_TOOLTIP), this.setHelpUrl(i.Msg$$module$build$src$core$msg.PROCEDURES_DEFNORETURN_HELPURL), this.arguments_ = [], this.argumentVarModels_ = [], this.setStatements_(!0), this.statementConnection_ = null;
      }, getProcedureDef: function() {
        return [this.getFieldValue("NAME"), this.arguments_, !1];
      }, callType_: "procedures_callnoreturn" }), tt.procedures_defreturn = Object.assign({}, kr, { init: function() {
        var I = i.findLegalName$$module$build$src$core$procedures("", this);
        I = i.fromJson$$module$build$src$core$field_registry({ type: "field_input", text: I }), I.setValidator(i.rename$$module$build$src$core$procedures), I.setSpellcheck(!1), this.appendDummyInput().appendField(i.Msg$$module$build$src$core$msg.PROCEDURES_DEFRETURN_TITLE).appendField(I, "NAME").appendField(
          "",
          "PARAMS"
        ), this.appendValueInput("RETURN").setAlign(i.Align$$module$build$src$core$inputs$input.RIGHT).appendField(i.Msg$$module$build$src$core$msg.PROCEDURES_DEFRETURN_RETURN), this.setMutator(new i.MutatorIcon$$module$build$src$core$icons$mutator_icon(["procedures_mutatorarg"], this)), (this.workspace.options.comments || this.workspace.options.parentWorkspace && this.workspace.options.parentWorkspace.options.comments) && i.Msg$$module$build$src$core$msg.PROCEDURES_DEFRETURN_COMMENT && this.setCommentText(i.Msg$$module$build$src$core$msg.PROCEDURES_DEFRETURN_COMMENT), this.setStyle("procedure_blocks"), this.setTooltip(i.Msg$$module$build$src$core$msg.PROCEDURES_DEFRETURN_TOOLTIP), this.setHelpUrl(i.Msg$$module$build$src$core$msg.PROCEDURES_DEFRETURN_HELPURL), this.arguments_ = [], this.argumentVarModels_ = [], this.setStatements_(!0), this.statementConnection_ = null;
      }, getProcedureDef: function() {
        return [this.getFieldValue("NAME"), this.arguments_, !0];
      }, callType_: "procedures_callreturn" });
      var oi = { init: function() {
        this.appendDummyInput().appendField(i.Msg$$module$build$src$core$msg.PROCEDURES_MUTATORCONTAINER_TITLE), this.appendStatementInput("STACK"), this.appendDummyInput("STATEMENT_INPUT").appendField(i.Msg$$module$build$src$core$msg.PROCEDURES_ALLOW_STATEMENTS).appendField(i.fromJson$$module$build$src$core$field_registry({ type: "field_checkbox", checked: !0 }), "STATEMENTS"), this.setStyle("procedure_blocks"), this.setTooltip(i.Msg$$module$build$src$core$msg.PROCEDURES_MUTATORCONTAINER_TOOLTIP), this.contextMenu = !1;
      } };
      tt.procedures_mutatorcontainer = oi;
      var bo = { init: function() {
        const I = i.fromJson$$module$build$src$core$field_registry({ type: "field_input", text: i.DEFAULT_ARG$$module$build$src$core$procedures });
        I.setValidator(this.validator_), I.oldShowEditorFn_ = I.showEditor_, I.showEditor_ = function() {
          this.createdVariables_ = [], this.oldShowEditorFn_();
        }, this.appendDummyInput().appendField(i.Msg$$module$build$src$core$msg.PROCEDURES_MUTATORARG_TITLE).appendField(I, "NAME"), this.setPreviousStatement(!0), this.setNextStatement(!0), this.setStyle("procedure_blocks"), this.setTooltip(i.Msg$$module$build$src$core$msg.PROCEDURES_MUTATORARG_TOOLTIP), this.contextMenu = !1, I.onFinishEditing_ = this.deleteIntermediateVars_, I.createdVariables_ = [], I.onFinishEditing_("x");
      }, validator_: function(I) {
        var R = this.getSourceBlock();
        const B = R.workspace.getRootWorkspace();
        if (I = I.replace(/[\s\xa0]+/g, " ").replace(/^ | $/g, ""), !I)
          return null;
        const Y = (R.workspace.targetWorkspace || R.workspace).getAllBlocks(!1), ie = I.toLowerCase();
        for (let ke = 0; ke < Y.length; ke++) {
          if (Y[ke].id === this.getSourceBlock().id)
            continue;
          const yt = Y[ke].getFieldValue("NAME");
          if (yt && yt.toLowerCase() === ie)
            return null;
        }
        return R.isInFlyout || ((R = B.getVariable(I, "")) && R.name !== I && B.renameVariableById(R.getId(), I), R || (R = B.createVariable(I, "")) && this.createdVariables_ && this.createdVariables_.push(R)), I;
      }, deleteIntermediateVars_: function(I) {
        const R = this.getSourceBlock().workspace.getRootWorkspace();
        if (R)
          for (let B = 0; B < this.createdVariables_.length; B++) {
            const Y = this.createdVariables_[B];
            Y.name !== I && R.deleteVariableById(Y.getId());
          }
      } };
      tt.procedures_mutatorarg = bo;
      var ge = { getProcedureCall: function() {
        return this.getFieldValue("NAME");
      }, renameProcedure: function(I, R) {
        i.Names$$module$build$src$core$names.equals(I, this.getProcedureCall()) && (this.setFieldValue(R, "NAME"), this.setTooltip((this.outputConnection ? i.Msg$$module$build$src$core$msg.PROCEDURES_CALLRETURN_TOOLTIP : i.Msg$$module$build$src$core$msg.PROCEDURES_CALLNORETURN_TOOLTIP).replace("%1", R)));
      }, setProcedureParameters_: function(I, R) {
        var B = i.getDefinition$$module$build$src$core$procedures(
          this.getProcedureCall(),
          this.workspace
        );
        if ((B = (B = B && B.getIcon(i.MutatorIcon$$module$build$src$core$icons$mutator_icon.TYPE)) && B.bubbleIsVisible()) ? this.setCollapsed(!1) : (this.quarkConnections_ = {}, this.quarkIds_ = null), I.join(`
`) === this.arguments_.join(`
`))
          this.quarkIds_ = R;
        else {
          if (R.length !== I.length)
            throw RangeError("paramNames and paramIds must be the same length.");
          this.quarkIds_ || (this.quarkConnections_ = {}, this.quarkIds_ = []);
          for (let ie = 0; ie < this.arguments_.length; ie++) {
            var Y = this.getInput("ARG" + ie);
            Y && (Y = Y.connection.targetConnection, this.quarkConnections_[this.quarkIds_[ie]] = Y, B && Y && R.indexOf(this.quarkIds_[ie]) === -1 && (Y.disconnect(), Y.getSourceBlock().bumpNeighbours()));
          }
          for (this.arguments_ = [].concat(I), this.argumentVarModels_ = [], I = 0; I < this.arguments_.length; I++)
            B = i.getOrCreateVariablePackage$$module$build$src$core$variables(this.workspace, null, this.arguments_[I], ""), this.argumentVarModels_.push(B);
          if (this.updateShape_(), this.quarkIds_ = R) {
            for (R = 0; R < this.arguments_.length; R++)
              if (I = this.quarkIds_[R], I in this.quarkConnections_) {
                let ie;
                (ie = this.quarkConnections_[I]) != null && ie.reconnect(this, "ARG" + R) || delete this.quarkConnections_[I];
              }
          }
        }
      }, updateShape_: function() {
        for (var I = 0; I < this.arguments_.length; I++) {
          var R = this.getField("ARGNAME" + I);
          if (R) {
            i.disable$$module$build$src$core$events$utils();
            try {
              R.setValue(this.arguments_[I]);
            } finally {
              i.enable$$module$build$src$core$events$utils();
            }
          } else
            R = i.fromJson$$module$build$src$core$field_registry({ type: "field_label", text: this.arguments_[I] }), this.appendValueInput("ARG" + I).setAlign(i.Align$$module$build$src$core$inputs$input.RIGHT).appendField(
              R,
              "ARGNAME" + I
            ).init();
        }
        for (I = this.arguments_.length; this.getInput("ARG" + I); I++)
          this.removeInput("ARG" + I);
        (I = this.getInput("TOPROW")) && (this.arguments_.length ? this.getField("WITH") || (I.appendField(i.Msg$$module$build$src$core$msg.PROCEDURES_CALL_BEFORE_PARAMS, "WITH"), I.init()) : this.getField("WITH") && I.removeField("WITH"));
      }, mutationToDom: function() {
        const I = i.createElement$$module$build$src$core$utils$xml("mutation");
        I.setAttribute("name", this.getProcedureCall());
        for (let R = 0; R < this.arguments_.length; R++) {
          const B = i.createElement$$module$build$src$core$utils$xml("arg");
          B.setAttribute("name", this.arguments_[R]), I.appendChild(B);
        }
        return I;
      }, domToMutation: function(I) {
        var R = I.getAttribute("name");
        this.renameProcedure(this.getProcedureCall(), R), R = [];
        const B = [];
        for (let Y = 0, ie; ie = I.childNodes[Y]; Y++)
          ie.nodeName.toLowerCase() === "arg" && (R.push(ie.getAttribute("name")), B.push(ie.getAttribute("paramId")));
        this.setProcedureParameters_(R, B);
      }, saveExtraState: function() {
        const I = /* @__PURE__ */ Object.create(null);
        return I.name = this.getProcedureCall(), this.arguments_.length && (I.params = this.arguments_), I;
      }, loadExtraState: function(I) {
        if (this.renameProcedure(this.getProcedureCall(), I.name), I = I.params) {
          const R = [];
          R.length = I.length, R.fill(null), this.setProcedureParameters_(I, R);
        }
      }, getVars: function() {
        return this.arguments_;
      }, getVarModels: function() {
        return this.argumentVarModels_;
      }, onchange: function(I) {
        if (this.workspace && !this.workspace.isFlyout && I.recordUndo)
          if (I.type === i.CREATE$$module$build$src$core$events$utils && I.ids.indexOf(this.id) !== -1) {
            var R = this.getProcedureCall();
            if (R = i.getDefinition$$module$build$src$core$procedures(R, this.workspace), !R || R.type === this.defType_ && JSON.stringify(R.getVars()) === JSON.stringify(this.arguments_) || (R = null), !R) {
              i.setGroup$$module$build$src$core$events$utils(I.group), I = i.createElement$$module$build$src$core$utils$xml("xml"), R = i.createElement$$module$build$src$core$utils$xml("block"), R.setAttribute("type", this.defType_);
              var B = this.getRelativeToSurfaceXY(), Y = B.y + 2 * i.config$$module$build$src$core$config.snapRadius;
              R.setAttribute("x", `${B.x + i.config$$module$build$src$core$config.snapRadius * (this.RTL ? -1 : 1)}`), R.setAttribute("y", `${Y}`), B = this.mutationToDom(), R.appendChild(B), B = i.createElement$$module$build$src$core$utils$xml("field"), B.setAttribute("name", "NAME"), Y = this.getProcedureCall();
              const ie = i.findLegalName$$module$build$src$core$procedures(Y, this);
              Y !== ie && this.renameProcedure(Y, ie), B.appendChild(i.createTextNode$$module$build$src$core$utils$xml(Y)), R.appendChild(B), I.appendChild(R), i.domToWorkspace$$module$build$src$core$xml(
                I,
                this.workspace
              ), i.setGroup$$module$build$src$core$events$utils(!1);
            }
          } else
            I.type === i.DELETE$$module$build$src$core$events$utils ? (R = this.getProcedureCall(), i.getDefinition$$module$build$src$core$procedures(R, this.workspace) || (i.setGroup$$module$build$src$core$events$utils(I.group), this.dispose(!0), i.setGroup$$module$build$src$core$events$utils(!1))) : I.type === i.CHANGE$$module$build$src$core$events$utils && I.element === "disabled" && (R = this.getProcedureCall(), (R = i.getDefinition$$module$build$src$core$procedures(
              R,
              this.workspace
            )) && R.id === I.blockId && ((R = i.getGroup$$module$build$src$core$events$utils()) && console.log("Saw an existing group while responding to a definition change"), i.setGroup$$module$build$src$core$events$utils(I.group), I.newValue ? (this.previousEnabledState_ = this.isEnabled(), this.setEnabled(!1)) : this.setEnabled(this.previousEnabledState_), i.setGroup$$module$build$src$core$events$utils(R)));
      }, customContextMenu: function(I) {
        if (this.workspace.isMovable()) {
          var R = this.getProcedureCall(), B = this.workspace;
          I.push({ enabled: !0, text: i.Msg$$module$build$src$core$msg.PROCEDURES_HIGHLIGHT_DEF, callback: function() {
            const Y = i.getDefinition$$module$build$src$core$procedures(R, B);
            Y && (B.centerOnBlock(Y.id), Y.select());
          } });
        }
      } };
      tt.procedures_callnoreturn = Object.assign({}, ge, { init: function() {
        this.appendDummyInput("TOPROW").appendField("", "NAME"), this.setPreviousStatement(!0), this.setNextStatement(!0), this.setStyle("procedure_blocks"), this.setHelpUrl(i.Msg$$module$build$src$core$msg.PROCEDURES_CALLNORETURN_HELPURL), this.arguments_ = [], this.argumentVarModels_ = [], this.quarkConnections_ = {}, this.quarkIds_ = null, this.previousEnabledState_ = !0;
      }, defType_: "procedures_defnoreturn" }), tt.procedures_callreturn = Object.assign({}, ge, { init: function() {
        this.appendDummyInput("TOPROW").appendField("", "NAME"), this.setOutput(!0), this.setStyle("procedure_blocks"), this.setHelpUrl(i.Msg$$module$build$src$core$msg.PROCEDURES_CALLRETURN_HELPURL), this.arguments_ = [], this.argumentVarModels_ = [], this.quarkConnections_ = {}, this.quarkIds_ = null, this.previousEnabledState_ = !0;
      }, defType_: "procedures_defreturn" });
      var Vn = { init: function() {
        this.appendValueInput("CONDITION").setCheck("Boolean").appendField(i.Msg$$module$build$src$core$msg.CONTROLS_IF_MSG_IF), this.appendValueInput("VALUE").appendField(i.Msg$$module$build$src$core$msg.PROCEDURES_DEFRETURN_RETURN), this.setInputsInline(!0), this.setPreviousStatement(!0), this.setNextStatement(!0), this.setStyle("procedure_blocks"), this.setTooltip(i.Msg$$module$build$src$core$msg.PROCEDURES_IFRETURN_TOOLTIP), this.setHelpUrl(i.Msg$$module$build$src$core$msg.PROCEDURES_IFRETURN_HELPURL), this.hasReturnValue_ = !0;
      }, mutationToDom: function() {
        const I = i.createElement$$module$build$src$core$utils$xml("mutation");
        return I.setAttribute("value", String(Number(this.hasReturnValue_))), I;
      }, domToMutation: function(I) {
        this.hasReturnValue_ = I.getAttribute("value") === "1", this.hasReturnValue_ || (this.removeInput("VALUE"), this.appendDummyInput("VALUE").appendField(i.Msg$$module$build$src$core$msg.PROCEDURES_DEFRETURN_RETURN));
      }, onchange: function(I) {
        if (!(this.workspace.isDragging && this.workspace.isDragging() || I.type !== i.MOVE$$module$build$src$core$events$utils)) {
          var R = !1, B = this;
          do {
            if (this.FUNCTION_TYPES.indexOf(B.type) !== -1) {
              R = !0;
              break;
            }
            B = B.getSurroundParent();
          } while (B);
          R ? (B.type === "procedures_defnoreturn" && this.hasReturnValue_ ? (this.removeInput("VALUE"), this.appendDummyInput("VALUE").appendField(i.Msg$$module$build$src$core$msg.PROCEDURES_DEFRETURN_RETURN), this.hasReturnValue_ = !1) : B.type !== "procedures_defreturn" || this.hasReturnValue_ || (this.removeInput("VALUE"), this.appendValueInput("VALUE").appendField(i.Msg$$module$build$src$core$msg.PROCEDURES_DEFRETURN_RETURN), this.hasReturnValue_ = !0), this.setWarningText(null)) : this.setWarningText(i.Msg$$module$build$src$core$msg.PROCEDURES_IFRETURN_WARNING), this.isInFlyout || (B = i.getGroup$$module$build$src$core$events$utils(), i.setGroup$$module$build$src$core$events$utils(I.group), this.setEnabled(R), i.setGroup$$module$build$src$core$events$utils(B));
        }
      }, FUNCTION_TYPES: ["procedures_defnoreturn", "procedures_defreturn"] };
      tt.procedures_ifreturn = Vn, i.defineBlocks$$module$build$src$core$common(tt);
      var Gn = {};
      Gn.blocks = tt;
      var Fr = i.createBlockDefinitionsFromJsonArray$$module$build$src$core$common([{ type: "text", message0: "%1", args0: [{ type: "field_input", name: "TEXT", text: "" }], output: "String", style: "text_blocks", helpUrl: "%{BKY_TEXT_TEXT_HELPURL}", tooltip: "%{BKY_TEXT_TEXT_TOOLTIP}", extensions: ["text_quotes", "parent_tooltip_when_inline"] }, { type: "text_multiline", message0: "%1 %2", args0: [{
        type: "field_image",
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAARCAYAAADpPU2iAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAAdhgAAHYYBXaITgQAAABh0RVh0U29mdHdhcmUAcGFpbnQubmV0IDQuMS42/U4J6AAAAP1JREFUOE+Vks0KQUEYhjmRIja4ABtZ2dm5A3t3Ia6AUm7CylYuQRaUhZSlLZJiQbFAyRnPN33y01HOW08z8873zpwzM4F3GWOCruvGIE4/rLaV+Nq1hVGMBqzhqlxgCys4wJA65xnogMHsQ5lujnYHTejBBCK2mE4abjCgMGhNxHgDFWjDSG07kdfVa2pZMf4ZyMAdWmpZMfYOsLiDMYMjlMB+K613QISRhTnITnsYg5yUd0DETmEoMlkFOeIT/A58iyK5E18BuTBfgYXfwNJv4P9/oEBerLylOnRhygmGdPpTTBZAPkde61lbQe4moWUvYUZYLfUNftIY4zwA5X2Z9AYnQrEAAAAASUVORK5CYII=",
        width: 12,
        height: 17,
        alt: "¶"
      }, { type: "field_multilinetext", name: "TEXT", text: "" }], output: "String", style: "text_blocks", helpUrl: "%{BKY_TEXT_TEXT_HELPURL}", tooltip: "%{BKY_TEXT_TEXT_TOOLTIP}", extensions: ["parent_tooltip_when_inline"] }, { type: "text_join", message0: "", output: "String", style: "text_blocks", helpUrl: "%{BKY_TEXT_JOIN_HELPURL}", tooltip: "%{BKY_TEXT_JOIN_TOOLTIP}", mutator: "text_join_mutator" }, { type: "text_create_join_container", message0: "%{BKY_TEXT_CREATE_JOIN_TITLE_JOIN} %1 %2", args0: [
        { type: "input_dummy" },
        { type: "input_statement", name: "STACK" }
      ], style: "text_blocks", tooltip: "%{BKY_TEXT_CREATE_JOIN_TOOLTIP}", enableContextMenu: !1 }, { type: "text_create_join_item", message0: "%{BKY_TEXT_CREATE_JOIN_ITEM_TITLE_ITEM}", previousStatement: null, nextStatement: null, style: "text_blocks", tooltip: "%{BKY_TEXT_CREATE_JOIN_ITEM_TOOLTIP}", enableContextMenu: !1 }, {
        type: "text_append",
        message0: "%{BKY_TEXT_APPEND_TITLE}",
        args0: [{ type: "field_variable", name: "VAR", variable: "%{BKY_TEXT_APPEND_VARIABLE}" }, { type: "input_value", name: "TEXT" }],
        previousStatement: null,
        nextStatement: null,
        style: "text_blocks",
        extensions: ["text_append_tooltip"]
      }, { type: "text_length", message0: "%{BKY_TEXT_LENGTH_TITLE}", args0: [{ type: "input_value", name: "VALUE", check: ["String", "Array"] }], output: "Number", style: "text_blocks", tooltip: "%{BKY_TEXT_LENGTH_TOOLTIP}", helpUrl: "%{BKY_TEXT_LENGTH_HELPURL}" }, {
        type: "text_isEmpty",
        message0: "%{BKY_TEXT_ISEMPTY_TITLE}",
        args0: [{ type: "input_value", name: "VALUE", check: ["String", "Array"] }],
        output: "Boolean",
        style: "text_blocks",
        tooltip: "%{BKY_TEXT_ISEMPTY_TOOLTIP}",
        helpUrl: "%{BKY_TEXT_ISEMPTY_HELPURL}"
      }, { type: "text_indexOf", message0: "%{BKY_TEXT_INDEXOF_TITLE}", args0: [{ type: "input_value", name: "VALUE", check: "String" }, { type: "field_dropdown", name: "END", options: [["%{BKY_TEXT_INDEXOF_OPERATOR_FIRST}", "FIRST"], ["%{BKY_TEXT_INDEXOF_OPERATOR_LAST}", "LAST"]] }, { type: "input_value", name: "FIND", check: "String" }], output: "Number", style: "text_blocks", helpUrl: "%{BKY_TEXT_INDEXOF_HELPURL}", inputsInline: !0, extensions: ["text_indexOf_tooltip"] }, {
        type: "text_charAt",
        message0: "%{BKY_TEXT_CHARAT_TITLE}",
        args0: [{ type: "input_value", name: "VALUE", check: "String" }, { type: "field_dropdown", name: "WHERE", options: [["%{BKY_TEXT_CHARAT_FROM_START}", "FROM_START"], ["%{BKY_TEXT_CHARAT_FROM_END}", "FROM_END"], ["%{BKY_TEXT_CHARAT_FIRST}", "FIRST"], ["%{BKY_TEXT_CHARAT_LAST}", "LAST"], ["%{BKY_TEXT_CHARAT_RANDOM}", "RANDOM"]] }],
        output: "String",
        style: "text_blocks",
        helpUrl: "%{BKY_TEXT_CHARAT_HELPURL}",
        inputsInline: !0,
        mutator: "text_charAt_mutator"
      }]), Hr = {
        init: function() {
          this.WHERE_OPTIONS_1 = [[i.Msg$$module$build$src$core$msg.TEXT_GET_SUBSTRING_START_FROM_START, "FROM_START"], [i.Msg$$module$build$src$core$msg.TEXT_GET_SUBSTRING_START_FROM_END, "FROM_END"], [i.Msg$$module$build$src$core$msg.TEXT_GET_SUBSTRING_START_FIRST, "FIRST"]], this.WHERE_OPTIONS_2 = [[i.Msg$$module$build$src$core$msg.TEXT_GET_SUBSTRING_END_FROM_START, "FROM_START"], [i.Msg$$module$build$src$core$msg.TEXT_GET_SUBSTRING_END_FROM_END, "FROM_END"], [i.Msg$$module$build$src$core$msg.TEXT_GET_SUBSTRING_END_LAST, "LAST"]], this.setHelpUrl(i.Msg$$module$build$src$core$msg.TEXT_GET_SUBSTRING_HELPURL), this.setStyle("text_blocks"), this.appendValueInput("STRING").setCheck("String").appendField(i.Msg$$module$build$src$core$msg.TEXT_GET_SUBSTRING_INPUT_IN_TEXT), this.appendDummyInput("AT1"), this.appendDummyInput("AT2"), i.Msg$$module$build$src$core$msg.TEXT_GET_SUBSTRING_TAIL && this.appendDummyInput("TAIL").appendField(i.Msg$$module$build$src$core$msg.TEXT_GET_SUBSTRING_TAIL), this.setInputsInline(!0), this.setOutput(!0, "String"), this.updateAt_(1, !0), this.updateAt_(2, !0), this.setTooltip(i.Msg$$module$build$src$core$msg.TEXT_GET_SUBSTRING_TOOLTIP);
        },
        mutationToDom: function() {
          const I = i.createElement$$module$build$src$core$utils$xml("mutation");
          var R = this.getInput("AT1") instanceof i.ValueInput$$module$build$src$core$inputs$value_input;
          return I.setAttribute("at1", `${R}`), R = this.getInput("AT2") instanceof i.ValueInput$$module$build$src$core$inputs$value_input, I.setAttribute("at2", `${R}`), I;
        },
        domToMutation: function(I) {
          const R = I.getAttribute("at1") === "true";
          I = I.getAttribute("at2") === "true", this.updateAt_(1, R), this.updateAt_(2, I);
        },
        updateAt_: function(I, R) {
          this.removeInput("AT" + I), this.removeInput("ORDINAL" + I, !0), R ? (this.appendValueInput("AT" + I).setCheck("Number"), i.Msg$$module$build$src$core$msg.ORDINAL_NUMBER_SUFFIX && this.appendDummyInput("ORDINAL" + I).appendField(i.Msg$$module$build$src$core$msg.ORDINAL_NUMBER_SUFFIX)) : this.appendDummyInput("AT" + I), I === 2 && i.Msg$$module$build$src$core$msg.TEXT_GET_SUBSTRING_TAIL && (this.removeInput("TAIL", !0), this.appendDummyInput("TAIL").appendField(i.Msg$$module$build$src$core$msg.TEXT_GET_SUBSTRING_TAIL));
          const B = i.fromJson$$module$build$src$core$field_registry({ type: "field_dropdown", options: this["WHERE_OPTIONS_" + I] });
          B.setValidator(function(Y) {
            const ie = Y === "FROM_START" || Y === "FROM_END";
            if (ie !== R) {
              const ke = this.getSourceBlock();
              return ke.updateAt_(I, ie), ke.setFieldValue(Y, "WHERE" + I), null;
            }
          }), this.getInput("AT" + I).appendField(B, "WHERE" + I), I === 1 && (this.moveInputBefore("AT1", "AT2"), this.getInput("ORDINAL1") && this.moveInputBefore("ORDINAL1", "AT2"));
        }
      };
      Fr.text_getSubstring = Hr, Fr.text_changeCase = { init: function() {
        const I = [[i.Msg$$module$build$src$core$msg.TEXT_CHANGECASE_OPERATOR_UPPERCASE, "UPPERCASE"], [i.Msg$$module$build$src$core$msg.TEXT_CHANGECASE_OPERATOR_LOWERCASE, "LOWERCASE"], [i.Msg$$module$build$src$core$msg.TEXT_CHANGECASE_OPERATOR_TITLECASE, "TITLECASE"]];
        this.setHelpUrl(i.Msg$$module$build$src$core$msg.TEXT_CHANGECASE_HELPURL), this.setStyle("text_blocks"), this.appendValueInput("TEXT").setCheck("String").appendField(i.fromJson$$module$build$src$core$field_registry({
          type: "field_dropdown",
          options: I
        }), "CASE"), this.setOutput(!0, "String"), this.setTooltip(i.Msg$$module$build$src$core$msg.TEXT_CHANGECASE_TOOLTIP);
      } }, Fr.text_trim = { init: function() {
        const I = [[i.Msg$$module$build$src$core$msg.TEXT_TRIM_OPERATOR_BOTH, "BOTH"], [i.Msg$$module$build$src$core$msg.TEXT_TRIM_OPERATOR_LEFT, "LEFT"], [i.Msg$$module$build$src$core$msg.TEXT_TRIM_OPERATOR_RIGHT, "RIGHT"]];
        this.setHelpUrl(i.Msg$$module$build$src$core$msg.TEXT_TRIM_HELPURL), this.setStyle("text_blocks"), this.appendValueInput("TEXT").setCheck("String").appendField(
          i.fromJson$$module$build$src$core$field_registry({ type: "field_dropdown", options: I }),
          "MODE"
        ), this.setOutput(!0, "String"), this.setTooltip(i.Msg$$module$build$src$core$msg.TEXT_TRIM_TOOLTIP);
      } }, Fr.text_print = { init: function() {
        this.jsonInit({ message0: i.Msg$$module$build$src$core$msg.TEXT_PRINT_TITLE, args0: [{ type: "input_value", name: "TEXT" }], previousStatement: null, nextStatement: null, style: "text_blocks", tooltip: i.Msg$$module$build$src$core$msg.TEXT_PRINT_TOOLTIP, helpUrl: i.Msg$$module$build$src$core$msg.TEXT_PRINT_HELPURL });
      } };
      var o_ = { updateType_: function(I) {
        this.outputConnection.setCheck(I === "NUMBER" ? "Number" : "String");
      }, mutationToDom: function() {
        const I = i.createElement$$module$build$src$core$utils$xml("mutation");
        return I.setAttribute("type", this.getFieldValue("TYPE")), I;
      }, domToMutation: function(I) {
        this.updateType_(I.getAttribute("type"));
      } };
      Fr.text_prompt_ext = Object.assign({}, o_, { init: function() {
        var I = [[i.Msg$$module$build$src$core$msg.TEXT_PROMPT_TYPE_TEXT, "TEXT"], [i.Msg$$module$build$src$core$msg.TEXT_PROMPT_TYPE_NUMBER, "NUMBER"]];
        this.setHelpUrl(i.Msg$$module$build$src$core$msg.TEXT_PROMPT_HELPURL), this.setStyle("text_blocks"), I = i.fromJson$$module$build$src$core$field_registry({ type: "field_dropdown", options: I }), I.setValidator((R) => {
          this.updateType_(R);
        }), this.appendValueInput("TEXT").appendField(
          I,
          "TYPE"
        ), this.setOutput(!0, "String"), this.setTooltip(() => this.getFieldValue("TYPE") === "TEXT" ? i.Msg$$module$build$src$core$msg.TEXT_PROMPT_TOOLTIP_TEXT : i.Msg$$module$build$src$core$msg.TEXT_PROMPT_TOOLTIP_NUMBER);
      } });
      var dr = Object.assign({}, o_, { init: function() {
        this.mixin(K);
        var I = [[i.Msg$$module$build$src$core$msg.TEXT_PROMPT_TYPE_TEXT, "TEXT"], [i.Msg$$module$build$src$core$msg.TEXT_PROMPT_TYPE_NUMBER, "NUMBER"]];
        this.setHelpUrl(i.Msg$$module$build$src$core$msg.TEXT_PROMPT_HELPURL), this.setStyle("text_blocks"), I = i.fromJson$$module$build$src$core$field_registry({
          type: "field_dropdown",
          options: I
        }), I.setValidator((R) => {
          this.updateType_(R);
        }), this.appendDummyInput().appendField(I, "TYPE").appendField(this.newQuote_(!0)).appendField(i.fromJson$$module$build$src$core$field_registry({ type: "field_input", text: "" }), "TEXT").appendField(this.newQuote_(!1)), this.setOutput(!0, "String"), this.setTooltip(() => this.getFieldValue("TYPE") === "TEXT" ? i.Msg$$module$build$src$core$msg.TEXT_PROMPT_TOOLTIP_TEXT : i.Msg$$module$build$src$core$msg.TEXT_PROMPT_TOOLTIP_NUMBER);
      } });
      Fr.text_prompt = dr, Fr.text_count = { init: function() {
        this.jsonInit({ message0: i.Msg$$module$build$src$core$msg.TEXT_COUNT_MESSAGE0, args0: [{ type: "input_value", name: "SUB", check: "String" }, { type: "input_value", name: "TEXT", check: "String" }], output: "Number", inputsInline: !0, style: "text_blocks", tooltip: i.Msg$$module$build$src$core$msg.TEXT_COUNT_TOOLTIP, helpUrl: i.Msg$$module$build$src$core$msg.TEXT_COUNT_HELPURL });
      } }, Fr.text_replace = { init: function() {
        this.jsonInit({ message0: i.Msg$$module$build$src$core$msg.TEXT_REPLACE_MESSAGE0, args0: [{ type: "input_value", name: "FROM", check: "String" }, { type: "input_value", name: "TO", check: "String" }, { type: "input_value", name: "TEXT", check: "String" }], output: "String", inputsInline: !0, style: "text_blocks", tooltip: i.Msg$$module$build$src$core$msg.TEXT_REPLACE_TOOLTIP, helpUrl: i.Msg$$module$build$src$core$msg.TEXT_REPLACE_HELPURL });
      } }, Fr.text_reverse = { init: function() {
        this.jsonInit({ message0: i.Msg$$module$build$src$core$msg.TEXT_REVERSE_MESSAGE0, args0: [{ type: "input_value", name: "TEXT", check: "String" }], output: "String", inputsInline: !0, style: "text_blocks", tooltip: i.Msg$$module$build$src$core$msg.TEXT_REVERSE_TOOLTIP, helpUrl: i.Msg$$module$build$src$core$msg.TEXT_REVERSE_HELPURL });
      } };
      var K = {
        QUOTE_IMAGE_LEFT_DATAURI: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAQAAAAqJXdxAAAAn0lEQVQI1z3OMa5BURSF4f/cQhAKjUQhuQmFNwGJEUi0RKN5rU7FHKhpjEH3TEMtkdBSCY1EIv8r7nFX9e29V7EBAOvu7RPjwmWGH/VuF8CyN9/OAdvqIXYLvtRaNjx9mMTDyo+NjAN1HNcl9ZQ5oQMM3dgDUqDo1l8DzvwmtZN7mnD+PkmLa+4mhrxVA9fRowBWmVBhFy5gYEjKMfz9AylsaRRgGzvZAAAAAElFTkSuQmCC",
        QUOTE_IMAGE_RIGHT_DATAURI: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAQAAAAqJXdxAAAAqUlEQVQI1z3KvUpCcRiA8ef9E4JNHhI0aFEacm1o0BsI0Slx8wa8gLauoDnoBhq7DcfWhggONDmJJgqCPA7neJ7p934EOOKOnM8Q7PDElo/4x4lFb2DmuUjcUzS3URnGib9qaPNbuXvBO3sGPHJDRG6fGVdMSeWDP2q99FQdFrz26Gu5Tq7dFMzUvbXy8KXeAj57cOklgA+u1B5AoslLtGIHQMaCVnwDnADZIFIrXsoXrgAAAABJRU5ErkJggg==",
        QUOTE_IMAGE_WIDTH: 12,
        QUOTE_IMAGE_HEIGHT: 12,
        quoteField_: function(I) {
          for (let R = 0, B; B = this.inputList[R]; R++)
            for (let Y = 0, ie; ie = B.fieldRow[Y]; Y++)
              if (I === ie.name) {
                B.insertFieldAt(Y, this.newQuote_(!0)), B.insertFieldAt(Y + 2, this.newQuote_(!1));
                return;
              }
          console.warn('field named "' + I + '" not found in ' + this.toDevString());
        },
        newQuote_: function(I) {
          return I = this.RTL ? !I : I, i.fromJson$$module$build$src$core$field_registry({
            type: "field_image",
            src: I ? this.QUOTE_IMAGE_LEFT_DATAURI : this.QUOTE_IMAGE_RIGHT_DATAURI,
            width: this.QUOTE_IMAGE_WIDTH,
            height: this.QUOTE_IMAGE_HEIGHT,
            alt: I ? "“" : "”"
          });
        }
      }, be = function() {
        this.mixin(K), this.quoteField_("TEXT");
      }, Ti = {
        itemCount_: 0,
        mutationToDom: function() {
          const I = i.createElement$$module$build$src$core$utils$xml("mutation");
          return I.setAttribute("items", `${this.itemCount_}`), I;
        },
        domToMutation: function(I) {
          this.itemCount_ = parseInt(I.getAttribute("items"), 10), this.updateShape_();
        },
        saveExtraState: function() {
          return { itemCount: this.itemCount_ };
        },
        loadExtraState: function(I) {
          this.itemCount_ = I.itemCount, this.updateShape_();
        },
        decompose: function(I) {
          const R = I.newBlock("text_create_join_container");
          R.initSvg();
          let B = R.getInput("STACK").connection;
          for (let Y = 0; Y < this.itemCount_; Y++) {
            const ie = I.newBlock("text_create_join_item");
            ie.initSvg(), B.connect(ie.previousConnection), B = ie.nextConnection;
          }
          return R;
        },
        compose: function(I) {
          var R = I.getInputTargetBlock("STACK");
          for (I = []; R; )
            R.isInsertionMarker() || I.push(R.valueConnection_), R = R.getNextBlock();
          for (R = 0; R < this.itemCount_; R++) {
            const B = this.getInput("ADD" + R).connection.targetConnection;
            B && I.indexOf(B) === -1 && B.disconnect();
          }
          for (this.itemCount_ = I.length, this.updateShape_(), R = 0; R < this.itemCount_; R++) {
            let B;
            (B = I[R]) == null || B.reconnect(this, "ADD" + R);
          }
        },
        saveConnections: function(I) {
          I = I.getInputTargetBlock("STACK");
          let R = 0;
          for (; I; ) {
            if (I.isInsertionMarker()) {
              I = I.getNextBlock();
              continue;
            }
            const B = this.getInput("ADD" + R);
            I.valueConnection_ = B && B.connection.targetConnection, I = I.getNextBlock(), R++;
          }
        },
        updateShape_: function() {
          this.itemCount_ && this.getInput("EMPTY") ? this.removeInput("EMPTY") : this.itemCount_ || this.getInput("EMPTY") || this.appendDummyInput("EMPTY").appendField(this.newQuote_(!0)).appendField(this.newQuote_(!1));
          for (var I = 0; I < this.itemCount_; I++)
            if (!this.getInput("ADD" + I)) {
              const R = this.appendValueInput("ADD" + I).setAlign(i.Align$$module$build$src$core$inputs$align.RIGHT);
              I === 0 && R.appendField(i.Msg$$module$build$src$core$msg.TEXT_JOIN_TITLE_CREATEWITH);
            }
          for (I = this.itemCount_; this.getInput("ADD" + I); I++)
            this.removeInput("ADD" + I);
        }
      }, Be = function() {
        this.mixin(K), this.itemCount_ = 2, this.updateShape_(), this.setMutator(new i.MutatorIcon$$module$build$src$core$icons$mutator_icon(["text_create_join_item"], this));
      };
      i.register$$module$build$src$core$extensions("text_append_tooltip", i.buildTooltipWithFieldText$$module$build$src$core$extensions("%{BKY_TEXT_APPEND_TOOLTIP}", "VAR"));
      var b_ = function() {
        this.setTooltip(() => i.Msg$$module$build$src$core$msg.TEXT_INDEXOF_TOOLTIP.replace("%1", this.workspace.options.oneBasedIndex ? "0" : "-1"));
      }, Tt = { isAt_: !1, mutationToDom: function() {
        const I = i.createElement$$module$build$src$core$utils$xml("mutation");
        return I.setAttribute("at", `${this.isAt_}`), I;
      }, domToMutation: function(I) {
        I = I.getAttribute("at") !== "false", this.updateAt_(I);
      }, updateAt_: function(I) {
        this.removeInput(
          "AT",
          !0
        ), this.removeInput("ORDINAL", !0), I && (this.appendValueInput("AT").setCheck("Number"), i.Msg$$module$build$src$core$msg.ORDINAL_NUMBER_SUFFIX && this.appendDummyInput("ORDINAL").appendField(i.Msg$$module$build$src$core$msg.ORDINAL_NUMBER_SUFFIX)), i.Msg$$module$build$src$core$msg.TEXT_CHARAT_TAIL && (this.removeInput("TAIL", !0), this.appendDummyInput("TAIL").appendField(i.Msg$$module$build$src$core$msg.TEXT_CHARAT_TAIL)), this.isAt_ = I;
      } }, Sr = function() {
        this.getField("WHERE").setValidator(function(I) {
          I = I === "FROM_START" || I === "FROM_END";
          const R = this.getSourceBlock();
          I !== R.isAt_ && R.updateAt_(I);
        }), this.updateAt_(!0), this.setTooltip(() => {
          var I = this.getFieldValue("WHERE");
          let R = i.Msg$$module$build$src$core$msg.TEXT_CHARAT_TOOLTIP;
          return (I === "FROM_START" || I === "FROM_END") && (I = I === "FROM_START" ? i.Msg$$module$build$src$core$msg.LISTS_INDEX_FROM_START_TOOLTIP : i.Msg$$module$build$src$core$msg.LISTS_INDEX_FROM_END_TOOLTIP) && (R += "  " + I.replace("%1", this.workspace.options.oneBasedIndex ? "#1" : "#0")), R;
        });
      };
      i.register$$module$build$src$core$extensions("text_indexOf_tooltip", b_), i.register$$module$build$src$core$extensions("text_quotes", be), i.registerMutator$$module$build$src$core$extensions("text_join_mutator", Ti, Be), i.registerMutator$$module$build$src$core$extensions("text_charAt_mutator", Tt, Sr), i.defineBlocks$$module$build$src$core$common(Fr);
      var wi = {};
      wi.blocks = Fr;
      var C_ = i.createBlockDefinitionsFromJsonArray$$module$build$src$core$common([{ type: "variables_get", message0: "%1", args0: [{ type: "field_variable", name: "VAR", variable: "%{BKY_VARIABLES_DEFAULT_NAME}" }], output: null, style: "variable_blocks", helpUrl: "%{BKY_VARIABLES_GET_HELPURL}", tooltip: "%{BKY_VARIABLES_GET_TOOLTIP}", extensions: ["contextMenu_variableSetterGetter"] }, { type: "variables_set", message0: "%{BKY_VARIABLES_SET}", args0: [
        { type: "field_variable", name: "VAR", variable: "%{BKY_VARIABLES_DEFAULT_NAME}" },
        { type: "input_value", name: "VALUE" }
      ], previousStatement: null, nextStatement: null, style: "variable_blocks", tooltip: "%{BKY_VARIABLES_SET_TOOLTIP}", helpUrl: "%{BKY_VARIABLES_SET_HELPURL}", extensions: ["contextMenu_variableSetterGetter"] }]), wr = { customContextMenu: function(I) {
        if (this.isInFlyout)
          (this.type === "variables_get" || this.type === "variables_get_reporter") && (R = { text: i.Msg$$module$build$src$core$msg.RENAME_VARIABLE, enabled: !0, callback: Qt(this) }, B = this.getField("VAR").getText(), B = { text: i.Msg$$module$build$src$core$msg.DELETE_VARIABLE.replace("%1", B), enabled: !0, callback: O_(this) }, I.unshift(R), I.unshift(B));
        else {
          if (this.type === "variables_get")
            var R = "variables_set", B = i.Msg$$module$build$src$core$msg.VARIABLES_GET_CREATE_SET;
          else
            R = "variables_get", B = i.Msg$$module$build$src$core$msg.VARIABLES_SET_CREATE_GET;
          const Y = this.getField("VAR").getText(), ie = i.createElement$$module$build$src$core$utils$xml("field");
          ie.setAttribute("name", "VAR"), ie.appendChild(i.createTextNode$$module$build$src$core$utils$xml(Y));
          const ke = i.createElement$$module$build$src$core$utils$xml("block");
          ke.setAttribute("type", R), ke.appendChild(ie), I.push({ enabled: 0 < this.workspace.remainingCapacity(), text: B.replace("%1", Y), callback: i.callbackFactory$$module$build$src$core$contextmenu(
            this,
            ke
          ) });
        }
      } }, Qt = function(I) {
        return function() {
          const R = I.workspace, B = I.getField("VAR").getVariable();
          i.renameVariable$$module$build$src$core$variables(R, B);
        };
      }, O_ = function(I) {
        return function() {
          const R = I.workspace, B = I.getField("VAR").getVariable();
          R.deleteVariableById(B.getId()), R.refreshToolboxSelection();
        };
      };
      i.registerMixin$$module$build$src$core$extensions("contextMenu_variableSetterGetter", wr), i.defineBlocks$$module$build$src$core$common(C_);
      var xr = {};
      xr.blocks = C_;
      var T_ = i.createBlockDefinitionsFromJsonArray$$module$build$src$core$common([{ type: "variables_get_dynamic", message0: "%1", args0: [{ type: "field_variable", name: "VAR", variable: "%{BKY_VARIABLES_DEFAULT_NAME}" }], output: null, style: "variable_dynamic_blocks", helpUrl: "%{BKY_VARIABLES_GET_HELPURL}", tooltip: "%{BKY_VARIABLES_GET_TOOLTIP}", extensions: ["contextMenu_variableDynamicSetterGetter"] }, { type: "variables_set_dynamic", message0: "%{BKY_VARIABLES_SET}", args0: [{
        type: "field_variable",
        name: "VAR",
        variable: "%{BKY_VARIABLES_DEFAULT_NAME}"
      }, { type: "input_value", name: "VALUE" }], previousStatement: null, nextStatement: null, style: "variable_dynamic_blocks", tooltip: "%{BKY_VARIABLES_SET_TOOLTIP}", helpUrl: "%{BKY_VARIABLES_SET_HELPURL}", extensions: ["contextMenu_variableDynamicSetterGetter"] }]), Hn = { customContextMenu: function(I) {
        if (this.isInFlyout)
          (this.type === "variables_get_dynamic" || this.type === "variables_get_reporter_dynamic") && (R = { text: i.Msg$$module$build$src$core$msg.RENAME_VARIABLE, enabled: !0, callback: si(this) }, Y = this.getField("VAR").getText(), Y = { text: i.Msg$$module$build$src$core$msg.DELETE_VARIABLE.replace(
            "%1",
            Y
          ), enabled: !0, callback: R_(this) }, I.unshift(R), I.unshift(Y));
        else {
          var R = this.getFieldValue("VAR"), B = this.workspace.getVariableById(R).type;
          if (this.type === "variables_get_dynamic") {
            R = "variables_set_dynamic";
            var Y = i.Msg$$module$build$src$core$msg.VARIABLES_GET_CREATE_SET;
          } else
            R = "variables_get_dynamic", Y = i.Msg$$module$build$src$core$msg.VARIABLES_SET_CREATE_GET;
          const ie = this.getField("VAR").getText(), ke = i.createElement$$module$build$src$core$utils$xml("field");
          ke.setAttribute("name", "VAR"), ke.setAttribute("variabletype", B), ke.appendChild(i.createTextNode$$module$build$src$core$utils$xml(ie)), B = i.createElement$$module$build$src$core$utils$xml("block"), B.setAttribute("type", R), B.appendChild(ke), I.push({ enabled: 0 < this.workspace.remainingCapacity(), text: Y.replace("%1", ie), callback: i.callbackFactory$$module$build$src$core$contextmenu(this, B) });
        }
      }, onchange: function(I) {
        I = this.getFieldValue("VAR"), I = i.getVariable$$module$build$src$core$variables(this.workspace, I), this.type === "variables_get_dynamic" ? this.outputConnection.setCheck(I.type) : this.getInput("VALUE").connection.setCheck(I.type);
      } }, si = function(I) {
        return function() {
          const R = I.workspace, B = I.getField("VAR").getVariable();
          i.renameVariable$$module$build$src$core$variables(R, B);
        };
      }, R_ = function(I) {
        return function() {
          const R = I.workspace, B = I.getField("VAR").getVariable();
          R.deleteVariableById(B.getId()), R.refreshToolboxSelection();
        };
      };
      i.registerMixin$$module$build$src$core$extensions("contextMenu_variableDynamicSetterGetter", Hn), i.defineBlocks$$module$build$src$core$common(T_);
      var Xr = {};
      Xr.blocks = T_;
      var li = Object.assign({}, a, E, et, Je, ur, tt, C_, T_), k = {};
      return k.blocks = li, k.colour = p, k.lists = ve, k.loops = Gr, k.math = ii, k.procedures = Gn, k.texts = wi, k.variables = xr, k.variablesDynamic = Xr, k.__namespace__ = i, k;
    });
  }(nh)), nh.exports;
}
var l4;
function VM() {
  return l4 || (l4 = 1, function(_, s) {
    (function(r, i) {
      _.exports = i(UM());
    })(nn, function(r) {
      /**
       * @license
       * Copyright 2020 Google LLC
       * SPDX-License-Identifier: Apache-2.0
       */
      return r;
    });
  }(rh)), rh.exports;
}
var _h = { exports: {} }, ih = { exports: {} }, a4;
function GM() {
  return a4 || (a4 = 1, function(_, s) {
    (function(r, i) {
      _.exports = i(yh());
    })(nn, function(r) {
      var i = r.__namespace__, a = function(m, b) {
        return [b.quote_(m.getFieldValue("COLOUR")), k.ATOMIC];
      }, p = function(m, b) {
        return [b.provideFunction_("colourRandom", `
function ${b.FUNCTION_NAME_PLACEHOLDER_}() {
  var num = Math.floor(Math.random() * Math.pow(2, 24));
  return '#' + ('00000' + num.toString(16)).substr(-6);
}
`) + "()", k.FUNCTION_CALL];
      }, E = function(m, b) {
        const W = b.valueToCode(m, "RED", k.NONE) || 0, H = b.valueToCode(m, "GREEN", k.NONE) || 0;
        return m = b.valueToCode(m, "BLUE", k.NONE) || 0, [b.provideFunction_(
          "colourRgb",
          `
function ${b.FUNCTION_NAME_PLACEHOLDER_}(r, g, b) {
  r = Math.max(Math.min(Number(r), 100), 0) * 2.55;
  g = Math.max(Math.min(Number(g), 100), 0) * 2.55;
  b = Math.max(Math.min(Number(b), 100), 0) * 2.55;
  r = ('0' + (Math.round(r) || 0).toString(16)).slice(-2);
  g = ('0' + (Math.round(g) || 0).toString(16)).slice(-2);
  b = ('0' + (Math.round(b) || 0).toString(16)).slice(-2);
  return '#' + r + g + b;
}
`
        ) + "(" + W + ", " + H + ", " + m + ")", k.FUNCTION_CALL];
      }, h = function(m, b) {
        const W = b.valueToCode(m, "COLOUR1", k.NONE) || "'#000000'", H = b.valueToCode(m, "COLOUR2", k.NONE) || "'#000000'";
        return m = b.valueToCode(m, "RATIO", k.NONE) || 0.5, [b.provideFunction_("colourBlend", `
function ${b.FUNCTION_NAME_PLACEHOLDER_}(c1, c2, ratio) {
  ratio = Math.max(Math.min(Number(ratio), 1), 0);
  var r1 = parseInt(c1.substring(1, 3), 16);
  var g1 = parseInt(c1.substring(3, 5), 16);
  var b1 = parseInt(c1.substring(5, 7), 16);
  var r2 = parseInt(c2.substring(1, 3), 16);
  var g2 = parseInt(c2.substring(3, 5), 16);
  var b2 = parseInt(c2.substring(5, 7), 16);
  var r = Math.round(r1 * (1 - ratio) + r2 * ratio);
  var g = Math.round(g1 * (1 - ratio) + g2 * ratio);
  var b = Math.round(b1 * (1 - ratio) + b2 * ratio);
  r = ('0' + (r || 0).toString(16)).slice(-2);
  g = ('0' + (g || 0).toString(16)).slice(-2);
  b = ('0' + (b || 0).toString(16)).slice(-2);
  return '#' + r + g + b;
}
`) + "(" + W + ", " + H + ", " + m + ")", k.FUNCTION_CALL];
      }, L = function(m, b) {
        return ["[]", k.ATOMIC];
      }, y = function(m, b) {
        const W = Array(m.itemCount_);
        for (let H = 0; H < m.itemCount_; H++)
          W[H] = b.valueToCode(m, "ADD" + H, k.NONE) || "null";
        return ["[" + W.join(", ") + "]", k.ATOMIC];
      }, V = function(m, b) {
        const W = b.provideFunction_("listsRepeat", `
function ${b.FUNCTION_NAME_PLACEHOLDER_}(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}
`), H = b.valueToCode(m, "ITEM", k.NONE) || "null";
        return m = b.valueToCode(m, "NUM", k.NONE) || "0", [W + "(" + H + ", " + m + ")", k.FUNCTION_CALL];
      }, Z = function(m, b) {
        return [(b.valueToCode(m, "VALUE", k.MEMBER) || "[]") + ".length", k.MEMBER];
      }, le = function(m, b) {
        return ["!" + (b.valueToCode(m, "VALUE", k.MEMBER) || "[]") + ".length", k.LOGICAL_NOT];
      }, ce = function(m, b) {
        const W = m.getFieldValue("END") === "FIRST" ? "indexOf" : "lastIndexOf", H = b.valueToCode(m, "FIND", k.NONE) || "''";
        return b = (b.valueToCode(m, "VALUE", k.MEMBER) || "[]") + "." + W + "(" + H + ")", m.workspace.options.oneBasedIndex ? [b + " + 1", k.ADDITION] : [b, k.FUNCTION_CALL];
      }, ve = function(m, b) {
        const W = m.getFieldValue("MODE") || "GET", H = m.getFieldValue("WHERE") || "FROM_START";
        var ee = b.valueToCode(m, "VALUE", H === "RANDOM" ? k.NONE : k.MEMBER) || "[]";
        switch (H) {
          case "FIRST":
            if (W === "GET")
              return [ee + "[0]", k.MEMBER];
            if (W === "GET_REMOVE")
              return [ee + ".shift()", k.MEMBER];
            if (W === "REMOVE")
              return ee + `.shift();
`;
            break;
          case "LAST":
            if (W === "GET")
              return [ee + ".slice(-1)[0]", k.MEMBER];
            if (W === "GET_REMOVE")
              return [ee + ".pop()", k.MEMBER];
            if (W === "REMOVE")
              return ee + `.pop();
`;
            break;
          case "FROM_START":
            if (m = b.getAdjusted(m, "AT"), W === "GET")
              return [ee + "[" + m + "]", k.MEMBER];
            if (W === "GET_REMOVE")
              return [ee + ".splice(" + m + ", 1)[0]", k.FUNCTION_CALL];
            if (W === "REMOVE")
              return ee + ".splice(" + m + `, 1);
`;
            break;
          case "FROM_END":
            if (m = b.getAdjusted(m, "AT", 1, !0), W === "GET")
              return [ee + ".slice(" + m + ")[0]", k.FUNCTION_CALL];
            if (W === "GET_REMOVE")
              return [ee + ".splice(" + m + ", 1)[0]", k.FUNCTION_CALL];
            if (W === "REMOVE")
              return ee + ".splice(" + m + ", 1);";
            break;
          case "RANDOM":
            if (ee = b.provideFunction_("listsGetRandomItem", `
function ${b.FUNCTION_NAME_PLACEHOLDER_}(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}
`) + "(" + ee + ", " + (W !== "GET") + ")", W === "GET" || W === "GET_REMOVE")
              return [ee, k.FUNCTION_CALL];
            if (W === "REMOVE")
              return ee + `;
`;
        }
        throw Error("Unhandled combination (lists_getIndex).");
      }, et = function(m, b) {
        function W() {
          if (H.match(/^\w+$/))
            return "";
          const qt = b.nameDB_.getDistinctName("tmpList", i.NameType$$module$build$src$core$names.VARIABLE), Yi = "var " + qt + " = " + H + `;
`;
          return H = qt, Yi;
        }
        let H = b.valueToCode(
          m,
          "LIST",
          k.MEMBER
        ) || "[]";
        const ee = m.getFieldValue("MODE") || "GET";
        var me = m.getFieldValue("WHERE") || "FROM_START";
        const Ge = b.valueToCode(m, "TO", k.ASSIGNMENT) || "null";
        switch (me) {
          case "FIRST":
            if (ee === "SET")
              return H + "[0] = " + Ge + `;
`;
            if (ee === "INSERT")
              return H + ".unshift(" + Ge + `);
`;
            break;
          case "LAST":
            if (ee === "SET")
              return W() + (H + "[" + H + ".length - 1] = " + Ge + `;
`);
            if (ee === "INSERT")
              return H + ".push(" + Ge + `);
`;
            break;
          case "FROM_START":
            if (m = b.getAdjusted(m, "AT"), ee === "SET")
              return H + "[" + m + "] = " + Ge + `;
`;
            if (ee === "INSERT")
              return H + ".splice(" + m + ", 0, " + Ge + `);
`;
            break;
          case "FROM_END":
            if (m = b.getAdjusted(m, "AT", 1, !1, k.SUBTRACTION), me = W(), ee === "SET")
              return me + (H + "[" + H + ".length - " + m + "] = " + Ge + `;
`);
            if (ee === "INSERT")
              return me + (H + ".splice(" + H + ".length - " + m + ", 0, " + Ge + `);
`);
            break;
          case "RANDOM":
            if (m = W(), me = b.nameDB_.getDistinctName("tmpX", i.NameType$$module$build$src$core$names.VARIABLE), m += "var " + me + " = Math.floor(Math.random() * " + H + `.length);
`, ee === "SET")
              return m + (H + "[" + me + "] = " + Ge + `;
`);
            if (ee === "INSERT")
              return m + (H + ".splice(" + me + ", 0, " + Ge + `);
`);
        }
        throw Error("Unhandled combination (lists_setIndex).");
      }, Te = function(m, b) {
        var W = b.valueToCode(m, "LIST", k.MEMBER) || "[]", H = m.getFieldValue("WHERE1");
        const ee = m.getFieldValue("WHERE2");
        if (H === "FIRST" && ee === "LAST")
          W += ".slice(0)";
        else if (W.match(/^\w+$/) || H !== "FROM_END" && ee === "FROM_START") {
          switch (H) {
            case "FROM_START":
              H = b.getAdjusted(m, "AT1");
              break;
            case "FROM_END":
              H = b.getAdjusted(m, "AT1", 1, !1, k.SUBTRACTION), H = W + ".length - " + H;
              break;
            case "FIRST":
              H = "0";
              break;
            default:
              throw Error("Unhandled option (lists_getSublist).");
          }
          switch (ee) {
            case "FROM_START":
              b = b.getAdjusted(m, "AT2", 1);
              break;
            case "FROM_END":
              b = b.getAdjusted(m, "AT2", 0, !1, k.SUBTRACTION), b = W + ".length - " + b;
              break;
            case "LAST":
              b = W + ".length";
              break;
            default:
              throw Error("Unhandled option (lists_getSublist).");
          }
          W = W + ".slice(" + H + ", " + b + ")";
        } else {
          const me = b.getAdjusted(m, "AT1");
          m = b.getAdjusted(m, "AT2");
          const Ge = { FIRST: "First", LAST: "Last", FROM_START: "FromStart", FROM_END: "FromEnd" };
          W = b.provideFunction_("subsequence" + Ge[H] + Ge[ee], `
function ${b.FUNCTION_NAME_PLACEHOLDER_}(sequence${H === "FROM_END" || H === "FROM_START" ? ", at1" : ""}${ee === "FROM_END" || ee === "FROM_START" ? ", at2" : ""}) {
  var start = ${B("sequence", H, "at1")};
  var end = ${B("sequence", ee, "at2")} + 1;
  return sequence.slice(start, end);
}
`) + "(" + W + (H === "FROM_END" || H === "FROM_START" ? ", " + me : "") + (ee === "FROM_END" || ee === "FROM_START" ? ", " + m : "") + ")";
        }
        return [W, k.FUNCTION_CALL];
      }, Le = function(m, b) {
        const W = b.valueToCode(m, "LIST", k.FUNCTION_CALL) || "[]", H = m.getFieldValue("DIRECTION") === "1" ? 1 : -1;
        return m = m.getFieldValue("TYPE"), b = b.provideFunction_("listsGetSortCompare", `
function ${b.FUNCTION_NAME_PLACEHOLDER_}(type, direction) {
  var compareFuncs = {
    'NUMERIC': function(a, b) {
        return Number(a) - Number(b); },
    'TEXT': function(a, b) {
        return String(a) > String(b) ? 1 : -1; },
    'IGNORE_CASE': function(a, b) {
        return String(a).toLowerCase() > String(b).toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; };
}
      `), [W + ".slice().sort(" + b + '("' + m + '", ' + H + "))", k.FUNCTION_CALL];
      }, we = function(m, b) {
        let W = b.valueToCode(m, "INPUT", k.MEMBER);
        if (b = b.valueToCode(m, "DELIM", k.NONE) || "''", m = m.getFieldValue("MODE"), m === "SPLIT")
          W || (W = "''"), m = "split";
        else if (m === "JOIN")
          W || (W = "[]"), m = "join";
        else
          throw Error("Unknown mode: " + m);
        return [W + "." + m + "(" + b + ")", k.FUNCTION_CALL];
      }, ot = function(m, b) {
        return [(b.valueToCode(m, "LIST", k.FUNCTION_CALL) || "[]") + ".slice().reverse()", k.FUNCTION_CALL];
      }, pr = function(m, b) {
        var W = 0;
        let H = "";
        b.STATEMENT_PREFIX && (H += b.injectId(b.STATEMENT_PREFIX, m));
        do {
          const ee = b.valueToCode(m, "IF" + W, k.NONE) || "false";
          let me = b.statementToCode(m, "DO" + W);
          b.STATEMENT_SUFFIX && (me = b.prefixLines(b.injectId(b.STATEMENT_SUFFIX, m), b.INDENT) + me), H += (0 < W ? " else " : "") + "if (" + ee + `) {
` + me + "}", W++;
        } while (m.getInput("IF" + W));
        return (m.getInput("ELSE") || b.STATEMENT_SUFFIX) && (W = b.statementToCode(m, "ELSE"), b.STATEMENT_SUFFIX && (W = b.prefixLines(b.injectId(
          b.STATEMENT_SUFFIX,
          m
        ), b.INDENT) + W), H += ` else {
` + W + "}"), H + `
`;
      }, Zt = function(m, b) {
        const W = { EQ: "==", NEQ: "!=", LT: "<", LTE: "<=", GT: ">", GTE: ">=" }[m.getFieldValue("OP")], H = W === "==" || W === "!=" ? k.EQUALITY : k.RELATIONAL, ee = b.valueToCode(m, "A", H) || "0";
        return m = b.valueToCode(m, "B", H) || "0", [ee + " " + W + " " + m, H];
      }, Je = function(m, b) {
        const W = m.getFieldValue("OP") === "AND" ? "&&" : "||", H = W === "&&" ? k.LOGICAL_AND : k.LOGICAL_OR;
        let ee = b.valueToCode(m, "A", H);
        return m = b.valueToCode(m, "B", H), ee || m ? (b = W === "&&" ? "true" : "false", ee || (ee = b), m || (m = b)) : m = ee = "false", [ee + " " + W + " " + m, H];
      }, Rt = function(m, b) {
        const W = k.LOGICAL_NOT;
        return ["!" + (b.valueToCode(m, "BOOL", W) || "true"), W];
      }, Wr = function(m, b) {
        return [m.getFieldValue("BOOL") === "TRUE" ? "true" : "false", k.ATOMIC];
      }, Un = function(m, b) {
        return ["null", k.ATOMIC];
      }, No = function(m, b) {
        const W = b.valueToCode(
          m,
          "IF",
          k.CONDITIONAL
        ) || "false", H = b.valueToCode(m, "THEN", k.CONDITIONAL) || "null";
        return m = b.valueToCode(m, "ELSE", k.CONDITIONAL) || "null", [W + " ? " + H + " : " + m, k.CONDITIONAL];
      }, i_ = function(m, b) {
        let W;
        W = m.getField("TIMES") ? String(Number(m.getFieldValue("TIMES"))) : b.valueToCode(m, "TIMES", k.ASSIGNMENT) || "0";
        let H = b.statementToCode(m, "DO");
        H = b.addLoopTrap(H, m), m = "";
        const ee = b.nameDB_.getDistinctName("count", i.NameType$$module$build$src$core$names.VARIABLE);
        let me = W;
        return W.match(/^\w+$/) || i.isNumber$$module$build$src$core$utils$string(W) || (me = b.nameDB_.getDistinctName("repeat_end", i.NameType$$module$build$src$core$names.VARIABLE), m += "var " + me + " = " + W + `;
`), m + ("for (var " + ee + " = 0; " + ee + " < " + me + "; " + ee + `++) {
` + H + `}
`);
      }, Gr = function(m, b) {
        const W = m.getFieldValue("MODE") === "UNTIL";
        let H = b.valueToCode(m, "BOOL", W ? k.LOGICAL_NOT : k.NONE) || "false", ee = b.statementToCode(m, "DO");
        return ee = b.addLoopTrap(ee, m), W && (H = "!" + H), "while (" + H + `) {
` + ee + `}
`;
      }, ur = function(m, b) {
        var W = b.nameDB_.getName(m.getFieldValue("VAR"), i.NameType$$module$build$src$core$names.VARIABLE), H = b.valueToCode(m, "FROM", k.ASSIGNMENT) || "0", ee = b.valueToCode(m, "TO", k.ASSIGNMENT) || "0";
        const me = b.valueToCode(m, "BY", k.ASSIGNMENT) || "1";
        let Ge = b.statementToCode(m, "DO");
        if (Ge = b.addLoopTrap(Ge, m), i.isNumber$$module$build$src$core$utils$string(H) && i.isNumber$$module$build$src$core$utils$string(ee) && i.isNumber$$module$build$src$core$utils$string(me))
          b = Number(H) <= Number(ee), m = "for (" + W + " = " + H + "; " + W + (b ? " <= " : " >= ") + ee + "; " + W, W = Math.abs(Number(me)), m = W === 1 ? m + (b ? "++" : "--") : m + ((b ? " += " : " -= ") + W), m += `) {
` + Ge + `}
`;
        else {
          m = "";
          let qt = H;
          H.match(/^\w+$/) || i.isNumber$$module$build$src$core$utils$string(H) || (qt = b.nameDB_.getDistinctName(W + "_start", i.NameType$$module$build$src$core$names.VARIABLE), m += "var " + qt + " = " + H + `;
`), H = ee, ee.match(/^\w+$/) || i.isNumber$$module$build$src$core$utils$string(ee) || (H = b.nameDB_.getDistinctName(W + "_end", i.NameType$$module$build$src$core$names.VARIABLE), m += "var " + H + " = " + ee + `;
`), ee = b.nameDB_.getDistinctName(W + "_inc", i.NameType$$module$build$src$core$names.VARIABLE), m += "var " + ee + " = ", m = i.isNumber$$module$build$src$core$utils$string(me) ? m + (Math.abs(me) + `;
`) : m + ("Math.abs(" + me + `);
`), m += "if (" + qt + " > " + H + `) {
`, m += b.INDENT + ee + " = -" + ee + `;
`, m = m + `}
for (` + (W + " = " + qt + "; " + ee + " >= 0 ? " + W + " <= " + H + " : " + W + " >= " + H + "; " + W + " += " + ee + `) {
` + Ge + `}
`);
        }
        return m;
      }, Cr = function(m, b) {
        const W = b.nameDB_.getName(m.getFieldValue("VAR"), i.NameType$$module$build$src$core$names.VARIABLE);
        var H = b.valueToCode(m, "LIST", k.ASSIGNMENT) || "[]";
        let ee = b.statementToCode(m, "DO");
        ee = b.addLoopTrap(ee, m), m = "";
        let me = H;
        return H.match(/^\w+$/) || (me = b.nameDB_.getDistinctName(
          W + "_list",
          i.NameType$$module$build$src$core$names.VARIABLE
        ), m += "var " + me + " = " + H + `;
`), H = b.nameDB_.getDistinctName(W + "_index", i.NameType$$module$build$src$core$names.VARIABLE), ee = b.INDENT + W + " = " + me + "[" + H + `];
` + ee, m + ("for (var " + H + " in " + me + `) {
` + ee + `}
`);
      }, fe = function(m, b) {
        let W = "";
        if (b.STATEMENT_PREFIX && (W += b.injectId(b.STATEMENT_PREFIX, m)), b.STATEMENT_SUFFIX && (W += b.injectId(b.STATEMENT_SUFFIX, m)), b.STATEMENT_PREFIX) {
          const H = m.getSurroundLoop();
          H && !H.suppressPrefixSuffix && (W += b.injectId(b.STATEMENT_PREFIX, H));
        }
        switch (m.getFieldValue("FLOW")) {
          case "BREAK":
            return W + `break;
`;
          case "CONTINUE":
            return W + `continue;
`;
        }
        throw Error("Unknown flow statement.");
      }, vT = function(m, b) {
        return m = Number(m.getFieldValue("NUM")), [m, 0 <= m ? k.ATOMIC : k.UNARY_NEGATION];
      }, on = function(m, b) {
        var W = { ADD: [" + ", k.ADDITION], MINUS: [" - ", k.SUBTRACTION], MULTIPLY: [" * ", k.MULTIPLICATION], DIVIDE: [" / ", k.DIVISION], POWER: [null, k.NONE] }[m.getFieldValue("OP")];
        const H = W[0];
        W = W[1];
        const ee = b.valueToCode(m, "A", W) || "0";
        return m = b.valueToCode(m, "B", W) || "0", H ? [ee + H + m, W] : ["Math.pow(" + ee + ", " + m + ")", k.FUNCTION_CALL];
      }, Ar = function(m, b) {
        const W = m.getFieldValue("OP");
        let H;
        if (W === "NEG")
          return m = b.valueToCode(m, "NUM", k.UNARY_NEGATION) || "0", m[0] === "-" && (m = " " + m), ["-" + m, k.UNARY_NEGATION];
        switch (m = W === "SIN" || W === "COS" || W === "TAN" ? b.valueToCode(m, "NUM", k.DIVISION) || "0" : b.valueToCode(m, "NUM", k.NONE) || "0", W) {
          case "ABS":
            H = "Math.abs(" + m + ")";
            break;
          case "ROOT":
            H = "Math.sqrt(" + m + ")";
            break;
          case "LN":
            H = "Math.log(" + m + ")";
            break;
          case "EXP":
            H = "Math.exp(" + m + ")";
            break;
          case "POW10":
            H = "Math.pow(10," + m + ")";
            break;
          case "ROUND":
            H = "Math.round(" + m + ")";
            break;
          case "ROUNDUP":
            H = "Math.ceil(" + m + ")";
            break;
          case "ROUNDDOWN":
            H = "Math.floor(" + m + ")";
            break;
          case "SIN":
            H = "Math.sin(" + m + " / 180 * Math.PI)";
            break;
          case "COS":
            H = "Math.cos(" + m + " / 180 * Math.PI)";
            break;
          case "TAN":
            H = "Math.tan(" + m + " / 180 * Math.PI)";
        }
        if (H)
          return [H, k.FUNCTION_CALL];
        switch (W) {
          case "LOG10":
            H = "Math.log(" + m + ") / Math.log(10)";
            break;
          case "ASIN":
            H = "Math.asin(" + m + ") / Math.PI * 180";
            break;
          case "ACOS":
            H = "Math.acos(" + m + ") / Math.PI * 180";
            break;
          case "ATAN":
            H = "Math.atan(" + m + ") / Math.PI * 180";
            break;
          default:
            throw Error("Unknown math operator: " + W);
        }
        return [H, k.DIVISION];
      }, ii = function(m, b) {
        return {
          PI: ["Math.PI", k.MEMBER],
          E: ["Math.E", k.MEMBER],
          GOLDEN_RATIO: ["(1 + Math.sqrt(5)) / 2", k.DIVISION],
          SQRT2: ["Math.SQRT2", k.MEMBER],
          SQRT1_2: ["Math.SQRT1_2", k.MEMBER],
          INFINITY: ["Infinity", k.ATOMIC]
        }[m.getFieldValue("CONSTANT")];
      }, tt = function(m, b) {
        var W = { EVEN: [
          " % 2 === 0",
          k.MODULUS,
          k.EQUALITY
        ], ODD: [" % 2 === 1", k.MODULUS, k.EQUALITY], WHOLE: [" % 1 === 0", k.MODULUS, k.EQUALITY], POSITIVE: [
          " > 0",
          k.RELATIONAL,
          k.RELATIONAL
        ], NEGATIVE: [" < 0", k.RELATIONAL, k.RELATIONAL], DIVISIBLE_BY: [null, k.MODULUS, k.EQUALITY], PRIME: [
          null,
          k.NONE,
          k.FUNCTION_CALL
        ] };
        const H = m.getFieldValue("PROPERTY"), [ee, me, Ge] = W[H];
        return W = b.valueToCode(m, "NUMBER_TO_CHECK", me) || "0", H === "PRIME" ? m = b.provideFunction_("mathIsPrime", `
function ${b.FUNCTION_NAME_PLACEHOLDER_}(n) {
  // https://en.wikipedia.org/wiki/Primality_test#Naive_methods
  if (n == 2 || n == 3) {
    return true;
  }
  // False if n is NaN, negative, is 1, or not whole.
  // And false if n is divisible by 2 or 3.
  if (isNaN(n) || n <= 1 || n % 1 !== 0 || n % 2 === 0 || n % 3 === 0) {
    return false;
  }
  // Check all the numbers of form 6k +/- 1, up to sqrt(n).
  for (var x = 6; x <= Math.sqrt(n) + 1; x += 6) {
    if (n % (x - 1) === 0 || n % (x + 1) === 0) {
      return false;
    }
  }
  return true;
}
`) + "(" + W + ")" : H === "DIVISIBLE_BY" ? (m = b.valueToCode(m, "DIVISOR", k.MODULUS) || "0", m = W + " % " + m + " === 0") : m = W + ee, [m, Ge];
      }, kr = function(m, b) {
        const W = b.valueToCode(m, "DELTA", k.ADDITION) || "0";
        return m = b.nameDB_.getName(m.getFieldValue("VAR"), i.NameType$$module$build$src$core$names.VARIABLE), m + " = (typeof " + m + " === 'number' ? " + m + " : 0) + " + W + `;
`;
      }, oi = function(m, b) {
        var W = m.getFieldValue("OP");
        switch (W) {
          case "SUM":
            m = b.valueToCode(m, "LIST", k.MEMBER) || "[]", m += ".reduce(function(x, y) {return x + y;}, 0)";
            break;
          case "MIN":
            m = b.valueToCode(m, "LIST", k.NONE) || "[]", m = "Math.min.apply(null, " + m + ")";
            break;
          case "MAX":
            m = b.valueToCode(m, "LIST", k.NONE) || "[]", m = "Math.max.apply(null, " + m + ")";
            break;
          case "AVERAGE":
            W = b.provideFunction_("mathMean", `
function ${b.FUNCTION_NAME_PLACEHOLDER_}(myList) {
  return myList.reduce(function(x, y) {return x + y;}, 0) / myList.length;
}
`), m = b.valueToCode(m, "LIST", k.NONE) || "[]", m = W + "(" + m + ")";
            break;
          case "MEDIAN":
            W = b.provideFunction_("mathMedian", `
function ${b.FUNCTION_NAME_PLACEHOLDER_}(myList) {
  var localList = myList.filter(function (x) {return typeof x === 'number';});
  if (!localList.length) return null;
  localList.sort(function(a, b) {return b - a;});
  if (localList.length % 2 === 0) {
    return (localList[localList.length / 2 - 1] + localList[localList.length / 2]) / 2;
  } else {
    return localList[(localList.length - 1) / 2];
  }
}
`), m = b.valueToCode(m, "LIST", k.NONE) || "[]", m = W + "(" + m + ")";
            break;
          case "MODE":
            W = b.provideFunction_("mathModes", `
function ${b.FUNCTION_NAME_PLACEHOLDER_}(values) {
  var modes = [];
  var counts = [];
  var maxCount = 0;
  for (var i = 0; i < values.length; i++) {
    var value = values[i];
    var found = false;
    var thisCount;
    for (var j = 0; j < counts.length; j++) {
      if (counts[j][0] === value) {
        thisCount = ++counts[j][1];
        found = true;
        break;
      }
    }
    if (!found) {
      counts.push([value, 1]);
      thisCount = 1;
    }
    maxCount = Math.max(thisCount, maxCount);
  }
  for (var j = 0; j < counts.length; j++) {
    if (counts[j][1] === maxCount) {
        modes.push(counts[j][0]);
    }
  }
  return modes;
}
`), m = b.valueToCode(m, "LIST", k.NONE) || "[]", m = W + "(" + m + ")";
            break;
          case "STD_DEV":
            W = b.provideFunction_("mathStandardDeviation", `
function ${b.FUNCTION_NAME_PLACEHOLDER_}(numbers) {
  var n = numbers.length;
  if (!n) return null;
  var mean = numbers.reduce(function(x, y) {return x + y;}) / n;
  var variance = 0;
  for (var j = 0; j < n; j++) {
    variance += Math.pow(numbers[j] - mean, 2);
  }
  variance = variance / n;
  return Math.sqrt(variance);
}
`), m = b.valueToCode(m, "LIST", k.NONE) || "[]", m = W + "(" + m + ")";
            break;
          case "RANDOM":
            W = b.provideFunction_("mathRandomList", `
function ${b.FUNCTION_NAME_PLACEHOLDER_}(list) {
  var x = Math.floor(Math.random() * list.length);
  return list[x];
}
`), m = b.valueToCode(m, "LIST", k.NONE) || "[]", m = W + "(" + m + ")";
            break;
          default:
            throw Error("Unknown operator: " + W);
        }
        return [m, k.FUNCTION_CALL];
      }, bo = function(m, b) {
        const W = b.valueToCode(m, "DIVIDEND", k.MODULUS) || "0";
        return m = b.valueToCode(m, "DIVISOR", k.MODULUS) || "0", [W + " % " + m, k.MODULUS];
      }, ge = function(m, b) {
        const W = b.valueToCode(m, "VALUE", k.NONE) || "0", H = b.valueToCode(m, "LOW", k.NONE) || "0";
        return m = b.valueToCode(m, "HIGH", k.NONE) || "Infinity", ["Math.min(Math.max(" + W + ", " + H + "), " + m + ")", k.FUNCTION_CALL];
      }, Vn = function(m, b) {
        const W = b.valueToCode(m, "FROM", k.NONE) || "0";
        return m = b.valueToCode(m, "TO", k.NONE) || "0", [b.provideFunction_("mathRandomInt", `
function ${b.FUNCTION_NAME_PLACEHOLDER_}(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}
`) + "(" + W + ", " + m + ")", k.FUNCTION_CALL];
      }, Gn = function(m, b) {
        return ["Math.random()", k.FUNCTION_CALL];
      }, Fr = function(m, b) {
        const W = b.valueToCode(m, "X", k.NONE) || "0";
        return ["Math.atan2(" + (b.valueToCode(
          m,
          "Y",
          k.NONE
        ) || "0") + ", " + W + ") / Math.PI * 180", k.DIVISION];
      }, Hr = function(m, b) {
        const W = b.nameDB_.getName(m.getFieldValue("NAME"), i.NameType$$module$build$src$core$names.PROCEDURE);
        var H = "";
        b.STATEMENT_PREFIX && (H += b.injectId(b.STATEMENT_PREFIX, m)), b.STATEMENT_SUFFIX && (H += b.injectId(b.STATEMENT_SUFFIX, m)), H && (H = b.prefixLines(H, b.INDENT));
        let ee = "";
        b.INFINITE_LOOP_TRAP && (ee = b.prefixLines(b.injectId(b.INFINITE_LOOP_TRAP, m), b.INDENT));
        const me = b.statementToCode(m, "STACK");
        let Ge = b.valueToCode(m, "RETURN", k.NONE) || "", qt = "";
        me && Ge && (qt = H), Ge && (Ge = b.INDENT + "return " + Ge + `;
`);
        const Yi = [], Pe = m.getVars();
        for (let hr = 0; hr < Pe.length; hr++)
          Yi[hr] = b.nameDB_.getName(Pe[hr], i.NameType$$module$build$src$core$names.VARIABLE);
        return H = "function " + W + "(" + Yi.join(", ") + `) {
` + H + ee + me + qt + Ge + "}", H = b.scrub_(m, H), b.definitions_["%" + W] = H, null;
      }, o_ = function(m, b) {
        const W = b.nameDB_.getName(m.getFieldValue("NAME"), i.NameType$$module$build$src$core$names.PROCEDURE), H = [], ee = m.getVars();
        for (let me = 0; me < ee.length; me++)
          H[me] = b.valueToCode(m, "ARG" + me, k.NONE) || "null";
        return [W + "(" + H.join(", ") + ")", k.FUNCTION_CALL];
      }, dr = function(m, b) {
        return b.forBlock.procedures_callreturn(m, b)[0] + `;
`;
      }, K = function(m, b) {
        let W = "if (" + (b.valueToCode(m, "CONDITION", k.NONE) || "false") + `) {
`;
        return b.STATEMENT_SUFFIX && (W += b.prefixLines(b.injectId(b.STATEMENT_SUFFIX, m), b.INDENT)), m.hasReturnValue_ ? (m = b.valueToCode(m, "VALUE", k.NONE) || "null", W += b.INDENT + "return " + m + `;
`) : W += b.INDENT + `return;
`, W + `}
`;
      }, be = function(m, b) {
        return [b.quote_(m.getFieldValue("TEXT")), k.ATOMIC];
      }, Ti = function(m, b) {
        return m = b.multiline_quote_(m.getFieldValue("TEXT")), b = m.indexOf("+") !== -1 ? k.ADDITION : k.ATOMIC, [m, b];
      }, Be = function(m, b) {
        switch (m.itemCount_) {
          case 0:
            return ["''", k.ATOMIC];
          case 1:
            return m = b.valueToCode(m, "ADD0", k.NONE) || "''", ai(m);
          case 2:
            var W = b.valueToCode(m, "ADD0", k.NONE) || "''";
            return m = b.valueToCode(
              m,
              "ADD1",
              k.NONE
            ) || "''", [ai(W)[0] + " + " + ai(m)[0], k.ADDITION];
          default:
            W = Array(m.itemCount_);
            for (let H = 0; H < m.itemCount_; H++)
              W[H] = b.valueToCode(m, "ADD" + H, k.NONE) || "''";
            return [
              "[" + W.join(",") + "].join('')",
              k.FUNCTION_CALL
            ];
        }
      }, b_ = function(m, b) {
        const W = b.nameDB_.getName(m.getFieldValue("VAR"), i.NameType$$module$build$src$core$names.VARIABLE);
        return m = b.valueToCode(m, "TEXT", k.NONE) || "''", W + " += " + ai(m)[0] + `;
`;
      }, Tt = function(m, b) {
        return [(b.valueToCode(m, "VALUE", k.MEMBER) || "''") + ".length", k.MEMBER];
      }, Sr = function(m, b) {
        return ["!" + (b.valueToCode(m, "VALUE", k.MEMBER) || "''") + ".length", k.LOGICAL_NOT];
      }, wi = function(m, b) {
        const W = m.getFieldValue("END") === "FIRST" ? "indexOf" : "lastIndexOf", H = b.valueToCode(m, "FIND", k.NONE) || "''";
        return b = (b.valueToCode(m, "VALUE", k.MEMBER) || "''") + "." + W + "(" + H + ")", m.workspace.options.oneBasedIndex ? [b + " + 1", k.ADDITION] : [b, k.FUNCTION_CALL];
      }, C_ = function(m, b) {
        const W = m.getFieldValue("WHERE") || "FROM_START", H = b.valueToCode(m, "VALUE", W === "RANDOM" ? k.NONE : k.MEMBER) || "''";
        switch (W) {
          case "FIRST":
            return [H + ".charAt(0)", k.FUNCTION_CALL];
          case "LAST":
            return [H + ".slice(-1)", k.FUNCTION_CALL];
          case "FROM_START":
            return m = b.getAdjusted(m, "AT"), [H + ".charAt(" + m + ")", k.FUNCTION_CALL];
          case "FROM_END":
            return m = b.getAdjusted(m, "AT", 1, !0), [H + ".slice(" + m + ").charAt(0)", k.FUNCTION_CALL];
          case "RANDOM":
            return [b.provideFunction_("textRandomLetter", `
function ${b.FUNCTION_NAME_PLACEHOLDER_}(text) {
  var x = Math.floor(Math.random() * text.length);
  return text[x];
}
`) + "(" + H + ")", k.FUNCTION_CALL];
        }
        throw Error("Unhandled option (text_charAt).");
      }, wr = function(m, b) {
        var W = m.getFieldValue("WHERE1");
        const H = m.getFieldValue("WHERE2");
        var ee = W !== "FROM_END" && W !== "LAST" && H !== "FROM_END" && H !== "LAST", me = b.valueToCode(m, "STRING", ee ? k.MEMBER : k.NONE) || "''";
        if (W === "FIRST" && H === "LAST")
          return [me, k.NONE];
        if (me.match(/^'?\w+'?$/) || ee) {
          switch (W) {
            case "FROM_START":
              W = b.getAdjusted(m, "AT1");
              break;
            case "FROM_END":
              W = b.getAdjusted(m, "AT1", 1, !1, k.SUBTRACTION), W = me + ".length - " + W;
              break;
            case "FIRST":
              W = "0";
              break;
            default:
              throw Error("Unhandled option (text_getSubstring).");
          }
          switch (H) {
            case "FROM_START":
              b = b.getAdjusted(m, "AT2", 1);
              break;
            case "FROM_END":
              b = b.getAdjusted(m, "AT2", 0, !1, k.SUBTRACTION), b = me + ".length - " + b;
              break;
            case "LAST":
              b = me + ".length";
              break;
            default:
              throw Error("Unhandled option (text_getSubstring).");
          }
          me = me + ".slice(" + W + ", " + b + ")";
        } else {
          ee = b.getAdjusted(m, "AT1"), m = b.getAdjusted(m, "AT2");
          const Ge = { FIRST: "First", LAST: "Last", FROM_START: "FromStart", FROM_END: "FromEnd" };
          me = b.provideFunction_("subsequence" + Ge[W] + Ge[H], `
function ${b.FUNCTION_NAME_PLACEHOLDER_}(sequence${W === "FROM_END" || W === "FROM_START" ? ", at1" : ""}${H === "FROM_END" || H === "FROM_START" ? ", at2" : ""}) {
  var start = ${v_("sequence", W, "at1")};
  var end = ${v_("sequence", H, "at2")} + 1;
  return sequence.slice(start, end);
}
`) + "(" + me + (W === "FROM_END" || W === "FROM_START" ? ", " + ee : "") + (H === "FROM_END" || H === "FROM_START" ? ", " + m : "") + ")";
        }
        return [me, k.FUNCTION_CALL];
      }, Qt = function(m, b) {
        const W = { UPPERCASE: ".toUpperCase()", LOWERCASE: ".toLowerCase()", TITLECASE: null }[m.getFieldValue("CASE")];
        return m = b.valueToCode(m, "TEXT", W ? k.MEMBER : k.NONE) || "''", [W ? m + W : b.provideFunction_("textToTitleCase", `
function ${b.FUNCTION_NAME_PLACEHOLDER_}(str) {
  return str.replace(/\\S+/g,
      function(txt) {return txt[0].toUpperCase() + txt.substring(1).toLowerCase();});
}
`) + "(" + m + ")", k.FUNCTION_CALL];
      }, O_ = function(m, b) {
        const W = { LEFT: ".replace(/^[\\s\\xa0]+/, '')", RIGHT: ".replace(/[\\s\\xa0]+$/, '')", BOTH: ".trim()" }[m.getFieldValue("MODE")];
        return [(b.valueToCode(m, "TEXT", k.MEMBER) || "''") + W, k.FUNCTION_CALL];
      }, xr = function(m, b) {
        return "window.alert(" + (b.valueToCode(m, "TEXT", k.NONE) || "''") + `);
`;
      }, T_ = function(m, b) {
        return b = "window.prompt(" + (m.getField("TEXT") ? b.quote_(m.getFieldValue("TEXT")) : b.valueToCode(m, "TEXT", k.NONE) || "''") + ")", m.getFieldValue("TYPE") === "NUMBER" && (b = "Number(" + b + ")"), [b, k.FUNCTION_CALL];
      }, Hn = function(m, b) {
        const W = b.valueToCode(m, "TEXT", k.NONE) || "''";
        return m = b.valueToCode(m, "SUB", k.NONE) || "''", [b.provideFunction_("textCount", `
function ${b.FUNCTION_NAME_PLACEHOLDER_}(haystack, needle) {
  if (needle.length === 0) {
    return haystack.length + 1;
  } else {
    return haystack.split(needle).length - 1;
  }
}
`) + "(" + W + ", " + m + ")", k.FUNCTION_CALL];
      }, si = function(m, b) {
        const W = b.valueToCode(m, "TEXT", k.NONE) || "''", H = b.valueToCode(m, "FROM", k.NONE) || "''";
        return m = b.valueToCode(m, "TO", k.NONE) || "''", [b.provideFunction_(
          "textReplace",
          `
function ${b.FUNCTION_NAME_PLACEHOLDER_}(haystack, needle, replacement) {
  needle = needle.replace(/([-()\\[\\]{}+?*.$\\^|,:#<!\\\\])/g, '\\\\$1')
                 .replace(/\\x08/g, '\\\\x08');
  return haystack.replace(new RegExp(needle, 'g'), replacement);
}
`
        ) + "(" + W + ", " + H + ", " + m + ")", k.FUNCTION_CALL];
      }, R_ = function(m, b) {
        return [(b.valueToCode(m, "TEXT", k.MEMBER) || "''") + ".split('').reverse().join('')", k.FUNCTION_CALL];
      }, Xr = function(m, b) {
        return [b.nameDB_.getName(
          m.getFieldValue("VAR"),
          i.NameType$$module$build$src$core$names.VARIABLE
        ), k.ATOMIC];
      }, li = function(m, b) {
        const W = b.valueToCode(m, "VALUE", k.ASSIGNMENT) || "0";
        return b.nameDB_.getName(m.getFieldValue("VAR"), i.NameType$$module$build$src$core$names.VARIABLE) + " = " + W + `;
`;
      }, k = {
        ATOMIC: 0,
        NEW: 1.1,
        MEMBER: 1.2,
        FUNCTION_CALL: 2,
        INCREMENT: 3,
        DECREMENT: 3,
        BITWISE_NOT: 4.1,
        UNARY_PLUS: 4.2,
        UNARY_NEGATION: 4.3,
        LOGICAL_NOT: 4.4,
        TYPEOF: 4.5,
        VOID: 4.6,
        DELETE: 4.7,
        AWAIT: 4.8,
        EXPONENTIATION: 5,
        MULTIPLICATION: 5.1,
        DIVISION: 5.2,
        MODULUS: 5.3,
        SUBTRACTION: 6.1,
        ADDITION: 6.2,
        BITWISE_SHIFT: 7,
        RELATIONAL: 8,
        IN: 8,
        INSTANCEOF: 8,
        EQUALITY: 9,
        BITWISE_AND: 10,
        BITWISE_XOR: 11,
        BITWISE_OR: 12,
        LOGICAL_AND: 13,
        LOGICAL_OR: 14,
        CONDITIONAL: 15,
        ASSIGNMENT: 16,
        YIELD: 17,
        COMMA: 18,
        NONE: 99
      }, I = class extends i.CodeGenerator$$module$build$src$core$generator {
        constructor(m) {
          super(m ?? "JavaScript"), this.ORDER_OVERRIDES = [
            [k.FUNCTION_CALL, k.MEMBER],
            [k.FUNCTION_CALL, k.FUNCTION_CALL],
            [
              k.MEMBER,
              k.MEMBER
            ],
            [k.MEMBER, k.FUNCTION_CALL],
            [k.LOGICAL_NOT, k.LOGICAL_NOT],
            [k.MULTIPLICATION, k.MULTIPLICATION],
            [k.ADDITION, k.ADDITION],
            [k.LOGICAL_AND, k.LOGICAL_AND],
            [k.LOGICAL_OR, k.LOGICAL_OR]
          ], this.isInitialized = !1;
          for (const b in k)
            this["ORDER_" + b] = k[b];
          this.addReservedWords("break,case,catch,class,const,continue,debugger,default,delete,do,else,export,extends,finally,for,function,if,import,in,instanceof,new,return,super,switch,this,throw,try,typeof,var,void,while,with,yield,enum,implements,interface,let,package,private,protected,public,static,await,null,true,false,arguments," + Object.getOwnPropertyNames(globalThis).join(","));
        }
        init(m) {
          super.init(m), this.nameDB_ ? this.nameDB_.reset() : this.nameDB_ = new i.Names$$module$build$src$core$names(this.RESERVED_WORDS_), this.nameDB_.setVariableMap(m.getVariableMap()), this.nameDB_.populateVariables(m), this.nameDB_.populateProcedures(m);
          const b = [];
          var W = i.allDeveloperVariables$$module$build$src$core$variables(m);
          for (let H = 0; H < W.length; H++)
            b.push(this.nameDB_.getName(W[H], i.NameType$$module$build$src$core$names.DEVELOPER_VARIABLE));
          for (m = i.allUsedVarModels$$module$build$src$core$variables(m), W = 0; W < m.length; W++)
            b.push(this.nameDB_.getName(
              m[W].getId(),
              i.NameType$$module$build$src$core$names.VARIABLE
            ));
          b.length && (this.definitions_.variables = "var " + b.join(", ") + ";"), this.isInitialized = !0;
        }
        finish(m) {
          const b = Object.values(this.definitions_);
          return super.finish(m), this.isInitialized = !1, this.nameDB_.reset(), b.join(`

`) + `


` + m;
        }
        scrubNakedValue(m) {
          return m + `;
`;
        }
        quote_(m) {
          return m = m.replace(/\\/g, "\\\\").replace(/\n/g, `\\
`).replace(/'/g, "\\'"), "'" + m + "'";
        }
        multiline_quote_(m) {
          return m.split(/\n/g).map(this.quote_).join(` + '\\n' +
`);
        }
        scrub_(m, b, W) {
          let H = "";
          if (!m.outputConnection || !m.outputConnection.targetConnection) {
            var ee = m.getCommentText();
            ee && (ee = i.wrap$$module$build$src$core$utils$string(ee, this.COMMENT_WRAP - 3), H += this.prefixLines(ee + `
`, "// "));
            for (let me = 0; me < m.inputList.length; me++)
              m.inputList[me].type === i.inputTypes$$module$build$src$core$inputs$input_types.VALUE && (ee = m.inputList[me].connection.targetBlock()) && (ee = this.allNestedComments(ee)) && (H += this.prefixLines(ee, "// "));
          }
          return m = m.nextConnection && m.nextConnection.targetBlock(), W = W ? "" : this.blockToCode(m), H + b + W;
        }
        getAdjusted(m, b, W, H, ee) {
          W = W || 0, ee = ee || this.ORDER_NONE, m.workspace.options.oneBasedIndex && W--;
          const me = m.workspace.options.oneBasedIndex ? "1" : "0";
          let Ge, qt = ee;
          return 0 < W ? Ge = qt = this.ORDER_ADDITION : 0 > W ? Ge = qt = this.ORDER_SUBTRACTION : H && (Ge = qt = this.ORDER_UNARY_NEGATION), m = this.valueToCode(m, b, qt) || me, i.isNumber$$module$build$src$core$utils$string(m) ? (m = Number(m) + W, H && (m = -m)) : (0 < W ? m = m + " + " + W : 0 > W && (m = m + " - " + -W), H && (m = W ? "-(" + m + ")" : "-" + m), Ge = Math.floor(Ge), ee = Math.floor(ee), Ge && ee >= Ge && (m = "(" + m + ")")), m;
        }
      }, R = {};
      R.colour_blend = h, R.colour_picker = a, R.colour_random = p, R.colour_rgb = E;
      var B = function(m, b, W) {
        return b === "FIRST" ? "0" : b === "FROM_END" ? m + ".length - 1 - " + W : b === "LAST" ? m + ".length - 1" : W;
      }, Y = {};
      Y.lists_create_empty = L, Y.lists_create_with = y, Y.lists_getIndex = ve, Y.lists_getSublist = Te, Y.lists_indexOf = ce, Y.lists_isEmpty = le, Y.lists_length = Z, Y.lists_repeat = V, Y.lists_reverse = ot, Y.lists_setIndex = et, Y.lists_sort = Le, Y.lists_split = we;
      var ie = {};
      ie.controls_if = pr, ie.controls_ifelse = pr, ie.logic_boolean = Wr, ie.logic_compare = Zt, ie.logic_negate = Rt, ie.logic_null = Un, ie.logic_operation = Je, ie.logic_ternary = No;
      var ke = {};
      ke.controls_flow_statements = fe, ke.controls_for = ur, ke.controls_forEach = Cr, ke.controls_repeat = i_, ke.controls_repeat_ext = i_, ke.controls_whileUntil = Gr;
      var yt = {};
      yt.math_arithmetic = on, yt.math_atan2 = Fr, yt.math_change = kr, yt.math_constant = ii, yt.math_constrain = ge, yt.math_modulo = bo, yt.math_number = vT, yt.math_number_property = tt, yt.math_on_list = oi, yt.math_random_float = Gn, yt.math_random_int = Vn, yt.math_round = Ar, yt.math_single = Ar, yt.math_trig = Ar;
      var y_ = {};
      y_.procedures_callnoreturn = dr, y_.procedures_callreturn = o_, y_.procedures_defnoreturn = Hr, y_.procedures_defreturn = Hr, y_.procedures_ifreturn = K;
      var ea = /^\s*'([^']|\\')*'\s*$/, ai = function(m) {
        return ea.test(m) ? [m, k.ATOMIC] : ["String(" + m + ")", k.FUNCTION_CALL];
      }, v_ = function(m, b, W) {
        return b === "FIRST" ? "0" : b === "FROM_END" ? m + ".length - 1 - " + W : b === "LAST" ? m + ".length - 1" : W;
      }, Ut = {};
      Ut.text = be, Ut.text_append = b_, Ut.text_changeCase = Qt, Ut.text_charAt = C_, Ut.text_count = Hn, Ut.text_getSubstring = wr, Ut.text_indexOf = wi, Ut.text_isEmpty = Sr, Ut.text_join = Be, Ut.text_length = Tt, Ut.text_multiline = Ti, Ut.text_print = xr, Ut.text_prompt = T_, Ut.text_prompt_ext = T_, Ut.text_replace = si, Ut.text_reverse = R_, Ut.text_trim = O_;
      var $T = {};
      $T.variables_get = Xr, $T.variables_set = li;
      var Co = {};
      Co.variables_get_dynamic = Xr, Co.variables_set_dynamic = li;
      var WT = new I();
      Object.assign(WT.forBlock, R, Y, ie, ke, yt, y_, Ut, $T, Co);
      var Bi = {};
      return Bi.JavascriptGenerator = I, Bi.Order = k, Bi.javascriptGenerator = WT, Bi.__namespace__ = i, Bi;
    });
  }(ih)), ih.exports;
}
var c4;
function HM() {
  return c4 || (c4 = 1, function(_, s) {
    (function(r, i) {
      _.exports = i(aI(), GM());
    })(nn, function(r, i) {
      /**
       * @license
       * Copyright 2020 Google LLC
       * SPDX-License-Identifier: Apache-2.0
       */
      return i;
    });
  }(_h)), _h.exports;
}
var p4;
function xM() {
  return p4 || (p4 = 1, function(_, s) {
    (function(r, i) {
      _.exports = i(aI(), YM(), VM(), HM());
    })(nn, function(r, i, a, p) {
      return r.setLocale(i), r;
    });
  }(ZS)), ZS.exports;
}
(function(_, s) {
  (function(r, i) {
    _.exports = i(xM());
  })(nn, function(r) {
    /**
     * @license
     * Copyright 2019 Google LLC
     * SPDX-License-Identifier: Apache-2.0
     */
    return r;
  });
})(lI);
var X = lI.exports;
const g = /* @__PURE__ */ wM(X);
var sS = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
sS.exports;
(function(_, s) {
  (function() {
    var r, i = "4.17.21", a = 200, p = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", E = "Expected a function", h = "Invalid `variable` option passed into `_.template`", L = "__lodash_hash_undefined__", y = 500, V = "__lodash_placeholder__", Z = 1, le = 2, ce = 4, ve = 1, et = 2, Te = 1, Le = 2, we = 4, ot = 8, pr = 16, Zt = 32, Je = 64, Rt = 128, Wr = 256, Un = 512, No = 30, i_ = "...", Gr = 800, ur = 16, Cr = 1, fe = 2, vT = 3, on = 1 / 0, Ar = 9007199254740991, ii = 17976931348623157e292, tt = NaN, kr = 4294967295, oi = kr - 1, bo = kr >>> 1, ge = [
      ["ary", Rt],
      ["bind", Te],
      ["bindKey", Le],
      ["curry", ot],
      ["curryRight", pr],
      ["flip", Un],
      ["partial", Zt],
      ["partialRight", Je],
      ["rearg", Wr]
    ], Vn = "[object Arguments]", Gn = "[object Array]", Fr = "[object AsyncFunction]", Hr = "[object Boolean]", o_ = "[object Date]", dr = "[object DOMException]", K = "[object Error]", be = "[object Function]", Ti = "[object GeneratorFunction]", Be = "[object Map]", b_ = "[object Number]", Tt = "[object Null]", Sr = "[object Object]", wi = "[object Promise]", C_ = "[object Proxy]", wr = "[object RegExp]", Qt = "[object Set]", O_ = "[object String]", xr = "[object Symbol]", T_ = "[object Undefined]", Hn = "[object WeakMap]", si = "[object WeakSet]", R_ = "[object ArrayBuffer]", Xr = "[object DataView]", li = "[object Float32Array]", k = "[object Float64Array]", I = "[object Int8Array]", R = "[object Int16Array]", B = "[object Int32Array]", Y = "[object Uint8Array]", ie = "[object Uint8ClampedArray]", ke = "[object Uint16Array]", yt = "[object Uint32Array]", y_ = /\b__p \+= '';/g, ea = /\b(__p \+=) '' \+/g, ai = /(__e\(.*?\)|\b__t\)) \+\n'';/g, v_ = /&(?:amp|lt|gt|quot|#39);/g, Ut = /[&<>"']/g, $T = RegExp(v_.source), Co = RegExp(Ut.source), WT = /<%-([\s\S]+?)%>/g, Bi = /<%([\s\S]+?)%>/g, m = /<%=([\s\S]+?)%>/g, b = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, W = /^\w*$/, H = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ee = /[\\^$.*+?()[\]{}|]/g, me = RegExp(ee.source), Ge = /^\s+/, qt = /\s/, Yi = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Pe = /\{\n\/\* \[wrapped with (.+)\] \*/, hr = /,? & /, It = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, vs = /[()=,{}\[\]\/\s]/, Ui = /\\(\\)?/g, Oo = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, kT = /\w*$/, xn = /^[-+]0x[0-9a-f]+$/i, cp = /^0b[01]+$/i, $s = /^\[object .+?Constructor\]$/, JE = /^0o[0-7]+$/i, pp = /^(?:0|[1-9]\d*)$/, $_ = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, s_ = /($^)/, up = /['\n\r\u2028\u2029\\]/g, FT = "\\ud800-\\udfff", ta = "\\u0300-\\u036f", Ep = "\\ufe20-\\ufe2f", Ro = "\\u20d0-\\u20ff", Ws = ta + Ep + Ro, ra = "\\u2700-\\u27bf", na = "a-z\\xdf-\\xf6\\xf8-\\xff", jE = "\\xac\\xb1\\xd7\\xf7", zE = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Ap = "\\u2000-\\u206f", ks = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", dp = "A-Z\\xc0-\\xd6\\xd8-\\xde", Sp = "\\ufe0e\\ufe0f", ci = jE + zE + Ap + ks, Fs = "['’]", W_ = "[" + FT + "]", hp = "[" + ci + "]", ws = "[" + Ws + "]", Ip = "\\d+", Mp = "[" + ra + "]", mp = "[" + na + "]", Pp = "[^" + FT + ci + Ip + ra + na + dp + "]", _a = "\\ud83c[\\udffb-\\udfff]", ZE = "(?:" + ws + "|" + _a + ")", Dp = "[^" + FT + "]", Bs = "(?:\\ud83c[\\udde6-\\uddff]){2}", ia = "[\\ud800-\\udbff][\\udc00-\\udfff]", yo = "[" + dp + "]", Ys = "\\u200d", Lp = "(?:" + mp + "|" + Pp + ")", QE = "(?:" + yo + "|" + Pp + ")", oa = "(?:" + Fs + "(?:d|ll|m|re|s|t|ve))?", Us = "(?:" + Fs + "(?:D|LL|M|RE|S|T|VE))?", gp = ZE + "?", l_ = "[" + Sp + "]?", qE = "(?:" + Ys + "(?:" + [Dp, Bs, ia].join("|") + ")" + l_ + gp + ")*", eA = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", tA = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", fp = l_ + gp + qE, rA = "(?:" + [Mp, Bs, ia].join("|") + ")" + fp, nA = "(?:" + [Dp + ws + "?", ws, Bs, ia, W_].join("|") + ")", _A = RegExp(Fs, "g"), Np = RegExp(ws, "g"), k_ = RegExp(_a + "(?=" + _a + ")|" + nA + fp, "g"), Ta = RegExp([
      yo + "?" + mp + "+" + oa + "(?=" + [hp, yo, "$"].join("|") + ")",
      QE + "+" + Us + "(?=" + [hp, yo + Lp, "$"].join("|") + ")",
      yo + "?" + Lp + "+" + oa,
      yo + "+" + Us,
      tA,
      eA,
      Ip,
      rA
    ].join("|"), "g"), bp = RegExp("[" + Ys + FT + Ws + Sp + "]"), iA = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, oA = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], TA = -1, vt = {};
    vt[li] = vt[k] = vt[I] = vt[R] = vt[B] = vt[Y] = vt[ie] = vt[ke] = vt[yt] = !0, vt[Vn] = vt[Gn] = vt[R_] = vt[Hr] = vt[Xr] = vt[o_] = vt[K] = vt[be] = vt[Be] = vt[b_] = vt[Sr] = vt[wr] = vt[Qt] = vt[O_] = vt[Hn] = !1;
    var Ct = {};
    Ct[Vn] = Ct[Gn] = Ct[R_] = Ct[Xr] = Ct[Hr] = Ct[o_] = Ct[li] = Ct[k] = Ct[I] = Ct[R] = Ct[B] = Ct[Be] = Ct[b_] = Ct[Sr] = Ct[wr] = Ct[Qt] = Ct[O_] = Ct[xr] = Ct[Y] = Ct[ie] = Ct[ke] = Ct[yt] = !0, Ct[K] = Ct[be] = Ct[Hn] = !1;
    var sA = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, lA = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, aA = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, Cp = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, cA = parseFloat, Vi = parseInt, Op = typeof nn == "object" && nn && nn.Object === Object && nn, pA = typeof self == "object" && self && self.Object === Object && self, Lr = Op || pA || Function("return this")(), Gi = s && !s.nodeType && s, pi = Gi && !0 && _ && !_.nodeType && _, vo = pi && pi.exports === Gi, Vs = vo && Op.process, Tn = function() {
      try {
        var G = pi && pi.require && pi.require("util").types;
        return G || Vs && Vs.binding && Vs.binding("util");
      } catch {
      }
    }(), sa = Tn && Tn.isArrayBuffer, $o = Tn && Tn.isDate, Gs = Tn && Tn.isMap, Hs = Tn && Tn.isRegExp, Rp = Tn && Tn.isSet, wT = Tn && Tn.isTypedArray;
    function Kr(G, Q, J) {
      switch (J.length) {
        case 0:
          return G.call(Q);
        case 1:
          return G.call(Q, J[0]);
        case 2:
          return G.call(Q, J[0], J[1]);
        case 3:
          return G.call(Q, J[0], J[1], J[2]);
      }
      return G.apply(Q, J);
    }
    function yp(G, Q, J, Me) {
      for (var Ye = -1, ut = G == null ? 0 : G.length; ++Ye < ut; ) {
        var sr = G[Ye];
        Q(Me, sr, J(sr), G);
      }
      return Me;
    }
    function sn(G, Q) {
      for (var J = -1, Me = G == null ? 0 : G.length; ++J < Me && Q(G[J], J, G) !== !1; )
        ;
      return G;
    }
    function vp(G, Q) {
      for (var J = G == null ? 0 : G.length; J-- && Q(G[J], J, G) !== !1; )
        ;
      return G;
    }
    function la(G, Q) {
      for (var J = -1, Me = G == null ? 0 : G.length; ++J < Me; )
        if (!Q(G[J], J, G))
          return !1;
      return !0;
    }
    function F_(G, Q) {
      for (var J = -1, Me = G == null ? 0 : G.length, Ye = 0, ut = []; ++J < Me; ) {
        var sr = G[J];
        Q(sr, J, G) && (ut[Ye++] = sr);
      }
      return ut;
    }
    function xs(G, Q) {
      var J = G == null ? 0 : G.length;
      return !!J && ko(G, Q, 0) > -1;
    }
    function Wo(G, Q, J) {
      for (var Me = -1, Ye = G == null ? 0 : G.length; ++Me < Ye; )
        if (J(Q, G[Me]))
          return !0;
      return !1;
    }
    function $t(G, Q) {
      for (var J = -1, Me = G == null ? 0 : G.length, Ye = Array(Me); ++J < Me; )
        Ye[J] = Q(G[J], J, G);
      return Ye;
    }
    function Nn(G, Q) {
      for (var J = -1, Me = Q.length, Ye = G.length; ++J < Me; )
        G[Ye + J] = Q[J];
      return G;
    }
    function BT(G, Q, J, Me) {
      var Ye = -1, ut = G == null ? 0 : G.length;
      for (Me && ut && (J = G[++Ye]); ++Ye < ut; )
        J = Q(J, G[Ye], Ye, G);
      return J;
    }
    function a_(G, Q, J, Me) {
      var Ye = G == null ? 0 : G.length;
      for (Me && Ye && (J = G[--Ye]); Ye--; )
        J = Q(J, G[Ye], Ye, G);
      return J;
    }
    function Xs(G, Q) {
      for (var J = -1, Me = G == null ? 0 : G.length; ++J < Me; )
        if (Q(G[J], J, G))
          return !0;
      return !1;
    }
    var $p = ua("length");
    function uA(G) {
      return G.split("");
    }
    function Ks(G) {
      return G.match(It) || [];
    }
    function aa(G, Q, J) {
      var Me;
      return J(G, function(Ye, ut, sr) {
        if (Q(Ye, ut, sr))
          return Me = ut, !1;
      }), Me;
    }
    function YT(G, Q, J, Me) {
      for (var Ye = G.length, ut = J + (Me ? 1 : -1); Me ? ut-- : ++ut < Ye; )
        if (Q(G[ut], ut, G))
          return ut;
      return -1;
    }
    function ko(G, Q, J) {
      return Q === Q ? Ma(G, Q, J) : YT(G, pa, J);
    }
    function ca(G, Q, J, Me) {
      for (var Ye = J - 1, ut = G.length; ++Ye < ut; )
        if (Me(G[Ye], Q))
          return Ye;
      return -1;
    }
    function pa(G) {
      return G !== G;
    }
    function Wp(G, Q) {
      var J = G == null ? 0 : G.length;
      return J ? Hi(G, Q) / J : tt;
    }
    function ua(G) {
      return function(Q) {
        return Q == null ? r : Q[G];
      };
    }
    function Ea(G) {
      return function(Q) {
        return G == null ? r : G[Q];
      };
    }
    function kp(G, Q, J, Me, Ye) {
      return Ye(G, function(ut, sr, Pt) {
        J = Me ? (Me = !1, ut) : Q(J, ut, sr, Pt);
      }), J;
    }
    function EA(G, Q) {
      var J = G.length;
      for (G.sort(Q); J--; )
        G[J] = G[J].value;
      return G;
    }
    function Hi(G, Q) {
      for (var J, Me = -1, Ye = G.length; ++Me < Ye; ) {
        var ut = Q(G[Me]);
        ut !== r && (J = J === r ? ut : J + ut);
      }
      return J;
    }
    function Js(G, Q) {
      for (var J = -1, Me = Array(G); ++J < G; )
        Me[J] = Q(J);
      return Me;
    }
    function Fp(G, Q) {
      return $t(Q, function(J) {
        return [J, G[J]];
      });
    }
    function UT(G) {
      return G && G.slice(0, zs(G) + 1).replace(Ge, "");
    }
    function Jr(G) {
      return function(Q) {
        return G(Q);
      };
    }
    function Aa(G, Q) {
      return $t(Q, function(J) {
        return G[J];
      });
    }
    function VT(G, Q) {
      return G.has(Q);
    }
    function da(G, Q) {
      for (var J = -1, Me = G.length; ++J < Me && ko(Q, G[J], 0) > -1; )
        ;
      return J;
    }
    function Sa(G, Q) {
      for (var J = G.length; J-- && ko(Q, G[J], 0) > -1; )
        ;
      return J;
    }
    function ui(G, Q) {
      for (var J = G.length, Me = 0; J--; )
        G[J] === Q && ++Me;
      return Me;
    }
    var wp = Ea(sA), Bp = Ea(lA);
    function AA(G) {
      return "\\" + Cp[G];
    }
    function dA(G, Q) {
      return G == null ? r : G[Q];
    }
    function Fo(G) {
      return bp.test(G);
    }
    function SA(G) {
      return iA.test(G);
    }
    function Yp(G) {
      for (var Q, J = []; !(Q = G.next()).done; )
        J.push(Q.value);
      return J;
    }
    function ha(G) {
      var Q = -1, J = Array(G.size);
      return G.forEach(function(Me, Ye) {
        J[++Q] = [Ye, Me];
      }), J;
    }
    function Ia(G, Q) {
      return function(J) {
        return G(Q(J));
      };
    }
    function Ei(G, Q) {
      for (var J = -1, Me = G.length, Ye = 0, ut = []; ++J < Me; ) {
        var sr = G[J];
        (sr === Q || sr === V) && (G[J] = V, ut[Ye++] = J);
      }
      return ut;
    }
    function c_(G) {
      var Q = -1, J = Array(G.size);
      return G.forEach(function(Me) {
        J[++Q] = Me;
      }), J;
    }
    function js(G) {
      var Q = -1, J = Array(G.size);
      return G.forEach(function(Me) {
        J[++Q] = [Me, Me];
      }), J;
    }
    function Ma(G, Q, J) {
      for (var Me = J - 1, Ye = G.length; ++Me < Ye; )
        if (G[Me] === Q)
          return Me;
      return -1;
    }
    function ma(G, Q, J) {
      for (var Me = J + 1; Me--; )
        if (G[Me] === Q)
          return Me;
      return Me;
    }
    function Xn(G) {
      return Fo(G) ? xt(G) : $p(G);
    }
    function bn(G) {
      return Fo(G) ? Pa(G) : uA(G);
    }
    function zs(G) {
      for (var Q = G.length; Q-- && qt.test(G.charAt(Q)); )
        ;
      return Q;
    }
    var Up = Ea(aA);
    function xt(G) {
      for (var Q = k_.lastIndex = 0; k_.test(G); )
        ++Q;
      return Q;
    }
    function Pa(G) {
      return G.match(k_) || [];
    }
    function GT(G) {
      return G.match(Ta) || [];
    }
    var wo = function G(Q) {
      Q = Q == null ? Lr : Bo.defaults(Lr.Object(), Q, Bo.pick(Lr, oA));
      var J = Q.Array, Me = Q.Date, Ye = Q.Error, ut = Q.Function, sr = Q.Math, Pt = Q.Object, Da = Q.RegExp, hA = Q.String, ln = Q.TypeError, Br = J.prototype, IA = ut.prototype, Yo = Pt.prototype, an = Q["__core-js_shared__"], Mt = IA.toString, St = Yo.hasOwnProperty, MA = 0, La = function() {
        var T = /[^.]+$/.exec(an && an.keys && an.keys.IE_PROTO || "");
        return T ? "Symbol(src)_1." + T : "";
      }(), Kn = Yo.toString, ga = Mt.call(Pt), mA = Lr._, Zs = Da(
        "^" + Mt.call(St).replace(ee, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Uo = vo ? Q.Buffer : r, Ai = Q.Symbol, Vo = Q.Uint8Array, Vp = Uo ? Uo.allocUnsafe : r, Go = Ia(Pt.getPrototypeOf, Pt), fa = Pt.create, Na = Yo.propertyIsEnumerable, Qs = Br.splice, ba = Ai ? Ai.isConcatSpreadable : r, xi = Ai ? Ai.iterator : r, Xi = Ai ? Ai.toStringTag : r, qs = function() {
        try {
          var T = oo(Pt, "defineProperty");
          return T({}, "", {}), T;
        } catch {
        }
      }(), PA = Q.clearTimeout !== Lr.clearTimeout && Q.clearTimeout, Gp = Me && Me.now !== Lr.Date.now && Me.now, Ca = Q.setTimeout !== Lr.setTimeout && Q.setTimeout, HT = sr.ceil, Ho = sr.floor, Oa = Pt.getOwnPropertySymbols, Ra = Uo ? Uo.isBuffer : r, Hp = Q.isFinite, DA = Br.join, cn = Ia(Pt.keys, Pt), Ee = sr.max, mt = sr.min, Or = Me.now, Wt = Q.parseInt, p_ = sr.random, xT = Br.reverse, de = oo(Q, "DataView"), kt = oo(Q, "Map"), el = oo(Q, "Promise"), xo = oo(Q, "Set"), Xo = oo(Q, "WeakMap"), Ko = oo(Pt, "create"), XT = Xo && new Xo(), Ki = {}, xp = so(de), Xp = so(kt), KT = so(el), JT = so(xo), Kp = so(Xo), tl = Ai ? Ai.prototype : r, Ji = tl ? tl.valueOf : r, ya = tl ? tl.toString : r;
      function C(T) {
        if (Gt(T) && !$e(T) && !(T instanceof nt)) {
          if (T instanceof pn)
            return T;
          if (St.call(T, "__wrapped__"))
            return ku(T);
        }
        return new pn(T);
      }
      var ji = /* @__PURE__ */ function() {
        function T() {
        }
        return function(l) {
          if (!Vt(l))
            return {};
          if (fa)
            return fa(l);
          T.prototype = l;
          var u = new T();
          return T.prototype = r, u;
        };
      }();
      function rl() {
      }
      function pn(T, l) {
        this.__wrapped__ = T, this.__actions__ = [], this.__chain__ = !!l, this.__index__ = 0, this.__values__ = r;
      }
      C.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: WT,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Bi,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: m,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: C
        }
      }, C.prototype = rl.prototype, C.prototype.constructor = C, pn.prototype = ji(rl.prototype), pn.prototype.constructor = pn;
      function nt(T) {
        this.__wrapped__ = T, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = kr, this.__views__ = [];
      }
      function Jp() {
        var T = new nt(this.__wrapped__);
        return T.__actions__ = fr(this.__actions__), T.__dir__ = this.__dir__, T.__filtered__ = this.__filtered__, T.__iteratees__ = fr(this.__iteratees__), T.__takeCount__ = this.__takeCount__, T.__views__ = fr(this.__views__), T;
      }
      function jp() {
        if (this.__filtered__) {
          var T = new nt(this);
          T.__dir__ = -1, T.__filtered__ = !0;
        } else
          T = this.clone(), T.__dir__ *= -1;
        return T;
      }
      function nl() {
        var T = this.__wrapped__.value(), l = this.__dir__, u = $e(T), S = l < 0, P = u ? T.length : 0, O = GA(0, P, this.__views__), v = O.start, F = O.end, x = F - v, re = S ? F : v - 1, te = this.__iteratees__, oe = te.length, Se = 0, Ne = mt(x, this.__takeCount__);
        if (!u || !S && P == x && Ne == x)
          return B_(T, this.__actions__);
        var We = [];
        e:
          for (; x-- && Se < Ne; ) {
            re += l;
            for (var ze = -1, Fe = T[re]; ++ze < oe; ) {
              var it = te[ze], st = it.iteratee, Dn = it.type, rn = st(Fe);
              if (Dn == fe)
                Fe = rn;
              else if (!rn) {
                if (Dn == Cr)
                  continue e;
                break e;
              }
            }
            We[Se++] = Fe;
          }
        return We;
      }
      nt.prototype = ji(rl.prototype), nt.prototype.constructor = nt;
      function zi(T) {
        var l = -1, u = T == null ? 0 : T.length;
        for (this.clear(); ++l < u; ) {
          var S = T[l];
          this.set(S[0], S[1]);
        }
      }
      function zp() {
        this.__data__ = Ko ? Ko(null) : {}, this.size = 0;
      }
      function va(T) {
        var l = this.has(T) && delete this.__data__[T];
        return this.size -= l ? 1 : 0, l;
      }
      function LA(T) {
        var l = this.__data__;
        if (Ko) {
          var u = l[T];
          return u === L ? r : u;
        }
        return St.call(l, T) ? l[T] : r;
      }
      function gA(T) {
        var l = this.__data__;
        return Ko ? l[T] !== r : St.call(l, T);
      }
      function Zp(T, l) {
        var u = this.__data__;
        return this.size += this.has(T) ? 0 : 1, u[T] = Ko && l === r ? L : l, this;
      }
      zi.prototype.clear = zp, zi.prototype.delete = va, zi.prototype.get = LA, zi.prototype.has = gA, zi.prototype.set = Zp;
      function Cn(T) {
        var l = -1, u = T == null ? 0 : T.length;
        for (this.clear(); ++l < u; ) {
          var S = T[l];
          this.set(S[0], S[1]);
        }
      }
      function fA() {
        this.__data__ = [], this.size = 0;
      }
      function NA(T) {
        var l = this.__data__, u = jT(l, T);
        if (u < 0)
          return !1;
        var S = l.length - 1;
        return u == S ? l.pop() : Qs.call(l, u, 1), --this.size, !0;
      }
      function bA(T) {
        var l = this.__data__, u = jT(l, T);
        return u < 0 ? r : l[u][1];
      }
      function CA(T) {
        return jT(this.__data__, T) > -1;
      }
      function _l(T, l) {
        var u = this.__data__, S = jT(u, T);
        return S < 0 ? (++this.size, u.push([T, l])) : u[S][1] = l, this;
      }
      Cn.prototype.clear = fA, Cn.prototype.delete = NA, Cn.prototype.get = bA, Cn.prototype.has = CA, Cn.prototype.set = _l;
      function u_(T) {
        var l = -1, u = T == null ? 0 : T.length;
        for (this.clear(); ++l < u; ) {
          var S = T[l];
          this.set(S[0], S[1]);
        }
      }
      function Qp() {
        this.size = 0, this.__data__ = {
          hash: new zi(),
          map: new (kt || Cn)(),
          string: new zi()
        };
      }
      function qp(T) {
        var l = _s(this, T).delete(T);
        return this.size -= l ? 1 : 0, l;
      }
      function OA(T) {
        return _s(this, T).get(T);
      }
      function il(T) {
        return _s(this, T).has(T);
      }
      function eu(T, l) {
        var u = _s(this, T), S = u.size;
        return u.set(T, l), this.size += u.size == S ? 0 : 1, this;
      }
      u_.prototype.clear = Qp, u_.prototype.delete = qp, u_.prototype.get = OA, u_.prototype.has = il, u_.prototype.set = eu;
      function Jn(T) {
        var l = -1, u = T == null ? 0 : T.length;
        for (this.__data__ = new u_(); ++l < u; )
          this.add(T[l]);
      }
      function RA(T) {
        return this.__data__.set(T, L), this;
      }
      function tu(T) {
        return this.__data__.has(T);
      }
      Jn.prototype.add = Jn.prototype.push = RA, Jn.prototype.has = tu;
      function On(T) {
        var l = this.__data__ = new Cn(T);
        this.size = l.size;
      }
      function ru() {
        this.__data__ = new Cn(), this.size = 0;
      }
      function nu(T) {
        var l = this.__data__, u = l.delete(T);
        return this.size = l.size, u;
      }
      function _u(T) {
        return this.__data__.get(T);
      }
      function iu(T) {
        return this.__data__.has(T);
      }
      function ou(T, l) {
        var u = this.__data__;
        if (u instanceof Cn) {
          var S = u.__data__;
          if (!kt || S.length < a - 1)
            return S.push([T, l]), this.size = ++u.size, this;
          u = this.__data__ = new u_(S);
        }
        return u.set(T, l), this.size = u.size, this;
      }
      On.prototype.clear = ru, On.prototype.delete = nu, On.prototype.get = _u, On.prototype.has = iu, On.prototype.set = ou;
      function $a(T, l) {
        var u = $e(T), S = !u && po(T), P = !u && !S && I_(T), O = !u && !S && !P && uo(T), v = u || S || P || O, F = v ? Js(T.length, hA) : [], x = F.length;
        for (var re in T)
          (l || St.call(T, re)) && !(v && // Safari 9 has enumerable `arguments.length` in strict mode.
          (re == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          P && (re == "offset" || re == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          O && (re == "buffer" || re == "byteLength" || re == "byteOffset") || // Skip index properties.
          H_(re, x))) && F.push(re);
        return F;
      }
      function ol(T) {
        var l = T.length;
        return l ? T[Qo(0, l - 1)] : r;
      }
      function Tl(T, l) {
        return bi(fr(T), Zi(l, 0, T.length));
      }
      function Tu(T) {
        return bi(fr(T));
      }
      function Wa(T, l, u) {
        (u !== r && !Lt(T[l], u) || u === r && !(l in T)) && E_(T, l, u);
      }
      function Jo(T, l, u) {
        var S = T[l];
        (!(St.call(T, l) && Lt(S, u)) || u === r && !(l in T)) && E_(T, l, u);
      }
      function jT(T, l) {
        for (var u = T.length; u--; )
          if (Lt(T[u][0], l))
            return u;
        return -1;
      }
      function su(T, l, u, S) {
        return di(T, function(P, O, v) {
          l(S, P, u(P), v);
        }), S;
      }
      function ka(T, l) {
        return T && An(l, ir(l), T);
      }
      function lu(T, l) {
        return T && An(l, Ur(l), T);
      }
      function E_(T, l, u) {
        l == "__proto__" && qs ? qs(T, l, {
          configurable: !0,
          enumerable: !0,
          value: u,
          writable: !0
        }) : T[l] = u;
      }
      function sl(T, l) {
        for (var u = -1, S = l.length, P = J(S), O = T == null; ++u < S; )
          P[u] = O ? r : Ds(T, l[u]);
        return P;
      }
      function Zi(T, l, u) {
        return T === T && (u !== r && (T = T <= u ? T : u), l !== r && (T = T >= l ? T : l)), T;
      }
      function un(T, l, u, S, P, O) {
        var v, F = l & Z, x = l & le, re = l & ce;
        if (u && (v = P ? u(T, S, P, O) : u(T)), v !== r)
          return v;
        if (!Vt(T))
          return T;
        var te = $e(T);
        if (te) {
          if (v = RS(T), !F)
            return fr(T, v);
        } else {
          var oe = Nr(T), Se = oe == be || oe == Ti;
          if (I_(T))
            return qo(T, F);
          if (oe == Sr || oe == Vn || Se && !P) {
            if (v = x || Se ? {} : xA(T), !F)
              return x ? OS(T, lu(v, T)) : UA(T, ka(v, T));
          } else {
            if (!Ct[oe])
              return P ? T : {};
            v = Ru(T, oe, F);
          }
        }
        O || (O = new On());
        var Ne = O.get(T);
        if (Ne)
          return Ne;
        O.set(T, v), Cc(T) ? T.forEach(function(Fe) {
          v.add(un(Fe, l, u, Fe, T, O));
        }) : Ss(T) && T.forEach(function(Fe, it) {
          v.set(it, un(Fe, l, u, it, T, O));
        });
        var We = re ? x ? qa : Cu : x ? Ur : ir, ze = te ? r : We(T);
        return sn(ze || T, function(Fe, it) {
          ze && (it = Fe, Fe = T[it]), Jo(v, it, un(Fe, l, u, it, T, O));
        }), v;
      }
      function Qi(T) {
        var l = ir(T);
        return function(u) {
          return ll(u, T, l);
        };
      }
      function ll(T, l, u) {
        var S = u.length;
        if (T == null)
          return !S;
        for (T = Pt(T); S--; ) {
          var P = u[S], O = l[P], v = T[P];
          if (v === r && !(P in T) || !O(v))
            return !1;
        }
        return !0;
      }
      function al(T, l, u) {
        if (typeof T != "function")
          throw new ln(E);
        return To(function() {
          T.apply(r, u);
        }, l);
      }
      function jo(T, l, u, S) {
        var P = -1, O = xs, v = !0, F = T.length, x = [], re = l.length;
        if (!F)
          return x;
        u && (l = $t(l, Jr(u))), S ? (O = Wo, v = !1) : l.length >= a && (O = VT, v = !1, l = new Jn(l));
        e:
          for (; ++P < F; ) {
            var te = T[P], oe = u == null ? te : u(te);
            if (te = S || te !== 0 ? te : 0, v && oe === oe) {
              for (var Se = re; Se--; )
                if (l[Se] === oe)
                  continue e;
              x.push(te);
            } else
              O(l, oe, S) || x.push(te);
          }
        return x;
      }
      var di = rT(jn), Fa = rT(cl, !0);
      function wa(T, l) {
        var u = !0;
        return di(T, function(S, P, O) {
          return u = !!l(S, P, O), u;
        }), u;
      }
      function zT(T, l, u) {
        for (var S = -1, P = T.length; ++S < P; ) {
          var O = T[S], v = l(O);
          if (v != null && (F === r ? v === v && !en(v) : u(v, F)))
            var F = v, x = O;
        }
        return x;
      }
      function au(T, l, u, S) {
        var P = T.length;
        for (u = Ke(u), u < 0 && (u = -u > P ? 0 : P + u), S = S === r || S > P ? P : Ke(S), S < 0 && (S += P), S = u > S ? 0 : Rc(S); u < S; )
          T[u++] = l;
        return T;
      }
      function cu(T, l) {
        var u = [];
        return di(T, function(S, P, O) {
          l(S, P, O) && u.push(S);
        }), u;
      }
      function Ir(T, l, u, S, P) {
        var O = -1, v = T.length;
        for (u || (u = os), P || (P = []); ++O < v; ) {
          var F = T[O];
          l > 0 && u(F) ? l > 1 ? Ir(F, l - 1, u, S, P) : Nn(P, F) : S || (P[P.length] = F);
        }
        return P;
      }
      var Ba = Sl(), Ya = Sl(!0);
      function jn(T, l) {
        return T && Ba(T, l, ir);
      }
      function cl(T, l) {
        return T && Ya(T, l, ir);
      }
      function zo(T, l) {
        return F_(l, function(u) {
          return M_(T[u]);
        });
      }
      function Si(T, l) {
        l = vn(l, T);
        for (var u = 0, S = l.length; T != null && u < S; )
          T = T[hn(l[u++])];
        return u && u == S ? T : r;
      }
      function pl(T, l, u) {
        var S = l(T);
        return $e(T) ? S : Nn(S, u(T));
      }
      function gr(T) {
        return T == null ? T === r ? T_ : Tt : Xi && Xi in Pt(T) ? VA(T) : fi(T);
      }
      function ZT(T, l) {
        return T > l;
      }
      function yA(T, l) {
        return T != null && St.call(T, l);
      }
      function vA(T, l) {
        return T != null && l in Pt(T);
      }
      function $A(T, l, u) {
        return T >= mt(l, u) && T < Ee(l, u);
      }
      function Ua(T, l, u) {
        for (var S = u ? Wo : xs, P = T[0].length, O = T.length, v = O, F = J(O), x = 1 / 0, re = []; v--; ) {
          var te = T[v];
          v && l && (te = $t(te, Jr(l))), x = mt(te.length, x), F[v] = !u && (l || P >= 120 && te.length >= 120) ? new Jn(v && te) : r;
        }
        te = T[0];
        var oe = -1, Se = F[0];
        e:
          for (; ++oe < P && re.length < x; ) {
            var Ne = te[oe], We = l ? l(Ne) : Ne;
            if (Ne = u || Ne !== 0 ? Ne : 0, !(Se ? VT(Se, We) : S(re, We, u))) {
              for (v = O; --v; ) {
                var ze = F[v];
                if (!(ze ? VT(ze, We) : S(T[v], We, u)))
                  continue e;
              }
              Se && Se.push(We), re.push(Ne);
            }
          }
        return re;
      }
      function WA(T, l, u, S) {
        return jn(T, function(P, O, v) {
          l(S, u(P), O, v);
        }), S;
      }
      function QT(T, l, u) {
        l = vn(l, T), T = vu(T, l);
        var S = T == null ? T : T[hn(In(l))];
        return S == null ? r : Kr(S, T, u);
      }
      function pu(T) {
        return Gt(T) && gr(T) == Vn;
      }
      function kA(T) {
        return Gt(T) && gr(T) == R_;
      }
      function uu(T) {
        return Gt(T) && gr(T) == o_;
      }
      function Zo(T, l, u, S, P) {
        return T === l ? !0 : T == null || l == null || !Gt(T) && !Gt(l) ? T !== T && l !== l : Eu(T, l, u, S, Zo, P);
      }
      function Eu(T, l, u, S, P, O) {
        var v = $e(T), F = $e(l), x = v ? Gn : Nr(T), re = F ? Gn : Nr(l);
        x = x == Vn ? Sr : x, re = re == Vn ? Sr : re;
        var te = x == Sr, oe = re == Sr, Se = x == re;
        if (Se && I_(T)) {
          if (!I_(l))
            return !1;
          v = !0, te = !1;
        }
        if (Se && !te)
          return O || (O = new On()), v || uo(T) ? ae(T, l, u, S, P, O) : U_(T, l, x, u, S, P, O);
        if (!(u & ve)) {
          var Ne = te && St.call(T, "__wrapped__"), We = oe && St.call(l, "__wrapped__");
          if (Ne || We) {
            var ze = Ne ? T.value() : T, Fe = We ? l.value() : l;
            return O || (O = new On()), P(ze, Fe, u, S, O);
          }
        }
        return Se ? (O || (O = new On()), V_(T, l, u, S, P, O)) : !1;
      }
      function Au(T) {
        return Gt(T) && Nr(T) == Be;
      }
      function Va(T, l, u, S) {
        var P = u.length, O = P, v = !S;
        if (T == null)
          return !O;
        for (T = Pt(T); P--; ) {
          var F = u[P];
          if (v && F[2] ? F[1] !== T[F[0]] : !(F[0] in T))
            return !1;
        }
        for (; ++P < O; ) {
          F = u[P];
          var x = F[0], re = T[x], te = F[1];
          if (v && F[2]) {
            if (re === r && !(x in T))
              return !1;
          } else {
            var oe = new On();
            if (S)
              var Se = S(re, te, x, T, l, oe);
            if (!(Se === r ? Zo(te, re, ve | et, S, oe) : Se))
              return !1;
          }
        }
        return !0;
      }
      function du(T) {
        if (!Vt(T) || XA(T))
          return !1;
        var l = M_(T) ? Zs : $s;
        return l.test(so(T));
      }
      function Su(T) {
        return Gt(T) && gr(T) == wr;
      }
      function hu(T) {
        return Gt(T) && Nr(T) == Qt;
      }
      function Iu(T) {
        return Gt(T) && ne(T.length) && !!vt[gr(T)];
      }
      function Ga(T) {
        return typeof T == "function" ? T : T == null ? gt : typeof T == "object" ? $e(T) ? Pu(T[0], T[1]) : mu(T) : fE(T);
      }
      function ul(T) {
        if (!oT(T))
          return cn(T);
        var l = [];
        for (var u in Pt(T))
          St.call(T, u) && u != "constructor" && l.push(u);
        return l;
      }
      function Mu(T) {
        if (!Vt(T))
          return KA(T);
        var l = oT(T), u = [];
        for (var S in T)
          S == "constructor" && (l || !St.call(T, S)) || u.push(S);
        return u;
      }
      function El(T, l) {
        return T < l;
      }
      function Ha(T, l) {
        var u = -1, S = _r(T) ? J(T.length) : [];
        return di(T, function(P, O, v) {
          S[++u] = l(P, O, v);
        }), S;
      }
      function mu(T) {
        var l = ec(T);
        return l.length == 1 && l[0][2] ? _c(l[0][0], l[0][1]) : function(u) {
          return u === T || Va(u, T, l);
        };
      }
      function Pu(T, l) {
        return Pl(T) && nc(l) ? _c(hn(T), l) : function(u) {
          var S = Ds(u, T);
          return S === r && S === l ? Bl(u, T) : Zo(l, S, ve | et);
        };
      }
      function Ce(T, l, u, S, P) {
        T !== l && Ba(l, function(O, v) {
          if (P || (P = new On()), Vt(O))
            En(T, l, v, u, Ce, S, P);
          else {
            var F = S ? S(Ni(T, v), O, v + "", T, l, P) : r;
            F === r && (F = O), Wa(T, v, F);
          }
        }, Ur);
      }
      function En(T, l, u, S, P, O, v) {
        var F = Ni(T, u), x = Ni(l, u), re = v.get(x);
        if (re) {
          Wa(T, u, re);
          return;
        }
        var te = O ? O(F, x, u + "", T, l, v) : r, oe = te === r;
        if (oe) {
          var Se = $e(x), Ne = !Se && I_(x), We = !Se && !Ne && uo(x);
          te = x, Se || Ne || We ? $e(F) ? te = F : Kt(F) ? te = fr(F) : Ne ? (oe = !1, te = qo(x, !0)) : We ? (oe = !1, te = Al(x, !0)) : te = [] : Is(x) || po(x) ? (te = F, po(F) ? te = yc(F) : (!Vt(F) || M_(F)) && (te = xA(x))) : oe = !1;
        }
        oe && (v.set(x, te), P(te, x, S, O, v), v.delete(x)), Wa(T, u, te);
      }
      function hi(T, l) {
        var u = T.length;
        if (u)
          return l += l < 0 ? u : 0, H_(l, u) ? T[l] : r;
      }
      function FA(T, l, u) {
        l.length ? l = $t(l, function(O) {
          return $e(O) ? function(v) {
            return Si(v, O.length === 1 ? O[0] : O);
          } : O;
        }) : l = [gt];
        var S = -1;
        l = $t(l, Jr(ye()));
        var P = Ha(T, function(O, v, F) {
          var x = $t(l, function(re) {
            return re(O);
          });
          return { criteria: x, index: ++S, value: O };
        });
        return EA(P, function(O, v) {
          return Ja(O, v, u);
        });
      }
      function xa(T, l) {
        return w_(T, l, function(u, S) {
          return Bl(T, S);
        });
      }
      function w_(T, l, u) {
        for (var S = -1, P = l.length, O = {}; ++S < P; ) {
          var v = l[S], F = Si(T, v);
          u(F, v) && er(O, vn(v, T), F);
        }
        return O;
      }
      function se(T) {
        return function(l) {
          return Si(l, T);
        };
      }
      function Rn(T, l, u, S) {
        var P = S ? ca : ko, O = -1, v = l.length, F = T;
        for (T === l && (l = fr(l)), u && (F = $t(T, Jr(u))); ++O < v; )
          for (var x = 0, re = l[O], te = u ? u(re) : re; (x = P(F, te, x, S)) > -1; )
            F !== T && Qs.call(F, x, 1), Qs.call(T, x, 1);
        return T;
      }
      function jr(T, l) {
        for (var u = T ? l.length : 0, S = u - 1; u--; ) {
          var P = l[u];
          if (u == S || P !== O) {
            var O = P;
            H_(P) ? Qs.call(T, P, 1) : ts(T, P);
          }
        }
        return T;
      }
      function Qo(T, l) {
        return T + Ho(p_() * (l - T + 1));
      }
      function wA(T, l, u, S) {
        for (var P = -1, O = Ee(HT((l - T) / (u || 1)), 0), v = J(O); O--; )
          v[S ? O : ++P] = T, T += u;
        return v;
      }
      function Xa(T, l) {
        var u = "";
        if (!T || l < 1 || l > Ar)
          return u;
        do
          l % 2 && (u += T), l = Ho(l / 2), l && (T += T);
        while (l);
        return u;
      }
      function qe(T, l) {
        return $u(yu(T, l, gt), T + "");
      }
      function qT(T) {
        return ol(ho(T));
      }
      function BA(T, l) {
        var u = ho(T);
        return bi(u, Zi(l, 0, u.length));
      }
      function er(T, l, u, S) {
        if (!Vt(T))
          return T;
        l = vn(l, T);
        for (var P = -1, O = l.length, v = O - 1, F = T; F != null && ++P < O; ) {
          var x = hn(l[P]), re = u;
          if (x === "__proto__" || x === "constructor" || x === "prototype")
            return T;
          if (P != v) {
            var te = F[x];
            re = S ? S(te, x, F) : r, re === r && (re = Vt(te) ? te : H_(l[P + 1]) ? [] : {});
          }
          Jo(F, x, re), F = F[x];
        }
        return T;
      }
      var Du = XT ? function(T, l) {
        return XT.set(T, l), T;
      } : gt, YA = qs ? function(T, l) {
        return qs(T, "toString", {
          configurable: !0,
          enumerable: !1,
          value: L_(l),
          writable: !0
        });
      } : gt;
      function CS(T) {
        return bi(ho(T));
      }
      function zr(T, l, u) {
        var S = -1, P = T.length;
        l < 0 && (l = -l > P ? 0 : P + l), u = u > P ? P : u, u < 0 && (u += P), P = l > u ? 0 : u - l >>> 0, l >>>= 0;
        for (var O = J(P); ++S < P; )
          O[S] = T[S + l];
        return O;
      }
      function Lu(T, l) {
        var u;
        return di(T, function(S, P, O) {
          return u = l(S, P, O), !u;
        }), !!u;
      }
      function Ii(T, l, u) {
        var S = 0, P = T == null ? S : T.length;
        if (typeof l == "number" && l === l && P <= bo) {
          for (; S < P; ) {
            var O = S + P >>> 1, v = T[O];
            v !== null && !en(v) && (u ? v <= l : v < l) ? S = O + 1 : P = O;
          }
          return P;
        }
        return es(T, l, gt, u);
      }
      function es(T, l, u, S) {
        var P = 0, O = T == null ? 0 : T.length;
        if (O === 0)
          return 0;
        l = u(l);
        for (var v = l !== l, F = l === null, x = en(l), re = l === r; P < O; ) {
          var te = Ho((P + O) / 2), oe = u(T[te]), Se = oe !== r, Ne = oe === null, We = oe === oe, ze = en(oe);
          if (v)
            var Fe = S || We;
          else
            re ? Fe = We && (S || Se) : F ? Fe = We && Se && (S || !Ne) : x ? Fe = We && Se && !Ne && (S || !ze) : Ne || ze ? Fe = !1 : Fe = S ? oe <= l : oe < l;
          Fe ? P = te + 1 : O = te;
        }
        return mt(O, oi);
      }
      function Mi(T, l) {
        for (var u = -1, S = T.length, P = 0, O = []; ++u < S; ) {
          var v = T[u], F = l ? l(v) : v;
          if (!u || !Lt(F, x)) {
            var x = F;
            O[P++] = v === 0 ? 0 : v;
          }
        }
        return O;
      }
      function mi(T) {
        return typeof T == "number" ? T : en(T) ? tt : +T;
      }
      function Mr(T) {
        if (typeof T == "string")
          return T;
        if ($e(T))
          return $t(T, Mr) + "";
        if (en(T))
          return ya ? ya.call(T) : "";
        var l = T + "";
        return l == "0" && 1 / T == -on ? "-0" : l;
      }
      function yn(T, l, u) {
        var S = -1, P = xs, O = T.length, v = !0, F = [], x = F;
        if (u)
          v = !1, P = Wo;
        else if (O >= a) {
          var re = l ? null : Nu(T);
          if (re)
            return c_(re);
          v = !1, P = VT, x = new Jn();
        } else
          x = l ? [] : F;
        e:
          for (; ++S < O; ) {
            var te = T[S], oe = l ? l(te) : te;
            if (te = u || te !== 0 ? te : 0, v && oe === oe) {
              for (var Se = x.length; Se--; )
                if (x[Se] === oe)
                  continue e;
              l && x.push(oe), F.push(te);
            } else
              P(x, oe, u) || (x !== F && x.push(oe), F.push(te));
          }
        return F;
      }
      function ts(T, l) {
        return l = vn(l, T), T = vu(T, l), T == null || delete T[hn(In(l))];
      }
      function qi(T, l, u, S) {
        return er(T, l, u(Si(T, l)), S);
      }
      function zn(T, l, u, S) {
        for (var P = T.length, O = S ? P : -1; (S ? O-- : ++O < P) && l(T[O], O, T); )
          ;
        return u ? zr(T, S ? 0 : O, S ? O + 1 : P) : zr(T, S ? O + 1 : 0, S ? P : O);
      }
      function B_(T, l) {
        var u = T;
        return u instanceof nt && (u = u.value()), BT(l, function(S, P) {
          return P.func.apply(P.thisArg, Nn([S], P.args));
        }, u);
      }
      function eo(T, l, u) {
        var S = T.length;
        if (S < 2)
          return S ? yn(T[0]) : [];
        for (var P = -1, O = J(S); ++P < S; )
          for (var v = T[P], F = -1; ++F < S; )
            F != P && (O[P] = jo(O[P] || v, T[F], l, u));
        return yn(Ir(O, 1), l, u);
      }
      function A_(T, l, u) {
        for (var S = -1, P = T.length, O = l.length, v = {}; ++S < P; ) {
          var F = S < O ? l[S] : r;
          u(v, T[S], F);
        }
        return v;
      }
      function to(T) {
        return Kt(T) ? T : [];
      }
      function ro(T) {
        return typeof T == "function" ? T : gt;
      }
      function vn(T, l) {
        return $e(T) ? T : Pl(T, l) ? [T] : Wu(At(T));
      }
      var no = qe;
      function Zr(T, l, u) {
        var S = T.length;
        return u = u === r ? S : u, !l && u >= S ? T : zr(T, l, u);
      }
      var _o = PA || function(T) {
        return Lr.clearTimeout(T);
      };
      function qo(T, l) {
        if (l)
          return T.slice();
        var u = T.length, S = Vp ? Vp(u) : new T.constructor(u);
        return T.copy(S), S;
      }
      function Zn(T) {
        var l = new T.constructor(T.byteLength);
        return new Vo(l).set(new Vo(T)), l;
      }
      function eT(T, l) {
        var u = l ? Zn(T.buffer) : T.buffer;
        return new T.constructor(u, T.byteOffset, T.byteLength);
      }
      function Ka(T) {
        var l = new T.constructor(T.source, kT.exec(T));
        return l.lastIndex = T.lastIndex, l;
      }
      function tT(T) {
        return Ji ? Pt(Ji.call(T)) : {};
      }
      function Al(T, l) {
        var u = l ? Zn(T.buffer) : T.buffer;
        return new T.constructor(u, T.byteOffset, T.length);
      }
      function He(T, l) {
        if (T !== l) {
          var u = T !== r, S = T === null, P = T === T, O = en(T), v = l !== r, F = l === null, x = l === l, re = en(l);
          if (!F && !re && !O && T > l || O && v && x && !F && !re || S && v && x || !u && x || !P)
            return 1;
          if (!S && !O && !re && T < l || re && u && P && !S && !O || F && u && P || !v && P || !x)
            return -1;
        }
        return 0;
      }
      function Ja(T, l, u) {
        for (var S = -1, P = T.criteria, O = l.criteria, v = P.length, F = u.length; ++S < v; ) {
          var x = He(P[S], O[S]);
          if (x) {
            if (S >= F)
              return x;
            var re = u[S];
            return x * (re == "desc" ? -1 : 1);
          }
        }
        return T.index - l.index;
      }
      function ja(T, l, u, S) {
        for (var P = -1, O = T.length, v = u.length, F = -1, x = l.length, re = Ee(O - v, 0), te = J(x + re), oe = !S; ++F < x; )
          te[F] = l[F];
        for (; ++P < v; )
          (oe || P < O) && (te[u[P]] = T[P]);
        for (; re--; )
          te[F++] = T[P++];
        return te;
      }
      function dl(T, l, u, S) {
        for (var P = -1, O = T.length, v = -1, F = u.length, x = -1, re = l.length, te = Ee(O - F, 0), oe = J(te + re), Se = !S; ++P < te; )
          oe[P] = T[P];
        for (var Ne = P; ++x < re; )
          oe[Ne + x] = l[x];
        for (; ++v < F; )
          (Se || P < O) && (oe[Ne + u[v]] = T[P++]);
        return oe;
      }
      function fr(T, l) {
        var u = -1, S = T.length;
        for (l || (l = J(S)); ++u < S; )
          l[u] = T[u];
        return l;
      }
      function An(T, l, u, S) {
        var P = !u;
        u || (u = {});
        for (var O = -1, v = l.length; ++O < v; ) {
          var F = l[O], x = S ? S(u[F], T[F], F, u, T) : r;
          x === r && (x = T[F]), P ? E_(u, F, x) : Jo(u, F, x);
        }
        return u;
      }
      function UA(T, l) {
        return An(T, is(T), l);
      }
      function OS(T, l) {
        return An(T, ml(T), l);
      }
      function Y_(T, l) {
        return function(u, S) {
          var P = $e(u) ? yp : su, O = l ? l() : {};
          return P(u, T, ye(S, 2), O);
        };
      }
      function mr(T) {
        return qe(function(l, u) {
          var S = -1, P = u.length, O = P > 1 ? u[P - 1] : r, v = P > 2 ? u[2] : r;
          for (O = T.length > 3 && typeof O == "function" ? (P--, O) : r, v && Rr(u[0], u[1], v) && (O = P < 3 ? r : O, P = 1), l = Pt(l); ++S < P; ) {
            var F = u[S];
            F && T(l, F, S, O);
          }
          return l;
        });
      }
      function rT(T, l) {
        return function(u, S) {
          if (u == null)
            return u;
          if (!_r(u))
            return T(u, S);
          for (var P = u.length, O = l ? P : -1, v = Pt(u); (l ? O-- : ++O < P) && S(v[O], O, v) !== !1; )
            ;
          return u;
        };
      }
      function Sl(T) {
        return function(l, u, S) {
          for (var P = -1, O = Pt(l), v = S(l), F = v.length; F--; ) {
            var x = v[T ? F : ++P];
            if (u(O[x], x, O) === !1)
              break;
          }
          return l;
        };
      }
      function Pi(T, l, u) {
        var S = l & Te, P = Qr(T);
        function O() {
          var v = this && this !== Lr && this instanceof O ? P : T;
          return v.apply(S ? u : this, arguments);
        }
        return O;
      }
      function $n(T) {
        return function(l) {
          l = At(l);
          var u = Fo(l) ? bn(l) : r, S = u ? u[0] : l.charAt(0), P = u ? Zr(u, 1).join("") : l.slice(1);
          return S[T]() + P;
        };
      }
      function dn(T) {
        return function(l) {
          return BT(vi(r_(l).replace(_A, "")), T, "");
        };
      }
      function Qr(T) {
        return function() {
          var l = arguments;
          switch (l.length) {
            case 0:
              return new T();
            case 1:
              return new T(l[0]);
            case 2:
              return new T(l[0], l[1]);
            case 3:
              return new T(l[0], l[1], l[2]);
            case 4:
              return new T(l[0], l[1], l[2], l[3]);
            case 5:
              return new T(l[0], l[1], l[2], l[3], l[4]);
            case 6:
              return new T(l[0], l[1], l[2], l[3], l[4], l[5]);
            case 7:
              return new T(l[0], l[1], l[2], l[3], l[4], l[5], l[6]);
          }
          var u = ji(T.prototype), S = T.apply(u, l);
          return Vt(S) ? S : u;
        };
      }
      function gu(T, l, u) {
        var S = Qr(T);
        function P() {
          for (var O = arguments.length, v = J(O), F = O, x = Di(P); F--; )
            v[F] = arguments[F];
          var re = O < 3 && v[0] !== x && v[O - 1] !== x ? [] : Ei(v, x);
          if (O -= re.length, O < u)
            return _T(
              T,
              l,
              ht,
              P.placeholder,
              r,
              v,
              re,
              r,
              r,
              u - O
            );
          var te = this && this !== Lr && this instanceof P ? S : T;
          return Kr(te, this, v);
        }
        return P;
      }
      function hl(T) {
        return function(l, u, S) {
          var P = Pt(l);
          if (!_r(l)) {
            var O = ye(u, 3);
            l = ir(l), u = function(F) {
              return O(P[F], F, P);
            };
          }
          var v = T(l, u, S);
          return v > -1 ? P[O ? l[v] : v] : r;
        };
      }
      function lr(T) {
        return S_(function(l) {
          var u = l.length, S = u, P = pn.prototype.thru;
          for (T && l.reverse(); S--; ) {
            var O = l[S];
            if (typeof O != "function")
              throw new ln(E);
            if (P && !v && G_(O) == "wrapper")
              var v = new pn([], !0);
          }
          for (S = v ? S : u; ++S < u; ) {
            O = l[S];
            var F = G_(O), x = F == "wrapper" ? ns(O) : r;
            x && rc(x[0]) && x[1] == (Rt | ot | Zt | Wr) && !x[4].length && x[9] == 1 ? v = v[G_(x[0])].apply(v, x[3]) : v = O.length == 1 && rc(O) ? v[F]() : v.thru(O);
          }
          return function() {
            var re = arguments, te = re[0];
            if (v && re.length == 1 && $e(te))
              return v.plant(te).value();
            for (var oe = 0, Se = u ? l[oe].apply(this, re) : te; ++oe < u; )
              Se = l[oe].call(this, Se);
            return Se;
          };
        });
      }
      function ht(T, l, u, S, P, O, v, F, x, re) {
        var te = l & Rt, oe = l & Te, Se = l & Le, Ne = l & (ot | pr), We = l & Un, ze = Se ? r : Qr(T);
        function Fe() {
          for (var it = arguments.length, st = J(it), Dn = it; Dn--; )
            st[Dn] = arguments[Dn];
          if (Ne)
            var rn = Di(Fe), Ln = ui(st, rn);
          if (S && (st = ja(st, S, P, Ne)), O && (st = dl(st, O, v, Ne)), it -= Ln, Ne && it < re) {
            var cr = Ei(st, rn);
            return _T(
              T,
              l,
              ht,
              Fe.placeholder,
              u,
              st,
              cr,
              F,
              x,
              re - it
            );
          }
          var f_ = oe ? u : this, $i = Se ? f_[T] : T;
          return it = st.length, F ? st = yS(st, F) : We && it > 1 && st.reverse(), te && x < it && (st.length = x), this && this !== Lr && this instanceof Fe && ($i = ze || Qr($i)), $i.apply(f_, st);
        }
        return Fe;
      }
      function fu(T, l) {
        return function(u, S) {
          return WA(u, T, l(S), {});
        };
      }
      function Il(T, l) {
        return function(u, S) {
          var P;
          if (u === r && S === r)
            return l;
          if (u !== r && (P = u), S !== r) {
            if (P === r)
              return S;
            typeof u == "string" || typeof S == "string" ? (u = Mr(u), S = Mr(S)) : (u = mi(u), S = mi(S)), P = T(u, S);
          }
          return P;
        };
      }
      function za(T) {
        return S_(function(l) {
          return l = $t(l, Jr(ye())), qe(function(u) {
            var S = this;
            return T(l, function(P) {
              return Kr(P, S, u);
            });
          });
        });
      }
      function Ml(T, l) {
        l = l === r ? " " : Mr(l);
        var u = l.length;
        if (u < 2)
          return u ? Xa(l, T) : l;
        var S = Xa(l, HT(T / Xn(l)));
        return Fo(l) ? Zr(bn(S), 0, T).join("") : S.slice(0, T);
      }
      function io(T, l, u, S) {
        var P = l & Te, O = Qr(T);
        function v() {
          for (var F = -1, x = arguments.length, re = -1, te = S.length, oe = J(te + x), Se = this && this !== Lr && this instanceof v ? O : T; ++re < te; )
            oe[re] = S[re];
          for (; x--; )
            oe[re++] = arguments[++F];
          return Kr(Se, P ? u : this, oe);
        }
        return v;
      }
      function Za(T) {
        return function(l, u, S) {
          return S && typeof S != "number" && Rr(l, u, S) && (u = S = r), l = P_(l), u === r ? (u = l, l = 0) : u = P_(u), S = S === r ? l < u ? 1 : -1 : P_(S), wA(l, u, S, T);
        };
      }
      function nT(T) {
        return function(l, u) {
          return typeof l == "string" && typeof u == "string" || (l = Pn(l), u = Pn(u)), T(l, u);
        };
      }
      function _T(T, l, u, S, P, O, v, F, x, re) {
        var te = l & ot, oe = te ? v : r, Se = te ? r : v, Ne = te ? O : r, We = te ? r : O;
        l |= te ? Zt : Je, l &= ~(te ? Je : Zt), l & we || (l &= ~(Te | Le));
        var ze = [
          T,
          l,
          P,
          Ne,
          oe,
          We,
          Se,
          F,
          x,
          re
        ], Fe = u.apply(r, ze);
        return rc(T) && ar(Fe, ze), Fe.placeholder = S, yr(Fe, T, l);
      }
      function iT(T) {
        var l = sr[T];
        return function(u, S) {
          if (u = Pn(u), S = S == null ? 0 : mt(Ke(S), 292), S && Hp(u)) {
            var P = (At(u) + "e").split("e"), O = l(P[0] + "e" + (+P[1] + S));
            return P = (At(O) + "e").split("e"), +(P[0] + "e" + (+P[1] - S));
          }
          return l(u);
        };
      }
      var Nu = xo && 1 / c_(new xo([, -0]))[1] == on ? function(T) {
        return new xo(T);
      } : Gc;
      function rs(T) {
        return function(l) {
          var u = Nr(l);
          return u == Be ? ha(l) : u == Qt ? js(l) : Fp(l, T(l));
        };
      }
      function d_(T, l, u, S, P, O, v, F) {
        var x = l & Le;
        if (!x && typeof T != "function")
          throw new ln(E);
        var re = S ? S.length : 0;
        if (re || (l &= ~(Zt | Je), S = P = r), v = v === r ? v : Ee(Ke(v), 0), F = F === r ? F : Ke(F), re -= P ? P.length : 0, l & Je) {
          var te = S, oe = P;
          S = P = r;
        }
        var Se = x ? r : ns(T), Ne = [
          T,
          l,
          u,
          S,
          P,
          te,
          oe,
          O,
          v,
          F
        ];
        if (Se && U(Ne, Se), T = Ne[0], l = Ne[1], u = Ne[2], S = Ne[3], P = Ne[4], F = Ne[9] = Ne[9] === r ? x ? 0 : T.length : Ee(Ne[9] - re, 0), !F && l & (ot | pr) && (l &= ~(ot | pr)), !l || l == Te)
          var We = Pi(T, l, u);
        else
          l == ot || l == pr ? We = gu(T, l, F) : (l == Zt || l == (Te | Zt)) && !P.length ? We = io(T, l, u, S) : We = ht.apply(r, Ne);
        var ze = Se ? Du : ar;
        return yr(ze(We, Ne), T, l);
      }
      function Qa(T, l, u, S) {
        return T === r || Lt(T, Yo[u]) && !St.call(S, u) ? l : T;
      }
      function bu(T, l, u, S, P, O) {
        return Vt(T) && Vt(l) && (O.set(l, T), Ce(T, l, r, bu, O), O.delete(l)), T;
      }
      function Er(T) {
        return Is(T) ? r : T;
      }
      function ae(T, l, u, S, P, O) {
        var v = u & ve, F = T.length, x = l.length;
        if (F != x && !(v && x > F))
          return !1;
        var re = O.get(T), te = O.get(l);
        if (re && te)
          return re == l && te == T;
        var oe = -1, Se = !0, Ne = u & et ? new Jn() : r;
        for (O.set(T, l), O.set(l, T); ++oe < F; ) {
          var We = T[oe], ze = l[oe];
          if (S)
            var Fe = v ? S(ze, We, oe, l, T, O) : S(We, ze, oe, T, l, O);
          if (Fe !== r) {
            if (Fe)
              continue;
            Se = !1;
            break;
          }
          if (Ne) {
            if (!Xs(l, function(it, st) {
              if (!VT(Ne, st) && (We === it || P(We, it, u, S, O)))
                return Ne.push(st);
            })) {
              Se = !1;
              break;
            }
          } else if (!(We === ze || P(We, ze, u, S, O))) {
            Se = !1;
            break;
          }
        }
        return O.delete(T), O.delete(l), Se;
      }
      function U_(T, l, u, S, P, O, v) {
        switch (u) {
          case Xr:
            if (T.byteLength != l.byteLength || T.byteOffset != l.byteOffset)
              return !1;
            T = T.buffer, l = l.buffer;
          case R_:
            return !(T.byteLength != l.byteLength || !O(new Vo(T), new Vo(l)));
          case Hr:
          case o_:
          case b_:
            return Lt(+T, +l);
          case K:
            return T.name == l.name && T.message == l.message;
          case wr:
          case O_:
            return T == l + "";
          case Be:
            var F = ha;
          case Qt:
            var x = S & ve;
            if (F || (F = c_), T.size != l.size && !x)
              return !1;
            var re = v.get(T);
            if (re)
              return re == l;
            S |= et, v.set(T, l);
            var te = ae(F(T), F(l), S, P, O, v);
            return v.delete(T), te;
          case xr:
            if (Ji)
              return Ji.call(T) == Ji.call(l);
        }
        return !1;
      }
      function V_(T, l, u, S, P, O) {
        var v = u & ve, F = Cu(T), x = F.length, re = Cu(l), te = re.length;
        if (x != te && !v)
          return !1;
        for (var oe = x; oe--; ) {
          var Se = F[oe];
          if (!(v ? Se in l : St.call(l, Se)))
            return !1;
        }
        var Ne = O.get(T), We = O.get(l);
        if (Ne && We)
          return Ne == l && We == T;
        var ze = !0;
        O.set(T, l), O.set(l, T);
        for (var Fe = v; ++oe < x; ) {
          Se = F[oe];
          var it = T[Se], st = l[Se];
          if (S)
            var Dn = v ? S(st, it, Se, l, T, O) : S(it, st, Se, T, l, O);
          if (!(Dn === r ? it === st || P(it, st, u, S, O) : Dn)) {
            ze = !1;
            break;
          }
          Fe || (Fe = Se == "constructor");
        }
        if (ze && !Fe) {
          var rn = T.constructor, Ln = l.constructor;
          rn != Ln && "constructor" in T && "constructor" in l && !(typeof rn == "function" && rn instanceof rn && typeof Ln == "function" && Ln instanceof Ln) && (ze = !1);
        }
        return O.delete(T), O.delete(l), ze;
      }
      function S_(T) {
        return $u(yu(T, r, Ie), T + "");
      }
      function Cu(T) {
        return pl(T, ir, is);
      }
      function qa(T) {
        return pl(T, Ur, ml);
      }
      var ns = XT ? function(T) {
        return XT.get(T);
      } : Gc;
      function G_(T) {
        for (var l = T.name + "", u = Ki[l], S = St.call(Ki, l) ? u.length : 0; S--; ) {
          var P = u[S], O = P.func;
          if (O == null || O == T)
            return P.name;
        }
        return l;
      }
      function Di(T) {
        var l = St.call(C, "placeholder") ? C : T;
        return l.placeholder;
      }
      function ye() {
        var T = C.iteratee || Yc;
        return T = T === Yc ? Ga : T, arguments.length ? T(arguments[0], arguments[1]) : T;
      }
      function _s(T, l) {
        var u = T.__data__;
        return Li(l) ? u[typeof l == "string" ? "string" : "hash"] : u.map;
      }
      function ec(T) {
        for (var l = ir(T), u = l.length; u--; ) {
          var S = l[u], P = T[S];
          l[u] = [S, P, nc(P)];
        }
        return l;
      }
      function oo(T, l) {
        var u = dA(T, l);
        return du(u) ? u : r;
      }
      function VA(T) {
        var l = St.call(T, Xi), u = T[Xi];
        try {
          T[Xi] = r;
          var S = !0;
        } catch {
        }
        var P = Kn.call(T);
        return S && (l ? T[Xi] = u : delete T[Xi]), P;
      }
      var is = Oa ? function(T) {
        return T == null ? [] : (T = Pt(T), F_(Oa(T), function(l) {
          return Na.call(T, l);
        }));
      } : Hc, ml = Oa ? function(T) {
        for (var l = []; T; )
          Nn(l, is(T)), T = Go(T);
        return l;
      } : Hc, Nr = gr;
      (de && Nr(new de(new ArrayBuffer(1))) != Xr || kt && Nr(new kt()) != Be || el && Nr(el.resolve()) != wi || xo && Nr(new xo()) != Qt || Xo && Nr(new Xo()) != Hn) && (Nr = function(T) {
        var l = gr(T), u = l == Sr ? T.constructor : r, S = u ? so(u) : "";
        if (S)
          switch (S) {
            case xp:
              return Xr;
            case Xp:
              return Be;
            case KT:
              return wi;
            case JT:
              return Qt;
            case Kp:
              return Hn;
          }
        return l;
      });
      function GA(T, l, u) {
        for (var S = -1, P = u.length; ++S < P; ) {
          var O = u[S], v = O.size;
          switch (O.type) {
            case "drop":
              T += v;
              break;
            case "dropRight":
              l -= v;
              break;
            case "take":
              l = mt(l, T + v);
              break;
            case "takeRight":
              T = Ee(T, l - v);
              break;
          }
        }
        return { start: T, end: l };
      }
      function HA(T) {
        var l = T.match(Pe);
        return l ? l[1].split(hr) : [];
      }
      function Ou(T, l, u) {
        l = vn(l, T);
        for (var S = -1, P = l.length, O = !1; ++S < P; ) {
          var v = hn(l[S]);
          if (!(O = T != null && u(T, v)))
            break;
          T = T[v];
        }
        return O || ++S != P ? O : (P = T == null ? 0 : T.length, !!P && ne(P) && H_(v, P) && ($e(T) || po(T)));
      }
      function RS(T) {
        var l = T.length, u = new T.constructor(l);
        return l && typeof T[0] == "string" && St.call(T, "index") && (u.index = T.index, u.input = T.input), u;
      }
      function xA(T) {
        return typeof T.constructor == "function" && !oT(T) ? ji(Go(T)) : {};
      }
      function Ru(T, l, u) {
        var S = T.constructor;
        switch (l) {
          case R_:
            return Zn(T);
          case Hr:
          case o_:
            return new S(+T);
          case Xr:
            return eT(T, u);
          case li:
          case k:
          case I:
          case R:
          case B:
          case Y:
          case ie:
          case ke:
          case yt:
            return Al(T, u);
          case Be:
            return new S();
          case b_:
          case O_:
            return new S(T);
          case wr:
            return Ka(T);
          case Qt:
            return new S();
          case xr:
            return tT(T);
        }
      }
      function tc(T, l) {
        var u = l.length;
        if (!u)
          return T;
        var S = u - 1;
        return l[S] = (u > 1 ? "& " : "") + l[S], l = l.join(u > 2 ? ", " : " "), T.replace(Yi, `{
/* [wrapped with ` + l + `] */
`);
      }
      function os(T) {
        return $e(T) || po(T) || !!(ba && T && T[ba]);
      }
      function H_(T, l) {
        var u = typeof T;
        return l = l ?? Ar, !!l && (u == "number" || u != "symbol" && pp.test(T)) && T > -1 && T % 1 == 0 && T < l;
      }
      function Rr(T, l, u) {
        if (!Vt(u))
          return !1;
        var S = typeof l;
        return (S == "number" ? _r(u) && H_(l, u.length) : S == "string" && l in u) ? Lt(u[l], T) : !1;
      }
      function Pl(T, l) {
        if ($e(T))
          return !1;
        var u = typeof T;
        return u == "number" || u == "symbol" || u == "boolean" || T == null || en(T) ? !0 : W.test(T) || !b.test(T) || l != null && T in Pt(l);
      }
      function Li(T) {
        var l = typeof T;
        return l == "string" || l == "number" || l == "symbol" || l == "boolean" ? T !== "__proto__" : T === null;
      }
      function rc(T) {
        var l = G_(T), u = C[l];
        if (typeof u != "function" || !(l in nt.prototype))
          return !1;
        if (T === u)
          return !0;
        var S = ns(u);
        return !!S && T === S[0];
      }
      function XA(T) {
        return !!La && La in T;
      }
      var gi = an ? M_ : xc;
      function oT(T) {
        var l = T && T.constructor, u = typeof l == "function" && l.prototype || Yo;
        return T === u;
      }
      function nc(T) {
        return T === T && !Vt(T);
      }
      function _c(T, l) {
        return function(u) {
          return u == null ? !1 : u[T] === l && (l !== r || T in Pt(u));
        };
      }
      function Dt(T) {
        var l = br(T, function(S) {
          return u.size === y && u.clear(), S;
        }), u = l.cache;
        return l;
      }
      function U(T, l) {
        var u = T[1], S = l[1], P = u | S, O = P < (Te | Le | Rt), v = S == Rt && u == ot || S == Rt && u == Wr && T[7].length <= l[8] || S == (Rt | Wr) && l[7].length <= l[8] && u == ot;
        if (!(O || v))
          return T;
        S & Te && (T[2] = l[2], P |= u & Te ? 0 : we);
        var F = l[3];
        if (F) {
          var x = T[3];
          T[3] = x ? ja(x, F, l[4]) : F, T[4] = x ? Ei(T[3], V) : l[4];
        }
        return F = l[5], F && (x = T[5], T[5] = x ? dl(x, F, l[6]) : F, T[6] = x ? Ei(T[5], V) : l[6]), F = l[7], F && (T[7] = F), S & Rt && (T[8] = T[8] == null ? l[8] : mt(T[8], l[8])), T[9] == null && (T[9] = l[9]), T[0] = l[0], T[1] = P, T;
      }
      function KA(T) {
        var l = [];
        if (T != null)
          for (var u in Pt(T))
            l.push(u);
        return l;
      }
      function fi(T) {
        return Kn.call(T);
      }
      function yu(T, l, u) {
        return l = Ee(l === r ? T.length - 1 : l, 0), function() {
          for (var S = arguments, P = -1, O = Ee(S.length - l, 0), v = J(O); ++P < O; )
            v[P] = S[l + P];
          P = -1;
          for (var F = J(l + 1); ++P < l; )
            F[P] = S[P];
          return F[l] = u(v), Kr(T, this, F);
        };
      }
      function vu(T, l) {
        return l.length < 2 ? T : Si(T, zr(l, 0, -1));
      }
      function yS(T, l) {
        for (var u = T.length, S = mt(l.length, u), P = fr(T); S--; ) {
          var O = l[S];
          T[S] = H_(O, u) ? P[O] : r;
        }
        return T;
      }
      function Ni(T, l) {
        if (!(l === "constructor" && typeof T[l] == "function") && l != "__proto__")
          return T[l];
      }
      var ar = Sn(Du), To = Ca || function(T, l) {
        return Lr.setTimeout(T, l);
      }, $u = Sn(YA);
      function yr(T, l, u) {
        var S = l + "";
        return $u(T, tc(S, JA(HA(S), u)));
      }
      function Sn(T) {
        var l = 0, u = 0;
        return function() {
          var S = Or(), P = ur - (S - u);
          if (u = S, P > 0) {
            if (++l >= Gr)
              return arguments[0];
          } else
            l = 0;
          return T.apply(r, arguments);
        };
      }
      function bi(T, l) {
        var u = -1, S = T.length, P = S - 1;
        for (l = l === r ? S : l; ++u < l; ) {
          var O = Qo(u, P), v = T[O];
          T[O] = T[u], T[u] = v;
        }
        return T.length = l, T;
      }
      var Wu = Dt(function(T) {
        var l = [];
        return T.charCodeAt(0) === 46 && l.push(""), T.replace(H, function(u, S, P, O) {
          l.push(P ? O.replace(Ui, "$1") : S || u);
        }), l;
      });
      function hn(T) {
        if (typeof T == "string" || en(T))
          return T;
        var l = T + "";
        return l == "0" && 1 / T == -on ? "-0" : l;
      }
      function so(T) {
        if (T != null) {
          try {
            return Mt.call(T);
          } catch {
          }
          try {
            return T + "";
          } catch {
          }
        }
        return "";
      }
      function JA(T, l) {
        return sn(ge, function(u) {
          var S = "_." + u[0];
          l & u[1] && !xs(T, S) && T.push(S);
        }), T.sort();
      }
      function ku(T) {
        if (T instanceof nt)
          return T.clone();
        var l = new pn(T.__wrapped__, T.__chain__);
        return l.__actions__ = fr(T.__actions__), l.__index__ = T.__index__, l.__values__ = T.__values__, l;
      }
      function TT(T, l, u) {
        (u ? Rr(T, l, u) : l === r) ? l = 1 : l = Ee(Ke(l), 0);
        var S = T == null ? 0 : T.length;
        if (!S || l < 1)
          return [];
        for (var P = 0, O = 0, v = J(HT(S / l)); P < S; )
          v[O++] = zr(T, P, P += l);
        return v;
      }
      function jA(T) {
        for (var l = -1, u = T == null ? 0 : T.length, S = 0, P = []; ++l < u; ) {
          var O = T[l];
          O && (P[S++] = O);
        }
        return P;
      }
      function zA() {
        var T = arguments.length;
        if (!T)
          return [];
        for (var l = J(T - 1), u = arguments[0], S = T; S--; )
          l[S - 1] = arguments[S];
        return Nn($e(u) ? fr(u) : [u], Ir(l, 1));
      }
      var ZA = qe(function(T, l) {
        return Kt(T) ? jo(T, Ir(l, 1, Kt, !0)) : [];
      }), ic = qe(function(T, l) {
        var u = In(l);
        return Kt(u) && (u = r), Kt(T) ? jo(T, Ir(l, 1, Kt, !0), ye(u, 2)) : [];
      }), Fu = qe(function(T, l) {
        var u = In(l);
        return Kt(u) && (u = r), Kt(T) ? jo(T, Ir(l, 1, Kt, !0), r, u) : [];
      });
      function QA(T, l, u) {
        var S = T == null ? 0 : T.length;
        return S ? (l = u || l === r ? 1 : Ke(l), zr(T, l < 0 ? 0 : l, S)) : [];
      }
      function Dl(T, l, u) {
        var S = T == null ? 0 : T.length;
        return S ? (l = u || l === r ? 1 : Ke(l), l = S - l, zr(T, 0, l < 0 ? 0 : l)) : [];
      }
      function sT(T, l) {
        return T && T.length ? zn(T, ye(l, 3), !0, !0) : [];
      }
      function wu(T, l) {
        return T && T.length ? zn(T, ye(l, 3), !0) : [];
      }
      function qA(T, l, u, S) {
        var P = T == null ? 0 : T.length;
        return P ? (u && typeof u != "number" && Rr(T, l, u) && (u = 0, S = P), au(T, l, u, S)) : [];
      }
      function lo(T, l, u) {
        var S = T == null ? 0 : T.length;
        if (!S)
          return -1;
        var P = u == null ? 0 : Ke(u);
        return P < 0 && (P = Ee(S + P, 0)), YT(T, ye(l, 3), P);
      }
      function oc(T, l, u) {
        var S = T == null ? 0 : T.length;
        if (!S)
          return -1;
        var P = S - 1;
        return u !== r && (P = Ke(u), P = u < 0 ? Ee(S + P, 0) : mt(P, S - 1)), YT(T, ye(l, 3), P, !0);
      }
      function Ie(T) {
        var l = T == null ? 0 : T.length;
        return l ? Ir(T, 1) : [];
      }
      function lt(T) {
        var l = T == null ? 0 : T.length;
        return l ? Ir(T, on) : [];
      }
      function Ts(T, l) {
        var u = T == null ? 0 : T.length;
        return u ? (l = l === r ? 1 : Ke(l), Ir(T, l)) : [];
      }
      function Tc(T) {
        for (var l = -1, u = T == null ? 0 : T.length, S = {}; ++l < u; ) {
          var P = T[l];
          S[P[0]] = P[1];
        }
        return S;
      }
      function sc(T) {
        return T && T.length ? T[0] : r;
      }
      function ed(T, l, u) {
        var S = T == null ? 0 : T.length;
        if (!S)
          return -1;
        var P = u == null ? 0 : Ke(u);
        return P < 0 && (P = Ee(S + P, 0)), ko(T, l, P);
      }
      function td(T) {
        var l = T == null ? 0 : T.length;
        return l ? zr(T, 0, -1) : [];
      }
      var lc = qe(function(T) {
        var l = $t(T, to);
        return l.length && l[0] === T[0] ? Ua(l) : [];
      }), Ll = qe(function(T) {
        var l = In(T), u = $t(T, to);
        return l === In(u) ? l = r : u.pop(), u.length && u[0] === T[0] ? Ua(u, ye(l, 2)) : [];
      }), Bu = qe(function(T) {
        var l = In(T), u = $t(T, to);
        return l = typeof l == "function" ? l : r, l && u.pop(), u.length && u[0] === T[0] ? Ua(u, r, l) : [];
      });
      function rd(T, l) {
        return T == null ? "" : DA.call(T, l);
      }
      function In(T) {
        var l = T == null ? 0 : T.length;
        return l ? T[l - 1] : r;
      }
      function ac(T, l, u) {
        var S = T == null ? 0 : T.length;
        if (!S)
          return -1;
        var P = S;
        return u !== r && (P = Ke(u), P = P < 0 ? Ee(S + P, 0) : mt(P, S - 1)), l === l ? ma(T, l, P) : YT(T, pa, P, !0);
      }
      function Yu(T, l) {
        return T && T.length ? hi(T, Ke(l)) : r;
      }
      var lT = qe(aT);
      function aT(T, l) {
        return T && T.length && l && l.length ? Rn(T, l) : T;
      }
      function ss(T, l, u) {
        return T && T.length && l && l.length ? Rn(T, l, ye(u, 2)) : T;
      }
      function at(T, l, u) {
        return T && T.length && l && l.length ? Rn(T, l, r, u) : T;
      }
      var ls = S_(function(T, l) {
        var u = T == null ? 0 : T.length, S = sl(T, l);
        return jr(T, $t(l, function(P) {
          return H_(P, u) ? +P : P;
        }).sort(He)), S;
      });
      function cT(T, l) {
        var u = [];
        if (!(T && T.length))
          return u;
        var S = -1, P = [], O = T.length;
        for (l = ye(l, 3); ++S < O; ) {
          var v = T[S];
          l(v, S, T) && (u.push(v), P.push(S));
        }
        return jr(T, P), u;
      }
      function gl(T) {
        return T == null ? T : xT.call(T);
      }
      function ao(T, l, u) {
        var S = T == null ? 0 : T.length;
        return S ? (u && typeof u != "number" && Rr(T, l, u) ? (l = 0, u = S) : (l = l == null ? 0 : Ke(l), u = u === r ? S : Ke(u)), zr(T, l, u)) : [];
      }
      function nd(T, l) {
        return Ii(T, l);
      }
      function Uu(T, l, u) {
        return es(T, l, ye(u, 2));
      }
      function tr(T, l) {
        var u = T == null ? 0 : T.length;
        if (u) {
          var S = Ii(T, l);
          if (S < u && Lt(T[S], l))
            return S;
        }
        return -1;
      }
      function fl(T, l) {
        return Ii(T, l, !0);
      }
      function pT(T, l, u) {
        return es(T, l, ye(u, 2), !0);
      }
      function cc(T, l) {
        var u = T == null ? 0 : T.length;
        if (u) {
          var S = Ii(T, l, !0) - 1;
          if (Lt(T[S], l))
            return S;
        }
        return -1;
      }
      function Nl(T) {
        return T && T.length ? Mi(T) : [];
      }
      function as(T, l) {
        return T && T.length ? Mi(T, ye(l, 2)) : [];
      }
      function _d(T) {
        var l = T == null ? 0 : T.length;
        return l ? zr(T, 1, l) : [];
      }
      function id(T, l, u) {
        return T && T.length ? (l = u || l === r ? 1 : Ke(l), zr(T, 0, l < 0 ? 0 : l)) : [];
      }
      function uT(T, l, u) {
        var S = T == null ? 0 : T.length;
        return S ? (l = u || l === r ? 1 : Ke(l), l = S - l, zr(T, l < 0 ? 0 : l, S)) : [];
      }
      function Vu(T, l) {
        return T && T.length ? zn(T, ye(l, 3), !1, !0) : [];
      }
      function Gu(T, l) {
        return T && T.length ? zn(T, ye(l, 3)) : [];
      }
      var Qn = qe(function(T) {
        return yn(Ir(T, 1, Kt, !0));
      }), bl = qe(function(T) {
        var l = In(T);
        return Kt(l) && (l = r), yn(Ir(T, 1, Kt, !0), ye(l, 2));
      }), Hu = qe(function(T) {
        var l = In(T);
        return l = typeof l == "function" ? l : r, yn(Ir(T, 1, Kt, !0), r, l);
      });
      function xu(T) {
        return T && T.length ? yn(T) : [];
      }
      function od(T, l) {
        return T && T.length ? yn(T, ye(l, 2)) : [];
      }
      function Td(T, l) {
        return l = typeof l == "function" ? l : r, T && T.length ? yn(T, r, l) : [];
      }
      function cs(T) {
        if (!(T && T.length))
          return [];
        var l = 0;
        return T = F_(T, function(u) {
          if (Kt(u))
            return l = Ee(u.length, l), !0;
        }), Js(l, function(u) {
          return $t(T, ua(u));
        });
      }
      function rr(T, l) {
        if (!(T && T.length))
          return [];
        var u = cs(T);
        return l == null ? u : $t(u, function(S) {
          return Kr(l, r, S);
        });
      }
      var Pr = qe(function(T, l) {
        return Kt(T) ? jo(T, l) : [];
      }), Xu = qe(function(T) {
        return eo(F_(T, Kt));
      }), Ku = qe(function(T) {
        var l = In(T);
        return Kt(l) && (l = r), eo(F_(T, Kt), ye(l, 2));
      }), sd = qe(function(T) {
        var l = In(T);
        return l = typeof l == "function" ? l : r, eo(F_(T, Kt), r, l);
      }), Yr = qe(cs);
      function Cl(T, l) {
        return A_(T || [], l || [], Jo);
      }
      function ps(T, l) {
        return A_(T || [], l || [], er);
      }
      var pc = qe(function(T) {
        var l = T.length, u = l > 1 ? T[l - 1] : r;
        return u = typeof u == "function" ? (T.pop(), u) : r, rr(T, u);
      });
      function ET(T) {
        var l = C(T);
        return l.__chain__ = !0, l;
      }
      function us(T, l) {
        return l(T), T;
      }
      function Mn(T, l) {
        return l(T);
      }
      var x_ = S_(function(T) {
        var l = T.length, u = l ? T[0] : 0, S = this.__wrapped__, P = function(O) {
          return sl(O, T);
        };
        return l > 1 || this.__actions__.length || !(S instanceof nt) || !H_(u) ? this.thru(P) : (S = S.slice(u, +u + (l ? 1 : 0)), S.__actions__.push({
          func: Mn,
          args: [P],
          thisArg: r
        }), new pn(S, this.__chain__).thru(function(O) {
          return l && !O.length && O.push(r), O;
        }));
      });
      function _t() {
        return ET(this);
      }
      function nr() {
        return new pn(this.value(), this.__chain__);
      }
      function ld() {
        this.__values__ === r && (this.__values__ = Oc(this.value()));
        var T = this.__index__ >= this.__values__.length, l = T ? r : this.__values__[this.__index__++];
        return { done: T, value: l };
      }
      function Ol() {
        return this;
      }
      function vS(T) {
        for (var l, u = this; u instanceof rl; ) {
          var S = ku(u);
          S.__index__ = 0, S.__values__ = r, l ? P.__wrapped__ = S : l = S;
          var P = S;
          u = u.__wrapped__;
        }
        return P.__wrapped__ = T, l;
      }
      function $S() {
        var T = this.__wrapped__;
        if (T instanceof nt) {
          var l = T;
          return this.__actions__.length && (l = new nt(this)), l = l.reverse(), l.__actions__.push({
            func: Mn,
            args: [gl],
            thisArg: r
          }), new pn(l, this.__chain__);
        }
        return this.thru(gl);
      }
      function mn() {
        return B_(this.__wrapped__, this.__actions__);
      }
      var Ot = Y_(function(T, l, u) {
        St.call(T, u) ? ++T[u] : E_(T, u, 1);
      });
      function Rl(T, l, u) {
        var S = $e(T) ? la : wa;
        return u && Rr(T, l, u) && (l = r), S(T, ye(l, 3));
      }
      function Ju(T, l) {
        var u = $e(T) ? F_ : cu;
        return u(T, ye(l, 3));
      }
      var ju = hl(lo), X_ = hl(oc);
      function WS(T, l) {
        return Ir(Ac(T, l), 1);
      }
      function kS(T, l) {
        return Ir(Ac(T, l), on);
      }
      function uc(T, l, u) {
        return u = u === r ? 1 : Ke(u), Ir(Ac(T, l), u);
      }
      function Xt(T, l) {
        var u = $e(T) ? sn : di;
        return u(T, ye(l, 3));
      }
      function Ec(T, l) {
        var u = $e(T) ? vp : Fa;
        return u(T, ye(l, 3));
      }
      var Xe = Y_(function(T, l, u) {
        St.call(T, u) ? T[u].push(l) : E_(T, u, [l]);
      });
      function ad(T, l, u, S) {
        T = _r(T) ? T : ho(T), u = u && !S ? Ke(u) : 0;
        var P = T.length;
        return u < 0 && (u = Ee(P + u, 0)), ms(T) ? u <= P && T.indexOf(l, u) > -1 : !!P && ko(T, l, u) > -1;
      }
      var AT = qe(function(T, l, u) {
        var S = -1, P = typeof l == "function", O = _r(T) ? J(T.length) : [];
        return di(T, function(v) {
          O[++S] = P ? Kr(l, v, u) : QT(v, l, u);
        }), O;
      }), FS = Y_(function(T, l, u) {
        E_(T, u, l);
      });
      function Ac(T, l) {
        var u = $e(T) ? $t : Ha;
        return u(T, ye(l, 3));
      }
      function dc(T, l, u, S) {
        return T == null ? [] : ($e(l) || (l = l == null ? [] : [l]), u = S ? r : u, $e(u) || (u = u == null ? [] : [u]), FA(T, l, u));
      }
      var zu = Y_(function(T, l, u) {
        T[u ? 0 : 1].push(l);
      }, function() {
        return [[], []];
      });
      function cd(T, l, u) {
        var S = $e(T) ? BT : kp, P = arguments.length < 3;
        return S(T, ye(l, 4), u, P, di);
      }
      function Ue(T, l, u) {
        var S = $e(T) ? a_ : kp, P = arguments.length < 3;
        return S(T, ye(l, 4), u, P, Fa);
      }
      function pd(T, l) {
        var u = $e(T) ? F_ : cu;
        return u(T, K_(ye(l, 3)));
      }
      function co(T) {
        var l = $e(T) ? ol : qT;
        return l(T);
      }
      function qn(T, l, u) {
        (u ? Rr(T, l, u) : l === r) ? l = 1 : l = Ke(l);
        var S = $e(T) ? Tl : BA;
        return S(T, l);
      }
      function Ci(T) {
        var l = $e(T) ? Tu : CS;
        return l(T);
      }
      function Sc(T) {
        if (T == null)
          return 0;
        if (_r(T))
          return ms(T) ? Xn(T) : T.length;
        var l = Nr(T);
        return l == Be || l == Qt ? T.size : ul(T).length;
      }
      function hc(T, l, u) {
        var S = $e(T) ? Xs : Lu;
        return u && Rr(T, l, u) && (l = r), S(T, ye(l, 3));
      }
      var Es = qe(function(T, l) {
        if (T == null)
          return [];
        var u = l.length;
        return u > 1 && Rr(T, l[0], l[1]) ? l = [] : u > 2 && Rr(l[0], l[1], l[2]) && (l = [l[0]]), FA(T, Ir(l, 1), []);
      }), Ic = Gp || function() {
        return Lr.Date.now();
      };
      function e_(T, l) {
        if (typeof l != "function")
          throw new ln(E);
        return T = Ke(T), function() {
          if (--T < 1)
            return l.apply(this, arguments);
        };
      }
      function Zu(T, l, u) {
        return l = u ? r : l, l = T && l == null ? T.length : l, d_(T, Rt, r, r, r, r, l);
      }
      function je(T, l) {
        var u;
        if (typeof l != "function")
          throw new ln(E);
        return T = Ke(T), function() {
          return --T > 0 && (u = l.apply(this, arguments)), T <= 1 && (l = r), u;
        };
      }
      var h_ = qe(function(T, l, u) {
        var S = Te;
        if (u.length) {
          var P = Ei(u, Di(h_));
          S |= Zt;
        }
        return d_(T, S, l, u, P);
      }), Bt = qe(function(T, l, u) {
        var S = Te | Le;
        if (u.length) {
          var P = Ei(u, Di(Bt));
          S |= Zt;
        }
        return d_(l, S, T, u, P);
      });
      function Mc(T, l, u) {
        l = u ? r : l;
        var S = d_(T, ot, r, r, r, r, r, l);
        return S.placeholder = Mc.placeholder, S;
      }
      function mc(T, l, u) {
        l = u ? r : l;
        var S = d_(T, pr, r, r, r, r, r, l);
        return S.placeholder = mc.placeholder, S;
      }
      function Qu(T, l, u) {
        var S, P, O, v, F, x, re = 0, te = !1, oe = !1, Se = !0;
        if (typeof T != "function")
          throw new ln(E);
        l = Pn(l) || 0, Vt(u) && (te = !!u.leading, oe = "maxWait" in u, O = oe ? Ee(Pn(u.maxWait) || 0, l) : O, Se = "trailing" in u ? !!u.trailing : Se);
        function Ne(cr) {
          var f_ = S, $i = P;
          return S = P = r, re = cr, v = T.apply($i, f_), v;
        }
        function We(cr) {
          return re = cr, F = To(it, l), te ? Ne(cr) : v;
        }
        function ze(cr) {
          var f_ = cr - x, $i = cr - re, Qd = l - f_;
          return oe ? mt(Qd, O - $i) : Qd;
        }
        function Fe(cr) {
          var f_ = cr - x, $i = cr - re;
          return x === r || f_ >= l || f_ < 0 || oe && $i >= O;
        }
        function it() {
          var cr = Ic();
          if (Fe(cr))
            return st(cr);
          F = To(it, ze(cr));
        }
        function st(cr) {
          return F = r, Se && S ? Ne(cr) : (S = P = r, v);
        }
        function Dn() {
          F !== r && _o(F), re = 0, S = x = P = F = r;
        }
        function rn() {
          return F === r ? v : st(Ic());
        }
        function Ln() {
          var cr = Ic(), f_ = Fe(cr);
          if (S = arguments, P = this, x = cr, f_) {
            if (F === r)
              return We(x);
            if (oe)
              return _o(F), F = To(it, l), Ne(x);
          }
          return F === r && (F = To(it, l)), v;
        }
        return Ln.cancel = Dn, Ln.flush = rn, Ln;
      }
      var qu = qe(function(T, l) {
        return al(T, 1, l);
      }), ud = qe(function(T, l, u) {
        return al(T, Pn(l) || 0, u);
      });
      function Ed(T) {
        return d_(T, Un);
      }
      function br(T, l) {
        if (typeof T != "function" || l != null && typeof l != "function")
          throw new ln(E);
        var u = function() {
          var S = arguments, P = l ? l.apply(this, S) : S[0], O = u.cache;
          if (O.has(P))
            return O.get(P);
          var v = T.apply(this, S);
          return u.cache = O.set(P, v) || O, v;
        };
        return u.cache = new (br.Cache || u_)(), u;
      }
      br.Cache = u_;
      function K_(T) {
        if (typeof T != "function")
          throw new ln(E);
        return function() {
          var l = arguments;
          switch (l.length) {
            case 0:
              return !T.call(this);
            case 1:
              return !T.call(this, l[0]);
            case 2:
              return !T.call(this, l[0], l[1]);
            case 3:
              return !T.call(this, l[0], l[1], l[2]);
          }
          return !T.apply(this, l);
        };
      }
      function Oi(T) {
        return je(2, T);
      }
      var eE = no(function(T, l) {
        l = l.length == 1 && $e(l[0]) ? $t(l[0], Jr(ye())) : $t(Ir(l, 1), Jr(ye()));
        var u = l.length;
        return qe(function(S) {
          for (var P = -1, O = mt(S.length, u); ++P < O; )
            S[P] = l[P].call(this, S[P]);
          return Kr(T, this, S);
        });
      }), t_ = qe(function(T, l) {
        var u = Ei(l, Di(t_));
        return d_(T, Zt, r, l, u);
      }), tE = qe(function(T, l) {
        var u = Ei(l, Di(tE));
        return d_(T, Je, r, l, u);
      }), Wn = S_(function(T, l) {
        return d_(T, Wr, r, r, r, l);
      });
      function As(T, l) {
        if (typeof T != "function")
          throw new ln(E);
        return l = l === r ? l : Ke(l), qe(T, l);
      }
      function yl(T, l) {
        if (typeof T != "function")
          throw new ln(E);
        return l = l == null ? 0 : Ee(Ke(l), 0), qe(function(u) {
          var S = u[l], P = Zr(u, 0, l);
          return S && Nn(P, S), Kr(T, this, P);
        });
      }
      function vl(T, l, u) {
        var S = !0, P = !0;
        if (typeof T != "function")
          throw new ln(E);
        return Vt(u) && (S = "leading" in u ? !!u.leading : S, P = "trailing" in u ? !!u.trailing : P), Qu(T, l, {
          leading: S,
          maxWait: l,
          trailing: P
        });
      }
      function $l(T) {
        return Zu(T, 1);
      }
      function rE(T, l) {
        return t_(ro(l), T);
      }
      function Pc() {
        if (!arguments.length)
          return [];
        var T = arguments[0];
        return $e(T) ? T : [T];
      }
      function Dc(T) {
        return un(T, ce);
      }
      function Lc(T, l) {
        return l = typeof l == "function" ? l : r, un(T, ce, l);
      }
      function ds(T) {
        return un(T, Z | ce);
      }
      function nE(T, l) {
        return l = typeof l == "function" ? l : r, un(T, Z | ce, l);
      }
      function Ri(T, l) {
        return l == null || ll(T, l, ir(l));
      }
      function Lt(T, l) {
        return T === l || T !== T && l !== l;
      }
      var _E = nT(ZT), Ad = nT(function(T, l) {
        return T >= l;
      }), po = pu(/* @__PURE__ */ function() {
        return arguments;
      }()) ? pu : function(T) {
        return Gt(T) && St.call(T, "callee") && !Na.call(T, "callee");
      }, $e = J.isArray, dd = sa ? Jr(sa) : kA;
      function _r(T) {
        return T != null && ne(T.length) && !M_(T);
      }
      function Kt(T) {
        return Gt(T) && _r(T);
      }
      function Wl(T) {
        return T === !0 || T === !1 || Gt(T) && gr(T) == Hr;
      }
      var I_ = Ra || xc, Sd = $o ? Jr($o) : uu;
      function gc(T) {
        return Gt(T) && T.nodeType === 1 && !Is(T);
      }
      function J_(T) {
        if (T == null)
          return !0;
        if (_r(T) && ($e(T) || typeof T == "string" || typeof T.splice == "function" || I_(T) || uo(T) || po(T)))
          return !T.length;
        var l = Nr(T);
        if (l == Be || l == Qt)
          return !T.size;
        if (oT(T))
          return !ul(T).length;
        for (var u in T)
          if (St.call(T, u))
            return !1;
        return !0;
      }
      function ct(T, l) {
        return Zo(T, l);
      }
      function hd(T, l, u) {
        u = typeof u == "function" ? u : r;
        var S = u ? u(T, l) : r;
        return S === r ? Zo(T, l, r, u) : !!S;
      }
      function fc(T) {
        if (!Gt(T))
          return !1;
        var l = gr(T);
        return l == K || l == dr || typeof T.message == "string" && typeof T.name == "string" && !Is(T);
      }
      function dT(T) {
        return typeof T == "number" && Hp(T);
      }
      function M_(T) {
        if (!Vt(T))
          return !1;
        var l = gr(T);
        return l == be || l == Ti || l == Fr || l == C_;
      }
      function Nc(T) {
        return typeof T == "number" && T == Ke(T);
      }
      function ne(T) {
        return typeof T == "number" && T > -1 && T % 1 == 0 && T <= Ar;
      }
      function Vt(T) {
        var l = typeof T;
        return T != null && (l == "object" || l == "function");
      }
      function Gt(T) {
        return T != null && typeof T == "object";
      }
      var Ss = Gs ? Jr(Gs) : Au;
      function Id(T, l) {
        return T === l || Va(T, l, ec(l));
      }
      function iE(T, l, u) {
        return u = typeof u == "function" ? u : r, Va(T, l, ec(l), u);
      }
      function qr(T) {
        return hs(T) && T != +T;
      }
      function oE(T) {
        if (gi(T))
          throw new Ye(p);
        return du(T);
      }
      function m_(T) {
        return T === null;
      }
      function kn(T) {
        return T == null;
      }
      function hs(T) {
        return typeof T == "number" || Gt(T) && gr(T) == b_;
      }
      function Is(T) {
        if (!Gt(T) || gr(T) != Sr)
          return !1;
        var l = Go(T);
        if (l === null)
          return !0;
        var u = St.call(l, "constructor") && l.constructor;
        return typeof u == "function" && u instanceof u && Mt.call(u) == ga;
      }
      var bc = Hs ? Jr(Hs) : Su;
      function Ms(T) {
        return Nc(T) && T >= -Ar && T <= Ar;
      }
      var Cc = Rp ? Jr(Rp) : hu;
      function ms(T) {
        return typeof T == "string" || !$e(T) && Gt(T) && gr(T) == O_;
      }
      function en(T) {
        return typeof T == "symbol" || Gt(T) && gr(T) == xr;
      }
      var uo = wT ? Jr(wT) : Iu;
      function TE(T) {
        return T === r;
      }
      function sE(T) {
        return Gt(T) && Nr(T) == Hn;
      }
      function Eo(T) {
        return Gt(T) && gr(T) == si;
      }
      var lE = nT(El), aE = nT(function(T, l) {
        return T <= l;
      });
      function Oc(T) {
        if (!T)
          return [];
        if (_r(T))
          return ms(T) ? bn(T) : fr(T);
        if (xi && T[xi])
          return Yp(T[xi]());
        var l = Nr(T), u = l == Be ? ha : l == Qt ? c_ : ho;
        return u(T);
      }
      function P_(T) {
        if (!T)
          return T === 0 ? T : 0;
        if (T = Pn(T), T === on || T === -on) {
          var l = T < 0 ? -1 : 1;
          return l * ii;
        }
        return T === T ? T : 0;
      }
      function Ke(T) {
        var l = P_(T), u = l % 1;
        return l === l ? u ? l - u : l : 0;
      }
      function Rc(T) {
        return T ? Zi(Ke(T), 0, kr) : 0;
      }
      function Pn(T) {
        if (typeof T == "number")
          return T;
        if (en(T))
          return tt;
        if (Vt(T)) {
          var l = typeof T.valueOf == "function" ? T.valueOf() : T;
          T = Vt(l) ? l + "" : l;
        }
        if (typeof T != "string")
          return T === 0 ? T : +T;
        T = UT(T);
        var u = cp.test(T);
        return u || JE.test(T) ? Vi(T.slice(2), u ? 2 : 8) : xn.test(T) ? tt : +T;
      }
      function yc(T) {
        return An(T, Ur(T));
      }
      function cE(T) {
        return T ? Zi(Ke(T), -Ar, Ar) : T === 0 ? T : 0;
      }
      function At(T) {
        return T == null ? "" : Mr(T);
      }
      var pE = mr(function(T, l) {
        if (oT(l) || _r(l)) {
          An(l, ir(l), T);
          return;
        }
        for (var u in l)
          St.call(l, u) && Jo(T, u, l[u]);
      }), he = mr(function(T, l) {
        An(l, Ur(l), T);
      }), Ao = mr(function(T, l, u, S) {
        An(l, Ur(l), T, S);
      }), Md = mr(function(T, l, u, S) {
        An(l, ir(l), T, S);
      }), wS = S_(sl);
      function w(T, l) {
        var u = ji(T);
        return l == null ? u : ka(u, l);
      }
      var j_ = qe(function(T, l) {
        T = Pt(T);
        var u = -1, S = l.length, P = S > 2 ? l[2] : r;
        for (P && Rr(l[0], l[1], P) && (S = 1); ++u < S; )
          for (var O = l[u], v = Ur(O), F = -1, x = v.length; ++F < x; ) {
            var re = v[F], te = T[re];
            (te === r || Lt(te, Yo[re]) && !St.call(T, re)) && (T[re] = O[re]);
          }
        return T;
      }), ST = qe(function(T) {
        return T.push(r, bu), Kr(AE, r, T);
      });
      function kl(T, l) {
        return aa(T, ye(l, 3), jn);
      }
      function md(T, l) {
        return aa(T, ye(l, 3), cl);
      }
      function hT(T, l) {
        return T == null ? T : Ba(T, ye(l, 3), Ur);
      }
      function Fl(T, l) {
        return T == null ? T : Ya(T, ye(l, 3), Ur);
      }
      function Ps(T, l) {
        return T && jn(T, ye(l, 3));
      }
      function wl(T, l) {
        return T && cl(T, ye(l, 3));
      }
      function uE(T) {
        return T == null ? [] : zo(T, ir(T));
      }
      function So(T) {
        return T == null ? [] : zo(T, Ur(T));
      }
      function Ds(T, l, u) {
        var S = T == null ? r : Si(T, l);
        return S === r ? u : S;
      }
      function Ls(T, l) {
        return T != null && Ou(T, l, yA);
      }
      function Bl(T, l) {
        return T != null && Ou(T, l, vA);
      }
      var Pd = fu(function(T, l, u) {
        l != null && typeof l.toString != "function" && (l = Kn.call(l)), T[l] = u;
      }, L_(gt)), Fn = fu(function(T, l, u) {
        l != null && typeof l.toString != "function" && (l = Kn.call(l)), St.call(T, l) ? T[l].push(u) : T[l] = [u];
      }, ye), EE = qe(QT);
      function ir(T) {
        return _r(T) ? $a(T) : ul(T);
      }
      function Ur(T) {
        return _r(T) ? $a(T, !0) : Mu(T);
      }
      function Dd(T, l) {
        var u = {};
        return l = ye(l, 3), jn(T, function(S, P, O) {
          E_(u, l(S, P, O), S);
        }), u;
      }
      function Ld(T, l) {
        var u = {};
        return l = ye(l, 3), jn(T, function(S, P, O) {
          E_(u, P, l(S, P, O));
        }), u;
      }
      var gd = mr(function(T, l, u) {
        Ce(T, l, u);
      }), AE = mr(function(T, l, u, S) {
        Ce(T, l, u, S);
      }), Yl = S_(function(T, l) {
        var u = {};
        if (T == null)
          return u;
        var S = !1;
        l = $t(l, function(O) {
          return O = vn(O, T), S || (S = O.length > 1), O;
        }), An(T, qa(T), u), S && (u = un(u, Z | le | ce, Er));
        for (var P = l.length; P--; )
          ts(u, l[P]);
        return u;
      });
      function dE(T, l) {
        return vc(T, K_(ye(l)));
      }
      var Ul = S_(function(T, l) {
        return T == null ? {} : xa(T, l);
      });
      function vc(T, l) {
        if (T == null)
          return {};
        var u = $t(qa(T), function(S) {
          return [S];
        });
        return l = ye(l), w_(T, u, function(S, P) {
          return l(S, P[0]);
        });
      }
      function gs(T, l, u) {
        l = vn(l, T);
        var S = -1, P = l.length;
        for (P || (P = 1, T = r); ++S < P; ) {
          var O = T == null ? r : T[hn(l[S])];
          O === r && (S = P, O = u), T = M_(O) ? O.call(T) : O;
        }
        return T;
      }
      function fd(T, l, u) {
        return T == null ? T : er(T, l, u);
      }
      function $c(T, l, u, S) {
        return S = typeof S == "function" ? S : r, T == null ? T : er(T, l, u, S);
      }
      var SE = rs(ir), hE = rs(Ur);
      function Nd(T, l, u) {
        var S = $e(T), P = S || I_(T) || uo(T);
        if (l = ye(l, 4), u == null) {
          var O = T && T.constructor;
          P ? u = S ? new O() : [] : Vt(T) ? u = M_(O) ? ji(Go(T)) : {} : u = {};
        }
        return (P ? sn : jn)(T, function(v, F, x) {
          return l(u, v, F, x);
        }), u;
      }
      function BS(T, l) {
        return T == null ? !0 : ts(T, l);
      }
      function YS(T, l, u) {
        return T == null ? T : qi(T, l, ro(u));
      }
      function US(T, l, u, S) {
        return S = typeof S == "function" ? S : r, T == null ? T : qi(T, l, ro(u), S);
      }
      function ho(T) {
        return T == null ? [] : Aa(T, ir(T));
      }
      function bd(T) {
        return T == null ? [] : Aa(T, Ur(T));
      }
      function Wc(T, l, u) {
        return u === r && (u = l, l = r), u !== r && (u = Pn(u), u = u === u ? u : 0), l !== r && (l = Pn(l), l = l === l ? l : 0), Zi(Pn(T), l, u);
      }
      function Cd(T, l, u) {
        return l = P_(l), u === r ? (u = l, l = 0) : u = P_(u), T = Pn(T), $A(T, l, u);
      }
      function Vl(T, l, u) {
        if (u && typeof u != "boolean" && Rr(T, l, u) && (l = u = r), u === r && (typeof l == "boolean" ? (u = l, l = r) : typeof T == "boolean" && (u = T, T = r)), T === r && l === r ? (T = 0, l = 1) : (T = P_(T), l === r ? (l = T, T = 0) : l = P_(l)), T > l) {
          var S = T;
          T = l, l = S;
        }
        if (u || T % 1 || l % 1) {
          var P = p_();
          return mt(T + P * (l - T + cA("1e-" + ((P + "").length - 1))), l);
        }
        return Qo(T, l);
      }
      var dt = dn(function(T, l, u) {
        return l = l.toLowerCase(), T + (u ? IE(l) : l);
      });
      function IE(T) {
        return Hl(At(T).toLowerCase());
      }
      function r_(T) {
        return T = At(T), T && T.replace($_, wp).replace(Np, "");
      }
      function tn(T, l, u) {
        T = At(T), l = Mr(l);
        var S = T.length;
        u = u === r ? S : Zi(Ke(u), 0, S);
        var P = u;
        return u -= l.length, u >= 0 && T.slice(u, P) == l;
      }
      function Od(T) {
        return T = At(T), T && Co.test(T) ? T.replace(Ut, Bp) : T;
      }
      function kc(T) {
        return T = At(T), T && me.test(T) ? T.replace(ee, "\\$&") : T;
      }
      var Qe = dn(function(T, l, u) {
        return T + (u ? "-" : "") + l.toLowerCase();
      }), Fc = dn(function(T, l, u) {
        return T + (u ? " " : "") + l.toLowerCase();
      }), IT = $n("toLowerCase");
      function wn(T, l, u) {
        T = At(T), l = Ke(l);
        var S = l ? Xn(T) : 0;
        if (!l || S >= l)
          return T;
        var P = (l - S) / 2;
        return Ml(Ho(P), u) + T + Ml(HT(P), u);
      }
      function Rd(T, l, u) {
        T = At(T), l = Ke(l);
        var S = l ? Xn(T) : 0;
        return l && S < l ? T + Ml(l - S, u) : T;
      }
      function ME(T, l, u) {
        T = At(T), l = Ke(l);
        var S = l ? Xn(T) : 0;
        return l && S < l ? Ml(l - S, u) + T : T;
      }
      function mE(T, l, u) {
        return u || l == null ? l = 0 : l && (l = +l), Wt(At(T).replace(Ge, ""), l || 0);
      }
      function Gl(T, l, u) {
        return (u ? Rr(T, l, u) : l === r) ? l = 1 : l = Ke(l), Xa(At(T), l);
      }
      function D_() {
        var T = arguments, l = At(T[0]);
        return T.length < 3 ? l : l.replace(T[1], T[2]);
      }
      var PE = dn(function(T, l, u) {
        return T + (u ? "_" : "") + l.toLowerCase();
      });
      function yd(T, l, u) {
        return u && typeof u != "number" && Rr(T, l, u) && (l = u = r), u = u === r ? kr : u >>> 0, u ? (T = At(T), T && (typeof l == "string" || l != null && !bc(l)) && (l = Mr(l), !l && Fo(T)) ? Zr(bn(T), 0, u) : T.split(l, u)) : [];
      }
      var DE = dn(function(T, l, u) {
        return T + (u ? " " : "") + Hl(l);
      });
      function vd(T, l, u) {
        return T = At(T), u = u == null ? 0 : Zi(Ke(u), 0, T.length), l = Mr(l), T.slice(u, u + l.length) == l;
      }
      function VS(T, l, u) {
        var S = C.templateSettings;
        u && Rr(T, l, u) && (l = r), T = At(T), l = Ao({}, l, S, Qa);
        var P = Ao({}, l.imports, S.imports, Qa), O = ir(P), v = Aa(P, O), F, x, re = 0, te = l.interpolate || s_, oe = "__p += '", Se = Da(
          (l.escape || s_).source + "|" + te.source + "|" + (te === m ? Oo : s_).source + "|" + (l.evaluate || s_).source + "|$",
          "g"
        ), Ne = "//# sourceURL=" + (St.call(l, "sourceURL") ? (l.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++TA + "]") + `
`;
        T.replace(Se, function(Fe, it, st, Dn, rn, Ln) {
          return st || (st = Dn), oe += T.slice(re, Ln).replace(up, AA), it && (F = !0, oe += `' +
__e(` + it + `) +
'`), rn && (x = !0, oe += `';
` + rn + `;
__p += '`), st && (oe += `' +
((__t = (` + st + `)) == null ? '' : __t) +
'`), re = Ln + Fe.length, Fe;
        }), oe += `';
`;
        var We = St.call(l, "variable") && l.variable;
        if (!We)
          oe = `with (obj) {
` + oe + `
}
`;
        else if (vs.test(We))
          throw new Ye(h);
        oe = (x ? oe.replace(y_, "") : oe).replace(ea, "$1").replace(ai, "$1;"), oe = "function(" + (We || "obj") + `) {
` + (We ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (F ? ", __e = _.escape" : "") + (x ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + oe + `return __p
}`;
        var ze = Bc(function() {
          return ut(O, Ne + "return " + oe).apply(r, v);
        });
        if (ze.source = oe, fc(ze))
          throw ze;
        return ze;
      }
      function GS(T) {
        return At(T).toLowerCase();
      }
      function yi(T) {
        return At(T).toUpperCase();
      }
      function LE(T, l, u) {
        if (T = At(T), T && (u || l === r))
          return UT(T);
        if (!T || !(l = Mr(l)))
          return T;
        var S = bn(T), P = bn(l), O = da(S, P), v = Sa(S, P) + 1;
        return Zr(S, O, v).join("");
      }
      function $d(T, l, u) {
        if (T = At(T), T && (u || l === r))
          return T.slice(0, zs(T) + 1);
        if (!T || !(l = Mr(l)))
          return T;
        var S = bn(T), P = Sa(S, bn(l)) + 1;
        return Zr(S, 0, P).join("");
      }
      function Io(T, l, u) {
        if (T = At(T), T && (u || l === r))
          return T.replace(Ge, "");
        if (!T || !(l = Mr(l)))
          return T;
        var S = bn(T), P = da(S, bn(l));
        return Zr(S, P).join("");
      }
      function wc(T, l) {
        var u = No, S = i_;
        if (Vt(l)) {
          var P = "separator" in l ? l.separator : P;
          u = "length" in l ? Ke(l.length) : u, S = "omission" in l ? Mr(l.omission) : S;
        }
        T = At(T);
        var O = T.length;
        if (Fo(T)) {
          var v = bn(T);
          O = v.length;
        }
        if (u >= O)
          return T;
        var F = u - Xn(S);
        if (F < 1)
          return S;
        var x = v ? Zr(v, 0, F).join("") : T.slice(0, F);
        if (P === r)
          return x + S;
        if (v && (F += x.length - F), bc(P)) {
          if (T.slice(F).search(P)) {
            var re, te = x;
            for (P.global || (P = Da(P.source, At(kT.exec(P)) + "g")), P.lastIndex = 0; re = P.exec(te); )
              var oe = re.index;
            x = x.slice(0, oe === r ? F : oe);
          }
        } else if (T.indexOf(Mr(P), F) != F) {
          var Se = x.lastIndexOf(P);
          Se > -1 && (x = x.slice(0, Se));
        }
        return x + S;
      }
      function vr(T) {
        return T = At(T), T && $T.test(T) ? T.replace(v_, Up) : T;
      }
      var Wd = dn(function(T, l, u) {
        return T + (u ? " " : "") + l.toUpperCase();
      }), Hl = $n("toUpperCase");
      function vi(T, l, u) {
        return T = At(T), l = u ? r : l, l === r ? SA(T) ? GT(T) : Ks(T) : T.match(l) || [];
      }
      var Bc = qe(function(T, l) {
        try {
          return Kr(T, r, l);
        } catch (u) {
          return fc(u) ? u : new Ye(u);
        }
      }), xl = S_(function(T, l) {
        return sn(l, function(u) {
          u = hn(u), E_(T, u, h_(T[u], T));
        }), T;
      });
      function HS(T) {
        var l = T == null ? 0 : T.length, u = ye();
        return T = l ? $t(T, function(S) {
          if (typeof S[1] != "function")
            throw new ln(E);
          return [u(S[0]), S[1]];
        }) : [], qe(function(S) {
          for (var P = -1; ++P < l; ) {
            var O = T[P];
            if (Kr(O[0], this, S))
              return Kr(O[1], this, S);
          }
        });
      }
      function kd(T) {
        return Qi(un(T, Z));
      }
      function L_(T) {
        return function() {
          return T;
        };
      }
      function fs(T, l) {
        return T == null || T !== T ? l : T;
      }
      var Mo = lr(), MT = lr(!0);
      function gt(T) {
        return T;
      }
      function Yc(T) {
        return Ga(typeof T == "function" ? T : un(T, Z));
      }
      function xS(T) {
        return mu(un(T, Z));
      }
      function g_(T, l) {
        return Pu(T, un(l, Z));
      }
      var Ns = qe(function(T, l) {
        return function(u) {
          return QT(u, T, l);
        };
      }), Uc = qe(function(T, l) {
        return function(u) {
          return QT(T, u, l);
        };
      });
      function Vc(T, l, u) {
        var S = ir(l), P = zo(l, S);
        u == null && !(Vt(l) && (P.length || !S.length)) && (u = l, l = T, T = this, P = zo(l, ir(l)));
        var O = !(Vt(u) && "chain" in u) || !!u.chain, v = M_(T);
        return sn(P, function(F) {
          var x = l[F];
          T[F] = x, v && (T.prototype[F] = function() {
            var re = this.__chain__;
            if (O || re) {
              var te = T(this.__wrapped__), oe = te.__actions__ = fr(this.__actions__);
              return oe.push({ func: x, args: arguments, thisArg: T }), te.__chain__ = re, te;
            }
            return x.apply(T, Nn([this.value()], arguments));
          });
        }), T;
      }
      function gE() {
        return Lr._ === this && (Lr._ = mA), this;
      }
      function Gc() {
      }
      function Et(T) {
        return T = Ke(T), qe(function(l) {
          return hi(l, T);
        });
      }
      var Fd = za($t), mT = za(la), wd = za(Xs);
      function fE(T) {
        return Pl(T) ? ua(hn(T)) : se(T);
      }
      function Bd(T) {
        return function(l) {
          return T == null ? r : Si(T, l);
        };
      }
      var Yd = Za(), Ud = Za(!0);
      function Hc() {
        return [];
      }
      function xc() {
        return !1;
      }
      function Vd() {
        return {};
      }
      function Gd() {
        return "";
      }
      function z_() {
        return !0;
      }
      function Hd(T, l) {
        if (T = Ke(T), T < 1 || T > Ar)
          return [];
        var u = kr, S = mt(T, kr);
        l = ye(l), T -= kr;
        for (var P = Js(S, l); ++u < T; )
          l(u);
        return P;
      }
      function xd(T) {
        return $e(T) ? $t(T, hn) : en(T) ? [T] : fr(Wu(At(T)));
      }
      function Xd(T) {
        var l = ++MA;
        return At(T) + l;
      }
      var Kd = Il(function(T, l) {
        return T + l;
      }, 0), Xl = iT("ceil"), Jd = Il(function(T, l) {
        return T / l;
      }, 1), jd = iT("floor");
      function NE(T) {
        return T && T.length ? zT(T, gt, ZT) : r;
      }
      function XS(T, l) {
        return T && T.length ? zT(T, ye(l, 2), ZT) : r;
      }
      function bs(T) {
        return Wp(T, gt);
      }
      function zd(T, l) {
        return Wp(T, ye(l, 2));
      }
      function Zd(T) {
        return T && T.length ? zT(T, gt, El) : r;
      }
      function bE(T, l) {
        return T && T.length ? zT(T, ye(l, 2), El) : r;
      }
      var KS = Il(function(T, l) {
        return T * l;
      }, 1), Z_ = iT("round"), Q_ = Il(function(T, l) {
        return T - l;
      }, 0);
      function JS(T) {
        return T && T.length ? Hi(T, gt) : 0;
      }
      function jS(T, l) {
        return T && T.length ? Hi(T, ye(l, 2)) : 0;
      }
      return C.after = e_, C.ary = Zu, C.assign = pE, C.assignIn = he, C.assignInWith = Ao, C.assignWith = Md, C.at = wS, C.before = je, C.bind = h_, C.bindAll = xl, C.bindKey = Bt, C.castArray = Pc, C.chain = ET, C.chunk = TT, C.compact = jA, C.concat = zA, C.cond = HS, C.conforms = kd, C.constant = L_, C.countBy = Ot, C.create = w, C.curry = Mc, C.curryRight = mc, C.debounce = Qu, C.defaults = j_, C.defaultsDeep = ST, C.defer = qu, C.delay = ud, C.difference = ZA, C.differenceBy = ic, C.differenceWith = Fu, C.drop = QA, C.dropRight = Dl, C.dropRightWhile = sT, C.dropWhile = wu, C.fill = qA, C.filter = Ju, C.flatMap = WS, C.flatMapDeep = kS, C.flatMapDepth = uc, C.flatten = Ie, C.flattenDeep = lt, C.flattenDepth = Ts, C.flip = Ed, C.flow = Mo, C.flowRight = MT, C.fromPairs = Tc, C.functions = uE, C.functionsIn = So, C.groupBy = Xe, C.initial = td, C.intersection = lc, C.intersectionBy = Ll, C.intersectionWith = Bu, C.invert = Pd, C.invertBy = Fn, C.invokeMap = AT, C.iteratee = Yc, C.keyBy = FS, C.keys = ir, C.keysIn = Ur, C.map = Ac, C.mapKeys = Dd, C.mapValues = Ld, C.matches = xS, C.matchesProperty = g_, C.memoize = br, C.merge = gd, C.mergeWith = AE, C.method = Ns, C.methodOf = Uc, C.mixin = Vc, C.negate = K_, C.nthArg = Et, C.omit = Yl, C.omitBy = dE, C.once = Oi, C.orderBy = dc, C.over = Fd, C.overArgs = eE, C.overEvery = mT, C.overSome = wd, C.partial = t_, C.partialRight = tE, C.partition = zu, C.pick = Ul, C.pickBy = vc, C.property = fE, C.propertyOf = Bd, C.pull = lT, C.pullAll = aT, C.pullAllBy = ss, C.pullAllWith = at, C.pullAt = ls, C.range = Yd, C.rangeRight = Ud, C.rearg = Wn, C.reject = pd, C.remove = cT, C.rest = As, C.reverse = gl, C.sampleSize = qn, C.set = fd, C.setWith = $c, C.shuffle = Ci, C.slice = ao, C.sortBy = Es, C.sortedUniq = Nl, C.sortedUniqBy = as, C.split = yd, C.spread = yl, C.tail = _d, C.take = id, C.takeRight = uT, C.takeRightWhile = Vu, C.takeWhile = Gu, C.tap = us, C.throttle = vl, C.thru = Mn, C.toArray = Oc, C.toPairs = SE, C.toPairsIn = hE, C.toPath = xd, C.toPlainObject = yc, C.transform = Nd, C.unary = $l, C.union = Qn, C.unionBy = bl, C.unionWith = Hu, C.uniq = xu, C.uniqBy = od, C.uniqWith = Td, C.unset = BS, C.unzip = cs, C.unzipWith = rr, C.update = YS, C.updateWith = US, C.values = ho, C.valuesIn = bd, C.without = Pr, C.words = vi, C.wrap = rE, C.xor = Xu, C.xorBy = Ku, C.xorWith = sd, C.zip = Yr, C.zipObject = Cl, C.zipObjectDeep = ps, C.zipWith = pc, C.entries = SE, C.entriesIn = hE, C.extend = he, C.extendWith = Ao, Vc(C, C), C.add = Kd, C.attempt = Bc, C.camelCase = dt, C.capitalize = IE, C.ceil = Xl, C.clamp = Wc, C.clone = Dc, C.cloneDeep = ds, C.cloneDeepWith = nE, C.cloneWith = Lc, C.conformsTo = Ri, C.deburr = r_, C.defaultTo = fs, C.divide = Jd, C.endsWith = tn, C.eq = Lt, C.escape = Od, C.escapeRegExp = kc, C.every = Rl, C.find = ju, C.findIndex = lo, C.findKey = kl, C.findLast = X_, C.findLastIndex = oc, C.findLastKey = md, C.floor = jd, C.forEach = Xt, C.forEachRight = Ec, C.forIn = hT, C.forInRight = Fl, C.forOwn = Ps, C.forOwnRight = wl, C.get = Ds, C.gt = _E, C.gte = Ad, C.has = Ls, C.hasIn = Bl, C.head = sc, C.identity = gt, C.includes = ad, C.indexOf = ed, C.inRange = Cd, C.invoke = EE, C.isArguments = po, C.isArray = $e, C.isArrayBuffer = dd, C.isArrayLike = _r, C.isArrayLikeObject = Kt, C.isBoolean = Wl, C.isBuffer = I_, C.isDate = Sd, C.isElement = gc, C.isEmpty = J_, C.isEqual = ct, C.isEqualWith = hd, C.isError = fc, C.isFinite = dT, C.isFunction = M_, C.isInteger = Nc, C.isLength = ne, C.isMap = Ss, C.isMatch = Id, C.isMatchWith = iE, C.isNaN = qr, C.isNative = oE, C.isNil = kn, C.isNull = m_, C.isNumber = hs, C.isObject = Vt, C.isObjectLike = Gt, C.isPlainObject = Is, C.isRegExp = bc, C.isSafeInteger = Ms, C.isSet = Cc, C.isString = ms, C.isSymbol = en, C.isTypedArray = uo, C.isUndefined = TE, C.isWeakMap = sE, C.isWeakSet = Eo, C.join = rd, C.kebabCase = Qe, C.last = In, C.lastIndexOf = ac, C.lowerCase = Fc, C.lowerFirst = IT, C.lt = lE, C.lte = aE, C.max = NE, C.maxBy = XS, C.mean = bs, C.meanBy = zd, C.min = Zd, C.minBy = bE, C.stubArray = Hc, C.stubFalse = xc, C.stubObject = Vd, C.stubString = Gd, C.stubTrue = z_, C.multiply = KS, C.nth = Yu, C.noConflict = gE, C.noop = Gc, C.now = Ic, C.pad = wn, C.padEnd = Rd, C.padStart = ME, C.parseInt = mE, C.random = Vl, C.reduce = cd, C.reduceRight = Ue, C.repeat = Gl, C.replace = D_, C.result = gs, C.round = Z_, C.runInContext = G, C.sample = co, C.size = Sc, C.snakeCase = PE, C.some = hc, C.sortedIndex = nd, C.sortedIndexBy = Uu, C.sortedIndexOf = tr, C.sortedLastIndex = fl, C.sortedLastIndexBy = pT, C.sortedLastIndexOf = cc, C.startCase = DE, C.startsWith = vd, C.subtract = Q_, C.sum = JS, C.sumBy = jS, C.template = VS, C.times = Hd, C.toFinite = P_, C.toInteger = Ke, C.toLength = Rc, C.toLower = GS, C.toNumber = Pn, C.toSafeInteger = cE, C.toString = At, C.toUpper = yi, C.trim = LE, C.trimEnd = $d, C.trimStart = Io, C.truncate = wc, C.unescape = vr, C.uniqueId = Xd, C.upperCase = Wd, C.upperFirst = Hl, C.each = Xt, C.eachRight = Ec, C.first = sc, Vc(C, function() {
        var T = {};
        return jn(C, function(l, u) {
          St.call(C.prototype, u) || (T[u] = l);
        }), T;
      }(), { chain: !1 }), C.VERSION = i, sn(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(T) {
        C[T].placeholder = C;
      }), sn(["drop", "take"], function(T, l) {
        nt.prototype[T] = function(u) {
          u = u === r ? 1 : Ee(Ke(u), 0);
          var S = this.__filtered__ && !l ? new nt(this) : this.clone();
          return S.__filtered__ ? S.__takeCount__ = mt(u, S.__takeCount__) : S.__views__.push({
            size: mt(u, kr),
            type: T + (S.__dir__ < 0 ? "Right" : "")
          }), S;
        }, nt.prototype[T + "Right"] = function(u) {
          return this.reverse()[T](u).reverse();
        };
      }), sn(["filter", "map", "takeWhile"], function(T, l) {
        var u = l + 1, S = u == Cr || u == vT;
        nt.prototype[T] = function(P) {
          var O = this.clone();
          return O.__iteratees__.push({
            iteratee: ye(P, 3),
            type: u
          }), O.__filtered__ = O.__filtered__ || S, O;
        };
      }), sn(["head", "last"], function(T, l) {
        var u = "take" + (l ? "Right" : "");
        nt.prototype[T] = function() {
          return this[u](1).value()[0];
        };
      }), sn(["initial", "tail"], function(T, l) {
        var u = "drop" + (l ? "" : "Right");
        nt.prototype[T] = function() {
          return this.__filtered__ ? new nt(this) : this[u](1);
        };
      }), nt.prototype.compact = function() {
        return this.filter(gt);
      }, nt.prototype.find = function(T) {
        return this.filter(T).head();
      }, nt.prototype.findLast = function(T) {
        return this.reverse().find(T);
      }, nt.prototype.invokeMap = qe(function(T, l) {
        return typeof T == "function" ? new nt(this) : this.map(function(u) {
          return QT(u, T, l);
        });
      }), nt.prototype.reject = function(T) {
        return this.filter(K_(ye(T)));
      }, nt.prototype.slice = function(T, l) {
        T = Ke(T);
        var u = this;
        return u.__filtered__ && (T > 0 || l < 0) ? new nt(u) : (T < 0 ? u = u.takeRight(-T) : T && (u = u.drop(T)), l !== r && (l = Ke(l), u = l < 0 ? u.dropRight(-l) : u.take(l - T)), u);
      }, nt.prototype.takeRightWhile = function(T) {
        return this.reverse().takeWhile(T).reverse();
      }, nt.prototype.toArray = function() {
        return this.take(kr);
      }, jn(nt.prototype, function(T, l) {
        var u = /^(?:filter|find|map|reject)|While$/.test(l), S = /^(?:head|last)$/.test(l), P = C[S ? "take" + (l == "last" ? "Right" : "") : l], O = S || /^find/.test(l);
        P && (C.prototype[l] = function() {
          var v = this.__wrapped__, F = S ? [1] : arguments, x = v instanceof nt, re = F[0], te = x || $e(v), oe = function(it) {
            var st = P.apply(C, Nn([it], F));
            return S && Se ? st[0] : st;
          };
          te && u && typeof re == "function" && re.length != 1 && (x = te = !1);
          var Se = this.__chain__, Ne = !!this.__actions__.length, We = O && !Se, ze = x && !Ne;
          if (!O && te) {
            v = ze ? v : new nt(this);
            var Fe = T.apply(v, F);
            return Fe.__actions__.push({ func: Mn, args: [oe], thisArg: r }), new pn(Fe, Se);
          }
          return We && ze ? T.apply(this, F) : (Fe = this.thru(oe), We ? S ? Fe.value()[0] : Fe.value() : Fe);
        });
      }), sn(["pop", "push", "shift", "sort", "splice", "unshift"], function(T) {
        var l = Br[T], u = /^(?:push|sort|unshift)$/.test(T) ? "tap" : "thru", S = /^(?:pop|shift)$/.test(T);
        C.prototype[T] = function() {
          var P = arguments;
          if (S && !this.__chain__) {
            var O = this.value();
            return l.apply($e(O) ? O : [], P);
          }
          return this[u](function(v) {
            return l.apply($e(v) ? v : [], P);
          });
        };
      }), jn(nt.prototype, function(T, l) {
        var u = C[l];
        if (u) {
          var S = u.name + "";
          St.call(Ki, S) || (Ki[S] = []), Ki[S].push({ name: l, func: u });
        }
      }), Ki[ht(r, Le).name] = [{
        name: "wrapper",
        func: r
      }], nt.prototype.clone = Jp, nt.prototype.reverse = jp, nt.prototype.value = nl, C.prototype.at = x_, C.prototype.chain = _t, C.prototype.commit = nr, C.prototype.next = ld, C.prototype.plant = vS, C.prototype.reverse = $S, C.prototype.toJSON = C.prototype.valueOf = C.prototype.value = mn, C.prototype.first = C.prototype.head, xi && (C.prototype[xi] = Ol), C;
    }, Bo = wo();
    pi ? ((pi.exports = Bo)._ = Bo, Gi._ = Bo) : Lr._ = Bo;
  }).call(nn);
})(sS, sS.exports);
var vh = sS.exports;
const XM = {
  common_blocks: {
    colourPrimary: "#B38E20",
    colourTertiary: "#503D04"
  },
  event_blocks: {
    colourPrimary: "#984848",
    colourTertiary: "#542929"
  },
  action_blocks: {
    colourPrimary: "#79803B",
    colourTertiary: "#444917"
  },
  logic_blocks: {
    colourPrimary: "#205C48",
    colourTertiary: "#1D3D32"
  },
  condition_blocks: {
    colourPrimary: "#205C48",
    colourTertiary: "#1D3D32"
  },
  module_blocks: {
    colourPrimary: "#326884",
    colourTertiary: "#284C5E"
  },
  data_blocks: {
    colourPrimary: "#984877",
    colourTertiary: "#612046"
  },
  var_blocks: {
    colourPrimary: "#3B5383",
    colourTertiary: "#2A3957"
  },
  function_blocks: {
    colourPrimary: "#544280",
    colourTertiary: "#392D57"
  },
  enum_blocks: {
    colourPrimary: "#4F4F5B",
    colourTertiary: "#363636"
  },
  external_blocks: {
    colourPrimary: "#5148A1",
    colourTertiary: "#342E66"
  },
  shadow_blocks: {
    colourPrimary: "#3A3A3A",
    colourTertiary: "#333333"
  },
  comment_blocks: {
    colourPrimary: "#43414D",
    colourTertiary: "#363A41"
  },
  deprecated_blocks: {
    colourPrimary: "#48484D ",
    colourTertiary: "#363A41"
  },
  input_blocks: {
    colourPrimary: "#984877",
    colourTertiary: "#612046"
  },
  game_blocks: {
    colourPrimary: "#326884",
    colourTertiary: "#284C5E"
  },
  entity_blocks: {
    colourPrimary: "#79803B",
    colourTertiary: "#444917"
  }
}, KM = {}, JM = {
  workspaceBackgroundColour: "#14161B",
  toolboxBackgroundColour: "#C4C4C4",
  flyoutBackgroundColour: "#191B20",
  flyoutOpacity: 1,
  scrollbarColour: "#4D5158",
  scrollbarOpacity: 1
}, jM = {
  family: "Din, JhengHei",
  size: 12
}, cI = {
  blockStyles: XM,
  categoryStyles: KM,
  componentStyles: JM,
  fontStyle: jM,
  name: "customTheme"
}, $h = vh.cloneDeep(cI);
$h.blockStyles.input_blocks.colourPrimary = "#585555";
$h.blockStyles.input_blocks.colourTertiary = "#747474";
X.Theme.defineTheme("customTheme", cI);
X.Theme.defineTheme("craftlandTheme", $h);
const zM = `
  data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZ
  XdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMu
  b3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNiIgY3k9IjYiIHI9IjUuNSIgc3Ryb2t
  lPSIjQkFCRUM1Ii8+CjxjaXJjbGUgY3g9IjYiIGN5PSI2IiByPSIyIiBmaWxsPSIjQk
  FCRUM1Ii8+Cjwvc3ZnPgo=
`;
class ZM extends X.blockRendering.ConstantProvider {
  constructor() {
    super();
    N(this, "IsCraftland");
    N(this, "DARK_PATH_OFFSET");
    N(this, "MAX_BOTTOM_WIDTH");
    N(this, "SPACER_WIDTH");
    N(this, "BREAKPOINT_RADUIS");
    N(this, "FIELD_RESOURCE_SELECTOR_SVG_SIZE");
    N(this, "FIELD_RESOURCE_SELECTOR_SVG_DATAURI");
    N(this, "EMPTY_INPUT_WIDTH");
    this.FIELD_TEXT_BASELINE_CENTER = !1, this.DARK_PATH_OFFSET = 1, this.MAX_BOTTOM_WIDTH = 30, this.STATEMENT_BOTTOM_SPACER = -this.NOTCH_HEIGHT, this.NOTCH_WIDTH = 28, this.NOTCH_HEIGHT = 4, this.NOTCH_OFFSET_LEFT = 13, this.TAB_WIDTH = 4, this.TAB_HEIGHT = 8, this.EMPTY_INLINE_INPUT_HEIGHT = this.TAB_HEIGHT + 14, this.TAB_OFFSET_FROM_TOP = 4, this.MEDIUM_PADDING = 6, this.LARGE_PADDING = 8, this.TOP_ROW_PRECEDES_STATEMENT_MIN_HEIGHT = this.LARGE_PADDING, this.BOTTOM_ROW_AFTER_STATEMENT_MIN_HEIGHT = this.LARGE_PADDING, this.FIELD_BORDER_RECT_X_PADDING = 8, this.FIELD_BORDER_RECT_Y_PADDING = 2, this.FIELD_BORDER_RECT_HEIGHT = 24, this.FIELD_IN_SHADOW_BORDER_RECT_HEIGHT = 20, this.FIELD_DROPDOWN_BORDER_RECT_HEIGHT = 24, this.FIELD_BORDER_RECT_RADIUS = 0, this.TOP_ROW_MIN_HEIGHT = 2, this.BOTTOM_ROW_MIN_HEIGHT = 2, this.DUMMY_INPUT_SHADOW_MIN_HEIGHT = 20, this.DUMMY_INPUT_MIN_HEIGHT = 20, this.MIN_BLOCK_HEIGHT = 24, this.FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW = !0, this.FIELD_BORDER_RECT_COLOUR = "#3E3E48", this.FIELD_DROPDOWN_SVG_ARROW = !0, this.SPACER_WIDTH = 10, this.FIELD_COLOUR_DEFAULT_HEIGHT = 20, this.FIELD_DROPDOWN_SVG_ARROW_DATAURI = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6"><defs><style>.cls-1{fill: %23c3c3c3;fill-rule: evenodd;}</style></defs><path id="icon_ecaarrow" class="cls-1" d="M788,413h-2l-3,3-3-3h-2l5,5Z" transform="translate(-778 -412.5)"/></svg>', this.FIELD_DROPDOWN_SVG_ARROW_SIZE = 9, this.CORNER_RADIUS = 0, this.BREAKPOINT_RADUIS = 3, this.FULL_BLOCK_FIELDS = !1, this.FIELD_RESOURCE_SELECTOR_SVG_SIZE = 12, this.FIELD_RESOURCE_SELECTOR_SVG_DATAURI = zM;
  }
  init() {
    super.init(), this.EMPTY_INPUT_WIDTH = this.IsCraftland ? 60 : 0, this.IsCraftland && (this.FIELD_DROPDOWN_SVG_ARROW_DATAURI = 'data:image/svg+xml;utf8,      <svg width="24" height="24" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">        <path d="M4 20L24 40L44 20" stroke="white" stroke-width="8" fill="none" stroke-linecap="round" stroke-linejoin="round"/>      </svg>', this.FIELD_DROPDOWN_SVG_ARROW_SIZE = 12);
  }
  shapeFor(r) {
    switch (r.type) {
      case X.ConnectionType.INPUT_VALUE:
      case X.ConnectionType.OUTPUT_VALUE:
        return this.PUZZLE_TAB;
      case X.ConnectionType.PREVIOUS_STATEMENT:
      case X.ConnectionType.NEXT_STATEMENT:
        return this.NOTCH;
      default:
        throw Error("Unknown connection type");
    }
  }
  makeNotch() {
    const r = this.NOTCH_WIDTH, i = this.NOTCH_HEIGHT, a = 10, p = 4;
    function E(y) {
      return X.utils.svgPaths.line([
        X.utils.svgPaths.point(y * p, i),
        X.utils.svgPaths.point(y * a * 2, 0),
        X.utils.svgPaths.point(y * p, -i)
      ]);
    }
    const h = E(1), L = E(-1);
    return {
      type: this.SHAPES.NOTCH,
      width: r,
      height: i,
      pathLeft: h,
      pathRight: L
    };
  }
  makePuzzleTab() {
    const r = this.TAB_WIDTH, i = this.TAB_HEIGHT / 2;
    function a(h) {
      return h ? X.utils.svgPaths.lineTo(-r, -i) + X.utils.svgPaths.lineTo(r, -i) : X.utils.svgPaths.lineTo(-r, i) + X.utils.svgPaths.lineTo(r, i);
    }
    const p = a(!0), E = a(!1);
    return {
      type: this.SHAPES.PUZZLE,
      width: r,
      height: i,
      pathDown: E,
      pathUp: p
    };
  }
  setFontConstants_(r) {
    r.fontStyle && r.fontStyle.family && (this.FIELD_TEXT_FONTFAMILY = r.fontStyle.family), r.fontStyle && r.fontStyle.weight && (this.FIELD_TEXT_FONTWEIGHT = r.fontStyle.weight), r.fontStyle && r.fontStyle.size && (this.FIELD_TEXT_FONTSIZE = r.fontStyle.size);
    const i = QM(
      "Hg",
      this.FIELD_TEXT_FONTSIZE + "px",
      this.FIELD_TEXT_FONTWEIGHT,
      this.FIELD_TEXT_FONTFAMILY
    );
    this.FIELD_TEXT_HEIGHT = i.height, this.FIELD_TEXT_BASELINE = i.baseline;
  }
  getCSS_(r) {
    const i = this.IsCraftland ? "black" : "none";
    return super.getCSS_(r).concat([
      /* eslint-disable indent */
      // Insertion marker.
      r + " .blocklyInsertionMarker>.blocklyPathDark {",
      "fill-opacity: " + this.INSERTION_MARKER_OPACITY + ";",
      "stroke: none;",
      "}",
      r + " .blocklyText, ",
      r + " .blocklyFlyoutLabelText {",
      "font: " + this.FIELD_TEXT_FONTWEIGHT + " " + this.FIELD_TEXT_FONTSIZE + "px " + this.FIELD_TEXT_FONTFAMILY + ";",
      "}",
      r + " .blocklyFlyoutLabelText {",
      "fill: #797979;",
      "}",
      r + " .blocklyInvalidInput,",
      r + " .blocklyHtmlInput {",
      "font-family: " + this.FIELD_TEXT_FONTFAMILY + ";",
      "font-weight: " + this.FIELD_TEXT_FONTWEIGHT + ";",
      "text-align: center;",
      "color: #D9D9D9;",
      "}",
      r + " .blocklyEditableText>rect {",
      "fill: " + this.FIELD_BORDER_RECT_COLOUR + ";",
      "fill-opacity: 1;",
      `stroke: ${i};`,
      "}",
      r + " .blocklyNonEditableText>rect {",
      ...this.IsCraftland ? [
        "display: none;"
      ] : [
        "fill: " + this.FIELD_BORDER_RECT_COLOUR + ";",
        "fill-opacity: 1;",
        "stroke: none;"
      ],
      "}",
      r + " .blocklyNonEditableText>text,",
      r + " .blocklyEditableText>text {",
      "fill: #D9D9D9;",
      "}",
      r + " .shadow-block text {",
      "fill: #8e8e8e;",
      "}",
      r + " .blocklyNonEditableText>text.blocklyDropdownText tspan,",
      r + " .blocklyEditableText>text.blocklyDropdownText tspan {",
      "fill: #C3C3C3 !important;",
      "}",
      r + " .blocklySelected>.blocklyPath,",
      r + " .blocklyPathLight {",
      "stroke-width: 2px;",
      "display: inline;",
      "}",
      // Editable field hover.
      r + " .blocklyEditableText:not(.editing):hover>rect {",
      "stroke: #fff;",
      "stroke-width: 1;",
      "}"
      /* eslint-enable indent */
    ]);
  }
}
let oh = /* @__PURE__ */ new Map();
function QM(_, s, r, i) {
  let a = _ + s + r + i;
  if (oh.has(a))
    return oh.get(a);
  let p = X.utils.dom.measureFontMetrics(
    _,
    s,
    r,
    i
  );
  return oh.set(a, p), p;
}
const { svgPaths: Dr } = X.utils, { Types: Jc, Connection: u4 } = X.blockRendering;
class qM extends X.blockRendering.Drawer {
  constructor(r, i) {
    super(r, i);
    N(this, "cuteSquare_");
    N(this, "beakpoint_");
    this.cuteSquare_ = !this.block_.isShadow() && !this.block_.isInsertionMarker() && i.outputConnection ? new a0(i) : null;
  }
  draw() {
    this.drawOutline_(), this.drawInternals_();
    const r = this.block_.pathObject;
    r.setPath(this.outlinePath_ + `
` + this.inlinePath_, this.outlinePath_), r.setBreakpoint(), this.cuteSquare_ && r.setSquarePath(this.cuteSquare_.getPath()), this.info_.RTL && r.flipRTL(), this.recordSizeOnBlock_();
  }
  drawTop_() {
    const r = this.info_.topRow, i = r.elements;
    this.positionPreviousConnection_(), this.outlinePath_ += Dr.moveBy(r.xPos, this.info_.startY);
    for (let a = 0, p; p = i[a]; a++)
      Jc.isPreviousConnection(p) && p instanceof u4 ? this.outlinePath_ += p.shape.pathLeft : Jc.isHat(p) ? this.outlinePath_ += this.constants_.START_HAT.path : Jc.isSpacer(p) && (this.outlinePath_ += Dr.lineOnAxis("h", p.width));
    this.outlinePath_ += Dr.lineOnAxis("v", r.height);
  }
  drawJaggedEdge_(r) {
    super.drawJaggedEdge_(r);
  }
  drawValueInput_(r) {
    const i = (
      /** @type {ExternalValueInput|InlineInput} */
      r.getLastInput()
    );
    this.positionExternalValueConnection_(r);
    const a = typeof i.shape.pathDown == "function" ? i.shape.pathDown(i.height) : i.shape.pathDown, p = (r.height - this.constants_.TAB_HEIGHT) / 2;
    this.outlinePath_ += Dr.lineOnAxis("H", i.xPos + i.width) + Dr.lineOnAxis("v", p) + a + Dr.lineOnAxis("v", p);
  }
  drawStatementInput_(r) {
    const i = r.getLastInput(), a = i.xPos + i.notchOffset + i.shape.width, p = i.shape.pathRight + Dr.lineOnAxis(
      "h",
      -i.notchOffset
    );
    this.outlinePath_ += Dr.lineOnAxis("H", a) + p + Dr.lineOnAxis("v", r.height + this.constants_.DARK_PATH_OFFSET) + Dr.lineOnAxis("H", r.xPos + r.width), this.positionStatementInputConnection_(r);
  }
  drawRightSideRow_(r) {
    this.outlinePath_ += Dr.lineOnAxis("H", r.xPos + r.width) + Dr.lineOnAxis("V", r.yPos + r.height);
  }
  drawBottom_() {
    const r = this.info_.bottomRow, i = r.elements;
    this.positionNextConnection_();
    let a = 0, p = "";
    for (let E = i.length - 1, h; h = i[E]; E--)
      Jc.isNextConnection(h) && h instanceof u4 ? p += h.shape.pathRight : Jc.isLeftSquareCorner(h) ? p += Dr.lineOnAxis("H", r.xPos) : Jc.isSpacer(h) && (p += Dr.lineOnAxis("h", h.width * -1));
    this.outlinePath_ += Dr.lineOnAxis("V", r.baseline - a), this.outlinePath_ += p;
  }
  drawLeft_() {
    var i;
    const r = this.info_.outputConnection;
    if (this.positionOutputConnection_(), r) {
      const p = this.info_.bottomRow.baseline / 2 - this.constants_.TAB_HEIGHT / 2, E = typeof r.shape.pathUp == "function" ? r.shape.pathUp(r.height) : r.shape.pathUp;
      (i = this.cuteSquare_) == null || i.drawer(this.info_.startX - 1, this.info_.height - p), this.outlinePath_ += Dr.lineOnAxis("v", -p) + E + X.utils.svgPaths.lineOnAxis("V", 0);
    }
    this.outlinePath_ += "z";
  }
  positionOutputConnection_() {
    if (this.info_.outputConnection) {
      const r = this.info_.startX + this.info_.outputConnection.connectionOffsetX, i = this.info_.RTL ? -r : r, p = this.info_.bottomRow.baseline / 2 - this.constants_.TAB_HEIGHT / 2;
      this.block_.outputConnection.setOffsetInBlock(i, p + 1);
    }
  }
  drawInlineInput_(r) {
    const i = r.width, a = r.height, p = r.centerline - a / 2, E = (r.height - this.constants_.TAB_HEIGHT) / 2, h = E, L = r.xPos + r.connectionWidth;
    this.inlinePath_ += Dr.moveTo(L, p) + Dr.lineOnAxis("v", E) + r.shape.pathDown + Dr.lineOnAxis("v", h) + Dr.lineOnAxis("h", i - r.connectionWidth) + Dr.lineOnAxis("v", -a) + "z", this.positionInlineInputConnection_(r);
  }
  positionInlineInputConnection_(r) {
    const i = r.centerline - r.height / 2, a = (r.height - this.constants_.TAB_HEIGHT) / 2;
    if (r.connectionModel) {
      let p = r.xPos + r.connectionWidth + this.constants_.DARK_PATH_OFFSET;
      this.info_.RTL && (p *= -1), r.connectionModel.setOffsetInBlock(
        p,
        i + a + this.constants_.DARK_PATH_OFFSET
      );
    }
  }
  positionStatementInputConnection_(r) {
    const i = r.getLastInput();
    if (i.connectionModel) {
      let a = r.xPos + r.statementEdge + i.notchOffset;
      this.info_.RTL ? a *= -1 : a += this.constants_.DARK_PATH_OFFSET / 2, i.connectionModel.setOffsetInBlock(
        a,
        r.yPos + this.constants_.DARK_PATH_OFFSET
      );
    }
  }
  positionExternalValueConnection_(r) {
    const i = r.getLastInput(), a = (r.height - this.constants_.TAB_HEIGHT) / 2;
    if (i.connectionModel) {
      let p = r.xPos + r.width + this.constants_.DARK_PATH_OFFSET;
      this.info_.RTL && (p *= -1), i.connectionModel.setOffsetInBlock(p, r.yPos + a);
    }
  }
  positionNextConnection_() {
    const r = this.info_.bottomRow;
    if (r.connection) {
      const i = r.connection, a = i.xPos, p = (this.info_.RTL ? -a : a) + this.constants_.DARK_PATH_OFFSET / 2;
      i.connectionModel.setOffsetInBlock(
        p,
        r.baseline + this.constants_.DARK_PATH_OFFSET
      );
    }
  }
}
class e0 extends X.blockRendering.InlineInput {
  constructor(s, r) {
    super(s, r), this.connectedBlock && (this.width += this.constants_.DARK_PATH_OFFSET, this.height += this.constants_.DARK_PATH_OFFSET);
  }
}
const { colour: E4, dom: CE, Svg: qd } = X.utils, { PathObject: t0 } = X.blockRendering;
class r0 extends t0 {
  constructor(r, i, a) {
    super(r, i, a);
    N(this, "svgPathDark");
    N(this, "svgPathLight");
    N(this, "svgPathSquare");
    N(this, "svgPathPoint");
    N(this, "colourDark");
    N(this, "colourWhite");
    this.constants = a, this.svgPathDark = CE.createSvgElement(
      qd.PATH,
      { class: "blocklyPathDark", transform: "translate(1,1)" }
    ), this.svgRoot.insertBefore(this.svgPathDark, this.svgPath), this.svgPathLight = CE.createSvgElement(
      qd.PATH,
      { class: "blocklyPathLight" },
      this.svgRoot
    ), this.svgPathSquare = CE.createSvgElement(
      qd.PATH,
      { class: "blocklyPathSquare" },
      this.svgRoot
    ), this.svgPathPoint = CE.createSvgElement(
      qd.CIRCLE,
      { class: "beakpointPath", cx: 6, cy: 6, r: 0 },
      this.svgRoot
    ), this.colourDark = "#000000", this.colourWhite = "#ffffff";
  }
  setPath(r, i) {
    this.svgPath.setAttribute("d", r), this.svgPathDark.setAttribute("d", i), this.svgPathLight.setAttribute("d", r);
  }
  setSquarePath(r) {
    this.svgPathSquare.setAttribute("d", r);
  }
  setBreakpoint() {
    this.svgPathPoint.setAttribute("r", this.constants.BREAKPOINT_RADUIS);
  }
  flipRTL() {
    this.svgPath.setAttribute("transform", "scale(-1 1)"), this.svgPathLight.setAttribute("transform", "scale(-1 1)"), this.svgPathDark.setAttribute("transform", "translate(1,1) scale(-1 1)"), this.svgPathSquare.setAttribute("transform", "translate(1,1) scale(-1 1)");
  }
  applyColour(r) {
    this.svgPathLight.style.display = "", this.svgPathDark.style.display = "", this.svgPathDark.setAttribute("fill", this.colourDark), this.svgPathSquare.setAttribute("fill", "#FFC736"), this.applyBreakpointColor(r), super.applyColour(r);
  }
  applyBreakpointColor(r) {
    this.svgPathPoint.setAttribute("fill", "none"), this.svgPathPoint.setAttribute("stroke", "none");
  }
  setStyle(r) {
    this.style = r, this.colourDark = E4.blend("#000", this.style.colourPrimary, 0.2) || this.colourDark, this.colourWhite = E4.blend("#fff", this.style.colourPrimary, 0.3) || this.colourWhite;
  }
  updateHighlighted(r) {
    r ? (this.svgPathLight.setAttribute(
      "stroke",
      "#ffffff"
    ), this.svgPath.style.display = "none") : (this.svgPathLight.setAttribute("stroke", "none"), this.svgPath.style.display = "inline");
  }
  updateBreakpointStyle(r) {
    this.svgPath.style.display = r ? "inline" : "none";
  }
  updateShadow_(r) {
    r && (this.svgPathDark.setAttribute("fill", "none"), this.svgPath.setAttribute("stroke", "none"), this.svgPath.setAttribute("fill", "none"));
  }
  updateDisabled_(r) {
    super.updateDisabled_(r), r && (this.svgPathLight.setAttribute("stroke", "none"), this.svgPath.setAttribute("stroke", "none"));
  }
  updateSelected(r) {
    this.setClass_("blocklySelected", r), CE.hasClass(this.svgRoot, "blocklyDisabled") || this.svgPath.setAttribute(
      "fill",
      r ? this.colourWhite : this.style.colourPrimary
    );
  }
}
const {
  BottomRow: nb,
  ExternalValueInput: n0,
  Field: _0,
  InRowSpacer: Th,
  RenderInfo: i0,
  TopRow: _b,
  Types: Ve
} = X.blockRendering;
class o0 extends i0 {
  constructor(s, r) {
    super(s, r);
  }
  getRenderer() {
    return this.renderer_;
  }
  createRows_() {
    this.populateTopRow_(), this.rows.push(this.topRow);
    let s = new X.blockRendering.InputRow(this.constants_);
    this.inputRows.push(s);
    const r = this.block_.getIcons();
    for (let a = 0, p; p = r[a]; a++) {
      const E = new X.blockRendering.Icon(this.constants_, p);
      (!this.isCollapsed || p.isShownWhenCollapsed()) && s.elements.push(E);
    }
    let i = null;
    for (let a = 0, p; p = this.block_.inputList[a]; a++)
      if (p.isVisible()) {
        this.shouldStartNewRow_(p, i) && (this.rows.push(s), s = new X.blockRendering.InputRow(this.constants_), this.inputRows.push(s));
        for (let E = 0, h; h = p.fieldRow[E]; E++) {
          let L = new _0(this.constants_, h, p), y = h.minWidth;
          L.width < y && (L.width = y), s.elements.push(L);
        }
        this.addInput_(p, s), i = p;
      }
    this.isCollapsed && (s.hasJaggedEdge = !0, s.elements.push(new X.blockRendering.JaggedEdge(this.constants_))), (s.elements.length || s.hasDummyInput) && this.rows.push(s), this.populateBottomRow_(), this.rows.push(this.bottomRow);
  }
  populateTopRow_() {
    const s = !!this.block_.previousConnection, r = (this.block_.hat ? this.block_.hat === "cap" : this.constants_.ADD_START_HATS) && !this.outputConnection && !s;
    let i = X.blockRendering.SquareCorner;
    if (this.topRow.elements.push(new i(this.constants_)), r) {
      const p = new X.blockRendering.Hat(this.constants_);
      this.topRow.elements.push(p), this.topRow.capline = p.ascenderHeight;
    } else
      s && (this.topRow.hasPreviousConnection = !0, this.topRow.connection = new X.blockRendering.PreviousConnection(
        this.constants_,
        this.block_.previousConnection
      ), this.topRow.elements.push(this.topRow.connection));
    this.block_.inputList.length && this.block_.inputList[0].type === X.inputTypes.STATEMENT && !this.block_.isCollapsed() ? this.topRow.minHeight = this.constants_.TOP_ROW_PRECEDES_STATEMENT_MIN_HEIGHT : s ? this.topRow.minHeight = this.constants_.NOTCH_HEIGHT + this.constants_.FIELD_BORDER_RECT_Y_PADDING : this.topRow.minHeight = this.constants_.TOP_ROW_MIN_HEIGHT, this.topRow.elements.push(new i(this.constants_, "right"));
  }
  populateBottomRow_() {
    this.bottomRow.hasNextConnection = !!this.block_.nextConnection, this.block_.inputList.length && this.block_.inputList[this.block_.inputList.length - 1].type === X.inputTypes.STATEMENT ? this.bottomRow.minHeight = this.constants_.BOTTOM_ROW_AFTER_STATEMENT_MIN_HEIGHT : this.bottomRow.hasNextConnection && this.block_.inputList.find((r) => r.type !== X.inputTypes.DUMMY) ? this.bottomRow.minHeight = this.constants_.NOTCH_HEIGHT + this.constants_.FIELD_BORDER_RECT_Y_PADDING : this.bottomRow.minHeight = this.constants_.BOTTOM_ROW_MIN_HEIGHT, this.bottomRow.elements.push(new X.blockRendering.SquareCorner(this.constants_)), this.bottomRow.hasNextConnection && (this.bottomRow.connection = new X.blockRendering.NextConnection(
      this.constants_,
      this.block_.nextConnection
    ), this.bottomRow.elements.push(this.bottomRow.connection)), this.bottomRow.elements.push(new X.blockRendering.SquareCorner(this.constants_, "right"));
  }
  addInput_(s, r) {
    if (this.isInline && s.type === X.inputTypes.VALUE) {
      let i = new e0(this.constants_, s);
      i.connectedBlock || i.width < this.constants_.EMPTY_INPUT_WIDTH && (i.width = this.constants_.EMPTY_INPUT_WIDTH), r.elements.push(i), r.hasInlineInput = !0;
    } else
      s.type === X.inputTypes.STATEMENT ? (r.elements.push(new s0(this.constants_, s)), r.hasStatement = !0) : s.type === X.inputTypes.VALUE ? (r.elements.push(new n0(this.constants_, s)), r.hasExternalInput = !0) : s.type === X.inputTypes.DUMMY && (r.minHeight = Math.max(r.minHeight, this.constants_.DUMMY_INPUT_MIN_HEIGHT), r.hasDummyInput = !0);
    !this.isInline && r.align === null && (r.align = X.ALIGN_LEFT);
  }
  addElemSpacing_() {
    let s = !1;
    for (let r = 0, i; i = this.rows[r]; r++)
      i.hasExternalInput && (s = !0);
    for (let r = 0, i; i = this.rows[r]; r++) {
      const a = i.elements;
      if (i.elements = [], i.startsWithElemSpacer() && i.elements.push(new Th(
        this.constants_,
        this.getInRowSpacing_(null, a[0])
      )), !!a.length) {
        for (let p = 0; p < a.length - 1; p++) {
          i.elements.push(a[p]);
          const E = this.getInRowSpacing_(a[p], a[p + 1]);
          i.elements.push(new Th(this.constants_, E));
        }
        if (i.elements.push(a[a.length - 1]), i.elements.length && i.endsWithElemSpacer()) {
          let p = this.getInRowSpacing_(a[a.length - 1], null);
          s && i.hasDummyInput && (p += this.constants_.TAB_WIDTH), i.elements.push(new Th(this.constants_, p));
        }
      }
    }
  }
  getInRowSpacing_(s, r) {
    if (!s)
      return r && Ve.isField(r) && /** @type {Field} */
      r.isEditable ? this.constants_.SPACER_WIDTH : r && Ve.isInlineInput(r) ? this.constants_.SPACER_WIDTH : r && Ve.isStatementInput(r) ? this.constants_.STATEMENT_INPUT_PADDING_LEFT : this.constants_.FIELD_BORDER_RECT_X_PADDING;
    if (!Ve.isInput(s) && (!r || Ve.isStatementInput(r)))
      return Ve.isField(s) && /** @type {Field} */
      s.isEditable ? this.constants_.SPACER_WIDTH : Ve.isIcon(s) ? this.constants_.LARGE_PADDING * 2 + 1 : Ve.isHat(s) ? this.constants_.NO_PADDING : Ve.isPreviousOrNextConnection(s) ? this.constants_.LARGE_PADDING : Ve.isLeftRoundedCorner(s) ? this.constants_.MIN_BLOCK_WIDTH : Ve.isJaggedEdge(s) ? this.constants_.NO_PADDING : this.constants_.FIELD_BORDER_RECT_X_PADDING;
    if (Ve.isInput(s) && !r) {
      if (Ve.isExternalInput(s))
        return this.constants_.NO_PADDING;
      if (Ve.isInlineInput(s))
        return this.constants_.SPACER_WIDTH;
      if (Ve.isStatementInput(s))
        return this.constants_.NO_PADDING;
    }
    if (!Ve.isInput(s) && r && Ve.isInput(r)) {
      if (Ve.isField(s) && /** @type {Field} */
      s.isEditable) {
        if (Ve.isInlineInput(r))
          return this.constants_.SPACER_WIDTH;
        if (Ve.isExternalInput(r))
          return this.constants_.SPACER_WIDTH;
      } else {
        if (Ve.isInlineInput(r))
          return this.constants_.SPACER_WIDTH;
        if (Ve.isExternalInput(r))
          return this.constants_.SPACER_WIDTH;
        if (Ve.isStatementInput(r))
          return this.constants_.SPACER_WIDTH;
      }
      return this.constants_.SPACER_WIDTH - 1;
    }
    if (Ve.isIcon(s) && r && !Ve.isInput(r))
      return this.constants_.SPACER_WIDTH;
    if (Ve.isInlineInput(s) && r && Ve.isField(r))
      return (
        /** @type {Field} */
        r.isEditable ? this.constants_.SPACER_WIDTH : this.constants_.SPACER_WIDTH
      );
    if (Ve.isLeftSquareCorner(s) && r) {
      if (Ve.isHat(r))
        return this.constants_.NO_PADDING;
      if (Ve.isPreviousConnection(r))
        return r.notchOffset;
      if (Ve.isNextConnection(r)) {
        const i = (this.RTL ? 1 : -1) * this.constants_.DARK_PATH_OFFSET / 2;
        return r.notchOffset + i;
      }
    }
    if (Ve.isLeftRoundedCorner(s) && r) {
      if (Ve.isPreviousConnection(r))
        return r.notchOffset - this.constants_.CORNER_RADIUS;
      if (Ve.isNextConnection(r)) {
        const i = (this.RTL ? 1 : -1) * this.constants_.DARK_PATH_OFFSET;
        return r.notchOffset - this.constants_.CORNER_RADIUS + i;
      }
    }
    return Ve.isField(s) && r && Ve.isField(r) && /** @type {Field} */
    s.isEditable === /** @type {Field} */
    r.isEditable ? this.constants_.SPACER_WIDTH : r && Ve.isJaggedEdge(r) ? this.constants_.SPACER_WIDTH : this.constants_.FIELD_BORDER_RECT_X_PADDING;
  }
  getSpacerRowHeight_(s, r) {
    return Ve.isTopRow(s) && Ve.isBottomRow(r) ? this.constants_.EMPTY_BLOCK_SPACER_HEIGHT : Ve.isTopRow(s) || Ve.isBottomRow(r) ? this.constants_.NO_PADDING : s.hasExternalInput && r.hasExternalInput ? this.constants_.LARGE_PADDING : !s.hasStatement && r.hasStatement ? this.constants_.BETWEEN_STATEMENT_PADDING_Y : s.hasStatement && r.hasStatement ? this.constants_.LARGE_PADDING : !s.hasStatement && r.hasDummyInput ? this.constants_.LARGE_PADDING : s.hasDummyInput ? this.constants_.LARGE_PADDING : this.constants_.MEDIUM_PADDING;
  }
  getElemCenterline_(s, r) {
    if (Ve.isSpacer(r))
      return s.yPos + r.height / 2;
    if (Ve.isBottomRow(s)) {
      const a = (
        /** @type {!BottomRow} */
        s
      ), p = a.yPos + a.height - a.descenderHeight;
      return Ve.isNextConnection(r) ? p + r.height / 2 : p - r.height / 2;
    }
    if (Ve.isTopRow(s)) {
      const a = (
        /** @type {!TopRow} */
        s
      );
      return Ve.isHat(r) ? a.capline - r.height / 2 : a.capline + r.height / 2;
    }
    let i = s.yPos;
    return i += s.height / 2, i;
  }
  alignRowElements_() {
    if (!this.isInline) {
      super.alignRowElements_();
      return;
    }
    let s = 0;
    const r = /* @__PURE__ */ new WeakMap();
    let i = null;
    for (let p = this.rows.length - 1, E; E = this.rows[p]; p--)
      r.set(E, s), Ve.isInputRow(E) && (E.hasStatement && this.alignStatementRow_(E), i && i.hasStatement && E.width < i.width ? r.set(E, i.width) : s = Math.max(E.width, s), i = E);
    let a = 0;
    for (let p = 0, E; E = this.rows[p]; p++)
      if (E.hasStatement)
        a = this.getDesiredRowWidth_(E);
      else if (Ve.isSpacer(E))
        E.width = Math.max(a, r.get(E));
      else {
        const h = E.width, y = Math.max(a, r.get(E)) - h;
        y > 0 && this.addAlignmentPadding_(E, y), a = E.width;
      }
  }
  getDesiredRowWidth_(s) {
    return this.isInline && s.hasStatement ? this.statementEdge + this.constants_.MAX_BOTTOM_WIDTH + this.startX : super.getDesiredRowWidth_(s);
  }
  finalize_() {
    let s = 0, r = 0;
    for (let i = 0, a; a = this.rows[i]; i++) {
      a.yPos = r, a.xPos = this.startX, r += a.height, s = Math.max(s, a.widthWithConnectedBlocks);
      const p = r - this.topRow.ascenderHeight;
      if (a === this.bottomRow && p < this.constants_.MIN_BLOCK_HEIGHT) {
        const E = this.constants_.MIN_BLOCK_HEIGHT - p;
        this.bottomRow.height += E, r += E;
      }
      this.recordElemPositions_(a);
    }
    this.outputConnection && this.block_.nextConnection && this.block_.nextConnection.isConnected() && (s = Math.max(
      s,
      this.block_.nextConnection.targetBlock().getHeightWidth().width - this.constants_.DARK_PATH_OFFSET
    )), this.bottomRow.baseline = r - this.bottomRow.descenderHeight, this.widthWithChildren = s + this.startX + this.constants_.DARK_PATH_OFFSET, this.width += this.constants_.DARK_PATH_OFFSET, this.height = r, this.block_.isShadow() || (this.height += this.constants_.DARK_PATH_OFFSET), this.startY = this.topRow.capline;
  }
}
class T0 extends X.blockRendering.StatementInput {
  constructor(s, r) {
    super(s, r), this.connectedBlock && (this.height += this.constants_.DARK_PATH_OFFSET);
  }
}
const s0 = T0;
class l0 {
  constructor(s) {
    N(this, "info_");
    N(this, "RTL_");
    N(this, "constants_");
    N(this, "offset_", 1);
    N(this, "outsidePaths_");
    N(this, "len", 4);
    this.info_ = s, this.RTL_ = this.info_.RTL;
    const r = s.getRenderer();
    this.constants_ = r.getConstants(), this.outsidePaths_ = "";
  }
  getPath() {
    return this.outsidePaths_;
  }
  drawer(s, r) {
    this.outsidePaths_ += X.utils.svgPaths.moveTo(s + this.offset_, r - this.offset_) + X.utils.svgPaths.lineTo(this.len, -this.len) + X.utils.svgPaths.lineTo(-this.len, -this.len) + X.utils.svgPaths.lineTo(-this.len, this.len) + X.utils.svgPaths.lineTo(this.len, this.len);
  }
}
const a0 = l0;
class c0 extends X.blockRendering.Renderer {
  constructor(s) {
    super(s);
  }
  init(s, r) {
    super.init(s, r);
  }
  refreshDom(s, r) {
    super.refreshDom(s, r);
  }
  makeConstants_() {
    return new ZM();
  }
  makeRenderInfo_(s) {
    return new o0(this, s);
  }
  makeDrawer_(s, r) {
    return new qM(s, r);
  }
  makePathObject(s, r) {
    return new r0(s, r, this.getConstants());
  }
}
X.blockRendering.register("eca_renderer", c0);
class bt {
  Equals(s) {
    return this === s;
  }
  GetHashCode() {
    return ue.GetHashCode(this.toString());
  }
  ToString() {
    return this.GetType().Name;
  }
  toString() {
    return this.ToString();
  }
  GetType() {
    return new kh(this.constructor.toString().match(/function (\w*)/)[1]);
  }
  static ReferenceEquals(s, r) {
    return s === r;
  }
  static GenericEquals(s, r) {
    return typeof s == "object" ? s.Equals(r) : s === r;
  }
  static GenericToString(s) {
    return typeof s == "object" ? s.ToString() : s.toString();
  }
  static GenericGetHashCode(s) {
    return typeof s == "object" ? s.GetHashCode() : ue.GetHashCode(this.toString());
  }
}
class fn extends bt {
  constructor(r = "") {
    super();
    N(this, "Message");
    this.Message = r;
  }
  ToString() {
    return "Exception: " + this.Message;
  }
}
class $r {
  static IndexOf(s, r) {
    var i, a = s.length;
    for (i = 0; i < a; i++)
      if (s[i] === r)
        return i;
    return -1;
  }
  static ToEnumerable(s) {
    return new EI(s);
  }
  static Resize(s, r) {
    if (s[0] === null) {
      s[0] = new Array(r);
      return;
    }
    if (s[0].length !== r)
      throw new Jl();
  }
  static ConvertAll(s, r) {
    return s.map(r);
  }
  static Reverse(s) {
    s.reverse();
  }
  static FindAll(s, r) {
    return s.filter(r);
  }
}
class A4 {
  static Parse(s, r, i) {
    return parseFloat(s);
  }
  static ToString(s, r, i) {
    return s.toString();
  }
  static GetHashCode(s) {
    return s;
  }
  static IsInfinity(s) {
    return s === 1 / 0;
  }
  static TryParse(s, r) {
    try {
      return r[0] = parseFloat(s), !0;
    } catch {
      return r[0] = 0, !1;
    }
  }
  static IsNaN(s) {
    return isNaN(s);
  }
}
const WE = class WE {
  static escapeRegExp(s) {
    var r = /[\\^$.*+?()[\]{}|]/g, i = RegExp(r.source);
    return s && i.test(s) ? s.replace(i, "\\$&") : s;
  }
  static IndexOf(s, r, i) {
    var a;
    return typeof r == "number" ? a = String.fromCharCode(r) : a = r, s.indexOf(a, i);
  }
  static LastIndexOf(s, r, i) {
    var a;
    return typeof r == "number" ? a = String.fromCharCode(r) : a = r, s.lastIndexOf(a, i);
  }
  static IndexOfAny(s, r, i = 0) {
    for (var a = i; a < s.length; ++a)
      for (var p = s.charCodeAt(a), E = 0; E < r.length; ++E)
        if (p == r[E])
          return a;
    return -1;
  }
  static GetHashCode(s) {
    var r = 0, i, a, p;
    if (s.length == 0)
      return r;
    for (i = 0, a = s.length; i < a; i++)
      p = s.charCodeAt(i), r = (r << 5) - r + p, r |= 0;
    return r;
  }
  static Replace(s, r, i) {
    var a = typeof r == "number" ? String.fromCharCode(r) : r, p = typeof i == "number" ? String.fromCharCode(i) : i;
    return s.replace(a, p);
  }
  static Substring(s, r, i = -1) {
    return i < 0 ? s.substr(r) : s.substr(r, i);
  }
  /*static Remove(str: string, startIndex: number): string*/
  static Remove(s, r, i) {
    return typeof i === void 0 ? s.substring(0, r) : s.substring(0, r) + s.substring(r + i);
  }
  /*static Remove(str: string, startIndex: number, length?: number): string
  {
  	throw new NotImplementedException(); // do we care that ts->js compiler will get rid of this syntactic sugar?
  }*/
  static Trim(s, r) {
    if (r == null)
      return s.trim();
    let i = 0;
    for (; i < s.length && r.includes(s.charCodeAt(i)); )
      i++;
    let a = s.length - 1;
    for (; a >= 0 && r.includes(s.charCodeAt(a)); )
      a--;
    return s.substring(i, a + 1);
  }
  static TrimStart(s, r = [
    32
    /* space */
  ]) {
    let i = 0;
    for (; i < s.length && r.includes(s.charCodeAt(i)); )
      i++;
    return s.substring(i);
  }
  static TrimEnd(s, r = [
    32
    /* space */
  ]) {
    let i = s.length - 1;
    for (; i >= 0 && r.includes(s.charCodeAt(i)); )
      i--;
    return s.substring(0, i + 1);
  }
  static ToUpperInvariant(s) {
    return s.toUpperCase();
  }
  static ToLowerInvariant(s) {
    return s.toLowerCase();
  }
  static Contains(s, r) {
    return s.indexOf(r) >= 0;
  }
  static StartsWith(s, r, i) {
    return s.indexOf(r) === 0;
  }
  static EndsWith(s, r, i) {
    let a = s.lastIndexOf(r);
    return a >= 0 && a == s.length - r.length;
  }
  static Format(s, r, i, a, p, E, h) {
    if (r.constructor === Array) {
      for (var L = s, y = r.length; y--; )
        L = L.replace(new RegExp("\\{" + y + "\\}", "gm"), r[y]);
      return L;
    } else {
      var V = [r, i, a, p, E, h];
      return WE.Format(s, V);
    }
  }
  static IsNullOrEmpty(s) {
    return !s;
  }
  static Join(s, r) {
    return r.join(s);
  }
  static Concat(s) {
    throw new Jl();
  }
  static FromChars(s, r = 1) {
    if (typeof s == "number") {
      for (var i = String.fromCharCode(s), a = 1; a < r; a++)
        i += String.fromCharCode(s);
      return i;
    }
    throw new Jl();
  }
  static Split(s, r, i) {
    var a = new RegExp(`[${WE.escapeRegExp(String.fromCharCode(...r))}]`);
    return s.split(a);
  }
};
N(WE, "Empty", "");
let ue = WE;
var Wh = /* @__PURE__ */ ((_) => (_[_.RemoveEmptyEntries = 0] = "RemoveEmptyEntries", _))(Wh || {});
class kh extends bt {
  constructor(s) {
    super(), this.Name = s;
  }
  Equals(s) {
    return s instanceof kh && s.Name === this.Name;
  }
}
class p0 extends fn {
}
class pI {
}
N(pI, "NewLine", `
`);
class u0 extends bt {
  constructor() {
    super(...arguments);
    N(this, "NumberDecimalSeparator", ".");
    N(this, "NumberGroupSeparator", ",");
  }
}
const pS = class pS extends bt {
};
N(pS, "UTF8", new pS());
let d4 = pS;
const Zc = class Zc extends bt {
  constructor(r) {
    super();
    N(this, "Name", "Invariant");
    N(this, "nfi", new u0());
  }
  GetFormat(r) {
    return r.Name === "NumberFormatInfo" ? this.nfi : null;
  }
};
N(Zc, "InvariantCulture", new Zc("Invariant")), N(Zc, "CurrentCulture", Zc.InvariantCulture);
let S4 = Zc;
class Jl extends fn {
  constructor(s = "Not implemented") {
    super(s);
  }
}
class rt extends bt {
  constructor(r) {
    super();
    N(this, "array", new Array());
    arguments.length == 1 && r.constructor !== Number && this.AddRange(r);
  }
  [Symbol.iterator]() {
    return this.array[Symbol.iterator]();
  }
  Add(r) {
    this.array.push(r);
  }
  AddRange(r) {
    for (var i = r.GetEnumerator(); i.MoveNext(); )
      this.Add(i.Current);
  }
  get Count() {
    return this.array.length;
  }
  get_Item(r) {
    return this.array[r];
  }
  set_Item(r, i) {
    this.array[r] = i;
  }
  GetEnumerator() {
    return new AI(this);
  }
  Remove(r) {
    var i = this.IndexOf(r);
    return i >= 0 ? (this.RemoveAt(i), !0) : !1;
  }
  RemoveAt(r) {
    this.array.splice(r, 1);
  }
  RemoveRange(r, i) {
    this.array.splice(r, i);
  }
  Insert(r, i) {
    this.array.splice(r, 0, i);
  }
  Clear() {
    this.array = new Array();
  }
  Sort(r) {
    this.array.sort(r);
  }
  ToArray() {
    return this.array.slice(0);
  }
  RemoveAll(r) {
    for (var i = new Array(), a = 0; a < this.array.length; a++)
      r(this.array[a]) || i.push(this.array[a]);
    this.array = i;
  }
  FindAll(r) {
    return new EI(this.array.filter(r));
  }
  Reverse() {
    this.array.reverse();
  }
  IndexOf(r) {
    return this.array.indexOf(r);
  }
  ForEach(r) {
    this.array.forEach(r);
  }
  FindIndex(r) {
    return this.array.findIndex(r);
  }
  Find(r) {
    return this.array.find(r);
  }
  Contains(r) {
    return this.array.indexOf(r) >= 0;
  }
}
class uI extends bt {
  constructor(r) {
    super();
    N(this, "array");
    N(this, "index", -1);
    this.array = r;
  }
  MoveNext() {
    return this.index++, this.index < this.array.length;
  }
  get Current() {
    return this.array[this.index];
  }
  Dispose() {
  }
}
class EI extends bt {
  constructor(r) {
    super();
    N(this, "array");
    this.array = r;
  }
  GetEnumerator() {
    return new uI(this.array);
  }
  [Symbol.iterator]() {
    return this.array[Symbol.iterator]();
  }
}
class AI extends uI {
  constructor(s) {
    super(s.array);
  }
}
class Do extends bt {
  constructor(r) {
    super();
    N(this, "store");
    this.store = new Set(r);
  }
  [Symbol.iterator]() {
    return this.store[Symbol.iterator]();
  }
  Add(r) {
    return this.store.has(r) ? !1 : (this.store.add(r), !0);
  }
  Remove(r) {
    return this.store.has(r) ? (this.store.delete(r), !0) : !1;
  }
  GetEnumerator() {
    return new E0(this);
  }
  Contains(r) {
    return this.store.has(r);
  }
  get Count() {
    return this.store.size;
  }
  Clear() {
    this.store.clear();
  }
}
class E0 extends bt {
  constructor(r) {
    super();
    N(this, "iterator");
    N(this, "Current");
    this.iterator = r.store[Symbol.iterator]();
  }
  Dispose() {
  }
  MoveNext() {
    let r = this.iterator.next();
    return this.Current = r.value, !r.done;
  }
}
class dI extends bt {
  constructor(r, i) {
    super();
    N(this, "Key");
    N(this, "Value");
    this.Key = r, this.Value = i;
  }
}
class A0 {
  constructor(s) {
    N(this, "iter");
    this.iter = s;
  }
  [Symbol.iterator]() {
    return this;
  }
  next() {
    let s = this.iter.next();
    return {
      done: s.done,
      value: s.value == null ? s.value : new dI(s.value[0], s.value[1])
    };
  }
}
class q_ extends bt {
  constructor(r) {
    super();
    N(this, "map", /* @__PURE__ */ new Map());
  }
  [Symbol.iterator]() {
    return new A0(this.map[Symbol.iterator]());
  }
  get_Item(r) {
    return this.map.get(r);
  }
  set_Item(r, i) {
    this.map.set(r, i);
  }
  Add(r, i) {
    if (this.map.has(r))
      throw new p0();
    this.map.set(r, i);
  }
  ContainsKey(r) {
    return this.map.has(r);
  }
  TryGetValue(r, i) {
    let a = this.map.get(r);
    return a != null ? (i[0] = a, !0) : !1;
  }
  Remove(r) {
    this.map.delete(r);
  }
  Clear() {
    this.map.clear();
  }
  get Count() {
    return this.map.size;
  }
  GetEnumerator() {
    var r = new rt();
    for (var i of this.map)
      r.Add(new dI(i[0], i[1]));
    return new d0(r);
  }
  get Keys() {
    var r = new S0();
    for (var i of this.map)
      r.Add(i[0]);
    return r;
  }
  get Values() {
    var r = new h0();
    for (var i of this.map)
      r.Add(i[1]);
    return r;
  }
}
class d0 extends AI {
  constructor(s) {
    super(s);
  }
}
class S0 extends rt {
}
class h0 extends rt {
}
class I0 extends bt {
  constructor() {
    super(...arguments);
    N(this, "parts", new Array());
  }
  Append(r) {
    var i = typeof r == "number" ? String.fromCharCode(r) : r;
    this.parts.push(i);
  }
  AppendLine(r) {
    r != null && this.parts.push(r), this.parts.push(pI.NewLine);
  }
  AppendFormat(r, i, a, p) {
    throw new Jl();
  }
  ToString() {
    return this.parts.join("");
  }
  get Length() {
    for (var r = 0, i = 0; i < this.parts.length; i++)
      r += this.parts[i].length;
    return r;
  }
  Clear() {
    return this.parts.length = 0, this;
  }
  get_Item(r) {
    for (var i = 0, a = 0; a < this.parts.length; ++a) {
      var p = this.parts[a];
      if (r < i + p.length)
        return p.charCodeAt(r - i);
      i += p.length;
    }
    return 0;
  }
}
class Wi extends bt {
  static ToArray(s) {
    const r = [], i = s.GetEnumerator();
    for (; i.MoveNext(); )
      r.push(i.Current);
    return r;
  }
  static ToList(s) {
    return new rt(s);
  }
  static Empty() {
    return new rt();
  }
  static Range(s, r) {
    for (var i = s + r, a = new rt(), p = s; p < i; p++)
      a.Add(p);
    return a;
  }
  static Select(s, r) {
    for (var i = new rt(), a = s.GetEnumerator(); a.MoveNext(); )
      i.Add(r(a.Current));
    return i;
  }
  static SelectMany(s, r, i) {
    throw new Jl();
  }
  static Where(s, r) {
    for (var i = new rt(), a = s.GetEnumerator(); a.MoveNext(); )
      r(a.Current) && i.Add(a.Current);
    return i;
  }
  static OrderBy(s, r) {
    for (var i = new rt(), a = s.GetEnumerator(); a.MoveNext(); )
      i.Add(a.Current);
    return i.array.sort(function(p, E) {
      var h = r(p), L = r(E);
      return h === L ? 0 : h < L ? -1 : 1;
    }), i;
  }
  static OrderByDescending(s, r) {
    for (var i = new rt(), a = s.GetEnumerator(); a.MoveNext(); )
      i.Add(a.Current);
    return i.array.sort(function(p, E) {
      var h = r(p), L = r(E);
      return h === L ? 0 : h < L ? 1 : -1;
    }), i;
  }
  static ThenBy(s, r) {
    return Wi.OrderBy(s, r);
  }
  static Concat(s, r) {
    var i = new rt(s);
    return i.AddRange(r), i;
  }
  static Take(s, r) {
    for (var i = new rt(), a = s.GetEnumerator(); i.Count < r && a.MoveNext(); )
      i.Add(a.Current);
    return i;
  }
  static Skip(s, r) {
    for (var i = new rt(), a = s.GetEnumerator(), p = 0; a.MoveNext(); )
      p >= r && i.Add(a.Current), p++;
    return i;
  }
  static Distinct(s) {
    throw new Jl();
  }
  static Cast(s) {
    return s;
  }
  static OfType(s) {
    throw new Jl();
  }
  static Contains(s, r) {
    if (typeof s == "string") {
      for (let a = 0; a < s.length; ++a)
        if (s.charCodeAt(a) == r)
          return !0;
    } else
      for (var i = s.GetEnumerator(); i.MoveNext(); )
        if (i.Current === r)
          return !0;
    return !1;
  }
  static FirstOrDefault(s, r) {
    for (var i = s.GetEnumerator(); i.MoveNext(); )
      if (r == null || r(i.Current))
        return i.Current;
    return null;
  }
  static LastOrDefault(s, r) {
    for (var i = s.GetEnumerator(), a = null; i.MoveNext(); )
      (r == null || r(i.Current)) && (a = i.Current);
    return a;
  }
  static Last(s, r) {
    for (var i = s.GetEnumerator(), a = void 0, p = !1; i.MoveNext(); )
      (r == null || r(i.Current)) && (a = i.Current, p = !0);
    if (p && a)
      return a;
    throw new fn("Not found");
  }
  static First(s, r) {
    for (var i = s.GetEnumerator(); i.MoveNext(); )
      if (r == null || r(i.Current))
        return i.Current;
    throw new fn("Not found");
  }
  static Any(s, r) {
    for (var i = s.GetEnumerator(); i.MoveNext(); )
      if (r(i.Current))
        return !0;
    return !1;
  }
  static All(s, r) {
    for (var i = s.GetEnumerator(); i.MoveNext(); )
      if (!r(i.Current))
        return !1;
    return !0;
  }
  static Count(s, r) {
    for (var i = 0, a = s.GetEnumerator(); a.MoveNext(); )
      (r == null || r(a.Current)) && ++i;
    return i;
  }
  static Sum(s, r) {
    for (var i = 0, a = s.GetEnumerator(); a.MoveNext(); )
      i += r != null ? r(a.Current) : a.Current;
    return i;
  }
  static Max(s, r) {
    for (var i = Number.MIN_VALUE, a = s.GetEnumerator(); a.MoveNext(); ) {
      var p = r != null ? r(a.Current) : a.Current;
      p > i && (i = p);
    }
    return i;
  }
  static Min(s, r) {
    for (var i = Number.MAX_VALUE, a = s.GetEnumerator(); a.MoveNext(); ) {
      var p = r != null ? r(a.Current) : a.Current;
      p < i && (i = p);
    }
    return i;
  }
  static ToDictionary(s, r, i) {
    for (var a = new q_(), p = s.GetEnumerator(); p.MoveNext(); ) {
      var E = p.Current, h = r(E), L = i(E);
      a.Add(h, L);
    }
    return a;
  }
}
class sh extends bt {
  static WriteLine(s) {
    console.log(s);
  }
  static Assert(s, r) {
    if (!s)
      throw new fn(r);
  }
}
const Qc = class Qc extends bt {
  constructor() {
    super();
    N(this, "ManagedThreadId");
    this.ManagedThreadId = Qc.nextId++;
  }
};
N(Qc, "nextId", 1), N(Qc, "CurrentThread", new Qc());
let h4 = Qc;
function I4(_) {
  let s = new bt();
  return Object.assign(s, _), s;
}
function M0(_, s) {
  return s instanceof _ ? s : null;
}
class ft extends bt {
  constructor(r, i = "") {
    super();
    N(this, "Name", "");
    N(this, "Label", "");
    N(this, "Tip", "");
    this.Name = r, ue.IsNullOrEmpty(i) ? this.Label = r : this.Label = i;
  }
  static op_Implicit(r) {
    return new ft(r, "");
  }
}
class pe extends bt {
  constructor() {
    super();
  }
}
N(pe, "Prop_LeftValue", "left"), N(pe, "Prop_RightValue", "right"), N(pe, "Prop_Condition", "Condition"), N(pe, "Prop_This", "this"), N(pe, "Prop_Index", "index"), N(pe, "Prop_Value", "value"), N(pe, "Prop_Signature", "signature"), N(pe, "Prop_Body", "content"), N(pe, "Prop_TemplateList", "functions"), N(pe, "Prop_TruthBlock", "truth"), N(pe, "Prop_FalseBlock", "false"), N(pe, "Prop_Element", "element"), N(pe, "Prop_Do", "do"), N(pe, "Prop_VarDefines", "variables"), N(pe, "Prop_Start", "start"), N(pe, "Prop_End", "end"), N(pe, "Prop_Step", "step"), N(pe, "Prop_X", "X"), N(pe, "Prop_Y", "Y"), N(pe, "Prop_Z", "Z"), N(pe, "Key_Out", "out"), N(pe, "CONTROLS_IF", "if"), N(pe, "CONTROLS_FOR", "for"), N(pe, "CONTROLS_FOREACH", "foreach"), N(pe, "CONTROLS_WHILE", "while"), N(pe, "CONTROLS_BREAK", "break"), N(pe, "CONTROLS_CONTINUE", "continue"), N(pe, "CONTROLS_RETURN", "return"), N(pe, "COMPARE_GRAPH", "Compare"), N(pe, "ARITH_GRAPH", "Arithmetic"), N(pe, "ENTITY_PICKENTITY", "pickEntity"), N(pe, "ENTITY_GETPROPERTY", "getProperty"), N(pe, "ENTITY_SETPROPERTY", "setProperty"), N(pe, "ENTITY_THISENTITY", "thisEntity"), N(pe, "TRUE", "true"), N(pe, "FALSE", "false"), N(pe, "GlobalScope", "G"), N(pe, "MechanismScope", "K"), N(pe, "ARITHMETIC", "Arithmetic"), N(pe, "CONDITION", "Condition"), N(pe, "ACTIONBLOCK", "ActionBlock"), N(pe, "CALLTYPE_WAIT", "wait"), N(pe, "CALLTYPE_START", "start"), N(pe, "CONDITION_IF", "if"), N(pe, "CONDITION_ELSEIF", "else if"), N(pe, "CONDITION_ELSE", "else"), N(pe, "ROOT_ECASYSTEM", "/ECASystem"), N(pe, "SetOp_Set", ""), N(pe, "SetOp_Inc", "Inc"), N(pe, "SetOp_Dec", "Dec"), N(pe, "SetOp_Mul", "Mul"), N(pe, "SetOp_Div", "Div"), N(pe, "SetOperators", [
  "",
  "Inc",
  "Dec",
  "Mul",
  "Div"
]), N(pe, "Arith_Add", "AD"), N(pe, "Arith_Sub", "SB"), N(pe, "Arith_Mul", "MU"), N(pe, "Arith_Div", "DV"), N(pe, "Arith_Mod", "MD"), N(pe, "Arithmetics", [
  "AD",
  "SB",
  "MU",
  "DV",
  "MD"
]), N(pe, "Condition_EQ", "EQ"), N(pe, "Condition_NQ", "NQ"), N(pe, "Condition_LS", "LS"), N(pe, "Condition_LQ", "LQ"), N(pe, "Condition_GR", "GR"), N(pe, "Condition_GQ", "GQ"), N(pe, "Condition_AN", "AN"), N(pe, "Condition_OR", "OR"), N(pe, "Conditions", [
  "EQ",
  "NQ",
  "LS",
  "LQ",
  "GR",
  "GQ",
  "AN",
  "OR"
]), N(pe, "OnEventProperties", $r.ToEnumerable([
  ft.op_Implicit("Condition")
])), N(pe, "ArithmeticProperties", $r.ToEnumerable([
  ft.op_Implicit("left"),
  ft.op_Implicit("right")
])), N(pe, "GetPropertyProperties", $r.ToEnumerable([
  ft.op_Implicit("this")
])), N(pe, "GetElementProperties", $r.ToEnumerable([
  ft.op_Implicit("this"),
  ft.op_Implicit("index")
])), N(pe, "SetPropertyProperties", $r.ToEnumerable([
  ft.op_Implicit("this"),
  ft.op_Implicit("value")
])), N(pe, "SetGlobalProperties", $r.ToEnumerable([
  ft.op_Implicit("value")
])), N(pe, "FuncDefineProperties", $r.ToEnumerable([
  ft.op_Implicit("signature"),
  ft.op_Implicit("content")
])), N(pe, "CodeGraphProperties", $r.ToEnumerable([
  ft.op_Implicit("variables"),
  ft.op_Implicit("functions")
])), N(pe, "IfElseProperties", $r.ToEnumerable([
  ft.op_Implicit("Condition")
])), N(pe, "AsTypeProperties", $r.ToEnumerable([
  ft.op_Implicit("value")
])), N(pe, "ReturnProperties", $r.ToEnumerable([
  ft.op_Implicit("value")
])), N(pe, "ForEachProperties", $r.ToEnumerable([
  ft.op_Implicit("value"),
  ft.op_Implicit("do")
])), N(pe, "ForIndexProperties", $r.ToEnumerable([
  ft.op_Implicit("start"),
  ft.op_Implicit("end"),
  ft.op_Implicit("step"),
  ft.op_Implicit("do")
])), N(pe, "WhileLoopProperties", $r.ToEnumerable([
  ft.op_Implicit("Condition")
])), N(pe, "VarDefineProperties", $r.ToEnumerable([
  ft.op_Implicit("value")
])), N(pe, "CallExternFunctionProperties", $r.ToEnumerable([
  ft.op_Implicit("this")
])), N(pe, "Vector3Properties", $r.ToEnumerable([
  ft.op_Implicit("X"),
  ft.op_Implicit("Y"),
  ft.op_Implicit("Z")
]));
class SI extends bt {
  constructor() {
    super();
    N(this, "descriptionFile", null);
    N(this, "charsToTrim", [
      32,
      /*' '*/
      9,
      /*'\t'*/
      13,
      /*'\r'*/
      10
    ]);
  }
  ParseTexts(r, i) {
    this.descriptionFile = i;
    let a = r.GetEnumerator(), p = new rt(), E = new M4();
    for (; a.MoveNext(); )
      if (this.readline(a.Current, E), !ue.IsNullOrEmpty(E.name) || !ue.IsNullOrEmpty(E.main)) {
        let h;
        if (E.main == "event") {
          let L = new L0(E.name, ""), y = "Global", V = "", Z = p.GetEnumerator();
          try {
            for (; Z.MoveNext(); ) {
              let ce = Z.Current;
              if (ce.Name == "Owner") {
                y = ce.Value, V = ce.m_Label;
                break;
              }
            }
          } finally {
            Z.Dispose();
          }
          i.events.set_Item(y + "::" + E.name, L), h = L, h.Category = V;
          let le;
          (() => {
            let ce = [], ve = i.event_ownertypes.TryGetValue(L.Name, ce);
            return le = ce[0], ve;
          })() || (le = new rt(), i.event_ownertypes.set_Item(L.Name, le)), le.Add(y), (() => {
            let ce = [], ve = i.ownertype_events.TryGetValue(y, ce);
            return le = ce[0], ve;
          })() || (le = new rt(), i.ownertype_events.set_Item(y, le)), le.Add(L.Name);
        } else if (E.main == "action") {
          let L = new D0(E.name, "");
          i.actions.set_Item(E.name, L), h = L, h.Category = i.Texts.CATEGORY_ACTIONS;
        } else if (E.main == "alias") {
          E.type = ue.Replace(ue.Replace(E.type, " ", ""), "	", ""), this.checkForwardType(E);
          let L = new Yt("alias", E.name, E.type);
          i.DefineType(E.name, L), h = L;
        } else if (E.main == "generic") {
          ue.IsNullOrEmpty(E.type) || (E.type = ue.Replace(ue.Replace(E.type, " ", ""), "	", ""), this.checkForwardType(E));
          let L = new Yt("generic", E.name, E.type);
          i.DefineType(E.name, L), h = L;
        } else if (E.main == "type")
          if (Wi.Contains(E.name, 124) || Wi.Contains(E.name, 38) || Wi.Contains(E.name, 95))
            h = i.GetVarType(E.name);
          else {
            ue.IsNullOrEmpty(E.type) || (E.type = ue.Replace(ue.Replace(E.type, " ", ""), "	", ""), this.checkForwardType(E));
            let L = new Yt("type", E.name, E.type);
            i.DefineType(E.name, L), h = L;
          }
        else if (E.main == "enum") {
          ue.IsNullOrEmpty(E.type) || (E.type = ue.Replace(ue.Replace(E.type, " ", ""), "	", ""), this.checkForwardType(E));
          let L = new Yt("enum", E.name, E.type);
          L.IsEnum = !0, i.DefineType(E.name, L), i.enumTypes.Add(L), h = L, h.Category = i.Texts.CATEGORY_ENUMS;
        } else if (E.main == "variable") {
          let L = new g0(E.name, E.type);
          i.variables.set_Item(E.name, L), h = L, h.Category = i.Texts.CATEGORY_VARIABLES;
        } else
          E.main == "setup" ? h = new N_("setup", E.name, E.type) : h = new N_(E.main, E.name, E.type);
        if (h.SetValue(E.value), h.SetLabel(E.rawLabel), h.DoLoc(i), E.hasChildren && this.enterSubs(h, a), E.IsAttribute ? (h.PostLoad(i), p.Add(h)) : (h.Attributes = p, p = new rt(), h.PostLoad(i)), E.main == "setup" && i.Setup(h), E.main == "partial") {
          let L = i.getType(E.name);
          if (L != null) {
            let y = h.Items.GetEnumerator();
            try {
              for (; y.MoveNext(); ) {
                let V = y.Current;
                L.Items.Add(V);
              }
            } finally {
              y.Dispose();
            }
          }
        }
      }
  }
  checkForwardType(r) {
    if (this.descriptionFile.GetVarType(r.type) == null)
      throw new fn(ue.Format("{0} is null", r.type));
  }
  enterSubs(r, i) {
    r.Items = new rt();
    let a = new rt();
    for (; i.MoveNext(); ) {
      let p = new M4();
      if (this.readline(i.Current, p), p.name == "}")
        break;
      if (!ue.IsNullOrEmpty(p.name)) {
        let E = new N_(p.main, p.name, p.type);
        E.SetValue(p.value), E.SetLabel(p.rawLabel), E.DoLoc(this.descriptionFile), p.hasChildren && this.enterSubs(E, i), p.IsAttribute ? (E.PostLoad(this.descriptionFile), a.Add(E)) : (E.Attributes = a, E.PostLoad(this.descriptionFile), r.Items.Add(E), a = new rt());
      }
    }
  }
  readline(r, i) {
    return r = this.cleancomments(r), r = this.getRawLabel(r, i), r = this.getHasChildren(r, i), r = this.getValue(r, i), r = this.getType(r, i), this.getMainAndName(r, i), i;
  }
  cleancomments(r) {
    let i = ue.IndexOf(r, "//"), a;
    return i >= 0 ? a = ue.Substring(r, 0, i) : a = r, a;
  }
  getRawLabel(r, i) {
    let a = ue.IndexOf(r, "#");
    return a >= 0 ? (i.rawLabel = ue.Trim(ue.Substring(r, a + 1)), r = ue.Substring(r, 0, a)) : i.rawLabel = "", r;
  }
  getHasChildren(r, i) {
    let a = ue.IndexOf(r, 123);
    return a >= 0 ? (r = ue.Substring(r, 0, a), i.hasChildren = !0) : i.hasChildren = !1, r;
  }
  getValue(r, i) {
    let a = ue.IndexOf(r, 61);
    return a >= 0 ? (i.value = ue.Trim(ue.Substring(r, a + 1)), r = ue.Substring(r, 0, a)) : i.value = "", r;
  }
  getType(r, i) {
    let a = ue.IndexOf(r, 58);
    return a >= 0 ? (i.type = ue.Trim(ue.Substring(r, a + 1)), r = ue.Substring(r, 0, a)) : i.type = "", r;
  }
  getMainAndName(r, i) {
    i.IsAttribute = !1, r = ue.Trim(r, this.charsToTrim), ue.StartsWith(r, "@") && (i.IsAttribute = !0);
    let a = ue.IndexOf(r, 32);
    a > 0 ? (i.main = ue.Substring(r, 0, a), i.name = ue.Trim(ue.Substring(r, a + 1), this.charsToTrim)) : i.IsAttribute ? (i.main = r, i.name = ue.Substring(r, 1)) : (i.main = "", i.name = r);
  }
}
class M4 extends bt {
  constructor() {
    super();
    N(this, "main", "");
    N(this, "name", "");
    N(this, "type", "");
    N(this, "value", "");
    N(this, "rawLabel", "");
    N(this, "hasChildren", !1);
    N(this, "IsAttribute", !1);
  }
}
class m0 extends bt {
  constructor() {
    super();
    N(this, "CATEGORY_BASIC", "基本");
    N(this, "CATEGORY_COMBINED", "复合");
    N(this, "CATEGORY_CONTROLS", "流程控制");
    N(this, "CATEGORY_ACTIONS", "动作");
    N(this, "CATEGORY_VARIABLES", "取值");
    N(this, "CATEGORY_ENUMS", "枚举");
    N(this, "CATEGORY_FUNCTIONS", "函数");
    N(this, "CATEGORY_EDIT", "编辑");
    N(this, "CATEGORY_COMPARE", "比较");
    N(this, "CATEGORY_ENTITY", "实体");
    N(this, "CATEGORY_ARITHMETIC", "运算");
    N(this, "CATEGORY_LOCALVARS", "变量");
    N(this, "CATEGORY_GLOBAL", "全局");
    N(this, "CATEGORY_GLOBALVARS", "全局变量");
    N(this, "CATEGORY_MECHANISM", "关卡参数");
    N(this, "CATEGORY_MORE", "更多");
    N(this, "CATEGORY_PROPERTY", "属性");
    N(this, "CATEGORY_TYPES", "类型");
    N(this, "CATEGORY_ASTYPE", "类型转换");
    N(this, "CATEGORY_SETVAR", "设置");
    N(this, "CATEGORY_EXTERN", "外部脚本");
    N(this, "Arithmetics", null);
    N(this, "Conditions", null);
    N(this, "SetOperators", null);
  }
}
class P0 extends bt {
  constructor() {
    super();
    N(this, "EntityType", 0);
    N(this, "Name", "");
    N(this, "defines", new rt());
  }
}
const Po = class Po extends bt {
  constructor() {
    super();
    N(this, "Texts", new m0());
    N(this, "PRIDefineMode", 0);
    N(this, "PRIDefines", new rt());
    N(this, "tempEventSets", new Do());
    N(this, "cacheElements", new rt());
    N(this, "allowAccept", !0);
    N(this, "varTypes", new q_());
    N(this, "events", new q_());
    N(this, "actions", new q_());
    N(this, "variables", new q_());
    N(this, "event_ownertypes", new q_());
    N(this, "ownertype_events", new q_());
    N(this, "m_typeWithBase", new q_());
    N(this, "m_typeNoBase", new q_());
    N(this, "temp_hashes", new Do());
    N(this, "enumTypes", new rt());
    N(this, "EntityTypes", new rt());
    N(this, "voidType", new Yt("type", "void", ""));
    N(this, "unknownType", new Yt("type", "unknown", "").WithLabel("未知"));
    N(this, "setups", new m4());
    N(this, "m_FormalLogicAdaptor", null);
    N(this, "m_FindGraphProxy", null);
    N(this, "m_LocalizeProxy", null);
    N(this, "m_DebugProxy", null);
    N(this, "m_JsonProxy", null);
    N(this, "nullType", null);
    N(this, "anyType", null);
    N(this, "objectType", null);
    N(this, "entityType", null);
    N(this, "boolType", null);
    N(this, "intType", null);
    N(this, "floatType", null);
    N(this, "stringType", null);
    N(this, "arrayType", null);
    N(this, "numberType", null);
    N(this, "typeType", null);
    N(this, "listGenericType", null);
    N(this, "GlobalEntityType", null);
    N(this, "vector3Type", null);
    N(this, "vector2Type", null);
    this.m_FormalLogicAdaptor = new f0(this);
  }
  get VarTypes() {
    return this.varTypes;
  }
  Load(r) {
    this.setups = new m4(), this.m_typeWithBase.Clear(), this.m_typeNoBase.Clear(), this.enumTypes.Clear(), this.events.Clear(), this.event_ownertypes.Clear(), this.ownertype_events.Clear(), this.actions.Clear(), this.varTypes.Clear(), this.variables.Clear(), this.InitDefaultTypes();
    let i = ue.Split(r, Po.splits, Wh.RemoveEmptyEntries);
    return new SI().ParseTexts($r.ToEnumerable(i), this), this.postLoad(), !0;
  }
  GenerateTypeEnums() {
    let r = this.enumTypes.GetEnumerator();
    try {
      for (; r.MoveNext(); ) {
        let i = r.Current;
        if (i.Attributes != null) {
          let a = i.Attributes.GetEnumerator();
          try {
            for (; a.MoveNext(); ) {
              let p = a.Current;
              if (p.Main == "@genTypeEnum" && (i.Items.Clear(), p.Name == "base")) {
                let E = this.GetVarType(p.Value), h = this.varTypes.GetEnumerator();
                try {
                  for (; h.MoveNext(); ) {
                    let L = h.Current, y = L.Value;
                    if (y != this.anyType && y != this.nullType && L.Key == y.Name && !y.IsGeneric && this.CheckIsExtention(E, y)) {
                      let V = i.Items, Z = new N_("", y.Name, "");
                      Z.Label = y.Label, Z.Value = y.Name, Z.m_ApiLevel = y.m_ApiLevel, Z.m_Tip = y.m_Tip, V.Add(Z);
                    }
                  }
                } finally {
                  h.Dispose();
                }
              }
            }
          } finally {
            a.Dispose();
          }
        }
      }
    } finally {
      r.Dispose();
    }
  }
  VisitBases(r) {
    if (r != null && r.Bases == null) {
      if (r.Bases = new Do(), r.IsFormalLogic) {
        let i = r instanceof Vr ? r : null;
        if (i.Operator == 2) {
          let p = null;
          for (let E = 0; E < i.SubLogics.Count; E = E + 1) {
            let h = i.SubLogics.get_Item(E) instanceof Yt ? i.SubLogics.get_Item(E) : null;
            if (h != null)
              if (p == null)
                p = new Do(), this.addBaseTypeToBases(r, h);
              else {
                this.VisitBases(h), !h.IsAlias && !h.IsFormalLogic && r.Bases.Contains(h.Name) && p.Add(h.Name);
                let L = h.Bases.GetEnumerator();
                try {
                  for (; L.MoveNext(); ) {
                    let V = L.Current;
                    r.Bases.Contains(V) && p.Add(V);
                  }
                } finally {
                  L.Dispose();
                }
                let y = r.Bases;
                if (r.Bases = p, p = y, p.Clear(), r.Bases.Count == 0)
                  break;
              }
          }
        } else {
          let p = i.SubLogics.GetEnumerator();
          try {
            for (; p.MoveNext(); ) {
              let E = p.Current;
              E != null && this.addBaseTypeToBases(r, E);
            }
          } finally {
            p.Dispose();
          }
        }
      } else if (r.Type != "") {
        let i = this.GetVarType(r.Type);
        i != null && this.addBaseTypeToBases(r, i);
      }
    }
  }
  addBaseTypeToBases(r, i) {
    this.VisitBases(i), !i.IsAlias && !i.IsFormalLogic && r.Bases.Add(i.Name);
    let a = i.Bases.GetEnumerator();
    try {
      for (; a.MoveNext(); ) {
        let p = a.Current;
        r.Bases.Add(p);
      }
    } finally {
      a.Dispose();
    }
  }
  postLoad() {
    this.FinalizeDefaultType(), this.EntityTypes.Clear();
    let r = this.varTypes.GetEnumerator();
    try {
      for (; r.MoveNext(); ) {
        let a = r.Current.Value;
        if (!a.IsAlias && !a.IsFormalLogic && a.Bases.Contains(this.entityType.Name) && (this.EntityTypes.Contains(a) || this.EntityTypes.Add(a)), ue.IsNullOrEmpty(a.Category)) {
          let p = a.Bases.GetEnumerator();
          try {
            for (; p.MoveNext(); ) {
              let E = p.Current, h = this.GetVarType(E);
              if (h != this.objectType && h != null) {
                a.Category = h.CategoryLabel;
                break;
              }
            }
          } finally {
            p.Dispose();
          }
        }
      }
    } finally {
      r.Dispose();
    }
    if (this.EntityTypes != null) {
      let i = new q_(), a = this.PRIDefines.GetEnumerator();
      try {
        for (; a.MoveNext(); ) {
          let E = a.Current, h = E.Name != null ? E.Name : "";
          i.ContainsKey(h) || i.Add(h, E);
        }
      } finally {
        a.Dispose();
      }
      this.PRIDefines.Clear();
      let p = this.EntityTypes.GetEnumerator();
      try {
        for (; p.MoveNext(); ) {
          let E = p.Current;
          if (E.IntValue != 0) {
            let h;
            (() => {
              let V = [], Z = i.TryGetValue(E.Name, V);
              return h = V[0], Z;
            })() || (h = new P0()), this.PRIDefines.Add(h), h.Name = E.m_Name, h.EntityType = E.IntValue;
            let L = E.IntValue * 1e3;
            this.PRIDefineMode == 1 && (L = L + 999);
            let y = h.defines.GetEnumerator();
            try {
              for (; y.MoveNext(); ) {
                let V = y.Current;
                E.Items == null && (E.Items = new rt());
                let Z = E.Items, le = new N_("", V.m_Name, V.Type);
                le.Value = V.Value, le.Items = V.Items, le.Label = V.Label;
                let ce = le, ve;
                this.PRIDefineMode == 1 ? L = (ve = L) - 1 : L = (ve = L) + 1, ce.IntValue = ve, Z.Add(le);
              }
            } finally {
              y.Dispose();
            }
          }
        }
      } finally {
        p.Dispose();
      }
    }
    this.GenerateTypeEnums();
  }
  RefreshCustomPRI(r) {
    let i = this.getType(r.Name);
    if (i != null && !i.IsAlias && !i.IsEnum && !i.IsFormalLogic && !i.IsGeneric && this.CheckIsExtention(this.entityType, i)) {
      let a = i.Items;
      for (let h = a.Count - 1; h >= 0; h = h - 1)
        a.get_Item(h).IntValue > 0 && a.RemoveAt(h);
      let p = i.IntValue * 1e3;
      this.PRIDefineMode == 1 && (p = p + 999);
      let E = r.defines.GetEnumerator();
      try {
        for (; E.MoveNext(); ) {
          let h = E.Current;
          i.Items == null && (i.Items = new rt());
          let L = i.Items, y = new N_("", h.m_Name, h.Type);
          y.Value = h.Value, y.Items = h.Items, y.Label = h.Label;
          let V = y, Z;
          this.PRIDefineMode == 1 ? p = (Z = p) - 1 : p = (Z = p) + 1, V.IntValue = Z, L.Add(y);
        }
      } finally {
        E.Dispose();
      }
    }
  }
  GetEventDefine(r) {
    let i;
    return (() => {
      let a = [], p = this.events.TryGetValue(r, a);
      return i = a[0], p;
    })(), i;
  }
  FindEventDefine(r, i) {
    let a = this.GetVarType(i), p;
    if (a != null) {
      i = a.Name;
      let E = i + "::" + r, h;
      if ((() => {
        let y = [], V = this.events.TryGetValue(E, y);
        return h = y[0], V;
      })())
        return p = h, p;
      let L = a.Bases.GetEnumerator();
      try {
        for (; L.MoveNext(); ) {
          let y = L.Current;
          if ((() => {
            let V = [], Z = this.events.TryGetValue(y + "::" + r, V);
            return h = V[0], Z;
          })())
            return p = h, p;
        }
      } finally {
        L.Dispose();
      }
    }
    if (i != this.GlobalEntityType.Name) {
      let E;
      if ((() => {
        let h = [], L = this.events.TryGetValue(this.GlobalEntityType.Name + "::" + r, h);
        return E = h[0], L;
      })())
        return p = E, p;
    }
    return p = null, p;
  }
  GetEventsByOwnerType(r, i = !0) {
    this.tempEventSets.Clear();
    let a = new rt();
    i && r != this.GlobalEntityType.Name && this.addEventsToList(a, this.GlobalEntityType.Name), this.addEventsToList(a, r);
    let E = this.GetVarType(r).Bases.GetEnumerator();
    try {
      for (; E.MoveNext(); ) {
        let h = E.Current;
        this.addEventsToList(a, h);
      }
    } finally {
      E.Dispose();
    }
    return a;
  }
  addEventsToList(r, i) {
    let a;
    if ((() => {
      let p = [], E = this.ownertype_events.TryGetValue(i, p);
      return a = p[0], E;
    })()) {
      let p = a.GetEnumerator();
      try {
        for (; p.MoveNext(); ) {
          let E = p.Current;
          if (!this.tempEventSets.Contains(E)) {
            this.tempEventSets.Add(E);
            let h = this.GetEventDefine(i + "::" + E);
            h != null && r.Add(h);
          }
        }
      } finally {
        p.Dispose();
      }
    }
  }
  getType(r) {
    let i, a;
    return (() => {
      let p = [], E = this.varTypes.TryGetValue(r, p);
      return i = p[0], E;
    })() ? a = i : a = null, a;
  }
  CheckNextVarType(r, i) {
    let a = i[0], p = ue.IndexOfAny(r, Po.chars, a), E;
    if (p < 0)
      i[0] = r.length, E = this.getType(ue.Substring(r, a));
    else if (r.charCodeAt(p) == 95) {
      let h = ue.Substring(r, a, p - a), L = this.getType(h);
      if (i[0] = p, L == null)
        throw new fn("cannot find type " + h);
      if (L.IsGeneric) {
        let y = this.cacheElements.Count, V = L.Items.GetEnumerator();
        try {
          for (; V.MoveNext(); ) {
            let ce = V.Current;
            i[0] < r.length && r.charCodeAt(i[0]) == 95 && (i[0] = i[0] + 1);
            let ve = !1;
            r.charCodeAt(i[0]) == 60 && (i[0] = i[0] + 1, ve = !0);
            let et = (() => {
              let Te = [
                i[0]
              ], Le = this.CheckNextVarType(r, Te);
              return i[0] = Te[0], Le;
            })();
            if (ve) {
              if (r.charCodeAt(i[0]) != 62)
                throw new fn("ECA CheckNextVarType Wait for >");
              i[0] = i[0] + 1;
            }
            this.cacheElements.Add(et);
          }
        } finally {
          V.Dispose();
        }
        let Z = ue.Substring(r, a, i[0] - a), le = this.getType(Z);
        if (le == null) {
          le = new Yt("type", Z, L.Type);
          let ce = L.Label;
          le.GenericType = L.Name, le.ElementTypes = new Array(L.Items.Count);
          for (let et = 0; et < L.Items.Count; et = et + 1) {
            let Te = this.cacheElements.get_Item(y + et);
            Te != null ? (le.ElementTypes[et] = Te.Name, ce = ce + "<" + Te.Label + ">") : le.ElementTypes[et] = "";
          }
          let ve = this.GetVarType(L.Type);
          le.Category = ve.CategoryLabel, le.Label = ce, L.Attributes != null && (le.Attributes = Wi.ToList(L.Attributes)), this.DefineType(Z, le);
        } else if (le.ElementTypes == null) {
          le.ElementTypes = new Array(L.Items.Count);
          for (let ce = 0; ce < L.Items.Count; ce = ce + 1) {
            let ve = this.cacheElements.get_Item(y + ce);
            ve != null ? le.ElementTypes[ce] = ve.Name : le.ElementTypes[ce] = "";
          }
        }
        this.cacheElements.RemoveRange(y, this.cacheElements.Count - y), E = le;
      } else
        E = L;
    } else {
      p = a;
      let h = M0(Yt, (() => {
        let L = [
          p
        ], y = DT.ParseAndSimplify(r, L, this.m_FormalLogicAdaptor);
        return p = L[0], y;
      })());
      h.m_Name = ue.Substring(r, a, p - a), i[0] = p, E = h;
    }
    return E;
  }
  GetGenericVarType(r, i, a) {
    let p;
    if (!r.IsGeneric)
      p = null;
    else {
      let E = r.Name;
      if (i.IsFormalLogic ? E = E + "_<" + i.Name + ">" : E = E + "_" + i.Name, a != null)
        for (let L = 0; L < a.length; L = L + 1) {
          let y = a[L];
          y.IsFormalLogic ? E = E + "_<" + y.Name + ">" : E = E + "_" + y.Name;
        }
      let h = this.getType(E);
      if (h != null)
        p = h;
      else if (r.Items.Count != (a != null ? a.length + 1 : 1))
        p = null;
      else {
        h = new Yt("type", E, r.Type), h.Value = r.Value, h.IntValue = r.IntValue, h.FloatValue = r.FloatValue;
        let y = this.GetVarType(r.Type);
        if (h.Category = y.CategoryLabel, h.Label = r.Label + "<" + i.Label + ">", r.Attributes != null && (h.Attributes = Wi.ToList(r.Attributes)), a != null) {
          h.ElementTypes = new Array(a.length + 1), h.ElementTypes[0] = i.Name;
          let V = 1;
          for (let Z = 0; Z < a.length; Z = Z + 1) {
            let le = a[Z], ce = h;
            ce.Label = ce.Label + "<" + le.Label + ">", h.ElementTypes[V] = le.Name, V = V + 1;
          }
        } else
          h.ElementTypes = [
            i.Name
          ];
        h.GenericType = r.Name, this.DefineType(E, h), p = h;
      }
    }
    return p;
  }
  GetVarTypeFromWord(r) {
    let i;
    if (r == "[]")
      i = this.arrayType;
    else {
      r = this.normalizeTypeName(r);
      let a = this.getType(r);
      a != null ? i = a : (a = this.analyzeGenericType(r), a == null ? i = this.unknownType : i = a);
    }
    return i;
  }
  GetVarType(r) {
    let i;
    if (r == null)
      i = null;
    else if (r == "[]")
      i = this.arrayType;
    else {
      r = this.normalizeTypeName(r), r = ue.Replace(r, " ", "");
      let a;
      if ((() => {
        let p = [], E = this.varTypes.TryGetValue(r, p);
        return a = p[0], E;
      })())
        i = a;
      else if (ue.IndexOfAny(r, Po.charsFormalLogic) < 0)
        i = null;
      else {
        try {
          let p = DT.ParseAndSimplify(r, this.m_FormalLogicAdaptor) instanceof Yt ? DT.ParseAndSimplify(r, this.m_FormalLogicAdaptor) : null;
          if (p != null) {
            let E = this.getType(r);
            if (E != null)
              return i = E, i;
            p.m_Name = r, this.DefineType(r, p);
          }
          return i = p, i;
        } catch (p) {
          if (p instanceof fn)
            this.LogError("GetVarType exception on " + r, p);
          else
            throw p;
        }
        i = null;
      }
    }
    return i;
  }
  normalizeTypeName(r) {
    if (ue.EndsWith(r, "?"))
      r = ue.Trim(ue.Substring(r, 0, r.length - 1));
    else
      for (; ue.EndsWith(r, "[]"); )
        r = this.listGenericType.Name + "_" + ue.Trim(ue.Substring(r, 0, r.length - 2));
    return r;
  }
  analyzeGenericType(r) {
    let i;
    if (ue.IndexOfAny(r, Po.chars) < 0)
      i = null;
    else {
      let a = 0, p = (() => {
        let E = [
          a
        ], h = this.CheckNextVarType(r, E);
        return a = E[0], h;
      })();
      if (a != r.length || p == null)
        throw new fn(r + " is not a correct type");
      i = p;
    }
    return i;
  }
  TryGetVarType(r, i) {
    return i[0] = this.GetVarType(r), i[0] != null;
  }
  CheckFinalSelfAcceptable(r, i) {
    let a;
    if (r == null)
      a = !1;
    else if (i == null)
      a = !1;
    else if (i == r)
      a = !0;
    else if (r == this.objectType)
      a = !0;
    else if (r == this.anyType)
      a = !0;
    else if (i == this.anyType)
      a = !0;
    else {
      if (r.Attributes != null && this.allowAccept) {
        let p = r.Attributes.GetEnumerator();
        try {
          for (; p.MoveNext(); ) {
            let E = p.Current;
            if (E.Main == "@Accept" && E.Name == i.Name)
              return a = !0, a;
          }
        } finally {
          p.Dispose();
        }
      }
      if (ue.IsNullOrEmpty(r.GenericType))
        a = !1;
      else if (r.GenericType == i.GenericType)
        if (r.ElementTypes.length != i.ElementTypes.length)
          a = !1;
        else {
          for (let p = 0; p < r.ElementTypes.length; p = p + 1) {
            let E = this.GetFormalLogicNoBases(r.ElementTypes[p]), h = this.GetFormalLogicWithBases(i.ElementTypes[p]);
            if (!DT.CheckAssignable(E, h, this.m_FormalLogicAdaptor))
              return a = !1, a;
          }
          a = !0;
        }
      else
        a = !1;
    }
    return a;
  }
  CheckIsExtention(r, i) {
    return r != null && i != null && (r == i || i.Bases.Contains(r.Name));
  }
  CheckIsAssignable(r, i, a = !0, p) {
    return arguments.length == 4 && (r == null || r instanceof Yt) && (i == null || i instanceof Yt) && (a == null || a.constructor == Boolean) && (p == null || p.constructor == Boolean) ? this.CheckIsAssignable_ECADescriptionFile_0(r, i, a, p) : this.CheckIsAssignable_ECADescriptionFile_1(r, i, a);
  }
  CheckIsAssignable_ECADescriptionFile_0(r, i, a, p) {
    let E = this.allowAccept;
    this.allowAccept = p;
    let h = this.CheckIsAssignable(r, i, a);
    return this.allowAccept = E, h;
  }
  CheckIsAssignable_ECADescriptionFile_1(r, i, a) {
    let p;
    if (r == null)
      p = !1;
    else if (i == null)
      p = !1;
    else if (i == this.nullType && a)
      p = !0;
    else if (r == this.anyType)
      p = !0;
    else if (i == this.anyType && this.allowAccept)
      p = !0;
    else if (i == this.anyType && (i = this.objectType), r == i)
      p = !0;
    else {
      let E = this.GetFormalLogicNoBases(r.Name), h = this.GetFormalLogicWithBases(i.Name);
      p = DT.CheckAssignable(E, h, this.m_FormalLogicAdaptor);
    }
    return p;
  }
  GetTypeID(r) {
    let i = 0;
    if (r != null)
      if (r.IntValue > 0)
        i = r.IntValue;
      else {
        let a = r.Bases.GetEnumerator();
        try {
          for (; a.MoveNext(); ) {
            let p = a.Current, E = this.GetVarType(p);
            if (E != null && E.IntValue > 0) {
              i = E.IntValue;
              break;
            }
          }
        } finally {
          a.Dispose();
        }
      }
    return i;
  }
  IsArray(r) {
    return r == this.arrayType || r.Bases.Contains(this.arrayType.Name);
  }
  DefineType(r, i) {
    this.VisitBases(i), this.varTypes.set_Item(r, i);
  }
  GetFormalLogicNoBases(r) {
    let i, a;
    if ((() => {
      let p = [], E = this.m_typeNoBase.TryGetValue(r, p);
      return i = p[0], E;
    })())
      a = i;
    else {
      if (i = this.GetFormalLogicWithBases(r), i instanceof Vr) {
        let p = i instanceof Vr ? i : null;
        if (p.Operator == 1)
          i = this.hidebasesInAnds(p);
        else if (p.Operator == 2) {
          let E = new Vr();
          E.Operator = 2;
          let h = p.SubLogics.GetEnumerator();
          try {
            for (; h.MoveNext(); ) {
              let L = h.Current;
              if (L instanceof Vr) {
                let y = L instanceof Vr ? L : null;
                E.SubLogics.Add(this.hidebasesInAnds(y));
              } else
                E.SubLogics.Add(L);
            }
          } finally {
            h.Dispose();
          }
          i = E;
        }
      }
      this.m_typeNoBase.set_Item(r, i), a = i;
    }
    return a;
  }
  hidebasesInAnds(r) {
    this.temp_hashes.Clear();
    let i = r.SubLogics.GetEnumerator();
    try {
      for (; i.MoveNext(); ) {
        let L = i.Current.Bases.GetEnumerator();
        try {
          for (; L.MoveNext(); ) {
            let y = L.Current;
            this.temp_hashes.Add(y);
          }
        } finally {
          L.Dispose();
        }
      }
    } finally {
      i.Dispose();
    }
    let a = new Vr();
    a.Operator = 1;
    let p = r.SubLogics.GetEnumerator();
    try {
      for (; p.MoveNext(); ) {
        let h = p.Current;
        this.temp_hashes.Contains(h.Name) || a.SubLogics.Add(h);
      }
    } finally {
      p.Dispose();
    }
    let E;
    return a.SubLogics.Count == 1 ? E = a.SubLogics.get_Item(0) instanceof Yt ? a.SubLogics.get_Item(0) : null : (a.SubLogics.Count == 0, E = a), E;
  }
  GetFormalLogicWithBases(r) {
    let i, a;
    if ((() => {
      let p = [], E = this.m_typeWithBase.TryGetValue(r, p);
      return i = p[0], E;
    })())
      a = i;
    else {
      for (i = this.GetVarType(r); i != null && i.IsAlias; )
        i = this.GetVarType(i.Type);
      if (i == null && (i = this.unknownType), i instanceof Vr)
        this.m_typeWithBase.set_Item(r, i);
      else if (ue.IsNullOrEmpty(i.Type))
        this.m_typeWithBase.set_Item(r, i);
      else {
        let p = this.GetFormalLogicWithBases(i.Type), E = new Vr();
        E.Operator = 1, E.SubLogics.Add(i), E.SubLogics.Add(p), i = DT.Simplify(E, this.m_FormalLogicAdaptor) instanceof Yt ? DT.Simplify(E, this.m_FormalLogicAdaptor) : null, this.m_typeWithBase.set_Item(r, i);
      }
      a = i;
    }
    return a;
  }
  InitDefaultTypes() {
    this.GlobalEntityType = null;
  }
  FinalizeDefaultType() {
    this.anyType = this.finalizeDefaultType("any"), this.intType = this.finalizeDefaultType("int"), this.floatType = this.finalizeDefaultType("float"), this.numberType = this.finalizeDefaultType("number"), this.boolType = this.finalizeDefaultType("bool"), this.stringType = this.finalizeDefaultType("string"), this.entityType = this.finalizeDefaultType("entity"), this.nullType = this.finalizeDefaultType("null"), this.typeType = this.finalizeDefaultType("type"), this.arrayType = this.finalizeDefaultType("array"), this.GlobalEntityType = this.finalizeDefaultType("global"), this.listGenericType = this.finalizeDefaultType("listGeneric"), this.objectType = this.finalizeDefaultType("object"), this.vector3Type = this.finalizeDefaultType("Vector3"), this.vector2Type = this.finalizeDefaultType("Vector2"), this.unknownType.Bases = new Do(), this.voidType.Bases = new Do();
  }
  finalizeDefaultType(r) {
    let i = this.setups.get_Item(r), a;
    if (ue.IsNullOrEmpty(i))
      a = null;
    else {
      let p = this.getType(i);
      p == null && (p = new Yt("type", i, ""), p.Bases = new Do(), this.varTypes.set_Item(i, p), this.LogError(ue.Concat([
        "No define default type ",
        r,
        " ",
        i,
        ".  Give a default type"
      ]), null)), i != r && this.varTypes.set_Item(r, p), a = p;
    }
    return a;
  }
  Setup(r) {
    this.setups.ContainsKey(r.m_Name) ? this.setups.set_Item(r.m_Name, r.Value) : this.LogError("You are entering unknown Setup " + r.m_Name, null);
  }
  Log(r) {
    this.m_DebugProxy != null && this.m_DebugProxy.Log(r);
  }
  LogError(r, i = null) {
    this.m_DebugProxy != null && this.m_DebugProxy.LogError(r, i);
  }
  Assert(r, i = null) {
    this.m_DebugProxy != null && this.m_DebugProxy.Assert(r, i);
  }
  SetDebugProxy(r) {
    this.m_DebugProxy = r;
  }
  SetAssetGUIDProxy(r) {
    this.m_FindGraphProxy = r;
  }
  SetLocalizeProxy(r) {
    this.m_LocalizeProxy = r;
  }
  SetJsonProxy(r) {
    this.m_JsonProxy = r;
  }
  FindAsset(r) {
    let i;
    return this.m_FindGraphProxy == null ? i = null : i = this.m_FindGraphProxy.FindAsset(r), i;
  }
  GetGUID(r) {
    let i;
    return this.m_FindGraphProxy == null ? i = null : i = this.m_FindGraphProxy.GetAssetGUID(r), i;
  }
  JsonParse(r) {
    let i;
    return ue.IsNullOrEmpty(r) || this.m_JsonProxy == null ? i = null : i = this.m_JsonProxy.Parse(r), i;
  }
  JsonStringify(r, i) {
    let a;
    return this.m_JsonProxy == null ? a = null : a = this.m_JsonProxy.Serialize(r, i), a;
  }
  Localize(r) {
    let i;
    if (this.m_LocalizeProxy == null)
      i = r;
    else {
      let a = new I0(), p = 0, E = r.length, h = -1;
      for (; p < E; ) {
        let L = r.charCodeAt(p);
        if (h < 0)
          L == 37 ? (p = p + 1, p < E ? r.charCodeAt(p) == 40 ? h = p + 1 : (a.Append(L), a.Append(r.charCodeAt(p))) : a.Append(L)) : a.Append(L);
        else if (L == 41) {
          let y = p - h;
          if (y > 0) {
            let V = ue.Substring(r, h, y), Z = this.m_LocalizeProxy.Localize(V);
            a.Append(Z);
          }
          h = -1;
        }
        p = p + 1;
      }
      i = a.ToString();
    }
    return i;
  }
};
N(Po, "CurrentDescriptionFile", null), N(Po, "splits", [
  13,
  /*'\r'*/
  10
]), N(Po, "chars", [
  95,
  /*'_'*/
  124,
  /*'|'*/
  38,
  /*'&'*/
  62
]), N(Po, "charsFormalLogic", [
  124,
  /*'|'*/
  38,
  /*'&'*/
  40,
  /*'('*/
  41,
  /*')'*/
  95
]);
let Ae = Po;
class m4 extends q_ {
  constructor() {
    super(), super.set_Item("any", "any"), super.set_Item("null", "null"), super.set_Item("object", "Object"), super.set_Item("bool", "bool"), super.set_Item("int", "int"), super.set_Item("float", "float"), super.set_Item("number", "number"), super.set_Item("string", "string"), super.set_Item("type", "type"), super.set_Item("array", "array"), super.set_Item("listGeneric", "ListT"), super.set_Item("entity", "entity"), super.set_Item("global", "Global"), super.set_Item("Vector3", "Vector3"), super.set_Item("Vector2", "Vector2");
  }
}
class N_ extends bt {
  constructor(r, i, a) {
    super();
    N(this, "Main", "");
    N(this, "m_Name", "");
    N(this, "Type", "");
    N(this, "Value", "");
    N(this, "m_Label", "");
    N(this, "m_LabelKey", "");
    N(this, "m_Tip", "");
    N(this, "m_TipKey", "");
    N(this, "m_ApiLevel", 0);
    N(this, "m_ScriptName", "");
    N(this, "m_Category", "");
    N(this, "IntValue", 0);
    N(this, "FloatValue", 0);
    N(this, "Items", null);
    N(this, "Attributes", null);
    N(this, "ModuleID", 0);
    N(this, "m_ModuleLib", "");
    N(this, "m_ApiTarget", 0);
    N(this, "Addable", null);
    N(this, "Conflicts", null);
    if (arguments.length == 0) {
      this.constructor_0();
      return;
    }
    this.constructor_1(r, i, a);
  }
  get Operator() {
    return -1;
  }
  get ScriptName() {
    let r;
    return ue.IsNullOrEmpty(this.m_ScriptName) ? r = this.m_Name : r = this.m_ScriptName, r;
  }
  get CategoryLabel() {
    let r;
    return ue.IsNullOrEmpty(this.Category) ? r = this.Label : r = this.Category + "/" + this.Label, r;
  }
  set Label(r) {
    this.m_Label = r;
  }
  get Label() {
    return ue.IsNullOrEmpty(this.m_Label) ? this.m_Name : this.m_Label;
  }
  get Name() {
    return this.m_Name;
  }
  set Category(r) {
    this.m_Category = r;
  }
  get Category() {
    return this.m_Category;
  }
  set Tip(r) {
    this.m_Tip = r;
  }
  get Tip() {
    return this.m_Tip;
  }
  get TipKey() {
    return this.m_TipKey;
  }
  constructor_0() {
  }
  constructor_1(r, i, a) {
    this.Main = r, this.m_Name = i, this.Type = a;
  }
  ToString() {
    return this.m_Name;
  }
  GetItem(r) {
    let i;
    if (this.Items != null) {
      let a = this.Items.GetEnumerator();
      try {
        for (; a.MoveNext(); ) {
          let p = a.Current;
          if (p.m_Name == r)
            return i = p, i;
        }
      } finally {
        a.Dispose();
      }
    }
    return i = null, i;
  }
  PostLoad(r) {
    if (this.Attributes != null) {
      let i = this.Attributes.GetEnumerator();
      try {
        for (; i.MoveNext(); ) {
          let a = i.Current;
          switch (a.Main) {
            case "@Tip":
              this.m_Tip = r.Localize(a.Value), this.m_TipKey = this.getLabelKey(a.Value);
              break;
            case "@ApiLevel":
              this.m_ApiLevel = a.IntValue;
              break;
            case "@ScriptName":
              this.m_ScriptName = a.Value;
              break;
            case "@ModuleID":
              this.ModuleID = a.IntValue;
              break;
            case "@ModuleLib":
              this.m_ModuleLib = a.Value;
              break;
            case "@ApiTarget":
              this.m_ApiTarget = a.IntValue;
              break;
            case "@Addable":
              this.Addable = r.JsonParse(a.Value);
              break;
            case "@Conflict":
              this.Conflicts = r.JsonParse(a.Value);
              break;
          }
        }
      } finally {
        i.Dispose();
      }
    }
  }
  SetValue(r) {
    this.Value = r, (() => {
      let i = [], a = A4.TryParse(this.Value, i);
      return this.IntValue = i[0], a;
    })() ? this.FloatValue = this.IntValue : (() => {
      let i = [], a = A4.TryParse(this.Value, i);
      return this.FloatValue = i[0], a;
    })() && (this.IntValue = this.FloatValue);
  }
  SetLabel(r) {
    if (r != null) {
      r = ue.Trim(r), ue.Trim(
        r,
        [
          47
        ]
        /*'/'*/
      );
      let i = ue.LastIndexOf(r, 47);
      if (i != -1 && i < r.length - 1) {
        let a = ue.Substring(r, 0, i);
        this.Category = a, r = ue.Substring(r, i + 1);
      }
      ue.IsNullOrEmpty(r) || (this.m_Label = r, this.m_LabelKey = this.getLabelKey(r));
    }
  }
  getLabelKey(r) {
    let i = ue.LastIndexOf(r, "%("), a;
    return i >= 0 && i < r.length - 3 ? a = ue.Substring(r, i + 2, r.length - i - 3) : a = r, a;
  }
  DoLoc(r) {
    ue.IsNullOrEmpty(this.m_Category) || (this.m_Category = r.Localize(this.m_Category)), ue.IsNullOrEmpty(this.m_Label) || (this.m_Label = r.Localize(this.m_Label));
  }
}
class Yt extends N_ {
  constructor(r, i, a) {
    super(r, i, a);
    N(this, "IsGeneric", !1);
    N(this, "IsEnum", !1);
    N(this, "IsAlias", !1);
    N(this, "IsFormalLogic", !1);
    N(this, "GenericType", "");
    N(this, "ElementTypes", null);
    N(this, "Bases", null);
    this.IsGeneric = r == "generic", this.IsAlias = r == "alias", this.Items = new rt();
  }
  get ElementType() {
    let r;
    return this.ElementTypes != null && this.ElementTypes.length > 0 ? r = this.ElementTypes[0] : r = "any", r;
  }
  WithCategory(r) {
    return this.Category = r, this;
  }
  WithLabel(r) {
    return this.m_Label = r, this;
  }
  WithValue(r) {
    return super.SetValue(r), this;
  }
}
class Vr extends Yt {
  constructor() {
    super("formal", "", "");
    N(this, "SubLogics", new rt());
    N(this, "_Operator", 0);
    this.IsFormalLogic = !0;
  }
  get Operator() {
    return this._Operator;
  }
  set Operator(r) {
    this._Operator = r;
  }
}
class Fh extends N_ {
  constructor(r, i, a) {
    super(r, i, a);
    N(this, "_properties", null);
  }
  get Parameters() {
    if (this._properties == null && (this._properties = new rt(), this.Items != null)) {
      let r = this.Items.GetEnumerator();
      try {
        for (; r.MoveNext(); ) {
          let i = r.Current;
          this._properties.Add(i);
        }
      } finally {
        r.Dispose();
      }
    }
    return this._properties;
  }
  get ReturnType() {
    return null;
  }
}
class D0 extends Fh {
  constructor(s, r = "") {
    super("action", s, ""), this.Category = r;
  }
}
class L0 extends Fh {
  constructor(r, i) {
    super("event", r, i);
    N(this, "owner", "Global");
  }
  PostLoad(r) {
    if (super.PostLoad(r), this.Attributes != null) {
      let i = this.Attributes.GetEnumerator();
      try {
        for (; i.MoveNext(); ) {
          let a = i.Current;
          a.Main == "@Owner" && (this.owner = a.Value);
        }
      } finally {
        i.Dispose();
      }
    }
  }
}
class g0 extends Fh {
  constructor(r, i) {
    super("variable", r, i);
    N(this, "thisName", null);
  }
  get ReturnType() {
    return this.Type;
  }
  PostLoad(r) {
    super.PostLoad(r);
    let i = this.Items.GetEnumerator();
    try {
      for (; i.MoveNext(); ) {
        let a = i.Current;
        (a.m_Name == "this" || a.Main == "this") && (this.thisName = a);
      }
    } finally {
      i.Dispose();
    }
  }
}
class f0 extends bt {
  constructor(r) {
    super();
    N(this, "m_description", null);
    this.m_description = r;
  }
  CreateContainer() {
    return new Vr();
  }
  CreateItem(r) {
    if (this.m_description.GetVarTypeFromWord(r) == null)
      throw new fn(ue.Format("get type `{0}` before it defined", r));
    return this.m_description.GetFormalLogicWithBases(r);
  }
  GetContainerOperator(r) {
    let i = r instanceof Vr ? r : null, a;
    return i != null ? a = i.Operator : a = 0, a;
  }
  PopFromContainer(r) {
    let i = r instanceof Vr ? r : null, a;
    if (i != null) {
      let p = i.SubLogics;
      if (p.Count > 0) {
        let E = p.get_Item(p.Count - 1);
        return p.RemoveAt(p.Count - 1), a = E, a;
      }
    }
    return a = null, a;
  }
  PushToContainer(r, i) {
    let a = r instanceof Vr ? r : null;
    if (a != null) {
      let p = i instanceof Yt ? i : null;
      p != null && a.SubLogics.Add(p);
    }
  }
  SetContainerOperator(r, i) {
    let a = r instanceof Vr ? r : null;
    a != null && (a.Operator = i);
  }
  GetSubFormalLogics(r) {
    let i;
    return r instanceof Vr ? i = r.SubLogics : i = null, i;
  }
  ClearContainer(r) {
    if (r instanceof Vr) {
      let i = r instanceof Vr ? r : null;
      i.Operator = 0, i.SubLogics.Clear();
    }
  }
  IsAcceptable(r, i) {
    return this.m_description.CheckFinalSelfAcceptable(r instanceof Yt ? r : null, i instanceof Yt ? i : null);
  }
}
class Bn extends bt {
  static CheckIsAssignable(s, r, i) {
    return arguments.length == 3 && (s == null || s instanceof Yt) && (r == null || r.constructor == String) && (i == null || i instanceof Ae) ? Bn.CheckIsAssignable_ECAHelper_0(s, r, i) : Bn.CheckIsAssignable_ECAHelper_1(s, r, i);
  }
  static CheckIsAssignable_ECAHelper_0(s, r, i) {
    let a;
    return (() => {
      let p = [], E = i.TryGetVarType(r, p);
      return a = p[0], E;
    })(), a != null && Bn.CheckIsAssignable(s, a, i);
  }
  static IsArithType(s, r) {
    return s == r.intType || s == r.floatType;
  }
  static CheckIsAssignable_ECAHelper_1(s, r, i) {
    return i.CheckIsAssignable(s, r, !0);
  }
  static CheckSenderType(s, r, i) {
    let a;
    return s != null && (s.Name == "Global" || Bn.CheckIsAssignable(s, r, i)) ? (a = !0, a) : (a = !1, a);
  }
  static GetObjectPropertyVarItem(s, r, i, a) {
    return arguments.length == 3 && (s == null || s instanceof Ae) && (r == null || r instanceof Yt) && (i == null || i.constructor == String) ? Bn.GetObjectPropertyVarItem_ECAHelper_0(s, r, i) : Bn.GetObjectPropertyVarItem_ECAHelper_1(s, r, i, a);
  }
  static GetObjectPropertyVarItem_ECAHelper_0(s, r, i) {
    return (() => {
      let a = [], p = Bn.GetObjectPropertyVarItem(s, r, i, a);
      return a[0], p;
    })();
  }
  static GetObjectPropertyVarItem_ECAHelper_1(s, r, i, a) {
    a[0] = null;
    let p;
    if (r == null)
      p = null;
    else if (r.IsEnum)
      p = null;
    else {
      a[0] = r;
      let E = r.GetItem(i);
      if (E != null)
        p = E;
      else {
        let h = r.Bases.GetEnumerator();
        try {
          for (; h.MoveNext(); ) {
            let L = h.Current, y = s.GetVarType(L);
            if (y != null && !y.IsEnum) {
              a[0] = y;
              let V = y.GetItem(i);
              if (V != null)
                return p = V, p;
            }
          }
        } finally {
          h.Dispose();
        }
        a[0] = null, p = null;
      }
    }
    return p;
  }
  static GetObjectPropertyVarType(s, r, i) {
    let a;
    if (s == null)
      a = null;
    else if (s.IsEnum)
      a = null;
    else {
      let p = Bn.GetObjectPropertyVarItem(i, s, r);
      p != null ? a = i.GetVarType(p.Type) : a = null;
    }
    return a;
  }
  constructor() {
    super();
  }
}
var hI = /* @__PURE__ */ ((_) => (_[_.EndNode = -1] = "EndNode", _[_.None = 0] = "None", _[_.And = 1] = "And", _[_.Or = 2] = "Or", _))(hI || {});
class Kl extends bt {
  constructor(r = null) {
    super();
    N(this, "word", "");
    N(this, "_operator", 0);
    N(this, "SubLogics", null);
    r != null ? (this.word = r, this.Operator = -1) : this.SubLogics = new rt();
  }
  set Operator(r) {
    this._operator = r;
  }
  get Operator() {
    return this._operator;
  }
  ToString() {
    let r;
    if (this.Operator == 0)
      this.SubLogics.Count > 0 ? r = this.SubLogics.get_Item(0).ToString() : r = "";
    else if (this.Operator == -1)
      r = this.word;
    else {
      let i = this.Operator != 1 ? " | " : " & ";
      r = "( " + ue.Join(i, Wi.ToArray(Wi.Select(this.SubLogics, (a) => a.ToString()))) + " ) ";
    }
    return r;
  }
}
const kE = class kE extends bt {
  ClearContainer(s) {
    let r = s instanceof Kl ? s : null;
    r != null && (r.Operator = 0, r.SubLogics.Clear());
  }
  CreateContainer() {
    return new Kl(null);
  }
  CreateItem(s) {
    let r;
    if (!(() => {
      let i = [], a = kE.s_dicts.TryGetValue(s, i);
      return r = i[0], a;
    })()) {
      let i = new Kl(s);
      kE.s_dicts.set_Item(s, i), r = i;
    }
    return r;
  }
  GetSubFormalLogics(s) {
    let r = s instanceof Kl ? s : null, i;
    return r == null ? i = null : i = r.SubLogics, i;
  }
  PopFromContainer(s) {
    let r = s instanceof Kl ? s : null, i;
    if (r == null)
      i = null;
    else {
      let a = r.SubLogics.Count;
      if (a > 0) {
        let p = r.SubLogics.get_Item(a - 1);
        r.SubLogics.RemoveAt(a - 1), i = p;
      } else
        i = null;
    }
    return i;
  }
  PushToContainer(s, r) {
    let i = s instanceof Kl ? s : null;
    i != null && i.SubLogics.Add(r);
  }
  SetContainerOperator(s, r) {
    let i = s instanceof Kl ? s : null;
    i != null && (i.Operator = r);
  }
  IsAcceptable(s, r) {
    return s == r;
  }
  constructor() {
    super();
  }
};
N(kE, "s_dicts", new q_());
let Ih = kE;
const Re = class Re extends bt {
  static DoTest() {
    Re.s_adapter = new Ih(), Re.Parse("A", null), Re.Parse("A & B", null);
    let s = Re.Parse("A & (B | C)", null);
    Re.Simplify(s, null);
    let r = Re.Parse("A | ( B &C )", null);
    Re.Simplify(r, null);
    let i = Re.Parse("A |B&C", null);
    Re.Simplify(i, null);
    let a = Re.Parse("A & (A & B)", null);
    Re.Simplify(a, null);
    let p = Re.Parse("A | (A & B)", null);
    Re.Simplify(p, null);
    let E = Re.Parse("(A | (A &B)) &(C|A&D)", null);
    Re.Simplify(E, null);
    let h = Re.Parse("A & (A |B) & ( C |(D&E|F) &G)", null);
    Re.Simplify(h, null), Re.Parse("A & B_<xyz&anything|ddd>_C | D", null), Re.s_adapter = null;
  }
  static ParseAndSimplify(s, r, i) {
    return arguments.length == 2 && (s == null || s.constructor == String) ? Re.ParseAndSimplify_FormalLogicUtil_0(s, r) : Re.ParseAndSimplify_FormalLogicUtil_1(s, r, i);
  }
  static ParseAndSimplify_FormalLogicUtil_0(s, r) {
    return Re.Simplify(Re.Parse(s, r), r);
  }
  static Parse(s, r, i) {
    return arguments.length == 2 && (s == null || s.constructor == String) ? Re.Parse_FormalLogicUtil_0(s, r) : Re.Parse_FormalLogicUtil_1(s, r, i);
  }
  static Parse_FormalLogicUtil_0(s, r) {
    r == null && (r = Re.s_adapter);
    let i;
    if (r == null)
      i = null;
    else {
      let a = 0;
      i = (() => {
        let p = [
          a
        ], E = Re.Parse(s, p, r);
        return a = p[0], E;
      })();
    }
    return i;
  }
  static ParseAndSimplify_FormalLogicUtil_1(s, r, i) {
    return Re.Simplify((() => {
      let a = [
        r[0]
      ], p = Re.Parse(s, a, i);
      return r[0] = a[0], p;
    })(), i);
  }
  static Parse_FormalLogicUtil_1(s, r, i) {
    i == null && (i = Re.s_adapter);
    let a;
    if (i == null)
      a = null;
    else {
      let p = s.length, E = i.CreateContainer(), h = E, L = 0;
      for (; r[0] < p; ) {
        let y = r[0], V = (() => {
          let le = [
            y
          ], ce = Re.skipAngle(s, p, le);
          return y = le[0], ce;
        })(), Z = ue.Trim(ue.Substring(s, r[0], y - r[0]));
        if (Z != "") {
          if (L != 0)
            throw new fn("Wait & | ), but got word " + Z);
          if (i.PushToContainer(h, i.CreateItem(Z)), V == 62)
            return r[0] = y, a = E, a;
          L = 1, r[0] = y + 1;
        }
        if (L == 0) {
          if (V != 40)
            throw new fn("Wait word, but got operator or end");
          r[0] = y + 1;
          let le = (() => {
            let ce = [
              r[0]
            ], ve = Re.Parse(s, ce, i);
            return r[0] = ce[0], ve;
          })();
          i.PushToContainer(h, le), L = 2;
        } else if (L == 1) {
          if (V == 0 || V == 41) {
            r[0] = y;
            break;
          }
          if (V != 124 && V != 38)
            throw new fn("Wait oeprator got ( ");
          let le = h.Operator, ce = V != 124 ? 1 : 2;
          if (le == 0)
            i.SetContainerOperator(h, ce);
          else if (ce == 2 && le == 1)
            h == E && (E = i.CreateContainer(), i.SetContainerOperator(E, ce), i.PushToContainer(E, h)), h = E;
          else if (V == 38 && le == 2) {
            if (h != E)
              throw new fn("Impossible from algorithem");
            h = i.CreateContainer(), i.SetContainerOperator(
              h,
              1
              /* And */
            );
            let ve = i.PopFromContainer(E);
            i.PushToContainer(h, ve), i.PushToContainer(E, h);
          }
          L = 0, r[0] = y + 1;
        } else if (L == 2) {
          if (V != 41)
            throw new fn("Wait ) got others");
          L = 1, r[0] = y + 1;
        }
      }
      a = E;
    }
    return a;
  }
  static skipAngle(s, r, i) {
    let a = 0, p;
    for (; i[0] = ue.IndexOfAny(s, Re.ops, i[0]), p = 0, !(i[0] < 0); ) {
      if (p = s.charCodeAt(i[0]), p == 60)
        a = a + 1;
      else if (p == 62)
        a = a - 1;
      else if (a == 0)
        return p;
      if (a < 0)
        return p;
      i[0] = i[0] + 1;
    }
    return i[0] = r, p;
  }
  static alloc() {
    let s;
    if (Re.s_caches.Count == 0)
      s = new rt();
    else {
      let r = Re.s_caches.get_Item(Re.s_caches.Count - 1);
      Re.s_caches.RemoveAt(Re.s_caches.Count - 1), s = r;
    }
    return s;
  }
  static free(s) {
    s.Clear(), Re.s_caches.Add(s);
  }
  static simplify(s, r) {
    let i = Re.alloc(), a;
    if (s.Operator == -1) {
      let p = i, E = new Do();
      E.Add(s), p.Add(E), a = i;
    } else if (s.Operator == 0) {
      let p = r.GetSubFormalLogics(s);
      a = Re.simplify(Wi.First(p), r);
    } else {
      if (s.Operator == 2) {
        let E = r.GetSubFormalLogics(s).GetEnumerator();
        try {
          for (; E.MoveNext(); ) {
            let h = E.Current, L = Re.simplify(h, r), y = L.GetEnumerator();
            try {
              for (; y.MoveNext(); ) {
                let V = y.Current;
                i.Add(V);
              }
            } finally {
              y.Dispose();
            }
            Re.free(L);
          }
        } finally {
          E != null && E.Dispose();
        }
      } else if (s.Operator == 1) {
        i.Add(new Do());
        let E = r.GetSubFormalLogics(s).GetEnumerator();
        try {
          for (; E.MoveNext(); ) {
            let h = E.Current, L = i;
            i = Re.alloc();
            let y = Re.simplify(h, r), V = L.GetEnumerator();
            try {
              for (; V.MoveNext(); ) {
                let Z = V.Current, le = y.GetEnumerator();
                try {
                  for (; le.MoveNext(); ) {
                    let ce = le.Current, ve = new Do(Z), et = ce.GetEnumerator();
                    try {
                      for (; et.MoveNext(); ) {
                        let Te = et.Current;
                        ve.Add(Te);
                      }
                    } finally {
                      et.Dispose();
                    }
                    i.Add(ve);
                  }
                } finally {
                  le.Dispose();
                }
              }
            } finally {
              V.Dispose();
            }
            Re.free(L);
          }
        } finally {
          E != null && E.Dispose();
        }
      }
      i = Re.simplifyHashes(i, !0), a = i;
    }
    return a;
  }
  static Simplify(s, r = null) {
    return r == null && (r = Re.s_adapter), Re.orAndsToLogic(Re.simplify(s, r), r);
  }
  static orAndsToLogic(s, r) {
    let i;
    if (s.Count == 0)
      i = r.CreateContainer();
    else if (s.Count == 1) {
      let a = s.get_Item(0);
      i = Re.pushAnds(null, a, r);
    } else {
      let a = r.CreateContainer();
      r.ClearContainer(a), r.SetContainerOperator(
        a,
        2
        /* Or */
      );
      let p = s.GetEnumerator();
      try {
        for (; p.MoveNext(); ) {
          let E = p.Current;
          r.PushToContainer(a, Re.pushAnds(null, E, r));
        }
      } finally {
        p.Dispose();
      }
      i = a;
    }
    return i;
  }
  static pushAnds(s, r, i) {
    sh.Assert(r.Count > 0, "Ands should at least one element");
    let a;
    if (r.Count == 1) {
      let p = Wi.First(r);
      sh.Assert(p.Operator == -1, "simplified logics second level should be only EndNode"), a = p;
    } else {
      s == null ? s = i.CreateContainer() : i.ClearContainer(s), i.SetContainerOperator(
        s,
        1
        /* And */
      );
      let p = r.GetEnumerator();
      try {
        for (; p.MoveNext(); ) {
          let E = p.Current;
          sh.Assert(E.Operator == -1, "simplified logics second level should be only EndNode"), i.PushToContainer(s, E);
        }
      } finally {
        p.Dispose();
      }
      a = s;
    }
    return a;
  }
  static simplifyHashes(s, r = !0) {
    let i = Re.alloc();
    s.Sort((a, p) => a.Count - p.Count);
    for (let a = 0; a < s.Count; a = a + 1) {
      let p = s.get_Item(a), E = !1;
      for (let h = 0; h < i.Count; h = h + 1) {
        let L = i.get_Item(h);
        E = !0;
        let y = L.GetEnumerator();
        try {
          for (; y.MoveNext(); ) {
            let V = y.Current;
            if (!p.Contains(V)) {
              E = !1;
              break;
            }
          }
        } finally {
          y.Dispose();
        }
        if (E)
          break;
      }
      E || i.Add(p);
    }
    return r && Re.free(s), i;
  }
  static CheckAssignable(s, r, i) {
    i == null && (i = Re.s_adapter);
    let a;
    if (r.Operator == 2) {
      let E = i.GetSubFormalLogics(r).GetEnumerator();
      try {
        for (; E.MoveNext(); ) {
          let h = E.Current;
          if (!Re.CheckAssignable(s, h, i))
            return a = !1, a;
        }
      } finally {
        E != null && E.Dispose();
      }
      a = !0;
    } else {
      if (r.Operator == 1)
        if (s.Operator == 2) {
          let E = i.GetSubFormalLogics(s).GetEnumerator();
          try {
            for (; E.MoveNext(); ) {
              let h = E.Current;
              if (Re.CheckAssignable(h, r, i))
                return a = !0, a;
            }
          } finally {
            E != null && E.Dispose();
          }
        } else {
          if (s.Operator == 1) {
            let p = i.GetSubFormalLogics(s), E = i.GetSubFormalLogics(r), h = p.GetEnumerator();
            try {
              for (; h.MoveNext(); ) {
                let L = h.Current, y = !1, V = E.GetEnumerator();
                try {
                  for (; V.MoveNext(); ) {
                    let Z = V.Current;
                    if (i.IsAcceptable(L, Z)) {
                      y = !0;
                      break;
                    }
                  }
                } finally {
                  V != null && V.Dispose();
                }
                if (!y)
                  return a = !1, a;
              }
            } finally {
              h != null && h.Dispose();
            }
            return a = !0, a;
          }
          if (s.Operator == -1) {
            let E = i.GetSubFormalLogics(r).GetEnumerator();
            try {
              for (; E.MoveNext(); ) {
                let h = E.Current;
                if (i.IsAcceptable(s, h))
                  return a = !0, a;
              }
            } finally {
              E != null && E.Dispose();
            }
            return a = !1, a;
          }
        }
      else if (r.Operator == -1)
        if (s.Operator == 2) {
          let E = i.GetSubFormalLogics(s).GetEnumerator();
          try {
            for (; E.MoveNext(); ) {
              let h = E.Current;
              if (Re.CheckAssignable(h, r, i))
                return a = !0, a;
            }
          } finally {
            E != null && E.Dispose();
          }
        } else {
          if (s.Operator == 1) {
            let E = i.GetSubFormalLogics(s).GetEnumerator();
            try {
              for (; E.MoveNext(); ) {
                let h = E.Current;
                if (!i.IsAcceptable(h, r))
                  return a = !1, a;
              }
            } finally {
              E != null && E.Dispose();
            }
            return a = !0, a;
          }
          if (s.Operator == -1)
            return a = i.IsAcceptable(s, r), a;
        }
      a = !1;
    }
    return a;
  }
  constructor() {
    super();
  }
};
N(Re, "s_adapter", null), N(Re, "ops", [
  40,
  /*'('*/
  41,
  /*')'*/
  124,
  /*'|'*/
  38,
  /*'&'*/
  60,
  /*'<'*/
  62
]), N(Re, "s_caches", new rt());
let DT = Re;
var Oe = function(_, s) {
  return _ == null ? "" : b0(_, s);
};
let Mh;
function N0(_) {
  Mh = _;
}
function b0(_, s) {
  return Mh ? Mh.doLoc(_, s) : _;
}
var II = /* @__PURE__ */ ((_) => (_.English = "en", _.SimplifiedChinese = "zh-cn", _.TraditionalChinese = "zh-tw", _.Thai = "th", _.Vietnamese = "vn", _.Indonesia = "ind", _.BrazilianPortuguese = "pt-br", _.Spanish = "es", _.Russian = "ru", _.Korean = "ko", _.French = "fr", _.German = "de", _.Turkish = "tr", _.Hindi = "hi", _.Japanese = "ja", _.Romanian = "ro", _.Arabic = "ar", _.Burmese = "my", _.Urdu = "ur", _.Bengali = "bn", _))(II || {});
const mh = "en", C0 = "zh-tw", O0 = "zh-cn", R0 = "vn";
class y0 {
  constructor() {
    N(this, "locData", {});
    N(this, "locLang");
    N(this, "curLocData");
    this.locLang = "en";
  }
  hasLang(s) {
    return this.locData[s] != null;
  }
  async init(s) {
    await this.loadLocData(s);
  }
  async loadLocData(s) {
    const r = /* @__PURE__ */ Object.assign({ "./Config/Loc/FE/fe_loc-en.json": () => import("./fe_loc-en-CywtJnt6.js"), "./Config/Loc/FE/fe_loc-vi.json": () => import("./fe_loc-vi-BS3E-6OT.js"), "./Config/Loc/FE/fe_loc-zh-Hans.json": () => import("./fe_loc-zh-Hans-CqpzrvrP.js"), "./Config/Loc/FE/fe_loc-zh-Hant.json": () => import("./fe_loc-zh-Hant-Cprreq1o.js"), "./Config/Loc/FF/ar.json": () => import("./ar-MSXeNUV9.js"), "./Config/Loc/FF/bn.json": () => import("./bn-02YeYHIc.js"), "./Config/Loc/FF/de.json": () => import("./de-CnduGeOC.js"), "./Config/Loc/FF/en-in.json": () => import("./en-in-k-ZzhqF2.js"), "./Config/Loc/FF/en.json": () => import("./en-C9abPo-1.js"), "./Config/Loc/FF/es.json": () => import("./es-Ct1XqBGj.js"), "./Config/Loc/FF/fr.json": () => import("./fr-xLiid3D9.js"), "./Config/Loc/FF/hi.json": () => import("./hi-BILa48s6.js"), "./Config/Loc/FF/ind.json": () => import("./ind-Cd2iNfMR.js"), "./Config/Loc/FF/ja.json": () => import("./ja-CDDDLCJs.js"), "./Config/Loc/FF/ko.json": () => import("./ko-4vA8V_5G.js"), "./Config/Loc/FF/my.json": () => import("./my-h0Vhqk0_.js"), "./Config/Loc/FF/pt-br.json": () => import("./pt-br-9aPPXXuv.js"), "./Config/Loc/FF/ro.json": () => import("./ro-D-5hXhyT.js"), "./Config/Loc/FF/ru.json": () => import("./ru-Cq_yyqCv.js"), "./Config/Loc/FF/th.json": () => import("./th-BhW8Q9gM.js"), "./Config/Loc/FF/tr.json": () => import("./tr-BC_VobsA.js"), "./Config/Loc/FF/ur.json": () => import("./ur-D2_X-8A0.js"), "./Config/Loc/FF/vn.json": () => import("./vn-CvInjhI0.js"), "./Config/Loc/FF/zh-cn.json": () => import("./zh-cn-D1UO6xKH.js"), "./Config/Loc/FF/zh-tw.json": () => import("./zh-tw-5F3LH6jG.js") });
    let i = [];
    return Object.entries(r).forEach(([a, p]) => {
      const E = v0(a, ".json"), h = $0(E);
      (h === mh || h === s) && i.push(new Promise(async (L, y) => {
        try {
          const V = await p();
          L({
            locale: h,
            data: V.default
          });
        } catch (V) {
          console.error("load localization json error", V), y(V);
        }
      }));
    }), Promise.all(i).then((a) => {
      a.forEach((p) => {
        const E = p.locale;
        this.locData[E] || (this.locData[E] = {});
        const h = p.data;
        this.locData[E] = Object.assign(this.locData[E], h);
      });
    });
  }
  SetLanguage(s) {
    this.locLang = s, this.curLocData = this.locData[s];
  }
  doLoc(s, r) {
    if (!this.curLocData)
      return s;
    let i = this.curLocData[s];
    if (i || (i = this.locData[mh][s] ?? s), Array.isArray(r))
      r.forEach((a, p) => {
        i = i.replace(`{${p}}`, a);
      });
    else if (typeof r == "object")
      for (const [a, p] of Object.entries(r))
        i = i.replace(`{${a}}`, p);
    return i;
  }
}
function v0(_, s) {
  _ = _.replace(/\/+$/, "");
  let r = _.substring(_.lastIndexOf("/") + 1);
  return r.slice(-s.length) === s && (r = r.slice(0, -s.length)), r;
}
function $0(_) {
  const s = "fe_loc-";
  if (_.startsWith(s)) {
    let r = _.replace(s, "");
    switch (r) {
      case "zh-Hant":
        r = C0;
        break;
      case "zh-Hans":
        r = O0;
        break;
      case "vi":
        r = R0;
        break;
      default:
        r = mh;
    }
    return r;
  }
  return _;
}
const _e = {
  If_Craftland: "T_34_WZ_WS_LOGIC5_NAME",
  Foreach_craftland: "T_34_WZ_WS_LOGIC7_NAME",
  Warning_TypeAssign: "T_37_SP_WS_LOG_VAR_ASSIGNMENT_OPERATOR_MISMATCH",
  Warning_NoDefine: "FE_0_HW_WARNING_NODEFINE",
  Warning_LowLevel: "FE_0_HW_WARNING_NODEFINE",
  Warning_Deprecated: "T_40_XXJ_WS_OBSOLETE",
  Warning_Param_NoDefine: "FE_0_HW_WARNING_PARAM_NODEFINE",
  Warning_ReturnNotInFunction: "FE_0_HW_WARNING_RETURNNOTINFUNCTION",
  Warning_FunctionSignature_ReturnType: "FE_0_HW_WARNING_FUNCTIONSIGNATURE_RETURNTYPE",
  Warning_FunctionSignature_Parameters: "FE_0_HW_WARNING_FUNCTIONSIGNATURE_PARAMETERS",
  Warning_LocalVar_NoDefine: "FE_0_HW_WARNING_LOCALVAR_NODEFINE",
  Warning_LocalVar_OOS: "FE_0_HW_WARNING_LOCALVAR_OOS",
  Deprecated: "T_42_XXJ_WS_OBSOLETE",
  Tip_NoExternal: "FE_0_HW_TIP_NOEXTERNAL",
  Tip_NotTransform: "FE_43A_HZY_ERROR_TIP1",
  ListTypeLabel: "FE_0_HW_GRAPH_LISTTYPELABEL",
  ListGet: "FE_0_HW_GRAPH_LISTGET",
  // Get xxx idx
  ListCreate: "FE_0_HW_GRAPH_CREATELIST",
  //TODO: 使用如下定义替换三部分组成
  //Set %1 [%2] = %3
  ListSet: "FE_0_HW_GRAPH_LISTSET",
  ListSet_1: "[",
  ListSet_2: "] =",
  //TODO: 使用如下定义替换两部分组成
  //Append %1 with value %2    
  ListAppend: "FE_0_HW_GRAPH_LISTAPPEND",
  ListAppend_1: "FE_0_HW_GRAPH_LISTAPPEND_1",
  //TODO: 使用如下定义替换三部分组成
  //Insert %1 with value %2 at %3
  ListInsert: "FE_0_HW_GRAPH_LISTINSERT",
  ListInsert_1: "FE_0_HW_GRAPH_LISTINSERT_1",
  ListInsert_2: "FE_0_HW_GRAPH_LISTINSERT_2",
  NewMap: "T_40_XXJ_WS_NEWMAP_NAMEKEY",
  ConditionalStatement: "FE_38_B_ECA_CONDITIONAL_STATEMENT",
  If: "FE_0_HW_GRAPH_IF",
  ElseIf: "FE_0_HW_GRAPH_ELSEIF",
  Else: "FE_0_HW_GRAPH_ELSE",
  ExternalCall: "FE_0_HW_GRAPH_EXTERNALCALL",
  CallReturn: "FE_0_HW_GRAPH_CALLRETURN",
  ParallelCall: "FE_0_HW_GRAPH_PARALLELCALL",
  SerialCall: "FE_0_HW_GRAPH_SERIALCALL",
  Int: "FE_0_HW_GRAPH_INT",
  Index: "FE_0_HW_GRAPH_INDEX",
  // 数组编号
  Text: "FE_0_HW_GRAPH_TEXT",
  Float: "FE_0_HW_GRAPH_FLOAT",
  Number: "FE_0_HW_GRAPH_NUMBER",
  NULL: "FE_0_HW_GRAPH_NULL",
  PI: "T_42_XXJ_WS_MATHPI",
  E: "T_42_XXJ_WS_MATHE",
  Vector3: "T_34_M_WS_VECTOR",
  Boolean: "T_34_M_WS_BOOL",
  Color: "T_34_M_WS_COLOUR",
  FunctionDefineValution: "FE_0_HW_GRAPH_FUNCTION_DEFINE_VAL",
  FunctionDefineAction: "FE_0_HW_GRAPH_FUNCTION_DEFINE_ACT",
  FunctionDefineReturn: "FE_0_HW_GRAPH_FUNCTION_DEFINE_RETURN",
  FunctionDefineBehaviorAction: "T_41_XXJ_WS_BTREENODESTATE",
  FunctionXBTAction: "FE_42_JH_AIEDITOR_ACTIONFUNCNAME",
  FunctionXBTCondition: "FE_42_JH_AIEDITOR_TICKFUNCNAME",
  ReturnSentense: "FE_0_HW_GRAPH_RETURN_SENTENSE",
  FunctionCall: "FE_38_B_ECA_CALL_FUNCTION",
  FunctionCallTooltip: "FE_42A_HZY_WS_FUNCTIONCALL_D",
  FunctionMutatorParameters: "FE_0_HW_GRAPH_FUNCTION_MUTATOR_PARA",
  While: "T_34_WZ_WS_LOGIC8_NAME",
  //TODO: 使用如下定义替换四部分组成
  // for index %1 from %2 to %3 by step %4        
  ForIndex: "FE_0_HW_GRAPH_FOR_INDEX",
  ForIndex_1: "FE_0_HW_GRAPH_FOR_INDEX_1",
  ForIndex_2: "FE_0_HW_GRAPH_FOR_INDEX_2",
  ForIndex_3: "FE_0_HW_GRAPH_FOR_INDEX_3",
  //TODO: 使用如下定义替换三部分组成
  // foreach  %1  %2 in %3
  Foreach: "FE_0_HW_GRAPH_FOREACH",
  Foreach_2: "FE_0_HW_GRAPH_FOREACH_2",
  Break: "FE_0_HW_GRAPH_BREAK",
  Continue: "FE_0_HW_GRAPH_CONTINUE",
  //TODO: 使用如下定义替换两部分组成
  // get %1 from %2
  PropertyGet: "FE_0_HW_GRAPH_PROPERTY_GET",
  PropertyGet_1: "FE_0_HW_GRAPH_PROPERTY_GET_1",
  // get %1 of %2
  PropertyGet_2: "T_34_WT_WS_ENTITY4_NAME",
  PropertyGet_3: "T_34_WT_WS_ENTITY2_PARAM3",
  TupleGet: "T_50_HJ_SEARCHKEY_TUPLEGET",
  //TODO: 使用如下定义替换三部分组成
  // set %1 %2 with %3
  PropertySet: "FE_0_HW_GRAPH_PROPERTY_SET",
  PropertySet_1: "",
  PropertySet_2: "FE_0_HW_GRAPH_PROPERTY_SET_2",
  TupleSet: "T_50_HJ_SEARCHKEY_TUPLESET",
  //TODO: 使用如下定义替换三部分组成
  // extern get %graph %property from %entity
  ExternalGet: "FE_0_HW_GRAPH_EXTERNAL_GET",
  ExternalGet_2: "FE_0_HW_GRAPH_EXTERNAL_GET_2",
  //TODO: 使用如下定义替换四部分组成
  // extern set %entity %graph %property with %value
  ExternalSet: "FE_0_HW_GRAPH_EXTERNAL_SET",
  ExternalSet_3: "FE_0_HW_GRAPH_EXTERNAL_SET_3",
  // get global %1
  GlobalGet: "FE_0_HW_GRAPH_GLOBAL_GET",
  //TODO: 使用如下定义替换两部分组成
  // set global %1 with %2
  GlobalSet: "T_40_XXJ_WS_SETGLOBAL",
  GlobalSet_1: "FE_0_HW_GRAPH_GLOBAL_SET_1",
  UnkownType: "FE_0_HW_GRAPH_UNKOWN_TYPE",
  Unselected: "FE_0_HW_GRAPH_NONE",
  // 未选择时出现的内容
  None: "T_41_XXJ_WS_NONE1",
  AsType: "FE_0_HW_GRAPH_AS_TYPE",
  //TODO: 使用如下定义替换两部分组成
  // %1 = %2
  LocalvarSet: "FE_0_HW_GRAPH_PROPERTY_SET",
  LocalvarSet_1: "=",
  LocalvarGet: "",
  LcoalvarDefine: "FE_44_M_WS_LOCALVAR",
  LcoalvarDefineTooltip: "FE_42A_HZY_WS_LOCALVAR_D",
  OpAnd: "FE_0_HW_GRAPH_OP_AND",
  OpOr: "FE_0_HW_GRAPH_OP_OR",
  ArithAdd: "+",
  ArithSub: "-",
  ArithMultiply: "×",
  ArithDivide: "÷",
  ArithMod: "%",
  CompareEqual: "==",
  CompareNotEqual: "≠",
  // ≠
  CompareLess: "‏<",
  // <
  CompareLessEqual: "‏≤",
  // ≤
  CompareGreater: "‏>",
  // >
  CompareGreaterEqual: "‏≥",
  // ≥
  ThisEntity: "T_47_XXJ_WS_THISENTITY",
  CreateHud: "T_34_SP_WS_BLOCK6_NAME",
  CreateHud_Tip: "T_34_SP_WS_BLOCK6_NAMEDESC",
  CreateHud_OwnerPlayer: "T_34_SP_WS_BLOCK6_PARAM2_NAME",
  CreateHud_OwnerPlayer_Tip: "T_34_SP_WS_BLOCK6_PARAM2_NAMEDESC",
  GetWidgetFromCustomHud: "T_34_M_WS_GETCONTROL",
  CustomHud: "T_34_M_WS_CUSTOMINF",
  PickEntity: "FE_0_HW_GRAPH_PICK_ENTITY",
  //选择场景物件
  PickWidget: "FE_0_HW_GRAPH_PICK_WIDGET",
  //选择UI控件
  SceneID: "FE_0_Q_SENCE_ENUM",
  //场景枚举
  SceneFile: "FE_0_F_PROJECT_SCENE",
  ItemGoodsLabel: "T_35_WZY_WS_ITEMSTYPE_NAMEDESC",
  SoundLabel: "T_34_M_WS_SOUND",
  PrefabLabel: "FE_0_F_PROJECT_PREFAB",
  IconLabel: "T_34_M_WS_ICON",
  TextureIDLabel: "T_38_WZY_WS_TEXTUREID",
  EffectIDLabel: "T_38_WZY_WS_PARTICALMAP",
  DynamicCreateItemLabel: "T_36_WZY_WS_CREABLEOB",
  EffectLabel: "T_34_M_WS_VFX",
  InternalHud: "T_36_WZY_WS_HUDTYPE",
  False: "FE_0_Q_FALSE",
  True: "FE_0_Q_TRUE",
  More: "FE_0_B_ECA_MORE",
  GetVar: "FE_0_HW_CATEGORY_VARIBLE",
  SetVar: "FE_38_B_ECA_SET_VARIABLE",
  FixFunctionCaller: "以下参数与定义不相符",
  FixFunctionCallerTip: "删除多余参数",
  LocalizationKeyParams: "FE_38_B_ECA_PARALIST",
  ECAScript: "FE_0_F_ECA_SCRIPT",
  Script: "FE_40_B_SCRIPT",
  // eca + fcg
  Behavior: "FE_41_JH_BT_BTNAME",
  Entity: "T_34_M_WS_ENTITY",
  Concat: "T_34_LY_WS_JOIN",
  StringConcatTip: "T_34_LY_WS_STRC_DESC",
  Value: "T_34_WT_WS_ENTITY2_PARAM4",
  ClothSkinSet: "T_40_XXJ_WS_SETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY",
  WeaponSkinSet: "T_40_XXJ_WS_SETPLAYERWEAPONSKINIDBYWEAPONID_NAMEKEY",
  Player: "T_34_WT_WS_ENTITY7_PARAM1",
  WardrobeType: "T_40_XXJ_WS_WARDROBETYPE_NAMEKEY",
  ClothID: "T_40_XXJ_WS_CLOTHID_NAMEKEY",
  WeaponIDLabel: "FE_40_XXJ_WEASKINSTYPE",
  ClothIDLabel: "FE_40_XXJ_CLOTHESTYPE",
  VehicleSkinIDLabel: "T_42_XXJ_WS_VEHICLESKINID",
  BagIDLabel: "T_44_XXJ_WS_BAGSKINID",
  PlayerSkill: "T_44_XXJ_WS_PLAYERSKILLID",
  Comment: "FE_40_SD_NOTE",
  EmoteIDLabel: "T_32_LC_NEWVAULT_EMOTE",
  Object3DResourceLabel: "T_41_XXJ_WS_RESOURCEID",
  Resource: "FE_0_HW_MENU_ASSET",
  Enum: "FE_39_B_ENUM",
  Arithmetic: "T_36_WZY_WS_ARITHMETIC_NAME",
  Compare: "T_34_WZ_WS_LOGIC2_NAME",
  VarIn: "FE_42_XXJ_INVAR",
  VarOut: "FE_42_XXJ_OUTVAR",
  ReadAcc: "T_41_XXJ_WS_READDBACCUMULATEDDATA",
  WriteAcc: "T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET",
  WorkShopCode: "T_42_XXJ_WS_WORKSHOPCODE",
  SheetName: "T_40_XXJ_WS_DBTABLENAME",
  SheetKey: "T_40_XXJ_WS_DBKEY_NAMEKEY",
  VectorOperation: "FE_43_XXJ_VECTOR3OPERATIONS",
  VectorDotProduct: "T_34_LY_WS_VDP",
  VectorCrossProduct: "T_34_LY_WS_VCP",
  VectorDistance: "FE_0_HW_CAMERA_DISTANCE",
  VectorIncludedAngle: "T_34_LY_WS_VANG",
  VectorGetter: "FE_43_XXJ_GETVECTOR3COMPONENT",
  VectorSetter: "FE_43_XXJ_SETVECTOR3COMPONENT",
  Vector2Operation: "FE_43_XXJ_VECTOR2OPERATIONS",
  Vector2Getter: "FE_43_XXJ_GETVECTOR2COMPONENT",
  Vector2Setter: "FE_43_XXJ_SETVECTOR2COMPONENT",
  PlayerDataID: "T_43_YU_WS_PLAYERDATAID",
  AnimationClipID: "T_43_YU_WS_ANIMATIONCLIPID",
  PrintInfo: "T_44_XXJ_WS_PRINT",
  LogString: "T_46_META_WS_A_LOG",
  LogWarning: "T_46_META_WS_E_WARNING",
  LogError: "TXT_MESSAGEBOX_ERROR",
  RegisteredAsset: "FE_44_XXJ_GETRIGISTERASSETBYKEY",
  AssetType: "FE_44_XXJ_ASSETTYPE",
  AssetName: "FE_44_XXJ_WS_RIGISTERRESNAME",
  Component: "T_38_WZY_WS_COMPONENT",
  Type: "T_34_WT_WS_ENTITY13_PARAM1",
  NumToString: "FE_46_XXJ_NUMTOFLOAT",
  NumFormatG: "FE_46_XXJ_NUMTOFLOAT2",
  NumFormatType: "FE_46_XXJ_FORMAT",
  NumFormatF: "FE_46_XXJ_NUMTOFLOAT1",
  NumFormatE: "FE_46_XXJ_NUMTOFLOAT3",
  NumFormatN: "FE_46_LJY_NUMTOSTRING5",
  NumFormatP: "FE_46_XXJ_NUMTOFLOAT4",
  FormatValue: "FE_46_XXJ_FORMATVALUE",
  CollectRes: "FE_46_XXJ_RESCOLLECT",
  NecessaryRes: "FE_46_XXJ_MUSTRES",
  DynamicRes: "FE_46_XXJ_DYNAMICRES",
  PersonaID: "T_47_XXJ_WS_PERSONAID",
  ObsoleteTip: "FE_44_XXJ_COMPOBSOLETE",
  Obsoleted: "T_42_XXJ_WS_OBSOLETE",
  AnimationController: "T_49_META_TYP_314_I1_D",
  AnimationState: "T_46_META_WS_A_STATE",
  GetPropertyId: "T_48_META_API_2014_P0"
};
let f = {};
function W0() {
  f = {};
  for (let _ in _e) {
    let s = _;
    f[s] = Oe(_e[s]);
  }
}
var M = /* @__PURE__ */ ((_) => (_.shadow_craftland = "shc", _.action = "a", _.valution = "v", _.event = "e", _.propertyref = "p", _.get_property_id = "gpi", _.list_set = "lis", _.list_get = "lig", _.list_insert = "lii", _.list_append = "lia", _.list_create = "lic", _.list_dictionary = "lid", _.ctrl_ifelse = "ife", _.ctrl_ifelse1 = "ife1", _.loop_while = "lpw", _.loop_forindex = "lpi", _.loop_foreach = "lpe", _.loop_continue = "lpc", _.loop_break = "lpb", _.op_logic = "opl", _.op_compare = "opc", _.op_arith = "opa", _.op_string = "ops", _.input_null = "nul", _.input_pi = "pi", _.input_e = "ie", _.input_int = "ipi", _.input_intplus = "ipp", _.input_float = "ipf", _.input_text = "ipt", _.input_color = "ipc", _.input_boolean = "ipb", _.input_enum = "ipe", _.input_number = "ipn", _.input_vector3 = "ipv", _.input_vector2 = "ipv2", _.input_localization_key = "ipk", _.input_bezier = "ipbz", _.input_tag = "iptag", _.input_textarea = "ipta", _.input_comments = "ipcm", _.key_enum = "kye", _.externvar_get = "exg", _.externvar_set = "exs", _.extern_call_value = "exv", _.extern_call_action = "exa", _.function_definition_valution = "fnv", _.function_definition_action = "fna", _.function_return = "fnr", _.function_xbt_action = "fnxbta", _.function_xbt_condition = "fnxbtc", _.function_mutator_container = "fnc", _.function_mutator_parameter = "fnp", _.function_call_value = "fcv", _.function_call_action = "fca", _.graphvar_get = "grg", _.graphvar_set = "grs", _.pick_entity = "pke", _.pick_hudwidget = "pkw", _.pick_hudwidgetid = "pwi", _.pick_itemgoods = "pki", _.pick_sound = "psd", _.pick_script = "psc", _.pick_xbt = "pxbt", _.pick_csv = "pcv", _.pick_prefab = "pfb", _.pick_icon = "pin", _.pick_texture = "ptx", _.pick_effect = "pef", _.pick_cloth_skin = "pkch", _.pick_weapon_skin = "pkws", _.pick_emote_skin = "pem", _.pick_vehicle_skin = "pvs", _.pick_hud = "pkh", _.pick_obj3d = "pk3", _.raw_resource = "rrs", _.pick_dynamic_create_item = "pkdc", _.pick_effect_type = "pet", _.pick_internal_hud = "pih", _.pick_player_data_id = "ppd", _.pick_animation_clip_id = "pac", _.pick_animation_ctrl_id = "pal", _.pick_material_id = "pim", _.pick_mesh_id = "pme", _.pick_bag_id = "pkbg", _.pick_skill_id = "pkskl", _.pick_scene_id = "pks", _.pick_particles_id = "ppt", _.pick_performance = "pperformance", _.create_hud_deprecated = "chd", _.property_get = "prg", _.property_set = "prs", _.globalvar_get = "glg", _.globalvar_set = "gls", _.shadow_type = "tys", _.shadow_default = "tyd", _.as_type = "tya", _.typeid = "tyi", _.componentid = "tyc", _.localvar_get = "lcg", _.localvar_set = "lcs", _.localvar_def = "lcd", _.this_entity = "ent", _.hud_buttonevent = "hbe", _.sheet_data = "sdt", _.sheet_rank = "srk", _.sheet_statistic = "sst", _.sheet_multicol = "smc", _.sheet_column = "scl", _.read_statistic = "rst", _.write_statistic = "wst", _.read_statistic_v2 = "rst2", _.write_statistic_v2 = "wst2", _.write_statistic_cross_map = "wstc", _.read_statistic_err = "rst3", _.write_statistic_err = "wst3", _.write_statistic_cross_map_err = "wstc3", _.signal_shoot = "sls", _.signal_shootv2 = "slsv2", _.signal_receive = "slr", _.signal_shootV3 = "ss", _.signal_shootV4 = "slsv4", _.vector3_operation = "v3op", _.vector3_get = "v3g", _.vector3_set = "v3s", _.vector3_setxyz = "v3sxyz", _.vector2_operation = "v2op", _.vector2_get = "v2g", _.vector2_set = "v2s", _.vector2_setxy = "v2sxy", _.print_info = "print", _.pick_registeredAsset = "pkassett", _.num_to_string = "n2s", _.pick_persona_id = "persona", _.tuple_get = "tug", _.tuple_set = "tus", _.tuple_create = "tuc", _.animation_state = "ast", _))(M || {});
for (let _ in M)
  M[_];
var ei = /* @__PURE__ */ ((_) => (_.InVar = "", _.OutVar = "o", _))(ei || {});
function bT(_) {
  return "P" + _;
}
var d = /* @__PURE__ */ ((_) => (_.Value = "V", _.Header = "A", _.This = "H", _.Label = "B", _.Item = "I", _.Name = "N", _.Type = "T", _.Property = "P", _.Operator = "O", _.Index = "X", _.Condition = "C", _.ConditionIds = "CIDS", _.Code = "D", _.Return = "R", _.Entity = "E", _.GraphID = "G", _.ParamList = "L", _.V1 = "V1", _.V2 = "V2", _.V3 = "V3", _.From = "FR", _.To = "TO", _.Step = "ST", _.Range = "RN", _.Player = "PL", _.T1 = "T1", _.T2 = "T2", _.Key = "K", _.VarRef = "VR", _.VarID = "VI", _.VarDef = "VD", _.OwnerType = "OT", _.GraphName = "GN", _.Color = "CO", _.ColorStr = "CS", _.Hud = "HD", _.BlockStyle = "BSTYL", _.Bezier = "BZ", _.EntityTag = "ETAG", _.WardrobeType = "WRT", _.TypeLabel = "TPL", _.Owner = "ow", _.AssetType = "AssetTP", _.Version = "VER", _))(d || {}), FE = /* @__PURE__ */ ((_) => (_.Start = "S", _.Wait = "W", _))(FE || {}), Nt = /* @__PURE__ */ ((_) => (_.Unknown = "UK", _.Add = "AD", _.Substract = "SU", _.Multiply = "MU", _.Divide = "DI", _.Mod = "MD", _))(Nt || {}), RE = /* @__PURE__ */ ((_) => (_.And = "AND", _.Or = "OR", _))(RE || {}), PT = /* @__PURE__ */ ((_) => (_.Equal = "EQ", _.NotEqual = "NE", _.Greater = "GT", _.GreaterEqual = "GE", _.Less = "LT", _.LessEqual = "LE", _))(PT || {}), Ze = /* @__PURE__ */ ((_) => (_.Addition = "Addition", _.Subtraction = "Subtraction", _.Multiplication = "Multiplication", _.DotProduct = "DotProduct", _.CrossProduct = "CrossProduct", _.Distance = "Distance", _.IncludedAngle = "IncludedAngle", _))(Ze || {}), mo = /* @__PURE__ */ ((_) => (_.Regular = "G", _.Float = "F", _.ScientificNotation = "E", _.ThousandsSeparator = "N", _.Percentage = "P", _))(mo || {});
function wt(_) {
  if (_.saveExtraState) {
    const s = _.saveExtraState();
    return s ? JSON.stringify(s) : "";
  } else if (_.mutationToDom) {
    const s = _.mutationToDom();
    return s ? g.Xml.domToText(s) : "";
  }
  return "";
}
let z = {
  SceneName: "",
  SceneId: "",
  OwnerType: "",
  ComponentTypes: "",
  curTarget: 0,
  graphElementMap: /* @__PURE__ */ new Map(),
  // key is Graph Element Id
  geIdReverseMap: /* @__PURE__ */ new Map(),
  // block.type=>geId or name=>geId
  internalBlocks: /* @__PURE__ */ new Map(),
  availableInternalModIds: [],
  //get entity Info
  func_getEntityInfo: null,
  func_getPrefabInfo: null,
  func_entityPickList: null,
  func_hudWidgetList: null,
  func_hudList: null,
  func_pickSceneEntity: null,
  func_showResourceSelector: null,
  containsKey: null
};
z.containsKey = function(_, s) {
  return _ ? _.toLowerCase().includes(s) : !1;
};
const wh = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMTAuODA0MiIgeT0iMS44OTQ4OCIgd2lkdGg9IjIuOCIgaGVpZ2h0PSIxMS45IiByeD0iMS40IiB0cmFuc2Zvcm09InJvdGF0ZSg0NSAxMC44MDQyIDEuODk0ODgpIiBzdHJva2U9IiNEQ0UwRTciIHN0cm9rZS13aWR0aD0iMC43Ii8+CjxyZWN0IHg9IjIuODg0NzciIHk9IjEwLjgwNDMiIHdpZHRoPSIxLjQiIGhlaWdodD0iMS40IiByeD0iMC43IiB0cmFuc2Zvcm09InJvdGF0ZSg0NSAyLjg4NDc3IDEwLjgwNDMpIiBzdHJva2U9IiNEQ0UwRTciIHN0cm9rZS13aWR0aD0iMC43Ii8+CjxwYXRoIGQ9Ik05LjU2Njc2IDIuNjM3MzRDMTAuMjUwMiAxLjk1MzkyIDExLjM1ODIgMS45NTM5MiAxMi4wNDE2IDIuNjM3MzRDMTIuNzI1MSAzLjMyMDc2IDEyLjcyNTEgNC40Mjg4IDEyLjA0MTYgNS4xMTIyMUw4LjgyNDMgOC4zMjk1NUw2LjM0OTQzIDUuODU0NjdMOS41NjY3NiAyLjYzNzM0WiIgZmlsbD0iI0RDRTBFNyIvPgo8cGF0aCBkPSJNNS42MDc0OSA0LjYxNzEyQzUuNzQ0MTggNC40ODA0MyA1Ljk2NTc4IDQuNDgwNDMgNi4xMDI0NyA0LjYxNzEyTDEwLjA2MjMgOC41NzY5MUMxMC4xOTg5IDguNzEzNiAxMC4xOTg5IDguOTM1MjEgMTAuMDYyMyA5LjA3MTg5QzkuOTI1NTggOS4yMDg1NyA5LjcwMzk3IDkuMjA4NTcgOS41NjcyOSA5LjA3MTg5TDUuNjA3NDkgNS4xMTIwOUM1LjQ3MDgxIDQuOTc1NDEgNS40NzA4MSA0Ljc1MzggNS42MDc0OSA0LjYxNzEyWiIgZmlsbD0iI0RDRTBFNyIvPgo8L3N2Zz4K", k0 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDQwIDQwIj4KICA8bGluZSB4MT0iMjAiIHkxPSIwIiB4Mj0iMjAiIHkyPSI0MCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSI2IiBvcGFjaXR5PSIwLjUiIC8+CiAgPGxpbmUgeDE9IjAiIHkxPSIyMCIgeDI9IjE3IiB5Mj0iMjAiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iNiIgb3BhY2l0eT0iMC41IiAvPgogIDxsaW5lIHgxPSIyMyIgeTE9IjIwIiB4Mj0iNDAiIHkyPSIyMCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSI2IiBvcGFjaXR5PSIwLjUiIC8+Cjwvc3ZnPg==", F0 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjg1NjkgMTEuODU5OVYxMC43MTQySDE4LjU3MTJWMTEuODU5OUgxMi44NTY5Wk0xMi44NTY5IDE0Ljk5OTlWMTMuODU0M0gxOC41NzEyVjE0Ljk5OTlIMTIuODU2OVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik03LjY0NjMyIDVMOC43MDc0NCA5LjE4MTNMMTIuODczNiA1SDE1TDEzLjk5NDIgNS43NjUxOUw5LjM4NDA2IDEwLjExMzRMMTAuNzcyNSAxNC40ODQ5TDExLjQyODYgMTUuMjI2OUg5LjA3NjM1TDcuOTM2MTIgMTEuMjU4NkwzLjg0OTA3IDE1LjIyNjlIMS40Mjg3NUwyLjY5NTczIDE0LjQ4NDlMNy4yODE3OSAxMC4xMTM0TDUuOTQ5MDQgNS43NjUxOUw1IDVINy42NDYzMloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=", Lo = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS41IDAuNUgwLjVWMTEuNUgxMS41VjAuNVpNNi44NzUgMi41SDUuMTI1VjUuMTI1SDIuNVY2Ljg3NUg1LjEyNVY5LjVINi44NzVWNi44NzVIOS41VjUuMTI1SDYuODc1VjIuNVoiIGZpbGw9IiNEQ0UwRTciLz4KPC9zdmc+Cg==", fT = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS41IDAuNUgwLjVWMTEuNUgxMS41VjAuNVpNOS41IDUuMTI1VjYuODc1SDIuNVY1LjEyNUg5LjVaIiBmaWxsPSIjRENFMEU3Ii8+Cjwvc3ZnPgo=", MI = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMiIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDIgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxsaW5lIHgxPSIxLjI1IiB5MT0iLTIuMTg1NTdlLTA4IiB4Mj0iMS4yNSIgeTI9IjI0IiBzdHJva2U9IiMyNzI3MzQiLz4KPC9zdmc+Cg==";
function __(_, s, r = !0) {
  _.getSourceBlock().workspace.IsCraftland && (s = {
    type: M.shadow_craftland
  });
  const a = function(p, E) {
    return JSON.stringify(p) === JSON.stringify(E);
  };
  _.connection.setShadowState(s), setTimeout(() => {
    var h;
    let p = (h = _.connection) == null ? void 0 : h.getShadowState(!0), E;
    p ? p.type == s.type ? r && !a(p.extraState || "", s.extraState || "") && (E = p, E.extraState = s.extraState) : p.type == M.shadow_type && !a(p, s) && (E = s) : E = s, E && _.connection.setShadowState(E);
  });
}
function _n(_, s, r = !1) {
  if (_.setCheck(s), _.getSourceBlock().isInsertionMarker())
    return;
  if (_.getSourceBlock().workspace.IsCraftland) {
    let E = {
      type: M.shadow_craftland
    };
    _.connection.setShadowState(E);
    return;
  }
  let a = _.connection.getShadowState();
  if (a == null) {
    if (!r)
      return;
    a = xe(s), _.connection.setShadowState(a);
    return;
  }
  let p = _.connection.targetBlock();
  p && p.isShadow() && p.rendered && p.UpdateShadowVarType ? p.UpdateShadowVarType(s) : (a.type == M.shadow_type || r) && (a = xe(s), _.connection.setShadowState(a));
}
let w0 = !1, mI = {
  varType: "",
  onchange(_) {
    if (_ instanceof X.Events.Click) {
      if (_.blockId != this.id || this.isInFlyout)
        return;
      let s = Date.now(), r = s - this.dbclickCheck;
      r > 0 && r < 500 ? (this.createBlock(w0), this.dbclickCheck = 0) : this.dbclickCheck = s;
    }
  },
  createBlock(_ = !1) {
    if (this.getParent() == null)
      return;
    const r = Ae.CurrentDescriptionFile;
    let i = r.GetVarType(this.varType);
    if (i == null)
      return;
    let a = this.workspace, p = a == null ? void 0 : a.graphData, E = (p == null ? void 0 : p.componentTypes) ?? (p == null ? void 0 : p.ownerType), h = em(i, r, { ownerType: E }, _);
    if (h) {
      g.Events.setGroup(!0);
      const L = g.serialization.blocks.append(h, this.workspace, { recordUndo: !0 });
      this.outputConnection.targetConnection.connect(L.outputConnection), g.Events.setGroup(!1);
    }
  },
  dbclickCheck: 0
}, B0 = {
  ...mI,
  varType: "",
  /** placeholder默认是对应类型的名称，也可以手动设置 */
  placeholder: "",
  geId: M.shadow_type,
  init() {
    let _ = new X.FieldLabel("");
    this.workspace.IsCraftland && (_.minWidth = 40), this.appendDummyInput().appendField(_, d.Label), this.setOutput(!0), this.varType = "", this.setStyle("shadow_blocks"), this.svgGroup_.setAttribute("class", "shadow-block");
  },
  UpdateShadowVarType(_, s) {
    var E;
    let r = Ae.CurrentDescriptionFile, i = (E = this.outputConnection.targetConnection) == null ? void 0 : E.getCheck();
    if (i && i.length > 0 && (_ = i[0]), _ == this.varType)
      return;
    let a = r.GetVarType(_), p = a ? a.Label : _ + f.UnkownType;
    this.setFieldValue(s || p, d.Label), this.setOutput(!0), this.varType = _;
  },
  saveExtraState() {
    let _ = this.varType;
    return this.placeholder && (_ += "__" + this.placeholder), _;
  },
  loadExtraState(_) {
    let s = this.varType;
    if (typeof _ == "string") {
      let r = _.split("__");
      s = r[0], this.placeholder = r[1] || "";
    }
    this.UpdateShadowVarType(s, this.placeholder);
  }
}, Y0 = {
  ...mI,
  varType: "",
  geId: M.shadow_type,
  init() {
    this.appendDummyInput().appendField("", d.Label), this.setOutput(!0), this.varType = "", this.setStyle("shadow_blocks"), this.svgGroup_.setAttribute("class", "shadow-block");
  },
  UpdateShadowVarType(_) {
    var a;
    let s = Ae.CurrentDescriptionFile, r = (a = this.outputConnection.targetConnection) == null ? void 0 : a.getCheck();
    if (r && r.length > 0 && (_ = r[0]), _ == this.varType)
      return;
    this.varType = _;
    let i = s.GetVarType(_);
    if (i != null)
      if (s.IsArray(i))
        this.setFieldValue("[]", d.Label);
      else if (i.IsEnum) {
        let p = i.Items.get_Item(0);
        p ? this.setFieldValue(p.Label, d.Label) : this.setFieldValue(f.NULL, d.Label);
      } else
        i == s.intType || i == s.numberType || i == s.floatType ? this.setFieldValue("0", d.Label) : i == s.boolType ? this.setFieldValue(f.False, d.Label) : i == s.stringType ? this.setFieldValue('""', d.Label) : i == s.vector3Type ? this.setFieldValue("0 0 0", d.Label) : i == s.vector2Type ? this.setFieldValue("0 0", d.Label) : i == s.GetVarType("Color") ? this.setFieldValue("#FFFFFF", d.Label) : this.setFieldValue(f.NULL, d.Label);
  },
  saveExtraState() {
    return this.varType;
  },
  loadExtraState(_) {
    let s = this.varType;
    typeof _ == "string" && (s = _), this.UpdateShadowVarType(s);
  }
}, U0 = {
  init() {
    this.appendDummyInput().appendField(" ").appendField(new X.FieldImage(k0, 18, 18, "+"), d.Label).appendField(" "), this.setOutput(!0), this.setStyle("shadow_blocks"), this.svgGroup_.setAttribute("class", "shadow-block");
  }
};
const V0 = function(_, s) {
  if (s.CheckIsAssignable(s.GetVarType("HudWidget"), _))
    return [{
      kind: "block",
      type: M.valution,
      extraState: {
        [d.Index]: 102,
        [d.ParamList]: [2, 3]
      }
    }];
}, G0 = (_, s, r) => {
  if (s.CheckIsAssignable(s.entityType, _) && s.CheckIsAssignable(_, r))
    return z.internalBlocks.get("this_entity");
}, H0 = (_, s) => {
  var r, i;
  if (s.CheckIsAssignable(_, s.GetVarType("MapT_any_any"))) {
    let a = Object.assign({}, z.internalBlocks.get("map_dictionary"));
    return a.fields = {
      [d.T1]: ((r = _.ElementTypes) == null ? void 0 : r[0]) ?? "",
      [d.T2]: ((i = _.ElementTypes) == null ? void 0 : i[1]) ?? ""
    }, a;
  }
}, x0 = (_, s) => {
  if (s.CheckIsAssignable(_, s.GetVarType("ListT_any"))) {
    let r = q0(_, s.arrayType, s), i = [];
    if (r) {
      for (let a of r) {
        let p = Object.assign({}, z.internalBlocks.get("list_create"));
        p.fields = {
          [d.Type]: a.ElementType
        }, i.push(p);
      }
      return i;
    }
  }
}, PI = (_, s) => {
  if (s.CheckIsAssignable(_, s.numberType))
    return z.internalBlocks.get("input_number");
}, DI = (_, s) => {
  if (s.CheckIsAssignable(_, s.stringType))
    return z.internalBlocks.get("input_text");
}, X0 = (_, s) => {
  if (s.CheckIsAssignable(_, s.floatType))
    return z.internalBlocks.get("input_float");
}, K0 = (_, s) => {
  if (s.CheckIsAssignable(_, s.intType))
    return z.internalBlocks.get("input_int");
}, J0 = (_, s) => {
  if (s.CheckIsAssignable(_, s.GetVarType("Color")))
    return z.internalBlocks.get("input_color");
}, LI = (_, s) => {
  if (s.CheckIsAssignable(_, s.boolType))
    return z.internalBlocks.get("logic_boolean");
}, j0 = (_, s) => {
  if (s.CheckIsAssignable(_, s.vector3Type))
    return {
      kind: "block",
      type: M.valution,
      extraState: {
        [d.Index]: 56,
        [d.ParamList]: [1, 2, 3]
      }
    };
}, z0 = (_, s) => {
  if (s.CheckIsAssignable(_, s.vector2Type))
    return {
      kind: "block",
      type: M.valution,
      extraState: {
        [d.Index]: 702,
        [d.ParamList]: [1, 2]
      }
    };
}, Z0 = (_, s) => {
  if (_ == s.anyType || _ == s.objectType) {
    let r = [], i = [
      DI,
      PI,
      LI
    ];
    for (let a of i) {
      let p = a(_, s);
      vh.isArray(p) ? r.push(...p) : p && r.push(p);
    }
    return r;
  }
};
let Q0 = [
  (_) => z.internalBlocks.get(_.Name),
  (_) => {
    if (_.IsEnum) {
      let s = {
        type: M.input_enum,
        extraState: _.Name
      }, r = z.geIdReverseMap.get(_.Name);
      if (r) {
        let i = z.graphElementMap.get(r);
        s = z.internalBlocks.get(i.fe_custom), s || (s = {
          type: M.input_enum,
          extraState: r
        });
      }
      return s;
    }
  },
  V0,
  G0,
  H0,
  x0,
  PI,
  DI,
  X0,
  K0,
  J0,
  LI,
  z0,
  j0
];
function q0(_, s, r) {
  if (_ = r.GetFormalLogicNoBases(_.Name), _ instanceof Vr && _.Operator == hI.Or) {
    let i = [];
    for (let a of _.SubLogics) {
      let p = a;
      r.CheckIsAssignable(s, p) && i.push(p);
    }
    return i.length ? i : null;
  }
  return r.CheckIsAssignable(s, _) ? [_] : null;
}
function em(_, s, r, i) {
  let a, p = s.GetVarType(r.ownerType), E = 0;
  i && (E = 1);
  let h = Z0(_, s);
  if (h)
    a = h;
  else {
    a = [];
    for (let L of Q0) {
      let y = L(_, s, p);
      if (y)
        if (vh.isArray(y)) {
          for (let V of y)
            if (a.push(V), a.length > E)
              break;
        } else
          a.push(y);
      if (y === !1 || a.length > E)
        break;
    }
  }
  if (a.length > 0)
    return E = E % a.length, a[E];
}
function xe(_) {
  return {
    type: M.shadow_type,
    extraState: _
  };
}
function tm(_) {
  return {
    type: M.shadow_default,
    extraState: _
  };
}
function rm(_) {
  g.Blocks[M.shadow_type] = B0, g.Blocks[M.shadow_default] = Y0, g.Blocks[M.shadow_craftland] = U0;
}
function Bh() {
  const _ = this.getConstants();
  this.borderRect_ && (this.borderRect_.setAttribute("width", `${this.size_.width}`), this.getSourceBlock().isShadow() ? (this.borderRect_.setAttribute("height", `${_.FIELD_IN_SHADOW_BORDER_RECT_HEIGHT}`), this.borderRect_.setAttribute("y", `${_.FIELD_BORDER_RECT_Y_PADDING}`)) : this.borderRect_.setAttribute("height", `${_.FIELD_BORDER_RECT_HEIGHT}`));
}
const qc = class qc extends g.FieldDropdown {
  //override
  constructor(r, i, a) {
    var s = (...PR) => (super(...PR), //@ts-ignore
    N(this, "menuGenerator_"), this);
    if (g.Field.SKIP_SETUP === r ? s(r) : s(r, i, a), r === g.Field.SKIP_SETUP)
      return;
    this.menuGenerator_ = r, this.validator_ = null;
    let p = this.getOptions(!0);
    if (p != null) {
      for (let E = 0; E < p.length; ++E)
        if (!p[E][1].startsWith(qc.SpecialItem)) {
          this.selectedOption = p[E], this.setValue(p[E][1]);
          break;
        }
    }
    i && this.setValidator(i);
  }
  initView() {
    super.initView(), this.clickTarget_ = this.getSvgRoot();
  }
  positionBorderRect_() {
    Bh.bind(this)();
  }
  setOptions(r) {
    this.menuGenerator_ = r, this.UpdateDisplay();
  }
  setValue(r) {
    r.startsWith(qc.SpecialItem) || super.setValue(r);
  }
  shouldAddBorderRect_() {
    let r = super.shouldAddBorderRect_(), i = 0;
    for (let a = 0, p; p = this.getSourceBlock().inputList[a]; a++) {
      for (let E = 0; p.fieldRow[E]; E++)
        if (p.fieldRow[E].EDITABLE && i++, i >= 2)
          return !0;
      if (p.connection)
        return !0;
    }
    return r;
  }
  getText_() {
    let r = this;
    if (!r.selectedOption)
      return null;
    const i = r.selectedOption[2] || r.selectedOption[0];
    return typeof i == "object" && i != null ? i.alt : i;
  }
  UpdateDisplay() {
    let r = this, i = this.getValue(), a = this.getText();
    this.getOptions(), r.selectedOption = [i + f.UnkownType, i], this.doValueUpdate_(i), this.getText() != a && (this.markDirty(), this.forceRerender());
  }
  getOptions(r) {
    let i = super.getOptions(r), a = this;
    if (!r) {
      let p = this.getValue(), E = this.getText();
      a.selectedOption = [p + f.UnkownType, p], this.doValueUpdate_(p), this.getText() != E && (this.markDirty(), this.forceRerender());
    }
    return i;
  }
  doClassValidation_(r) {
    return r;
  }
  getValueDefaultOptions(r) {
    var i;
    return (i = this.sourceBlock_) != null && i.workspace.IsCraftland ? this.getOptions(!0)[0] ?? [f.Unselected, r] : r == "" ? [f.Unselected, r] : [r + f.UnkownType, r];
  }
  doValueUpdate_(r) {
    let i = this;
    i.selectedOption = this.getValueDefaultOptions(r), super.doValueUpdate_(r);
  }
  onItemSelected_(r, i) {
    let a = i.getValue();
    return a.startsWith(qc.SpecialItem) || this.setValue(a), !0;
  }
  getTextElement() {
    return this.textElement_;
  }
};
N(qc, "SpecialItem", "DROPDOWNV2SPECIALITEM");
let pt = qc;
class Yn extends pt {
  constructor(r, i, a) {
    super(r, i, a);
    N(this, "showSearch", !1);
    N(this, "selectTree_", null);
    a && typeof a.showSearch == "boolean" && (this.showSearch = a.showSearch);
  }
  /**
   * Create a dropdown menu under the text.
   * @param {Event=} opt_e Optional mouse event that triggered the field to
   *     open, or undefined if triggered programmatically.
   * @protected
   */
  showEditor_(r) {
    this.selectTreeCreate_(), X.DropDownDiv.clearContent();
    const i = X.DropDownDiv.getContentDiv(), a = this.selectTree_.$mount();
    i.appendChild(a.$el), X.DropDownDiv.showPositionedByField(this, this.selectTreeDispose_.bind(this));
  }
  getDropdownData() {
    return null;
  }
  /**
   * Create the select tree editor.
   * @private
   */
  selectTreeCreate_() {
  }
  /**
   * Disposes of events and DOM-references belonging to the select tree editor.
   * @private
   */
  selectTreeDispose_() {
    this.selectTree_ && this.selectTree_.$destroy(), this.selectTree_ = null;
  }
  /**
   * Handle an action in the select tree.
   * @param nodeItem The selected tree node.
   * @private
   */
  handleSelectTreeActionEvent_(r) {
    X.DropDownDiv.hideIfOwner(this, !0), this.onNodeSelected_(r);
  }
  /**
   * Handle the selection of an item in the select tree.
   * @param nodeItem The selected node.
   * @protected
   */
  onNodeSelected_(r) {
    this.setValue(r.value);
  }
}
const P4 = "!!More";
class ni extends Yn {
  constructor(r, i, a) {
    super([[f.Unselected, ""]]);
    N(this, "baseType", "");
    N(this, "hasAuto", !1);
    N(this, "hasMore", !1);
    N(this, "curMore", !1);
    N(this, "checkExtension", !1);
    N(this, "autoLabel", "");
    this.menuGenerator_ = this.TypeGenerator, typeof r == "string" ? this.baseType = r : (this.baseType = r.baseType ?? "", this.hasMore = r.hasMore ?? !1, this.hasAuto = r.hasAuto ?? !1, this.checkExtension = r.checkExtension ?? !1);
    let p = this.getOptions();
    a && this.configure_(a);
    for (let E = 0; E < p.length; ++E)
      if (!p[E][1].startsWith(pt.SpecialItem)) {
        this.setValue(p[E][1]);
        break;
      }
    this.validator_ = i;
  }
  positionBorderRect_() {
    Bh.bind(this)();
  }
  doClassValidation_(r) {
    let i = Ae.CurrentDescriptionFile.GetVarType(r);
    return i ? i.Name : r;
  }
  getValueDefaultOptions(r) {
    if (!r)
      return [f.Unselected, "", "", { style: "fill: var(--red_err5);" }];
    let i = Ae.CurrentDescriptionFile.GetVarType(r);
    return i ? [i.Label, i.Name, ""] : [r + f.UnkownType, r, "", { style: "fill: var(--red_err5);" }];
  }
  showEditor(r) {
    this.curMore = !1, super.showEditor(r);
  }
  doValueUpdate_(r) {
    if (r == P4) {
      this.curMore = !0, this.showEditor_();
      return;
    }
    super.doValueUpdate_(r);
  }
  SetAutoLabel(r) {
    this.autoLabel != r && (this.autoLabel = r, this.UpdateDisplay());
  }
  TypeGenerator() {
    let r = Ae.CurrentDescriptionFile, i = [], a = this.getValue(), p = r.GetVarType(a), E = r.GetVarType(this.baseType);
    if (this.curMore && (E = null), p && p != r.anyType) {
      let L = i.length;
      if (r.IsArray(p)) {
        var h = r.GetVarType(p.ElementType);
        h != null && (E == null || Bn.CheckIsAssignable(E, h, r)) && i.findIndex((Z) => Z[1] === h.Name) === -1 && i.push([h.Label, h.Name]);
      }
      let y = r.GetGenericVarType(r.listGenericType, p);
      (E == null || r.CheckIsAssignable(E, y)) && i.findIndex((Z) => Z[1] === y.Name) === -1 && i.push([y.Label, y.Name]), L != i.length && i.splice(L, 0, ["----------------", pt.SpecialItem + "--"]);
    }
    if (this.hasAuto) {
      let L = "Auto";
      this.autoLabel && (L += "(" + this.autoLabel + ")"), i.unshift([L, "$Auto"]);
    }
    return this.hasMore && E && !this.curMore && E != r.anyType && E != r.objectType && i.push([f.More, P4]), i.length == 0 && i.push(["None", ""]), i;
  }
  getDropdownData() {
    return [];
  }
}
let Yh = {
  type: M.input_intplus
}, ES = {
  geId: void 0,
  getElementType() {
    let _ = "", s = Ae.CurrentDescriptionFile, r, i = this.getInput(d.This);
    if (i != null && (r = i.connection.targetBlock()), r != null) {
      let a = r.outputConnection.getCheck();
      if (a != null) {
        let p = s.GetVarType(a[0]);
        p != null && s.IsArray(p) && (_ = p.ElementType);
      }
    }
    return _;
  }
};
function nm() {
  let _ = null, s = this.outputConnection.getCheck();
  s != null && s.length == 1 && (_ = s[0]);
  let r = this.getElementType();
  return r != _ ? (this.setOutput(!0, r), !0) : !1;
}
function Uh() {
  let _ = this.getInput(d.Value), s = _.connection.getCheck(), r = null;
  s && s.length == 1 && (r = s[0]);
  let i = this.getElementType();
  return r != i && _n(_, i), !1;
}
let _m = {
  ...ES,
  geId: M.list_get,
  locKey: _e.ListGet,
  init() {
    this.appendValueInput(d.This).setAlign(g.ALIGN_RIGHT).appendField(f.ListGet).setCheck("[]").connection.setShadowState(xe("[]")), this.appendValueInput(d.Index).setCheck("int").connection.setShadowState(Yh), this.setInputsInline(!0), this.setTooltip(""), this.setHelpUrl(""), this.setOutput(!0, ""), this.setStyle("data_blocks");
  },
  DetermineTypes: nm,
  search(_, s) {
    return [f.ListTypeLabel, f.ListGet].find((r) => z.containsKey(r, _)) || !1;
  }
}, im = {
  ...ES,
  debugAvailable: !0,
  geId: M.list_set,
  locKey: _e.ListTypeLabel,
  init() {
    this.appendValueInput(d.This).setAlign(g.ALIGN_RIGHT).appendField(f.ListSet).setCheck("[]").connection.setShadowState(xe("[]")), this.appendValueInput(d.Index).appendField(f.ListSet_1).setAlign(g.ALIGN_RIGHT).setCheck("int").connection.setShadowState(Yh), this.appendValueInput(d.Value).appendField(f.ListSet_2).connection.setShadowState(xe("")), this.setInputsInline(!0), this.setTooltip(""), this.setHelpUrl(""), this.setPreviousStatement(!0), this.setNextStatement(!0, "action"), this.setStyle("data_blocks");
  },
  DetermineTypes: Uh,
  search(_, s) {
    return !1;
  }
}, om = {
  ...ES,
  debugAvailable: !0,
  geId: M.list_append,
  locKey: _e.ListAppend,
  init() {
    this.appendValueInput(d.This).setAlign(g.ALIGN_RIGHT).appendField(f.ListAppend).setCheck("[]").connection.setShadowState(xe("[]")), this.appendValueInput(d.Value).appendField(f.ListAppend_1).connection.setShadowState(xe("")), this.setInputsInline(!0), this.setTooltip(""), this.setHelpUrl(""), this.setPreviousStatement(!0), this.setNextStatement(!0, "action"), this.setStyle("data_blocks");
  },
  DetermineTypes: Uh,
  search(_, s) {
    return !1;
  }
}, Tm = {
  ...ES,
  geId: M.list_insert,
  locKey: _e.ListInsert,
  init() {
    this.appendValueInput(d.This).setAlign(g.ALIGN_RIGHT).appendField(f.ListInsert).setCheck("[]").connection.setShadowState(xe("[]")), this.appendValueInput(d.Value).appendField(f.ListInsert_1).connection.setShadowState(xe("")), this.appendValueInput(d.Index).appendField(f.ListInsert_2).setAlign(g.ALIGN_RIGHT).setCheck("int").connection.setShadowState(Yh), this.setInputsInline(!0), this.setTooltip(""), this.setHelpUrl(""), this.setPreviousStatement(!0), this.setNextStatement(!0, "action"), this.setStyle("data_blocks");
  },
  DetermineTypes: Uh,
  search(_, s) {
    return !1;
  }
}, sm = {
  itemCount_: 0,
  locKey: _e.ListCreate,
  init() {
    this.itemCount_ = 0, this.setInputsInline(!0), this.appendDummyInput().appendField(new g.FieldImage(Lo, 14, 14, "+", (_) => this.onAddItem(_))).appendField(f.ListCreate).appendField(new ni(""), d.Type), this.setStyle("data_blocks"), this.varType = "any", this.setOutput(!0, "ListT_any");
  },
  /**
   * Returns the state of this block as a JSON serializable object.
   * @return {{itemCount: number}} The state of this block, ie the item count.
   */
  saveExtraState: function() {
    return {
      [d.Index]: this.itemCount_
    };
  },
  /**
   * Applies the given state to this block.
   * @param {*} state The state to apply to this block, ie the item count.
   */
  loadExtraState: function(_) {
    this.updateShape_(_[d.Index]);
  },
  updateShape_(_) {
    for (; this.itemCount_ < _; )
      this.addPart_();
    for (; this.itemCount_ > _; )
      this.removePart_();
  },
  addPart_: function() {
    this.appendDummyInput("NEW_LINE_" + this.itemCount_), this.appendValueInput(d.Item + this.itemCount_).appendField(new g.FieldImage(fT, 14, 14, "-", (_) => this.onRemoveItem(_)), this.itemCount_.toString()).appendField("[" + this.itemCount_ + "]").setCheck(this.varType).connection.setShadowState(xe(this.varType)), this.itemCount_++;
  },
  removePart_: function() {
    this.itemCount_--, this.removeInput("NEW_LINE_" + this.itemCount_), this.removeInput(d.Item + this.itemCount_);
  },
  onAddItem(_) {
    g.Events.setGroup(!0);
    const s = wt(this);
    this.addPart_();
    const r = wt(this);
    s != r && g.Events.fire(new g.Events.BlockChange(
      this,
      "mutation",
      null,
      s,
      r
    )), g.Events.setGroup(!1);
  },
  onRemoveItem(_) {
    var a;
    g.Events.setGroup(!0);
    const s = wt(this);
    let r = Number(_.name);
    for (let p = r; p < this.itemCount_; ++p) {
      let E = this.inputList[p * 2 + 2], h = this.inputList[(p + 1) * 2 + 2];
      E != null && E.connection.targetConnection && ((a = E.connection.targetBlock()) == null || a.dispose(!0)), E && (h != null && h.connection.targetConnection) && E.connection.connect(h.connection.targetConnection);
    }
    this.removePart_();
    const i = wt(this);
    s != i && g.Events.fire(new g.Events.BlockChange(
      this,
      "mutation",
      null,
      s,
      i
    )), g.Events.setGroup(!1);
  },
  DetermineTypes() {
    let _ = this.getFieldValue(d.Type);
    if (this.varType != _) {
      this.varType = _;
      for (let a = 0; a < this.itemCount_; a++)
        this.inputList[a * 2 + 2].setCheck(this.varType).connection.setShadowState(xe(this.varType));
      var s = Ae.CurrentDescriptionFile, r = s.GetVarType(_);
      r == null && (r = s.anyType);
      var i = s.GetGenericVarType(s.listGenericType, r);
      return this.setOutput(!0, i.Name), !0;
    }
  },
  search(_, s) {
    return [f.ListCreate, "ListCreate", "array"].find((r) => z.containsKey(r, _)) || !1;
  }
}, lm = {
  itemCount: 0,
  keyType: "any",
  valueType: "any",
  locKey: _e.NewMap,
  init() {
    this.setInputsInline(!0), this.appendDummyInput().appendField(new g.FieldImage(Lo, 14, 14, "+", () => {
      this.onAddItem();
    })).appendField(f.NewMap).appendField("Key").appendField(new ni(""), d.T1).appendField("Value").appendField(new ni(""), d.T2), this.setStyle("data_blocks"), this.setOutput(!0, "MapT_any_any");
  },
  saveExtraState() {
    return {
      [d.Index]: this.itemCount
    };
  },
  loadExtraState(_) {
    this.updateShape_(_[d.Index]);
  },
  DetermineTypes() {
    let _ = this.getFieldValue(d.T1), s = this.getFieldValue(d.T2), r = !1, i = !1;
    if (_ !== this.keyType && (r = !0, this.keyType = _), s !== this.valueType && (i = !0, this.valueType = s), r || i) {
      for (let a = 0; a < this.itemCount; a++)
        r && this.inputList[a * 3 + 2].setCheck(this.keyType).connection.setShadowState(xe(this.keyType + "__Key")), i && this.inputList[a * 3 + 3].setCheck(this.valueType).connection.setShadowState(xe(this.valueType + "__Value"));
      this.setOutput(!0, `MapT_${_}_${s}`);
    }
    return r || i;
  },
  updateShape_(_) {
    for (; this.itemCount < _; )
      this.addPart();
    for (; this.itemCount > _; )
      this.deletePart();
  },
  onAddItem() {
    g.Events.setGroup(!0);
    const _ = wt(this);
    this.addPart();
    const s = wt(this);
    _ != s && g.Events.fire(new g.Events.BlockChange(this, "mutation", null, _, s)), g.Events.setGroup(!1);
  },
  addPart() {
    this.appendDummyInput("NEW_LINE_" + this.itemCount).appendField(
      new g.FieldImage(fT, 14, 14, "-", (_) => this.onDeleteItem(_)),
      this.itemCount.toString()
    ), this.appendValueInput(d.Key + this.itemCount).setCheck(this.keyType).connection.setShadowState(xe(this.keyType + "__Key")), this.appendValueInput(d.Value + this.itemCount).setCheck(this.valueType).connection.setShadowState(xe(this.valueType + "__Value")), this.itemCount++;
  },
  onDeleteItem(_) {
    var a, p;
    if (!_.name)
      return;
    g.Events.setGroup(!0);
    const s = wt(this), r = Number(_.name);
    for (let E = r; E < this.itemCount; E++) {
      const h = this.inputList[E * 3 + 2], L = this.inputList[(E + 1) * 3 + 2];
      h != null && h.connection.targetConnection && ((a = h.connection.targetBlock()) == null || a.dispose(!0)), h && (L != null && L.connection.targetConnection) && h.connection.connect(L.connection.targetConnection);
      const y = this.inputList[E * 3 + 3], V = this.inputList[(E + 1) * 3 + 3];
      y != null && y.connection.targetConnection && ((p = y.connection.targetBlock()) == null || p.dispose(!0)), y && (V != null && V.connection.targetConnection) && y.connection.connect(V.connection.targetConnection);
    }
    this.deletePart();
    const i = wt(this);
    s != i && g.Events.fire(new g.Events.BlockChange(this, "mutation", null, s, i)), g.Events.setGroup(!1);
  },
  deletePart() {
    this.itemCount--, this.removeInput("NEW_LINE_" + this.itemCount), this.removeInput(d.Key + this.itemCount), this.removeInput(d.Value + this.itemCount);
  },
  search(_) {
    return [f.NewMap, "NewMap"].find((s) => z.containsKey(s, _)) || !1;
  }
};
function am(_) {
  g.Blocks[M.list_get] = _m, g.Blocks[M.list_set] = im, g.Blocks[M.list_append] = om, g.Blocks[M.list_insert] = Tm, g.Blocks[M.list_create] = sm, g.Blocks[M.list_dictionary] = lm, _.set("array_get", { kind: "block", type: M.list_get }), _.set("array_set", { kind: "block", type: M.list_set }), _.set("list_append", { kind: "block", type: M.list_append }), _.set("list_insert", { kind: "block", type: M.list_insert }), _.set("list_create", { kind: "block", type: M.list_create }), _.set("map_dictionary", { kind: "block", type: M.list_dictionary });
}
const { dom: eS, aria: tS, userAgent: lh, Coordinate: cm } = X.utils, uS = class uS extends X.Field {
  /**
   * @param value The initial value of the field. Should cast to a string.
   *     Defaults to an empty string if null or undefined. Also accepts
   *     Field.SKIP_SETUP if you wish to skip setup (only used by subclasses
   *     that want to handle configuration and setting the field value after
   *     their own constructors have run).
   * @param validator A function that is called to validate changes to the
   *     field's value. Takes in a string & returns a validated string, or null
   *     to abort the change.
   * @param config A map of options used to configure the field.
   *     See the [field creation documentation]{@link
   * https://developers.google.com/blockly/guides/create-custom-blocks/fields/built-in-fields/text-input#creation}
   * for a list of properties this parameter supports.
   */
  constructor(r, i, a) {
    super(X.Field.SKIP_SETUP);
    /** Allow browser to spellcheck this field. */
    N(this, "spellcheck_", !0);
    /** The HTML input element. */
    N(this, "htmlInput_", null);
    /** True if the field's value is currently being edited via the UI. */
    N(this, "isBeingEdited_", !1);
    /**
     * True if the value currently displayed in the field's editory UI is valid.
     */
    N(this, "isTextValid_", !1);
    /** Key down event data. */
    N(this, "onKeyDownWrapper_", null);
    /** Key input event data. */
    N(this, "onKeyInputWrapper_", null);
    /**
     * Whether the field should consider the whole parent block to be its click
     * target.
     */
    N(this, "fullBlockClickTarget_", !1);
    /** The workspace that this field belongs to. */
    N(this, "workspace_", null);
    /**
     * Serializable fields are saved by the serializer, non-serializable fields
     * are not. Editable fields should also be serializable.
     */
    N(this, "SERIALIZABLE", !0);
    /** Mouse cursor style when over the hotspot that initiates the editor. */
    N(this, "CURSOR", "text");
    r !== X.Field.SKIP_SETUP && (a && this.configure_(a), this.setValue(r), i && this.setValidator(i));
  }
  configure_(r) {
    super.configure_(r), r.spellcheck !== void 0 && (this.spellcheck_ = r.spellcheck);
  }
  /** @internal */
  initView() {
    const r = this.getSourceBlock();
    if (!r)
      throw new X.UnattachedFieldError();
    if (this.getConstants().FULL_BLOCK_FIELDS) {
      let i = 0, a = 0;
      for (let p = 0, E; E = r.inputList[p]; p++) {
        for (let h = 0; E.fieldRow[h]; h++)
          i++;
        E.connection && a++;
      }
      this.fullBlockClickTarget_ = i <= 1 && r.outputConnection && !a;
    } else
      this.fullBlockClickTarget_ = !1;
    this.fullBlockClickTarget_ ? this.clickTarget_ = this.sourceBlock_.getSvgRoot() : this.createBorderRect_(), this.createTextElement_();
  }
  /**
   * Called by setValue if the text input is not valid. If the field is
   * currently being edited it reverts value of the field to the previous
   * value while allowing the display text to be handled by the htmlInput_.
   *
   * @param _invalidValue The input value that was determined to be invalid.
   *    This is not used by the text input because its display value is stored
   * on the htmlInput_.
   */
  doValueInvalid_(r) {
    if (this.isBeingEdited_) {
      this.isDirty_ = !0, this.isTextValid_ = !1;
      const i = this.value_;
      this.value_ = this.htmlInput_.getAttribute("data-untyped-default-value"), this.sourceBlock_ && X.Events.isEnabled() && X.Events.fire(new (X.Events.get(X.Events.BLOCK_CHANGE))(
        this.sourceBlock_,
        "field",
        this.name || null,
        i,
        this.value_
      ));
    }
  }
  /**
   * Called by setValue if the text input is valid. Updates the value of the
   * field, and updates the text of the field if it is not currently being
   * edited (i.e. handled by the htmlInput_).
   *
   * @param newValue The value to be saved. The default validator guarantees
   *     that this is a string.
   */
  doValueUpdate_(r) {
    this.isDirty_ = !0, this.isTextValid_ = !0, this.value_ = r;
  }
  /**
   * Updates text field to match the colour/style of the block.
   *
   * @internal
   */
  applyColour() {
    if (!this.sourceBlock_ || !this.getConstants().FULL_BLOCK_FIELDS)
      return;
    const r = this.sourceBlock_;
    this.borderRect_ ? this.borderRect_.setAttribute("stroke", r.style.colourTertiary) : r.pathObject.svgPath.setAttribute(
      "fill",
      this.getConstants().FIELD_BORDER_RECT_COLOUR
    );
  }
  /**
   * Updates the colour of the htmlInput given the current validity of the
   * field's value.
   */
  render_() {
    if (super.render_(), this.isBeingEdited_) {
      this.resizeEditor_();
      const r = this.htmlInput_;
      this.isTextValid_ ? (eS.removeClass(r, "blocklyInvalidInput"), tS.setState(r, tS.State.INVALID, !1)) : (eS.addClass(r, "blocklyInvalidInput"), tS.setState(r, tS.State.INVALID, !0));
    }
  }
  /**
   * Set whether this field is spellchecked by the browser.
   *
   * @param check True if checked.
   */
  setSpellcheck(r) {
    r !== this.spellcheck_ && (this.spellcheck_ = r, this.htmlInput_ && this.htmlInput_.setAttribute(
      "spellcheck",
      this.spellcheck_
    ));
  }
  /**
   * Show an editor for the field.
   * Shows the inline free-text editor on top of the text by default.
   * Shows a prompt editor for mobile browsers if the modalInputs option is
   * enabled.
   *
   * @param _e Optional mouse event that triggered the field to open, or
   *     undefined if triggered programmatically.
   * @param quietInput True if editor should be created without focus.
   *     Defaults to false.
   */
  showEditor_(r, i = !1) {
    this.workspace_ = this.sourceBlock_.workspace, !i && this.workspace_.options.modalInputs && (lh.MOBILE || lh.ANDROID || lh.IPAD) ? this.showPromptEditor_() : this.showInlineEditor_(i);
  }
  /**
   * Create and show a text input editor that is a prompt (usually a popup).
   * Mobile browsers may have issues with in-line textareas (focus and
   * keyboards).
   */
  showPromptEditor_() {
    X.dialog.prompt(
      X.Msg.CHANGE_VALUE_TITLE,
      this.getText(),
      (r) => {
        r !== null && this.setValue(this.getValueFromEditorText_(r));
      }
    );
  }
  /**
   * Create and show a text input editor that sits directly over the text input.
   *
   * @param quietInput True if editor should be created without focus.
   */
  showInlineEditor_(r) {
    const i = this.getSourceBlock();
    if (!i)
      throw new X.UnattachedFieldError();
    X.WidgetDiv.show(this, i.RTL, this.widgetDispose_.bind(this)), this.htmlInput_ = this.widgetCreate_(), this.isBeingEdited_ = !0, r || (this.htmlInput_.focus({
      preventScroll: !0
    }), this.htmlInput_.select());
  }
  /**
   * Create the text input editor widget.
   *
   * @returns The newly created text input editor.
   */
  widgetCreate_() {
    const r = this.getSourceBlock();
    if (!r)
      throw new X.UnattachedFieldError();
    X.Events.setGroup(!0);
    const i = X.WidgetDiv.getDiv(), a = this.getClickTarget_();
    if (!a)
      throw new Error("A click target has not been set.");
    eS.addClass(a, "editing");
    const p = document.createElement("input");
    p.className = "blocklyHtmlInput", p.setAttribute(
      "spellcheck",
      this.spellcheck_
    );
    const E = this.workspace_.getScale(), h = this.getConstants().FIELD_TEXT_FONTSIZE * E + "px";
    i.style.fontSize = h, p.style.fontSize = h;
    let L = uS.BORDERRADIUS * E + "px";
    if (this.fullBlockClickTarget_) {
      const y = this.getScaledBBox();
      L = (y.bottom - y.top) / 2 + "px";
      const V = r.getParent() ? r.getParent().style.colourTertiary : this.sourceBlock_.style.colourTertiary;
      p.style.border = 1 * E + "px solid " + V, i.style.borderRadius = L, i.style.transition = "box-shadow 0.25s ease 0s", this.getConstants().FIELD_TEXTINPUT_BOX_SHADOW && (i.style.boxShadow = "rgba(255, 255, 255, 0.3) 0 0 0 " + 4 * E + "px");
    }
    return p.style.borderRadius = L, i.appendChild(p), p.value = p.defaultValue = this.getEditorText_(this.value_), p.setAttribute("data-untyped-default-value", String(this.value_)), this.resizeEditor_(), this.bindInputEvents_(p), p;
  }
  /**
   * Closes the editor, saves the results, and disposes of any events or
   * DOM-references belonging to the editor.
   */
  widgetDispose_() {
    this.isBeingEdited_ = !1, this.isTextValid_ = !0, this.forceRerender(), this.onFinishEditing_(this.value_), X.Events.setGroup(!1), this.unbindInputEvents_();
    const r = X.WidgetDiv.getDiv().style;
    r.width = "auto", r.height = "auto", r.fontSize = "", r.transition = "", r.boxShadow = "", this.htmlInput_ = null;
    const i = this.getClickTarget_();
    if (!i)
      throw new Error("A click target has not been set.");
    eS.removeClass(i, "editing");
  }
  /**
   * A callback triggered when the user is done editing the field via the UI.
   *
   * @param _value The new value of the field.
   */
  onFinishEditing_(r) {
  }
  // NOP by default.
  // TODO(#2496): Support people passing a func into the field.
  /**
   * Bind handlers for user input on the text input field's editor.
   *
   * @param htmlInput The htmlInput to which event handlers will be bound.
   */
  bindInputEvents_(r) {
    this.onKeyDownWrapper_ = X.browserEvents.conditionalBind(
      r,
      "keydown",
      this,
      this.onHtmlInputKeyDown_
    ), this.onKeyInputWrapper_ = X.browserEvents.conditionalBind(
      r,
      "input",
      this,
      this.onHtmlInputChange_
    );
  }
  /** Unbind handlers for user input and workspace size changes. */
  unbindInputEvents_() {
    this.onKeyDownWrapper_ && (X.browserEvents.unbind(this.onKeyDownWrapper_), this.onKeyDownWrapper_ = null), this.onKeyInputWrapper_ && (X.browserEvents.unbind(this.onKeyInputWrapper_), this.onKeyInputWrapper_ = null);
  }
  /**
   * Handle key down to the editor.
   *
   * @param e Keyboard event.
   */
  onHtmlInputKeyDown_(r) {
    r.key === "Enter" ? (X.WidgetDiv.hide(), X.DropDownDiv.hideWithoutAnimation()) : r.key === "Escape" ? (this.setValue(
      this.htmlInput_.getAttribute("data-untyped-default-value")
    ), X.WidgetDiv.hide(), X.DropDownDiv.hideWithoutAnimation()) : r.key === "Tab" && (X.WidgetDiv.hide(), X.DropDownDiv.hideWithoutAnimation(), this.sourceBlock_.tab(this, !r.shiftKey), r.preventDefault());
  }
  /**
   * Handle a change to the editor.
   *
   * @param _e Keyboard event.
   */
  onHtmlInputChange_(r) {
    this.setValue(this.getValueFromEditorText_(this.htmlInput_.value));
  }
  /**
   * Set the HTML input value and the field's internal value. The difference
   * between this and `setValue` is that this also updates the HTML input
   * value whilst editing.
   *
   * @param newValue New value.
   */
  setEditorValue_(r) {
    this.isDirty_ = !0, this.isBeingEdited_ && (this.htmlInput_.value = this.getEditorText_(r)), this.setValue(r);
  }
  /** Resize the editor to fit the text. */
  resizeEditor_() {
    const r = this.getSourceBlock();
    if (!r)
      throw new X.UnattachedFieldError();
    const i = X.WidgetDiv.getDiv(), a = this.getScaledBBox();
    i.style.width = a.right - a.left + "px", i.style.height = a.bottom - a.top + "px";
    const p = r.RTL ? a.right - i.offsetWidth : a.left, E = new cm(p, a.top);
    i.style.left = E.x + "px", i.style.top = E.y + "px";
  }
  /**
   * Returns whether or not the field is tab navigable.
   *
   * @returns True if the field is tab navigable.
   */
  isTabNavigable() {
    return !0;
  }
  /**
   * Use the `getText_` developer hook to override the field's text
   * representation. When we're currently editing, return the current HTML value
   * instead. Otherwise, return null which tells the field to use the default
   * behaviour (which is a string cast of the field's value).
   *
   * @returns The HTML value if we're editing, otherwise null.
   */
  getText_() {
    return this.isBeingEdited_ && this.htmlInput_ ? this.htmlInput_.value : null;
  }
  /**
   * Transform the provided value into a text to show in the HTML input.
   * Override this method if the field's HTML input representation is different
   * than the field's value. This should be coupled with an override of
   * `getValueFromEditorText_`.
   *
   * @param value The value stored in this field.
   * @returns The text to show on the HTML input.
   */
  getEditorText_(r) {
    return `${r}`;
  }
  /**
   * Transform the text received from the HTML input into a value to store
   * in this field.
   * Override this method if the field's HTML input representation is different
   * than the field's value. This should be coupled with an override of
   * `getEditorText_`.
   *
   * @param text Text received from the HTML input.
   * @returns The value to store.
   */
  getValueFromEditorText_(r) {
    return r;
  }
};
/**
 * Pixel size of input border radius.
 * Should match blocklyText's border-radius in CSS.
 */
N(uS, "BORDERRADIUS", 4);
let Ph = uS;
const { dom: lS, Svg: pm } = X.utils;
let NT;
function um(_, s) {
  var a;
  let i = _.workspace.getAllBlocks(!1);
  for (let p of i) {
    let E = p;
    ((a = E.vardef) == null ? void 0 : a.id) == s.id && HE(E);
  }
}
class gI extends X.FieldLabel {
  constructor(r, i, a) {
    super(r, void 0, a);
    N(this, "fieldRef");
    this.fieldRef = i;
  }
  initView() {
    this.createBorderRect_(), this.createTextElement_(), lS.addClass(this.fieldGroup_, "blocklyDragOutSet");
  }
  createBorderRect_() {
    this.borderRect_ = lS.createSvgElement(
      "path",
      {},
      this.fieldGroup_
    );
  }
  positionBorderRect_() {
    if (!this.borderRect_)
      return;
    let r = this.size_.width, i = this.size_.height;
    const a = `m 0,0  h 10  l 3,3  10,0  3,-3  H${r}  V${i} H28  l -3,3  -10,0  -3,-3 H 0 z`;
    this.borderRect_.setAttribute(
      "d",
      a
    );
  }
  getDragOutBlockState() {
    let i = this.getSourceBlock().getField(this.fieldRef);
    if (!(i instanceof jt))
      return null;
    let a = i.getVarDefine();
    return a ? {
      kind: "block",
      type: M.localvar_set,
      extraState: a.id,
      fields: {
        [d.VarRef]: a.name
      }
    } : null;
  }
  onMouseDown_(r) {
    if (super.onMouseDown_(r), !this.sourceBlock_ || this.sourceBlock_.disposed || this.sourceBlock_.isInFlyout)
      return;
    const i = this.sourceBlock_.workspace.getGesture(r);
    if (NT ?? (NT = !1), i && r.button === 0 && !NT) {
      let a = AS(this.sourceBlock_.workspace);
      i.setStartBlock(this.sourceBlock_), i.handleFlyoutStart(r, a), a.targetWorkspace = this.sourceBlock_.workspace, a.refField = this;
    }
  }
}
class Em extends X.FieldImage {
  constructor(r, i, a, p, E, h, L) {
    super(i, a, p, E, void 0, h, L);
    N(this, "fieldRef");
    this.fieldRef = r;
  }
  // override initView(): void { 
  //     this.createBorderRect_();
  //     this.createTextElement_();
  //     dom.addClass(this.fieldGroup_, 'blocklyDragOutSet');
  // }
  getDragOutBlockState() {
    let i = this.getSourceBlock().getField(this.fieldRef);
    if (!(i instanceof jt))
      return null;
    let a = i.getVarDefine();
    return a ? {
      kind: "block",
      type: M.localvar_set,
      extraState: a.id,
      fields: {
        [d.VarRef]: a.name
      }
    } : null;
  }
  onMouseDown_(r) {
    if (super.onMouseDown_(r), !this.sourceBlock_ || this.sourceBlock_.disposed || this.sourceBlock_.isInFlyout)
      return;
    const i = this.sourceBlock_.workspace.getGesture(r);
    if (NT ?? (NT = !1), i && r.button === 0 && !NT) {
      let a = AS(this.sourceBlock_.workspace);
      i.setStartBlock(this.sourceBlock_), i.handleFlyoutStart(r, a), a.targetWorkspace = this.sourceBlock_.workspace, a.refField = this;
    }
  }
}
class jt extends Ph {
  constructor(r, i, a) {
    super(X.Field.SKIP_SETUP);
    N(this, "value_", {});
    N(this, "DEFAULT_VALUE", {});
    N(this, "SERIALIZABLE", !0);
    N(this, "cuteSqaurePath", "");
    N(this, "cuteSquareSvg");
    N(this, "vardef", { id: "", name: "", type: "", blockId: "" });
    a && this.configure_(a), this.setValue(r), i && this.setValidator(i);
  }
  initView() {
    super.initView(), lS.addClass(this.borderRect_, "blocklyFieldEntity");
  }
  initCuteSquare() {
    const r = this.size_.height / 2 + 4;
    this.cuteSqaurePath = "", this.cuteSqaurePath += X.utils.svgPaths.moveTo(0, r) + X.utils.svgPaths.lineTo(4, -4) + X.utils.svgPaths.lineTo(-4, -4) + X.utils.svgPaths.lineTo(-4, 4) + X.utils.svgPaths.lineTo(4, 4), this.cuteSquareSvg || (this.cuteSquareSvg = lS.createSvgElement(
      pm.PATH,
      { class: "blocklyPathSquare" },
      this.fieldGroup_
    ), this.cuteSquareSvg.setAttribute("fill", "#FFC736")), this.cuteSquareSvg.setAttribute("d", this.cuteSqaurePath);
  }
  positionBorderRect_() {
    super.positionBorderRect_(), this.initCuteSquare();
  }
  getValue() {
    return this.value_;
  }
  getVarDefine() {
    return this.vardef.id = this.sourceBlock_.id + this.name, this.vardef.blockId = this.sourceBlock_.id, this.vardef.name = this.value_.name, this.vardef.type = this.value_.type, this.vardef;
  }
  // override initView(): void {
  //     super.initView()
  // }
  applyColour() {
    if (this.borderRect_) {
      const r = this.sourceBlock_;
      this.borderRect_.setAttribute("fill", X.utils.colour.blend("#ffffff", r.style.colourPrimary, 0.1)), this.borderRect_.setAttribute("stroke", r.style.colourTertiary);
    }
  }
  updateEditable() {
  }
  // collapse will use this
  getText_() {
    var r;
    return ((r = this.vardef) == null ? void 0 : r.name) ?? "";
  }
  getEditorText_(r) {
    return typeof r == "string" ? r : typeof r == "object" && r != null ? r.name ?? "" : String(r);
  }
  doClassValidation_(r) {
    if ((this.value_ == null || typeof this.value_ != "object") && (this.value_ = {}), typeof r == "string" && (r = { name: r }), typeof r == "object") {
      let i = { ...this.value_ }, a = !1;
      if (r.name && i.name != r.name && (i.name = r.name, this.vardef.name = i.name, a = !0), r.type != null && i.type != r.type) {
        i.type = r.type, this.vardef.type = i.type, a = !0;
        let p = Ae.CurrentDescriptionFile.getType(i.type);
        p ? this.setTooltip(p.Label) : this.setTooltip(f.UnkownType);
      }
      return a && this.sourceBlock_ && um(this.sourceBlock_, this.vardef), a ? i : this.value_;
    }
    return null;
  }
  onMouseDown_(r) {
    if (super.onMouseDown_(r), !this.sourceBlock_ || this.sourceBlock_.disposed || this.sourceBlock_.isInFlyout)
      return;
    const i = this.sourceBlock_.workspace.getGesture(r);
    if (NT ?? (NT = !1), i && r.button === 0 && !NT) {
      let a = AS(this.sourceBlock_.workspace);
      i.setStartBlock(this.sourceBlock_), i.handleFlyoutStart(r, a), a.targetWorkspace = this.sourceBlock_.workspace, a.refField = this;
    }
  }
  getDragOutBlockState() {
    let r = "", i = "", a = this.getVarDefine();
    return a && (r = a.name, i = a.id), {
      kind: "block",
      type: M.localvar_get,
      extraState: i,
      fields: {
        [d.VarRef]: r
      }
    };
  }
  static fromJson(r) {
    const i = r.name, a = r.type;
    return new this({ name: i, type: a }, void 0, r);
  }
}
class Am extends X.VerticalFlyout {
  constructor() {
    super(...arguments);
    N(this, "refField");
    N(this, "autoClose", !1);
  }
  isBlockCreatable(r) {
    return !0;
  }
  // override isBlockCreatable_(block: BlockSvg): boolean {
  //     return true
  // }
  createBlock(r) {
    let i = null;
    X.Events.disable(), this.targetWorkspace.setResizesEnabled(!1);
    try {
      i = this.placenewblock();
    } finally {
      X.Events.enable();
    }
    return X.Events.isEnabled() && (X.Events.setGroup(!0), X.Events.fire(new (X.Events.get(X.Events.BLOCK_CREATE))(i))), i;
  }
  placenewblock() {
    if (this.refField == null)
      throw Error("refField is null.");
    let r = this.refField.getSourceBlock();
    const i = this.targetWorkspace;
    if (!r.getSvgRoot())
      throw Error("oldBlock is not rendered.");
    let p = this.refField.getDragOutBlockState();
    if (p == null)
      throw Error("blockState not defined.");
    i.setResizesEnabled(!1);
    const E = X.serialization.blocks.append(p, i, { recordUndo: !0 });
    let h = r.getRelativeToSurfaceXY(), y = this.refField.getSvgRoot().transform.baseVal.consolidate().matrix;
    return h.x += y.e, h.y += y.f, E.moveTo(new X.utils.Coordinate(h.x, h.y)), E;
  }
}
let rS;
function AS(_) {
  if (rS != null)
    return rS;
  const s = new X.Options(
    /** @type {!BlocklyOptions} */
    {
      parentWorkspace: _,
      rtl: _.RTL,
      oneBasedIndex: _.options.oneBasedIndex,
      renderer: _.options.renderer,
      rendererOverrides: _.options.rendererOverrides,
      theme: _.options.theme
    }
  );
  return rS = new Am(s), rS;
}
g.fieldRegistry.register("field_vardef", jt);
class dm {
  constructor() {
    N(this, "oldGroup");
    this.oldGroup = g.Events.getGroup();
  }
  Leave() {
    this.oldGroup != null && g.Events.setGroup(this.oldGroup), this.oldGroup = null;
  }
}
function ys(_) {
  let s = new dm();
  return _.group ? g.Events.setGroup(_.group) : (g.Events.setGroup(!0), _.group = g.Events.getGroup()), s;
}
let fI = /* @__PURE__ */ new Map();
function ip() {
  return fI;
}
let Dh = "";
function Lh() {
  return Dh;
}
function NI(_, s) {
  let r = fI.get(Dh);
  if (r) {
    for (let i = 0; i < r.functions.length; ++i) {
      let a = r.functions[i];
      if (a.id == _) {
        typeof s == "string" ? (a = JSON.parse(JSON.stringify(a)), a.name = s, r.functions[i] = a) : s == null ? r.functions.splice(i, 1) : (s.graphId = Dh, r.functions[i] = s);
        return;
      }
    }
    s != null && typeof s != "string" && r.functions.push(s);
  }
}
function Sm(_) {
  return null;
}
const hm = [
  "HudEmptyWidget",
  //HudEmpty = 0,
  "HudImageWidget",
  //HudImage = 1,
  "HudLabelWidget",
  //HudLabel = 2,
  "HudButtonWidget",
  //HudButton = 3,
  "HudInputWidget",
  //HudInput = 4 ,
  "HudPanel",
  //HudPanel = 5 ,
  "HudScrollView",
  //HudScrollView = 6 ,
  "HudGrid",
  //HudGrid = 7 ,
  "HudLayout",
  //HudLayout = 8, 
  "HudEffect"
  //HudEffect = 9,
];
function Im(_) {
  return hm[_];
}
class Mm {
  constructor(s) {
    N(this, "descriptionFile");
    this.descriptionFile = s;
  }
  getValue(s, r) {
    let i = this.getBlock(s);
    if (i)
      return gm(this, i, r);
    {
      let a = typeof s;
      if (a === "number" || a === "string")
        return s;
    }
  }
  getElementType(s, r) {
    let i = this.getVarType(s);
    return i && i.GenericType && i.ElementTypes && i.ElementTypes.length > r ? this.descriptionFile.GetVarType(i.ElementTypes[r]) : null;
  }
  getSheetType(s) {
    let r = this.getBlock(s);
    if (!r)
      return this.descriptionFile.anyType;
    if (r.type === M.sheet_data || r.type === M.sheet_rank) {
      const i = this.getFieldValue(r, d.Value);
      if (i) {
        const a = i.split("--")[1] ?? "any";
        return this.descriptionFile.GetVarType(a);
      }
    }
    return null;
  }
  parseTokens(s) {
    let r = [], i = s.length;
    for (let a = 0; a < i; ++a)
      if (this.calcuToken(r, s[a]), r.length == 0)
        return null;
    if (r.length == 0)
      return null;
    for (let a = r.length - 1; a >= 0; --a) {
      let p = this.getVarType(r[a]);
      if (p)
        return p;
    }
    return null;
  }
  calcuToken(s, r) {
    if (r.startsWith(".")) {
      if (s.length == 0)
        return;
      let i = s.pop();
      if (r == ".EnumToType") {
        let a = this.getEnumedType(i);
        a ? s.push(a) : s.push(null);
        return;
      } else if (r == ".ItemIDToType") {
        this.getValue(i, "int");
        let a = Sm(), p = this.descriptionFile.GetVarType(a);
        p ? s.push(p) : s.push(null);
        return;
      } else if (r === ".WidgetType") {
        let a = this.getValue(i, "int"), p = Im(a), E = this.descriptionFile.GetVarType(p);
        E ? s.push(E) : s.push(null);
        return;
      } else if (r == ".IsList") {
        let a = this.getVarType(i);
        a && this.descriptionFile.IsArray(a) ? s.push(!0) : s.push(!1);
        return;
      } else if (r.startsWith(".T")) {
        let a = Number.parseInt(r.substring(2));
        if (!Number.isNaN(a)) {
          let p = this.getElementType(i, a);
          if (p !== void 0) {
            s.push(p);
            return;
          }
        }
      } else if (r == ".SheetType") {
        let a = this.getSheetType(i);
        if (a !== void 0) {
          s.push(a);
          return;
        }
      } else if (r == ".InternalHudType") {
        const a = this.getBlock(i);
        if (!a)
          return;
        if (a.type === M.input_enum) {
          const p = this.getEnumedType(i);
          s.push(p || null);
        } else {
          const p = this.getElementType(i, 0);
          p && s.push(p);
        }
        return;
      }
    } else if (r == ">") {
      if (s.length == 0)
        return;
      let i = s.pop(), a = this.getVarType(i);
      if (a && a.IsGeneric && a.Items && s.length >= a.Items.Count) {
        let p = s.splice(s.length - a.Items.Count + 1), E = this.getVarType(s.pop());
        if (E == null) {
          s.splice(0);
          return;
        }
        for (let L = 0; L < p.length; ++L)
          if ((p[L] = this.getVarType(p[L])) == null) {
            s.splice(0);
            return;
          }
        let h = this.descriptionFile.GetGenericVarType(a, E, p);
        if (h != null) {
          s.push(h);
          return;
        }
      }
    } else if (r == "?") {
      if (s.length >= 3) {
        if (s.pop() === !0) {
          let a = s.pop();
          s.pop(), s.push(a);
        } else {
          s.pop();
          let a = s.pop();
          s.push(a);
        }
        return;
      }
    } else if (r.match(/^\?+$/)) {
      let i = r.length;
      if (s.length >= i) {
        let a = null;
        for (let p = 0; p < i; ++p) {
          let E = s.pop();
          a == null && (a = E);
        }
        s.push(a);
        return;
      }
    } else if (r == "?number") {
      let i = "";
      for (; s.length > 0; ) {
        let a = s.pop(), p = this.getVarType(a);
        if (a == 0) {
          i === "int" ? s.push(this.descriptionFile.intType) : i === "float" ? s.push(this.descriptionFile.floatType) : s.push(this.descriptionFile.numberType);
          return;
        }
        i !== "float" && (p ? this.descriptionFile.CheckIsAssignable(this.descriptionFile.intType, p, !1, !1) ? i === "" && (i = "int") : this.descriptionFile.CheckIsAssignable(this.descriptionFile.floatType, p, !1, !1) ? i = "float" : i = "number" : i = "number");
      }
      return;
    } else {
      let i = this.getInput(r);
      if (i != null) {
        s.push(i);
        return;
      } else {
        let a = this.descriptionFile.GetVarType(r);
        if (a != null) {
          s.push(a);
          return;
        } else {
          let p = r.toLocaleLowerCase();
          if (p === "true" || p === "false" || !Number.isNaN(Number(p))) {
            s.push(r);
            return;
          }
        }
      }
    }
    s.splice(0);
  }
}
const mm = -(2 ** 31), Pm = 2 ** 31 - 1;
let Dm = /\s+|(?=[.>])|(?:[>])/, D4 = /* @__PURE__ */ new Map();
function Lm(_) {
  if (_ == null)
    return null;
  let s = D4.get(_);
  if (s)
    return s;
  let r = _.split(";"), i = {};
  D4.set(_, i);
  let a = !1;
  for (let p = 0; p < r.length; ++p) {
    let h = r[p].split("=");
    if (h.length >= 2) {
      let L = h[0].trim(), y = h[1].split(Dm);
      i[L] = y, a = !0;
    }
  }
  return a ? i : null;
}
function gm(_, s, r) {
  var i, a, p;
  if (s.type == M.input_enum) {
    let E = _.getFieldValue(s, d.Item), h = _.getExtraValue(s);
    if (h) {
      let L;
      if (typeof h == "string")
        L = _.descriptionFile.GetVarType(h);
      else if (typeof h == "number") {
        const y = z.graphElementMap.get(h);
        L = _.descriptionFile.GetVarType(y == null ? void 0 : y.ref);
      }
      if (L && L.IsEnum) {
        let y = _.descriptionFile.GetVarType(r);
        if (_.descriptionFile.CheckIsAssignable(y, L))
          return r === "int" ? (i = L.GetItem(E)) == null ? void 0 : i.IntValue : r === "float" ? (a = L.GetItem(E)) == null ? void 0 : a.FloatValue : (p = L.GetItem(E)) == null ? void 0 : p.Value;
      }
    }
  } else if (s.type === M.input_int) {
    if (r === "int" || r === "float")
      return _.getFieldValue(s, d.Value);
  } else if (s.type === M.input_float) {
    if (r === "float")
      return _.getFieldValue(s, d.Value);
  } else if (s.type === M.input_number) {
    let E = _.getFieldValue(s, d.Value);
    const h = Number(E);
    let L = E.indexOf(".") !== -1;
    if ((h < mm || h > Pm) && (L = !0), r === "int" && !L)
      return h;
    if (r === "float")
      return h;
  } else if (s.type === M.input_text) {
    let E = _.getFieldValue(s, d.Value);
    if (r === "string")
      return E == null ? void 0 : E.toString();
  } else if (s.type === M.pick_dynamic_create_item) {
    _.getFieldValue(s, d.Value);
    return;
  }
}
function HE(_) {
  if (_.DetermineTypes && _.DetermineTypes() && _.outputConnection) {
    let s = _.outputConnection.targetBlock();
    s && HE(s);
  }
}
function fm() {
  let _ = this.outputConnection.getCheck(), s = "";
  _ && _.length == 1 && (s = _[0]);
  let r = Ae.CurrentDescriptionFile, i = r.intType, a = r.floatType, p = "";
  for (let E of this.inputList)
    if (E.type == g.inputTypes.VALUE)
      if (_ = E.connection.getCheck(), _ && _.length == 1 && _[0] == "number") {
        let h = E.connection.targetConnection, L;
        if (h && h.getCheck() && h.getCheck().length == 1 && (L = r.GetVarType(h.getCheck()[0])), r.CheckIsAssignable(a, L, !1, !1)) {
          p = "float";
          break;
        } else
          r.CheckIsAssignable(i, L, !1, !1) ? p === "" && (p = "int") : p = "number";
      } else
        (_ == null ? void 0 : _.length) === 1 && (_[0] === "int" || _[0] === "float") && (p = _[0]);
  return p === "" && (p = "number"), p != s ? (this.setOutput(!0, p), !0) : !1;
}
let L4 = /* @__PURE__ */ new Map();
function Nm(_) {
  let s = L4.get(_);
  if (s)
    return s;
  let r = Lm(_);
  return s = function() {
    return bm.call(this, r);
  }, L4.set(_, s), s;
}
function bm(_) {
  let s = Ae.CurrentDescriptionFile, r = !1, i = new Cm(this, s);
  for (let a in _) {
    let p = _[a], E = i.parseTokens(p);
    if (E == null) {
      let V = this.paramInfo[a];
      V && (E = s.GetVarType(V.inputType));
    }
    let h = (E == null ? void 0 : E.Name) ?? "any", L = (E == null ? void 0 : E.Label) ?? "";
    if (a == "R") {
      if (this.outputConnection) {
        let y = this.outputConnection.getCheck();
        if ((y == null ? void 0 : y[0]) != h) {
          this.setOutput(!0, h), r = !0;
          let Z = this.action;
          Z && this.setTooltip(Z.Label + `
` + f.ReturnSentense + " " + L);
        }
      }
    } else {
      let y = this.getInput(a);
      if (y != null && y.connection != null) {
        let V = y.connection.getCheck();
        (V == null ? void 0 : V[0]) != h && _n(y, h);
      } else {
        let V = this.getField(a);
        if (V instanceof jt) {
          V.setValue({ type: h }, !1);
          let Z = g.Events.getRecordUndo();
          g.Events.setRecordUndo(!1);
          const le = this.getField(a + "L");
          le && le.setValue(L, !1), g.Events.setRecordUndo(Z);
        }
      }
    }
  }
  return r;
}
class Cm extends Mm {
  constructor(r, i) {
    super(i);
    N(this, "block");
    this.block = r;
  }
  getVarType(r) {
    let i;
    if (r instanceof Yt)
      return r;
    if (r instanceof g.Input) {
      let a = r.connection.targetBlock();
      if (a == null)
        return this.descriptionFile.anyType;
      {
        let p = a.outputConnection.getCheck(), E = p == null ? void 0 : p[0];
        E && (i = this.descriptionFile.GetVarType(E));
      }
    }
    return i;
  }
  getEnumedType(r) {
    var a;
    var i = null;
    if (r instanceof g.Input) {
      let p = r.connection.targetBlock();
      if (p && p.type == M.input_enum) {
        let E = p.getFieldValue(d.Item), h = p.varType;
        if (h) {
          let L = this.descriptionFile.GetVarType(h);
          if (L && L.IsEnum) {
            let y = (a = L.GetItem(E)) == null ? void 0 : a.Value;
            y && (i = this.descriptionFile.GetVarType(y));
          }
        }
      }
    }
    return i;
  }
  getInput(r) {
    return this.block.getInput(r);
  }
  getBlock(r) {
    if (r instanceof g.Input)
      return r.connection.targetBlock();
  }
  getFieldValue(r, i) {
    if (r instanceof g.Block)
      return r.getFieldValue(i);
  }
  getExtraValue(r) {
    if (r instanceof g.Block)
      return r.saveExtraState();
  }
}
let Om = {
  geId: M.as_type,
  locKey: _e.AsType,
  init() {
    this.setStyle("action_blocks"), this.setInputsInline(!0), this.appendValueInput(d.Value).appendField(f.AsType).appendField(new ni({ hasMore: !0 }), d.Type).connection.setShadowState(xe("any")), this.setOutput(!0);
  },
  DetermineTypes() {
    let _ = this.outputConnection.getCheck(), s = null;
    _ && _.length == 1 && (s = _[0]);
    let i = this.getInput(d.Value).connection.targetConnection, a = "";
    i && i.getCheck() && i.getCheck().length == 1 && (a = i.getCheck()[0]);
    let p = this.getField(d.Type);
    p.baseType = a;
    let E = this.getFieldValue(d.Type);
    if (i) {
      let h = Ae.CurrentDescriptionFile, L = h.GetVarType(a);
      if (L)
        if (Bn.CheckIsAssignable(L, E, h))
          this.setWarningText(null, "AS");
        else {
          let y = h.GetVarType(E);
          y ? this.setWarningText(L.Label + ` ${f.Tip_NotTransform} ` + y.Label, "AS") : this.setWarningText(Oe(_e.Warning_NoDefine, [E]), "NODEF");
        }
    } else
      this.setWarningText(null, "AS");
    return s != E ? (this.setOutput(!0, E), !0) : !1;
  },
  search(_) {
    return ["as", f.AsType].find((s) => z.containsKey(s, _)) || !1;
  }
};
function Rm(_) {
  g.Blocks[M.as_type] = Om, _.set("as_type", { kind: "block", type: M.as_type });
}
let ym = {
  lastCondition: null,
  geId: M.ctrl_ifelse,
  locKey: _e.ConditionalStatement,
  init: function() {
    let _ = function(r) {
      return this.getSourceBlock().updateStatement_(r), r;
    }, s = new pt([[f.If, "if"], [f.ElseIf, "elseif"], [f.Else, "else"]], _);
    this.setInputsInline(!0), this.appendValueInput(d.Condition).setCheck("bool").appendField(s, d.Type).connection.setShadowState(xe("bool")), this.appendStatementInput(d.Code).setCheck("action"), this.setPreviousStatement(!0, null), this.setNextStatement(!0, null), this.setColour(130), this.setTooltip(""), this.setHelpUrl(""), this.setStyle("logic_blocks");
  },
  updateStatement_: function(_) {
    let s = this.getFieldValue(d.Type);
    if (_ != s) {
      let r = this.getInput(d.Condition);
      _ == "else" ? (wm.call(this, r), this.setPreviousStatement(!0, ["ifelse"]), this.setNextStatement(!0, ["action"]), this.geId = `ex_${M.ctrl_ifelse}_else}`) : _ == "if" ? (g4.call(this, r), this.setPreviousStatement(!0, ["ifelse", "action"]), this.setNextStatement(!0, ["action", "ifelse"]), this.geId = `ex_${M.ctrl_ifelse}_if}`) : _ == "elseif" && (g4.call(this, r), this.setPreviousStatement(!0, ["ifelse"]), this.setNextStatement(!0, ["action", "ifelse"]), this.geId = `ex_${M.ctrl_ifelse}_elseif}`);
    }
  },
  search(_, s) {
    var i;
    if (!_)
      return !1;
    let r = (i = s.fields) == null ? void 0 : i[d.Type];
    if (r == _)
      return r;
    switch (r) {
      case "if":
        return z.containsKey(f.If, _) ? f.If : !1;
      case "elseif":
        return z.containsKey(f.ElseIf, _) ? f.ElseIf : !1;
      case "else":
        return z.containsKey(f.Else, _) ? f.Else : !1;
    }
  },
  lastConditionBlock: null,
  lastConditionConnection: null
}, bI = {
  operationCount: 1,
  saveExtraState() {
    return {
      [d.Index]: this.operationCount
    };
  },
  loadExtraState(_) {
    this.updateShape_(_[d.Index]);
  },
  updateShape_(_) {
    const s = this;
    for (; this.operationCount < _; )
      s.addOperation();
    for (; this.operationCount > _; )
      s.deleteOperation();
  },
  addButtons() {
    const s = 10, r = this.appendDummyInput("buttons");
    this.operationCount > 1 && r.appendField(new g.FieldImage(fT, 14, 14, "-", () => {
      this.onDeleteItem();
    })), this.operationCount < s && r.appendField(new g.FieldImage(Lo, 14, 14, "+", () => {
      this.onAddItem();
    }));
  },
  onAddItem() {
    g.Events.setGroup(!0);
    const _ = wt(this);
    this.addOperation();
    const r = wt(this);
    _ != r && g.Events.fire(new g.Events.BlockChange(this, "mutation", null, _, r)), g.Events.setGroup(!1);
  },
  onDeleteItem() {
    g.Events.setGroup(!0);
    const _ = wt(this);
    this.deleteOperation();
    const r = wt(this);
    _ != r && g.Events.fire(new g.Events.BlockChange(this, "mutation", null, _, r)), g.Events.setGroup(!1);
  }
}, vm = {
  ...bI,
  geId: M.op_arith,
  locKey: _e.Arithmetic,
  init() {
    this.setInputsInline(!0), this.setStyle("data_blocks"), this.setOutput(!0, "float"), __(
      this.appendValueInput(d.V1).setCheck("number"),
      { type: M.input_number }
    ), __(
      this.appendValueInput(d.V2).setCheck("number").appendField(new pt(
        [
          [f.ArithAdd, Nt.Add],
          [f.ArithSub, Nt.Substract],
          [f.ArithMultiply, Nt.Multiply],
          [f.ArithDivide, Nt.Divide],
          [f.ArithMod, Nt.Mod]
        ]
      ), d.Operator),
      { type: M.input_number }
    ), this.addButtons();
  },
  addOperation() {
    this.removeInput("buttons"), this.operationCount++, __(
      this.appendValueInput(d.Value + (this.operationCount + 1)).setCheck("number").appendField(new g.FieldImage(MI, 3, 24, void 0, void 0, void 0, { imageClass: "hover-show-image" })).appendField(new pt(
        [
          [f.ArithAdd, Nt.Add],
          [f.ArithSub, Nt.Substract],
          [f.ArithMultiply, Nt.Multiply],
          [f.ArithDivide, Nt.Divide],
          [f.ArithMod, Nt.Mod]
        ]
      ), d.Operator + this.operationCount),
      { type: M.input_number }
    ), this.addButtons();
  },
  deleteOperation() {
    this.removeInput("buttons"), this.removeInput(d.Value + (this.operationCount + 1)), this.operationCount--, this.addButtons();
  },
  DetermineTypes() {
    for (let _ = 1; _ <= this.operationCount; _++) {
      let s = d.Operator + (_ === 1 ? "" : _);
      if (this.getFieldValue(s) == Nt.Mod)
        _n(this.getInput(d.Value + _), "int"), _n(this.getInput(d.Value + (_ + 1)), "int");
      else {
        let i = _ - 1;
        this.getFieldValue(d.Operator + (i === 1 ? "" : i)) !== Nt.Mod && _n(this.getInput(d.Value + _), "number"), _n(this.getInput(d.Value + (_ + 1)), "number");
      }
    }
    return fm.call(this);
  },
  search(_, s) {
    return !1;
  }
}, $m = {
  ...bI,
  geId: M.op_logic,
  locKey: "and/or",
  init() {
    this.setInputsInline(!0), this.setStyle("data_blocks"), this.setOutput(!0, "bool"), this.appendValueInput(d.V1).setCheck("bool").connection.setShadowState(xe("bool")), this.appendValueInput(d.V2).setCheck("bool").appendField(new pt(
      [
        [f.OpAnd, RE.And],
        [f.OpOr, RE.Or]
      ]
    ), d.Operator).connection.setShadowState(xe("bool")), this.addButtons();
  },
  search(_, s) {
    if (!_)
      return !1;
    let r = [f.OpAnd, f.OpOr].find((i) => z.containsKey(i, _));
    return r || ["and", "or"].find((i) => i === _) || !1;
  },
  addOperation() {
    this.removeInput("buttons"), this.operationCount++, this.appendValueInput(d.Value + (this.operationCount + 1)).setCheck("bool").appendField(new g.FieldImage(MI, 3, 24, void 0, void 0, void 0, { imageClass: "hover-show-image" })).appendField(new pt(
      [
        [f.OpAnd, RE.And],
        [f.OpOr, RE.Or]
      ]
    ), d.Operator + this.operationCount).connection.setShadowState(xe("bool")), this.addButtons();
  },
  deleteOperation() {
    this.removeInput("buttons"), this.removeInput(d.Value + (this.operationCount + 1)), this.operationCount--, this.addButtons();
  }
}, Wm = {
  geId: M.op_compare,
  locKey: _e.Compare,
  init() {
    this.setInputsInline(!0), this.setStyle("data_blocks"), this.setOutput(!0, "bool"), __(
      this.appendValueInput(d.V1).setCheck(""),
      { type: M.shadow_type }
    ), __(
      this.appendValueInput(d.V2).setCheck("").appendField(new pt(
        [
          [f.CompareEqual, PT.Equal],
          [f.CompareNotEqual, PT.NotEqual],
          [f.CompareLess, PT.Less],
          [f.CompareLessEqual, PT.LessEqual],
          [f.CompareGreater, PT.Greater],
          [f.CompareGreaterEqual, PT.GreaterEqual]
        ]
      ), d.Operator),
      { type: M.shadow_type }
    );
  },
  DetermineTypes() {
    var i, a;
    switch (this.getFieldValue(d.Operator)) {
      case PT.Equal:
      case PT.NotEqual:
        _n(this.getInput(d.V1), "any"), _n(this.getInput(d.V2), "any");
        break;
      default:
        _n(this.getInput(d.V1), "number"), _n(this.getInput(d.V2), "number");
        break;
    }
    let s = this.getInput(d.V1).connection.targetConnection, r = this.getInput(d.V2).connection.targetConnection;
    if (this.setWarningText(null, "TYPENOTEQUAL"), s && r) {
      const p = Ae.CurrentDescriptionFile, E = (i = s.getCheck()) == null ? void 0 : i[0], h = (a = r.getCheck()) == null ? void 0 : a[0], L = E == null ? void 0 : E.toLowerCase(), y = h == null ? void 0 : h.toLowerCase(), V = p.GetVarType(E), Z = p.GetVarType(h);
      E && h && L !== "any" && y !== "any" && L !== y && !Bn.CheckIsAssignable(V, h, p) && !Bn.CheckIsAssignable(Z, E, p) && this.setWarningText(Oe("FE_41B_HZY_COMPARE_NOTSAME"), "TYPENOTEQUAL");
    }
  },
  search(_, s) {
    return _ && ["==", "<", ">", "!=", "<=", ">="].find((i) => z.containsKey(i, _)) || !1;
  }
}, km = {
  geId: M.op_string,
  valueCount: 0,
  locKey: _e.Concat,
  init() {
    this.appendDummyInput().appendField(f.Concat, d.Label), this.updateShape_(2), this.setInputsInline(!0), this.setOutput(!0, "string"), this.setTooltip(f.StringConcatTip), this.setStyle("data_blocks");
  },
  search(_) {
    return [f.Concat, "StrConcat"].find((s) => z.containsKey(s, _)) || !1;
  },
  saveExtraState() {
    return {
      [d.Index]: this.valueCount
    };
  },
  loadExtraState(_) {
    this.updateShape_(_[d.Index]);
  },
  DetermineTypes() {
    var _;
    for (let s = 1; s <= this.valueCount; s++) {
      const r = this.getInputTargetBlock(d.Property + s), i = (_ = r == null ? void 0 : r.outputConnection) == null ? void 0 : _.getCheck();
      if (Array.isArray(i) && i.includes("LocString"))
        return this.setWarningText(Oe("FE_40A_B_ECA_TIPS1"), "TYPE"), !1;
    }
    return this.setWarningText(null, "TYPE"), !1;
  },
  updateShape_(_) {
    for (; this.valueCount < _; )
      this.addStrValue();
    for (; this.valueCount > _; )
      this.deleteStrValue();
  },
  addButtons() {
    const s = 10, r = this.appendDummyInput("buttons");
    this.valueCount > 2 && r.appendField(new g.FieldImage(fT, 14, 14, "-", () => {
      this.onDeleteItem();
    })), this.valueCount < s && r.appendField(new g.FieldImage(Lo, 14, 14, "+", () => {
      this.onAddItem();
    }));
  },
  onAddItem() {
    g.Events.setGroup(!0);
    const _ = wt(this);
    this.addStrValue();
    const s = wt(this);
    _ != s && g.Events.fire(new g.Events.BlockChange(this, "mutation", null, _, s)), g.Events.setGroup(!1);
  },
  addStrValue() {
    this.getInput("buttons") && this.removeInput("buttons");
    let _ = ++this.valueCount;
    __(
      this.appendValueInput(d.Property + _).appendField(f.Value + _).setCheck("Object").setAlign(g.ALIGN_RIGHT),
      {
        type: M.shadow_type,
        extraState: "Object"
      }
    ), this.addButtons();
  },
  onDeleteItem() {
    g.Events.setGroup(!0);
    const _ = wt(this);
    this.deleteStrValue();
    const s = wt(this);
    _ != s && g.Events.fire(new g.Events.BlockChange(this, "mutation", null, _, s)), g.Events.setGroup(!1);
  },
  deleteStrValue() {
    this.removeInput("buttons"), this.removeInput(d.Property + this.valueCount), this.valueCount--, this.addButtons();
  }
}, Fm = {
  geId: M.ctrl_ifelse1,
  locKey: _e.ConditionalStatement,
  uniqueIds: [],
  conditionCount: 1,
  init() {
    this.setInputsInline(!0), this.appendValueInput(d.Condition).setCheck("bool").appendField(f.If, d.Label).connection.setShadowState(xe("bool")), this.appendStatementInput(d.Code).setCheck("action"), this.appendDummyInput("addbtn").setAlign(g.ALIGN_RIGHT).appendField(new g.FieldImage(Lo, 14, 14, "+", () => {
      this.addCondition();
    })), this.setPreviousStatement(!0, null), this.setNextStatement(!0, null), this.setStyle("logic_blocks"), this.uniqueIds = [];
  },
  saveExtraState() {
    return {
      [d.Index]: this.conditionCount,
      [d.ConditionIds]: [...this.uniqueIds]
    };
  },
  loadExtraState(_) {
    const s = _[d.ConditionIds] || [], r = _[d.Index];
    if (this.conditionCount >= r) {
      if (this.conditionCount === r) {
        this.uniqueIds = [...s];
        return;
      }
      _[d.Index] === 1 ? this.delCondition(0) : [...this.uniqueIds].forEach((a) => {
        s.includes(a) || this.delCondition(a);
      });
    } else {
      this.conditionCount === 1 && s.length && this.addCondition(), s.forEach((a) => {
        this.addCondition(a);
      });
      let i = _[d.Index] - this.conditionCount;
      if (i > 0)
        for (; i; )
          this.addCondition(), i--;
    }
  },
  addCondition(_) {
    g.Events.setGroup(!0);
    const s = wt(this);
    if (this.conditionCount > 1) {
      let i = _ ?? this.newId();
      const a = `${d.Condition}_${i}`, p = this.uniqueIds.findIndex((y) => y === i);
      let E = null, h = null;
      if (p > -1) {
        if (this.getInput(a))
          return;
        E = p - 1;
      } else
        this.uniqueIds.push(i);
      this.appendValueInput(a).setCheck("bool").appendField(f.ElseIf, d.Label).connection.setShadowState(xe("bool")), this.appendDummyInput(`del_${i}`).appendField(new g.FieldImage(fT, 14, 14, "-", () => {
        this.delCondition(i);
      })).setAlign(g.ALIGN_RIGHT), this.appendStatementInput(`${d.Code}_${i}`).setCheck("action");
      const L = this.getInput("else");
      E > 0 ? h = `${d.Condition}_${E}` : L && (L.fieldRow.findIndex((y) => y.name === "del") > -1 && L.removeField("del"), h = "else"), h && (this.moveInputBefore(a, h), this.moveInputBefore(`del_${i}`, h), this.moveInputBefore(`${d.Code}_${i}`, h));
    } else
      this.removeInput("addbtn"), this.appendDummyInput("else").appendField(f.Else, d.Label).appendField(new g.FieldImage(fT, 14, 14, "-", () => {
        this.delCondition(0);
      }), "del").appendField(new g.FieldImage(Lo, 14, 14, "+", () => {
        this.addCondition();
      }), "add"), this.appendStatementInput(`${d.Code}_else`).setCheck("action");
    this.conditionCount++;
    const r = wt(this);
    s !== r && g.Events.fire(new g.Events.BlockChange(this, "mutation", null, s, r)), g.Events.setGroup(!1);
  },
  delCondition(_) {
    g.Events.setGroup(!0);
    const s = wt(this);
    let r = "else", i = `${d.Code}_else`;
    if (_ > 0) {
      const p = this.uniqueIds.findIndex((E) => _ === E);
      p > -1 && this.uniqueIds.splice(p, 1), r = `${d.Condition}_${_}`, i = `${d.Code}_${_}`;
    }
    this.removeInput(r), this.removeInput(i), r !== "else" && this.removeInput(`del_${_}`), this.conditionCount--;
    const a = wt(this);
    s !== a && g.Events.fire(new g.Events.BlockChange(this, "mutation", null, s, a)), this.conditionCount === 1 ? this.appendDummyInput("addbtn").setAlign(g.ALIGN_RIGHT).appendField(new g.FieldImage(Lo, 14, 14, "+", () => {
      this.addCondition();
    })) : this.conditionCount === 2 && this.getInput("else").insertFieldAt(1, new g.FieldImage(fT, 14, 14, "-", () => {
      this.delCondition(0);
    }), "del"), g.Events.setGroup(!1);
  },
  newId() {
    let _ = 1;
    for (; this.uniqueIds.includes(_); )
      _++;
    return _;
  },
  search(_) {
    return [f.If, f.ElseIf, f.Else].find((s) => z.containsKey(s, _)) || !1;
  }
};
function wm(_) {
  if (_.type != g.inputTypes.DUMMY) {
    let s = g.Events.getRecordUndo();
    g.Events.setRecordUndo(!1), _.setShadowDom(null);
    let r = _.connection.targetBlock();
    r && (r.unplug(!0), r.isShadow() && (r.dispose(!1), r = null)), this.lastConditionBlock = r, this.lastCondition = _.connection, _.connection = null, _.type = g.inputTypes.DUMMY, g.Events.setRecordUndo(s);
  }
}
function g4(_) {
  if (_.type != g.inputTypes.VALUE) {
    let s = g.Events.getRecordUndo();
    g.Events.setRecordUndo(!1), _.connection = this.lastCondition, _.type = g.inputTypes.VALUE;
    let r = this.lastConditionBlock;
    r && !r.disposed && !r.outputConnection.targetConnection && _.connection.connect(r.outputConnection), _.connection.setShadowState(xe("bool")), g.Events.setRecordUndo(s);
  }
}
function Bm(_) {
  g.Blocks[M.ctrl_ifelse] = ym, g.Blocks[M.op_arith] = vm, g.Blocks[M.op_logic] = $m, g.Blocks[M.op_compare] = Wm, g.Blocks[M.op_string] = km, g.Blocks[M.ctrl_ifelse1] = Fm, _.set("if", { kind: "block", type: M.ctrl_ifelse1, extraState: {
    [d.Index]: 1
  } }), _.set("ifelse", { kind: "block", type: M.ctrl_ifelse1, extraState: {
    [d.Index]: 2
  } }), _.set(
    "ifelse:if",
    {
      kind: "block",
      type: M.ctrl_ifelse,
      fields: {
        [d.Type]: "if"
      }
    }
  ), _.set(
    "ifelse:elseif",
    {
      kind: "block",
      type: M.ctrl_ifelse,
      fields: {
        [d.Type]: "elseif"
      }
    }
  ), _.set("ifelse:else", {
    kind: "block",
    type: M.ctrl_ifelse,
    fields: {
      [d.Type]: "else"
    }
  }), _.set("logic_operation", { kind: "block", type: M.op_logic }), _.set("logic_compare", { kind: "block", type: M.op_compare }), _.set("math_arithmetic", { kind: "block", type: M.op_arith }), _.set("str_concat", { kind: "block", type: M.op_string });
}
class fo extends X.FieldTextInput {
  constructor(s, r, i) {
    super(s, r, i);
  }
  widgetCreate_() {
    const s = super.widgetCreate_(), r = this.workspace_.getScale(), i = this.getConstants().FIELD_TEXT_FONTSIZE * r + "px";
    return s.style.fontSize = i, s.style.borderRadius = "0", s.style.padding = "0 " + this.getConstants().FIELD_BORDER_RECT_X_PADDING * r + "px", this.resizeEditor_(), s.addEventListener("click", (a) => {
      a.stopPropagation(), a.preventDefault();
    }), s;
  }
  showEditor_(s, r) {
    this.workspace_ = this.sourceBlock_.workspace;
    const i = r || !1;
    !i && (X.utils.userAgent.MOBILE || X.utils.userAgent.ANDROID || X.utils.userAgent.IPAD) ? this.showPromptEditor_() : this.showInlineEditor_(i);
  }
  resizeEditor_() {
    const s = X.WidgetDiv.getDiv(), r = this.getScaledBBox();
    s.style.width = r.right - r.left + 1 + "px", s.style.height = r.bottom - r.top + "px";
    const i = this.sourceBlock_.RTL ? r.right - s.offsetWidth : r.left, a = new X.utils.Coordinate(i, r.top);
    s.style.left = a.x + "px", s.style.top = a.y + "px";
  }
}
X.fieldRegistry.unregister("field_input");
X.fieldRegistry.register("field_input", fo);
class Cs extends X.FieldNumber {
  constructor(r, i, a, p, E, h) {
    super(r, i, a, p, E, h);
    N(this, "EDITABLE", !0);
  }
  widgetCreate_() {
    const r = super.widgetCreate_(), i = this.workspace_.getScale(), a = this.getConstants().FIELD_TEXT_FONTSIZE * i + "px";
    return r.style.fontSize = a, r.style.borderRadius = "0", r.style.padding = "0 " + this.getConstants().FIELD_BORDER_RECT_X_PADDING * i + "px", this.resizeEditor_(), r.addEventListener("click", (p) => {
      p.stopPropagation(), p.preventDefault();
    }), r;
  }
}
class wE extends g.Field {
  constructor(r, i, a) {
    super(r, i, a);
    N(this, "DEFAULT_VALUE", "#FF00FF");
    N(this, "CURSOR", "default");
    N(this, "SERIALIZABLE", !0);
    /**
     * Whether text editing is enabled on this field.
     * @type {boolean}
     * @private
     */
    N(this, "textEditEnabled_", !1);
  }
  static fromJson(r) {
    var i = g.utils.parsing.replaceMessageReferences(r.text);
    return new wE(i, void 0, r);
  }
  /**
  * Copied form the color field
  */
  initView() {
    this.size_ = new g.utils.Size(
      this.getConstants().FIELD_COLOUR_DEFAULT_HEIGHT,
      this.getConstants().FIELD_COLOUR_DEFAULT_HEIGHT
    ), this.getConstants().FIELD_COLOUR_FULL_BLOCK ? this.clickTarget_ = this.sourceBlock_.getSvgRoot() : (this.createBorderRect_(), this.borderRect_.style.fillOpacity = "1");
  }
  /**
   * Show the inline free-text editor on top of the text.
   * @param {Event=} _opt_e Optional mouse event that triggered the field to open,
   *     or undefined if triggered programmatically.
   * @param {boolean=} opt_quietInput True if editor should be created without
   *     focus.  Defaults to false.
   * @protected
   */
  showEditor_(r) {
  }
  /**
   * Copied from colour field
   * Update the value of this colour field, and update the displayed colour.
   * @param {*} newValue The value to be saved. The default validator guarantees
   * that this is a colour in '#rrggbb' format.
   * @protected
   */
  doValueUpdate_(r) {
    this.value_ = r;
    let i = this.sourceBlock_;
    this.borderRect_ ? this.borderRect_.style.fill = /** @type {string} */
    r : this.sourceBlock_ && this.sourceBlock_.rendered && (i.pathObject.svgPath.setAttribute("fill", r), i.pathObject.svgPath.setAttribute("stroke", "#fff"));
  }
  /**
   * Copied from colour field
   * @override
   */
  applyColour() {
    if (!this.getConstants().FIELD_COLOUR_FULL_BLOCK)
      this.borderRect_ && (this.borderRect_.style.fill = /** @type {string} */
      this.getValue());
    else {
      let r = this.sourceBlock_;
      r.pathObject.svgPath.setAttribute("fill", this.getValue()), r.pathObject.svgPath.setAttribute("stroke", "#fff");
    }
  }
  /**
  * Set the html input value and the field's internal value. The difference
  * between this and ``setValue`` is that this also updates the html input
  * value whilst editing.
  * @param {*} newValue New value.
  * @protected
  */
  setEditorValue_(r) {
    this.setValue(r);
  }
  updateSize_(r) {
    super.updateSize_(r), this.size_.width = this.size_.height, this.positionBorderRect_();
  }
}
g.fieldRegistry.register("field_color_picker", wE);
const Ym = 1e5, Um = 1e6;
var CT;
((_) => {
  function s(Te, Le) {
    Te.events.set_Item(`${Le.owner}::${Le.Name}`, Le);
    let we = Te.event_ownertypes.get_Item(Le.Name);
    we || (we = new rt(), Te.event_ownertypes.set_Item(Le.Name, we)), we.Add(Le.owner);
    let ot = Te.ownertype_events.get_Item(Le.owner);
    ot || (ot = new rt(), Te.ownertype_events.set_Item(Le.owner, ot)), ot.Add(Le.Name);
  }
  _.AddEvent = s;
  function r(Te, Le) {
    Te.events.Remove(`${Le.owner}::${Le.Name}`);
    let we = Te.ownertype_events.get_Item(Le.owner);
    we && we.Remove(Le.Name);
    let ot = Te.event_ownertypes.get_Item(Le.Name);
    ot && ot.Remove(Le.owner);
  }
  _.RemoveEvent = r;
  function i(Te) {
    let Le = Te;
    Le._sortedVarType = null, Le._sortedComponentTypes = null;
  }
  _.SetSortedTypesDirty = i;
  function a(Te) {
    return Te.m_ApiLevel >= 10;
  }
  _.IsLowApiLevel = a;
  function p(Te) {
    let Le = Te.m_ApiLevel;
    return Le >= 1 && Le <= 3;
  }
  _.IsDevApi = p;
  function E(Te) {
    return "*" + Te;
  }
  _.GetDevApiLabel = E;
  function h(Te) {
    switch (Te) {
      case "String":
        return "";
      case "Int":
        return 0;
      case "Float":
        return 0;
      case "Bool":
        return !1;
      case "List":
        return [];
      case "Color":
        return { r: 255, g: 255, b: 255, a: 1 };
      case "Vector3":
        return {
          x: 0,
          y: 0,
          z: 0
        };
      default:
        return Te.includes("ListT_") ? [] : null;
    }
  }
  _.GetInitialValue = h;
  function L(Te) {
    return Te.IntValue >= Ym || //@ts-expect-error
    Te.IsEnum && !Te.IntValue;
  }
  _.IsCustomType = L;
  function y(Te) {
    const Le = Ae.CurrentDescriptionFile, we = Le.GetVarType("Component");
    return Le.CheckIsExtention(we, Te) && L(Te);
  }
  _.IsCustomComponentType = y;
  function V(Te) {
    return L(Te) && !Te.m_ModuleLib;
  }
  _.IsOwnModuleCustomType = V;
  function Z(Te) {
    return L(Te) && !!Te.m_ModuleLib;
  }
  _.IsOtherModuleCustomType = Z;
  function le(Te) {
    return Math.floor(Te / Um);
  }
  _.GetNamespaceIntFromTypeID = le;
  function ce(Te) {
    var Le;
    return y(Te) || !!((Le = Te == null ? void 0 : Te.Addable) != null && Le.length);
  }
  _.IsDynamicAddableComponent = ce;
  function ve(Te, Le) {
    var pr;
    if (!Te || !Le || !ce(Te))
      return !1;
    if (y(Te))
      return !0;
    const we = Ae.CurrentDescriptionFile;
    let ot = !1;
    return (pr = Te == null ? void 0 : Te.Addable) == null || pr.forEach((Zt) => {
      let Je = we.GetVarType(Zt);
      ot = ot || !!Je && we.CheckIsExtention(Je, Le);
    }), ot;
  }
  _.IsComponentAddableToEntity = ve;
  function et(Te, Le) {
    let we = ue.Split(Te, Ae.splits, Wh.RemoveEmptyEntries);
    return new SI().ParseTexts($r.ToEnumerable(we), Le), Le.postLoad(), !0;
  }
  _.LoadAdditional = et;
})(CT || (CT = {}));
let Vm = 0;
class dS extends g.FieldTextInput {
  constructor(r, i, a) {
    super(r, i, a);
    N(this, "FRAME_SIZE", 24);
    N(this, "bezierPath");
    N(this, "clipPathRect");
    N(this, "boundEvents", []);
  }
  static fromJson(r) {
    var i = g.utils.parsing.replaceMessageReferences(r.text);
    return new dS(i, void 0, r);
  }
  initView() {
    this.size_ = new g.utils.Size(this.FRAME_SIZE, this.FRAME_SIZE), this.createBorderRect_();
    const r = this.getSvgRoot(), i = "clipPath" + Vm++, a = g.utils.dom.createSvgElement("clipPath", {
      id: i
    });
    this.clipPathRect = g.utils.dom.createSvgElement("rect", {
      width: this.FRAME_SIZE,
      height: this.FRAME_SIZE
    }), a.appendChild(this.clipPathRect), r.appendChild(a), this.bezierPath = g.utils.dom.createSvgElement("path", {
      d: this.pathD,
      stroke: "#FFFFFF",
      fill: "transparent",
      style: `clip-path: url(#${i});`
    }), r.appendChild(this.bezierPath);
  }
  updateSize_(r) {
    var i, a, p, E;
    super.updateSize_(r), this.FRAME_SIZE = ((i = this.getBorderRect()) == null ? void 0 : i.height.baseVal.value) ?? 24, this.size_.width = this.size_.height = this.FRAME_SIZE, (a = this.bezierPath) == null || a.setAttribute("d", this.pathD), (p = this.clipPathRect) == null || p.setAttribute("width", this.FRAME_SIZE.toString()), (E = this.clipPathRect) == null || E.setAttribute("height", this.FRAME_SIZE.toString()), this.positionBorderRect_();
  }
  get pathD() {
    const r = this.FRAME_SIZE, i = (ce) => Math.round(ce * r), a = this.value_.split(",").map((ce) => Number(ce)), [p, E, h, L, y, V, Z, le] = a;
    return `M ${i(p)} ${i(E)} C ${i(h)} ${i(L)}, ${i(y)} ${i(V)}, ${i(Z)} ${i(le)}`;
  }
  setEditorValue_(r) {
    this.setValue(r);
  }
  doValueUpdate_(r) {
    var i;
    this.value_ = r, (i = this.bezierPath) == null || i.setAttribute("d", this.pathD);
  }
  showEditor_(r) {
  }
  // onDashboardEvent(value: string) {
  //     this.setEditorValue_('0,0,1,1');
  //     console.log(value);
  //     this.resizeEditor_();
  // }
  render_() {
    super.render_();
  }
}
g.fieldRegistry.register("field_bezier_curve", dS);
class CI extends X.FieldMultilineInput {
  constructor(s, r, i) {
    super(s, r, i);
  }
  /**
   * Updates the size of the field based on the text.
   * @protected
   */
  updateSize_() {
    const s = this.textGroup.childNodes;
    let r = 0, i = 0;
    for (let a = 0; a < s.length; a++) {
      const p = s[a], E = this.getConstants(), h = X.utils.dom.getFastTextWidth(
        p,
        E.FIELD_TEXT_FONTSIZE,
        E.FIELD_TEXT_FONTWEIGHT,
        E.FIELD_TEXT_FONTFAMILY
      );
      h > r && (r = h), i += this.getConstants().FIELD_TEXT_HEIGHT + (a > 0 ? this.getConstants().FIELD_BORDER_RECT_Y_PADDING : 0);
    }
    if (this.isBeingEdited_) {
      const a = this.value_.split(`
`), p = X.utils.dom.createSvgElement(
        X.utils.Svg.TEXT,
        { class: "blocklyText blocklyMultilineText" }
      ), E = this.getConstants().FIELD_TEXT_FONTSIZE, h = this.getConstants().FIELD_TEXT_FONTWEIGHT, L = this.getConstants().FIELD_TEXT_FONTFAMILY;
      for (let V = 0; V < a.length; V++) {
        a[V].length > this.maxDisplayLength && (a[V] = a[V].substring(0, this.maxDisplayLength)), p.textContent = a[V];
        const Z = X.utils.dom.getFastTextWidth(
          p,
          E,
          h,
          L
        );
        Z > r && (r = Z);
      }
      const y = this.htmlInput_.offsetWidth - this.htmlInput_.clientWidth;
      r += y;
    }
    this.borderRect_ && (i += this.getConstants().FIELD_BORDER_RECT_Y_PADDING * 2, r += this.getConstants().FIELD_BORDER_RECT_X_PADDING * 2, this.borderRect_.setAttribute("width", String(r)), this.borderRect_.setAttribute("height", String(i))), this.size_.width = r, this.size_.height = i, this.positionBorderRect_();
  }
}
X.fieldRegistry.unregister("field_multilinetext");
X.fieldRegistry.register("field_multilinetext", CI);
const OI = -2147483648, RI = 2147483647;
let xE = X.BlockSvg.prototype.setShadow;
function Zl(_) {
  let s = _.init;
  return s && (_.init = function() {
    s.call(this), this.workspace.IsCraftland && this.inputList[0].removeField(d.Label);
  }), _;
}
let Gm = Zl(
  {
    geId: M.input_number,
    locKey: _e.Number,
    init() {
      let _ = function(s) {
        const r = this.getValue();
        let i = String(s);
        i = i.replace(/O/ig, "0"), i = i.replace(/,/g, ""), i = i.replace(/infinity/i, "Infinity");
        let a = Number(i || 0);
        if (isNaN(a))
          return r;
        a = Math.min(Math.max(a, -1 / 0), 1 / 0);
        let p = String(a);
        return i.indexOf(".") !== -1 && Number.isInteger(a) && (p = a.toFixed(1)), p;
      };
      this.setOutput(!0, "int"), this.appendDummyInput().appendField(f.Number, d.Label).appendField(new fo(0, _), d.Value), this.setStyle("input_blocks");
    },
    loadExtraState(_) {
    },
    saveExtraState() {
    },
    DetermineTypes() {
      let _ = this.getFieldValue(d.Value), s = String(_).indexOf(".") !== -1, r = this.outputConnection.getCheck()[0], i = "float";
      return _ = Number(_), _ >= OI && _ <= RI && !s && Number.isInteger(_) && (i = "int"), i != r ? (this.setOutput(!0, i), !0) : !1;
    },
    setShadow(_) {
      xE.call(this, _), _ && this.inputList[0].removeField(d.Label, !0);
    },
    search(_, s) {
      return ["number", f.Number].find((r) => z.containsKey(r, _)) || !1;
    }
  }
), Hm = Zl(
  {
    geId: M.input_int,
    locKey: _e.Int,
    init() {
      this.setOutput(!0, "int"), this.appendDummyInput().appendField(f.Int, d.Label).appendField(new Cs(0, OI, RI, 1), d.Value), this.setStyle("input_blocks");
    },
    loadExtraState(_) {
    },
    saveExtraState() {
    },
    setShadow(_) {
      xE.call(this, _), _ && this.inputList[0].removeField(d.Label, !0);
    },
    search(_, s) {
      return ["int", f.Int].find((r) => z.containsKey(r, _)) || !1;
    }
  }
), xm = Zl(
  {
    geId: M.input_null,
    locKey: _e.NULL,
    init() {
      this.setOutput(!0, "any"), this.appendDummyInput().appendField(f.NULL), this.setStyle("input_blocks");
    },
    loadExtraState(_) {
    },
    saveExtraState() {
    },
    search(_, s) {
      return ["null", f.NULL].find((r) => z.containsKey(r, _)) || !1;
    }
  }
), Xm = {
  geId: M.input_pi,
  locKey: _e.PI,
  init() {
    this.setOutput(!0, "float"), this.appendDummyInput().appendField(f.PI), this.setStyle("shadow_blocks");
  },
  search(_, s) {
    return ["pi", f.PI].find((r) => z.containsKey(r, _)) || !1;
  }
}, Km = {
  geId: M.input_e,
  locKey: _e.E,
  init() {
    this.setOutput(!0, "float"), this.appendDummyInput().appendField(f.E), this.setStyle("shadow_blocks");
  },
  search(_, s) {
    return ["e", f.E].find((r) => z.containsKey(r, _)) || !1;
  }
}, Jm = {
  geId: M.input_intplus,
  locKey: _e.Int,
  init: function() {
    this.setOutput(!0, "int"), this.appendDummyInput().appendField(new Cs(0, 0, 2147483647, 1), d.Value), this.setStyle("input_blocks");
  },
  loadExtraState(_) {
  },
  saveExtraState() {
  },
  search(_, s) {
    return ["int", f.Int].find((r) => z.containsKey(r, _)) || !1;
  }
}, jm = Zl(
  {
    geId: M.input_float,
    locKey: _e.Float,
    init: function() {
      this.setOutput(!0, "float"), this.appendDummyInput().appendField(f.Float, d.Label).appendField(new Cs(0), d.Value), this.setStyle("input_blocks");
    },
    loadExtraState(_) {
    },
    saveExtraState() {
    },
    setShadow(_) {
      xE.call(this, _), _ && this.inputList[0].removeField(d.Label, !0);
    },
    search(_, s) {
      return ["float", f.Float].find((r) => z.containsKey(r, _)) || !1;
    }
  }
), zm = Zl(
  {
    geId: M.input_text,
    locKey: _e.Text,
    init: function() {
      this.setOutput(!0, "string"), this.appendDummyInput().appendField(f.Text, d.Label).appendField(new fo(), d.Value), this.setStyle("input_blocks");
    },
    loadExtraState(_) {
    },
    saveExtraState() {
    },
    setShadow(_) {
      xE.call(this, _), _ && this.inputList[0].removeField(d.Label, !0);
    },
    search(_, s) {
      return ["string", "text", f.Text].find((r) => z.containsKey(r, _)) || !1;
    }
  }
), Zm = Zl({
  geId: M.input_textarea,
  init: function() {
    const _ = new CI();
    _.setMaxLines(30), this.setOutput(!0, "string"), this.appendDummyInput().appendField(_, d.Value), this.setStyle("input_blocks");
  }
}), Qm = {
  geId: M.input_boolean,
  locKey: _e.Boolean,
  init() {
    this.setOutput(!0, "bool"), this.appendDummyInput().appendField(new pt([
      [f.False, "F"],
      [f.True, "T"]
    ]), d.Value), this.setStyle("input_blocks");
  },
  loadExtraState(_) {
  },
  saveExtraState() {
  },
  setShadow(_) {
    xE.call(this, _), _ && this.inputList[0].removeField(d.Label, !0);
  },
  search(_, s) {
    return ["bool", "boolean", f.Boolean, f.True, f.False].find((r) => z.containsKey(r, _)) || !1;
  }
}, qm = {
  geId: M.input_vector3,
  locKey: _e.Vector3,
  init() {
    this.setOutput(!0, "Vector3"), this.appendDummyInput().appendField("X").appendField(new Cs(), d.V1).appendField("Y").appendField(new Cs(), d.V2).appendField("Z").appendField(new Cs(), d.V3), this.setStyle("input_blocks");
  },
  loadExtraState(_) {
  },
  saveExtraState() {
  },
  search(_, s) {
    return ["Vector3", f.Vector3].find((r) => z.containsKey(r, _)) || !1;
  }
}, e1 = {
  geId: M.input_vector2,
  init() {
    this.setOutput(!0, "Vector2"), this.appendDummyInput().appendField("X").appendField(new Cs(), d.V1).appendField("Y").appendField(new Cs(), d.V2), this.setStyle("input_blocks");
  }
}, t1 = /^#[0-9a-fA-F]{6}$/, r1 = {
  geId: M.input_color,
  locKey: _e.Color,
  init() {
    const _ = this.workspace.IsCraftland;
    let s = function(r) {
      return r.match(t1) ? r.toLowerCase() : null;
    };
    _ ? this.appendDummyInput().appendField(Oe("T_34_M_WS_COLOUR")).appendField(new wE("#ffffff", s), d.Color) : this.appendDummyInput().appendField(new wE("#ff00ff", s), d.Color).appendField(new fo("#ff00ff", s), d.ColorStr).appendField(new X.FieldImage(wh, 20, 20, "pick", () => {
      this.showColorEyeDropper();
    })), this.setOutput(!0, "Color"), this.setStyle("input_blocks"), this.setTooltip(""), this.setHelpUrl("");
  },
  loadExtraState(_) {
  },
  saveExtraState() {
  },
  showColorEyeDropper() {
  },
  onchange(_) {
    if (_ instanceof g.Events.BlockChange && _.type == g.Events.BLOCK_CHANGE && _.blockId == this.id && _.element == "field") {
      if (g.Events.disable(), _.name == d.Color) {
        let s = this.getFieldValue(d.ColorStr), r = _.newValue;
        r && s != r && this.setFieldValue(r, d.ColorStr);
      } else if (_.name == d.ColorStr) {
        let s = this.getFieldValue(d.Color), r = _.newValue;
        r && s != r && this.setFieldValue(r, d.Color);
      }
      g.Events.enable();
    }
  },
  search(_, s) {
    return ["color", f.Color].find((r) => z.containsKey(r, _)) || !1;
  }
}, n1 = Zl(
  {
    isTypeEnum: !1,
    nextTypeChanged: !1,
    varType: "",
    locKey: _e.Enum,
    setNextTypeChanged() {
      this.nextTypeChanged = this.isTypeEnum;
    },
    init() {
      this.appendDummyInput("").appendField("", d.Label).appendField(new Yn(
        [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]],
        (_) => (this.setNextTypeChanged(), _)
      ), d.Item), this.setStyle("input_blocks"), this.setHelpUrl(""), this.setOutput(!0), this.setTooltip(() => "");
    },
    loadExtraState(_) {
      let s = "";
      if (typeof _ == "string")
        this.geId = s = _;
      else if (typeof _ == "number") {
        this.geId = _;
        let r = z.graphElementMap.get(_);
        r && (s = r.ref, this.workspace.IsCraftland || this.setStyle(r.block_style));
      } else
        this.geId = s = _.varType;
      s && this.varType != s && (this.varType = s, this.updateShape_()), this.isShadow() && this.inputList[0].removeField(d.Label, !0);
    },
    saveExtraState() {
      return this.geId;
    },
    updateShape_() {
      let _ = Ae.CurrentDescriptionFile, s = _.GetVarType(this.varType);
      if (s == null || !s.IsEnum)
        return;
      this.locKey = `${f.Enum}: ${s.Label}`, this.setOutput(!0, this.varType), this.isTypeEnum = !1, s.Bases.Contains(_.typeType.Name) ? this.isTypeEnum = !0 : (s.Name === "DynamicCreateItemID" || s.Name === "HudWidgetType") && (this.isTypeEnum = !0), this.getField(d.Label) && this.setFieldValue(s.Label, d.Label);
      let r = [];
      for (let a of s.Items) {
        if (CT.IsLowApiLevel(a))
          continue;
        let p = a.Label;
        CT.IsDevApi(a) && (p = "*" + p), r.push([p, a.Name]);
      }
      this.getField(d.Item).setOptions(r);
    },
    search(_, s) {
      return !1;
    },
    DetermineTypes() {
      return this.nextTypeChanged ? (this.nextTypeChanged = !1, !0) : !1;
    },
    UpdateDisplayByScene(_, s) {
      this.varType == "SceneID" && s === "Scene" && this.updateShape_();
    },
    onchange(_) {
      if (_.type === "block_define_change") {
        let s = _.defineKey;
        (s === "customEnum" || s === this.varType) && (g.Events.disable(), this.updateShape_(), g.Events.enable());
      }
    }
  }
), _1 = {
  geId: M.input_localization_key,
  locKey: "KEY",
  init: function() {
    this.setOutput(!0, "LocString"), this.setInputsInline(!0), this.appendValueInput(d.V1).appendField("KEY").setCheck("string").setAlign(X.ALIGN_RIGHT).connection.setShadowState({
      type: M.key_enum,
      extraState: ""
    }), this.appendValueInput(d.V2).appendField(f.LocalizationKeyParams).setCheck("[]").setAlign(X.ALIGN_RIGHT).connection.setShadowState(xe("[]")), this.setStyle("data_blocks");
  },
  search(_) {
    return ["KEY", f.LocalizationKeyParams].find((s) => z.containsKey(s, _)) || !1;
  }
}, i1 = {
  geId: M.key_enum,
  varType: "",
  init() {
    this.appendDummyInput("").appendField("KEY", d.Label).appendField(
      new Yn(
        a1,
        null,
        { showSearch: !0 }
      ),
      d.Item
    ), this.setOutput(!0, "String"), this.setStyle("data_blocks");
  }
}, o1 = {
  geId: M.input_bezier,
  locKey: "TWEEN CURVE BEZIER",
  init() {
    this.appendDummyInput().appendField(new dS("0,1,0.1,0.9,0.9,0.1,1,0"), d.Bezier).appendField(new X.FieldLabelSerializable("LinearIncrease"), "BezierText"), this.setOutput(!0, "BezierCurve"), this.setStyle("data_blocks"), this.setTooltip(""), this.setHelpUrl("");
  },
  loadExtraState(_) {
  },
  saveExtraState() {
  },
  presets: [
    { name: "Ease", value: [0.25, 0.1, 0.25, 1] },
    { name: "Ease In", value: [0.42, 0, 1, 1] },
    { name: "Ease Out", value: [0, 0, 0.58, 1] },
    { name: "Ease Both", value: [0.42, 0, 0.58, 1] },
    { name: "Linear", value: [0, 0, 1, 1] }
  ],
  getStoragePresets() {
    return [];
  },
  getLabel(_) {
    let s = 0, r = "Custom";
    const i = [...this.presets, ...this.getStoragePresets()];
    for (; s < i.length; ) {
      if (i[s].value.join(",") === _) {
        r = i[s].name;
        break;
      }
      s += 1;
    }
    return r;
  },
  onchange(_) {
    _ instanceof g.Events.BlockChange && _.type == g.Events.BLOCK_CHANGE && _.blockId == this.id && _.element == "field" && (g.Events.disable(), _.name == d.Bezier && (this.setFieldValue(_.newValue, d.Bezier), this.setFieldValue(this.getLabel(_.newValue), "BezierText")), g.Events.enable());
  },
  search(_) {
    return z.containsKey("TWEEN CURVE BEZIER", _) ? "TWEEN CURVE BEZIER" : !1;
  },
  updateBezierLabel() {
    const _ = this.getLabel(this.getFieldValue(d.Bezier));
    this.setFieldValue(_, "BezierText");
  }
}, T1 = {
  geId: M.input_tag,
  sheetTypeTypeChanged: !1,
  init() {
    this.setOutput(!0, "string"), this.appendDummyInput().appendField(
      new Yn(
        () => [[f.Unselected, ""]],
        (_) => (this.sheetTypeTypeChanged = !0, _)
      ),
      bT(2)
    );
  },
  DetermineTypes() {
    return this.sheetTypeTypeChanged ? (this.sheetTypeTypeChanged = !1, !0) : !1;
  }
}, s1 = {
  geId: M.input_comments,
  locKey: _e.Comment,
  init() {
    this.setInputsInline(!0), this.setStyle("comment_blocks"), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.appendValueInput(d.Value);
  },
  search(_) {
    return z.containsKey(f.Comment, _) ? f.Comment : !1;
  }
}, l1 = {
  geId: M.num_to_string,
  locKey: _e.NumToString,
  formatType: mo.Regular,
  init() {
    this.setStyle("data_blocks"), this.setOutput(!0, "string"), this.setInputsInline(!0), this.appendDummyInput().appendField(f.NumToString, d.Label), this.appendValueInput(d.Value).appendField(f.Value).setCheck("number").connection.setShadowState({
      type: M.input_number
    }), this.appendDummyInput().appendField(f.NumFormatType).appendField(new pt(
      [
        [f.NumFormatF, mo.Float],
        [f.NumFormatG, mo.Regular],
        [f.NumFormatE, mo.ScientificNotation],
        [f.NumFormatN, mo.ThousandsSeparator],
        [f.NumFormatP, mo.Percentage]
      ],
      (_) => (this.formatType = _, this.updateShape_(), _)
    ), d.To), this.appendValueInput(d.Range).appendField(f.FormatValue).setCheck("number").connection.setShadowState({
      type: M.input_int,
      fields: {
        [d.Value]: 2
      }
    });
  },
  loadExtraState(_) {
    this.formatType = _[d.To], this.updateShape_();
  },
  saveExtraState() {
    return {
      [d.To]: this.formatType
    };
  },
  updateShape_() {
    const _ = this.formatType, s = [
      mo.Float,
      mo.ScientificNotation,
      mo.Percentage
    ].includes(_), r = this.getInput(d.Range);
    s && !r ? this.appendValueInput(d.Range).appendField(f.FormatValue).setCheck("number").connection.setShadowState({
      type: M.input_int,
      fields: {
        [d.Value]: 2
      }
    }) : !s && r && this.removeInput(d.Range, !0);
  },
  search(_) {
    return ["NumTostring", f.NumToString].find((s) => z.containsKey(s, _)) || !1;
  }
};
function a1() {
  return [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]];
}
function c1(_) {
  g.Blocks[M.input_int] = Hm, g.Blocks[M.input_number] = Gm, g.Blocks[M.input_intplus] = Jm, g.Blocks[M.input_float] = jm, g.Blocks[M.input_text] = zm, g.Blocks[M.input_color] = r1, g.Blocks[M.input_bezier] = o1, g.Blocks[M.input_boolean] = Qm, g.Blocks[M.input_enum] = n1, g.Blocks[M.input_null] = xm, g.Blocks[M.input_vector3] = qm, g.Blocks[M.input_vector2] = e1, g.Blocks[M.input_localization_key] = _1, g.Blocks[M.key_enum] = i1, g.Blocks[M.input_tag] = T1, g.Blocks[M.input_textarea] = Zm, g.Blocks[M.input_comments] = s1, g.Blocks[M.input_pi] = Xm, g.Blocks[M.input_e] = Km, g.Blocks[M.num_to_string] = l1, _.set("input_int", { kind: "block", type: M.input_int }), _.set("input_number", { kind: "block", type: M.input_number }), _.set("input_float", { kind: "block", type: M.input_float }), _.set("input_intplus", { kind: "block", type: M.input_intplus }), _.set("input_text", { kind: "block", type: M.input_text }), _.set("input_color", { kind: "block", type: M.input_color }), _.set("input_bezier", { kind: "block", type: M.input_bezier }), _.set("logic_boolean", { kind: "block", type: M.input_boolean }), _.set("input_null", { kind: "block", type: M.input_null }), _.set("input_vector3", { kind: "block", type: M.input_vector3 }), _.set("input_vector2", { kind: "block", type: M.input_vector2 }), _.set("input_localization_key", { kind: "block", type: M.input_localization_key }), _.set("key_enum", { kind: "block", type: M.key_enum }), _.set("InputTag", { kind: "block", type: M.input_tag }), _.set("input_textarea", { kind: "block", type: M.input_textarea }), _.set("input_comments", { kind: "block", type: M.input_comments }), _.set("input_pi", { kind: "block", type: M.input_pi }), _.set("input_e", { kind: "block", type: M.input_e }), _.set("num_to_string", { kind: "block", type: M.num_to_string });
}
var BE;
((_) => {
  _.CUSTOM_BLOCK_DEFINE_CHANGE = "block_define_change";
  class s extends g.Events.Abstract {
    constructor(a, p) {
      super();
      N(this, "isBlank", !0);
      N(this, "defineKey");
      N(this, "ownerType");
      this.type = _.CUSTOM_BLOCK_DEFINE_CHANGE, this.workspaceId = a, this.defineKey = p.id, this.ownerType = p.ownerType, this.isBlank = typeof a > "u";
    }
  }
  _.BlockDefineChange = s;
})(BE || (BE = {}));
g.registry.register(g.registry.Type.EVENT, BE.CUSTOM_BLOCK_DEFINE_CHANGE, BE.BlockDefineChange);
var yI = /* @__PURE__ */ ((_) => (_[_.server = 2] = "server", _[_.client = 1] = "client", _[_.clientAndServer = 0] = "clientAndServer", _))(yI || {}), vI = /* @__PURE__ */ ((_) => (_[_.get = 0] = "get", _[_.set = 1] = "set", _[_.formula = 2] = "formula", _[_.tween = 3] = "tween", _[_.tuple_get = 4] = "tuple_get", _[_.tuple_set = 5] = "tuple_set", _))(vI || {});
const yE = "Tuple";
let gh = {
  currentCheck: "",
  fromType: "",
  method: 0,
  initialTips: "",
  getThisType() {
    return this.getFirstThisType();
  },
  getFirstThisType() {
    let _, s = this.getInput(d.This);
    if (s != null && (_ = s.connection.targetBlock()), _ == null)
      return this.fromType;
    let r = _.outputConnection.getCheck();
    return r == null || r.length < 1 ? "" : r[0];
  },
  /**
   * @param propertyIndex get the output of a specified property, start from 1
   * @returns output type(ECADefineBase) of the block
   */
  getShouldCheck() {
    let _ = Ae.CurrentDescriptionFile, s = this.getFirstThisType(), r = this.getFieldValue(d.Property);
    return jl(s, r, _);
  },
  updateShouldChecks() {
    return !1;
  },
  DetermineTypes() {
    let _ = this.updateShouldChecks(), s = this.getShouldCheck(), r = (s == null ? void 0 : s.Type) ?? "";
    if (s)
      CT.IsLowApiLevel(s) ? this.setWarningText(Oe(_e.Warning_LowLevel, [s.Label]), "NODEF") : this.setWarningText(null, "NODEF");
    else {
      let p = this.getFieldValue(d.Property);
      this.setWarningText(Oe(_e.Warning_LowLevel, [p]), "NODEF");
    }
    let i = (s == null ? void 0 : s.Tip) ?? "";
    if (i ? this.setTooltip(this.initialTips + `
${s.Label}: ${i}`) : this.setTooltip(this.initialTips), this.method == 1) {
      const p = this.getField(d.Operator);
      p && p.opType !== r && (p.setOpType(r), p.UpdateDisplay());
    }
    let a = this.currentCheck != r;
    return (a || _) && this.updatePropertyFieldDisplays(), a ? (this.setCurrentCheck(r), !0) : !1;
  },
  updatePropertyFieldDisplays() {
    let _ = this.getField(d.Property);
    _.getOptions(!1), _.UpdateDisplay();
  },
  setCurrentCheck(_) {
    if (this.currentCheck = _, this.method == 0)
      this.setOutput(!0, _);
    else if (this.method == 1) {
      let s = this.getInput(d.Value);
      s != null && this.rendered && _n(s, _);
    }
  }
};
function XE(_, s, r, i) {
  if (_ == "Global")
    return {
      ...gh,
      debugAvailable: s == 1,
      fromType: _,
      method: s,
      locKey: s === 0 ? _e.GlobalGet : _e.GlobalSet,
      init() {
        this.method == 0 ? (this.appendDummyInput("").appendField(f.GlobalGet).appendField(new gT(this.method), d.Property), this.geId = r) : (this.appendValueInput(d.Value).appendField(f.GlobalSet).appendField(new gT(this.method), d.Property).appendField(new YE(), d.Operator).connection.setShadowState(xe("")), this.geId = r), this.setInputsInline(!0), this.setColour(20), this.setTooltip(""), this.setHelpUrl(""), this.setStyle(i), this.method == 0 ? this.setOutput(!0) : this.method == 1 && (this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"));
      },
      search(a, p) {
        var y, V;
        const h = [s === 0 ? f.GlobalGet : f.GlobalSet], L = ((y = p == null ? void 0 : p.fields) == null ? void 0 : y[d.Property]) ?? "";
        if (L) {
          const Z = (V = jl(_, L, Ae.CurrentDescriptionFile)) == null ? void 0 : V.Label;
          Z && h.push(Z);
        }
        return h.find((Z) => z.containsKey(Z, a)) || !1;
      }
    };
  {
    let a = s == 0 || s == 4;
    return {
      ...gh,
      debugAvailable: s == 1,
      fromType: _,
      method: s,
      locKey: a ? _e.PropertyGet : _e.PropertySet,
      init() {
        a ? (this.appendDummyInput("").appendField(f.PropertyGet).appendField(new gT(this.method), d.Property), this.appendValueInput(d.This).appendField(f.PropertyGet_1).setAlign(g.ALIGN_RIGHT).setCheck(_).connection.setShadowState(xe(_)), this.geId = r, this.locKey = _e.PropertyGet) : (this.appendValueInput(d.This).appendField(f.PropertySet).setAlign(g.ALIGN_RIGHT).setCheck(_).connection.setShadowState(xe(_)), this.appendValueInput(d.Value).appendField(new gT(this.method), d.Property).appendField(new YE(), d.Operator).connection.setShadowState(xe("")), this.geId = r, this.locKey = _e.PropertySet), this.setInputsInline(!0), this.setHelpUrl(""), a ? this.setOutput(!0) : (this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action")), this.setStyle(i);
      },
      search(p) {
        return (a ? [f.PropertyGet, "get"] : [f.PropertySet, "set"]).find((h) => z.containsKey(h, p)) || !1;
      }
    };
  }
}
let p1 = {
  ...gh,
  debugAvailable: !1,
  fromType: "Component",
  method: 0,
  propertyCount: 1,
  thisTypes: null,
  locKey: _e.PropertyGet_2,
  init() {
    this.appendDummyInput("").appendField(f.PropertyGet_2), this.appendValueInput(d.This).appendField(f.Entity).setAlign(g.ALIGN_RIGHT).setCheck("Component").connection.setShadowState(xe("Component")), this.appendDummyInput("").appendField(f.PropertyGet_3).appendField(new gT(this.method), d.Property), this.geId = M.property_get, this.setInputsInline(!0), this.setHelpUrl(""), this.setOutput(!0), this.setStyle("action_blocks");
  },
  // overwrite not override
  getThisType(_) {
    if (_ == null)
      return this.getFirstThisType();
    this.thisTypes == null && this.updateShouldChecks();
    let s = 0;
    return _.name != d.Property && _.name.startsWith(d.Property) && (s = Number.parseInt(_.name.substring(d.Property.length)) - 1), s < this.thisTypes.length ? this.thisTypes[s] : "";
  },
  // overwrite not override
  getShouldCheck() {
    let _ = Ae.CurrentDescriptionFile, s = this.propertyCount || 1;
    if (s != this.thisTypes.length && (this.updateShouldChecks(), s != this.thisTypes.length))
      return null;
    let r = this.thisTypes[this.thisTypes.length - 1], i = this.getFieldValue(s == 1 ? d.Property : d.Property + s);
    return jl(r, i, _);
  },
  // overwrite not override
  updatePropertyFieldDisplays() {
    let _ = this.getField(d.Property);
    _.getOptions(!1), _.UpdateDisplay();
    for (let s = 2; s <= this.propertyCount; ++s)
      _ = this.getField(d.Property + s), _.getOptions(!1), _.UpdateDisplay();
  },
  updateShouldChecks(_ = !1) {
    let s = this.thisTypes;
    this.thisTypes = [];
    let r = Ae.CurrentDescriptionFile, i = this.getFirstThisType(), a = this.getFieldValue(d.Property);
    this.thisTypes.push(i);
    for (let p = 2; p <= this.propertyCount; ++p) {
      let E = jl(i, a, r);
      if (E ? i = E.Type : i = "", _) {
        let h = r.GetVarType(i);
        if (h == null || !h.Bases.Contains("Component"))
          break;
      }
      this.thisTypes.push(i), a = this.getFieldValue(d.Property + p);
    }
    if (_ && this.thisTypes.length != this.propertyCount)
      return this.updateShape_(this.thisTypes.length), !0;
    if (this.thisTypes.length === (s == null ? void 0 : s.length)) {
      for (let p = 0; p < s.length; ++p)
        if (this.thisTypes[p] != s[p])
          return !0;
      return !1;
    }
    return !0;
  },
  saveExtraState() {
    return {
      [d.Index]: this.propertyCount,
      [d.Type]: this.currentCheck
    };
  },
  saveExtraStateWithFields() {
    let _ = {};
    for (let s = 2; s <= this.propertyCount; ++s) {
      const r = d.Property + s;
      _[r] = this.getFieldValue(r);
    }
    return JSON.stringify({
      [d.Index]: this.propertyCount,
      [d.Type]: this.currentCheck,
      FIELDS: _
    });
  },
  loadExtraState(_) {
    if (this.updateShape_(_[d.Index], _[d.Type]), _.FIELDS)
      for (let s in _.FIELDS)
        this.setFieldValue(_.FIELDS[s], s);
  },
  updateShape_(_, s) {
    for (; this.propertyCount < _; )
      this.addProperty();
    for (; this.propertyCount > _; )
      this.deleteProperty();
    s !== void 0 && this.setButtons(s);
  },
  onchange(_) {
    if (_ instanceof g.Events.BlockChange && _.blockId == this.id) {
      if (_.element == "field" && _.name && _.name.includes(d.Property)) {
        let s = ys(_);
        this.recordMutation(
          () => this.updateShouldChecks(!0)
        ), HE(this), s.Leave();
      }
      this.setButtons(this.currentCheck);
    }
  },
  search(_) {
    return z.containsKey(f.PropertyGet_2, _) ? f.PropertyGet_2 : !1;
  },
  setButtons(_) {
    var i;
    this.propertyCount > 1 ? (!this.getInput("button_delete") && this.appendDummyInput("button_delete").appendField(new g.FieldImage(fT, 14, 14, "+", () => {
      this.onDeleteItem();
    })), this.getInput("button_add") && this.removeInput("button_add")) : this.getInput("button_delete") && this.removeInput("button_delete");
    let r = Ae.CurrentDescriptionFile.GetVarType(_);
    _ === "Entity" || (i = r == null ? void 0 : r.Bases) != null && i.Contains("Entity") ? !this.getInput("button_add") && this.appendDummyInput("button_add").appendField(new g.FieldImage(Lo, 14, 14, "+", () => {
      this.onAddItem();
    })) : this.getInput("button_add") && this.removeInput("button_add");
  },
  deleteButtons() {
    this.getInput("button_add") && this.removeInput("button_add"), this.getInput("button_delete") && this.removeInput("button_delete");
  },
  onAddItem() {
    g.Events.setGroup(!0);
    const _ = wt(this);
    this.addProperty();
    const s = wt(this);
    _ != s && g.Events.fire(new g.Events.BlockChange(this, "mutation", null, _, s)), g.Events.setGroup(!1);
  },
  addProperty() {
    this.deleteButtons(), this.propertyCount++, this.appendDummyInput(d.Item + this.propertyCount).appendField(f.PropertyGet_3).appendField(
      new gT(this.method),
      this.propertyCount === 1 ? d.Property : d.Property + this.propertyCount
    );
  },
  onDeleteItem() {
    g.Events.setGroup(!0), this.recordMutation(
      () => this.deleteProperty()
    ), g.Events.setGroup(!1);
  },
  recordMutation(_) {
    const s = wt(this), r = this.saveExtraStateWithFields();
    _();
    const i = wt(this);
    s != i && g.Events.fire(new g.Events.BlockChange(this, "mutation", null, r, i));
  },
  deleteProperty() {
    this.deleteButtons();
    let _ = this.getFieldValue(d.Property + this.propertyCount);
    return this.removeInput(d.Item + this.propertyCount), this.propertyCount--, _;
  }
}, u1 = {
  geId: M.this_entity,
  locKey: _e.ThisEntity,
  init() {
    let _ = z.ComponentTypes ?? z.OwnerType;
    this.appendDummyInput().appendField(f.ThisEntity), this.setOutput(!0, _), this.setStyle("action_blocks");
  },
  DetermineTypes() {
    var i;
    let _ = (i = this.outputConnection.getCheck()) == null ? void 0 : i[0], s = z.ComponentTypes ?? z.OwnerType;
    const r = this.getParentEventOwner();
    return r && r !== "Global" && (s += `&${r}`), s != _ ? (this.setOutput(!0, s), !0) : !1;
  },
  triggerCheck() {
  },
  getParentEventOwner() {
    let _ = this;
    do {
      if (_.type == M.event)
        break;
      _ = _.getParent();
    } while (_);
    if (!_)
      return;
    const s = _.action;
    return s == null ? void 0 : s.owner;
  },
  onchange(_) {
    let s = this.workspace;
    if (s.isDragging && s.isDragging())
      return;
    let r = this;
    if (_.type == X.Events.BLOCK_MOVE) {
      let a = !1, p = !1;
      const E = _.blockId;
      do {
        if (r.id === E && (p = !0), r.type == M.event) {
          a = !0;
          break;
        }
        r = r.getParent();
      } while (r);
      if (a && p) {
        const h = ys(_);
        try {
          this.DetermineTypes();
        } finally {
          h.Leave();
        }
      }
    }
  },
  search(_) {
    return [f.ThisEntity, "thisentity"].find((s) => z.containsKey(s, _)) || !1;
  }
};
class gT extends Yn {
  constructor(r, i, a, p) {
    super([[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]]);
    N(this, "method");
    N(this, "fromType");
    this.method = r, this.fromType = p, this.menuGenerator_ = this.generateProperties;
    let E = this.getOptions();
    a && this.configure_(a), this.setValue(E[0][1]), this.validator_ = i;
  }
  getObjectType() {
    return this.sourceBlock_ && "getThisType" in this.sourceBlock_ ? this.sourceBlock_.getThisType(this) : "";
  }
  getValueDefaultOptions(r) {
    if (r) {
      let i = r.split(":"), a = i[0], p = i[1], h = Ae.CurrentDescriptionFile.GetVarType(p);
      if (h && h.GetItem(a))
        return [r + f.UnkownType, r, "", { style: "fill: var(--red_err5);" }];
    }
    return [f.Unselected, r, "", { style: "fill: var(--red_err5);" }];
  }
  doClassValidation_(r) {
    if (!r.includes(":")) {
      let i = this.getOptions(!0);
      for (let a of i) {
        let p = a[1].split(":");
        if (r == p[0])
          return a[1];
      }
    }
  }
  generateProperties() {
    let r = Ae.CurrentDescriptionFile, i = this.fromType || this.getObjectType();
    if (i) {
      let a = r.GetVarType(i);
      if (a == null || a.IsEnum)
        return [
          [f.Unselected, "", "", { style: "fill: var(--red_err5);" }]
        ];
      {
        let p = [], E = /* @__PURE__ */ new Set();
        this.addProperties(a, p, E);
        for (let h of a.Bases) {
          let L = r.GetVarType(h);
          this.addProperties(L, p, E);
        }
        return p.length == 0 ? [
          [f.Unselected, "", "", { style: "fill: var(--red_err5);" }]
        ] : p;
      }
    } else
      return [
        [f.Unselected, "", "", { style: "fill: var(--red_err5);" }]
      ];
  }
  addProperties(r, i, a) {
    if (!r)
      return;
    let p = Ae.CurrentDescriptionFile;
    if (!(this.method == 2 && !p.CheckIsExtention(p.GetVarType("FormulableEntity"), r)))
      for (let E of r.Items) {
        if (CT.IsLowApiLevel(E) || E.m_ApiTarget != null && !f1(E.m_ApiTarget))
          continue;
        if (this.method == 2) {
          if (E.IntValue >= 0)
            continue;
          let V = p.GetVarType(E.Type);
          if (V != p.floatType && V != p.intType)
            continue;
        } else if (this.method == 1) {
          if (E.Main == "get")
            continue;
        } else if (this.method == 3 && (E.Main == "get" || !["Vector2", "Vector3", "Float", "Int", "Color", "Quaternion"].includes(E.Type)))
          continue;
        let h = E.Label, L = p.GetVarType(E.Type), y = E.Type;
        L && (y = L.Label), a.has(h) && (h = h + "(" + r.Label + ")"), a.add(h), CT.IsDevApi(E) && (h = "*" + h), i.push([h + "    " + y, E.Name + ":" + r.Name, h]);
      }
  }
}
class YE extends pt {
  constructor() {
    super([["=", Nt.Unknown]]);
    N(this, "opType", "");
    this.menuGenerator_ = this.opGenerator;
  }
  setOpType(r) {
    this.opType = r;
  }
  opGenerator() {
    return ["", "int", "float", "number"].includes(this.opType.toLowerCase()) ? [
      ["=", Nt.Unknown],
      ["+=", Nt.Add],
      ["-=", Nt.Substract],
      ["*=", Nt.Multiply],
      ["/=", Nt.Divide]
    ] : [["=", Nt.Unknown]];
  }
}
let E1 = {
  init() {
    this.setOutput(!0, "Property"), this.appendDummyInput().appendField(new gT(
      2
      /* formula */
    ), d.Property);
  },
  getThisType() {
    let _ = this.outputConnection.targetConnection, s = _ == null ? void 0 : _.getCheck(), r = s == null ? void 0 : s[0];
    if (r) {
      let i = Ae.CurrentDescriptionFile, a = i.GetVarType(r);
      if (a && i.CheckIsExtention(i.getType("Property"), a))
        return a.ElementType;
    }
    return "";
  },
  loadExtraState(_) {
    if (typeof _ == "number" && vI[_]) {
      let s = this.getField(d.Property);
      s.method = _;
    }
  },
  saveExtraState() {
    let _ = this.getField(d.Property);
    return _ == null ? void 0 : _.method;
  },
  ReversedDetermineType() {
    this.getField(d.Property).UpdateDisplay();
  },
  DetermineTypes() {
    return this.getField(d.Property).UpdateDisplay(), !1;
  }
}, A1 = {
  itemCount: 0,
  TupleType: yE,
  locKey: _e.NewMap,
  getThisType() {
    return this.TupleType;
  },
  init() {
    this.setInputsInline(!0), this.appendDummyInput().appendField(new g.FieldImage(Lo, 14, 14, "+", () => {
      this.onAddItem();
    })).appendField("Create Tuple").appendField(new ni({ baseType: yE, checkExtension: !0 }), d.Type), this.setStyle("data_blocks"), this.setOutput(!0, yE);
  },
  saveExtraState() {
    return {
      [d.Index]: this.itemCount
    };
  },
  loadExtraState(_) {
    this.updateShape_(_[d.Index]);
  },
  DetermineTypes() {
    let _ = this.getFieldValue(d.Type), s = !1;
    if (_ !== this.TupleType && (s = !0, this.TupleType = _), s) {
      const r = Ae.CurrentDescriptionFile;
      for (let i = 0; i < this.itemCount; i++) {
        this.getField(d.Key + i).UpdateDisplay();
        let p = this.getFieldValue(d.Key + i), E = jl(this.TupleType, p, r), h = "";
        E && (h = E.Type), this.inputList[i * 2 + 2].setCheck(h).connection.setShadowState(xe(h));
      }
      this.setOutput(!0, this.TupleType);
    }
    return s;
  },
  updateShape_(_) {
    for (; this.itemCount < _; )
      this.addPart();
    for (; this.itemCount > _; )
      this.deletePart();
  },
  onAddItem() {
    g.Events.setGroup(!0);
    const _ = wt(this);
    let s = this.itemCount;
    this.addPart();
    const r = wt(this);
    if (_ != r) {
      g.Events.fire(new g.Events.BlockChange(this, "mutation", null, _, r));
      let i = Ae.CurrentDescriptionFile.GetVarType(this.TupleType), a = /* @__PURE__ */ new Set();
      if (i != null) {
        for (let E of i.Items) {
          if (CT.IsLowApiLevel(E) || E.Main == "get")
            continue;
          let h = E.Name + ":" + this.TupleType;
          a.has(h) || a.add(h);
        }
        for (let E = 0; E < s; ++E) {
          let h = this.getFieldValue(d.Key + E);
          a.delete(h);
        }
      }
      let p = a.size > 0 ? a.values().next().value : "";
      if (p) {
        let E = this.getField(d.Key + (this.itemCount - 1));
        E.setValue(p), E.UpdateDisplay();
      }
    }
    g.Events.setGroup(!1);
  },
  addPart() {
    let _ = this.itemCount, s = (r) => {
      let i = jl(this.TupleType, r, Ae.CurrentDescriptionFile), a = this.getInput(d.Value + _);
      return a.connection.setShadowState(xe(i == null ? void 0 : i.Type)), a.setCheck(i == null ? void 0 : i.Type), r;
    };
    this.appendDummyInput("NEW_LINE_" + this.itemCount).appendField(
      new g.FieldImage(fT, 14, 14, "-", (r) => this.onDeleteItem(r)),
      _.toString()
    ).appendField(new gT(5, s), d.Key + _), this.appendValueInput(d.Value + _).connection.setShadowState(xe("")), this.itemCount++;
  },
  onDeleteItem(_) {
    var a;
    if (!_.name)
      return;
    g.Events.setGroup(!0);
    const s = wt(this), r = Number(_.name);
    for (let p = r; p < this.itemCount; p++) {
      let E = this.getFieldValue(d.Key + (p + 1)) ?? "";
      this.setFieldValue(E, d.Key + p);
      const h = this.inputList[p * 2 + 2], L = this.inputList[(p + 1) * 2 + 2];
      h != null && h.connection.targetConnection && ((a = h.connection.targetBlock()) == null || a.dispose(!0)), h && (L != null && L.connection.targetConnection) && h.connection.connect(L.connection.targetConnection);
    }
    this.deletePart();
    const i = wt(this);
    s != i && g.Events.fire(new g.Events.BlockChange(this, "mutation", null, s, i)), g.Events.setGroup(!1);
  },
  deletePart() {
    this.itemCount--, this.removeInput("NEW_LINE_" + this.itemCount), this.removeInput(d.Value + this.itemCount);
  },
  search(_) {
    return [f.NewMap, "NewMap"].find((s) => z.containsKey(s, _)) || !1;
  }
}, d1 = {
  locKey: _e.GetPropertyId,
  init() {
    this.appendDummyInput("").appendField(f.GetPropertyId), this.appendDummyInput().appendField(new ni({ baseType: "Component", checkExtension: !0 }), d.Type), this.appendDummyInput("").appendField(f.PropertyGet_3).appendField(new gT(
      0
      /* get */
    ), d.Property), this.geId = M.get_property_id, this.setOutput(!0, "Property"), this.setInputsInline(!0), this.setHelpUrl(""), this.setStyle("action_blocks"), this.setTooltip(() => `${Oe("FE_44_SD_TIPSFCG")}: 
${this.getScriptSyntax()}`);
  },
  getShouldCheck() {
    let _ = Ae.CurrentDescriptionFile, s = this.getFieldValue(d.Type), r = this.getFieldValue(d.Property);
    return jl(s, r, _);
  },
  // a public method used in FieldProperty
  getThisType() {
    return this.getFieldValue(d.Type);
  },
  DetermineTypes() {
    let _ = this.getField(d.Property);
    _.getOptions(!1), _.UpdateDisplay(), S1(this.getShouldCheck(), this.setWarningText.bind(this), this.getFieldValue.bind(this));
  },
  getScriptSyntax() {
    return "";
  },
  search(_, s) {
    return [f.GetPropertyId].find((i) => z.containsKey(i, _)) || !1;
  }
};
function jl(_, s, r) {
  if (!_)
    return null;
  let i = s.split(":"), a = _;
  if (i.length >= 2) {
    a = i[1], s = i[0];
    let E = r.GetVarType(_);
    if (E == null || a != _ && !E.Bases.Contains(a))
      return null;
  }
  let p = r.GetVarType(a);
  if (!(p == null || p.IsEnum)) {
    for (let E of p.Items)
      if (E.Name == s)
        return E;
  }
  return null;
}
const S1 = (_, s, r) => {
  if (_)
    _.m_ApiLevel >= 10 ? s(Oe(_e.Warning_Deprecated, [_.Label]), "NODEF") : CT.IsLowApiLevel(_) ? s(Oe(_e.Warning_LowLevel, [_.Label]), "NODEF") : s(null, "NODEF");
  else {
    let i = r(d.Property);
    s(Oe(_e.Warning_NoDefine, [i]), "NODEF");
  }
};
let h1 = XE("Component", 1, M.property_set, "action_blocks"), I1 = XE("Global", 0, M.globalvar_get, "module_blocks"), M1 = XE("Global", 1, M.globalvar_set, "module_blocks"), m1 = XE(yE, 4, M.tuple_get, "data_blocks"), P1 = XE(yE, 5, M.tuple_set, "data_blocks"), D1 = {
  locKey: _e.Type,
  init() {
    this.setOutput(!0, "Type"), this.appendDummyInput().appendField(new ni(""), d.Type), this.setStyle("data_blocks");
  },
  search(_, s) {
    return [f.Type].find((i) => z.containsKey(i, _)) || !1;
  }
}, L1 = {
  locKey: _e.Component,
  init() {
    this.setOutput(!0, "Type"), this.appendDummyInput().appendField(new ni({ baseType: "Component", checkExtension: !0 }), d.Type), this.setStyle("data_blocks");
  },
  search(_, s) {
    return [f.Component, f.Type].find((i) => z.containsKey(i, _)) || !1;
  }
};
function g1(_) {
  g.Blocks[M.property_get] = p1, g.Blocks[M.property_set] = h1, g.Blocks[M.globalvar_get] = I1, g.Blocks[M.globalvar_set] = M1, g.Blocks[M.this_entity] = u1, g.Blocks[M.propertyref] = E1, g.Blocks[M.typeid] = D1, g.Blocks[M.componentid] = L1, g.Blocks[M.tuple_get] = m1, g.Blocks[M.tuple_set] = P1, g.Blocks[M.tuple_create] = A1, g.Blocks[M.get_property_id] = d1, _.set("property_get", { kind: "block", type: M.property_get }), _.set("property_set", { kind: "block", type: M.property_set }), _.set("globalvar_get", { kind: "block", type: M.globalvar_get }), _.set("globalvar_set", { kind: "block", type: M.globalvar_set }), _.set("this_entity", { kind: "block", type: M.this_entity }), _.set("FormulaProperty", {
    kind: "block",
    type: M.propertyref,
    extraState: 2
    /* formula */
  }), _.set("TweenProperty", {
    kind: "block",
    type: M.propertyref,
    extraState: 3
    /* tween */
  }), _.set("Type", { kind: "block", type: M.typeid }), _.set("ComponentID", { kind: "block", type: M.componentid }), _.set("tuple_get", { kind: "block", type: M.tuple_get }), _.set("tuple_set", { kind: "block", type: M.tuple_set }), _.set("tuple_create", { kind: "block", type: M.tuple_create }), _.set("get_property_id", { kind: "block", type: M.get_property_id });
}
function f1(_) {
  return _ === yI.clientAndServer ? !0 : z.curTarget === _;
}
const $I = X.ContextMenuRegistry.ScopeType, f4 = "$Auto";
var Tr = /* @__PURE__ */ ((_) => (_[_.SelfDefine = 0] = "SelfDefine", _[_.NextStatements = 1] = "NextStatements", _[_.ChildStatements = 2] = "ChildStatements", _[_.ChildInputs = 3] = "ChildInputs", _))(Tr || {});
function go(_, s, r, i) {
  let a = _.getField(s);
  if (a == null || !a.getVarDefine || _.isEnabled && !_.isEnabled())
    return null;
  let p = a.getVarDefine();
  return i && p.name == r || !i && p.id == r ? p : null;
}
function ki(_, s, r) {
  for (let i of _.inputList) {
    if (i.type != g.inputTypes.VALUE)
      continue;
    let a = i.connection.targetBlock();
    if (a == null)
      continue;
    let p = N1(a, s, r);
    if (p || (p = ki(a, s, r), p))
      return p;
  }
  return null;
}
function N1(_, s, r) {
  if (_.isEnabled && !_.isEnabled())
    return null;
  for (let i of _.inputList)
    for (let a of i.fieldRow) {
      if (a == null || !a.getVarDefine)
        continue;
      let p = a.getVarDefine();
      if (r && p.name == s)
        return p;
      if (!r && p.id == s)
        return p;
    }
}
let WI = {
  isOOS: !1,
  vardef: null,
  SetVarType: null,
  // abstract
  recordType: "",
  //记录的类型
  UpdateVardef() {
    let _ = this.vardef;
    if (_ == null) {
      this.setWarningText(Oe(_e.Warning_NoDefine, [""]), "NOREF");
      return;
    }
    let s = this.getField(d.VarRef);
    if (s.getValue() != _.name) {
      let i = g.Events.getRecordUndo();
      g.Events.setRecordUndo(!1), s.setValue(_.name), g.Events.setRecordUndo(i);
    }
    this.SetVarType(_.type);
  },
  updateLocalScopedVarDefine(_) {
    let s = this;
    if (this.vardef) {
      let r = this.vardef.id;
      for (; s != null; ) {
        let i = s;
        if (s = s.getParent(), s != null) {
          let a = null, p = ah(s, i);
          if (s.getVarDefine)
            a = s.getVarDefine(r, ah(s, i));
          else if (p == 1 && (a = ki(this, r, !1), a))
            return a;
          if (a != null)
            return this.isOOS = !1, this.vardef = a, this.setWarningText(null, "NOREF"), a;
        }
      }
    }
    for (s = this; s != null; ) {
      let r = s;
      if (s = s.getParent(), s != null) {
        let i = null, a = ah(s, r);
        if (s.getVarDefine)
          i = s.getVarDefine(_, a, !0);
        else if (a == 1 && (i = ki(this, _, !0), i))
          return i;
        if (i != null)
          return this.isOOS = !1, this.vardef = i, this.setWarningText(null, "NOREF"), i;
      }
    }
    return this.isOOS = !0, this.vardef ? this.setWarningText(f.Warning_LocalVar_OOS, "NOREF") : this.setWarningText(f.Warning_LocalVar_NoDefine, "NOREF"), null;
  },
  onchange(_) {
    if (_.type == g.Events.CREATE || _.type == g.Events.MOVE || _.type == g.Events.CHANGE && _.element === "disabled") {
      let s = this.getField(d.VarRef), r = s == null ? void 0 : s.getValue();
      if (!r)
        return;
      const i = ys(_);
      try {
        this.updateLocalScopedVarDefine(r), HE(this);
      } finally {
        i.Leave();
      }
    }
  },
  DetermineTypes() {
    let _ = this.recordType;
    if (this.UpdateVardef(), this.type === M.localvar_set) {
      const s = this.getField(d.Operator);
      s && s.opType !== this.recordType && (s.setOpType(this.recordType), s.UpdateDisplay());
    }
    return _ != this.recordType;
  },
  loadExtraState(_) {
    if (typeof _ == "string") {
      let s = b1(_);
      s && (this.vardef = s, this.UpdateVardef());
    }
  },
  saveExtraState() {
    var _;
    return (_ = this.vardef) == null ? void 0 : _.id;
  }
};
function b1(_) {
  let s = g.getMainWorkspace();
  for (; s.options.parentWorkspace; )
    s = s.options.parentWorkspace;
  let r = _.substring(0, 20), i = s.getBlockById(r);
  return i == null && (r = Number.parseInt(_).toString(), _ = _.replace(" ", ""), i = s.getBlockById(r)), i ? i.getVarDefine(
    _,
    0
    /* SelfDefine */
  ) : null;
}
let C1 = {
  ...WI,
  geId: M.localvar_get,
  init() {
    this.setInputsInline(!0), this.appendDummyInput(d.Value).appendField(new X.FieldLabelSerializable(), d.VarRef), this.setOutput(!0), this.setStyle("shadow_blocks");
  },
  SetVarType(_) {
    if (_ != this.recordType) {
      this.recordType = _, this.setOutput(!0, _);
      let s = Ae.CurrentDescriptionFile.GetVarType(_);
      s ? this.setTooltip(s.Label) : this.setTooltip(f.UnkownType);
    }
  }
}, O1 = {
  ...WI,
  debugAvailable: !0,
  geId: M.localvar_set,
  locKey: _e.LocalvarSet,
  init() {
    this.setInputsInline(!this.isInFlyout), this.isInFlyout && this.setEditable(!1);
    let _ = this.appendValueInput(d.Value);
    _.appendField(f.LocalvarSet).appendField(new X.FieldLabelSerializable(), d.VarRef), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.isInFlyout || (_.appendField(new YE(), d.Operator), _.connection.setShadowState(xe(""))), this.setStyle("var_blocks");
  },
  SetVarType(_) {
    if (_ != this.recordType) {
      this.recordType = _;
      let s = this.getInput(d.Value);
      _n(s, _);
    }
  },
  search(_, s) {
    const r = [f.LocalvarSet], i = s.fields && s.fields[d.VarRef];
    return i && r.push(i), r.find((a) => z.containsKey(a, _)) || !1;
  }
};
$I.BLOCK;
$I.BLOCK;
function ah(_, s) {
  let r = 2;
  return _.getNextBlock() === s ? r = 1 : s.outputConnection && (r = 3), r;
}
let R1 = {
  debugAvailable: !0,
  geId: M.localvar_def,
  locKey: _e.LcoalvarDefine,
  init() {
    const _ = this.workspace.IsCraftland, s = !_;
    let r = "var" + (Math.random() * 1e3).toFixed(0), i = function(p) {
      let E = p;
      return p === f4 && (E = "any"), this.getSourceBlock().getField(d.VarDef).setValue({ type: E }), p;
    };
    this.inputsInline = !0, this.inputsInlineDefault = !0;
    let a;
    _ ? a = new Em(d.VarDef, F0, 24, 24) : a = new gI(f.LocalvarSet, d.VarDef), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.appendValueInput(d.Value).appendField(f.LcoalvarDefine).appendField(new jt({ name: r }), d.VarDef).appendField(new ni({ hasAuto: s }, i), d.Type), this.appendDummyInput().appendField(a), this.setTooltip(f.LcoalvarDefineTooltip), this.setStyle("var_blocks");
  },
  getVarDefine(_, s, r) {
    if (s == 1 || s == 0) {
      let i = go(this, d.VarDef, _, r);
      if (i)
        return i;
    }
    return s == 1 ? ki(this, _, r) : null;
  },
  DetermineTypes() {
    var p;
    let _ = this.getInput(d.Value), s = _.connection.getCheck(), r = "";
    s && (r = s[0]);
    let i = this.getFieldValue(d.Type), a = "";
    {
      let E = (p = _.connection.targetConnection) == null ? void 0 : p.getCheck();
      E ? a = E[0] : a = "";
      let h = "", L = Ae.CurrentDescriptionFile.GetVarType(a);
      h = (L == null ? void 0 : L.Label) ?? "", this.getField(d.Type).SetAutoLabel(h);
    }
    i === f4 && (i = a, this.getField(d.VarDef).setValue({ type: i }, !1)), r != i && (_.setCheck(i), this.updateShadowDefaultValue());
  },
  updateShadowDefaultValue() {
    let _ = this.getInput(d.Value), s = tm(this.getFieldValue(d.Type));
    _.connection.setShadowState(s), setTimeout(() => {
      var i;
      let r = (i = _.connection) == null ? void 0 : i.getShadowState(!0);
      r ? r.type == s.type ? r.extraState = s.extraState : r.type == M.shadow_type && (r = s) : r = s, _.connection.setShadowState(r);
    });
  },
  search(_, s) {
    var a;
    const r = [f.LcoalvarDefine], i = s.fields && ((a = s.fields[d.VarDef]) == null ? void 0 : a.name);
    return i && r.push(i), r.find((p) => z.containsKey(p, _)) || !1;
  }
};
function y1(_) {
  g.Blocks[M.localvar_def] = R1, g.Blocks[M.localvar_get] = C1, g.Blocks[M.localvar_set] = O1, _.set("localvar_get", { kind: "block", type: M.localvar_get }), _.set("localvar_set", { kind: "block", type: M.localvar_set }), _.set("localvar_def", { kind: "block", type: M.localvar_def });
}
let v1 = {
  geId: "ifelse_craftland",
  locKey: _e.ConditionalStatement,
  uniqueIds: [],
  conditionCount: 1,
  init() {
    this.setInputsInline(!0), this.appendValueInput(d.Condition).setCheck("bool").appendField(f.If_Craftland, d.Label), this.appendStatementInput(d.Code).setCheck("action"), this.appendDummyInput().appendField("     "), this.setPreviousStatement(!0, null), this.setNextStatement(!0, null), this.setStyle("logic_blocks"), this.uniqueIds = [];
  }
}, $1 = {
  geId: "ifelse_craftland",
  locKey: _e.ConditionalStatement,
  uniqueIds: [],
  conditionCount: 1,
  init() {
    this.setInputsInline(!0), this.appendValueInput(d.Condition).setCheck("bool").appendField(f.If_Craftland, d.Label), this.appendStatementInput(d.Code), this.appendDummyInput().appendField(f.Else).appendField("     "), this.appendStatementInput(d.Code + "_else").setCheck("action"), this.appendDummyInput().appendField("     "), this.setPreviousStatement(!0, null), this.setNextStatement(!0, null), this.setStyle("logic_blocks"), this.uniqueIds = [];
  }
}, W1 = {
  geId: "EntityGetter_craftland",
  init() {
    this.setInputsInline(!0), this.appendDummyInput().appendField("No entity").appendField(new X.FieldImage(wh, 20, 20, "pick")), this.setStyle("input_blocks");
  }
}, k1 = {
  geId: "EntityGetter_craftland",
  init() {
    this.setInputsInline(!0), this.appendDummyInput().appendField("Empty list"), this.setStyle("input_blocks");
  }
};
function F1(_) {
  g.Blocks.if_craftland = v1, g.Blocks.ifelse_craftland = $1, g.Blocks.EntityGetter_craftland = W1, g.Blocks.EmptyList_craftland = k1, _.set("if_craftland", { kind: "block", type: "if_craftland", extraState: {
    [d.Index]: 1
  } }), _.set("ifelse_craftland", { kind: "block", type: "ifelse_craftland", extraState: {
    [d.Index]: 2
  } }), _.set("loop_forindex_craftland", {
    kind: "block",
    type: M.loop_forindex,
    inputs: {
      [d.From]: { block: { type: M.input_int, fields: { [d.Value]: 0 } } },
      [d.To]: { block: { type: M.input_int, fields: { [d.Value]: 10 } } },
      [d.Step]: { block: { type: M.input_int, fields: { [d.Value]: 1 } } }
    }
  }), _.set("ConstFloatOrInt_craftland", {
    kind: "block",
    type: M.input_number
  }), _.set("ConstVector3_craftland", {
    kind: "block",
    type: M.input_vector3
  }), _.set("EntityGetter_craftland", {
    kind: "block",
    type: "EntityGetter_craftland"
  }), _.set("EmptyList_craftland", {
    kind: "block",
    type: "EmptyList_craftland"
  }), _.set("loop_break_craftland", { kind: "block", type: M.loop_break }), _.set("loop_continue_craftland", { kind: "block", type: M.loop_continue }), _.set("ProcessCtlReturn_craftland", { kind: "block", type: M.function_return, extraState: { rt: "" } }), _.set("ProcessCtlReturnVoid_craftland", { kind: "block", type: M.function_return, extraState: { rt: null } });
}
var kI = typeof global == "object" && global && global.Object === Object && global, w1 = typeof self == "object" && self && self.Object === Object && self, Fi = kI || w1 || Function("return this")(), rp = Fi.Symbol, FI = Object.prototype, B1 = FI.hasOwnProperty, Y1 = FI.toString, OE = rp ? rp.toStringTag : void 0;
function U1(_) {
  var s = B1.call(_, OE), r = _[OE];
  try {
    _[OE] = void 0;
    var i = !0;
  } catch {
  }
  var a = Y1.call(_);
  return i && (s ? _[OE] = r : delete _[OE]), a;
}
var V1 = Object.prototype, G1 = V1.toString;
function H1(_) {
  return G1.call(_);
}
var x1 = "[object Null]", X1 = "[object Undefined]", N4 = rp ? rp.toStringTag : void 0;
function op(_) {
  return _ == null ? _ === void 0 ? X1 : x1 : N4 && N4 in Object(_) ? U1(_) : H1(_);
}
function Tp(_) {
  return _ != null && typeof _ == "object";
}
var K1 = "[object Symbol]";
function J1(_) {
  return typeof _ == "symbol" || Tp(_) && op(_) == K1;
}
var Vh = Array.isArray, j1 = /\s/;
function z1(_) {
  for (var s = _.length; s-- && j1.test(_.charAt(s)); )
    ;
  return s;
}
var Z1 = /^\s+/;
function Q1(_) {
  return _ && _.slice(0, z1(_) + 1).replace(Z1, "");
}
function Os(_) {
  var s = typeof _;
  return _ != null && (s == "object" || s == "function");
}
var b4 = NaN, q1 = /^[-+]0x[0-9a-f]+$/i, eP = /^0b[01]+$/i, tP = /^0o[0-7]+$/i, rP = parseInt;
function C4(_) {
  if (typeof _ == "number")
    return _;
  if (J1(_))
    return b4;
  if (Os(_)) {
    var s = typeof _.valueOf == "function" ? _.valueOf() : _;
    _ = Os(s) ? s + "" : s;
  }
  if (typeof _ != "string")
    return _ === 0 ? _ : +_;
  _ = Q1(_);
  var r = eP.test(_);
  return r || tP.test(_) ? rP(_.slice(2), r ? 2 : 8) : q1.test(_) ? b4 : +_;
}
var nP = "[object AsyncFunction]", _P = "[object Function]", iP = "[object GeneratorFunction]", oP = "[object Proxy]";
function wI(_) {
  if (!Os(_))
    return !1;
  var s = op(_);
  return s == _P || s == iP || s == nP || s == oP;
}
var ch = Fi["__core-js_shared__"], O4 = function() {
  var _ = /[^.]+$/.exec(ch && ch.keys && ch.keys.IE_PROTO || "");
  return _ ? "Symbol(src)_1." + _ : "";
}();
function TP(_) {
  return !!O4 && O4 in _;
}
var sP = Function.prototype, lP = sP.toString;
function Ql(_) {
  if (_ != null) {
    try {
      return lP.call(_);
    } catch {
    }
    try {
      return _ + "";
    } catch {
    }
  }
  return "";
}
var aP = /[\\^$.*+?()[\]{}|]/g, cP = /^\[object .+?Constructor\]$/, pP = Function.prototype, uP = Object.prototype, EP = pP.toString, AP = uP.hasOwnProperty, dP = RegExp(
  "^" + EP.call(AP).replace(aP, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function SP(_) {
  if (!Os(_) || TP(_))
    return !1;
  var s = wI(_) ? dP : cP;
  return s.test(Ql(_));
}
function hP(_, s) {
  return _ == null ? void 0 : _[s];
}
function ql(_, s) {
  var r = hP(_, s);
  return SP(r) ? r : void 0;
}
var fh = ql(Fi, "WeakMap"), R4 = Object.create, IP = /* @__PURE__ */ function() {
  function _() {
  }
  return function(s) {
    if (!Os(s))
      return {};
    if (R4)
      return R4(s);
    _.prototype = s;
    var r = new _();
    return _.prototype = void 0, r;
  };
}();
function MP(_, s) {
  var r = -1, i = _.length;
  for (s || (s = Array(i)); ++r < i; )
    s[r] = _[r];
  return s;
}
var y4 = function() {
  try {
    var _ = ql(Object, "defineProperty");
    return _({}, "", {}), _;
  } catch {
  }
}();
function mP(_, s) {
  for (var r = -1, i = _ == null ? 0 : _.length; ++r < i && s(_[r], r, _) !== !1; )
    ;
  return _;
}
var PP = 9007199254740991, DP = /^(?:0|[1-9]\d*)$/;
function LP(_, s) {
  var r = typeof _;
  return s = s ?? PP, !!s && (r == "number" || r != "symbol" && DP.test(_)) && _ > -1 && _ % 1 == 0 && _ < s;
}
function BI(_, s, r) {
  s == "__proto__" && y4 ? y4(_, s, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : _[s] = r;
}
function YI(_, s) {
  return _ === s || _ !== _ && s !== s;
}
var gP = Object.prototype, fP = gP.hasOwnProperty;
function UI(_, s, r) {
  var i = _[s];
  (!(fP.call(_, s) && YI(i, r)) || r === void 0 && !(s in _)) && BI(_, s, r);
}
function SS(_, s, r, i) {
  var a = !r;
  r || (r = {});
  for (var p = -1, E = s.length; ++p < E; ) {
    var h = s[p], L = void 0;
    L === void 0 && (L = _[h]), a ? BI(r, h, L) : UI(r, h, L);
  }
  return r;
}
var NP = 9007199254740991;
function VI(_) {
  return typeof _ == "number" && _ > -1 && _ % 1 == 0 && _ <= NP;
}
function GI(_) {
  return _ != null && VI(_.length) && !wI(_);
}
var bP = Object.prototype;
function Gh(_) {
  var s = _ && _.constructor, r = typeof s == "function" && s.prototype || bP;
  return _ === r;
}
function CP(_, s) {
  for (var r = -1, i = Array(_); ++r < _; )
    i[r] = s(r);
  return i;
}
var OP = "[object Arguments]";
function v4(_) {
  return Tp(_) && op(_) == OP;
}
var HI = Object.prototype, RP = HI.hasOwnProperty, yP = HI.propertyIsEnumerable, vP = v4(/* @__PURE__ */ function() {
  return arguments;
}()) ? v4 : function(_) {
  return Tp(_) && RP.call(_, "callee") && !yP.call(_, "callee");
};
function $P() {
  return !1;
}
var xI = typeof exports == "object" && exports && !exports.nodeType && exports, $4 = xI && typeof module == "object" && module && !module.nodeType && module, WP = $4 && $4.exports === xI, W4 = WP ? Fi.Buffer : void 0, kP = W4 ? W4.isBuffer : void 0, XI = kP || $P, FP = "[object Arguments]", wP = "[object Array]", BP = "[object Boolean]", YP = "[object Date]", UP = "[object Error]", VP = "[object Function]", GP = "[object Map]", HP = "[object Number]", xP = "[object Object]", XP = "[object RegExp]", KP = "[object Set]", JP = "[object String]", jP = "[object WeakMap]", zP = "[object ArrayBuffer]", ZP = "[object DataView]", QP = "[object Float32Array]", qP = "[object Float64Array]", eD = "[object Int8Array]", tD = "[object Int16Array]", rD = "[object Int32Array]", nD = "[object Uint8Array]", _D = "[object Uint8ClampedArray]", iD = "[object Uint16Array]", oD = "[object Uint32Array]", Jt = {};
Jt[QP] = Jt[qP] = Jt[eD] = Jt[tD] = Jt[rD] = Jt[nD] = Jt[_D] = Jt[iD] = Jt[oD] = !0;
Jt[FP] = Jt[wP] = Jt[zP] = Jt[BP] = Jt[ZP] = Jt[YP] = Jt[UP] = Jt[VP] = Jt[GP] = Jt[HP] = Jt[xP] = Jt[XP] = Jt[KP] = Jt[JP] = Jt[jP] = !1;
function TD(_) {
  return Tp(_) && VI(_.length) && !!Jt[op(_)];
}
function Hh(_) {
  return function(s) {
    return _(s);
  };
}
var KI = typeof exports == "object" && exports && !exports.nodeType && exports, vE = KI && typeof module == "object" && module && !module.nodeType && module, sD = vE && vE.exports === KI, ph = sD && kI.process, np = function() {
  try {
    var _ = vE && vE.require && vE.require("util").types;
    return _ || ph && ph.binding && ph.binding("util");
  } catch {
  }
}(), k4 = np && np.isTypedArray, lD = k4 ? Hh(k4) : TD, aD = Object.prototype, cD = aD.hasOwnProperty;
function JI(_, s) {
  var r = Vh(_), i = !r && vP(_), a = !r && !i && XI(_), p = !r && !i && !a && lD(_), E = r || i || a || p, h = E ? CP(_.length, String) : [], L = h.length;
  for (var y in _)
    (s || cD.call(_, y)) && !(E && // Safari 9 has enumerable `arguments.length` in strict mode.
    (y == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (y == "offset" || y == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    p && (y == "buffer" || y == "byteLength" || y == "byteOffset") || // Skip index properties.
    LP(y, L))) && h.push(y);
  return h;
}
function jI(_, s) {
  return function(r) {
    return _(s(r));
  };
}
var pD = jI(Object.keys, Object), uD = Object.prototype, ED = uD.hasOwnProperty;
function AD(_) {
  if (!Gh(_))
    return pD(_);
  var s = [];
  for (var r in Object(_))
    ED.call(_, r) && r != "constructor" && s.push(r);
  return s;
}
function xh(_) {
  return GI(_) ? JI(_) : AD(_);
}
function dD(_) {
  var s = [];
  if (_ != null)
    for (var r in Object(_))
      s.push(r);
  return s;
}
var SD = Object.prototype, hD = SD.hasOwnProperty;
function ID(_) {
  if (!Os(_))
    return dD(_);
  var s = Gh(_), r = [];
  for (var i in _)
    i == "constructor" && (s || !hD.call(_, i)) || r.push(i);
  return r;
}
function Xh(_) {
  return GI(_) ? JI(_, !0) : ID(_);
}
var UE = ql(Object, "create");
function MD() {
  this.__data__ = UE ? UE(null) : {}, this.size = 0;
}
function mD(_) {
  var s = this.has(_) && delete this.__data__[_];
  return this.size -= s ? 1 : 0, s;
}
var PD = "__lodash_hash_undefined__", DD = Object.prototype, LD = DD.hasOwnProperty;
function gD(_) {
  var s = this.__data__;
  if (UE) {
    var r = s[_];
    return r === PD ? void 0 : r;
  }
  return LD.call(s, _) ? s[_] : void 0;
}
var fD = Object.prototype, ND = fD.hasOwnProperty;
function bD(_) {
  var s = this.__data__;
  return UE ? s[_] !== void 0 : ND.call(s, _);
}
var CD = "__lodash_hash_undefined__";
function OD(_, s) {
  var r = this.__data__;
  return this.size += this.has(_) ? 0 : 1, r[_] = UE && s === void 0 ? CD : s, this;
}
function zl(_) {
  var s = -1, r = _ == null ? 0 : _.length;
  for (this.clear(); ++s < r; ) {
    var i = _[s];
    this.set(i[0], i[1]);
  }
}
zl.prototype.clear = MD;
zl.prototype.delete = mD;
zl.prototype.get = gD;
zl.prototype.has = bD;
zl.prototype.set = OD;
function RD() {
  this.__data__ = [], this.size = 0;
}
function hS(_, s) {
  for (var r = _.length; r--; )
    if (YI(_[r][0], s))
      return r;
  return -1;
}
var yD = Array.prototype, vD = yD.splice;
function $D(_) {
  var s = this.__data__, r = hS(s, _);
  if (r < 0)
    return !1;
  var i = s.length - 1;
  return r == i ? s.pop() : vD.call(s, r, 1), --this.size, !0;
}
function WD(_) {
  var s = this.__data__, r = hS(s, _);
  return r < 0 ? void 0 : s[r][1];
}
function kD(_) {
  return hS(this.__data__, _) > -1;
}
function FD(_, s) {
  var r = this.__data__, i = hS(r, _);
  return i < 0 ? (++this.size, r.push([_, s])) : r[i][1] = s, this;
}
function RT(_) {
  var s = -1, r = _ == null ? 0 : _.length;
  for (this.clear(); ++s < r; ) {
    var i = _[s];
    this.set(i[0], i[1]);
  }
}
RT.prototype.clear = RD;
RT.prototype.delete = $D;
RT.prototype.get = WD;
RT.prototype.has = kD;
RT.prototype.set = FD;
var VE = ql(Fi, "Map");
function wD() {
  this.size = 0, this.__data__ = {
    hash: new zl(),
    map: new (VE || RT)(),
    string: new zl()
  };
}
function BD(_) {
  var s = typeof _;
  return s == "string" || s == "number" || s == "symbol" || s == "boolean" ? _ !== "__proto__" : _ === null;
}
function IS(_, s) {
  var r = _.__data__;
  return BD(s) ? r[typeof s == "string" ? "string" : "hash"] : r.map;
}
function YD(_) {
  var s = IS(this, _).delete(_);
  return this.size -= s ? 1 : 0, s;
}
function UD(_) {
  return IS(this, _).get(_);
}
function VD(_) {
  return IS(this, _).has(_);
}
function GD(_, s) {
  var r = IS(this, _), i = r.size;
  return r.set(_, s), this.size += r.size == i ? 0 : 1, this;
}
function sp(_) {
  var s = -1, r = _ == null ? 0 : _.length;
  for (this.clear(); ++s < r; ) {
    var i = _[s];
    this.set(i[0], i[1]);
  }
}
sp.prototype.clear = wD;
sp.prototype.delete = YD;
sp.prototype.get = UD;
sp.prototype.has = VD;
sp.prototype.set = GD;
function zI(_, s) {
  for (var r = -1, i = s.length, a = _.length; ++r < i; )
    _[a + r] = s[r];
  return _;
}
var ZI = jI(Object.getPrototypeOf, Object);
function HD() {
  this.__data__ = new RT(), this.size = 0;
}
function xD(_) {
  var s = this.__data__, r = s.delete(_);
  return this.size = s.size, r;
}
function XD(_) {
  return this.__data__.get(_);
}
function KD(_) {
  return this.__data__.has(_);
}
var JD = 200;
function jD(_, s) {
  var r = this.__data__;
  if (r instanceof RT) {
    var i = r.__data__;
    if (!VE || i.length < JD - 1)
      return i.push([_, s]), this.size = ++r.size, this;
    r = this.__data__ = new sp(i);
  }
  return r.set(_, s), this.size = r.size, this;
}
function lp(_) {
  var s = this.__data__ = new RT(_);
  this.size = s.size;
}
lp.prototype.clear = HD;
lp.prototype.delete = xD;
lp.prototype.get = XD;
lp.prototype.has = KD;
lp.prototype.set = jD;
function zD(_, s) {
  return _ && SS(s, xh(s), _);
}
function ZD(_, s) {
  return _ && SS(s, Xh(s), _);
}
var QI = typeof exports == "object" && exports && !exports.nodeType && exports, F4 = QI && typeof module == "object" && module && !module.nodeType && module, QD = F4 && F4.exports === QI, w4 = QD ? Fi.Buffer : void 0, B4 = w4 ? w4.allocUnsafe : void 0;
function qD(_, s) {
  if (s)
    return _.slice();
  var r = _.length, i = B4 ? B4(r) : new _.constructor(r);
  return _.copy(i), i;
}
function eL(_, s) {
  for (var r = -1, i = _ == null ? 0 : _.length, a = 0, p = []; ++r < i; ) {
    var E = _[r];
    s(E, r, _) && (p[a++] = E);
  }
  return p;
}
function qI() {
  return [];
}
var tL = Object.prototype, rL = tL.propertyIsEnumerable, Y4 = Object.getOwnPropertySymbols, Kh = Y4 ? function(_) {
  return _ == null ? [] : (_ = Object(_), eL(Y4(_), function(s) {
    return rL.call(_, s);
  }));
} : qI;
function nL(_, s) {
  return SS(_, Kh(_), s);
}
var _L = Object.getOwnPropertySymbols, eM = _L ? function(_) {
  for (var s = []; _; )
    zI(s, Kh(_)), _ = ZI(_);
  return s;
} : qI;
function iL(_, s) {
  return SS(_, eM(_), s);
}
function tM(_, s, r) {
  var i = s(_);
  return Vh(_) ? i : zI(i, r(_));
}
function oL(_) {
  return tM(_, xh, Kh);
}
function TL(_) {
  return tM(_, Xh, eM);
}
var Nh = ql(Fi, "DataView"), bh = ql(Fi, "Promise"), Ch = ql(Fi, "Set"), U4 = "[object Map]", sL = "[object Object]", V4 = "[object Promise]", G4 = "[object Set]", H4 = "[object WeakMap]", x4 = "[object DataView]", lL = Ql(Nh), aL = Ql(VE), cL = Ql(bh), pL = Ql(Ch), uL = Ql(fh), LT = op;
(Nh && LT(new Nh(new ArrayBuffer(1))) != x4 || VE && LT(new VE()) != U4 || bh && LT(bh.resolve()) != V4 || Ch && LT(new Ch()) != G4 || fh && LT(new fh()) != H4) && (LT = function(_) {
  var s = op(_), r = s == sL ? _.constructor : void 0, i = r ? Ql(r) : "";
  if (i)
    switch (i) {
      case lL:
        return x4;
      case aL:
        return U4;
      case cL:
        return V4;
      case pL:
        return G4;
      case uL:
        return H4;
    }
  return s;
});
var EL = Object.prototype, AL = EL.hasOwnProperty;
function dL(_) {
  var s = _.length, r = new _.constructor(s);
  return s && typeof _[0] == "string" && AL.call(_, "index") && (r.index = _.index, r.input = _.input), r;
}
var X4 = Fi.Uint8Array;
function Jh(_) {
  var s = new _.constructor(_.byteLength);
  return new X4(s).set(new X4(_)), s;
}
function SL(_, s) {
  var r = s ? Jh(_.buffer) : _.buffer;
  return new _.constructor(r, _.byteOffset, _.byteLength);
}
var hL = /\w*$/;
function IL(_) {
  var s = new _.constructor(_.source, hL.exec(_));
  return s.lastIndex = _.lastIndex, s;
}
var K4 = rp ? rp.prototype : void 0, J4 = K4 ? K4.valueOf : void 0;
function ML(_) {
  return J4 ? Object(J4.call(_)) : {};
}
function mL(_, s) {
  var r = s ? Jh(_.buffer) : _.buffer;
  return new _.constructor(r, _.byteOffset, _.length);
}
var PL = "[object Boolean]", DL = "[object Date]", LL = "[object Map]", gL = "[object Number]", fL = "[object RegExp]", NL = "[object Set]", bL = "[object String]", CL = "[object Symbol]", OL = "[object ArrayBuffer]", RL = "[object DataView]", yL = "[object Float32Array]", vL = "[object Float64Array]", $L = "[object Int8Array]", WL = "[object Int16Array]", kL = "[object Int32Array]", FL = "[object Uint8Array]", wL = "[object Uint8ClampedArray]", BL = "[object Uint16Array]", YL = "[object Uint32Array]";
function UL(_, s, r) {
  var i = _.constructor;
  switch (s) {
    case OL:
      return Jh(_);
    case PL:
    case DL:
      return new i(+_);
    case RL:
      return SL(_, r);
    case yL:
    case vL:
    case $L:
    case WL:
    case kL:
    case FL:
    case wL:
    case BL:
    case YL:
      return mL(_, r);
    case LL:
      return new i();
    case gL:
    case bL:
      return new i(_);
    case fL:
      return IL(_);
    case NL:
      return new i();
    case CL:
      return ML(_);
  }
}
function VL(_) {
  return typeof _.constructor == "function" && !Gh(_) ? IP(ZI(_)) : {};
}
var GL = "[object Map]";
function HL(_) {
  return Tp(_) && LT(_) == GL;
}
var j4 = np && np.isMap, xL = j4 ? Hh(j4) : HL, XL = "[object Set]";
function KL(_) {
  return Tp(_) && LT(_) == XL;
}
var z4 = np && np.isSet, JL = z4 ? Hh(z4) : KL, jL = 1, zL = 2, ZL = 4, rM = "[object Arguments]", QL = "[object Array]", qL = "[object Boolean]", eg = "[object Date]", tg = "[object Error]", nM = "[object Function]", rg = "[object GeneratorFunction]", ng = "[object Map]", _g = "[object Number]", _M = "[object Object]", ig = "[object RegExp]", og = "[object Set]", Tg = "[object String]", sg = "[object Symbol]", lg = "[object WeakMap]", ag = "[object ArrayBuffer]", cg = "[object DataView]", pg = "[object Float32Array]", ug = "[object Float64Array]", Eg = "[object Int8Array]", Ag = "[object Int16Array]", dg = "[object Int32Array]", Sg = "[object Uint8Array]", hg = "[object Uint8ClampedArray]", Ig = "[object Uint16Array]", Mg = "[object Uint32Array]", Ht = {};
Ht[rM] = Ht[QL] = Ht[ag] = Ht[cg] = Ht[qL] = Ht[eg] = Ht[pg] = Ht[ug] = Ht[Eg] = Ht[Ag] = Ht[dg] = Ht[ng] = Ht[_g] = Ht[_M] = Ht[ig] = Ht[og] = Ht[Tg] = Ht[sg] = Ht[Sg] = Ht[hg] = Ht[Ig] = Ht[Mg] = !0;
Ht[tg] = Ht[nM] = Ht[lg] = !1;
function _S(_, s, r, i, a, p) {
  var E, h = s & jL, L = s & zL, y = s & ZL;
  if (E !== void 0)
    return E;
  if (!Os(_))
    return _;
  var V = Vh(_);
  if (V) {
    if (E = dL(_), !h)
      return MP(_, E);
  } else {
    var Z = LT(_), le = Z == nM || Z == rg;
    if (XI(_))
      return qD(_, h);
    if (Z == _M || Z == rM || le && !a) {
      if (E = L || le ? {} : VL(_), !h)
        return L ? iL(_, ZD(E, _)) : nL(_, zD(E, _));
    } else {
      if (!Ht[Z])
        return a ? _ : {};
      E = UL(_, Z, h);
    }
  }
  p || (p = new lp());
  var ce = p.get(_);
  if (ce)
    return ce;
  p.set(_, E), JL(_) ? _.forEach(function(Te) {
    E.add(_S(Te, s, r, Te, _, p));
  }) : xL(_) && _.forEach(function(Te, Le) {
    E.set(Le, _S(Te, s, r, Le, _, p));
  });
  var ve = y ? L ? TL : oL : L ? Xh : xh, et = V ? void 0 : ve(_);
  return mP(et || _, function(Te, Le) {
    et && (Le = Te, Te = _[Le]), UI(E, Le, _S(Te, s, r, Le, _, p));
  }), E;
}
var mg = 1, Pg = 4;
function iM(_) {
  return _S(_, mg | Pg);
}
var uh = function() {
  return Fi.Date.now();
}, Dg = "Expected a function", Lg = Math.max, gg = Math.min;
function fg(_, s, r) {
  var i, a, p, E, h, L, y = 0, V = !1, Z = !1, le = !0;
  if (typeof _ != "function")
    throw new TypeError(Dg);
  s = C4(s) || 0, Os(r) && (V = !!r.leading, Z = "maxWait" in r, p = Z ? Lg(C4(r.maxWait) || 0, s) : p, le = "trailing" in r ? !!r.trailing : le);
  function ce(Je) {
    var Rt = i, Wr = a;
    return i = a = void 0, y = Je, E = _.apply(Wr, Rt), E;
  }
  function ve(Je) {
    return y = Je, h = setTimeout(Le, s), V ? ce(Je) : E;
  }
  function et(Je) {
    var Rt = Je - L, Wr = Je - y, Un = s - Rt;
    return Z ? gg(Un, p - Wr) : Un;
  }
  function Te(Je) {
    var Rt = Je - L, Wr = Je - y;
    return L === void 0 || Rt >= s || Rt < 0 || Z && Wr >= p;
  }
  function Le() {
    var Je = uh();
    if (Te(Je))
      return we(Je);
    h = setTimeout(Le, et(Je));
  }
  function we(Je) {
    return h = void 0, le && i ? ce(Je) : (i = a = void 0, E);
  }
  function ot() {
    h !== void 0 && clearTimeout(h), y = 0, i = L = a = h = void 0;
  }
  function pr() {
    return h === void 0 ? E : we(uh());
  }
  function Zt() {
    var Je = uh(), Rt = Te(Je);
    if (i = arguments, a = this, L = Je, Rt) {
      if (h === void 0)
        return ve(L);
      if (Z)
        return clearTimeout(h), h = setTimeout(Le, s), ce(L);
    }
    return h === void 0 && (h = setTimeout(Le, s)), E;
  }
  return Zt.cancel = ot, Zt.flush = pr, Zt;
}
function _i(_, s, r) {
  let i = bT(s), a = Oe(_e.Warning_Param_NoDefine, [i]);
  r == ei.OutVar ? _.appendDummyInput(i).appendField(a).appendField(new jt({ name: i, type: "" }), i) : _.appendValueInput(i).appendField(a), _.setWarningText(a, "NODEF");
}
function Z4(_, s, r, i, a, p) {
  let E = s.GetVarType(i.Type), h = E, L = bT(a);
  const y = _.workspace.IsCraftland;
  let V = null, Z = _.paramInfo[L];
  if (Z) {
    let et = Z.inputType;
    et && (h = s.GetVarType(et)), Z.bShadow && (V = Z.block);
  } else
    V = z.internalBlocks.get(i.Type);
  h || (h = E);
  let le = ei.InVar;
  (i.Main == "out" || r.Main == "event") && (le = ei.OutVar), p == null && i.Main == "out" && (p = ei.OutVar);
  let ce = le != p, ve;
  if (ce && (ve = `Param "${i.Label}" in/out mismatch`, _.setWarningText(ve, L)), r.Main == "event" || p == ei.OutVar) {
    let et = _.appendDummyInput(L).appendField(new jt({ name: i.Label, type: i.Type }), L);
    if (!y) {
      let Te = new X.FieldLabel(E.Label, ce ? "red-label" : void 0);
      et.appendField(Te, L + "L"), Te.setTooltip(ve ?? i.Tip);
    }
  } else {
    let et = _.appendValueInput(L).appendField(new X.FieldLabel(i.Label, ce ? "red-label" : void 0)).setCheck(i.Type).setAlign(X.ALIGN_RIGHT);
    et.fieldRow[0].setTooltip(ve ?? i.Tip), V || (V = oM(h, s, i.Type, Z)), __(et, V);
  }
}
function Q4(_, s) {
  _.appendDummyInput("NEW_LINE_" + s);
}
function yT(_, s = !1, r) {
  const i = Ae.CurrentDescriptionFile;
  let a = "";
  if (_.Type) {
    let h = i.GetVarType(_.Type);
    h && (a = `
` + f.FunctionDefineReturn + " " + h.Label);
  }
  let p = _.m_ScriptName || _.Name;
  if (r !== void 0) {
    const h = z.graphElementMap.get(r);
    h != null && h.syntax_tooltip && (p = h.syntax_tooltip);
  }
  let E = _.Tip + a + `

${Oe("FE_44_SD_TIPSFCG")}: ${p}`;
  return (s || _.m_ApiLevel < 4) && (E += `
--------------------------------------`, s && (E += `
` + Oe("FE_42_HJ_BLOCKDESCINTERNAL")), _.m_ApiLevel < 4 && (E += `
` + Oe("FE_42_HJ_BLOCKDESCTEST"))), E.trim();
}
let OT = {
  // actionType: '', // either be action/event/variable type
  // actionEnum: 0, // the id of it, we can result it to find a rename 
  paramInfo: {},
  paramOrder: [],
  paramOpers: [],
  // idx is orderId-1, orderId is paramOrder[index]
  ecatype: void 0,
  geId: 0,
  apiname: "",
  isDev: !1,
  useCustomTooltip: !1,
  action: null,
  fixOwnerType: null,
  // special event should fix owner type
  locKey: void 0,
  common_init() {
    this.appendDummyInput().appendField("", d.Label), this.setInputsInline(!0), this.geId = 0;
  },
  getVarDefine(_, s, r) {
    if (this.action == null)
      return null;
    if (s == Tr.SelfDefine || s == Tr.NextStatements) {
      let i = this.action, a = 1;
      for (let p of i.Items) {
        let E = bT(a);
        if (p.Main == "out" || i.Main == "event") {
          let h = go(this, E, _, r);
          if (h)
            return h;
        }
        ++a;
      }
    }
    return s == Tr.NextStatements ? ki(this, _, r) : null;
  },
  UpdateDisplay() {
    if (this.geId) {
      let _ = z.graphElementMap.get(this.geId);
      _ && this.resolveApi(_.ref, _.ParsedParamOrder);
    } else
      this.apiname && this.resolveApi(this.apiname);
    this.updateTitle();
  },
  updateTitle() {
    this.action && this.updateTitle_(this.action.Label, this.action.m_ApiLevel);
  },
  loadExtraState(_) {
    const s = this.workspace.IsCraftland;
    let r = _[d.Index], i = _[d.Type];
    this.apiname = i, this.paramOrder = _[d.ParamList], this.paramOpers = _[d.Operator] ?? [], this.paramInfo = {}, _[d.OwnerType] && (this.fixOwnerType = _[d.OwnerType]);
    let a = z.graphElementMap.get(r);
    a ? (this.geId = r, this.resolveApi(a.ref, a.ParsedParamOrder), this.setStyle(s ? a.block_style_cl : a.block_style), this.DetermineTypes = Nm(a.fe_custom), this.isDev = a.dev_only, this.paramInfo = iM(a.ParsedParamInfo) ?? {}) : (this.geId = 0, this.resolveApi(i)), this.updateShape_();
  },
  saveExtraState() {
    var _;
    return {
      [d.Index]: this.geId,
      [d.ParamList]: this.paramOrder,
      [d.Operator]: this.paramOpers,
      [d.Type]: ((_ = this.action) == null ? void 0 : _.Name) ?? this.apiname,
      [d.OwnerType]: this.fixOwnerType
    };
  },
  updateTitle_(_, s) {
    var r;
    s == 10 && (_ += " " + f.Deprecated), this.isDev ? this.setFieldValue("*" + _, d.Label) : this.setFieldValue(_, d.Label), s < 4 && s != 0 && ((r = this.getField(d.Label)) == null || r.setClass("blocklyLowApiLevel")), s == 10 && this.setStyle("deprecated_blocks");
  },
  updateShape_() {
    for (let a = 1; a < 10; ++a)
      this.setWarningText(null, "P" + a);
    let _ = Ae.CurrentDescriptionFile, s = this.action;
    if (s == null) {
      let a = this.paramOrder;
      if (a) {
        let p = this.paramOpers;
        a.forEach((E, h) => {
          let L = p[h];
          this.ecatype === "event" && (L = ei.OutVar), E === -1 ? Q4(this, h) : _i(this, E, L);
        });
      }
      return;
    }
    if (!this.useCustomTooltip) {
      const a = yT(this.action, this.isDev, this.geId);
      this.setTooltip(a);
    }
    this.updateTitle(), this.ecatype === "valuation" && (this.setOutput(!0, s.Type), this.paramInfo.R = { inputType: s.Type });
    let r = this.paramOrder, i = this.paramOpers;
    if (r == null) {
      this.paramOrder = [];
      let a = 1;
      for (let p of s.Items) {
        this.paramOrder.push(a);
        let E = i[a - 1];
        this.ecatype === "event" && (E = ei.OutVar), Z4(this, _, s, p, a, E), a++;
      }
    } else
      r.forEach((a, p) => {
        if (a === -1)
          Q4(this, p);
        else {
          let E = i[a - 1];
          this.ecatype === "event" && (E = ei.OutVar);
          let h = s.Items.get_Item(a - 1);
          h == null ? _i(this, a, E) : Z4(this, _, s, h, a, E);
        }
      });
  },
  resolveApi(_, s) {
    let r = Ae.CurrentDescriptionFile;
    if (this.locKey = `desc:${_}`, this.ecatype === "action")
      this.action = r.actions.map.get(_);
    else if (this.ecatype === "valuation")
      this.action = r.variables.map.get(_);
    else if (this.ecatype === "event") {
      let a = this.fixOwnerType ?? z.OwnerType ?? "Global";
      this.action = r.FindEventDefine(_, a), _ != null && _.endsWith("receive") && !this.action && (this.action = r.FindEventDefine(_.substring(0, _.length - 7), a));
    } else if (this.ecatype === "signal") {
      let a = this.fixOwnerType ?? z.OwnerType ?? "Global";
      this.action = r.FindEventDefine(_, a);
    } else
      this.action = null;
    this.action && (this.locKey = `desc:${this.action.ScriptName}`);
    let i = this.paramOrder;
    if (i) {
      this.paramOrder = s == null ? void 0 : s.slice(), this.paramOrder == null && (this.paramOrder = []);
      for (let a of i)
        this.paramOrder.indexOf(a) == -1 && this.paramOrder.push(a);
    }
    if (this.action && this.paramOrder) {
      for (let a of this.paramOrder)
        if (this.paramOpers[a - 1] == null) {
          let p = ei.InVar;
          if (this.ecatype == "event")
            p = ei.OutVar;
          else {
            let E = this.action.Items.get_Item(a - 1);
            E && E.Main == "out" && (p = ei.OutVar);
          }
          this.paramOpers[a - 1] = p;
        }
    }
    this.action == null ? (this.setWarningText(Oe(_e.Warning_NoDefine, [_]), "NODEF"), this.setFieldValue(Oe(_e.Warning_NoDefine, [_]), d.Label)) : this.action.m_ApiLevel >= 10 ? this.setWarningText(Oe(_e.Warning_Deprecated, [_]), "NODEF") : this.setWarningText(null, "NODEF");
  },
  compose(_) {
  },
  decompose(_) {
    return null;
  },
  search(_, s) {
    var E, h;
    let r = Ae.CurrentDescriptionFile, i = (E = s.extraState) == null ? void 0 : E[d.Index], a = z.graphElementMap.get(i);
    if (a == null)
      return !1;
    let p;
    if (s.type == M.event || s.type == M.hud_buttonevent) {
      const L = (h = s.extraState) != null && h[d.OwnerType] ? s.extraState[d.OwnerType] : z.OwnerType;
      p = r.FindEventDefine(a.ref, L);
    } else
      s.type == M.action ? p = r.actions.get_Item(a.ref) : s.type == M.valution && (p = r.variables.get_Item(a.ref));
    return p == null ? !1 : [p.Label, p.Name, p.ScriptName].find((L) => z.containsKey(L, _)) ?? !1;
  }
}, Ng = {
  ...OT,
  debugAvailable: !0,
  ecatype: "action",
  init() {
    this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.common_init();
  },
  onchange(_) {
    this.geId === 305 && bg();
  }
};
const bg = (_, s) => {
};
let Cg = {
  ...OT,
  ecatype: "valuation",
  init() {
    this.setOutput(!0), this.common_init(), this.DetermineTypes && this.DetermineTypes();
  }
}, Og = {
  ...OT,
  ecatype: "event",
  init() {
    this.hat = "cap", this.common_init(), this.setNextStatement(!0, "action");
  }
};
function oM(_, s, r, i) {
  let a = M.shadow_type, p, E;
  if (_.IsEnum)
    a = M.input_enum, p = _.Name;
  else if (_ == s.boolType)
    a = M.input_boolean;
  else if (_ == s.intType)
    a = M.input_int, i && i.defaultValue && (E = {
      [d.Value]: parseInt(i.defaultValue)
    });
  else if (_ == s.floatType)
    a = M.input_float;
  else if (_ == s.stringType)
    a = M.input_text;
  else if (_ == s.numberType)
    a = M.input_number;
  else if (_ == s.vector3Type)
    a = M.input_vector3;
  else if (_.Name == "Color")
    a = M.input_color;
  else if (Bn.CheckIsAssignable(s.typeType, _, s)) {
    for (let h of s.enumTypes)
      if (h.Type == _.Name) {
        a = M.input_enum, p = h.Name;
        break;
      }
    p ?? (p = r);
  } else
    p = r;
  return {
    type: a,
    extraState: p,
    fields: E
  };
}
var aS;
((_) => {
  _.MAIN_SCENE_CHANGE = "main_scene_change";
  class s extends g.Events.Abstract {
    constructor() {
      super();
      N(this, "isBlank", !0);
      this.type = _.MAIN_SCENE_CHANGE;
    }
  }
  _.MainSceneChange = s;
})(aS || (aS = {}));
g.registry.register(
  g.registry.Type.EVENT,
  aS.MAIN_SCENE_CHANGE,
  aS.MainSceneChange
);
function Rg(_) {
  g.Blocks[M.action] = Ng, g.Blocks[M.valution] = Cg, g.Blocks[M.event] = Og;
}
let yg = {
  debugAvailable: !0,
  IsLoop: !0,
  geId: M.loop_while,
  locKey: _e.While,
  init() {
    this.setInputsInline(!0), this.setStyle("logic_blocks"), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), __(
      this.appendValueInput(d.Condition).appendField(f.While).setCheck("bool"),
      xe("bool")
    ), this.appendStatementInput(d.Code);
  },
  search(_, s) {
    return ["while", f.While].find((r) => z.containsKey(r, _)) || !1;
  }
}, TM = {
  IsLoop: !0,
  getVarDefine(_, s, r) {
    if (s == Tr.ChildStatements || s == Tr.SelfDefine)
      return go(this, d.Index, _, r) ?? go(this, d.Item, _, r);
    if (s == Tr.NextStatements)
      return ki(this, _, r);
  }
}, vg = {
  ...TM,
  debugAvailable: !0,
  geId: M.loop_forindex,
  locKey: _e.ForIndex,
  init() {
    const _ = this.workspace.IsCraftland;
    this.setInputsInline(!0), this.setStyle("logic_blocks"), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.appendDummyInput().appendField(this.workspace.IsCraftland ? Oe("T_34_WZ_WS_LOGIC6_NAME") : f.ForIndex), this.appendDummyInput(d.Index).conditionAppendField(_, "Index name").appendField(new jt({ name: "i", type: "int" }), d.Index), this.appendValueInput(d.From).appendField(_ ? Oe("T_34_WZ_WS_LOGIC6_PARAM2_NAME") : f.ForIndex_1).setCheck("number").setAlign(X.ALIGN_RIGHT), this.appendValueInput(d.To).appendField(_ ? Oe("T_34_WZ_WS_LOGIC6_PARAM3_NAME") : f.ForIndex_2).setCheck("number").setAlign(X.ALIGN_RIGHT), this.appendValueInput(d.Step).appendField(_ ? Oe("T_34_WZ_WS_LOGIC6_PARAM4_NAME") : f.ForIndex_3).setCheck("number").setAlign(X.ALIGN_RIGHT), this.appendStatementInput(d.Code);
  },
  search(_, s) {
    return ["for", f.ForIndex].find((r) => z.containsKey(r, _)) || !1;
  }
}, $g = {
  ...TM,
  debugAvailable: !0,
  geId: M.loop_foreach,
  locKey: _e.Foreach,
  init() {
    const _ = this.workspace.IsCraftland;
    this.setInputsInline(!0), this.setStyle("logic_blocks"), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.appendDummyInput().appendField(this.workspace.IsCraftland ? f.Foreach_craftland : f.Foreach), this.appendDummyInput(d.Index).conditionAppendField(_, "Index name").appendField(new jt({ name: _ ? "Index name" : "key" }), d.Index).appendField("", d.T1), this.appendDummyInput().conditionAppendField(_, Oe("T_34_WZ_WS_LOGIC7_PARAM1_NAME")).appendField(new jt({ name: _ ? Oe("T_34_WZ_WS_LOGIC7_PARAM1_NAME") : "value" }), d.Item).appendField("", d.Type), __(
      this.appendValueInput(d.Range).appendField(_ ? Oe("T_34_WZ_WS_LOGIC7_PARAM3_NAME") : f.Foreach_2).setCheck("List|Map").setAlign(X.ALIGN_RIGHT),
      xe(`List|Map__${Oe("T_40_XXJ_WS_DICTANDLIST")}`)
    ), this.appendStatementInput(d.Code);
  },
  search(_, s) {
    return ["foreach", f.Foreach].find((r) => z.containsKey(r, _)) || !1;
  },
  DetermineTypes() {
    var E, h;
    let _ = this.getInputTargetBlock(d.Range), s = this.getField(d.Index), r = this.getField(d.Item), i, a;
    if (_ != null) {
      let L = _.outputConnection.getCheck();
      if (L && L.length >= 1) {
        let y = Ae.CurrentDescriptionFile, V = y.GetVarType(L[0]), Z = y.GetVarType("Map");
        V && y.IsArray(V) ? (i = y.intType, a = y.GetVarType(V.ElementType)) : V && (V === Z || V.Bases.Contains(Z.Name)) && (i = y.GetVarType((E = V.ElementTypes) == null ? void 0 : E[0]) ?? y.anyType, a = y.GetVarType((h = V.ElementTypes) == null ? void 0 : h[1]) ?? y.anyType);
      }
    }
    let p = g.Events.getRecordUndo();
    g.Events.setRecordUndo(!1);
    try {
      i ? (s.setValue({ type: i.Name }), this.setFieldValue(i.Label, d.T1)) : (s.setValue({ type: "" }), this.setFieldValue("", d.T1)), a ? (r.setValue({ type: a.Name }), this.setFieldValue(a.Label, d.Type)) : (r.setValue({ type: "" }), this.setFieldValue("", d.Type));
    } finally {
      p && g.Events.setRecordUndo(p);
    }
  }
}, sM = {
  onchange(_) {
    let s = this.workspace;
    if (s.isDragging && s.isDragging())
      return;
    if (_.type == X.Events.BLOCK_MOVE) {
      let i = !1, a = this;
      do {
        if (a.IsLoop) {
          i = !0;
          break;
        }
        a = a.getSurroundParent();
      } while (a);
      i ? this.setWarningText(null, "LOOP") : this.setWarningText(g.Msg.CONTROLS_FLOW_STATEMENTS_WARNING, "LOOP");
    }
  }
}, Wg = {
  ...sM,
  debugAvailable: !0,
  geId: M.loop_break,
  locKey: _e.Break,
  init() {
    this.setStyle("logic_blocks"), this.setPreviousStatement(!0), this.appendDummyInput().appendField(f.Break);
  },
  search(_, s) {
    return ["break", f.Break].find((r) => z.containsKey(r, _)) || !1;
  }
}, kg = {
  ...sM,
  debugAvailable: !0,
  geId: M.loop_continue,
  locKey: _e.Continue,
  init() {
    this.setStyle("logic_blocks"), this.setPreviousStatement(!0), this.appendDummyInput().appendField(f.Continue);
  },
  search(_, s) {
    return ["continue", f.Continue].find((r) => z.containsKey(r, _)) || !1;
  }
};
function Fg(_) {
  g.Blocks[M.loop_while] = yg, g.Blocks[M.loop_forindex] = vg, g.Blocks[M.loop_foreach] = $g, g.Blocks[M.loop_break] = Wg, g.Blocks[M.loop_continue] = kg, _.set("loop_while", { kind: "block", type: M.loop_while }), _.set("loop_forindex", {
    kind: "block",
    type: M.loop_forindex,
    inputs: {
      [d.From]: { shadow: { type: M.input_int, fields: { [d.Value]: 0 } } },
      [d.To]: { shadow: { type: M.input_int, fields: { [d.Value]: 10 } } },
      [d.Step]: { shadow: { type: M.input_int, fields: { [d.Value]: 1 } } }
    }
  }), _.set("loop_foreach", { kind: "block", type: M.loop_foreach }), _.set("loop_break", { kind: "block", type: M.loop_break }), _.set("loop_continue", { kind: "block", type: M.loop_continue });
}
var ti;
((_) => {
  class s extends g.Events.Abstract {
    constructor(h, L) {
      super();
      N(this, "varId");
      N(this, "isBlank", !0);
      this.isBlank = typeof h > "u", this.varId = this.isBlank ? "" : h.id, this.workspaceId = this.isBlank ? "" : L;
    }
  }
  _.GraphVarBase = s, _.GRAPHVAR_EDIT = "graphvar_rename", _.GRAPHVAR_CREATE = "graphvar_create", _.GRAPHVAR_DELETE = "graphvar_delete", _.CUSTOM_BLOCK_DEFINE_DELETE = "block_define_delete";
  class r extends s {
    constructor(h, L, y, V, Z) {
      super(L, h);
      N(this, "oldName");
      N(this, "newName");
      N(this, "oldType");
      N(this, "newType");
      N(this, "oldValue");
      N(this, "newValue");
      this.type = _.GRAPHVAR_EDIT, y !== void 0 && (this.oldName = L.name), V !== void 0 && (this.oldType = L.type), Z !== void 0 && (this.oldValue = JSON.stringify(L.value)), this.newName = y, this.newType = V, this.newValue = JSON.stringify(Z);
    }
    /**
     * Encode the event as JSON.
     * @return {!Object} JSON representation.
     */
    toJson() {
      let h = super.toJson();
      return h.oldName = this.oldName, h.newName = this.newName, h.oldType = this.oldType, h.newType = this.newType, h.oldValue = this.oldValue, h.newValue = this.newValue, h;
    }
    /**
     * Decode the JSON event.
     * @param {!Object} json JSON representation.
     */
    fromJson(h) {
      this.isBlank = !1, this.group = h.group, this.oldName = h.oldName, this.newName = h.newName, this.oldType = h.oldType, this.newType = h.newType, this.oldValue = h.oldValue, this.newValue = h.newValue;
    }
    run(h) {
      const L = this.getEventWorkspace_();
      if (h) {
        let y;
        this.newValue && (y = JSON.parse(this.newValue)), gn.Get(L).edit(this.varId, this.newName, this.newType, y);
      } else {
        let y;
        this.newValue && (y = JSON.parse(this.oldValue)), gn.Get(L).edit(this.varId, this.oldName, this.oldType, y);
      }
    }
  }
  _.GraphVarEdit = r;
  class i extends s {
    constructor(h, L) {
      super(L, h);
      N(this, "varName");
      N(this, "varType");
      N(this, "varValue");
      this.type = _.GRAPHVAR_CREATE, this.varName = L.name, this.varType = L.type, this.varValue = JSON.stringify(L.value);
    }
    /**
     * Encode the event as JSON.
     * @return {!Object} JSON representation.
     */
    toJson() {
      let h = super.toJson();
      return h.varName = this.varName, h.varType = this.varType, h.varValue = this.varValue, h;
    }
    /**
     * Decode the JSON event.
     * @param {!Object} json JSON representation.
     */
    fromJson(h) {
      this.isBlank = !1, this.group = h.group, this.varName = h.varName, this.varType = h.varType, this.varValue = h.varValue;
    }
    run(h) {
      const L = this.getEventWorkspace_();
      if (h) {
        let y = null;
        this.varValue && (y = JSON.parse(this.varValue)), gn.Get(L).createWithId(this.varId, this.varName, this.varType, y);
      } else
        gn.Get(L).delete(this.varId);
    }
  }
  _.GraphVarCreate = i;
  class a extends s {
    constructor(h, L) {
      super(L, h);
      N(this, "varName");
      N(this, "varType");
      N(this, "varValue");
      this.type = _.GRAPHVAR_DELETE, this.varName = L.name, this.varType = L.type, this.varValue = JSON.stringify(L.value);
    }
    /**
     * Encode the event as JSON.
     * @return {!Object} JSON representation.
     */
    toJson() {
      let h = super.toJson();
      return h.varName = this.varName, h.varType = this.varType, h.varValue = this.varValue, h;
    }
    /**
     * Decode the JSON event.
     * @param {!Object} json JSON representation.
     */
    fromJson(h) {
      this.isBlank = !1, this.group = h.group, this.varName = h.varName, this.varType = h.varType, this.varValue = h.varValue;
    }
    run(h) {
      const L = this.getEventWorkspace_();
      if (h)
        gn.Get(L).delete(this.varId);
      else {
        let y = null;
        this.varValue && (y = JSON.parse(this.varValue)), gn.Get(L).createWithId(this.varId, this.varName, this.varType, y);
      }
    }
  }
  _.GraphVarDelete = a;
})(ti || (ti = {}));
class gn {
  constructor() {
    N(this, "variables", /* @__PURE__ */ new Map());
    N(this, "workspace");
    N(this, "encStr", "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ");
  }
  getByName(s) {
    for (let [r, i] of this.variables)
      if (i.name == s)
        return i;
    return null;
  }
  get(s) {
    return this.variables.get(s);
  }
  createWithId(s, r, i, a) {
    return this.get(s) != null ? (console.warn("create with duplicated id"), null) : this.getByName(r) ? (console.error("create with duplicated name"), null) : this._create(s, r, i, a);
  }
  create(s, r, i) {
    if (s = s.trim(), this.getByName(s))
      return console.error("create with duplicated name"), null;
    let a = this.encStr.length, p = "v";
    for (let E = 0; E < 8; ++E)
      p += this.encStr[Math.floor(Math.random() * a)];
    for (; this.variables.has(p); )
      p += this.encStr[Math.floor(Math.random() * a)];
    return this._create(p, s, r, i);
  }
  _create(s, r, i, a) {
    let p = {
      id: s,
      name: r,
      type: i,
      value: a
    }, E = new (g.Events.get(ti.GRAPHVAR_CREATE))(this.workspace.id, p);
    return g.Events.fire(E), this.variables.set(s, p), p;
  }
  edit(s, r, i, a) {
    let p = this.get(s);
    if (p == null)
      return;
    let E = new (g.Events.get(ti.GRAPHVAR_EDIT))(this.workspace.id, p, r, i, a);
    g.Events.fire(E), r !== void 0 && (p.name = r), i !== void 0 && (p.type = i), a !== void 0 && (p.value = a);
  }
  delete(s) {
    let r = this.get(s);
    if (r) {
      let i = new (g.Events.get(ti.GRAPHVAR_DELETE))(this.workspace.id, r);
      g.Events.fire(i), this.variables.delete(s);
    }
  }
  clear() {
    this.variables.clear();
  }
  static Get(s) {
    let r = s, i = r.graphVariables;
    return i instanceof gn ? i : r.targetWorkspace ? gn.Get(r.targetWorkspace) : (i = new gn(), r.graphVariables = i, i.workspace = s, i);
  }
  static Set(s, r) {
    let i = s;
    i.graphVariables = r;
  }
}
g.utils.xml;
class MS extends Yn {
  constructor(r, i, a) {
    super(X.Field.SKIP_SETUP);
    N(this, "variable_");
    this.menuGenerator_ = MS.dropdownCreate, r !== X.Field.SKIP_SETUP && (a && this.configure_(a), i && this.setValidator(i));
  }
  getVariable() {
    return this.variable_;
  }
  getText() {
    return this.variable_ ? this.variable_.name : "";
  }
  static dropdownCreate() {
    var p;
    let r = Ae.CurrentDescriptionFile, i = (p = this.getSourceBlock()) == null ? void 0 : p.workspace;
    const a = [];
    if (i != null) {
      let E = gn.Get(i).variables;
      for (let [h, L] of E) {
        let y = r.GetVarType(L.type), V = y ? y.Label : L.type;
        a.push(
          [L.name + " : " + V, L.id]
        );
      }
    }
    return a.length == 0 && a.push([f.Unselected, "", "", { style: "fill: var(--red_err5);" }]), a;
  }
  /**
   * Update the value of this variable field, as well as its variable and text.
   *
   * The variable ID should be valid at this point, but if a variable field
   * validator returns a bad ID, this could break.
   * @param {*} newId The value to be saved.
   * @protected
   */
  doValueUpdate_(r) {
    this.variable_ = gn.Get(this.sourceBlock_.workspace).get(r), super.doValueUpdate_(r);
  }
  referencesVariables() {
    return !0;
  }
  refreshVariableName() {
    this.forceRerender();
  }
}
const lM = {
  /**
   * Add menu option to create getter/setter block for this setter/getter.
   * @param {!Array} options List of menu options to add to.
   * @this {Block}
   */
  // customContextMenu(options: Array<Blockly.ContextMenuRegistry.ContextMenuOption | Blockly.ContextMenuRegistry.LegacyContextMenuOption>) {
  //     // Getter blocks have the option to create a setter block, and vice versa.
  //     if(!this.isEditable()) return options;
  //     if (!this.isInFlyout) {
  //         let oppositeType;
  //         let contextMenuMsg;
  //         const id = this.getFieldValue(SerializeKeys.VarRef);
  //         const varInfo = GraphVars.Get(this.workspace).get(id);
  //         if (!varInfo) {
  //             return options;
  //         }
  //         const varType = varInfo.type;
  //         if (this.type === BlockTypes.graphvar_get) {
  //             oppositeType = BlockTypes.graphvar_set;
  //             contextMenuMsg = Msg['VARIABLES_GET_CREATE_SET'];
  //         } else {
  //             oppositeType = BlockTypes.graphvar_get;
  //             contextMenuMsg = Msg['VARIABLES_SET_CREATE_GET'];
  //         }
  //         const name = this.getField(SerializeKeys.VarRef).getText();
  //         const xmlField = xml.createElement('field');
  //         xmlField.setAttribute('name', SerializeKeys.VarRef);
  //         xmlField.setAttribute('variabletype', varType);
  //         xmlField.appendChild(xml.createTextNode(id));
  //         const xmlBlock = xml.createElement('block');
  //         xmlBlock.setAttribute('type', oppositeType);
  //         xmlBlock.appendChild(xmlField);
  //         options.push({
  //             enabled: this.workspace.remainingCapacity() > 0,
  //             text: contextMenuMsg.replace('%1', name),
  //             callback: ContextMenu.callbackFactory(this, xmlBlock),
  //         });
  //     } else {
  //         const searchOption = {
  //             text: $t('FE_44_HZY_SEARCH_VARIABLENAME'),
  //             enabled: true,
  //             callback: () => {
  //                 const name = (this.getField(SerializeKeys.VarRef) as FieldGraphVar)?.getVariable()?.name;
  //                 if(name) {
  //                     const cm = GModuleManager.Get(ICommandModule);
  //                     cm.Send(ECommandActionIds.toolbar_logic_search, name);
  //                 }
  //             }
  //         };
  //         options.splice(1, 0, searchOption);
  //         //if (this.type === BlockTypes.graphvar_set) {
  //             const renameOption = {
  //                 text: $t('FE_0_B_WORK_EDIT_VARIABLE'),
  //                 enabled: true,
  //                 callback: renameOptionCallbackFactory(this),
  //             };
  //             const name = this.getField(SerializeKeys.VarRef).getText();
  //             const deleteOption = {
  //                 text: Msg['DELETE_VARIABLE'].replace('%1', name),
  //                 enabled: true,
  //                 callback: deleteOptionCallbackFactory(this),
  //             };
  //             options.unshift(renameOption);
  //             options.unshift(deleteOption);
  //        // }
  //     }
  // },
  /**
   * Called whenever anything on the workspace changes.
   * Set the connection type for this block.
   * @param {AbstractEvent} _e Change event.
   * @this {Block}
   */
  onchange(_) {
    if (_ instanceof ti.GraphVarBase) {
      let s = ys(_);
      try {
        HE(this);
      } finally {
        s.Leave();
      }
    }
  },
  DetermineTypes() {
    const _ = this.getFieldValue(d.VarRef), s = gn.Get(this.workspace).get(_);
    s == null ? this.setWarningText(Oe(_e.Warning_NoDefine, [_]), "NODEF") : this.setWarningText(null, "NODEF");
    const r = (s == null ? void 0 : s.type) ?? "";
    if (this.type === M.graphvar_get) {
      let a = this.outputConnection.getCheck(), p = null;
      if (a && a.length == 1 && (p = a[0]), p != r)
        return this.outputConnection.setCheck(r), !0;
      var i = this.getField(d.VarRef);
      i.refreshVariableName();
    } else if (this.type === M.graphvar_set) {
      let a = this.getInput(d.Value);
      _n(a, r);
      var i = this.getField(d.VarRef);
      i.refreshVariableName();
      const E = this.getField(d.Operator);
      E && E.opType !== r && (E.setOpType(r), E.UpdateDisplay());
    }
  },
  initToolTip() {
    this.setTooltip(() => "");
  }
};
let wg = {
  ...lM,
  geId: M.graphvar_get,
  locKey: _e.GetVar,
  init() {
    this.setInputsInline(!0), this.inputsInlineDefault = !0, this.setStyle("var_blocks"), this.appendDummyInput().appendField(new MS("item"), d.VarRef), this.setOutput(!0), this.initToolTip();
  },
  search(_, s, r, i) {
    return !1;
  }
}, Bg = {
  ...lM,
  debugAvailable: !0,
  geId: M.graphvar_set,
  locKey: _e.SetVar,
  init() {
    this.setInputsInline(!0), this.inputsInlineDefault = !0, this.setStyle("var_blocks"), this.appendValueInput(d.Value).appendField(f.SetVar).appendField(new MS("item"), d.VarRef).appendField(new YE(), d.Operator).connection.setShadowState(xe("")), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.initToolTip();
  },
  search(_, s, r, i) {
    return !1;
  }
};
function Yg(_) {
  g.Blocks[M.graphvar_get] = wg, g.Blocks[M.graphvar_set] = Bg, _.set("graphvar_def", {
    kind: "customButton",
    text: Oe("FE_0_HW_WORK_CREATE_VARIABLE"),
    background: {
      show: !0,
      rx: 0,
      ry: 0,
      borderWidth: 1
    },
    callbackKey: "CREATE_GRAPH_VAR"
  }), _.set("graphvar_get", { kind: "block", type: M.graphvar_get }), _.set("graphvar_set", { kind: "block", type: M.graphvar_set });
}
class Ug {
  constructor() {
    N(this, "priority", 99);
  }
  save(s) {
    let r = gn.Get(s);
    if (r) {
      const i = [];
      for (const [a, p] of r.variables)
        i.push(p);
      return i.length ? i : null;
    }
  }
  /**
   * Deserializes the variable defined by the given state into the given
   * workspace.
   * @param {!Array<!State>} state The state of the variables to deserialize.
   * @param {!Workspace} workspace The workspace to deserialize into.
   */
  load(s, r) {
    let i = gn.Get(r);
    for (const a of s) {
      let p = {
        id: a.id,
        name: a.name,
        type: a.type,
        value: a.value
      };
      i.variables.set(p.id, p);
    }
  }
  /**
   * Disposes of any variables that exist on the workspace.
   * @param {!Workspace} workspace The workspace to clear the variables of.
   */
  clear(s) {
    gn.Get(s).clear();
  }
}
g.serialization.registry.unregister("variables");
g.serialization.registry.register("variables", new Ug());
g.registry.register(g.registry.Type.EVENT, ti.GRAPHVAR_EDIT, ti.GraphVarEdit);
g.registry.register(g.registry.Type.EVENT, ti.GRAPHVAR_CREATE, ti.GraphVarCreate);
g.registry.register(g.registry.Type.EVENT, ti.GRAPHVAR_DELETE, ti.GraphVarDelete);
class Vg {
  constructor() {
    N(this, "isDisposed", !1);
    N(this, "disposableObjectCollection");
    cS.Add(this);
  }
  CollectDisposalObject(s) {
    this.disposableObjectCollection || (this.disposableObjectCollection = new Gg()), this.disposableObjectCollection.Collect(s);
  }
  IsDisposed() {
    return this.isDisposed;
  }
  Dispose() {
    this.isDisposed || (this.isDisposed = !0, cS.Remove(this), this.disposableObjectCollection && this.disposableObjectCollection.Dispose());
  }
}
class Gg {
  constructor() {
    N(this, "isDisposed", !1);
    N(this, "disposableObjs");
    cS.Add(this);
  }
  Collect(s) {
    if (s) {
      if (this.disposableObjs || (this.disposableObjs = /* @__PURE__ */ new Set()), this.isDisposed) {
        console.error("try to add a disposable object into disposed collection");
        return;
      }
      this.disposableObjs.add(s);
    }
  }
  Dispose() {
    if (!this.isDisposed && (cS.Remove(this), this.isDisposed = !0, !!this.disposableObjs)) {
      for (let s of this.disposableObjs)
        s.Dispose();
      this.disposableObjs.clear();
    }
  }
}
class mS {
  constructor() {
    N(this, "comp", new Vg());
  }
  CollectDisposalObject(s) {
    this.comp.CollectDisposalObject(s);
  }
  IsDisposed() {
    return this.comp.IsDisposed();
  }
  Dispose() {
    this.IsDisposed() || (this.comp.Dispose(), this.OnDispose());
  }
  OnDispose() {
  }
}
const cS = new class {
  // private trackedOrder = new UniqueIDGen();
  //private trackedObjects = new Map<IDisposableObject, TrackInfo>();
  Add(_) {
  }
  Remove(_) {
  }
  // public CheckLeak() {
  //     console.log(`------------------ LEAK REPORT BEGIN (${this.trackedObjects.size})------------------`);
  //     let index = 0;
  //     let trackedList = new Array<TrackInfo>(this.trackedObjects.size);
  //     this.trackedObjects.forEach((v, k) => {
  //         trackedList[index] = v;
  //         index++;
  //     });
  //     trackedList.sort((a, b) => {
  //         return a.order < b.order ? -1 : 1;
  //     });
  //     for (let i = 0; i < trackedList.length; ++i) {
  //         console.log(trackedList[i].obj);
  //         console.log(`[@${i} #${trackedList[i].order} callstack]: \n${trackedList[i].stack}`);
  //     }
  //     console.log(`------------------ LEAK REPORT END (${this.trackedObjects.size})------------------`);
  // }
}(), Rs = new class extends mS {
  constructor() {
    super(...arguments);
    N(this, "_Mods", /* @__PURE__ */ new Map());
  }
  Register(s, r) {
    this._Mods.has(s) || (this._Mods.set(s, r), this.CollectDisposalObject(r));
  }
  Get(s) {
    return this._Mods.get(s);
  }
  OnDispose() {
    this._Mods.forEach((s, r) => {
      s.Dispose();
    }), this._Mods.clear();
  }
}();
let Eh = /* @__PURE__ */ new Map();
function aM(_) {
  if (Eh.has(_))
    return Eh.get(_);
  const s = function() {
  };
  return s.toString = () => _, Eh.set(_, s), s;
}
class cM extends mS {
}
const KE = aM("reserved.mod.project"), q4 = g.utils.Svg;
class zt extends X.Field {
  constructor(r, i, a) {
    super("", i, a);
    N(this, "SERIALIZABLE", !0);
    /** Tspan based arrow element. */
    N(this, "arrow_", null);
    /** SVG based arrow element. */
    N(this, "svgArrow_", null);
    // TODO: we may display image
    N(this, "imageElement_", null);
    N(this, "resourceType");
    N(this, "subinfo");
    N(this, "defaultLabel", "");
    N(this, "nullable", !1);
    N(this, "resourceNotFound", !1);
    N(this, "previousText");
    this.resourceType = r.type, this.defaultLabel = r.defaultLabel, this.subinfo = r.subinfo, this.nullable = r.nullable || !1;
  }
  SetSubInfo(r, i) {
    this.subinfo = r, i != null && (this.defaultLabel = i);
  }
  get SubInfo() {
    return this.subinfo;
  }
  initView() {
    this.shouldAddBorderRect_() ? this.createBorderRect_() : this.clickTarget_ = this.getSvgRoot(), this.createTextElement_(), this.imageElement_ = g.utils.dom.createSvgElement(q4.IMAGE, {}, this.fieldGroup_), this.createSVGSelector_(), this.borderRect_ && g.utils.dom.addClass(this.borderRect_, "blocklyDropdownRect");
  }
  UpdateDisplay() {
    this.previousText !== this.getText_() && (this.markDirty(), this.forceRerender());
  }
  /** Draws the border with the correct width. */
  render_() {
    this.getTextContent().nodeValue = "", this.imageElement_.style.display = "none", this.renderSelectedText_(), this.positionBorderRect_();
  }
  /** Renders the selected option, which must be text. */
  renderSelectedText_() {
    this.getTextContent().nodeValue = this.getDisplayText_();
    const r = this.getTextElement();
    g.utils.dom.addClass(r, "blocklyDropdownText"), r.setAttribute("text-anchor", "start"), r.setAttribute("style", this.resourceNotFound ? "fill: var(--red_err5)" : "");
    const i = !!this.borderRect_, a = Math.max(
      i ? this.getConstants().FIELD_DROPDOWN_BORDER_RECT_HEIGHT : 0,
      this.getConstants().FIELD_TEXT_HEIGHT
    ), p = g.utils.dom.getFastTextWidth(
      this.getTextElement(),
      this.getConstants().FIELD_TEXT_FONTSIZE,
      this.getConstants().FIELD_TEXT_FONTWEIGHT,
      this.getConstants().FIELD_TEXT_FONTFAMILY
    ), E = i ? this.getConstants().FIELD_BORDER_RECT_X_PADDING : 0;
    let h = 0;
    this.svgArrow_ && (h = this.positionSVGArrow_(
      p + E,
      a / 2 - this.getConstants().FIELD_RESOURCE_SELECTOR_SVG_SIZE / 2
    )), this.size_.width = p + h + E * 2, this.size_.height = a, this.positionTextElement_(E, p);
  }
  /**
   * Position a drop-down arrow at the appropriate location at render-time.
   *
   * @param x X position the arrow is being rendered at, in px.
   * @param y Y position the arrow is being rendered at, in px.
   * @returns Amount of space the arrow is taking up, in px.
   */
  positionSVGArrow_(r, i) {
    if (!this.svgArrow_)
      return 0;
    const p = !!this.borderRect_ ? this.getConstants().FIELD_BORDER_RECT_X_PADDING : 0, E = this.getConstants().FIELD_DROPDOWN_SVG_ARROW_PADDING, h = this.getConstants().FIELD_RESOURCE_SELECTOR_SVG_SIZE, L = this.getSourceBlock().RTL ? p : r + E;
    return this.svgArrow_.setAttribute(
      "transform",
      "translate(" + L + "," + i + ")"
    ), h + E;
  }
  createSVGSelector_() {
    this.svgArrow_ = g.utils.dom.createSvgElement(
      q4.IMAGE,
      {
        height: this.getConstants().FIELD_RESOURCE_SELECTOR_SVG_SIZE + "px",
        width: this.getConstants().FIELD_RESOURCE_SELECTOR_SVG_SIZE + "px"
      },
      this.fieldGroup_
    ), this.svgArrow_.setAttributeNS(
      g.utils.dom.XLINK_NS,
      "xlink:href",
      this.getConstants().FIELD_RESOURCE_SELECTOR_SVG_DATAURI
    );
  }
  getTextElement() {
    return this.textElement_;
  }
  getTextContent() {
    return this.textContent_;
  }
  getText_() {
    this.previousText = this.defaultLabel;
    let r = this.value_;
    if (this.resourceNotFound = !this.nullable, !r)
      return this.defaultLabel;
    this.resourceNotFound = !1;
    let a = Rs.Get(KE).FindGFile(r);
    if (a && a.treeViewData) {
      let p = Oe(a.treeViewData.name);
      return this.previousText = p, p;
    }
    return this.resourceNotFound = !0, this.previousText = r, r;
  }
  shouldAddBorderRect_() {
    let r = !this.getConstants().FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW || this.getConstants().FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW && !this.getSourceBlock().isShadow(), i = 0;
    for (let a = 0, p; p = this.getSourceBlock().inputList[a]; a++) {
      for (let E = 0; p.fieldRow[E]; E++)
        if (p.fieldRow[E].EDITABLE && i++, i >= 2)
          return !0;
      if (p.connection)
        return !0;
    }
    return r;
  }
  showEditor_(r) {
    z.func_showResourceSelector && z.func_showResourceSelector(this.getValue(), {
      type: this.resourceType,
      info: this.subinfo,
      onChange: (i) => {
      }
    });
  }
  applyColour() {
    const r = this.sourceBlock_.style;
    this.borderRect_ && (this.borderRect_.setAttribute("stroke", r.colourTertiary), this.borderRect_.setAttribute("fill", "transparent"));
  }
  refreshText() {
    var r;
    ((r = this.textContent_) == null ? void 0 : r.nodeValue) !== this.getDisplayText_() && this.forceRerender();
  }
}
let pM = X.BlockSvg.prototype.setShadow;
function Hg(_, s) {
  let r = z.func_entityPickList;
  return r ? r(_, s) : [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]];
}
class xg extends Yn {
  constructor(s, r) {
    super([[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]], s, r), this.menuGenerator_ = () => {
      let i = this.sourceBlock_.getFieldValue(d.Hud);
      return Hg(i, "Component");
    };
  }
  getValueDefaultOptions(s) {
    return this.sourceBlock_ == null ? [s, s] : [s + f.UnkownType, s, "", { style: "fill: var(--red_err5);" }];
  }
}
let Xg = {
  geId: M.pick_entity,
  locKey: _e.PickEntity,
  init() {
    this.appendDummyInput().appendField(f.PickEntity, d.Label).appendField(new zt({ type: "GFileType", subinfo: "scene", defaultLabel: f.SceneFile }), d.Hud).appendField(new xg(), d.Entity).appendField(new X.FieldImage(wh, 20, 20, "pick", (_) => Jg(this))), this.setOutput(!0), $E && $E.block_style ? this.setStyle($E.block_style) : this.setStyle("module_blocks");
  },
  setShadow(_) {
    pM.call(this, _), _ && this.inputList[0].removeField(d.Label, !0);
  },
  DetermineTypes() {
    let _ = this.outputConnection.getCheck(), s = null;
    _ && _.length == 1 && (s = _[0]);
    let r = this.getFieldValue(d.Hud);
    if (!r && z.SceneName) {
      const E = `${z.SceneName}.scene`, L = [].find((y) => y.name === E);
      L && (r = L.id, this.setFieldValue(r, d.Hud));
    }
    this.UpdateDisplayByScene();
    let i = this.getFieldValue(d.Entity), a = "Component", p = z.func_getEntityInfo;
    if (p && r) {
      let E = p(r, i);
      E && E.ecaType && (a = E.ecaType);
    }
    if (a != s) {
      this.setOutput(!0, a);
      let h = Ae.CurrentDescriptionFile.GetVarType(a);
      return this.setTooltip(h.Label), !0;
    }
  },
  UpdateDisplayByScene(_, s) {
    let r = this.getField(d.Hud);
    (!_ || _ === r.getValue()) && (r.UpdateDisplay(), this.getField(d.Entity).UpdateDisplay());
  },
  search(_, s) {
    return ["pickentity", f.PickEntity].find((r) => z.containsKey(r, _)) || !1;
  }
}, Kg = {
  geId: M.pick_prefab,
  locKey: _e.PrefabLabel,
  init() {
    this.appendDummyInput().appendField(new zt({ type: "Prefab", defaultLabel: f.PrefabLabel }), d.Entity), this.setOutput(!0, "$PrefabT_Entity"), ep && ep.block_style ? this.setStyle(ep.block_style) : this.setStyle("module_blocks");
  },
  setShadow(_) {
    pM.call(this, _), _ && this.inputList[0].removeField(d.Label, !0);
  },
  UpdateDisplayByScene(_) {
    let s = this.getField(d.Entity);
    (!_ || _ === s.getValue()) && s.refreshText();
  },
  search(_) {
    return ["pickprefab", f.PrefabLabel].find((s) => z.containsKey(s, _)) || !1;
  },
  DetermineTypes() {
    let _ = Ae.CurrentDescriptionFile, s = this.outputConnection.getCheck(), r = null;
    s && s.length == 1 && (r = s[0]);
    let i = this.getFieldValue(d.Entity), a = "$PrefabT_Component", p = z.func_getEntityInfo;
    if (p && i) {
      let E = p(i, "$PrefabRoot");
      if (E && E.ecaType) {
        const h = _.GetVarType("$PrefabT"), L = _.GetVarType(E.ecaType);
        L && (a = _.GetGenericVarType(h, L).Name);
      }
    }
    if (a != r) {
      this.setOutput(!0, a);
      let E = _.GetVarType(a);
      return this.setTooltip(E.Label), !0;
    }
  }
};
function Jg(_) {
  let s = z.func_pickSceneEntity;
  if (s == null)
    return;
  const r = _.getFieldValue(d.Hud);
  s("Component", r).then((i) => {
    X.Events.setGroup(!0), _.setFieldValue(i.sceneId, d.Hud), _.setFieldValue(i.entityId, d.Entity), _.getField(d.Entity).UpdateDisplay(), X.Events.setGroup(!1);
  }, (i) => {
  });
}
var $E, ep;
function jg(_) {
  g.Blocks[M.pick_entity] = Xg, g.Blocks[M.pick_prefab] = Kg, $E = { kind: "block", type: M.pick_entity }, ep = { kind: "block", type: M.pick_prefab }, _.set("EntityGetter", $E), _.set("PrefabGetter", ep), _.set("PrefabID", ep);
}
const { dom: eI } = X.utils;
function tp(_ = "MyFunction") {
  return _ + (Math.random() * 1e4).toFixed(0);
}
let zg = {
  argId: "",
  geId: M.function_mutator_parameter,
  init() {
    let _ = this.isInFlyout ? "" : tp("Param");
    this.argId = tp("_arg"), this.appendDummyInput(d.ParamList).appendField(new X.FieldDropdown([[f.VarIn, ""], [f.VarOut, "out"]]), d.Operator).appendField(new fo(_, (s) => s || null), d.Name).appendField(new ni(""), d.Type), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setStyle("function_blocks");
  }
}, Zg = {
  geId: M.function_mutator_container,
  init() {
    this.appendDummyInput().appendField(new g.FieldImage(Lo, 14, 14, "+", () => {
      this.onAddItem();
    })).appendField(f.FunctionMutatorParameters), this.appendStatementInput(d.ParamList), this.setStyle("function_blocks");
  },
  onAddItem() {
    let _ = {
      type: M.function_mutator_parameter
    }, s = this.getInputTargetBlock(d.ParamList);
    if (s == null) {
      const r = g.serialization.blocks.append(_, this.workspace, { recordUndo: !0 });
      this.getInput(d.ParamList).connection.connect(r.previousConnection);
    } else {
      const r = g.serialization.blocks.append(_, this.workspace, { recordUndo: !0 });
      s.lastConnectionInStack(!0).connect(r.previousConnection);
    }
  }
}, PS = {
  arguments_: [],
  getFunctionDef() {
    let _ = this.arguments_;
    for (let s of _) {
      let r = this.getFieldValue(s.id);
      r && (s.type = r.type);
    }
    return {
      id: this.id,
      name: this.getFieldValue(d.Name),
      params: this.arguments_,
      returnType: this.getFieldValue(d.Return)
    };
  },
  compose(_) {
    this.arguments_ = [];
    let s = _.getInputTargetBlock(d.ParamList);
    for (; s && !s.isInsertionMarker(); ) {
      const i = s.argId, a = s.getFieldValue(d.Operator) === "out", p = s.getFieldValue(d.Name), E = s.getFieldValue(d.Type);
      this.arguments_.push({ id: i, name: p, type: E, isOut: a }), s = s.nextConnection && s.nextConnection.targetBlock();
    }
    this.updateShape_(this.arguments_), GE(this);
  },
  decompose(_) {
    var s = _.newBlock(M.function_mutator_container);
    s.initSvg();
    var r = s.getInput(d.ParamList).connection;
    for (var i of this.arguments_) {
      var a = _.newBlock(M.function_mutator_parameter);
      a.initSvg(), a.argId = i.id, a.setFieldValue(i.isOut ? "out" : "", d.Operator), a.setFieldValue(i.name, d.Name), a.setFieldValue(i.type, d.Type), r.connect(a.previousConnection), r = a.nextConnection;
    }
    return s;
  },
  saveExtraState() {
    return this.arguments_;
  },
  loadExtraState(_) {
    let s = [];
    if (_) {
      for (let r of _)
        typeof r == "string" ? s.push({
          id: r,
          name: "",
          type: "any"
        }) : s.push(r);
      this.arguments_ = s, this.updateShape_(s);
    }
  },
  updateTypeLabel(_) {
    if (_ instanceof jt) {
      let s = Ae.CurrentDescriptionFile, r = _.vardef, i = s.GetVarType(r.type), a = r.type;
      i != null && (a = i.Label);
      let p = this.arguments_.find((h) => h.id === _.name);
      p && (p.name = r.name);
      let E = X.Events.getRecordUndo();
      X.Events.setRecordUndo(!1), this.getField("label" + _.name) && this.setFieldValue(a, "label" + _.name), X.Events.setRecordUndo(E);
    }
  },
  updateShape_(_) {
    let s = Ae.CurrentDescriptionFile, r = this;
    for (let p of _) {
      p.name == "" && (p.name = tp("Param"));
      let E = s.GetVarType(p.type), h = p.type;
      E != null && (h = E.Label);
      let L = this.getInput(p.id);
      L ? (L.fieldRow[0].setValue(p.isOut ? f.VarOut : f.VarIn), L.fieldRow[2].setValue(h), L.fieldRow[1].setValue(p)) : L = this.appendDummyInput(p.id).appendField(p.isOut ? f.VarOut : f.VarIn).appendField(new jt(p, a), p.id).appendField(h, "label" + p.id).appendField(new gI(f.LocalvarSet, p.id)), this.moveInputBefore(p.id, d.Code);
    }
    let i = d.Code;
    for (_.length > 0 && (i = _[0].id); this.inputList[1].name != i; )
      this.removeInput(this.inputList[1].name);
    function a(p) {
      return setTimeout(() => {
        GE(r), r.updateTypeLabel(this);
      }), p;
    }
  },
  getVarDefine(_, s, r) {
    if (s == Tr.ChildStatements || s == Tr.SelfDefine) {
      for (let i of this.inputList)
        if (i.name) {
          let a = go(this, i.name, _, r);
          if (a)
            return a;
        }
    }
    return s == Tr.NextStatements ? ki(this, _, r) : null;
  },
  initTooltips() {
    this.setTooltip(() => "");
  },
  checkHasReturn() {
    if (!this.getField(d.Return))
      return;
    let _ = this.getInput(d.Code).connection.targetBlock();
    s(_) ? this.setWarningText(null, "funcret") : this.setWarningText(Oe("FE_42_XXJ_NORETURN"), "funcret");
    function s(r) {
      for (; r; ) {
        if (r.type == M.function_return)
          return !0;
        for (let i of r.inputList)
          if (i.type === X.inputTypes.STATEMENT && s(i.connection.targetBlock()))
            return !0;
        r = r.getNextBlock();
      }
    }
  }
}, Ah = {
  ...PS,
  geId: M.function_definition_valution,
  locKey: _e.FunctionDefineValution,
  init() {
    this.setInputsInline(!0);
    const _ = this.workspace.IsCraftland;
    let s = this.appendDummyInput(d.Header).appendField(f.FunctionDefineValution);
    _ || s.appendField(new fo(LS(this), DS), d.Name).appendField(f.FunctionDefineReturn).appendField(new ni(""), d.Return).appendField(new gS(f.ReturnSentense, ""), d.Return + "_drag"), this.appendStatementInput(d.Code), _ && this.appendValueInput(d.Return).appendField("return Value"), this.setStyle("function_blocks"), _ || this.setMutator(new g.icons.MutatorIcon([], this)), this.initTooltips();
  },
  onchange(_) {
    if (_ instanceof X.Events.BlockMove) {
      const r = _.reason ?? [];
      let i;
      if (r.includes("connect"))
        i = _.newParentId;
      else if (r.includes("disconnect"))
        i = _.oldParentId;
      else
        return;
      let p = this.workspace.getBlockById(i);
      for (; p != null && p.getParent(); )
        p = p.getParent();
      (p == null ? void 0 : p.id) === this.id && this.checkHasReturn();
    }
    if (!(_ instanceof X.Events.BlockChange) || _.blockId != this.id)
      return;
    let s = ys(_);
    _.type == g.Events.BLOCK_CHANGE && _.element == "field" && _.name == d.Return && GE(this), s.Leave();
  },
  search(_, s, r, i) {
    return !1;
  }
}, Qg = {
  ...PS,
  geId: M.function_definition_action,
  locKey: _e.FunctionDefineAction,
  init() {
    const _ = this.workspace.IsCraftland;
    let s = this.appendDummyInput(d.Header).appendField(f.FunctionDefineAction);
    _ || s.appendField(new fo(LS(this, !1), DS), d.Name).appendField(new gS(f.ReturnSentense, ""), d.Return + "_drag"), this.appendStatementInput(d.Code), _ && this.appendDummyInput(), this.setStyle("function_blocks"), _ || this.setMutator(new g.icons.MutatorIcon([], this)), this.initTooltips();
  },
  search(_, s, r, i) {
    return !1;
  }
};
({
  ...PS,
  geId: M.function_xbt_action,
  locKey: _e.FunctionXBTAction
});
({
  ...PS,
  geId: M.function_xbt_condition,
  locKey: _e.FunctionXBTCondition
});
let jh = {
  paramCount: 0,
  state_: {},
  locKey: _e.FunctionCall,
  // customContextMenu(options: Array<Blockly.ContextMenuRegistry.ContextMenuOption | Blockly.ContextMenuRegistry.LegacyContextMenuOption>) {
  //     if (this.isInFlyout) {
  //         const searchOption = {
  //             text: $t('FE_44_HZY_SEARCH_FUNCTIONNAME'),
  //             enabled: true,
  //             callback: () => {
  //                 const name = this.getField(SerializeKeys.Name)?.getValue();
  //                 if(name) {
  //                     const cm = GModuleManager.Get(ICommandModule);
  //                     cm.Send(ECommandActionIds.toolbar_logic_search, name);
  //                 }
  //             }
  //         };
  //         options.splice(1, 0, searchOption);
  //     }
  // },
  findDefinition() {
    return nf(this.state_, this.workspace);
  },
  saveExtraState() {
    return this.state_;
  },
  loadExtraState(_) {
    var s;
    this.state_ = _, (s = this.state_) != null && s.tooltip && this.setTooltip(this.state_.tooltip), this.updateFunction();
  },
  updateFunction() {
    this.checkFunctionReference(), this.updateFunctionShape_();
  },
  updateFunctionShape_() {
    if (this.setFieldValue(this.state_.name, d.Name), this.removeInput("fixButton", !0), this.state_.params)
      for (let i = 0; i < this.state_.params.length; ++i) {
        i == this.paramCount && this.appendDummyInput("fixButton").appendField(f.FixFunctionCaller).appendField(new X.FieldImage("aa", 20, 20, "FIX", () => {
          let h = this.findDefinition();
          h && this.loadExtraState(h);
        }, !1, { tooltip: f.FixFunctionCallerTip }));
        let a = this.state_.params[i], p = this.getInput(a.id), E = a.isOut ? f.VarOut : a.name;
        p ? a.isOut && p.type != g.inputTypes.DUMMY ? (this.removeInput(a.id), p = this.appendDummyInput(a.id), p.appendField(a.name, "label" + a.id), p.appendField(new jt({ name: a.name, type: a.type }), a.id)) : !a.isOut && p.type != g.inputTypes.VALUE ? (this.removeInput(a.id), p = this.appendValueInput(a.id), p.appendField(E, "label" + a.id)) : p.fieldRow[0].setValue(E) : a.isOut ? (p = this.appendDummyInput(a.id), p.appendField(E, "label" + a.id), p.appendField(new jt({ name: a.name, type: a.type }), a.id)) : (p = this.appendValueInput(a.id), p.appendField(E, "label" + a.id)), a.isOut ? (g.Events.disable(), p.fieldRow[1].setValue({ type: a.type }), g.Events.enable()) : (p.setCheck(a.type), g.Events.disable(), p.connection.setShadowState(xe(a.type)), g.Events.enable()), this.moveInputBefore(p.name, null);
      }
    let _ = g.constants.COLLAPSED_INPUT_NAME;
    this.state_.params.length > 0 && (_ = this.state_.params[0].id);
    let s = -1;
    for (let i = 0; i < this.inputList.length; ++i)
      if (this.inputList[i].name == d.Header) {
        s = i + 1;
        break;
      }
    for (; this.inputList.length > s && this.inputList[s].name != _; )
      this.removeInput(this.inputList[s].name);
    if (this.getField(d.Return)) {
      this.setOutput(!0, this.state_.returnType);
      let i = Ae.CurrentDescriptionFile.GetVarType(this.state_.returnType);
      g.Events.disable(), i != null ? this.setFieldValue(i.Label, d.Return) : this.setFieldValue(f.UnkownType, d.Return), g.Events.enable();
    }
  },
  renameFunction(_, s) {
    this.state_.name == _ && (this.state_.name = s, this.setFieldValue(this.state_.name, d.Name));
  },
  checkFunctionReference() {
    let _ = X.Events.getRecordUndo();
    X.Events.setRecordUndo(!1);
    try {
      let s = this.state_;
      if (this.paramCount = 0, !this.isInFlyout) {
        let r = this.findDefinition();
        if (r == null)
          this.setWarningText(Oe(_e.Warning_NoDefine, [s.name]), "NODEF");
        else {
          this.paramCount = r.params.length, this.state_ = iM(r);
          for (let i of s.params)
            this.state_.params.find((a) => a.id == i.id) || this.state_.params.push(i);
          if (this.state_.params.length != r.params.length) {
            this.setWarningText(f.Warning_FunctionSignature_Parameters, "NODEF");
            return;
          }
          this.state_.id = r.id, this.state_.name = r.name, this.setWarningText(null, "NODEF");
        }
      }
    } finally {
      X.Events.setRecordUndo(_);
    }
  },
  getVarDefine(_, s, r) {
    if (s == Tr.NextStatements || s == Tr.SelfDefine) {
      for (let i of this.inputList)
        if (i.name) {
          let a = go(this, i.name, _, r);
          if (a)
            return a;
        }
    }
    return s == Tr.NextStatements ? ki(this, _, r) : null;
  },
  onchange(_) {
    _.type === X.Events.FINISHED_LOADING && this.updateFunction(), _ instanceof X.Events.BlockDelete && !_.wasShadow && this.checkFunctionReference();
  },
  search(_, s) {
    var r;
    return (((r = s == null ? void 0 : s.extraState) == null ? void 0 : r.name) || "").toLocaleLowerCase().includes(_) ? s.extraState.name : [f.FunctionCall].find((i) => z.containsKey(i, _)) ?? !1;
  },
  UpdateDisplay() {
    this.updateFunction();
  }
}, qg = {
  ...jh,
  geId: M.function_call_value,
  init: function() {
    this.setInputsInline(!0), this.appendDummyInput(d.Header).appendField("", d.Name).appendField(f.CallReturn).appendField(new X.FieldLabel("", void 0, void 0), d.Return), this.setStyle("function_blocks"), this.setOutput(!0, this.state_.returnType);
  }
}, ef = {
  ...jh,
  debugAvailable: !0,
  geId: M.function_call_action,
  locKey: _e.FunctionCall,
  init: function() {
    this.setInputsInline(!0), this.appendDummyInput(d.Header).appendField(new pt([[f.SerialCall, FE.Wait], [f.ParallelCall, FE.Start]]), d.Type).appendField("", d.Name), this.setStyle("function_blocks"), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setTooltip(f.FunctionCallTooltip);
  }
}, tf = {
  debugAvailable: !0,
  returnType: "",
  geId: M.function_return,
  locKey: _e.ReturnSentense,
  init() {
    this.setStyle("function_blocks"), this.setInputsInline(!0), this.setPreviousStatement(!0), this.setNextStatement(!1), _n(
      this.appendValueInput(d.Return).appendField(f.ReturnSentense).conditionAppendField(this.workspace.IsCraftland, "Return value"),
      this.returnType,
      !0
    );
  },
  loadExtraState(_) {
    this.returnType = _.rt;
    let s = this.getInput(d.Return);
    this.returnType == null ? s.type == X.inputTypes.VALUE && (this.removeInput(d.Return), this.appendDummyInput(d.Return).appendField(f.ReturnSentense)) : (s.type == X.inputTypes.DUMMY && (this.removeInput(d.Return), s = this.appendValueInput(d.Return).appendField(f.ReturnSentense)), _n(s, this.returnType, !0));
  },
  saveExtraState() {
    return {
      rt: this.returnType
    };
  },
  onchange(_) {
    let s = this.workspace;
    if (s.isDragging && s.isDragging())
      return;
    let r = _.type == X.Events.BLOCK_MOVE;
    if (_ instanceof X.Events.BlockChange && _.type == X.Events.BLOCK_CHANGE && _.element == "field" && _.name == d.Return && (r = !0), r) {
      let i = !1, a = this;
      do {
        if (a.type == M.function_definition_valution || a.type == M.function_definition_action || a.type === M.function_xbt_action || a.type === M.function_xbt_condition) {
          i = !0;
          break;
        }
        a = a.getSurroundParent();
      } while (a);
      const p = ys(_);
      try {
        if (i) {
          let h = a.getFunctionDef().returnType;
          this.loadExtraState({ rt: h }), this.setWarningText(null, "RET");
        } else
          this.setWarningText(f.Warning_ReturnNotInFunction, "RET");
      } finally {
        p.Leave();
      }
    }
  },
  search(_) {
    return ["return", f.ReturnSentense].find((s) => z.containsKey(s, _)) || !1;
  }
};
function rf(_) {
  g.Blocks[M.function_mutator_container] = Zg, g.Blocks[M.function_mutator_parameter] = zg, g.Blocks[M.function_definition_valution] = Ah, g.Blocks[M.function_definition_action] = Qg, g.Blocks[M.function_xbt_action] = Ah, g.Blocks[M.function_xbt_condition] = Ah, g.Blocks[M.function_call_value] = qg, g.Blocks[M.function_call_action] = ef, g.Blocks[M.function_return] = tf, _.set("function_definition", { kind: "block", type: M.function_definition_valution }), _.set("function_definition_noreturn", { kind: "block", type: M.function_definition_action }), _.set("function_return", { kind: "block", type: M.function_return });
}
function nf(_, s, r) {
  let i = s.getAllBlocks(!1);
  for (let a = 0; a < i.length; a++) {
    let p = i[a];
    if (p.getFunctionDef != null) {
      let E = p.getFunctionDef();
      if (E && E.id == _.id)
        return p.isEnabled() ? E : null;
    }
  }
  for (let a = 0; a < i.length; a++) {
    let p = i[a];
    if (p.getFunctionDef != null) {
      let E = p.getFunctionDef();
      if (E && E.name == _.name)
        return p.isEnabled() ? E : null;
    }
  }
  return null;
}
const GE = fg((_) => {
  var p, E;
  if (_.isInsertionMarker())
    return;
  const s = _.getFunctionDef();
  s.graphId = Lh(), NI(s.id, s);
  const r = s.id;
  let i = g.Events.getRecordUndo();
  g.Events.setRecordUndo(!1);
  const a = ((p = _.workspace) == null ? void 0 : p.getAllBlocks(!1)) || [];
  for (let h = 0; h < a.length; h++) {
    const L = a[h];
    if ((E = L.state_) != null && E.id) {
      let y = L.state_.graphId;
      const V = L.state_.id;
      (y == Lh() || y == null) && V == r && L.loadExtraState(s);
    }
  }
  g.Events.setRecordUndo(i);
}, 100), _f = function(_, s, r) {
  const i = s.getAllBlocks(!1);
  for (let a = 0; a < i.length; a++) {
    if (i[a] === r)
      continue;
    const p = i[a];
    if (p.getFunctionDef) {
      const E = p.getFunctionDef();
      if (X.Names.equals(E.name, _))
        return !0;
    }
  }
  return !1;
};
function of(_, s, r) {
  return !_f(_, s, r);
}
function Tf(_, s) {
  if (s.isInFlyout)
    return _;
  for (_ = _ || "unnamed"; !of(_, s.workspace, s); ) {
    const r = _.match(/^(.*?)(\d+)$/);
    r ? _ = r[1] + (parseInt(r[2], 10) + 1) : _ += "2";
  }
  return _;
}
function DS(_) {
  if (this.sourceBlock_.isInsertionMarker())
    return;
  _ = _.trim();
  const s = Tf(_, this.getSourceBlock()), r = this.getValue();
  if (r !== _ && r !== s) {
    let i = this.sourceBlock_.id;
    NI(i, s);
    const a = this.getSourceBlock().workspace.getAllBlocks(!1);
    for (let p = 0; p < a.length; p++) {
      const E = a[p];
      E.renameFunction && E.renameFunction(r, s);
    }
  }
  return s;
}
var tI, rI;
function LS(_, s = !0, r = "MyFunction") {
  return _.workspace.isFlyout ? s ? tI = tI ?? tp(r) : rI = rI ?? tp(r) : tp(r);
}
class gS extends X.FieldLabel {
  constructor(r, i, a) {
    super(r);
    N(this, "fieldRef");
    this.fieldRef = i;
  }
  initView() {
    this.createBorderRect_(), this.createTextElement_(), eI.addClass(this.fieldGroup_, "blocklyDragOutReturn");
  }
  createBorderRect_() {
    this.borderRect_ = eI.createSvgElement(
      "path",
      {},
      this.fieldGroup_
    );
  }
  positionBorderRect_() {
    if (!this.borderRect_)
      return;
    let r = this.size_.width, i = this.size_.height;
    const a = `m 0,0  h 10  l 3,3  10,0  3,-3  H${r}  V${i} H 0 z`;
    this.borderRect_.setAttribute(
      "d",
      a
    );
  }
  getDragOutBlockState() {
    let i = this.getSourceBlock().getField(this.fieldRef), a = i == null ? void 0 : i.getValue();
    return {
      kind: "block",
      type: M.function_return,
      extraState: { rt: a }
    };
  }
  onMouseDown_(r) {
    if (super.onMouseDown_(r), !this.sourceBlock_ || this.sourceBlock_.disposed || this.sourceBlock_.isInFlyout)
      return;
    const i = this.sourceBlock_.workspace.getGesture(r);
    if (dh ?? (dh = !1), i && r.button === 0 && !dh) {
      let a = AS(this.sourceBlock_.workspace);
      i.setStartBlock(this.sourceBlock_), i.handleFlyoutStart(r, a), a.targetWorkspace = this.sourceBlock_.workspace, a.refField = this;
    }
  }
}
let dh;
class uM extends g.Field {
  constructor() {
    super(...arguments);
    N(this, "SERIALIZABLE", !0);
  }
  initView() {
  }
  updateSize_(r) {
    this.size_ = {
      width: 1,
      height: 1
    };
  }
  positionBorderRect_() {
    Bh.bind(this)();
  }
}
function sf(_) {
  let s = ip().get(_.graphId);
  if (s && s.functions) {
    for (let r = 0; r < s.functions.length; ++r) {
      let i = s.functions[r];
      if (i.id == _.id)
        return i;
    }
    for (let r = 0; r < s.functions.length; ++r) {
      let i = s.functions[r];
      if (i.name == _.name)
        return i;
    }
  }
  return null;
}
class EM extends Yn {
  constructor() {
    super([[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]]);
    N(this, "graphId");
    this.menuGenerator_ = this.menuGenerator;
  }
  UpdateGraphID(r) {
    if (r) {
      if (r == this.graphId)
        return;
      this.graphId = r;
    }
    this.getOptions(!1), this.doValueUpdate_(this.getValue());
  }
  menuGenerator() {
    var a;
    let i = ip().get(this.graphId);
    if (i && ((a = i.vars) == null ? void 0 : a.length) > 0) {
      let p = Ae.CurrentDescriptionFile, E = [];
      for (let h = 0; h < i.vars.length; ++h) {
        let L = p.GetVarType(i.vars[h].type), y = L ? L.Label : i.vars[h].type;
        E.push([i.vars[h].name + " : " + y, i.vars[h].id, i.vars[h].name, i.vars[h].type]);
      }
      return E;
    }
    return [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]];
  }
  getSelectedType() {
    const r = this.selectedOption;
    return r != null && r[3] && typeof r[3] == "string" ? r[3] : "";
  }
}
let AM = {
  OnGraphIDChanged(_) {
    let s = this.getSourceBlock(), i = ip().get(_);
    i ? s.setFieldValue(i.name, d.GraphName) : s.setFieldValue(_, d.GraphName), s.getField(d.VarID).UpdateGraphID(_);
  },
  DetermineTypes() {
    let s = this.getField(d.VarID).getSelectedType();
    if (this.type === M.externvar_set) {
      const a = this.getField(d.Operator);
      a && a.opType !== s && (a.setOpType(s), a.UpdateDisplay());
    }
    const r = this.getField(d.GraphID), i = this.getFieldValue(d.GraphID);
    return this.OnGraphIDChanged.call(r, i), this.setCheckType(s);
  },
  setCheckType: null
  //abstract
}, lf = {
  ...AM,
  geId: M.externvar_get,
  locKey: _e.ExternalGet,
  init() {
    this.setInputsInline(!0), this.appendValueInput(d.This).appendField(f.ExternalGet).appendField(new uM("", this.OnGraphIDChanged), d.GraphID).appendField("", d.GraphName).appendField(new EM(), d.VarID).appendField(f.ExternalGet_2).setCheck("Component").connection.setShadowState(xe("Component")), this.setOutput(!0), this.setStyle("action_blocks");
  },
  search(_, s) {
    var y;
    if (z.containsKey(f.ExternalGet, _))
      return f.ExternalGet;
    const r = ip(), i = s.fields[d.GraphID], a = r.get(i);
    if (!a)
      return !1;
    const { name: p } = a;
    if (z.containsKey(p, _))
      return p;
    const { vars: E } = a, h = s.fields[d.VarID], L = (y = E.find((V) => V.id === h)) == null ? void 0 : y.name;
    return L && z.containsKey(L, _) ? L : !1;
  },
  setCheckType(_) {
    const s = this.outputConnection.getCheck();
    return ((s == null ? void 0 : s[0]) ?? "") != _ ? (this.setOutput(!0, _), !0) : !1;
  }
}, af = {
  ...AM,
  debugAvailable: !0,
  geId: M.externvar_set,
  locKey: _e.ExternalSet,
  init() {
    this.setInputsInline(!0), this.appendValueInput(d.This).appendField(f.ExternalSet).setCheck("Component").connection.setShadowState(xe("Component")), this.appendValueInput(d.Value).appendField(new uM("", this.OnGraphIDChanged), d.GraphID).appendField("", d.GraphName).appendField(new EM(), d.VarID).appendField(new YE(), d.Operator).connection.setShadowState(xe("any")), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setStyle("action_blocks");
  },
  search(_, s) {
    var y;
    if (z.containsKey(f.ExternalSet, _))
      return f.ExternalSet;
    const r = ip(), i = s.fields[d.GraphID], a = r.get(i);
    if (!a)
      return !1;
    const { name: p } = a;
    if (z.containsKey(p, _))
      return p;
    const { vars: E } = a, h = s.fields[d.VarID], L = (y = E.find((V) => V.id === h)) == null ? void 0 : y.name;
    return L && z.containsKey(L, _) ? L : !1;
  },
  setCheckType(_) {
    var i;
    const s = this.getInput(d.Value);
    return (((i = s.connection.getCheck()) == null ? void 0 : i[0]) ?? "") != _ ? (_n(s, _), !0) : !1;
  }
}, dM = {
  ...jh,
  findDefinition() {
    return this.state_.graphId, sf(this.state_);
  },
  updateShape() {
    this.updateFunctionShape_();
    let _ = this.state_.graphId, r = ip().get(_);
    r ? this.setFieldValue(r.name, d.GraphName) : this.setFieldValue(_, d.GraphName);
  },
  renameFunction(_, s) {
    this.state_.graphId == Lh() && this.state_.name == _ && (this.state_.name = s, this.setFieldValue(this.state_.name, d.Name));
  },
  search(_, s) {
    var r;
    return (((r = s == null ? void 0 : s.extraState) == null ? void 0 : r.name) || "").toLocaleLowerCase().includes(_) ? s.extraState.name : [f.ExternalCall, f.FunctionCall].find((i) => z.containsKey(i, _)) || !1;
  }
}, cf = {
  ...dM,
  geId: M.extern_call_value,
  locKey: _e.ExternalCall,
  init() {
    this.setInputsInline(!0), this.appendValueInput(d.This).appendField(f.ExternalCall).setCheck("Component").connection.setShadowState(xe("Component")), this.appendDummyInput(d.Header).appendField("", d.GraphName).appendField("", d.Name).appendField(f.CallReturn).appendField("", d.Return), this.setStyle("action_blocks"), this.setOutput(!0);
  }
}, pf = {
  ...dM,
  debugAvailable: !0,
  geId: M.extern_call_value,
  locKey: _e.ExternalCall,
  init() {
    this.setInputsInline(!0), this.appendValueInput(d.This).appendField(f.ExternalCall).setCheck("Component").connection.setShadowState(xe("Component")), this.appendDummyInput(d.Header).appendField(new pt([[f.SerialCall, FE.Wait], [f.ParallelCall, FE.Start]]), d.Type).appendField("", d.GraphName).appendField("", d.Name), this.setStyle("action_blocks"), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action");
  }
};
function uf(_) {
  X.Blocks[M.externvar_get] = lf, X.Blocks[M.externvar_set] = af, X.Blocks[M.extern_call_value] = cf, X.Blocks[M.extern_call_action] = pf;
}
function Ef(_, s) {
  let r = z.func_hudWidgetList;
  return r ? r(_, s) : [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]];
}
function Af() {
  let _ = z.func_hudList;
  return _ ? _() : [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]];
}
class SM extends Yn {
  constructor(r, i, a) {
    super([[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]], i, a);
    N(this, "hudFile");
    this.menuGenerator_ = () => {
      let p = this.getSourceBlock().getFieldValue(d.Hud) ?? "", E = r;
      return E || (E = this.getSourceBlock().getFieldValue(d.Type) ?? ""), Ef(p, E);
    };
  }
  UpdateDisplay() {
    let r = this.getValue(), i = this.getText();
    this.getOptions(), this.doValueUpdate_(r), this.getText() != i && (this.markDirty(), this.forceRerender());
  }
  getValueDefaultOptions(r) {
    let i = this.getSourceBlock();
    if (i != null) {
      let a = i.getFieldValue(d.Hud), p = z.func_getEntityInfo;
      if (a && p) {
        let E = p(a, r);
        if (E)
          return [E.name, E.entityId];
      }
    }
    return super.getValueDefaultOptions(r);
  }
}
class fS extends Yn {
  constructor(r, i) {
    super([[f.CustomHud, ""]], r, i);
    N(this, "hudFile");
    this.menuGenerator_ = () => (this.getSourceBlock().getFieldValue(d.Type), Af());
  }
  UpdateDisplay() {
    let r = this, i = this.getValue(), a = this.getText();
    this.getOptions(), r.selectedOption_ = [i + f.UnkownType, i, "", { style: "{ fill: var(--red_err5); }" }], this.doValueUpdate_(i), this.getText() != a && (this.markDirty(), this.forceRerender());
  }
}
let df = {
  locKey: "CustomHudWidgetID",
  init() {
    this.appendDummyInput().appendField(new fS(), d.Hud).appendField(new SM(), d.Entity), this.setOutput(!0, "CustomHudWidgetID"), oS && oS.block_style ? this.setStyle(oS.block_style) : this.setStyle("action_blocks");
  },
  DetermineTypes() {
    let _ = this.outputConnection.getCheck(), s = null;
    _ && _.length == 1 && (s = _[0]);
    let r = "CustomHudWidgetID", i = z.func_getEntityInfo, a = this.getFieldValue(d.Hud), p = this.getFieldValue(d.Entity);
    if (i && a) {
      let E = i(a, p);
      E && E.ecaType && (r = `$HudWidgetIDT_${E.ecaType}`);
    }
    if (r != s) {
      this.setOutput(!0, r);
      let h = Ae.CurrentDescriptionFile.GetVarType(r);
      return this.setTooltip((h == null ? void 0 : h.Label) || null), this.UpdateDisplayByScene(), !0;
    }
  },
  UpdateDisplayByScene(_, s) {
    let r = this.getField(d.Hud);
    (!_ || _ === r.getValue()) && (r.UpdateDisplay(), this.getField(d.Entity).UpdateDisplay());
  },
  search(_) {
    const s = Ae.CurrentDescriptionFile.GetVarType("CustomHudWidgetID");
    return ["CustomHudWidgetID", s.Label, s.ScriptName].find((r) => z.containsKey(r, _)) || !1;
  }
}, Sf = {
  locKey: _e.PickWidget,
  init() {
    this.appendValueInput(d.Hud).appendField(new ni("HudWidget"), d.Type).appendField(f.GetWidgetFromCustomHud).setCheck("CustomHud").connection.setShadowState(xe("CustomHud")), this.appendDummyInput().appendField(new fS(), d.Hud).appendField(new SM(), d.Entity), this.setOutput(!0, "HudWidget"), iS && iS.block_style ? this.setStyle(iS.block_style) : this.setStyle("action_blocks");
  },
  DetermineTypes() {
    let _ = this.outputConnection.getCheck(), s = null;
    _ && _.length == 1 && (s = _[0]);
    let r = this.getFieldValue(d.Type), i = z.func_getEntityInfo, a = this.getFieldValue(d.Hud), p = this.getFieldValue(d.Entity);
    if (i && a) {
      let E = i(a, p);
      E && E.ecaType && (r = E.ecaType);
    }
    if (r != s) {
      this.setOutput(!0, r);
      let h = Ae.CurrentDescriptionFile.GetVarType(r);
      return this.setTooltip(h.Label), this.UpdateDisplayByScene(), !0;
    }
  },
  UpdateDisplayByScene(_, s) {
    let r = this.getField(d.Hud);
    (!_ || _ === r.getValue()) && (r.UpdateDisplay(), this.getField(d.Entity).UpdateDisplay());
  },
  search(_) {
    return ["pickwidget", f.PickWidget].find((s) => z.containsKey(s, _)) || !1;
  }
}, hf = {
  debugAvailable: !0,
  geId: M.create_hud,
  locKey: _e.CreateHud,
  init() {
    let _;
    this.appendDummyInput().appendField(f.CreateHud).appendField(new jt({ name: "CustomHud", type: "CustomHud" }), d.Entity), _ = this.appendValueInput(d.Player).appendField(f.CreateHud_OwnerPlayer).setCheck("Player"), _.fieldRow[0].setTooltip(f.CreateHud_OwnerPlayer_Tip), _.connection.setShadowState(xe("Player")), this.appendDummyInput().appendField(new fS(), d.Hud), this.setNextStatement(!0, "action"), this.setPreviousStatement(!0, "action"), TS && TS.block_style ? this.setStyle(TS.block_style) : this.setStyle("action_blocks"), this.setTooltip(f.CreateHud_Tip);
  },
  UpdateDisplayByScene(_, s) {
    let r = this.getField(d.Hud);
    (!_ || _ === r.getValue()) && r.UpdateDisplay();
  },
  search(_) {
    return ["createhud", f.CreateHud].find((s) => z.containsKey(s, _)) || !1;
  },
  getVarDefine(_, s, r) {
    if (s == Tr.SelfDefine || s == Tr.NextStatements) {
      let i = go(this, d.Entity, _, r);
      if (i)
        return i;
    }
    return s == Tr.NextStatements ? ki(this, _, r) : null;
  }
};
var iS = { kind: "block", type: M.pick_hudwidget, block_style: "" }, oS = { kind: "block", type: M.pick_hudwidgetid, block_style: "" }, TS = { kind: "block", type: M.create_hud, block_style: "" };
function If(_) {
  g.Blocks[M.pick_hudwidget] = Sf, g.Blocks[M.create_hud] = hf, g.Blocks[M.pick_hudwidgetid] = df, _.set("pickhudwidget", iS), _.set("createhud", TS), _.set("CustomHudWidgetID", oS);
}
let Mf = {
  ...OT,
  ecatype: "event",
  fixOwnerType: "HudButtonWidget",
  init() {
    this.hat = "cap", this.appendDummyInput().appendField("", d.Label).appendField(new fo(), d.Name).appendField(new jt({ name: "Button", type: "HudButtonWidget" }), d.This), this.setNextStatement(!0, "action"), this.setInputsInline(!0), this.inputsInlineDefault = !0;
  },
  getVarDefine: function(_, s, r) {
    if (s == Tr.SelfDefine || s == Tr.NextStatements) {
      let a = d.This, p = go(this, a, _, r);
      if (p)
        return p;
    }
    return OT.getVarDefine.call(this, _, s, r);
  },
  updateTitle_(_) {
    let s = _, r = "Callback";
    this.setFieldValue(s, d.Label), this.getFieldValue(d.Name) || this.setFieldValue(Pf(r), d.Name);
  }
};
function mf(_) {
  g.Blocks[M.hud_buttonevent] = Mf;
}
function Pf(_ = "Callback") {
  return _ + (Math.random() * 1e4).toFixed(0);
}
let Df = {
  locKey: _e.IconLabel,
  init() {
    this.setOutput(!0, "SpriteID"), this.appendDummyInput().appendField(new zt({
      type: "Icon",
      defaultLabel: f.IconLabel
    }), d.Value), this.setStyle("data_blocks");
  },
  saveExtraState() {
  },
  loadExtraState(_) {
  },
  search(_, s) {
    let i = Ae.CurrentDescriptionFile.GetVarType("SpriteID");
    return [i.Label, i.Name].find((a) => z.containsKey(a, _)) || !1;
  }
}, Lf = {
  locKey: _e.ItemGoodsLabel,
  init() {
    this.setOutput(!0, "ItemID"), this.appendDummyInput().appendField(new zt({
      type: "ItemGoods",
      defaultLabel: f.ItemGoodsLabel
    }), d.Value), this.setStyle("data_blocks");
  },
  saveExtraState() {
    let _ = this.getField(d.Value);
    return _ == null ? void 0 : _.SubInfo;
  },
  loadExtraState(_) {
    let s = this.getField(d.Value), r = _ == null ? void 0 : _.entityType, a = Ae.CurrentDescriptionFile.GetVarType(r);
    s.SetSubInfo(_, (a == null ? void 0 : a.Label) + " ID");
  },
  search(_, s) {
    var E;
    let r = Ae.CurrentDescriptionFile, i = r.GetVarType("ItemID"), a = (E = s == null ? void 0 : s.extraState) == null ? void 0 : E.entityType, p = r.GetVarType(a);
    return [i.Label, i.Name, (p == null ? void 0 : p.Label) ?? "", (p == null ? void 0 : p.Name) ?? ""].find((h) => z.containsKey(h, _)) || !1;
  }
};
const Oh = "AudioType";
let gf = {
  locKey: _e.SoundLabel,
  init() {
    this.setOutput(!0, Oh), this.appendDummyInput().appendField(new zt({
      type: "Sound",
      defaultLabel: f.SoundLabel
    }), d.Value), this.setStyle("data_blocks");
  },
  saveExtraState() {
  },
  loadExtraState(_) {
  },
  search(_, s) {
    let i = Ae.CurrentDescriptionFile.GetVarType(Oh);
    return [i.Label, i.Name].find((a) => z.containsKey(a, _)) || !1;
  }
}, ff = {
  locKey: _e.TextureIDLabel,
  init() {
    this.setOutput(!0, "TextureID"), this.appendDummyInput().appendField(new zt({
      type: "Texture",
      defaultLabel: f.TextureIDLabel
    }), d.Value), this.setStyle("data_blocks");
  },
  saveExtraState() {
  },
  loadExtraState(_) {
  },
  search(_, s) {
    return ["texture", f.TextureIDLabel].find((r) => z.containsKey(r, _)) || !1;
  }
}, Nf = {
  locKey: _e.EffectIDLabel,
  init() {
    this.setOutput(!0, "TextureID"), this.appendDummyInput().appendField(new zt({
      type: "PresentEffectTexType",
      defaultLabel: f.EffectIDLabel
    }), d.Value), this.setStyle("data_blocks");
  },
  saveExtraState() {
  },
  loadExtraState(_) {
  },
  search(_, s) {
    return ["presenteffecttextype", f.EffectIDLabel].find((r) => z.containsKey(r, _)) || !1;
  }
}, bf = {
  locKey: _e.Script,
  init() {
    this.setOutput(!0, "GraphID"), this.appendDummyInput().appendField(new zt({ type: "Script", defaultLabel: f.Script }), d.Value), this.setStyle("data_blocks");
  },
  search(_, s) {
    return ["eca", "script", f.ECAScript, f.Script].find((r) => z.containsKey(r, _)) || !1;
  }
}, Cf = {
  locKey: _e.Behavior,
  init() {
    this.setOutput(!0, "BTreeID"), this.appendDummyInput().appendField(new zt({ type: "Behavior", defaultLabel: f.Behavior }), d.Value), this.setStyle("data_blocks");
  },
  search(_, s) {
    return ["behavior", "xbt", f.Behavior].find((r) => z.containsKey(r, _)) || !1;
  }
}, Of = {
  locKey: _e.CustomHud,
  init() {
    this.setOutput(!0, "CustomHudID"), this.appendDummyInput().appendField(new fS(), d.Hud), this.setStyle("data_blocks");
  },
  search(_, s) {
    return ["customhud", f.CustomHud].find((r) => z.containsKey(r, _)) || !1;
  }
}, Rf = {
  init() {
    this.setOutput(!0, "CsvID"), this.appendDummyInput().appendField(new zt({ type: "CSV", defaultLabel: "CSV" }), d.Value), this.setStyle("data_blocks");
  }
}, yf = {
  relateParamVal: null,
  locKey: _e.CustomHud,
  init() {
    this.setOutput(!0, "ClothID"), this.appendDummyInput().appendField(f.ClothIDLabel, d.Label).appendField(
      new zt(
        {
          type: "ClothSkin",
          defaultLabel: f.None,
          nullable: !0
        }
      ),
      d.Value
    ), this.setStyle("data_blocks");
  },
  search(_, s) {
    return ["ClothID", f.ClothIDLabel].find((r) => z.containsKey(r, _)) || !1;
  }
}, vf = {
  locKey: _e.WeaponIDLabel,
  init() {
    this.setOutput(!0, "WeaponSkinID"), this.appendDummyInput().appendField(f.WeaponIDLabel, d.Label).appendField(
      new zt(
        {
          type: "WeaponSkin",
          defaultLabel: f.None,
          nullable: !0
        }
      ),
      d.Value
    ), this.setStyle("data_blocks");
  },
  updateShape_() {
  },
  search(_, s) {
    return ["WeaponSkinID", f.WeaponIDLabel].find((r) => z.containsKey(r, _)) || !1;
  }
}, $f = {
  locKey: _e.EmoteIDLabel,
  init() {
    this.setOutput(!0, "EmoteType"), this.appendDummyInput().appendField(new zt({
      type: "EmoteSkin",
      defaultLabel: f.EmoteIDLabel
    }), d.Value), this.setStyle("data_blocks");
  },
  updateShape_() {
  },
  search(_, s) {
    return ["EmoteSkinID", f.EmoteIDLabel].find((r) => z.containsKey(r, _)) || !1;
  }
}, Wf = {
  locKey: _e.Object3DResourceLabel,
  init() {
    this.setOutput(!0, "String"), this.appendDummyInput().appendField(new zt({
      type: "Object3DResource",
      defaultLabel: f.Object3DResourceLabel
    }), d.Value), this.setStyle("data_blocks");
  },
  updateShape_() {
  },
  search(_, s) {
    return ["Obj3DRes", "Object3DResource", f.Object3DResourceLabel].find((r) => z.containsKey(r, _)) || !1;
  }
}, kf = {
  locKey: _e.PlayerDataID,
  init() {
    this.setOutput(!0, "PlayerDataID"), this.setStyle("data_blocks"), this.appendDummyInput().appendField(new zt({
      type: "PlayerDataID",
      defaultLabel: f.PlayerDataID
    }), d.Value);
  },
  search(_) {
    return ["PlayerDataID", f.PlayerDataID].find((s) => z.containsKey(s, _)) || !1;
  }
}, Ff = {
  locKey: _e.PersonaID,
  init() {
    this.setOutput(!0, "PersonaID"), this.setStyle("data_blocks"), this.appendDummyInput().appendField(new zt({
      type: "PersonaID",
      defaultLabel: f.PersonaID
    }), d.Value);
  },
  search(_) {
    return ["PersonaID", f.PersonaID].find((s) => z.containsKey(s, _)) || !1;
  }
}, wf = {
  locKey: _e.AnimationClipID,
  init() {
    this.setOutput(!0, "AnimationClipID"), this.setStyle("data_blocks"), this.appendDummyInput().appendField(new zt({
      type: "AnimationClipID",
      defaultLabel: f.AnimationClipID
    }), d.Value);
  },
  search(_) {
    return ["AnimationClipID", f.AnimationClipID].find((s) => z.containsKey(s, _)) || !1;
  }
}, Bf = {
  locKey: _e.BagIDLabel,
  init() {
    this.setOutput(!0, "BagSkinID"), this.appendDummyInput().appendField(f.BagIDLabel, d.Label).appendField(
      new zt(
        {
          type: "BagSkin",
          defaultLabel: f.None,
          nullable: !0
        }
      ),
      d.Value
    ), this.setStyle("data_blocks");
  },
  updateShape_() {
  },
  search(_, s) {
    return ["BagSkinID", f.BagIDLabel].find((r) => z.containsKey(r, _)) || !1;
  }
}, Yf = {
  locKey: _e.PlayerSkill,
  init() {
    this.setOutput(!0, "PlayerSkillID"), this.appendDummyInput().appendField(new zt({
      type: "PlayerSkillType",
      defaultLabel: f.PlayerSkill
    }), d.Value), this.setStyle("data_blocks");
  },
  updateShape_() {
  },
  search(_, s) {
    return ["PlayerSkillID", f.PlayerSkill].find((r) => z.containsKey(r, _)) || !1;
  }
};
function jc(_) {
  let s = _, r = Oe(s), i = "";
  return {
    locKey: s,
    init() {
      this.setOutput(!0, i), this.setStyle("data_blocks");
      let a = new zt({
        type: "GFileType",
        defaultLabel: r
      });
      a.SetSubInfo(_), this.appendDummyInput().appendField(a, d.Value);
    },
    search(a) {
      return [_, r].find((p) => z.containsKey(p, a)) || !1;
    }
  };
}
const Rh = [
  ["None", ""],
  ["变身ID", "HumanModelID"],
  ["ItemID", "ItemID"],
  // here refer to LevelObjectID   don't change
  ["ItemGoodsID", "ItemGoodsID"],
  // here refer to ItemID  don't change
  ["SpriteID", "SpriteID"],
  ["TextureID", "TextureID"],
  ["WeaponSkinID", "WeaponSkinID"],
  ["ClothID", "ClothID"],
  ["MeshID", "MeshID"],
  ["BagSkinID", "BagSkinID"]
], Uf = [
  ["必须资源", ""],
  ["动态下载资源", "D"]
];
let Vf = {
  locKey: _e.Resource,
  init() {
    this.setOutput(!0, "String"), this.appendDummyInput().appendField("* Raw 资源").appendField(new pt(Uf), d.Condition).appendField(new pt(Rh), d.Type).appendField(new g.FieldTextInput(), d.Value), this.setStyle("data_blocks");
  },
  DetermineTypes() {
    var i;
    let _ = this.getFieldValue(d.Type), s = (i = this.outputConnection.getCheck()) == null ? void 0 : i[0], r = "String";
    switch (_) {
      default:
        r = _;
        break;
    }
    if (s != r)
      return this.setOutput(!0, r), !0;
  },
  search(_, s) {
    for (let r of Rh) {
      if (z.containsKey(r[0], _))
        return r[0];
      if (z.containsKey(r[1], _))
        return r[1];
    }
    return ["资源", "Raw Resource"].find((r) => z.containsKey(r, _)) || !1;
  }
}, Gf = {
  locKey: _e.VehicleSkinIDLabel,
  init() {
    this.setOutput(!0, "VehicleSkinID"), this.appendDummyInput().appendField(f.VehicleSkinIDLabel, d.Label).appendField(
      new zt(
        {
          type: "VehicleSkin",
          defaultLabel: f.None,
          nullable: !0
        }
      ),
      d.Value
    ), this.setStyle("data_blocks");
  },
  search(_, s) {
    return ["VehicleSkinID", f.VehicleSkinIDLabel].find((r) => z.containsKey(r, _)) || !1;
  }
};
const Hf = "DynamicCreateItemID";
let xf = {
  locKey: _e.DynamicCreateItemLabel,
  nextTypeChanged: !1,
  setNextTypeChanged() {
    this.nextTypeChanged = !0;
  },
  init() {
    this.setOutput(!0, Hf), this.appendDummyInput().appendField(f.DynamicCreateItemLabel, d.Label).appendField(
      new zt({
        type: "DynamicCreateItem",
        defaultLabel: f.Unselected
      }, () => this.setNextTypeChanged()),
      d.Value
    ), this.setStyle("data_blocks");
  },
  search(_) {
    return ["DynamicCreateItemID", f.DynamicCreateItemLabel].find((s) => z.containsKey(s, _)) || !1;
  },
  DetermineTypes() {
    return this.nextTypeChanged ? (this.nextTypeChanged = !1, !0) : !1;
  },
  setShadow(_) {
    var s, r;
    g.BlockSvg.prototype.setShadow.call(this, _), _ && ((r = (s = this.inputList) == null ? void 0 : s[0]) == null || r.removeField(d.Label, !0));
  }
}, Xf = {
  locKey: _e.EffectLabel,
  init() {
    this.setOutput(!0, "EffectID"), this.appendDummyInput().appendField(new zt({
      type: "EffectType",
      defaultLabel: f.EffectLabel
    }), d.Value), this.setStyle("data_blocks");
  },
  search(_) {
    return ["EffectID", "EffectType", f.EffectLabel].find((s) => z.containsKey(s, _)) || !1;
  }
}, Kf = {
  locKey: _e.InternalHud,
  init() {
    this.setOutput(!0, "$InternalHudTypeT_InternalHud"), this.appendDummyInput().appendField(new zt({
      type: "InternalHudType",
      defaultLabel: f.InternalHud
    }), d.Value), this.setStyle("data_blocks");
  },
  DetermineTypes() {
    var a;
    const _ = (a = this.outputConnection) == null ? void 0 : a.getCheck();
    let s;
    _ && _.length === 1 && (s = _[0]);
    let r = "$InternalHudTypeT_InternalHud";
    const i = this.getFieldValue(d.Value) ?? "";
    if (i.startsWith("InternalHud_")) {
      const p = i.slice(12), E = Ae.CurrentDescriptionFile, h = E.GetVarType(p);
      if (h) {
        const L = E.GetVarType("$InternalHudTypeT");
        r = E.GetGenericVarType(L, h).Name;
      }
    }
    return r != s ? (this.setOutput(!0, r), !0) : !1;
  },
  search(_) {
    return ["InternalHudType", f.InternalHud].find((s) => z.containsKey(s, _)) || !1;
  }
};
function Jf(_) {
  g.Blocks[M.pick_itemgoods] = Lf, _.set("ItemGoodsIDType", { kind: "block", type: M.pick_itemgoods }), _.set("ItemID", { kind: "block", type: M.pick_itemgoods }), _.set("EquipItemID_Attachment", { kind: "block", type: M.pick_itemgoods, extraState: { entityType: "Attachment" } }), g.Blocks[M.pick_sound] = gf, _.set(Oh, { kind: "block", type: M.pick_sound }), _.set("AudioID", { kind: "block", type: M.pick_sound }), g.Blocks[M.pick_icon] = Df, _.set("IconType", { kind: "block", type: M.pick_icon }), _.set("SpriteID", { kind: "block", type: M.pick_icon }), g.Blocks[M.pick_script] = bf, _.set("ScriptID", { kind: "block", type: M.pick_script }), g.Blocks[M.pick_xbt] = Cf, _.set("BTreeID", { kind: "block", type: M.pick_xbt }), g.Blocks[M.pick_hud] = Of, _.set("CustomHudID", { kind: "block", type: M.pick_hud }), g.Blocks[M.pick_csv] = Rf, _.set("SelectCSV", { kind: "block", type: M.pick_csv }), _.set("CsvID", { kind: "block", type: M.pick_csv }), g.Blocks[M.pick_texture] = ff, _.set("TextureID", { kind: "block", type: M.pick_texture }), g.Blocks[M.pick_effect] = Nf, _.set("PresentEffectTexType", { kind: "block", type: M.pick_effect }), g.Blocks[M.pick_cloth_skin] = yf, _.set("ClothID", { kind: "block", type: M.pick_cloth_skin }), g.Blocks[M.pick_weapon_skin] = vf, _.set("WeaponSkinID", { kind: "block", type: M.pick_weapon_skin }), g.Blocks[M.pick_vehicle_skin] = Gf, _.set("VehicleSkinID", { kind: "block", type: M.pick_vehicle_skin }), g.Blocks[M.pick_emote_skin] = $f, _.set("EmoteType", { kind: "block", type: M.pick_emote_skin }), g.Blocks[M.pick_obj3d] = Wf, _.set("Object3DResourceID", { kind: "block", type: M.pick_obj3d }), g.Blocks[M.pick_bag_id] = Bf, _.set("BagSkinID", { kind: "block", type: M.pick_bag_id }), g.Blocks[M.pick_skill_id] = Yf, _.set("PlayerSkillID", { kind: "block", type: M.pick_skill_id }), g.Blocks[M.raw_resource] = Vf, _.set("RawResource", { kind: "block", type: M.raw_resource });
  for (let s of Rh) {
    let r = s[1];
    r && _.set("RawResource_" + r, { kind: "block", type: M.raw_resource, fields: {
      [d.Type]: r
    } });
  }
  g.Blocks[M.pick_dynamic_create_item] = xf, _.set("DynamicCreateItemID", { kind: "block", type: M.pick_dynamic_create_item }), g.Blocks[M.pick_effect_type] = Xf, _.set("EffectType", { kind: "block", type: M.pick_effect_type }), _.set("EffectID", { kind: "block", type: M.pick_effect_type }), g.Blocks[M.pick_internal_hud] = Kf, _.set("InternalHudType", { kind: "block", type: M.pick_internal_hud }), g.Blocks[M.pick_player_data_id] = kf, _.set("PlayerDataID", { kind: "block", type: M.pick_player_data_id }), g.Blocks[M.pick_persona_id] = Ff, _.set("PersonaID", { kind: "block", type: M.pick_persona_id }), g.Blocks[M.pick_animation_clip_id] = wf, _.set("AnimationClipID", { kind: "block", type: M.pick_animation_clip_id }), g.Blocks[M.pick_animation_ctrl_id] = jc("ac"), _.set("AnimationCtrlID", { kind: "block", type: M.pick_animation_ctrl_id }), g.Blocks[M.pick_material_id] = jc("material"), _.set("MaterialID", { kind: "block", type: M.pick_material_id }), g.Blocks[M.pick_mesh_id] = jc("mesh"), _.set("MeshID", { kind: "block", type: M.pick_mesh_id }), g.Blocks[M.pick_scene_id] = jc("scene"), _.set("SceneID", { kind: "block", type: M.pick_scene_id }), g.Blocks[M.pick_particles_id] = jc("particles"), _.set("ParticlesID", { kind: "block", type: M.pick_particles_id }), g.Blocks[M.pick_performance] = jc("performance"), _.set("PerformanceID", { kind: "block", type: M.pick_performance });
}
const NS = {
  onchange(_) {
    if (_.type === _p.DATA_STORAGE_CHANGE) {
      const s = this.getField(d.Value);
      s == null || s.UpdateDisplay();
    }
  }
}, hM = {
  onchange(_) {
    if (_.type === _p.DATA_STORAGE_CHANGE) {
      const s = this.getField(d.Property + "2");
      s == null || s.UpdateDisplay();
    }
  }
};
let jf = {
  ...NS,
  geId: M.sheet_data,
  sheetTypeTypeChanged: !1,
  init() {
    const _ = () => [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]];
    this.setOutput(!0, "string"), this.appendDummyInput().appendField(new pt(_, (s) => (this.sheetTypeTypeChanged = !0, s)), d.Value), this.setStyle("data_blocks");
  },
  DetermineTypes() {
    return this.sheetTypeTypeChanged ? (this.sheetTypeTypeChanged = !1, !0) : !1;
  }
}, zf = {
  ...NS,
  geId: M.sheet_rank,
  sheetTypeTypeChanged: !1,
  init() {
    const _ = () => [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]];
    this.setOutput(!0, "string"), this.appendDummyInput().appendField(new pt(_, (s) => (this.sheetTypeTypeChanged = !0, s)), d.Value), this.setStyle("data_blocks");
  },
  DetermineTypes() {
    return this.sheetTypeTypeChanged ? (this.sheetTypeTypeChanged = !1, !0) : !1;
  }
}, Zf = {
  ...NS,
  geId: M.sheet_statistic,
  init() {
    const _ = () => [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]];
    this.setOutput(!0, "string"), this.appendDummyInput().appendField(new pt(_), d.Value), this.setStyle("deprecated_blocks");
  },
  DetermineTypes() {
    return !0;
  }
}, Qf = {
  ...NS,
  geId: M.sheet_multicol,
  sheetTypeTypeChanged: !1,
  init() {
    const _ = () => [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]];
    this.setOutput(!0, "string"), this.appendDummyInput().appendField(new pt(_, (s) => (this.sheetTypeTypeChanged = !0, s)), d.Value), this.setStyle("data_blocks");
  },
  DetermineTypes() {
    return this.sheetTypeTypeChanged ? (this.sheetTypeTypeChanged = !1, !0) : !1;
  }
}, zh = {
  ...hM,
  geId: M.read_statistic,
  locKey: _e.ReadAcc,
  init() {
    this.appendDummyInput("").appendField(f.ReadAcc), this.appendValueInput(d.Property + "1").appendField(f.SheetName).setCheck("String").connection.setShadowState({
      type: M.sheet_statistic
    }), this.appendDummyInput("").appendField(f.SheetKey).appendField(new ap(), d.Property + "2"), this.appendDummyInput().appendField(
      new jt({
        name: Oe("T_40_XXJ_WS_RESULT_NAMEKEY"),
        type: "Int"
      }),
      d.Property + "3"
    ).appendField(Oe("T_34_M_WS_INT")), this.appendValueInput(d.Property + "4").appendField(f.WorkShopCode).setCheck("string").connection.setShadowState({ type: M.input_text }), this.setInputsInline(!0), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setStyle("deprecated_blocks");
  },
  DetermineTypes() {
    const _ = this.getField(d.Property + "2");
    return _ == null || _.UpdateDisplay(), !1;
  },
  search(_) {
    return ["ReadDBAccumulatedData", f.ReadAcc].find((s) => z.containsKey(s, _)) || !1;
  },
  getSheetId() {
    const _ = this.getInputTargetBlock(d.Property + "1");
    return (_ == null ? void 0 : _.getFieldValue(d.Value)) || "";
  },
  getVarDefine(_, s, r) {
    if (s == Tr.SelfDefine || s == Tr.NextStatements) {
      let i = d.Property + "3", a = go(this, i, _, r);
      if (a)
        return a;
    }
    return s == Tr.NextStatements ? ki(this, _, r) : null;
  }
}, qf = {
  ...zh,
  geId: M.read_statistic_v2,
  init() {
    this.appendDummyInput("").appendField(f.ReadAcc), this.appendValueInput(d.Property + "1").appendField(f.SheetName).setCheck("String").connection.setShadowState({
      type: M.sheet_statistic
    }), this.appendDummyInput("").appendField(f.SheetKey).appendField(new ap(), d.Property + "2"), this.appendDummyInput().appendField(
      new jt({
        name: Oe("T_40_XXJ_WS_RESULT_NAMEKEY"),
        type: "Int"
      }),
      d.Property + "3"
    ).appendField(Oe("T_34_M_WS_INT")), this.setInputsInline(!0), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setStyle("deprecated_blocks");
  }
}, eN = {
  ...zh,
  geId: M.read_statistic_err,
  init() {
    this.appendDummyInput("").appendField(f.ReadAcc), this.appendValueInput(d.Property + "1").appendField(f.SheetName).setCheck("String").connection.setShadowState({
      type: M.sheet_statistic
    }), this.appendDummyInput("").appendField(f.SheetKey).appendField(new ap(), d.Property + "2"), this.appendDummyInput().appendField(
      new jt({
        name: Oe("T_40_XXJ_WS_RESULT_NAMEKEY"),
        type: "Int"
      }),
      d.Property + "3"
    ).appendField(Oe("T_34_M_WS_INT"));
    let _ = Ae.CurrentDescriptionFile.GetVarType("ErrorCode");
    this.appendDummyInput(d.Property + "5").appendField(new jt({ name: _.Label, type: _.Name }), d.Property + "5").appendField(_.Label, d.Property + "5L"), this.setInputsInline(!0), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setStyle("module_blocks");
  }
}, Zh = {
  ...hM,
  geId: M.write_statistic,
  locKey: _e.WriteAcc,
  init() {
    this.appendDummyInput("").appendField(f.WriteAcc), this.appendValueInput(d.Property + "1").appendField(f.SheetName).setCheck("String").connection.setShadowState({
      type: M.sheet_statistic
    }), this.appendDummyInput("").appendField(f.SheetKey).appendField(new ap(), d.Property + "2"), this.appendDummyInput("").appendField(new pt(
      [
        ["+=", Nt.Add],
        ["-=", Nt.Substract]
      ]
    ), d.Operator), this.appendValueInput(d.Property + "3").appendField(Oe("T_41_XXJ_WS_OFFSET")).setCheck("int").connection.setShadowState({ type: M.input_int }), this.appendValueInput(d.Property + "4").appendField(f.WorkShopCode).setCheck("string").connection.setShadowState({ type: M.input_text }), this.setInputsInline(!0), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setStyle("deprecated_blocks");
  },
  DetermineTypes() {
    const _ = this.getField(d.Property + "2");
    return _ == null || _.UpdateDisplay(), !1;
  },
  search(_) {
    return ["WriteDBAccumulatedDataOffset", f.WriteAcc].find((s) => z.containsKey(s, _)) || !1;
  },
  getSheetId() {
    const _ = this.getInputTargetBlock(d.Property + "1");
    return (_ == null ? void 0 : _.getFieldValue(d.Value)) || "";
  }
}, tN = {
  ...Zh,
  geId: M.write_statistic_v2,
  init() {
    this.appendDummyInput("").appendField(f.WriteAcc), this.appendValueInput(d.Property + "1").appendField(f.SheetName).setCheck("String").connection.setShadowState({
      type: M.sheet_statistic
    }), this.appendDummyInput("").appendField(f.SheetKey).appendField(new ap(), d.Property + "2"), this.appendDummyInput("").appendField(new pt(
      [
        ["+=", Nt.Add],
        ["-=", Nt.Substract]
      ]
    ), d.Operator), this.appendValueInput(d.Property + "3").appendField(Oe("T_41_XXJ_WS_OFFSET")).setCheck("int").connection.setShadowState({ type: M.input_int }), this.setInputsInline(!0), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setStyle("deprecated_blocks");
  }
}, rN = {
  ...Zh,
  geId: M.write_statistic_err,
  init() {
    this.appendDummyInput("").appendField(f.WriteAcc), this.appendValueInput(d.Property + "1").appendField(f.SheetName).setCheck("String").connection.setShadowState({
      type: M.sheet_statistic
    }), this.appendDummyInput("").appendField(f.SheetKey).appendField(new ap(), d.Property + "2"), this.appendDummyInput("").appendField(new pt(
      [
        ["+=", Nt.Add],
        ["-=", Nt.Substract]
      ]
    ), d.Operator), this.appendValueInput(d.Property + "3").appendField(Oe("T_41_XXJ_WS_OFFSET")).setCheck("int").connection.setShadowState({ type: M.input_int });
    let _ = Ae.CurrentDescriptionFile.GetVarType("ErrorCode");
    this.appendDummyInput(d.Property + "5").appendField(new jt({ name: _.Label, type: _.Name }), d.Property + "5").appendField(_.Label, d.Property + "5L"), this.setInputsInline(!0), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setStyle("module_blocks");
  }
}, nN = {
  geId: M.write_statistic_cross_map,
  locKey: _e.WriteAcc,
  init() {
    var _;
    this.appendDummyInput("").appendField("*" + f.WriteAcc, d.Label), (_ = this.getField(d.Label)) == null || _.setClass("blocklyLowApiLevel"), this.appendValueInput(d.Property + "1").appendField(f.SheetName).setCheck("string").connection.setShadowState({ type: M.input_text }), this.appendValueInput(d.Property + "2").appendField(f.SheetKey).setCheck("string").connection.setShadowState({ type: M.input_text }), this.appendDummyInput("").appendField(new pt(
      [
        ["+=", Nt.Add],
        ["-=", Nt.Substract]
      ]
    ), d.Operator), this.appendValueInput(d.Property + "4").appendField(Oe("T_41_XXJ_WS_OFFSET")).setCheck("int").connection.setShadowState({ type: M.input_int }), this.appendValueInput(d.Property + "5").appendField(f.WorkShopCode).setCheck("string").connection.setShadowState({ type: M.input_text }), this.setInputsInline(!0), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setStyle("deprecated_blocks");
  },
  loadExtraState() {
  },
  saveExtraState() {
    return {
      [d.Index]: 670
    };
  },
  search(_) {
    return ["WriteDBAccumulatedDataOffset", f.WriteAcc].find((s) => z.containsKey(s, _)) || !1;
  }
}, _N = {
  geId: M.write_statistic_cross_map_err,
  locKey: _e.WriteAcc,
  init() {
    var s;
    this.appendDummyInput("").appendField("*" + f.WriteAcc, d.Label), (s = this.getField(d.Label)) == null || s.setClass("blocklyLowApiLevel"), this.appendValueInput(d.Property + "1").appendField(f.SheetName).setCheck("string").connection.setShadowState({ type: M.input_text }), this.appendValueInput(d.Property + "2").appendField(f.SheetKey).setCheck("string").connection.setShadowState({ type: M.input_text }), this.appendDummyInput("").appendField(new pt(
      [
        ["+=", Nt.Add],
        ["-=", Nt.Substract]
      ]
    ), d.Operator), this.appendValueInput(d.Property + "4").appendField(Oe("T_41_XXJ_WS_OFFSET")).setCheck("int").connection.setShadowState({ type: M.input_int }), this.appendValueInput(d.Property + "5").appendField(f.WorkShopCode).setCheck("string").connection.setShadowState({ type: M.input_text });
    let _ = Ae.CurrentDescriptionFile.GetVarType("ErrorCode");
    this.appendDummyInput(d.Property + "6").appendField(new jt({ name: _.Label, type: _.Name }), d.Property + "6").appendField(_.Label, d.Property + "6L"), this.setInputsInline(!0), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setStyle("module_blocks");
  },
  loadExtraState() {
  },
  saveExtraState() {
    return {
      [d.Index]: 810
    };
  },
  search(_) {
    return ["WriteDBAccumulatedDataOffset", f.WriteAcc].find((s) => z.containsKey(s, _)) || !1;
  },
  getVarDefine(_, s, r) {
    if (s == Tr.SelfDefine || s == Tr.NextStatements) {
      let i = d.Property + "6", a = go(this, i, _, r);
      if (a)
        return a;
    }
    return s == Tr.NextStatements ? ki(this, _, r) : null;
  }
};
class ap extends Yn {
  constructor(s, r) {
    super([[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]], s, r), this.menuGenerator_ = this.getSheetKeys;
  }
  getSheetKeys() {
    return [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]];
  }
}
let iN = {
  previousValue: null,
  init() {
    this.setOutput(!0, "TupleIndex"), this.appendDummyInput().appendField(new oN(), d.Property), this.setStyle("data_blocks");
  },
  getSheetType() {
    let _ = this.outputConnection.targetConnection, s = _ == null ? void 0 : _.getCheck(), r = s == null ? void 0 : s[0];
    if (r) {
      const i = Ae.CurrentDescriptionFile;
      let a = i.GetVarType(r);
      if (a && i.CheckIsExtention(i.getType("TupleIndex"), a))
        return a.ElementType;
    }
    return "";
  },
  DetermineTypes() {
    let _ = this.getField(d.Property);
    _.UpdateDisplay();
    let s = _.getValue();
    return this.previousValue != s ? (this.previousValue = s, !0) : !1;
  }
};
class oN extends Yn {
  constructor(s, r) {
    super([[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]], s, r), this.menuGenerator_ = this.generateProperties;
  }
  getValueDefaultOptions(s) {
    var r;
    if (s) {
      const i = s.split("--"), a = i[0], p = i[1], h = Ae.CurrentDescriptionFile.GetVarType(a), L = (r = h == null ? void 0 : h.Items) == null ? void 0 : r.get_Item(p);
      if (L)
        return [L.Name, `${a}--${p}`];
    }
    return [f.Unselected, s, "", { style: "fill: var(--red_err5);" }];
  }
  getSheetType() {
    return this.sourceBlock_ && "getSheetType" in this.sourceBlock_ ? this.sourceBlock_.getSheetType(this) : "";
  }
  generateProperties() {
    const s = this.getSheetType();
    if (!s)
      return [
        [f.Unselected, "", "", { style: "fill: var(--red_err5);" }]
      ];
    const i = Ae.CurrentDescriptionFile.GetVarType(s);
    if (!i)
      return [
        [f.Unselected, "", "", { style: "fill: var(--red_err5);" }]
      ];
    const a = [];
    for (const p of i.Items)
      a.push([p.Label, `${s}--${p.Value}`]);
    return a.length ? a : [
      [f.Unselected, "", "", { style: "fill: var(--red_err5);" }]
    ];
  }
}
function TN(_) {
  g.Blocks[M.sheet_data] = jf, g.Blocks[M.sheet_rank] = zf, g.Blocks[M.sheet_statistic] = Zf, g.Blocks[M.sheet_multicol] = Qf, g.Blocks[M.read_statistic] = zh, g.Blocks[M.write_statistic] = Zh, g.Blocks[M.read_statistic_v2] = qf, g.Blocks[M.write_statistic_v2] = tN, g.Blocks[M.write_statistic_cross_map] = nN, g.Blocks[M.read_statistic_err] = eN, g.Blocks[M.write_statistic_err] = rN, g.Blocks[M.write_statistic_cross_map_err] = _N, g.Blocks[M.sheet_column] = iN, _.set("DataSheet", { kind: "block", type: M.sheet_data }), _.set("RankSheet", { kind: "block", type: M.sheet_rank }), _.set("MulticolSheet", { kind: "block", type: M.sheet_multicol }), _.set("SheetColumn", { kind: "block", type: M.sheet_column }), _.set("ReadStatisticalSheet", { kind: "block", type: M.read_statistic }), _.set("WriteStatisticalSheet", { kind: "block", type: M.write_statistic }), _.set("ReadStatisticalSheetV2", { kind: "block", type: M.read_statistic_v2 }), _.set("WriteStatisticalSheetV2", { kind: "block", type: M.write_statistic_v2 }), _.set("WriteStatisticalSheetCrossMap", { kind: "block", type: M.write_statistic_cross_map }), _.set("ReadStatisticalSheet_ERR", { kind: "block", type: M.read_statistic_err }), _.set("WriteStatisticalSheet_ERR", { kind: "block", type: M.write_statistic_err }), _.set("WriteStatisticalSheetCross_ERR", { kind: "block", type: M.write_statistic_cross_map_err });
}
var _p;
((_) => {
  _.DATA_STORAGE_CHANGE = "data_storage_change";
  class s extends g.Events.Abstract {
    constructor(a) {
      super();
      N(this, "defineKey");
      N(this, "isBlank");
      this.type = _.DATA_STORAGE_CHANGE, this.workspaceId = a;
    }
  }
  _.DataStorageChange = s;
})(_p || (_p = {}));
g.registry.register(
  g.registry.Type.EVENT,
  _p.DATA_STORAGE_CHANGE,
  _p.DataStorageChange
);
const sN = 1;
function ri(_, s, r, i, a = !1) {
  var Z;
  let p = s.GetVarType(r.Type), E = p, h = bT(i), L = null, y = _.paramInfo[h];
  if (y) {
    let le = y.inputType;
    le && (E = s.GetVarType(le)), y.bShadow && (L = y.block);
  }
  E || (E = p);
  const V = _.getInput(h);
  if (a)
    V && _.removeInput(h), _.appendDummyInput(h).appendField(new jt({ name: r.Label, type: r.Type }), h);
  else {
    let le;
    V && ((Z = V.connection) != null && Z.targetBlock() && (le = V.connection.targetConnection, V.connection.disconnect()), _.removeInput(h));
    let ce = _.appendValueInput(h).appendField(r.Label).setCheck(r.Type);
    ce.fieldRow[0].setTooltip(r.Tip), L ?? (L = oM(E, s, r.Type, y)), __(ce, L), le && ce.connection.connect(le), _n(ce, r.Type);
  }
}
function bS(_, s, r) {
  return !1;
}
const IM = {
  ...OT,
  ecatype: "action",
  fixOwnerType: "HudSignalWidget",
  init() {
    this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.common_init(), this.setStyle("event_blocks");
  },
  updateShape_() {
    let _ = Ae.CurrentDescriptionFile, s = this.action;
    if (s == null) {
      let i = this.paramOrder;
      if (i)
        for (let a of i)
          _i(this, a, !1);
      return;
    }
    if (s.Type) {
      let i = _.GetVarType(s.Type);
      i && "" + f.FunctionDefineReturn + i.Label;
    }
    this.updateTitle_(Oe("FE_49_XXJ_SENDEVENT", [s.Label]), s.m_ApiLevel);
    let r = this.paramOrder;
    if (r == null) {
      this.paramOrder = [];
      let i = 1;
      for (let a of s.Items)
        this.paramOrder.push(i), ri(this, _, a, i), i++;
    } else
      for (let i of r) {
        let a = s.Items.get_Item(i - 1);
        a == null ? _i(this, i, !1) : ri(this, _, a, i);
      }
  },
  search(_, s) {
    return bS();
  },
  UpdateDisplay() {
    if (this.geId) {
      let _ = z.graphElementMap.get(this.geId);
      _ && this.resolveApi(_.ref, _.ParsedParamOrder);
    } else
      this.apiname && this.resolveApi(this.apiname);
    if (this.action) {
      let _ = this.action;
      this.updateTitle_(Oe("FE_49_XXJ_SENDEVENT", [_.Label]), _.m_ApiLevel);
    }
  }
  // customContextMenu(options: Array<Blockly.ContextMenuRegistry.ContextMenuOption | Blockly.ContextMenuRegistry.LegacyContextMenuOption>) {
  //     const action = (this as Blockly.Block as IBlockEVACommon).action;
  //     if (this.isInFlyout && action && !action.m_ModuleLib) {
  //         const deleteSignal = {
  //             text: $t('FE_45_XXJ_DELETECUSTOMEVENT', [action.Label]),
  //             enabled: true,
  //             callback: () => {
  //                 GModuleManager.Get(IEventManagementModule).deleteCustomEvent(action as ECAPackage.ECAEventDefine);
  //             },
  //         };
  //         options.push(deleteSignal);
  //     }
  // },
}, lN = {
  ...IM,
  updateShape_() {
    let _ = Ae.CurrentDescriptionFile;
    if (this.action == null) {
      let s = this.paramOrder;
      if (s)
        for (let r of s)
          _i(this, r, !1);
      return;
    }
    if (this.updateTitle_(Oe("FE_49_XXJ_SENDEVENT", [this.action.Label])), this.paramOrder)
      for (let s of this.paramOrder) {
        const r = this.action.Items.get_Item(s - 1);
        r ? ri(this, _, r, s) : _i(this, s, !1);
      }
    else {
      this.paramOrder = [];
      let s = sN;
      for (let r of this.action.Items)
        this.paramOrder.push(s), ri(this, _, r, s), s++;
    }
  }
  // customContextMenu(options: Array<Blockly.ContextMenuRegistry.ContextMenuOption | Blockly.ContextMenuRegistry.LegacyContextMenuOption>) {
  //     const action = (this as Blockly.Block as IBlockEVACommon).action;
  //     if (this.isInFlyout && action && !action.m_ModuleLib) {
  //         const deleteSignal = {
  //             text: $t('FE_45_XXJ_DELETECUSTOMEVENT', [action.Label]),
  //             enabled: true,
  //             callback: () => {
  //                 GModuleManager.Get(IEventManagementModule).deleteCustomEvent(action as ECAPackage.ECAEventDefine);
  //             },
  //         };
  //         options.push(deleteSignal);
  //     }
  // },
}, aN = {
  ...OT,
  old_loadExtraState: OT.loadExtraState,
  loadExtraState(_) {
    this.hasCrossPlatform = !!(_ != null && _[d.Code]), this.old_loadExtraState(_);
  },
  saveExtraState() {
    var _;
    return {
      [d.Index]: this.geId,
      [d.ParamList]: this.paramOrder,
      [d.Type]: (_ = this.action) == null ? void 0 : _.Name,
      [d.OwnerType]: this.fixOwnerType,
      [d.Code]: this.hasCrossPlatform
    };
  },
  ecatype: "signal",
  hasCrossPlatform: !1,
  init() {
    this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.common_init(), this.setStyle("event_blocks");
  },
  updateShape_() {
    let _ = Ae.CurrentDescriptionFile, s = this.action, r = s == null ? void 0 : s.owner, i = this.appendValueInput(d.Owner).appendField(Oe("T_34_M_WS_ENTITY")).setCheck(r);
    if (i.fieldRow[0].setTooltip(Oe("T_40_XXJ_WS_TARGETENTITY_DESCKEY")), __(i, { type: M.shadow_type, extraState: r }), this.hasCrossPlatform) {
      let p = this.appendValueInput(d.V1).appendField(Oe("T_43_YU_WS_CROSSPLATFORM")).setCheck("Bool");
      p.fieldRow[0].setTooltip(Oe("T_43_YU_WS_CROSSPLATFORM_D")), __(p, { type: M.input_boolean });
    }
    if (s == null) {
      let p = this.paramOrder;
      if (p)
        for (let E of p)
          _i(this, E, !1);
      return;
    }
    this.updateTitle_(Oe("FE_49_XXJ_SENDEVENT", [s.Label]));
    let a = this.paramOrder;
    if (a == null) {
      this.paramOrder = [];
      let p = 1;
      for (let E of s.Items)
        this.paramOrder.push(p), ri(this, _, E, p), p++;
    } else
      for (let p of a) {
        let E = s.Items.get_Item(p - 1);
        E == null ? _i(this, p, !1) : ri(this, _, E, p);
      }
  },
  search(_, s) {
    return bS();
  },
  updateTitle() {
    this.action && this.updateTitle_(Oe("FE_49_XXJ_SENDEVENT", [this.action.Label]), this.action.m_ApiLevel);
  }
  // customContextMenu(options: Array<Blockly.ContextMenuRegistry.ContextMenuOption | Blockly.ContextMenuRegistry.LegacyContextMenuOption>) {
  //     const action = (this as Blockly.Block as IBlockEVACommon).action;
  //     if (this.isInFlyout && action && !action.m_ModuleLib) {
  //         const deleteSignal = {
  //             text: $t('FE_45_XXJ_DELETECUSTOMEVENT', [action.Label]),
  //             enabled: true,
  //             callback: () => {
  //                 GModuleManager.Get(IEventManagementModule).deleteCustomEvent(action as ECAPackage.ECAEventDefine);
  //             },
  //         };
  //         options.push(deleteSignal);
  //     }
  // },
}, MM = {
  ...OT,
  loadExtraState(_) {
    let s = _[d.Type];
    this.apiname = s, this.paramOrder = _[d.ParamList], this.paramInfo = {}, _[d.OwnerType] && (this.fixOwnerType = _[d.OwnerType]), this.geId = 0, this.resolveApi(s), this.updateShape_();
  },
  onchange(_) {
    if (_.type === g.Events.FINISHED_LOADING && this.UpdateDisplay(), _.type === BE.CUSTOM_BLOCK_DEFINE_CHANGE) {
      const s = this.action;
      if (_.defineKey === (s == null ? void 0 : s.Name)) {
        const i = _.ownerType;
        i && (this.fixOwnerType = i), this.resolveApi(s.Name), this.UpdateDisplay();
      }
    }
  }
}, cN = {
  ...MM,
  ecatype: "signal",
  init() {
    this.common_init(), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setStyle("event_blocks");
  },
  // customContextMenu(options: Array<Blockly.ContextMenuRegistry.ContextMenuOption | Blockly.ContextMenuRegistry.LegacyContextMenuOption>) {
  //     const action = (this as Blockly.Block as IBlockEVACommon).action;
  //     if (this.isInFlyout && action && !action.m_ModuleLib) {
  //         const editSignal = {
  //             text: $t('FE_45_XXJ_EDITCUSTOMEVENT', [action.Label]),
  //             enabled: true,
  //             callback: () => {
  //                 GModuleManager.Get(ICommandModule).Send(
  //                     ECommandActionIds.menu_event_setting,
  //                     true,
  //                     action.Name
  //                 );
  //             },
  //         };
  //         const deleteSignal = {
  //             text: $t('FE_45_XXJ_DELETECUSTOMEVENT', [action.Label]),
  //             enabled: true,
  //             callback: () => {
  //                 GModuleManager.Get(IEventManagementModule).deleteCustomEvent(action as ECAPackage.ECAEventDefine);
  //             },
  //         };
  //         options.push(editSignal, deleteSignal);
  //     }
  // },
  updateShape_() {
    const _ = () => {
      const E = Ae.CurrentDescriptionFile, h = [], L = E.GetVarType("PlatformType");
      for (let y of L.Items)
        h.push([y.Label, y.Value]);
      return h;
    };
    let s = Ae.CurrentDescriptionFile, r = this.action, i = r == null ? void 0 : r.owner, a = this.appendValueInput(d.Owner).appendField(Oe("T_34_M_WS_ENTITY")).setCheck(i);
    if (a.fieldRow[0].setTooltip(Oe("T_40_XXJ_WS_TARGETENTITY_DESCKEY")), __(a, { type: M.shadow_type, extraState: i }), this.appendDummyInput(d.Condition).appendField(Oe("T_45_XXJ_WS_TARGETSIDE")).appendField(new Yn(_), d.To), r == null) {
      let E = this.paramOrder;
      if (E)
        for (let h of E)
          _i(this, h, !1);
      return;
    }
    this.updateTitle_(Oe("FE_49_XXJ_SENDEVENT", [r.Label]));
    let p = this.paramOrder;
    if (p == null) {
      this.paramOrder = [];
      let E = 1;
      for (let h of r.Items)
        this.paramOrder.push(E), ri(this, s, h, E), E++;
    } else
      for (let E of p) {
        let h = r.Items.get_Item(E - 1);
        h == null ? _i(this, E, !1) : ri(this, s, h, E);
      }
  },
  UpdateDisplay() {
    g.Events.disable();
    let _ = Ae.CurrentDescriptionFile, s = this.action;
    if (!s) {
      g.Events.enable();
      return;
    }
    let r = s == null ? void 0 : s.owner, i = this.getInput(d.Owner);
    i == null || i.setCheck(r), __(i, { type: M.shadow_type, extraState: r }), this.updateTitle_(Oe("FE_49_XXJ_SENDEVENT", [s.Label])), this.paramOrder = [];
    let a = 1;
    for (let E of s.Items)
      this.paramOrder.push(a), ri(this, _, E, a), a++;
    let p = bT(a);
    for (; this.getInput(p); )
      this.removeInput(p, !0), a++, p = bT(a);
    g.Events.enable();
  },
  search(_, s) {
    return bS();
  }
}, pN = {
  ...MM,
  ecatype: "event",
  init() {
    this.hat = "cap", this.common_init(), this.setNextStatement(!0, "action"), this.setStyle("event_blocks");
  },
  updateShape_() {
    let _ = Ae.CurrentDescriptionFile, s = this.action;
    if (s == null) {
      let a = this.paramOrder;
      if (a)
        for (let p of a)
          _i(this, p, !0);
      return;
    }
    let r = "";
    if (s.Type) {
      let a = _.GetVarType(s.Type);
      a && (r = `
` + f.FunctionDefineReturn + " " + a.Label);
    }
    this.setTooltip(s.Tip + r), this.updateTitle();
    let i = this.paramOrder;
    if (i == null) {
      this.paramOrder = [];
      let a = 1;
      for (let p of s.Items)
        this.paramOrder.push(a), ri(this, _, p, a, !0), a++;
    } else
      for (let a of i) {
        let p = s.Items.get_Item(a - 1);
        p == null ? _i(this, a, !0) : ri(this, _, p, a, !0);
      }
  },
  UpdateDisplay() {
    g.Events.disable();
    let _ = Ae.CurrentDescriptionFile, s = this.action;
    if (!s) {
      g.Events.enable();
      return;
    }
    this.updateTitle(), this.paramOrder = [];
    let r = 1;
    for (let a of s.Items)
      this.paramOrder.push(r), ri(this, _, a, r, !0), r++;
    let i = bT(r);
    for (; this.getInput(i); )
      this.removeInput(i, !0), r++, i = bT(r);
    g.Events.enable();
  },
  search(_, s) {
    return bS();
  },
  updateTitle() {
    this.action && this.updateTitle_(Oe("FE_49_XXJ_RECEIVEEVENT", [this.action.Label]), this.action.m_ApiLevel);
  }
};
function uN(_) {
  g.Blocks[M.signal_shoot] = IM, g.Blocks[M.signal_shootv2] = lN, g.Blocks[M.signal_receive] = pN, g.Blocks[M.signal_shootV3] = aN, g.Blocks[M.signal_shootV4] = cN;
}
const EN = {
  geId: M.vector3_operation,
  locKey: _e.VectorOperation,
  operator: Ze.Addition,
  init() {
    this.setInputsInline(!0), this.setOutput(!0, "Vector3"), this.appendValueInput(d.V1).setCheck("Vector3").appendField(f.VectorOperation).connection.setShadowState({
      type: M.input_vector3
    }), this.appendDummyInput().appendField(
      new pt(
        [
          ["+", Ze.Addition],
          ["-", Ze.Subtraction],
          ["x", Ze.Multiplication],
          [f.VectorDotProduct, Ze.DotProduct],
          [f.VectorCrossProduct, Ze.CrossProduct],
          [f.VectorDistance, Ze.Distance],
          [f.VectorIncludedAngle, Ze.IncludedAngle]
        ],
        (_) => (this.updateShape_(_), _)
      ),
      d.Operator
    ), this.appendValueInput(d.V2).setCheck("Vector3").connection.setShadowState({
      type: M.input_vector3
    }), this.setStyle("data_blocks");
  },
  loadExtraState(_) {
    this.updateShape_(_ == null ? void 0 : _[d.Operator]);
  },
  saveExtraState() {
    return {
      [d.Operator]: this.operator
    };
  },
  updateShape_(_) {
    var E, h, L, y;
    const s = (V) => {
      switch (V) {
        case Ze.Addition:
        case Ze.Subtraction:
        case Ze.Multiplication:
        case Ze.CrossProduct:
          return "Vector3";
        case Ze.DotProduct:
        case Ze.Distance:
        case Ze.IncludedAngle:
          return "float";
        default:
          return "";
      }
    };
    this.setOutput(!!s(_), s(_));
    const r = Ae.CurrentDescriptionFile;
    let i;
    switch (_) {
      case Ze.Addition:
        i = r.variables.get_Item("VectorAdd");
        break;
      case Ze.Subtraction:
        i = r.variables.get_Item("VectorSub");
        break;
      case Ze.Multiplication:
        i = r.variables.get_Item("VectorMul");
        break;
      case Ze.DotProduct:
        i = r.variables.get_Item("VectorDot");
        break;
      case Ze.CrossProduct:
        i = r.variables.get_Item("VectorCross");
        break;
      case Ze.Distance:
        i = r.variables.get_Item("VectorDistance");
        break;
      case Ze.IncludedAngle:
        i = r.variables.get_Item("VectorAngel");
        break;
    }
    if (i) {
      const V = yT(i);
      this.setTooltip(V);
    } else
      this.setTooltip("");
    if (this.operator === _)
      return;
    const a = (V) => V === Ze.Multiplication ? "InputNumber" : "Vector3", p = this.operator;
    this.operator = _, a(p) !== a(_) && (a(_) === "InputNumber" ? (h = (E = this.getInput(d.V2)) == null ? void 0 : E.setCheck("float")) == null || h.connection.setShadowState({
      type: M.input_float
    }) : (y = (L = this.getInput(d.V2)) == null ? void 0 : L.setCheck("Vector3")) == null || y.connection.setShadowState({
      type: M.input_vector3
    }));
  },
  search(_) {
    return [f.VectorOperation].find((s) => z.containsKey(s, _)) || !1;
  }
}, AN = {
  geId: M.vector3_get,
  locKey: _e.VectorGetter,
  property: "X",
  init() {
    this.setInputsInline(!0), this.setStyle("data_blocks"), this.setOutput(!0, "float"), this.appendValueInput(d.Value).setCheck("Vector3").appendField(f.VectorGetter).appendField(
      new pt(
        [
          ["X", "X"],
          ["Y", "Y"],
          ["Z", "Z"]
        ],
        (_) => (this.property = _, this.updateTooltip(_), _)
      ),
      d.Property
    ).connection.setShadowState({
      type: M.input_vector3
    });
  },
  loadExtraState(_) {
    this.updateTooltip(_ == null ? void 0 : _[d.Property]);
  },
  saveExtraState() {
    return {
      [d.Property]: this.property
    };
  },
  updateTooltip(_) {
    const s = Ae.CurrentDescriptionFile;
    let r, i = "";
    switch (_) {
      case "X":
        r = s.variables.get_Item("VectorGetX");
        break;
      case "Y":
        r = s.variables.get_Item("VectorGetY");
        break;
      case "Z":
        r = s.variables.get_Item("VectorGetZ");
        break;
    }
    r && (i = yT(r)), this.setTooltip(i);
  },
  search(_) {
    return [f.VectorGetter].find((s) => z.containsKey(s, _)) || !1;
  }
}, dN = {
  geId: M.vector3_set,
  locKey: _e.VectorSetter,
  property: "X",
  init() {
    this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setInputsInline(!0), this.setStyle("data_blocks"), this.appendValueInput(d.Item).setCheck("Vector3").appendField(f.VectorSetter).appendField(
      new pt(
        [
          ["X", "X"],
          ["Y", "Y"],
          ["Z", "Z"]
        ],
        (_) => (this.property = _, this.updateTooltip(_), _)
      ),
      d.Property
    ).connection.setShadowState({
      type: M.input_vector3
    }), this.appendValueInput(d.Value).setCheck("float").connection.setShadowState({
      type: M.input_float
    });
  },
  loadExtraState(_) {
    this.updateTooltip(_ == null ? void 0 : _[d.Property]);
  },
  saveExtraState() {
    return {
      [d.Property]: this.property
    };
  },
  updateTooltip(_) {
    const s = Ae.CurrentDescriptionFile;
    let r, i = "";
    switch (_) {
      case "X":
        r = s.actions.get_Item("VectorSetX");
        break;
      case "Y":
        r = s.actions.get_Item("VectorSetY");
        break;
      case "Z":
        r = s.actions.get_Item("VectorSetZ");
        break;
    }
    r && (i = yT(r)), this.setTooltip(i);
  },
  search(_) {
    return [f.VectorSetter].find((s) => z.containsKey(s, _)) || !1;
  }
}, SN = {
  geId: M.vector3_setxyz,
  locKey: _e.VectorSetter,
  property: "X",
  init() {
    this.setInputsInline(!0), this.setOutput(!0, "Vector3"), this.setStyle("data_blocks"), this.appendValueInput(d.Item).setCheck("Vector3").appendField(f.VectorSetter).appendField(
      new pt(
        [
          ["X", "X"],
          ["Y", "Y"],
          ["Z", "Z"]
        ],
        (_) => (this.property = _, this.updateTooltip(_), _)
      ),
      d.Property
    ).connection.setShadowState({
      type: M.input_vector3
    }), this.appendValueInput(d.Value).setCheck("float").connection.setShadowState({
      type: M.input_float
    });
  },
  loadExtraState(_) {
    this.updateTooltip(_ == null ? void 0 : _[d.Property]);
  },
  saveExtraState() {
    return {
      [d.Property]: this.property
    };
  },
  updateTooltip(_) {
    const s = Ae.CurrentDescriptionFile;
    let r, i = "";
    switch (_) {
      case "X":
        r = s.variables.get_Item("VectorSetXClient");
        break;
      case "Y":
        r = s.variables.get_Item("VectorSetYClient");
        break;
      case "Z":
        r = s.variables.get_Item("VectorSetZClient");
        break;
    }
    r && (i = yT(r)), this.setTooltip(i);
  },
  search(_) {
    return [f.VectorSetter].find((s) => z.containsKey(s, _)) || !1;
  }
}, hN = {
  geId: M.vector2_operation,
  locKey: _e.Vector2Operation,
  operator: Ze.Addition,
  init() {
    this.setInputsInline(!0), this.setOutput(!0, "Vector2"), this.appendValueInput(d.V1).setCheck("Vector2").appendField(f.Vector2Operation).connection.setShadowState({
      type: M.input_vector2
    }), this.appendDummyInput().appendField(
      new pt(
        [
          ["+", Ze.Addition],
          ["-", Ze.Subtraction],
          ["x", Ze.Multiplication],
          [f.VectorDotProduct, Ze.DotProduct],
          [f.VectorDistance, Ze.Distance],
          [f.VectorIncludedAngle, Ze.IncludedAngle]
        ],
        (_) => (this.updateShape_(_), _)
      ),
      d.Operator
    ), this.appendValueInput(d.V2).setCheck("Vector2").connection.setShadowState({
      type: M.input_vector2
    }), this.setStyle("data_blocks");
  },
  loadExtraState(_) {
    this.updateShape_(_ == null ? void 0 : _[d.Operator]);
  },
  saveExtraState() {
    return {
      [d.Operator]: this.operator
    };
  },
  updateShape_(_) {
    var E, h, L, y;
    const s = (V) => {
      switch (V) {
        case Ze.Addition:
        case Ze.Subtraction:
        case Ze.Multiplication:
          return "Vector2";
        case Ze.DotProduct:
        case Ze.Distance:
        case Ze.IncludedAngle:
          return "float";
        default:
          return "";
      }
    };
    this.setOutput(!!s(_), s(_));
    const r = Ae.CurrentDescriptionFile;
    let i;
    switch (_) {
      case Ze.Addition:
        i = r.variables.get_Item("Vector2Add");
        break;
      case Ze.Subtraction:
        i = r.variables.get_Item("Vector2Sub");
        break;
      case Ze.Multiplication:
        i = r.variables.get_Item("Vector2Scale");
        break;
      case Ze.DotProduct:
        i = r.variables.get_Item("Vector2Dot");
        break;
      case Ze.Distance:
        i = r.variables.get_Item("Vector2Distance");
        break;
      case Ze.IncludedAngle:
        i = r.variables.get_Item("Vector2Angle");
        break;
    }
    if (i) {
      const V = yT(i);
      this.setTooltip(V);
    } else
      this.setTooltip("");
    if (this.operator === _)
      return;
    const a = (V) => V === Ze.Multiplication ? "InputNumber" : "Vector2", p = this.operator;
    this.operator = _, a(p) !== a(_) && (a(_) === "InputNumber" ? (h = (E = this.getInput(d.V2)) == null ? void 0 : E.setCheck("float")) == null || h.connection.setShadowState({
      type: M.input_float
    }) : (y = (L = this.getInput(d.V2)) == null ? void 0 : L.setCheck("Vector2")) == null || y.connection.setShadowState({
      type: M.input_vector2
    }));
  },
  search(_) {
    return [f.Vector2Operation].find((s) => z.containsKey(s, _)) || !1;
  }
}, IN = {
  geId: M.vector2_get,
  locKey: _e.Vector2Getter,
  property: "X",
  init() {
    this.setInputsInline(!0), this.setStyle("data_blocks"), this.setOutput(!0, "float"), this.appendValueInput(d.Value).setCheck("Vector2").appendField(f.Vector2Getter).appendField(
      new pt(
        [
          ["X", "X"],
          ["Y", "Y"]
        ],
        (_) => (this.property = _, this.updateTooltip(_), _)
      ),
      d.Property
    ).connection.setShadowState({
      type: M.input_vector2
    });
  },
  loadExtraState(_) {
    this.updateTooltip(_ == null ? void 0 : _[d.Property]);
  },
  saveExtraState() {
    return {
      [d.Property]: this.property
    };
  },
  updateTooltip(_) {
    const s = Ae.CurrentDescriptionFile;
    let r, i = "";
    switch (_) {
      case "X":
        r = s.variables.get_Item("Vector2GetX");
        break;
      case "Y":
        r = s.variables.get_Item("Vector2GetY");
        break;
    }
    r && (i = yT(r)), this.setTooltip(i);
  },
  search(_) {
    return [f.Vector2Getter].find((s) => z.containsKey(s, _)) || !1;
  }
}, MN = {
  geId: M.vector2_set,
  locKey: _e.Vector2Setter,
  property: "X",
  init() {
    this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setInputsInline(!0), this.setStyle("data_blocks"), this.appendValueInput(d.Item).setCheck("Vector2").appendField(f.Vector2Setter).appendField(
      new pt(
        [
          ["X", "X"],
          ["Y", "Y"]
        ],
        (_) => (this.property = _, this.updateTooltip(_), _)
      ),
      d.Property
    ).connection.setShadowState({
      type: M.input_vector2
    }), this.appendValueInput(d.Value).setCheck("float").connection.setShadowState({
      type: M.input_float
    });
  },
  loadExtraState(_) {
    this.updateTooltip(_ == null ? void 0 : _[d.Property]);
  },
  saveExtraState() {
    return {
      [d.Property]: this.property
    };
  },
  updateTooltip(_) {
    const s = Ae.CurrentDescriptionFile;
    let r, i = "";
    switch (_) {
      case "X":
        r = s.actions.get_Item("Vector2SetX");
        break;
      case "Y":
        r = s.actions.get_Item("Vector2SetY");
        break;
    }
    r && (i = yT(r)), this.setTooltip(i);
  },
  search(_) {
    return [f.Vector2Setter].find((s) => z.containsKey(s, _)) || !1;
  }
}, mN = {
  geId: M.vector2_setxy,
  locKey: _e.Vector2Setter,
  property: "X",
  init() {
    this.setInputsInline(!0), this.setOutput(!0, "Vector2"), this.setStyle("data_blocks"), this.appendValueInput(d.Item).setCheck("Vector2").appendField(f.Vector2Setter).appendField(
      new pt(
        [
          ["X", "X"],
          ["Y", "Y"]
        ],
        (_) => (this.property = _, this.updateTooltip(_), _)
      ),
      d.Property
    ).connection.setShadowState({
      type: M.input_vector2
    }), this.appendValueInput(d.Value).setCheck("float").connection.setShadowState({
      type: M.input_float
    });
  },
  loadExtraState(_) {
    this.updateTooltip(_ == null ? void 0 : _[d.Property]);
  },
  saveExtraState() {
    return {
      [d.Property]: this.property
    };
  },
  updateTooltip(_) {
    const s = Ae.CurrentDescriptionFile;
    let r, i = "";
    switch (_) {
      case "X":
        r = s.variables.get_Item("Vector2SetXClient");
        break;
      case "Y":
        r = s.variables.get_Item("Vector2SetYClient");
        break;
    }
    r && (i = yT(r)), this.setTooltip(i);
  },
  search(_) {
    return [f.Vector2Setter].find((s) => z.containsKey(s, _)) || !1;
  }
};
function PN(_) {
  g.Blocks[M.vector3_operation] = EN, g.Blocks[M.vector3_get] = AN, g.Blocks[M.vector3_set] = dN, g.Blocks[M.vector3_setxyz] = SN, g.Blocks[M.vector2_operation] = hN, g.Blocks[M.vector2_get] = IN, g.Blocks[M.vector2_set] = MN, g.Blocks[M.vector2_setxy] = mN, _.set("Vector3Operation", { kind: "block", type: M.vector3_operation }), _.set("Vector3Getter", { kind: "block", type: M.vector3_get }), _.set("Vector3Setter", { kind: "block", type: M.vector3_set }), _.set("Vector3xyzSetter", { kind: "block", type: M.vector3_setxyz }), _.set("Vector2Operation", { kind: "block", type: M.vector2_operation }), _.set("Vector2Getter", { kind: "block", type: M.vector2_get }), _.set("Vector2Setter", { kind: "block", type: M.vector2_set }), _.set("Vector2xySetter", { kind: "block", type: M.vector2_setxy });
}
const DN = {
  debugAvailable: !0,
  locKey: _e.PrintInfo,
  geId: 0,
  init() {
    this.setInputsInline(!0), this.setStyle("action_blocks"), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.appendDummyInput().appendField(f.PrintInfo).appendField(new pt([
      [f.LogString, "PrintString"],
      [f.LogWarning, "PrintWarning"],
      [f.LogError, "PrintError"]
    ]), d.Type), this.appendValueInput(d.Value).setAlign(X.ALIGN_RIGHT).setCheck("Object").connection.setShadowState(xe("Object"));
  },
  updateShape_() {
  },
  search(_, s) {
    return ["PrintString", f.LogString, "PrintWarning", f.LogWarning, "PrintError", f.LogError].find((r) => z.containsKey(r, _)) || !1;
  }
};
function LN(_) {
  g.Blocks[M.print_info] = DN, _.set("PrintInfo", {
    kind: "block",
    type: M.print_info,
    fields: {
      [d.Type]: "PrintString"
    }
  });
}
const nI = () => [
  {
    label: f.Unselected,
    type: "",
    id: ""
  }
], gN = {
  debugAvailable: !1,
  locKey: _e.RegisteredAsset,
  geId: 0,
  init() {
    const _ = nI();
    let s = function() {
      return _.map((r) => [Oe(r.label), r.id]);
    };
    this.setStyle("data_blocks"), this.setInputsInline(!0), this.appendDummyInput().appendField(f.RegisteredAsset).appendField(f.AssetType).appendField(new Yn(s), d.AssetType), this.appendValueInput(d.Name).appendField(f.AssetName).setAlign(X.ALIGN_RIGHT).setCheck("String").connection.setShadowState(xe("String")), this.setOutput(!0, "any");
  },
  updateShape_() {
  },
  DetermineTypes() {
    var a;
    let _ = this.getFieldValue(d.AssetType), s = this.outputConnection.getCheck()[0], i = (a = nI().find((p) => p.id === _)) == null ? void 0 : a.type;
    return i && i != s ? (this.setOutput(!0, i), !0) : !1;
  },
  search(_, s) {
    return ["asset", f.RegisteredAsset].find((r) => z.containsKey(r, _)) || !1;
  }
};
function fN(_) {
  g.Blocks[M.pick_registeredAsset] = gN, _.set("PickRegisteredAsset", {
    kind: "block",
    type: M.pick_registeredAsset,
    fields: {
      [d.AssetType]: ""
    }
  });
}
const NN = {
  geId: M.animation_state,
  init() {
    this.appendDummyInput().appendField(f.AnimationState, d.Label).appendField(
      new zt({
        type: "GFileType",
        subinfo: "ac",
        defaultLabel: f.AnimationController
      }),
      d.Hud
    ).appendField(new bN(), d.Entity), this.setOutput(!0, "String"), this.setStyle("data_blocks");
  },
  setShadow(_) {
    g.BlockSvg.prototype.setShadow.call(this, _), _ && this.inputList[0].removeField(d.Label, !0);
  },
  DetermineTypes() {
    return this.getField(d.Entity).UpdateDisplay(), !1;
  }
};
class bN extends Yn {
  constructor(s, r) {
    super([[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]], s, r), this.menuGenerator_ = () => [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]];
  }
}
function CN(_) {
  g.Blocks[M.animation_state] = NN, _.set("AnimationState", { kind: "block", type: M.animation_state });
}
function ON() {
  let _ = /* @__PURE__ */ new Map();
  return F1(_), am(_), rf(_), Bm(_), c1(_), g1(_), y1(_), Fg(_), Rm(_), Yg(_), jg(_), uf(), rm(), If(_), Rg(), mf(), Jf(_), TN(_), uN(), PN(_), LN(_), fN(_), CN(_), _;
}
const RN = `//Basic Type Redirection\r
setup bool = Bool\r
setup int = Int\r
setup float = Float\r
setup number = Number\r
setup string = String\r
setup entity = Component\r
setup array = List\r
setup listGeneric = ListT\r
setup type = Type\r
setup global = Global\r
\r
type any         #%(T_36_WZY_WS_ANYTYPE)\r
type null        #%(T_NULL)\r
\r
\r
@ApiLevel=4\r
@ScriptName=Object\r
@Tip = %(T_49_META_TYPE_0_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Object  = 0 { #%(T_46_META_WS_C_OBJECT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Type\r
@Tip = %(T_49_META_TYPE_1027_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Type : Object = 1027 { #%(T_46_META_WS_C_TYPE)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_49_META_TYPE_240_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type entity : Object = 240 { #%(T_46_META_WS_ENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Property\r
@Tip = %(T_49_META_TYPE_180_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Property : Object = 180 { #%(T_46_META_WS_C_PROPERTY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EventID\r
@Tip = %(T_49_META_TYPE_358_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type EventID : Object = 358 { #%(T_46_META_WS_C_EVENTID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TypeEnum\r
@Tip = %(T_49_META_TYPE_98_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@genTypeEnum base = Object\r
enum TypeEnum : Type = 98 { #%(T_46_META_WS_C_TYPEENUM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Bool\r
@Tip = %(T_49_META_TYPE_2_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type Bool : Object = 2 { #%(T_46_META_WS_C_BOOL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Int\r
@Tip = %(T_49_META_TYPE_3_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type Int : Object = 3 { #%(T_46_META_WS_C_INT)\r
}\r
\r
@Accept Int\r
@ApiLevel=4\r
@ScriptName=Float\r
@Tip = %(T_49_META_TYPE_4_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type Float : Object = 4 { #%(T_46_META_WS_C_FLOAT)\r
}\r
\r
@Accept Int\r
@ApiLevel=4\r
@ScriptName=Int64\r
@Tip = %(T_49_META_TYPE_108_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type Int64 : Object = 108 { #%(T_46_META_WS_C_INT64)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Number\r
@Tip = %(T_49_META_TYPE_7_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias Number : Object&(Int|Int64|Float) = 7 #%(T_46_META_WS_C_NUMBER)\r
\r
@ApiLevel=3\r
@ScriptName=BigFloat\r
@Tip = %(T_49_META_TYPE_69_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type BigFloat : Object = 69 { #%(T_36_WZY_WS_BIGFLOAT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=String\r
@Tip = %(T_49_META_TYPE_5_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type String : Object = 5 { #%(T_46_META_WS_C_STRING)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Color\r
@Tip = %(T_49_META_TYPE_87_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Color : Object = 87 { #%(T_44_XXJ_WS_COLOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UUID\r
@Tip = %(T_49_META_TYPE_261_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type UUID : Object = 261 { #%(T_46_META_WS_C_UUID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AssetConfigID\r
@Tip = %(T_49_META_TYPE_282_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type AssetConfigID : Int = 282 { #%(T_46_META_WS_C_ASSETCONFIGID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AssetID\r
@Tip = %(T_49_META_TYPE_283_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type AssetID : String = 283 { #%(T_46_META_WS_C_ASSETID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PersonaID\r
@Tip = %(T_49_META_TYPE_423_D)\r
@ModuleID=43\r
@ModuleLib=LLM\r
type PersonaID : AssetID = 423 { #%(T_47_XXJ_WS_PERSONAID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlotID\r
@Tip = %(T_49_META_TYPE_443_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type PlotID : AssetID = 443 { #%(T_48_META_EVT_3141_P1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CollectionID\r
@Tip = %(T_49_META_TYPE_373_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type CollectionID : AssetConfigID = 373 { #%(T_46_META_WS_C_COLLECTIONID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ItemID\r
@Tip = %(T_49_META_TYPE_264_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type ItemID : AssetConfigID = 264 { #%(T_46_META_WS_C_ITEMID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LevelObjectID\r
@Tip = %(T_49_META_TYPE_351_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type LevelObjectID : AssetConfigID = 351 { #%(T_46_META_WS_C_LEVELOBJECTID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WeaponSkinID\r
@Tip = %(T_49_META_TYPE_262_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@NotNull=True\r
type WeaponSkinID : CollectionID = 262 { #%(T_46_META_WS_C_WEAPONSKINID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OutfitID\r
@Tip = %(T_49_META_TYPE_263_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@NotNull=True\r
type ClothID : CollectionID = 263 { #%(T_46_META_WS_C_OUTFITID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BackpackSkinID\r
@Tip = %(T_49_META_TYPE_388_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@NotNull=True\r
type BagSkinID : CollectionID = 388 { #%(T_46_META_WS_C_BACKPACKSKINID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=HumanModelID\r
@Tip = %(T_49_META_TYPE_284_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type HumanModelID : CollectionID = 284 { #%(T_46_META_WS_C_HUMANMODELID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=List\r
@Tip = %(T_49_META_TYPE_1_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type List : Object = 1 { #%(T_46_META_WS_C_LIST)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT\r
@Tip = %(T_49_META_TYPE_19_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
generic ListT : List = 19 { #%(T_46_META_WS_C_LISTT)\r
    T0 : Object\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Map\r
@Tip = %(T_49_META_TYPE_216_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Map : Object = 216 { #%(T_46_META_WS_C_MAP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MapT\r
@Tip = %(T_49_META_TYPE_217_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
generic MapT : Map = 217 { #%(T_46_META_WS_C_MAPT)\r
    T0 : Object\r
    T1 : Object\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListOrMap\r
@Tip = %(T_49_META_TYPE_285_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias ListOrMap : Object&(List|Map) = 285 #%(T_46_META_WS_C_LISTORMAP)\r
\r
@ApiLevel=4\r
@ScriptName=ListT_Type\r
@Tip = %(T_49_META_TYPE_162_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_Type : List = 162 { #%(T_46_META_WS_C_LISTT_TYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TypeOrTypeList\r
@Tip = %(T_49_META_TYPE_163_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias TypeOrListType : Object&(Type|ListT_Type) = 163 #%(T_46_META_WS_C_TYPEORTYPELIST)\r
\r
@Accept Vector3\r
@ApiLevel=4\r
@ScriptName=Vector2\r
@Tip = %(T_49_META_TYPE_159_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type Vector2 : Object = 159 { #%(T_46_META_WS_C_VECTOR2)\r
}\r
\r
@Accept DirectedPoint\r
@ApiLevel=4\r
@ScriptName=Vector3\r
@Tip = %(T_49_META_TYPE_6_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type Vector3 : Object = 6 { #%(T_46_META_WS_C_VECTOR3)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Quaternion\r
@Tip = %(T_49_META_TYPE_151_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type Quaternion : Object = 151 { #%(T_46_META_WS_C_QUATERNION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BezierCurve\r
@Tip = %(T_49_META_TYPE_331_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
type BezierCurve : Object = 331 { #%(T_46_META_WS_C_BEZIERCURVE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Condition\r
@Tip = %(T_49_META_TYPE_8_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias Condition : Bool = 8 #%(T_46_META_WS_C_CONDITION)\r
\r
@ApiLevel=4\r
@ScriptName=ListT_Condition\r
@Tip = %(T_49_META_TYPE_9_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_Condition : List = 9 { #%(T_46_META_WS_C_LISTT_CONDITION)\r
}\r
\r
@Accept Vector3\r
@ApiLevel=10\r
@ScriptName=DirectedPoint_Deprecated\r
@Tip = %(T_49_META_TYPE_18_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type DirectedPoint : Object = 18 { #%(T_36_WZY_WS_DIRPOINT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LocString\r
@Tip = %(T_49_META_TYPE_149_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type LocString : String = 149 { #%(T_46_META_WS_C_LOCKEY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MeshID\r
@Tip = %(T_49_META_TYPE_181_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type MeshID : AssetID = 181 { #%(T_46_META_WS_C_MESHID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayerDataID\r
@Tip = %(T_49_META_TYPE_368_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type PlayerDataID : AssetID = 368 { #%(T_46_META_WS_C_PLAYERDATAID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AnimationClipID\r
@Tip = %(T_49_META_TYPE_369_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type AnimationClipID : AssetID = 369 { #%(T_46_META_WS_C_ANIMATIONCLIPID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MaterialID\r
@Tip = %(T_49_META_TYPE_182_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type MaterialID : AssetID = 182 { #%(T_46_META_WS_C_MATERIALID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ColliderCollectionID\r
@Tip = %(T_49_META_TYPE_202_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ColliderID : AssetID = 202 { #%(T_46_META_WS_C_COLLIDERCOLLECTIONID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TextureID\r
@Tip = %(T_49_META_TYPE_183_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type TextureID : AssetID = 183 { #%(T_46_META_WS_C_TEXTUREID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SpriteID\r
@Tip = %(T_49_META_TYPE_214_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type SpriteID : AssetID = 214 { #%(T_46_META_WS_C_SPRITEID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ScriptID\r
@Tip = %(T_49_META_TYPE_286_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type GraphID : AssetID = 286 { #%(T_46_META_WS_C_SCRIPTID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=StaticScriptID\r
@Tip = %(T_49_META_TYPE_287_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type StaticGraphID : AssetID = 287 { #%(T_46_META_WS_C_STATICSCRIPTID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CustomUIID\r
@Tip = %(T_49_META_TYPE_288_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type CustomHudID : AssetConfigID = 288 { #%(T_46_META_WS_C_CUSTOMUIID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CustomUIWidgetID\r
@Tip = %(T_49_META_TYPE_325_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type CustomHudWidgetID : AssetConfigID = 325 { #%(T_46_META_WS_C_CUSTOMUIWIDGETID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=VehicleSkinID\r
@Tip = %(T_49_META_TYPE_334_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@NotNull=True\r
type VehicleSkinID : CollectionID = 334 { #%(T_46_META_WS_C_VEHICLESKINID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PrefabID\r
@Tip = %(T_49_META_TYPE_289_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type PrefabID : AssetID = 289 { #%(T_46_META_WS_C_PREFABID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CustomUIAssetID\r
@Tip = %(T_50_META_TYP_452_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type CustomHudAssetID : AssetID = 452 { #%(T_50_META_TYP_452)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AudioID\r
@Tip = %(T_49_META_TYPE_378_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type AudioID : AssetID = 378 { #%(T_46_META_WS_C_AUDIOID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CsvID\r
@Tip = %(T_49_META_TYPE_379_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type CsvID : AssetID = 379 { #%(T_46_META_WS_C_CSVID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EffectID\r
@Tip = %(T_49_META_TYPE_380_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type EffectID : AssetID = 380 { #%(T_46_META_WS_C_EFFECTID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BevTreeID\r
@Tip = %(T_49_META_TYPE_328_D)\r
@ModuleID=36\r
@ModuleLib=BehaviourTree\r
type BTreeID : AssetID = 328 { #%(T_46_META_WS_C_BEVTREEID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AnimationControllerID\r
@Tip = %(T_49_META_TYPE_381_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type AnimationCtrlID : AssetID = 381 { #%(T_46_META_WS_C_ANIMATIONCONTROLLERID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ParticlesID\r
@Tip = %(T_49_META_TYPE_425_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ParticlesID : AssetID = 425 { #%(T_47_XXJ_WS_PARTICLESID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayableControllerID\r
@Tip = %(T_49_META_TYP_445)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type PlayableControllerResID : AssetID = 445 { #%(T_49_META_TYP_445)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_Bool\r
@Tip = %(T_49_META_TYPE_45_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_Bool : List = 45 { #%(T_46_META_WS_C_LISTT_BOOL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_Int\r
@Tip = %(T_49_META_TYPE_46_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_Int : List = 46 { #%(T_46_META_WS_C_LISTT_INT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IntOrIntList\r
@Tip = %(T_49_META_TYPE_91_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias IntOrListInt : Object&(Int|ListT_Int) = 91 #%(T_46_META_WS_C_INTORINTLIST)\r
\r
@ApiLevel=4\r
@ScriptName=ListT_Float\r
@Tip = %(T_49_META_TYPE_47_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_Float : List = 47 { #%(T_46_META_WS_C_LISTT_FLOAT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_String\r
@Tip = %(T_49_META_TYPE_48_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_String : List = 48 { #%(T_46_META_WS_C_LISTT_STRING)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_Vector3\r
@Tip = %(T_49_META_TYPE_49_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_Vector3 : List = 49 { #%(T_46_META_WS_C_LISTT_VECTOR3)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_LocKey\r
@Tip = %(T_49_META_TYPE_189_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_LocString : List = 189 { #%(T_46_META_WS_C_LISTT_LOCKEY)\r
}\r
\r
@ApiLevel=3\r
@ScriptName=InternalBuffType\r
@Tip = %(T_49_META_TYPE_303_D)\r
@ModuleID=10011\r
@ModuleLib=Buff\r
enum InternalBuffType : Int = 303 { #%(T_41_XXJ_WS_INTERNALBUFFTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Test_AddPlayerMaxHP\r
	@Tip = %(T_49_META_TYP_303_I0_D)\r
    Test_AddPlayerMaxHP = 262 #%(T_41_XXJ_WS_ADDPLAYERMAXHP)\r
	@ApiLevel=4\r
	@ScriptName=Test_RecoverPlayerHPContinusly\r
	@Tip = %(T_49_META_TYP_303_I1_D)\r
    Test_RecoverPlayerHPContinusly = 285 #%(T_41_XXJ_WS_RECOVERPLAYERHP)\r
}\r
\r
@ApiLevel=3\r
@ScriptName=ListT_BuffType\r
@Tip = %(T_49_META_TYPE_304_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_InternalBuffType : List = 304 { #%(T_41_XXJ_WS_LISTT_INTERNALBUFFTYPE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=PlayerSkillType\r
@Tip = %(T_49_META_TYPE_18_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
enum PlayerSkillType : Int = 223 { #%(T_39_WZY_WS_SKILLTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Gluttony\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    EatFast_lv6 = 706 #%(TXT_OB7_JRW_SKILL_NAME_FOODIEBOY)\r
	@ApiLevel=4\r
	@ScriptName=Dash\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    MoveFast_lv6 = 206 #%(TXT_SKILL_NAME_RUNNER)\r
	@ApiLevel=4\r
	@ScriptName=Camouflage\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Monkey_lv6 = 1206 #%(T_12_R_SKILL_NAME_MONKEYGOD)\r
	@ApiLevel=4\r
	@ScriptName=TimeTurner\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    SpaceShield_lv6 = 3806 #%(T_25_C_SKILL_NAME_BOUNTYHUNTER)\r
	@ApiLevel=4\r
	@ScriptName=SplitBlitz\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    GrenadeSplite_lv6 = 6306 #%(T_39_WH_SKILL_NAME_GRENADESPLIT)\r
	@ApiLevel=4\r
	@ScriptName=Sprint\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    PlayerSprint = 60001 #%(TXT_TUTORIAL_HUD_LABEL10)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=ListT_SkillType\r
@Tip = %(T_49_META_TYPE_224_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_PlayerSkillType : List = 224 { #%(T_39_WZY_WS_SKILLLIST)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SkillID\r
@Tip = %(T_49_META_TYPE_385_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@NotNull=True\r
type PlayerSkillID : Int = 385 { #%(T_46_META_WS_C_SKILLID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_SkillID\r
@Tip = %(T_49_META_TYPE_386_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_PlayerSkillID : List = 386 { #%(T_46_META_WS_C_LISTT_SKILLID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Component\r
@Tip = %(T_49_META_TYPE_164_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Component : Object = 164 { #%(T_46_META_WS_C_COMPONENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Entity\r
@Tip = %(T_49_META_TYPE_10_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Entity : Component = 10 { #%(T_46_META_WS_C_ENTITY)\r
	@ApiLevel=10\r
	@Default=true\r
	@ScriptName=Enable_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Enable : Bool = -10000 #%(T_36_WZY_AVAILAB)\r
	@ApiLevel=4\r
	@ScriptName=Tags\r
	@Tip = %(T_49_META_TYP_10_I1_D)\r
    TagsList : ListT_String = -10001 #%(T_46_META_WS_P_TAGS)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ActiveSelf\r
	@Tip = %(T_49_META_TYP_10_I2_D)\r
    get ActiveSelf : Bool = -10002 #%(T_46_META_WS_P_ACTIVESELF)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ActiveParent\r
	@Tip = %(T_49_META_TYP_10_I3_D)\r
    get ActiveParent : Bool = -10003 #%(T_40_XXJ_WS_ACTIVEPARENT_NAMEKEY)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ActiveInHierarchy\r
	@Tip = %(T_49_META_TYP_10_I4_D)\r
    get ActiveInHierarchy : Bool = -10004 #%(T_46_META_WS_P_ACTIVEINHIERARCHY)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=Enable\r
	@Tip = %(T_49_META_TYP_10_I5_D)\r
    EnableLogic : Bool = -10005 #%(T_38_WZY_WS_ACTIVEB)\r
	@ApiLevel=4\r
	@ScriptName=Name\r
	@Tip = %(T_49_META_TYP_10_I6_D)\r
    EntityName : String = -10006 #%(T_46_META_WS_P_NAME)\r
	@ApiLevel=4\r
	@ScriptName=AOISetting\r
	@Tip = %(T_49_META_TYP_10_I7_D)\r
    get AOISetting : Int = -10007 #%(T_47_XXJ_WS_AOISETTING)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Terrain\r
@Tip = %(T_49_META_TYPE_383_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Terrain : Entity = 383 { #%(T_46_META_WS_C_TERRAIN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Transform\r
@Tip = %(T_49_META_TYPE_97_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Transform : Entity = 97 { #%(T_46_META_WS_C_TRANSFORM)\r
	@ApiLevel=4\r
	@ScriptName=Position\r
	@Tip = %(T_49_META_TYP_97_I0_D)\r
    Position : Vector3 = -97000 #%(T_46_META_WS_P_POSITION)\r
	@ApiLevel=4\r
	@ScriptName=Rotation\r
	@Tip = %(T_49_META_TYP_97_I1_D)\r
    Rotation : Vector3 = -97001 #%(T_46_META_WS_P_ROTATION)\r
	@ApiLevel=4\r
	@Default=math.Vector3_1()\r
	@ScriptName=Scale\r
	@Tip = %(T_49_META_TYP_97_I2_D)\r
    Scale : Vector3 = -97002 #%(T_46_META_WS_P_SCALE)\r
	@ApiLevel=4\r
	@ScriptName=Parent\r
	@Tip = %(T_49_META_TYP_97_I3_D)\r
    Parent : Transform = -97003 #%(T_46_META_WS_P_PARENT)\r
	@ApiLevel=4\r
	@Default=math.Quaternion_Identity()\r
	@ScriptName=RotationQ\r
	@Tip = %(T_49_META_TYP_97_I4_D)\r
    RotationQ : Quaternion = -97004 #%(T_46_META_WS_P_ROTATIONQ)\r
	@ApiLevel=4\r
	@ScriptName=LocalPosition\r
	@Tip = %(T_49_META_TYP_97_I5_D)\r
    LocalPosition : Vector3 = -97005 #%(T_46_META_WS_P_LOCALPOSITION)\r
	@ApiLevel=4\r
	@Default=math.Quaternion_Identity()\r
	@ScriptName=LocalRotationQ\r
	@Tip = %(T_49_META_TYP_97_I6_D)\r
    LocalRotationQ : Quaternion = -97006 #%(T_46_META_WS_P_LOCALROTATIONQ)\r
	@ApiLevel=4\r
	@ScriptName=LocalRotation\r
	@Tip = %(T_49_META_TYP_97_I7_D)\r
    LocalRotation : Vector3 = -97007 #%(T_46_META_WS_P_LOCALROTATION)\r
	@ApiLevel=4\r
	@Default=math.Vector3_1()\r
	@ScriptName=LocalScale\r
	@Tip = %(T_49_META_TYP_97_I8_D)\r
    LocalScale : Vector3 = -97008 #%(T_46_META_WS_P_LOCALSCALE)\r
	@ApiLevel=4\r
	@ScriptName=Up\r
	@Tip = %(T_49_META_TYP_97_I9_D)\r
    Up : Vector3 = -97009 #%(T_46_META_WS_P_UP)\r
	@ApiLevel=4\r
	@ScriptName=Right\r
	@Tip = %(T_49_META_TYP_97_I10_D)\r
    Right : Vector3 = -97010 #%(T_46_META_WS_P_RIGHT)\r
	@ApiLevel=4\r
	@ScriptName=Forward\r
	@Tip = %(T_49_META_TYP_97_I11_D)\r
    Forward : Vector3 = -97011 #%(T_46_META_WS_P_FORWARD)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Visibility\r
@Tip = %(T_49_META_TYPE_170_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Visibility : Entity = 170 { #%(T_46_META_WS_C_VISIBILITY)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_170_I0_D)\r
    Visible : Bool = -170000 #%(T_46_META_WS_P_VISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=VisibilityLayer\r
	@Tip = %(T_49_META_TYP_170_I1_D)\r
    VisibilityLayer : Int = -170001 #%(T_46_META_WS_P_VISIBILITYLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BasicAppearance\r
@Conflict=["MeshRender","SimpleRender"]\r
@Tip = %(T_49_META_TYPE_125_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Appearance : Visibility = 125 { #%(T_46_META_WS_C_BASICAPPEARANCE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=DiffuseColor\r
	@Tip = %(T_49_META_TYP_125_I0_D)\r
    DiffuseColor : Color = -125000 #%(T_46_META_WS_P_DIFFUSECOLOR)\r
	@ApiLevel=10\r
	@Default=0\r
	@ScriptName=RimColor\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    RimColor : Color = -125001 #%(T_46_META_WS_P_RIMCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=DiffuseTexture\r
	@Tip = %(T_49_META_TYP_125_I2_D)\r
    DiffuseTexture : TextureID = -125002 #%(T_46_META_WS_P_DIFFUSETEXTURE)\r
	@ApiLevel=10\r
	@ScriptName=RimTexture\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    RimTexture : TextureID = -125003 #%(T_46_META_WS_P_RIMTEXTURE)\r
	@ApiLevel=4\r
	@ScriptName=DiffuseAlpha\r
	@Tip = %(T_49_META_TYP_125_I4_D)\r
    DiffuseAlpha : Int = -125004 #%(T_46_META_WS_P_DIFFUSEALPHA)\r
	@ApiLevel=10\r
	@ScriptName=RimAlpha\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    RimAlpha : Int = -125005 #%(T_46_META_WS_P_RIMALPHA)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Collider\r
@Addable=["ColliderShape"]\r
@Conflict=["PhysicalCCT"]\r
@Tip = %(T_49_META_TYPE_165_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Collider : Entity = 165 { #%(T_46_META_WS_C_COLLIDER)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=Enable\r
	@Tip = %(T_49_META_TYP_165_I0_D)\r
    Collidable : Bool = -165000 #%(T_46_META_WS_P_ENABLE)\r
	@ApiLevel=3\r
	@Default=false\r
	@ScriptName=IsTrigger\r
	@Tip = %(T_49_META_TYP_165_I1_D)\r
    get IsTrigger : Bool = -165001 #%(T_40_XXJ_WS_ISTRIGGER)\r
	@ApiLevel=4\r
	@ScriptName=PhysicalLayer\r
	@Tip = %(T_49_META_TYP_165_I2_D)\r
    PhysicalLayer : Int = -165002 #%(T_46_META_WS_P_PHYSICALLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RigidbodyType\r
@Tip = %(T_49_META_TYPE_256_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
enum RigidbodyType : Int = 256 { #%(T_46_META_WS_C_RIGIDBODYTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Static\r
	@Tip = %(T_49_META_TYP_256_I0_D)\r
    Static = 1 #%(T_46_META_WS_E_STATIC)\r
	@ApiLevel=4\r
	@ScriptName=Dynamic\r
	@Tip = %(T_49_META_TYP_256_I1_D)\r
    Dynamic = 2 #%(T_46_META_WS_E_DYNAMIC)\r
	@ApiLevel=4\r
	@ScriptName=Kinematic\r
	@Tip = %(T_49_META_TYP_256_I2_D)\r
    Kinematic = 3 #%(T_46_META_WS_E_KINEMATIC)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Rigidbody\r
@Addable=["Collider"]\r
@Conflict=["PhysicalCCT"]\r
@Tip = %(T_49_META_TYPE_257_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
type Rigidbody : Entity = 257 { #%(T_46_META_WS_C_RIGIDBODY)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=Type\r
	@Tip = %(T_49_META_TYP_257_I0_D)\r
    Type : RigidbodyType = -257000 #%(T_46_META_WS_P_TYPE)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=UseGravity\r
	@Tip = %(T_49_META_TYP_257_I1_D)\r
    UseGravity : Bool = -257001 #%(T_46_META_WS_P_USEGRAVITY)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=Mass\r
	@Tip = %(T_49_META_TYP_257_I2_D)\r
    Mass : Float = -257002 #%(T_46_META_WS_P_MASS)\r
	@ApiLevel=4\r
	@Default=math.Vector3_0()\r
	@ScriptName=CenterOfMass\r
	@Tip = %(T_49_META_TYP_257_I3_D)\r
    get CenterOfMass : Vector3 = -257003 #%(T_46_META_WS_P_CENTEROFMASS)\r
	@ApiLevel=4\r
	@Default=math.Vector3_0()\r
	@ScriptName=Velocity\r
	@Tip = %(T_49_META_TYP_257_I4_D)\r
    Velocity : Vector3 = -257004 #%(T_46_META_WS_P_VELOCITY)\r
	@ApiLevel=4\r
	@Default=math.Vector3_0()\r
	@ScriptName=AngularVelocity\r
	@Tip = %(T_49_META_TYP_257_I5_D)\r
    AngularVelocity : Vector3 = -257005 #%(T_46_META_WS_P_ANGULARVELOCITY)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=Drag\r
	@Tip = %(T_49_META_TYP_257_I6_D)\r
    Drag : Float = -257006 #%(T_46_META_WS_P_DRAG)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=AngularDrag\r
	@Tip = %(T_49_META_TYP_257_I7_D)\r
    AngularDrag : Float = -257007 #%(T_46_META_WS_P_ANGULARDRAG)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=Constrain\r
	@Tip = %(T_49_META_TYP_257_I8_D)\r
    Constrain : Int = -257008 #%(T_46_META_WS_P_CONSTRAIN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RigidbodyConstrainType\r
@Tip = %(T_49_META_TYPE_317_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
enum RigidbodyConstrainType : Int = 317 { #%(T_46_META_WS_C_RIGIDBODYCONSTRAINTYPE)\r
	@ApiLevel=4\r
	@ScriptName=None\r
	@Tip = %(T_49_META_TYP_317_I0_D)\r
    None = 0 #%(T_46_META_WS_E_NONE)\r
	@ApiLevel=4\r
	@ScriptName=FreezePositionX\r
	@Tip = %(T_49_META_TYP_317_I1_D)\r
    FreezePositionX = 2 #%(T_46_META_WS_E_FREEZEPOSITIONX)\r
	@ApiLevel=4\r
	@ScriptName=FreezePositionY\r
	@Tip = %(T_49_META_TYP_317_I2_D)\r
    FreezePositionY = 4 #%(T_46_META_WS_E_FREEZEPOSITIONY)\r
	@ApiLevel=4\r
	@ScriptName=FreezePositionZ\r
	@Tip = %(T_49_META_TYP_317_I3_D)\r
    FreezePositionZ = 8 #%(T_46_META_WS_E_FREEZEPOSITIONZ)\r
	@ApiLevel=4\r
	@ScriptName=FreezeRotationX\r
	@Tip = %(T_49_META_TYP_317_I4_D)\r
    FreezeRotationX = 16 #%(T_46_META_WS_E_FREEZEROTATIONX)\r
	@ApiLevel=4\r
	@ScriptName=FreezeRotationY\r
	@Tip = %(T_49_META_TYP_317_I5_D)\r
    FreezeRotationY = 32 #%(T_46_META_WS_E_FREEZEROTATIONY)\r
	@ApiLevel=4\r
	@ScriptName=FreezeRotationZ\r
	@Tip = %(T_49_META_TYP_317_I6_D)\r
    FreezeRotationZ = 64 #%(T_46_META_WS_E_FREEZEROTATIONZ)\r
	@ApiLevel=4\r
	@ScriptName=FreezePosition\r
	@Tip = %(T_49_META_TYP_317_I7_D)\r
    FreezePosition = 14 #%(T_46_META_WS_E_FREEZEPOSITION)\r
	@ApiLevel=4\r
	@ScriptName=FreezeRotation\r
	@Tip = %(T_49_META_TYP_317_I8_D)\r
    FreezeRotation = 112 #%(T_46_META_WS_E_FREEZEROTATION)\r
	@ApiLevel=4\r
	@ScriptName=FreezeAll\r
	@Tip = %(T_49_META_TYP_317_I9_D)\r
    FreezeAll = 126 #%(T_46_META_WS_E_FREEZEALL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ForceType\r
@Tip = %(T_49_META_TYPE_324_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
enum ForceType : Int = 324 { #%(T_46_META_WS_C_FORCETYPE)\r
	@ApiLevel=4\r
	@ScriptName=Force\r
	@Tip = %(T_49_META_TYP_324_I0_D)\r
    Force = 1 #%(T_46_META_WS_E_FORCE)\r
	@ApiLevel=4\r
	@ScriptName=Acceleration\r
	@Tip = %(T_49_META_TYP_324_I1_D)\r
    Acceleration = 2 #%(T_46_META_WS_E_ACCELERATION)\r
	@ApiLevel=4\r
	@ScriptName=Impulse\r
	@Tip = %(T_49_META_TYP_324_I2_D)\r
    Impulse = 3 #%(T_46_META_WS_E_IMPULSE)\r
	@ApiLevel=4\r
	@ScriptName=Velocity\r
	@Tip = %(T_49_META_TYP_324_I3_D)\r
    Velocity = 4 #%(T_46_META_WS_E_VELOCITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CharacterController\r
@Addable=["CustomLevelObject"]\r
@Conflict=["Collider","ColliderShape","Rigidbody"]\r
@Tip = %(T_49_META_TYPE_359_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
type PhysicalCCT : Entity = 359 { #%(T_46_META_WS_C_CHARACTERCONTROLLER)\r
	@ApiLevel=4\r
	@ScriptName=UsePhysicalCCT\r
	@Tip = %(T_49_META_TYP_359_I0_D)\r
    UsePhysicalCCT : Bool = -359000 #%(T_46_META_WS_P_USEPHYSICALCCT)\r
	@ApiLevel=4\r
	@Default=45\r
	@ScriptName=SlopeLimit\r
	@Tip = %(T_49_META_TYP_359_I1_D)\r
    SlopeLimit : Float = -359001 #%(T_46_META_WS_P_SLOPELIMIT)\r
	@ApiLevel=4\r
	@Default=0.3\r
	@ScriptName=StepOffset\r
	@Tip = %(T_49_META_TYP_359_I2_D)\r
    StepOffset : Float = -359002 #%(T_46_META_WS_P_STEPOFFSET)\r
	@ApiLevel=4\r
	@Default=0.08\r
	@ScriptName=SkinWidth\r
	@Tip = %(T_49_META_TYP_359_I3_D)\r
    SkinWidth : Float = -359003 #%(T_46_META_WS_P_SKINWIDTH)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=MinMoveDistance\r
	@Tip = %(T_49_META_TYP_359_I4_D)\r
    MinMoveDistance : Float = -359004 #%(T_46_META_WS_P_MINMOVEDISTANCE)\r
	@ApiLevel=4\r
	@Default=&math.Vector3(0, 0.75, 0)\r
	@ScriptName=CenterOffset\r
	@Tip = %(T_49_META_TYP_359_I5_D)\r
    get CenterOffset : Vector3 = -359005 #%(T_46_META_WS_P_CENTEROFFSET)\r
	@ApiLevel=4\r
	@Default=0.3\r
	@ScriptName=Radius\r
	@Tip = %(T_49_META_TYP_359_I6_D)\r
    Radius : Float = -359006 #%(T_46_META_WS_P_RADIUS)\r
	@ApiLevel=4\r
	@Default=1.34\r
	@ScriptName=Height\r
	@Tip = %(T_49_META_TYP_359_I7_D)\r
    Height : Float = -359007 #%(T_46_META_WS_P_HEIGHT)\r
	@ApiLevel=4\r
	@ScriptName=Velocity\r
	@Tip = %(T_49_META_TYP_359_I8_D)\r
    get Velocity : Vector3 = -359008 #%(T_46_META_WS_P_VELOCITY)\r
	@ApiLevel=10\r
	@Default=10\r
	@ScriptName=MaxSpeed\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    MaxSpeed : Float = -359009 #%(T_46_META_WS_P_MAXSPEED)\r
	@ApiLevel=4\r
	@ScriptName=Gravity\r
	@Tip = %(T_49_META_TYP_359_I10_D)\r
    Gravity : Vector3 = -359010 #%(T_46_META_WS_P_GRAVITY)\r
	@ApiLevel=4\r
	@Default=50\r
	@ScriptName=Mass\r
	@Tip = %(T_49_META_TYP_359_I11_D)\r
    Mass : Float = -359011 #%(T_46_META_WS_P_MASS)\r
	@ApiLevel=4\r
	@ScriptName=IsSliding\r
	@Tip = %(T_49_META_TYP_359_I12_D)\r
    get IsSliding : Bool = -359012 #%(T_46_META_WS_P_ISSLIDING)\r
	@ApiLevel=10\r
	@ScriptName=IsTopColliding\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get IsTopColliding : Bool = -359013 #%(T_46_META_WS_P_ISTOPCOLLIDING)\r
	@ApiLevel=10\r
	@ScriptName=IsSideColliding\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get IsSideColliding : Bool = -359014 #%(T_46_META_WS_P_ISSIDECOLLIDING)\r
	@ApiLevel=10\r
	@ScriptName=IsBottomColliding\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get IsBottomColliding : Bool = -359015 #%(T_46_META_WS_P_ISBOTTOMCOLLIDING)\r
	@ApiLevel=4\r
	@ScriptName=IsServerDriven\r
	@Tip = %(T_49_META_TYP_359_I16_D)\r
    IsServerDriven : Bool = -359016 #%(T_46_META_WS_P_ISSERVERDRIVEN)\r
	@ApiLevel=4\r
	@ScriptName=UseCustomPushForce\r
	@Tip = %(T_49_META_TYP_359_I17_D)\r
    UseCustomPushForce : Bool = -359017 #%(T_46_META_WS_P_USECUSTOMPUSHFORCE)\r
	@ApiLevel=4\r
	@ScriptName=CustomPushForce\r
	@Tip = %(T_49_META_TYP_359_I18_D)\r
    CustomPushForce : Float = -359018 #%(T_46_META_WS_P_CUSTOMPUSHFORCE)\r
	@ApiLevel=4\r
	@ScriptName=IsGrounded\r
	@Tip = %(T_49_META_TYP_359_I19_D)\r
    get IsGrounded : Bool = -359019 #%(T_46_META_WS_P_ISGROUNDED)\r
	@ApiLevel=4\r
	@ScriptName=PhysicalLayer\r
	@Tip = %(T_49_META_TYP_359_I20_D)\r
    get PhysicalLayer : Int = -359020 #%(T_46_META_WS_P_PHYSICALLAYER)\r
	@ApiLevel=4\r
	@ScriptName=EnableRotateWithGravity\r
	@Tip = %(T_49_META_TYP_359_I21_D)\r
    get EnableRotateWithGravity : Bool = -359021 #%(T_46_META_WS_P_ENABLEROTATEWITHGRAVITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayerCCT\r
@Addable=["Player"]\r
@Tip = %(T_49_META_TYPE_399_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
type PlayerCCT : PhysicalCCT = 399 { #%(T_46_META_WS_C_PLAYERCCT)\r
	@ApiLevel=4\r
	@Default=0.8\r
	@ScriptName=JumpHeight\r
	@Tip = %(T_49_META_TYP_399_I0_D)\r
    JumpHeight : Float = -399000 #%(T_46_META_WS_P_JUMPHEIGHT)\r
	@ApiLevel=4\r
	@Default=2\r
	@ScriptName=MaxJumpCount\r
	@Tip = %(T_49_META_TYP_399_I1_D)\r
    MaxJumpCount : Int = -399001 #%(T_46_META_WS_P_MAXJUMPCOUNT)\r
	@ApiLevel=4\r
	@ScriptName=RemainJumpCount\r
	@Tip = %(T_49_META_TYP_399_I2_D)\r
    get RemainJumpCount : Int = -399002 #%(T_46_META_WS_P_REMAINJUMPCOUNT)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=EnableMoveInMidair\r
	@Tip = %(T_49_META_TYP_399_I3_D)\r
    CanMoveInAir : Bool = -399003 #%(T_46_META_WS_P_ENABLEMOVEINMIDAIR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PhysicalMover\r
@Addable=["Rigidbody"]\r
@Tip = %(T_49_META_TYPE_395_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
type PhysicalMover : Entity = 395 { #%(T_46_META_WS_C_PHYSICALMOVER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PhysicalObject\r
@Tip = %(T_49_META_TYPE_393_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
alias PhysicalObject : Entity&(PhysicalCCT|Rigidbody) = 393 #%(T_46_META_WS_C_PHYSICALOBJECT)\r
\r
@ApiLevel=4\r
@ScriptName=EntityOrPrefabID\r
@Tip = %(T_49_META_TYPE_270_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias EntityOrPrefabID : Object&(Entity|PrefabID) = 270 #%(T_46_META_WS_C_ENTITYORPREFABID)\r
\r
@ApiLevel=4\r
@ScriptName=AnimationControllerAttachable\r
@Addable=["CustomLevelObject","AI"]\r
@Tip = %(T_49_META_TYPE_314_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type AnimationControllerAble : Entity = 314 { #%(T_46_META_WS_C_ANIMATIONCONTROLLERATTACHABLE)\r
	@ApiLevel=4\r
	@ScriptName=AnimationControllerResID\r
	@Tip = %(T_49_META_TYP_314_I0_D)\r
    AnimationControllerResUUID : AnimationCtrlID = -314000 #%(T_46_META_WS_P_ANIMATIONCONTROLLERRESID)\r
	@ApiLevel=4\r
	@ScriptName=AnimationController\r
	@Tip = %(T_49_META_TYP_314_I1_D)\r
    get AnimationController : AnimationController = -314001 #%(T_46_META_WS_P_ANIMATIONCONTROLLER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Appearance\r
@Addable=["CustomLevelObject","AI","Player"]\r
@Tip = %(T_49_META_TYPE_327_D)\r
@ModuleID=38\r
@ModuleLib=Avatar\r
type AvatarAble : Entity = 327 { #%(T_46_META_WS_C_APPEARENCE)\r
	@ApiLevel=4\r
	@ScriptName=Resource\r
	@Tip = %(T_49_META_TYP_327_I0_D)\r
    get AvatarResUUID : String = -327000 #%(T_46_META_WS_P_RESOURCE)\r
	@ApiLevel=4\r
	@ScriptName=PartMaskA\r
	@Tip = %(T_49_META_TYP_327_I1_D)\r
    get PartVisableMask1 : Int = -327001 #%(T_46_META_WS_P_PARTMASKA)\r
	@ApiLevel=4\r
	@ScriptName=PartMaskB\r
	@Tip = %(T_49_META_TYP_327_I2_D)\r
    get PartVisableMask2 : Int = -327002 #%(T_46_META_WS_P_PARTMASKA)\r
	@ApiLevel=4\r
	@ScriptName=PartMaskC\r
	@Tip = %(T_49_META_TYP_327_I3_D)\r
    get PartVisableMask3 : Int = -327003 #%(T_46_META_WS_P_PARTMASKA)\r
	@ApiLevel=4\r
	@ScriptName=PartMaskD\r
	@Tip = %(T_49_META_TYP_327_I4_D)\r
    get PartVisableMask4 : Int = -327004 #%(T_46_META_WS_P_PARTMASKA)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BuiltinRender\r
@Conflict=["MeshRender","Appearance"]\r
@Tip = %(T_49_META_TYPE_184_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type SimpleRender : Visibility = 184 { #%(T_46_META_WS_C_BUILTINRENDER)\r
	@ApiLevel=4\r
	@ScriptName=ResourceID\r
	@Tip = %(T_49_META_TYP_184_I0_D)\r
    ResUUID : String = -184000 #%(T_46_META_WS_P_RESOURCEID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BatchCombineRender\r
@Tip = %(T_49_META_TYPE_366_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type BatchCombineRender : Visibility = 366 { #%(T_46_META_WS_C_BATCHCOMBINERENDER)\r
	@ApiLevel=4\r
	@ScriptName=ResourceID\r
	@Tip = %(T_49_META_TYP_366_I0_D)\r
    ResUUID : String = -366000 #%(T_46_META_WS_P_RESOURCEID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CustomRender\r
@Addable=["CustomLevelObject"]\r
@Conflict=["SimpleRender","Appearance"]\r
@Tip = %(T_49_META_TYPE_185_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type MeshRender : Visibility = 185 { #%(T_40_ZQ_WS_COMPONENT_CUSTOMRENDER)\r
	@ApiLevel=4\r
	@ScriptName=MeshID\r
	@Tip = %(T_49_META_TYP_185_I0_D)\r
    MeshID : MeshID = -185000 #%(T_43_YU_WS_MESHID1)\r
	@ApiLevel=4\r
	@ScriptName=MaterialIDList\r
	@Tip = %(T_49_META_TYP_185_I1_D)\r
    Materials : ListT_MaterialID = -185001 #%(T_43_YU_WS_MATERIALS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Aimable\r
@Addable=["LevelObject"]\r
@Tip = %(T_49_META_TYPE_107_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type AimableEntity : Entity = 107 { #%(T_46_META_WS_C_AIMABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AimAssistable\r
@Addable=["AimableEntity"]\r
@Tip = %(T_49_META_TYPE_321_D)\r
@ModuleID=10016\r
@ModuleLib=Combat\r
type AimAssistEntity : AimableEntity = 321 { #%(T_46_META_WS_C_AIMASSISTABLE)\r
	@ApiLevel=4\r
	@Default=25\r
	@ScriptName=AimAssistDistance\r
	@Tip = %(T_49_META_TYP_321_I0_D)\r
    AimAssistDistance : Float = -321000 #%(T_46_META_WS_P_AIMASSISTDISTANCE)\r
	@ApiLevel=4\r
	@Default=&math.Vector3(0, 0, 0)\r
	@ScriptName=AimAssistCenterOffset\r
	@Tip = %(T_49_META_TYP_321_I1_D)\r
    AimAssistCenterOffset : Vector3 = -321001 #%(T_46_META_WS_P_AIMASSISTCENTEROFFSET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Container\r
@Tip = %(T_49_META_TYPE_153_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ItemContainerGenerator : Entity = 153 { #%(T_46_META_WS_C_CONTAINER)\r
}\r
\r
@ApiLevel=11\r
@ScriptName=DescriptiveColor\r
@Tip = %(T_49_META_TYPE_357_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type DescriptiveColor : Entity = 357 { #%(T_45_META_WS_DESCRIPTIVECOLOR)\r
	@ApiLevel=3\r
	@Default=-1\r
	@ScriptName=Surface\r
	@Tip = %(T_49_META_TYP_357_I0_D)\r
    Surface : Color = -357000 #%(T_35_SP_WS_IMAGE03)\r
	@ApiLevel=3\r
	@Default=0\r
	@ScriptName=Border\r
	@Tip = %(T_49_META_TYP_357_I1_D)\r
    Border : Color = -357001 #%(T_35_SP_WS_IMAGE04)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayerBackpack\r
@Tip = %(T_49_META_TYPE_315_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type PlayerBag : Entity = 315 { #%(T_46_META_WS_C_PLAYERBACKPACK)\r
	@ApiLevel=4\r
	@ScriptName=Owner\r
	@Tip = %(T_49_META_TYP_315_I0_D)\r
    get Owner : Player = -315000 #%(T_46_META_WS_P_OWNER)\r
	@ApiLevel=4\r
	@ScriptName=MaxCapacity\r
	@Tip = %(T_49_META_TYP_315_I1_D)\r
    get MaxCapacity : Int = -315001 #%(T_46_META_WS_P_MAXCAPACITY)\r
	@ApiLevel=4\r
	@ScriptName=UsedCapacity\r
	@Tip = %(T_49_META_TYP_315_I2_D)\r
    get CurCapacity : Int = -315002 #%(T_46_META_WS_P_USEDCAPACITY)\r
	@ApiLevel=4\r
	@ScriptName=AllItems\r
	@Tip = %(T_49_META_TYP_315_I3_D)\r
    get AllItemGoodsType : ListT_ItemGoodsIDType = -315003 #%(T_46_META_WS_P_ALLITEMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SkyboxType\r
@Tip = %(T_49_META_TYPE_123_D)\r
@ModuleID=10012\r
@ModuleLib=Scene\r
enum SkyboxEnvBaseType : String = 123 { #%(T_46_META_WS_C_SKYBOXTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Day\r
	@Tip = %(T_49_META_TYP_123_I0_D)\r
    Day = UGC_SKYENV_DAY #%(T_46_META_WS_E_DAY)\r
	@ApiLevel=4\r
	@ScriptName=Night\r
	@Tip = %(T_49_META_TYP_123_I1_D)\r
    Night = UGC_SKYENV_NIGHT #%(T_46_META_WS_E_NIGHT)\r
	@ApiLevel=4\r
	@ScriptName=Dusk\r
	@Tip = %(T_49_META_TYP_123_I2_D)\r
    Eve = UGC_SKYENV_EVE #%(T_46_META_WS_E_DUSK)\r
	@ApiLevel=4\r
	@ScriptName=City\r
	@Tip = %(T_49_META_TYP_123_I3_D)\r
    CityBuilding = UGC_SKYENV_CITY #%(T_46_META_WS_E_CITY)\r
	@ApiLevel=4\r
	@ScriptName=Colorful\r
	@Tip = %(T_49_META_TYP_123_I4_D)\r
    Colorful = UGC_SKYENV_COLORFULSKY #%(T_40_XYL_WS_COLORFULSKY)\r
	@ApiLevel=4\r
	@ScriptName=FrostGalaxy\r
	@Tip = %(T_49_META_TYP_123_I5_D)\r
    SnowSky = UGC_SKYENV_SNOW #%(T_46_META_WS_E_FROST GALAXY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EmoteType\r
@Tip = %(T_49_META_TYPE_166_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
enum EmoteType : AnimationClipID = 166 { #%(T_46_META_WS_C_EMOTETYPE)\r
	@ApiLevel=4\r
	@ScriptName=Ridicule\r
	@Tip = %(T_49_META_TYP_166_I0_D)\r
    Emote1 = 909034005 #%(T_46_META_WS_E_RIDICULE)\r
	@ApiLevel=4\r
	@ScriptName=RidiculeFunny\r
	@Tip = %(T_49_META_TYP_166_I1_D)\r
    Emote2 = 909034007 #%(T_46_META_WS_E_RIDICULEFUNNY)\r
	@ApiLevel=4\r
	@ScriptName=GreatConductor\r
	@Tip = %(T_49_META_TYP_166_I2_D)\r
    Emote3 = 909034004 #%(T_46_META_WS_E_GREATCONDUCTOR)\r
	@ApiLevel=4\r
	@ScriptName=Energetic\r
	@Tip = %(T_49_META_TYP_166_I3_D)\r
    Emote4 = 909000127 #%(T_46_META_WS_E_ENERGETIC)\r
	@ApiLevel=4\r
	@ScriptName=BattleInStyle\r
	@Tip = %(T_49_META_TYP_166_I4_D)\r
    Emote5 = 909000099 #%(T_46_META_WS_E_BATTLEINSTYLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SkyBox\r
@Tip = %(T_49_META_TYPE_122_D)\r
@ModuleID=10012\r
@ModuleLib=Scene\r
type SkyboxEnv : Entity = 122 { #%(T_46_META_WS_C_SKYBOX)\r
	@ApiLevel=4\r
	@Default=UGC_SKYENV_DAY\r
	@ScriptName=SkyBoxResource\r
	@Tip = %(T_49_META_TYP_122_I0_D)\r
    BaseSkyEnvRes : SkyboxEnvBaseType = -122000 #%(T_46_META_WS_P_SKYBOXRESOURCE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=LightColor\r
	@Tip = %(T_49_META_TYP_122_I1_D)\r
    LightColor : Color = -122001 #%(T_46_META_WS_P_LIGHTCOLOR)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=LightIntensity\r
	@Tip = %(T_49_META_TYP_122_I2_D)\r
    LightIntensity : Float = -122002 #%(T_46_META_WS_P_LIGHTINTENSITY)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=Darkness\r
	@Tip = %(T_49_META_TYP_122_I3_D)\r
    Darkness : Float = -122003 #%(T_46_META_WS_P_DARKNESS)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=ShadowStrength\r
	@Tip = %(T_49_META_TYP_122_I4_D)\r
    ShadowStrength : Float = -122004 #%(T_46_META_WS_P_SHADOWSTRENGTH)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=TerrainWetness\r
	@Tip = %(T_49_META_TYP_122_I5_D)\r
    TerrainWetness : Float = -122005 #%(T_46_META_WS_P_TERRAINWETNESS)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=LensFlare\r
	@Tip = %(T_49_META_TYP_122_I6_D)\r
    LensFlare : Float = -122006 #%(T_46_META_WS_P_LENSFLARE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=FogColor\r
	@Tip = %(T_49_META_TYP_122_I7_D)\r
    FogColor : Color = -122007 #%(T_46_META_WS_P_FOGCOLOR)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=AmbientColor\r
	@Tip = %(T_49_META_TYP_122_I8_D)\r
    AmbientColor : Color = -122008 #%(T_46_META_WS_P_AMBIENTCOLOR)\r
	@ApiLevel=10\r
	@Default=false\r
	@ScriptName=NightMode_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    NightMode : Bool = -122009 #%(T_37_WZY_WS_NIGHTMODE)\r
	@ApiLevel=4\r
	@Default=true\r
	@Tip = %(T_49_META_TYP_122_I11_D)\r
    Fog : Bool = -122011 #%(T_47_XXJ_WS_FOG)\r
	@ApiLevel=4\r
	@Default=1\r
	@Tip = %(T_49_META_TYP_122_I12_D)\r
    FogMode : FogModeType = -122012 #%(T_47_XXJ_WS_FOGMODE)\r
	@ApiLevel=4\r
	@Default=0.01\r
	@Tip = %(T_49_META_TYP_122_I13_D)\r
    FogDensity : Float = -122013 #%(T_47_XXJ_WS_FOGDENSITY)\r
	@ApiLevel=4\r
	@Default=50\r
	@Tip = %(T_49_META_TYP_122_I14_D)\r
    FogStartDistance : Float = -122014 #%(T_47_XXJ_WS_FOGSTARTDISTANCE)\r
	@ApiLevel=4\r
	@Default=1000\r
	@Tip = %(T_49_META_TYP_122_I15_D)\r
    FogEndDistance : Float = -122015 #%(T_47_XXJ_WS_FOGENDDISTANCE)\r
	@ApiLevel=3\r
	@Default=false\r
	@Tip = %(T_49_META_TYP_122_I16_D)\r
    EnableUGCFogFeature : Bool = -122016 #%(T_47_XXJ_WS_ENABLEUGCFOGFEATURE)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_122_I17_D)\r
    LightRotate : Quaternion = -122017 #%(T_47_XXJ_WS_LIGHTROTATE)\r
	@ApiLevel=4\r
	@Default=false\r
	@Tip = %(T_49_META_TYP_122_I18_D)\r
    EnableUGCLightRotateFeature : Bool = -122018 #%(T_47_XXJ_WS_ENABLEUGCLIGHTROTATEFEATURE)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_122_I19_D)\r
    CustomMaterial : MaterialID = -122019 #%(T_49_META_TYP_122_I19)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=FogModeType\r
@Tip = %(T_49_META_TYPE_424_D)\r
@ModuleID=10012\r
@ModuleLib=Scene\r
enum FogModeType : Int = 424 { #%(T_47_XXJ_WS_FOGMODETYPE)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_424_I0_D)\r
    Linear = 1 #%(T_47_XXJ_WS_LINEAR)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_424_I1_D)\r
    Exponential = 2 #%(T_47_XXJ_WS_EXPONENTIAL)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_424_I2_D)\r
    ExponentialSquared = 3 #%(T_47_XXJ_WS_EXPONENTIALSQUARED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Global\r
@Tip = %(T_49_META_TYPE_11_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Global : Entity = 11 { #%(T_34_WT_WS_ENTITY_PARAM1)\r
	@ApiLevel=3\r
	@ScriptName=IsInvalid\r
	@Tip = %(T_49_META_TYP_11_I0_D)\r
    get IsInvalidMatch : Bool = -11000 #%(T_34_WT_WS_ENTITY_PARAM2)\r
	@ApiLevel=4\r
	@ScriptName=GameTimeCount\r
	@Tip = %(T_49_META_TYP_11_I1_D)\r
    get GameTimeMs : Int = -11001 #%(T_46_META_WS_P_GAMETIMECOUNT)\r
	@ApiLevel=4\r
	@ScriptName=CurrentRoundIndex\r
	@Tip = %(T_49_META_TYP_11_I2_D)\r
    get CurRoundIndex : Int = -11002 #%(T_46_META_WS_P_CURRENTROUNDINDEX)\r
	@ApiLevel=4\r
	@ScriptName=CurrentPhaseIndex\r
	@Tip = %(T_49_META_TYP_11_I3_D)\r
    get CurPhaseIndex : Int = -11003 #%(T_46_META_WS_P_CURRENTPHASEINDEX)\r
	@ApiLevel=3\r
	@ScriptName=ModeTemplateID\r
	@Tip = %(T_49_META_TYP_11_I4_D)\r
    get ModeTemplateID : Int = -11004 #%(T_34_WT_WS_ENTITY_PARAM6)\r
	@ApiLevel=4\r
	@ScriptName=EnablePlayerRevive\r
	@Tip = %(T_49_META_TYP_11_I5_D)\r
    get HumanCanRevive : Bool = -11005 #%(T_46_META_WS_P_ENABLEPLAYERREVIVE)\r
	@ApiLevel=4\r
	@ScriptName=EnableBotRevive\r
	@Tip = %(T_49_META_TYP_11_I6_D)\r
    get BotCanRevive : Bool = -11006 #%(T_46_META_WS_P_ENABLEBOTREVIVE)\r
	@ApiLevel=4\r
	@ScriptName=ReviveCD\r
	@Tip = %(T_49_META_TYP_11_I7_D)\r
    get ReviveCDTime : Int = -11007 #%(T_46_META_WS_P_REVIVECD)\r
	@ApiLevel=4\r
	@ScriptName=TeamNum\r
	@Tip = %(T_49_META_TYP_11_I8_D)\r
    get TeamNum : Int = -11008 #%(T_46_META_WS_P_TEAMNUM)\r
	@ApiLevel=4\r
	@ScriptName=TeamMemberNum\r
	@Tip = %(T_49_META_TYP_11_I9_D)\r
    get TeamMemberNum : Int = -11009 #%(T_46_META_WS_P_TEAMMEMBERNUM)\r
	@ApiLevel=3\r
	@ScriptName=ResetEquipment\r
	@Tip = %(T_49_META_TYP_11_I10_D)\r
    get ResetEquipment : Bool = -11010 #%(T_34_WT_WS_ENTITY_PARAM12)\r
	@ApiLevel=3\r
	@ScriptName=SafeZoneEnabled\r
	@Tip = %(T_49_META_TYP_11_I11_D)\r
    get SafeZoneEnabled : Bool = -11011 #%(T_34_WT_WS_ENTITY_PARAM13)\r
	@ApiLevel=3\r
	@ScriptName=SafeZoneSize\r
	@Tip = %(T_49_META_TYP_11_I12_D)\r
    get SafeZoneSize : Float = -11012 #%(T_34_WT_WS_ENTITY_PARAM14)\r
	@ApiLevel=3\r
	@ScriptName=SafeZoneStartTime\r
	@Tip = %(T_49_META_TYP_11_I13_D)\r
    get SafeZoneStartTime : Float = -11013 #%(T_34_WT_WS_ENTITY_PARAM15)\r
	@ApiLevel=3\r
	@ScriptName=SafeZoneShrinkTime\r
	@Tip = %(T_49_META_TYP_11_I14_D)\r
    get SafeZoneShrinkTime : Float = -11014 #%(T_34_WT_WS_ENTITY_PARAM16)\r
	@ApiLevel=3\r
	@ScriptName=SafeZoneDamage\r
	@Tip = %(T_49_META_TYP_11_I15_D)\r
    get SafeZoneDamage : Float = -11015 #%(T_34_WT_WS_ENTITY_PARAM17)\r
	@ApiLevel=10\r
	@ScriptName=TargetScore\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get TargetScore : Int = -11016 #%(T_34_WT_WS_ENTITY_PARAM18)\r
	@ApiLevel=10\r
	@ScriptName=KillingScore\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get KillingScore : Int = -11017 #%(T_34_WT_WS_ENTITY_PARAM19)\r
	@ApiLevel=3\r
	@ScriptName=ReviveType\r
	@Tip = %(T_49_META_TYP_11_I18_D)\r
    get ReviveRule : Int = -11018 #%(T_34_WT_WS_ENTITY_PARAM20)\r
	@ApiLevel=10\r
	@ScriptName=PlayerRoundScoreType\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    PlayerRoundRankingRuleScoreType : ListT_Int = -11019 #%(T_34_WT_WS_ENTITY_PARAM21)\r
	@ApiLevel=10\r
	@ScriptName=PlayerRoundSortType\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    PlayerRoundRankingRuleSortType : ListT_Int = -11020 #%(T_34_WT_WS_ENTITY_PARAM22)\r
	@ApiLevel=10\r
	@ScriptName=TeamRoundScoreType\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    TeamRoundRankingRuleScoreType : ListT_Int = -11021 #%(T_34_WT_WS_ENTITY_PARAM23)\r
	@ApiLevel=10\r
	@ScriptName=TeamRoundSortType\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    TeamRoundRankingRuleSortType : ListT_Int = -11022 #%(T_34_WT_WS_ENTITY_PARAM24)\r
	@ApiLevel=10\r
	@ScriptName=MVPScoreType\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    MVPRuleScoreType : ListT_Int = -11023 #%(T_34_WT_WS_ENTITY_PARAM25)\r
	@ApiLevel=10\r
	@ScriptName=MVPScoreWeight\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    MVPRuleScoreWeight : ListT_Int = -11024 #%(T_34_WT_WS_ENTITY_PARAM26)\r
	@ApiLevel=10\r
	@ScriptName=RoundScore\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    RoundRankToScoreMap : ListT_Int = -11025 #%(T_34_WT_WS_ENTITY_PARAM27)\r
	@ApiLevel=10\r
	@ScriptName=ShowScoreTypeResult\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    ScoreTypeToShowResult : ListT_Int = -11026 #%(T_34_WT_WS_ENTITY_PARAM28)\r
	@ApiLevel=4\r
	@ScriptName=TotalRoundCount\r
	@Tip = %(T_49_META_TYP_11_I27_D)\r
    get SumRoundCount : Int = -11027 #%(T_46_META_WS_P_TOTALROUNDCOUNT)\r
	@ApiLevel=10\r
	@ScriptName=TeamScoreType\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    TeamRankAccumulateScoreType : Int = -11028 #%(T_24_V_TRAINING_AIMBOT_GAMESCORE)\r
	@ApiLevel=10\r
	@ScriptName=TeamScoreOrder\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    TeamRankAccumulateScoreOrder : Int = -11029 #%(T_39_XXJ_WS_RANK1)\r
	@ApiLevel=10\r
	@ScriptName=PlayerScoreType\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    PlayerRankAccumulateScoreType : Int = -11030 #%(T_42_ZZ_GUILDWAR_PERSONALSCORE)\r
	@ApiLevel=10\r
	@ScriptName=PlayerScoreOrder\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    PlayerRankAccumulateScoreOrder : Int = -11031 #%(T_39_XXJ_WS_RANK2)\r
	@ApiLevel=3\r
	@ScriptName=EcoCoinRoundBegin\r
	@Tip = %(T_49_META_TYP_11_I32_D)\r
    EcoRoundMoney : Int = -11032 #%(T_36_JH_WS_BASEMONEY)\r
	@ApiLevel=3\r
	@ScriptName=EcoCoinKill\r
	@Tip = %(T_49_META_TYP_11_I33_D)\r
    EcoKillMoney : Int = -11033 #%(T_36_JH_WS_KILLMONEY)\r
	@ApiLevel=3\r
	@ScriptName=EcoCoinWin\r
	@Tip = %(T_49_META_TYP_11_I34_D)\r
    EcoWinMoney : Int = -11034 #%(T_36_JH_WS_WINMONEY)\r
	@ApiLevel=3\r
	@ScriptName=IsShowCoin\r
	@Tip = %(T_49_META_TYP_11_I35_D)\r
    CoinHudShow : Bool = -11035 #%(T_36_JH_WS_COINHUD)\r
	@ApiLevel=4\r
	@ScriptName=SkyboxEnv\r
	@Tip = %(T_49_META_TYP_11_I36_D)\r
    SkyboxEnv : SkyboxEnv = -11036 #%(T_46_META_WS_P_SKYBOXENV)\r
	@ApiLevel=4\r
	@ScriptName=GameFrameCount\r
	@Tip = %(T_49_META_TYP_11_I37_D)\r
    get FrameCount : Int = -11037 #%(T_46_META_WS_P_GAMEFRAMECOUNT)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsMoveable\r
	@Tip = %(T_49_META_TYP_11_I38_D)\r
    get MatchCanMove : Bool = -11038 #%(T_46_META_WS_P_ISMOVEABLE)\r
	@ApiLevel=3\r
	@Default=false\r
	@ScriptName=CustomGameResult\r
	@Tip = %(T_49_META_TYP_11_I39_D)\r
    CustomMatchResult : Bool = -11039 #%(T_46_META_WS_P_CUSTOMGAMERESULT)\r
	@ApiLevel=3\r
	@Default=false\r
	@ScriptName=EnableJoin\r
	@Tip = %(T_49_META_TYP_11_I40_D)\r
    get EnableHalfwayJoin : Bool = -11040 #%(T_39_WZY_WS_ENABLEJOIN)\r
	@ApiLevel=3\r
	@Default=false\r
	@ScriptName=EnableLowFrame\r
	@Tip = %(T_49_META_TYP_11_I41_D)\r
    get EnableEnergySavingMode : Bool = -11041 #%(T_41_XXJ_WS_ENABLEENERGYSAVINGMODE)\r
	@ApiLevel=4\r
	@ScriptName=DeltaTime\r
	@Tip = %(T_49_META_TYP_11_I42_D)\r
    get DeltaTime : Int = -11042 #%(T_46_META_WS_P_DELTATIME)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_11_I43_D)\r
    get FixedDeltaTime : Int = -11043 #%(T_46_META_WS_P_FIXEDDELTATIME)\r
	@ApiLevel=3\r
	@Tip = %(T_50_META_TYP_11_I44_D)\r
    get DistanceVolumes : String = -11044 #%(T_50_META_TYP_11_I44)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Rankable\r
@Tip = %(T_49_META_TYPE_84_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type RankableEntity : Entity = 84 { #%(T_46_META_WS_C_RANKABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Scoreable\r
@Tip = %(T_49_META_TYPE_85_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ScoreableEntity : Entity = 85 { #%(T_46_META_WS_C_SCOREABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Team\r
@Tip = %(T_49_META_TYPE_15_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Team : Entity&ScoreableEntity&RankableEntity = 15 { #%(T_46_META_WS_C_TEAM)\r
	@ApiLevel=4\r
	@ScriptName=IsAced\r
	@Tip = %(T_49_META_TYP_15_I0_D)\r
    get IsACE : Bool = -15000 #%(T_46_META_WS_P_ISACE)\r
	@ApiLevel=4\r
	@ScriptName=AllTeammates\r
	@Tip = %(T_49_META_TYP_15_I1_D)\r
    get AllPlayers : ListT_Player = -15001 #%(T_46_META_WS_P_ALLTEAMMATES)\r
	@ApiLevel=10\r
	@ScriptName=TeamIndex\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get TeamIndex : Int = -15002 #%(T_34_LY_WS_INDEX)\r
	@ApiLevel=4\r
	@ScriptName=AttackableTeams\r
	@Tip = %(T_49_META_TYP_15_I3_D)\r
    get HostileTeams : ListT_Team = -15003 #%(T_46_META_WS_P_HOSTILETEAMS)\r
	@ApiLevel=3\r
	@ScriptName=FriendTeams\r
	@Tip = %(T_49_META_TYP_15_I4_D)\r
    get FriendlyTeams : ListT_Team = -15004 #%(T_37_WZY_FRIDTEAM)\r
	@ApiLevel=4\r
	@ScriptName=TeamSeq\r
	@Tip = %(T_49_META_TYP_15_I5_D)\r
    get TeamSeq : Int = -15005 #%(T_46_META_WS_P_TEAMSEQ)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsShowTeammateName\r
	@Tip = %(T_51_META_TYP_15_I6_D)\r
    IsShowHudName : Bool = -15006 #%(T_51_META_TYP_15_I6)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Combatable\r
@Tip = %(T_49_META_TYPE_12_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type FightingEntity : AimableEntity = 12 { #%(T_46_META_WS_C_COMBATABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Buffable\r
@Tip = %(T_49_META_TYPE_306_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type BuffableEntity : Entity = 306 { #%(T_46_META_WS_C_BUFFABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Spawn\r
@Tip = %(T_49_META_TYPE_77_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type SpawnableEntity : Entity = 77 { #%(T_46_META_WS_C_SPAWN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Spawnable\r
@Tip = %(T_49_META_TYPE_78_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type InstanceEntity : Entity = 78 { #%(T_46_META_WS_C_SPAWNABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayerStateType\r
@Tip = %(T_49_META_TYPE_32_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
enum PlayerStateType : Int = 32 { #%(T_46_META_WS_C_PLAYERSTATETYPE)\r
	@ApiLevel=4\r
	@ScriptName=Alive\r
	@Tip = %(T_49_META_TYP_32_I0_D)\r
    Alive = 1 #%(T_46_META_WS_E_ALIVE)\r
	@ApiLevel=4\r
	@ScriptName=KnockedDown\r
	@Tip = %(T_49_META_TYP_32_I1_D)\r
    KnockDown = 2 #%(T_46_META_WS_E_KNOCKEDDOWN)\r
	@ApiLevel=4\r
	@ScriptName=Dead\r
	@Tip = %(T_49_META_TYP_32_I2_D)\r
    Dead = 3 #%(T_46_META_WS_E_DEAD)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayerPoseType\r
@Tip = %(T_49_META_TYPE_372_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
enum PlayerPhysXPoseType : Int = 372 { #%(T_46_META_WS_C_PLAYERPOSETYPE)\r
	@ApiLevel=4\r
	@ScriptName=Standing\r
	@Tip = %(T_49_META_TYP_372_I0_D)\r
    EPHYSXPOSE_STANDING = 0 #%(T_46_META_WS_E_STANDING)\r
	@ApiLevel=4\r
	@ScriptName=Crouching\r
	@Tip = %(T_49_META_TYP_372_I1_D)\r
    EPHYSXPOSE_CROUCHING = 1 #%(T_46_META_WS_E_CROUCHING)\r
	@ApiLevel=4\r
	@ScriptName=Sprint\r
	@Tip = %(T_49_META_TYP_372_I2_D)\r
    EPHYSXPOSE_DASHING = 2 #%(T_46_META_WS_E_SPRINT)\r
	@ApiLevel=4\r
	@ScriptName=Prone\r
	@Tip = %(T_49_META_TYP_372_I3_D)\r
    EPHYSXPOSE_CREEPING = 3 #%(T_46_META_WS_E_PRONE)\r
	@ApiLevel=3\r
	@ScriptName=Swimdash\r
	@Tip = %(T_49_META_TYP_372_I4_D)\r
    EPHYSXPOSE_SWIMDASH = 4 #EPHYSXPOSE_SWIMDASH\r
	@ApiLevel=3\r
	@ScriptName=Skydiving\r
	@Tip = %(T_49_META_TYP_372_I5_D)\r
    EPHYSXPOSE_SKYDIVING = 5 #EPHYSXPOSE_SKYDIVING\r
	@ApiLevel=3\r
	@ScriptName=Crossover\r
	@Tip = %(T_49_META_TYP_372_I6_D)\r
    EPHYSXPOSE_CROSSOVER = 6 #EPHYSXPOSE_CROSSOVER\r
	@ApiLevel=3\r
	@ScriptName=Climbover\r
	@Tip = %(T_49_META_TYP_372_I7_D)\r
    EPHYSXPOSE_CLIMBOVER = 7 #EPHYSXPOSE_CLIMBOVER\r
	@ApiLevel=3\r
	@ScriptName=Knockdown\r
	@Tip = %(T_49_META_TYP_372_I8_D)\r
    EPHYSXPOSE_KNOCKDOWN = 8 #EPHYSXPOSE_KNOCKDOWN\r
	@ApiLevel=3\r
	@ScriptName=Swimsurfing\r
	@Tip = %(T_49_META_TYP_372_I9_D)\r
    EPHYSXPOSE_SWIMSURFING = 9 #EPHYSXPOSE_SWIMSURFING\r
	@ApiLevel=3\r
	@ScriptName=Highfalling\r
	@Tip = %(T_49_META_TYP_372_I10_D)\r
    EPHYSXPOSE_HIGHFALLING = 10 #EPHYSXPOSE_HIGHFALLING\r
	@ApiLevel=4\r
	@ScriptName=LowFalling\r
	@Tip = %(T_49_META_TYP_372_I11_D)\r
    EPHYSXPOSE_LOWFALLING = 11 #%(T_46_META_WS_E_LOWFALLING)\r
	@ApiLevel=3\r
	@ScriptName=Jetflyrush\r
	@Tip = %(T_49_META_TYP_372_I12_D)\r
    EPHYSXPOSE_JETFLYRUSH = 12 #EPHYSXPOSE_JETFLYRUSH\r
	@ApiLevel=3\r
	@ScriptName=Secondfalling\r
	@Tip = %(T_49_META_TYP_372_I13_D)\r
    EPHYSXPOSE_SECONDFALLING = 13 #EPHYSXPOSE_SECONDFALLING\r
	@ApiLevel=3\r
	@ScriptName=Sitting\r
	@Tip = %(T_49_META_TYP_372_I14_D)\r
    EPHYSXPOSE_SITTING = 14 #EPHYSXPOSE_SITTING\r
	@ApiLevel=3\r
	@ScriptName=Catapultfalling\r
	@Tip = %(T_49_META_TYP_372_I15_D)\r
    EPHYSXPOSE_CATAPULTFALLING = 15 #EPHYSXPOSE_CATAPULTFALLING\r
	@ApiLevel=3\r
	@ScriptName=Catapultstanding\r
	@Tip = %(T_49_META_TYP_372_I16_D)\r
    EPHYSXPOSE_CATAPULTSTANDING = 16 #EPHYSXPOSE_CATAPULTSTANDING\r
	@ApiLevel=3\r
	@ScriptName=Gliding\r
	@Tip = %(T_49_META_TYP_372_I17_D)\r
    EPHYSXPOSE_GLIDING = 17 #EPHYSXPOSE_GLIDING\r
	@ApiLevel=3\r
	@ScriptName=Glidefalling\r
	@Tip = %(T_49_META_TYP_372_I18_D)\r
    EPHYSXPOSE_GLIDEFALLING = 18 #EPHYSXPOSE_GLIDEFALLING\r
	@ApiLevel=3\r
	@ScriptName=Fountainfalling\r
	@Tip = %(T_49_META_TYP_372_I19_D)\r
    EPHYSXPOSE_FOUNTAINFALLING = 19 #EPHYSXPOSE_FOUNTAINFALLING\r
	@ApiLevel=3\r
	@ScriptName=Humantirefalling\r
	@Tip = %(T_49_META_TYP_372_I20_D)\r
    EPHYSXPOSE_HUMANTIREFALLING = 20 #EPHYSXPOSE_HUMANTIREFALLING\r
	@ApiLevel=3\r
	@ScriptName=Partydance\r
	@Tip = %(T_49_META_TYP_372_I21_D)\r
    EPHYSXPOSE_PARTYDANCE = 21 #EPHYSXPOSE_PARTYDANCE\r
	@ApiLevel=3\r
	@ScriptName=Flightroamrush\r
	@Tip = %(T_49_META_TYP_372_I22_D)\r
    EPHYSXPOSE_FLIGHTROAMRUSH = 22 #EPHYSXPOSE_FLIGHTROAMRUSH\r
	@ApiLevel=3\r
	@ScriptName=Cannonstanding\r
	@Tip = %(T_49_META_TYP_372_I23_D)\r
    EPHYSXPOSE_CANNONSTANDING = 23 #EPHYSXPOSE_CANNONSTANDING\r
	@ApiLevel=3\r
	@ScriptName=Platform_Falling\r
	@Tip = %(T_49_META_TYP_372_I24_D)\r
    EPHYSXPOSE_PLATFORM_FALLING = 24 #EPHYSXPOSE_PLATFORM_FALLING\r
	@ApiLevel=3\r
	@ScriptName=Jumppadfalling\r
	@Tip = %(T_49_META_TYP_372_I25_D)\r
    EPHYSXPOSE_JUMPPADFALLING = 25 #EPHYSXPOSE_JUMPPADFALLING\r
	@ApiLevel=3\r
	@ScriptName=Stropfalling\r
	@Tip = %(T_49_META_TYP_372_I26_D)\r
    EPHYSXPOSE_STROPFALLING = 26 #EPHYSXPOSE_STROPFALLING\r
	@ApiLevel=3\r
	@ScriptName=Count\r
	@Tip = %(T_49_META_TYP_372_I27_D)\r
    EPHYSXPOSE_COUNT = 27 #EPHYSXPOSE_COUNT\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Resettable\r
@Tip = %(T_49_META_TYPE_28_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ResetableEntity : Entity = 28 { #%(T_46_META_WS_C_RESETABLE)\r
	@ApiLevel=4\r
	@ScriptName=ResetPerRound\r
	@Tip = %(T_49_META_TYP_28_I0_D)\r
    ResetPerRound : Bool = -28000 #%(T_46_META_WS_P_RESETPERROUND)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GenderType\r
@Tip = %(T_49_META_TYPE_272_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
enum GenderType : Int = 272 { #%(T_46_META_WS_C_GENDERTYPE)\r
	@ApiLevel=4\r
	@ScriptName=FeMale\r
	@Tip = %(T_49_META_TYP_272_I0_D)\r
    FeMale = 1 #%(T_46_META_WS_E_FEMALE)\r
	@ApiLevel=4\r
	@ScriptName=Male\r
	@Tip = %(T_49_META_TYP_272_I1_D)\r
    Male = 2 #%(T_46_META_WS_E_MALE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayerOutfit\r
@Tip = %(T_49_META_TYPE_269_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
type PlayerAvatarInfo : Entity = 269 { #%(T_46_META_WS_C_PLAYEROUTFIT)\r
	@ApiLevel=4\r
	@ScriptName=Owner\r
	@Tip = %(T_49_META_TYP_269_I0_D)\r
    get Owner : Player = -269000 #%(T_46_META_WS_P_OWNER)\r
	@ApiLevel=4\r
	@ScriptName=Set\r
	@Tip = %(T_49_META_TYP_269_I1_D)\r
    get CustomClothSetID : ClothID = -269001 #%(T_46_META_WS_P_SET)\r
	@ApiLevel=4\r
	@ScriptName=Head\r
	@Tip = %(T_49_META_TYP_269_I2_D)\r
    get CustomClothHairID : ClothID = -269002 #%(T_46_META_WS_P_HEAD)\r
	@ApiLevel=4\r
	@ScriptName=Mask\r
	@Tip = %(T_49_META_TYP_269_I3_D)\r
    get CustomClothHeadAdditiveID : ClothID = -269003 #%(T_46_META_WS_P_MASK)\r
	@ApiLevel=4\r
	@ScriptName=Facepaint\r
	@Tip = %(T_49_META_TYP_269_I4_D)\r
    get CustomClothFaceID : ClothID = -269004 #%(T_46_META_WS_P_FACEPAINT)\r
	@ApiLevel=4\r
	@ScriptName=Top\r
	@Tip = %(T_49_META_TYP_269_I5_D)\r
    get CustomClothChestID : ClothID = -269005 #%(T_46_META_WS_P_TOP)\r
	@ApiLevel=4\r
	@ScriptName=Bottom\r
	@Tip = %(T_49_META_TYP_269_I6_D)\r
    get CustomClothLegsID : ClothID = -269006 #%(T_46_META_WS_P_BUTTOM)\r
	@ApiLevel=4\r
	@ScriptName=Shoes\r
	@Tip = %(T_49_META_TYP_269_I7_D)\r
    get CustomClothFeetID : ClothID = -269007 #%(T_46_META_WS_P_SHOES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TransformClothInfo\r
@Tip = %(T_49_META_TYPE_428_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
type TransformClothInfo : Entity = 428 { #%(T_48_META_TYP_428)\r
	@ApiLevel=3\r
	@ScriptName=CurWeaponSkinID\r
	@Tip = %(T_49_META_TYP_428_I0_D)\r
    get CurWeaponSkinID : WeaponSkinID = -428000 #%(T_46_META_WS_P_WEAPONSKINIDS)\r
	@ApiLevel=3\r
	@ScriptName=BackpackSkinID\r
	@Tip = %(T_49_META_TYPE_388_D)\r
    get BagSkinID : Int = -428001 #%(T_46_META_WS_P_BACKPACKSKINID)\r
	@ApiLevel=3\r
	@ScriptName=Set\r
	@Tip = %(T_49_META_TYP_428_I2_D)\r
    get CustomClothSetID : ClothID = -428002 #%(T_46_META_WS_P_SET)\r
	@ApiLevel=3\r
	@ScriptName=Head\r
	@Tip = %(T_49_META_TYP_428_I3_D)\r
    get CustomClothHairID : ClothID = -428003 #%(T_46_META_WS_P_HEAD)\r
	@ApiLevel=3\r
	@ScriptName=Mask\r
	@Tip = %(T_49_META_TYP_428_I4_D)\r
    get CustomClothHeadAdditiveID : ClothID = -428004 #%(T_46_META_WS_P_MASK)\r
	@ApiLevel=3\r
	@ScriptName=Facepaint\r
	@Tip = %(T_49_META_TYP_428_I5_D)\r
    get CustomClothFaceID : ClothID = -428005 #%(T_46_META_WS_P_FACEPAINT)\r
	@ApiLevel=3\r
	@ScriptName=Top\r
	@Tip = %(T_49_META_TYP_428_I6_D)\r
    get CustomClothChestID : ClothID = -428006 #%(T_46_META_WS_P_TOP)\r
	@ApiLevel=3\r
	@ScriptName=Bottom\r
	@Tip = %(T_49_META_TYP_428_I7_D)\r
    get CustomClothLegsID : ClothID = -428007 #%(T_46_META_WS_P_BUTTOM)\r
	@ApiLevel=3\r
	@ScriptName=Shoes\r
	@Tip = %(T_49_META_TYP_428_I8_D)\r
    get CustomClothFeetID : ClothID = -428008 #%(T_46_META_WS_P_SHOES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ProfilePictureWidget\r
@Tip = %(T_49_META_TYPE_326_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
type ProfileInfo : Entity = 326 { #%(T_46_META_WS_C_PROFILEPICTUREWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=AccountID\r
	@Tip = %(T_49_META_TYP_326_I0_D)\r
    get AccountID : UUID = -326000 #%(T_46_META_WS_P_ACCOUNTID)\r
	@ApiLevel=4\r
	@ScriptName=AvatarID\r
	@Tip = %(T_49_META_TYP_326_I1_D)\r
    get HeadID : String = -326001 #%(T_46_META_WS_P_AVATARID)\r
	@ApiLevel=4\r
	@ScriptName=BannerID\r
	@Tip = %(T_49_META_TYP_326_I2_D)\r
    get BannerID : String = -326002 #%(T_46_META_WS_P_BANNERID)\r
	@ApiLevel=4\r
	@ScriptName=PinID\r
	@Tip = %(T_49_META_TYP_326_I3_D)\r
    get PinID : String = -326003 #%(T_46_META_WS_P_PINID)\r
	@ApiLevel=4\r
	@ScriptName=NickName\r
	@Tip = %(T_49_META_TYP_326_I4_D)\r
    get NickName : String = -326004 #%(T_46_META_WS_P_NICKNAME)\r
	@ApiLevel=4\r
	@ScriptName=BRRank\r
	@Tip = %(T_49_META_TYP_326_I5_D)\r
    get BRRank : Int = -326005 #%(T_46_META_WS_P_BRRANK)\r
	@ApiLevel=4\r
	@ScriptName=HighestBRrank\r
	@Tip = %(T_49_META_TYP_326_I6_D)\r
    get BRPeakRank : Int = -326006 #%(T_46_META_WS_P_HIGHESTBRRANK)\r
	@ApiLevel=4\r
	@ScriptName=CSRank\r
	@Tip = %(T_49_META_TYP_326_I7_D)\r
    get CSRank : Int = -326007 #%(T_46_META_WS_P_CSRANK)\r
	@ApiLevel=4\r
	@ScriptName=HighestCSrank\r
	@Tip = %(T_49_META_TYP_326_I8_D)\r
    get CSPeakRank : Int = -326008 #%(T_46_META_WS_P_HIGHESTCSRANK)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Formulable\r
@Tip = %(T_49_META_TYPE_93_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type FormulableEntity : Entity = 93 { #%(T_46_META_WS_C_FORMULABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Player\r
@Tip = %(T_49_META_TYPE_14_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Player : FightingEntity&ScoreableEntity&RankableEntity&Visibility&BuffableEntity&FormulableEntity&AnimationControllerAble = 14 { #%(T_46_META_WS_C_PLAYER)\r
	@ApiLevel=4\r
	@ScriptName=HP\r
	@Tip = %(T_49_META_TYP_14_I0_D)\r
    HP : Int = -14000 #%(T_46_META_WS_P_HP)\r
	@ApiLevel=4\r
	@ScriptName=MaxHP\r
	@Tip = %(T_49_META_TYP_14_I1_D)\r
    HPMAX : Int = -14001 #%(T_46_META_WS_P_MAXHP)\r
	@ApiLevel=4\r
	@ScriptName=IsMonster\r
	@Tip = %(T_49_META_TYP_14_I2_D)\r
    get IsAI : Bool = -14002 #%(T_46_META_WS_P_ISAI)\r
	@ApiLevel=4\r
	@ScriptName=PlayerStatus\r
	@Tip = %(T_49_META_TYP_14_I3_D)\r
    get State : PlayerStateType = -14003 #%(T_46_META_WS_P_PLAYERSTATUS)\r
	@ApiLevel=4\r
	@ScriptName=LastSurvivalTime\r
	@Tip = %(T_49_META_TYP_14_I4_D)\r
    get LastSurvivalTime : Int = -14004 #%(T_46_META_WS_P_LASTSURVIVALTIME)\r
	@ApiLevel=4\r
	@ScriptName=Invincible\r
	@Tip = %(T_49_META_TYP_14_I5_D)\r
    GodState : Bool = -14005 #%(T_46_META_WS_P_INVINCIBLE)\r
	@ApiLevel=4\r
	@ScriptName=HostTeam\r
	@Tip = %(T_49_META_TYP_14_I6_D)\r
    get HostTeamEntity : Team = -14006 #%(T_46_META_WS_P_HOSTTEAM)\r
	@ApiLevel=4\r
	@ScriptName=LastCheckPointID\r
	@Tip = %(T_49_META_TYP_14_I7_D)\r
    LastCheckPointID : Int = -14007 #%(T_46_META_WS_P_LASTCHECKPOINTID)\r
	@ApiLevel=4\r
	@ScriptName=TargetCheckpointID\r
	@Tip = %(T_49_META_TYP_14_I8_D)\r
    NextCheckPointID : Int = -14008 #%(T_46_META_WS_P_TARGETCHECKPOINTID)\r
	@ApiLevel=10\r
	@ScriptName=BornPosition_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get BornPosition : DirectedPoint = -14009 #%(T_34_WT_WS_PLAYERENTITY_PARAM9)\r
	@ApiLevel=10\r
	@ScriptName=RevivePosition_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    RevivePosition : DirectedPoint = -14010 #%(T_34_WT_WS_PLAYERENTITY_PARAM10)\r
	@ApiLevel=3\r
	@ScriptName=Faction_ForInfection\r
	@Tip = %(T_49_META_TYP_14_I11_D)\r
    Faction : Int = -14011 #%(T_40_XXJ_WS_FACINFECTION)\r
	@ApiLevel=4\r
	@ScriptName=WeaponDamageRate\r
	@Tip = %(T_49_META_TYP_14_I12_D)\r
    UGCWeaponDamageRate : Float = -14012 #%(T_46_META_WS_P_WEAPONDAMAGERATE)\r
	@ApiLevel=3\r
	@ScriptName=HumanModel\r
	@Tip = %(T_49_META_TYP_14_I13_D)\r
    HumanModel : HumanModelID = -14013 #%(T_34_WT_WS_PLAYERENTITY_PARAM13)\r
	@ApiLevel=4\r
	@ScriptName=RunSpeedScale\r
	@Tip = %(T_49_META_TYP_14_I14_D)\r
    RunSpeedScale : Float = -14014 #%(T_46_META_WS_P_RUNSPEEDSCALE)\r
	@ApiLevel=4\r
	@ScriptName=JumpHeightScale\r
	@Tip = %(T_49_META_TYP_14_I15_D)\r
    JumpHeightScale : Float = -14015 #%(T_46_META_WS_P_JUMPHEIGHTSCALE)\r
	@ApiLevel=3\r
	@ScriptName=Identity_ForInfection\r
	@Tip = %(T_49_META_TYP_14_I16_D)\r
    Identity : Int = -14016 #%(T_34_WT_WS_PLAYERENTITY_PARAM17)\r
	@ApiLevel=3\r
	@ScriptName=MonsterLevel\r
	@Tip = %(T_49_META_TYP_14_I17_D)\r
    ZombieLevel : Int = -14017 #%(T_43_XXJ_WS_LEVEL_D1)\r
	@ApiLevel=10\r
	@ScriptName=DirectPosition_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get DirectPosition : DirectedPoint = -14018 #%(T_36_WZY_WS_DIRPOINT)\r
	@ApiLevel=4\r
	@ScriptName=NickName\r
	@Tip = %(T_49_META_TYP_14_I19_D)\r
    get NickName : String = -14019 #%(T_46_META_WS_P_NICKNAME)\r
	@ApiLevel=4\r
	@ScriptName=DamageTakenPercent\r
	@Tip = %(T_49_META_TYP_14_I20_D)\r
    InjuredScale : Float = -14020 #%(T_46_META_WS_P_DAMAGETAKENPCT)\r
	@ApiLevel=4\r
	@ScriptName=EP\r
	@Tip = %(T_49_META_TYP_14_I21_D)\r
    EP : Int = -14021 #%(T_46_META_WS_P_EP)\r
	@ApiLevel=4\r
	@ScriptName=EPMAX\r
	@Tip = %(T_49_META_TYP_14_I22_D)\r
    EPMAX : Int = -14022 #%(T_46_META_WS_P_EPMAX)\r
	@ApiLevel=4\r
	@ScriptName=MainWeapon\r
	@Tip = %(T_49_META_TYP_14_I23_D)\r
    get WeaponInHand : Weapon = -14023 #%(T_46_META_WS_P_MAINWEAPON)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsDropOnEliminated\r
	@Tip = %(T_49_META_TYP_14_I24_D)\r
    RemoveAllEquipmentOnDeath : Bool = -14024 #%(T_46_META_WS_P_ISDROPONELIMINATED)\r
	@ApiLevel=10\r
	@Default=false\r
	@ScriptName=SkipKnockdown\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    SkipKnockdown : Bool = -14025 #%(T_36_WZY_WS_SKIPKNODOWN)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=AimAssistType\r
	@Tip = %(T_49_META_TYP_14_I26_D)\r
    AimAssistType : AimAssistType = -14026 #%(T_46_META_WS_P_AIMASSISTTYPE)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=AllowLockByAimAssist\r
	@Tip = %(T_49_META_TYP_14_I27_D)\r
    CanBeLockedByAimAssist : Bool = -14027 #%(T_46_META_WS_P_ALLOWLOCKBYAIMASSIST)\r
	@ApiLevel=4\r
	@ScriptName=MuteVoiceChat\r
	@Tip = %(T_49_META_TYP_14_I28_D)\r
    get MuteVoice : Bool = -14028 #%(T_46_META_WS_P_DISABLEVOICECHAT)\r
	@ApiLevel=4\r
	@ScriptName=MuteQuickChat\r
	@Tip = %(T_49_META_TYP_14_I29_D)\r
    get MuteQuickChat : Bool = -14029 #%(T_46_META_WS_P_DISABLEQUICKCHAT)\r
	@ApiLevel=4\r
	@ScriptName=ChatChannel\r
	@Tip = %(T_49_META_TYP_14_I30_D)\r
    get ChatChannel : ChatChannel = -14030 #%(T_46_META_WS_P_CHATCHANNEL)\r
	@ApiLevel=10\r
	@ScriptName=MovementStatus_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get MovementStatus : PlayerBehaviorStatus = -14031 #%(T_42_XXJ_WS_MOVEMENTSTATUS)\r
	@ApiLevel=10\r
	@ScriptName=SprintStatus_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get SprintStatus : PlayerBehaviorStatus = -14032 #%(T_42_XXJ_WS_SPRINTSTATUS)\r
	@ApiLevel=10\r
	@ScriptName=AttackStatus_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get AttackStatus : PlayerBehaviorStatus = -14033 #%(T_42_XXJ_WS_ATTACKSTATUS)\r
	@ApiLevel=10\r
	@ScriptName=JumpStatus_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get JumpStatus : PlayerBehaviorStatus = -14034 #%(T_42_XXJ_WS_JUMPSTATUS)\r
	@ApiLevel=4\r
	@ScriptName=DisableItemPickup\r
	@Tip = %(T_49_META_TYP_14_I35_D)\r
    PickupItemDisabled : Bool = -14035 #%(T_46_META_WS_P_DISABLEITEMPICKUP)\r
	@ApiLevel=4\r
	@ScriptName=DisableItemDrop\r
	@Tip = %(T_49_META_TYP_14_I36_D)\r
    DropItemDisabled : Bool = -14036 #%(T_46_META_WS_P_DISABLEITEMDROP)\r
	@ApiLevel=4\r
	@ScriptName=AttackableTargets\r
	@Tip = %(T_49_META_TYP_14_I37_D)\r
    get HostilePlayers : ListT_Player = -14037 #%(T_46_META_WS_P_ATTTACKABLETARGETS)\r
	@ApiLevel=4\r
	@ScriptName=FriendPlayers\r
	@Tip = %(T_49_META_TYP_14_I38_D)\r
    get FriendlyPlayers : ListT_Player = -14038 #%(T_46_META_WS_P_FRIENDLYPLAYERS)\r
	@ApiLevel=10\r
	@ScriptName=Faction\r
	@Tip = %(T_49_META_TYP_14_I39_D)\r
    get FactionEntity : Faction = -14039 #%(T_46_META_WS_P_FACTION)\r
	@ApiLevel=10\r
	@ScriptName=NumberInFaction\r
	@Tip = %(T_49_META_TYP_14_I40_D)\r
    get FactionIndex : Int = -14040 #%(T_46_META_WS_P_NUMBERINFACTION)\r
	@ApiLevel=4\r
	@ScriptName=MainCamera\r
	@Tip = %(T_49_META_TYP_14_I41_D)\r
    CurrentCameraConfig : CameraConfig = -14041 #%(T_46_META_WS_P_MAIN CAMERA)\r
	@ApiLevel=4\r
	@Default=-9.8\r
	@ScriptName=Gravity\r
	@Tip = %(T_49_META_TYP_14_I42_D)\r
    CustomGravity : Float = -14042 #%(T_46_META_WS_P_GRAVITY)\r
	@ApiLevel=4\r
	@ScriptName=Helmet\r
	@Tip = %(T_49_META_TYP_14_I43_D)\r
    get Helmet : Helmet = -14043 #%(T_46_META_WS_P_HELMET)\r
	@ApiLevel=4\r
	@ScriptName=Vest\r
	@Tip = %(T_49_META_TYP_14_I44_D)\r
    get Vest : Vest = -14044 #%(T_46_META_WS_P_VEST)\r
	@ApiLevel=4\r
	@ScriptName=CrouchWalkSpeedScale\r
	@Tip = %(T_49_META_TYP_14_I14_D)\r
    CrouchSpeedScale : Float = -14045 #%(T_46_META_WS_P_CROUCHWALKSPEEDSCALE)\r
	@ApiLevel=4\r
	@ScriptName=SprintSpeedScale\r
	@Tip = %(T_49_META_TYP_14_I14_D)\r
    DashSpeedScale : Float = -14046 #%(T_46_META_WS_P_SPRINTSPEEDSCALE)\r
	@ApiLevel=4\r
	@ScriptName=DownedCrawlSpeedScale\r
	@Tip = %(T_49_META_TYP_14_I14_D)\r
    KnockDownSpeedScale : Float = -14047 #%(T_46_META_WS_P_DOWNEDCRAWLSPEEDSCALE)\r
	@ApiLevel=4\r
	@ScriptName=CrawlSpeedScale\r
	@Tip = %(T_49_META_TYP_14_I14_D)\r
    CreepSpeedScale : Float = -14048 #%(T_46_META_WS_P_CRAWLSPEEDSCALE)\r
	@ApiLevel=10\r
	@Default=&math.Vector3(1, 1, 1)\r
	@ScriptName=HeadBonesScale_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    HeadBonesScale : Vector3 = -14049 #%(T_39_WZY_WS_HEADSCALE)\r
	@ApiLevel=10\r
	@Default=&math.Vector3(1, 1, 1)\r
	@ScriptName=BodyBonesScale_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    BodyBonesScale : Vector3 = -14050 #%(T_39_WZY_WS_BODYSCALE)\r
	@ApiLevel=10\r
	@Default=&math.Vector3(1, 1, 1)\r
	@ScriptName=LimbBonesScale_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    LimbBonesScale : Vector3 = -14051 #%(T_39_WZY_WS_LIMBSCALE)\r
	@ApiLevel=4\r
	@ScriptName=UserUID\r
	@Tip = %(T_49_META_TYP_14_I52_D)\r
    get UserUID : UUID = -14052 #%(T_46_META_WS_P_USERUID)\r
	@ApiLevel=4\r
	@ScriptName=HeadshotDamageReduction\r
	@Tip = %(T_49_META_TYP_14_I53_D)\r
    UGCHeadshotDamageDecreaseScale : Float = -14053 #%(T_46_META_WS_P_HEADSHOTDAMAGEREDUCTION)\r
	@ApiLevel=4\r
	@ScriptName=Outfit\r
	@Tip = %(T_49_META_TYP_14_I54_D)\r
    get PlayerAvatar : PlayerAvatarInfo = -14054 #%(T_46_META_WS_P_OUTFIT)\r
	@ApiLevel=4\r
	@ScriptName=Gender\r
	@Tip = %(T_49_META_TYP_14_I55_D)\r
    get Gender : GenderType = -14055 #%(T_46_META_WS_P_GENDER)\r
	@ApiLevel=4\r
	@ScriptName=WeaponSkinIDs\r
	@Tip = %(T_49_META_TYP_14_I56_D)\r
    get WeaponSkinID : ListT_WeaponSkinID = -14056 #%(T_46_META_WS_P_WEAPONSKINIDS)\r
	@ApiLevel=4\r
	@ScriptName=SpawnPoint\r
	@Tip = %(T_49_META_TYP_14_I57_D)\r
    get BornPositionVec3 : Vector3 = -14057 #%(T_46_META_WS_P_SPAWNPOINT)\r
	@ApiLevel=4\r
	@ScriptName=RevivalPoint\r
	@Tip = %(T_49_META_TYP_14_I58_D)\r
    RevivePositionVec3 : Vector3 = -14058 #%(T_46_META_WS_P_REVIVALPOINT)\r
	@ApiLevel=4\r
	@ScriptName=Position\r
	@Tip = %(T_49_META_TYP_14_I59_D)\r
    get DirectPositionVec3 : Vector3 = -14059 #%(T_46_META_WS_P_POSITION)\r
	@ApiLevel=4\r
	@ScriptName=Forward\r
	@Tip = %(T_49_META_TYP_14_I60_D)\r
    get DirectForwardVec3 : Vector3 = -14060 #%(T_46_META_WS_P_FORWARD)\r
	@ApiLevel=4\r
	@ScriptName=Skeleton\r
	@Tip = %(T_49_META_TYP_14_I61_D)\r
    get Bones : Skeleton = -14061 #%(T_46_META_WS_P_SKELETON)\r
	@ApiLevel=4\r
	@ScriptName=Backpack\r
	@Tip = %(T_49_META_TYP_14_I62_D)\r
    get PlayerBagEntity : PlayerBag = -14062 #%(T_46_META_WS_P_BACKPACK)\r
	@ApiLevel=4\r
	@ScriptName=TemporaryShieldPoints\r
	@Tip = %(T_49_META_TYP_14_I63_D)\r
    TemporaryShield : Int = -14063 #%(T_46_META_WS_P_TEMPORARYSHIELDPOINTS)\r
	@ApiLevel=4\r
	@ScriptName=VehicleSkinIDs\r
	@Tip = %(T_49_META_TYP_14_I64_D)\r
    get VehicleSkinIDs : ListT_Int = -14064 #%(T_46_META_WS_P_VEHICLESKINIDS)\r
	@ApiLevel=4\r
	@ScriptName=IsSkipStaggerAnimation\r
	@Tip = %(T_49_META_TYP_14_I65_D)\r
    AnimSkipFallingLand : Bool = -14065 #%(T_46_META_WS_P_ISSKIPSTAGGERANIMATION)\r
	@ApiLevel=4\r
	@ScriptName=DisableFallDamage\r
	@Tip = %(T_49_META_TYP_14_I66_D)\r
    FallDamageDisabled : Bool = -14066 #%(T_46_META_WS_P_DISABLEFALLDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=CurrentItemInHand\r
	@Tip = %(T_49_META_TYP_14_I67_D)\r
    get HandHeldItem : Entity = -14067 #%(T_46_META_WS_P_CURRENTHANDHELDITEM)\r
	@ApiLevel=4\r
	@ScriptName=ItemPickupBanlist\r
	@Tip = %(T_49_META_TYP_14_I68_D)\r
    DisablePickUpItems : ListT_ItemGoodsIDType = -14068 #%(T_46_META_WS_P_ITEMPICKUPBANLIST)\r
	@ApiLevel=4\r
	@ScriptName=CustomCharacterResource\r
	@Tip = %(T_49_META_TYP_14_I69_D)\r
    ResPlayerUUID : PlayerDataID = -14069 #%(T_46_META_WS_P_CUSTOMCHARACTERRESOURCE)\r
	@ApiLevel=4\r
	@ScriptName=AskBuyTarget\r
	@Tip = %(T_49_META_TYP_14_I70_D)\r
    AskBuyTarget : RequestPurchaseType = -14070 #%(T_46_META_WS_P_ASKBUYTARGET)\r
	@ApiLevel=4\r
	@ScriptName=CurrentAnimationResource\r
	@Tip = %(T_49_META_TYP_14_I71_D)\r
    get CurrentEmoteClip : AnimationClipID = -14071 #%(T_46_META_WS_P_CURRENTANIMATIONRESOURCE)\r
	@ApiLevel=4\r
	@ScriptName=IsCurrentAnimationLoop\r
	@Tip = %(T_49_META_TYP_14_I72_D)\r
    get IsCurrentEmoteLoop : Bool = -14072 #%(T_46_META_WS_P_ISCURRENTANIMATIONLOOP)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=KnockdownStatus\r
	@Tip = %(T_49_META_TYP_14_I73_D)\r
    KnockDown : KnockDownStateType = -14073 #%(T_46_META_WS_P_KNOCKDOWNSTATUS)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ShowDamageNumber\r
	@Tip = %(T_49_META_TYP_14_I74_D)\r
    ShowDamageNum : Bool = -14074 #%(T_46_META_WS_P_SHOWDAMAGENUMBER)\r
	@ApiLevel=4\r
	@ScriptName=BackpackSkinID\r
	@Tip = %(T_49_META_TYPE_388_D)\r
    get BagSkinID : Int = -14075 #%(T_46_META_WS_P_BACKPACKSKINID)\r
	@ApiLevel=3\r
	@ScriptName=CanQuitMdiway\r
	@Tip = %(T_49_META_TYP_14_I76_D)\r
	@ApiTarget=1\r
    get CanFreeQuit : Bool = -14076 #%(T_48_META_API_90_P1)\r
	@ApiLevel=3\r
	@ScriptName=TransformClothInfo\r
	@Tip = %(T_49_META_TYP_14_I77_D)\r
    get TransformClothInfo : TransformClothInfo = -14077 #TransformClothInfo\r
	@ApiLevel=4\r
	@ScriptName=CustomCamera\r
	@Tip = %(T_49_META_TYP_14_I78_D)\r
    CurrentNewCamera : BasicCamera = -14078 #%(T_49_META_TYP_449)\r
	@ApiLevel=4\r
	@ScriptName=BindCustomPlayer\r
	@Tip = %(T_51_META_TYP_14_I79_D)\r
    get BindedCustomPlayer : Entity = -14079 #%(T_51_META_TYP_14_I79)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=KnockDownType\r
@Tip = %(T_49_META_TYPE_382_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
enum KnockDownStateType : Int = 382 { #%(T_46_META_WS_C_KNOCKDOWNTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Default\r
	@Tip = %(T_49_META_TYP_382_I0_D)\r
    Default = 0 #%(T_46_META_WS_E_DEFAULT)\r
	@ApiLevel=4\r
	@ScriptName=SkipKnockDown\r
	@Tip = %(T_49_META_TYP_382_I1_D)\r
    SkipKnockDown = 1 #%(T_46_META_WS_E_SKIPKNOCKDOWN)\r
	@ApiLevel=4\r
	@ScriptName=NoSkipKnockdown\r
	@Tip = %(T_49_META_TYP_382_I2_D)\r
    MustKnockDown = 2 #%(T_46_META_WS_E_NOSKIPKNOCKDOWN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BevTreeAttachable\r
@Addable=["LevelObject","AI"]\r
@Tip = %(T_49_META_TYPE_293_D)\r
@ModuleID=36\r
@ModuleLib=BehaviourTree\r
type BehaviourTreeAttachable : Entity = 293 { #%(T_46_META_WS_C_BEVTREEATTACHABLE)\r
	@ApiLevel=4\r
	@ScriptName=BevTreeID\r
	@Tip = %(T_49_META_TYP_293_I0_D)\r
    BTreeID : BTreeID = -293000 #%(T_46_META_WS_P_BEVTREEID)\r
	@ApiLevel=4\r
	@ScriptName=AttachTarget\r
	@Tip = %(T_49_META_TYP_293_I1_D)\r
    get TargetTree : BehaviourTree = -293001 #%(T_46_META_WS_P_ATTACHTARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LevelObject\r
@Tip = %(T_49_META_TYPE_16_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type LevelObject : Transform&Visibility = 16 { #%(T_40_XXJ_WS_LEVELOBJECT)\r
	@ApiLevel=10\r
	@ScriptName=Name_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get Name : String = -16000 #%(TXT_CLAN_NAME)\r
	@ApiLevel=3\r
	@ScriptName=ItemID\r
	@Tip = %(T_49_META_TYP_16_I1_D)\r
    get ItemID : LevelObjectID = -16001 #%(T_40_XXJ_WS_ITEMID_NAMEKEY)\r
	@ApiLevel=3\r
	@Default=false\r
	@ScriptName=IsNavMeshStatic\r
	@Tip = %(T_49_META_TYP_16_I2_D)\r
    get IsNavMeshStatic : Bool = -16002 #%(T_41_XXJ_WS_ISNAVMESHSTATIC)\r
	@ApiLevel=3\r
	@Default=false\r
	@ScriptName=IsDynamicObstacle\r
	@Tip = %(T_49_META_TYP_16_I3_D)\r
    get IsDynamicObstacle : Bool = -16003 #%(T_44_XXJ_WS_ISDYNAMICOBSTACLE)\r
	@ApiLevel=3\r
	@Default=false\r
	@ScriptName=IsAsyncLoad\r
	@Tip = %(T_49_META_TYP_16_I4_D)\r
    get IsAsyncLoad : Bool = -16004 #IsAsyncLoad\r
	@ApiLevel=11\r
	@Default=0\r
	@ScriptName=ShopItemID\r
    get ShopItemID : Int64 = -16005 #ShopItemID\r
	@ApiLevel=11\r
	@Default=0\r
	@ScriptName=ShopItemVersion\r
    get ShopItemVersion : Int = -16006 #ShopItemVersion\r
	@ApiLevel=11\r
	@Default=0\r
	@ScriptName=EditState\r
    get EditState : Int = -16007 #EditState\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_LevelObject\r
@Tip = %(T_49_META_TYPE_17_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_LevelObject : List = 17 { #%(T_46_META_WS_C_LISTT_LEVELOBJECT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BuiltInUIType\r
@Tip = %(T_49_META_TYPE_20_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
@genTypeEnum base = InternalHud\r
enum InternalHudType : Type = 20 { #%(T_46_META_WS_C_BUILTINUITYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BuiltInUI\r
@Tip = %(T_49_META_TYPE_21_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type InternalHud : Entity = 21 { #%(T_46_META_WS_C_BUILTINUI)\r
	@ApiLevel=3\r
	@ScriptName=Depth\r
	@Tip = %(T_49_META_TYP_21_I0_D)\r
    Depth : Int = -21000 #%(T_46_META_WS_P_DEPTH)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CustomUI\r
@Tip = %(T_49_META_TYPE_22_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
type CustomHud : Entity = 22 { #%(T_46_META_WS_C_CUSTOMUI)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -22000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=PrefabID\r
	@Tip = %(T_49_META_TYP_22_I1_D)\r
    get PrefabID : Int = -22001 #%(T_46_META_WS_P_PREFABID)\r
	@ApiLevel=3\r
	@ScriptName=MaxWidgetID\r
	@Tip = %(T_49_META_TYP_22_I2_D)\r
    get MaxWidgetID : Int = -22002 #%(T_46_META_WS_P_MAXWIDGETID)\r
	@ApiLevel=4\r
	@ScriptName=Depth\r
	@Tip = %(T_49_META_TYP_22_I3_D)\r
    Depth : Int = -22003 #%(T_46_META_WS_P_DEPTH)\r
	@ApiLevel=4\r
	@ScriptName=EnablePlayerView\r
	@Tip = %(T_49_META_TYP_22_I4_D)\r
    OpenPlayerView : Bool = -22004 #%(T_46_META_WS_P_ENABLEPLAYERVIEW)\r
	@ApiLevel=4\r
	@ScriptName=WorldPosition\r
	@Tip = %(T_49_META_TYP_22_I5_D)\r
    WorldPosition : Vector3 = -22005 #%(T_46_META_WS_P_WORLDPOSITION)\r
	@ApiLevel=4\r
	@ScriptName=InScene\r
	@Tip = %(T_49_META_TYP_22_I6_D)\r
    InScene : Bool = -22006 #%(T_46_META_WS_P_INSCENE)\r
	@ApiLevel=4\r
	@ScriptName=Rotation\r
	@Tip = %(T_49_META_TYP_22_I7_D)\r
    Rotation : Vector3 = -22007 #%(T_46_META_WS_P_ROTATION)\r
	@ApiLevel=4\r
	@Default=math.Vector3_1()\r
	@ScriptName=Scale\r
	@Tip = %(T_49_META_TYP_22_I8_D)\r
    Scale : Vector3 = -22008 #%(T_46_META_WS_P_SCALE)\r
	@ApiLevel=4\r
	@ScriptName=UIAssetID\r
	@Tip = %(T_50_META_TYP_22_I9_D)\r
    get HudAssetID : CustomHudAssetID = -22009 #%(T_50_META_API_114_P2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LevelObjectType\r
@Tip = %(T_49_META_TYPE_23_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@genTypeEnum base = LevelObject\r
enum LevelObjType : Type = 23 { #%(T_46_META_WS_C_LEVELOBJECTTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DamageType\r
@Tip = %(T_49_META_TYPE_24_D)\r
@ModuleID=10016\r
@ModuleLib=Combat\r
enum DamageType : Int = 24 { #%(T_46_META_WS_C_DAMAGETYPE)\r
	@ApiLevel=4\r
	@ScriptName=Melee\r
	@Tip = %(T_49_META_TYP_24_I0_D)\r
    Melee = 1 #%(T_46_META_WS_E_MELEE)\r
	@ApiLevel=4\r
	@ScriptName=Gun\r
	@Tip = %(T_49_META_TYP_24_I1_D)\r
    Gun = 2 #%(T_46_META_WS_E_GUN)\r
	@ApiLevel=4\r
	@ScriptName=Grenade\r
	@Tip = %(T_49_META_TYP_24_I2_D)\r
    Grenade = 3 #%(T_46_META_WS_E_GRENADE)\r
	@ApiLevel=4\r
	@ScriptName=ElectricZone\r
	@Tip = %(T_49_META_TYP_24_I3_D)\r
    ElectricZone = -1 #%(T_46_META_WS_E_ELECTRICZONE)\r
	@ApiLevel=4\r
	@ScriptName=Vehicle\r
	@Tip = %(T_49_META_TYP_24_I4_D)\r
    Vehicle = -2 #%(T_46_META_WS_E_VEHICLE)\r
	@ApiLevel=4\r
	@ScriptName=Falling\r
	@Tip = %(T_49_META_TYP_24_I5_D)\r
    Falling = -4 #%(T_46_META_WS_E_FALLING)\r
	@ApiLevel=4\r
	@ScriptName=KillZone\r
	@Tip = %(T_49_META_TYP_24_I6_D)\r
    KillZone = -14 #%(T_46_META_WS_E_KILLZONE)\r
	@ApiLevel=4\r
	@ScriptName=Exit\r
	@Tip = %(T_49_META_TYP_24_I7_D)\r
    Leave = -50 #%(T_46_META_WS_E_EXIT)\r
	@ApiLevel=4\r
	@ScriptName=Disconnect\r
	@Tip = %(T_49_META_TYP_24_I8_D)\r
    Disconnect = -51 #%(T_46_META_WS_E_DISCONNECT)\r
	@ApiLevel=4\r
	@ScriptName=VehicleExplode\r
	@Tip = %(T_49_META_TYP_24_I9_D)\r
    VehicleExplode = -6 #%(T_46_META_WS_E_VEHICLEEXPLODE)\r
	@ApiLevel=4\r
	@ScriptName=Airdrop\r
	@Tip = %(T_49_META_TYP_24_I10_D)\r
    Airdrop = -8 #%(T_46_META_WS_E_AIRDROP)\r
	@ApiLevel=4\r
	@ScriptName=Burning\r
	@Tip = %(T_49_META_TYP_24_I11_D)\r
    Burning = -10 #%(T_46_META_WS_E_BURNING)\r
	@ApiLevel=4\r
	@ScriptName=OilDrumExplode\r
	@Tip = %(T_49_META_TYP_24_I12_D)\r
    OildrumExplode = -16 #%(T_46_META_WS_E_OILDRUMEXPLODE)\r
	@ApiLevel=4\r
	@ScriptName=MissileExplode\r
	@Tip = %(T_49_META_TYP_24_I13_D)\r
    MissileExplode = -17 #%(T_46_META_WS_E_MISSILEEXPLODE)\r
	@ApiLevel=4\r
	@ScriptName=Monster\r
	@Tip = %(T_49_META_TYP_24_I14_D)\r
    Zombie = -19 #%(T_46_META_WS_E_MONSTER)\r
	@ApiLevel=4\r
	@ScriptName=DamageZone\r
	@Tip = %(T_49_META_TYP_24_I15_D)\r
    DamageZone = -20 #%(T_46_META_WS_E_DAMAGEZONE)\r
	@ApiLevel=4\r
	@ScriptName=MiniSentry\r
	@Tip = %(T_49_META_TYPE_2507_D)\r
    MiniSentry = -23 #%(T_46_META_WS_E_MINISENTRY)\r
	@ApiLevel=4\r
	@ScriptName=CharacterSkill\r
	@Tip = %(T_49_META_TYP_24_I17_D)\r
    ActivitySkill = -31 #%(T_46_META_WS_E_CHARACTERSKILL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Phase\r
@Tip = %(T_49_META_TYPE_25_D)\r
@ModuleID=1\r
@ModuleLib=Workflow\r
type Phase : Entity = 25 { #%(T_46_META_WS_C_PHASE)\r
	@ApiLevel=4\r
	@ScriptName=Index\r
	@Tip = %(T_49_META_TYP_25_I0_D)\r
    get PhaseIndex : Int = -25000 #%(T_46_META_WS_P_INDEX)\r
	@ApiLevel=4\r
	@ScriptName=StartTime\r
	@Tip = %(T_49_META_TYP_25_I1_D)\r
    get PhaseStartTime : Int = -25001 #%(T_46_META_WS_P_STARTTIME)\r
	@ApiLevel=4\r
	@ScriptName=EndTime\r
	@Tip = %(T_49_META_TYP_25_I2_D)\r
    get PhaseEndTime : Int = -25002 #%(T_46_META_WS_P_ENDTIME)\r
	@ApiLevel=4\r
	@ScriptName=Duration\r
	@Tip = %(T_49_META_TYP_25_I3_D)\r
    get PhaseDuration : Int = -25003 #%(T_46_META_WS_P_DURATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Round\r
@Tip = %(T_49_META_TYPE_26_D)\r
@ModuleID=2\r
@ModuleLib=Workflow\r
type Round : Entity = 26 { #%(T_46_META_WS_C_ROUND)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=ScoreType\r
@Tip = %(T_49_META_TYPE_18_D)\r
@ModuleID=5\r
@ModuleLib=GameResult\r
enum ScoreType : Int = 27 { #%(T_34_M_WS_SCORINGTYPE)\r
	@ApiLevel=4\r
	@ScriptName=KillCount\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    KillCount = 1 #%(T_34_M_WS_ST_KILLCOUNT)\r
	@ApiLevel=4\r
	@ScriptName=DamageSum\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    DamageSum = 2 #%(T_34_M_WS_ST_DAMAGESUM)\r
	@ApiLevel=4\r
	@ScriptName=AssistCount\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    AssistCount = 3 #%(T_34_M_WS_ST_ASSISTCOUNT)\r
	@ApiLevel=4\r
	@ScriptName=FinishOrder\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    FinishOrder = 4 #%(T_34_M_WS_ST_FINISHORDER)\r
	@ApiLevel=4\r
	@ScriptName=FinishTimestamp\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    FinishTimestamp = 5 #%(T_34_M_WS_ST_FINISHTIME)\r
	@ApiLevel=4\r
	@ScriptName=FinishCount\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    FinishCount = 6 #%(T_34_M_WS_ST_FINISHCOUNT)\r
	@ApiLevel=4\r
	@ScriptName=CheckPointProgress\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    CheckPointProgress = 7 #%(T_34_M_WS_ST_CHECKPROGRESS)\r
	@ApiLevel=4\r
	@ScriptName=RankScore\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    RankScore = 8 #%(T_34_M_WS_ST_RANKSCORE)\r
	@ApiLevel=4\r
	@ScriptName=SurvivalDuration\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    SurvivalDuration = 9 #%(T_34_M_WS_ST_SURVIVALDURACTION)\r
	@ApiLevel=4\r
	@ScriptName=MainScore\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    MainScore = 10 #%(T_34_M_WS_ST_MAINSCORE)\r
	@ApiLevel=4\r
	@ScriptName=MonsterKillCount\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    ZombieKillCount = 11 #%(T_38_WZY_WS_KILLCONZOM)\r
	@ApiLevel=4\r
	@ScriptName=MonsterAssistCount\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    ZombieAssistCount = 12 #%(T_38_WZY_WS_ASSCONZOM)\r
	@ApiLevel=4\r
	@ScriptName=MonsterDamageSum\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    ZombieDamageSum = 13 #%(T_38_WZY_WS_DAMSUMZOM)\r
	@ApiLevel=4\r
	@ScriptName=Unknown\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Unknown = 0 #%(T_34_M_WS_ST_UNKOWN)\r
}\r
\r
@Accept EffectID\r
@ApiLevel=4\r
@ScriptName=VFXType\r
@Tip = %(T_49_META_TYPE_29_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum EffectType : EffectID = 29 { #%(T_34_M_WS_VFXTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Sphere\r
	@Tip = %(T_49_META_TYP_29_I0_D)\r
    Sphere = UGC_T_34_LY_WS_VFX1 #%(T_46_META_WS_E_SPHERE)\r
	@ApiLevel=4\r
	@ScriptName=LightBeamPreDiscarded\r
	@Tip = %(T_49_META_TYP_29_I1_D)\r
    LightBeam = UGC_T_34_LY_WS_VFX2 #%(T_46_META_WS_E_LIGHTBEAMPREDISCARDED)\r
	@ApiLevel=4\r
	@ScriptName=RingPreDiscarded\r
	@Tip = %(T_49_META_TYP_29_I2_D)\r
    Ring1 = UGC_T_34_LY_WS_VFX3 #%(T_46_META_WS_E_RINGPREDISCARDED)\r
	@ApiLevel=4\r
	@ScriptName=Boom\r
	@Tip = %(T_49_META_TYP_29_I2_D)\r
    Ring2 = UGC_T_34_LY_WS_VFX4 #%(T_46_META_WS_E_BOOM)\r
	@ApiLevel=4\r
	@ScriptName=TelePort\r
	@Tip = %(T_49_META_TYP_29_I2_D)\r
    Ring3 = UGC_T_34_LY_WS_VFX5 #%(T_46_META_WS_E_TELEPORT)\r
	@ApiLevel=4\r
	@ScriptName=Recover\r
	@Tip = %(T_49_META_TYP_29_I2_D)\r
    Ring4 = UGC_T_34_LY_WS_VFX6 #%(T_46_META_WS_E_RECOVER)\r
	@ApiLevel=4\r
	@ScriptName=CircleofHeat\r
	@Tip = %(T_49_META_TYP_29_I6_D)\r
    FootBeam = UGC_T_36_M_WS_VFX6 #%(T_46_META_WS_E_CIRCLEOFHEAT)\r
	@ApiLevel=4\r
	@ScriptName=Symbolic\r
	@Tip = %(T_49_META_TYP_29_I7_D)\r
    GroundImprint = UGC_T_37_WZY_WS_VFX1 #%(T_46_META_WS_E_SYMBOLIC)\r
	@ApiLevel=4\r
	@ScriptName=Smokey\r
	@Tip = %(T_49_META_TYP_29_I8_D)\r
    Smoke = UGC_T_37_WZY_WS_VFX2 #%(T_46_META_WS_E_SMOKEY)\r
	@ApiLevel=4\r
	@ScriptName=CurseExplosion\r
	@Tip = %(T_49_META_TYP_29_I9_D)\r
    SpellBlast = UGC_T_37_WZY_WS_VFX3 #%(T_46_META_WS_E_CURSEEXPLOSION)\r
	@ApiLevel=4\r
	@ScriptName=FrozenGrenade\r
	@Tip = %(T_49_META_TYP_29_I10_D)\r
    IceGrenade = UGC_T_37_WZY_WS_VFX4 #%(T_46_META_WS_E_FROZENGRENADE)\r
	@ApiLevel=4\r
	@ScriptName=Frozen\r
	@Tip = %(T_49_META_TYP_29_I11_D)\r
    Frozen = UGC_T_37_WZY_WS_VFX5 #%(T_46_META_WS_E_FROZEN)\r
	@ApiLevel=4\r
	@ScriptName=Spotlight\r
	@Tip = %(T_49_META_TYP_29_I12_D)\r
    Light = UGC_T_37_WZY_WS_VFX6 #%(T_46_META_WS_E_SPOTLIGHT)\r
	@ApiLevel=4\r
	@ScriptName=UpwardTurbulence\r
	@Tip = %(T_49_META_TYP_29_I13_D)\r
    Updraft = UGC_T_37_WZY_WS_VFX7 #%(T_46_META_WS_E_UPWARDTURBULENCE)\r
	@ApiLevel=4\r
	@ScriptName=AtmosphereExplosion\r
	@Tip = %(T_49_META_TYP_29_I14_D)\r
    GasExplosion = UGC_T_37_WZY_WS_VFX8 #%(T_46_META_WS_E_ATMOSPHEREEXPLOSION)\r
	@ApiLevel=4\r
	@ScriptName=HiderKill\r
	@Tip = %(T_49_META_TYP_29_I15_D)\r
    HiderKill = UGC_T_38_WZY_WS_VFX1 #%(T_46_META_WS_E_HIDERKILL)\r
	@ApiLevel=4\r
	@ScriptName=Rampage\r
	@Tip = %(T_49_META_TYP_29_I16_D)\r
    SeekerGoBallistic = UGC_T_38_WZY_WS_VFX2 #%(T_46_META_WS_E_RAMPAGE)\r
	@ApiLevel=4\r
	@ScriptName=CloneKill\r
	@Tip = %(T_49_META_TYP_29_I17_D)\r
    HiderKillFake = UGC_T_38_WZY_WS_VFX3 #%(T_46_META_WS_E_CLONEKILL)\r
	@ApiLevel=4\r
	@ScriptName=HitFeedback\r
	@Tip = %(T_49_META_TYP_29_I18_D)\r
    Shooting = UGC_T_38_WZY_WS_VFX4 #%(T_46_META_WS_E_HITFEEDBACK)\r
	@ApiLevel=4\r
	@ScriptName=Clone\r
	@Tip = %(T_49_META_TYP_29_I19_D)\r
    HiderTransfiguration = UGC_T_38_WZY_WS_VFX5 #%(T_46_META_WS_E_CLONE)\r
	@ApiLevel=4\r
	@ScriptName=Disguise\r
	@Tip = %(T_49_META_TYP_29_I20_D)\r
    HiderBilocation = UGC_T_38_WZY_WS_VFX6 #%(T_46_META_WS_E_DISGUISE)\r
	@ApiLevel=4\r
	@ScriptName=Portal\r
	@Tip = %(T_49_META_TYP_29_I21_D)\r
    Entrance = UGC_T_38_WZY_WS_VFX7 #%(T_46_META_WS_E_PORTAL)\r
	@ApiLevel=4\r
	@ScriptName=FlashbangSparks\r
	@Tip = %(T_49_META_TYP_29_I22_D)\r
    Trail = UGC_T_38_WZY_WS_VFX8 #%(T_46_META_WS_E_FLASHBANGSPARKS)\r
	@ApiLevel=4\r
	@ScriptName=FireCharge\r
	@Tip = %(T_49_META_TYP_29_I23_D)\r
    Fire = UGC_T_38_WZY_WS_VFX9 #%(T_46_META_WS_E_FIRECHARGE)\r
	@ApiLevel=4\r
	@ScriptName=CyclicCombustion\r
	@Tip = %(T_49_META_TYP_29_I24_D)\r
    Digitaluniverse = UGC_T_38_WZY_WS_VFX10 #%(T_46_META_WS_E_CYCLICCOMBUSTION)\r
	@ApiLevel=4\r
	@ScriptName=PoisonGasPreDiscarded\r
	@Tip = %(T_49_META_TYP_29_I25_D)\r
    Dragon = UGC_T_38_WZY_WS_VFX11 #%(T_46_META_WS_E_POISONGASPREDISCARDED)\r
	@ApiLevel=4\r
	@ScriptName=Heart\r
	@Tip = %(T_49_META_TYP_29_I26_D)\r
    HEARTVFX = UGC_T_38_WZY_WS_VFX12 #%(T_46_META_WS_E_HEART)\r
	@ApiLevel=4\r
	@ScriptName=Soccer\r
	@Tip = %(T_49_META_TYPE_99_D)\r
    FOOTBALLVFX = UGC_T_38_WZY_WS_VFX13 #%(T_46_META_WS_E_SOCCER)\r
	@ApiLevel=4\r
	@ScriptName=MotionTrail\r
	@Tip = %(T_49_META_TYPE_99_D)\r
    TAILVFX = UGC_T_38_WZY_WS_VFX14 #%(T_46_META_WS_E_MOTIONTRAIL)\r
	@ApiLevel=4\r
	@ScriptName=Door\r
	@Tip = %(T_49_META_TYP_29_I29_D)\r
    DOORVFX = UGC_T_38_WZY_WS_VFX15 #%(T_46_META_WS_E_DOOR)\r
	@ApiLevel=4\r
	@ScriptName=FireWork\r
	@Tip = %(T_49_META_TYP_29_I30_D)\r
    FIREWORK = UGC_T_38_WZY_WS_VFX16 #%(T_46_META_WS_E_FIREWORK)\r
	@ApiLevel=4\r
	@ScriptName=Sneakers\r
	@Tip = %(T_49_META_TYP_29_I31_D)\r
    VFX_Ingame_WS_Water_RopsBuff = VFX_INGAME_WS_WATER_ROPSBUFF #%(T_46_META_WS_E_SNEAKERS)\r
	@ApiLevel=4\r
	@ScriptName=Explosion\r
	@Tip = %(T_49_META_TYP_29_I32_D)\r
    VFX_Ingame_WS_Water_Boom = VFX_INGAME_WS_WATER_BOOM #%(T_46_META_WS_E_EXPLOSION)\r
	@ApiLevel=4\r
	@ScriptName=Spawnpoint\r
	@Tip = %(T_49_META_TYP_29_I33_D)\r
    WS_FF_VFX_SpawnArea = WS_FF_VFX_SPAWNAREA #%(T_46_META_WS_E_SPAWNPOINT)\r
	@ApiLevel=4\r
	@ScriptName=Laser\r
	@Tip = %(T_49_META_TYP_29_I34_D)\r
    WS_FF_VFX_Laser = WS_FF_VFX_LASER #%(T_46_META_WS_E_LASER)\r
	@ApiLevel=4\r
	@ScriptName=ReleasingSkill\r
	@Tip = %(T_49_META_TYP_29_I35_D)\r
    VFX_Ingame_WS_Water_RechargeMax = VFX_INGAME_WS_WATER_RECHARGEMAX #%(T_46_META_WS_E_RELEASINGSKILL)\r
	@ApiLevel=4\r
	@ScriptName=Ammo\r
	@Tip = %(T_49_META_TYP_29_I36_D)\r
    VFX_Ingame_WS_Water_Bullet = VFX_INGAME_WS_WATER_BULLET #%(T_46_META_WS_E_AMMO)\r
	@ApiLevel=4\r
	@ScriptName=HitEffect\r
	@Tip = %(T_49_META_TYP_29_I37_D)\r
    VFX_Ingame_WS_Water_Hit = VFX_INGAME_WS_WATER_HIT #%(T_46_META_WS_E_HITEFFECT)\r
	@ApiLevel=4\r
	@ScriptName=FiringEffect\r
	@Tip = %(T_49_META_TYP_29_I38_D)\r
    VFX_Ingame_WS_Water_Shot = VFX_INGAME_WS_WATER_SHOT #%(T_46_META_WS_E_FIRINGEFFECT)\r
	@ApiLevel=4\r
	@ScriptName=SpiderWeb\r
	@Tip = %(T_49_META_TYP_29_I39_D)\r
    WS_IPBAR_SpiderWeb = WS_IPBAR_SPIDERWEB #%(T_46_META_WS_E_SPIDERWEB)\r
	@ApiLevel=4\r
	@ScriptName=Halo\r
	@Tip = %(T_49_META_TYP_29_I40_D)\r
    UGC_T_36_M_WS_VFX6_01 = UGC_T_36_M_WS_VFX6_01 #%(T_46_META_WS_E_HALO)\r
	@ApiLevel=4\r
	@ScriptName=Bubble\r
	@Tip = %(T_49_META_TYP_29_I41_D)\r
    UGC_T_36_M_WS_VFX6_02 = UGC_T_36_M_WS_VFX6_02 #%(T_46_META_WS_E_BUBBLE)\r
	@ApiLevel=4\r
	@ScriptName=Dust\r
	@Tip = %(T_49_META_TYP_29_I42_D)\r
    VFX_UGC_BOOM_01 = VFX_UGC_BOOM_01 #%(T_46_META_WS_E_DUST)\r
	@ApiLevel=4\r
	@ScriptName=StoneSplash\r
	@Tip = %(T_49_META_TYP_29_I43_D)\r
    VFX_UGC_BOOM_02 = VFX_UGC_BOOM_02 #%(T_46_META_WS_E_STONESPLASH)\r
	@ApiLevel=4\r
	@ScriptName=Line\r
	@Tip = %(T_49_META_TYP_29_I44_D)\r
    VFX_UGC_RECOVER_01 = VFX_UGC_RECOVER_01 #%(T_46_META_WS_E_LINE)\r
	@ApiLevel=4\r
	@ScriptName=Flicker\r
	@Tip = %(T_49_META_TYP_29_I45_D)\r
    VFX_UGC_RECOVER_02 = VFX_UGC_RECOVER_02 #%(T_46_META_WS_E_FLICKER)\r
	@ApiLevel=4\r
	@ScriptName=Ring\r
	@Tip = %(T_49_META_TYP_29_I2_D)\r
    VFX_UGC_TELEPORT_01 = VFX_UGC_TELEPORT_01 #%(T_46_META_WS_E_RING)\r
	@ApiLevel=4\r
	@ScriptName=RisingParticle\r
	@Tip = %(T_49_META_TYP_29_I47_D)\r
    VFX_UGC_TELEPORT_02 = VFX_UGC_TELEPORT_02 #%(T_46_META_WS_E_RISINGPARTICLE)\r
	@ApiLevel=4\r
	@ScriptName=Smoke\r
	@Tip = %(T_49_META_TYP_29_I48_D)\r
    WS_FF_VFX_Cobra_grenade_Explode_01 = WS_FF_VFX_Cobra_grenade_Explode_01 #%(T_46_META_WS_E_SMOKE)\r
	@ApiLevel=4\r
	@ScriptName=Curse\r
	@Tip = %(T_49_META_TYP_29_I49_D)\r
    WS_FF_VFX_Cobra_grenade_Explode_02 = WS_FF_VFX_Cobra_grenade_Explode_02 #%(T_46_META_WS_E_CURSE)\r
	@ApiLevel=4\r
	@ScriptName=FreezeZone\r
	@Tip = %(T_49_META_TYP_29_I50_D)\r
    WS_FF_VFX_Default_Grenade_Attri_Debuff_01 = WS_FF_VFX_Default_Grenade_Attri_Debuff_01 #%(T_46_META_WS_E_FREEZEZONE)\r
	@ApiLevel=4\r
	@ScriptName=ColdAir\r
	@Tip = %(T_49_META_TYP_29_I51_D)\r
    WS_FF_VFX_Default_Grenade_Attri_Debuff_02 = WS_FF_VFX_Default_Grenade_Attri_Debuff_02 #%(T_46_META_WS_E_COLDAIR)\r
	@ApiLevel=4\r
	@ScriptName=Snowflake\r
	@Tip = %(T_49_META_TYP_29_I52_D)\r
    WS_FF_VFX_Default_Grenade_Attri_Dot_01 = WS_FF_VFX_Default_Grenade_Attri_Dot_01 #%(T_46_META_WS_E_SNOWFLAKE)\r
	@ApiLevel=4\r
	@ScriptName=Flame\r
	@Tip = %(T_49_META_TYP_29_I53_D)\r
    WS_FF_VFX_Emote_Female_Cos_Booyahday21_Gun_01 = WS_FF_VFX_Emote_Female_Cos_Booyahday21_Gun_01 #%(T_46_META_WS_E_FLAME)\r
	@ApiLevel=4\r
	@ScriptName=LightBeam\r
	@Tip = %(T_49_META_TYP_29_I54_D)\r
    WS_FF_VFX_Emote_Female_Cos_Cup_01 = WS_FF_VFX_Emote_Female_Cos_Cup_01 #%(T_46_META_WS_E_LIGHTBEAM)\r
	@ApiLevel=4\r
	@ScriptName=SpreadofPoisonGas\r
	@Tip = %(T_49_META_TYP_29_I55_D)\r
    WS_FF_VFX_Emote_Female_Cos_Dragon_01 = WS_FF_VFX_Emote_Female_Cos_Dragon_01 #%(T_46_META_WS_E_SPREADOFPOISONGAS)\r
	@ApiLevel=4\r
	@ScriptName=PoisonGas\r
	@Tip = %(T_49_META_TYP_29_I56_D)\r
    WS_FF_VFX_Griza_Grenade_Explode_01 = WS_FF_VFX_Griza_Grenade_Explode_01 #%(T_46_META_WS_E_POISONGAS)\r
	@ApiLevel=4\r
	@ScriptName=ExplosiveBlaze\r
	@Tip = %(T_49_META_TYP_29_I57_D)\r
    WS_FF_VFX_Griza_Grenade_Explode_02 = WS_FF_VFX_Griza_Grenade_Explode_02 #%(T_46_META_WS_E_EXPLOSIVEBLAZE)\r
	@ApiLevel=4\r
	@ScriptName=LightEffect\r
	@Tip = %(T_49_META_TYP_29_I58_D)\r
    WS_FF_VFX_Griza_Grenade_Explode_03 = WS_FF_VFX_Griza_Grenade_Explode_03 #%(T_46_META_WS_E_LIGHTEFFECT)\r
	@ApiLevel=4\r
	@ScriptName=Star\r
	@Tip = %(T_49_META_TYP_29_I59_D)\r
    WS_FF_VFX_Griza_Grenade_Explode_04 = WS_FF_VFX_Griza_Grenade_Explode_04 #%(T_46_META_WS_E_STAR)\r
	@ApiLevel=4\r
	@ScriptName=Bonfire\r
	@Tip = %(T_49_META_TYP_29_I60_D)\r
    WS_VFX_Fire = WS_VFX_FIRE #%(T_46_META_WS_E_BONFIRE)\r
	@ApiLevel=4\r
	@ScriptName=WaterRing\r
	@Tip = %(T_49_META_TYP_29_I61_D)\r
    WS_VFX_Water = WS_VFX_WATER #%(T_46_META_WS_E_WATERRING)\r
	@ApiLevel=4\r
	@ScriptName=Thunder\r
	@Tip = %(T_49_META_TYP_29_I62_D)\r
    WS_VFX_Thunder = WS_VFX_THUNDER #%(T_46_META_WS_E_THUNDER)\r
	@ApiLevel=4\r
	@ScriptName=Ink\r
	@Tip = %(T_49_META_TYP_29_I63_D)\r
    WS_VFX_Ink = WS_VFX_INK #%(T_46_META_WS_E_INK)\r
	@ApiLevel=4\r
	@ScriptName=BloodBall\r
	@Tip = %(T_49_META_TYP_29_I64_D)\r
    WS_VFX_BLOODBALL = WS_VFX_BLOODBALL #%(T_46_META_WS_E_BLOODBALL)\r
	@ApiLevel=4\r
	@ScriptName=BlackHole\r
	@Tip = %(T_49_META_TYP_29_I65_D)\r
    WS_VFX_BLACKHOLE = WS_VFX_BLACKHOLE #%(T_46_META_WS_E_BLACKHOLE)\r
	@ApiLevel=4\r
	@ScriptName=BlackHoleBoom\r
	@Tip = %(T_49_META_TYP_29_I66_D)\r
    WS_VFX_BLACKHOLE_BOOM = WS_VFX_BLACKHOLE_BOOM #%(T_46_META_WS_E_BLACKHOLEBOOM)\r
	@ApiLevel=4\r
	@ScriptName=Tracerlight\r
	@Tip = %(T_49_META_TYP_29_I67_D)\r
    WS_VFX_LIGHTING = WS_VFX_LIGHTING #%(T_47_HJ_WS_VFX_LIGHTING)\r
	@ApiLevel=4\r
	@ScriptName=Trailing\r
	@Tip = %(T_49_META_TYP_29_I68_D)\r
    WS_VFX_TRAILING = WS_VFX_TRAILING #%(T_47_HJ_WS_VFX_TRAILING)\r
	@ApiLevel=4\r
	@ScriptName=Fog\r
	@Tip = %(T_49_META_TYP_29_I69_D)\r
    WS_VFX_FLOG = WS_VFX_FLOG #%(T_47_HJ_WS_VFX_FOG)\r
}\r
\r
@Accept WeaponSkinID\r
@ApiLevel=4\r
@ScriptName=WeaponSkinType\r
@Tip = %(T_49_META_TYPE_419_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum WeaponSkinType : WeaponSkinID = 419 { #%(T_47_XXJ_WS_WEAPONSKINTYPE)\r
}\r
\r
@Accept VehicleSkinID\r
@ApiLevel=4\r
@ScriptName=VehicleSkinType\r
@Tip = %(T_49_META_TYPE_420_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum VehicleSkinType : VehicleSkinID = 420 { #%(T_47_XXJ_WS_VEHICLESKINTYPE)\r
}\r
\r
@Accept ClothID\r
@ApiLevel=4\r
@ScriptName=ClothType\r
@Tip = %(T_49_META_TYPE_421_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum ClothType : ClothID = 421 { #%(T_47_XXJ_WS_CLOTHTYPE)\r
}\r
\r
@Accept BagSkinID\r
@ApiLevel=4\r
@ScriptName=BagSkinType\r
@Tip = %(T_49_META_TYPE_422_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum BagSkinType : BagSkinID = 422 { #%(T_47_XXJ_WS_BAGSKINTYPE)\r
}\r
\r
@Accept TextureID\r
@ApiLevel=4\r
@ScriptName=TextureType\r
@Tip = %(T_49_META_TYPE_160_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum TextureType : TextureID = 160 { #%(T_46_META_WS_C_TEXTURETYPE)\r
	@ApiLevel=4\r
	@ScriptName=BrickA\r
	@Tip = %(T_49_META_TYP_160_I0_D)\r
    SceneEdit_Cube_Texture_Bricks = SceneEdit_Cube_Texture_Bricks #%(T_46_META_WS_E_BRICKA)\r
	@ApiLevel=4\r
	@ScriptName=TileA\r
	@Tip = %(T_49_META_TYP_160_I1_D)\r
    SceneEdit_Cube_frame_Texture_01 = SceneEdit_Cube_frame_Texture_01 #%(T_46_META_WS_E_TILEA)\r
	@ApiLevel=4\r
	@ScriptName=TileB\r
	@Tip = %(T_49_META_TYP_160_I2_D)\r
    SceneEdit_Cube_frame_Texture_02 = SceneEdit_Cube_frame_Texture_02 #%(T_46_META_WS_E_TILEB)\r
	@ApiLevel=4\r
	@ScriptName=TileC\r
	@Tip = %(T_49_META_TYP_160_I3_D)\r
    SceneEdit_Cube_frame_Texture_03 = SceneEdit_Cube_frame_Texture_03 #%(T_46_META_WS_E_TILEC)\r
	@ApiLevel=4\r
	@ScriptName=BambooA\r
	@Tip = %(T_49_META_TYP_160_I4_D)\r
    SceneEdit_Cube_Texture_Bamboo_01 = SceneEdit_Cube_Texture_Bamboo_01 #%(T_46_META_WS_E_BAMBOOA)\r
	@ApiLevel=4\r
	@ScriptName=CementA\r
	@Tip = %(T_49_META_TYP_160_I5_D)\r
    SceneEdit_Cube_Texture_Cement_01 = SceneEdit_Cube_Texture_Cement_01 #%(T_46_META_WS_E_CEMENTA)\r
	@ApiLevel=4\r
	@ScriptName=ContainerA\r
	@Tip = %(T_49_META_TYP_160_I6_D)\r
    SceneEdit_Cube_Texture_Container_01 = SceneEdit_Cube_Texture_Container_01 #%(T_46_META_WS_E_CONTAINERA)\r
	@ApiLevel=4\r
	@ScriptName=LawnA\r
	@Tip = %(T_49_META_TYP_160_I7_D)\r
    SceneEdit_Cube_Texture_Grassland_01 = SceneEdit_Cube_Texture_Grassland_01 #%(T_46_META_WS_E_LAWNA)\r
	@ApiLevel=4\r
	@ScriptName=IceA\r
	@Tip = %(T_49_META_TYP_160_I8_D)\r
    SceneEdit_Cube_Texture_Ice_01 = SceneEdit_Cube_Texture_Ice_01 #%(T_46_META_WS_E_ICEA)\r
	@ApiLevel=4\r
	@ScriptName=MagmaA\r
	@Tip = %(T_49_META_TYP_160_I9_D)\r
    SceneEdit_Cube_Texture_Magma_01 = SceneEdit_Cube_Texture_Magma_01 #%(T_46_META_WS_E_MAGMAA)\r
	@ApiLevel=4\r
	@ScriptName=SandA\r
	@Tip = %(T_49_META_TYP_160_I10_D)\r
    SceneEdit_Cube_Texture_Sand_01 = SceneEdit_Cube_Texture_Sand_01 #%(T_46_META_WS_E_SANDA)\r
	@ApiLevel=4\r
	@ScriptName=SnowA\r
	@Tip = %(T_49_META_TYP_160_I11_D)\r
    SceneEdit_Cube_Texture_Snow_01 = SceneEdit_Cube_Texture_Snow_01 #%(T_46_META_WS_E_SNOWA)\r
	@ApiLevel=4\r
	@ScriptName=WoodA\r
	@Tip = %(T_49_META_TYP_160_I12_D)\r
    SceneEdit_Cube_Texture_Wood_01 = SceneEdit_Cube_Texture_Wood_01 #%(T_46_META_WS_E_WOODA)\r
	@ApiLevel=4\r
	@ScriptName=StoneA\r
	@Tip = %(T_49_META_TYP_160_I13_D)\r
    SceneEdit_Cube_Texture_Stone_01 = SceneEdit_Cube_Texture_Stone_01 #%(T_46_META_WS_E_TONEA)\r
	@ApiLevel=4\r
	@ScriptName=LawnB\r
	@Tip = %(T_49_META_TYP_160_I14_D)\r
    SceneEdit_Cube_Texture_Grassland_02 = SceneEdit_Cube_Texture_Grassland_02 #%(T_46_META_WS_E_LAWNB)\r
	@ApiLevel=4\r
	@ScriptName=BrickB\r
	@Tip = %(T_49_META_TYP_160_I15_D)\r
    SceneEdit_Cube_Texture_Wall_01 = SceneEdit_Cube_Texture_Wall_01 #%(T_46_META_WS_E_BRICKB)\r
	@ApiLevel=4\r
	@ScriptName=BrickC\r
	@Tip = %(T_49_META_TYP_160_I16_D)\r
    SceneEdit_Cube_Texture_Wall_02 = SceneEdit_Cube_Texture_Wall_02 #%(T_46_META_WS_E_BRICKC)\r
	@ApiLevel=4\r
	@ScriptName=Clear\r
	@Tip = %(T_49_META_TYP_160_I17_D)\r
    SceneEdit_Cube_Clear = SceneEdit_Cube_Clear #%(T_46_META_WS_E_CLEAR)\r
}\r
\r
@Accept SpriteID\r
@ApiLevel=4\r
@ScriptName=IconType\r
@Tip = %(T_49_META_TYPE_30_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum IconType : SpriteID = 30 { #%(T_46_META_WS_C_ICONTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Square\r
	@Tip = %(T_49_META_TYP_30_I0_D)\r
    Square = T_34_M_WS_ICON_SQUARE #%(T_46_META_WS_E_SQUARE)\r
	@ApiLevel=4\r
	@ScriptName=Quadrilateral\r
	@Tip = %(T_49_META_TYP_30_I1_D)\r
    Quadrilateral = T_34_M_WS_ICON_QUADRI #%(T_46_META_WS_E_QUADRILATERAL)\r
	@ApiLevel=4\r
	@ScriptName=RightTrapezoid\r
	@Tip = %(T_49_META_TYP_30_I2_D)\r
    RightAngledTrapezoid = T_34_M_WS_ICON_RIGHTTRAPEZOID #%(T_46_META_WS_E_RIGHTTRAPEZOID)\r
	@ApiLevel=4\r
	@ScriptName=Trapezoid\r
	@Tip = %(T_49_META_TYP_30_I3_D)\r
    Trapezoid = T_34_M_WS_ICON_TRAPEZOID #%(T_46_META_WS_E_TRAPEZOID)\r
	@ApiLevel=4\r
	@ScriptName=Hexagon\r
	@Tip = %(T_49_META_TYP_30_I4_D)\r
    Hexagon = T_34_M_WS_ICON_HEXAGON #%(T_46_META_WS_E_HEXAGON)\r
	@ApiLevel=4\r
	@ScriptName=Circle\r
	@Tip = %(T_49_META_TYP_30_I5_D)\r
    Round = T_34_M_WS_ICON_CIRCULAR #%(T_46_META_WS_E_CIRCLE)\r
	@ApiLevel=4\r
	@ScriptName=Triangle\r
	@Tip = %(T_49_META_TYP_30_I6_D)\r
    Triangle = T_34_M_WS_ICON_TRIANGLE #%(T_46_META_WS_E_TRIANGLE)\r
	@ApiLevel=4\r
	@ScriptName=ExclamationMark\r
	@Tip = %(T_49_META_TYP_30_I7_D)\r
    ExclamationMark = T_34_M_WS_ICON_EXCLAMATIONMARK #%(T_46_META_WS_E_EXCLAMATIONMARK)\r
	@ApiLevel=4\r
	@ScriptName=QuestionMark\r
	@Tip = %(T_49_META_TYP_30_I8_D)\r
    QuestionMark = T_34_M_WS_ICON_QUESTIONMARK #%(T_46_META_WS_E_QUESTIONMARK)\r
	@ApiLevel=4\r
	@ScriptName=Mark\r
	@Tip = %(T_49_META_TYP_30_I9_D)\r
    Sign = T_34_M_WS_ICON_SIGN #%(T_46_META_WS_E_MARK)\r
	@ApiLevel=4\r
	@ScriptName=Arrow\r
	@Tip = %(T_49_META_TYP_30_I10_D)\r
    Arrow = T_34_M_WS_ICON_ARROW #%(T_46_META_WS_E_ARROW)\r
	@ApiLevel=4\r
	@ScriptName=Pin\r
	@Tip = %(T_49_META_TYP_30_I11_D)\r
    Callout = T_34_M_WS_ICON_TAGGING #%(T_46_META_WS_E_PIN)\r
	@ApiLevel=4\r
	@ScriptName=Stone\r
	@Tip = %(T_49_META_TYP_30_I12_D)\r
    Stone = T_34_M_WS_ICON_STONE #%(T_46_META_WS_E_STONE)\r
	@ApiLevel=4\r
	@ScriptName=Scissors\r
	@Tip = %(T_49_META_TYP_30_I13_D)\r
    Scissors = T_34_M_WS_ICON_SCISSORS #%(T_46_META_WS_E_SCISSORS)\r
	@ApiLevel=4\r
	@ScriptName=Palm\r
	@Tip = %(T_49_META_TYP_30_I14_D)\r
    Cloth = T_34_M_WS_ICON_CLOTH #%(T_46_META_WS_E_PALM)\r
	@ApiLevel=4\r
	@ScriptName=ThumbsUp\r
	@Tip = %(T_49_META_TYP_30_I15_D)\r
    Praise = T_34_M_WS_ICON_UP #%(T_46_META_WS_E_THUMBSUP)\r
	@ApiLevel=4\r
	@ScriptName=Right\r
	@Tip = %(T_49_META_TYP_30_I16_D)\r
    Yes = T_34_M_WS_ICON_YES #%(T_46_META_WS_E_RIGHT)\r
	@ApiLevel=4\r
	@ScriptName=Wrong\r
	@Tip = %(T_49_META_TYP_30_I17_D)\r
    Wrong = T_34_M_WS_ICON_WRONG #%(T_46_META_WS_E_WRONG)\r
	@ApiLevel=4\r
	@ScriptName=Plus\r
	@Tip = %(T_49_META_TYP_30_I18_D)\r
    Plus = T_34_M_WS_ICON_PLUS #%(T_46_META_WS_E_PLUS)\r
	@ApiLevel=4\r
	@ScriptName=Lightning\r
	@Tip = %(T_49_META_TYP_30_I19_D)\r
    Lightning = T_34_M_WS_ICON_LIGHTNING #%(T_46_META_WS_E_LIGHTNING)\r
	@ApiLevel=4\r
	@ScriptName=Heart\r
	@Tip = %(T_49_META_TYP_30_I20_D)\r
    Heart = T_34_M_WS_ICON_HEART #%(T_46_META_WS_E_HEART)\r
	@ApiLevel=4\r
	@ScriptName=Star\r
	@Tip = %(T_49_META_TYP_30_I21_D)\r
    Star = T_34_M_WS_ICON_STAR #%(T_46_META_WS_E_STAR)\r
	@ApiLevel=4\r
	@ScriptName=Moon\r
	@Tip = %(T_49_META_TYP_30_I22_D)\r
    Moon = T_34_M_WS_ICON_MONTH #%(T_46_META_WS_E_MOON)\r
	@ApiLevel=4\r
	@ScriptName=Sun\r
	@Tip = %(T_49_META_TYP_30_I23_D)\r
    Sun = T_34_M_WS_ICON_DAY #%(T_46_META_WS_E_SUN)\r
	@ApiLevel=4\r
	@ScriptName=Eye\r
	@Tip = %(T_49_META_TYP_30_I24_D)\r
    Glasses = T_34_M_WS_ICON_GLASSES #%(T_46_META_WS_E_EYE)\r
	@ApiLevel=4\r
	@ScriptName=Key\r
	@Tip = %(T_49_META_TYP_30_I25_D)\r
    Key = T_34_M_WS_ICON_KEY #%(T_46_META_WS_E_KEY)\r
	@ApiLevel=4\r
	@ScriptName=Trophy\r
	@Tip = %(T_49_META_TYP_30_I26_D)\r
    Trophy = T_34_M_WS_ICON_TROPHY #%(T_46_META_WS_E_TROPHY)\r
	@ApiLevel=4\r
	@ScriptName=Flag\r
	@Tip = %(T_49_META_TYP_30_I27_D)\r
    Flag = T_34_M_WS_ICON_FLAG #%(T_46_META_WS_E_FLAG)\r
	@ApiLevel=4\r
	@ScriptName=Hourglass\r
	@Tip = %(T_49_META_TYP_30_I28_D)\r
    Hourglass = T_34_M_WS_ICON_HOURGLASS #%(T_46_META_WS_E_HOURGLASS)\r
	@ApiLevel=4\r
	@ScriptName=Folder\r
	@Tip = %(T_49_META_TYP_30_I29_D)\r
    Folder = T_34_M_WS_ICON_FOLDER #%(T_46_META_WS_E_FOLDER)\r
	@ApiLevel=4\r
	@ScriptName=OpenFolder\r
	@Tip = %(T_49_META_TYP_30_I30_D)\r
    OpenFolder = T_34_M_WS_ICON_OPENFOLDER #%(T_46_META_WS_E_OPENFOLDER)\r
	@ApiLevel=4\r
	@ScriptName=House\r
	@Tip = %(T_49_META_TYP_30_I31_D)\r
    House = T_34_M_WS_ICON_HOUSE #%(T_46_META_WS_E_HOUSE)\r
	@ApiLevel=4\r
	@ScriptName=Rest\r
	@Tip = %(T_49_META_TYP_30_I32_D)\r
    Rest = T_34_M_WS_ICON_REST #%(T_46_META_WS_E_REST)\r
	@ApiLevel=4\r
	@ScriptName=Refresh\r
	@Tip = %(T_49_META_TYP_30_I33_D)\r
    Refresh = T_34_M_WS_ICON_REFRESH #%(T_46_META_WS_E_REFRESH)\r
	@ApiLevel=4\r
	@ScriptName=Loop\r
	@Tip = %(T_49_META_TYP_30_I34_D)\r
    Loop = T_34_M_WS_ICON_LOOP #%(T_46_META_WS_E_LOOP)\r
	@ApiLevel=4\r
	@ScriptName=MagnifyingGlass\r
	@Tip = %(T_49_META_TYP_30_I35_D)\r
    Magnifier = T_34_M_WS_ICON_MAGNIFIER #%(T_46_META_WS_E_MAGNIFYINGGLASS)\r
	@ApiLevel=4\r
	@ScriptName=TrashCan\r
	@Tip = %(T_49_META_TYP_30_I36_D)\r
    TrashCan = T_34_M_WS_ICON_TRASHCAN #%(T_46_META_WS_E_TRASHCAN)\r
	@ApiLevel=4\r
	@ScriptName=Back\r
	@Tip = %(T_49_META_TYP_30_I37_D)\r
    Return = T_34_M_WS_ICON_RETURN #%(T_46_META_WS_E_BACK)\r
	@ApiLevel=4\r
	@ScriptName=Diamond\r
	@Tip = %(T_49_META_TYP_30_I38_D)\r
    Diamonds = T_34_M_WS_ICON_DIAMONDS #%(T_46_META_WS_E_DIAMOND)\r
	@ApiLevel=4\r
	@ScriptName=SwimRing\r
	@Tip = %(T_49_META_TYP_30_I39_D)\r
    SwimmingCircle = T_34_M_WS_ICON_SWIMMINGCIRCLE #%(T_46_META_WS_E_SWIMRING)\r
	@ApiLevel=4\r
	@ScriptName=Money\r
	@Tip = %(T_49_META_TYP_30_I40_D)\r
    Money = T_34_M_WS_ICON_MONEY #%(T_46_META_WS_E_MONEY)\r
	@ApiLevel=4\r
	@ScriptName=Lock\r
	@Tip = %(T_49_META_TYP_30_I41_D)\r
    Lock = T_34_M_WS_ICON_LOCK #%(T_46_META_WS_E_LOCK)\r
	@ApiLevel=4\r
	@ScriptName=Setting\r
	@Tip = %(T_49_META_TYP_30_I42_D)\r
    SetUp = T_34_M_WS_ICON_SETUP #%(T_46_META_WS_E_SETTING)\r
	@ApiLevel=4\r
	@ScriptName=SignOut\r
	@Tip = %(T_49_META_TYP_30_I43_D)\r
    SignOut = T_34_M_WS_ICON_SIGNOUT #%(T_46_META_WS_E_SIGNOUT)\r
	@ApiLevel=4\r
	@ScriptName=Dialogue\r
	@Tip = %(T_49_META_TYP_30_I44_D)\r
    Dialogue = T_34_M_WS_ICON_DIALOGUE #%(T_46_META_WS_E_DIALOGUE)\r
	@ApiLevel=4\r
	@ScriptName=Crosshair\r
	@Tip = %(T_49_META_TYP_30_I45_D)\r
    FrontSight = T_34_M_WS_ICON_COLLIMATION #%(T_46_META_WS_E_CROSSHAIR)\r
	@ApiLevel=4\r
	@ScriptName=Gun\r
	@Tip = %(T_49_META_TYP_30_I46_D)\r
    Gun = T_34_M_WS_ICON_GUN #%(T_46_META_WS_E_GUN)\r
	@ApiLevel=4\r
	@ScriptName=Sword\r
	@Tip = %(T_49_META_TYP_30_I47_D)\r
    Sword = T_34_M_WS_ICON_THESWORD #%(T_46_META_WS_E_SWORD)\r
	@ApiLevel=4\r
	@ScriptName=Blast\r
	@Tip = %(T_49_META_TYP_30_I48_D)\r
    Blast = T_34_M_WS_ICON_BLAST #%(T_46_META_WS_E_BLAST)\r
	@ApiLevel=4\r
	@ScriptName=Aim\r
	@Tip = %(T_49_META_TYP_30_I49_D)\r
    Aim = T_34_M_WS_ICON_AIM #%(T_46_META_WS_E_AIM)\r
	@ApiLevel=4\r
	@ScriptName=Cross\r
	@Tip = %(T_49_META_TYP_30_I50_D)\r
    Cross = T_34_M_WS_ICON_CROSS #%(T_46_META_WS_E_CROSS)\r
	@ApiLevel=4\r
	@ScriptName=Shield\r
	@Tip = %(T_49_META_TYP_30_I51_D)\r
    Defense = T_34_M_WS_ICON_DEFENSE #%(T_46_META_WS_E_SHIELD)\r
	@ApiLevel=4\r
	@ScriptName=Monster\r
	@Tip = %(T_49_META_TYP_30_I52_D)\r
    Corpse = T_34_M_WS_ICON_CORPSE #%(T_46_META_WS_E_ZOMBIE)\r
	@ApiLevel=4\r
	@ScriptName=Recycle\r
	@Tip = %(T_49_META_TYP_30_I53_D)\r
    Recycling = T_34_M_WS_ICON_RECYCLING #%(T_46_META_WS_E_RECYCLE)\r
	@ApiLevel=4\r
	@ScriptName=Gift\r
	@Tip = %(T_49_META_TYP_30_I54_D)\r
    Gift = FF_WS_7Days #%(T_46_META_WS_E_GIFT)\r
	@ApiLevel=4\r
	@ScriptName=Clothes\r
	@Tip = %(T_49_META_TYP_30_I55_D)\r
    Clothes = FF_WS_Clothes #%(T_46_META_WS_E_CLOTHES)\r
	@ApiLevel=4\r
	@ScriptName=Game\r
	@Tip = %(T_49_META_TYP_30_I56_D)\r
    Game = FF_WS_Debug_01 #%(T_46_META_WS_E_GAME)\r
	@ApiLevel=4\r
	@ScriptName=Player\r
	@Tip = %(T_49_META_TYP_30_I57_D)\r
    Guest = FF_WS_guest #%(T_46_META_WS_E_PLAYER)\r
	@ApiLevel=4\r
	@ScriptName=Store\r
	@Tip = %(T_49_META_TYP_30_I58_D)\r
    Minshop = FF_WS_MinShop #%(T_46_META_WS_E_STORE)\r
	@ApiLevel=4\r
	@ScriptName=Exit\r
	@Tip = %(T_49_META_TYP_30_I59_D)\r
    Quit = FF_WS_Quit #%(T_46_META_WS_E_EXIT)\r
	@ApiLevel=4\r
	@ScriptName=Warning\r
	@Tip = %(T_49_META_TYP_30_I60_D)\r
    Warnning = FF_WS_Report_Room_icon #%(T_46_META_WS_E_WARNING)\r
	@ApiLevel=4\r
	@ScriptName=Text\r
	@Tip = %(T_49_META_TYP_30_I61_D)\r
    Text = FF_WS_Reservation #%(T_46_META_WS_E_TEXT)\r
	@ApiLevel=4\r
	@ScriptName=CountDown\r
	@Tip = %(T_49_META_TYP_30_I62_D)\r
    Clock = FF_WS_timelimite #%(T_46_META_WS_E_COUNTDOWN)\r
	@ApiLevel=4\r
	@ScriptName=Bell\r
	@Tip = %(T_49_META_TYP_30_I63_D)\r
    Pet = FF_icon_Pet #%(T_46_META_WS_E_BELL)\r
	@ApiLevel=4\r
	@ScriptName=PetTabBG\r
	@Tip = %(T_49_META_TYP_30_I64_D)\r
    PetTabBG = T_12_O_PET_TITLE #%(T_46_META_WS_E_PETTABBG)\r
	@ApiLevel=4\r
	@ScriptName=Boom\r
	@Tip = %(T_49_META_TYP_30_I65_D)\r
    BOMBBD = FF_UI_Bomb_BD #%(T_46_META_WS_E_BOOM)\r
	@ApiLevel=4\r
	@ScriptName=Repair\r
	@Tip = %(T_49_META_TYP_30_I66_D)\r
    Debug = FF_UI_Common_Debug #%(T_46_META_WS_E_REPAIR)\r
	@ApiLevel=4\r
	@ScriptName=Smiley\r
	@Tip = %(T_49_META_TYP_30_I67_D)\r
    Emoji = Icon_Chat_Emoji #%(T_46_META_WS_E_SMILEY)\r
	@ApiLevel=4\r
	@ScriptName=LoudSpeaker\r
	@Tip = %(T_49_META_TYP_30_I68_D)\r
    Speaker = Icon_Chat_Speaker #%(T_46_META_WS_E_LOUDSPEAKER)\r
	@ApiLevel=4\r
	@ScriptName=CircleBack\r
	@Tip = %(T_49_META_TYP_30_I34_D)\r
    Unlimited = Icon_PlayCard_unlimited #%(T_46_META_WS_E_CIRCLEBACK)\r
	@ApiLevel=4\r
	@ScriptName=Crown\r
	@Tip = %(T_49_META_TYP_30_I70_D)\r
    CROWN = UI_Customize_official_icon #%(T_46_META_WS_E_CROWN)\r
	@ApiLevel=4\r
	@ScriptName=Duel\r
	@Tip = %(T_49_META_TYP_30_I71_D)\r
    BATTLE = UI_Icon_battle #%(T_46_META_WS_E_DUEL)\r
	@ApiLevel=4\r
	@ScriptName=Guild\r
	@Tip = %(T_49_META_TYP_30_I72_D)\r
    Guild = UI_icon_Guild #%(T_46_META_WS_E_GUILD)\r
	@ApiLevel=4\r
	@ScriptName=HeartBeat\r
	@Tip = %(T_49_META_TYP_30_I73_D)\r
    HeartbHud = UI_icon_HP #%(T_46_META_WS_E_HEARTBEAT)\r
	@ApiLevel=4\r
	@ScriptName=Music\r
	@Tip = %(T_49_META_TYP_30_I74_D)\r
    Music = UI_Icon_Music #%(T_46_META_WS_E_MUSIC)\r
	@ApiLevel=4\r
	@ScriptName=Vehicle\r
	@Tip = %(T_49_META_TYP_30_I75_D)\r
    Vehicle = UI_Icon_Vehicle #%(T_46_META_WS_E_VEHICLE)\r
	@ApiLevel=4\r
	@ScriptName=MeleeWeapons\r
	@Tip = %(T_49_META_TYP_30_I76_D)\r
    MELEEWEAPONS = Icon_HUD_Changuo #%(T_46_META_WS_E_MELEEWEAPONS)\r
	@ApiLevel=4\r
	@ScriptName=Pistol\r
	@Tip = %(T_49_META_TYP_30_I77_D)\r
    PISTOL = Icon_HUD_DE #%(T_46_META_WS_E_PISTOL)\r
	@ApiLevel=4\r
	@ScriptName=Rifle\r
	@Tip = %(T_49_META_TYP_30_I78_D)\r
    RIFLE = Icon_HUD_M4A1 #%(T_46_META_WS_E_RIFLE)\r
	@ApiLevel=4\r
	@ScriptName=Sniper\r
	@Tip = %(T_49_META_TYP_30_I79_D)\r
    SNIPER = Icon_HUD_M24 #%(T_46_META_WS_E_SNIPER)\r
	@ApiLevel=4\r
	@ScriptName=Shotgun\r
	@Tip = %(T_49_META_TYP_30_I80_D)\r
    SHOTGUN = Icon_HUD_M1887 #%(T_46_META_WS_E_SHOTGUN)\r
	@ApiLevel=4\r
	@ScriptName=MachineGun\r
	@Tip = %(T_49_META_TYP_30_I81_D)\r
    SUBMACHINE = Icon_HUD_MP5 #%(T_46_META_WS_E_MACHINEGUN)\r
	@ApiLevel=4\r
	@ScriptName=HealPistol\r
	@Tip = %(T_49_META_TYP_30_I82_D)\r
    TREATMENTGUN = Icon_HUD_TREATMENTGUN #%(T_46_META_WS_E_HEALPISTOL)\r
	@ApiLevel=4\r
	@ScriptName=ArmorPiercing\r
	@Tip = %(T_49_META_TYP_30_I83_D)\r
    KillA = FF_UI_FirstBlood_icon_kill01 #%(T_46_META_WS_E_ARMORPIERCING)\r
	@ApiLevel=4\r
	@ScriptName=Headshoot\r
	@Tip = %(T_49_META_TYP_30_I84_D)\r
    HEADSHOOT = FF_UI_FirstBlood_icon_kill02 #%(T_46_META_WS_E_HEADSHOOT)\r
	@ApiLevel=4\r
	@ScriptName=ArmorSpecialist\r
	@Tip = %(T_49_META_TYP_30_I85_D)\r
    Awakening = ui_icon_skill_Andrew_Awakening #%(T_46_META_WS_E_ARMORSPECIALIST)\r
	@ApiLevel=4\r
	@ScriptName=WallBrawl\r
	@Tip = %(T_49_META_TYP_30_I86_D)\r
    Crazygirl = ui_icon_skill_Crazygirl #%(T_46_META_WS_E_WALLBRAWL)\r
	@ApiLevel=4\r
	@ScriptName=TracingSteps\r
	@Tip = %(T_49_META_TYP_30_I87_D)\r
    Detective = ui_icon_skill_Detective #%(T_46_META_WS_E_TRACINGSTEPS)\r
	@ApiLevel=4\r
	@ScriptName=DropBeat\r
	@Tip = %(T_49_META_TYP_30_I88_D)\r
    Djmale = ui_icon_skill_Djmale #%(T_46_META_WS_E_DROPBEAT)\r
	@ApiLevel=4\r
	@ScriptName=ThrillBattle\r
	@Tip = %(T_49_META_TYP_30_I89_D)\r
    MadeManA = ui_icon_skill_MadeManA #%(T_46_META_WS_E_THRILLBATTLE)\r
	@ApiLevel=4\r
	@ScriptName=Camouflage\r
	@Tip = %(T_49_META_TYP_30_I90_D)\r
    Monkeygod = ui_icon_skill_monkeygod #%(T_46_META_WS_E_CAMOUFLAGE)\r
	@ApiLevel=4\r
	@ScriptName=NuttyMovement\r
	@Tip = %(T_49_META_TYP_30_I91_D)\r
    Singersb = ui_icon_skill_Singersb_link #%(T_46_META_WS_E_NUTTYMOVEMENT)\r
	@ApiLevel=4\r
	@ScriptName=HatTrick\r
	@Tip = %(T_49_META_TYP_30_I92_D)\r
    SoccerStar = ui_icon_skill_SoccerStar #%(T_46_META_WS_E_HATTRICK)\r
	@ApiLevel=4\r
	@ScriptName=RiptideRhythm\r
	@Tip = %(T_49_META_TYP_30_I93_D)\r
    Superstar = ui_icon_skill_Superstar #%(T_46_META_WS_E_RIPTIDERHYTHM)\r
	@ApiLevel=4\r
	@ScriptName=SensesShockwave\r
	@Tip = %(T_49_META_TYP_30_I94_D)\r
    TRACKER = ui_icon_skill_ #%(T_46_META_WS_E_SENSESSHOCKWAVE)\r
}\r
\r
@Accept AudioID\r
@ApiLevel=4\r
@ScriptName=SoundEffectType\r
@Tip = %(T_49_META_TYPE_31_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum AudioType : AudioID = 31 { #%(T_46_META_WS_C_SOUNDEFFECTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Explosion\r
	@Tip = %(T_49_META_TYP_31_I0_D)\r
    SoundGrenadeExplosion = SOUND_UAV_EXPLODE #%(T_46_META_WS_E_EXPLOSION)\r
	@ApiLevel=4\r
	@ScriptName=Gunfire\r
	@Tip = %(T_49_META_TYP_31_I1_D)\r
    SoundGun = SOUND_MP5_FIRE #%(T_46_META_WS_E_GUNFIRE)\r
	@ApiLevel=4\r
	@ScriptName=CountDownDiDi\r
	@Tip = %(T_49_META_TYP_31_I2_D)\r
    SoundCountDownDD = SOUND_INGAME_WAITINGCOUNTDOWN #%(T_46_META_WS_E_COUNTDOWNDIDI)\r
	@ApiLevel=4\r
	@ScriptName=UITap\r
	@Tip = %(T_49_META_TYP_31_I3_D)\r
    SoundClick = SOUND_UI_CLICK_COMMON_DEFAULT #%(T_46_META_WS_E_UITAP)\r
	@ApiLevel=4\r
	@ScriptName=InjuredFemale\r
	@Tip = %(T_49_META_TYP_31_I4_D)\r
    SOUNDFEMALEA = SOUND_FEMALE_INJURED_SERIOUS01 #%(T_46_META_WS_E_INJUREDFEMALE)\r
	@ApiLevel=4\r
	@ScriptName=InjuredMale\r
	@Tip = %(T_49_META_TYP_31_I5_D)\r
    SOUNDMALEA = SOUND_MALE_INJURED_SERIOUS01 #%(T_46_META_WS_E_INJUREDMALE)\r
	@ApiLevel=3\r
	@ScriptName=CoinGenerator\r
	@Tip = %(T_49_META_TYP_31_I6_D)\r
    SOUNDTOKENPICKUP = SOUND_UI_TOKENPICKUP #%(T_36_JH_WS_CREATEGOLD)\r
	@ApiLevel=4\r
	@ScriptName=FinishingPoint\r
	@Tip = %(T_49_META_TYP_31_I7_D)\r
    SOUNDUIENDPOINT = SOUND_SFX_Rushingpets_UI_Checkpoint #%(T_46_META_WS_E_FINISHINGPOINT)\r
	@ApiLevel=4\r
	@ScriptName=Triggers\r
	@Tip = %(T_49_META_TYP_31_I8_D)\r
    SOUNDTRIGGER = SOUND_TELEPORTDOOR_STARTUSE #%(T_46_META_WS_E_TRIGGERS)\r
	@ApiLevel=4\r
	@ScriptName=RankDown\r
	@Tip = %(T_49_META_TYP_31_I9_D)\r
    RANKDOWN = SOUND_PUMPKINSNATCH_RANKDOWN #%(T_46_META_WS_E_RANKDOWN)\r
	@ApiLevel=4\r
	@ScriptName=SuccessfulHit\r
	@Tip = %(T_49_META_TYP_31_I10_D)\r
    LIGHTATTACK = SFX_REAPER_LIGHTATTACK #%(T_46_META_WS_E_SUCCESSFULHIT)\r
	@ApiLevel=4\r
	@ScriptName=LevelUpDiscarded\r
	@Tip = %(T_49_META_TYP_31_I11_D)\r
    RANKUP = SOUND_PUMPKINSNATCH_RANKUP #%(T_46_META_WS_E_LEVELUPDISCARDED)\r
	@ApiLevel=4\r
	@ScriptName=GentleTap\r
	@Tip = %(T_49_META_TYP_31_I12_D)\r
    PRESS = SOUND_USE_MESSAGEBOX #%(T_46_META_WS_E_GENTLETAP)\r
	@ApiLevel=4\r
	@ScriptName=StepTrigger\r
	@Tip = %(T_49_META_TYP_31_I13_D)\r
    BOXOPEN = SOUND_VEHICLE_AIRSHIP_BOX_OPEN #%(T_46_META_WS_E_STEPTRIGGER)\r
	@ApiLevel=4\r
	@ScriptName=RepairEquip\r
	@Tip = %(T_49_META_TYP_31_I14_D)\r
    ARMORTOOL = SOUND_USE_ARMORTOOL #%(T_46_META_WS_E_REPAIREQUIP)\r
	@ApiLevel=4\r
	@ScriptName=HeartBeat\r
	@Tip = %(T_49_META_TYP_31_I15_D)\r
    HEARTBEAT = SOUND_PACEMAKER_HEARTBEAT #%(T_46_META_WS_E_HEARTBEAT)\r
	@ApiLevel=4\r
	@ScriptName=Mistake\r
	@Tip = %(T_49_META_TYP_31_I16_D)\r
    DROP = SOUND_SFX_Rushingpets_Pets_Drop #%(T_46_META_WS_E_MISTAKE)\r
	@ApiLevel=4\r
	@ScriptName=Reminder\r
	@Tip = %(T_49_META_TYP_31_I17_D)\r
    MESSAGEBOX = SOUND_SHRINK_MESSAGEBOX #%(T_46_META_WS_E_REMINDER)\r
	@ApiLevel=4\r
	@ScriptName=Football\r
	@Tip = %(T_49_META_TYP_31_I18_D)\r
    FOOTBALL = SOUND_FOOTBALL_BOUNCE #%(T_46_META_WS_E_FOOTBALL)\r
	@ApiLevel=4\r
	@ScriptName=Cheer\r
	@Tip = %(T_49_META_TYP_31_I19_D)\r
    CHEER = SFX_TORTOISE_CHEER #%(T_46_META_WS_E_CHEER)\r
	@ApiLevel=4\r
	@ScriptName=BombIndication\r
	@Tip = %(T_49_META_TYP_31_I20_D)\r
    BOMBSTART = SOUND_BOMB_TIME_start #%(T_46_META_WS_E_BOMBINDICATION)\r
	@ApiLevel=4\r
	@ScriptName=PriorExplosion\r
	@Tip = %(T_49_META_TYP_31_I21_D)\r
    BOMBEND = SOUND_BOMB_TIME_END #%(T_46_META_WS_E_PRIOREXPLOSION)\r
	@ApiLevel=3\r
	@ScriptName=CharacterAppears\r
	@Tip = %(T_49_META_TYP_31_I22_D)\r
    HUNTERSHOW = SOUND_INFECTION_HUNTERROAR #%(T_37_WZY_WS_BOMBEND)\r
	@ApiLevel=3\r
	@ScriptName=EndBGM\r
	@Tip = %(T_49_META_TYP_31_I23_D)\r
    FINALBGM = SOUND_BGM_MODE_INFECTION_FINALPHASE #%(T_37_WZY_WS_BOMBEND)\r
	@ApiLevel=3\r
	@ScriptName=SupplyBox\r
	@Tip = %(T_49_META_TYP_31_I24_D)\r
    BOMREFRESH = SOUND_AIR_DROP_PLANE_NORMAL  #%(T_37_WZY_WS_BOMBEND)\r
	@ApiLevel=4\r
	@ScriptName=Acceleration\r
	@Tip = %(T_49_META_TYP_31_I25_D)\r
    EVENTSTART = SOUND_TELEPORTDOOR_EVENTSTART #%(T_46_META_WS_E_ACCELERATION)\r
	@ApiLevel=4\r
	@ScriptName=DisappearNotification\r
	@Tip = %(T_49_META_TYP_31_I26_D)\r
    DISABLE = SOUND_TELEPORTDOOR_DISABLE #%(T_46_META_WS_E_DISAPPEARNOTIFICATION)\r
	@ApiLevel=4\r
	@ScriptName=VisualEffects\r
	@Tip = %(T_49_META_TYP_31_I27_D)\r
    LOOP = SOUND_TELEPORTDOOR_LOOP #%(T_46_META_WS_E_VISUALEFFECTS)\r
	@ApiLevel=4\r
	@ScriptName=InsectChirping\r
	@Tip = %(T_49_META_TYP_31_I28_D)\r
    INSECTCRY = SOUND_AMBIENCE_INSECTCRY #%(T_46_META_WS_E_INSECTCHIRPING)\r
	@ApiLevel=4\r
	@ScriptName=HitBlunt\r
	@Tip = %(T_49_META_TYP_31_I29_D)\r
    HIT = SOUND_ICEWALL_HIT #%(T_46_META_WS_E_HITBLUNT)\r
	@ApiLevel=4\r
	@ScriptName=Reaction\r
	@Tip = %(T_49_META_TYP_31_I30_D)\r
    TACTICS = SOUND_ING_CHAT_TACTICS #%(T_46_META_WS_E_REACTION)\r
	@ApiLevel=4\r
	@ScriptName=SurpriseFind\r
	@Tip = %(T_49_META_TYP_31_I31_D)\r
    Butterfly = SOUND_GUNSHOW_AWM_Butterfly #%(T_46_META_WS_E_SURPRISEFIND)\r
	@ApiLevel=4\r
	@ScriptName=Apparition\r
	@Tip = %(T_49_META_TYP_31_I32_D)\r
    MAXLEVEL = SOUND_HYPE_MAX_LEVEL #%(T_46_META_WS_E_APPARITION)\r
	@ApiLevel=4\r
	@ScriptName=PhaseStart\r
	@Tip = %(T_49_META_TYP_31_I33_D)\r
    SHOOTINGGAMEEND = SOUND_UI_SHOOTINGGAME_END #%(T_46_META_WS_E_PHASESTART)\r
	@ApiLevel=4\r
	@ScriptName=Monsters\r
	@Tip = %(T_49_META_TYP_31_I34_D)\r
    ZOMBIE = SOUND_ZOMBIE_FURY #%(T_46_META_WS_E_ZOMBIES)\r
	@ApiLevel=4\r
	@ScriptName=Horror\r
	@Tip = %(T_49_META_TYP_31_I35_D)\r
    GHOST = SOUND_EMOTE_GHOST_MOVE #%(T_46_META_WS_E_HORROR)\r
	@ApiLevel=4\r
	@ScriptName=Transformation\r
	@Tip = %(T_49_META_TYP_31_I36_D)\r
    MORPH = SOUND_UI_NOTICE_PEEKABOO_TRANSFORM #%(T_46_META_WS_E_TRANSFORMATION)\r
	@ApiLevel=4\r
	@ScriptName=PoundingHeart\r
	@Tip = %(T_49_META_TYP_31_I37_D)\r
    HEARTBEAT_FAST = SOUND_UI_NOTICE_PEEKABOO_HEARTBEAT_FAST #%(T_46_META_WS_E_POUNDINGHEART)\r
	@ApiLevel=4\r
	@ScriptName=MediumHeartbeat\r
	@Tip = %(T_49_META_TYP_31_I38_D)\r
    HEARTBEAT_MEDIUM = SOUND_UI_NOTICE_PEEKABOO_HEARTBEAT_MEDIUM #%(T_46_META_WS_E_MEDIUMHEARTBEAT)\r
	@ApiLevel=4\r
	@ScriptName=SlowHeartbeat\r
	@Tip = %(T_49_META_TYP_31_I39_D)\r
    HEARTBEAT_SLOW = SOUND_UI_NOTICE_PEEKABOO_HEARTBEAT_SLOW #%(T_46_META_WS_E_SLOWHEARTBEAT)\r
	@ApiLevel=4\r
	@ScriptName=RushTime\r
	@Tip = %(T_49_META_TYP_31_I40_D)\r
    FEVERTIME = SOUND_UI_NOTICE_PEEKABOO_FEVERTIME #%(T_46_META_WS_E_RUSHTIME)\r
	@ApiLevel=4\r
	@ScriptName=Tap\r
	@Tip = %(T_49_META_TYP_31_I41_D)\r
    CLICK = SOUND_UI_CLICK_COMMON_TINY #%(T_46_META_WS_E_TAP)\r
	@ApiLevel=4\r
	@ScriptName=SkillRecover\r
	@Tip = %(T_49_META_TYP_31_I42_D)\r
    ACTIVESKILLREADY = SOUND_ACTIVESKILLREADY #%(T_46_META_WS_E_SKILLRECOVER)\r
	@ApiLevel=4\r
	@ScriptName=JoinGame\r
	@Tip = %(T_49_META_TYP_31_I43_D)\r
    PVE_JOIN = SOUND_PVE_JOIN #%(T_46_META_WS_E_JOINGAME)\r
	@ApiLevel=4\r
	@ScriptName=MechanicalDeviceEcho\r
	@Tip = %(T_49_META_TYP_31_I44_D)\r
    SFX_Generator_Loop = SOUND_UI_Generator #%(T_46_META_WS_E_MECHANICALDEVICEECHO)\r
	@ApiLevel=4\r
	@ScriptName=Mosquito\r
	@Tip = %(T_49_META_TYP_31_I45_D)\r
    SFX_Mosquito_GhillieSuit = SOUND_BUSH_CAMOUFLAGE_MOSQUITO #%(T_46_META_WS_E_MOSQUITO)\r
	@ApiLevel=4\r
	@ScriptName=SharpMechanical\r
	@Tip = %(T_49_META_TYP_31_I46_D)\r
    SFX_MovieOpening_Type = SOUND_GAMEOPENING_TYPEWRITER #%(T_46_META_WS_E_SHARPMECHANICAL)\r
	@ApiLevel=4\r
	@ScriptName=Mechanical\r
	@Tip = %(T_49_META_TYP_31_I47_D)\r
    SFX_UI_Motion_Common_ProgressLong = SOUND_UI_MOTION_COMMON_PROGRESSLONG #%(T_46_META_WS_E_MECHANICAL)\r
	@ApiLevel=4\r
	@ScriptName=GearSwitchedOn\r
	@Tip = %(T_49_META_TYP_31_I48_D)\r
    Weapon_OnGround_Cannon_Turn_a = SOUND_CANNON_TURN #%(T_46_META_WS_E_GEARSWITCHEDON)\r
	@ApiLevel=4\r
	@ScriptName=Charge\r
	@Tip = %(T_49_META_TYP_31_I49_D)\r
    SFX_Charge_EjectCannon1 = SOUND_CATAPULT_CHARGE #%(T_46_META_WS_E_CHARGE)\r
	@ApiLevel=4\r
	@ScriptName=Step\r
	@Tip = %(T_49_META_TYP_31_I50_D)\r
    SFX_TankZombie_Walk01 = SOUND_ZombieTank_Walk01 #%(T_46_META_WS_E_STEP)\r
	@ApiLevel=4\r
	@ScriptName=MissionComplete\r
	@Tip = %(T_49_META_TYP_31_I51_D)\r
    SFX_UI_Bomb_Success = SOUND_BOMB_SUCCESS #%(T_46_META_WS_E_MISSIONCOMPLETE)\r
	@ApiLevel=4\r
	@ScriptName=DangerVibrating\r
	@Tip = %(T_49_META_TYP_31_I52_D)\r
    SFX_UI_EnterFail = SOUND_SFX_UI_EnterFail #%(T_46_META_WS_E_DANGERVIBRATING)\r
	@ApiLevel=4\r
	@ScriptName=DangerAlarm\r
	@Tip = %(T_49_META_TYP_31_I53_D)\r
    SFX_AMB_Alarm_Shrink = SOUND_ALARM_SHRINK_NORMAL #%(T_46_META_WS_E_DANGERALARM)\r
	@ApiLevel=4\r
	@ScriptName=CountdownWithinGame\r
	@Tip = %(T_49_META_TYP_31_I54_D)\r
    SFX_Ingame_WaitingCountDown = SOUND_UI_WAITING_COUNT_DOWN #%(T_46_META_WS_E_COUNTDOWNWITHINGAME)\r
	@ApiLevel=4\r
	@ScriptName=TipsSound\r
	@Tip = %(T_49_META_TYP_31_I55_D)\r
    SFX_Tips_Announce = SOUND_TIPS_ANNOUNCE #%(T_46_META_WS_E_TIPSSOUND)\r
	@ApiLevel=4\r
	@ScriptName=CrowCaw\r
	@Tip = %(T_49_META_TYP_31_I56_D)\r
    Ambient_Bird = SOUND_AMBIENCE_BIRD #%(T_46_META_WS_E_CROWCAW)\r
	@ApiLevel=4\r
	@ScriptName=TeleportWrong\r
	@Tip = %(T_49_META_TYP_31_I57_D)\r
    SFX_Item_Beaconing_Disapper = SOUND_ITEM_BEACONING_DISAPPER #%(T_46_META_WS_E_TELEPORTWRONG)\r
	@ApiLevel=4\r
	@ScriptName=TeleportCorrect\r
	@Tip = %(T_49_META_TYP_31_I58_D)\r
    SFX_M60_FoxMiko = SOUND_PREVIEW_M60_FOXMIKO #%(T_46_META_WS_E_TELEPORTCORRECT)\r
	@ApiLevel=4\r
	@ScriptName=Teleport\r
	@Tip = %(T_49_META_TYP_31_I59_D)\r
    SFX_Fist_Meteorite_Whoosh = SOUND_FIST_METEORITE_WHOOSH #%(T_46_META_WS_E_TELEPORT)\r
	@ApiLevel=4\r
	@ScriptName=ElectricShock\r
	@Tip = %(T_49_META_TYP_31_I60_D)\r
    SFX_Fist_Rampage4_Whoosh = SOUND_FIST_RAMPAGE4_WHOOSH #%(T_46_META_WS_E_ELECTRICSHOCK)\r
	@ApiLevel=4\r
	@ScriptName=FallingStar\r
	@Tip = %(T_49_META_TYP_31_I61_D)\r
    FallingStar = SOUND_METEOR #%(T_46_META_WS_E_FALLINGSTAR)\r
	@ApiLevel=4\r
	@ScriptName=ElectronicBGM\r
	@Tip = %(T_49_META_TYP_31_I62_D)\r
    SFX_Pet_BGM = SOUND_BGM_PET #%(T_46_META_WS_E_ELECTRONICBGM)\r
	@ApiLevel=4\r
	@ScriptName=CasualGameBGM\r
	@Tip = %(T_49_META_TYP_31_I63_D)\r
    GAMEOVER = SOUND_GAMEOVER #%(T_46_META_WS_E_CASUALGAMEBGM)\r
	@ApiLevel=4\r
	@ScriptName=OpeningBox\r
	@Tip = %(T_49_META_TYP_31_I64_D)\r
    MysteryBox_Open = SOUND_MYSTERY_BOX_PURCHASE #%(T_46_META_WS_E_OPENINGBOX)\r
	@ApiLevel=4\r
	@ScriptName=LevelUp\r
	@Tip = %(T_49_META_TYP_31_I65_D)\r
    SFX_FourSymbols_General_Levelup = SOUND_UI_FS_LEVELUP_DEFAULT #%(T_46_META_WS_E_LEVELUP)\r
	@ApiLevel=4\r
	@ScriptName=LevelMaxed\r
	@Tip = %(T_49_META_TYP_31_I66_D)\r
    SFX_FourSymbols_General_Levelfull = SOUND_UI_FS_LEVELUP_FULL #%(T_46_META_WS_E_LEVELMAXED)\r
	@ApiLevel=4\r
	@ScriptName=TappingButton\r
	@Tip = %(T_49_META_TYP_31_I67_D)\r
    SFX_PetStar_Skill_ButtonUI_01 = SOUND_PETSTAR_SKILL_BUTTONUI_01 #%(T_46_META_WS_E_TAPPINGBUTTON)\r
	@ApiLevel=4\r
	@ScriptName=CountdownDengDeng\r
	@Tip = %(T_49_META_TYP_31_I68_D)\r
    SFX_Rushingpets_UI_Countdown = SOUND_SFX_Rushingpets_UI_Countdown #%(T_46_META_WS_E_COUNTDOWNDENGDENG)\r
	@ApiLevel=4\r
	@ScriptName=Whistle\r
	@Tip = %(T_49_META_TYP_31_I69_D)\r
    SFX_Rushingpets_UI_Defeat = SOUND_SFX_Rushingpets_UI_Defeat #%(T_46_META_WS_E_WHISTLE)\r
	@ApiLevel=4\r
	@ScriptName=UIFinish\r
	@Tip = %(T_49_META_TYP_31_I70_D)\r
    SFX_Rushingpets_UI_Finish = SOUND_SFX_Rushingpets_UI_Finish #%(T_46_META_WS_E_UIFINISH)\r
	@ApiLevel=4\r
	@ScriptName=Forward\r
	@Tip = %(T_49_META_TYP_31_I71_D)\r
    SFX_Rushingpets_UI_Go = SOUND_SFX_Rushingpets_UI_Go #%(T_46_META_WS_E_FORWARD)\r
	@ApiLevel=4\r
	@ScriptName=Booyah\r
	@Tip = %(T_49_META_TYP_31_I72_D)\r
    SFX_Rushingpets_UI_Victory = SOUND_SFX_Rushingpets_UI_Victory #%(T_46_META_WS_E_BOOYAH)\r
	@ApiLevel=4\r
	@ScriptName=Checkpoint\r
	@Tip = %(T_49_META_TYP_31_I73_D)\r
    SFX_Training_Racer_Checkpoint = SOUND_TRAINING_RACER_CHECKPOINT #%(T_46_META_WS_E_CHECKPOINT)\r
	@ApiLevel=4\r
	@ScriptName=CountdownMechanical\r
	@Tip = %(T_49_META_TYP_31_I74_D)\r
    SFX_UI_Training_CountDown0 = SOUND_UI_TRAINING_COUNTDOWN #%(T_46_META_WS_E_COUNTDOWNMECHANICAL)\r
	@ApiLevel=4\r
	@ScriptName=GameStart\r
	@Tip = %(T_49_META_TYP_31_I75_D)\r
    SFX_UI_Training_GameStart = SOUND_UI_SHOOTINGGAME_START #%(T_46_META_WS_E_GAMESTART)\r
	@ApiLevel=4\r
	@ScriptName=ObtainedManyCoins\r
	@Tip = %(T_49_META_TYP_31_I76_D)\r
    SFX_UI_Coin_Get_Large = SOUND_UI_NOTICE_COMMON_COINS_ADD_03 #%(T_46_META_WS_E_OBTAINEDMANYCOINS)\r
	@ApiLevel=4\r
	@ScriptName=ObtainedCoins\r
	@Tip = %(T_49_META_TYP_31_I77_D)\r
    SFX_UI_Coin_Get_Mid = SOUND_UI_NOTICE_COMMON_COINS_ADD_02 #%(T_46_META_WS_E_OBTAINEDCOINS)\r
	@ApiLevel=4\r
	@ScriptName=ObtainedSomeCoins\r
	@Tip = %(T_49_META_TYP_31_I78_D)\r
    SFX_UI_Coin_Get_Small = SOUND_UI_NOTICE_COMMON_COINS_ADD_01 #%(T_46_META_WS_E_OBTAINEDSOMECOINS)\r
	@ApiLevel=4\r
	@ScriptName=JoinedGameDull\r
	@Tip = %(T_49_META_TYP_31_I79_D)\r
    SFX_GuildWar_Join = SOUND_SFX_GUILDWAR_JOIN #%(T_46_META_WS_E_JOINEDGAMEDULL)\r
	@ApiLevel=4\r
	@ScriptName=OpeningGuildSupply\r
	@Tip = %(T_49_META_TYP_31_I80_D)\r
    SFX_UI_Guildwelfare_redpocket = SOUND_SFX_UI_GUILDWELFARE_REDPOCKET #%(T_46_META_WS_E_OPENINGGUILDSUPPLY)\r
	@ApiLevel=4\r
	@ScriptName=Horn\r
	@Tip = %(T_49_META_TYP_31_I81_D)\r
    SFX_UI_Horn = SOUND_UI_HORN #%(T_46_META_WS_E_HORN)\r
	@ApiLevel=4\r
	@ScriptName=EliminatedBoss\r
	@Tip = %(T_49_META_TYP_31_I82_D)\r
    SFX_UI_KillLeader = SOUND_UI_KILLLEADER #%(T_46_META_WS_E_ELIMINATEDBOSS)\r
	@ApiLevel=4\r
	@ScriptName=OpeningWarChest\r
	@Tip = %(T_49_META_TYP_31_I83_D)\r
    SFX_Warehouse_Save = SOUND_UI_Warehouse_SAVE #%(T_46_META_WS_E_OPENINGWARCHEST)\r
	@ApiLevel=4\r
	@ScriptName=SpecialFiringSound\r
	@Tip = %(T_49_META_TYP_31_I84_D)\r
    SFX_Weapon_WS_Fire = SOUND_WEAPON_WS_FIRE #%(T_46_META_WS_E_SPECIALFIRINGSOUND)\r
	@ApiLevel=4\r
	@ScriptName=BulletHitting\r
	@Tip = %(T_49_META_TYP_31_I85_D)\r
    SFX_Weapon_WS_Hit = SOUND_WEAPON_WS_HIT #%(T_46_META_WS_E_BULLETHITTING)\r
	@ApiLevel=4\r
	@ScriptName=Movement\r
	@Tip = %(T_49_META_TYP_31_I86_D)\r
    SFX_WS_Footstep = SOUND_WS_FOOTSTEP #%(T_46_META_WS_E_MOVEMENT)\r
	@ApiLevel=4\r
	@ScriptName=TappingDisabledButton\r
	@Tip = %(T_49_META_TYP_31_I87_D)\r
    SFX_UI_Skill_Unavailable = SOUND_UI_SKILL_UNAVAILABLE #%(T_46_META_WS_E_TAPPINGDISABLEDBUTTON)\r
	@ApiLevel=4\r
	@ScriptName=SkillChargingComplete\r
	@Tip = %(T_49_META_TYP_31_I88_D)\r
    SFX_UI_Skill_Available = SOUND_ACTIVESKILLREADY #%(T_46_META_WS_E_SKILLCHARGINGCOMPLETE)\r
	@ApiLevel=4\r
	@ScriptName=LaserSkill\r
	@Tip = %(T_49_META_TYP_31_I89_D)\r
    SFX_WS_Skill_Meteorite = SOUND_WS_SKILL_METEORITE #%(T_46_META_WS_E_LASERSKILL)\r
	@ApiLevel=4\r
	@ScriptName=GetItem\r
	@Tip = %(T_49_META_TYP_31_I90_D)\r
    SFX_WS_Item_Get = SOUND_WS_ITEM_GET #%(T_46_META_WS_E_GETITEM)\r
	@ApiLevel=4\r
	@ScriptName=Countdown\r
	@Tip = %(T_49_META_TYP_31_I91_D)\r
    SFX_WS_CountDown = SOUND_WS_COUNTDOWN #%(T_46_META_WS_E_COUNTDOWN)\r
	@ApiLevel=4\r
	@ScriptName=GameOver\r
	@Tip = %(T_49_META_TYP_31_I92_D)\r
    SFX_WS_ResultBanner = SOUND_WS_RESULTBANNER #%(T_46_META_WS_E_GAMEOVER)\r
	@ApiLevel=4\r
	@ScriptName=EliminationNotification\r
	@Tip = %(T_49_META_TYP_31_I93_D)\r
    SFX_WS_Kill = SOUND_WS_KILL #%(T_46_META_WS_E_ELIMINATIONNOTIFICATION)\r
	@ApiLevel=4\r
	@ScriptName=Boom\r
	@Tip = %(T_49_META_TYP_31_I94_D)\r
    SFX_WS_Kill_Enemy = SOUND_WS_KILL_ENEMY #%(T_46_META_WS_E_BOOM)\r
	@ApiLevel=4\r
	@ScriptName=ExplosivePaintSkill\r
	@Tip = %(T_49_META_TYP_31_I95_D)\r
    SFX_WS_Skill_Bomb = SOUND_WS_SKILL_BOMB #%(T_46_META_WS_E_EXPLOSIVEPAINTSKILL)\r
	@ApiLevel=4\r
	@ScriptName=PaintShieldSkill\r
	@Tip = %(T_49_META_TYP_31_I96_D)\r
    SFX_WS_Skill_BloodPool = SOUND_WS_SKILL_BLOODPOOL #%(T_46_META_WS_E_PAINTSHIELDSKILL)\r
	@ApiLevel=4\r
	@ScriptName=TUNG\r
	@Tip = %(T_49_YU_QCITEM_ALL_11)\r
    SFX_WS_SOUND_TUNG_VOICE_ITEM_01_EN = SOUND_TUNG_VOICE_ITEM_01_EN #%(T_49_YU_QCITEM_ALL_11)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SortType\r
@Tip = %(T_49_META_TYPE_33_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum SortType : Int = 33 { #%(T_46_META_WS_C_SORTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=AscIgnoreZero\r
	@Tip = %(T_49_META_TYP_33_I0_D)\r
    AscIgnoreZero = 0 #%(T_46_META_WS_E_ASCIGNOREZERO)\r
	@ApiLevel=4\r
	@ScriptName=Desc\r
	@Tip = %(T_49_META_TYP_33_I1_D)\r
    Desc = 1 #%(T_46_META_WS_E_DESC)\r
	@ApiLevel=4\r
	@ScriptName=Asc\r
	@Tip = %(T_49_META_TYP_33_I2_D)\r
    Asc = 2 #%(T_46_META_WS_E_ASC)\r
}\r
\r
@Accept ItemID\r
@ApiLevel=4\r
@ScriptName=ItemIDType\r
@Tip = %(T_49_META_TYPE_34_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum ItemGoodsIDType : ItemID = 34 { #%(T_46_META_WS_C_ITEMIDTYPE)\r
	@ApiLevel=4\r
	@ScriptName=DefaultFist\r
	@Tip = %(T_49_META_TYP_34_I0_D)\r
    DefaultFIST = 1 #%(T_46_META_WS_E_DEFAULTFIST)\r
	@ApiLevel=4\r
	@ScriptName=Kar98K\r
	@Tip = %(T_49_META_TYP_34_I1_D)\r
    KAR98K = 21 #%(T_46_META_WS_E_KAR98K)\r
	@ApiLevel=4\r
	@ScriptName=CrossBow\r
	@Tip = %(T_49_META_TYP_34_I2_D)\r
    CROSSBOW = 22 #%(T_46_META_WS_E_CROSSBOW)\r
	@ApiLevel=4\r
	@ScriptName=FootballShield\r
	@Tip = %(T_49_META_TYP_34_I3_D)\r
    FootballShield = 6402 #%(T_46_META_WS_E_FOOTBALLSHIELD)\r
	@ApiLevel=4\r
	@ScriptName=FootballIce\r
	@Tip = %(T_49_META_TYP_34_I4_D)\r
    FootballIce = 6403 #%(T_46_META_WS_E_FOOTBALLICE)\r
	@ApiLevel=4\r
	@ScriptName=Bizon\r
	@Tip = %(T_49_META_TYP_34_I5_D)\r
    Bizon = 150 #%(T_46_META_WS_E_BIZON)\r
	@ApiLevel=4\r
	@ScriptName=VSK94\r
	@Tip = %(T_49_META_TYP_34_I6_D)\r
    VSK94 = 197 #%(T_46_META_WS_E_VSK94)\r
	@ApiLevel=4\r
	@ScriptName=M4A1\r
	@Tip = %(T_49_META_TYP_34_I7_D)\r
    M4A1 = 2 #%(T_46_META_WS_E_M4A1)\r
	@ApiLevel=4\r
	@ScriptName=USP\r
	@Tip = %(T_49_META_TYP_34_I8_D)\r
    USP = 3 #%(T_46_META_WS_E_USP)\r
	@ApiLevel=4\r
	@ScriptName=AWM\r
	@Tip = %(T_49_META_TYP_34_I9_D)\r
    AWM = 4 #%(T_46_META_WS_E_AWM)\r
	@ApiLevel=4\r
	@ScriptName=AWM2\r
	@Tip = %(T_49_META_TYP_34_I10_D)\r
    AWM2 = 172 #%(T_46_META_WS_E_AWM2)\r
	@ApiLevel=4\r
	@ScriptName=M1014\r
	@Tip = %(T_49_META_TYP_34_I11_D)\r
    M1014 = 5 #%(T_46_META_WS_E_M1014)\r
	@ApiLevel=4\r
	@ScriptName=M10142\r
	@Tip = %(T_49_META_TYP_34_I12_D)\r
    M10142 = 163 #%(T_46_META_WS_E_M10142)\r
	@ApiLevel=4\r
	@ScriptName=FGL24\r
	@Tip = %(T_49_META_TYP_34_I13_D)\r
    FGL24 = 196 #%(T_46_META_WS_E_FGL24)\r
	@ApiLevel=4\r
	@ScriptName=AK\r
	@Tip = %(T_49_META_TYP_34_I14_D)\r
    AK = 6 #%(T_46_META_WS_E_AK)\r
	@ApiLevel=4\r
	@ScriptName=AK2\r
	@Tip = %(T_49_META_TYP_34_I15_D)\r
    AK2 = 154 #%(T_46_META_WS_E_AK2)\r
	@ApiLevel=4\r
	@ScriptName=UMP\r
	@Tip = %(T_49_META_TYP_34_I16_D)\r
    UMP = 7 #%(T_46_META_WS_E_UMP)\r
	@ApiLevel=4\r
	@ScriptName=UMP2\r
	@Tip = %(T_49_META_TYP_34_I17_D)\r
    UMP2 = 169 #%(T_46_META_WS_E_UMP2)\r
	@ApiLevel=4\r
	@ScriptName=MP5\r
	@Tip = %(T_49_META_TYP_34_I18_D)\r
    MP5 = 8 #%(T_46_META_WS_E_MP5)\r
	@ApiLevel=4\r
	@ScriptName=EAGLE\r
	@Tip = %(T_49_META_TYP_34_I19_D)\r
    EAGLE = 9 #%(T_46_META_WS_E_EAGLE)\r
	@ApiLevel=4\r
	@ScriptName=G18\r
	@Tip = %(T_49_META_TYP_34_I20_D)\r
    G18 = 10 #%(T_46_META_WS_E_G18)\r
	@ApiLevel=4\r
	@ScriptName=M14\r
	@Tip = %(T_49_META_TYP_34_I21_D)\r
    M14 = 11 #%(T_46_META_WS_E_M14)\r
	@ApiLevel=4\r
	@ScriptName=SCAR\r
	@Tip = %(T_49_META_TYP_34_I22_D)\r
    SCAR = 12 #%(T_46_META_WS_E_SCAR)\r
	@ApiLevel=4\r
	@ScriptName=SCAR2\r
	@Tip = %(T_49_META_TYP_34_I23_D)\r
    SCAR2 = 156 #%(T_46_META_WS_E_SCAR2)\r
	@ApiLevel=4\r
	@ScriptName=GOLD_SCAR_I\r
	@Tip = %(T_49_META_TYP_34_I24_D)\r
    GOLD_SCAR_I = 178 #%(T_46_META_WS_E_GOLD_SCAR_I)\r
	@ApiLevel=4\r
	@ScriptName=GOLD_SCAR_II\r
	@Tip = %(T_49_META_TYP_34_I25_D)\r
    GOLD_SCAR_II = 179 #%(T_46_META_WS_E_GOLD_SCAR_II)\r
	@ApiLevel=4\r
	@ScriptName=GOLD_SCAR_III\r
	@Tip = %(T_49_META_TYP_34_I26_D)\r
    GOLD_SCAR_III = 180 #%(T_46_META_WS_E_GOLD_SCAR_III)\r
	@ApiLevel=4\r
	@ScriptName=GOLD_M1014_I\r
	@Tip = %(T_49_META_TYP_34_I27_D)\r
    GOLD_M1014_I = 184 #%(T_46_META_WS_E_GOLD_M1014_I)\r
	@ApiLevel=4\r
	@ScriptName=GOLD_M1014_II\r
	@Tip = %(T_49_META_TYP_34_I28_D)\r
    GOLD_M1014_II = 185 #%(T_46_META_WS_E_GOLD_M1014_II)\r
	@ApiLevel=4\r
	@ScriptName=GOLD_M1014_III\r
	@Tip = %(T_49_META_TYP_34_I29_D)\r
    GOLD_M1014_III = 186 #%(T_46_META_WS_E_GOLD_M1014_III)\r
	@ApiLevel=4\r
	@ScriptName=HeatGun\r
	@Tip = %(T_49_META_TYP_34_I30_D)\r
    HEATGUN = 39 #%(T_46_META_WS_E_HEATGUN)\r
	@ApiLevel=4\r
	@ScriptName=GOLD_HEATGUN_I\r
	@Tip = %(T_49_META_TYP_34_I31_D)\r
    GOLD_HEATGUN_I = 66 #%(T_46_META_WS_E_GOLD_HEATGUN_I)\r
	@ApiLevel=4\r
	@ScriptName=GOLD_HEATGUN_II\r
	@Tip = %(T_49_META_TYP_34_I32_D)\r
    GOLD_HEATGUN_II = 132 #%(T_46_META_WS_E_GOLD_HEATGUN_II)\r
	@ApiLevel=4\r
	@ScriptName=GOLD_HEATGUN_III\r
	@Tip = %(T_49_META_TYP_34_I33_D)\r
    GOLD_HEATGUN_III = 133 #%(T_46_META_WS_E_GOLD_HEATGUN_III)\r
	@ApiLevel=4\r
	@ScriptName=PLASMA_X\r
	@Tip = %(T_49_META_TYP_34_I34_D)\r
    PLASMA_X = 199 #%(T_46_META_WS_E_PLASMA_X)\r
	@ApiLevel=4\r
	@ScriptName=HealingPistol_X\r
	@Tip = %(T_49_META_TYP_34_I35_D)\r
    HealingPistol_X = 21001 #%(T_46_META_WS_E_HEALINGPISTOL_X)\r
	@ApiLevel=4\r
	@ScriptName=Healinggun_Sniper\r
	@Tip = %(T_49_META_TYP_34_I36_D)\r
    Healinggun_Sniper = 78 #%(T_46_META_WS_E_HEALINGGUN_SNIPER)\r
	@ApiLevel=4\r
	@ScriptName=HealPistol\r
	@Tip = %(T_49_META_TYP_34_I37_D)\r
    TREATMENTGUN = 93 #%(T_46_META_WS_E_HEALPISTOL)\r
	@ApiLevel=4\r
	@ScriptName=VSS\r
	@Tip = %(T_49_META_TYP_34_I38_D)\r
    VSS = 13 #%(T_46_META_WS_E_VSS)\r
	@ApiLevel=4\r
	@ScriptName=GROZA\r
	@Tip = %(T_49_META_TYP_34_I39_D)\r
    GROZA = 14 #%(T_46_META_WS_E_GROZA)\r
	@ApiLevel=4\r
	@ScriptName=GROZA2\r
	@Tip = %(T_49_META_TYP_34_I40_D)\r
    GROZA2 = 153 #%(T_46_META_WS_E_GROZA2)\r
	@ApiLevel=4\r
	@ScriptName=MP40\r
	@Tip = %(T_49_META_TYP_34_I41_D)\r
    MP40 = 15 #%(T_46_META_WS_E_MP40)\r
	@ApiLevel=4\r
	@ScriptName=MP402\r
	@Tip = %(T_49_META_TYP_34_I42_D)\r
    MP402 = 164 #%(T_46_META_WS_E_MP402)\r
	@ApiLevel=4\r
	@ScriptName=Pot\r
	@Tip = %(T_49_META_TYP_34_I43_D)\r
    CHANGUO = 16 #%(T_46_META_WS_E_POT)\r
	@ApiLevel=4\r
	@ScriptName=Machete\r
	@Tip = %(T_49_META_TYP_34_I44_D)\r
    MACHETE = 17 #%(T_46_META_WS_E_MACHETE)\r
	@ApiLevel=4\r
	@ScriptName=SKS\r
	@Tip = %(T_49_META_TYP_34_I45_D)\r
    SKS = 18 #%(T_46_META_WS_E_SKS)\r
	@ApiLevel=4\r
	@ScriptName=M249\r
	@Tip = %(T_49_META_TYP_34_I46_D)\r
    M249 = 19 #%(T_46_META_WS_E_M249)\r
	@ApiLevel=4\r
	@ScriptName=M2492\r
	@Tip = %(T_49_META_TYP_34_I47_D)\r
    M2492 = 71 #%(T_46_META_WS_E_M2492)\r
	@ApiLevel=4\r
	@ScriptName=M1873\r
	@Tip = %(T_49_META_TYP_34_I48_D)\r
    M1873 = 20 #%(T_46_META_WS_E_M1873)\r
	@ApiLevel=4\r
	@ScriptName=M79\r
	@Tip = %(T_49_META_TYP_34_I49_D)\r
    M79 = 23 #%(T_46_META_WS_E_M79)\r
	@ApiLevel=4\r
	@ScriptName=FAMAS\r
	@Tip = %(T_49_META_TYP_34_I50_D)\r
    FAMAS = 24 #%(T_46_META_WS_E_FAMAS)\r
	@ApiLevel=4\r
	@ScriptName=M500\r
	@Tip = %(T_49_META_TYP_34_I51_D)\r
    M500 = 25 #%(T_46_META_WS_E_M500)\r
	@ApiLevel=4\r
	@ScriptName=SVD\r
	@Tip = %(T_49_META_TYP_34_I52_D)\r
    SVD = 26 #%(T_46_META_WS_E_SVD)\r
	@ApiLevel=4\r
	@ScriptName=SVD2\r
	@Tip = %(T_49_META_TYP_34_I53_D)\r
    SVD2 = 170 #%(T_46_META_WS_E_SVD2)\r
	@ApiLevel=4\r
	@ScriptName=AC80\r
	@Tip = %(T_49_META_TYP_34_I54_D)\r
    AC80 = 89 #%(T_46_META_WS_E_AC80)\r
	@ApiLevel=4\r
	@ScriptName=BaseballPole\r
	@Tip = %(T_49_META_TYP_34_I55_D)\r
    BASEBALLPOLE = 27 #%(T_46_META_WS_E_BASEBALLPOLE)\r
	@ApiLevel=4\r
	@ScriptName=XM8\r
	@Tip = %(T_49_META_TYP_34_I56_D)\r
    XM8 = 28 #%(T_46_META_WS_E_XM8)\r
	@ApiLevel=4\r
	@ScriptName=XM82\r
	@Tip = %(T_49_META_TYP_34_I57_D)\r
    XM82 = 159 #%(T_46_META_WS_E_XM82)\r
	@ApiLevel=4\r
	@ScriptName=SPAS12\r
	@Tip = %(T_49_META_TYP_34_I58_D)\r
    SPAS12 = 29 #%(T_46_META_WS_E_SPAS12)\r
	@ApiLevel=4\r
	@ScriptName=SPAS122\r
	@Tip = %(T_49_META_TYP_34_I59_D)\r
    SPAS122 = 162 #%(T_46_META_WS_E_SPAS122)\r
	@ApiLevel=4\r
	@ScriptName=M60\r
	@Tip = %(T_49_META_TYP_34_I60_D)\r
    M60 = 30 #%(T_46_META_WS_E_M60)\r
	@ApiLevel=4\r
	@ScriptName=MGL140\r
	@Tip = %(T_49_META_TYP_34_I61_D)\r
    MGL140 = 31 #%(T_46_META_WS_E_MGL140)\r
	@ApiLevel=4\r
	@ScriptName=P90\r
	@Tip = %(T_49_META_TYP_34_I62_D)\r
    P90 = 32 #%(T_46_META_WS_E_P90)\r
	@ApiLevel=4\r
	@ScriptName=P902\r
	@Tip = %(T_49_META_TYP_34_I63_D)\r
    P902 = 166 #%(T_46_META_WS_E_P902)\r
	@ApiLevel=4\r
	@ScriptName=AN94\r
	@Tip = %(T_49_META_TYP_34_I64_D)\r
    AN94 = 33 #%(T_46_META_WS_E_AN94)\r
	@ApiLevel=4\r
	@ScriptName=Katana\r
	@Tip = %(T_49_META_TYP_34_I65_D)\r
    KATANA = 34 #%(T_46_META_WS_E_KATANA)\r
	@ApiLevel=4\r
	@ScriptName=CG15\r
	@Tip = %(T_49_META_TYP_34_I66_D)\r
    CG15 = 35 #%(T_46_META_WS_E_CG15)\r
	@ApiLevel=4\r
	@ScriptName=RG550\r
	@Tip = %(T_49_META_TYP_34_I67_D)\r
    RG550 = 36 #%(T_46_META_WS_E_RG550)\r
	@ApiLevel=4\r
	@ScriptName=Gatling\r
	@Tip = %(T_49_META_TYP_34_I68_D)\r
    GATLING = 37 #%(T_46_META_WS_E_GATLING)\r
	@ApiLevel=4\r
	@ScriptName=HookGun\r
	@Tip = %(T_49_META_TYPE_237_D)\r
    GRAPPLINGHOOKGUN = 38 #%(T_46_META_WS_E_HOOKGUN)\r
	@ApiLevel=3\r
	@ScriptName=NewHookGun\r
	@Tip = %(T_49_META_TYP_34_I70_D)\r
    NEWGRAPPLINGHOOKGUN = 19001 #%(T_40_XYL_WS_NEWHOOKGUN)\r
	@ApiLevel=4\r
	@ScriptName=ThrowingKnife\r
	@Tip = %(T_49_META_TYP_34_I71_D)\r
    THROWINGKNIFE = 40 #%(T_46_META_WS_E_THROWINGKNIFE)\r
	@ApiLevel=4\r
	@ScriptName=M1887\r
	@Tip = %(T_49_META_TYP_34_I72_D)\r
    M1887 = 41 #%(T_46_META_WS_E_M1887)\r
	@ApiLevel=4\r
	@ScriptName=M1887X\r
	@Tip = %(T_49_META_TYP_34_I73_D)\r
    M1887X = 119 #%(T_46_META_WS_E_M1887X)\r
	@ApiLevel=4\r
	@ScriptName=M18872\r
	@Tip = %(T_49_META_TYP_34_I74_D)\r
    M18872 = 161 #%(T_46_META_WS_E_M18872)\r
	@ApiLevel=4\r
	@ScriptName=THOMPSON\r
	@Tip = %(T_49_META_TYP_34_I75_D)\r
    THOMPSON = 43 #%(T_46_META_WS_E_THOMPSON)\r
	@ApiLevel=4\r
	@ScriptName=THOMPSON2\r
	@Tip = %(T_49_META_TYP_34_I76_D)\r
    THOMPSON2 = 168 #%(T_46_META_WS_E_THOMPSON2)\r
	@ApiLevel=4\r
	@ScriptName=BLT\r
	@Tip = %(T_49_META_TYP_34_I77_D)\r
    BLT = 45 #%(T_46_META_WS_E_BLT)\r
	@ApiLevel=4\r
	@ScriptName=BLT2\r
	@Tip = %(T_49_META_TYP_34_I78_D)\r
    BLT2 = 173 #%(T_46_META_WS_E_BLT2)\r
	@ApiLevel=4\r
	@ScriptName=AUG\r
	@Tip = %(T_49_META_TYP_34_I79_D)\r
    AUG = 46 #%(T_46_META_WS_E_AUG)\r
	@ApiLevel=4\r
	@ScriptName=PARAFAL\r
	@Tip = %(T_49_META_TYP_34_I80_D)\r
    PARAFAL = 47 #%(T_46_META_WS_E_PARAFAL)\r
	@ApiLevel=4\r
	@ScriptName=PARAFAL2\r
	@Tip = %(T_49_META_TYP_34_I81_D)\r
    PARAFAL2 = 158 #%(T_46_META_WS_E_PARAFAL2)\r
	@ApiLevel=4\r
	@ScriptName=M21A5\r
	@Tip = %(T_49_META_TYP_34_I82_D)\r
    M21A5 = 48 #%(T_46_META_WS_E_M21A5)\r
	@ApiLevel=4\r
	@ScriptName=VECTOR\r
	@Tip = %(T_49_META_TYP_34_I83_D)\r
    VECTOR = 49 #%(T_46_META_WS_E_VECTOR)\r
	@ApiLevel=4\r
	@ScriptName=MAG7\r
	@Tip = %(T_49_META_TYP_34_I84_D)\r
    MAG7 = 50 #%(T_46_META_WS_E_MAG7)\r
	@ApiLevel=4\r
	@ScriptName=MAG72\r
	@Tip = %(T_49_META_TYP_34_I85_D)\r
    MAG72 = 160 #%(T_46_META_WS_E_MAG72)\r
	@ApiLevel=4\r
	@ScriptName=Sickle\r
	@Tip = %(T_49_META_TYP_34_I86_D)\r
    SICKLE = 51 #%(T_46_META_WS_E_SICKLE)\r
	@ApiLevel=4\r
	@ScriptName=BigHeadHammer\r
	@Tip = %(T_49_META_TYP_34_I87_D)\r
    BigHeadHammer = 52 #%(T_46_META_WS_E_BIGHEADHAMMER)\r
	@ApiLevel=4\r
	@ScriptName=Knife\r
	@Tip = %(T_49_META_TYP_34_I88_D)\r
    Knife = 53 #%(T_46_META_WS_E_KNIFE)\r
	@ApiLevel=4\r
	@ScriptName=Kord\r
	@Tip = %(T_49_META_TYP_34_I89_D)\r
    Kord = 54 #%(T_46_META_WS_E_KORD)\r
	@ApiLevel=4\r
	@ScriptName=M1917\r
	@Tip = %(T_49_META_TYP_34_I90_D)\r
    M1917 = 55 #%(T_46_META_WS_E_M1917)\r
	@ApiLevel=4\r
	@ScriptName=USP_2\r
	@Tip = %(T_49_META_TYP_34_I91_D)\r
    USP-2 = 56 #%(T_46_META_WS_E_USP_2)\r
	@ApiLevel=4\r
	@ScriptName=AR15\r
	@Tip = %(T_49_META_TYP_34_I92_D)\r
    AR15 = 57 #%(T_46_META_WS_E_AR15)\r
	@ApiLevel=4\r
	@ScriptName=UZI\r
	@Tip = %(T_49_META_TYP_34_I93_D)\r
    UZI = 58 #%(T_46_META_WS_E_UZI)\r
	@ApiLevel=4\r
	@ScriptName=GoldMP5_I\r
	@Tip = %(T_49_META_TYP_34_I94_D)\r
    GoldMP5_1 = 60 #%(T_46_META_WS_E_GOLDMP5_I)\r
	@ApiLevel=4\r
	@ScriptName=GoldM60_I\r
	@Tip = %(T_49_META_TYP_34_I95_D)\r
    GoldM60_1 = 61 #%(T_46_META_WS_E_GOLDM60_I)\r
	@ApiLevel=4\r
	@ScriptName=GoldVSS_I\r
	@Tip = %(T_49_META_TYP_34_I96_D)\r
    GoldVSS_1 = 62 #%(T_46_META_WS_E_GOLDVSS_I)\r
	@ApiLevel=4\r
	@ScriptName=GoldM14_I\r
	@Tip = %(T_49_META_TYP_34_I97_D)\r
    GoldM14_1 = 63 #%(T_46_META_WS_E_GOLDM14_I)\r
	@ApiLevel=4\r
	@ScriptName=GoldKar98K_I\r
	@Tip = %(T_49_META_TYP_34_I98_D)\r
    GoldKar98K_1 = 64 #%(T_46_META_WS_E_GOLDKAR98K_I)\r
	@ApiLevel=4\r
	@ScriptName=GoldAWM\r
	@Tip = %(T_49_META_TYP_34_I99_D)\r
    GoldAWM = 65 #%(T_46_META_WS_E_GOLDAWM)\r
	@ApiLevel=4\r
	@ScriptName=GoldFamas_I\r
	@Tip = %(T_49_META_TYP_34_I100_D)\r
    GoldFamas-1 = 67 #%(T_46_META_WS_E_GOLDFAMAS_I)\r
	@ApiLevel=4\r
	@ScriptName=GoldGroza\r
	@Tip = %(T_49_META_TYP_34_I101_D)\r
    GoldGroza = 70 #%(T_46_META_WS_E_GOLDGROZA)\r
	@ApiLevel=4\r
	@ScriptName=GoldSVD\r
	@Tip = %(T_49_META_TYP_34_I102_D)\r
    GoldSVD = 72 #%(T_46_META_WS_E_GOLDSVD)\r
	@ApiLevel=4\r
	@ScriptName=G36\r
	@Tip = %(T_49_META_TYP_34_I103_D)\r
    G36 = 73 #%(T_46_META_WS_E_G36)\r
	@ApiLevel=4\r
	@ScriptName=M24\r
	@Tip = %(T_49_META_TYP_34_I104_D)\r
    M24 = 75 #%(T_46_META_WS_E_M24)\r
	@ApiLevel=4\r
	@ScriptName=GoldM4A1_I\r
	@Tip = %(T_49_META_TYP_34_I105_D)\r
    GoldM4A1_1 = 80 #%(T_46_META_WS_E_GOLDM4A1_I)\r
	@ApiLevel=4\r
	@ScriptName=GoldM4A1_II\r
	@Tip = %(T_49_META_TYP_34_I106_D)\r
    GoldM4A1_2 = 81 #%(T_46_META_WS_E_GOLDM4A1_II)\r
	@ApiLevel=4\r
	@ScriptName=GoldM4A1_III\r
	@Tip = %(T_49_META_TYP_34_I107_D)\r
    GoldM4A1_3 = 82 #%(T_46_META_WS_E_GOLDM4A1_III)\r
	@ApiLevel=4\r
	@ScriptName=GoldM4A1_III_ForInfection\r
	@Tip = %(T_49_META_TYP_34_I108_D)\r
    GoldM4A1_3_2 = 155 #%(T_46_META_WS_E_GOLDM4A1_III_FORINFECTION)\r
	@ApiLevel=4\r
	@ScriptName=ChargeBuster\r
	@Tip = %(T_49_META_TYP_34_I109_D)\r
    ChargeBuster = 86 #%(T_46_META_WS_E_CHARGEBUSTER)\r
	@ApiLevel=4\r
	@ScriptName=MAC10\r
	@Tip = %(T_49_META_TYP_34_I110_D)\r
    MAC10 = 88 #%(T_46_META_WS_E_MAC10)\r
	@ApiLevel=4\r
	@ScriptName=HandCannon\r
	@Tip = %(T_49_META_TYP_34_I111_D)\r
    HandCannon = 95 #%(T_46_META_WS_E_HANDCANNON)\r
	@ApiLevel=4\r
	@ScriptName=IceGun\r
	@Tip = %(T_49_META_TYP_34_I112_D)\r
    IceGun = 97 #%(T_46_META_WS_E_ICEGUN)\r
	@ApiLevel=4\r
	@ScriptName=ShieldGun\r
	@Tip = %(T_49_META_TYP_34_I113_D)\r
    ShieldGun = 99 #%(T_46_META_WS_E_SHIELDGUN)\r
	@ApiLevel=4\r
	@ScriptName=GoldMP5_II\r
	@Tip = %(T_49_META_TYP_34_I114_D)\r
    GoldMP5_2 = 120 #%(T_46_META_WS_E_GOLDMP5_II)\r
	@ApiLevel=4\r
	@ScriptName=GoldMP5_III\r
	@Tip = %(T_49_META_TYP_34_I115_D)\r
    GoldMP5_3 = 121 #%(T_46_META_WS_E_GOLDMP5_III)\r
	@ApiLevel=4\r
	@ScriptName=GoldMP5_III_ForInfection\r
	@Tip = %(T_49_META_TYP_34_I116_D)\r
    GoldMP5_3_2 = 165 #%(T_46_META_WS_E_GOLDMP5_III_FORINFECTION)\r
	@ApiLevel=4\r
	@ScriptName=GoldM60_II\r
	@Tip = %(T_49_META_TYP_34_I117_D)\r
    GoldM60_2 = 122 #%(T_46_META_WS_E_GOLDM60_II)\r
	@ApiLevel=4\r
	@ScriptName=GoldM60_III\r
	@Tip = %(T_49_META_TYP_34_I118_D)\r
    GoldM60_3 = 123 #%(T_46_META_WS_E_GOLDM60_III)\r
	@ApiLevel=4\r
	@ScriptName=GoldM60_III_ForInfection\r
	@Tip = %(T_49_META_TYP_34_I119_D)\r
    GoldM60_3_2 = 167 #%(T_46_META_WS_E_GOLDM60_III_FORINFECTION)\r
	@ApiLevel=4\r
	@ScriptName=GoldVSS_II\r
	@Tip = %(T_49_META_TYP_34_I120_D)\r
    GoldVSS_2 = 124 #%(T_46_META_WS_E_GOLDVSS_II)\r
	@ApiLevel=4\r
	@ScriptName=GoldVSS_III\r
	@Tip = %(T_49_META_TYP_34_I121_D)\r
    GoldVSS_3 = 125 #%(T_46_META_WS_E_GOLDVSS_III)\r
	@ApiLevel=4\r
	@ScriptName=GoldM14_II\r
	@Tip = %(T_49_META_TYP_34_I122_D)\r
    GoldM14_2 = 126 #%(T_46_META_WS_E_GOLDM14_II)\r
	@ApiLevel=4\r
	@ScriptName=GoldM14_III\r
	@Tip = %(T_49_META_TYP_34_I123_D)\r
    GoldM14_3 = 127 #%(T_46_META_WS_E_GOLDM14_III)\r
	@ApiLevel=4\r
	@ScriptName=GoldM14_III_ForInfection\r
	@Tip = %(T_49_META_TYP_34_I124_D)\r
    GoldM14_3_2 = 157 #%(T_46_META_WS_E_GOLDM14_III_FORINFECTION)\r
	@ApiLevel=4\r
	@ScriptName=GoldKar98K_II\r
	@Tip = %(T_49_META_TYP_34_I125_D)\r
    GoldKar98K_2 = 128 #%(T_46_META_WS_E_GOLDKAR98K_II)\r
	@ApiLevel=4\r
	@ScriptName=GoldKar98K_III\r
	@Tip = %(T_49_META_TYP_34_I126_D)\r
    GoldKar98K_3 = 129 #%(T_46_META_WS_E_GOLDKAR98K_III)\r
	@ApiLevel=4\r
	@ScriptName=GoldKar98K_III_ForInfection\r
	@Tip = %(T_49_META_TYP_34_I127_D)\r
    GoldKar98K_3_2 = 175 #%(T_46_META_WS_E_GOLDKAR98K_III_FORINFECTION)\r
	@ApiLevel=4\r
	@ScriptName=GoldFamas_II\r
	@Tip = %(T_49_META_TYP_34_I128_D)\r
    GoldFamas-2 = 130 #%(T_46_META_WS_E_GOLDFAMAS_II)\r
	@ApiLevel=4\r
	@ScriptName=GoldFamas_III\r
	@Tip = %(T_49_META_TYP_34_I129_D)\r
    GoldFamas-3 = 131 #%(T_46_META_WS_E_GOLDFAMAS_III)\r
	@ApiLevel=4\r
	@ScriptName=Grenade\r
	@Tip = %(T_49_META_TYP_24_I2_D)\r
    Grenade = 601 #%(T_46_META_WS_E_GRENADE)\r
	@ApiLevel=4\r
	@ScriptName=Flashbang\r
	@Tip = %(T_49_META_TYP_34_I133_D)\r
    FlashGrenade = 602 #%(T_46_META_WS_E_FLASHBANG)\r
	@ApiLevel=4\r
	@ScriptName=SmokeGrenade\r
	@Tip = %(T_49_META_TYP_34_I134_D)\r
    SmokeGrenade = 603 #%(T_46_META_WS_E_SMOKEGRENADE)\r
	@ApiLevel=4\r
	@ScriptName=FlashFreeze\r
	@Tip = %(T_49_META_TYP_34_I135_D)\r
    FlashFreeze = 608 #%(T_46_META_WS_E_FLASHFREEZE)\r
	@ApiLevel=4\r
	@ScriptName=Vest1\r
	@Tip = %(T_49_META_TYP_34_I136_D)\r
    Vest1 = 301 #%(T_46_META_WS_E_VEST1)\r
	@ApiLevel=4\r
	@ScriptName=Vest2\r
	@Tip = %(T_49_META_TYP_34_I137_D)\r
    Vest2 = 302 #%(T_46_META_WS_E_VEST2)\r
	@ApiLevel=4\r
	@ScriptName=Vest3\r
	@Tip = %(T_49_META_TYP_34_I138_D)\r
    Vest3 = 303 #%(T_46_META_WS_E_VEST3)\r
	@ApiLevel=4\r
	@ScriptName=Helmet1\r
	@Tip = %(T_49_META_TYP_34_I139_D)\r
    Helmet1 = 304 #%(T_46_META_WS_E_HELMET1)\r
	@ApiLevel=4\r
	@ScriptName=Helmet2\r
	@Tip = %(T_49_META_TYP_34_I140_D)\r
    Helmet2 = 305 #%(T_46_META_WS_E_HELMET2)\r
	@ApiLevel=4\r
	@ScriptName=Helmet3\r
	@Tip = %(T_49_META_TYP_34_I141_D)\r
    Helmet3 = 306 #%(T_46_META_WS_E_HELMET3)\r
	@ApiLevel=4\r
	@ScriptName=Vest4\r
	@Tip = %(T_49_META_TYP_34_I142_D)\r
    Vest4 = 309 #%(T_46_META_WS_E_VEST4)\r
	@ApiLevel=4\r
	@ScriptName=Bag1\r
	@Tip = %(T_49_META_TYP_34_I143_D)\r
    Bag1 = 401 #%(T_46_META_WS_E_BAG1)\r
	@ApiLevel=4\r
	@ScriptName=Bag2\r
	@Tip = %(T_49_META_TYP_34_I144_D)\r
    Bag2 = 402 #%(T_46_META_WS_E_BAG2)\r
	@ApiLevel=4\r
	@ScriptName=Bag3\r
	@Tip = %(T_49_META_TYP_34_I145_D)\r
    Bag3 = 403 #%(T_46_META_WS_E_BAG3)\r
	@ApiLevel=4\r
	@ScriptName=Muzzle1\r
	@Tip = %(T_49_META_TYP_34_I146_D)\r
    Muzzle1 = 501 #%(T_46_META_WS_E_MUZZLE1)\r
	@ApiLevel=4\r
	@ScriptName=Muzzle2\r
	@Tip = %(T_49_META_TYP_34_I147_D)\r
    Muzzle2 = 502 #%(T_46_META_WS_E_MUZZLE2)\r
	@ApiLevel=4\r
	@ScriptName=Muzzle3\r
	@Tip = %(T_49_META_TYP_34_I148_D)\r
    Muzzle3 = 503 #%(T_46_META_WS_E_MUZZLE3)\r
	@ApiLevel=4\r
	@ScriptName=Silencer\r
	@Tip = %(T_49_META_TYP_34_I149_D)\r
    Silencer = 504 #%(T_46_META_WS_E_SILENCER)\r
	@ApiLevel=4\r
	@ScriptName=SMGMuzzle\r
	@Tip = %(T_49_META_TYP_34_I150_D)\r
    SMGMuzzle = 505 #%(T_46_META_WS_E_SMGMUZZLE)\r
	@ApiLevel=4\r
	@ScriptName=ShotgunMuzzle\r
	@Tip = %(T_49_META_TYP_34_I151_D)\r
    ShotgunMuzzle = 506 #%(T_46_META_WS_E_SHOTGUNMUZZLE)\r
	@ApiLevel=4\r
	@ScriptName=Magazine1\r
	@Tip = %(T_49_META_TYP_34_I152_D)\r
    Magezine1 = 511 #%(T_46_META_WS_E_MAGEZINE1)\r
	@ApiLevel=4\r
	@ScriptName=Magazine2\r
	@Tip = %(T_49_META_TYP_34_I153_D)\r
    Magezine2 = 512 #%(T_46_META_WS_E_MAGEZINE2)\r
	@ApiLevel=4\r
	@ScriptName=Magazine3\r
	@Tip = %(T_49_META_TYP_34_I154_D)\r
    Magezine3 = 513 #%(T_46_META_WS_E_MAGEZINE3)\r
	@ApiLevel=4\r
	@ScriptName=DoubleMagazine\r
	@Tip = %(T_49_META_TYP_34_I155_D)\r
    DoubleMagezine = 516 #%(T_46_META_WS_E_DOUBLEMAGEZINE)\r
	@ApiLevel=4\r
	@ScriptName=ARMagazine\r
	@Tip = %(T_49_META_TYP_34_I156_D)\r
    ARMagazine = 517 #%(T_46_META_WS_E_ARMAGAZINE)\r
	@ApiLevel=4\r
	@ScriptName=Foregrip1\r
	@Tip = %(T_49_META_TYP_34_I157_D)\r
    Foregrip1 = 521 #%(T_46_META_WS_E_FOREGRIP1)\r
	@ApiLevel=4\r
	@ScriptName=Foregrip2\r
	@Tip = %(T_49_META_TYP_34_I158_D)\r
    Foregrip2 = 522 #%(T_46_META_WS_E_FOREGRIP2)\r
	@ApiLevel=4\r
	@ScriptName=Foregrip3\r
	@Tip = %(T_49_META_TYP_34_I159_D)\r
    Foregrip3 = 523 #%(T_46_META_WS_E_FOREGRIP3)\r
	@ApiLevel=4\r
	@ScriptName=Bipod\r
	@Tip = %(T_49_META_TYP_34_I160_D)\r
    Bipod = 524 #%(T_46_META_WS_E_BIPOD)\r
	@ApiLevel=4\r
	@ScriptName=FOREGRIP_MR\r
	@Tip = %(T_49_META_TYP_34_I161_D)\r
    FOREGRIP_MR = 525 #%(T_46_META_WS_E_FOREGRIP_MR)\r
	@ApiLevel=4\r
	@ScriptName=STOCK_S\r
	@Tip = %(T_49_META_TYP_34_I162_D)\r
    STOCK_S = 544 #%(T_46_META_WS_E_STOCK_S)\r
	@ApiLevel=4\r
	@ScriptName=STOCK_SR\r
	@Tip = %(T_49_META_TYP_34_I163_D)\r
    STOCK_SR = 545 #%(T_46_META_WS_E_STOCK_SR)\r
	@ApiLevel=4\r
	@ScriptName=ThermalScope\r
	@Tip = %(T_49_META_TYP_34_I164_D)\r
    ThermalScope = 537 #%(T_46_META_WS_E_THERMALSCOPE)\r
	@ApiLevel=4\r
	@ScriptName=Stock1\r
	@Tip = %(T_49_META_TYP_34_I165_D)\r
    Stock1 = 541 #%(T_46_META_WS_E_STOCK1)\r
	@ApiLevel=4\r
	@ScriptName=Stock2\r
	@Tip = %(T_49_META_TYP_34_I166_D)\r
    Stock2 = 542 #%(T_46_META_WS_E_STOCK2)\r
	@ApiLevel=4\r
	@ScriptName=Stock3\r
	@Tip = %(T_49_META_TYP_34_I167_D)\r
    Stock3 = 543 #%(T_46_META_WS_E_STOCK3)\r
	@ApiLevel=4\r
	@ScriptName=Attachment1ForCompatibility\r
	@Tip = %(T_49_META_TYP_34_I168_D)\r
    Attachment1 = 5601 #%(T_46_META_WS_E_ATTACHMENT1FORCOMPATIBILITY)\r
	@ApiLevel=4\r
	@ScriptName=Attachment4ForCompatibility\r
	@Tip = %(T_49_META_TYP_34_I169_D)\r
    Attachment4 = 5604 #%(T_46_META_WS_E_ATTACHMENT4FORCOMPATIBILITY)\r
	@ApiLevel=4\r
	@ScriptName=Attachment5ForCompatibility\r
	@Tip = %(T_49_META_TYP_34_I170_D)\r
    Attachment5 = 5605 #%(T_46_META_WS_E_ATTACHMENT5FORCOMPATIBILITY)\r
	@ApiLevel=4\r
	@ScriptName=Attachment6ForCompatibility\r
	@Tip = %(T_49_META_TYP_34_I171_D)\r
    Attachment6 = 5606 #%(T_46_META_WS_E_ATTACHMENT6FORCOMPATIBILITY)\r
	@ApiLevel=4\r
	@ScriptName=Attachment8ForCompatibility\r
	@Tip = %(T_49_META_TYP_34_I172_D)\r
    Attachment8 = 5607 #%(T_46_META_WS_E_ATTACHMENT8FORCOMPATIBILITY)\r
	@ApiLevel=4\r
	@ScriptName=Inhaler\r
	@Tip = %(T_49_META_TYP_34_I173_D)\r
    Inhaler = 213 #%(T_46_META_WS_E_INHALER)\r
	@ApiLevel=4\r
	@ScriptName=Cardiotonic\r
	@Tip = %(T_49_META_TYP_34_I174_D)\r
    Cardiac = 108 #%(T_46_META_WS_E_CARDIOTONIC)\r
	@ApiLevel=4\r
	@ScriptName=MedKit\r
	@Tip = %(T_49_META_TYP_34_I175_D)\r
    Fak = 102 #%(T_46_META_WS_E_MEDKIT)\r
	@ApiLevel=4\r
	@ScriptName=RepairKit\r
	@Tip = %(T_49_META_TYP_34_I176_D)\r
    ArmorRepair = 106 #%(T_46_META_WS_E_REPAIRKIT)\r
	@ApiLevel=4\r
	@ScriptName=MiniHandle\r
	@Tip = %(T_49_META_TYP_34_I177_D)\r
    MiniHandle = 2102 #%(T_46_META_WS_E_MINIHANDLE)\r
	@ApiLevel=4\r
	@ScriptName=Mushroom1\r
	@Tip = %(T_49_META_TYP_34_I178_D)\r
    Mushroom1 = 701 #%(T_46_META_WS_E_MUSHROOM1)\r
	@ApiLevel=4\r
	@ScriptName=Mushroom2\r
	@Tip = %(T_49_META_TYP_34_I179_D)\r
    Mushroom2 = 702 #%(T_46_META_WS_E_MUSHROOM2)\r
	@ApiLevel=4\r
	@ScriptName=Mushroom3\r
	@Tip = %(T_49_META_TYP_34_I180_D)\r
    Mushroom3 = 703 #%(T_46_META_WS_E_MUSHROOM3)\r
	@ApiLevel=4\r
	@ScriptName=Mushroom4\r
	@Tip = %(T_49_META_TYP_34_I181_D)\r
    Mushroom4 = 707 #%(T_46_META_WS_E_MUSHROOM4)\r
	@ApiLevel=4\r
	@ScriptName=UAVLite\r
	@Tip = %(T_49_META_TYP_34_I182_D)\r
    UAVLite = 1006 #%(T_46_META_WS_E_UAVLITE)\r
	@ApiLevel=4\r
	@ScriptName=GlooWall\r
	@Tip = %(T_49_META_TYPE_235_D)\r
    GlooWall = 1201 #%(T_46_META_WS_E_GLOOWALL)\r
	@ApiLevel=4\r
	@ScriptName=Landmine\r
	@Tip = %(T_49_META_TYP_34_I184_D)\r
    Landmine = 1401 #%(T_46_META_WS_E_LANDMINE)\r
	@ApiLevel=4\r
	@ScriptName=Flyshoe\r
	@Tip = %(T_49_META_TYP_34_I185_D)\r
    Flyshoe = 1601 #%(T_46_META_WS_E_FLYSHOE)\r
	@ApiLevel=4\r
	@ScriptName=DoubleJumpShoe\r
	@Tip = %(T_49_META_TYP_34_I186_D)\r
    DoublejumpShoe = 1602 #%(T_46_META_WS_E_DOUBLEJUMPSHOE)\r
	@ApiLevel=4\r
	@ScriptName=Foldwings\r
	@Tip = %(T_49_META_TYP_34_I187_D)\r
    Foldwings = 2003 #%(T_46_META_WS_E_FOLDWINGS)\r
	@ApiLevel=4\r
	@ScriptName=Dummy\r
	@Tip = %(T_49_META_TYP_34_I188_D)\r
    Dummy = 2401 #%(T_46_META_WS_E_DUMMY)\r
	@ApiLevel=4\r
	@ScriptName=ElectricSurfboard\r
	@Tip = %(T_49_META_TYP_34_I189_D)\r
    ElectricSurfboard = 2501 #%(T_46_META_WS_E_ELECTRICSURFBOARD)\r
	@ApiLevel=4\r
	@ScriptName=BombPliers\r
	@Tip = %(T_49_META_TYP_34_I190_D)\r
    BombPliers = 2801 #%(T_46_META_WS_E_BOMBPLIERS)\r
	@ApiLevel=4\r
	@ScriptName=Replacer\r
	@Tip = %(T_49_META_TYP_34_I191_D)\r
    Replacer = 3008 #%(T_46_META_WS_E_REPLACER)\r
	@ApiLevel=4\r
	@ScriptName=ARAmmo\r
	@Tip = %(T_49_META_TYP_34_I192_D)\r
    ARAMMO = 201 #%(T_46_META_WS_E_ARAMMO)\r
	@ApiLevel=4\r
	@ScriptName=HGAmmo\r
	@Tip = %(T_49_META_TYP_34_I193_D)\r
    HGAMMO = 202 #%(T_46_META_WS_E_HGAMMO)\r
	@ApiLevel=4\r
	@ScriptName=SNAmmo\r
	@Tip = %(T_49_META_TYP_34_I194_D)\r
    SNAMMO = 203 #%(T_46_META_WS_E_SNAMMO)\r
	@ApiLevel=4\r
	@ScriptName=SGAmmo\r
	@Tip = %(T_49_META_TYP_34_I195_D)\r
    SGAMMO = 204 #%(T_46_META_WS_E_SGAMMO)\r
	@ApiLevel=4\r
	@ScriptName=SMGAmmo\r
	@Tip = %(T_49_META_TYP_34_I196_D)\r
    SMGAMMO = 205 #%(T_46_META_WS_E_SMGAMMO)\r
	@ApiLevel=4\r
	@ScriptName=BOWAmmo\r
	@Tip = %(T_49_META_TYP_34_I197_D)\r
    BOWAMMO = 206 #%(T_46_META_WS_E_BOWAMMO)\r
	@ApiLevel=4\r
	@ScriptName=LauncherAMMO\r
	@Tip = %(T_49_META_TYP_34_I198_D)\r
    LANUNCHERAMMO = 207 #%(T_46_META_WS_E_LANUNCHERAMMO)\r
	@ApiLevel=4\r
	@ScriptName=FlameGun\r
	@Tip = %(T_49_META_TYP_34_I199_D)\r
    FLAMETHROWER = 214 #%(T_46_META_WS_E_FLAMEGUN)\r
	@ApiLevel=4\r
	@ScriptName=ThowingKnife2ForCompatibility\r
	@Tip = %(T_49_META_TYP_34_I200_D)\r
    THROWINGKNIFE2 = 152 #%(T_46_META_WS_E_THOWINGKNIFE2FORCOMPATIBILITY)\r
	@ApiLevel=4\r
	@ScriptName=HookGunAMMO\r
	@Tip = %(T_49_META_TYP_34_I201_D)\r
    GRAPPLINGHOOKAMMO = 209 #%(T_46_META_WS_E_HOOKGUNAMMO)\r
	@ApiLevel=4\r
	@ScriptName=FootballGun\r
	@Tip = %(T_49_META_TYP_34_I202_D)\r
    FOOTBALLGUN = 177 #%(T_46_META_WS_E_FOOTBALLGUN)\r
	@ApiLevel=4\r
	@ScriptName=Fist\r
	@Tip = %(T_49_META_TYP_34_I203_D)\r
    FIST = 17001 #%(T_46_META_WS_E_FIST)\r
	@ApiLevel=4\r
	@ScriptName=HideAndSeekFlamethrower\r
	@Tip = %(T_49_META_TYP_34_I204_D)\r
    FLAMETHROWERDMM = 17002 #%(T_46_META_WS_E_HIDEANDSEEKFLAMETHROWER)\r
	@ApiLevel=4\r
	@ScriptName=\r
    MonkeygodCard = 5611 #%(T_12_R_SKILL_NAME_MONKEYGOD)\r
	@ApiLevel=4\r
	@ScriptName=\r
    MadeManACard = 5612 #%(T_33_C_SKILL_NAME_MADEMANA)\r
	@ApiLevel=4\r
	@ScriptName=\r
    DjmaleCard = 5613 #%(T_18_C_SKILL_NAME_DJMALE)\r
	@ApiLevel=4\r
	@ScriptName=\r
    GraffitistCard = 5614 #%(T_20_C_SKILL_NAME_GRAFFITIST)\r
	@ApiLevel=4\r
	@ScriptName=\r
    DetectiveCard = 5615 #%(T_22_C_SKILL_NAME_DETECTIVE)\r
	@ApiLevel=4\r
	@ScriptName=\r
    ProfessorCard = 5616 #%(T_24_C_SKILL_NAME_PROFESSOR)\r
	@ApiLevel=4\r
	@ScriptName=\r
    BountyHunterCard = 5617 #%(T_25_C_SKILL_NAME_BOUNTYHUNTER)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SuperstarCard = 5618 #%(T_26_C_SKILL_NAME_SUPERSTAR)\r
	@ApiLevel=4\r
	@ScriptName=\r
    XtremeCard = 5619 #%(T_27_C_SKILL_NAME_XTREME)\r
	@ApiLevel=4\r
	@ScriptName=\r
    MusicBroCard = 5620 #%(T_29_C_SKILL_NAME_MUSICBRO_WHITE)\r
	@ApiLevel=4\r
	@ScriptName=\r
    KentaCard = 5621 #%(T_42_WH_ITEM_SKILLCARD)\r
	@ApiLevel=4\r
	@ScriptName=\r
    TRACKERCard = 5622 #%(T_34_C_SKILL_NAME_TRACKER)\r
	@ApiLevel=4\r
	@ScriptName=\r
    CrazygirlCard = 5623 #%(T_35_JL_SKILL_NAME_CRAZYGIRL)\r
	@ApiLevel=4\r
	@ScriptName=\r
    RunSpeedUpCard = 5624 #%(T_32_C_SKILL_NAME_YAKUZA)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SantinoCard = 5625 #%(T_38_BQ_SKILL_NAME_DUMMY1)\r
	@ApiLevel=4\r
	@ScriptName=\r
    VillainCard = 5626 #%(T_39_BQ_SKILL_NAME_VILLAIN)\r
	@ApiLevel=4\r
	@ScriptName=\r
	@Tip = %(T_42_WH_ITEM_HEALUAV_DESC)\r
    HealUAV = 92103 #%(T_42_WH_ITEM_HEALUAV)\r
	@ApiLevel=4\r
	@ScriptName=\r
	@Tip = %(T_37_RW_LOADOUT_BORNFIRETAG)\r
    NewLoadoutTBonfire = 1001 #%(TXT_OB8_HQW_NEWLOADOUT_BONFIRE)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradIgnis = 91017 #%(T_41_WT_SKILL_NAME_FIREBOY)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradKoda = 91055 #%(T_47_B_SKILL_NAME_AURORABOY)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradCamouflage = 91037 #%(T_12_R_SKILL_NAME_MONKEYGOD)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradThrillOfBattle = 91038 #%(T_33_C_SKILL_NAME_MADEMANA)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradDropTheBeat = 91039 #%(T_18_C_SKILL_NAME_DJMALE)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradPaintedRefuge = 91040 #%(T_20_C_SKILL_NAME_GRAFFITIST)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradTracingSteps = 91041 #%(T_22_C_SKILL_NAME_DETECTIVE)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradMasterOfAll = 91042 #%(T_24_C_SKILL_NAME_PROFESSOR)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradTimeTurner = 91043 #%(T_25_C_SKILL_NAME_BOUNTYHUNTER)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradRiptideRhythm = 91044 #%(T_26_C_SKILL_NAME_SUPERSTAR)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradXtremeEncounter = 91045 #%(T_27_C_SKILL_NAME_XTREME)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradHealingHeartbeat = 91046 #%(T_29_C_SKILL_NAME_MUSICBRO_WHITE)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradSwordsmansWrath = 91047 #%(T_33_C_SKILL_NAME_KENTA)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradSensesShockwave = 91048 #%(T_34_C_SKILL_NAME_TRACKER)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradWallBrawl = 91049 #%(T_35_JL_SKILL_NAME_CRAZYGIRL)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradRebelRush = 91050 #%(T_32_C_SKILL_NAME_YAKUZA)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradStuntDouble = 91051 #%(T_38_BQ_SKILL_NAME_DUMMY1)\r
	@ApiLevel=4\r
	@ScriptName=\r
	@Tip = %(T_43_B_SKILL_DESC_ORION)\r
    SkillCradCrimsonCrush = 91052 #%(T_39_BQ_SKILL_NAME_VILLAIN)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradFlameMirage = 91053 #%(T_39_BQ_SKILL_NAME_VILLAIN)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradSpiderTrap = 91054 #%(T_42_B_SKILL_NAME_GEEK)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradAuroraVision = 91057 #%(T_47_B_SKILL_NAME_AURORABOY)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradElectroTherapy = 91060 #%(T_44_B_SKILL_NAME_ELECTRICGIRL)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradValiantDash = 91063 #%(T_48_WT_SKILL_NAME_CITYHEROBOY)\r
	@ApiLevel=4\r
	@ScriptName=\r
	@Tip = %(T_44_QL_GRENADE_DRAGON_DES)\r
    GrenadeDragon = 624 #%(T_44_QL_GRENADE_DRAGON)\r
	@ApiLevel=4\r
	@ScriptName=\r
	@Tip = %(T_37_QL_JUMPPAD_DES)\r
    GrenadeJumpPad = 622 #%(T_37_QL_JUMPPAD_NAME)\r
	@ApiLevel=4\r
	@ScriptName=\r
	@Tip = %(T_43_WH_ITEM_SUPPLYBOX_DESC)\r
    SupplkyBox = 1015 #%(T_43_WH_ITEM_SUPPLYBOX_NAME)\r
	@ApiLevel=4\r
	@ScriptName=\r
	@Tip = %(T_16_Q_MINISENTRY_DESC)\r
    GrenadeMinisentry = 93003 #%(T_16_Q_MINISENTRY)\r
	@ApiLevel=4\r
	@ScriptName=\r
	@Tip = %(T_44_QL_JUMPSHOESX_DES)\r
    JumpShoesX = 1605 #%(T_44_QL_JUMPSHOESX)\r
	@ApiLevel=4\r
	@ScriptName=\r
	@Tip = %(T_45_ZD_VEHICLEDROP_R_DESC)\r
    VehicledropRandom = 92200 #%(T_45_ZD_VEHICLEDROP_R_NAME)\r
	@ApiLevel=4\r
	@ScriptName=\r
	@Tip = %(T_42_RW_PORTALSFORPERSONAL_DESC)\r
    VehicledropRandomPORTALSPERSONAL = 91200 #%(T_42_RW_PORTALSPERSONAL_NAME)\r
	@ApiLevel=3\r
	@ScriptName=\r
	@Tip = %(T_47_WT_W_NB_GP_SRK_HEAVY_DESC)\r
    Shuriken_Heavy = 21003 #%(T_47_WT_W_NB_GP_SRK_HEAVY_NAME)\r
	@ApiLevel=3\r
	@ScriptName=\r
	@Tip = %(T_47_WT_W_NB_GP_SRK_LIGHT_DESC)\r
    Shuriken_Light = 21004 #%(T_47_WT_W_NB_GP_SRK_LIGHT_NAME)\r
	@ApiLevel=3\r
	@ScriptName=\r
	@Tip = %(T_47_WT_W_NB_GP_KA_EXPLODE_DESC)\r
    Kunai_Explode = 10050 #%(T_47_WT_W_NB_GP_KA_EXPLODE_NAME)\r
	@ApiLevel=3\r
	@ScriptName=\r
	@Tip = %(T_47_WT_W_NB_GP_KA_THUNDER_DESC)\r
    Kunai_Thunder = 10051 #%(T_47_WT_W_NB_GP_KA_THUNDER_NAME)\r
	@ApiLevel=3\r
	@ScriptName=\r
	@Tip = %(T_47_WT_W_NB_GP_KA_WIND_DESC)\r
    Kunai_Wind = 10052 #%(T_47_WT_W_NB_GP_KA_WIND_NAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SpecialItemIDType\r
@Tip = %(T_49_META_TYPE_308_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
enum SpecialItemGoodsIDType : ItemID = 308 { #%(T_46_META_WS_C_SPECIALITEMIDTYPE)\r
	@ApiLevel=4\r
	@ScriptName=IceWallMaker\r
	@Tip = %(T_49_META_TYP_308_I0_D)\r
    IceWallMaker = 1299 #%(T_46_META_WS_E_ICEWALLMAKER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UITimerInfo\r
@Tip = %(T_49_META_TYPE_1010_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type CountdownHud : InternalHud = 1010 { #%(T_46_META_WS_C_UITIMERINFO)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1010000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=Duration\r
	@Tip = %(T_49_META_TYP_1010_I1_D)\r
    Duration : Int = -1010001 #%(T_46_META_WS_P_DURATION)\r
	@ApiLevel=4\r
	@ScriptName=BaseTime\r
	@Tip = %(T_49_META_TYP_1010_I2_D)\r
    BaseTime : Int = -1010002 #%(T_46_META_WS_P_BASETIME)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=UpdateType\r
	@Tip = %(T_49_META_TYP_1010_I3_D)\r
    UpdateType : Int = -1010003 #%(T_46_META_WS_P_UPDATETYPE)\r
	@ApiLevel=4\r
	@Default=&math.Vector3(0, -16, 0)\r
	@ScriptName=Offset\r
	@Tip = %(T_49_META_TYP_1010_I4_D)\r
    Offset : Vector3 = -1010004 #%(T_46_META_WS_P_OFFSET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIOpeningBanner\r
@Tip = %(T_49_META_TYPE_1011_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type OpeningBannerHud : InternalHud = 1011 { #%(T_46_META_WS_C_UIOPENINGBANNER)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1011000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=10\r
	@ScriptName=IconName_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    IconSpriteName : String = -1011001 #IconSpriteName\r
	@ApiLevel=4\r
	@ScriptName=ThemeColor\r
	@Tip = %(T_49_META_TYP_1011_I2_D)\r
    ThemeColor : Color = -1011002 #%(T_46_META_WS_P_THEMECOLOR)\r
	@ApiLevel=4\r
	@ScriptName=EnableLocalization\r
	@Tip = %(T_49_META_TYP_1011_I3_D)\r
    LocSwitch : Bool = -1011003 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=Title\r
	@Tip = %(T_49_META_TYP_1011_I4_D)\r
    TitleText : String = -1011004 #%(T_46_META_WS_P_TITLE)\r
	@ApiLevel=4\r
	@ScriptName=Description\r
	@Tip = %(T_49_META_TYP_1011_I5_D)\r
    DescText : String = -1011005 #%(T_46_META_WS_P_DESCRIPTION)\r
	@ApiLevel=4\r
	@ScriptName=Icon\r
	@Tip = %(T_49_META_TYP_1011_I6_D)\r
    Icon : SpriteID = -1011006 #%(T_46_META_WS_P_ICON)\r
	@ApiLevel=4\r
	@ScriptName=MaxProgress\r
	@Tip = %(T_49_META_TYP_1011_I7_D)\r
    MaxProgress : Int = -1011007 #%(T_46_META_WS_P_MAXPROGRESS)\r
	@ApiLevel=4\r
	@ScriptName=CurrentProgress\r
	@Tip = %(T_49_META_TYP_1011_I8_D)\r
    CurProgress : Int = -1011008 #%(T_46_META_WS_P_CURRENTPROGRESS)\r
	@ApiLevel=4\r
	@ScriptName=ProgressIcon\r
	@Tip = %(T_49_META_TYP_1011_I9_D)\r
    ProgressIcon : SpriteID = -1011009 #%(T_46_META_WS_P_PROGRESSICON)\r
	@ApiLevel=4\r
	@ScriptName=ProgressIconName\r
	@Tip = %(T_49_META_TYP_1011_I10_D)\r
    ProgressIconSpriteName : String = -1011010 #%(T_46_META_WS_P_PROGRESSICONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIPersonaChat\r
@Tip = %(T_49_META_TYPE_416_D)\r
@ModuleID=43\r
@ModuleLib=LLM\r
type LLMChatHud : InternalHud = 416 { #%(T_47_XXJ_WS_LLMCHATHUD)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=Visible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    IsVisible : Bool = -416000 #%(T_47_XXJ_WS_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=Target\r
	@Tip = %(T_49_META_TYP_416_I1_D)\r
    BindPersona : PersonaID = -416001 #%(T_46_META_WS_A_TARGET)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
	@Tip = %(T_49_META_TYP_416_I2_D)\r
    Offset : Vector2 = -416002 #%(T_46_META_WS_P_OFFSET)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ShowSystemReply\r
	@Tip = %(T_49_META_TYP_416_I4_D)\r
    ShowSystemReply : Bool = -416004 #%(T_47_XXJ_WS_SHOWSYSTEMREPLY)\r
	@ApiLevel=4\r
	@Default=Persona\r
	@ScriptName=PersonaNickName\r
	@Tip = %(T_49_META_TYP_416_I5_D)\r
    PersonaNickName : String = -416005 #%(T_47_XXJ_WS_PERSONANICKNAME)\r
	@ApiLevel=4\r
	@ScriptName=PersonaAvatar\r
	@Tip = %(T_49_META_TYP_416_I6_D)\r
    PersonaAvatar : SpriteID = -416006 #%(T_47_XXJ_WS_PERSONAAVATAR)\r
	@ApiLevel=4\r
	@ScriptName=UserNickName\r
	@Tip = %(T_49_META_TYP_416_I7_D)\r
    UserNickName : String = -416007 #%(T_47_XXJ_WS_USERNICKNAME)\r
	@ApiLevel=4\r
	@ScriptName=UserAvatar\r
	@Tip = %(T_49_META_TYP_416_I8_D)\r
    UserAvatar : SpriteID = -416008 #%(T_47_XXJ_WS_USERAVATAR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIRoundStartBanner\r
@Tip = %(T_49_META_TYPE_1012_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TwoTeamRoundStartBannerHud : InternalHud = 1012 { #%(T_46_META_WS_C_UIROUNDSTARTBANNER)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1012000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=EnableLocalization\r
	@Tip = %(T_49_META_TYP_1012_I1_D)\r
    LocSwitch : Bool = -1012001 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=RoundNumKey\r
	@Tip = %(T_49_META_TYP_1012_I2_D)\r
    RoundNumLocKey : String = -1012002 #%(T_46_META_WS_P_ROUNDNUMKEY)\r
	@ApiLevel=4\r
	@ScriptName=RoundNumLocKeyParams\r
	@Tip = %(T_49_META_TYP_1012_I3_D)\r
    RoundNumLocKey_Params : ListT_Int = -1012003 #%(T_46_META_WS_P_ROUNDNUMLOCKEYPARAMS)\r
	@ApiLevel=4\r
	@ScriptName=Description\r
	@Tip = %(T_49_META_TYP_1011_I5_D)\r
    DescText : String = -1012004 #%(T_46_META_WS_P_DESCRIPTION)\r
	@ApiLevel=4\r
	@ScriptName=LeftColor\r
	@Tip = %(T_49_META_TYP_1012_I5_D)\r
    LeftColor : Color = -1012005 #%(T_46_META_WS_P_LEFTCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=RightColor\r
	@Tip = %(T_49_META_TYP_1012_I6_D)\r
    RightColor : Color = -1012006 #%(T_46_META_WS_P_RIGHTCOLOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UISimpleRoundStartBanner\r
@Tip = %(T_49_META_TYPE_1013_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type NormalRoundStartBannerHud : InternalHud = 1013 { #%(T_46_META_WS_C_UISIMPLEROUNDSTARTBANNER)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1013000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=EnableLocalization\r
	@Tip = %(T_49_META_TYP_1012_I1_D)\r
    LocSwitch : Bool = -1013001 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=RoundNumKey\r
	@Tip = %(T_49_META_TYP_1013_I2_D)\r
    RoundNumLocKey : String = -1013002 #%(T_46_META_WS_P_ROUNDNUMKEY)\r
	@ApiLevel=4\r
	@ScriptName=RoundNumLocKeyParams\r
	@Tip = %(T_49_META_TYP_1013_I3_D)\r
    RoundNumLocKey_Params : ListT_Int = -1013003 #%(T_46_META_WS_P_ROUNDNUMLOCKEYPARAMS)\r
	@ApiLevel=4\r
	@ScriptName=Description\r
	@Tip = %(T_49_META_TYP_1011_I5_D)\r
    DescText : String = -1013004 #%(T_46_META_WS_P_DESCRIPTION)\r
	@ApiLevel=4\r
	@ScriptName=ThemeColor\r
	@Tip = %(T_49_META_TYP_1011_I2_D)\r
    ThemeColor : Color = -1013005 #%(T_46_META_WS_P_THEMECOLOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UISimpleRoundScoreBanner\r
@Tip = %(T_49_META_TYPE_1014_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TeamRoundScoreBannerHud : InternalHud = 1014 { #%(T_46_META_WS_C_UISIMPLEROUNDSCOREBANNER)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1014000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=EnableLocalization\r
	@Tip = %(T_49_META_TYP_1012_I1_D)\r
    LocSwitch : Bool = -1014001 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=FirstScoreTitle\r
	@Tip = %(T_49_META_TYP_1014_I2_D)\r
    FirstScoreTitleLocKey : String = -1014002 #%(T_46_META_WS_P_FIRSTSCORETITLE)\r
	@ApiLevel=4\r
	@ScriptName=FirstScoreValue\r
	@Tip = %(T_49_META_TYP_1014_I3_D)\r
    FirstScoreValueLocKey : String = -1014003 #%(T_46_META_WS_P_FIRSTSCOREVALUE)\r
	@ApiLevel=4\r
	@ScriptName=FirstScoreParams\r
	@Tip = %(T_49_META_TYP_1014_I4_D)\r
    FirstScoreValueLocKey_Params : ListT_Int = -1014004 #%(T_46_META_WS_P_FIRSTSCOREPARAMS)\r
	@ApiLevel=4\r
	@ScriptName=SecondScoreTitle\r
	@Tip = %(T_49_META_TYP_1014_I5_D)\r
    SecondScoreTitleLocKey : String = -1014005 #%(T_46_META_WS_P_SECONDSCORETITLE)\r
	@ApiLevel=4\r
	@ScriptName=SecondScoreValue\r
	@Tip = %(T_49_META_TYP_1014_I6_D)\r
    SecondScoreValueLocKey : String = -1014006 #%(T_46_META_WS_P_SECONDSCOREVALUE)\r
	@ApiLevel=4\r
	@ScriptName=SecondScoreValueParams\r
	@Tip = %(T_49_META_TYP_1014_I7_D)\r
    SecondScoreValueLocKey_Params : ListT_Int = -1014007 #%(T_46_META_WS_P_SECONDSCOREVALUEPARAMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UICheckPointIndicator\r
@Tip = %(T_49_META_TYPE_1015_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type CheckPointMgrHud : InternalHud = 1015 { #%(T_46_META_WS_C_UICHECKPOINTINDICATOR)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1015000 #%(T_46_META_WS_P_ISVISIBLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UITwoTeamResultPanel\r
@Tip = %(T_49_META_TYPE_1016_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type RoundResultShowTimeHud : InternalHud = 1016 { #%(T_46_META_WS_C_UITWOTEAMRESULTPANEL)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1016000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=ShowTimeType\r
	@Tip = %(T_49_META_TYP_1016_I1_D)\r
    ShowTimeType : Int = -1016001 #%(T_46_META_WS_P_SHOWTIMETYPE)\r
	@ApiLevel=4\r
	@ScriptName=ShowTwoTeamScore\r
	@Tip = %(T_49_META_TYP_1016_I2_D)\r
    ShowTwoTeamScore : Bool = -1016002 #%(T_46_META_WS_P_SHOWTWOTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeamScore\r
	@Tip = %(T_49_META_TYP_1016_I3_D)\r
    LeftTeamScore : Int = -1016003 #%(T_46_META_WS_P_LEFTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=RightTeamScore\r
	@Tip = %(T_49_META_TYP_1016_I4_D)\r
    RightTeamScore : Int = -1016004 #%(T_46_META_WS_P_RIGHTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=PhaseEndTime\r
	@Tip = %(T_49_META_TYP_1016_I5_D)\r
    PhaseEndTime : Int = -1016005 #%(T_46_META_WS_P_PHASEENDTIME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIVersusBanner\r
@Tip = %(T_49_META_TYPE_1017_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TwoTeamFactionHud : InternalHud = 1017 { #%(T_46_META_WS_C_UIVERSUSBANNER)\r
	@ApiLevel=4\r
	@ScriptName=EnableLocalization\r
	@Tip = %(T_49_META_TYP_1012_I1_D)\r
    LocSwitch : Bool = -1017000 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeamName\r
	@Tip = %(T_49_META_TYP_1017_I1_D)\r
    LeftTeamName : String = -1017001 #%(T_46_META_WS_P_LEFTTEAMNAME)\r
	@ApiLevel=4\r
	@ScriptName=LeftDescription\r
	@Tip = %(T_49_META_TYP_1017_I2_D)\r
    LeftTeamDesc : String = -1017002 #%(T_46_META_WS_P_LEFTDESCRIPTION)\r
	@ApiLevel=4\r
	@ScriptName=RightTeamName\r
	@Tip = %(T_49_META_TYP_1017_I3_D)\r
    RightTeamName : String = -1017003 #%(T_46_META_WS_P_RIGHTTEAMNAME)\r
	@ApiLevel=4\r
	@ScriptName=RightDescription\r
	@Tip = %(T_49_META_TYP_1017_I4_D)\r
    RightTeamDesc : String = -1017004 #%(T_46_META_WS_P_RIGHTDESCRIPTION)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1017005 #%(T_46_META_WS_P_ISVISIBLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UITwoTeamRoundScoreBanner\r
@Tip = %(T_49_META_TYPE_1018_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TwoTeamRoundScoreBannerHud : InternalHud = 1018 { #%(T_46_META_WS_C_UITWOTEAMROUNDSCOREBANNER)\r
	@ApiLevel=4\r
	@ScriptName=EnableLocalization\r
	@Tip = %(T_49_META_TYP_1012_I1_D)\r
    LocSwitch : Bool = -1018000 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=RoundNum\r
	@Tip = %(T_49_META_TYP_1018_I1_D)\r
    RoundNum : Int = -1018001 #%(T_46_META_WS_P_ROUNDNUM)\r
	@ApiLevel=10\r
	@ScriptName=LeftTeamIndex_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    LeftTeamIndex : Int = -1018002 #LeftTeamIndex\r
	@ApiLevel=4\r
	@ScriptName=LeftTeamName\r
	@Tip = %(T_49_META_TYP_1017_I1_D)\r
    LeftTeamName : String = -1018003 #%(T_46_META_WS_P_LEFTTEAMNAME)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeamScore\r
	@Tip = %(T_49_META_TYP_1018_I4_D)\r
    LeftTeamScore : Int = -1018004 #%(T_46_META_WS_P_LEFTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=RightTeamName\r
	@Tip = %(T_49_META_TYP_1017_I3_D)\r
    RightTeamName : String = -1018005 #%(T_46_META_WS_P_RIGHTTEAMNAME)\r
	@ApiLevel=4\r
	@ScriptName=RightTeamScore\r
	@Tip = %(T_49_META_TYP_1018_I6_D)\r
    RightTeamScore : Int = -1018006 #%(T_46_META_WS_P_RIGHTTEAMSCORE)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1018007 #%(T_46_META_WS_P_ISVISIBLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIWinOrLoseBanner\r
@Tip = %(T_49_META_TYPE_1019_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type ResultBannerHud : InternalHud = 1019 { #%(T_46_META_WS_C_UIWINORLOSEBANNER)\r
	@ApiLevel=3\r
	@ScriptName=EnableLocalization\r
	@Tip = %(T_49_META_TYP_1012_I1_D)\r
    LocSwitch : Bool = -1019000 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=Result\r
	@Tip = %(T_49_META_TYP_1019_I1_D)\r
    Result : Int = -1019001 #%(T_46_META_WS_P_RESULT)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1019002 #%(T_46_META_WS_P_ISVISIBLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIRoundNumber\r
@Tip = %(T_49_META_TYPE_1020_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type RoundNumHud : InternalHud = 1020 { #%(T_46_META_WS_C_UIROUNDNUMBER)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1020000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=3\r
	@ScriptName=EnableLocalization\r
	@Tip = %(T_49_META_TYP_1012_I1_D)\r
    LocSwitch : Bool = -1020001 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=TextKey\r
	@Tip = %(T_49_META_TYP_1020_I2_D)\r
    TextKey : String = -1020002 #%(T_46_META_WS_P_TEXTKEY)\r
	@ApiLevel=4\r
	@ScriptName=TextKeyParams\r
	@Tip = %(T_49_META_TYP_1020_I3_D)\r
    TextKey_Params : ListT_Int = -1020003 #%(T_46_META_WS_P_TEXTKEYPARAMS)\r
	@ApiLevel=4\r
	@ScriptName=ThemeColor\r
	@Tip = %(T_49_META_TYP_1011_I2_D)\r
    ThemeColor : Color = -1020004 #%(T_46_META_WS_P_THEMECOLOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIPhaseTimer\r
@Tip = %(T_49_META_TYPE_1021_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type PhaseCountDownHud : InternalHud = 1021 { #%(T_46_META_WS_C_UIPHASETIMER)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1021000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=BaseTime\r
	@Tip = %(T_49_META_TYP_1021_I1_D)\r
    BaseTimeS : Int = -1021001 #%(T_46_META_WS_P_BASETIME)\r
	@ApiLevel=4\r
	@ScriptName=Duration\r
	@Tip = %(T_49_META_TYP_1021_I2_D)\r
    DurationTimeS : Int = -1021002 #%(T_46_META_WS_P_DURATION)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
	@Tip = %(T_49_META_TYP_1021_I3_D)\r
    Offset : Vector3 = -1021003 #%(T_46_META_WS_P_OFFSET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIMatchSubtitle\r
@Tip = %(T_49_META_TYPE_1022_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type MatchInfoSubTitleHud : InternalHud = 1022 { #%(T_46_META_WS_C_UIMATCHSUBTITLE)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1022000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=EnableLocalization\r
	@Tip = %(T_49_META_TYP_1012_I1_D)\r
    LocSwitch : Bool = -1022001 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=TextKey\r
	@Tip = %(T_49_META_TYP_1022_I2_D)\r
    TextKey : String = -1022002 #%(T_46_META_WS_P_TEXTKEY)\r
	@ApiLevel=4\r
	@ScriptName=TextKeyParams\r
	@Tip = %(T_49_META_TYP_1022_I3_D)\r
    TextKey_Params : ListT_Int = -1022003 #%(T_46_META_WS_P_TEXTKEYPARAMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UITwoTeamInfo\r
@Tip = %(T_49_META_TYPE_1023_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TwoTeamMatchInfoHud : InternalHud = 1023 { #%(T_46_META_WS_C_UITWOTEAMINFO)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1023000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=ShowTeamScore\r
	@Tip = %(T_49_META_TYP_1023_I1_D)\r
    ShowTeamScore : Bool = -1023001 #%(T_46_META_WS_P_SHOWTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeamScore\r
	@Tip = %(T_49_META_TYP_1016_I3_D)\r
    LeftTeamScore : Int = -1023002 #%(T_46_META_WS_P_LEFTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=RightTeamScore\r
	@Tip = %(T_49_META_TYP_1016_I4_D)\r
    RightTeamScore : Int = -1023003 #%(T_46_META_WS_P_RIGHTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=ShowTeammateState\r
	@Tip = %(T_49_META_TYP_1023_I4_D)\r
    ShowTeammateState : Bool = -1023004 #%(T_46_META_WS_P_SHOWTEAMMATESTATE)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeammateStates\r
	@Tip = %(T_49_META_TYP_1023_I5_D)\r
    LeftTeammateStateArray : ListT_Int = -1023005 #%(T_46_META_WS_P_LEFTTEAMMATESTATES)\r
	@ApiLevel=4\r
	@ScriptName=RightTeammateStates\r
	@Tip = %(T_49_META_TYP_1023_I6_D)\r
    RightTeammateStateArray : ListT_Int = -1023006 #%(T_46_META_WS_P_RIGHTTEAMMATESTATES)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeammateFlagCount\r
	@Tip = %(T_49_META_TYP_1023_I7_D)\r
    LeftTeammateFlagCount : Int = -1023007 #%(T_46_META_WS_P_LEFTTEAMMATEFLAGCOUNT)\r
	@ApiLevel=4\r
	@ScriptName=RightTeammateFlagCount\r
	@Tip = %(T_49_META_TYP_1023_I8_D)\r
    RightTeammateFlagCount : Int = -1023008 #%(T_46_META_WS_P_RIGHTTEAMMATEFLAGCOUNT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UITeamMatchInfo\r
@Tip = %(T_49_META_TYPE_1024_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TeamMatchInfoHud : InternalHud = 1024 { #%(T_46_META_WS_C_UITEAMMATCHINFO)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1024000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=EnableLocalization\r
	@Tip = %(T_49_META_TYP_1012_I1_D)\r
    LocSwitch : Bool = -1024001 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
	@Tip = %(T_49_META_TYP_1024_I2_D)\r
    OffsetPosition : Vector3 = -1024002 #%(T_46_META_WS_P_OFFSET)\r
	@ApiLevel=4\r
	@ScriptName=Rank\r
	@Tip = %(T_49_META_TYP_1024_I3_D)\r
    Rank : Int = -1024003 #%(T_46_META_WS_P_RANK)\r
	@ApiLevel=4\r
	@ScriptName=TeamColor\r
	@Tip = %(T_49_META_TYP_1024_I4_D)\r
    TeamColor : Color = -1024004 #%(T_46_META_WS_P_TEAMCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=IconName\r
	@Tip = %(T_49_META_TYP_1024_I5_D)\r
    IconSpriteName : String = -1024005 #%(T_46_META_WS_P_ICONNAME)\r
	@ApiLevel=4\r
	@ScriptName=ShowFrame\r
	@Tip = %(T_49_META_TYP_1024_I6_D)\r
    ShowFrame : Bool = -1024006 #%(T_46_META_WS_P_SHOWFRAME)\r
	@ApiLevel=4\r
	@ScriptName=ScoreTextKey\r
	@Tip = %(T_49_META_TYP_1024_I7_D)\r
    ScoreTextKey : String = -1024007 #%(T_46_META_WS_P_SCORETEXTKEY)\r
	@ApiLevel=4\r
	@ScriptName=ScoreTextKeyParams\r
	@Tip = %(T_49_META_TYP_1024_I8_D)\r
    ScoreTextKey_Params : ListT_Int = -1024008 #%(T_46_META_WS_P_SCORETEXTKEYPARAMS)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=UITwoTeamLeaderboard\r
@Tip = %(T_49_META_TYPE_18_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TwoTeamLeaderboardHud : InternalHud = 1025 { #%(T_46_META_WS_C_UITWOTEAMLEADERBOARD)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    OpenState : Bool = -1025000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=10\r
	@ScriptName=LeftTeamIndex\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    LeftTeamIndex : Int = -1025001 #%(T_46_META_WS_P_LEFTTEAMINDEX)\r
	@ApiLevel=10\r
	@ScriptName=RightTeamIndex\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    RightTeamIndex : Int = -1025002 #%(T_46_META_WS_P_RIGHTTEAMINDEX)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeamScore\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    LeftTeamScore : Int = -1025003 #%(T_46_META_WS_P_LEFTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=RightTeamScore\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    RightTeamScore : Int = -1025004 #%(T_46_META_WS_P_RIGHTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=PlayerScoreTypes\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    PlayerScoreTypes : ListT_Int = -1025005 #%(T_46_META_WS_P_PLAYERSCORETYPES)\r
	@ApiLevel=4\r
	@ScriptName=LeftPlayers\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    LeftPlayerArray : ListT_Player = -1025006 #%(T_46_META_WS_P_LEFTPLAYERS)\r
	@ApiLevel=4\r
	@ScriptName=RightPlayers\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    RightPlayerArray : ListT_Player = -1025007 #%(T_46_META_WS_P_RIGHTPLAYERS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UITwoTeamLeaderboardV2\r
@Tip = %(T_49_META_TYPE_437_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TwoTeamLeaderboardHudV2 : InternalHud = 437 { #%(T_46_META_WS_C_UITWOTEAMLEADERBOARD)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -437000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeamScore\r
	@Tip = %(T_49_META_TYP_1016_I3_D)\r
    LeftTeamScore : Int = -437001 #%(T_46_META_WS_P_LEFTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=RightTeamScore\r
	@Tip = %(T_49_META_TYP_1016_I4_D)\r
    RightTeamScore : Int = -437002 #%(T_46_META_WS_P_RIGHTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=LeftPlayers\r
	@Tip = %(T_49_META_TYP_437_I3_D)\r
    LeftPlayerArray : ListT_Player = -437003 #%(T_46_META_WS_P_LEFTPLAYERS)\r
	@ApiLevel=4\r
	@ScriptName=RightPlayers\r
	@Tip = %(T_49_META_TYP_437_I4_D)\r
    RightPlayerArray : ListT_Player = -437004 #%(T_46_META_WS_P_RIGHTPLAYERS)\r
	@ApiLevel=4\r
	@ScriptName=ScoreTypeNames\r
	@Tip = %(T_49_META_TYP_437_I5_D)\r
    ScoreTypeNames : ListT_String = -437005 #%(T_48_META_TYP_437_I5)\r
	@ApiLevel=4\r
	@ScriptName=LeftScoreContent\r
	@Tip = %(T_49_META_TYP_437_I6_D)\r
    LeftScoreContent : ListT_ListT_Object = -437006 #%(T_48_META_TYP_437_I6)\r
	@ApiLevel=4\r
	@ScriptName=RightScoreContent\r
	@Tip = %(T_49_META_TYP_437_I7_D)\r
    RightScoreContent : ListT_ListT_Object = -437007 #%(T_48_META_TYP_437_I7)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=UIMultipleTeamLeaderboard\r
@Tip = %(T_49_META_TYPE_18_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type MoreTeamLeaderboardHud : InternalHud = 1026 { #%(T_46_META_WS_C_UIMULTIPLETEAMLEADERBOARD)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    OpenState : Bool = -1026000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=TeamIndexs\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    TeamIndexs : ListT_Int = -1026001 #%(T_46_META_WS_P_TEAMINDEXS)\r
	@ApiLevel=4\r
	@ScriptName=TeamRanks\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    TeamRanks : ListT_Int = -1026002 #%(T_46_META_WS_P_TEAMRANKS)\r
	@ApiLevel=4\r
	@ScriptName=TeamScores\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    TeamScores : ListT_Int = -1026003 #%(T_46_META_WS_P_TEAMSCORES)\r
	@ApiLevel=4\r
	@ScriptName=TeamColors\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    TeamColors : ListT_Color = -1026004 #%(T_46_META_WS_P_TEAMCOLORS)\r
	@ApiLevel=4\r
	@ScriptName=PlayerScoreTypes\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    PlayerScoreTypes : ListT_Int = -1026005 #%(T_46_META_WS_P_PLAYERSCORETYPES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIMultipleTeamLeaderboardV2\r
@Tip = %(T_49_META_TYPE_438_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type MoreTeamLeaderboardHudV2 : InternalHud = 438 { #%(T_46_META_WS_C_UIMULTIPLETEAMLEADERBOARD)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -438000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=Players\r
	@Tip = %(T_49_META_TYP_438_I1_D)\r
    Players : ListT_ListT_Player = -438001 #%(T_48_META_TYP_438_I1)\r
	@ApiLevel=4\r
	@ScriptName=Ranks\r
	@Tip = %(T_49_META_TYP_438_I2_D)\r
    Ranks : ListT_Int = -438002 #%(T_48_META_TYP_438_I2)\r
	@ApiLevel=4\r
	@ScriptName=TotalScores\r
	@Tip = %(T_49_META_TYP_438_I3_D)\r
    TotalScores : ListT_Int = -438003 #%(T_48_META_TYP_438_I3)\r
	@ApiLevel=4\r
	@ScriptName=ScoreTypeNames\r
	@Tip = %(T_49_META_TYP_438_I4_D)\r
    ScoreTypeNames : ListT_String = -438004 #%(T_48_META_TYP_438_I4)\r
	@ApiLevel=4\r
	@ScriptName=Colors\r
	@Tip = %(T_49_META_TYP_438_I5_D)\r
    Colors : ListT_Color = -438005 #%(T_48_META_TYP_438_I5)\r
	@ApiLevel=4\r
	@ScriptName=Scores\r
	@Tip = %(T_49_META_TYP_438_I6_D)\r
    Scores : ListT_ListT_Object = -438006 #%(T_48_META_TYP_438_I6)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=UISimpleVersusBanner\r
@Tip = %(T_49_META_TYPE_1028_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type FactionInfoHud : InternalHud = 1028 { #%(T_46_META_WS_C_UISIMPLEVERSUSBANNER)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1028000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeammateAliveNum\r
	@Tip = %(T_49_META_TYP_1028_I1_D)\r
    LeftTeammateAliveCount : Int = -1028001 #%(T_46_META_WS_P_LEFTTEAMMATEALIVENUM)\r
	@ApiLevel=4\r
	@ScriptName=RightTeammateAliveNum\r
	@Tip = %(T_49_META_TYP_1028_I2_D)\r
    RightTeammateAliveCount : Int = -1028002 #%(T_46_META_WS_P_RIGHTTEAMMATEALIVENUM)\r
	@ApiLevel=4\r
	@ScriptName=LeftBackgroundColor\r
	@Tip = %(T_49_META_TYP_1028_I3_D)\r
    LeftBgColor : Color = -1028003 #%(T_46_META_WS_P_LEFTBACKGROUNDCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=RightBackgroundColor\r
	@Tip = %(T_49_META_TYP_1028_I4_D)\r
    RightBgColor : Color = -1028004 #%(T_46_META_WS_P_RIGHTBACKGROUNDCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=LeftIconName\r
	@Tip = %(T_49_META_TYP_1028_I5_D)\r
    LeftIconSpriteName : String = -1028005 #%(T_46_META_WS_P_LEFTICONNAME)\r
	@ApiLevel=4\r
	@ScriptName=RightIconName\r
	@Tip = %(T_49_META_TYP_1028_I6_D)\r
    RightIconSpriteName : String = -1028006 #%(T_46_META_WS_P_RIGHTICONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIIconNotification\r
@Tip = %(T_49_META_TYPE_1029_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type IconNotificationHud : InternalHud = 1029 { #%(T_46_META_WS_C_UIICONNOTIFICATION)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1029000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=IconName\r
	@Tip = %(T_49_META_TYP_1029_I1_D)\r
    IconSpriteName : String = -1029001 #%(T_46_META_WS_P_ICONNAME)\r
	@ApiLevel=4\r
	@ScriptName=BackgroundIconName\r
	@Tip = %(T_49_META_TYP_1029_I2_D)\r
    BgIconSpriteName : String = -1029002 #%(T_46_META_WS_P_BACKGROUNDICONNAME)\r
	@ApiLevel=4\r
	@ScriptName=Description\r
	@Tip = %(T_49_META_TYP_1011_I5_D)\r
    Description : String = -1029003 #%(T_46_META_WS_P_DESCRIPTION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UITwoTeamBriefInfo\r
@Tip = %(T_49_META_TYPE_1030_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TwoTeamMatchInfoSimpleHud : InternalHud = 1030 { #%(T_46_META_WS_C_UITWOTEAMBRIEFINFO)\r
	@ApiLevel=4\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1030000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeamScore\r
	@Tip = %(T_49_META_TYP_1016_I3_D)\r
    LeftTeamScore : Int = -1030001 #%(T_46_META_WS_P_LEFTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=RightTeamScore\r
	@Tip = %(T_49_META_TYP_1016_I4_D)\r
    RightTeamScore : Int = -1030002 #%(T_46_META_WS_P_RIGHTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeammateAliveNum\r
	@Tip = %(T_49_META_TYP_1030_I3_D)\r
    LeftTeammateAliveCount : Int = -1030003 #%(T_46_META_WS_P_LEFTTEAMMATEALIVENUM)\r
	@ApiLevel=4\r
	@ScriptName=RightTeammateAliveNum\r
	@Tip = %(T_49_META_TYP_1030_I4_D)\r
    RightTeammateAliveCount : Int = -1030004 #%(T_46_META_WS_P_RIGHTTEAMMATEALIVENUM)\r
	@ApiLevel=4\r
	@ScriptName=LeftIconName\r
	@Tip = %(T_49_META_TYP_1030_I5_D)\r
    LeftIconSpriteName : String = -1030005 #%(T_46_META_WS_P_LEFTICONNAME)\r
	@ApiLevel=4\r
	@ScriptName=RightIconName\r
	@Tip = %(T_49_META_TYP_1030_I6_D)\r
    RightIconSpriteName : String = -1030006 #%(T_46_META_WS_P_RIGHTICONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UITwoTeamBriefInfoV2\r
@Tip = %(T_49_META_TYPE_442_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TwoTeamMatchInfoSimpleHudV2 : InternalHud = 442 { #%(T_46_META_WS_C_UITWOTEAMBRIEFINFO)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -442000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=LeftScore\r
	@Tip = %(T_49_META_TYP_442_I1_D)\r
    LeftScore : Int = -442001 #%(T_48_META_TYP_442_I1)\r
	@ApiLevel=4\r
	@ScriptName=RightScore\r
	@Tip = %(T_49_META_TYP_442_I2_D)\r
    RightScore : Int = -442002 #%(T_48_META_TYP_442_I2)\r
	@ApiLevel=4\r
	@ScriptName=LeftAliveNum\r
	@Tip = %(T_49_META_TYP_442_I3_D)\r
    LeftAliveCount : Int = -442003 #%(T_48_META_TYP_442_I3)\r
	@ApiLevel=4\r
	@ScriptName=RightAliveNum\r
	@Tip = %(T_49_META_TYP_442_I4_D)\r
    RightAliveCount : Int = -442004 #%(T_48_META_TYP_442_I4)\r
	@ApiLevel=4\r
	@ScriptName=LeftDeadNum\r
	@Tip = %(T_49_META_TYP_442_I5_D)\r
    LeftDeadCount : Int = -442005 #%(T_48_META_TYP_442_I5)\r
	@ApiLevel=4\r
	@ScriptName=RightDeadNum\r
	@Tip = %(T_49_META_TYP_442_I6_D)\r
    RightDeadCount : Int = -442006 #%(T_48_META_TYP_442_I6)\r
	@ApiLevel=4\r
	@ScriptName=LeftAliveIcon\r
	@Tip = %(T_49_META_TYP_442_I7_D)\r
    LeftAliveIcon : SpriteID = -442007 #%(T_48_META_TYP_442_I7)\r
	@ApiLevel=4\r
	@ScriptName=RightAliveIcon\r
	@Tip = %(T_49_META_TYP_442_I8_D)\r
    RightAliveIcon : SpriteID = -442008 #%(T_48_META_TYP_442_I8)\r
	@ApiLevel=4\r
	@ScriptName=LeftDeadIcon\r
	@Tip = %(T_49_META_TYP_442_I9_D)\r
    LeftDeadIcon : SpriteID = -442009 #%(T_48_META_TYP_442_I9)\r
	@ApiLevel=4\r
	@ScriptName=RightDeadIcon\r
	@Tip = %(T_49_META_TYP_442_I10_D)\r
    RightDeadIcon : SpriteID = -442010 #%(T_48_META_TYP_442_I10)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UICountdownReminder\r
@Tip = %(T_49_META_TYPE_1031_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type CountdownReminderHud : InternalHud = 1031 { #%(T_46_META_WS_C_UICOUNTDOWNREMINDER)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1031000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=Duration\r
	@Tip = %(T_49_META_TYP_1021_I2_D)\r
    DurationTimeS : Int = -1031001 #%(T_46_META_WS_P_DURATION)\r
	@ApiLevel=4\r
	@ScriptName=Description\r
	@Tip = %(T_49_META_TYP_1031_I2_D)\r
    Description : String = -1031002 #%(T_46_META_WS_P_DESCRIPTION)\r
	@ApiLevel=4\r
	@ScriptName=BaseTime\r
	@Tip = %(T_49_META_TYP_1031_I3_D)\r
    CountDownBaseTimeS : Int = -1031003 #%(T_46_META_WS_P_BASETIME)\r
	@ApiLevel=4\r
	@ScriptName=DescriptionParams\r
	@Tip = %(T_49_META_TYP_1031_I4_D)\r
    DescriptionParams : ListT_String = -1031004 #%(T_46_META_WS_P_DESCRIPTIONPARAMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UITweenTip\r
@Tip = %(T_49_META_TYPE_1032_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TweenTipsHud : InternalHud = 1032 { #%(T_46_META_WS_C_UITWEENTIP)\r
	@ApiLevel=4\r
	@ScriptName=EnableLocalization\r
	@Tip = %(T_49_META_TYP_1012_I1_D)\r
    LocSwitch : Bool = -1032000 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=TipsType\r
	@Tip = %(T_49_META_TYP_1032_I1_D)\r
    EventTipsType : Int = -1032001 #%(T_46_META_WS_P_TIPSTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Description\r
	@Tip = %(T_49_META_TYP_1031_I2_D)\r
    Description : String = -1032002 #%(T_46_META_WS_P_DESCRIPTION)\r
	@ApiLevel=4\r
	@ScriptName=Params\r
	@Tip = %(T_49_META_TYP_1032_I3_D)\r
    Params : ListT_Int = -1032003 #%(T_46_META_WS_P_PARAMS)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1032004 #%(T_46_META_WS_P_ISVISIBLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIRoundTransition\r
@Tip = %(T_49_META_TYPE_1033_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type RoundTransitionHud : InternalHud = 1033 { #%(T_46_META_WS_C_UIROUNDTRANSITION)\r
	@ApiLevel=4\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1033000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=TransitionStage\r
	@Tip = %(T_49_META_TYP_1033_I1_D)\r
    TransitionStage : Int = -1033001 #%(T_46_META_WS_P_TRANSITIONSTAGE)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeamScore\r
	@Tip = %(T_49_META_TYP_1016_I3_D)\r
    LeftTeamScore : Int = -1033002 #%(T_46_META_WS_P_LEFTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=RightTeamScore\r
	@Tip = %(T_49_META_TYP_1016_I4_D)\r
    RightTeamScore : Int = -1033003 #%(T_46_META_WS_P_RIGHTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeamName\r
	@Tip = %(T_49_META_TYP_1017_I1_D)\r
    LeftTeamName : String = -1033004 #%(T_46_META_WS_P_LEFTTEAMNAME)\r
	@ApiLevel=4\r
	@ScriptName=RightTeamName\r
	@Tip = %(T_49_META_TYP_1017_I3_D)\r
    RightTeamName : String = -1033005 #%(T_46_META_WS_P_RIGHTTEAMNAME)\r
	@ApiLevel=4\r
	@ScriptName=LeftIconName\r
	@Tip = %(T_49_META_TYP_1033_I6_D)\r
    LeftIconSpriteName : String = -1033006 #%(T_46_META_WS_P_LEFTICONNAME)\r
	@ApiLevel=4\r
	@ScriptName=RightIconName\r
	@Tip = %(T_49_META_TYP_1033_I7_D)\r
    RightIconSpriteName : String = -1033007 #%(T_46_META_WS_P_RIGHTICONNAME)\r
	@ApiLevel=4\r
	@ScriptName=ResultType\r
	@Tip = %(T_49_META_TYP_1033_I8_D)\r
    ResultType : Int = -1033008 #%(T_46_META_WS_P_RESULTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=WinText\r
	@Tip = %(T_49_META_TYP_1033_I9_D)\r
    WinLoc : String = -1033009 #%(T_46_META_WS_P_WINTEXT)\r
	@ApiLevel=4\r
	@ScriptName=LoseText\r
	@Tip = %(T_49_META_TYP_1033_I10_D)\r
    LoseLoc : String = -1033010 #%(T_46_META_WS_P_LOSETEXT)\r
	@ApiLevel=4\r
	@ScriptName=RoundIncomeTitle\r
	@Tip = %(T_49_META_TYP_1033_I11_D)\r
    RoundIncomeTitle : String = -1033011 #%(T_46_META_WS_P_ROUNDINCOMETITLE)\r
	@ApiLevel=4\r
	@ScriptName=RoundIncome\r
	@Tip = %(T_49_META_TYP_1033_I12_D)\r
    RoundIncome : Int = -1033012 #%(T_46_META_WS_P_ROUNDINCOME)\r
	@ApiLevel=4\r
	@ScriptName=RoundIncomeDetailTitles\r
	@Tip = %(T_49_META_TYP_1033_I13_D)\r
    RoundIncomeDetailTitleList : ListT_String = -1033013 #%(T_46_META_WS_P_ROUNDINCOMEDETAILTITLES)\r
	@ApiLevel=4\r
	@ScriptName=RoundIncomeDetailNums\r
	@Tip = %(T_49_META_TYP_1033_I14_D)\r
    RoundIncomeDetailList : ListT_Int = -1033014 #%(T_46_META_WS_P_ROUNDINCOMEDETAILNUMS)\r
	@ApiLevel=4\r
	@ScriptName=MVP\r
	@Tip = %(T_49_META_TYP_1033_I15_D)\r
    MVP : String = -1033015 #%(T_46_META_WS_P_MVP)\r
	@ApiLevel=4\r
	@ScriptName=NextRoundIndex\r
	@Tip = %(T_49_META_TYP_1033_I16_D)\r
    NextRoundIndex : Int = -1033016 #%(T_46_META_WS_P_NEXTROUNDINDEX)\r
	@ApiLevel=4\r
	@ScriptName=IsMatchPoint\r
	@Tip = %(T_49_META_TYP_1033_I17_D)\r
    IsMatchPoint : Bool = -1033017 #%(T_46_META_WS_P_ISMATCHPOINT)\r
	@ApiLevel=4\r
	@ScriptName=IsLastRound\r
	@Tip = %(T_49_META_TYP_1033_I18_D)\r
    IsLastRound : Bool = -1033018 #%(T_46_META_WS_P_ISLASTROUND)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=UISoloLeaderboard\r
@Tip = %(T_49_META_TYPE_18_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type SingleLeaderboardHud : InternalHud = 1034 { #%(T_46_META_WS_C_UISOLOLEADERBOARD)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    OpenState : Bool = -1034000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=Players\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Players : ListT_Player = -1034001 #%(T_46_META_WS_P_PLAYERS)\r
	@ApiLevel=4\r
	@ScriptName=PlayerRanks\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    PlayerRanks : ListT_Int = -1034002 #%(T_46_META_WS_P_PLAYERRANKS)\r
	@ApiLevel=4\r
	@ScriptName=PlayerScoreTypes\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    PlayerScoreTypes : ListT_Int = -1034003 #%(T_46_META_WS_P_PLAYERSCORETYPES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UILeaderboardButton\r
@Tip = %(T_49_META_TYPE_1035_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type LeaderboardButtonHud : InternalHud = 1035 { #%(T_46_META_WS_C_UILEADERBOARDBUTTON)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1035000 #%(T_46_META_WS_P_ISVISIBLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIMonsterLevel\r
@Tip = %(T_49_META_TYPE_1036_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type ZombieLevelHud : InternalHud = 1036 { #%(T_46_META_WS_C_UIMONSTERLEVEL)\r
	@ApiLevel=4\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1036000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=TotalLevel\r
	@Tip = %(T_49_META_TYP_1036_I1_D)\r
    TotalLevel : Int = -1036001 #%(T_46_META_WS_P_TOTALLEVEL)\r
	@ApiLevel=4\r
	@ScriptName=Level\r
	@Tip = %(T_49_META_TYP_1036_I2_D)\r
    Level : Int = -1036002 #%(T_46_META_WS_P_LEVEL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIAddScore\r
@Tip = %(T_49_META_TYPE_1037_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type AddScoreVFXHud : InternalHud = 1037 { #%(T_46_META_WS_C_UIADDSCORE)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1037000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=Score\r
	@Tip = %(T_49_META_TYP_1037_I1_D)\r
    ScoreNum : Int = -1037001 #%(T_46_META_WS_P_SCORE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIMonster\r
@Tip = %(T_49_META_TYPE_1038_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type ZombieVFXHud : InternalHud = 1038 { #%(T_46_META_WS_C_UIMONSTERUI)\r
	@ApiLevel=4\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1038000 #%(T_46_META_WS_P_ISVISIBLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UICountdownHint\r
@Tip = %(T_49_META_TYPE_1039_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TimeTweenTipsHud : InternalHud = 1039 { #%(T_46_META_WS_C_UICOUNTDOWNHINT)\r
	@ApiLevel=4\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1039000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=3\r
	@ScriptName=EnableLocalization\r
	@Tip = %(T_49_META_TYP_1012_I1_D)\r
    LocSwitch : Bool = -1039001 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=Description\r
	@Tip = %(T_49_META_TYP_1031_I2_D)\r
    Description : String = -1039002 #%(T_46_META_WS_P_DESCRIPTION)\r
	@ApiLevel=4\r
	@ScriptName=BaseTime\r
	@Tip = %(T_49_META_TYP_1039_I3_D)\r
    CountDownBaseTimeS : Int = -1039003 #%(T_46_META_WS_P_BASETIME)\r
	@ApiLevel=4\r
	@ScriptName=Duration\r
	@Tip = %(T_49_META_TYP_1021_I2_D)\r
    DurationTimeS : Int = -1039004 #%(T_46_META_WS_P_DURATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UICardSelectionPanel\r
@Tip = %(T_49_META_TYPE_1040_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type ChooseCardHud : InternalHud = 1040 { #%(T_46_META_WS_C_UICARDSELECTIONPANEL)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1040000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=EnableLocalization\r
	@Tip = %(T_49_META_TYP_1012_I1_D)\r
    LocSwitch : Bool = -1040001 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=CountDownKey\r
	@Tip = %(T_49_META_TYP_1040_I2_D)\r
    CountDownKey : String = -1040002 #%(T_46_META_WS_P_COUNTDOWNKEY)\r
	@ApiLevel=4\r
	@ScriptName=CountDownTime\r
	@Tip = %(T_49_META_TYP_1040_I3_D)\r
    CountDownTimeS : Int = -1040003 #%(T_46_META_WS_P_COUNTDOWNTIME)\r
	@ApiLevel=4\r
	@ScriptName=DescriptionKey\r
	@Tip = %(T_49_META_TYP_1040_I4_D)\r
    DescriptionKey : String = -1040004 #%(T_46_META_WS_P_DESCRIPTIONKEY)\r
	@ApiLevel=4\r
	@ScriptName=DescriptionParams\r
	@Tip = %(T_49_META_TYP_1040_I5_D)\r
    DescriptionParams : List = -1040005 #%(T_46_META_WS_P_DESCRIPTIONPARAMS)\r
	@ApiLevel=4\r
	@ScriptName=ItemBackgrounds\r
	@Tip = %(T_49_META_TYP_1040_I6_D)\r
    ItemBGSprites : ListT_String = -1040006 #%(T_46_META_WS_P_ITEMBACKGROUNDS)\r
	@ApiLevel=4\r
	@ScriptName=ItemBackgroundColors\r
	@Tip = %(T_49_META_TYP_1040_I7_D)\r
    ItemBGColors : ListT_Color = -1040007 #%(T_46_META_WS_P_ITEMBACKGROUNDCOLORS)\r
	@ApiLevel=4\r
	@ScriptName=ItemIcons\r
	@Tip = %(T_49_META_TYP_1040_I8_D)\r
    ItemIconSprites : ListT_String = -1040008 #%(T_46_META_WS_P_ITEMICONS)\r
	@ApiLevel=4\r
	@ScriptName=ItemNames\r
	@Tip = %(T_49_META_TYP_1040_I9_D)\r
    ItemNames : ListT_String = -1040009 #%(T_46_META_WS_P_ITEMNAMES)\r
	@ApiLevel=4\r
	@ScriptName=ItemDescriptions\r
	@Tip = %(T_49_META_TYP_1040_I10_D)\r
    ItemDescs : ListT_String = -1040010 #%(T_46_META_WS_P_ITEMDESCRIPTIONS)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=SelectedIndex\r
	@Tip = %(T_49_META_TYP_1040_I11_D)\r
    SelectItemIndex : Int = -1040011 #%(T_46_META_WS_P_SELECTEDINDEX)\r
	@ApiLevel=4\r
	@ScriptName=ButtonNames\r
	@Tip = %(T_49_META_TYP_1040_I12_D)\r
    ButtonNames : ListT_String = -1040012 #%(T_46_META_WS_P_BUTTONNAMES)\r
	@ApiLevel=4\r
	@ScriptName=ButtonColors\r
	@Tip = %(T_49_META_TYP_1040_I13_D)\r
    ButtonColors : ListT_Color = -1040013 #%(T_46_META_WS_P_BUTTONCOLORS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIIdentityNotification\r
@Tip = %(T_49_META_TYPE_1041_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type IdentityNotifyHud : InternalHud = 1041 { #%(T_46_META_WS_C_UIIDENTITYNOTIFICATION)\r
	@ApiLevel=4\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1041000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=3\r
	@ScriptName=EnableLocalization\r
	@Tip = %(T_49_META_TYP_1012_I1_D)\r
    LocSwitch : Bool = -1041001 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=Position\r
	@Tip = %(T_49_META_TYP_1041_I2_D)\r
    Position : Vector3 = -1041002 #%(T_46_META_WS_P_POSITION)\r
	@ApiLevel=4\r
	@ScriptName=Icon\r
	@Tip = %(T_49_META_TYP_1041_I3_D)\r
    IconSprite : String = -1041003 #%(T_46_META_WS_P_ICON)\r
	@ApiLevel=4\r
	@ScriptName=Label\r
	@Tip = %(T_49_META_TYP_1041_I4_D)\r
    Label : String = -1041004 #%(T_46_META_WS_P_LABEL)\r
	@ApiLevel=4\r
	@ScriptName=BackgroundColor\r
	@Tip = %(T_49_META_TYP_1041_I5_D)\r
    BGColor : Color = -1041005 #%(T_46_META_WS_P_BACKGROUNDCOLOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UICountDown5\r
@Tip = %(T_49_META_TYPE_1042_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type FiveSecondCountDownHud : InternalHud = 1042 { #%(T_46_META_WS_C_UICOUNTDOWN5)\r
	@ApiLevel=4\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1042000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=LocalPosition\r
	@Tip = %(T_49_META_TYP_1042_I1_D)\r
    LocalPosition : Vector3 = -1042001 #%(T_46_META_WS_P_LOCALPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UITitleBanner\r
@Tip = %(T_49_META_TYPE_1043_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TitleBannerHud : InternalHud = 1043 { #%(T_46_META_WS_C_UITITLEBANNER)\r
	@ApiLevel=4\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1043000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=3\r
	@ScriptName=EnableLocalization\r
	@Tip = %(T_49_META_TYP_1012_I1_D)\r
    LocSwitch : Bool = -1043001 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=LocalPosition\r
	@Tip = %(T_49_META_TYP_1042_I1_D)\r
    LocalPosition : Vector3 = -1043002 #%(T_46_META_WS_P_LOCALPOSITION)\r
	@ApiLevel=4\r
	@ScriptName=FontSize\r
	@Tip = %(T_49_META_TYP_1042_I1_D)\r
    FontSize : Int = -1043003 #%(T_46_META_WS_P_FONTSIZE)\r
	@ApiLevel=4\r
	@ScriptName=FontColor\r
	@Tip = %(T_49_META_TYP_1043_I4_D)\r
    Color : Int = -1043004 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@ScriptName=LabelKey\r
	@Tip = %(T_49_META_TYP_1043_I5_D)\r
    LabelKey : String = -1043005 #%(T_46_META_WS_P_LABELKEY)\r
	@ApiLevel=4\r
	@ScriptName=LabelParams\r
	@Tip = %(T_49_META_TYP_1043_I6_D)\r
    LabelParams : List = -1043006 #%(T_46_META_WS_P_LABELPARAMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIBuiltInSwitch\r
@Tip = %(T_49_META_TYPE_1044_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type CommonHudSwitchHud : InternalHud = 1044 { #%(T_46_META_WS_C_UIBUILTINSWITCH)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1044000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ShowCrouch\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    CrouchSwitch : Bool = -1044001 #%(T_46_META_WS_P_SHOWCROUCH)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ShowProne\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    CreepSwitch : Bool = -1044002 #%(T_46_META_WS_P_SHOWPRONE)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ShowJump\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    JumpSwitch : Bool = -1044003 #%(T_46_META_WS_P_SHOWJUMP)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ShowFire\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    FireSwitch : Bool = -1044004 #%(T_46_META_WS_P_SHOWFIRE)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ShowMovingJoystick\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    MovingJoystickSwitch : Bool = -1044005 #%(T_46_META_WS_P_SHOWMOVINGJOYSTICK)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ShowTeammatesInfo\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    TeammatesInfoSwitch : Bool = -1044006 #%(T_46_META_WS_P_SHOWTEAMMATESINFO)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ShowAttackGrenade\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    AttackGrenadeSwitch : Bool = -1044007 #%(T_46_META_WS_P_SHOWATTACKGRENADE)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ShowDefenceGrenade\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    DefenceGrenadeSwitch : Bool = -1044008 #%(T_46_META_WS_P_SHOWDEFENCEGRENADE)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ShowSprint\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    SpeedupSwitch : Bool = -1044009 #%(T_46_META_WS_P_SHOWSPRINT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UISkillButton\r
@Tip = %(T_49_META_TYPE_1045_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type SkillButtonHud : InternalHud = 1045 { #%(T_46_META_WS_C_UISKILLBUTTON)\r
	@ApiLevel=4\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -1045000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=10\r
	@ScriptName=Name_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Name : String = -1045001 #Name\r
	@ApiLevel=4\r
	@ScriptName=Icon\r
	@Tip = %(T_49_META_TYP_1045_I2_D)\r
    IconSprite : String = -1045002 #%(T_46_META_WS_P_ICON)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=IconColor\r
	@Tip = %(T_49_META_TYP_1045_I3_D)\r
    IconColor : Color = -1045003 #%(T_46_META_WS_P_ICONCOLOR)\r
	@ApiLevel=4\r
	@Default=60\r
	@ScriptName=Size\r
	@Tip = %(T_49_META_TYP_1045_I4_D)\r
    Size : Int = -1045004 #%(T_46_META_WS_P_SIZE)\r
	@ApiLevel=4\r
	@ScriptName=LocalPosition\r
	@Tip = %(T_49_META_TYP_1045_I5_D)\r
    LocalPosition : Vector3 = -1045005 #%(T_46_META_WS_P_LOCALPOSITION)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Count\r
	@Tip = %(T_49_META_TYP_1045_I6_D)\r
    Count : Int = -1045006 #%(T_46_META_WS_P_COUNT)\r
	@ApiLevel=4\r
	@ScriptName=BaseTime\r
	@Tip = %(T_49_META_TYP_1045_I7_D)\r
    CDStartTime : Int = -1045007 #%(T_46_META_WS_P_BASETIME)\r
	@ApiLevel=4\r
	@ScriptName=Duration\r
	@Tip = %(T_49_META_TYP_1045_I8_D)\r
    CDDurationTime : Int = -1045008 #%(T_46_META_WS_P_DURATION)\r
	@ApiLevel=4\r
	@ScriptName=IsGrey\r
	@Tip = %(T_49_META_TYP_1045_I9_D)\r
    Grey : Bool = -1045009 #%(T_46_META_WS_P_ISGREY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIHeartbeat\r
@Tip = %(T_49_META_TYPE_82_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type HeartbeatHud : InternalHud = 82 { #%(T_46_META_WS_C_UIHEARTBEAT)\r
	@ApiLevel=4\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -82000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=Icon\r
	@Tip = %(T_49_META_TYP_82_I1_D)\r
    IconSprite : String = -82001 #%(T_46_META_WS_P_ICON)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=IconColor\r
	@Tip = %(T_49_META_TYP_1045_I3_D)\r
    IconColor : Color = -82002 #%(T_46_META_WS_P_ICONCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=LocalPosition\r
	@Tip = %(T_49_META_TYP_82_I3_D)\r
    LocalPosition : Vector3 = -82003 #%(T_46_META_WS_P_LOCALPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIProgressBar\r
@Tip = %(T_49_META_TYPE_120_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type ProgressbarHud : InternalHud = 120 { #%(T_46_META_WS_C_UIPROGRESSBAR)\r
	@ApiLevel=4\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -120000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=FollowTarget\r
	@Tip = %(T_49_META_TYP_120_I1_D)\r
    FollowTarget : Entity = -120001 #%(T_46_META_WS_P_FOLLOWTARGET)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Color\r
	@Tip = %(T_49_META_TYP_120_I2_D)\r
    Color : Color = -120002 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@Default=100\r
	@ScriptName=Length\r
	@Tip = %(T_49_META_TYP_120_I3_D)\r
    HUDLength : Int = -120003 #%(T_46_META_WS_P_LENGTH)\r
	@ApiLevel=4\r
	@ScriptName=CurrentValue\r
	@Tip = %(T_49_META_TYP_120_I4_D)\r
    CurrentValue : Float = -120004 #%(T_46_META_WS_P_CURRENTVALUE)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
	@Tip = %(T_49_META_TYP_120_I5_D)\r
    Offset : Vector3 = -120005 #%(T_46_META_WS_P_OFFSET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIHealthBar\r
@Tip = %(T_49_META_TYPE_126_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type HPbarHud : InternalHud = 126 { #%(T_46_META_WS_C_UIHEALTHBAR)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -126000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=Name\r
	@Tip = %(T_49_META_TYP_126_I1_D)\r
    ObjectName : String = -126001 #%(T_46_META_WS_P_NAME)\r
	@ApiLevel=4\r
	@ScriptName=CurrentValue\r
	@Tip = %(T_49_META_TYP_126_I2_D)\r
    CurrentValue : Int = -126002 #%(T_46_META_WS_P_CURRENTVALUE)\r
	@ApiLevel=4\r
	@ScriptName=MaxValue\r
	@Tip = %(T_49_META_TYP_126_I3_D)\r
    MaxValue : Int = -126003 #%(T_46_META_WS_P_MAXVALUE)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
	@Tip = %(T_49_META_TYP_126_I4_D)\r
    Offset : Vector3 = -126004 #%(T_46_META_WS_P_OFFSET)\r
	@ApiLevel=4\r
	@Default=387\r
	@ScriptName=Length\r
	@Tip = %(T_49_META_TYP_126_I5_D)\r
    Length : Int = -126005 #%(T_46_META_WS_P_LENGTH)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIVFXHeartbeat\r
@Tip = %(T_49_META_TYPE_254_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type HeartbeatEffectHud : InternalHud = 254 { #%(T_46_META_WS_C_UIHEARTBEAT)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -254000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=PlaySpeed\r
	@Tip = %(T_49_META_TYP_254_I1_D)\r
    PlaySpeed : Float = -254001 #%(T_46_META_WS_P_PLAYSPEED)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Color\r
	@Tip = %(T_49_META_TYP_254_I2_D)\r
    Color : Color = -254002 #%(T_44_XXJ_WS_COLOR)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=PresentIcon_Deprecated\r
@Tip = %(T_49_META_TYPE_18_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type PresentIcon : Entity = 35 { #%(T_34_WT_WS_ICONENTITY_PARAM1)\r
	@ApiLevel=4\r
	@ScriptName=IconResID\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    IconType : SpriteID = -35000 #%(T_34_WT_WS_ICONENTITY_PARAM2)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Color\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Color : Color = -35001 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=ScaleDiscarded\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Scale : Float = -35002 #%(T_34_WT_WS_ICONENTITY_PARAM4)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Offset : Vector3 = -35003 #%(T_34_WT_WS_ICONENTITY_PARAM5)\r
	@ApiLevel=4\r
	@ScriptName=FollowTarget\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    FollowTarget : Entity = -35004 #%(T_34_WT_WS_ICONENTITY_PARAM6)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=IsIgnoreDepth\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    IgnoreDepth : Bool = -35005 #%(T_34_WT_WS_ICONENTITY_PARAM7)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=IsAlwaysInScreen\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    AlwaysInScreen : Bool = -35006 #%(T_34_WT_WS_ICONENTITY_PARAM8)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsBillboard\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    IsBillboard : Bool = -35007 #%(T_36_WZY_WS_FACECAMERA)\r
	@ApiLevel=4\r
	@ScriptName=Rotation\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Rotator : Vector3 = -35008 #%(T_36_WZY_WS_EULERANGLE)\r
	@ApiLevel=4\r
	@Default=math.Vector3_1()\r
	@ScriptName=Scale\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    ScaleVector : Vector3 = -35009 #%(T_36_WZY_WS_3DZOOM)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=PresentText_Deprecated\r
@Tip = %(T_49_META_TYPE_18_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type PresentText : Entity = 36 { #%(T_34_WT_WS_TXTENTITY_PARAM1)\r
	@ApiLevel=4\r
	@ScriptName=TextKey\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    TextKey : String = -36000 #%(T_34_WT_WS_TXTENTITY_PARAM2)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Color\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Color : Color = -36001 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=ScaleDiscarded\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Scale : Float = -36002 #%(T_34_WT_WS_ICONENTITY_PARAM4)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Offset : Vector3 = -36003 #%(T_34_WT_WS_ICONENTITY_PARAM5)\r
	@ApiLevel=4\r
	@ScriptName=FollowTarget\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    FollowTarget : Entity = -36004 #%(T_34_WT_WS_ICONENTITY_PARAM6)\r
	@ApiLevel=4\r
	@ScriptName=IsIgnoreDepth\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    IgnoreDepth : Bool = -36005 #%(T_34_WT_WS_ICONENTITY_PARAM7)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsBillboard\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    IsBillboard : Bool = -36006 #%(T_36_WZY_WS_FACECAMERA)\r
	@ApiLevel=4\r
	@ScriptName=Rotation\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Rotator : Vector3 = -36007 #%(T_36_WZY_WS_EULERANGLE)\r
	@ApiLevel=4\r
	@Default=math.Vector3_1()\r
	@ScriptName=Scale\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    ScaleVector : Vector3 = -36008 #%(T_36_WZY_WS_3DZOOM)\r
	@ApiLevel=4\r
	@Default=16\r
	@ScriptName=FontSize\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    FontSize : Int = -36009 #%(T_40_WZY_WS_PRESENTTXT_FONTSIZE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=PresentEffect_Deprecated\r
@Tip = %(T_49_META_TYPE_18_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type PresentEffect : Entity = 37 { #%(T_34_WT_WS_VFXENTITY_PARAM1)\r
	@ApiLevel=4\r
	@ScriptName=EffectResID\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    EffectType : EffectType = -37000 #%(T_34_WT_WS_ICONENTITY_PARAM2)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Color\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Color : Color = -37001 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=ScaleDiscarded\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Scale : Float = -37002 #%(T_34_WT_WS_ICONENTITY_PARAM4)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Offset : Vector3 = -37003 #%(T_34_WT_WS_ICONENTITY_PARAM5)\r
	@ApiLevel=4\r
	@ScriptName=FollowTarget\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    FollowTarget : Entity = -37004 #%(T_34_WT_WS_ICONENTITY_PARAM6)\r
	@ApiLevel=4\r
	@ScriptName=Rotation\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Rotator : Vector3 = -37005 #%(T_36_WZY_WS_EULERANGLE)\r
	@ApiLevel=4\r
	@Default=math.Vector3_1()\r
	@ScriptName=Scale\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    ScaleVector : Vector3 = -37006 #%(T_36_WZY_WS_3DZOOM)\r
	@ApiLevel=4\r
	@Default=100\r
	@ScriptName=PlaySpeed\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    PlaySpeed : Int = -37007 #%(T_38_WZY_WS_PLAYSPEED)\r
	@ApiLevel=4\r
	@ScriptName=PresentEffectTextureType\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    PresentEffectTexType : TextureID = -37008 #%(T_38_WZY_WS_PARTICALMAP)\r
	@ApiLevel=4\r
	@ScriptName=DiffuseAlpha\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    DiffuseAlpha : Int = -37009 #%(T_39_WZY_WS_DIFFUSEALPHA)\r
}\r
\r
@ApiLevel=11\r
@ScriptName=VFXReplaceTextPresent\r
@Tip = %(T_49_META_TYPE_167_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type ReplaceTexPresentEffect : Entity = 167 { #%(T_46_META_WS_C_VFXREPLACETEXTPRESENT)\r
	@ApiLevel=4\r
	@ScriptName=VFXTextureType\r
	@Tip = %(T_49_META_TYP_167_I0_D)\r
    VFXTexture : TextureID = -167000 #%(T_46_META_WS_P_VFXTEXTURETYPE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=PresentEffectTextureType_Deprecated\r
@Tip = %(T_49_META_TYPE_18_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum PresentEffectTexType : TextureID = 168 { #%(T_46_META_WS_C_PRESENTEFFECTTEXTURETYPE_DEPRECATED)\r
	@ApiLevel=4\r
	@ScriptName=Lightning\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Lightning = VFX_2X2_Lightning003_BJ #%(T_46_META_WS_E_LIGHTNING)\r
	@ApiLevel=4\r
	@ScriptName=Air\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Air = VFX_Air_A #%(T_46_META_WS_E_AIR)\r
	@ApiLevel=4\r
	@ScriptName=Bubble\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Bubble = VFX_Bubble001 #%(T_46_META_WS_E_BUBBLE)\r
	@ApiLevel=4\r
	@ScriptName=Circle\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Circle = WS_VFX_Circle002_A #%(T_46_META_WS_E_CIRCLE)\r
	@ApiLevel=4\r
	@ScriptName=Darkness\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Darkness = VFX_Darkness_Trail001_BJ #%(T_46_META_WS_E_DARKNESS)\r
	@ApiLevel=4\r
	@ScriptName=Feather\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Feather = WS_VFX_Feather006_A #%(T_46_META_WS_E_FEATHER)\r
	@ApiLevel=4\r
	@ScriptName=Fire\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Fire = WS_VFX_Fire001_A #%(T_46_META_WS_E_FIRE)\r
	@ApiLevel=4\r
	@ScriptName=Flower\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Flower = WS_VFX_Flower001_A #%(T_46_META_WS_E_FLOWER)\r
	@ApiLevel=4\r
	@ScriptName=Ghost\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Ghost = VFX_Ghost001 #%(T_46_META_WS_E_GHOST)\r
	@ApiLevel=4\r
	@ScriptName=Gunfire\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Gunfire = VFX_Gunfire001 #%(T_46_META_WS_E_GUNFIRE)\r
	@ApiLevel=4\r
	@ScriptName=Line\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Line = VFX_Line001 #%(T_46_META_WS_E_LINE)\r
	@ApiLevel=4\r
	@ScriptName=Liquid\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Liquid = WS_VFX_Liquid011 #%(T_46_META_WS_E_LIQUID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIWidget\r
@Tip = %(T_49_META_TYPE_13_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudWidget : Entity = 13 { #%(T_46_META_WS_C_UIWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=Active\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    ActiveSelf : Bool = -13000 #%(T_46_META_WS_P_ACTIVE)\r
	@ApiLevel=4\r
	@ScriptName=AnchorPosition\r
	@Tip = %(T_49_META_TYP_13_I1_D)\r
    AnchorPosition : Vector3 = -13001 #%(T_46_META_WS_P_ANCHORPOSITION)\r
	@ApiLevel=4\r
	@ScriptName=Width\r
	@Tip = %(T_49_META_TYP_13_I2_D)\r
    Width : Int = -13002 #%(T_46_META_WS_P_WIDTH)\r
	@ApiLevel=4\r
	@ScriptName=Height\r
	@Tip = %(T_49_META_TYP_416_I3_D)\r
    Height : Int = -13003 #%(T_46_META_WS_P_HEIGHT)\r
	@ApiLevel=4\r
	@ScriptName=Angle\r
	@Tip = %(T_49_META_TYP_13_I4_D)\r
    Angle : Float = -13004 #%(T_46_META_WS_P_ANGLE)\r
	@ApiLevel=10\r
	@ScriptName=HostHudID_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get HostHudEntityID : String = -13005 #HostHudEntityID\r
	@ApiLevel=3\r
	@ScriptName=FileID\r
	@Tip = %(T_49_META_TYP_13_I6_D)\r
    get FileID : Int = -13006 #%(T_46_META_WS_P_FILEID)\r
	@ApiLevel=4\r
	@ScriptName=ParentUI\r
	@Tip = %(T_49_META_TYP_13_I7_D)\r
    get HostHudEntity : CustomHud = -13007 #%(T_46_META_WS_P_PARENTUI)\r
	@ApiLevel=4\r
	@ScriptName=AnchorMin\r
	@Tip = %(T_49_META_TYP_13_I8_D)\r
    AnchorMin : Vector2 = -13008 #%(T_46_META_WS_P_ANCHORMIN)\r
	@ApiLevel=4\r
	@ScriptName=AnchorMax\r
	@Tip = %(T_49_META_TYP_13_I9_D)\r
    AnchorMax : Vector2 = -13009 #%(T_46_META_WS_P_ANCHORMAX)\r
	@ApiLevel=4\r
	@ScriptName=SizeDelta\r
	@Tip = %(T_49_META_TYP_13_I10_D)\r
    SizeDelta : Vector2 = -13010 #%(T_46_META_WS_P_SIZEDELTA)\r
	@ApiLevel=4\r
	@ScriptName=Pivot\r
	@Tip = %(T_49_META_TYP_13_I11_D)\r
    Pivot : Vector2 = -13011 #%(T_46_META_WS_P_PIVOT)\r
	@ApiLevel=3\r
	@ScriptName=Depth\r
	@Tip = %(T_49_META_TYP_13_I12_D)\r
    get Depth : Int = -13012 #%(T_46_META_WS_P_DEPTH)\r
	@ApiLevel=10\r
	@ScriptName=ParentWidgetFileID_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get ParentWidgetFileID : Int = -13013 #ParentWidgetFileID\r
	@ApiLevel=4\r
	@ScriptName=ChildIndex\r
	@Tip = %(T_49_META_TYP_13_I14_D)\r
    get ChildIndex : Int = -13014 #%(T_46_META_WS_P_CHILDINDEX)\r
	@ApiLevel=3\r
	@ScriptName=ParentWidgetEntityID\r
	@Tip = %(T_49_META_TYP_13_I15_D)\r
    get ParentEntityID : String = -13015 #%(T_46_META_WS_P_PARENTWIDGETENTITYID)\r
	@ApiLevel=3\r
	@Tip = %(T_49_META_TYP_13_I16_D)\r
    get UniqueID : String = -13016 #UniqueID\r
	@ApiLevel=4\r
	@ScriptName=Priority\r
	@Tip = %(T_49_META_TYP_13_I17_D)\r
    Priority : Int = -13017 #%(T_46_META_WS_P_PRIORITY)\r
	@ApiLevel=4\r
	@ScriptName=ActualPosition\r
	@Tip = %(T_49_META_TYP_13_I18_D)\r
    ActualPosition : Vector3 = -13018 #%(T_46_META_WS_P_ACTUALPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CustomUIOrWidget\r
@Tip = %(T_49_META_TYPE_391_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
alias HudWidgetOrCustomHud : Object&(HudWidget|CustomHud) = 391 #%(T_46_META_WS_C_CUSTOMUIORWIDGET)\r
\r
@ApiLevel=4\r
@ScriptName=UIWidgetEmpty\r
@Tip = %(T_49_META_TYPE_38_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudEmptyWidget : HudWidget = 38 { #%(T_46_META_WS_C_UIWIDGETEMPTY)\r
	@ApiLevel=4\r
	@ScriptName=Alpha\r
	@Tip = %(T_49_META_TYP_38_I0_D)\r
    Alpha : Float = -38000 #%(T_46_META_WS_P_ALPHA)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIWidgetImage\r
@Tip = %(T_49_META_TYPE_39_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudImageWidget : HudWidget = 39 { #%(T_46_META_WS_C_UIWIDGETIMAGE)\r
	@ApiLevel=4\r
	@ScriptName=Color\r
	@Tip = %(T_49_META_TYP_254_I2_D)\r
    Color : Color = -39000 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@ScriptName=SpriteName\r
	@Tip = %(T_49_META_TYP_39_I1_D)\r
    SpriteName : SpriteID = -39001 #%(T_46_META_WS_P_SPRITENAME)\r
	@ApiLevel=4\r
	@ScriptName=Alpha\r
	@Tip = %(T_49_META_TYP_38_I0_D)\r
    Alpha : Float = -39002 #%(T_46_META_WS_P_ALPHA)\r
	@ApiLevel=4\r
	@ScriptName=Flip\r
	@Tip = %(T_49_META_TYP_39_I3_D)\r
    SpriteFlip : Int = -39003 #%(T_46_META_WS_P_FLIP)\r
	@ApiLevel=4\r
	@ScriptName=Fill\r
	@Tip = %(T_49_META_TYP_39_I4_D)\r
    SpriteType : FillType = -39004 #%(T_46_META_WS_P_FILL)\r
	@ApiLevel=4\r
	@ScriptName=CenterInvisible\r
	@Tip = %(T_49_META_TYP_39_I5_D)\r
    CenterInvisible : Bool = -39005 #%(T_46_META_WS_P_CENTERINVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=FillDirection\r
	@Tip = %(T_49_META_TYP_39_I6_D)\r
    FillDir : FillDir = -39006 #%(T_46_META_WS_P_FILLDIRECTION)\r
	@ApiLevel=4\r
	@ScriptName=FillAmount\r
	@Tip = %(T_49_META_TYP_39_I7_D)\r
    FillAmount : Float = -39007 #%(T_46_META_WS_P_FILLAMOUNT)\r
	@ApiLevel=4\r
	@ScriptName=InvertFill\r
	@Tip = %(T_49_META_TYP_39_I8_D)\r
    InvertFill : Bool = -39008 #%(T_46_META_WS_P_INVERTFILL)\r
	@ApiLevel=4\r
	@ScriptName=Gradient\r
	@Tip = %(T_49_META_TYP_39_I9_D)\r
    Gradient : Int = -39009 #%(T_46_META_WS_P_GRADIENT)\r
	@ApiLevel=4\r
	@ScriptName=GradientTop\r
	@Tip = %(T_49_META_TYP_39_I10_D)\r
    GradientTop : Color = -39010 #%(T_46_META_WS_P_GRADIENTTOP)\r
	@ApiLevel=4\r
	@ScriptName=GradientBottom\r
	@Tip = %(T_49_META_TYP_39_I11_D)\r
    GradientBottom : Color = -39011 #%(T_46_META_WS_P_GRADIENTBOTTOM)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=TopAlpha\r
	@Tip = %(T_49_META_TYP_39_I12_D)\r
    GradientTopAlpha : Float = -39012 #%(T_46_META_WS_P_TOPALPHA)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=BottomAlpha\r
	@Tip = %(T_49_META_TYP_39_I13_D)\r
    GradientBottomAlpha : Float = -39013 #%(T_46_META_WS_P_BOTTOMALPHA)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIWidgetLabel\r
@Tip = %(T_49_META_TYPE_40_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudLabelWidget : HudWidget = 40 { #%(T_46_META_WS_C_UIWIDGETLABEL)\r
	@ApiLevel=4\r
	@ScriptName=Color\r
	@Tip = %(T_49_META_TYP_254_I2_D)\r
    Color : Color = -40000 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@ScriptName=Content\r
	@Tip = %(T_49_META_TYP_40_I1_D)\r
    Text : String = -40001 #%(T_46_META_WS_P_CONTENT)\r
	@ApiLevel=4\r
	@ScriptName=Alpha\r
	@Tip = %(T_49_META_TYP_38_I0_D)\r
    Alpha : Float = -40002 #%(T_46_META_WS_P_ALPHA)\r
	@ApiLevel=4\r
	@ScriptName=LocKey\r
	@Tip = %(T_49_META_TYP_40_I3_D)\r
    LocKey : String = -40003 #%(T_46_META_WS_P_LOCKEY)\r
	@ApiLevel=4\r
	@ScriptName=FontSize\r
	@Tip = %(T_49_META_TYP_1042_I1_D)\r
    FontSize : Int = -40004 #%(T_46_META_WS_P_FONTSIZE)\r
	@ApiLevel=4\r
	@ScriptName=AlignmentHorizontal\r
	@Tip = %(T_49_META_TYP_40_I5_D)\r
    Alignment : Int = -40005 #%(T_46_META_WS_P_ALIGNMENTHORIZONTAL)\r
	@ApiLevel=4\r
	@ScriptName=AlignmentVertical\r
	@Tip = %(T_49_META_TYP_40_I6_D)\r
    AlignmentVertical : Int = -40006 #%(T_46_META_WS_P_ALIGNMENTVERTICAL)\r
	@ApiLevel=4\r
	@ScriptName=IsBold\r
	@Tip = %(T_49_META_TYP_40_I7_D)\r
    IsBold : Bool = -40007 #%(T_46_META_WS_P_ISBOLD)\r
	@ApiLevel=4\r
	@ScriptName=IsItalic\r
	@Tip = %(T_49_META_TYP_40_I8_D)\r
    IsItalic : Bool = -40008 #%(T_46_META_WS_P_ISITALIC)\r
	@ApiLevel=4\r
	@ScriptName=IsUnderline\r
	@Tip = %(T_49_META_TYP_40_I9_D)\r
    IsUnderline : Bool = -40009 #%(T_46_META_WS_P_ISUNDERLINE)\r
	@ApiLevel=4\r
	@ScriptName=LineSpacing\r
	@Tip = %(T_49_META_TYP_40_I10_D)\r
    LineSpacing : Float = -40010 #%(T_46_META_WS_P_LINESPACING)\r
	@ApiLevel=4\r
	@ScriptName=Overflow\r
	@Tip = %(T_49_META_TYP_40_I11_D)\r
    Overflow : Int = -40011 #%(T_46_META_WS_P_OVERFLOW)\r
	@ApiLevel=4\r
	@ScriptName=Font\r
	@Tip = %(T_49_META_TYP_40_I12_D)\r
    FontType : FontType = -40012 #%(T_46_META_WS_P_FONT)\r
	@ApiLevel=4\r
	@ScriptName=IsApplyShadow\r
	@Tip = %(T_49_META_TYP_40_I13_D)\r
    IsApplyShadow : Bool = -40013 #%(T_46_META_WS_P_ISAPPLYSHADOW)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=ShadowColor\r
	@Tip = %(T_49_META_TYP_40_I14_D)\r
    ShadowColor : Color = -40014 #%(T_46_META_WS_P_SHADOWCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=ShadowOffset\r
	@Tip = %(T_49_META_TYP_40_I15_D)\r
    ShadowOffset : Vector2 = -40015 #%(T_46_META_WS_P_SHADOWOFFSET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIWidgetButton\r
@Tip = %(T_49_META_TYPE_41_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudButtonWidget : HudWidget = 41 { #%(T_46_META_WS_C_UIWIDGETBUTTON)\r
	@ApiLevel=4\r
	@ScriptName=SpriteResource\r
	@Tip = %(T_49_META_TYP_41_I0_D)\r
    SpriteName : SpriteID = -41000 #%(T_46_META_WS_P_SPRITERESOURCE)\r
	@ApiLevel=4\r
	@ScriptName=Color\r
	@Tip = %(T_49_META_TYP_254_I2_D)\r
    Color : Color = -41001 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@ScriptName=Alpha\r
	@Tip = %(T_49_META_TYP_38_I0_D)\r
    Alpha : Float = -41002 #%(T_46_META_WS_P_ALPHA)\r
	@ApiLevel=3\r
	@ScriptName=DisableColor\r
	@Tip = %(T_49_META_TYP_41_I3_D)\r
    DisableColor : Color = -41003 #%(T_46_META_WS_P_DISABLECOLOR)\r
	@ApiLevel=4\r
	@ScriptName=PressedColor\r
	@Tip = %(T_49_META_TYP_41_I4_D)\r
    PressedColor : Color = -41004 #%(T_46_META_WS_P_PRESSEDCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=FillType\r
	@Tip = %(T_49_META_TYP_41_I5_D)\r
    SpriteType : FillType = -41005 #%(T_46_META_WS_P_FILLTYPE)\r
	@ApiLevel=3\r
	@ScriptName=IsFEButton\r
	@Tip = %(T_49_META_TYP_41_I6_D)\r
    get IsFEButton : Bool = -41006 #%(T_46_META_WS_P_ISFEBUTTON)\r
	@ApiLevel=10\r
	@ScriptName=PressedSprite\r
	@Tip = %(T_49_META_TYP_41_I7_D)\r
    PressedSprite : SpriteID = -41007 #%(T_46_META_WS_P_PRESSEDSPRITE)\r
	@ApiLevel=10\r
	@Default=-1\r
	@ScriptName=PressedSpriteType\r
	@Tip = %(T_49_META_TYP_41_I8_D)\r
    PressedSpriteType : FillType = -41008 #%(T_46_META_WS_P_PRESSEDSPRITETYPE)\r
	@ApiLevel=4\r
	@ScriptName=FlipType\r
	@Tip = %(T_49_META_TYP_41_I9_D)\r
    FlipType : Int = -41009 #%(T_46_META_WS_P_FLIPTYPE)\r
	@ApiLevel=4\r
	@ScriptName=CenterInvisible\r
	@Tip = %(T_49_META_TYP_39_I5_D)\r
    CenterInvisible : Bool = -41010 #%(T_46_META_WS_P_CENTERINVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=FillDirection\r
	@Tip = %(T_49_META_TYP_39_I6_D)\r
    FillDir : FillDir = -41011 #%(T_46_META_WS_P_FILLDIRECTION)\r
	@ApiLevel=4\r
	@ScriptName=FillAmount\r
	@Tip = %(T_49_META_TYP_39_I7_D)\r
    FillAmount : Float = -41012 #%(T_46_META_WS_P_FILLAMOUNT)\r
	@ApiLevel=4\r
	@ScriptName=InvertFill\r
	@Tip = %(T_49_META_TYP_39_I8_D)\r
    InvertFill : Bool = -41013 #%(T_46_META_WS_P_INVERTFILL)\r
	@ApiLevel=4\r
	@ScriptName=Gradient\r
	@Tip = %(T_49_META_TYP_39_I9_D)\r
    Gradient : Int = -41014 #%(T_46_META_WS_P_GRADIENT)\r
	@ApiLevel=4\r
	@ScriptName=GradientTop\r
	@Tip = %(T_49_META_TYP_39_I10_D)\r
    GradientTop : Color = -41015 #%(T_46_META_WS_P_GRADIENTTOP)\r
	@ApiLevel=4\r
	@ScriptName=GradientBottom\r
	@Tip = %(T_49_META_TYP_39_I11_D)\r
    GradientBottom : Color = -41016 #%(T_46_META_WS_P_GRADIENTBOTTOM)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=TopAlpha\r
	@Tip = %(T_49_META_TYP_39_I12_D)\r
    GradientTopAlpha : Float = -41017 #%(T_46_META_WS_P_TOPALPHA)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=BottomAlpha\r
	@Tip = %(T_49_META_TYP_39_I13_D)\r
    GradientBottomAlpha : Float = -41018 #%(T_46_META_WS_P_BOTTOMALPHA)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=DisableCollider\r
	@Tip = %(T_49_META_TYP_41_I19_D)\r
    DisableCollider : Bool = -41019 #%(T_48_META_TYP_41_I19)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIWidgetInputLabel\r
@Tip = %(T_49_META_TYPE_42_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudInputWidget : HudWidget = 42 { #%(T_46_META_WS_C_UIWIDGETINPUTLABLE)\r
	@ApiLevel=4\r
	@ScriptName=DefaultText\r
	@Tip = %(T_49_META_TYP_42_I0_D)\r
    DefaultText : String = -42000 #%(T_46_META_WS_P_DEFAULTTEXT)\r
	@ApiLevel=4\r
	@ScriptName=ActiveText\r
	@Tip = %(T_49_META_TYP_42_I1_D)\r
    ActiveText : String = -42001 #%(T_46_META_WS_P_ACTIVETEXT)\r
	@ApiLevel=4\r
	@ScriptName=FontSize\r
	@Tip = %(T_49_META_TYP_1042_I1_D)\r
    FontSize : Int = -42002 #%(T_46_META_WS_P_FONTSIZE)\r
	@ApiLevel=4\r
	@ScriptName=AlignmentHorizontal\r
	@Tip = %(T_49_META_TYP_42_I3_D)\r
    Alignment : Int = -42003 #%(T_46_META_WS_P_ALIGNMENTHORIZONTAL)\r
	@ApiLevel=4\r
	@ScriptName=AlignmentVertical\r
	@Tip = %(T_49_META_TYP_42_I4_D)\r
    AlignmentVertical : Int = -42004 #%(T_46_META_WS_P_ALIGNMENTVERTICAL)\r
	@ApiLevel=4\r
	@ScriptName=IsBold\r
	@Tip = %(T_49_META_TYP_42_I5_D)\r
    IsBold : Bool = -42005 #%(T_46_META_WS_P_ISBOLD)\r
	@ApiLevel=4\r
	@ScriptName=IsItalic\r
	@Tip = %(T_49_META_TYP_42_I6_D)\r
    IsItalic : Bool = -42006 #%(T_46_META_WS_P_ISITALIC)\r
	@ApiLevel=4\r
	@ScriptName=IsUnderline\r
	@Tip = %(T_49_META_TYP_42_I7_D)\r
    IsUnderline : Bool = -42007 #%(T_46_META_WS_P_ISUNDERLINE)\r
	@ApiLevel=4\r
	@ScriptName=LineSpacing\r
	@Tip = %(T_49_META_TYP_42_I8_D)\r
    LineSpacing : Float = -42008 #%(T_46_META_WS_P_LINESPACING)\r
	@ApiLevel=4\r
	@ScriptName=WordWrap\r
	@Tip = %(T_49_META_TYP_42_I9_D)\r
    WordWrap : Int = -42009 #%(T_46_META_WS_P_WORDWRAP)\r
	@ApiLevel=4\r
	@ScriptName=MaxLength\r
	@Tip = %(T_49_META_TYP_42_I10_D)\r
    MaxLength : Int = -42010 #%(T_46_META_WS_P_MAXLENGTH)\r
	@ApiLevel=10\r
	@ScriptName=TransitionType\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get TransitionType : Int = -42011 #%(T_46_META_WS_P_TRANSITIONTYPE)\r
	@ApiLevel=4\r
	@ScriptName=LabelColor\r
	@Tip = %(T_49_META_TYP_1043_I4_D)\r
    LabelColor : Color = -42012 #%(T_46_META_WS_P_LABELCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=NormalColor\r
	@Tip = %(T_49_META_TYP_254_I2_D)\r
    NormalColor : Color = -42013 #%(T_46_META_WS_P_NORMALCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=PressedColor\r
	@Tip = %(T_49_META_TYP_42_I14_D)\r
    PressedColor : Color = -42014 #%(T_46_META_WS_P_PRESSEDCOLOR)\r
	@ApiLevel=10\r
	@ScriptName=DisableColor\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    DisableColor : Color = -42015 #%(T_46_META_WS_P_DISABLECOLOR)\r
	@ApiLevel=4\r
	@ScriptName=LocKey\r
	@Tip = %(T_49_META_TYP_42_I16_D)\r
    LocKey : String = -42016 #%(T_46_META_WS_P_LOCKEY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIWidgetLayout\r
@Tip = %(T_49_META_TYPE_294_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudLayout : HudWidget = 294 { #%(T_46_META_WS_C_UIWIDGETLAYOUT)\r
	@ApiLevel=4\r
	@ScriptName=Alpha\r
	@Tip = %(T_49_META_TYP_38_I0_D)\r
    Alpha : Float = -294000 #%(T_46_META_WS_P_ALPHA)\r
	@ApiLevel=4\r
	@ScriptName=LayoutType\r
	@Tip = %(T_49_META_TYP_294_I1_D)\r
    LayoutType : Int = -294001 #%(T_46_META_WS_P_LAYOUTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=ContentOrigin\r
	@Tip = %(T_49_META_TYP_294_I2_D)\r
    ContentOrigin : Int = -294002 #%(T_46_META_WS_P_CONTENTORIGIN)\r
	@ApiLevel=4\r
	@ScriptName=FillDirection\r
	@Tip = %(T_49_META_TYP_294_I3_D)\r
    FillDirection : Int = -294003 #%(T_46_META_WS_P_FILLDIRECTION)\r
	@ApiLevel=4\r
	@ScriptName=CellSize\r
	@Tip = %(T_49_META_TYP_294_I4_D)\r
    CellSize : Vector2 = -294004 #%(T_46_META_WS_P_CELLSIZE)\r
	@ApiLevel=4\r
	@ScriptName=CellSpace\r
	@Tip = %(T_49_META_TYP_294_I5_D)\r
    Space : Vector2 = -294005 #%(T_46_META_WS_P_CELLSPACE)\r
	@ApiLevel=4\r
	@ScriptName=Constraint\r
	@Tip = %(T_49_META_TYP_294_I6_D)\r
    Constraint : Int = -294006 #%(T_46_META_WS_P_CONSTRAINT)\r
	@ApiLevel=4\r
	@ScriptName=ConstraintCount\r
	@Tip = %(T_49_META_TYP_294_I7_D)\r
    ConstraintCount : Int = -294007 #%(T_46_META_WS_P_CONSTRAINTCOUNT)\r
	@ApiLevel=4\r
	@ScriptName=VerticalOffset\r
	@Tip = %(T_49_META_TYP_294_I8_D)\r
    OffsetUpDown : Vector2 = -294008 #%(T_46_META_WS_P_VERTICALOFFSET)\r
	@ApiLevel=4\r
	@ScriptName=HorizontalOffset\r
	@Tip = %(T_49_META_TYP_294_I9_D)\r
    OffsetLeftRight : Vector2 = -294009 #%(T_46_META_WS_P_HORIZONTALOFFSET)\r
	@ApiLevel=4\r
	@ScriptName=SortType\r
	@Tip = %(T_49_META_TYP_294_I10_D)\r
    SortType : LayoutSortType = -294010 #%(T_46_META_WS_P_SORTTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIWidgetTexture\r
@Tip = %(T_49_META_TYPE_316_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudTexture : HudWidget = 316 { #%(T_46_META_WS_C_UIWIDGETTEXTURE)\r
	@ApiLevel=4\r
	@ScriptName=TextureResource\r
	@Tip = %(T_49_META_TYP_316_I0_D)\r
    TextureName : TextureID = -316000 #%(T_46_META_WS_P_TEXTURERESOURCE)\r
	@ApiLevel=3\r
	@ScriptName=ShaderName\r
	@Tip = %(T_49_META_TYP_316_I1_D)\r
    get ShaderName : String = -316001 #%(T_46_META_WS_P_SHADERNAME)\r
	@ApiLevel=4\r
	@ScriptName=UVOffset\r
	@Tip = %(T_49_META_TYP_316_I2_D)\r
    UVRectXY : Vector2 = -316002 #%(T_46_META_WS_P_UVOFFSET)\r
	@ApiLevel=4\r
	@ScriptName=UVSize\r
	@Tip = %(T_49_META_TYP_316_I3_D)\r
    UVRectWH : Vector2 = -316003 #%(T_46_META_WS_P_UVSIZE)\r
	@ApiLevel=4\r
	@ScriptName=FillType\r
	@Tip = %(T_49_META_TYP_316_I4_D)\r
    FillType : FillType = -316004 #%(T_46_META_WS_P_FILLTYPE)\r
	@ApiLevel=4\r
	@ScriptName=BorderLR\r
	@Tip = %(T_49_META_TYP_316_I5_D)\r
    BorderLR : Vector2 = -316005 #%(T_46_META_WS_P_BORDERLR)\r
	@ApiLevel=4\r
	@ScriptName=BorderTB\r
	@Tip = %(T_49_META_TYP_316_I6_D)\r
    BorderTB : Vector2 = -316006 #%(T_46_META_WS_P_BORDERTB)\r
	@ApiLevel=4\r
	@ScriptName=CenterInvisible\r
	@Tip = %(T_49_META_TYP_39_I5_D)\r
    CenterInvisible : Bool = -316007 #%(T_46_META_WS_P_CENTERINVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=FillDirection\r
	@Tip = %(T_49_META_TYP_39_I6_D)\r
    FillDir : FillDir = -316008 #%(T_46_META_WS_P_FILLDIRECTION)\r
	@ApiLevel=4\r
	@ScriptName=FillAmount\r
	@Tip = %(T_49_META_TYP_39_I7_D)\r
    FillAmount : Float = -316009 #%(T_46_META_WS_P_FILLAMOUNT)\r
	@ApiLevel=4\r
	@ScriptName=InvertFill\r
	@Tip = %(T_49_META_TYP_39_I8_D)\r
    InvertFill : Bool = -316010 #%(T_46_META_WS_P_INVERTFILL)\r
	@ApiLevel=4\r
	@ScriptName=FlipType\r
	@Tip = %(T_49_META_TYP_316_I11_D)\r
    Flip : Int = -316011 #%(T_46_META_WS_P_FLIPTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Color\r
	@Tip = %(T_49_META_TYP_254_I2_D)\r
    Color : Color = -316012 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@ScriptName=Gradient\r
	@Tip = %(T_49_META_TYP_39_I9_D)\r
    Gradient : Int = -316013 #%(T_46_META_WS_P_GRADIENT)\r
	@ApiLevel=4\r
	@ScriptName=GradientTop\r
	@Tip = %(T_49_META_TYP_39_I10_D)\r
    GradientTop : Color = -316014 #%(T_46_META_WS_P_GRADIENTTOP)\r
	@ApiLevel=4\r
	@ScriptName=GradientBottom\r
	@Tip = %(T_49_META_TYP_39_I11_D)\r
    GradientBottom : Color = -316015 #%(T_46_META_WS_P_GRADIENTBOTTOM)\r
	@ApiLevel=4\r
	@ScriptName=Alpha\r
	@Tip = %(T_49_META_TYP_38_I0_D)\r
    Alpha : Float = -316016 #%(T_46_META_WS_P_ALPHA)\r
	@ApiLevel=4\r
	@ScriptName=TopAlpha\r
	@Tip = %(T_49_META_TYP_39_I12_D)\r
    GradientTopAlpha : Float = -316017 #%(T_46_META_WS_P_TOPALPHA)\r
	@ApiLevel=4\r
	@ScriptName=BottomAlpha\r
	@Tip = %(T_49_META_TYP_39_I13_D)\r
    GradientBottomAlpha : Float = -316018 #%(T_46_META_WS_P_BOTTOMALPHA)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIWidgetProfile\r
@Tip = %(T_49_META_TYPE_323_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudProfileInfo : HudWidget = 323 { #%(T_46_META_WS_C_UIWIDGETPROFILE)\r
	@ApiLevel=4\r
	@ScriptName=Scale\r
	@Tip = %(T_49_META_TYP_323_I0_D)\r
    Scale : Vector3 = -323000 #%(T_46_META_WS_P_SCALE)\r
	@ApiLevel=4\r
	@ScriptName=AccountID\r
	@Tip = %(T_49_META_TYP_323_I1_D)\r
    AccountID : UUID = -323001 #%(T_46_META_WS_P_ACCOUNTID)\r
	@ApiLevel=3\r
	@ScriptName=ProfileInfo\r
	@Tip = %(T_49_META_TYP_323_I2_D)\r
    get ProfileInfo : ProfileInfo = -323002 #%(T_46_META_WS_P_PROFILEINFO)\r
	@ApiLevel=4\r
	@ScriptName=Style\r
	@Tip = %(T_49_META_TYP_323_I3_D)\r
    get ShowType : Int = -323003 #%(T_46_META_WS_P_STYLE)\r
	@ApiLevel=4\r
	@ScriptName=ShowRank\r
	@Tip = %(T_49_META_TYP_323_I4_D)\r
    get ShowRank : Int = -323004 #%(T_46_META_WS_P_SHOWRANK)\r
	@ApiLevel=4\r
	@ScriptName=ShowPin\r
	@Tip = %(T_49_META_TYP_323_I5_D)\r
    get ShowPin : Bool = -323005 #%(T_46_META_WS_P_SHOWPIN)\r
	@ApiLevel=4\r
	@ScriptName=ShowName\r
	@Tip = %(T_49_META_TYP_323_I6_D)\r
    get ShowName : Bool = -323006 #%(T_46_META_WS_P_SHOWNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIWidgetToggle\r
@Tip = %(T_49_META_TYPE_352_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudToggle : HudWidget = 352 { #%(T_46_META_WS_C_UIWIDGETTOGGLE)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=Alpha\r
	@Tip = %(T_49_META_TYP_38_I0_D)\r
    Alpha : Float = -352000 #%(T_46_META_WS_P_ALPHA)\r
	@ApiLevel=4\r
	@ScriptName=UnselectedSprite\r
	@Tip = %(T_49_META_TYP_352_I1_D)\r
    UnSelectedSprite : SpriteID = -352001 #%(T_46_META_WS_P_UNSELECTEDSPRITE)\r
	@ApiLevel=4\r
	@ScriptName=UnselectedType\r
	@Tip = %(T_49_META_TYP_352_I2_D)\r
    UnSelectedType : FillType = -352002 #%(T_46_META_WS_P_UNSELECTEDTYPE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=UnselectedColor\r
	@Tip = %(T_49_META_TYP_352_I3_D)\r
    UnSelectedColor : Color = -352003 #%(T_46_META_WS_P_UNSELECTEDCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=SelectedSprite\r
	@Tip = %(T_49_META_TYP_352_I4_D)\r
    SelectedSprite : SpriteID = -352004 #%(T_46_META_WS_P_SELECTEDSPRITE)\r
	@ApiLevel=4\r
	@ScriptName=SelectedType\r
	@Tip = %(T_49_META_TYP_352_I5_D)\r
    SelectedType : FillType = -352005 #%(T_46_META_WS_P_SELECTEDTYPE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=SelectedColor\r
	@Tip = %(T_49_META_TYP_352_I6_D)\r
    SelectedColor : Color = -352006 #%(T_46_META_WS_P_SELECTEDCOLOR)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=DisableCollider\r
	@Tip = %(T_49_META_TYP_41_I19_D)\r
    DisableCollider : Bool = -352007 #%(T_48_META_TYP_41_I19)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIWidgetTouchPad\r
@Tip = %(T_49_META_TYPE_387_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudTouchPad : HudWidget = 387 { #%(T_46_META_WS_C_UIWIDGETTOUCHPAD)\r
	@ApiLevel=4\r
	@Default=0.2\r
	@ScriptName=Alpha\r
	@Tip = %(T_49_META_TYP_38_I0_D)\r
    Alpha : Float = -387000 #%(T_46_META_WS_P_ALPHA)\r
	@ApiLevel=4\r
	@ScriptName=AllowPressedOutside\r
	@Tip = %(T_49_META_TYP_387_I1_D)\r
    AllowPressedOutside : Bool = -387001 #%(T_46_META_WS_P_ALLOWPRESSEDOUTSIDE)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=DisableCollider\r
	@Tip = %(T_49_META_TYP_41_I19_D)\r
    DisableCollider : Bool = -387002 #%(T_48_META_TYP_41_I19)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIWidgetJoystick\r
@Tip = %(T_49_META_TYPE_389_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudJoystick : HudWidget = 389 { #%(T_46_META_WS_C_UIWIDGETJOYSTICK)\r
	@ApiLevel=4\r
	@ScriptName=BackgroundOffset\r
	@Tip = %(T_49_META_TYP_389_I0_D)\r
    Offset : Vector2 = -389000 #%(T_46_META_WS_P_BACKGROUNDOFFSET)\r
	@ApiLevel=4\r
	@Default=UI_move_bg\r
	@ScriptName=BackgroundSprite\r
	@Tip = %(T_49_META_TYP_389_I1_D)\r
    BackGroundImage : SpriteID = -389001 #%(T_46_META_WS_P_BACKGROUNDSPRITE)\r
	@ApiLevel=4\r
	@Default=91\r
	@ScriptName=BackgroundRadius\r
	@Tip = %(T_49_META_TYP_389_I2_D)\r
    BackGroundRadius : Int = -389002 #%(T_46_META_WS_P_BACKGROUNDRADIUS)\r
	@ApiLevel=4\r
	@Default=UI_move_bt\r
	@ScriptName=JoystickImage\r
	@Tip = %(T_49_META_TYP_389_I3_D)\r
    JoystickCapImage : SpriteID = -389003 #%(T_46_META_WS_P_JOYSTICKIMAGE)\r
	@ApiLevel=4\r
	@Default=27\r
	@ScriptName=JoystickRadius\r
	@Tip = %(T_49_META_TYP_389_I4_D)\r
    JoystickCapRadius : Int = -389004 #%(T_46_META_WS_P_JOYSTICKRADIUS)\r
	@ApiLevel=4\r
	@Default=58\r
	@ScriptName=JoystickDragRadius\r
	@Tip = %(T_49_META_TYP_389_I5_D)\r
    JoystickCapDragRadius : Int = -389005 #%(T_46_META_WS_P_JOYSTICKDRAGRADIUS)\r
	@ApiLevel=4\r
	@Default=UI_move_bt01\r
	@ScriptName=ArrowSprite\r
	@Tip = %(T_49_META_TYP_389_I6_D)\r
    ArrowImage : SpriteID = -389006 #%(T_46_META_WS_P_ARROWSPRITE)\r
	@ApiLevel=4\r
	@Default=&math.Vector2(70, 24)\r
	@ScriptName=ArrowSize\r
	@Tip = %(T_49_META_TYP_389_I7_D)\r
    ArrowSize : Vector2 = -389007 #%(T_46_META_WS_P_ARROWSIZE)\r
	@ApiLevel=4\r
	@Default=98\r
	@ScriptName=ArrowOffset\r
	@Tip = %(T_49_META_TYP_389_I8_D)\r
    ArrowOffset : Int = -389008 #%(T_46_META_WS_P_ARROWOFFSET)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=ActivatedAlpha\r
	@Tip = %(T_49_META_TYP_389_I9_D)\r
    ActivatedAlpha : Float = -389009 #%(T_46_META_WS_P_ACTIVATEDALPHA)\r
	@ApiLevel=4\r
	@Default=0.5\r
	@ScriptName=InactivatedAlpha\r
	@Tip = %(T_49_META_TYP_389_I10_D)\r
    InactivatedAlpha : Float = -389010 #%(T_46_META_WS_P_INACTIVATEDALPHA)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=DisableCollider\r
	@Tip = %(T_49_META_TYP_41_I19_D)\r
    DisableCollider : Bool = -389011 #%(T_48_META_TYP_41_I19)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIPanel\r
@Tip = %(T_49_META_TYPE_265_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudPanel : HudWidget = 265 { #%(T_46_META_WS_C_UIPANEL)\r
	@ApiLevel=4\r
	@ScriptName=Alpha\r
	@Tip = %(T_49_META_TYP_38_I0_D)\r
    Alpha : Float = -265000 #%(T_46_META_WS_P_ALPHA)\r
	@ApiLevel=4\r
	@ScriptName=BackgroundFill\r
	@Tip = %(T_49_META_TYP_265_I1_D)\r
    BgFill : Bool = -265001 #%(T_46_META_WS_P_BACKGROUNDFILL)\r
	@ApiLevel=3\r
	@ScriptName=BackgroundName\r
	@Tip = %(T_49_META_TYP_265_I2_D)\r
    BgName : SpriteID = -265002 #%(T_46_META_WS_P_BACKGROUNDNAME)\r
	@ApiLevel=4\r
	@ScriptName=BackgroundColor\r
	@Tip = %(T_49_META_TYP_265_I3_D)\r
    BgColor : Color = -265003 #%(T_46_META_WS_P_BACKGROUNDCOLOR)\r
	@ApiLevel=10\r
	@ScriptName=BackgroundSizeDelta\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get BgSizeDelta : Vector2 = -265004 #%(T_46_META_WS_P_BACKGROUNDSIZEDELTA)\r
	@ApiLevel=4\r
	@ScriptName=BackgroundAlpha\r
	@Tip = %(T_49_META_TYP_265_I5_D)\r
    BgAlpha : Float = -265005 #%(T_46_META_WS_P_BACKGROUNDALPHA)\r
	@ApiLevel=4\r
	@ScriptName=ClippingType\r
	@Tip = %(T_49_META_TYP_265_I6_D)\r
    ClippingType : Int = -265006 #%(T_46_META_WS_P_CLIPPINGTYPE)\r
	@ApiLevel=4\r
	@ScriptName=MaskName\r
	@Tip = %(T_49_META_TYP_265_I7_D)\r
    MaskName : String = -265007 #%(T_46_META_WS_P_MASKNAME)\r
	@ApiLevel=4\r
	@ScriptName=Softness\r
	@Tip = %(T_49_META_TYP_265_I8_D)\r
    Softness : Vector2 = -265008 #%(T_46_META_WS_P_SOFTNESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIPanelEmpty\r
@Tip = %(T_49_META_TYPE_271_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudEmptyPanel : HudPanel = 271 { #%(T_46_META_WS_C_UIPANELEMPTY)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=Grid\r
@Tip = %(T_49_META_TYPE_18_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudGrid : HudPanel = 266 { #%(T_46_META_WS_C_GRID)\r
	@ApiLevel=4\r
	@ScriptName=LayoutType\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    LayoutType : Int = -266000 #%(T_46_META_WS_P_LAYOUTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=ContentOrigin\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    ContentOrigin : Int = -266001 #%(T_46_META_WS_P_CONTENTORIGIN)\r
	@ApiLevel=4\r
	@ScriptName=FillDirection\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    FillDirection : Int = -266002 #%(T_46_META_WS_P_FILLDIRECTION)\r
	@ApiLevel=4\r
	@ScriptName=CellSize\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    CellSize : Vector2 = -266003 #%(T_46_META_WS_P_CELLSIZE)\r
	@ApiLevel=4\r
	@ScriptName=CellSpace\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Space : Vector2 = -266004 #%(T_46_META_WS_P_CELLSPACE)\r
	@ApiLevel=4\r
	@ScriptName=Constraint\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Constraint : Int = -266005 #%(T_46_META_WS_P_CONSTRAINT)\r
	@ApiLevel=4\r
	@ScriptName=ConstraintCount\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    ConstraintCount : Int = -266006 #%(T_46_META_WS_P_CONSTRAINTCOUNT)\r
	@ApiLevel=4\r
	@ScriptName=VerticalOffset\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    OffsetUpDown : Vector2 = -266007 #%(T_46_META_WS_P_VERTICALOFFSET)\r
	@ApiLevel=4\r
	@ScriptName=HorizontalOffset\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    OffsetLeftRight : Vector2 = -266008 #%(T_46_META_WS_P_HORIZONTALOFFSET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIScrollPanel\r
@Tip = %(T_49_META_TYPE_267_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudScrollView : HudPanel = 267 { #%(T_46_META_WS_C_UISCROLLPANEL)\r
	@ApiLevel=4\r
	@ScriptName=ContentOrigin\r
	@Tip = %(T_49_META_TYP_267_I0_D)\r
    ContentOrigin : Int = -267000 #%(T_46_META_WS_P_CONTENTORIGIN)\r
	@ApiLevel=4\r
	@ScriptName=ScrollDirection\r
	@Tip = %(T_49_META_TYP_267_I1_D)\r
    ScrollDirection : Int = -267001 #%(T_46_META_WS_P_SCROLLDIRECTION)\r
	@ApiLevel=4\r
	@ScriptName=CustomXY\r
	@Tip = %(T_49_META_TYP_267_I2_D)\r
    CustomXY : Vector2 = -267002 #%(T_46_META_WS_P_CUSTOMXY)\r
	@ApiLevel=4\r
	@ScriptName=ScrollEffect\r
	@Tip = %(T_49_META_TYP_267_I3_D)\r
    DragEffect : Int = -267003 #%(T_46_META_WS_P_SCROLLEFFECT)\r
	@ApiLevel=4\r
	@ScriptName=ScrollWheelSpeed\r
	@Tip = %(T_49_META_TYP_267_I4_D)\r
    ScrollWheelFactor : Float = -267004 #%(T_46_META_WS_P_SCROLLWHEELSPEED)\r
	@ApiLevel=4\r
	@ScriptName=ScrollContinuity\r
	@Tip = %(T_49_META_TYP_267_I5_D)\r
    MomentumAmount : Float = -267005 #%(T_46_META_WS_P_SCROLLCONTINUITY)\r
	@ApiLevel=4\r
	@ScriptName=RestrictWithinPanel\r
	@Tip = %(T_49_META_TYP_267_I6_D)\r
    RestrictWithinPanel : Bool = -267006 #%(T_46_META_WS_P_RESTRICTWITHINPANEL)\r
	@ApiLevel=4\r
	@ScriptName=SmoothScrollStart\r
	@Tip = %(T_49_META_TYP_267_I7_D)\r
    SmoothDragStart : Bool = -267007 #%(T_46_META_WS_P_SMOOTHSCROLLSTART)\r
	@ApiLevel=4\r
	@ScriptName=CancelDragIfFits\r
	@Tip = %(T_49_META_TYP_267_I8_D)\r
    CancelDragIfFits : Bool = -267008 #%(T_46_META_WS_P_CANCELDRAGIFFITS)\r
	@ApiLevel=4\r
	@ScriptName=VerticalBar\r
	@Tip = %(T_49_META_TYP_267_I9_D)\r
    VerticalBar : Int = -267009 #%(T_46_META_WS_P_VERTICALBAR)\r
	@ApiLevel=4\r
	@ScriptName=HorizontalBar\r
	@Tip = %(T_49_META_TYP_267_I10_D)\r
    HorizontalBar : Int = -267010 #%(T_46_META_WS_P_HORIZONTALBAR)\r
	@ApiLevel=3\r
	@Tip = %(T_49_META_TYP_267_I11_D)\r
    ShowPosition : Vector2 = -267011 #ShowPosition\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=DisableCollider\r
	@Tip = %(T_49_META_TYP_41_I19_D)\r
    DisableCollider : Bool = -267012 #%(T_48_META_TYP_41_I19)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=HudTransform_Deprecated\r
@Tip = %(T_49_META_TYPE_18_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudTransform : Entity = 299 { #%(T_46_META_WS_C_HUDTRANSFORM_DEPRECATED)\r
	@ApiLevel=4\r
	@ScriptName=Active\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    ActiveSelf : Bool = -299000 #%(T_46_META_WS_P_ACTIVE)\r
	@ApiLevel=4\r
	@ScriptName=AnchorPosition\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    AnchorPosition : Vector3 = -299001 #%(T_46_META_WS_P_ANCHORPOSITION)\r
	@ApiLevel=4\r
	@ScriptName=Angle\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Angle : Float = -299002 #%(T_46_META_WS_P_ANGLE)\r
	@ApiLevel=4\r
	@ScriptName=Scale\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Scale : Vector3 = -299003 #%(T_46_META_WS_P_SCALE)\r
	@ApiLevel=3\r
	@ScriptName=FileID\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get FileID : Int = -299004 #%(T_46_META_WS_P_FILEID)\r
	@ApiLevel=4\r
	@ScriptName=ParentUI\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get HostHudEntity : CustomHud = -299005 #%(T_46_META_WS_P_PARENTUI)\r
	@ApiLevel=3\r
	@ScriptName=Depth\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get Depth : Int = -299006 #%(T_46_META_WS_P_DEPTH)\r
	@ApiLevel=3\r
	@ScriptName=ParentWidgetFileID\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get ParentWidgetFileID : Int = -299007 #%(T_46_META_WS_P_PARENTWIDGETFILEID)\r
	@ApiLevel=4\r
	@ScriptName=ChildIndex\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get ChildIndex : Int = -299008 #%(T_46_META_WS_P_CHILDINDEX)\r
	@ApiLevel=3\r
	@ScriptName=ParentID\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get ParentEntityID : String = -299009 #%(T_46_META_WS_P_PARENTID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIWidgetContainer\r
@Tip = %(T_49_META_TYPE_300_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
type Hud3DContainer : HudWidget = 300 { #%(T_46_META_WS_C_UIWIDGETCONTAINER)\r
	@ApiLevel=4\r
	@ScriptName=Resource\r
	@Tip = %(T_49_META_TYP_300_I0_D)\r
    ResourceID : String = -300000 #%(T_46_META_WS_P_RESOURCE)\r
	@ApiLevel=4\r
	@ScriptName=Scale\r
	@Tip = %(T_49_META_TYP_323_I0_D)\r
    Scale : Vector3 = -300001 #%(T_46_META_WS_P_SCALE)\r
	@ApiLevel=4\r
	@ScriptName=Rotation\r
	@Tip = %(T_49_META_TYP_300_I2_D)\r
    Rotation : Vector3 = -300002 #%(T_46_META_WS_P_ROTATION)\r
	@ApiLevel=4\r
	@ScriptName=CreatedEntity\r
	@Tip = %(T_49_META_TYP_300_I3_D)\r
    get PrefabEntity : Entity = -300003 #%(T_46_META_WS_P_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Turret\r
@Tip = %(T_49_META_TYPE_2507_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type UGCMinisentry : LevelObject&FightingEntity&ResetableEntity&Collider = 2507 { #%(T_46_META_WS_C_TURRET)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=TeamSeq\r
	@Tip = %(T_49_META_TYP_2507_I0_D)\r
    TeamID : Int = -2507000 #%(T_46_META_WS_P_TEAMSEQ)\r
	@ApiLevel=4\r
	@Default=200\r
	@ScriptName=HP\r
	@Tip = %(T_49_META_TYP_2507_I1_D)\r
    HP : Int = -2507001 #%(T_46_META_WS_P_HP)\r
	@ApiLevel=4\r
	@Default=200\r
	@ScriptName=MaxHP\r
	@Tip = %(T_49_META_TYP_2507_I2_D)\r
    MaxHP : Int = -2507002 #%(T_46_META_WS_P_MAXHP)\r
	@ApiLevel=4\r
	@Default=100\r
	@ScriptName=Damage\r
	@Tip = %(T_49_META_TYP_2507_I3_D)\r
    Attack : Int = -2507003 #%(T_46_META_WS_P_DAMAGE)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=AttackInterval\r
	@Tip = %(T_49_META_TYP_2507_I4_D)\r
    AttackInterval : Float = -2507004 #%(T_46_META_WS_P_ATTACKINTERVAL)\r
	@ApiLevel=4\r
	@Default=2\r
	@ScriptName=AttackRange\r
	@Tip = %(T_49_META_TYP_2507_I5_D)\r
    AttackRange : MinisentryAttackRangeType = -2507005 #%(T_46_META_WS_P_ATTACKRANGE)\r
	@ApiLevel=4\r
	@Default=0.01\r
	@ScriptName=Defense\r
	@Tip = %(T_49_META_TYP_2507_I6_D)\r
    Defense : Float = -2507006 #%(T_46_META_WS_P_DEFENSE)\r
	@ApiLevel=3\r
	@ScriptName=Target\r
	@Tip = %(T_49_META_TYP_2507_I7_D)\r
    get Target : Int = -2507007 #%(T_43_YU_WS_TARGET)\r
	@ApiLevel=3\r
	@ScriptName=RotationAngle\r
	@Tip = %(T_49_META_TYP_2507_I8_D)\r
    get Rot_Angles : Int = -2507008 #%(T_46_META_WS_P_ROTATIONANGLE)\r
	@ApiLevel=3\r
	@ScriptName=Status\r
	@Tip = %(T_49_META_TYP_2507_I9_D)\r
    get Status : Int = -2507009 #%(T_46_META_WS_P_STATUS)\r
	@ApiLevel=3\r
	@ScriptName=ObjectID\r
	@Tip = %(T_49_META_TYP_2507_I10_D)\r
    get ObjectID : Int = -2507010 #%(T_46_META_WS_P_OBJECTID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SpawnPosition\r
@Tip = %(T_49_META_TYPE_2500_D)\r
@ModuleID=10\r
@ModuleLib=LevelObject\r
type SpawnPos : LevelObject = 2500 { #%(T_46_META_WS_C_SPAWNPOSITION)\r
	@ApiLevel=10\r
	@ScriptName=AvailablePosition_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get AvailablePos : DirectedPoint = -2500000 #AvailablePos\r
	@ApiLevel=4\r
	@ScriptName=IsDefaultSpawnPoint\r
	@Tip = %(T_49_META_TYP_2500_I1_D)\r
    get IsDefault : Bool = -2500001 #%(T_46_META_WS_P_ISDEFAULTSPAWNPOINT)\r
	@ApiLevel=10\r
	@ScriptName=DynamicCollider_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get DynamicCollider : LevelObject = -2500002 #DynamicCollider\r
	@ApiLevel=4\r
	@ScriptName=IsOccupied\r
	@Tip = %(T_49_META_TYP_2500_I3_D)\r
    get IsOccupied : Bool = -2500003 #%(T_46_META_WS_P_ISOCCUPIED)\r
	@ApiLevel=4\r
	@ScriptName=AvailablePoint\r
	@Tip = %(T_49_META_TYP_2500_I4_D)\r
    get AvailablePosVec3 : Vector3 = -2500004 #%(T_46_META_WS_P_AVAILABLEPOINT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CustomizeTrigger\r
@Tip = %(T_49_META_TYPE_2501_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type CustomizeTrigger : LevelObject&Collider = 2501 { #%(T_46_META_WS_C_CUSTOMIZETRIGGER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DeathOrInvincibilityTrigger\r
@Tip = %(T_49_META_TYPE_2502_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type KillOrGodZoneTrigger : CustomizeTrigger = 2502 { #%(T_46_META_WS_C_DEATHORINVINCIBILITYTRIGGER)\r
	@ApiLevel=4\r
	@ScriptName=IsDeathTrigger\r
	@Tip = %(T_49_META_TYP_2502_I0_D)\r
    IsKillZone : Bool = -2502000 #%(T_46_META_WS_P_ISDEATHTRIGGER)\r
	@ApiLevel=4\r
	@ScriptName=IsShow\r
	@Tip = %(T_49_META_TYP_2502_I1_D)\r
    ShowOrHide : Bool = -2502001 #%(T_46_META_WS_P_IS SHOW)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CheckPointTrigger\r
@Tip = %(T_49_META_TYPE_2503_D)\r
@ModuleID=13\r
@ModuleLib=CheckPoint\r
type CheckPointTrigger : CustomizeTrigger = 2503 { #%(T_46_META_WS_C_CHECKPOINTTRIGGER)\r
	@ApiLevel=4\r
	@ScriptName=CheckpointID\r
	@Tip = %(T_49_META_TYP_2503_I0_D)\r
    get ID : Int = -2503000 #%(T_46_META_WS_P_CHECKPOINTID)\r
	@ApiLevel=10\r
	@ScriptName=DirectPosition_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get DirectPos : DirectedPoint = -2503001 #DirectPos\r
	@ApiLevel=4\r
	@ScriptName=PointPosition\r
	@Tip = %(T_49_META_TYP_2503_I2_D)\r
    get DirectPosVec3 : Vector3 = -2503002 #%(T_46_META_WS_P_POINTPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EndPointTrigger\r
@Tip = %(T_49_META_TYPE_2504_D)\r
@ModuleID=13\r
@ModuleLib=CheckPoint\r
type EndPointTrigger : CustomizeTrigger = 2504 { #%(T_46_META_WS_C_ENDPOINTTRIGGER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DynamicFence\r
@Tip = %(T_49_META_TYPE_2505_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type DynamicCollider : LevelObject = 2505 { #%(T_46_META_WS_C_DYNAMICFENCE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=SupplyBoxTrigger\r
@Tip = %(T_49_META_TYPE_18_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type SupplyBoxTrigger : CustomizeTrigger = 2506 { #%(T_46_META_WS_C_SUPPLYBOXTRIGGER)\r
	@ApiLevel=4\r
	@ScriptName=Model\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Model : Int = -2506000 #%(T_46_META_WS_P_MODEL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MonsterSpawn\r
@Tip = %(T_49_META_TYPE_2508_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type BotGenerator : LevelObject&SpawnableEntity&ResetableEntity = 2508 { #%(T_46_META_WS_C_MONSTERSPAWN)\r
	@ApiLevel=4\r
	@ScriptName=CountPerWave\r
	@Tip = %(T_49_META_TYP_2508_I0_D)\r
    CountEachBatch : Int = -2508000 #%(T_46_META_WS_P_COUNTPERWAVE)\r
	@ApiLevel=4\r
	@ScriptName=WaveCount\r
	@Tip = %(T_49_META_TYP_2508_I1_D)\r
    BatchCount : Int = -2508001 #%(T_46_META_WS_P_WAVECOUNT)\r
	@ApiLevel=4\r
	@ScriptName=IsContinuous\r
	@Tip = %(T_49_META_TYP_2508_I2_D)\r
    IsContinuous : Bool = -2508002 #%(T_46_META_WS_P_ISCONTINUOUS)\r
	@ApiLevel=4\r
	@ScriptName=CurrentWave\r
	@Tip = %(T_49_META_TYP_2508_I3_D)\r
    CurBatch : Int = -2508003 #%(T_46_META_WS_P_CURRENTWAVE)\r
	@ApiLevel=10\r
	@ScriptName=WaveInterval_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    BatchInterval : Int = -2508004 #BatchInterval\r
	@ApiLevel=4\r
	@ScriptName=Type\r
	@Tip = %(T_49_META_TYP_2508_I5_D)\r
    AIType : AIType = -2508005 #%(T_46_META_WS_P_TYPE)\r
	@ApiLevel=4\r
	@ScriptName=EnableDropOnDeath\r
	@Tip = %(T_49_META_TYP_2508_I6_D)\r
    EnableDeadDrop : Bool = -2508006 #%(T_46_META_WS_P_ENABLEDROPONDEATH)\r
	@ApiLevel=4\r
	@ScriptName=StartSpawnTime\r
	@Tip = %(T_49_META_TYP_2508_I7_D)\r
    StartGenTime : Float = -2508007 #%(T_46_META_WS_P_STARTSPAWNTIME)\r
	@ApiLevel=4\r
	@ScriptName=WaveInterval\r
	@Tip = %(T_49_META_TYP_2508_I8_D)\r
    BatchIntervalFloat : Float = -2508008 #%(T_46_META_WS_P_WAVEINTERVAL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SpawnBox\r
@Tip = %(T_49_META_TYPE_2510_D)\r
@ModuleID=10\r
@ModuleLib=LevelObject\r
type SpawnBox : SpawnPos = 2510 { #%(T_46_META_WS_C_SPAWNBOX)\r
	@ApiLevel=4\r
	@ScriptName=SpawnPointCount\r
	@Tip = %(T_49_META_TYP_2510_I0_D)\r
    get SpawnPointCount : Int = -2510000 #%(T_46_META_WS_P_SPAWNPOINTCOUNT)\r
	@ApiLevel=10\r
	@ScriptName=TeamIndex_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get TeamIndex : Int = -2510001 #TeamIndex\r
	@ApiLevel=4\r
	@ScriptName=TeamSeq\r
	@Tip = %(T_49_META_TYP_15_I5_D)\r
    get TeamSeq : Int = -2510002 #%(T_46_META_WS_P_TEAMSEQ)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsMovementLocked\r
	@Tip = %(T_51_ZCS_SPAWNPOINT_DescKey)\r
    IsMovementLocked : Bool = -2510003 #%(T_51_ZCS_SPAWNPOINT_NAME)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=PresentEffectGenerator_Deprecated\r
@Tip = %(T_49_META_TYPE_18_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type PresentEffectGenerator : LevelObject&PresentEffect = 169 { #%(T_46_META_WS_C_PRESENTEFFECTGENERATOR_DEPRECATED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EffectContainer\r
@Tip = %(T_49_META_TYPE_251_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type EffectEntityGenerator : ItemContainerGenerator = 251 { #%(T_46_META_WS_C_EFFECTCONTAINER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_Player\r
@Tip = %(T_49_META_TYPE_43_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_Player : List = 43 { #%(T_46_META_WS_C_LISTT_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_Team\r
@Tip = %(T_49_META_TYPE_44_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_Team : List = 44 { #%(T_46_META_WS_C_LISTT_TEAM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_Entity\r
@Tip = %(T_49_META_TYPE_50_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_Entity : List = 50 { #%(T_46_META_WS_C_LISTT_ENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MonsterType\r
@Tip = %(T_49_META_TYPE_51_D)\r
@ModuleID=10008\r
@ModuleLib=AI\r
enum AIType : AssetConfigID = 51 { #%(T_46_META_WS_C_MONSTERTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Regular\r
	@Tip = %(T_49_META_TYP_51_I0_D)\r
    UGCAI = 18 #%(T_46_META_WS_E_NORMAL)\r
	@ApiLevel=4\r
	@ScriptName=WoodCutZombie\r
	@Tip = %(T_49_META_TYP_51_I1_D)\r
    ZombieWoodCut = 4 #%(T_46_META_WS_E_WOODCUTZOMBIE)\r
	@ApiLevel=4\r
	@ScriptName=ThrowZombie\r
	@Tip = %(T_49_META_TYP_51_I2_D)\r
    ZombieThrow = 5 #%(T_46_META_WS_E_THROWZOMBIE)\r
	@ApiLevel=4\r
	@ScriptName=ExplosiveZombie\r
	@Tip = %(T_49_META_TYP_51_I3_D)\r
    ZombieExplosive = 6 #%(T_46_META_WS_E_EXPLOSIVEZOMBIE)\r
	@ApiLevel=4\r
	@ScriptName=TyrantZombie\r
	@Tip = %(T_49_META_TYP_51_I4_D)\r
    ZombieTyrant = 8 #%(T_46_META_WS_E_TYRANTZOMBIE)\r
	@ApiLevel=4\r
	@ScriptName=ThrowRedZombie\r
	@Tip = %(T_49_META_TYP_51_I5_D)\r
    ZombieThrowRed = 9 #%(T_46_META_WS_E_THROWREDZOMBIE)\r
	@ApiLevel=4\r
	@ScriptName=MrV\r
	@Tip = %(T_49_META_TYP_51_I6_D)\r
    ZombieMrV = 10 #%(T_46_META_WS_E_MRV)\r
	@ApiLevel=4\r
	@ScriptName=TankZombie\r
	@Tip = %(T_49_META_TYP_51_I7_D)\r
    ZombieTank = 11 #%(T_46_META_WS_E_TANKZOMBIE)\r
	@ApiLevel=4\r
	@ScriptName=DrillZombie\r
	@Tip = %(T_49_META_TYP_51_I8_D)\r
    ZombieDrill = 12 #%(T_46_META_WS_E_DRILLZOMBIE)\r
	@ApiLevel=4\r
	@ScriptName=Samurai\r
	@Tip = %(T_49_META_TYP_51_I9_D)\r
    ZombieSamurai = 13 #%(T_46_META_WS_E_SAMURAI)\r
	@ApiLevel=4\r
	@ScriptName=FlyBombBee\r
	@Tip = %(T_49_META_TYP_51_I10_D)\r
    FlyBombBee = 21 #%(T_46_META_WS_E_FLYBOMBBEE)\r
	@ApiLevel=3\r
	@ScriptName=ZombieDragon\r
	@Tip = %(T_49_META_TYP_51_I11_D)\r
    ZombieDragon = 23 #%(T_44_PD_PVE_DRAGON_NAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WaveCountType\r
@Tip = %(T_49_META_TYPE_140_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum BatchCountType : Int = 140 { #%(T_46_META_WS_C_WAVECOUNTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Wave1\r
	@Tip = %(T_49_META_TYP_140_I0_D)\r
    Batch1 = 1 #%(T_46_META_WS_E_WAVE1)\r
	@ApiLevel=4\r
	@ScriptName=Wave2\r
	@Tip = %(T_49_META_TYP_140_I1_D)\r
    Batch2 = 2 #%(T_46_META_WS_E_WAVE2)\r
	@ApiLevel=4\r
	@ScriptName=Wave3\r
	@Tip = %(T_49_META_TYP_140_I2_D)\r
    Batch3 = 3 #%(T_46_META_WS_E_WAVE3)\r
	@ApiLevel=4\r
	@ScriptName=Continuous\r
	@Tip = %(T_49_META_TYP_140_I3_D)\r
    BatchContinuous = 255 #%(T_46_META_WS_E_CONTINUOUS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WaveIntervalType\r
@Tip = %(T_49_META_TYPE_121_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum BatchIntervalType : Int = 121 { #%(T_46_META_WS_C_WAVEINTERVALTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Interval3Seconds\r
	@Tip = %(T_49_META_TYP_121_I0_D)\r
    Interval3Seconds = 3 #%(T_46_META_WS_E_INTERVAL3SECONDS)\r
	@ApiLevel=4\r
	@ScriptName=Interval5Seconds\r
	@Tip = %(T_49_META_TYP_121_I1_D)\r
    Interval5Seconds = 5 #%(T_46_META_WS_E_INTERVAL5SECONDS)\r
	@ApiLevel=4\r
	@ScriptName=Interval10Seconds\r
	@Tip = %(T_49_META_TYP_121_I2_D)\r
    Interval10Seconds = 10 #%(T_46_META_WS_E_INTERVAL10SECONDS)\r
	@ApiLevel=4\r
	@ScriptName=Interval15Seconds\r
	@Tip = %(T_49_META_TYP_121_I3_D)\r
    Interval15Seconds = 15 #%(T_46_META_WS_E_INTERVAL15SECONDS)\r
	@ApiLevel=4\r
	@ScriptName=Interval30Seconds\r
	@Tip = %(T_49_META_TYP_121_I4_D)\r
    Interval30Seconds = 30 #%(T_46_META_WS_E_INTERVAL30SECONDS)\r
	@ApiLevel=4\r
	@ScriptName=Interval9999Seconds\r
	@Tip = %(T_49_META_TYP_121_I5_D)\r
    Interval9999Seconds = 9999 #%(T_46_META_WS_E_INTERVAL9999SECONDS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BuffType\r
@Tip = %(T_49_META_TYPE_81_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum BuffType : Int = 81 { #%(T_46_META_WS_C_BUFFTYPE)\r
	@ApiLevel=4\r
	@ScriptName=RandomBuff\r
	@Tip = %(T_49_META_TYP_81_I0_D)\r
    BuffTypeRandom = 0 #%(T_46_META_WS_E_RANDOMBUFF)\r
	@ApiLevel=4\r
	@ScriptName=HPBuff\r
	@Tip = %(T_49_META_TYP_81_I1_D)\r
    BuffTypeHP = 1 #%(T_46_META_WS_E_HPBUFF)\r
	@ApiLevel=4\r
	@ScriptName=BulletBuff\r
	@Tip = %(T_49_META_TYP_81_I2_D)\r
    BuffTypeAmmo = 2 #%(T_46_META_WS_E_BULLETBUFF)\r
	@ApiLevel=4\r
	@ScriptName=ArmorBuff\r
	@Tip = %(T_49_META_TYP_81_I3_D)\r
    BuffTypeArmor = 3 #%(T_46_META_WS_E_ARMORBUFF)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SoundDrumType\r
@Tip = %(T_49_META_TYPE_117_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum DrumMusicElementType : Int = 117 { #%(T_46_META_WS_C_SOUNDDRUMTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Claps\r
	@Tip = %(T_49_META_TYP_117_I0_D)\r
    Claps = 1 #%(T_46_META_WS_E_CLAPS)\r
	@ApiLevel=4\r
	@ScriptName=Hihats\r
	@Tip = %(T_49_META_TYP_117_I1_D)\r
    Hihats = 2 #%(T_46_META_WS_E_HIHATS)\r
	@ApiLevel=4\r
	@ScriptName=Kick\r
	@Tip = %(T_49_META_TYP_117_I2_D)\r
    Kick = 3 #%(T_46_META_WS_E_KICK)\r
	@ApiLevel=4\r
	@ScriptName=OpenHihats\r
	@Tip = %(T_49_META_TYP_117_I3_D)\r
    OpenHihats = 4 #%(T_46_META_WS_E_OPENHIHATS)\r
	@ApiLevel=4\r
	@ScriptName=Rides\r
	@Tip = %(T_49_META_TYP_117_I4_D)\r
    Rides = 5 #%(T_46_META_WS_E_RIDES)\r
	@ApiLevel=4\r
	@ScriptName=Snares\r
	@Tip = %(T_49_META_TYP_117_I5_D)\r
    Snares = 6 #%(T_46_META_WS_E_SNARES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SoundLead1Type\r
@Tip = %(T_49_META_TYPE_143_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum Lead1MusicElementType : Int = 143 { #%(T_46_META_WS_C_SOUNDLEAD1TYPE)\r
	@ApiLevel=4\r
	@ScriptName=Lead1C2\r
	@Tip = %(T_49_META_TYP_143_I0_D)\r
    Lead1C2 = 7 #%(T_46_META_WS_E_LEAD1C2)\r
	@ApiLevel=4\r
	@ScriptName=Lead1C2Sharp\r
	@Tip = %(T_49_META_TYP_143_I1_D)\r
    Lead1C2Sharp = 8 #%(T_46_META_WS_E_LEAD1C2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead1D2\r
	@Tip = %(T_49_META_TYP_143_I2_D)\r
    Lead1D2 = 9 #%(T_46_META_WS_E_LEAD1D2)\r
	@ApiLevel=4\r
	@ScriptName=Lead1D2Sharp\r
	@Tip = %(T_49_META_TYP_143_I3_D)\r
    Lead1D2Sharp = 10 #%(T_46_META_WS_E_LEAD1D2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead1E2\r
	@Tip = %(T_49_META_TYP_143_I4_D)\r
    Lead1E2 = 11 #%(T_46_META_WS_E_LEAD1E2)\r
	@ApiLevel=4\r
	@ScriptName=Lead1F2\r
	@Tip = %(T_49_META_TYP_143_I5_D)\r
    Lead1F2 = 12 #%(T_46_META_WS_E_LEAD1F2)\r
	@ApiLevel=4\r
	@ScriptName=Lead1F2Sharp\r
	@Tip = %(T_49_META_TYP_143_I6_D)\r
    Lead1F2Sharp = 13 #%(T_46_META_WS_E_LEAD1F2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead1G2\r
	@Tip = %(T_49_META_TYP_143_I7_D)\r
    Lead1G2 = 14 #%(T_46_META_WS_E_LEAD1G2)\r
	@ApiLevel=4\r
	@ScriptName=Lead1G2Sharp\r
	@Tip = %(T_49_META_TYP_143_I8_D)\r
    Lead1G2Sharp = 15 #%(T_46_META_WS_E_LEAD1G2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead1A2\r
	@Tip = %(T_49_META_TYP_143_I9_D)\r
    Lead1A2 = 16 #%(T_46_META_WS_E_LEAD1A2)\r
	@ApiLevel=4\r
	@ScriptName=Lead1A2Sharp\r
	@Tip = %(T_49_META_TYP_143_I10_D)\r
    Lead1A2Sharp = 17 #%(T_46_META_WS_E_LEAD1A2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead1B2\r
	@Tip = %(T_49_META_TYP_143_I11_D)\r
    Lead1B2 = 18 #%(T_46_META_WS_E_LEAD1B2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SoundLead2Type\r
@Tip = %(T_49_META_TYPE_144_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum Lead2MusicElementType : Int = 144 { #%(T_46_META_WS_C_SOUNDLEAD2TYPE)\r
	@ApiLevel=4\r
	@ScriptName=Lead2C2\r
	@Tip = %(T_49_META_TYP_144_I0_D)\r
    Lead2C2 = 19 #%(T_46_META_WS_E_LEAD2C2)\r
	@ApiLevel=4\r
	@ScriptName=Lead2C2Sharp\r
	@Tip = %(T_49_META_TYP_144_I1_D)\r
    Lead2C2Sharp = 20 #%(T_46_META_WS_E_LEAD2C2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead2D2\r
	@Tip = %(T_49_META_TYP_144_I2_D)\r
    Lead2D2 = 21 #%(T_46_META_WS_E_LEAD2D2)\r
	@ApiLevel=4\r
	@ScriptName=Lead2D2Sharp\r
	@Tip = %(T_49_META_TYP_144_I3_D)\r
    Lead2D2Sharp = 22 #%(T_46_META_WS_E_LEAD2D2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead2E2\r
	@Tip = %(T_49_META_TYP_144_I4_D)\r
    Lead2E2 = 23 #%(T_46_META_WS_E_LEAD2E2)\r
	@ApiLevel=4\r
	@ScriptName=Lead2F2\r
	@Tip = %(T_49_META_TYP_144_I5_D)\r
    Lead2F2 = 24 #%(T_46_META_WS_E_LEAD2F2)\r
	@ApiLevel=4\r
	@ScriptName=Lead2F2Sharp\r
	@Tip = %(T_49_META_TYP_144_I6_D)\r
    Lead2F2Sharp = 25 #%(T_46_META_WS_E_LEAD2F2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead2G2\r
	@Tip = %(T_49_META_TYP_144_I7_D)\r
    Lead2G2 = 26 #%(T_46_META_WS_E_LEAD2G2)\r
	@ApiLevel=4\r
	@ScriptName=Lead2G2Sharp\r
	@Tip = %(T_49_META_TYP_144_I8_D)\r
    Lead2G2Sharp = 27 #%(T_46_META_WS_E_LEAD2G2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead2A2\r
	@Tip = %(T_49_META_TYP_144_I9_D)\r
    Lead2A2 = 28 #%(T_46_META_WS_E_LEAD2A2)\r
	@ApiLevel=4\r
	@ScriptName=Lead2A2Sharp\r
	@Tip = %(T_49_META_TYP_144_I10_D)\r
    Lead2A2Sharp = 29 #%(T_46_META_WS_E_LEAD2A2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead2B2\r
	@Tip = %(T_49_META_TYP_144_I11_D)\r
    Lead2B2 = 30 #%(T_46_META_WS_E_LEAD2B2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SoundLead3Type\r
@Tip = %(T_49_META_TYPE_145_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum Lead3MusicElementType : Int = 145 { #%(T_46_META_WS_C_SOUNDLEAD3TYPE)\r
	@ApiLevel=4\r
	@ScriptName=Lead3C2\r
	@Tip = %(T_49_META_TYP_145_I0_D)\r
    Lead3C2 = 31 #%(T_46_META_WS_E_LEAD3C2)\r
	@ApiLevel=4\r
	@ScriptName=Lead3C2Sharp\r
	@Tip = %(T_49_META_TYP_145_I1_D)\r
    Lead3C2Sharp = 32 #%(T_46_META_WS_E_LEAD3C2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead3D2\r
	@Tip = %(T_49_META_TYP_145_I2_D)\r
    Lead3D2 = 33 #%(T_46_META_WS_E_LEAD3D2)\r
	@ApiLevel=4\r
	@ScriptName=Lead3D2Sharp\r
	@Tip = %(T_49_META_TYP_145_I3_D)\r
    Lead3D2Sharp = 34 #%(T_46_META_WS_E_LEAD3D2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead3E2\r
	@Tip = %(T_49_META_TYP_145_I4_D)\r
    Lead3E2 = 35 #%(T_46_META_WS_E_LEAD3E2)\r
	@ApiLevel=4\r
	@ScriptName=Lead3F2\r
	@Tip = %(T_49_META_TYP_145_I5_D)\r
    Lead3F2 = 36 #%(T_46_META_WS_E_LEAD3F2)\r
	@ApiLevel=4\r
	@ScriptName=Lead3F2Sharp\r
	@Tip = %(T_49_META_TYP_145_I6_D)\r
    Lead3F2Sharp = 37 #%(T_46_META_WS_E_LEAD3F2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead3G2\r
	@Tip = %(T_49_META_TYP_145_I7_D)\r
    Lead3G2 = 38 #%(T_46_META_WS_E_LEAD3G2)\r
	@ApiLevel=4\r
	@ScriptName=Lead3G2Sharp\r
	@Tip = %(T_49_META_TYP_145_I8_D)\r
    Lead3G2Sharp = 39 #%(T_46_META_WS_E_LEAD3G2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead3A2\r
	@Tip = %(T_49_META_TYP_145_I9_D)\r
    Lead3A2 = 40 #%(T_46_META_WS_E_LEAD3A2)\r
	@ApiLevel=4\r
	@ScriptName=Lead3A2Sharp\r
	@Tip = %(T_49_META_TYP_145_I10_D)\r
    Lead3A2Sharp = 41 #%(T_46_META_WS_E_LEAD3A2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead3B2\r
	@Tip = %(T_49_META_TYP_145_I11_D)\r
    Lead3B2 = 42 #%(T_46_META_WS_E_LEAD3B2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SoundPianoType\r
@Tip = %(T_49_META_TYPE_146_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum PianoMusicElementType : Int = 146 { #%(T_46_META_WS_C_SOUNDPIANOTYPE)\r
	@ApiLevel=4\r
	@ScriptName=PianoC3\r
	@Tip = %(T_49_META_TYP_146_I0_D)\r
    PianoC3 = 43 #%(T_46_META_WS_E_PIANOC3)\r
	@ApiLevel=4\r
	@ScriptName=PianoC3Sharp\r
	@Tip = %(T_49_META_TYP_146_I1_D)\r
    PianoC3Sharp = 44 #%(T_46_META_WS_E_PIANOC3SHARP)\r
	@ApiLevel=4\r
	@ScriptName=PianoD3\r
	@Tip = %(T_49_META_TYP_146_I2_D)\r
    PianoD3 = 45 #%(T_46_META_WS_E_PIANOD3)\r
	@ApiLevel=4\r
	@ScriptName=PianoD3Sharp\r
	@Tip = %(T_49_META_TYP_146_I3_D)\r
    PianoD3Sharp = 46 #%(T_46_META_WS_E_PIANOD3SHARP)\r
	@ApiLevel=4\r
	@ScriptName=PianoE3\r
	@Tip = %(T_49_META_TYP_146_I4_D)\r
    PianoE3 = 47 #%(T_46_META_WS_E_PIANOE3)\r
	@ApiLevel=4\r
	@ScriptName=PianoF3\r
	@Tip = %(T_49_META_TYP_146_I5_D)\r
    PianoF3 = 48 #%(T_46_META_WS_E_PIANOF3)\r
	@ApiLevel=4\r
	@ScriptName=PianoF3Sharp\r
	@Tip = %(T_49_META_TYP_146_I6_D)\r
    PianoF3Sharp = 49 #%(T_46_META_WS_E_PIANOF3SHARP)\r
	@ApiLevel=4\r
	@ScriptName=PianoG3\r
	@Tip = %(T_49_META_TYP_146_I7_D)\r
    PianoG3 = 50 #%(T_46_META_WS_E_PIANOG3)\r
	@ApiLevel=4\r
	@ScriptName=PianoG3Sharp\r
	@Tip = %(T_49_META_TYP_146_I8_D)\r
    PianoG3Sharp = 51 #%(T_46_META_WS_E_PIANOG3SHARP)\r
	@ApiLevel=4\r
	@ScriptName=PianoA3\r
	@Tip = %(T_49_META_TYP_146_I9_D)\r
    PianoA3 = 52 #%(T_46_META_WS_E_PIANOA3)\r
	@ApiLevel=4\r
	@ScriptName=PianoA3Sharp\r
	@Tip = %(T_49_META_TYP_146_I10_D)\r
    PianoA3Sharp = 53 #%(T_46_META_WS_E_PIANOA3SHARP)\r
	@ApiLevel=4\r
	@ScriptName=PianoB3\r
	@Tip = %(T_49_META_TYP_146_I11_D)\r
    PianoB3 = 54 #%(T_46_META_WS_E_PIANOB3)\r
	@ApiLevel=4\r
	@ScriptName=PianoC4\r
	@Tip = %(T_49_META_TYP_146_I12_D)\r
    PianoC4 = 55 #%(T_46_META_WS_E_PIANOC4)\r
	@ApiLevel=4\r
	@ScriptName=PianoC4Sharp\r
	@Tip = %(T_49_META_TYP_146_I13_D)\r
    PianoC4Sharp = 56 #%(T_46_META_WS_E_PIANOC4SHARP)\r
	@ApiLevel=4\r
	@ScriptName=PianoD4\r
	@Tip = %(T_49_META_TYP_146_I14_D)\r
    PianoD4 = 57 #%(T_46_META_WS_E_PIANOD4)\r
	@ApiLevel=4\r
	@ScriptName=PianoD4Sharp\r
	@Tip = %(T_49_META_TYP_146_I15_D)\r
    PianoD4Sharp = 58 #%(T_46_META_WS_E_PIANOD4SHARP)\r
	@ApiLevel=4\r
	@ScriptName=PianoE4\r
	@Tip = %(T_49_META_TYP_146_I16_D)\r
    PianoE4 = 59 #%(T_46_META_WS_E_PIANOE4)\r
	@ApiLevel=4\r
	@ScriptName=PianoF4\r
	@Tip = %(T_49_META_TYP_146_I17_D)\r
    PianoF4 = 60 #%(T_46_META_WS_E_PIANOF4)\r
	@ApiLevel=4\r
	@ScriptName=PianoF4Sharp\r
	@Tip = %(T_49_META_TYP_146_I18_D)\r
    PianoF4Sharp = 61 #%(T_46_META_WS_E_PIANOF4SHARP)\r
	@ApiLevel=4\r
	@ScriptName=PianoG4\r
	@Tip = %(T_49_META_TYP_146_I19_D)\r
    PianoG4 = 62 #%(T_46_META_WS_E_PIANOG4)\r
	@ApiLevel=4\r
	@ScriptName=PianoG4Sharp\r
	@Tip = %(T_49_META_TYP_146_I20_D)\r
    PianoG4Sharp = 63 #%(T_46_META_WS_E_PIANOG4SHARP)\r
	@ApiLevel=4\r
	@ScriptName=PianoA4\r
	@Tip = %(T_49_META_TYP_146_I21_D)\r
    PianoA4 = 64 #%(T_46_META_WS_E_PIANOA4)\r
	@ApiLevel=4\r
	@ScriptName=PianoA4Sharp\r
	@Tip = %(T_49_META_TYP_146_I22_D)\r
    PianoA4Sharp = 65 #%(T_46_META_WS_E_PIANOA4SHARP)\r
	@ApiLevel=4\r
	@ScriptName=PianoB4\r
	@Tip = %(T_49_META_TYP_146_I23_D)\r
    PianoB4 = 66 #%(T_46_META_WS_E_PIANOB4)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MiniSentryAttackRangeType\r
@Tip = %(T_49_META_TYPE_124_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum MinisentryAttackRangeType : Int = 124 { #%(T_46_META_WS_C_MINISENTRYATTACKRANGETYPE)\r
	@ApiLevel=4\r
	@ScriptName=Near\r
	@Tip = %(T_49_META_TYP_124_I0_D)\r
    Near = 0 #%(T_46_META_WS_E_NEAR)\r
	@ApiLevel=4\r
	@ScriptName=Middle\r
	@Tip = %(T_49_META_TYP_124_I1_D)\r
    Middle = 1 #%(T_46_META_WS_E_MIDDLE)\r
	@ApiLevel=4\r
	@ScriptName=Far\r
	@Tip = %(T_49_META_TYP_124_I2_D)\r
    Far = 2 #%(T_46_META_WS_E_FAR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Playable\r
@Tip = %(T_49_META_TYPE_197_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Playable : Entity = 197 { #%(T_46_META_WS_C_PLAYABLE)\r
	@ApiLevel=4\r
	@ScriptName=IsPlaying\r
	@Tip = %(T_49_META_TYP_197_I0_D)\r
    get Playing : Bool = -197000 #%(T_46_META_WS_P_PLAYINGSTATUS)\r
	@ApiLevel=3\r
	@ScriptName=Flag\r
	@Tip = %(T_49_META_TYP_197_I1_D)\r
    get Flag : Int = -197001 #%(FLAG)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=IsAutoPlaying\r
	@Tip = %(T_49_META_TYP_197_I2_D)\r
    AutoPlay : Bool = -197002 #%(T_46_META_WS_P_AUTOPLAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Loopable\r
@Tip = %(T_49_META_TYPE_332_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Loopable : Entity = 332 { #%(T_46_META_WS_C_LOOPABLE)\r
	@ApiLevel=4\r
	@ScriptName=IsLoop\r
	@Tip = %(T_49_META_TYP_332_I0_D)\r
    IsLoop : AnimationOverrideLoopType = -332000 #%(T_46_META_WS_P_ISLOOP)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=PresentSound_Deprecated\r
@Tip = %(T_49_META_TYPE_18_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type PresentSound : Playable = 52 { #%(T_40_XXJ_WS_SOUNDNTITY_NAMEKEY)\r
	@ApiLevel=4\r
	@ScriptName=SoundResID\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    SoundType : AudioType = -52000 #%(T_34_M_WS_SOUND)\r
	@ApiLevel=4\r
	@ScriptName=FollowTarget\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    FollowTarget : Entity = -52001 #%(T_34_WT_WS_ICONENTITY_PARAM6)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=PlayTime\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    PlayTime : Int = -52002 #%(T_38_WZY_WS_CYCLES)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=IsLoop\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    IsLoop : Bool = -52003 #%(T_38_WZY_WS_WHECYCLE)\r
	@ApiLevel=4\r
	@Default=50\r
	@ScriptName=Volume\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Volume : Int = -52004 #%(T_38_WZY_WS_VOLUME)\r
	@ApiLevel=4\r
	@Default=30\r
	@ScriptName=PlayDistance\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    PlayDistance : Float = -52005 #%(T_38_WZY_WS_TRANDIST)\r
	@ApiLevel=4\r
	@ScriptName=Position\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Position : Vector3 = -52006 #%(T_34_WT_WS_ENTITY13_PARAM2)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=Is3D\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Is3D : Bool = -52007 #%(T_40_XXJ_WS_IS3D)\r
	@ApiLevel=10\r
	@Default=0\r
	@ScriptName=IsPlaying\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    State : Int = -52008 #%(T_46_META_WS_P_ISPLAYING)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=ListT_PresentSound_Deprecated\r
@Tip = %(T_49_META_TYPE_18_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_PresentSound : List = 229 { #%(T_39_WZY_WS_SOUNDENTL)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=PresentSoundOrPresentSoundList_Deprecated\r
@Tip = %(T_49_META_TYPE_18_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias PresentSoundOrListPresentSound : Object&(PresentSound|ListT_PresentSound) = 230 #%(T_39_WZY_WS_SOUNDENTLORSENT)\r
\r
@ApiLevel=4\r
@ScriptName=DummyLevelObject\r
@Tip = %(T_49_META_TYPE_53_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type DummyLevelObject : LevelObject&Collider = 53 { #%(T_46_META_WS_C_DUMMYLEVELOBJECT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DestructibleLevelObject\r
@Tip = %(T_49_META_TYPE_54_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type DestructibleLevelObject : LevelObject&Collider = 54 { #%(T_46_META_WS_C_DESTRUCTIBLELEVELOBJECT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GeneralSpawnPoint\r
@Tip = %(T_49_META_TYPE_55_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type NoTeamIndexSpawnPoint : SpawnPos = 55 { #%(T_46_META_WS_C_GENERALSPAWNPOINT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vehicle\r
@Tip = %(T_49_META_TYPE_56_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type Vehicle : LevelObject&ResetableEntity&BuffableEntity&FightingEntity = 56 { #%(T_46_META_WS_C_VEHICLE)\r
	@ApiLevel=10\r
	@ScriptName=EngineTorque\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    EngineTorque : Float = -56000 #%(T_46_META_WS_P_ENGINETORQUE)\r
	@ApiLevel=10\r
	@ScriptName=BrakeTorque\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    BrakeTorque : Float = -56001 #%(T_46_META_WS_P_BRAKETORQUE)\r
	@ApiLevel=10\r
	@ScriptName=HighSpeedSteerAngle\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get HighSpeedSteerAngle : Float = -56002 #%(T_46_META_WS_P_HIGHSPEEDSTEERANGLE)\r
	@ApiLevel=10\r
	@ScriptName=HighSpeedSteerAngleAtSpeed\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get HighSpeedSteerAngleAtspeed : Float = -56003 #%(T_46_META_WS_P_HIGHSPEEDSTEERANGLEATSPEED)\r
	@ApiLevel=10\r
	@ScriptName=MaxSpeed\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    MaxSpeed : Float = -56004 #%(T_46_META_WS_P_MAXSPEED)\r
	@ApiLevel=10\r
	@ScriptName=IdleBrakeInput\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get IdleBrakeInput : Float = -56005 #%(T_46_META_WS_P_IDLEBRAKEINPUT)\r
	@ApiLevel=10\r
	@ScriptName=CrashMessFactor\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    CrashMessFactor : Float = -56006 #%(T_46_META_WS_P_CRASHMESSFACTOR)\r
	@ApiLevel=10\r
	@ScriptName=CrashMaxSpeed\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    CrashMaxSpeed : Float = -56007 #%(T_46_META_WS_P_CRASHMAXSPEED)\r
	@ApiLevel=10\r
	@ScriptName=CrashMinDamage\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    CrashMinDamage : Float = -56008 #%(T_46_META_WS_P_CRASHMINDAMAGE)\r
	@ApiLevel=10\r
	@ScriptName=CrashMaxDamage\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    CrashMaxDamage : Float = -56009 #%(T_46_META_WS_P_CRASHMAXDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=ExplodeDelay\r
	@Tip = %(T_49_META_TYP_56_I10_D)\r
    ExplodeDelay : Float = -56010 #%(T_46_META_WS_P_EXPLODEDELAY)\r
	@ApiLevel=4\r
	@ScriptName=ExplodeRange\r
	@Tip = %(T_49_META_TYP_56_I11_D)\r
    ExplodeRange : Float = -56011 #%(T_46_META_WS_P_EXPLODERANGE)\r
	@ApiLevel=4\r
	@ScriptName=ExplodeDamage\r
	@Tip = %(T_49_META_TYP_56_I12_D)\r
    ExplodeDamage : Int = -56012 #%(T_46_META_WS_P_EXPLODEDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=BurnTime\r
	@Tip = %(T_49_META_TYP_56_I13_D)\r
    BurnTime : Float = -56013 #%(T_46_META_WS_P_BURNTIME)\r
	@ApiLevel=4\r
	@ScriptName=BurnDamage\r
	@Tip = %(T_49_META_TYP_56_I14_D)\r
    BurnDamage : Int = -56014 #%(T_46_META_WS_P_BURNDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=BurningDamageInterval\r
	@Tip = %(T_49_META_TYP_56_I15_D)\r
    BurnInterval : Float = -56015 #%(T_46_META_WS_P_BURNINGDAMAGEINTERVAL)\r
	@ApiLevel=10\r
	@ScriptName=HP\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    HP : Int = -56016 #%(T_46_META_WS_P_HP)\r
	@ApiLevel=4\r
	@ScriptName=Driver\r
	@Tip = %(T_49_META_TYP_56_I17_D)\r
    get Driver : Player = -56017 #%(T_46_META_WS_P_DRIVER)\r
	@ApiLevel=4\r
	@ScriptName=Passengers\r
	@Tip = %(T_49_META_TYP_56_I18_D)\r
    get Passengers : ListT_Player = -56018 #%(T_46_META_WS_P_PASSENGERS)\r
	@ApiLevel=4\r
	@ScriptName=VehicleSkinID\r
	@Tip = %(T_49_META_TYP_56_I19_D)\r
    VehicleSkinID : VehicleSkinID = -56019 #%(T_46_META_WS_P_VEHICLESKINID)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=OverloadByPlayerConfiguration\r
	@Tip = %(T_49_META_TYP_56_I20_D)\r
    OverloadByPlayerSkin : Bool = -56020 #%(T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION)\r
	@ApiLevel=4\r
	@Default=800\r
	@ScriptName=MaxHP\r
	@Tip = %(T_49_META_TYP_56_I21_D)\r
    MaxHP : Int = -56021 #%(T_46_META_WS_P_MAXHP)\r
	@ApiLevel=4\r
	@Default=800\r
	@ScriptName=CurrentHP\r
	@Tip = %(T_49_META_TYP_56_I22_D)\r
    CurrentHP : Int = -56022 #%(T_46_META_WS_P_HP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Car\r
@Tip = %(T_49_META_TYPE_412_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type Car : Vehicle = 412 { #%(T_46_META_WS_C_CAR)\r
	@ApiLevel=4\r
	@ScriptName=EngineHorsepower\r
	@Tip = %(T_49_META_TYP_412_I0_D)\r
    EngineTorque : Float = -56000 #%(T_46_META_WS_P_ENGINEHORSEPOWER)\r
	@ApiLevel=4\r
	@ScriptName=BrakeHorsepower\r
	@Tip = %(T_49_META_TYP_412_I1_D)\r
    BrakeTorque : Float = -56001 #%(T_46_META_WS_P_BRAKEHORSEPOWER)\r
	@ApiLevel=4\r
	@ScriptName=HighSpeedSteerAngle\r
	@Tip = %(T_49_META_TYP_412_I2_D)\r
    get HighSpeedSteerAngle : Float = -56002 #%(T_46_META_WS_P_HIGHSPEEDSTEERANGLE)\r
	@ApiLevel=4\r
	@ScriptName=HighSpeedSteerAngleAtSpeed\r
	@Tip = %(T_49_META_TYP_412_I3_D)\r
    get HighSpeedSteerAngleAtspeed : Float = -56003 #%(T_46_META_WS_P_HIGHSPEEDSTEERANGLEATSPEED)\r
	@ApiLevel=4\r
	@ScriptName=MaxSpeed\r
	@Tip = %(T_49_META_TYP_412_I4_D)\r
    MaxSpeed : Float = -56004 #%(T_46_META_WS_P_MAXSPEED)\r
	@ApiLevel=4\r
	@ScriptName=IdleBrakeInput\r
	@Tip = %(T_49_META_TYP_412_I5_D)\r
    get IdleBrakeInput : Float = -56005 #%(T_46_META_WS_P_IDLEBRAKEINPUT)\r
	@ApiLevel=4\r
	@ScriptName=CrashMessFactor\r
	@Tip = %(T_49_META_TYP_412_I6_D)\r
    CrashMessFactor : Float = -56006 #%(T_46_META_WS_P_CRASHMESSFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=CrashMaxSpeed\r
	@Tip = %(T_49_META_TYP_412_I7_D)\r
    CrashMaxSpeed : Float = -56007 #%(T_46_META_WS_P_CRASHMAXSPEED)\r
	@ApiLevel=4\r
	@ScriptName=CrashMinDamage\r
	@Tip = %(T_49_META_TYP_412_I8_D)\r
    CrashMinDamage : Float = -56008 #%(T_46_META_WS_P_CRASHMINDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=CrashMaxDamage\r
	@Tip = %(T_49_META_TYP_412_I9_D)\r
    CrashMaxDamage : Float = -56009 #%(T_46_META_WS_P_CRASHMAXDAMAGE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Portal\r
@Tip = %(T_49_META_TYPE_57_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type TeleportDoor : LevelObject&Collider = 57 { #%(T_46_META_WS_C_PORTAL)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=IsAutoTeleport\r
	@Tip = %(T_49_META_TYP_57_I0_D)\r
    IsAutoTeleport : Bool = -57000 #%(T_46_META_WS_P_ISAUTOTELEPORT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BuffGenerator\r
@Tip = %(T_49_META_TYPE_58_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type BuffGen : LevelObject = 58 { #%(T_46_META_WS_C_BUFFGENERATOR)\r
	@ApiLevel=4\r
	@ScriptName=BuffType\r
	@Tip = %(T_49_META_TYP_58_I0_D)\r
    BuffGenType : BuffType = -58000 #%(T_46_META_WS_P_BUFFTYPE)\r
	@ApiLevel=4\r
	@ScriptName=RefreshTime\r
	@Tip = %(T_49_META_TYP_58_I1_D)\r
    BuffGenTime : Int = -58001 #%(T_46_META_WS_P_REFRESHTIME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MovePlatform\r
@Tip = %(T_49_META_TYPE_59_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type MoveObject : LevelObject&Collider = 59 { #%(T_46_META_WS_C_MOVEPLATFORM)\r
	@ApiLevel=4\r
	@ScriptName=MotionType\r
	@Tip = %(T_49_META_TYP_59_I0_D)\r
    MotionType : MoveObjectMotionType = -59000 #%(T_46_META_WS_P_MOTIONTYPE)\r
	@ApiLevel=4\r
	@ScriptName=MotionValueX\r
	@Tip = %(T_49_META_TYP_59_I1_D)\r
    MotionValueX : Int = -59001 #%(T_46_META_WS_P_MOTIONVALUEX)\r
	@ApiLevel=4\r
	@ScriptName=MotionValueY\r
	@Tip = %(T_49_META_TYP_59_I2_D)\r
    MotionValueY : Int = -59002 #%(T_46_META_WS_P_MOTIONVALUEY)\r
	@ApiLevel=4\r
	@ScriptName=MotionValueZ\r
	@Tip = %(T_49_META_TYP_59_I3_D)\r
    MotionValueZ : Int = -59003 #%(T_46_META_WS_P_MOTIONVALUEZ)\r
	@ApiLevel=4\r
	@ScriptName=MovementDuration\r
	@Tip = %(T_49_META_TYP_59_I4_D)\r
    MotionTime : Int = -59004 #%(T_46_META_WS_P_MOVEMENTDURATION)\r
	@ApiLevel=4\r
	@ScriptName=StopDuration\r
	@Tip = %(T_49_META_TYP_59_I5_D)\r
    StayTime : Int = -59005 #%(T_46_META_WS_P_STOPDURATION)\r
	@ApiLevel=4\r
	@ScriptName=DisableReciprocating\r
	@Tip = %(T_49_META_TYP_59_I6_D)\r
    IsReset : Bool = -59006 #%(T_46_META_WS_P_DISABLERECIPROCATING)\r
	@ApiLevel=3\r
    ExtraBaseInfoInstanceId : Int = -59007 #ExtraBaseInfoInstanceId\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootWeapon\r
@Tip = %(T_49_META_TYPE_60_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type LootItemBox : LevelObject&SpawnableEntity&ResetableEntity = 60 { #%(T_46_META_WS_C_LOOTWEAPON)\r
	@ApiLevel=4\r
	@Default=1000\r
	@ScriptName=WeaponType\r
	@Tip = %(T_49_META_TYP_60_I0_D)\r
    LootWeapon : LootWeaponType = -60000 #%(T_46_META_WS_P_WEAPONTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootIAmmo\r
@Tip = %(T_49_META_TYPE_135_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type LootItemBoxAmmo : LevelObject&SpawnableEntity&ResetableEntity = 135 { #%(T_46_META_WS_C_LOOTIAMMO)\r
	@ApiLevel=4\r
	@Default=1014\r
	@ScriptName=AmmoType\r
	@Tip = %(T_49_META_TYP_135_I0_D)\r
    LootArmor : LootAmmoType = -135000 #%(T_46_META_WS_P_AMMOTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootConsumable\r
@Tip = %(T_49_META_TYPE_136_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type LootItemBoxConsumableItem : LevelObject&SpawnableEntity&ResetableEntity = 136 { #%(T_46_META_WS_C_LOOTCONSUMABLE)\r
	@ApiLevel=4\r
	@Default=1024\r
	@ScriptName=ConsumableType\r
	@Tip = %(T_49_META_TYP_136_I0_D)\r
    LootConsumableItem : LootConsumableItemType = -136000 #%(T_46_META_WS_P_CONSUMABLETYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootThrowable\r
@Tip = %(T_49_META_TYPE_137_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type LootItemBoxProjectile : LevelObject&SpawnableEntity&ResetableEntity = 137 { #%(T_46_META_WS_C_LOOTTHROWABLE)\r
	@ApiLevel=4\r
	@Default=1029\r
	@ScriptName=ThrowableType\r
	@Tip = %(T_49_META_TYP_137_I0_D)\r
    LootProjectile : LootProjectileType = -137000 #%(T_46_META_WS_P_THROWABLETYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootScope\r
@Tip = %(T_49_META_TYPE_138_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type LootItemBoxSight : LevelObject&SpawnableEntity&ResetableEntity = 138 { #%(T_46_META_WS_C_LOOTSCOPE)\r
	@ApiLevel=4\r
	@Default=1036\r
	@ScriptName=ScopeType\r
	@Tip = %(T_49_META_TYP_138_I0_D)\r
    LootSight : LootSightType = -138000 #%(T_46_META_WS_P_SCOPETYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootArmor\r
@Tip = %(T_49_META_TYPE_139_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type LootItemBoxArmor : LevelObject&SpawnableEntity&ResetableEntity = 139 { #%(T_46_META_WS_C_LOOTARMOR)\r
	@ApiLevel=4\r
	@Default=1018\r
	@ScriptName=ArmorType\r
	@Tip = %(T_49_META_TYP_139_I0_D)\r
    LootArmor : LootArmorType = -139000 #%(T_46_META_WS_P_ARMORTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=VendingMachine\r
@Tip = %(T_49_META_TYPE_61_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type VendingMachine : CustomizeTrigger = 61 { #%(T_46_META_WS_C_VENDINGMACHINE)\r
	@ApiLevel=4\r
	@ScriptName=Shop\r
	@Tip = %(T_49_META_TYP_61_I0_D)\r
    BindShop : Shop = -61000 #%(T_46_META_WS_P_SHOP)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=TriggerRange\r
	@Tip = %(T_49_META_TYP_61_I1_D)\r
    TriggerRadius : Float = -61001 #%(T_46_META_WS_P_TRIGGERRANGE)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ModelVisibility\r
	@Tip = %(T_49_META_TYP_61_I2_D)\r
    ModelShow : Bool = -61002 #%(T_46_META_WS_P_MODELVISIBILITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Dice\r
@Tip = %(T_49_META_TYPE_62_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type BigToyBall : LevelObject&Collider = 62 { #%(T_46_META_WS_C_DICE)\r
	@ApiLevel=4\r
	@ScriptName=VelocityXZ\r
	@Tip = %(T_49_META_TYP_62_I0_D)\r
    VelocityXZ : Int = -62000 #%(T_46_META_WS_P_VELOCITYXZ)\r
	@ApiLevel=4\r
	@ScriptName=VelocityY\r
	@Tip = %(T_49_META_TYP_62_I1_D)\r
    VelocityY : Int = -62001 #%(T_46_META_WS_P_VELOCITYY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BouncingTire\r
@Tip = %(T_49_META_TYPE_63_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type BounceTire : LevelObject&Collider = 63 { #%(T_46_META_WS_C_BOUNCINGTIRE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Keyboard\r
@Tip = %(T_49_META_TYPE_64_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type MusicElement : LevelObject&Collider = 64 { #%(T_46_META_WS_C_KEYBOARD)\r
	@ApiLevel=4\r
	@ScriptName=MusicElementType\r
	@Tip = %(T_49_META_TYP_64_I0_D)\r
    get MusicElementType : PianoMusicElementType = -64000 #%(T_46_META_WS_P_MUSICELEMENTTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BasicScalable\r
@Tip = %(T_49_META_TYPE_65_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type BasicScalableItem : LevelObject&Appearance&Collider = 65 { #%(T_46_META_WS_C_BASICSCALABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CustomPath\r
@Tip = %(T_49_META_TYPE_66_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type CustomPath : LevelObject = 66 { #%(T_46_META_WS_C_CUSTOMPATH)\r
	@ApiLevel=4\r
	@ScriptName=InstanceID\r
	@Tip = %(T_49_META_TYP_66_I0_D)\r
    get InstanceID : Int = -66000 #%(T_46_META_WS_P_INSTANCEID)\r
	@ApiLevel=4\r
	@ScriptName=Points\r
	@Tip = %(T_49_META_TYP_66_I1_D)\r
    get Points : ListT_Vector3 = -66001 #%(T_46_META_WS_P_POINTS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PathPoint\r
@Tip = %(T_49_META_TYPE_67_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type CustomPathPoint : LevelObject = 67 { #%(T_46_META_WS_C_PATHPOINT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Monster\r
@Tip = %(T_49_META_TYPE_68_D)\r
@ModuleID=10008\r
@ModuleLib=AI\r
type AI : FightingEntity&InstanceEntity&Transform&ItemContainerGenerator&Visibility = 68 { #%(T_46_META_WS_C_MONSTER)\r
	@ApiLevel=4\r
	@ScriptName=HP\r
	@Tip = %(T_49_META_TYP_68_I0_D)\r
    HP : Int = -68000 #%(T_46_META_WS_P_HP)\r
	@ApiLevel=4\r
	@ScriptName=HPMax\r
	@Tip = %(T_49_META_TYP_68_I1_D)\r
    HPMAX : Int = -68001 #%(T_46_META_WS_P_HPMAX)\r
	@ApiLevel=4\r
	@ScriptName=HostTeam\r
	@Tip = %(T_49_META_TYP_68_I2_D)\r
    get HostTeamEntity : Team = -68002 #%(T_46_META_WS_P_HOSTTEAM)\r
	@ApiLevel=10\r
	@ScriptName=SpawnPosition_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    SpawnPos : DirectedPoint = -68003 #%(T_38_WZY_WS_SPAWNPOS)\r
	@ApiLevel=4\r
	@ScriptName=AttackDamage\r
	@Tip = %(T_49_META_TYP_68_I4_D)\r
    AttackDamage : Int = -68004 #%(T_46_META_WS_P_ATTACKDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=AttackInterval\r
	@Tip = %(T_49_META_TYP_68_I4_D)\r
    AttackInterval : Int = -68005 #%(T_46_META_WS_P_ATTACKINTERVAL)\r
	@ApiLevel=4\r
	@ScriptName=AttackRange\r
	@Tip = %(T_49_META_TYP_68_I4_D)\r
    AttackRange : Float = -68006 #%(T_46_META_WS_P_ATTACKRANGE)\r
	@ApiLevel=4\r
	@ScriptName=WanderRange\r
	@Tip = %(T_49_META_TYP_68_I7_D)\r
    WanderRange : Float = -68007 #%(T_46_META_WS_P_WANDERRANGE)\r
	@ApiLevel=4\r
	@ScriptName=DetectRange\r
	@Tip = %(T_49_META_TYP_68_I8_D)\r
    DetectRange : Float = -68008 #%(T_46_META_WS_P_DETECTRANGE)\r
	@ApiLevel=4\r
	@ScriptName=RunSpeed\r
	@Tip = %(T_49_META_TYP_68_I9_D)\r
    RunSpeed : Float = -68009 #%(T_46_META_WS_P_RUNSPEED)\r
	@ApiLevel=4\r
	@ScriptName=IsDeadDrop\r
	@Tip = %(T_49_META_TYP_68_I10_D)\r
    EnableDeadDrop : Bool = -68010 #%(T_46_META_WS_P_ISDEADDROP)\r
	@ApiLevel=4\r
	@ScriptName=IsInvincible\r
	@Tip = %(T_49_META_TYP_68_I11_D)\r
    IsGod : Bool = -68011 #%(T_46_META_WS_P_ISINVINCIBLE)\r
	@ApiLevel=4\r
	@ScriptName=DamageTakenPercent\r
	@Tip = %(T_49_META_TYP_68_I12_D)\r
    InjuredScale : Float = -68012 #%(T_46_META_WS_P_DAMAGETAKENPERCENT)\r
	@ApiLevel=4\r
	@ScriptName=MonsterType\r
	@Tip = %(T_49_META_TYP_68_I13_D)\r
    get AIType : AIType = -68013 #%(T_46_META_WS_P_MONSTERTYPE)\r
	@ApiLevel=4\r
	@ScriptName=IsAutoChaseEnemy\r
	@Tip = %(T_49_META_TYP_68_I14_D)\r
    get CanChaseEnemy : Bool = -68014 #%(T_46_META_WS_P_ISAUTOCHASEENEMY)\r
	@ApiLevel=4\r
	@ScriptName=ActionType\r
	@Tip = %(T_49_META_TYP_68_I15_D)\r
    get ActionType : Int = -68015 #%(T_46_META_WS_P_ACTIONTYPE)\r
	@ApiLevel=4\r
	@ScriptName=PathID\r
	@Tip = %(T_49_META_TYP_68_I16_D)\r
    get PathID : Int = -68016 #%(T_46_META_WS_P_PATHID)\r
	@ApiLevel=4\r
	@ScriptName=ChaseTarget\r
	@Tip = %(T_49_META_TYP_68_I17_D)\r
    ChaseTarget : FightingEntity = -68017 #%(T_46_META_WS_P_CHASETARGET)\r
	@ApiLevel=4\r
	@ScriptName=AttackTarget\r
	@Tip = %(T_49_META_TYP_68_I18_D)\r
    get AttackTarget : FightingEntity = -68018 #%(T_46_META_WS_P_ATTACKTARGET)\r
	@ApiLevel=4\r
	@ScriptName=SpawnPosition\r
	@Tip = %(T_49_META_TYP_68_I19_D)\r
    SpawnPosVec3 : Vector3 = -68019 #%(T_46_META_WS_P_SPAWNPOSITION)\r
	@ApiLevel=3\r
	@ScriptName=TeamIndex\r
	@Tip = %(T_49_META_TYP_68_I20_D)\r
    get TeamIndex : Int = -68020 #%(T_41_XXJ_WS_TEAMINDEX)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ShopItem\r
@Tip = %(T_49_META_TYPE_71_D)\r
@ModuleID=19\r
@ModuleLib=Economy\r
type ShopItem : Entity = 71 { #%(T_46_META_WS_C_SHOPITEM)\r
	@ApiLevel=3\r
	@ScriptName=ID\r
	@Tip = %(T_49_META_TYP_71_I0_D)\r
    ID : Int = -71000 #%(T_46_META_WS_P_ID)\r
	@ApiLevel=4\r
	@ScriptName=Price\r
	@Tip = %(T_49_META_TYP_71_I1_D)\r
    Price : Int = -71001 #%(T_46_META_WS_P_PRICE)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=MoneyType\r
	@Tip = %(T_49_META_TYP_71_I2_D)\r
    MoneyType : MoneyType = -71002 #%(T_46_META_WS_P_MONEYTYPE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=PurchaseLimit\r
	@Tip = %(T_49_META_TYP_71_I3_D)\r
    TotalPurchaseLimit : Int = -71003 #%(T_46_META_WS_P_PURCHASELIMIT)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=RemainQuantity\r
	@Tip = %(T_49_META_TYP_71_I4_D)\r
    CurTotalPurchaseLimit : Int = -71004 #%(T_46_META_WS_P_REMAINQUANTITY)\r
	@ApiLevel=4\r
	@ScriptName=Name\r
	@Tip = %(T_49_META_TYP_71_I5_D)\r
    Name : String = -71005 #%(T_46_META_WS_P_NAME)\r
	@ApiLevel=3\r
	@ScriptName=Desc\r
	@Tip = %(T_49_META_TYP_71_I6_D)\r
    Desc : String = -71006 #%(T_46_META_WS_P_DESC)\r
	@ApiLevel=3\r
	@ScriptName=ItemIDs\r
	@Tip = %(T_49_META_TYP_71_I7_D)\r
    ItemGoodsIDList : ListT_ItemGoodsIDType = -71007 #%(T_46_META_WS_P_ITEMIDS)\r
	@ApiLevel=3\r
	@ScriptName=ItemCounts\r
	@Tip = %(T_49_META_TYP_71_I8_D)\r
    ItemGoodsCntList : ListT_Int = -71008 #%(T_46_META_WS_P_ITEMCOUNTS)\r
	@ApiLevel=4\r
	@ScriptName=Icon\r
	@Tip = %(T_49_META_TYP_71_I9_D)\r
    IconType : SpriteID = -71009 #%(T_46_META_WS_P_ICON)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsPurchasable\r
	@Tip = %(T_49_META_TYP_71_I10_D)\r
    CanPurchas : Bool = -71010 #%(T_46_META_WS_P_ISPURCHASABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ShopShelf\r
@Tip = %(T_49_META_TYPE_72_D)\r
@ModuleID=19\r
@ModuleLib=Economy\r
type ShopShelf : Entity = 72 { #%(T_46_META_WS_C_SHOPSHELF)\r
	@ApiLevel=10\r
	@ScriptName=Name_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Name : String = -72000 #Name\r
	@ApiLevel=4\r
	@ScriptName=ShopItems\r
	@Tip = %(T_49_META_TYP_72_I1_D)\r
    ShopItemList : ListT_ShopItem = -72001 #%(T_46_META_WS_P_SHOPITEMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Shop\r
@Tip = %(T_49_META_TYPE_73_D)\r
@ModuleID=19\r
@ModuleLib=Economy\r
type Shop : Entity = 73 { #%(T_46_META_WS_C_SHOP)\r
	@ApiLevel=10\r
	@ScriptName=Name_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Name : String = -73000 #Name\r
	@ApiLevel=4\r
	@ScriptName=Shelves\r
	@Tip = %(T_49_META_TYP_73_I1_D)\r
    ShopShelfList : ListT_ShopShelf = -73001 #%(T_46_META_WS_P_SHELFS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=InventoryType\r
@Tip = %(T_49_META_TYPE_74_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
enum InventoryType : Int = 74 { #%(T_46_META_WS_C_INVENTORYTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Weapon\r
	@Tip = %(T_49_META_TYP_74_I0_D)\r
    Weapon = 0 #%(T_24_V_TRAINING_BOX_WEAPON)\r
	@ApiLevel=4\r
	@ScriptName=Helmet\r
	@Tip = %(T_49_META_TYP_74_I1_D)\r
    Helmet = 2 #%(T_46_META_WS_E_HELMET)\r
	@ApiLevel=4\r
	@ScriptName=Vest\r
	@Tip = %(T_49_META_TYP_74_I2_D)\r
    Vest = 4 #%(T_46_META_WS_E_VEST)\r
	@ApiLevel=4\r
	@ScriptName=Grenade\r
	@Tip = %(T_49_META_TYP_74_I3_D)\r
    Grenade = 8 #%(T_46_META_WS_E_GRENADE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PatrolType\r
@Tip = %(T_49_META_TYPE_75_D)\r
@ModuleID=10008\r
@ModuleLib=AI\r
enum PatrolType : Int = 75 { #%(T_46_META_WS_C_PATROLTYPE)\r
	@ApiLevel=4\r
	@ScriptName=OneWay\r
	@Tip = %(T_49_META_TYP_75_I0_D)\r
    OneWay = 1 #%(T_46_META_WS_E_ONEWAY)\r
	@ApiLevel=4\r
	@ScriptName=BackAndForth\r
	@Tip = %(T_49_META_TYP_75_I1_D)\r
    BackAndForth = 2 #%(T_46_META_WS_E_BACKANDFORTH)\r
	@ApiLevel=4\r
	@ScriptName=Cyclic\r
	@Tip = %(T_49_META_TYP_30_I34_D)\r
    Cylic = 3 #%(T_46_META_WS_E_CYLIC)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PatrolStyleType\r
@Tip = %(T_49_META_TYPE_76_D)\r
@ModuleID=10008\r
@ModuleLib=AI\r
enum PatrolStyleType : Int = 76 { #%(T_46_META_WS_C_PATROLSTYLETYPE)\r
	@ApiLevel=4\r
	@ScriptName=JustPatrol\r
	@Tip = %(T_49_META_TYP_76_I0_D)\r
    JustPatrol = 1 #%(T_46_META_WS_E_JUSTPATROL)\r
	@ApiLevel=4\r
	@ScriptName=PatrolWhileAttack\r
	@Tip = %(T_49_META_TYP_76_I1_D)\r
    Attack = 2 #%(T_46_META_WS_E_PATROLWHILEATTACK)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=FireType\r
@Tip = %(T_49_META_TYPE_401_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
enum FireType : Int = 401 { #%(T_46_META_WS_C_FIRETYPE)\r
	@ApiLevel=4\r
	@ScriptName=None\r
	@Tip = %(T_49_META_TYP_401_I0_D)\r
    None = -1 #%(T_46_META_WS_E_NONE)\r
	@ApiLevel=4\r
	@ScriptName=Auto\r
	@Tip = %(T_49_META_TYP_401_I1_D)\r
    Auto = 0 #%(T_46_META_WS_E_AUTO)\r
	@ApiLevel=4\r
	@ScriptName=Single\r
	@Tip = %(T_49_META_TYP_401_I2_D)\r
    Single = 1 #%(T_46_META_WS_E_SINGLE)\r
	@ApiLevel=4\r
	@ScriptName=Triple\r
	@Tip = %(T_49_META_TYP_401_I3_D)\r
    Triple = 2 #%(T_46_META_WS_E_TRIPLE)\r
	@ApiLevel=4\r
	@ScriptName=Double\r
	@Tip = %(T_49_META_TYP_401_I4_D)\r
    Double = 3 #%(T_46_META_WS_E_DOUBLE)\r
	@ApiLevel=4\r
	@ScriptName=Dump\r
	@Tip = %(T_49_META_TYP_401_I5_D)\r
    Dump = 4 #%(T_46_META_WS_E_DUMP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Weapon\r
@Tip = %(T_49_META_TYPE_79_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type Weapon : FormulableEntity&BuffableEntity = 79 { #%(T_46_META_WS_C_WEAPON)\r
	@ApiLevel=4\r
	@ScriptName=Damage\r
	@Tip = %(T_49_META_TYP_79_I0_D)\r
    Damage : Int = -79000 #%(T_46_META_WS_P_DAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=AttackRange\r
	@Tip = %(T_49_META_TYP_79_I1_D)\r
    Range : Float = -79001 #%(T_46_META_WS_P_ATTACKRANGE)\r
	@ApiLevel=4\r
	@ScriptName=AttackInterval\r
	@Tip = %(T_49_META_TYP_79_I2_D)\r
    FireInterval : Float = -79002 #%(T_32_YS_WEAPON_TAG_3)\r
	@ApiLevel=4\r
	@ScriptName=AmmoMagSize\r
	@Tip = %(T_49_META_TYP_79_I3_D)\r
    AmmoClipSize : Int = -79003 #%(T_46_META_WS_P_AMMOMAGSIZE)\r
	@ApiLevel=4\r
	@ScriptName=InitialMagCount\r
	@Tip = %(T_49_META_TYP_79_I4_D)\r
    InitialClipCount : Int = -79004 #%(T_46_META_WS_P_INITIALMAGCOUNT)\r
	@ApiLevel=4\r
	@ScriptName=ArmorPenetration\r
	@Tip = %(T_49_META_TYP_79_I5_D)\r
    BiteArmor : Float = -79005 #%(T_46_META_WS_P_ARMORPENETRATION)\r
	@ApiLevel=4\r
	@ScriptName=FullDamageDistance\r
	@Tip = %(T_49_META_TYP_79_I6_D)\r
    FullDamageDistance : Float = -79006 #%(T_46_META_WS_P_FULLDAMAGEDISTANCE)\r
	@ApiLevel=4\r
	@ScriptName=MinDamageDistance\r
	@Tip = %(T_49_META_TYP_79_I7_D)\r
    MinDamageDistance : Float = -79007 #%(T_46_META_WS_P_MINDAMAGEDISTANCE)\r
	@ApiLevel=4\r
	@ScriptName=MinDamage\r
	@Tip = %(T_49_META_TYP_79_I8_D)\r
    MinDamage : Int = -79008 #%(T_46_META_WS_P_MINDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=ScatterThreshold\r
	@Tip = %(T_49_META_TYP_79_I9_D)\r
    ScatterNum : Float = -79009 #%(T_46_META_WS_P_SCATTERTHRESHOLD)\r
	@ApiLevel=4\r
	@ScriptName=MaxScatterRatio\r
	@Tip = %(T_49_META_TYP_79_I10_D)\r
    ScatterMax : Float = -79010 #%(T_46_META_WS_P_MAXSCATTERRATIO)\r
	@ApiLevel=4\r
	@ScriptName=ItemID\r
	@Tip = %(T_49_META_TYP_79_I11_D)\r
    get ItemID : ItemGoodsIDType = -79011 #%(T_46_META_WS_P_ITEMID)\r
	@ApiLevel=4\r
	@ScriptName=FiringInterval\r
	@Tip = %(T_49_META_TYP_79_I12_D)\r
    RepeatFireInterval : Float = -79012 #%(T_36_WZY_GUNPRO_PARAM12)\r
	@ApiLevel=4\r
	@ScriptName=Owner\r
	@Tip = %(T_49_META_TYP_79_I13_D)\r
    get Owner : Player = -79013 #%(T_46_META_WS_P_OWNER)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsConsumeAmmo\r
	@Tip = %(T_49_META_TYP_79_I14_D)\r
    CostAmmo : Bool = -79014 #%(T_46_META_WS_P_ISCONSUMEAMMO)\r
	@ApiLevel=4\r
	@ScriptName=DoubleGunType\r
	@Tip = %(T_49_META_TYP_79_I15_D)\r
    CombineType : WeaponCombineType = -79015 #%(T_46_META_WS_P_DOUBLEGUNTYPE)\r
	@ApiLevel=4\r
	@ScriptName=ArmorPenetrationFactor\r
	@Tip = %(T_49_META_TYP_79_I16_D)\r
    Armordestroy : Float = -79016 #%(T_46_META_WS_P_ARMORPENETRATIONFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=PlayerSpeedFactor\r
	@Tip = %(T_49_META_TYP_79_I17_D)\r
    PlayerSpeedFactor : Float = -79017 #%(T_46_META_WS_P_PLAYERSPEEDFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=BodyDamageFactor\r
	@Tip = %(T_49_META_TYP_79_I18_D)\r
    DamageRatioBody : Float = -79018 #%(T_46_META_WS_P_BODYDAMAGEFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=HeadDamageFactor\r
	@Tip = %(T_49_META_TYP_79_I19_D)\r
    DamageRatioHead : Float = -79019 #%(T_46_META_WS_P_HEADDAMAGEFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=LimbDamageFactor\r
	@Tip = %(T_49_META_TYP_79_I20_D)\r
    DamageLimbBody : Float = -79020 #%(T_46_META_WS_P_LIMBDAMAGEFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=OtherDamageFactor\r
	@Tip = %(T_49_META_TYP_79_I21_D)\r
    ExtraDamageRate : Float = -79021 #%(T_46_META_WS_P_OTHERDAMAGEFACTOR)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=VisibleOnBack\r
	@Tip = %(T_49_META_TYP_79_I22_D)\r
    VisibleOnBack : Bool = -79022 #%(T_46_META_WS_P_VISIBLEONBACK)\r
	@ApiLevel=4\r
	@ScriptName=KnockdownDamageBonus\r
	@Tip = %(T_49_META_TYP_79_I23_D)\r
    KnockDownDamage : Int = -79023 #%(T_46_META_WS_P_KNOCKDOWNDAMAGEBONUS)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=AmmoPerShot\r
	@Tip = %(T_49_META_TYP_79_I24_D)\r
    OnceAmmo : Int = -79024 #%(T_46_META_WS_P_AMMOPERSHOT)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=ReloadSpeedFactor\r
	@Tip = %(T_49_META_TYP_79_I25_D)\r
    ReloadSpeed : Float = -79025 #%(T_46_META_WS_P_RELOADSPEEDFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=CurrentAmmo\r
	@Tip = %(T_49_META_TYP_79_I26_D)\r
    AmmoInClip : Int = -79026 #%(T_46_META_WS_P_CURRENT AMMO)\r
	@ApiLevel=4\r
	@ScriptName=SkinID\r
	@Tip = %(T_49_META_TYP_79_I27_D)\r
    WeaponSkinID : WeaponSkinID = -79027 #%(T_46_META_WS_P_SKINID)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=OverloadByPlayerConfiguration\r
	@Tip = %(T_49_META_TYP_79_I28_D)\r
    OverloadByPlayerWeaponSkin : Bool = -79028 #%(T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=EnableSkinAttributes\r
	@Tip = %(T_49_META_TYP_79_I29_D)\r
    EnableWeaponSkinProp : Bool = -79029 #%(T_46_META_WS_P_ENABLESKINATTRIBUTES)\r
	@ApiLevel=4\r
	@ScriptName=ScatterIncreaseSpeed\r
	@Tip = %(T_49_META_TYP_79_I30_D)\r
    ScatterSpeed : Float = -79030 #%(T_46_META_WS_P_SCATTERINCREASESPEED)\r
	@ApiLevel=4\r
	@ScriptName=ScatterRecoverSpeed\r
	@Tip = %(T_49_META_TYP_79_I31_D)\r
    ScatterRecoverSpeed : Float = -79031 #%(T_46_META_WS_P_SCATTERRECOVERSPEED)\r
	@ApiLevel=4\r
	@ScriptName=PlayerSpeedFactorWhileFiring\r
	@Tip = %(T_49_META_TYP_79_I32_D)\r
    PlayerSpeedFactorFiring : Float = -79032 #%(T_46_META_WS_P_PLAYERSPEEDFACTORWHILEFIRING)\r
	@ApiLevel=4\r
	@ScriptName=ScatterMultiplierWhileMoving\r
	@Tip = %(T_49_META_TYP_79_I33_D)\r
    ScatterMove : Float = -79033 #%(T_46_META_WS_P_SCATTERMULTIPLIERWHILEMOVING)\r
	@ApiLevel=4\r
	@ScriptName=WeaponType\r
	@Tip = %(T_49_META_TYP_79_I34_D)\r
    get OriginWeaponType : WeaponType = -79034 #%(T_46_META_WS_P_WEAPONTYPE)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYPE_346_D)\r
    get AmmoType : AmmoType = -79035 #%(T_46_META_WS_P_AMMOTYPE)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_79_I36_D)\r
    FireType : FireType = -79036 #%(T_46_META_WS_P_FIRETYPE)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=IsSingleShot\r
	@Tip = %(T_49_META_TYP_79_I37_D)\r
    IsSingleShot : Bool = -79037 #%(T_46_META_WS_P_ISSINGLESHOT)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=IsSilence\r
	@Tip = %(T_49_META_TYP_79_I38_D)\r
    IsSilence : Bool = -79038 #%(T_46_META_WS_P_ISSILENCE)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=SpeedWhileAiming\r
	@Tip = %(T_49_META_TYP_79_I39_D)\r
    SpeedWhileAiming : Float = -79039 #%(T_46_META_WS_P_SPEEDWHILEAIMING)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WeaponGenerator\r
@Tip = %(T_49_META_TYPE_176_D)\r
@ModuleID=10016\r
@ModuleLib=Combat\r
type WeaponGenerator : ItemContainerGenerator&Weapon&InstanceEntity = 176 { #%(T_46_META_WS_C_WEAPONGENERATOR)\r
	@ApiLevel=4\r
	@ScriptName=WeaponType\r
	@Tip = %(T_49_META_TYP_176_I0_D)\r
    get WeaponType : Int = -176000 #%(T_46_META_WS_P_WEAPONTYPE)\r
	@ApiLevel=4\r
	@ScriptName=WeaponSubType\r
	@Tip = %(T_49_META_TYP_176_I1_D)\r
    get WeaponSubType : Int = -176001 #%(T_46_META_WS_P_WEAPONSUBTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ItemContainer\r
@Tip = %(T_49_META_TYPE_187_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type ItemGenerator : ItemContainerGenerator&InstanceEntity = 187 { #%(T_46_META_WS_C_ITEMCONTAINER)\r
	@ApiLevel=4\r
	@ScriptName=ItemID\r
	@Tip = %(T_49_META_TYP_187_I0_D)\r
    get ItemID : Int = -187000 #%(T_46_META_WS_P_ITEMID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIRequestPurchaseType\r
@Tip = %(T_49_META_TYPE_363_D)\r
@ModuleID=19\r
@ModuleLib=Economy\r
enum RequestPurchaseType : Int = 363 { #%(T_46_META_WS_C_UIREQUESTPURCHASETYPE)\r
	@ApiLevel=4\r
	@ScriptName=Disabled\r
	@Tip = %(T_49_META_TYP_363_I0_D)\r
    Forbiden = 1 #%(T_46_META_WS_E_DISABLED)\r
	@ApiLevel=4\r
	@ScriptName=Team\r
	@Tip = %(T_49_META_TYP_363_I1_D)\r
    Team = 2 #%(T_46_META_WS_E_TEAM)\r
	@ApiLevel=10\r
	@ScriptName=Faction\r
	@Tip = %(T_49_META_TYP_363_I2_D)\r
    Faction = 3 #%(T_46_META_WS_E_FACTION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIStore\r
@Tip = %(T_49_META_TYPE_80_D)\r
@ModuleID=19\r
@ModuleLib=Economy\r
type UGCShopHud : InternalHud = 80 { #%(T_46_META_WS_C_UISTORE)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -80000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=3\r
	@ScriptName=DisableManualClosing\r
	@Tip = %(T_49_META_TYP_80_I1_D)\r
    CloseForbiden : Bool = -80001 #%(T_46_META_WS_P_DISABLEMANUALCLOSING)\r
	@ApiLevel=4\r
	@ScriptName=Store\r
	@Tip = %(T_49_META_TYP_80_I2_D)\r
    BindShopEntity : Shop = -80002 #%(T_46_META_WS_P_STORE)\r
	@ApiLevel=10\r
	@ScriptName=Money\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    BindMoneyEntity : Money = -80003 #%(T_46_META_WS_P_MONEY)\r
	@ApiLevel=3\r
	@ScriptName=MoneyList\r
	@Tip = %(T_49_META_TYP_80_I4_D)\r
    BindMoneyEntityList : ListT_Money = -80004 #%(T_46_META_WS_P_MONEYLIST)\r
	@ApiLevel=3\r
	@ScriptName=WalletID\r
	@Tip = %(T_49_META_TYP_80_I5_D)\r
    get BindWalletEntityID : String = -80005 #%(T_46_META_WS_P_WALLETID)\r
	@ApiLevel=3\r
	@Default=0\r
	@ScriptName=RequestType\r
	@Tip = %(T_49_META_TYP_80_I6_D)\r
    get RequestType : RequestPurchaseType = -80006 #%(T_46_META_WS_P_REQUESTTYPE)\r
	@ApiLevel=3\r
	@ScriptName=RequestedItemList\r
	@Tip = %(T_49_META_TYP_80_I7_D)\r
    get AskedList : ListT_Object = -80007 #%(T_46_META_WS_P_REQUESTEDITEMLIST)\r
}\r
\r
@ApiLevel=3\r
@ScriptName=UIInteractionButton\r
@Tip = %(T_49_META_TYPE_83_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type ActionHud : InternalHud = 83 { #%(T_46_META_WS_C_UIINTERACTIONBUTTON)\r
	@ApiLevel=3\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -83000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=3\r
	@ScriptName=TriggerPlayerID\r
	@Tip = %(T_49_META_TYP_83_I1_D)\r
    EntityID : Entity = -83001 #%(T_46_META_WS_P_TRIGGERPLAYERID)\r
	@ApiLevel=3\r
	@ScriptName=Params\r
	@Tip = %(T_49_META_TYP_83_I2_D)\r
    Params : ListT_Object = -83002 #%(T_46_META_WS_P_PARAMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PropertyFormulaFactorType\r
@Tip = %(T_49_META_TYPE_86_D)\r
@ModuleID=18\r
@ModuleLib=PropertyFormula\r
enum FormulaFactorType : Int = 86 { #%(T_46_META_WS_C_PROPERTYFORMULAFACTORTYPE)\r
	@ApiLevel=4\r
	@ScriptName=MinValue\r
	@Tip = %(T_49_META_TYP_86_I0_D)\r
    MinValue = 1 #%(T_46_META_WS_E_MINVALUE)\r
	@ApiLevel=4\r
	@ScriptName=MaxValue\r
	@Tip = %(T_49_META_TYP_86_I1_D)\r
    MaxValue = 2 #%(T_46_META_WS_E_MAXVALUE)\r
	@ApiLevel=4\r
	@ScriptName=BaseCoefficient\r
	@Tip = %(T_49_META_TYP_86_I2_D)\r
    BaseMultiplier = 3 #%(T_46_META_WS_E_BASECOEFFICIENT)\r
	@ApiLevel=4\r
	@ScriptName=PreAccumulator\r
	@Tip = %(T_49_META_TYP_86_I3_D)\r
    BeforeAccumulator = 4 #%(T_46_META_WS_E_PREACCUMULATOR)\r
	@ApiLevel=4\r
	@ScriptName=Multiplier\r
	@Tip = %(T_49_META_TYP_86_I4_D)\r
    Multiplier = 5 #%(T_46_META_WS_E_MULTIPLIER)\r
	@ApiLevel=4\r
	@ScriptName=MultiplyAccumulate\r
	@Tip = %(T_49_META_TYP_86_I5_D)\r
    SumMultiplier = 6 #%(T_46_META_WS_E_MULTIPLYACCUMULATE)\r
	@ApiLevel=4\r
	@ScriptName=PostAccumulator\r
	@Tip = %(T_49_META_TYP_86_I6_D)\r
    AfterAccumulator = 7 #%(T_46_META_WS_E_POSTACCUMULATOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DualWieldWeaponType\r
@Tip = %(T_49_META_TYPE_154_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
enum WeaponCombineType : Int = 154 { #%(T_46_META_WS_C_DUALWIELDWEAPONTYPE)\r
	@ApiLevel=4\r
	@ScriptName=NoDualWielding\r
	@Tip = %(T_49_META_TYP_154_I0_D)\r
    NoCombine = 0 #%(T_46_META_WS_E_NODUALWIELDING)\r
	@ApiLevel=4\r
	@ScriptName=CombineSelf\r
	@Tip = %(T_49_META_TYP_154_I1_D)\r
    CombineSelf = 1 #%(T_46_META_WS_E_COMBINESELF)\r
	@ApiLevel=4\r
	@ScriptName=CombineAll\r
	@Tip = %(T_49_META_TYP_154_I2_D)\r
    CombineAll = 2 #%(T_46_META_WS_E_COMBINEALL)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_49_META_TYPE_345_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum WeaponType : Int = 345 { #%(T_46_META_WS_C_WEAPONTYPE)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_30_I78_D)\r
    Rifle = 0 #%(T_46_META_WS_E_RIFLE)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_30_I79_D)\r
    Sniper = 1 #%(T_46_META_WS_E_SNIPER)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_30_I77_D)\r
    Pistol = 2 #%(T_46_META_WS_E_PISTOL)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_30_I76_D)\r
    Melee = 3 #%(T_46_META_WS_E_MELEE)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_345_I4_D)\r
    Shotgun = 4 #%(T_46_META_WS_E_SHOTGUN)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_30_I81_D)\r
    SubMachineGun = 6 #%(T_46_META_WS_E_SUBMACHINEGUN)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_345_I6_D)\r
    SpecialGun = 7 #%(T_46_META_WS_E_SPECIALGUN)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYPE_310_D)\r
    CrossBow = 8 #%(T_46_META_WS_E_CROSSBOW)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_345_I8_D)\r
    CG15 = 12 #%(T_46_META_WS_E_CG15)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYPE_237_D)\r
    GrapplingHookGun = 15 #%(T_46_META_WS_E_GRAPPLINGHOOKGUN)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_345_I10_D)\r
    HandCannon = 16 #%(T_46_META_WS_E_HANDCANNON)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYPE_344_D)\r
    ThrowingKnife = 18 #%(T_46_META_WS_E_THROWINGKNIFE)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_345_I12_D)\r
    IceGun = 19 #%(T_46_META_WS_E_ICEGUN)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_345_I13_D)\r
    FlameThrower = 21 #%(T_46_META_WS_E_FLAMETHROWER)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYPE_344_D)\r
    Dagger = 22 #%(T_46_META_WS_E_DAGGER)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_49_META_TYPE_346_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum AmmoType : Int = 346 { #%(T_46_META_WS_C_AMMOTYPE)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_346_I0_D)\r
    RifleAmmo = 201 #%(T_46_META_WS_E_RIFLEAMMO)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_346_I1_D)\r
    PistolAmmo = 202 #%(T_46_META_WS_E_PISTOLAMMO)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_346_I2_D)\r
    SniperAmmo = 203 #%(T_46_META_WS_E_SNIPERAMMO)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_346_I3_D)\r
    ShotgunAmmo = 204 #%(T_46_META_WS_E_SHOTGUNAMMO)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_346_I4_D)\r
    SubMachineGunAmmo = 205 #%(T_46_META_WS_E_SUBMACHINEGUNAMMO)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_346_I5_D)\r
    BowAmmo = 206 #%(T_46_META_WS_E_BOWAMMO)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_346_I6_D)\r
    M79Ammo = 207 #%(T_46_META_WS_E_M79AMMO)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_346_I7_D)\r
    Hook = 209 #%(T_46_META_WS_E_HOOK)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_346_I8_D)\r
    M79Ammo_Exclusive = 219 #%(T_46_META_WS_E_M79AMMO_EXCLUSIVE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MovePlatformType\r
@Tip = %(T_49_META_TYPE_127_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum MoveObjectMotionType : Int = 127 { #%(T_46_META_WS_C_MOVEPLATFORMTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Move\r
	@Tip = %(T_49_META_TYP_127_I0_D)\r
    Translate = 0 #%(T_46_META_WS_E_MOVE)\r
	@ApiLevel=4\r
	@ScriptName=Rotate\r
	@Tip = %(T_49_META_TYP_127_I1_D)\r
    Rotate = 1 #%(T_46_META_WS_E_ROTATE)\r
	@ApiLevel=4\r
	@ScriptName=Scale\r
	@Tip = %(T_49_META_TYP_127_I2_D)\r
    Scale = 2 #%(T_46_META_WS_E_SCALE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootAmmoType\r
@Tip = %(T_49_META_TYPE_129_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum LootAmmoType : Int = 129 { #%(T_46_META_WS_C_LOOTAMMOTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Random\r
	@Tip = %(T_49_META_TYP_129_I0_D)\r
    LootAmmoRandom = 1014 #%(T_46_META_WS_E_RANDOM)\r
	@ApiLevel=4\r
	@ScriptName=ARAmmo\r
	@Tip = %(T_49_META_TYP_129_I1_D)\r
    ARAmmo = 1008 #%(T_46_META_WS_E_ARAMMO)\r
	@ApiLevel=4\r
	@ScriptName=SMGAmmo\r
	@Tip = %(T_49_META_TYP_129_I2_D)\r
    SMGAmmo = 1009 #%(T_46_META_WS_E_SMGAMMO)\r
	@ApiLevel=4\r
	@ScriptName=SNAmmo\r
	@Tip = %(T_49_META_TYP_129_I3_D)\r
    SNAmmo = 1010 #%(T_46_META_WS_E_SNAMMO)\r
	@ApiLevel=4\r
	@ScriptName=HGAmmo\r
	@Tip = %(T_49_META_TYP_129_I4_D)\r
    HGAmmo = 1011 #%(T_46_META_WS_E_HGAMMO)\r
	@ApiLevel=4\r
	@ScriptName=SGAmmo\r
	@Tip = %(T_49_META_TYP_129_I5_D)\r
    SGAmmo = 1012 #%(T_46_META_WS_E_SGAMMO)\r
	@ApiLevel=4\r
	@ScriptName=BOWAmmo\r
	@Tip = %(T_49_META_TYP_129_I6_D)\r
    BOWAmmo = 1013 #%(T_46_META_WS_E_BOWAMMO)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootConsumableType\r
@Tip = %(T_49_META_TYPE_130_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum LootConsumableItemType : Int = 130 { #%(T_46_META_WS_C_LOOTCONSUMABLETYPE)\r
	@ApiLevel=4\r
	@ScriptName=Random\r
	@Tip = %(T_49_META_TYP_130_I0_D)\r
    LootCORandom = 1024 #%(T_46_META_WS_E_RANDOM)\r
	@ApiLevel=4\r
	@ScriptName=MedKit\r
	@Tip = %(T_49_META_TYP_130_I1_D)\r
    FAK = 1019 #%(T_46_META_WS_E_MEDKIT)\r
	@ApiLevel=4\r
	@ScriptName=RepairKit\r
	@Tip = %(T_49_META_TYP_130_I2_D)\r
    ArmorPrepair = 1020 #%(T_46_META_WS_E_REPAIRKIT)\r
	@ApiLevel=4\r
	@ScriptName=Horizaline\r
	@Tip = %(T_49_META_TYP_130_I3_D)\r
    Cardiac = 1021 #%(T_46_META_WS_E_HORIZALINE)\r
	@ApiLevel=4\r
	@ScriptName=Inhaler\r
	@Tip = %(T_49_META_TYP_130_I4_D)\r
    Inhaler = 1022 #%(T_46_META_WS_E_INHALER)\r
	@ApiLevel=4\r
	@ScriptName=GlooWall\r
	@Tip = %(T_49_META_TYPE_235_D)\r
    Glooshield = 1023 #%(T_46_META_WS_E_GLOOWALL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootArmorType\r
@Tip = %(T_49_META_TYPE_131_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum LootArmorType : Int = 131 { #%(T_46_META_WS_C_LOOTARMORTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Random\r
	@Tip = %(T_49_META_TYP_131_I0_D)\r
    LootArRandom = 1018 #%(T_46_META_WS_E_RANDOM)\r
	@ApiLevel=4\r
	@ScriptName=ArmorLv1\r
	@Tip = %(T_49_META_TYP_131_I1_D)\r
    ArmorLv1 = 1015 #%(T_46_META_WS_E_ARMORLV1)\r
	@ApiLevel=4\r
	@ScriptName=ArmorLv2\r
	@Tip = %(T_49_META_TYP_131_I2_D)\r
    ArmorLv2 = 1016 #%(T_46_META_WS_E_ARMORLV2)\r
	@ApiLevel=4\r
	@ScriptName=ArmorLv3\r
	@Tip = %(T_49_META_TYP_131_I3_D)\r
    ArmorLv3 = 1017 #%(T_46_META_WS_E_ARMORLV3)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootThrowableType\r
@Tip = %(T_49_META_TYPE_132_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum LootProjectileType : Int = 132 { #%(T_46_META_WS_C_LOOTTHROWABLETYPE)\r
	@ApiLevel=4\r
	@ScriptName=Random\r
	@Tip = %(T_49_META_TYP_132_I0_D)\r
    LootJaRandom = 1029 #%(T_46_META_WS_E_RANDOM)\r
	@ApiLevel=4\r
	@ScriptName=Grenade\r
	@Tip = %(T_49_META_TYP_132_I1_D)\r
    Grenade = 1025 #%(T_46_META_WS_E_GRENADE)\r
	@ApiLevel=4\r
	@ScriptName=FlashGrenade\r
	@Tip = %(T_49_META_TYP_34_I133_D)\r
    Flash = 1026 #%(TXT_ITEM_FLASH)\r
	@ApiLevel=4\r
	@ScriptName=SmokeGrenade\r
	@Tip = %(T_49_META_TYP_34_I134_D)\r
    SmokeGrenade = 1027 #%(T_46_META_WS_E_SMOKEGRENADE)\r
	@ApiLevel=4\r
	@ScriptName=FlashFreeze\r
	@Tip = %(T_49_META_TYP_132_I4_D)\r
    IceGrenade = 1028 #%(T_46_META_WS_E_FLASHFREEZE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootScopeType\r
@Tip = %(T_49_META_TYPE_133_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum LootSightType : Int = 133 { #%(T_46_META_WS_C_LOOTSCOPETYPE)\r
	@ApiLevel=4\r
	@ScriptName=Random\r
	@Tip = %(T_49_META_TYP_133_I0_D)\r
    LootSightRandom = 1036 #%(T_46_META_WS_E_RANDOM)\r
	@ApiLevel=4\r
	@ScriptName=Scope2x\r
	@Tip = %(T_49_META_TYP_133_I1_D)\r
    Sight2 = 1032 #%(T_46_META_WS_E_SCOPE2X)\r
	@ApiLevel=4\r
	@ScriptName=Scope4x\r
	@Tip = %(T_49_META_TYP_133_I2_D)\r
    Sight4 = 1033 #%(T_46_META_WS_E_SCOPE4X)\r
	@ApiLevel=4\r
	@ScriptName=ThermalScope\r
	@Tip = %(T_49_META_TYP_133_I3_D)\r
    HeatSight = 1035 #%(T_46_META_WS_E_THERMALSCOPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootWeaponType\r
@Tip = %(T_49_META_TYPE_134_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum LootWeaponType : Int = 134 { #%(T_46_META_WS_C_LOOTWEAPONTYPE)\r
	@ApiLevel=4\r
	@ScriptName=LootWeaponRandom\r
	@Tip = %(T_49_META_TYP_134_I0_D)\r
    LootSightRandom = 1000 #%(T_46_META_WS_E_LOOTWEAPONRANDOM)\r
	@ApiLevel=4\r
	@ScriptName=AR\r
	@Tip = %(T_49_META_TYP_30_I78_D)\r
    AR = 1001 #%(T_46_META_WS_E_AR)\r
	@ApiLevel=4\r
	@ScriptName=SMG\r
	@Tip = %(T_49_META_TYP_30_I81_D)\r
    SMG = 1002 #%(T_46_META_WS_E_SMG)\r
	@ApiLevel=4\r
	@ScriptName=SR\r
	@Tip = %(T_49_META_TYP_30_I79_D)\r
    SR = 1003 #%(T_46_META_WS_E_SR)\r
	@ApiLevel=4\r
	@ScriptName=Pistol\r
	@Tip = %(T_49_META_TYP_30_I77_D)\r
    Pistol = 1004 #%(T_46_META_WS_E_PISTOL)\r
	@ApiLevel=4\r
	@ScriptName=SG\r
	@Tip = %(T_49_META_TYP_134_I5_D)\r
    SG = 1005 #%(T_46_META_WS_E_SG)\r
	@ApiLevel=4\r
	@ScriptName=Melee\r
	@Tip = %(T_49_META_TYP_30_I76_D)\r
    Melee = 1006 #%(T_46_META_WS_E_MELEE)\r
	@ApiLevel=4\r
	@ScriptName=CrossBow\r
	@Tip = %(T_49_META_TYPE_310_D)\r
    CrossBow = 1007 #%(T_46_META_WS_E_CROSSBOW)\r
	@ApiLevel=4\r
	@ScriptName=FootballShooter\r
	@Tip = %(T_49_META_TYP_134_I8_D)\r
    FootGun = 1041 #%(T_46_META_WS_E_FOOTBALLSHOOTER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MoneyType\r
@Tip = %(T_49_META_TYPE_88_D)\r
@ModuleID=20\r
@ModuleLib=Economy\r
enum MoneyType : Int = 88 { #%(T_46_META_WS_C_MONEYTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Basic\r
	@Tip = %(T_49_META_TYP_88_I0_D)\r
    Basic = 1 #%(T_46_META_WS_E_BASIC)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Money\r
@Tip = %(T_49_META_TYPE_89_D)\r
@ModuleID=20\r
@ModuleLib=Economy\r
type Money : Entity = 89 { #%(T_46_META_WS_C_MONEY)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=Type\r
	@Tip = %(T_49_META_TYP_89_I0_D)\r
    Type : MoneyType = -89000 #%(T_46_META_WS_P_TYPE)\r
	@ApiLevel=4\r
	@ScriptName=Count\r
	@Tip = %(T_49_META_TYP_89_I1_D)\r
    Count : BigFloat = -89001 #%(T_46_META_WS_P_COUNT)\r
	@ApiLevel=4\r
	@ScriptName=Icon\r
	@Tip = %(T_49_META_TYP_89_I2_D)\r
    MoneyIcon : SpriteID = -89002 #%(T_46_META_WS_P_ICON)\r
	@ApiLevel=4\r
	@ScriptName=IconColor\r
	@Tip = %(T_49_META_TYP_89_I3_D)\r
    MoneyIconColor : Color = -89003 #%(T_46_META_WS_P_ICONCOLOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Wallet\r
@Tip = %(T_49_META_TYPE_90_D)\r
@ModuleID=20\r
@ModuleLib=Economy\r
type Wallet : Entity = 90 { #%(T_46_META_WS_C_WALLET)\r
	@ApiLevel=4\r
	@ScriptName=Moneys\r
	@Tip = %(T_49_META_TYP_90_I0_D)\r
    Content : ListT_Money = -90000 #%(T_46_META_WS_P_MONEYS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UnitSpawn\r
@Tip = %(T_49_META_TYPE_2509_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type EntityGenerator : LevelObject&SpawnableEntity&ResetableEntity = 2509 { #%(T_46_META_WS_C_UNITSPAWN)\r
	@ApiLevel=4\r
	@ScriptName=SpawnCountPerWave\r
	@Tip = %(T_49_META_TYP_2509_I0_D)\r
    CountEachBatch : Int = -2509000 #%(T_46_META_WS_P_SPAWNCOUNTPERWAVE)\r
	@ApiLevel=4\r
	@ScriptName=WaveCount\r
	@Tip = %(T_49_META_TYP_2509_I1_D)\r
    BatchCount : Int = -2509001 #%(T_46_META_WS_P_WAVECOUNT)\r
	@ApiLevel=4\r
	@ScriptName=CurrentWave\r
	@Tip = %(T_49_META_TYP_2509_I2_D)\r
    CurBatch : Int = -2509002 #%(T_46_META_WS_P_CURRENTWAVE)\r
	@ApiLevel=10\r
	@ScriptName=WaveInterval_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    BatchInterval : Int = -2509003 #%(T_33_LO_WS_ZBPARA_INTERVAL)\r
	@ApiLevel=4\r
	@ScriptName=TemplateEntity\r
	@Tip = %(T_49_META_TYP_2509_I4_D)\r
    LogicEntity : Entity = -2509004 #%(T_46_META_WS_P_TEMPLATEENTITY)\r
	@ApiLevel=4\r
	@ScriptName=StartSpawnTime\r
	@Tip = %(T_49_META_TYP_2509_I5_D)\r
    StartGenTime : Float = -2509005 #%(T_46_META_WS_P_STARTSPAWNTIME)\r
	@ApiLevel=4\r
	@ScriptName=IsContinuous\r
	@Tip = %(T_49_META_TYP_2509_I6_D)\r
    IsContinuous : Bool = -2509006 #%(T_46_META_WS_P_ISCONTINUOUS)\r
	@ApiLevel=4\r
	@ScriptName=WaveInterval\r
	@Tip = %(T_49_META_TYP_2509_I7_D)\r
    BatchIntervalFloat : Float = -2509007 #%(T_46_META_WS_P_WAVEINTERVAL)\r
	@ApiLevel=3\r
	@ScriptName=TemplatePrefabID\r
	@Tip = %(T_49_META_TYP_2509_I8_D)\r
    TemplatePrefabID : PrefabID = -2509008 #%(T_41_XXJ_WS_TEMPLATEPREFABID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DynamicCreateLevelObjectType\r
@Tip = %(T_49_META_TYPE_92_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum DynamicCreateItemID : LevelObjectID = 92 { #%(T_46_META_WS_C_DYNAMICCREATELEVELOBJECTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=SquareBox\r
	@Tip = %(T_49_META_TYP_92_I0_D)\r
    Item1 = 1 #%(T_46_META_WS_E_SQUAREBOX)\r
	@ApiLevel=4\r
	@ScriptName=LongBox\r
	@Tip = %(T_49_META_TYP_92_I1_D)\r
    Item2 = 2 #%(T_46_META_WS_E_LONGBOX)\r
	@ApiLevel=4\r
	@ScriptName=Shrub\r
	@Tip = %(T_49_META_TYP_92_I2_D)\r
    Item3 = 3 #%(T_46_META_WS_E_SHRUB)\r
	@ApiLevel=4\r
	@ScriptName=Haystack\r
	@Tip = %(T_49_META_TYP_92_I3_D)\r
    Item4 = 4 #%(T_46_META_WS_E_HAYSTACK)\r
	@ApiLevel=4\r
	@ScriptName=WreckedCar\r
	@Tip = %(T_49_META_TYP_92_I4_D)\r
    Item5 = 5 #%(T_46_META_WS_E_WRECKEDCAR)\r
	@ApiLevel=4\r
	@ScriptName=WreckedBus\r
	@Tip = %(T_49_META_TYP_92_I5_D)\r
    Item6 = 6 #%(T_46_META_WS_E_WRECKEDBUS)\r
	@ApiLevel=4\r
	@ScriptName=ContainerA\r
	@Tip = %(T_49_META_TYP_92_I6_D)\r
    Item7 = 7 #%(T_46_META_WS_E_CONTAINERA)\r
	@ApiLevel=4\r
	@ScriptName=ContainerB\r
	@Tip = %(T_49_META_TYP_92_I7_D)\r
    Item8 = 8 #%(T_46_META_WS_E_CONTAINERB)\r
	@ApiLevel=4\r
	@ScriptName=ContainerC\r
	@Tip = %(T_49_META_TYP_92_I8_D)\r
    Item9 = 9 #%(T_46_META_WS_E_CONTAINERC)\r
	@ApiLevel=4\r
	@ScriptName=Hut\r
	@Tip = %(T_49_META_TYP_92_I9_D)\r
    Item10 = 10 #%(T_46_META_WS_E_HUT)\r
	@ApiLevel=4\r
	@ScriptName=GuardTower\r
	@Tip = %(T_49_META_TYP_92_I10_D)\r
    Item11 = 11 #%(T_46_META_WS_E_GUARDTOWER)\r
	@ApiLevel=4\r
	@ScriptName=Outpost\r
	@Tip = %(T_49_META_TYP_92_I11_D)\r
    Item12 = 12 #%(T_46_META_WS_E_OUTPOST)\r
	@ApiLevel=4\r
	@ScriptName=HouseB\r
	@Tip = %(T_49_META_TYP_92_I12_D)\r
    Item14 = 14 #%(T_46_META_WS_E_HOUSEB)\r
	@ApiLevel=4\r
	@ScriptName=SandStructure\r
	@Tip = %(T_49_META_TYP_92_I13_D)\r
    Item16 = 16 #%(T_46_META_WS_E_SANDSTRUCTURE)\r
	@ApiLevel=4\r
	@ScriptName=Fountain\r
	@Tip = %(T_49_META_TYP_92_I14_D)\r
    Item17 = 17 #%(T_46_META_WS_E_FOUNTAIN)\r
	@ApiLevel=4\r
	@ScriptName=CherryBlossom\r
	@Tip = %(T_49_META_TYP_92_I15_D)\r
    Item18 = 18 #%(T_46_META_WS_E_CHERRYBLOSSOM)\r
	@ApiLevel=4\r
	@ScriptName=HouseA\r
	@Tip = %(T_49_META_TYP_92_I16_D)\r
    Item19 = 19 #%(T_46_META_WS_E_HOUSEA)\r
	@ApiLevel=4\r
	@ScriptName=HouseC\r
	@Tip = %(T_49_META_TYP_92_I17_D)\r
    Item20 = 20 #%(T_46_META_WS_E_HOUSEC)\r
	@ApiLevel=4\r
	@ScriptName=BananaTree\r
	@Tip = %(T_49_META_TYP_92_I18_D)\r
    Item21 = 21 #%(T_46_META_WS_E_BANANATREE)\r
	@ApiLevel=4\r
	@ScriptName=ToiletBowl\r
	@Tip = %(T_49_META_TYP_92_I19_D)\r
    Item22 = 22 #%(T_46_META_WS_E_TOILETBOWL)\r
	@ApiLevel=4\r
	@ScriptName=Fence\r
	@Tip = %(T_49_META_TYP_92_I20_D)\r
    Item23 = 23 #%(T_46_META_WS_E_FENCE)\r
	@ApiLevel=4\r
	@ScriptName=BreakableContainer\r
	@Tip = %(T_49_META_TYP_92_I21_D)\r
    DestructibleContainer = 24 #%(T_46_META_WS_E_BREAKABLECONTAINER)\r
	@ApiLevel=4\r
	@ScriptName=BreakableFence\r
	@Tip = %(T_49_META_TYP_92_I22_D)\r
    DestructibleFence = 25 #%(T_46_META_WS_E_BREAKABLEFENCE)\r
	@ApiLevel=4\r
	@ScriptName=BounceTire\r
	@Tip = %(T_49_META_TYP_92_I23_D)\r
    BounceTire = 28 #%(T_46_META_WS_E_BOUNCETIRE)\r
	@ApiLevel=4\r
	@ScriptName=Bumpercar\r
	@Tip = %(T_49_META_TYP_92_I24_D)\r
    Item32 = 32 #%(T_46_META_WS_E_BUMPERCAR)\r
	@ApiLevel=4\r
	@ScriptName=AmphibianCar\r
	@Tip = %(T_49_META_TYP_92_I25_D)\r
    Item33 = 33 #%(T_46_META_WS_E_AMPHIBIANCAR)\r
	@ApiLevel=4\r
	@ScriptName=Jeep\r
	@Tip = %(T_49_META_TYP_92_I26_D)\r
    Item34 = 34 #%(T_46_META_WS_E_JEEP)\r
	@ApiLevel=4\r
	@ScriptName=Trashcan\r
	@Tip = %(T_49_META_TYP_92_I27_D)\r
    Item35 = 35 #%(T_46_META_WS_E_TRASHCAN)\r
	@ApiLevel=4\r
	@ScriptName=MedicalTent\r
	@Tip = %(T_49_META_TYP_92_I28_D)\r
    Item37 = 37 #%(T_46_META_WS_E_MEDICALTENT)\r
	@ApiLevel=4\r
	@ScriptName=Garage\r
	@Tip = %(T_49_META_TYP_92_I29_D)\r
    Item38 = 38 #%(T_46_META_WS_E_GARAGE)\r
	@ApiLevel=4\r
	@ScriptName=PaintedWalls\r
	@Tip = %(T_49_META_TYP_92_I30_D)\r
    Item39 = 39 #%(T_46_META_WS_E_PAINTEDWALLS)\r
	@ApiLevel=4\r
	@ScriptName=Torii\r
	@Tip = %(T_49_META_TYP_92_I31_D)\r
    Item40 = 40 #%(T_46_META_WS_E_TORII)\r
	@ApiLevel=4\r
	@ScriptName=IronPlatform\r
	@Tip = %(T_49_META_TYP_92_I32_D)\r
    Item41 = 41 #%(T_46_META_WS_E_IRONPLATFORM)\r
	@ApiLevel=4\r
	@ScriptName=SiteHut\r
	@Tip = %(T_49_META_TYP_92_I33_D)\r
    Item42 = 42 #%(T_46_META_WS_E_SITEHUT)\r
	@ApiLevel=4\r
	@ScriptName=Trailer\r
	@Tip = %(T_49_META_TYP_92_I34_D)\r
    Item43 = 43 #%(T_46_META_WS_E_TRAILER)\r
	@ApiLevel=4\r
	@ScriptName=WallA\r
	@Tip = %(T_49_META_TYP_92_I35_D)\r
    Item44 = 44 #%(T_46_META_WS_E_WALLA)\r
	@ApiLevel=4\r
	@ScriptName=PianoKey1\r
	@Tip = %(T_49_META_TYP_92_I36_D)\r
    Item51 = 51 #%(T_46_META_WS_E_PIANOKEY1)\r
	@ApiLevel=4\r
	@ScriptName=PianoKey2\r
	@Tip = %(T_49_META_TYP_92_I37_D)\r
    Item52 = 52 #%(T_46_META_WS_E_PIANOKEY2)\r
	@ApiLevel=4\r
	@ScriptName=DrumKey1\r
	@Tip = %(T_49_META_TYP_92_I38_D)\r
    Item53 = 53 #%(T_46_META_WS_E_DRUMKEY1)\r
	@ApiLevel=4\r
	@ScriptName=DrumKey2\r
	@Tip = %(T_49_META_TYP_92_I39_D)\r
    Item54 = 54 #%(T_46_META_WS_E_DRUMKEY2)\r
	@ApiLevel=4\r
	@ScriptName=ComboKeyA1\r
	@Tip = %(T_49_META_TYP_92_I40_D)\r
    Item55 = 55 #%(T_46_META_WS_E_COMBOKEYA1)\r
	@ApiLevel=4\r
	@ScriptName=ComboKeyA2\r
	@Tip = %(T_49_META_TYP_92_I41_D)\r
    Item56 = 56 #%(T_46_META_WS_E_COMBOKEYA2)\r
	@ApiLevel=4\r
	@ScriptName=ComboKeyB1\r
	@Tip = %(T_49_META_TYP_92_I42_D)\r
    Item57 = 57 #%(T_46_META_WS_E_COMBOKEYB1)\r
	@ApiLevel=4\r
	@ScriptName=ComboKeyB2\r
	@Tip = %(T_49_META_TYP_92_I43_D)\r
    Item58 = 58 #%(T_46_META_WS_E_COMBOKEYB2)\r
	@ApiLevel=4\r
	@ScriptName=ComboKeyC1\r
	@Tip = %(T_49_META_TYP_92_I44_D)\r
    Item59 = 59 #%(T_46_META_WS_E_COMBOKEYC1)\r
	@ApiLevel=4\r
	@ScriptName=ComboKeyC2\r
	@Tip = %(T_49_META_TYP_92_I45_D)\r
    Item60 = 60 #%(T_46_META_WS_E_COMBOKEYC2)\r
	@ApiLevel=4\r
	@ScriptName=BuffGenerator\r
	@Tip = %(T_49_META_TYP_92_I46_D)\r
    Item61 = 61 #%(T_46_META_WS_E_BUFFGENERATOR)\r
	@ApiLevel=4\r
	@ScriptName=Fan\r
	@Tip = %(T_49_META_TYP_92_I47_D)\r
    Item62 = 62 #%(T_46_META_WS_E_FAN)\r
	@ApiLevel=4\r
	@ScriptName=FlyPan\r
	@Tip = %(T_49_META_TYP_92_I48_D)\r
    Item63 = 63 #%(T_46_META_WS_E_FLYPAN)\r
	@ApiLevel=4\r
	@ScriptName=Cube\r
	@Tip = %(T_49_META_TYP_92_I49_D)\r
    Item64 = 64 #%(T_46_META_WS_E_CUBE)\r
	@ApiLevel=4\r
	@ScriptName=Ring\r
	@Tip = %(T_49_META_TYP_92_I50_D)\r
    Item65 = 65 #%(T_46_META_WS_E_RING)\r
	@ApiLevel=4\r
	@ScriptName=Hammer\r
	@Tip = %(T_49_META_TYP_92_I51_D)\r
    Item66 = 66 #%(T_46_META_WS_E_HAMMER)\r
	@ApiLevel=4\r
	@ScriptName=Board\r
	@Tip = %(T_49_META_TYP_92_I52_D)\r
    Item67 = 67 #%(T_46_META_WS_E_BOARD)\r
	@ApiLevel=4\r
	@ScriptName=ShootingTarget\r
	@Tip = %(T_49_META_TYP_92_I53_D)\r
    Item68 = 68 #%(T_46_META_WS_E_SHOOTINGTARGET)\r
	@ApiLevel=4\r
	@ScriptName=FlexWall\r
	@Tip = %(T_49_META_TYP_92_I54_D)\r
    Item69 = 69 #%(T_46_META_WS_E_FLEXWALL)\r
	@ApiLevel=4\r
	@ScriptName=LootItemBox\r
	@Tip = %(T_49_META_TYP_92_I55_D)\r
    Item70 = 70 #%(T_46_META_WS_E_LOOTITEMBOX)\r
	@ApiLevel=4\r
	@ScriptName=LootItemBoxAmmo\r
	@Tip = %(T_49_META_TYP_92_I56_D)\r
    Item71 = 71 #%(T_46_META_WS_E_LOOTITEMBOXAMMO)\r
	@ApiLevel=4\r
	@ScriptName=LootItemBoxConsumableItem\r
	@Tip = %(T_49_META_TYP_92_I57_D)\r
    Item72 = 72 #%(T_46_META_WS_E_LOOTITEMBOXCONSUMABLEITEM)\r
	@ApiLevel=4\r
	@ScriptName=LootItemBoxProjectile\r
	@Tip = %(T_49_META_TYP_92_I58_D)\r
    Item73 = 73 #%(T_46_META_WS_E_LOOTITEMBOXPROJECTILE)\r
	@ApiLevel=4\r
	@ScriptName=LootItemBoxSight\r
	@Tip = %(T_49_META_TYP_92_I59_D)\r
    Item74 = 74 #%(T_46_META_WS_E_LOOTITEMBOXSIGHT)\r
	@ApiLevel=4\r
	@ScriptName=LootItemBoxArmor\r
	@Tip = %(T_49_META_TYP_92_I60_D)\r
    Item75 = 75 #%(T_46_META_WS_E_LOOTITEMBOXARMOR)\r
	@ApiLevel=4\r
	@ScriptName=IPipe\r
	@Tip = %(T_49_META_TYP_92_I61_D)\r
    Item76 = 76 #%(T_46_META_WS_E_IPIPE)\r
	@ApiLevel=4\r
	@ScriptName=TPipe\r
	@Tip = %(T_49_META_TYP_92_I62_D)\r
    Item77 = 77 #%(T_46_META_WS_E_TPIPE)\r
	@ApiLevel=4\r
	@ScriptName=PipeIntersection\r
	@Tip = %(T_49_META_TYP_92_I63_D)\r
    Item78 = 78 #%(T_46_META_WS_E_PIPEINTERSECTION)\r
	@ApiLevel=4\r
	@ScriptName=PipeCorner\r
	@Tip = %(T_49_META_TYP_92_I64_D)\r
    Item79 = 79 #%(T_46_META_WS_E_PIPECORNER)\r
	@ApiLevel=4\r
	@ScriptName=MushShade\r
	@Tip = %(T_49_META_TYP_92_I65_D)\r
    Item80 = 80 #%(T_46_META_WS_E_MUSHSHADE)\r
	@ApiLevel=4\r
	@ScriptName=Hanger\r
	@Tip = %(T_49_META_TYP_92_I66_D)\r
    Item81 = 81 #%(T_46_META_WS_E_HANGER)\r
	@ApiLevel=4\r
	@ScriptName=WoodenPlank\r
	@Tip = %(T_49_META_TYP_92_I67_D)\r
    Item82 = 82 #%(T_46_META_WS_E_WOODENPLANK)\r
	@ApiLevel=4\r
	@ScriptName=LatticeScreen\r
	@Tip = %(T_49_META_TYP_92_I68_D)\r
    Item83 = 83 #%(T_46_META_WS_E_LATTICESCREEN)\r
	@ApiLevel=4\r
	@ScriptName=Pillar\r
	@Tip = %(T_49_META_TYP_92_I69_D)\r
    Item84 = 84 #%(T_46_META_WS_E_PILLAR)\r
	@ApiLevel=4\r
	@ScriptName=Cactus\r
	@Tip = %(T_49_META_TYP_92_I70_D)\r
    Item85 = 85 #%(T_46_META_WS_E_CACTUS)\r
	@ApiLevel=4\r
	@ScriptName=LeaflessTree\r
	@Tip = %(T_49_META_TYP_92_I71_D)\r
    Item86 = 86 #%(T_46_META_WS_E_LEAFLESSTREE)\r
	@ApiLevel=4\r
	@ScriptName=StoneLantern\r
	@Tip = %(T_49_META_TYP_92_I72_D)\r
    Item87 = 87 #%(T_46_META_WS_E_STONELANTERN)\r
	@ApiLevel=4\r
	@ScriptName=Streetlamp\r
	@Tip = %(T_49_META_TYP_92_I73_D)\r
    Item88 = 88 #%(T_46_META_WS_E_STREETLAMP)\r
	@ApiLevel=4\r
	@ScriptName=SolarPanel\r
	@Tip = %(T_49_META_TYP_92_I74_D)\r
    Item89 = 89 #%(T_46_META_WS_E_SOLARPANEL)\r
	@ApiLevel=4\r
	@ScriptName=AirConditionerA\r
	@Tip = %(T_49_META_TYP_92_I75_D)\r
    Item90 = 90 #%(T_46_META_WS_E_AIRCONDITIONERA)\r
	@ApiLevel=4\r
	@ScriptName=Block\r
	@Tip = %(T_49_META_TYP_92_I76_D)\r
    Item91 = 91 #%(T_46_META_WS_E_BLOCK)\r
	@ApiLevel=4\r
	@ScriptName=Slope\r
	@Tip = %(T_49_META_TYP_92_I77_D)\r
    Item92 = 92 #%(T_46_META_WS_E_SLOPE)\r
	@ApiLevel=4\r
	@ScriptName=FoodTruck\r
	@Tip = %(T_49_META_TYP_92_I78_D)\r
    Item95 = 95 #%(T_46_META_WS_E_FOODTRUCK)\r
	@ApiLevel=4\r
	@ScriptName=StatusTrigger\r
	@Tip = %(T_49_META_TYP_92_I79_D)\r
    Item96 = 96 #%(T_46_META_WS_E_STATUSTRIGGER)\r
	@ApiLevel=4\r
	@ScriptName=CheckPoint\r
	@Tip = %(T_49_META_TYP_92_I80_D)\r
    Item97 = 97 #%(T_46_META_WS_E_CHECKPOINT)\r
	@ApiLevel=4\r
	@ScriptName=FinishingPoint\r
	@Tip = %(T_49_META_TYP_92_I81_D)\r
    Item98 = 98 #%(T_46_META_WS_E_FINISHINGPOINT)\r
	@ApiLevel=4\r
	@ScriptName=GiantDice\r
	@Tip = %(T_49_META_TYP_92_I82_D)\r
    Item99 = 99 #%(T_46_META_WS_E_GIANTDICE)\r
	@ApiLevel=4\r
	@ScriptName=Bench\r
	@Tip = %(T_49_META_TYP_92_I83_D)\r
    Item100 = 100 #%(T_46_META_WS_E_BENCH)\r
	@ApiLevel=4\r
	@ScriptName=BusStop\r
	@Tip = %(T_49_META_TYP_92_I84_D)\r
    Item101 = 101 #%(T_46_META_WS_E_BUSSTOP)\r
	@ApiLevel=4\r
	@ScriptName=DogHouse\r
	@Tip = %(T_49_META_TYP_92_I85_D)\r
    Item102 = 102 #%(T_46_META_WS_E_DOGHOUSE)\r
	@ApiLevel=4\r
	@ScriptName=AdBoard\r
	@Tip = %(T_49_META_TYP_92_I86_D)\r
    Item103 = 103 #%(T_46_META_WS_E_ADBOARD)\r
	@ApiLevel=4\r
	@ScriptName=RefineryTank\r
	@Tip = %(T_49_META_TYP_92_I87_D)\r
    Item104 = 104 #%(T_46_META_WS_E_REFINERYTANK)\r
	@ApiLevel=4\r
	@ScriptName=GraffitiWall\r
	@Tip = %(T_49_META_TYP_92_I88_D)\r
    Item105 = 105 #%(T_46_META_WS_E_GRAFFITIWALL)\r
	@ApiLevel=4\r
	@ScriptName=Stable\r
	@Tip = %(T_49_META_TYP_92_I89_D)\r
    Item106 = 106 #%(T_46_META_WS_E_STABLE)\r
	@ApiLevel=4\r
	@ScriptName=StoneBridge\r
	@Tip = %(T_49_META_TYP_92_I90_D)\r
    Item107 = 107 #%(T_46_META_WS_E_STONEBRIDGE)\r
	@ApiLevel=4\r
	@ScriptName=SunShade\r
	@Tip = %(T_49_META_TYP_92_I91_D)\r
    Item108 = 108 #%(T_46_META_WS_E_SUNSHADE)\r
	@ApiLevel=4\r
	@ScriptName=FinishLineArch\r
	@Tip = %(T_49_META_TYP_92_I92_D)\r
    Item109 = 109 #%(T_46_META_WS_E_FINISHLINEARCH)\r
	@ApiLevel=4\r
	@ScriptName=Tower\r
	@Tip = %(T_49_META_TYP_92_I93_D)\r
    Item110 = 110 #%(T_46_META_WS_E_TOWER)\r
	@ApiLevel=4\r
	@ScriptName=MonsterSpawn\r
	@Tip = %(T_49_META_TYP_92_I94_D)\r
    Item111 = 111 #%(T_46_META_WS_E_MONSTERSPAWN)\r
	@ApiLevel=4\r
	@ScriptName=Marker\r
	@Tip = %(T_49_META_TYP_92_I95_D)\r
    Item113 = 113 #%(T_46_META_WS_E_MARKER)\r
	@ApiLevel=4\r
	@ScriptName=MiniSentry\r
	@Tip = %(T_49_META_TYPE_2507_D)\r
    Item114 = 114 #%(T_46_META_WS_E_MINISENTRY)\r
	@ApiLevel=4\r
	@ScriptName=CustomTrigger\r
	@Tip = %(T_49_META_TYP_92_I97_D)\r
    CustomTrigger = 117 #%(T_46_META_WS_E_CUSTOMTRIGGER)\r
	@ApiLevel=4\r
	@ScriptName=DoubleDoor\r
	@Tip = %(T_49_META_TYP_92_I98_D)\r
    Item118 = 118 #%(T_46_META_WS_E_DOUBLEDOOR)\r
	@ApiLevel=4\r
	@ScriptName=Roadblock\r
	@Tip = %(T_49_META_TYP_92_I99_D)\r
    Item119 = 119 #%(T_46_META_WS_E_ROADBLOCK)\r
	@ApiLevel=4\r
	@ScriptName=Stairs\r
	@Tip = %(T_49_META_TYP_92_I100_D)\r
    Item120 = 120 #%(T_46_META_WS_E_STAIRS)\r
	@ApiLevel=4\r
	@ScriptName=LandingB\r
	@Tip = %(T_49_META_TYP_92_I101_D)\r
    Item121 = 121 #%(T_46_META_WS_E_LANDINGB)\r
	@ApiLevel=4\r
	@ScriptName=LandingA\r
	@Tip = %(T_49_META_TYP_92_I102_D)\r
    Item122 = 122 #%(T_46_META_WS_E_LANDINGA)\r
	@ApiLevel=4\r
	@ScriptName=PhoneBooth\r
	@Tip = %(T_49_META_TYP_92_I103_D)\r
    Item123 = 123 #%(T_46_META_WS_E_PHONEBOOTH)\r
	@ApiLevel=4\r
	@ScriptName=BISGraffitiWall\r
	@Tip = %(T_49_META_TYP_92_I104_D)\r
    Item124 = 124 #%(T_46_META_WS_E_BISGRAFFITIWALL)\r
	@ApiLevel=4\r
	@ScriptName=GraffitiFlowerbed\r
	@Tip = %(T_49_META_TYP_92_I105_D)\r
    Item125 = 125 #%(T_46_META_WS_E_GRAFFITIFLOWERBED)\r
	@ApiLevel=4\r
	@ScriptName=VendingMachine\r
	@Tip = %(T_49_META_TYP_92_I106_D)\r
    VendingMachine = 126 #%(T_46_META_WS_E_VENDINGMACHINE)\r
	@ApiLevel=4\r
	@ScriptName=Monster\r
	@Tip = %(T_49_META_TYP_92_I107_D)\r
    Item127 = 127 #%(T_46_META_WS_E_MONSTER)\r
	@ApiLevel=4\r
	@ScriptName=UnitGenerator\r
	@Tip = %(T_49_META_TYP_92_I108_D)\r
    Item128 = 128 #%(T_46_META_WS_E_UNITGENERATOR)\r
	@ApiLevel=4\r
	@ScriptName=SuperCar\r
	@Tip = %(T_49_META_TYP_92_I109_D)\r
    Item129 = 129 #%(T_46_META_WS_E_SUPERCAR)\r
	@ApiLevel=4\r
	@ScriptName=TuTuCar\r
	@Tip = %(T_49_META_TYP_92_I110_D)\r
    Item130 = 130 #%(T_46_META_WS_E_TUTUCAR)\r
	@ApiLevel=4\r
	@ScriptName=BreakableBox\r
	@Tip = %(T_49_META_TYP_92_I111_D)\r
    DestructibleBox = 131 #%(T_46_META_WS_E_BREAKABLEBOX)\r
	@ApiLevel=4\r
	@ScriptName=PickUpTruck\r
	@Tip = %(T_49_META_TYP_92_I112_D)\r
    Item132 = 132 #%(T_46_META_WS_E_PICKUPTRUCK)\r
	@ApiLevel=4\r
	@ScriptName=Motobike\r
	@Tip = %(T_49_META_TYP_92_I113_D)\r
    Item133 = 133 #%(T_46_META_WS_E_MOTOBIKE)\r
	@ApiLevel=4\r
	@ScriptName=MonsterTruck\r
	@Tip = %(T_49_META_TYP_92_I114_D)\r
    Item134 = 134 #%(T_46_META_WS_E_MONSTERTRUCK)\r
	@ApiLevel=4\r
	@ScriptName=CoinGenerator\r
	@Tip = %(T_49_META_TYP_92_I115_D)\r
    CoinGenerator = 135 #%(T_46_META_WS_E_COINGENERATOR)\r
	@ApiLevel=4\r
	@ScriptName=LandingC\r
	@Tip = %(T_49_META_TYP_92_I116_D)\r
    Item136 = 136 #%(T_46_META_WS_E_LANDINGC)\r
	@ApiLevel=4\r
	@ScriptName=DirectionSign\r
	@Tip = %(T_49_META_TYP_92_I117_D)\r
    Item137 = 137 #%(T_46_META_WS_E_DIRECTIONSIGN)\r
	@ApiLevel=4\r
	@ScriptName=IronFence\r
	@Tip = %(T_49_META_TYP_92_I118_D)\r
    Item138 = 138 #%(T_46_META_WS_E_IRONFENCE)\r
	@ApiLevel=4\r
	@ScriptName=JerseyMachine\r
	@Tip = %(T_49_META_TYP_92_I119_D)\r
    Wardrobe = 139 #%(T_46_META_WS_E_JERSEYMACHINE)\r
	@ApiLevel=4\r
	@ScriptName=Football\r
	@Tip = %(T_49_META_TYPE_99_D)\r
    Item140 = 140 #%(T_46_META_WS_E_FOOTBALL)\r
	@ApiLevel=4\r
	@ScriptName=ConcretePillar\r
	@Tip = %(T_49_META_TYP_92_I121_D)\r
    Item141 = 141 #%(T_46_META_WS_E_CONCRETEPILLAR)\r
	@ApiLevel=4\r
	@ScriptName=LootItemBoxSoccer\r
	@Tip = %(T_49_META_TYP_92_I122_D)\r
    Item184 = 184 #%(T_46_META_WS_E_LOOTITEMBOXSOCCER)\r
	@ApiLevel=4\r
	@ScriptName=JerryCan\r
	@Tip = %(T_49_META_TYP_92_I123_D)\r
    Item187 = 187 #%(T_46_META_WS_E_JERRYCAN)\r
	@ApiLevel=4\r
	@ScriptName=AbnormalGravZone\r
	@Tip = %(T_49_META_TYP_92_I124_D)\r
    Item188 = 188 #%(T_46_META_WS_E_ABNORMALGRAVZONE)\r
	@ApiLevel=4\r
	@ScriptName=WeaponGenerator\r
	@Tip = %(T_49_META_TYP_92_I125_D)\r
    Item189 = 189 #%(T_46_META_WS_E_WEAPONGENERATOR)\r
	@ApiLevel=4\r
	@ScriptName=IronFenceB\r
	@Tip = %(T_49_META_TYP_92_I126_D)\r
    Item191 = 191 #%(T_46_META_WS_E_IRONFENCEB)\r
	@ApiLevel=4\r
	@ScriptName=BrickHouseA\r
	@Tip = %(T_49_META_TYP_92_I127_D)\r
    Item192 = 192 #%(T_46_META_WS_E_BRICKHOUSEA)\r
	@ApiLevel=4\r
	@ScriptName=DamagedTruck\r
	@Tip = %(T_49_META_TYP_92_I128_D)\r
    Item193 = 193 #%(T_46_META_WS_E_DAMAGEDTRUCK)\r
	@ApiLevel=4\r
	@ScriptName=BasicSphere\r
	@Tip = %(T_49_META_TYP_92_I129_D)\r
    Item176 = 209 #%(T_46_META_WS_E_BASICSPHERE)\r
	@ApiLevel=4\r
	@ScriptName=BasicCone\r
	@Tip = %(T_49_META_TYP_92_I130_D)\r
    Item211 = 211 #%(T_46_META_WS_E_BASICCONE)\r
	@ApiLevel=4\r
	@ScriptName=BasicCylinder\r
	@Tip = %(T_49_META_TYP_92_I131_D)\r
    Item212 = 212 #%(T_46_META_WS_E_BASICCYLINDER)\r
	@ApiLevel=4\r
	@ScriptName=Itementity\r
	@Tip = %(T_49_META_TYP_92_I132_D)\r
    Item213 = 213 #%(T_46_META_WS_E_ITEMENTITY)\r
	@ApiLevel=4\r
	@ScriptName=CustomWaterZone\r
	@Tip = %(T_49_META_TYP_92_I133_D)\r
    Item215 = 215 #%(T_46_META_WS_E_CUSTOMWATERZONE)\r
	@ApiLevel=4\r
	@ScriptName=Arrow\r
	@Tip = %(T_49_META_TYP_92_I134_D)\r
    Item218 = 218 #%(T_46_META_WS_E_ARROW)\r
	@ApiLevel=4\r
	@ScriptName=ColorBlock\r
	@Tip = %(T_49_META_TYP_92_I135_D)\r
    Item220 = 220 #%(T_46_META_WS_E_COLORBLOCK)\r
	@ApiLevel=3\r
	@ScriptName=ColorOilBarrel\r
	@Tip = %(T_49_META_TYP_92_I136_D)\r
    Item221 = 221 #%(T_46_META_WS_E_COLOROILBARREL)\r
	@ApiLevel=4\r
	@ScriptName=TextObject\r
	@Tip = %(T_49_META_TYP_92_I137_D)\r
    Item115 = 222 #%(T_46_META_WS_E_TEXTOBJECT)\r
	@ApiLevel=4\r
	@ScriptName=IconObject\r
	@Tip = %(T_49_META_TYP_92_I138_D)\r
    Item116 = 223 #%(T_46_META_WS_E_ICONOBJECT)\r
	@ApiLevel=4\r
	@ScriptName=BlueDoll\r
	@Tip = %(T_49_META_TYP_92_I139_D)\r
    Item225 = 225 #%(T_46_META_WS_E_BLUEDOLL)\r
	@ApiLevel=4\r
	@ScriptName=CapsuleTrigger\r
	@Tip = %(T_49_META_TYP_92_I140_D)\r
    Item237 = 237 #%(T_46_META_WS_E_CAPSULETRIGGER)\r
	@ApiLevel=4\r
	@ScriptName=SphereTrigger\r
	@Tip = %(T_49_META_TYP_92_I141_D)\r
    Item238 = 238 #%(T_46_META_WS_E_SPHERETRIGGER)\r
	@ApiLevel=3\r
	@ScriptName=ReflectiveCube\r
	@Tip = %(T_49_META_TYP_92_I142_D)\r
    Item239 = 239 #%(T_46_META_WS_E_REFLECTIVECUBE)\r
	@ApiLevel=3\r
	@ScriptName=BumperCarFactory\r
	@Tip = %(T_49_META_TYP_92_I143_D)\r
    Item240 = 240 #%(T_46_META_WS_E_BUMPERCARFACTORY)\r
	@ApiLevel=3\r
	@ScriptName=PlaidAmusementParkCube\r
	@Tip = %(T_49_META_TYP_92_I144_D)\r
    Item241 = 241 #%(T_46_META_WS_E_PLAIDAMUSEMENTPARKCUBE)\r
	@ApiLevel=3\r
	@ScriptName=Billboard\r
	@Tip = %(T_49_META_TYP_92_I145_D)\r
    Item253 = 253 #%(T_46_META_WS_E_BILLBOARD)\r
	@ApiLevel=3\r
	@ScriptName=Podium\r
	@Tip = %(T_49_META_TYP_92_I146_D)\r
    Item254 = 254 #%(T_46_META_WS_E_PODIUM)\r
	@ApiLevel=3\r
	@ScriptName=GiantLollipop\r
	@Tip = %(T_49_META_TYP_92_I147_D)\r
    Item255 = 255 #%(T_46_META_WS_E_GIANTLOLLIPOP)\r
	@ApiLevel=3\r
	@ScriptName=FoodTruckB\r
	@Tip = %(T_49_META_TYP_92_I148_D)\r
    Item256 = 256 #%(T_46_META_WS_E_FOODTRUCKB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PropertyModifyType\r
@Tip = %(T_49_META_TYPE_94_D)\r
@ModuleID=18\r
@ModuleLib=PropertyFormula\r
enum PropertyModifyType : Int = 94 { #%(T_46_META_WS_C_PROPERTYMODIFYTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Add\r
	@Tip = %(T_49_META_TYP_94_I0_D)\r
    Add = 1 #%(T_46_META_WS_E_ADD)\r
	@ApiLevel=4\r
	@ScriptName=Multiply\r
	@Tip = %(T_49_META_TYP_94_I1_D)\r
    Mul = 2 #%(T_46_META_WS_E_MULTIPLY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CoinGenerator\r
@Tip = %(T_49_META_TYPE_95_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type CoinGenerator : CustomizeTrigger = 95 { #%(T_46_META_WS_C_COINGENERATOR)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=MoneyType\r
	@Tip = %(T_49_META_TYP_95_I0_D)\r
    MoneyType : MoneyType = -95000 #%(T_46_META_WS_P_MONEYTYPE)\r
	@ApiLevel=4\r
	@Default=500\r
	@ScriptName=Count\r
	@Tip = %(T_49_META_TYP_95_I1_D)\r
    Count : Float = -95001 #%(T_46_META_WS_P_COUNT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WalletHud\r
@Tip = %(T_49_META_TYPE_96_D)\r
@ModuleID=20\r
@ModuleLib=Economy\r
type WalletHud : InternalHud = 96 { #%(T_46_META_WS_C_WALLETHUD)\r
	@ApiLevel=4\r
	@ScriptName=BoundWallet\r
	@Tip = %(T_49_META_TYP_96_I0_D)\r
    BindMoneyEntity : Money = -96000 #%(T_46_META_WS_P_BOUNDWALLET)\r
	@ApiLevel=4\r
	@Default=&math.Vector3(-32, -15, 0)\r
	@ScriptName=Offset\r
	@Tip = %(T_49_META_TYP_96_I1_D)\r
    Offset : Vector3 = -96001 #%(T_46_META_WS_P_OFFSET)\r
	@ApiLevel=4\r
	@Default=math.Vector3_1()\r
	@ScriptName=Scale\r
	@Tip = %(T_49_META_TYP_323_I0_D)\r
    Scale : Vector3 = -96002 #%(T_46_META_WS_P_SCALE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UITextTip\r
@Tip = %(T_49_META_TYPE_158_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TextTipsHud : InternalHud = 158 { #%(T_46_META_WS_C_UITEXTTIP)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -158000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=3\r
	@ScriptName=EnableLocalization\r
	@Tip = %(T_49_META_TYP_1012_I1_D)\r
    LocSwitch : Bool = -158001 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@Default=9\r
	@ScriptName=AnchorType\r
	@Tip = %(T_49_META_TYP_158_I2_D)\r
    EUIAnchor : Int = -158002 #%(T_46_META_WS_P_ANCHORTYPE)\r
	@ApiLevel=4\r
	@ScriptName=LocalPosition\r
	@Tip = %(T_49_META_TYP_1042_I1_D)\r
    LocalPosition : Vector3 = -158003 #%(T_46_META_WS_P_LOCALPOSITION)\r
	@ApiLevel=4\r
	@Default=24\r
	@ScriptName=FontSize\r
	@Tip = %(T_49_META_TYP_1042_I1_D)\r
    FontSize : Int = -158004 #%(T_46_META_WS_P_FONTSIZE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=FontColor\r
	@Tip = %(T_49_META_TYP_1043_I4_D)\r
    Color : Color = -158005 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@ScriptName=LabelKey\r
	@Tip = %(T_49_META_TYP_158_I6_D)\r
    LabelKey : String = -158006 #%(T_46_META_WS_P_LABELKEY)\r
	@ApiLevel=4\r
	@ScriptName=LabelParams\r
	@Tip = %(T_49_META_TYP_158_I7_D)\r
    LabelParams : List = -158007 #%(T_46_META_WS_P_LABELPARAMS)\r
	@ApiLevel=4\r
	@ScriptName=TweenerEnabled\r
	@Tip = %(T_49_META_TYP_158_I8_D)\r
    TweenerEnabled : Bool = -158008 #%(T_46_META_WS_P_TWEENERENABLED)\r
	@ApiLevel=4\r
	@ScriptName=Duration\r
	@Tip = %(T_49_META_TYP_1021_I2_D)\r
    Duration : Float = -158009 #%(T_46_META_WS_P_DURATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UITwoTeamScorePanel\r
@Tip = %(T_49_META_TYPE_190_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TwoTeamMatchResultHud : InternalHud = 190 { #%(T_46_META_WS_C_UITWOTEAMSCOREPANEL)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_190_I0_D)\r
    OpenState : Bool = -190000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=Result\r
	@Tip = %(T_49_META_TYP_190_I1_D)\r
    Result : MatchResultType = -190001 #%(T_46_META_WS_P_RESULT)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeamName\r
	@Tip = %(T_49_META_TYP_1017_I1_D)\r
    LeftTeamName : String = -190002 #%(T_46_META_WS_P_LEFTTEAMNAME)\r
	@ApiLevel=4\r
	@ScriptName=RightTeamName\r
	@Tip = %(T_49_META_TYP_1017_I3_D)\r
    RightTeamName : String = -190003 #%(T_46_META_WS_P_RIGHTTEAMNAME)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeam\r
	@Tip = %(T_49_META_TYP_190_I4_D)\r
    LeftTeam : Entity = -190004 #%(T_46_META_WS_P_LEFTTEAM)\r
	@ApiLevel=4\r
	@ScriptName=RightTeam\r
	@Tip = %(T_49_META_TYP_190_I5_D)\r
    RightTeam : Entity = -190005 #%(T_46_META_WS_P_RIGHTTEAM)\r
	@ApiLevel=4\r
	@ScriptName=Players\r
	@Tip = %(T_49_META_TYP_190_I6_D)\r
    PlayerList : ListT_Player = -190006 #%(T_46_META_WS_P_PLAYERS)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeamScore\r
	@Tip = %(T_49_META_TYP_1016_I3_D)\r
    LeftTeamScore : String = -190007 #%(T_46_META_WS_P_LEFTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=RightTeamScore\r
	@Tip = %(T_49_META_TYP_1016_I4_D)\r
    RightTeamScore : String = -190008 #%(T_46_META_WS_P_RIGHTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=Titles\r
	@Tip = %(T_49_META_TYP_190_I9_D)\r
    TitleList : ListT_LocString = -190009 #%(T_46_META_WS_P_TITLES)\r
	@ApiLevel=4\r
	@ScriptName=Scores1\r
	@Tip = %(T_49_META_TYP_190_I10_D)\r
    ScoreList1 : ListT_Object = -190010 #%(T_46_META_WS_P_SCORES1)\r
	@ApiLevel=4\r
	@ScriptName=Scores2\r
	@Tip = %(T_49_META_TYP_190_I11_D)\r
    ScoreList2 : ListT_Object = -190011 #%(T_46_META_WS_P_SCORES2)\r
	@ApiLevel=4\r
	@ScriptName=Scores3\r
	@Tip = %(T_49_META_TYP_190_I12_D)\r
    ScoreList3 : ListT_Object = -190012 #%(T_46_META_WS_P_SCORES3)\r
	@ApiLevel=4\r
	@ScriptName=WinMVPs\r
	@Tip = %(T_49_META_TYP_190_I13_D)\r
    WinMVPList : ListT_Player = -190013 #%(T_46_META_WS_P_WINMVPS)\r
	@ApiLevel=4\r
	@ScriptName=LoseMVPs\r
	@Tip = %(T_49_META_TYP_190_I14_D)\r
    LoseMVPList : ListT_Player = -190014 #%(T_46_META_WS_P_LOSEMVPS)\r
	@ApiLevel=10\r
	@Default=true\r
	@ScriptName=ShowMatchDetail\r
	@Tip = %(T_49_META_TYP_190_I15_D)\r
    ShowMatchDetail : Bool = -190015 #%(T_46_META_WS_P_SHOWMATCHDETAIL)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ShowMapEvaluate\r
	@Tip = %(T_49_META_TYP_190_I16_D)\r
    ShowMapEvaluate : Bool = -190016 #%(T_46_META_WS_P_SHOWMAPEVALUATE)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ShowGift\r
	@Tip = %(T_49_META_TYP_190_I17_D)\r
    ShowGift : Bool = -190017 #%(T_46_META_WS_P_SHOWGIFT)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ShowReport\r
	@Tip = %(T_49_META_TYP_190_I18_D)\r
    ShowReport : Bool = -190018 #%(T_46_META_WS_P_SHOWREPORT)\r
	@ApiLevel=3\r
	@Default=false\r
	@ScriptName=ShowReplay\r
	@Tip = %(T_49_META_TYP_190_I19_D)\r
    ShowReplay : Bool = -190019 #%(T_46_META_WS_P_SHOWREPLAY)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ShowShare\r
	@Tip = %(T_49_META_TYP_190_I20_D)\r
    ShowShare : Bool = -190020 #%(T_46_META_WS_P_SHOWSHARE)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ShowLobby\r
	@Tip = %(T_49_META_TYP_190_I21_D)\r
    ShowLobby : Bool = -190021 #%(T_46_META_WS_P_SHOWLOBBY)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ShowLike\r
	@Tip = %(T_49_META_TYP_190_I22_D)\r
    ShowLike : Bool = -190022 #%(T_46_META_WS_P_SHOWLIKE)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ShowAddFriend\r
	@Tip = %(T_49_META_TYP_190_I23_D)\r
    ShowFriend : Bool = -190023 #%(T_46_META_WS_P_SHOWADDFRIEND)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIMultiTeamResultPanel\r
@Tip = %(T_49_META_TYPE_193_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type MultiTeamMatchResultHud : InternalHud = 193 { #%(T_46_META_WS_C_UIMULTITEAMRESULTPANEL)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -193000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=MatchTitleLeft\r
	@Tip = %(T_49_META_TYP_193_I1_D)\r
    MatchTitle1 : String = -193001 #%(T_46_META_WS_P_MATCHTITLELEFT)\r
	@ApiLevel=4\r
	@ScriptName=MatchTitleRight\r
	@Tip = %(T_49_META_TYP_193_I2_D)\r
    MatchTitle2 : String = -193002 #%(T_46_META_WS_P_MATCHTITLERIGHT)\r
	@ApiLevel=4\r
	@ScriptName=Result\r
	@Tip = %(T_49_META_TYP_193_I3_D)\r
    Result : MatchResultType = -193003 #%(T_46_META_WS_P_RESULT)\r
	@ApiLevel=4\r
	@ScriptName=TeamRank\r
	@Tip = %(T_49_META_TYP_193_I4_D)\r
    TeamRank : ListT_Entity = -193004 #%(T_46_META_WS_P_TEAMRANK)\r
	@ApiLevel=4\r
	@ScriptName=PlayerRank\r
	@Tip = %(T_49_META_TYP_193_I5_D)\r
    PlayerRank : ListT_Player = -193005 #%(T_46_META_WS_P_PLAYERRANK)\r
	@ApiLevel=4\r
	@ScriptName=TeamRankDisplay\r
	@Tip = %(T_49_META_TYP_193_I6_D)\r
    TeamRank4Display : ListT_String = -193006 #%(T_46_META_WS_P_TEAMRANKDISPLAY)\r
	@ApiLevel=4\r
	@ScriptName=MainScoreTitle\r
	@Tip = %(T_49_META_TYP_193_I7_D)\r
    MainScoreTitle : String = -193007 #%(T_46_META_WS_P_MAINSCORETITLE)\r
	@ApiLevel=4\r
	@ScriptName=MainScoreList\r
	@Tip = %(T_49_META_TYP_193_I8_D)\r
    MainScoreList : ListT_Int = -193008 #%(T_46_META_WS_P_MAINSCORELIST)\r
	@ApiLevel=4\r
	@ScriptName=TitleList\r
	@Tip = %(T_49_META_TYP_193_I9_D)\r
    TitleList : ListT_LocString = -193009 #%(T_46_META_WS_P_TITLELIST)\r
	@ApiLevel=4\r
	@ScriptName=Scores1\r
	@Tip = %(T_49_META_TYP_193_I10_D)\r
    ScoreList1 : ListT_Object = -193010 #%(T_46_META_WS_P_SCORES1)\r
	@ApiLevel=4\r
	@ScriptName=Scores2\r
	@Tip = %(T_49_META_TYP_193_I11_D)\r
    ScoreList2 : ListT_Object = -193011 #%(T_46_META_WS_P_SCORES2)\r
	@ApiLevel=4\r
	@ScriptName=Scores3\r
	@Tip = %(T_49_META_TYP_193_I12_D)\r
    ScoreList3 : ListT_Object = -193012 #%(T_46_META_WS_P_SCORES3)\r
	@ApiLevel=4\r
	@ScriptName=Scores4\r
	@Tip = %(T_49_META_TYP_193_I13_D)\r
    ScoreList4 : ListT_Object = -193013 #%(T_46_META_WS_P_SCORES4)\r
	@ApiLevel=4\r
	@ScriptName=Scores5\r
	@Tip = %(T_49_META_TYP_193_I14_D)\r
    ScoreList5 : ListT_Object = -193014 #%(T_46_META_WS_P_SCORES5)\r
	@ApiLevel=4\r
	@ScriptName=WinMVPs\r
	@Tip = %(T_49_META_TYP_193_I15_D)\r
    WinMVPList : ListT_Player = -193015 #%(T_46_META_WS_P_WINMVPS)\r
	@ApiLevel=4\r
	@ScriptName=LoseMVPs\r
	@Tip = %(T_49_META_TYP_193_I16_D)\r
    LoseMVPList : ListT_Player = -193016 #%(T_46_META_WS_P_LOSEMVPS)\r
	@ApiLevel=10\r
	@Default=true\r
	@ScriptName=ShowMatchDetail\r
	@Tip = %(T_49_META_TYP_193_I17_D)\r
    ShowMatchDetail : Bool = -193017 #%(T_46_META_WS_P_SHOWMATCHDETAIL)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ShowMapEvaluate\r
	@Tip = %(T_49_META_TYP_193_I18_D)\r
    ShowMapEvaluate : Bool = -193018 #%(T_46_META_WS_P_SHOWMAPEVALUATE)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ShowGift\r
	@Tip = %(T_49_META_TYP_193_I19_D)\r
    ShowGift : Bool = -193019 #%(T_46_META_WS_P_SHOWGIFT)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ShowReport\r
	@Tip = %(T_49_META_TYP_193_I20_D)\r
    ShowReport : Bool = -193020 #%(T_46_META_WS_P_SHOWREPORT)\r
	@ApiLevel=3\r
	@Default=false\r
	@ScriptName=ShowReplay\r
	@Tip = %(T_49_META_TYP_193_I21_D)\r
    ShowReplay : Bool = -193021 #%(T_46_META_WS_P_SHOWREPLAY)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ShowShare\r
	@Tip = %(T_49_META_TYP_193_I22_D)\r
    ShowShare : Bool = -193022 #%(T_46_META_WS_P_SHOWSHARE)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ShowLobby\r
	@Tip = %(T_49_META_TYP_193_I23_D)\r
    ShowLobby : Bool = -193023 #%(T_46_META_WS_P_SHOWLOBBY)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ShowLike\r
	@Tip = %(T_49_META_TYP_193_I24_D)\r
    ShowLike : Bool = -193024 #%(T_46_META_WS_P_SHOWLIKE)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ShowAddFriend\r
	@Tip = %(T_49_META_TYP_193_I25_D)\r
    ShowFriend : Bool = -193025 #%(T_46_META_WS_P_SHOWADDFRIEND)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Football\r
@Tip = %(T_49_META_TYPE_99_D)\r
@ModuleID=10006\r
@ModuleLib=Football\r
type Football : LevelObject = 99 { #%(T_46_META_WS_C_FOOTBALL)\r
	@ApiLevel=4\r
	@ScriptName=Radius\r
	@Tip = %(T_49_META_TYP_99_I0_D)\r
    Radius : Float = -99000 #%(T_46_META_WS_P_RADIUS)\r
	@ApiLevel=4\r
	@ScriptName=RollingFrictionCoeff\r
	@Tip = %(T_49_META_TYP_99_I1_D)\r
    RollingFrictionCoeff : Float = -99001 #%(T_46_META_WS_P_ROLLINGFRICTIONCOEFF)\r
	@ApiLevel=4\r
	@ScriptName=RollingFrictionCoeffRushing\r
	@Tip = %(T_49_META_TYP_99_I2_D)\r
    RollingFrictionCoeff_Rushing : Float = -99002 #%(T_46_META_WS_P_ROLLINGFRICTIONCOEFFRUSHING)\r
	@ApiLevel=4\r
	@ScriptName=ShootAngleMin\r
	@Tip = %(T_49_META_TYP_99_I3_D)\r
    ShootAngleMin : Int = -99003 #%(T_46_META_WS_P_SHOOTANGLEMIN)\r
	@ApiLevel=4\r
	@ScriptName=HighShootAngleMin\r
	@Tip = %(T_49_META_TYP_99_I4_D)\r
    HighShootAngleMin : Int = -99004 #%(T_46_META_WS_P_HIGHSHOOTANGLEMIN)\r
	@ApiLevel=4\r
	@ScriptName=ResetTime\r
	@Tip = %(T_49_META_TYP_99_I5_D)\r
    HideTime : Int = -99005 #%(T_46_META_WS_P_RESETTIME)\r
	@ApiLevel=4\r
	@ScriptName=ShootAngleMax\r
	@Tip = %(T_49_META_TYP_99_I6_D)\r
    ShootAngleMax : Int = -99006 #%(T_46_META_WS_P_SHOOTANGLEMAX)\r
	@ApiLevel=4\r
	@ScriptName=ResetPosition\r
	@Tip = %(T_49_META_TYP_99_I7_D)\r
    InitPos : Vector3 = -99007 #%(T_46_META_WS_P_RESETPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=JerseyMachine\r
@Tip = %(T_49_META_TYPE_100_D)\r
@ModuleID=10006\r
@ModuleLib=Football\r
type Wardrobe : CustomizeTrigger = 100 { #%(T_46_META_WS_C_JERSEYMACHINE)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=TriggerRadius\r
	@Tip = %(T_49_META_TYP_100_I0_D)\r
    TriggerRadius : Float = -100000 #%(T_46_META_WS_P_TRIGGERRADIUS)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ModelVisible\r
	@Tip = %(T_49_META_TYP_100_I1_D)\r
    ModelShow : Bool = -100001 #%(T_46_META_WS_P_MODELVISIBLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MorphObject\r
@Tip = %(T_49_META_TYPE_101_D)\r
@ModuleID=22\r
@ModuleLib=Morph\r
type MorphObject : LevelObject&Appearance = 101 { #%(T_46_META_WS_C_MORPHOBJECT)\r
	@ApiLevel=3\r
	@ScriptName=Player\r
	@Tip = %(T_49_META_TYP_101_I0_D)\r
    Player : Player = -101000 #%(T_46_META_WS_P_PLAYER)\r
	@ApiLevel=3\r
	@ScriptName=TargetItemID\r
	@Tip = %(T_49_META_TYP_101_I1_D)\r
    get TargetItemID : LevelObjectID = -101001 #%(T_46_META_WS_P_TARGETITEMID)\r
	@ApiLevel=3\r
	@Default=math.Vector3_Z()\r
	@ScriptName=TargetRotation\r
	@Tip = %(T_49_META_TYP_101_I2_D)\r
    get TargetRotation : Vector3 = -101002 #%(T_46_META_WS_P_TARGETROTATION)\r
	@ApiLevel=3\r
	@Default=math.Vector3_1()\r
	@ScriptName=TargetScale\r
	@Tip = %(T_49_META_TYP_101_I3_D)\r
    get TargetScale : Vector3 = -101003 #%(T_46_META_WS_P_TARGETSCALE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AnimationState\r
@Tip = %(T_49_META_TYPE_295_D)\r
@ModuleID=35\r
@ModuleLib=Animation\r
type AnimationState : Entity = 295 { #%(T_46_META_WS_C_ANIMATIONSTATE)\r
	@ApiLevel=10\r
	@ScriptName=Name\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get Name : String = -295000 #Name\r
	@ApiLevel=4\r
	@ScriptName=IsLoop\r
	@Tip = %(T_49_META_TYP_332_I0_D)\r
    IsLoop : Bool = -295001 #%(T_46_META_WS_P_ISLOOP)\r
	@ApiLevel=4\r
	@ScriptName=PlaySpeed\r
	@Tip = %(T_49_META_TYP_295_I2_D)\r
    Speed : Float = -295002 #%(T_46_META_WS_P_PLAYSPEED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AnimationClip\r
@Tip = %(T_49_META_TYPE_296_D)\r
@ModuleID=35\r
@ModuleLib=Animation\r
type AnimationClip : Entity = 296 { #%(T_46_META_WS_C_ANIMATIONCLIP)\r
	@ApiLevel=10\r
	@ScriptName=Name\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get Name : String = -296000 #Name\r
	@ApiLevel=4\r
	@ScriptName=ClipLength\r
	@Tip = %(T_49_META_TYP_296_I1_D)\r
    get Length : Float = -296001 #%(T_46_META_WS_P_CLIPLENGTH)\r
	@ApiLevel=4\r
	@ScriptName=PlaySpeed\r
	@Tip = %(T_49_META_TYP_295_I2_D)\r
    Speed : Float = -296002 #%(T_46_META_WS_P_PLAYSPEED)\r
	@ApiLevel=4\r
	@ScriptName=IsLoop\r
	@Tip = %(T_49_META_TYP_332_I0_D)\r
    IsLoop : Bool = -296003 #%(T_46_META_WS_P_ISLOOP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AnimationController\r
@Tip = %(T_49_META_TYPE_297_D)\r
@ModuleID=35\r
@ModuleLib=Animation\r
type AnimationController : Entity = 297 { #%(T_46_META_WS_C_ANIMATIONCONTROLLER)\r
	@ApiLevel=4\r
	@ScriptName=AttachTarget\r
	@Tip = %(T_49_META_TYP_297_I0_D)\r
    get AttachTarget : Entity = -297000 #%(T_46_META_WS_P_ATTACHTARGET)\r
	@ApiLevel=10\r
	@ScriptName=CurrentState\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get CurrentState : AnimationState = -297001 #%(T_46_META_WS_P_CURRENTSTATE)\r
	@ApiLevel=10\r
	@ScriptName=CurrentClip\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get CurrentClip : AnimationClip = -297002 #%(T_46_META_WS_P_CURRENTCLIP)\r
	@ApiLevel=10\r
	@ScriptName=CurrentClipProgress\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get CurrentClipProgress : Float = -297003 #%(T_46_META_WS_P_CURRENTCLIPPROGRESS)\r
	@ApiLevel=4\r
	@ScriptName=Resource\r
	@Tip = %(T_49_META_TYP_297_I4_D)\r
    get ResUUID : String = -297004 #%(T_46_META_WS_P_RESOURCE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LoopType\r
@Tip = %(T_49_META_TYPE_298_D)\r
@ModuleID=35\r
@ModuleLib=Animation\r
enum AnimationOverrideLoopType : Int = 298 { #%(T_46_META_WS_C_LOOPTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Default\r
	@Tip = %(T_49_META_TYP_298_I0_D)\r
    DontChange = 0 #%(T_46_META_WS_E_DEFAULT)\r
	@ApiLevel=4\r
	@ScriptName=Loop\r
	@Tip = %(T_49_META_TYP_30_I34_D)\r
    Loop = 1 #%(T_46_META_WS_E_LOOP)\r
	@ApiLevel=4\r
	@ScriptName=Once\r
	@Tip = %(T_49_META_TYP_298_I2_D)\r
    Once = 2 #%(T_46_META_WS_E_ONCE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayerReviveSourceType\r
@Tip = %(T_49_META_TYPE_102_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
enum PlayerReviveSourceType : Int = 102 { #%(T_46_META_WS_C_PLAYERREVIVESOURCETYPE)\r
	@ApiLevel=4\r
	@ScriptName=Death\r
	@Tip = %(T_49_META_TYP_102_I0_D)\r
    Death = 1 #%(T_46_META_WS_E_DEATH)\r
	@ApiLevel=4\r
	@ScriptName=KnockDown\r
	@Tip = %(T_49_META_TYP_102_I1_D)\r
    KnockDown = 2 #%(T_46_META_WS_E_KNOCKDOWN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EquipmentType\r
@Tip = %(T_49_META_TYPE_103_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
enum EquipSlotType : Int = 103 { #%(T_46_META_WS_C_EQUIPMENTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=PrimaryWeaponA\r
	@Tip = %(T_49_META_TYP_103_I0_D)\r
    PrimaryWeapon1 = 0 #%(T_46_META_WS_E_PRIMARYWEAPONA)\r
	@ApiLevel=4\r
	@ScriptName=PrimaryWeaponB\r
	@Tip = %(T_49_META_TYP_103_I1_D)\r
    PrimaryWeapon2 = 1 #%(T_46_META_WS_E_PRIMARYWEAPONB)\r
	@ApiLevel=4\r
	@ScriptName=SecondaryWeapon\r
	@Tip = %(T_49_META_TYP_103_I2_D)\r
    SecondaryWeapon = 2 #%(T_46_META_WS_E_SECONDARYWEAPON)\r
	@ApiLevel=4\r
	@ScriptName=Grenade\r
	@Tip = %(T_49_META_TYP_103_I3_D)\r
    ExplosiveWeapon = 3 #%(T_46_META_WS_E_GRENADE)\r
	@ApiLevel=4\r
	@ScriptName=Melee\r
	@Tip = %(T_49_META_TYP_30_I76_D)\r
    MeleeWeapon = 4 #%(T_46_META_WS_E_MELEE)\r
	@ApiLevel=4\r
	@ScriptName=HeavyWeapon\r
	@Tip = %(T_49_META_TYP_103_I5_D)\r
    HeavyWeapon = 5 #%(T_46_META_WS_E_HEAVYWEAPON)\r
	@ApiLevel=4\r
	@ScriptName=Helmet\r
	@Tip = %(T_49_META_TYP_74_I1_D)\r
    Helmet = 6 #%(T_46_META_WS_E_HELMET)\r
	@ApiLevel=4\r
	@ScriptName=Vest\r
	@Tip = %(T_49_META_TYP_74_I2_D)\r
    Vest = 8 #%(T_46_META_WS_E_VEST)\r
	@ApiLevel=4\r
	@ScriptName=Flash\r
	@Tip = %(T_49_META_TYP_34_I133_D)\r
    FlashBomb = 16 #%(T_46_META_WS_E_FLASH)\r
	@ApiLevel=4\r
	@ScriptName=SmokeGrenade\r
	@Tip = %(T_49_META_TYP_34_I134_D)\r
    SmokeGrenade = 23 #%(T_46_META_WS_E_SMOKEGRENADE)\r
	@ApiLevel=4\r
	@ScriptName=FlashFreeze\r
	@Tip = %(T_49_META_TYP_103_I10_D)\r
    FrozenGrenade = 30 #%(T_46_META_WS_E_FLASHFREEZE)\r
	@ApiLevel=4\r
	@ScriptName=GlooWall\r
	@Tip = %(T_49_META_TYP_103_I11_D)\r
    BuildingIceWall = 13 #%(T_46_META_WS_E_GLOOWALL)\r
	@ApiLevel=4\r
	@ScriptName=Landmine\r
	@Tip = %(T_49_META_TYP_103_I12_D)\r
    Landmine = 14 #%(T_46_META_WS_E_LANDMINE)\r
	@ApiLevel=4\r
	@ScriptName=MiniSentry\r
	@Tip = %(T_49_META_TYP_103_I13_D)\r
    MiniSentry = 17 #%(T_46_META_WS_E_MINISENTRY)\r
	@ApiLevel=4\r
	@ScriptName=Dummy\r
	@Tip = %(T_49_META_TYP_103_I14_D)\r
    Dummy = 21 #%(T_46_META_WS_E_DUMMY)\r
	@ApiLevel=4\r
	@ScriptName=PersonalUAV\r
	@Tip = %(T_49_META_TYP_34_I182_D)\r
    PersonalUAV = 28 #%(T_46_META_WS_E_PERSONALUAV)\r
	@ApiLevel=4\r
	@ScriptName=FunctionalItems\r
	@Tip = %(T_49_META_TYP_103_I16_D)\r
    Camouflage = 12 #%(T_46_META_WS_E_FUNCTIONALITEMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EquipmentSlotType\r
@Tip = %(T_49_META_TYPE_302_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
enum EquipmentSlot : Int = 302 { #%(T_46_META_WS_C_EQUIPMENTSLOTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=PrimaryWeaponA\r
	@Tip = %(T_49_META_TYP_103_I0_D)\r
    PrimaryWeapon1 = 0 #%(T_46_META_WS_E_PRIMARYWEAPONA)\r
	@ApiLevel=4\r
	@ScriptName=PrimaryWeaponB\r
	@Tip = %(T_49_META_TYP_103_I1_D)\r
    PrimaryWeapon2 = 1 #%(T_46_META_WS_E_PRIMARYWEAPONB)\r
	@ApiLevel=4\r
	@ScriptName=SecondaryWeapon\r
	@Tip = %(T_49_META_TYP_103_I2_D)\r
    SecondaryWeapon = 2 #%(T_46_META_WS_E_SECONDARYWEAPON)\r
	@ApiLevel=4\r
	@ScriptName=Melee\r
	@Tip = %(T_49_META_TYP_30_I76_D)\r
    MeleeWeapon = 4 #%(T_46_META_WS_E_MELEE)\r
	@ApiLevel=4\r
	@ScriptName=Helmet\r
	@Tip = %(T_49_META_TYP_74_I1_D)\r
    Helmet = 6 #%(T_46_META_WS_E_HELMET)\r
	@ApiLevel=4\r
	@ScriptName=Bag\r
	@Tip = %(T_49_META_TYP_302_I5_D)\r
    Bag = 7 #%(T_46_META_WS_E_BAG)\r
	@ApiLevel=4\r
	@ScriptName=Vest\r
	@Tip = %(T_49_META_TYP_74_I2_D)\r
    Vest = 8 #%(T_46_META_WS_E_VEST)\r
	@ApiLevel=4\r
	@ScriptName=FunctionalItems\r
	@Tip = %(T_49_META_TYP_302_I7_D)\r
    Camouflage = 12 #%(T_46_META_WS_E_FUNCTIONALITEMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=JerseyStyle\r
@Tip = %(T_49_META_TYPE_104_D)\r
@ModuleID=10006\r
@ModuleLib=Football\r
enum CustomizeClothesType : Int = 104 { #%(T_46_META_WS_C_JERSEY STYLE)\r
	@ApiLevel=4\r
	@ScriptName=StyleA\r
	@Tip = %(T_49_META_TYP_104_I0_D)\r
    Style1 = 1 #%(T_46_META_WS_E_STYLEA)\r
	@ApiLevel=4\r
	@ScriptName=StyleB\r
	@Tip = %(T_49_META_TYP_104_I1_D)\r
    Style2 = 2 #%(T_46_META_WS_E_STYLEB)\r
	@ApiLevel=4\r
	@ScriptName=StyleC\r
	@Tip = %(T_49_META_TYP_104_I2_D)\r
    Style3 = 3 #%(T_46_META_WS_E_STYLEC)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=FootballGoal\r
@Tip = %(T_49_META_TYPE_105_D)\r
@ModuleID=10006\r
@ModuleLib=Football\r
type FootballGoal : LevelObject = 105 { #%(T_37_XYL_SOCCERGOAL)\r
	@ApiLevel=10\r
	@ScriptName=Team_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get Team : Int = -105000 #%(TXT_ROOM_LOBBY_ID)\r
	@ApiLevel=4\r
	@ScriptName=TeamSeq\r
	@Tip = %(T_49_META_TYP_15_I5_D)\r
    get TeamSeq : Int = -105001 #%(T_46_META_WS_P_TEAMSEQ)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AimAssistType\r
@Tip = %(T_49_META_TYPE_106_D)\r
@ModuleID=10016\r
@ModuleLib=Combat\r
enum AimAssistType : Int = 106 { #%(T_46_META_WS_C_AIMASSISTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Default\r
	@Tip = %(T_49_META_TYP_382_I0_D)\r
    Default = 0 #%(T_46_META_WS_E_DEFAULT)\r
	@ApiLevel=4\r
	@ScriptName=Enable\r
	@Tip = %(T_49_META_TYP_106_I1_D)\r
    Enable = 1 #%(T_46_META_WS_E_ENABLE)\r
	@ApiLevel=4\r
	@ScriptName=Disable\r
	@Tip = %(T_49_META_TYP_106_I2_D)\r
    Disable = 2 #%(T_46_META_WS_E_DISABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ChatChannel\r
@Tip = %(T_49_META_TYPE_109_D)\r
@ModuleID=24\r
@ModuleLib=ChatChannel\r
type ChatChannel : Entity = 109 { #%(T_46_META_WS_C_CHATCHANNEL)\r
	@ApiLevel=3\r
	@ScriptName=ChannelID\r
	@Tip = %(T_49_META_TYP_109_I0_D)\r
    get ChannelID : String = -109000 #%(T_46_META_WS_P_CHANNELID)\r
	@ApiLevel=3\r
	@ScriptName=PlayerList\r
	@Tip = %(T_49_META_TYP_109_I1_D)\r
    Players : ListT_Player = -109001 #%(T_46_META_WS_P_PLAYERLIST)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ChatChannelType\r
@Tip = %(T_49_META_TYPE_110_D)\r
@ModuleID=24\r
@ModuleLib=ChatChannel\r
enum FreeChatChannel : Int = 110 { #%(T_46_META_WS_C_CHATCHANNELTYPE)\r
	@ApiLevel=4\r
	@ScriptName=ChannelA\r
	@Tip = %(T_49_META_TYP_110_I0_D)\r
    Channel_1 = 0 #%(T_46_META_WS_E_CHANNELA)\r
	@ApiLevel=4\r
	@ScriptName=ChannelB\r
	@Tip = %(T_49_META_TYP_110_I1_D)\r
    Channel_2 = 1 #%(T_46_META_WS_E_CHANNELB)\r
	@ApiLevel=4\r
	@ScriptName=ChannelC\r
	@Tip = %(T_49_META_TYP_110_I2_D)\r
    Channel_3 = 2 #%(T_46_META_WS_E_CHANNELC)\r
	@ApiLevel=4\r
	@ScriptName=ChannelD\r
	@Tip = %(T_49_META_TYP_110_I3_D)\r
    Channel_4 = 3 #%(T_46_META_WS_E_CHANNELD)\r
	@ApiLevel=4\r
	@ScriptName=ChannelE\r
	@Tip = %(T_49_META_TYP_110_I4_D)\r
    Channel_5 = 4 #%(T_46_META_WS_E_CHANNELE)\r
	@ApiLevel=4\r
	@ScriptName=ChannelF\r
	@Tip = %(T_49_META_TYP_110_I5_D)\r
    Channel_6 = 5 #%(T_46_META_WS_E_CHANNELF)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayerBehaviorType\r
@Tip = %(T_49_META_TYPE_111_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
enum PlayerBehaviorType : Int = 111 { #%(T_46_META_WS_C_PLAYERBEHAVIORTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Move\r
	@Tip = %(T_49_META_TYP_31_I86_D)\r
    Movement = 1 #%(T_46_META_WS_E_MOVE)\r
	@ApiLevel=4\r
	@ScriptName=Sprint\r
	@Tip = %(T_49_META_TYP_111_I1_D)\r
    Sprint = 2 #%(T_46_META_WS_E_SPRINT)\r
	@ApiLevel=4\r
	@ScriptName=Attack\r
	@Tip = %(T_49_META_TYP_111_I2_D)\r
    Attack = 3 #%(T_46_META_WS_E_ATTACK)\r
	@ApiLevel=4\r
	@ScriptName=Jump\r
	@Tip = %(T_49_META_TYP_111_I3_D)\r
    Jump = 4 #%(T_46_META_WS_E_JUMP)\r
	@ApiLevel=4\r
	@ScriptName=VaultOver\r
	@Tip = %(T_49_META_TYP_111_I4_D)\r
    Climb = 5 #%(T_46_META_WS_E_VAULTOVER)\r
	@ApiLevel=4\r
	@ScriptName=Drive\r
	@Tip = %(T_49_META_TYP_111_I5_D)\r
    Drive = 6 #%(T_46_META_WS_E_DRIVE)\r
	@ApiLevel=4\r
	@ScriptName=EnterVehicle\r
	@Tip = %(T_49_META_TYP_111_I6_D)\r
    GetOnDrive = 7 #%(T_46_META_WS_E_ENTERVEHICLE)\r
	@ApiLevel=4\r
	@ScriptName=ExitVehicle\r
	@Tip = %(T_49_META_TYP_111_I7_D)\r
    GetOffDrive = 8 #%(T_46_META_WS_E_EXITVEHICLE)\r
	@ApiLevel=4\r
	@ScriptName=DriveVehicle\r
	@Tip = %(T_49_META_TYP_111_I8_D)\r
    OpeVehicle = 9 #%(T_46_META_WS_E_DIRVEVEHICLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayerBehaviorStatusType\r
@Tip = %(T_49_META_TYPE_112_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
enum PlayerBehaviorStatus : Int = 112 { #%(T_46_META_WS_C_PLAYERBEHAVIORSTATUSTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Enable\r
	@Tip = %(T_49_META_TYP_112_I0_D)\r
    Enable = 0 #%(T_46_META_WS_E_ENABLE)\r
	@ApiLevel=4\r
	@ScriptName=Disable\r
	@Tip = %(T_49_META_TYP_112_I1_D)\r
    Disable = 1 #%(T_46_META_WS_E_DISABLE)\r
	@ApiLevel=4\r
	@ScriptName=Invisible\r
	@Tip = %(T_49_META_TYP_112_I2_D)\r
    Invisible = 2 #%(T_46_META_WS_E_INVISIBLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DrumMusic\r
@Tip = %(T_49_META_TYPE_113_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type DrumMusicElement : LevelObject&Collider = 113 { #%(T_46_META_WS_C_DRUMMUSIC)\r
	@ApiLevel=4\r
	@ScriptName=MusicElementType\r
	@Tip = %(T_49_META_TYP_64_I0_D)\r
    get MusicElementType : DrumMusicElementType = -113000 #%(T_46_META_WS_P_MUSICELEMENTTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Lead1Music\r
@Tip = %(T_49_META_TYPE_114_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type Lead1MusicElement : LevelObject&Collider = 114 { #%(T_46_META_WS_C_LEAD1MUSIC)\r
	@ApiLevel=4\r
	@ScriptName=MusicElementType\r
	@Tip = %(T_49_META_TYP_64_I0_D)\r
    get MusicElementType : Lead1MusicElementType = -114000 #%(T_46_META_WS_P_MUSICELEMENTTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Lead2Music\r
@Tip = %(T_49_META_TYPE_115_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type Lead2MusicElement : LevelObject&Collider = 115 { #%(T_46_META_WS_C_LEAD2MUSIC)\r
	@ApiLevel=4\r
	@ScriptName=MusicElementType\r
	@Tip = %(T_49_META_TYP_64_I0_D)\r
    get MusicElementType : Lead2MusicElementType = -115000 #%(T_46_META_WS_P_MUSICELEMENTTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Lead3Music\r
@Tip = %(T_49_META_TYPE_116_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type Lead3MusicElement : LevelObject&Collider = 116 { #%(T_46_META_WS_C_LEAD3MUSIC)\r
	@ApiLevel=4\r
	@ScriptName=MusicElementType\r
	@Tip = %(T_49_META_TYP_64_I0_D)\r
    get MusicElementType : Lead3MusicElementType = -116000 #%(T_46_META_WS_P_MUSICELEMENTTYPE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=Faction\r
@Tip = %(T_49_META_TYPE_118_D)\r
@ModuleID=25\r
@ModuleLib=Hostility\r
type Faction : Entity = 118 { #%(T_46_META_WS_C_FACTION)\r
	@ApiLevel=4\r
	@ScriptName=IsAced\r
	@Tip = %(T_49_META_TYP_118_I0_D)\r
    get IsACE : Bool = -118000 #%(T_46_META_WS_P_ISACED)\r
	@ApiLevel=4\r
	@ScriptName=AllPlayers\r
	@Tip = %(T_49_META_TYP_118_I1_D)\r
    get AllPlayers : ListT_Player = -118001 #%(T_46_META_WS_P_ALLPLAYERS)\r
	@ApiLevel=4\r
	@ScriptName=FriendFactions\r
	@Tip = %(T_49_META_TYP_118_I2_D)\r
    get FriendlyFactions : ListT_Faction = -118002 #%(T_46_META_WS_P_FRIENDFACTIONS)\r
	@ApiLevel=4\r
	@ScriptName=AttackableFactions\r
	@Tip = %(T_49_META_TYP_118_I3_D)\r
    get HostileFactions : ListT_Faction = -118003 #%(T_46_META_WS_P_ATTACKABLEFACTIONS)\r
	@ApiLevel=4\r
	@ScriptName=IsShowHudName\r
	@Tip = %(T_49_META_TYP_118_I4_D)\r
    IsShowHudName : Bool = -118004 #%(T_46_META_WS_P_ISSHOWHUDNAME)\r
	@ApiLevel=4\r
	@ScriptName=IsShowMapInfo\r
	@Tip = %(T_49_META_TYP_118_I5_D)\r
    IsShowMapInfo : Bool = -118005 #%(T_46_META_WS_P_ISSHOWMAPINFO)\r
	@ApiLevel=4\r
	@ScriptName=IsShowTag\r
	@Tip = %(T_49_META_TYP_118_I6_D)\r
    IsShowTag : Bool = -118006 #%(T_46_META_WS_P_ISSHOWTAG)\r
	@ApiLevel=4\r
	@ScriptName=IsShowScan\r
	@Tip = %(T_49_META_TYP_118_I7_D)\r
    IsShowScan : Bool = -118007 #%(T_46_META_WS_P_ISSHOWSCAN)\r
	@ApiLevel=4\r
	@ScriptName=AllMembers\r
	@Tip = %(T_49_META_TYP_118_I8_D)\r
    get AllMembers : ListT_Entity = -118008 #%(T_46_META_WS_P_ALLMEMBERS)\r
	@ApiLevel=4\r
	@ScriptName=IsShowQuickMessage\r
	@Tip = %(T_49_META_TYP_118_I9_D)\r
    IsShowQuickMessage : Bool = -118009 #%(T_46_META_WS_P_ISSHOWQUICKMESSAGE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AttackableType\r
@Tip = %(T_49_META_TYPE_119_D)\r
@ModuleID=26\r
@ModuleLib=Hostility\r
enum AttackableOption : Int = 119 { #%(T_46_META_WS_C_ATTACKABLETYPE)\r
	@ApiLevel=4\r
	@ScriptName=TRUE\r
	@Tip = %(T_49_META_TYP_119_I0_D)\r
    Yes = 1 #%(T_46_META_WS_E_TRUE)\r
	@ApiLevel=4\r
	@ScriptName=FALSE\r
	@Tip = %(T_49_META_TYP_119_I1_D)\r
    No = 2 #%(T_46_META_WS_E_FALSE)\r
	@ApiLevel=4\r
	@ScriptName=Default\r
	@Tip = %(T_49_META_TYP_382_I0_D)\r
    Default = 3 #%(T_46_META_WS_E_DEFAULT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MorphableObject\r
@Tip = %(T_49_META_TYPE_128_D)\r
@ModuleID=22\r
@ModuleLib=Morph\r
enum MorphableObject : Int = 128 { #%(T_46_META_WS_C_MORPHABLEOBJECT)\r
	@ApiLevel=4\r
	@ScriptName=Bushes\r
	@Tip = %(T_49_META_TYP_128_I0_D)\r
    PeekabooBushCover = 210 #%(T_46_META_WS_E_BUSHES)\r
	@ApiLevel=4\r
	@ScriptName=Pumpkin\r
	@Tip = %(T_49_META_TYP_128_I1_D)\r
    Pumpkin = 158 #%(T_46_META_WS_E_PUMPKIN)\r
	@ApiLevel=4\r
	@ScriptName=Scarecrow\r
	@Tip = %(T_49_META_TYP_128_I2_D)\r
    JackStraw = 159 #%(T_46_META_WS_E_SCARECROW)\r
	@ApiLevel=4\r
	@ScriptName=Cabinet\r
	@Tip = %(T_49_META_TYP_128_I3_D)\r
    Cabinet = 160 #%(T_46_META_WS_E_CABINET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootSoccerType\r
@Tip = %(T_49_META_TYPE_141_D)\r
@ModuleID=10006\r
@ModuleLib=Football\r
enum LootSoccerType : Int = 141 { #%(T_46_META_WS_C_LOOTSOCCERTYPE)\r
	@ApiLevel=4\r
	@ScriptName=LootSoccerRandom\r
	@Tip = %(T_49_META_TYP_141_I0_D)\r
    LootSoccerRandom = 1040 #%(T_46_META_WS_E_LOOTSOCCERRANDOM)\r
	@ApiLevel=4\r
	@ScriptName=LootSoccerShield\r
	@Tip = %(T_49_META_TYP_141_I1_D)\r
    LootSoccerShield = 1038 #%(T_46_META_WS_E_LOOTSOCCERSHIELD)\r
	@ApiLevel=4\r
	@ScriptName=LootSoccerIce\r
	@Tip = %(T_49_META_TYP_141_I2_D)\r
    LootSoccerIce = 1039 #%(T_46_META_WS_E_LOOTSOCCERICE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootItemBoxSoccer\r
@Tip = %(T_49_META_TYPE_142_D)\r
@ModuleID=10006\r
@ModuleLib=Football\r
type LootItemBoxSoccer : LevelObject&SpawnableEntity&ResetableEntity = 142 { #%(T_46_META_WS_C_LOOTITEMBOXSOCCER)\r
	@ApiLevel=4\r
	@Default=1040\r
	@ScriptName=LootSoccer\r
	@Tip = %(T_49_META_TYP_142_I0_D)\r
    LootSoccer : LootSoccerType = -142000 #%(T_46_META_WS_P_LOOTSOCCER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CameraType\r
@Tip = %(T_49_META_TYPE_147_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
enum CameraType : AssetConfigID = 147 { #%(T_46_META_WS_C_CAMERATYPE)\r
	@ApiLevel=4\r
	@ScriptName=ThirdPersonClassic\r
	@Tip = %(T_49_META_TYP_147_I0_D)\r
    Classic = 1 #%(T_46_META_WS_E_THIRDPERSONCLASSIC)\r
	@ApiLevel=4\r
	@ScriptName=ThirdPerson\r
	@Tip = %(T_49_META_TYP_147_I1_D)\r
    ThirdPerson = 2 #%(T_46_META_WS_E_THIRDPERSON)\r
	@ApiLevel=4\r
	@ScriptName=FirstPersonClassic\r
	@Tip = %(T_49_META_TYP_147_I2_D)\r
    FirstPerson = 3 #%(T_46_META_WS_E_FIRSTPERSONCLASSIC)\r
	@ApiLevel=4\r
	@ScriptName=TopDown\r
	@Tip = %(T_49_META_TYP_147_I3_D)\r
    LookDown = 4 #%(T_46_META_WS_E_TOPDOWN)\r
	@ApiLevel=4\r
	@ScriptName=SideScrolling\r
	@Tip = %(T_49_META_TYP_147_I4_D)\r
    TwoDimension = 5 #%(T_46_META_WS_E_SIDESCROLLING)\r
	@ApiLevel=4\r
	@ScriptName=Custom\r
	@Tip = %(T_49_META_TYP_147_I5_D)\r
    Performance = 6 #%(T_46_META_WS_E_CUSTOM)\r
	@ApiLevel=4\r
	@ScriptName=ThirdPersonLock\r
	@Tip = %(T_49_META_TYP_147_I6_D)\r
    ThirdPersonLock = 7 #%(T_46_META_WS_E_THIRDPERSONLOCK)\r
	@ApiLevel=4\r
	@ScriptName=Free\r
	@Tip = %(T_49_META_TYP_147_I7_D)\r
    Free = 8 #%(T_46_META_WS_E_FREE)\r
	@ApiLevel=4\r
	@ScriptName=FirstPersonAdvanced\r
	@Tip = %(T_49_META_TYP_147_I8_D)\r
    FirstPersonModel = 9 #%(T_46_META_WS_E_FIRSTPERSON)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CameraBlockMode\r
@Tip = %(T_49_META_TYPE_177_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
enum CameraBlockMode : Int = 177 { #%(T_46_META_WS_C_CAMERABLOCKMODE)\r
	@ApiLevel=4\r
	@ScriptName=Stable\r
	@Tip = %(T_49_META_TYP_177_I0_D)\r
    Stable = 0 #%(T_39_XXJ_WS_STABLE)\r
	@ApiLevel=4\r
	@ScriptName=Zoom\r
	@Tip = %(T_49_META_TYP_177_I1_D)\r
    Zoom = 1 #%(T_46_META_WS_E_ZOOM)\r
	@ApiLevel=4\r
	@ScriptName=Transparent\r
	@Tip = %(T_49_META_TYP_177_I2_D)\r
    Invisicam = 2 #%(T_46_META_WS_E_TRANSPARENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CameraProjectionMode\r
@Tip = %(T_49_META_TYPE_178_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
enum CameraProjectionMode : Int = 178 { #%(T_46_META_WS_C_CAMERAPROJECTIONMODE)\r
	@ApiLevel=4\r
	@ScriptName=Perspective\r
	@Tip = %(T_49_META_TYP_178_I0_D)\r
    Perspective = 0 #%(T_46_META_WS_E_PERSPECTIVE)\r
	@ApiLevel=4\r
	@ScriptName=Orthogonal\r
	@Tip = %(T_49_META_TYP_178_I1_D)\r
    Orthogonal = 1 #%(T_46_META_WS_E_ORTHOGONAL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Camera\r
@Tip = %(T_49_META_TYPE_148_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
type CameraConfig : Entity = 148 { #%(T_46_META_WS_C_CAMERA)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=CameraType\r
	@Tip = %(T_49_META_TYP_148_I0_D)\r
    CameraType : CameraType = -148000 #%(T_46_META_WS_P_CAMERATYPE)\r
	@ApiLevel=4\r
	@Default=60\r
	@ScriptName=FOV\r
	@Tip = %(T_49_META_TYP_148_I1_D)\r
    Fov : Float = -148001 #%(T_46_META_WS_P_FOV)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
	@Tip = %(T_49_META_TYP_148_I2_D)\r
    Offset : Vector3 = -148002 #%(T_46_META_WS_P_OFFSET)\r
	@ApiLevel=3\r
	@ScriptName=FocusPoint\r
	@Tip = %(T_49_META_TYP_148_I3_D)\r
    Offset2 : Vector3 = -148003 #%(T_39_XXJ_WS_OFFSET2)\r
	@ApiLevel=4\r
	@ScriptName=Pitch\r
	@Tip = %(T_49_META_TYP_148_I4_D)\r
    Pitch : Float = -148004 #%(T_46_META_WS_P_PITCH)\r
	@ApiLevel=4\r
	@ScriptName=Yaw\r
	@Tip = %(T_49_META_TYP_148_I5_D)\r
    Yaw : Float = -148005 #%(T_46_META_WS_P_YAW)\r
	@ApiLevel=10\r
	@ScriptName=Distance_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Distance : Float = -148006 #%(T_39_XXJ_WS_CAMERADISTANCE)\r
	@ApiLevel=3\r
	@ScriptName=FollowTarget\r
	@Tip = %(T_49_META_TYP_148_I7_D)\r
    FollowTarget : Entity = -148007 #%(T_39_XXJ_WS_FOLLOWTARGET)\r
	@ApiLevel=3\r
	@ScriptName=FocusTarget\r
	@Tip = %(T_49_META_TYP_148_I8_D)\r
    FocusTarget : Entity = -148008 #%(T_39_XXJ_WS_FOCUSTARGET)\r
	@ApiLevel=4\r
	@ScriptName=Owner\r
	@Tip = %(T_49_META_TYP_148_I9_D)\r
    get UseEntities : ListT_Player = -148009 #%(T_46_META_WS_P_OWNER)\r
	@ApiLevel=3\r
	@Default=0\r
	@ScriptName=CameraTransitionType\r
	@Tip = %(T_49_META_TYP_148_I10_D)\r
    get CameraTransitionType : CameraTransitionType = -148010 #%(T_39_XXJ_WS_TRANSITIONTYPE)\r
	@ApiLevel=3\r
	@ScriptName=CameraTransitionTime\r
	@Tip = %(T_49_META_TYP_148_I11_D)\r
    CameraTransitionTime : Float = -148011 #%(T_39_XXJ_WS_TRANSITIONTIME)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=CameraBlockMode\r
	@Tip = %(T_49_META_TYP_148_I12_D)\r
    CameraBlockMode : CameraBlockMode = -148012 #%(T_46_META_WS_P_CAMERABLOCKMODE)\r
	@ApiLevel=4\r
	@ScriptName=CameraProjectionMode\r
	@Tip = %(T_49_META_TYP_148_I13_D)\r
    CameraProjectionMode : CameraProjectionMode = -148013 #%(T_46_META_WS_P_CAMERAPROJECTIONMODE)\r
	@ApiLevel=3\r
	@Default=2\r
	@ScriptName=FollowCoordinateType\r
	@Tip = %(T_49_META_TYP_148_I14_D)\r
    FollowCoordinateType : CoordinateType = -148014 #FollowCoordinateType\r
	@ApiLevel=3\r
	@Default=2\r
	@ScriptName=FocusCoordinateType\r
	@Tip = %(T_49_META_TYP_148_I15_D)\r
    FocusCoordinateType : CoordinateType = -148015 #FocusCoordinateType\r
	@ApiLevel=3\r
	@Default=65535\r
	@ScriptName=CullingMask\r
	@Tip = %(T_49_META_TYP_148_I16_D)\r
    CullingMask : Int = -148016 #%(T_40_XXJ_WS_CULLINGMASK_NAMEKEY)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=ViewingAngleRestriction\r
	@Tip = %(T_49_META_TYP_148_I17_D)\r
    ViewingAngleRestriction : CameraViewingAngleRestrictionType = -148017 #%(T_46_META_WS_P_VIEWINGANGLERESTRICTION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Oildrum\r
@Tip = %(T_49_META_TYPE_150_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type Oildrum : LevelObject&Collider = 150 { #%(T_46_META_WS_C_OILDRUM)\r
	@ApiLevel=4\r
	@ScriptName=Durability\r
	@Tip = %(T_49_META_TYP_150_I0_D)\r
    Durability : Int = -150000 #%(T_46_META_WS_P_DURABILITY)\r
	@ApiLevel=4\r
	@ScriptName=DamageRadius\r
	@Tip = %(T_49_META_TYP_150_I1_D)\r
    Radius : Float = -150001 #%(T_46_META_WS_P_DAMAGERADIUS)\r
	@ApiLevel=4\r
	@ScriptName=DamageFactor\r
	@Tip = %(T_49_META_TYP_150_I2_D)\r
    DamageFac : Float = -150002 #%(T_46_META_WS_P_DAMAGEFACTOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LowGravity\r
@Tip = %(T_49_META_TYPE_152_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type LowGravity : CustomizeTrigger = 152 { #%(T_46_META_WS_C_LOWGRAVITY)\r
	@ApiLevel=4\r
	@ScriptName=JumpHeight\r
	@Tip = %(T_49_META_TYP_399_I0_D)\r
    JumpHeight : Float = -152000 #%(T_46_META_WS_P_JUMPHEIGHT)\r
	@ApiLevel=4\r
	@ScriptName=CustomGravity\r
	@Tip = %(T_49_META_TYP_152_I1_D)\r
    CustomGravity : Float = -152001 #%(T_46_META_WS_P_CUSTOMGRAVITY)\r
	@ApiLevel=4\r
	@ScriptName=IsShow\r
	@Tip = %(T_49_META_TYP_152_I2_D)\r
    get ShowOrHide : Bool = -152002 #%(T_46_META_WS_P_ISSHOW)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ItemBase\r
@Tip = %(T_49_META_TYPE_198_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type InventoryBase : Entity = 198 { #%(T_46_META_WS_C_ITEMBASE)\r
	@ApiLevel=4\r
	@ScriptName=ItemID\r
	@Tip = %(T_49_META_TYP_198_I0_D)\r
    get ItemID : ItemGoodsIDType = -198000 #%(T_46_META_WS_P_ITEMID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Helmet\r
@Tip = %(T_49_META_TYPE_155_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type Helmet : InventoryBase&FormulableEntity = 155 { #%(T_46_META_WS_C_HELMET)\r
	@ApiLevel=4\r
	@ScriptName=Level\r
	@Tip = %(T_49_META_TYP_155_I0_D)\r
    get Level : Int = -155000 #%(T_46_META_WS_P_LEVEL)\r
	@ApiLevel=4\r
	@ScriptName=MaxDurability\r
	@Tip = %(T_49_META_TYP_155_I1_D)\r
    DurabilityMax : Int = -155001 #%(T_46_META_WS_P_MAXDURABILITY)\r
	@ApiLevel=4\r
	@ScriptName=CurrentDurability\r
	@Tip = %(T_49_META_TYP_155_I2_D)\r
    Durability : Int = -155002 #%(T_46_META_WS_P_CURRENTDURABILITY)\r
	@ApiLevel=4\r
	@ScriptName=DamageReductionFactor\r
	@Tip = %(T_49_META_TYP_155_I3_D)\r
    DamageReductionFactor : Int = -155003 #%(T_46_META_WS_P_DAMAGEREDUCTIONFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=ExplodeDamageReductionFactor\r
	@Tip = %(T_49_META_TYP_155_I4_D)\r
    DamageReductionFactorExplode : Int = -155004 #%(T_46_META_WS_P_EXPLODEDAMAGEREDUCTIONFACTOR)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=CanDamaged\r
	@Tip = %(T_49_META_TYP_155_I5_D)\r
    CostDurability : Bool = -155005 #%(T_46_META_WS_P_CANCOSTDURABILITY)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=CanDestroyed\r
	@Tip = %(T_49_META_TYP_155_I6_D)\r
    CanDestroy : Bool = -155006 #%(T_46_META_WS_P_CANDESTROY)\r
	@ApiLevel=10\r
	@ScriptName=Owner_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get Owner : Player = -155007 #%(T_38_WZY_WS_OWNER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vest\r
@Tip = %(T_49_META_TYPE_156_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type Vest : InventoryBase&FormulableEntity = 156 { #%(T_46_META_WS_C_VEST)\r
	@ApiLevel=4\r
	@ScriptName=Level\r
	@Tip = %(T_49_META_TYP_155_I0_D)\r
    get Level : Int = -156000 #%(T_46_META_WS_P_LEVEL)\r
	@ApiLevel=4\r
	@ScriptName=MaxDurability\r
	@Tip = %(T_49_META_TYP_156_I1_D)\r
    DurabilityMax : Int = -156001 #%(T_46_META_WS_P_MAXDURABILITY)\r
	@ApiLevel=4\r
	@ScriptName=CurrentDurability\r
	@Tip = %(T_49_META_TYP_156_I2_D)\r
    Durability : Int = -156002 #%(T_46_META_WS_P_CURRENTDURABILITY)\r
	@ApiLevel=4\r
	@ScriptName=DamageReductionFactor\r
	@Tip = %(T_49_META_TYP_156_I3_D)\r
    DamageReductionFactor : Int = -156003 #%(T_46_META_WS_P_DAMAGEREDUCTIONFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=ExplodeDamageReductionFactor\r
	@Tip = %(T_49_META_TYP_156_I4_D)\r
    DamageReductionFactorExplode : Int = -156004 #%(T_46_META_WS_P_EXPLODEDAMAGEREDUCTIONFACTOR)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=CanDamaged\r
	@Tip = %(T_49_META_TYP_156_I5_D)\r
    CostDurability : Bool = -156005 #%(T_46_META_WS_P_CANDAMAGED)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=CanDestroyed\r
	@Tip = %(T_49_META_TYP_156_I6_D)\r
    CanDestroy : Bool = -156006 #%(T_46_META_WS_P_CANDESTROYED)\r
	@ApiLevel=10\r
	@ScriptName=Owner_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get Owner : Player = -156007 #%(T_38_WZY_WS_OWNER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CameraTransitionType\r
@Tip = %(T_49_META_TYPE_157_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
enum CameraTransitionType : Int = 157 { #%(T_46_META_WS_C_CAMERATRANSITIONTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Default\r
	@Tip = %(T_49_META_TYP_157_I0_D)\r
    Default = 0 #%(T_46_META_WS_E_DEFAULT)\r
	@ApiLevel=4\r
	@ScriptName=Smooth\r
	@Tip = %(T_49_META_TYP_157_I1_D)\r
    Smooth = 1 #%(T_46_META_WS_E_SMOOTH)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Mushroom\r
@Tip = %(T_49_META_TYPE_171_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type Mushroom : InventoryBase = 171 { #%(T_46_META_WS_C_MUSHROOM)\r
	@ApiLevel=4\r
	@ScriptName=Energy\r
	@Tip = %(T_49_META_TYP_171_I0_D)\r
    Energy : Int = -171000 #%(T_46_META_WS_P_ENERGY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Ammo\r
@Tip = %(T_49_META_TYPE_172_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type Ammo : InventoryBase = 172 { #%(T_46_META_WS_C_AMMO)\r
	@ApiLevel=4\r
	@ScriptName=Count\r
	@Tip = %(T_49_META_TYP_172_I0_D)\r
    Count : Int = -172000 #%(T_46_META_WS_P_COUNT)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYPE_346_D)\r
    get AmmoType : AmmoType = -172001 #%(T_46_META_WS_P_AMMOTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Backpack\r
@Tip = %(T_49_META_TYPE_173_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type Bag : InventoryBase = 173 { #%(T_46_META_WS_C_BACKPACK)\r
	@ApiLevel=4\r
	@ScriptName=ExtraBagCapacity\r
	@Tip = %(T_49_META_TYP_173_I0_D)\r
    ExtraBagCapacity : Int = -173000 #%(T_46_META_WS_P_EXTRABAGCAPACITY)\r
	@ApiLevel=4\r
	@ScriptName=OverloadByPlayerConfiguration\r
	@Tip = %(T_49_META_TYP_173_I1_D)\r
    PrioritizePlayerSkin : Bool = -173001 #%(T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION)\r
	@ApiLevel=4\r
	@ScriptName=Skin\r
	@Tip = %(T_49_META_TYP_173_I2_D)\r
    SkinID : BagSkinID = -173002 #%(T_46_META_WS_P_SKIN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Grenade\r
@Tip = %(T_49_META_TYPE_174_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type Grenade : InventoryBase&FormulableEntity = 174 { #%(T_46_META_WS_E_GRENADE)\r
	@ApiLevel=10\r
	@ScriptName=Owner_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get Owner : Player = -174000 #%(T_38_WZY_WS_OWNER)\r
	@ApiLevel=4\r
	@ScriptName=MinDamage\r
	@Tip = %(T_49_META_TYP_79_I8_D)\r
    MinDamage : Int = -174001 #%(T_46_META_WS_P_MINDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=MaxDamage\r
	@Tip = %(T_49_META_TYP_174_I2_D)\r
    MaxDamage : Int = -174002 #%(T_46_META_WS_P_MAXDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=ExplosionRange\r
	@Tip = %(T_49_META_TYP_56_I11_D)\r
    Range : Float = -174003 #%(T_46_META_WS_P_EXPLOSIONRANGE)\r
	@ApiLevel=4\r
	@ScriptName=ThrowingSpeed\r
	@Tip = %(T_49_META_TYP_174_I4_D)\r
    ThrowSpeed : Float = -174004 #%(T_46_META_WS_P_THROWINGSPEED)\r
	@ApiLevel=4\r
	@ScriptName=ExplosionTime\r
	@Tip = %(T_49_META_TYP_174_I5_D)\r
    ExplosionTime : Float = -174005 #%(T_46_META_WS_P_EXPLOSIONTIME)\r
	@ApiLevel=4\r
	@ScriptName=SelfDamageFactor\r
	@Tip = %(T_49_META_TYP_174_I6_D)\r
    RatioSelf : Float = -174006 #%(T_46_META_WS_P_SELFDAMAGEFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=TeammateDamageFactor\r
	@Tip = %(T_49_META_TYP_174_I7_D)\r
    RatioTeammate : Float = -174007 #%(T_46_META_WS_P_TEAMMATEDAMAGEFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=VehicleDamageFactor\r
	@Tip = %(T_49_META_TYP_174_I8_D)\r
    RatioVehicle : Float = -174008 #%(T_46_META_WS_P_VEHICLEDAMAGEFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=Skin\r
	@Tip = %(T_49_META_TYP_174_I9_D)\r
    AssetConfigID : WeaponSkinID = -174009 #%(T_46_META_WS_P_SKIN)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=OverloadByPlayerConfiguration\r
	@Tip = %(T_49_META_TYP_79_I28_D)\r
    OverloadByPlayerWeaponSkin : Bool = -174010 #%(T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GrenadeFrozen\r
@Tip = %(T_49_META_TYPE_175_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type GrenadeFrozen : InventoryBase&Grenade = 175 { #%(T_46_META_WS_C_GRENADEFROZEN)\r
	@ApiLevel=4\r
	@ScriptName=Radius\r
	@Tip = %(T_49_META_TYP_175_I0_D)\r
    ZoneRadius : Float = -175000 #%(T_46_META_WS_P_RADIUS)\r
	@ApiLevel=4\r
	@ScriptName=FrozenAreaDuration\r
	@Tip = %(T_49_META_TYP_175_I1_D)\r
    ZoneDuration : Float = -175001 #%(T_46_META_WS_P_DURATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BasicSphere\r
@Tip = %(T_49_META_TYPE_179_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type BasicSphereItem : LevelObject&Appearance&Collider = 179 { #%(T_46_META_WS_C_BASICSPHERE)\r
	@ApiLevel=10\r
	@Default=1\r
	@ScriptName=Radius\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Radius : Float = -179000 #%(T_46_META_WS_P_RADIUS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BasicCylinder\r
@Tip = %(T_49_META_TYPE_188_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type BasicCylinderItem : LevelObject&Appearance&Collider = 188 { #%(T_46_META_WS_C_BASICCYLINDER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GrenadeFlashbang\r
@Tip = %(T_49_META_TYPE_191_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type GrenadeFlash : InventoryBase&FormulableEntity = 191 { #%(T_46_META_WS_C_GRENADEFLASHBANG)\r
	@ApiLevel=4\r
	@ScriptName=CenterRange\r
	@Tip = %(T_49_META_TYP_191_I0_D)\r
    CentralRange : Float = -191000 #%(T_46_META_WS_P_CENTERRANGE)\r
	@ApiLevel=4\r
	@ScriptName=ExplosionRange\r
	@Tip = %(T_49_META_TYP_56_I11_D)\r
    Range : Float = -191001 #%(T_46_META_WS_P_EXPLOSIONRANGE)\r
	@ApiLevel=4\r
	@ScriptName=ThrowingSpeed\r
	@Tip = %(T_49_META_TYP_174_I4_D)\r
    ThrowSpeed : Float = -191002 #%(T_46_META_WS_P_THROWINGSPEED)\r
	@ApiLevel=4\r
	@ScriptName=ExplosionDelay\r
	@Tip = %(T_49_META_TYP_174_I5_D)\r
    ExplosionTime : Float = -191003 #%(T_46_META_WS_P_EXPLOSIONDELAY)\r
	@ApiLevel=4\r
	@ScriptName=CentralFlashTime\r
	@Tip = %(T_49_META_TYP_191_I4_D)\r
    CenterFlashTime : Float = -191004 #%(T_46_META_WS_P_CENTRALFLASHTIME)\r
	@ApiLevel=4\r
	@ScriptName=EdgeFlashTime\r
	@Tip = %(T_49_META_TYP_191_I5_D)\r
    EdgeFlashTime : Float = -191005 #%(T_46_META_WS_P_EDGEFLASHTIME)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=FlashbangHitEffectSwitch\r
	@Tip = %(T_49_META_TYP_191_I6_D)\r
    HitEffectSwitch : Bool = -191006 #%(T_46_META_WS_P_FLASHBANGHITEFFECTSWITCH)\r
	@ApiLevel=4\r
	@ScriptName=Skin\r
	@Tip = %(T_49_META_TYP_174_I9_D)\r
    AssetConfigID : WeaponSkinID = -191007 #%(T_46_META_WS_P_SKIN)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=OverloadByPlayerConfiguration\r
	@Tip = %(T_49_META_TYP_79_I28_D)\r
    OverloadByPlayerWeaponSkin : Bool = -191008 #%(T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GrenadeSmoke\r
@Tip = %(T_49_META_TYPE_192_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type GrenadeSmoke : InventoryBase&FormulableEntity = 192 { #%(T_46_META_WS_C_GRENADESMOKE)\r
	@ApiLevel=4\r
	@ScriptName=ExplosionRange\r
	@Tip = %(T_49_META_TYP_56_I11_D)\r
    Range : Float = -192000 #%(T_46_META_WS_P_EXPLOSIONRANGE)\r
	@ApiLevel=4\r
	@ScriptName=ThrowingSpeed\r
	@Tip = %(T_49_META_TYP_174_I4_D)\r
    ThrowSpeed : Float = -192001 #%(T_46_META_WS_P_THROWINGSPEED)\r
	@ApiLevel=4\r
	@ScriptName=ExplosionDelay\r
	@Tip = %(T_49_META_TYP_174_I5_D)\r
    ExplosionTime : Float = -192002 #%(T_46_META_WS_P_EXPLOSIONDELAY)\r
	@ApiLevel=4\r
	@ScriptName=EffectDuration\r
	@Tip = %(T_49_META_TYP_192_I3_D)\r
    EffectTime : Float = -192003 #%(T_46_META_WS_P_EFFECTDURATION)\r
	@ApiLevel=4\r
	@ScriptName=Skin\r
	@Tip = %(T_49_META_TYP_174_I9_D)\r
    AssetConfigID : WeaponSkinID = -192004 #%(T_46_META_WS_P_SKIN)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=OverloadByPlayerConfiguration\r
	@Tip = %(T_49_META_TYP_79_I28_D)\r
    OverloadByPlayerWeaponSkin : Bool = -192005 #%(T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Landmine\r
@Tip = %(T_49_META_TYPE_194_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type Landmine : InventoryBase&FormulableEntity = 194 { #%(T_46_META_WS_C_LANDMINE)\r
	@ApiLevel=4\r
	@ScriptName=StartTime\r
	@Tip = %(T_49_META_TYP_194_I0_D)\r
    StartTime : Float = -194000 #%(T_46_META_WS_P_STARTTIME)\r
	@ApiLevel=4\r
	@ScriptName=TriggerRadius\r
	@Tip = %(T_49_META_TYP_194_I1_D)\r
    TriggerRadius : Float = -194001 #%(T_46_META_WS_P_TRIGGERRADIUS)\r
	@ApiLevel=4\r
	@ScriptName=TriggerTime\r
	@Tip = %(T_49_META_TYP_194_I2_D)\r
    TriggerTime : Float = -194002 #%(T_46_META_WS_P_TRIGGERTIME)\r
	@ApiLevel=4\r
	@ScriptName=CanTriggeredbySelf\r
	@Tip = %(T_49_META_TYP_194_I3_D)\r
    CanSelfTrigger : Bool = -194003 #%(T_46_META_WS_P_CANTRIGGEREDBY SELF)\r
	@ApiLevel=4\r
	@ScriptName=CanTriggeredbyTeam\r
	@Tip = %(T_49_META_TYP_194_I4_D)\r
    CanTeamTrigger : Bool = -194004 #%(T_46_META_WS_P_CANTRIGGEREDBY TEAM)\r
	@ApiLevel=4\r
	@ScriptName=CanTriggeredbyVehicle\r
	@Tip = %(T_49_META_TYP_194_I5_D)\r
    CanVehicleTrigger : Bool = -194005 #%(T_46_META_WS_P_CANTRIGGEREDBY VEHICLE)\r
	@ApiLevel=4\r
	@ScriptName=LifeTime\r
	@Tip = %(T_49_META_TYP_194_I6_D)\r
    LifeTime : Float = -194006 #%(T_46_META_WS_P_LIFETIME)\r
	@ApiLevel=4\r
	@ScriptName=IsAttackable\r
	@Tip = %(T_49_META_TYP_194_I7_D)\r
    CanBeAttacked : Bool = -194007 #%(T_46_META_WS_P_ISATTACKABLE)\r
	@ApiLevel=4\r
	@ScriptName=MaxHP\r
	@Tip = %(T_49_META_TYP_194_I8_D)\r
    MaxHP : Int = -194008 #%(T_46_META_WS_P_MAXHP)\r
	@ApiLevel=4\r
	@ScriptName=SelfDamageFactor\r
	@Tip = %(T_49_META_TYP_174_I6_D)\r
    RatioSelf : Float = -194009 #%(T_46_META_WS_P_SELFDAMAGEFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=TeammateDamageFactor\r
	@Tip = %(T_49_META_TYP_174_I7_D)\r
    RatioTeammate : Float = -194010 #%(T_46_META_WS_P_TEAMMATEDAMAGEFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=VehicleDamageFactor\r
	@Tip = %(T_49_META_TYP_174_I8_D)\r
    RatioVehicle : Float = -194011 #%(T_46_META_WS_P_VEHICLEDAMAGEFACTOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TweenStyle\r
@Tip = %(T_49_META_TYPE_195_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
enum TweenStyle : Int = 195 { #%(T_46_META_WS_C_TWEENSTYLE)\r
	@ApiLevel=4\r
	@ScriptName=Once\r
	@Tip = %(T_49_META_TYP_195_I0_D)\r
    Once = 1 #%(T_46_META_WS_E_ONCE)\r
	@ApiLevel=4\r
	@ScriptName=Loop\r
	@Tip = %(T_49_META_TYP_30_I34_D)\r
    Loop = 2 #%(T_46_META_WS_E_LOOP)\r
	@ApiLevel=4\r
	@ScriptName=PingPong\r
	@Tip = %(T_49_META_TYP_195_I2_D)\r
    PingPong = 3 #%(T_46_META_WS_E_PINGPONG)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=TweenCurve_Deprecated\r
@Tip = %(T_49_META_TYPE_18_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
type TweenCurve : Entity = 196 { #%(T_46_META_WS_C_TWEENCURVE_DEPRECATED)\r
	@ApiLevel=4\r
	@ScriptName=ControlPoints\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    get ControlPoints : ListT_Float = -196000 #%(T_46_META_WS_P_CONTROLPOINTS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Tween\r
@Tip = %(T_49_META_TYPE_203_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
type Tween : Playable = 203 { #%(T_46_META_WS_C_TWEEN)\r
	@ApiLevel=4\r
	@ScriptName=Target\r
	@Tip = %(T_49_META_TYP_203_I0_D)\r
    TargetEntity : Entity = -203000 #%(T_43_YU_WS_TARGET)\r
	@ApiLevel=4\r
	@ScriptName=PropID\r
	@Tip = %(T_49_META_TYP_203_I1_D)\r
    PropID : Property = -203001 #%(T_46_META_WS_P_PROPID)\r
	@ApiLevel=10\r
	@ScriptName=SrcVal\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    SrcVal : ListT_Float = -203002 #%(T_46_META_WS_P_SRCVAL)\r
	@ApiLevel=10\r
	@ScriptName=DestVal\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    DestVal : ListT_Float = -203003 #%(T_46_META_WS_P_DESTVAL)\r
	@ApiLevel=4\r
	@ScriptName=TweenStyle\r
	@Tip = %(T_49_META_TYP_203_I4_D)\r
    Style : TweenStyle = -203004 #%(T_46_META_WS_P_TWEENSTYLE)\r
	@ApiLevel=10\r
	@ScriptName=Curve_Deprecated\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Curve : TweenCurve = -203005 #Curve\r
	@ApiLevel=4\r
	@ScriptName=Duration\r
	@Tip = %(T_49_META_TYP_203_I6_D)\r
    Duration : Float = -203006 #%(T_46_META_WS_P_DURATION)\r
	@ApiLevel=4\r
	@ScriptName=IsReverse\r
	@Tip = %(T_49_META_TYP_203_I7_D)\r
    Reverse : Bool = -203007 #%(T_46_META_WS_P_ISREVERSE)\r
	@ApiLevel=4\r
	@ScriptName=ControlPoints\r
	@Tip = %(T_49_META_TYP_203_I8_D)\r
    ControlPoints : BezierCurve = -203008 #%(T_46_META_WS_P_CONTROLPOINTS)\r
	@ApiLevel=3\r
	@ScriptName=ForceSyncToClient\r
	@Tip = %(T_49_META_TYP_203_I9_D)\r
    get ForceSyncValue : ListT_Float = -203009 #%(T_46_META_WS_P_FORCESYNCTOCLIENT)\r
	@ApiLevel=3\r
	@Tip = %(T_49_META_TYP_203_I10_D)\r
    get StartTickCount : Int = -203010 #StartTickCount\r
	@ApiLevel=4\r
	@ScriptName=StartValue\r
	@Tip = %(T_49_META_TYP_203_I11_D)\r
    StartValue : Object = -203011 #%(T_46_META_WS_P_STARTVALUE)\r
	@ApiLevel=4\r
	@ScriptName=EndValue\r
	@Tip = %(T_49_META_TYP_203_I12_D)\r
    EndValue : Object = -203012 #%(T_46_META_WS_P_ENDVALUE)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_203_I13_D)\r
	@ApiTarget=1\r
    get ElapsedPercentage : Float = -203013 #%(T_47_XXJ_WS_ELAPSEDPERCENTAGE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=JetShoes\r
@Tip = %(T_49_META_TYPE_199_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type JetPack : InventoryBase&FormulableEntity = 199 { #%(T_46_META_WS_C_JETSHOES)\r
	@ApiLevel=4\r
	@ScriptName=MaxEP\r
	@Tip = %(T_49_META_TYP_199_I0_D)\r
    MaxEnergy : Int = -199000 #%(T_46_META_WS_P_MAXEP)\r
	@ApiLevel=4\r
	@ScriptName=EnergyCost\r
	@Tip = %(T_49_META_TYP_199_I1_D)\r
    BaseEnergyCost : Float = -199001 #%(T_46_META_WS_P_ENERGYCOST)\r
	@ApiLevel=4\r
	@ScriptName=UpEnergyCost\r
	@Tip = %(T_49_META_TYP_199_I2_D)\r
    UpChangeEnergyCost : Float = -199002 #%(T_46_META_WS_P_UPENERGYCOST)\r
	@ApiLevel=4\r
	@ScriptName=SprintEnergyCost\r
	@Tip = %(T_49_META_TYP_199_I3_D)\r
    DashEnergyCost : Float = -199003 #%(T_46_META_WS_P_SPRINTENERGYCOST)\r
	@ApiLevel=4\r
	@ScriptName=RushEnergyCost\r
	@Tip = %(T_49_META_TYP_199_I4_D)\r
    RushEnergyCost : Float = -199004 #%(T_46_META_WS_P_RUSHENERGYCOST)\r
	@ApiLevel=4\r
	@ScriptName=BaseHorizontalSpeed\r
	@Tip = %(T_49_META_TYP_199_I5_D)\r
    BaseHSpeed : Float = -199005 #%(T_46_META_WS_P_BASEHORIZONTALSPEED)\r
	@ApiLevel=4\r
	@ScriptName=SprintHorizontalSpeed\r
	@Tip = %(T_49_META_TYP_199_I6_D)\r
    DashHSpeed : Float = -199006 #%(T_46_META_WS_P_SPRINTHORIZONTALSPEED)\r
	@ApiLevel=4\r
	@ScriptName=BaseVerticalSpeed\r
	@Tip = %(T_49_META_TYP_199_I7_D)\r
    BaseVSpeed : Float = -199007 #%(T_46_META_WS_P_BASEVERTICALSPEED)\r
	@ApiLevel=4\r
	@ScriptName=RushVerticalSpeed\r
	@Tip = %(T_49_META_TYP_199_I8_D)\r
    RushVSpeed : Float = -199008 #%(T_46_META_WS_P_RUSHVERTICALSPEED)\r
	@ApiLevel=4\r
	@ScriptName=RushDistance\r
	@Tip = %(T_49_META_TYP_199_I9_D)\r
    DistanceToReady : Float = -199009 #%(T_46_META_WS_P_RUSHDISTANCE)\r
	@ApiLevel=4\r
	@ScriptName=FallingDamageRatio\r
	@Tip = %(T_49_META_TYP_199_I10_D)\r
    FallingDamageScale : Float = -199010 #%(T_46_META_WS_P_FALLINGDAMAGERATIO)\r
	@ApiLevel=4\r
	@ScriptName=CurrentEnergy\r
	@Tip = %(T_49_META_TYP_199_I11_D)\r
    CurEnergy : Float = -199011 #%(T_46_META_WS_P_CURRENTENERGY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WaterZone\r
@Tip = %(T_49_META_TYPE_201_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type WaterZone : CustomizeTrigger = 201 { #%(T_46_META_WS_C_WATERZONE)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=DecelerationPercent\r
	@Tip = %(T_49_META_TYP_201_I0_D)\r
    DecelerationRatio : Int = -201000 #%(T_46_META_WS_P_DECELERATIONPERCENT)\r
}\r
\r
@ApiLevel=3\r
@ScriptName=JailBreakArea\r
@Tip = %(T_49_META_TYPE_200_D)\r
@ModuleID=10009\r
@ModuleLib=Other\r
type JailBreakArea : CustomizeTrigger = 200 { #%(T_40_XXJ_WS_JAILBREAKAREA_NAMEKEY)\r
	@ApiLevel=3\r
	@ScriptName=Area\r
	@Tip = %(T_49_META_TYP_200_I0_D)\r
    get JailBreakAreaID : Int = -200000 #JailBreakAreaID\r
	@ApiLevel=3\r
	@ScriptName=Game\r
	@Tip = %(T_49_META_TYP_200_I1_D)\r
    get JailBreakGameID : Int = -200001 #%(T_46_META_WS_A_GAMEID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CustomLevelObject\r
@Tip = %(T_49_META_TYPE_186_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type CustomLevelObject : LevelObject = 186 { #%(T_46_META_WS_C_CUSTOMLEVELOBJECT)\r
	@ApiLevel=11\r
	@ScriptName=ColliderID\r
	@Tip = %(T_49_META_TYPE_202_D)\r
    ColliderID : ColliderID = -186000 #%(T_46_META_WS_P_COLLIDERID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=NPC\r
@Tip = %(T_49_META_TYPE_413_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type NPC : CustomLevelObject = 413 { #%(T_46_META_WS_C_NPC)\r
	@ApiLevel=3\r
	@ScriptName=TransformClothInfo\r
	@Tip = %(T_49_META_TYP_413_I0_D)\r
    get TransformClothInfo : TransformClothInfo = -413000 #TransformClothInfo\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DoubleJumpShoes\r
@Tip = %(T_49_META_TYPE_204_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type DoubleJumpShoes : InventoryBase&FormulableEntity = 204 { #%(T_46_META_WS_C_DOUBLEJUMPSHOES)\r
	@ApiLevel=4\r
	@ScriptName=MaxJumpHeight\r
	@Tip = %(T_49_META_TYP_204_I0_D)\r
    MaxJumpHeight : Float = -204000 #%(T_46_META_WS_P_MAXJUMPHEIGHT)\r
	@ApiLevel=4\r
	@ScriptName=FallingDamageRatio\r
	@Tip = %(T_49_META_TYP_204_I1_D)\r
    DamageReduce : Float = -204001 #%(T_46_META_WS_P_FALLINGDAMAGERATIO)\r
	@ApiLevel=4\r
	@ScriptName=EnergyRecovery\r
	@Tip = %(T_49_META_TYP_204_I2_D)\r
    EnergyRecovery : Int = -204002 #%(T_46_META_WS_P_ENERGYRECOVERY)\r
	@ApiLevel=4\r
	@ScriptName=EnergyCost\r
	@Tip = %(T_49_META_TYP_204_I3_D)\r
    JumpConsume : Int = -204003 #%(T_46_META_WS_P_ENERGYCOST)\r
	@ApiLevel=4\r
	@ScriptName=MaxEnergy\r
	@Tip = %(T_49_META_TYP_204_I4_D)\r
    MaxEnergy : Int = -204004 #%(T_46_META_WS_P_MAXENERGY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=FoldWing\r
@Tip = %(T_49_META_TYPE_205_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type FoldWing : InventoryBase&FormulableEntity = 205 { #%(T_46_META_WS_C_FOLDWING)\r
	@ApiLevel=4\r
	@ScriptName=MinFlyHeight\r
	@Tip = %(T_49_META_TYP_205_I0_D)\r
    MinFlyHeight : Float = -205000 #%(T_46_META_WS_P_MINFLYHEIGHT)\r
	@ApiLevel=4\r
	@ScriptName=MinEndHeight\r
	@Tip = %(T_49_META_TYP_205_I1_D)\r
    MinEndHeight : Float = -205001 #%(T_46_META_WS_P_MINENDHEIGHT)\r
	@ApiLevel=4\r
	@ScriptName=FlySpeedHorizontal\r
	@Tip = %(T_49_META_TYP_205_I2_D)\r
    FlySpeedHorizontal : Float = -205002 #%(T_46_META_WS_P_FLYSPEEDHORIZONTAL)\r
	@ApiLevel=4\r
	@ScriptName=FlySpeedVertical\r
	@Tip = %(T_49_META_TYP_205_I3_D)\r
    FlySpeedVertical : Float = -205003 #%(T_46_META_WS_P_FLYSPEEDVERTICAL)\r
	@ApiLevel=4\r
	@ScriptName=FallSpeed\r
	@Tip = %(T_49_META_TYP_205_I4_D)\r
    FallSpeed : Float = -205004 #%(T_46_META_WS_P_FALLSPEED)\r
	@ApiLevel=4\r
	@ScriptName=TurnSpeed\r
	@Tip = %(T_49_META_TYP_205_I5_D)\r
    TurnSpeed : Float = -205005 #%(T_46_META_WS_P_TURNSPEED)\r
	@ApiLevel=4\r
	@ScriptName=FlyMaxHeight\r
	@Tip = %(T_49_META_TYP_205_I6_D)\r
    FlyMaxHeight : Float = -205006 #%(T_46_META_WS_P_FLYMAXHEIGHT)\r
	@ApiLevel=4\r
	@ScriptName=OverheightFallSpeed\r
	@Tip = %(T_49_META_TYP_205_I7_D)\r
    OverheightFallSpeed : Float = -205007 #%(T_46_META_WS_P_OVERHEIGHTFALLSPEED)\r
	@ApiLevel=4\r
	@ScriptName=Acceleration\r
	@Tip = %(T_49_META_TYP_205_I8_D)\r
    AcceleratedSpeed : Float = -205008 #%(T_46_META_WS_P_ACCELERATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Skateboard\r
@Tip = %(T_49_META_TYPE_206_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type Skateboard : InventoryBase&FormulableEntity = 206 { #%(T_46_META_WS_C_SKATEBOARD)\r
	@ApiLevel=4\r
	@ScriptName=Speed\r
	@Tip = %(T_49_META_TYP_206_I0_D)\r
    Speed : Float = -206000 #%(T_46_META_WS_P_SPEED)\r
	@ApiLevel=4\r
	@ScriptName=Accelerate\r
	@Tip = %(T_49_META_TYP_206_I1_D)\r
    Accelerate : Float = -206001 #%(T_46_META_WS_P_ACCELERATE)\r
	@ApiLevel=4\r
	@ScriptName=BoostSpeed\r
	@Tip = %(T_49_META_TYP_206_I2_D)\r
    BoostSpeed : Float = -206002 #%(T_46_META_WS_P_BOOSTSPEED)\r
	@ApiLevel=4\r
	@ScriptName=BoostDuration\r
	@Tip = %(T_49_META_TYP_206_I3_D)\r
    BoostDuration : Float = -206003 #%(T_46_META_WS_P_BOOSTDURATION)\r
	@ApiLevel=4\r
	@ScriptName=BoostCD\r
	@Tip = %(T_49_META_TYP_206_I4_D)\r
    BoostCooldown : Float = -206004 #%(T_46_META_WS_P_BOOSTCD)\r
	@ApiLevel=4\r
	@ScriptName=JumpHeight\r
	@Tip = %(T_49_META_TYP_399_I0_D)\r
    JumpHeight : Float = -206005 #%(T_46_META_WS_P_JUMPHEIGHT)\r
	@ApiLevel=4\r
	@ScriptName=JumpCD\r
	@Tip = %(T_49_META_TYP_206_I6_D)\r
    HBJumpCD : Float = -206006 #%(T_46_META_WS_P_JUMPCD)\r
	@ApiLevel=4\r
	@ScriptName=GetOnBoostCD\r
	@Tip = %(T_49_META_TYP_206_I7_D)\r
    HBBoostInitial : Float = -206007 #%(T_46_META_WS_P_GETONBOOSTCD)\r
	@ApiLevel=4\r
	@ScriptName=GetOnBoostCDSwitch\r
	@Tip = %(T_49_META_TYP_206_I8_D)\r
    HBBoostCDSwitch : Bool = -206008 #%(T_46_META_WS_P_GETONBOOSTCDSWITCH)\r
	@ApiLevel=4\r
	@ScriptName=GetOnSkateboardCD\r
	@Tip = %(T_49_META_TYP_206_I9_D)\r
    HoverboardCDMs : Float = -206009 #%(T_46_META_WS_P_GETONSKATEBOARDCD)\r
	@ApiLevel=4\r
	@ScriptName=HighSpeedSteerAngle\r
	@Tip = %(T_49_META_TYP_206_I10_D)\r
    HighSpeedSteerAngle : Float = -206010 #%(T_46_META_WS_P_HIGHSPEEDSTEERANGLE)\r
	@ApiLevel=4\r
	@ScriptName=HighSpeedSteerAngleAtSpeed\r
	@Tip = %(T_49_META_TYP_206_I11_D)\r
    HighSpeedSteerAngleAtSpeed : Float = -206011 #%(T_46_META_WS_P_HIGHSPEEDSTEERANGLEATSPEED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ZipLine\r
@Tip = %(T_49_META_TYPE_207_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type StropShelf : LevelObject&Collider = 207 { #%(T_46_META_WS_C_ZIPLINE)\r
	@ApiLevel=4\r
	@Default=12\r
	@ScriptName=Speed\r
	@Tip = %(T_49_META_TYP_206_I0_D)\r
    Speed : Float = -207000 #%(T_46_META_WS_P_SPEED)\r
	@ApiLevel=4\r
	@ScriptName=StartPosition\r
	@Tip = %(T_49_META_TYP_207_I1_D)\r
    get StartPosition : String = -207001 #%(T_46_META_WS_P_STARTPOSITION)\r
	@ApiLevel=4\r
	@ScriptName=EndPosition\r
	@Tip = %(T_49_META_TYP_207_I2_D)\r
    get EndPosition : String = -207002 #%(T_46_META_WS_P_ENDPOSITION)\r
	@ApiLevel=4\r
	@ScriptName=StropID\r
	@Tip = %(T_49_META_TYP_207_I3_D)\r
    get StropID : Int = -207003 #%(T_46_META_WS_P_STROPID)\r
	@ApiLevel=4\r
	@ScriptName=GroupID\r
	@Tip = %(T_49_META_TYP_207_I4_D)\r
    get GroupID : Int = -207004 #%(T_46_META_WS_P_GROUPID)\r
	@ApiLevel=4\r
	@ScriptName=IsEnd\r
	@Tip = %(T_49_META_TYP_207_I5_D)\r
    get IsEnd : Bool = -207005 #%(T_46_META_WS_P_ISEND)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_Playable\r
@Tip = %(T_49_META_TYPE_208_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_Playable : List = 208 { #%(T_46_META_WS_C_LISTT_PLAYABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayableOrPlayables\r
@Tip = %(T_49_META_TYPE_209_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
alias PlayableOrListPlayable : Object&(Playable|ListT_Playable) = 209 #%(T_46_META_WS_C_PLAYABLEORPLAYABLES)\r
\r
@ApiLevel=4\r
@ScriptName=Trajectory\r
@Tip = %(T_49_META_TYPE_210_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
type PlayableTrajectory : Playable&Loopable = 210 { #%(T_46_META_WS_C_TRAJECTORY)\r
	@ApiLevel=4\r
	@ScriptName=Target\r
	@Tip = %(T_49_META_TYP_203_I0_D)\r
    TargetEntity : Entity = -210000 #%(T_43_YU_WS_TARGET)\r
	@ApiLevel=4\r
	@ScriptName=InitialSpeed\r
	@Tip = %(T_49_META_TYP_210_I1_D)\r
    get InitialVelocity : Vector3 = -210001 #%(T_46_META_WS_P_INITIALSPEED)\r
	@ApiLevel=4\r
	@ScriptName=Acceleration\r
	@Tip = %(T_49_META_TYP_210_I2_D)\r
    get Acceleration : Vector3 = -210002 #%(T_46_META_WS_P_ACCELERATION)\r
	@ApiLevel=4\r
	@ScriptName=MaxDisplacement\r
	@Tip = %(T_49_META_TYP_210_I3_D)\r
    get MaxDisplacement : Float = -210003 #%(T_46_META_WS_P_MAXDISPLACEMENT)\r
	@ApiLevel=3\r
	@ScriptName=InitialWorldPosition\r
	@Tip = %(T_49_META_TYP_210_I4_D)\r
    get InitialWorldPos : Vector3 = -210004 #%(T_46_META_WS_P_INITIALWORLDPOSITION)\r
	@ApiLevel=3\r
	@ScriptName=ForceSyncToClient\r
	@Tip = %(T_49_META_TYP_210_I5_D)\r
    get ForceSyncValue : Vector3 = -210005 #%(T_46_META_WS_P_FORCESYNCTOCLIENT)\r
	@ApiLevel=3\r
	@Tip = %(T_49_META_TYP_203_I10_D)\r
    get StartTickCount : Int = -210006 #StartTickCount\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SelfRelative\r
@Tip = %(T_49_META_TYPE_330_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
type PlayableSelfRelative : Playable = 330 { #%(T_46_META_WS_C_SELFRELATIVE)\r
	@ApiLevel=4\r
	@ScriptName=Target\r
	@Tip = %(T_49_META_TYP_203_I0_D)\r
    TargetEntity : Entity = -330000 #%(T_43_YU_WS_TARGET)\r
	@ApiLevel=4\r
	@ScriptName=PropID\r
	@Tip = %(T_49_META_TYP_203_I1_D)\r
    PropID : Property = -330001 #%(T_46_META_WS_P_PROPID)\r
	@ApiLevel=10\r
	@ScriptName=Delta\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Delta : ListT_Float = -330002 #%(T_46_META_WS_P_DELTA)\r
	@ApiLevel=4\r
	@ScriptName=TweenStyle\r
	@Tip = %(T_49_META_TYP_203_I4_D)\r
    Style : TweenStyle = -330003 #%(T_46_META_WS_P_TWEENSTYLE)\r
	@ApiLevel=4\r
	@ScriptName=Duration\r
	@Tip = %(T_49_META_TYP_330_I4_D)\r
    Duration : Float = -330004 #%(T_46_META_WS_P_DURATION)\r
	@ApiLevel=4\r
	@ScriptName=ControlPoints\r
	@Tip = %(T_49_META_TYP_330_I5_D)\r
    ControlPoints : BezierCurve = -330005 #%(T_46_META_WS_P_CONTROLPOINTS)\r
	@ApiLevel=3\r
	@ScriptName=ForceSyncToClient\r
	@Tip = %(T_49_META_TYP_203_I9_D)\r
    get ForceSyncValue : ListT_Float = -330006 #%(T_46_META_WS_P_FORCESYNCTOCLIENT)\r
	@ApiLevel=3\r
	@Tip = %(T_49_META_TYP_203_I10_D)\r
    get StartTickCount : Int = -330007 #StartTickCount\r
	@ApiLevel=4\r
	@ScriptName=DeltaValue\r
	@Tip = %(T_49_META_TYP_330_I8_D)\r
    DeltaValue : Object = -330008 #%(T_46_META_WS_P_DELTAVALUE)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_203_I13_D)\r
	@ApiTarget=1\r
    get ElapsedPercentage : Float = -330009 #%(T_47_XXJ_WS_ELAPSEDPERCENTAGE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=FrameSelfRelative\r
@Tip = %(T_49_META_TYPE_347_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
type PlayableRelativeFrame : Playable = 347 { #%(T_46_META_WS_C_FRAMESELFRELATIVE)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_203_I0_D)\r
    TargetEntity : Entity = -347000 #%(T_43_YU_WS_TARGET)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_203_I1_D)\r
    PropID : Property = -347001 #%(T_46_META_WS_P_PROPID)\r
	@ApiLevel=10\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Delta : ListT_Float = -347002 #Delta\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=Type\r
	@Tip = %(T_49_META_TYP_347_I3_D)\r
    Switch : Bool = -347003 #%(T_46_META_WS_P_TYPE)\r
	@ApiLevel=3\r
	@Tip = %(T_49_META_TYP_203_I9_D)\r
    get ForceSyncValue : ListT_Float = -347004 #ForceSyncValue\r
	@ApiLevel=3\r
	@Tip = %(T_49_META_TYP_203_I10_D)\r
    get StartTickCount : Int = -347005 #StartTickCount\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_347_I6_D)\r
    DeltaValue : Object = -347006 #%(T_46_META_WS_P_DELTAVALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CoordinateSystemType\r
@Tip = %(T_49_META_TYPE_211_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum CoordinateType : Int = 211 { #%(T_46_META_WS_C_COORDINATESYSTEMTYPE)\r
	@ApiLevel=4\r
	@ScriptName=LocalPosition\r
	@Tip = %(T_49_META_TYP_211_I0_D)\r
    Local = 1 #%(T_46_META_WS_E_LOCALPOSITION)\r
	@ApiLevel=4\r
	@ScriptName=WorldPosition\r
	@Tip = %(T_49_META_TYP_211_I1_D)\r
    World = 2 #%(T_46_META_WS_E_WORLDPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Follow\r
@Tip = %(T_49_META_TYPE_212_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
type PlayablePosFollow : Playable = 212 { #%(T_46_META_WS_C_FOLLOW)\r
	@ApiLevel=4\r
	@ScriptName=Self\r
	@Tip = %(T_49_META_TYP_212_I0_D)\r
    SelfEntity : Entity = -212000 #%(T_46_META_WS_P_SELF)\r
	@ApiLevel=4\r
	@ScriptName=Target\r
	@Tip = %(T_49_META_TYP_2507_I7_D)\r
    TargetEntity : Entity = -212001 #%(T_43_YU_WS_TARGET)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
	@Tip = %(T_49_META_TYP_212_I2_D)\r
    get Offset : Vector3 = -212002 #%(T_46_META_WS_P_OFFSET)\r
	@ApiLevel=4\r
	@ScriptName=CoordinateSystem\r
	@Tip = %(T_49_META_TYPE_211_D)\r
    get CoordinateType : CoordinateType = -212003 #%(T_46_META_WS_P_COORDINATESYSTEM)\r
	@ApiLevel=3\r
	@ScriptName=ForceSyncToClient\r
	@Tip = %(T_49_META_TYP_203_I9_D)\r
    get ForceSyncValue : Vector3 = -212004 #%(T_46_META_WS_P_FORCESYNCTOCLIENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LookAt\r
@Tip = %(T_49_META_TYPE_213_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
type PlayableLookAt : Playable = 213 { #%(T_46_META_WS_C_LOOKAT)\r
	@ApiLevel=4\r
	@ScriptName=Self\r
	@Tip = %(T_49_META_TYP_213_I0_D)\r
    SelfEntity : Entity = -213000 #%(T_46_META_WS_P_SELF)\r
	@ApiLevel=4\r
	@ScriptName=Target\r
	@Tip = %(T_49_META_TYP_2507_I7_D)\r
    TargetEntity : Entity = -213001 #%(T_43_YU_WS_TARGET)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
	@Tip = %(T_49_META_TYP_213_I2_D)\r
    get Offset : Vector3 = -213002 #%(T_46_META_WS_P_OFFSET)\r
	@ApiLevel=4\r
	@ScriptName=CoordinateSystem\r
	@Tip = %(T_49_META_TYPE_211_D)\r
    get CoordinateType : CoordinateType = -213003 #%(T_46_META_WS_P_COORDINATESYSTEM)\r
	@ApiLevel=3\r
	@ScriptName=ForceSyncToClient\r
	@Tip = %(T_49_META_TYP_203_I9_D)\r
    get ForceSyncValue : Vector3 = -213004 #%(T_46_META_WS_P_FORCESYNCTOCLIENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GameResultType\r
@Tip = %(T_49_META_TYPE_215_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum MatchResultType : Int = 215 { #%(T_46_META_WS_C_GAMERESULTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Win\r
	@Tip = %(T_49_META_TYP_215_I0_D)\r
    Win = 1 #%(T_46_META_WS_E_WIN)\r
	@ApiLevel=4\r
	@ScriptName=Lose\r
	@Tip = %(T_49_META_TYP_215_I1_D)\r
    Lose = 2 #%(T_46_META_WS_E_LOSE)\r
	@ApiLevel=4\r
	@ScriptName=Booyah\r
	@Tip = %(T_49_META_TYP_215_I2_D)\r
    Booyah = 3 #%(T_44_L_HIGHLIGHT_BOOYAH)\r
	@ApiLevel=4\r
	@ScriptName=Draw\r
	@Tip = %(T_49_META_TYP_215_I3_D)\r
    Draw = 4 #%(T_46_META_WS_E_DRAW)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PointLight\r
@Tip = %(T_49_META_TYPE_218_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type PointLight : LevelObject = 218 { #%(T_46_META_WS_C_POINTLIGHT)\r
	@ApiLevel=4\r
	@Default=2\r
	@ScriptName=Intensity\r
	@Tip = %(T_49_META_TYP_218_I0_D)\r
    Intensity : Float = -218000 #%(T_46_META_WS_P_INTENSITY)\r
	@ApiLevel=4\r
	@Default=3\r
	@ScriptName=Range\r
	@Tip = %(T_49_META_TYP_218_I1_D)\r
    Range : Float = -218001 #%(T_46_META_WS_P_RANGE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Color\r
	@Tip = %(T_49_META_TYP_218_I2_D)\r
    Color : Color = -218002 #%(T_44_XXJ_WS_COLOR)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_49_META_TYPE_426_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type SpotLight : LevelObject = 426 { #%(T_47_XXJ_WS_SPOTLIGHT)\r
	@ApiLevel=4\r
	@Default=1\r
	@Tip = %(T_49_META_TYP_426_I0_D)\r
    Intensity : Float = -426000 #%(T_46_META_WS_P_INTENSITY)\r
	@ApiLevel=4\r
	@Default=1\r
	@Tip = %(T_49_META_TYP_426_I1_D)\r
    Range : Float = -426001 #%(T_46_META_WS_P_RANGE)\r
	@ApiLevel=4\r
	@Default=30\r
	@Tip = %(T_49_META_TYP_426_I2_D)\r
    SpotAngle : Float = -426002 #%(T_47_XXJ_WS_SPOTANGLE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@Tip = %(T_49_META_TYP_426_I3_D)\r
    Color : Color = -426003 #%(T_44_XXJ_WS_COLOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Motobike\r
@Tip = %(T_49_META_TYPE_219_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type MotobikeVehicle : Car = 219 { #%(T_46_META_WS_C_MOTOBIKE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TukTuk\r
@Tip = %(T_49_META_TYPE_220_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type TutuVehicle : Car = 220 { #%(T_46_META_WS_C_TUKTUK)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Amphibian\r
@Tip = %(T_49_META_TYPE_221_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type BumperVehicle : Car = 221 { #%(T_46_META_WS_C_AMPHIBIAN)\r
	@ApiLevel=4\r
	@ScriptName=GearShiftingDelay\r
	@Tip = %(T_49_META_TYP_221_I0_D)\r
    GearShiftingDelay : Float = -221000 #%(T_46_META_WS_P_GEARSHIFTINGDELAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SportsCar\r
@Tip = %(T_49_META_TYPE_222_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type CarVehicle : Car = 222 { #%(T_46_META_WS_C_SPORTSCAR)\r
	@ApiLevel=4\r
	@ScriptName=GearShiftingDelay\r
	@Tip = %(T_49_META_TYP_222_I0_D)\r
    GearShiftingDelay : Float = -222000 #%(T_46_META_WS_P_GEARSHIFTINGDELAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MiniSentry\r
@Tip = %(T_49_META_TYPE_225_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type MiniSentry : InventoryBase&FormulableEntity = 225 { #%(T_46_META_WS_C_MINISENTRY)\r
	@ApiLevel=4\r
	@ScriptName=Damage\r
	@Tip = %(T_49_META_TYP_225_I0_D)\r
    Damage : Int = -225000 #%(T_46_META_WS_P_DAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=DamageInterval\r
	@Tip = %(T_49_META_TYP_225_I1_D)\r
    Interval : Float = -225001 #%(T_46_META_WS_P_IDAMAGE NTERVAL)\r
	@ApiLevel=4\r
	@ScriptName=Accuracy\r
	@Tip = %(T_49_META_TYP_225_I2_D)\r
    HitChance : Float = -225002 #%(T_46_META_WS_P_ACCURACY)\r
	@ApiLevel=4\r
	@ScriptName=DamageRange\r
	@Tip = %(T_49_META_TYP_225_I3_D)\r
    Range : Float = -225003 #%(T_46_META_WS_P_DAMAGE RANGE)\r
	@ApiLevel=4\r
	@ScriptName=AngularSpeed\r
	@Tip = %(T_49_META_TYP_225_I4_D)\r
    AngleSpeed : Float = -225004 #%(T_46_META_WS_P_ANGULARSPEED)\r
	@ApiLevel=4\r
	@ScriptName=AngleUp\r
	@Tip = %(T_49_META_TYP_225_I5_D)\r
    AngleUp : Float = -225005 #%(T_46_META_WS_P_ANGLEUP)\r
	@ApiLevel=4\r
	@ScriptName=AngleDown\r
	@Tip = %(T_49_META_TYP_225_I6_D)\r
    AngleDown : Float = -225006 #%(T_46_META_WS_P_ANGLEDOWN)\r
	@ApiLevel=4\r
	@ScriptName=MaxHP\r
	@Tip = %(T_49_META_TYP_225_I7_D)\r
    HpMax : Int = -225007 #%(T_46_META_WS_P_MAXHP)\r
	@ApiLevel=4\r
	@ScriptName=LifeTime\r
	@Tip = %(T_49_META_TYP_225_I8_D)\r
    LifeTime : Int = -225008 #%(T_46_META_WS_P_LIFETIME)\r
	@ApiLevel=4\r
	@ScriptName=MaxTurretCount\r
	@Tip = %(T_49_META_TYP_225_I9_D)\r
    MaxCount : Int = -225009 #%(T_46_META_WS_P_MAXTURRETCOUNT)\r
	@ApiLevel=4\r
	@ScriptName=FireAngleLimit\r
	@Tip = %(T_49_META_TYP_225_I10_D)\r
    FireAngle : Float = -225010 #%(T_46_META_WS_P_FIREANGLELIMIT)\r
	@ApiLevel=4\r
	@ScriptName=DefenseRate\r
	@Tip = %(T_49_META_TYP_225_I11_D)\r
    Defense : Float = -225011 #%(T_46_META_WS_P_DEFENSERATE)\r
	@ApiLevel=4\r
	@ScriptName=ArmorPenetration\r
	@Tip = %(T_49_META_TYP_225_I12_D)\r
    BiteArmor : Float = -225012 #%(T_46_META_WS_P_ARMORPENETRATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MiniSentryCreated\r
@Tip = %(T_49_META_TYPE_226_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type MiniSentryObj : LevelObject&MiniSentry&FightingEntity = 226 { #%(T_46_META_WS_C_MINISENTRYCREATED)\r
	@ApiLevel=4\r
	@ScriptName=HP\r
	@Tip = %(T_49_META_TYP_226_I0_D)\r
    Hp : Int = -226000 #%(T_46_META_WS_P_HP)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=EnableAttack\r
	@Tip = %(T_49_META_TYP_226_I1_D)\r
    OpenAttack : Bool = -226001 #%(T_46_META_WS_P_ENABLEATTACK)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ActionType\r
@Tip = %(T_49_META_TYPE_400_D)\r
@ModuleID=10008\r
@ModuleLib=AI\r
enum ActionType : Int = 400 { #%(T_46_META_WS_C_ACTIONTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Active\r
	@Tip = %(T_49_META_TYP_400_I0_D)\r
    Active = 0 #%(T_46_META_WS_E_ACTIVE)\r
	@ApiLevel=4\r
	@ScriptName=Passive\r
	@Tip = %(T_49_META_TYP_400_I1_D)\r
    Passive = 1 #%(T_46_META_WS_E_PASSIVE)\r
	@ApiLevel=4\r
	@ScriptName=NoAttack\r
	@Tip = %(T_49_META_TYP_400_I2_D)\r
    NoAttack = 2 #%(T_46_META_WS_E_NOATTACK)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WidgetType\r
@Tip = %(T_49_META_TYPE_227_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
enum HudWidgetType : Int = 227 { #%(T_46_META_WS_C_WIDGETTYPE)\r
	@ApiLevel=4\r
	@ScriptName=SimpleWidget\r
	@Tip = %(T_49_META_TYP_227_I0_D)\r
    HudEmpty = 0 #%(T_46_META_WS_E_SIMPLEWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=ImageWidget\r
	@Tip = %(T_49_META_TYP_227_I1_D)\r
    HudImage = 1 #%(T_46_META_WS_E_IMAGEWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=LabelWidget\r
	@Tip = %(T_49_META_TYP_227_I2_D)\r
    HudLabel = 2 #%(T_46_META_WS_E_LABELWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=ButtonWidget\r
	@Tip = %(T_49_META_TYP_227_I3_D)\r
    HudButton = 3 #%(T_46_META_WS_E_BUTTONWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=InputLabelWidget\r
	@Tip = %(T_49_META_TYP_227_I4_D)\r
    HudInput = 4 #%(T_46_META_WS_E_INPUTLABLEWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=Panel\r
	@Tip = %(T_49_META_TYP_227_I5_D)\r
    HudPanel = 5 #%(T_46_META_WS_E_PANEL)\r
	@ApiLevel=4\r
	@ScriptName=ScrollPanel\r
	@Tip = %(T_49_META_TYP_227_I6_D)\r
    HudScrollView = 6 #%(T_46_META_WS_E_SCROLLPANEL)\r
	@ApiLevel=4\r
	@ScriptName=Grid\r
	@Tip = %(T_49_META_TYP_227_I7_D)\r
    HudGrid = 7 #%(T_46_META_WS_E_GRID)\r
	@ApiLevel=4\r
	@ScriptName=LayoutWidget\r
	@Tip = %(T_49_META_TYP_227_I8_D)\r
    HudLayout = 8 #%(T_46_META_WS_E_LAYOUTWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=ContainerWidget\r
	@Tip = %(T_49_META_TYP_227_I9_D)\r
    Hud3DContainer = 9 #%(T_46_META_WS_E_CONTAINERWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=TextureWidget\r
	@Tip = %(T_49_META_TYP_227_I10_D)\r
    HudTexture = 10 #%(T_46_META_WS_E_TEXTUREWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=ProfileWidget\r
	@Tip = %(T_49_META_TYP_227_I11_D)\r
    HudProfileInfo = 11 #%(T_46_META_WS_E_PROFILEWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=ToggleWidget\r
	@Tip = %(T_49_META_TYP_227_I12_D)\r
    HudToggle = 12 #%(T_46_META_WS_E_TOGGLEWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=TouchPadWidget\r
	@Tip = %(T_49_META_TYP_227_I13_D)\r
    HudTouchPad = 13 #%(T_46_META_WS_E_TOUCHPADWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=JoystickWidget\r
	@Tip = %(T_49_META_TYP_227_I14_D)\r
    HudJoystick = 14 #%(T_46_META_WS_E_JOYSTICKWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=SocialButtonWidget\r
	@Tip = %(T_49_META_TYP_227_I15_D)\r
    HUDSocialButtonWidget = 15 #%(T_46_META_WS_E_SOCIALBUTTONWIDGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=FillType\r
@Tip = %(T_49_META_TYPE_319_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
enum FillType : Int = 319 { #%(T_46_META_WS_C_FILLTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Simple\r
	@Tip = %(T_49_META_TYP_319_I0_D)\r
    Simple = 0 #%(T_46_META_WS_E_SIMPLE)\r
	@ApiLevel=4\r
	@ScriptName=Sliced\r
	@Tip = %(T_49_META_TYP_319_I1_D)\r
    Sliced = 1 #%(T_46_META_WS_E_SLICED)\r
	@ApiLevel=4\r
	@ScriptName=Tiled\r
	@Tip = %(T_49_META_TYP_319_I2_D)\r
    Tiled = 2 #%(T_46_META_WS_E_TILED)\r
	@ApiLevel=4\r
	@ScriptName=Filled\r
	@Tip = %(T_49_META_TYP_319_I3_D)\r
    Filled = 3 #%(T_46_META_WS_E_FILLED)\r
	@ApiLevel=4\r
	@ScriptName=Fit\r
	@Tip = %(T_49_META_TYP_319_I4_D)\r
    Fit = 5 #%(T_46_META_WS_E_FIT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=FillDirectionType\r
@Tip = %(T_49_META_TYPE_320_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
enum FillDir : Int = 320 { #%(T_46_META_WS_C_FILLDIRECTIONTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Horizontal\r
	@Tip = %(T_49_META_TYP_320_I0_D)\r
    Horizontal = 0 #%(T_46_META_WS_E_HORIZONTAL)\r
	@ApiLevel=4\r
	@ScriptName=Vertical\r
	@Tip = %(T_49_META_TYP_320_I1_D)\r
    Vertical = 1 #%(T_46_META_WS_E_VERTICAL)\r
	@ApiLevel=4\r
	@ScriptName=Radial90\r
	@Tip = %(T_49_META_TYP_320_I2_D)\r
    Radial90 = 2 #%(T_46_META_WS_E_RADIAL90)\r
	@ApiLevel=4\r
	@ScriptName=Radial180\r
	@Tip = %(T_49_META_TYP_320_I3_D)\r
    Radial180 = 3 #%(T_46_META_WS_E_RADIAL180)\r
	@ApiLevel=4\r
	@ScriptName=Radial360\r
	@Tip = %(T_49_META_TYP_320_I4_D)\r
    Radial360 = 4 #%(T_46_META_WS_E_RADIAL360)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LayoutSortType\r
@Tip = %(T_49_META_TYPE_405_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
enum LayoutSortType : Int = 405 { #%(T_46_META_WS_C_LAYOUTSORTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=ByHierarchy\r
	@Tip = %(T_49_META_TYP_405_I0_D)\r
    SortByHierarchy = 0 #%(T_46_META_WS_E_BYHIERARCHY)\r
	@ApiLevel=4\r
	@ScriptName=SortByPriorityHighToLow\r
	@Tip = %(T_49_META_TYP_405_I1_D)\r
    SortByPriorityHighToLow = 1 #%(T_46_META_WS_E_SORTBYPRIORITYHIGHTOLOW)\r
	@ApiLevel=4\r
	@ScriptName=SortByPriorityLowToHigh\r
	@Tip = %(T_49_META_TYP_405_I2_D)\r
    SortByPriorityLowToHigh = 2 #%(T_46_META_WS_E_SORTBYPRIORITYLOWTOHIGH)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=FontType\r
@Tip = %(T_49_META_TYPE_333_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum FontType : String = 333 { #%(T_46_META_WS_C_FONTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=FZLanTingHei\r
	@Tip = %(T_49_META_TYP_333_I0_D)\r
    T_40_WZY_WS_FONT_FF_CN_T = FONT_FF_CN_T #%(T_46_META_WS_E_FZLANTINGHEI)\r
	@ApiLevel=4\r
	@ScriptName=SimplifiedArabic\r
	@Tip = %(T_49_META_TYP_333_I1_D)\r
    T_40_WZY_WS_FONT_SIMPBDO = FONT_SIMPBDO #%(T_46_META_WS_E_SIMPLIFIEDARABIC)\r
	@ApiLevel=4\r
	@ScriptName=NotoNastaliqUrdu\r
	@Tip = %(T_49_META_TYP_333_I2_D)\r
    T_40_WZY_WS_FONT_NOTOSANS = FONT_NOTOSANS #%(T_46_META_WS_E_NOTONASTALIQURDU)\r
	@ApiLevel=4\r
	@ScriptName=GFFLatin\r
	@Tip = %(T_49_META_TYP_333_I3_D)\r
    T_40_WZY_WS_UIFONT_LATIN_BOLD = UIFONT_LATIN_BOLD #%(T_46_META_WS_E_GFFLATIN)\r
	@ApiLevel=4\r
	@ScriptName=AgencyFB\r
	@Tip = %(T_49_META_TYP_333_I4_D)\r
    T_40_WZY_WS_UIFONT_LATIN = UIFONT_LATIN #%(T_46_META_WS_E_AGENCYFB)\r
	@ApiLevel=4\r
	@ScriptName=Supermarket\r
	@Tip = %(T_49_META_TYP_333_I5_D)\r
    T_40_WZY_WS_FONT_SUPERMARKET = FONT_SUPERMARKET #%(T_46_META_WS_E_SUPERMARKET)\r
	@ApiLevel=4\r
	@ScriptName=HindSiliguri\r
	@Tip = %(T_49_META_TYP_333_I6_D)\r
    T_40_WZY_WS_FONT_HINDSILIGURI = FONT_HINDSILIGURI #%(T_46_META_WS_E_HINDSILIGURI)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OverflowType\r
@Tip = %(T_50_META_TYP_451_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum FondOverFlowMod : Int = 451 { #%(T_50_META_TYP_451)\r
	@ApiLevel=4\r
	@Tip = %(T_50_HJ_OVERFLOW_SHRINKCONTENT)\r
    Shrink = 0 #%(T_50_HJ_OVERFLOW_SHRINKCONTENT)\r
	@ApiLevel=4\r
	@Tip = %(T_50_HJ_OVERFLOW_RESIZEHEIGHT)\r
    Clamp = 1 #%(T_50_HJ_OVERFLOW_RESIZEHEIGHT)\r
	@ApiLevel=4\r
	@Tip = %(T_50_HJ_OVERFLOW_RESIZEFREELY)\r
    ResizeFreely = 2 #%(T_50_HJ_OVERFLOW_RESIZEFREELY)\r
}\r
\r
@ApiLevel=11\r
@ScriptName=MonsterAttackTargetType\r
@Tip = %(T_49_META_TYPE_375_D)\r
@ModuleID=10008\r
@ModuleLib=AI\r
enum AIAttackTargetType : Int = 375 { #%(T_40_XXJ_WS_MONSTERATTACKTARGETTYPE_NAMEKEY)\r
	@ApiLevel=4\r
	@ScriptName=Player\r
	@Tip = %(T_49_META_TYP_30_I57_D)\r
    Player = 0 #Player\r
	@ApiLevel=4\r
	@ScriptName=FightingEntity\r
	@Tip = %(T_49_META_TYP_375_I1_D)\r
    FightingEntity = 1 #FightingEntity\r
}\r
\r
@ApiLevel=11\r
@ScriptName=MiniSentryAttackTargetType\r
@Tip = %(T_49_META_TYPE_376_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum MiniSentryAttackTargetType : Int = 376 { #MiniSentryAttackTargetType\r
	@ApiLevel=4\r
	@ScriptName=Player\r
	@Tip = %(T_49_META_TYP_30_I57_D)\r
    Player = 0 #%(T_46_META_WS_E_PLAYER)\r
	@ApiLevel=4\r
	@ScriptName=FightingEntity\r
	@Tip = %(T_49_META_TYP_376_I1_D)\r
    FightingEntity = 1 #%(T_46_META_WS_E_FIGHTINGENTITY)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=RaycastLayerType\r
@Tip = %(T_49_META_TYPE_18_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
enum RayCastLayerType : Int = 228 { #%(T_46_META_WS_C_RAYCASTLAYERTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Static\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Static = 0 #%(T_46_META_WS_E_STATIC)\r
	@ApiLevel=4\r
	@ScriptName=Charactor\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Charactor = 1 #%(T_46_META_WS_E_CHARACTOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RepairKit\r
@Tip = %(T_49_META_TYPE_231_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type RepairArmorKit : InventoryBase&FormulableEntity = 231 { #%(T_46_META_WS_C_REPAIRKIT)\r
	@ApiLevel=4\r
	@ScriptName=DurabilityRecovery\r
	@Tip = %(T_49_META_TYP_231_I0_D)\r
    Health : Int = -231000 #%(T_46_META_WS_P_DURABILITYRECOVERY)\r
	@ApiLevel=4\r
	@ScriptName=EffectiveTimeInterval\r
	@Tip = %(T_49_META_TYP_231_I1_D)\r
    PreTime : Float = -231001 #%(T_46_META_WS_P_EFFECTIVETIMEINTERVAL)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=PlayerBonesType_Deprecated\r
@Tip = %(T_49_META_TYPE_18_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
enum PlayerBonesType : Int = 232 { #%(T_40_XXJ_WS_SKELETON)\r
	@ApiLevel=4\r
	@ScriptName=Head\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Head = 1 #%(T_41_XXJ_WS_HEAD)\r
	@ApiLevel=4\r
	@ScriptName=Body\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Body = 2 #%(T_41_XXJ_WS_BODY)\r
	@ApiLevel=4\r
	@ScriptName=Limb\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    Limb = 3 #%(T_41_XXJ_WS_LIMB)\r
}\r
\r
@ApiLevel=3\r
@ScriptName=UIProgressCircle\r
@Tip = %(T_49_META_TYPE_233_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type ProgressCircleHud : InternalHud = 233 { #%(T_46_META_WS_C_UIPROGRESSCIRCLE)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -233000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=3\r
	@Default=5\r
	@ScriptName=Duration\r
	@Tip = %(T_49_META_TYP_1021_I2_D)\r
    DurationTimeS : Int = -233001 #%(T_46_META_WS_P_DURATION)\r
	@ApiLevel=3\r
	@Default=0\r
	@ScriptName=EndTimeS\r
	@Tip = %(T_49_META_TYP_233_I2_D)\r
    EndTimeS : Int = -233002 #%(T_46_META_WS_P_ENDTIMES)\r
	@ApiLevel=3\r
	@Default=math.Vector3_1()\r
	@ScriptName=Offset\r
	@Tip = %(T_49_META_TYP_1010_I4_D)\r
    Offset : Vector3 = -233003 #%(T_46_META_WS_P_OFFSET)\r
	@ApiLevel=3\r
	@Default=UI_icon_FirstAidKit\r
	@ScriptName=Icon\r
	@Tip = %(T_49_META_TYP_233_I4_D)\r
    Icon : String = -233004 #%(T_46_META_WS_P_ICON)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LandmineCreated\r
@Tip = %(T_49_META_TYPE_234_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type LandmineObj : InventoryBase&FormulableEntity = 234 { #%(T_46_META_WS_C_LANDMINECREATED)\r
	@ApiLevel=4\r
	@ScriptName=TriggerTime\r
	@Tip = %(T_49_META_TYP_234_I0_D)\r
    TriggerTime : Float = -234000 #%(T_46_META_WS_P_TRIGGERTIME)\r
	@ApiLevel=4\r
	@ScriptName=CanSelfTrigger\r
	@Tip = %(T_49_META_TYP_234_I1_D)\r
    CanSelfTrigger : Bool = -234001 #%(T_46_META_WS_P_CANSELFTRIGGER)\r
	@ApiLevel=4\r
	@ScriptName=CanTeamTrigger\r
	@Tip = %(T_49_META_TYP_234_I2_D)\r
    CanTeamTrigger : Bool = -234002 #%(T_46_META_WS_P_CANTEAMTRIGGER)\r
	@ApiLevel=4\r
	@ScriptName=CanVehicleTrigger\r
	@Tip = %(T_49_META_TYP_234_I3_D)\r
    CanVehicleTrigger : Bool = -234003 #%(T_46_META_WS_P_CANVEHICLETRIGGER)\r
	@ApiLevel=4\r
	@ScriptName=Duration\r
	@Tip = %(T_49_META_TYP_234_I4_D)\r
    LifeTime : Float = -234004 #%(T_46_META_WS_P_DURATION)\r
	@ApiLevel=4\r
	@ScriptName=IsAttackable\r
	@Tip = %(T_49_META_TYP_234_I5_D)\r
    CanBeAttacked : Bool = -234005 #%(T_46_META_WS_P_ISATTACKABLE)\r
	@ApiLevel=4\r
	@ScriptName=MaxHP\r
	@Tip = %(T_49_META_TYP_234_I6_D)\r
    MaxHP : Int = -234006 #%(T_46_META_WS_P_MAXHP)\r
	@ApiLevel=4\r
	@ScriptName=SelfDamageFactor\r
	@Tip = %(T_49_META_TYP_174_I6_D)\r
    RatioSelf : Float = -234007 #%(T_46_META_WS_P_SELFDAMAGEFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=TeammateDamageFactor\r
	@Tip = %(T_49_META_TYP_174_I7_D)\r
    RatioTeammate : Float = -234008 #%(T_46_META_WS_P_TEAMMATEDAMAGEFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=VehicleDamageFactor\r
	@Tip = %(T_49_META_TYP_174_I8_D)\r
    RatioVehicle : Float = -234009 #%(T_46_META_WS_P_VEHICLEDAMAGEFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=HP\r
	@Tip = %(T_49_META_TYP_234_I10_D)\r
    Hp : Int = -234010 #%(T_46_META_WS_P_HP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IceWall\r
@Tip = %(T_49_META_TYPE_235_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type IceWall : InventoryBase&FormulableEntity = 235 { #%(T_46_META_WS_C_ICEWALL)\r
	@ApiLevel=4\r
	@ScriptName=MaxHP\r
	@Tip = %(T_49_META_TYP_235_I0_D)\r
    MaxHP : Int = -235000 #%(T_46_META_WS_P_MAXHP)\r
	@ApiLevel=4\r
	@ScriptName=Duration\r
	@Tip = %(T_49_META_TYP_234_I4_D)\r
    LifeTime : Float = -235001 #%(T_46_META_WS_P_DURATION)\r
	@ApiLevel=4\r
	@ScriptName=MaxCount\r
	@Tip = %(T_49_META_TYP_235_I2_D)\r
    MaxCount : Int = -235002 #%(T_46_META_WS_P_MAXCOUNT)\r
	@ApiLevel=4\r
	@ScriptName=Skin\r
	@Tip = %(T_49_META_TYP_174_I9_D)\r
    AssetConfigID : WeaponSkinID = -235003 #%(T_46_META_WS_P_SKIN)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=OverloadByPlayerConfiguration\r
	@Tip = %(T_49_META_TYP_79_I28_D)\r
    OverloadByPlayerWeaponSkin : Bool = -235004 #%(T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IceWallCreated\r
@Tip = %(T_49_META_TYPE_236_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type IceWallObj : InventoryBase&FormulableEntity = 236 { #%(T_46_META_WS_C_ICEWALLCREATED)\r
	@ApiLevel=4\r
	@ScriptName=Duration\r
	@Tip = %(T_49_META_TYP_234_I4_D)\r
    LifeTime : Float = -236000 #%(T_46_META_WS_P_DURATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=HookGun\r
@Tip = %(T_49_META_TYPE_237_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type GrapplingHookGun : Weapon = 237 { #%(T_46_META_WS_C_HOOKGUN)\r
	@ApiLevel=4\r
	@ScriptName=ThrowSpeed\r
	@Tip = %(T_49_META_TYP_237_I0_D)\r
    ThrowSpeed : Float = -237000 #%(T_46_META_WS_P_THROWSPEED)\r
	@ApiLevel=4\r
	@ScriptName=PlayerTractionSpeed\r
	@Tip = %(T_49_META_TYP_237_I1_D)\r
    TowSpeed : Float = -237001 #%(T_46_META_WS_P_PLAYERTRACTIONSPEED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SprayGun\r
@Tip = %(T_49_META_TYPE_238_D)\r
@ModuleID=32\r
@ModuleLib=Dyeing\r
type SprayGunComponent : Weapon = 238 { #%(T_46_META_WS_C_SPRAYGUN)\r
	@ApiLevel=4\r
	@ScriptName=SprayColor\r
	@Tip = %(T_49_META_TYP_238_I0_D)\r
    SprayColor : SprayColor = -238000 #%(T_46_META_WS_P_SPRAYCOLOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SprayRifle\r
@Tip = %(T_49_META_TYPE_239_D)\r
@ModuleID=32\r
@ModuleLib=Dyeing\r
type SprayRifle : SprayGunComponent = 239 { #%(T_46_META_WS_C_SPRAYRIFLE)\r
	@ApiLevel=4\r
	@Default=20\r
	@ScriptName=InitialSpeed\r
	@Tip = %(T_49_META_TYP_239_I0_D)\r
    InitialSpeed : Float = -239000 #%(T_46_META_WS_P_INITIALSPEED)\r
	@ApiLevel=4\r
	@Default=&math.Vector3(0, -9.8, 0)\r
	@ScriptName=Acceleration\r
	@Tip = %(T_49_META_TYP_239_I1_D)\r
    Acceleration : Vector3 = -239001 #%(T_46_META_WS_P_ACCELERATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SwingGun\r
@Tip = %(T_49_META_TYPE_241_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type SwingGun : Weapon = 241 { #%(T_46_META_WS_C_SWINGGUN)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=TowSpeed\r
	@Tip = %(T_49_META_TYP_241_I0_D)\r
    TowSpeed : Float = -241000 #%(T_46_META_WS_P_TOWSPEED)\r
	@ApiLevel=4\r
	@Default=3\r
	@ScriptName=SwingingSpeed\r
	@Tip = %(T_49_META_TYP_241_I1_D)\r
    SwingSpeed : Float = -241001 #%(T_46_META_WS_P_SWINGINGSPEED)\r
	@ApiLevel=4\r
	@ScriptName=EnableTraction\r
	@Tip = %(T_49_META_TYP_241_I2_D)\r
    OpenTow : Bool = -241002 #%(T_46_META_WS_P_ENABLETRACTION)\r
	@ApiLevel=4\r
	@ScriptName=EnableSwinging\r
	@Tip = %(T_49_META_TYP_241_I3_D)\r
    OpenSwing : Bool = -241003 #%(T_46_META_WS_P_ENABLESWINGING)\r
	@ApiLevel=4\r
	@ScriptName=AnchorObject\r
	@Tip = %(T_49_META_TYP_241_I4_D)\r
    TargetObject : LevelObject = -241004 #%(T_46_META_WS_P_ANCHOROBJECT)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=SwingExitAcceleration\r
	@Tip = %(T_49_META_TYP_241_I5_D)\r
    LeaveAcceleration : Float = -241005 #%(T_46_META_WS_P_SWINGEXITACCELERATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIScoreBar\r
@Tip = %(T_49_META_TYPE_242_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type ScoreBarHud : InternalHud = 242 { #%(T_46_META_WS_C_UISCOREBAR)\r
	@ApiLevel=4\r
	@ScriptName=LeftColor\r
	@Tip = %(T_49_META_TYP_1012_I5_D)\r
    LeftColor : Color = -242000 #%(T_46_META_WS_P_LEFTCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=RightColor\r
	@Tip = %(T_49_META_TYP_1012_I6_D)\r
    RightColor : Color = -242001 #%(T_46_META_WS_P_RIGHTCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=LeftEffectActive\r
	@Tip = %(T_49_META_TYP_242_I2_D)\r
    LeftEffectActive : Bool = -242002 #%(T_46_META_WS_P_LEFTEFFECTACTIVE)\r
	@ApiLevel=4\r
	@ScriptName=RightEffectActive\r
	@Tip = %(T_49_META_TYP_242_I3_D)\r
    RightEffectActive : Bool = -242003 #%(T_46_META_WS_P_RIGHTEFFECTACTIVE)\r
	@ApiLevel=4\r
	@ScriptName=CentralLineActive\r
	@Tip = %(T_49_META_TYP_242_I4_D)\r
    CentralLineActive : Bool = -242004 #%(T_46_META_WS_P_CENTRALLINEACTIVE)\r
	@ApiLevel=4\r
	@ScriptName=Value\r
	@Tip = %(T_49_META_TYP_242_I5_D)\r
    Value : Float = -242005 #%(T_46_META_WS_P_VALUE)\r
	@ApiLevel=4\r
	@ScriptName=Speed\r
	@Tip = %(T_49_META_TYP_206_I0_D)\r
    Speed : Float = -242006 #%(T_46_META_WS_P_SPEED)\r
	@ApiLevel=4\r
	@ScriptName=NormalizedPosition\r
	@Tip = %(T_49_META_TYP_242_I7_D)\r
    NormalizedPosition : Vector3 = -242007 #%(T_46_META_WS_P_NORMALIZEDPOSITION)\r
	@ApiLevel=4\r
	@ScriptName=CentralLinePosition\r
	@Tip = %(T_49_META_TYP_242_I8_D)\r
    CentralLinePos : Float = -242008 #%(T_46_META_WS_P_CENTRALLINEPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OutfitSlotType\r
@Tip = %(T_49_META_TYPE_243_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
enum WardrobeType : Int = 243 { #%(T_46_META_WS_C_OUTFITSLOTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Top\r
	@Tip = %(T_49_META_TYP_243_I0_D)\r
    Chest = 3 #%(T_46_META_WS_E_TOP)\r
	@ApiLevel=4\r
	@ScriptName=Bottom\r
	@Tip = %(T_49_META_TYP_243_I1_D)\r
    Legs = 4 #%(T_46_META_WS_E_BUTTOM)\r
	@ApiLevel=4\r
	@ScriptName=Shoes\r
	@Tip = %(T_49_META_TYP_243_I2_D)\r
    Feet = 5 #%(T_46_META_WS_E_SHOES)\r
	@ApiLevel=4\r
	@ScriptName=Facepaint\r
	@Tip = %(T_49_META_TYP_243_I3_D)\r
    Face = 8 #%(T_46_META_WS_E_FACEPAINT)\r
	@ApiLevel=4\r
	@ScriptName=Head\r
	@Tip = %(T_49_META_TYP_243_I4_D)\r
    Hair = 11 #%(T_46_META_WS_E_HEAD)\r
	@ApiLevel=4\r
	@ScriptName=Set\r
	@Tip = %(T_49_META_TYP_243_I5_D)\r
    Set = 12 #%(T_46_META_WS_E_SET)\r
	@ApiLevel=4\r
	@ScriptName=Mask\r
	@Tip = %(T_49_META_TYP_243_I6_D)\r
    HeadAdditive = 14 #%(T_46_META_WS_E_MASK)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Text\r
@Tip = %(T_49_META_TYPE_244_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type TextEntity : LevelObject = 244 { #%(T_46_META_WS_C_TEXT)\r
	@ApiLevel=4\r
	@Default=Text\r
	@ScriptName=Content\r
	@Tip = %(T_49_META_TYP_244_I0_D)\r
    TextKey : String = -244000 #%(T_46_META_WS_P_CONTENT)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Color\r
	@Tip = %(T_49_META_TYP_254_I2_D)\r
    Color : Color = -244001 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@ScriptName=FollowTarget\r
	@Tip = %(T_49_META_TYP_244_I2_D)\r
    FollowTarget : Entity = -244002 #%(T_46_META_WS_P_FOLLOWTARGET)\r
	@ApiLevel=4\r
	@ScriptName=IsIgnoreDepth\r
	@Tip = %(T_49_META_TYP_244_I3_D)\r
    IgnoreDepth : Bool = -244003 #%(T_46_META_WS_P_ISIGNOREDEPTH)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsBillboard\r
	@Tip = %(T_49_META_TYP_244_I4_D)\r
    IsBillboard : Bool = -244004 #%(T_46_META_WS_P_ISBILLBOARD)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=IsAlwaysInScreen\r
	@Tip = %(T_49_META_TYP_244_I5_D)\r
    AlwaysInScreen : Bool = -244005 #%(T_46_META_WS_P_ISALWAYSINSCREEN)\r
	@ApiLevel=4\r
	@Default=16\r
	@ScriptName=FontStyle\r
	@Tip = %(T_49_META_TYP_244_I6_D)\r
    FontStyle : Int = -244006 #%(T_46_META_WS_P_FONTSTYLE)\r
	@ApiLevel=4\r
	@Default=UIFONT_LATIN\r
	@ScriptName=FontType\r
	@Tip = %(T_49_META_TYP_244_I7_D)\r
    FontType : FontType = -244007 #%(T_46_META_WS_P_FONTTYPE)\r
	@ApiLevel=4\r
	@Default=48\r
	@ScriptName=FontSize\r
	@Tip = %(T_49_META_TYP_244_I8_D)\r
    FontSize : Int = -244008 #%(T_46_META_WS_P_FONTSIZE)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
	@Tip = %(T_49_META_TYP_1010_I4_D)\r
    Offset : Vector3 = -244009 #%(T_46_META_WS_P_OFFSET)\r
	@ApiLevel=4\r
	@ScriptName=VisiblePlayers\r
	@Tip = %(T_49_META_TYP_244_I10_D)\r
    VisiblePlayers : ListT_Player = -244010 #%(T_46_META_WS_P_VISIBLEPLAYERS)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=Depth\r
	@Tip = %(T_49_META_TYP_244_I11_D)\r
    Depth : Int = -244011 #%(T_46_META_WS_P_DEPTH)\r
	@ApiLevel=4\r
	@Default=100\r
	@Tip = %(T_50_META_TYP_244_I12_D)\r
    Width : Int = -244012 #%(T_46_META_WS_A_WIDTH)\r
	@ApiLevel=4\r
	@Default=100\r
	@Tip = %(T_50_META_TYP_244_I13_D)\r
    Height : Int = -244013 #%(T_46_META_WS_A_HEIGHT)\r
	@ApiLevel=4\r
	@Default=2\r
	@ScriptName=OverflowType\r
	@Tip = %(T_50_META_TYP_244_I14_D)\r
    FondOverFlowMod : FondOverFlowMod = -244014 #%(T_50_META_TYP_451)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Icon\r
@Tip = %(T_49_META_TYPE_245_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type IconEntity : LevelObject = 245 { #%(T_46_META_WS_C_ICON)\r
	@ApiLevel=4\r
	@Default=T_34_M_WS_ICON_SQUARE\r
	@ScriptName=Resource\r
	@Tip = %(T_49_META_TYP_245_I0_D)\r
    IconType : SpriteID = -245000 #%(T_46_META_WS_P_RESOURCE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Color\r
	@Tip = %(T_49_META_TYP_1045_I3_D)\r
    Color : Color = -245001 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@ScriptName=FollowTarget\r
	@Tip = %(T_49_META_TYP_244_I2_D)\r
    FollowTarget : Entity = -245002 #%(T_46_META_WS_P_FOLLOWTARGET)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=IsIgnoreDepth\r
	@Tip = %(T_49_META_TYP_245_I3_D)\r
    IgnoreDepth : Bool = -245003 #%(T_46_META_WS_P_ISIGNOREDEPTH)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=IsAlwaysInScreen\r
	@Tip = %(T_49_META_TYP_245_I4_D)\r
    AlwaysInScreen : Bool = -245004 #%(T_46_META_WS_P_ISALWAYSINSCREEN)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsBillboard\r
	@Tip = %(T_49_META_TYP_245_I5_D)\r
    IsBillboard : Bool = -245005 #%(T_46_META_WS_P_ISBILLBOARD)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=RenderType\r
	@Tip = %(T_49_META_TYP_245_I6_D)\r
    RenderType : Int = -245006 #%(T_46_META_WS_P_RENDERTYPE)\r
	@ApiLevel=4\r
	@Default=100\r
	@ScriptName=Width\r
	@Tip = %(T_49_META_TYP_245_I7_D)\r
    Width : Int = -245007 #%(T_46_META_WS_P_WIDTH)\r
	@ApiLevel=4\r
	@Default=100\r
	@ScriptName=Height\r
	@Tip = %(T_49_META_TYP_416_I3_D)\r
    Height : Int = -245008 #%(T_46_META_WS_P_HEIGHT)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
	@Tip = %(T_49_META_TYP_1010_I4_D)\r
    Offset : Vector3 = -245009 #%(T_46_META_WS_P_OFFSET)\r
	@ApiLevel=4\r
	@ScriptName=VisiblePlayers\r
	@Tip = %(T_49_META_TYP_244_I10_D)\r
    VisiblePlayers : ListT_Player = -245010 #%(T_46_META_WS_P_VISIBLEPLAYERS)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=Depth\r
	@Tip = %(T_49_META_TYP_245_I11_D)\r
    Depth : Int = -245011 #%(T_46_META_WS_P_DEPTH)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SprayColor\r
@Tip = %(T_49_META_TYPE_246_D)\r
@ModuleID=32\r
@ModuleLib=Dyeing\r
enum SprayColor : Int = 246 { #%(T_46_META_WS_C_SPRAYCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=Orange\r
	@Tip = %(T_49_META_TYP_246_I0_D)\r
    Orange = 1 #%(T_46_META_WS_E_ORANGE)\r
	@ApiLevel=4\r
	@ScriptName=Purple\r
	@Tip = %(T_49_META_TYP_246_I1_D)\r
    Purple = 2 #%(T_46_META_WS_E_PURPLE)\r
	@ApiLevel=4\r
	@ScriptName=Red\r
	@Tip = %(T_49_META_TYP_246_I2_D)\r
    Red = 3 #%(T_46_META_WS_E_RED)\r
	@ApiLevel=4\r
	@ScriptName=Green\r
	@Tip = %(T_49_META_TYP_246_I3_D)\r
    Green = 4 #%(T_46_META_WS_E_GREEN)\r
	@ApiLevel=4\r
	@ScriptName=Blue\r
	@Tip = %(T_49_META_TYP_246_I4_D)\r
    Blue = 5 #%(T_46_META_WS_E_BLUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayerUISwitchType\r
@Tip = %(T_49_META_TYPE_247_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
enum PlayerHudSwitchType : Int = 247 { #%(T_40_XXJ_WS_PLAYERUISWITCHTYPE_NAMEKEY)\r
	@ApiLevel=4\r
	@ScriptName=MovingJoystick\r
	@Tip = %(T_49_META_TYP_31_I86_D)\r
    MovementHUD = 1 #%(T_46_META_WS_E_MOVINGJOYSTICK)\r
	@ApiLevel=4\r
	@ScriptName=Sprint\r
	@Tip = %(T_49_META_TYP_247_I1_D)\r
    SprintHUD = 2 #%(T_46_META_WS_E_SPRINT)\r
	@ApiLevel=4\r
	@ScriptName=Attack\r
	@Tip = %(T_49_META_TYP_247_I2_D)\r
    AttackHUD = 3 #%(T_46_META_WS_E_ATTACK)\r
	@ApiLevel=4\r
	@ScriptName=Jump\r
	@Tip = %(T_49_META_TYP_247_I3_D)\r
    JumpHUD = 4 #%(T_46_META_WS_E_JUMP)\r
	@ApiLevel=4\r
	@ScriptName=KillingTips\r
	@Tip = %(T_49_META_TYP_247_I4_D)\r
    KillingTipsHUD = 5 #%(T_46_META_WS_E_KILLINGTIPS)\r
	@ApiLevel=4\r
	@ScriptName=WeaponSlot\r
	@Tip = %(T_49_META_TYP_247_I5_D)\r
    WeaponHUD = 6 #%(T_46_META_WS_E_WEAPONSLOT)\r
	@ApiLevel=4\r
	@ScriptName=MiniMap\r
	@Tip = %(T_49_META_TYP_247_I6_D)\r
    MinMapHUD = 7 #%(T_46_META_WS_E_MINIMAP)\r
	@ApiLevel=4\r
	@ScriptName=Bag\r
	@Tip = %(T_49_META_TYP_247_I7_D)\r
    BagHUD = 8 #%(T_46_META_WS_E_BAG)\r
	@ApiLevel=4\r
	@ScriptName=MedicalProps\r
	@Tip = %(T_49_META_TYP_247_I8_D)\r
    MedicalPropsHUD = 9 #%(T_46_META_WS_E_MEDICALPROPS)\r
	@ApiLevel=4\r
	@ScriptName=Crouch\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    CrouchHUD = 10 #%(T_46_META_WS_E_CROUCH)\r
	@ApiLevel=4\r
	@ScriptName=Prone\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    CreepHUD = 11 #%(T_46_META_WS_E_PRONE)\r
	@ApiLevel=4\r
	@ScriptName=TeammatesInfo\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    TeammatesInfoHUD = 12 #%(T_46_META_WS_E_TEAMMATESINFO)\r
	@ApiLevel=4\r
	@ScriptName=AttackGrenade\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    AttackGrenadeHUD = 13 #%(T_46_META_WS_E_ATTACKGRENADE)\r
	@ApiLevel=4\r
	@ScriptName=DefenceGrenade\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    DefenceGrenadeHUD = 14 #%(T_46_META_WS_E_DEFENCEGRENADE)\r
	@ApiLevel=4\r
	@ScriptName=Emote\r
	@Tip = %(T_49_META_TYP_247_I14_D)\r
    EmotionHUD = 15 #%(T_46_META_WS_E_EMOTE)\r
	@ApiLevel=4\r
	@ScriptName=QuickChat\r
	@Tip = %(T_49_META_TYP_247_I15_D)\r
    QuickChatBtnHUD = 16 #%(T_46_META_WS_E_QUICKCHAT)\r
	@ApiLevel=4\r
	@ScriptName=Pickups\r
	@Tip = %(T_49_META_TYP_247_I16_D)\r
    PickupListHUD = 17 #%(T_46_META_WS_E_PICKUPS)\r
	@ApiLevel=4\r
	@ScriptName=QuickChatShow\r
	@Tip = %(T_49_META_TYP_247_I17_D)\r
    QuickChatShowHUD = 18 #%(T_46_META_WS_E_QUICKCHATSHOW)\r
	@ApiLevel=4\r
	@ScriptName=HP\r
	@Tip = %(T_49_META_TYP_247_I18_D)\r
    HPItemHUD = 19 #%(T_46_META_WS_E_HP)\r
	@ApiLevel=4\r
	@ScriptName=EP\r
	@Tip = %(T_49_META_TYP_247_I19_D)\r
    EPItemHUD = 20 #%(T_46_META_WS_E_EP)\r
	@ApiLevel=4\r
	@ScriptName=Armor\r
	@Tip = %(T_49_META_TYP_247_I20_D)\r
    ArmorHUD = 21 #%(T_46_META_WS_E_ARMOR)\r
	@ApiLevel=4\r
	@ScriptName=Reload\r
	@Tip = %(T_49_META_TYP_247_I21_D)\r
    ReloadBtnHUD = 22 #%(T_46_META_WS_E_RELOAD)\r
	@ApiLevel=4\r
	@ScriptName=SweapWeaponQuick\r
	@Tip = %(T_49_META_TYP_247_I22_D)\r
    SweapWeaponQuickBtnHUD = 23 #%(T_46_META_WS_E_SWEAPWEAPONQUICK)\r
	@ApiLevel=4\r
	@ScriptName=Speaker\r
	@Tip = %(T_49_META_TYP_247_I23_D)\r
    SpeakerBtnHUD = 24 #%(T_46_META_WS_E_SPEAKER)\r
	@ApiLevel=4\r
	@ScriptName=MicroPhone\r
	@Tip = %(T_49_META_TYP_247_I24_D)\r
    MicroPhoneBtnHUD = 25 #%(T_46_META_WS_E_MICROPHONE)\r
	@ApiLevel=4\r
	@ScriptName=Mark\r
	@Tip = %(T_49_META_TYP_247_I25_D)\r
    MarkBtnHUD = 26 #%(T_46_META_WS_E_MARK)\r
	@ApiLevel=10\r
	@ScriptName=Settings\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    SettingsBtnHUD = 27 #%(T_46_META_WS_E_SETTINGS)\r
	@ApiLevel=4\r
	@ScriptName=Signal\r
	@Tip = %(T_49_META_TYP_247_I27_D)\r
    SignalIcoHUD = 28 #%(T_46_META_WS_E_SIGNAL)\r
	@ApiLevel=4\r
	@ScriptName=ActiveSkill\r
	@Tip = %(T_49_META_TYP_247_I28_D)\r
    ActiveSkillBtnHUD = 29 #%(T_46_META_WS_E_ACTIVESKILL)\r
	@ApiLevel=4\r
	@ScriptName=Crosshairs\r
	@Tip = %(T_49_META_TYP_247_I29_D)\r
    CrosshairsHUD = 30 #%(T_46_META_WS_E_CROSSHAIRS)\r
	@ApiLevel=4\r
	@ScriptName=PassiveSkill\r
	@Tip = %(T_49_META_TYP_247_I30_D)\r
    PassiveSkillHUD = 31 #%(T_46_META_WS_E_PASSIVESKILL)\r
	@ApiLevel=4\r
	@ScriptName=FPPInspectionHUD\r
    FPPInspectionHUD = 32 #FPPInspectionHUD\r
	@ApiLevel=4\r
	@ScriptName=HelpUpHUD\r
	@Tip = %(T_51_META_TYP_247_I31_D)\r
    HelpUpHud = 33 #%(T_51_META_TYP_247_I31)\r
	@ApiLevel=4\r
	@ScriptName=RescureHUD\r
	@Tip = %(T_51_META_TYP_247_I32_D)\r
    RescureHud = 34 #%(T_51_META_TYP_247_I32)\r
	@ApiLevel=4\r
	@ScriptName=Attack2HUD\r
	@Tip = %(T_51_META_TYP_247_I33_D)\r
    Attack2Hud = 35 #%(T_51_META_TYP_247_I33)\r
	@ApiLevel=4\r
	@ScriptName=CombineWeaponHUD\r
	@Tip = %(T_51_META_TYP_247_I34_D)\r
    CombineWeaponHud = 36 #%(T_51_META_TYP_247_I34)\r
	@ApiLevel=4\r
	@ScriptName=SwimmingSurfHUD\r
	@Tip = %(T_51_META_TYP_247_I35_D)\r
    SwimmingSurfHud = 37 #%(T_51_META_TYP_247_I35)\r
}\r
\r
@ApiLevel=3\r
@ScriptName=UIBuiltInUISwitchController\r
@Tip = %(T_49_META_TYPE_248_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type CommonHudSwitchController : Entity = 248 { #%(T_46_META_WS_C_UIBUILTINUISWITCHCONTROLLER)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Crouch\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    Crouch : CommonHudSwitchValue = -248000 #%(T_46_META_WS_E_CROUCH)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Prone\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    Creep : CommonHudSwitchValue = -248001 #%(T_46_META_WS_E_PRONE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Jump\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    Jump : CommonHudSwitchValue = -248002 #%(T_46_META_WS_E_JUMP)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Fire\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    Fire : CommonHudSwitchValue = -248003 #%(T_46_META_WS_E_ATTACK)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=MovingJoystick\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    MovingJoystick : CommonHudSwitchValue = -248004 #%(T_46_META_WS_E_MOVINGJOYSTICK)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=TeammatesInfo\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    TeammatesInfo : CommonHudSwitchValue = -248005 #%(T_46_META_WS_E_TEAMMATESINFO)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=AttackGrenade\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    AttackGrenade : CommonHudSwitchValue = -248006 #%(T_46_META_WS_E_ATTACKGRENADE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=DefenceGrenade\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    DefenceGrenade : CommonHudSwitchValue = -248007 #%(T_46_META_WS_E_DEFENCEGRENADE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Sprint\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    Speedup : CommonHudSwitchValue = -248008 #%(T_46_META_WS_E_SPRINT)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=KillingTips\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    KillingTips : CommonHudSwitchValue = -248009 #%(T_46_META_WS_E_KILLINGTIPS)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=WeaponSlot\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    WeaponHUD : CommonHudSwitchValue = -248010 #%(T_46_META_WS_E_WEAPONSLOT)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=MiniMap\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    MinMapHUD : CommonHudSwitchValue = -248011 #%(T_46_META_WS_E_MINIMAP)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Bag\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    BagHUD : CommonHudSwitchValue = -248012 #%(T_46_META_WS_E_BAG)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=MedicalProps\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    MedicalPropsHUD : CommonHudSwitchValue = -248013 #%(T_46_META_WS_E_MEDICALPROPS)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Emote\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    EmotionHUD : CommonHudSwitchValue = -248014 #%(T_46_META_WS_E_EMOTE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=QuickChat\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    QuickChatHUD : CommonHudSwitchValue = -248015 #%(T_46_META_WS_E_QUICKCHAT)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Pickups\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    PickupListHUD : CommonHudSwitchValue = -248016 #%(T_46_META_WS_E_PICKUPS)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=QuickChatShow\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    QuickChatShowHUD : CommonHudSwitchValue = -248017 #%(T_46_META_WS_E_QUICKCHATSHOW)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=HP\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    HPItemHUD : CommonHudSwitchValue = -248018 #%(T_46_META_WS_E_HP)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=EP\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    EPItemHUD : CommonHudSwitchValue = -248019 #%(T_46_META_WS_E_EP)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Armor\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    ArmorHUD : CommonHudSwitchValue = -248020 #%(T_46_META_WS_E_ARMOR)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Reload\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    ReloadBtnHUD : CommonHudSwitchValue = -248021 #%(T_46_META_WS_E_RELOAD)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=SweapWeaponQuick\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    SweapWeaponQuickBtnHUD : CommonHudSwitchValue = -248022 #%(T_46_META_WS_E_SWEAPWEAPONQUICK)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Speaker\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    SpeakerBtnHUD : CommonHudSwitchValue = -248023 #%(T_46_META_WS_E_SPEAKER)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=MicroPhone\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    MicroPhoneBtnHUD : CommonHudSwitchValue = -248024 #%(T_46_META_WS_E_MICROPHONE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Mark\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    MarkBtnHUD : CommonHudSwitchValue = -248025 #%(T_46_META_WS_E_MARK)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Settings\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    SettingsBtnHUD : CommonHudSwitchValue = -248026 #%(T_46_META_WS_E_SETTINGS)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=SignalIcon\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    SignalIcoHUD : CommonHudSwitchValue = -248027 #%(T_46_META_WS_E_SIGNAL)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=ActiveSkill\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    ActiveSkillBtnHUD : CommonHudSwitchValue = -248028 #%(T_46_META_WS_E_ACTIVESKILL)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Crosshairs\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    CrosshairsHUD : CommonHudSwitchValue = -248029 #%(T_46_META_WS_E_CROSSHAIRS)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=PassiveSkill\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    PassiveSkillHUD : CommonHudSwitchValue = -248030 #%(T_46_META_WS_E_PASSIVESKILL)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=FPPInspection\r
	@Tip = %(T_49_META_TYP_247_I9_D)\r
    FPPInspectionHUD : CommonHudSwitchValue = -248031 #%(T_45_HJ_CAMERA_INSPECTOR)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=HelpUp\r
    HelpUpHud : CommonHudSwitchValue = -248032 #HelpUpHud\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Rescure\r
    RescureHud : CommonHudSwitchValue = -248033 #RescureHud\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Attack2\r
    Attack2Hud : CommonHudSwitchValue = -248034 #Attack2Hud\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=CombineWeapon\r
    CombineWeaponHud : CommonHudSwitchValue = -248035 #CombineWeaponHud\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=SwimmingSurf\r
    SwimmingSurfHud : CommonHudSwitchValue = -248036 #SwimmingSurfHud\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SwitchEquipSlot\r
@Tip = %(T_49_META_TYPE_249_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
enum SwitchWeaponEquipSlot : Int = 249 { #%(T_46_META_WS_C_SWITCHEQUIPSLOT)\r
	@ApiLevel=4\r
	@ScriptName=PrimaryWeaponA\r
	@Tip = %(T_49_META_TYP_103_I0_D)\r
    PrimaryWeapon1 = 0 #%(T_46_META_WS_E_PRIMARYWEAPONA)\r
	@ApiLevel=4\r
	@ScriptName=PrimaryWeaponB\r
	@Tip = %(T_49_META_TYP_103_I1_D)\r
    PrimaryWeapon2 = 1 #%(T_46_META_WS_E_PRIMARYWEAPONB)\r
	@ApiLevel=4\r
	@ScriptName=SecondaryWeapon\r
	@Tip = %(T_49_META_TYP_103_I2_D)\r
    SecondaryWeapon = 2 #%(T_46_META_WS_E_SECONDARYWEAPON)\r
	@ApiLevel=4\r
	@ScriptName=Grenade\r
	@Tip = %(T_49_META_TYP_249_I3_D)\r
    ExplosiveWeapon = 3 #%(T_46_META_WS_E_GRENADE)\r
	@ApiLevel=4\r
	@ScriptName=Melee\r
	@Tip = %(T_49_META_TYP_30_I76_D)\r
    MeleeWeapon = 4 #%(T_46_META_WS_E_MELEE)\r
	@ApiLevel=4\r
	@ScriptName=HeavyWeapon\r
	@Tip = %(T_49_META_TYP_249_I5_D)\r
    HeavyWeapon = 5 #%(T_46_META_WS_E_HEAVYWEAPON)\r
	@ApiLevel=4\r
	@ScriptName=Flashbang\r
	@Tip = %(T_49_META_TYP_34_I133_D)\r
    FlashBomb = 16 #%(T_46_META_WS_E_FLASHBANG)\r
	@ApiLevel=4\r
	@ScriptName=SmokeGrenade\r
	@Tip = %(T_49_META_TYP_34_I134_D)\r
    SmokeGrenade = 23 #%(T_46_META_WS_E_SMOKEGRENADE)\r
	@ApiLevel=4\r
	@ScriptName=FlashFreeze\r
	@Tip = %(T_49_META_TYP_249_I8_D)\r
    FrozenGrenade = 30 #%(T_46_META_WS_E_FLASHFREEZE)\r
	@ApiLevel=4\r
	@ScriptName=DummyGrenade\r
	@Tip = %(T_49_META_TYP_249_I9_D)\r
    Dummy = 21 #%(T_46_META_WS_E_DUMMYGRENADE)\r
	@ApiLevel=4\r
	@ScriptName=PersonalUAV\r
	@Tip = %(T_49_META_TYP_34_I182_D)\r
    PersonalUAV = 28 #%(T_46_META_WS_E_PERSONALUAV)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Effect\r
@Tip = %(T_49_META_TYPE_250_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type EffectEntity : Playable&Loopable&LevelObject = 250 { #%(T_46_META_WS_C_EFFECT)\r
	@ApiLevel=4\r
	@ScriptName=EffectResID\r
	@Tip = %(T_49_META_TYP_245_I0_D)\r
    EffectType : EffectType = -250000 #%(T_46_META_WS_P_EFFECTRESID)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Color\r
	@Tip = %(T_49_META_TYP_250_I1_D)\r
    Color : Color = -250001 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@Default=100\r
	@ScriptName=PlaySpeed\r
	@Tip = %(T_49_META_TYP_295_I2_D)\r
    PlaySpeed : Int = -250002 #%(T_46_META_WS_P_PLAYSPEED)\r
	@ApiLevel=4\r
	@ScriptName=VFXTextureType\r
	@Tip = %(T_49_META_TYP_250_I3_D)\r
    PresentEffectTexType : TextureID = -250003 #%(T_46_META_WS_P_VFXTEXTURETYPE)\r
	@ApiLevel=4\r
	@ScriptName=DiffuseAlpha\r
	@Tip = %(T_49_META_TYP_250_I4_D)\r
    DiffuseAlpha : Int = -250004 #%(T_46_META_WS_P_DIFFUSEALPHA)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Particles\r
@Addable=["CustomLevelObject"]\r
@Tip = %(T_49_META_TYPE_417_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Particles : Playable&Loopable = 417 { #%(T_48_META_TYP_417)\r
	@ApiLevel=4\r
	@ScriptName=Resource\r
	@Tip = %(T_49_META_TYP_417_I0_D)\r
    ResUUID : ParticlesID = -417000 #%(T_46_META_WS_P_RESOURCE)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_203_I13_D)\r
	@ApiTarget=1\r
    get ElapsedPercentage : Float = -417001 #%(T_47_XXJ_WS_ELAPSEDPERCENTAGE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SprayResultUI\r
@Tip = %(T_49_META_TYPE_252_D)\r
@ModuleID=32\r
@ModuleLib=Dyeing\r
type SprayResultHud : InternalHud = 252 { #%(T_46_META_WS_C_SPRAYRESULTUI)\r
	@ApiLevel=4\r
	@ScriptName=LeftColor\r
	@Tip = %(T_49_META_TYP_1012_I5_D)\r
    LeftColor : Color = -252000 #%(T_46_META_WS_P_LEFTCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=LeftIcon\r
	@Tip = %(T_49_META_TYP_252_I1_D)\r
    LeftIcon : SpriteID = -252001 #%(T_46_META_WS_P_LEFTICON)\r
	@ApiLevel=4\r
	@ScriptName=LeftText\r
	@Tip = %(T_49_META_TYP_252_I2_D)\r
    LeftText : String = -252002 #%(T_46_META_WS_P_LEFTTEXT)\r
	@ApiLevel=4\r
	@ScriptName=LeftScoreText\r
	@Tip = %(T_49_META_TYP_252_I3_D)\r
    LeftScoreText : String = -252003 #%(T_46_META_WS_P_LEFTSCORETEXT)\r
	@ApiLevel=4\r
	@ScriptName=RightColor\r
	@Tip = %(T_49_META_TYP_1012_I6_D)\r
    RightColor : Color = -252004 #%(T_46_META_WS_P_RIGHTCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=RightIcon\r
	@Tip = %(T_49_META_TYP_252_I5_D)\r
    RightIcon : SpriteID = -252005 #%(T_46_META_WS_P_RIGHTICON)\r
	@ApiLevel=4\r
	@ScriptName=RightText\r
	@Tip = %(T_49_META_TYP_252_I6_D)\r
    RightText : String = -252006 #%(T_46_META_WS_P_RIGHTTEXT)\r
	@ApiLevel=4\r
	@ScriptName=RightScoreText\r
	@Tip = %(T_49_META_TYP_252_I7_D)\r
    RightScoreText : String = -252007 #%(T_46_META_WS_P_RIGHTSCORETEXT)\r
	@ApiLevel=4\r
	@ScriptName=Progress\r
	@Tip = %(T_49_META_TYP_252_I8_D)\r
    Progress : Float = -252008 #%(T_46_META_WS_P_PROGRESS)\r
	@ApiLevel=4\r
	@ScriptName=EnableLocalization\r
	@Tip = %(T_49_META_TYP_1012_I1_D)\r
    LocSwitch : Bool = -252009 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UITipButton\r
@Tip = %(T_49_META_TYPE_253_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type HintButtonHud : InternalHud = 253 { #%(T_46_META_WS_C_UITIPBUTTON)\r
	@ApiLevel=4\r
	@ScriptName=Icon\r
	@Tip = %(T_49_META_TYP_253_I0_D)\r
    Icon : SpriteID = -253000 #%(T_46_META_WS_P_ICON)\r
	@ApiLevel=4\r
	@ScriptName=Text\r
	@Tip = %(T_49_META_TYP_253_I1_D)\r
    Text : String = -253001 #%(T_46_META_WS_P_TEXT)\r
	@ApiLevel=4\r
	@ScriptName=EffectActive\r
	@Tip = %(T_49_META_TYP_253_I2_D)\r
    EffectActive : Bool = -253002 #%(T_46_META_WS_P_EFFECTACTIVE)\r
	@ApiLevel=4\r
	@ScriptName=NormalizedPosition\r
	@Tip = %(T_49_META_TYP_253_I3_D)\r
    NormalizedPosition : Vector3 = -253003 #%(T_46_META_WS_P_NORMALIZEDPOSITION)\r
	@ApiLevel=4\r
	@ScriptName=EnableLocalization\r
	@Tip = %(T_49_META_TYP_1012_I1_D)\r
    LocSwitch : Bool = -253004 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TimestampLocString\r
@Tip = %(T_49_META_TYPE_255_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type TimestampLocString : String = 255 { #%(T_46_META_WS_C_TIMESTAMPLOCSTRING)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TimestampLocStringMs\r
@Tip = %(T_49_META_TYPE_450_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type TimestampMsLocString : String = 450 { #%(T_49_META_TYP_450)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TimestampFormatStyleType\r
@Tip = %(T_49_META_TYPE_258_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum TimestampFormatStyle : Int = 258 { #%(T_46_META_WS_C_TIMESTAMPFORMATSTYLETYPE)\r
	@ApiLevel=4\r
	@ScriptName=DateTime\r
	@Tip = %(T_49_META_TYP_258_I0_D)\r
    DateTime = 1 #%(T_46_META_WS_E_DATETIME)\r
	@ApiLevel=4\r
	@ScriptName=ShortTime\r
	@Tip = %(T_49_META_TYP_258_I1_D)\r
    ShortTime = 2 #%(T_46_META_WS_E_SHORTTIME)\r
	@ApiLevel=4\r
	@ScriptName=ShortDateTime\r
	@Tip = %(T_49_META_TYP_258_I2_D)\r
    ShortDateTime = 3 #%(T_46_META_WS_E_SHORTDATETIME)\r
	@ApiLevel=4\r
	@ScriptName=ShortDate\r
	@Tip = %(T_49_META_TYP_258_I3_D)\r
    ShortDate = 4 #%(T_46_META_WS_E_SHORTDATE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UISimpleTip\r
@Tip = %(T_49_META_TYPE_259_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TipHud : InternalHud = 259 { #%(T_46_META_WS_C_UISIMPLETIP)\r
	@ApiLevel=4\r
	@ScriptName=Background\r
	@Tip = %(T_49_META_TYP_259_I0_D)\r
    Background : SpriteID = -259000 #%(T_46_META_WS_P_BACKGROUND)\r
	@ApiLevel=4\r
	@ScriptName=Text\r
	@Tip = %(T_49_META_TYP_259_I1_D)\r
    Text : String = -259001 #%(T_46_META_WS_P_TEXT)\r
	@ApiLevel=4\r
	@ScriptName=NormalizedPosition\r
	@Tip = %(T_49_META_TYP_259_I2_D)\r
    NormalizedPosition : Vector3 = -259002 #%(T_46_META_WS_P_NORMALIZEDPOSITION)\r
	@ApiLevel=4\r
	@ScriptName=EnableLocalization\r
	@Tip = %(T_49_META_TYP_1012_I1_D)\r
    LocSwitch : Bool = -259003 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=TextColor\r
	@Tip = %(T_49_META_TYP_259_I4_D)\r
    TextColor : Color = -259004 #%(T_46_META_WS_P_TEXTCOLOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIProgressSkillButton\r
@Tip = %(T_49_META_TYPE_260_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type ProgressSkillButtonHud : InternalHud = 260 { #%(T_46_META_WS_C_UIPROGRESSSKILLBUTTON)\r
	@ApiLevel=4\r
	@ScriptName=Icon\r
	@Tip = %(T_49_META_TYP_260_I0_D)\r
    Icon : SpriteID = -260000 #%(T_46_META_WS_P_ICON)\r
	@ApiLevel=4\r
	@ScriptName=Color\r
	@Tip = %(T_49_META_TYP_260_I1_D)\r
    Color : Color = -260001 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@ScriptName=Value\r
	@Tip = %(T_49_META_TYP_260_I2_D)\r
    Value : Float = -260002 #%(T_46_META_WS_P_VALUE)\r
	@ApiLevel=4\r
	@ScriptName=Speed\r
	@Tip = %(T_49_META_TYP_260_I3_D)\r
    Speed : Float = -260003 #%(T_46_META_WS_P_SPEED)\r
	@ApiLevel=4\r
	@ScriptName=EffectActive\r
	@Tip = %(T_49_META_TYP_260_I4_D)\r
    EffectActive : Bool = -260004 #%(T_46_META_WS_P_EFFECTACTIVE)\r
	@ApiLevel=4\r
	@ScriptName=NormalizedPosition\r
	@Tip = %(T_49_META_TYP_260_I5_D)\r
    NormalizedPosition : Vector3 = -260005 #%(T_46_META_WS_P_NORMALIZEDPOSITION)\r
	@ApiLevel=4\r
	@ScriptName=InitialValue\r
	@Tip = %(T_49_META_TYP_260_I6_D)\r
    InitialValue : Float = -260006 #%(T_46_META_WS_P_INITIALVALUE)\r
	@ApiLevel=4\r
	@ScriptName=EffectColor\r
	@Tip = %(T_49_META_TYP_260_I7_D)\r
    EffectColor : Color = -260007 #%(T_46_META_WS_P_EFFECTCOLOR)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=Scale\r
	@Tip = %(T_49_META_TYP_260_I8_D)\r
    Scale : Float = -260008 #%(T_46_META_WS_P_SCALE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CommonUISwitchValue\r
@Tip = %(T_49_META_TYPE_268_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum CommonHudSwitchValue : Int = 268 { #%(T_42_XXJ_WS_THREESTATESWITCH)\r
	@ApiLevel=3\r
	@ScriptName=OriginalLogic\r
	@Tip = %(T_49_META_TYP_268_I0_D)\r
    Original = -1 #%(T_40_XXJ_WS_ORIGINAL)\r
	@ApiLevel=4\r
	@ScriptName=Close\r
	@Tip = %(T_49_META_TYP_268_I1_D)\r
    Close = 0 #%(T_46_META_WS_E_CLOSE)\r
	@ApiLevel=4\r
	@ScriptName=Show\r
	@Tip = %(T_49_META_TYP_268_I2_D)\r
    Show = 1 #%(T_46_META_WS_E_SHOW)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MiniMap\r
@Tip = %(T_49_META_TYPE_273_D)\r
@ModuleID=34\r
@ModuleLib=MiniMap\r
type MiniMap : Entity = 273 { #%(T_46_META_WS_C_MINIMAP)\r
	@ApiLevel=4\r
	@ScriptName=Center\r
	@Tip = %(T_49_META_TYP_273_I0_D)\r
    Center : Vector3 = -273000 #%(T_46_META_WS_P_CENTER)\r
	@ApiLevel=4\r
	@Default=100\r
	@ScriptName=MapSize\r
	@Tip = %(T_49_META_TYP_273_I1_D)\r
    MapSize : Int = -273001 #%(T_46_META_WS_P_MAPSIZE)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=EnableDepthMap\r
	@Tip = %(T_49_META_TYP_273_I2_D)\r
    UseDepthMap : Bool = -273002 #%(T_46_META_WS_P_ENABLEDEPTHMAP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MiniMapIcon\r
@Tip = %(T_49_META_TYPE_274_D)\r
@ModuleID=34\r
@ModuleLib=MiniMap\r
type MiniMapIcon : Entity = 274 { #%(T_46_META_WS_C_MINIMAPICON)\r
	@ApiLevel=4\r
	@ScriptName=IconResource\r
	@Tip = %(T_49_META_TYP_245_I0_D)\r
    IconPath : SpriteID = -274000 #%(T_46_META_WS_P_ICONRESOURCE)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=Scale\r
	@Tip = %(T_49_META_TYP_274_I1_D)\r
    Scale : Float = -274001 #%(T_46_META_WS_P_SCALE)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
	@Tip = %(T_49_META_TYP_1010_I4_D)\r
    Offset : Vector3 = -274002 #%(T_46_META_WS_P_OFFSET)\r
	@ApiLevel=4\r
	@ScriptName=FollowTarget\r
	@Tip = %(T_49_META_TYP_244_I2_D)\r
    FollowTarget : Entity = -274003 #%(T_46_META_WS_P_FOLLOWTARGET)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_274_I4_D)\r
    Depth : Int = -274004 #%(T_46_META_WS_P_DEPTH)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MinimapPixelRenderer\r
@Tip = %(T_49_META_TYPE_278_D)\r
@ModuleID=34\r
@ModuleLib=MiniMap\r
type MiniMapBit : Entity = 278 { #%(T_46_META_WS_C_MINIMAPPIXELRENDERER)\r
	@ApiLevel=4\r
	@ScriptName=Target\r
	@Tip = %(T_49_META_TYP_278_I0_D)\r
    Target : Entity = -278000 #%(T_43_YU_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SkeletonPart\r
@Tip = %(T_49_META_TYPE_275_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type SkeletonPart : Entity = 275 { #%(T_46_META_WS_C_SKELETONPART)\r
	@ApiLevel=4\r
	@Default=math.Vector3_1()\r
	@ScriptName=BoneScale\r
	@Tip = %(T_49_META_TYP_275_I0_D)\r
    BoneScale : Vector3 = -275000 #%(T_46_META_WS_P_BONESCALE)\r
	@ApiLevel=4\r
	@Default=math.Vector3_0()\r
	@ScriptName=BonePosition\r
	@Tip = %(T_49_META_TYP_275_I1_D)\r
	@ApiTarget=1\r
    get BonePosition : Vector3 = -275001 #%(T_46_META_WS_P_BONEPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SkeletonPartController\r
@Tip = %(T_49_META_TYPE_447_D)\r
@ModuleID=38\r
@ModuleLib=Avatar\r
type SkeletonPartController : Entity = 447 { #%(T_49_META_TYP_447)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SkeletonPartLookAtController\r
@Tip = %(T_50_META_TYPE_448_D)\r
@ModuleID=38\r
@ModuleLib=Avatar\r
type SkeletonPartLookAtController : SkeletonPartController = 448 { #%(T_49_META_TYP_448)\r
	@ApiLevel=4\r
	@ScriptName=ControlledTarget\r
	@Tip = %(T_50_META_TYP_448_I0_D)\r
    ControlBone : SkeletonPart = -448000 #%(T_49_META_TYP_448_I0)\r
	@ApiLevel=4\r
	@ScriptName=LookAtTarget\r
	@Tip = %(T_50_META_TYP_448_I1_D)\r
	@ApiTarget=1\r
    LookAt : Transform = -448001 #%(T_49_META_TYP_448_I1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Skeleton\r
@Tip = %(T_49_META_TYPE_276_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
type Skeleton : Entity = 276 { #%(T_46_META_WS_C_SKELETON)\r
	@ApiLevel=4\r
	@ScriptName=Head\r
	@Tip = %(T_49_META_TYP_276_I0_D)\r
    get Head : SkeletonPart = -276000 #%(T_46_META_WS_P_HEAD)\r
	@ApiLevel=4\r
	@ScriptName=LeftArm\r
	@Tip = %(T_49_META_TYP_276_I1_D)\r
    get LeftArm : SkeletonPart = -276001 #%(T_46_META_WS_P_LEFTARM)\r
	@ApiLevel=4\r
	@ScriptName=LeftHand\r
	@Tip = %(T_49_META_TYP_276_I2_D)\r
    get LeftHand : SkeletonPart = -276002 #%(T_46_META_WS_P_LEFTHAND)\r
	@ApiLevel=4\r
	@ScriptName=RightArm\r
	@Tip = %(T_49_META_TYP_276_I3_D)\r
    get RightArm : SkeletonPart = -276003 #%(T_46_META_WS_P_RIGHTARM)\r
	@ApiLevel=4\r
	@ScriptName=RightHand\r
	@Tip = %(T_49_META_TYP_276_I4_D)\r
    get RightHand : SkeletonPart = -276004 #%(T_46_META_WS_P_RIGHTHAND)\r
	@ApiLevel=4\r
	@ScriptName=Body\r
	@Tip = %(T_49_META_TYP_276_I5_D)\r
    get Body : SkeletonPart = -276005 #%(T_46_META_WS_P_BODY)\r
	@ApiLevel=4\r
	@ScriptName=LeftLeg\r
	@Tip = %(T_49_META_TYP_276_I6_D)\r
    get LeftLeg : SkeletonPart = -276006 #%(T_46_META_WS_P_LEFTLEG)\r
	@ApiLevel=4\r
	@ScriptName=LeftFoot\r
	@Tip = %(T_49_META_TYP_276_I7_D)\r
    get LeftFoot : SkeletonPart = -276007 #%(T_46_META_WS_P_LEFTFOOT)\r
	@ApiLevel=4\r
	@ScriptName=RightLeg\r
	@Tip = %(T_49_META_TYP_276_I8_D)\r
    get RightLeg : SkeletonPart = -276008 #%(T_46_META_WS_P_RIGHTLEG)\r
	@ApiLevel=4\r
	@ScriptName=RightFoot\r
	@Tip = %(T_49_META_TYP_276_I9_D)\r
    get RightFoot : SkeletonPart = -276009 #%(T_46_META_WS_P_RIGHTFOOT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CameraRaycastUI\r
@Tip = %(T_49_META_TYPE_277_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
type CameraRayCastHud : InternalHud = 277 { #%(T_46_META_WS_C_CAMERARAYCASTUI)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -277000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@Default=10\r
	@ScriptName=Distance\r
	@Tip = %(T_49_META_TYP_277_I1_D)\r
    Distant : Float = -277001 #%(T_46_META_WS_P_DISTANCE)\r
	@ApiLevel=4\r
	@Default=4\r
	@ScriptName=LayerType\r
	@Tip = %(T_49_META_TYP_277_I2_D)\r
    LayerType : Int = -277002 #%(T_46_META_WS_P_LAYERTYPE)\r
	@ApiLevel=4\r
	@ScriptName=CenterOffset\r
	@Tip = %(T_49_META_TYP_277_I3_D)\r
    CenterOffset : Vector2 = -277003 #%(T_46_META_WS_P_CENTEROFFSET)\r
	@ApiLevel=4\r
	@ScriptName=SpriteResource\r
	@Tip = %(T_49_META_TYP_277_I4_D)\r
    IconSpriteName : SpriteID = -277004 #%(T_46_META_WS_P_SPRITERESOURCE)\r
	@ApiLevel=4\r
	@Default=&math.Vector2(100, 100)\r
	@ScriptName=ClickSize\r
	@Tip = %(T_49_META_TYP_277_I5_D)\r
    ClickSize : Vector2 = -277005 #%(T_46_META_WS_P_CLICKSIZE)\r
	@ApiLevel=4\r
	@ScriptName=ShowHitPointEffect\r
	@Tip = %(T_49_META_TYP_277_I6_D)\r
    ShowHitPointEffect : Bool = -277006 #%(T_46_META_WS_P_SHOWHITPOINTEFFECT)\r
	@ApiLevel=4\r
	@ScriptName=HitPointEffect\r
	@Tip = %(T_49_META_TYP_277_I7_D)\r
    HitPointEffect : Entity = -277007 #%(T_46_META_WS_P_HITPOINTEFFECT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ColorDrum\r
@Tip = %(T_49_META_TYPE_279_D)\r
@ModuleID=32\r
@ModuleLib=Dyeing\r
type ColorDrum : Oildrum = 279 { #%(T_46_META_WS_C_COLORDRUM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SphereTrigger\r
@Tip = %(T_49_META_TYPE_280_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type SphereTrigger : CustomizeTrigger = 280 { #%(T_46_META_WS_C_SPHERETRIGGER)\r
	@ApiLevel=4\r
	@Default=0.5\r
	@ScriptName=Radius\r
	@Tip = %(T_49_META_TYP_280_I0_D)\r
    Radius : Float = -280000 #%(T_46_META_WS_P_RADIUS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CapsuleTrigger\r
@Tip = %(T_49_META_TYPE_281_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type CapsuleTrigger : CustomizeTrigger = 281 { #%(T_46_META_WS_C_CAPSULETRIGGER)\r
	@ApiLevel=4\r
	@Default=0.5\r
	@ScriptName=Radius\r
	@Tip = %(T_49_META_TYP_281_I0_D)\r
    Radius : Float = -281000 #%(T_46_META_WS_P_RADIUS)\r
	@ApiLevel=4\r
	@Default=2\r
	@ScriptName=Height\r
	@Tip = %(T_49_META_TYP_416_I3_D)\r
    Height : Float = -281001 #%(T_46_META_WS_P_HEIGHT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BevTree\r
@Tip = %(T_49_META_TYPE_290_D)\r
@ModuleID=36\r
@ModuleLib=BehaviourTree\r
type BehaviourTree : Entity = 290 { #%(T_46_META_WS_C_BEVTREE)\r
	@ApiLevel=4\r
	@Default=10\r
	@ScriptName=TickInterval\r
	@Tip = %(T_49_META_TYP_290_I0_D)\r
    TickInterval : Int = -290000 #%(T_46_META_WS_P_TICKINTERVAL)\r
	@ApiLevel=3\r
	@Default=false\r
	@ScriptName=IsDebug\r
	@Tip = %(T_49_META_TYP_290_I1_D)\r
    Debug : Bool = -290001 #%(T_46_META_WS_P_ISDEBUG)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BevTreeNodeType\r
@Tip = %(T_49_META_TYPE_291_D)\r
@ModuleID=36\r
@ModuleLib=BehaviourTree\r
enum BTCustomNodeType : Int = 291 { #%(T_46_META_WS_C_BEVTREENODETYPE)\r
	@ApiLevel=4\r
	@ScriptName=ConditionNode\r
	@Tip = %(T_49_META_TYP_291_I0_D)\r
    Condition = 1 #%(T_46_META_WS_E_CONDITIONNODE)\r
	@ApiLevel=4\r
	@ScriptName=ActionNode\r
	@Tip = %(T_49_META_TYP_291_I1_D)\r
    Action = 2 #%(T_46_META_WS_E_ACTIONNODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BevTreeCustomNode\r
@Tip = %(T_49_META_TYPE_292_D)\r
@ModuleID=36\r
@ModuleLib=BehaviourTree\r
type BehaviourTreeNode : Entity = 292 { #%(T_46_META_WS_C_BEVTREECUSTOMNODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MonsterSkillType\r
@Tip = %(T_49_META_TYPE_301_D)\r
@ModuleID=10008\r
@ModuleLib=AI\r
enum AISkillType : Int = 301 { #%(T_41_XXJ_WS_MONSTERSKILLTYPE)\r
	@ApiLevel=4\r
	@ScriptName=ThrowAttack\r
	@Tip = %(T_49_META_TYP_24_I2_D)\r
    ThrowAttack = 1 #%(T_46_META_WS_E_THROWATTACK)\r
	@ApiLevel=4\r
	@ScriptName=Explode\r
	@Tip = %(T_49_META_TYP_301_I1_D)\r
    Explode = 2 #%(T_46_META_WS_E_EXPLODE)\r
	@ApiLevel=4\r
	@ScriptName=DashAttack\r
	@Tip = %(T_49_META_TYP_301_I2_D)\r
    DashAttack = 3 #%(T_46_META_WS_E_DASHATTACK)\r
	@ApiLevel=4\r
	@ScriptName=ShockWave\r
	@Tip = %(T_49_META_TYP_301_I3_D)\r
    ShockWave = 4 #%(T_46_META_WS_E_SHOCKWAVE)\r
	@ApiLevel=4\r
	@ScriptName=WindAttack\r
	@Tip = %(T_49_META_TYP_301_I4_D)\r
    WindAttack = 6 #%(T_46_META_WS_E_WINDATTACK)\r
	@ApiLevel=4\r
	@ScriptName=JumpAttack\r
	@Tip = %(T_49_META_TYP_301_I5_D)\r
    JumpAttack = 13 #%(T_46_META_WS_E_JUMPATTACK)\r
	@ApiLevel=4\r
	@ScriptName=ShieldUp\r
	@Tip = %(T_49_META_TYP_301_I6_D)\r
    ShieldUp = 22 #%(T_46_META_WS_E_SHIELDUP)\r
	@ApiLevel=4\r
	@ScriptName=ShieldBroken\r
	@Tip = %(T_49_META_TYP_301_I7_D)\r
    ShieldBroken = 23 #%(T_46_META_WS_E_SHIELDBROKEN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BevTreeNodeStatus\r
@Tip = %(T_49_META_TYPE_305_D)\r
@ModuleID=36\r
@ModuleLib=BehaviourTree\r
enum BTreeNodeState : Int = 305 { #%(T_46_META_WS_C_BEVTREENODESTATUS)\r
	@ApiLevel=4\r
	@ScriptName=Finish\r
	@Tip = %(T_49_META_TYP_305_I0_D)\r
    Finish = 1 #%(T_46_META_WS_E_FINISH)\r
	@ApiLevel=4\r
	@ScriptName=Running\r
	@Tip = %(T_49_META_TYP_305_I1_D)\r
    Running = 2 #%(T_46_META_WS_E_RUNNING)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IceWallMaker\r
@Tip = %(T_49_META_TYPE_307_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type IceWallMaker : Entity = 307 { #%(T_46_META_WS_C_ICEWALLMAKER)\r
	@ApiLevel=4\r
	@ScriptName=ExpPerDamage\r
	@Tip = %(T_49_META_TYP_307_I0_D)\r
    ExpPerDamage : Float = -307000 #%(T_46_META_WS_P_EXPPERDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=ExpPerMoveMile\r
	@Tip = %(T_49_META_TYP_307_I1_D)\r
    ExpPerMoveMile : Float = -307001 #%(T_46_META_WS_P_EXPPERMOVEMILE)\r
	@ApiLevel=4\r
	@ScriptName=ExpPerSecond\r
	@Tip = %(T_49_META_TYP_307_I2_D)\r
    ExpPerSecond : Float = -307002 #%(T_46_META_WS_P_EXPPERSECOND)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=ChipExp\r
	@Tip = %(T_49_META_TYP_307_I3_D)\r
    ExpChip : Float = -307003 #%(T_46_META_WS_P_CHIPEXP)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=ChargeMax\r
	@Tip = %(T_49_META_TYP_307_I4_D)\r
    ChargeMax : Float = -307004 #%(T_46_META_WS_P_CHARGEMAX)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GrenadeWeapon\r
@Tip = %(T_49_META_TYPE_311_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type GrenadeWeapon : Weapon = 311 { #%(T_46_META_WS_C_GRENADEWEAPON)\r
	@ApiLevel=4\r
	@ScriptName=MinDamage\r
	@Tip = %(T_49_META_TYP_79_I8_D)\r
    GrenadeMinDamage : Int = -311000 #%(T_46_META_WS_P_MINDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=MaxDamage\r
	@Tip = %(T_49_META_TYP_311_I1_D)\r
    GrenadeMaxDamage : Int = -311001 #%(T_46_META_WS_P_MAXDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=Range\r
	@Tip = %(T_49_META_TYP_56_I11_D)\r
    GrenadeRange : Float = -311002 #%(T_46_META_WS_P_EXPLODERANGE)\r
	@ApiLevel=4\r
	@ScriptName=ThrowSpeed\r
	@Tip = %(T_49_META_TYP_311_I3_D)\r
    GrenadeThrowSpeed : Float = -311003 #%(T_46_META_WS_P_THROWINGSPEED)\r
	@ApiLevel=4\r
	@ScriptName=ExplosionTime\r
	@Tip = %(T_49_META_TYP_311_I4_D)\r
    GrenadeExplosionTime : Float = -311004 #%(T_46_META_WS_P_EXPLOSIONTIME)\r
	@ApiLevel=4\r
	@ScriptName=RatioSelfFactor\r
	@Tip = %(T_49_META_TYP_174_I6_D)\r
    GrenadeRatioSelf : Float = -311005 #%(T_46_META_WS_P_RATIOSELFFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=RatioTeammateFactor\r
	@Tip = %(T_49_META_TYP_174_I7_D)\r
    GrenadeRatioTeammate : Float = -311006 #%(T_46_META_WS_P_RATIOTEAMMATEFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=RatioVehicleFactor\r
	@Tip = %(T_49_META_TYP_174_I8_D)\r
    GrenadeRatioVehicle : Float = -311007 #%(T_46_META_WS_P_RATIOVEHICLEFACTOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GrenadeLauncher\r
@Tip = %(T_49_META_TYPE_309_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type GrenadeLauncher : GrenadeWeapon = 309 { #%(T_46_META_WS_C_GRENADELAUNCHER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CrossBow\r
@Tip = %(T_49_META_TYPE_310_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type CrossBow : GrenadeWeapon = 310 { #%(T_46_META_WS_C_CROSSBOW)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=HandCannon\r
@Tip = %(T_49_META_TYPE_312_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type HandCannon : GrenadeWeapon = 312 { #%(T_46_META_WS_C_HANDCANNON)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GrenadeDeIceWall\r
@Tip = %(T_49_META_TYPE_313_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type GrenadeDeIceWall : InventoryBase&Grenade = 313 { #%(T_46_META_WS_C_GRENADEDEICEWALL)\r
	@ApiLevel=4\r
	@ScriptName=Radius\r
	@Tip = %(T_49_META_TYP_313_I0_D)\r
    ZoneRadius : Float = -313000 #%(T_46_META_WS_P_RADIUS)\r
	@ApiLevel=4\r
	@ScriptName=Duration\r
	@Tip = %(T_49_META_TYP_313_I1_D)\r
    ZoneDuration : Float = -313001 #%(T_46_META_WS_P_DURATION)\r
	@ApiLevel=4\r
	@Default=230\r
	@ScriptName=ZoneDamage\r
	@Tip = %(T_51_META_TYP_313_I2_D)\r
    ZoneDamage : Int = -313002 #%(T_46_META_WS_P_DAMAGE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Attachment\r
@Tip = %(T_49_META_TYPE_318_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type Attachment : InventoryBase&FormulableEntity = 318 { #%(T_46_META_WS_C_ATTACHMENT)\r
	@ApiLevel=4\r
	@ScriptName=AttackRange\r
	@Tip = %(T_49_META_TYP_318_I0_D)\r
    Range : Float = -318000 #%(T_46_META_WS_P_ATTACKRANGE)\r
	@ApiLevel=4\r
	@ScriptName=FullDamageDistance\r
	@Tip = %(T_49_META_TYP_318_I1_D)\r
    FullDamageDistance : Float = -318001 #%(T_46_META_WS_P_FULLDAMAGEDISTANCE)\r
	@ApiLevel=4\r
	@ScriptName=MinDamageDistance\r
	@Tip = %(T_49_META_TYP_318_I2_D)\r
    MinDamageDistance : Float = -318002 #%(T_46_META_WS_P_MINDAMAGEDISTANCE)\r
	@ApiLevel=4\r
	@ScriptName=AmmoClipSize\r
	@Tip = %(T_49_META_TYP_318_I3_D)\r
    AmmoClipSize : Int = -318003 #%(T_46_META_WS_P_AMMOCLIPSIZE)\r
	@ApiLevel=4\r
	@ScriptName=AttackInterval\r
	@Tip = %(T_49_META_TYP_318_I4_D)\r
    FireInterval : Float = -318004 #%(T_32_YS_WEAPON_TAG_3)\r
	@ApiLevel=4\r
	@ScriptName=ReloadSpeed\r
	@Tip = %(T_49_META_TYP_318_I5_D)\r
    ReloadSpeed : Float = -318005 #%(T_46_META_WS_P_RELOADSPEED)\r
	@ApiLevel=4\r
	@ScriptName=FastAutoReloadSpeed\r
	@Tip = %(T_49_META_TYP_318_I6_D)\r
    FastAutoReloadSpeed : Float = -318006 #%(T_46_META_WS_P_FASTAUTORELOADSPEED)\r
	@ApiLevel=4\r
	@ScriptName=ScatterSpeed\r
	@Tip = %(T_49_META_TYP_318_I7_D)\r
    ScatterSpeed : Float = -318007 #%(T_46_META_WS_P_SCATTERSPEED)\r
	@ApiLevel=4\r
	@ScriptName=ScatterSpeedCrouchProne\r
	@Tip = %(T_49_META_TYP_318_I8_D)\r
    ScatterSpeedCrouchCreep : Float = -318008 #%(T_46_META_WS_P_SCATTERSPEEDCROUCHPRONE)\r
	@ApiLevel=4\r
	@ScriptName=ScatterMax\r
	@Tip = %(T_49_META_TYP_318_I9_D)\r
    ScatterMax : Float = -318009 #%(T_46_META_WS_P_SCATTERMAX)\r
	@ApiLevel=4\r
	@ScriptName=PlayerAimingSpeedFactor\r
	@Tip = %(T_49_META_TYP_318_I10_D)\r
    PlayerSpeedFactorAiming : Float = -318010 #%(T_46_META_WS_P_PLAYERAIMINGSPEEDFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=SightAmplifyRatio\r
	@Tip = %(T_49_META_TYP_318_I11_D)\r
    SightAmplifyRatio : Int = -318011 #%(T_46_META_WS_P_SIGHTAMPLIFYRATIO)\r
	@ApiLevel=4\r
	@ScriptName=SightFOVAmplifyRatio\r
	@Tip = %(T_49_META_TYP_318_I12_D)\r
    SightFOVAmplifyRatio : Float = -318012 #%(T_46_META_WS_P_SIGHTFOVAMPLIFYRATIO)\r
	@ApiLevel=4\r
	@ScriptName=SightUIActionRatio\r
	@Tip = %(T_49_META_TYP_318_I13_D)\r
    SightUiActionRatio : Float = -318013 #%(T_46_META_WS_P_SIGHTUIACTIONRATIO)\r
	@ApiLevel=4\r
	@ScriptName=SightUIActionExpand\r
	@Tip = %(T_49_META_TYP_318_I14_D)\r
    SightUiActionExpand : Float = -318014 #%(T_46_META_WS_P_SIGHTUIACTIONEXPAND)\r
	@ApiLevel=4\r
	@ScriptName=SightUIActionRecovery\r
	@Tip = %(T_49_META_TYP_318_I15_D)\r
    SightUiActionRecovery : Float = -318015 #%(T_46_META_WS_P_SIGHTUIACTIONRECOVERY)\r
	@ApiLevel=4\r
	@ScriptName=SightShootMinDamage\r
	@Tip = %(T_49_META_TYP_318_I16_D)\r
    SightShootMinDamage : Int = -318016 #%(T_46_META_WS_P_SIGHTSHOOTMINDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=SightAimAssist\r
	@Tip = %(T_49_META_TYP_318_I17_D)\r
    SightAimAssist : Bool = -318017 #%(T_46_META_WS_P_SIGHTAIMASSIST)\r
	@ApiLevel=4\r
	@ScriptName=SightAimAssistSnapRange\r
	@Tip = %(T_49_META_TYP_318_I18_D)\r
    SightAimAssistSnapRange : Float = -318018 #%(T_46_META_WS_P_SIGHTAIMASSISTSNAPRANGE)\r
	@ApiLevel=4\r
	@ScriptName=SightAimAssistDistFalloff\r
	@Tip = %(T_49_META_TYP_318_I19_D)\r
    SightAimAssistDistFalloff : Float = -318019 #%(T_46_META_WS_P_SIGHTAIMASSISTDISTFALLOFF)\r
	@ApiLevel=4\r
	@ScriptName=SightAimAssistDistpriority\r
	@Tip = %(T_49_META_TYP_318_I20_D)\r
    SightAimAssistDistpriority : Bool = -318020 #%(T_46_META_WS_P_SIGHTAIMASSISTDISTPRIORITY)\r
	@ApiLevel=4\r
	@ScriptName=SightAimAssistDistprioMin\r
	@Tip = %(T_49_META_TYP_318_I21_D)\r
    SightAimAssistDistprioMin : Float = -318021 #%(T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMIN)\r
	@ApiLevel=4\r
	@ScriptName=SightAimAssistDistprioMax\r
	@Tip = %(T_49_META_TYP_318_I22_D)\r
    SightAimAssistDistprioMax : Float = -318022 #%(T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMAX)\r
	@ApiLevel=4\r
	@ScriptName=SightAimAssistDistprioCoef\r
	@Tip = %(T_49_META_TYP_318_I23_D)\r
    SightAimAssistDistprioCoef : Float = -318023 #%(T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOCOEF)\r
	@ApiLevel=4\r
	@ScriptName=SightRotSensitiveness\r
	@Tip = %(T_49_META_TYP_318_I24_D)\r
    SightRotSensitiveness : Float = -318024 #%(T_46_META_WS_P_SIGHTROTSENSITIVENESS)\r
	@ApiLevel=4\r
	@ScriptName=ShrinkSpeed\r
	@Tip = %(T_49_META_TYP_318_I25_D)\r
    ShrinkSpeed : Float = -318025 #%(T_46_META_WS_P_SHRINKSPEED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DamagedBodyPartType\r
@Tip = %(T_49_META_TYPE_322_D)\r
@ModuleID=10016\r
@ModuleLib=Combat\r
enum HitBodyPart : Int = 322 { #%(T_46_META_WS_C_DAMAGEDBODYPARTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=None\r
	@Tip = %(T_49_META_TYP_322_I0_D)\r
    None = 0 #%(T_46_META_WS_E_NONE)\r
	@ApiLevel=4\r
	@ScriptName=Head\r
	@Tip = %(T_49_META_TYP_322_I1_D)\r
    Head = 1 #%(T_46_META_WS_E_HEAD)\r
	@ApiLevel=4\r
	@ScriptName=Body\r
	@Tip = %(T_49_META_TYP_322_I2_D)\r
    Body = 2 #%(T_46_META_WS_E_BODY)\r
	@ApiLevel=4\r
	@ScriptName=Limb\r
	@Tip = %(T_49_META_TYP_322_I3_D)\r
    Limb = 3 #%(T_46_META_WS_E_LIMB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SeatType\r
@Tip = %(T_49_META_TYPE_329_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum SeatType : Int = 329 { #%(T_46_META_WS_C_SEATTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Driver\r
	@Tip = %(T_49_META_TYP_329_I0_D)\r
    Driver = 0 #%(T_46_META_WS_E_DRIVER)\r
	@ApiLevel=4\r
	@ScriptName=PassengerA\r
	@Tip = %(T_49_META_TYP_329_I1_D)\r
    Passenger1 = 1 #%(T_46_META_WS_E_PASSENGERA)\r
	@ApiLevel=4\r
	@ScriptName=PassengerB\r
	@Tip = %(T_49_META_TYP_329_I2_D)\r
    Passenger2 = 2 #%(T_46_META_WS_E_PASSENGERB)\r
	@ApiLevel=4\r
	@ScriptName=PassengerC\r
	@Tip = %(T_49_META_TYP_329_I3_D)\r
    Passenger3 = 3 #%(T_46_META_WS_E_PASSENGERC)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=VehicleIDType\r
@Tip = %(T_49_META_TYPE_350_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum VehicleID : Int = 350 { #%(T_46_META_WS_C_VEHICLEIDTYPE)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_350_I0_D)\r
    SportsCar = 118 #%(T_46_META_WS_E_SPORTSCAR)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_350_I1_D)\r
    Motorbike = 117 #%(T_46_META_WS_E_MOTORBIKE)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_350_I2_D)\r
    Jeep = 113 #%(T_46_META_WS_E_JEEP)\r
	@ApiLevel=4\r
	@ScriptName=SUV\r
	@Tip = %(T_49_META_TYP_350_I3_D)\r
    Suv = 112 #%(T_46_META_WS_E_SUV)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_350_I4_D)\r
    MonsterTruck = 116 #%(T_46_META_WS_E_MONSTERTRUCK)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_350_I5_D)\r
    TukTuk = 114 #%(T_46_META_WS_E_TUKTUK)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SoundEffect\r
@Tip = %(T_49_META_TYPE_335_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type SoundEntity : Transform&Playable&Loopable = 335 { #%(T_46_META_WS_C_SOUNDEFFECT)\r
	@ApiLevel=4\r
	@ScriptName=Resource\r
	@Tip = %(T_49_META_TYP_335_I0_D)\r
    SoundType : AudioType = -335000 #%(T_46_META_WS_P_RESOURCE)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=RepeatTimes\r
	@Tip = %(T_49_META_TYP_335_I1_D)\r
    RepeatTimes : Int = -335001 #%(T_46_META_WS_P_REPEATTIMES)\r
	@ApiLevel=4\r
	@Default=50\r
	@ScriptName=Volume\r
	@Tip = %(T_49_META_TYP_335_I2_D)\r
    Volume : Int = -335002 #%(T_46_META_WS_P_VOLUME)\r
	@ApiLevel=4\r
	@Default=30\r
	@ScriptName=MaxDistance\r
	@Tip = %(T_49_META_TYP_335_I3_D)\r
    MaxDistance : Float = -335003 #%(T_46_META_WS_P_MAXDISTANCE)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=MinDistance\r
	@Tip = %(T_49_META_TYP_335_I4_D)\r
    MinDistance : Float = -335004 #%(T_46_META_WS_P_MINDISTANCE)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=Is3D\r
	@Tip = %(T_49_META_TYP_335_I5_D)\r
    Is3D : Bool = -335005 #%(T_46_META_WS_P_IS3D)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=Priority\r
	@Tip = %(T_49_META_TYP_335_I6_D)\r
    Priority : Int = -335006 #%(T_46_META_WS_P_PRIORITY)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=StartTime\r
	@Tip = %(T_49_META_TYP_335_I7_D)\r
    StartTime : Float = -335007 #%(T_46_META_WS_P_STARTTIME)\r
	@ApiLevel=3\r
	@Default=2\r
	@ScriptName=IsPlaying\r
	@Tip = %(T_49_META_TYP_335_I8_D)\r
    get State : Int = -335008 #%(T_46_META_WS_P_ISPLAYING)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=ElapsedTime\r
	@Tip = %(T_49_META_TYP_335_I9_D)\r
    get PlayedTime : Int = -335009 #%(T_49_META_TYP_335_I9)\r
	@ApiLevel=4\r
	@Tip = %(T_50_META_TYP_335_I10_D)\r
    Speed : Float = -335010 #%(T_46_META_WS_P_SPEED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_SoundEffect\r
@Tip = %(T_49_META_TYPE_336_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_SoundEntity : List = 336 { #%(T_46_META_WS_C_LISTT_SOUNDEFFECT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SoundEffectOrSoundEffectList\r
@Tip = %(T_49_META_TYPE_337_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias SoundEntityOrListSoundEntity : Object&(SoundEntity|ListT_SoundEntity) = 337 #%(T_46_META_WS_C_SOUNDEFFECTORSOUNDEFFECTLIST)\r
\r
@ApiLevel=3\r
@ScriptName=PlayerBehavior\r
@Tip = %(T_49_META_TYPE_338_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
type PlayerBehavior : Entity = 338 { #%(T_42_XXJ_WS_PLAYERBEHAVIOR)\r
	@ApiLevel=3\r
	@ScriptName=MovementStatus\r
	@Tip = %(T_49_META_TYP_338_I0_D)\r
    get MovementStatus : PlayerBehaviorStatus = -338000 #%(T_42_XXJ_WS_MOVEMENTSTATUS)\r
	@ApiLevel=3\r
	@ScriptName=SprintStatus\r
	@Tip = %(T_49_META_TYP_338_I1_D)\r
    get SprintStatus : PlayerBehaviorStatus = -338001 #%(T_42_XXJ_WS_SPRINTSTATUS)\r
	@ApiLevel=3\r
	@ScriptName=AttackStatus\r
	@Tip = %(T_49_META_TYP_338_I2_D)\r
    get AttackStatus : PlayerBehaviorStatus = -338002 #%(T_42_XXJ_WS_ATTACKSTATUS)\r
	@ApiLevel=3\r
	@ScriptName=JumpStatus\r
	@Tip = %(T_49_META_TYP_338_I3_D)\r
    get JumpStatus : PlayerBehaviorStatus = -338003 #%(T_42_XXJ_WS_JUMPSTATUS)\r
	@ApiLevel=3\r
	@ScriptName=ClimbStatus\r
	@Tip = %(T_49_META_TYP_338_I4_D)\r
    get ClimbStatus : PlayerBehaviorStatus = -338004 #%(T_42_XXJ_WS_CLIMBSTATUS)\r
	@ApiLevel=3\r
	@ScriptName=GetOnAsDriverStatus\r
	@Tip = %(T_49_META_TYP_338_I5_D)\r
    get GetOnAsDriverStatus : PlayerBehaviorStatus = -338005 #%(T_42_XXJ_WS_GETONASDRIVERSTATUS)\r
	@ApiLevel=3\r
	@ScriptName=GetOnAsPassengerStatus\r
	@Tip = %(T_49_META_TYP_338_I6_D)\r
    get GetOnAsPassengerStatus : PlayerBehaviorStatus = -338006 #%(T_42_XXJ_WS_GETONASPASSENGERSTATUS)\r
	@ApiLevel=3\r
	@ScriptName=GetOffVehicleStatus\r
	@Tip = %(T_49_META_TYP_338_I7_D)\r
    get GetOffVehicleStatus : PlayerBehaviorStatus = -338007 #%(T_42_XXJ_WS_GETOFFVEHICLESTATUS)\r
	@ApiLevel=3\r
	@ScriptName=DrivingStatus\r
	@Tip = %(T_49_META_TYP_338_I8_D)\r
    get DrivingStatus : PlayerBehaviorStatus = -338008 #%(T_42_XXJ_WS_DRIVINGSTATUS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EquipmentAttachment\r
@Tip = %(T_49_META_TYPE_339_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
type EquipmentAttachment : InventoryBase&FormulableEntity = 339 { #%(T_46_META_WS_C_EQUIPMENTATTACHMENT)\r
	@ApiLevel=4\r
	@ScriptName=DamageRatioLimb\r
	@Tip = %(T_49_META_TYP_339_I0_D)\r
    DamageRatioLimb : Float = -339000 #%(T_46_META_WS_P_DAMAGERATIOLIMB)\r
	@ApiLevel=4\r
	@ScriptName=DamageRatioHead\r
	@Tip = %(T_49_META_TYP_339_I1_D)\r
    DamageRatioHead : Float = -339001 #%(T_46_META_WS_P_DAMAGERATIOHEAD)\r
	@ApiLevel=4\r
	@ScriptName=MaxDurabilityRatio\r
	@Tip = %(T_49_META_TYP_339_I2_D)\r
    MaxDurabilityRatio : Float = -339002 #%(T_46_META_WS_P_MAXDURABILITYRATIO)\r
	@ApiLevel=4\r
	@ScriptName=ExtraHPRatio\r
	@Tip = %(T_49_META_TYP_339_I3_D)\r
    ExtraHpRatio : Float = -339003 #%(T_46_META_WS_P_EXTRAHPRATIO)\r
	@ApiLevel=4\r
	@ScriptName=ExplodeDamageReductionFactor\r
	@Tip = %(T_49_META_TYP_339_I4_D)\r
    DamageReductionFactorExplode : Int = -339004 #%(T_46_META_WS_P_EXPLODEDAMAGEREDUCTIONFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=ExtraBackpackCapacity\r
	@Tip = %(T_49_META_TYP_339_I5_D)\r
    ExtraBagCapacity : Int = -339005 #%(T_46_META_WS_P_EXTRABACKPACKCAPACITY)\r
	@ApiLevel=4\r
	@ScriptName=ReplacementPriority\r
	@Tip = %(T_49_META_TYP_339_I6_D)\r
    ReplacementPriority : Int = -339006 #%(T_46_META_WS_P_REPLACEMENTPRIORITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BotDifficultyType\r
@Tip = %(T_49_META_TYPE_340_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum BotDifficulty : Int = 340 { #%(T_46_META_WS_C_BOTDIFFICULTYTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Easy\r
	@Tip = %(T_49_META_TYP_340_I0_D)\r
    Easy = 0 #%(T_46_META_WS_E_EASY)\r
	@ApiLevel=4\r
	@ScriptName=Simple\r
	@Tip = %(T_49_META_TYP_340_I1_D)\r
    Simple = 1 #%(T_46_META_WS_E_SIMPLE)\r
	@ApiLevel=4\r
	@ScriptName=Normal\r
	@Tip = %(T_49_META_TYP_340_I2_D)\r
    Normal = 2 #%(T_46_META_WS_E_NORMAL)\r
	@ApiLevel=4\r
	@ScriptName=Moderate\r
	@Tip = %(T_49_META_TYP_340_I3_D)\r
    Moderate = 3 #%(T_46_META_WS_E_MODERATE)\r
	@ApiLevel=4\r
	@ScriptName=Hard\r
	@Tip = %(T_49_META_TYP_340_I4_D)\r
    Hard = 4 #%(T_46_META_WS_E_HARD)\r
	@ApiLevel=4\r
	@ScriptName=Hell\r
	@Tip = %(T_49_META_TYP_340_I5_D)\r
    Hell = 5 #%(T_46_META_WS_E_HELL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IntegerMapTemplate\r
@Tip = %(T_49_META_TYPE_341_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type MapT_Int_Int : Map = 341 { #%(T_46_META_WS_C_INTEGERMAPTEMPLATE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Timer\r
@Tip = %(T_49_META_TYPE_342_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type Clock : LevelObject = 342 { #%(T_46_META_WS_C_TIMER)\r
	@ApiLevel=4\r
	@ScriptName=StartEvent\r
	@Tip = %(T_49_META_TYP_342_I0_D)\r
    get StartEventID : EventID = -342000 #%(T_46_META_WS_P_STARTEVENT)\r
	@ApiLevel=4\r
	@ScriptName=StopEvent\r
	@Tip = %(T_49_META_TYP_342_I1_D)\r
    get StopEventID : EventID = -342001 #%(T_46_META_WS_P_STOPEVENT)\r
	@ApiLevel=4\r
	@ScriptName=PauseEvent\r
	@Tip = %(T_49_META_TYP_342_I2_D)\r
    get PauseEventID : EventID = -342002 #%(T_46_META_WS_P_PAUSEEVENT)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_342_I3_D)\r
    StartTime : Int = -342003 #%(T_46_META_WS_P_STARTTIME)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_342_I4_D)\r
    LoopCount : Int = -342004 #%(T_46_META_WS_P_LOOPCOUNT)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_342_I5_D)\r
    get Events : MapT_Int_EventID = -342005 #%(T_46_META_WS_P_EVENTS)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_342_I6_D)\r
    IsCountdown : Bool = -342006 #%(T_46_META_WS_P_ISCOUNTDOWN)\r
	@ApiLevel=4\r
	@ScriptName=Status\r
	@Tip = %(T_49_META_TYP_342_I7_D)\r
    get State : Int = -342007 #%(T_46_META_WS_P_STATUS)\r
	@ApiLevel=4\r
	@ScriptName=CountdownEndTime\r
	@Tip = %(T_49_META_TYP_342_I8_D)\r
    get EndTimeS : Int = -342008 #%(T_46_META_WS_P_COUNTDOWNENDTIME)\r
	@ApiLevel=4\r
	@ScriptName=CountdownTime\r
	@Tip = %(T_49_META_TYP_1021_I2_D)\r
    get DurationTimeS : Int = -342009 #%(T_46_META_WS_P_COUNTDOWNTIME)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_49_META_TYPE_343_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type ThrowingKnife : Weapon = 343 { #%(T_42_SJ_WS_KNIFEITEMPICK)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_49_META_TYPE_344_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type ThrowingKnifeBR : ThrowingKnife = 344 { #%(T_42_SJ_WS_KNIFEITEM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MedKit\r
@Tip = %(T_49_META_TYPE_353_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type FirstAidKit : InventoryBase&FormulableEntity = 353 { #%(T_46_META_WS_C_MEDKIT)\r
	@ApiLevel=4\r
	@ScriptName=HPRecoveryAmount\r
	@Tip = %(T_49_META_TYP_353_I0_D)\r
    Health : Int = -353000 #%(T_46_META_WS_P_HPRECOVERYAMOUNT)\r
	@ApiLevel=4\r
	@ScriptName=HPRecoverySpeed\r
	@Tip = %(T_49_META_TYP_353_I1_D)\r
    Duration : Int = -353001 #%(T_46_META_WS_P_HPRECOVERYSPEED)\r
	@ApiLevel=4\r
	@ScriptName=TimeRequired\r
	@Tip = %(T_49_META_TYP_353_I2_D)\r
    Pretime : Int = -353002 #%(T_46_META_WS_P_TIMEREQUIRED)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_49_META_TYPE_354_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type Inhaler : FirstAidKit = 354 { #%(T_46_META_WS_C_INHALER)\r
	@ApiLevel=4\r
	@ScriptName=EPRecoveryAmount\r
	@Tip = %(T_49_META_TYP_354_I0_D)\r
    Energy : Int = -354000 #%(T_46_META_WS_P_EPRECOVERYAMOUNT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Horizaline\r
@Tip = %(T_49_META_TYPE_355_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type Pacemaker : InventoryBase&FormulableEntity = 355 { #%(T_46_META_WS_C_HORIZALINE)\r
	@ApiLevel=4\r
	@ScriptName=HPRecoveryAmount\r
	@Tip = %(T_49_META_TYP_355_I0_D)\r
    Health : Int = -355000 #%(T_46_META_WS_P_HPRECOVERYAMOUNT)\r
	@ApiLevel=4\r
	@ScriptName=EPRecoveryAmount\r
	@Tip = %(T_49_META_TYP_355_I1_D)\r
    Energy : Int = -355001 #%(T_46_META_WS_P_EPRECOVERYAMOUNT)\r
	@ApiLevel=4\r
	@ScriptName=TimeRequired\r
	@Tip = %(T_49_META_TYP_355_I2_D)\r
    Pretime : Int = -355002 #%(T_46_META_WS_P_TIMEREQUIRED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Airdrop\r
@Tip = %(T_49_META_TYPE_356_D)\r
@ModuleID=40\r
@ModuleLib=AirDrop\r
type AirDrop : Transform&ResetableEntity = 356 { #%(T_46_META_WS_C_AIRDROP)\r
	@ApiLevel=4\r
	@ScriptName=DropItems\r
	@Tip = %(T_49_META_TYP_356_I0_D)\r
    DropItems : MapT_Int_Int = -356000 #%(T_46_META_WS_P_DROPITEMS)\r
	@ApiLevel=4\r
	@ScriptName=StartDropTime\r
	@Tip = %(T_49_META_TYP_356_I1_D)\r
    StartDropTime : Int = -356001 #%(T_46_META_WS_P_STARTDROPTIME)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=AirDropState\r
	@Tip = %(T_49_META_TYP_356_I2_D)\r
    get AirDropState : Int = -356002 #%(T_46_META_WS_P_AIRDROPSTATE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LaunchPad\r
@Tip = %(T_49_META_TYPE_360_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type HandCatapult : InventoryBase&FormulableEntity = 360 { #%(T_46_META_WS_C_LAUNCHPAD)\r
	@ApiLevel=4\r
	@Default=-160\r
	@ScriptName=LeftFiringArcAngle\r
	@Tip = %(T_49_META_TYP_360_I0_D)\r
    HorizontalMinAngle : Float = -360000 #%(T_46_META_WS_P_LEFTFIRINGARCANGLE)\r
	@ApiLevel=4\r
	@Default=160\r
	@ScriptName=RightFiringArcAngle\r
	@Tip = %(T_49_META_TYP_360_I1_D)\r
    HorizontalMaxAngle : Float = -360001 #%(T_46_META_WS_P_RIGHTFIRINGARCANGLE)\r
	@ApiLevel=4\r
	@Default=-45\r
	@ScriptName=MinElevationAngle\r
	@Tip = %(T_49_META_TYP_360_I2_D)\r
    VerticalMinAngle : Float = -360002 #%(T_46_META_WS_P_MINELEVATIONANGLE)\r
	@ApiLevel=4\r
	@Default=-7\r
	@ScriptName=MaxDepressionAngle\r
	@Tip = %(T_49_META_TYP_360_I3_D)\r
    VerticalMaxAngle : Float = -360003 #%(T_46_META_WS_P_MAXDEPRESSIONANGLE)\r
	@ApiLevel=4\r
	@Default=35.0\r
	@ScriptName=MuzzleVelocity\r
	@Tip = %(T_49_META_TYP_360_I4_D)\r
    Speed : Float = -360004 #%(T_46_META_WS_P_MUZZLEVELOCITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LaunchPadLevelObject\r
@Tip = %(T_49_META_TYPE_361_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type HandCatapultLevelObj : HandCatapult = 361 { #%(T_46_META_WS_C_LAUNCH PAD LEVEL OBJECT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SocialIslandSnowball\r
@Tip = %(T_49_META_TYPE_362_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
type GrenadeSnowball : Grenade = 362 { #%(T_46_META_WS_C_SOCIALISLANDSNOWBALL)\r
	@ApiLevel=4\r
	@Default=2\r
	@ScriptName=FreezeDuration\r
	@Tip = %(T_49_META_TYP_362_I0_D)\r
    FreezingTime : Float = -362000 #%(T_46_META_WS_P_FREEZEDURATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AnimationTrigger\r
@Tip = %(T_49_META_TYPE_364_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type AnimationTrigger : CustomizeTrigger = 364 { #%(T_46_META_WS_C_ANIMATIONTRIGGER)\r
	@ApiLevel=4\r
	@ScriptName=IsCenterPos\r
	@Tip = %(T_49_META_TYP_364_I0_D)\r
    IsCenterPos : Bool = -364000 #%(T_46_META_WS_P_ISCENTERPOS)\r
	@ApiLevel=4\r
	@ScriptName=IsLoop\r
	@Tip = %(T_49_META_TYP_364_I1_D)\r
    Loop : Bool = -364001 #%(T_46_META_WS_P_ISLOOP)\r
	@ApiLevel=4\r
	@ScriptName=AnimationClip\r
	@Tip = %(T_49_META_TYP_364_I2_D)\r
    Clip : AnimationClipID = -364002 #%(T_46_META_WS_P_ANIMATIONCLIP)\r
	@ApiLevel=4\r
	@ScriptName=IsAutoPlay\r
	@Tip = %(T_49_META_TYP_364_I3_D)\r
    IsAutoPlay : Bool = -364003 #%(T_46_META_WS_P_ISAUTOPLAY)\r
	@ApiLevel=4\r
	@ScriptName=UseCustomResource\r
	@Tip = %(T_49_META_TYP_364_I4_D)\r
    IsCustomEmote : Bool = -364004 #%(T_46_META_WS_P_USECUSTOMRESOURCE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIAniTriggerHud\r
@Tip = %(T_49_META_TYPE_365_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type UGCAniTriggerHud : InternalHud = 365 { #%(T_46_META_WS_C_UIANITRIGGERHUD)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    get OpenState : Bool = -365000 #%(T_46_META_WS_P_ISVISIBLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UICompass\r
@Tip = %(T_49_META_TYPE_367_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type DirectionRulerHud : InternalHud = 367 { #%(T_46_META_WS_C_UICOMPASS)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
	@Tip = %(T_49_META_TYP_22_I0_D)\r
    OpenState : Bool = -367000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@Default=false\r
	@Tip = %(T_49_META_TYP_367_I1_D)\r
    ShowTag : Bool = -367001 #%(T_46_META_WS_P_SHOWTAG)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_367_I2_D)\r
    TargetIcons : MapT_Entity_IconType = -367002 #%(T_46_META_WS_P_TARGETICONS)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_367_I3_D)\r
    TargetIconColors : MapT_Entity_Color = -367003 #%(T_46_META_WS_P_TARGETICONCOLORS)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_367_I4_D)\r
    StaticIcons : MapT_Int_IconType = -367004 #%(T_46_META_WS_P_STATICICONS)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_367_I5_D)\r
    StaticIconColors : MapT_Int_Color = -367005 #%(T_46_META_WS_P_STATICICONCOLORS)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=AlwaysShowMark\r
	@Tip = %(T_49_META_TYP_367_I6_D)\r
    IconIsAlwaysShown : Bool = -367006 #%(T_46_META_WS_P_ALWAYSSHOWMARK)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIRoundInfoBanner\r
@Tip = %(T_49_META_TYPE_370_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type RoundInfoHud : InternalHud = 370 { #%(T_46_META_WS_C_UIROUNDINFOBANNER)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_370_I0_D)\r
    Title : String = -370000 #%(T_46_META_WS_P_TITLE)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_370_I1_D)\r
    SubTitle : String = -370001 #%(T_46_META_WS_P_SUBTITLE)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_370_I2_D)\r
    BackgroundColor1 : Color = -370002 #%(T_46_META_WS_P_BACKGROUNDCOLOR1)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_370_I3_D)\r
    BackgroundColor2 : Color = -370003 #%(T_46_META_WS_P_BACKGROUNDCOLOR2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIRoundResultBanner\r
@Tip = %(T_49_META_TYPE_371_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type CSRoundResultHud : InternalHud = 371 { #%(T_46_META_WS_C_UIROUNDRESULTBANNER)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_1012_I5_D)\r
    LeftColor : Color = -371000 #%(T_46_META_WS_P_LEFTCOLOR)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_1012_I6_D)\r
    RightColor : Color = -371001 #%(T_46_META_WS_P_RIGHTCOLOR)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_371_I2_D)\r
    LeftScore : String = -371002 #%(T_46_META_WS_P_LEFTSCORE)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_371_I3_D)\r
    RightScore : String = -371003 #%(T_46_META_WS_P_RIGHTSCORE)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_371_I4_D)\r
    LeftScoreAfter : String = -371004 #%(T_46_META_WS_P_LEFTSCOREAFTER)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_371_I5_D)\r
    RightScoreAfter : String = -371005 #%(T_46_META_WS_P_RIGHTSCOREAFTER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIFollowHeadlthBar\r
@Tip = %(T_49_META_TYPE_374_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
type PlayerHeadHud : InternalHud = 374 { #%(T_46_META_WS_C_UIFOLLOWHEADLTHBAR)\r
	@ApiLevel=4\r
	@Default=-362274305\r
	@Tip = %(T_49_META_TYP_374_I0_D)\r
    MainColor : Color = -374000 #%(T_46_META_WS_P_MAINCOLOR)\r
	@ApiLevel=4\r
	@Default=-4756993\r
	@Tip = %(T_49_META_TYP_374_I1_D)\r
    LoseHpColor : Color = -374001 #%(T_46_META_WS_P_LOSEHPCOLOR)\r
	@ApiLevel=4\r
	@Default=-1526765057\r
	@Tip = %(T_49_META_TYP_374_I2_D)\r
    GainHpColor : Color = -374002 #%(T_46_META_WS_P_GAINHPCOLOR)\r
	@ApiLevel=4\r
	@Default=255\r
	@ScriptName=BackgroundColor\r
	@Tip = %(T_49_META_TYP_374_I3_D)\r
    BackGrColor : Color = -374003 #%(T_46_META_WS_P_BACKGROUNDCOLOR)\r
	@ApiLevel=4\r
	@Default=1\r
	@Tip = %(T_49_META_TYP_374_I4_D)\r
    Alpha : Float = -374004 #%(T_46_META_WS_P_ALPHA)\r
	@ApiLevel=4\r
	@Default=math.Vector3_1()\r
	@Tip = %(T_49_META_TYP_374_I5_D)\r
    Scale : Vector3 = -374005 #%(T_46_META_WS_P_SCALE)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_374_I6_D)\r
    PlayerName : String = -374006 #%(T_46_META_WS_P_PLAYERNAME)\r
	@ApiLevel=4\r
	@Default=1\r
	@Tip = %(T_49_META_TYP_155_I0_D)\r
    Level : Int = -374007 #%(T_46_META_WS_P_LEVEL)\r
	@ApiLevel=4\r
	@Default=164\r
	@Tip = %(T_49_META_TYP_374_I8_D)\r
    Width : Int = -374008 #%(T_46_META_WS_P_WIDTH)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_374_I9_D)\r
    FollowTarget : Entity = -374009 #%(T_46_META_WS_P_FOLLOWTARGET)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_374_I10_D)\r
    Offset : Vector3 = -374010 #%(T_46_META_WS_P_OFFSET)\r
	@ApiLevel=4\r
	@Default=0\r
	@Tip = %(T_49_META_TYP_374_I11_D)\r
    LineSpacing : Int = -374011 #%(T_46_META_WS_P_LINESPACING)\r
	@ApiLevel=4\r
	@Default=100\r
	@Tip = %(T_49_META_TYP_374_I12_D)\r
    TotalHp : Int = -374012 #%(T_46_META_WS_P_TOTALHP)\r
	@ApiLevel=4\r
	@Default=100\r
	@Tip = %(T_49_META_TYP_374_I13_D)\r
    CurrentHp : Int = -374013 #%(T_46_META_WS_P_CURRENTHP)\r
	@ApiLevel=4\r
	@Default=false\r
	@Tip = %(T_49_META_TYP_374_I14_D)\r
    IsOpenTween : Bool = -374014 #%(T_46_META_WS_P_ISOPENTWEEN)\r
	@ApiLevel=4\r
	@Default=false\r
	@Tip = %(T_49_META_TYP_374_I15_D)\r
    IsLocalPos : Bool = -374015 #%(T_46_META_WS_P_ISLOCALPOS)\r
	@ApiLevel=4\r
	@ScriptName=VisiblePlayers\r
	@Tip = %(T_49_META_TYP_244_I10_D)\r
    VisiblePlayers : ListT_Player = -374016 #%(T_46_META_WS_P_VISIBLEPLAYERS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayerOrVehicle\r
@Tip = %(T_49_META_TYPE_377_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
alias PlayerOrVehicle : Entity&(Player|Vehicle) = 377 #%(T_46_META_WS_C_PLAYERORVEHICLE)\r
\r
@ApiLevel=4\r
@ScriptName=PlayerOrNPC\r
@Tip = %(T_49_META_TYPE_429_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias PlayerOrNPC : Entity&(Player|NPC) = 429 #%(T_47_XXJ_WS_PLAYERORNPC)\r
\r
@ApiLevel=4\r
@ScriptName=ListT_ItemGoodsIDType\r
@Tip = %(T_49_META_TYPE_384_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_ItemGoodsIDType : List = 384 { #%(T_46_META_WS_C_LISTT_ITEMGOODSIDTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SafeZone\r
@Tip = %(T_49_META_TYPE_392_D)\r
@ModuleID=9\r
@ModuleLib=SafeZone\r
type EradicateZone : LevelObject&ResetableEntity = 392 { #%(T_46_META_WS_C_SAFEZONE)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=StartTime\r
	@Tip = %(T_49_META_TYP_392_I0_D)\r
    StartTime : Int = -392000 #%(T_46_META_WS_P_STARTTIME)\r
	@ApiLevel=4\r
	@Default=60\r
	@ScriptName=ShrinkDuration\r
	@Tip = %(T_49_META_TYP_392_I1_D)\r
    ShrinkTime : Int = -392001 #%(T_46_META_WS_P_SHRINKDURATION)\r
	@ApiLevel=10\r
	@Default=5\r
	@ScriptName=DamageInterval\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    DamageTimeSpan : Float = -392002 #%(T_46_META_WS_P_DAMAGEINTERVAL)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=DamageValue\r
	@Tip = %(T_49_META_TYP_392_I3_D)\r
    DamageValue : Int = -392003 #%(T_46_META_WS_P_DAMAGEVALUE)\r
	@ApiLevel=4\r
	@ScriptName=Players\r
	@Tip = %(T_49_META_TYP_392_I4_D)\r
    Players : ListT_Player = -392004 #%(T_46_META_WS_P_PLAYERS)\r
	@ApiLevel=4\r
	@Default=10\r
	@ScriptName=EndTime\r
	@Tip = %(T_49_META_TYP_392_I5_D)\r
    CloseTime : Int = -392005 #%(T_46_META_WS_P_ENDTIME)\r
	@ApiLevel=4\r
	@ScriptName=GroupID\r
	@Tip = %(T_49_META_TYP_392_I6_D)\r
    get GroupID : Int = -392006 #%(T_46_META_WS_P_GROUPID)\r
	@ApiLevel=4\r
	@ScriptName=StartRadius\r
	@Tip = %(T_49_META_TYP_392_I7_D)\r
    StartRadius : Float = -392007 #%(T_46_META_WS_P_STARTRADIUS)\r
	@ApiLevel=4\r
	@ScriptName=IsEnd\r
	@Tip = %(T_49_META_TYP_392_I8_D)\r
    get IsEnd : Bool = -392008 #%(T_46_META_WS_P_ISEND)\r
	@ApiLevel=4\r
	@ScriptName=Status\r
	@Tip = %(T_49_META_TYP_392_I9_D)\r
    get State : Int = -392009 #%(T_46_META_WS_P_STATUS)\r
	@ApiLevel=4\r
	@ScriptName=ShrinkEndTime\r
	@Tip = %(T_49_META_TYP_392_I10_D)\r
    get ShrinkEndTime : Int = -392010 #%(T_46_META_WS_P_SHRINKENDTIME)\r
	@ApiLevel=10\r
	@Default=-1\r
	@ScriptName=EffectColor\r
	@Tip = %(T_49_META_TYPE_18_D)\r
    EffectColor : Color = -392011 #%(T_46_META_WS_P_EFFECTCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=EndRadius\r
	@Tip = %(T_49_META_TYP_392_I12_D)\r
    EndRadius : Float = -392012 #%(T_46_META_WS_P_ENDRADIUS)\r
	@ApiLevel=4\r
	@Default=60\r
	@ScriptName=ShrinkStartTime\r
	@Tip = %(T_49_META_TYP_392_I13_D)\r
    StartShrinkTime : Int = -392013 #%(T_46_META_WS_P_SHRINKSTARTTIME)\r
	@ApiLevel=4\r
	@Default=5\r
	@Tip = %(T_49_META_TYP_392_I14_D)\r
    DamageTimeInterval : Int = -392014 #%(T_46_META_WS_P_DAMAGEINTERVAL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Hierarchical\r
@Tip = %(T_49_META_TYPE_390_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias Mountable : Entity&(Player|Transform|SkeletonPart) = 390 #%(T_46_META_WS_C_HIERARCHICAL)\r
\r
@ApiLevel=4\r
@ScriptName=NaturalConstantType\r
@Tip = %(T_49_META_TYPE_394_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
enum NaturalConst : Float = 394 { #%(T_46_META_WS_C_NATURALCONSTANTTYPE)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_394_I0_D)\r
    Pi = 3.14159265 #%(T_46_META_WS_E_PI)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_394_I1_D)\r
    E = 2.71828183 #%(T_46_META_WS_E_E)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MidGameExitConfig\r
@Tip = %(T_49_META_TYPE_396_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type MidGameExitConfig : Entity = 396 { #%(T_46_META_WS_C_MIDGAMEEXITCONFIG)\r
	@ApiLevel=4\r
	@ScriptName=Title\r
	@Tip = %(T_49_META_TYP_396_I0_D)\r
    get Title : String = -396000 #%(T_46_META_WS_P_TITLE)\r
	@ApiLevel=4\r
	@ScriptName=Content\r
	@Tip = %(T_49_META_TYP_396_I1_D)\r
    get Content : String = -396001 #%(T_46_META_WS_P_CONTENT)\r
	@ApiLevel=4\r
	@ScriptName=Options\r
	@Tip = %(T_49_META_TYP_396_I2_D)\r
    get Options : ListT_String = -396002 #%(T_46_META_WS_P_OPTIONS)\r
	@ApiLevel=4\r
	@ScriptName=ShowBackground\r
	@Tip = %(T_49_META_TYP_396_I3_D)\r
    get ShowBackground : Bool = -396003 #%(T_46_META_WS_P_SHOWBACKGROUND)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ColliderCollection\r
@Addable=["CustomLevelObject"]\r
@Conflict=["PhysicalCCT"]\r
@Tip = %(T_49_META_TYPE_397_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type ColliderShape : Component = 397 { #%(T_46_META_WS_C_COLLIDERCOLLECTION)\r
	@ApiLevel=3\r
	@Tip = %(T_49_META_TYPE_202_D)\r
    ColliderID : ColliderID = -186000 #ColliderID\r
}\r
\r
@ApiLevel=4\r
@ScriptName=VaultTrigger\r
@Tip = %(T_49_META_TYPE_406_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type VaultTrigger : CustomizeTrigger = 406 { #%(T_46_META_WS_C_VAULTTRIGGER)\r
	@ApiLevel=4\r
	@Default=0.5\r
	@ScriptName=VaultDistance\r
	@Tip = %(T_49_META_TYP_406_I0_D)\r
    VaultDistance : Float = -406000 #%(T_46_META_WS_P_VAULTDISTANCE)\r
	@ApiLevel=4\r
	@Default=0.5\r
	@ScriptName=VaultHeight\r
	@Tip = %(T_49_META_TYP_406_I1_D)\r
    VaultHeight : Float = -406001 #%(T_46_META_WS_P_VAULTHEIGHT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Persona\r
@Addable=["CustomLevelObject"]\r
@Tip = %(T_49_META_TYPE_415_D)\r
@ModuleID=43\r
@ModuleLib=LLM\r
type Persona : Component = 415 { #%(T_46_META_WS_C_PERSONA)\r
	@ApiLevel=4\r
	@ScriptName=PersonaID\r
	@Tip = %(T_49_META_TYP_415_I0_D)\r
    PersonaID : PersonaID = -415000 #%(T_46_META_WS_P_PERSONAID)\r
	@ApiLevel=4\r
	@Default=Hi\r
	@ScriptName=NickName\r
	@Tip = %(T_49_META_TYP_415_I1_D)\r
    PersonaNickName : String = -415001 #%(T_46_META_WS_P_NICKNAME)\r
	@ApiLevel=4\r
	@ScriptName=Avatar\r
	@Tip = %(T_49_META_TYP_415_I2_D)\r
    PersonaAvatar : SpriteID = -415002 #%(T_46_META_WS_P_AVATAR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=StringOrLocString\r
@Tip = %(T_49_META_TYPE_398_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias StringOrLocString : Object&(String|LocString) = 398 #%(T_46_META_WS_C_STRINGORLOCSTRING)\r
\r
@ApiLevel=4\r
@ScriptName=UISocialButtonType\r
@Tip = %(T_49_META_TYPE_403_D)\r
@ModuleID=10013\r
@ModuleLib=FF_Platform\r
enum SocialButtonType : Int = 403 { #%(T_45_XXJ_WS_UISOCIALBUTTONTYPE)\r
	@ApiLevel=4\r
	@ScriptName=AddFriend\r
	@Tip = %(T_49_META_TYP_403_I0_D)\r
    AddFriend = 0 #%(T_46_META_WS_E_ADDFRIEND)\r
	@ApiLevel=4\r
	@ScriptName=Report\r
	@Tip = %(T_49_META_TYP_403_I1_D)\r
    Report = 1 #%(T_46_META_WS_E_REPORT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UISocialButtonStyleType\r
@Tip = %(T_49_META_TYPE_404_D)\r
@ModuleID=10013\r
@ModuleLib=FF_Platform\r
enum SocialButtonStyleType : Int = 404 { #%(T_45_XXJ_WS_UISOCIALBUTTONSTYLETYPE)\r
	@ApiLevel=4\r
	@ScriptName=Bright\r
	@Tip = %(T_49_META_TYP_404_I0_D)\r
    Light = 0 #%(T_46_META_WS_E_BRIGHT)\r
	@ApiLevel=4\r
	@ScriptName=Dark\r
	@Tip = %(T_49_META_TYP_404_I1_D)\r
    Dark = 1 #%(T_46_META_WS_E_DARK)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UISocialButtonWidget\r
@Tip = %(T_49_META_TYPE_402_D)\r
@ModuleID=10013\r
@ModuleLib=FF_Platform\r
type HUDSocialButtonWidget : HudWidget = 402 { #%(T_46_META_WS_C_UISOCIALBUTTONWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=Target\r
	@Tip = %(T_49_META_TYP_402_I0_D)\r
    Player : Player = -402000 #%(T_46_META_WS_TARGET)\r
	@ApiLevel=4\r
	@ScriptName=FunctionType\r
	@Tip = %(T_49_META_TYP_402_I1_D)\r
    FunctionType : SocialButtonType = -402001 #%(T_46_META_WS_P_FUNCTIONTYPE)\r
	@ApiLevel=4\r
	@ScriptName=ButtonStyle\r
	@Tip = %(T_49_META_TYP_402_I2_D)\r
    ButtonStyle : SocialButtonStyleType = -402002 #%(T_46_META_WS_P_BUTTONSTYLE)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=Alpha\r
	@Tip = %(T_49_META_TYP_38_I0_D)\r
    Alpha : Float = -402003 #%(T_46_META_WS_P_ALPHA)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_49_META_TYPE_407_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum PlatformType : Int = 407 { #%(T_46_META_WS_C_PLATFORMTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Local\r
	@Tip = %(T_49_META_TYP_407_I0_D)\r
    Local = 0 #%(T_46_META_WS_E_LOCAL)\r
	@ApiLevel=4\r
	@ScriptName=Client\r
	@Tip = %(T_49_META_TYP_407_I1_D)\r
    Client = 1 #%(T_46_META_WS_E_CLIENT)\r
	@ApiLevel=4\r
	@ScriptName=Server\r
	@Tip = %(T_49_META_TYP_407_I2_D)\r
    Server = 2 #%(T_46_META_WS_E_SERVER)\r
	@ApiLevel=4\r
	@ScriptName=Both\r
	@Tip = %(T_49_META_TYP_407_I3_D)\r
    Both = 3 #%(T_46_META_WS_E_BOTH)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BaseDataAlias\r
@Tip = %(T_49_META_TYPE_408_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias BaseData : Object&(Bool|Int|Int64|Float|String|Vector2|Vector3|Quaternion|Color) = 408 #%(T_46_META_WS_C_BASEDATAALIAS)\r
\r
@ApiLevel=4\r
@ScriptName=StatusCode\r
@Tip = %(T_49_META_TYPE_409_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum ErrorCode : Int = 409 { #%(T_46_META_WS_A_STATUSCODE)\r
	@ApiLevel=4\r
	@ScriptName=NoError\r
	@Tip = %(T_49_META_TYP_409_I0_D)\r
    None = 0 #%(T_46_META_WS_E_NOERROR)\r
	@ApiLevel=4\r
	@ScriptName=DataStorageTimeout\r
	@Tip = %(T_49_META_TYP_409_I1_D)\r
    DB_Timeout = 1 #%(T_46_META_WS_E_DATASTORAGETIMEOUT)\r
	@ApiLevel=4\r
	@ScriptName=DataStorageLimitExceeded\r
	@Tip = %(T_49_META_TYP_409_I2_D)\r
    DB_Overlimit = 2 #%(T_46_META_WS_E_DATASTORAGELIMITEXCEEDED)\r
	@ApiLevel=4\r
	@ScriptName=DataStorageParameterError\r
	@Tip = %(T_49_META_TYP_409_I3_D)\r
    DB_ParamError = 3 #%(T_46_META_WS_E_DATASTORAGEPARAMETERERROR)\r
	@ApiLevel=4\r
	@ScriptName=Failed_InvalidAllIDsOnCreate\r
	@Tip = %(T_49_META_TYP_409_I4_D)\r
    Failed_InvalidAllIDsOnCreate = 4 #%(T_47_XXJ_WS_FAILED_INVALIDALLIDSONCREATE)\r
	@ApiLevel=4\r
	@ScriptName=CommonError\r
	@Tip = %(T_49_META_TYP_409_I5_D)\r
    Common_Error = 5 #%(T_47_XXJ_WS_COMMON_ERROR)\r
	@ApiLevel=4\r
	@ScriptName=PremiumClosed\r
	@Tip = %(T_49_META_TYP_409_I6_D)\r
    Premium_Closed = 6 #%(T_47_XXJ_WS_PREMIUM_CLOSED)\r
	@ApiLevel=4\r
	@ScriptName=ChangeTeamFailed_NotSupported\r
	@Tip = %(T_49_META_TYP_409_I7_D)\r
    ChangeTeamFailed_NotSupported = 7 #%(T_48_META_TYP_409_I7)\r
	@ApiLevel=4\r
	@ScriptName=ChangeTeamFailed_AlreadyInTeam\r
	@Tip = %(T_49_META_TYP_409_I8_D)\r
    ChangeTeamFailed_AlreadyInTeam = 8 #%(T_48_META_TYP_409_I8)\r
	@ApiLevel=4\r
	@ScriptName=ChangeTeamFailed_InvalidTarget\r
	@Tip = %(T_49_META_TYP_409_I9_D)\r
    ChangeTeamFailed_InvalidTarget = 9 #%(T_48_META_TYP_409_I9)\r
	@ApiLevel=4\r
	@ScriptName=ChangeTeamFailed_InvalidTeam\r
	@Tip = %(T_49_META_TYP_409_I10_D)\r
    ChangeTeamFailed_InvalidTeam = 10 #%(T_48_META_TYP_409_I10)\r
	@ApiLevel=4\r
	@ScriptName=ChangeTeamFailed_Dead\r
	@Tip = %(T_49_META_TYP_409_I11_D)\r
    ChangeTeamFailed_Dead = 11 #%(T_48_META_TYP_409_I11)\r
	@ApiLevel=4\r
	@ScriptName=ChangeTeamFailed_InVehicle\r
	@Tip = %(T_49_META_TYP_409_I12_D)\r
    ChangeTeamFailed_InVehicle = 12 #%(T_48_META_TYP_409_I12)\r
	@ApiLevel=4\r
	@ScriptName=LLM_OK\r
	@Tip = %(T_49_META_TYP_409_I13_D)\r
    LLM_OK = 101 #%(T_49_META_TYP_409_I13)\r
	@ApiLevel=4\r
	@ScriptName=LLM_FAILED\r
	@Tip = %(T_49_META_TYP_409_I14_D)\r
    LLM_FAILED = 102 #%(T_49_META_TYP_409_I14)\r
	@ApiLevel=4\r
	@ScriptName=LLM_TIMEOUT\r
	@Tip = %(T_49_META_TYP_409_I15_D)\r
    LLM_TIMEOUT = 103 #%(T_49_META_TYP_409_I15)\r
	@ApiLevel=4\r
	@ScriptName=LLM_INVALID_PERSONA\r
	@Tip = %(T_49_META_TYP_409_I16_D)\r
    LLM_INVALID_PERSONA = 104 #%(T_49_META_TYP_409_I16)\r
	@ApiLevel=4\r
	@ScriptName=LLM_TOKEN_LIMIT\r
	@Tip = %(T_49_META_TYP_409_I17_D)\r
    LLM_TOKEN_LIMIT = 105 #%(T_49_META_TYP_409_I17)\r
	@ApiLevel=4\r
	@ScriptName=LLM_VIOLATION\r
	@Tip = %(T_49_META_TYP_409_I18_D)\r
    LLM_VIOLATION = 106 #%(T_49_META_TYP_409_I18)\r
	@ApiLevel=4\r
	@ScriptName=LLM_FREQUENT_REQUEST\r
	@Tip = %(T_49_META_TYP_409_I19_D)\r
    LLM_FREQUENT_REQUEST = 107 #%(T_49_META_TYP_409_I19)\r
	@ApiLevel=4\r
	@ScriptName=IO_CREATE_FILE_FAILED\r
	@Tip = %(T_50_META_TYP_409_I20_D)\r
    IO_CREATE_FILE_FAILED = 108 #%(T_50_META_TYP_409_I20)\r
	@ApiLevel=4\r
	@ScriptName=IO_INVALID_FILE_NAME\r
	@Tip = %(T_50_META_TYP_409_I21_D)\r
    IO_INVALID_FILE_NAME = 109 #%(T_50_META_TYP_409_I21)\r
	@ApiLevel=4\r
	@ScriptName=PARAM_ERROR\r
	@Tip = %(T_51_META_TYP_409_I22_D)\r
    PARAM_ERROR = 110 #%(T_51_META_TYP_409_I22)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayerOrTransform\r
@Tip = %(T_49_META_TYPE_410_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias PlayerOrTransform : Entity&(Player|Transform) = 410 #%(T_46_META_WS_C_PLAYERORTRANSFORM)\r
\r
@ApiLevel=4\r
@ScriptName=Skyblaster\r
@Tip = %(T_49_META_TYPE_411_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type Helicopter : Vehicle = 411 { #%(T_46_META_WS_C_SKYBLASTER)\r
	@ApiLevel=4\r
	@Default=800\r
	@ScriptName=ForwardSpeed\r
	@Tip = %(T_49_META_TYP_411_I0_D)\r
    ForwardSpeed : Float = -411000 #%(T_46_META_WS_P_FORWARDSPEED)\r
	@ApiLevel=4\r
	@Default=600\r
	@ScriptName=BackwardSpeed\r
	@Tip = %(T_49_META_TYP_411_I1_D)\r
    BackwardSpeed : Float = -411001 #%(T_46_META_WS_P_BACKWARDSPEED)\r
	@ApiLevel=4\r
	@Default=700\r
	@ScriptName=UpSpeed\r
	@Tip = %(T_49_META_TYP_411_I2_D)\r
    UpSpeed : Float = -411002 #%(T_46_META_WS_P_UPSPEED)\r
	@ApiLevel=4\r
	@Default=800\r
	@ScriptName=DownSpeed\r
	@Tip = %(T_49_META_TYP_411_I3_D)\r
    DownSpeed : Float = -411003 #%(T_46_META_WS_P_DOWNSPEED)\r
	@ApiLevel=4\r
	@ScriptName=MissileMinDamage\r
	@Tip = %(T_49_META_TYP_411_I4_D)\r
    GrenadeMinDamage : Int = -411004 #%(T_46_META_WS_P_MISSILEMINDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=MissileMaxDamage\r
	@Tip = %(T_49_META_TYP_411_I5_D)\r
    GrenadeMaxDamage : Int = -411005 #%(T_46_META_WS_P_MISSILEMAXDAMAGE)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=MissileRange\r
	@Tip = %(T_49_META_TYP_411_I6_D)\r
    GrenadeRange : Float = -411006 #%(T_46_META_WS_P_MISSILERANGE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CameraViewingAngleRestrictionType\r
@Tip = %(T_49_META_TYPE_414_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
enum CameraViewingAngleRestrictionType : Int = 414 { #%(T_46_META_WS_C_CAMERAVIEWINGANGLERESTRICTIONTYPE)\r
	@ApiLevel=4\r
	@ScriptName=\r
	@Tip = %(T_49_META_TYP_382_I0_D)\r
    Default = 0 #%(T_46_META_WS_E_DEFAULT)\r
	@ApiLevel=4\r
	@ScriptName=\r
	@Tip = %(T_49_META_TYP_414_I1_D)\r
    WideRange = 1 #%(T_46_META_WS_E_WIDERANGE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ComplexNPC\r
@Tip = %(T_49_META_TYPE_427_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
alias ComplexNPC : NPC&Collider&ColliderShape&LevelObject&CustomLevelObject&AvatarAble&AnimationControllerAble = 427 #%(T_47_XXJ_WS_CLNPC)\r
\r
@ApiLevel=4\r
@Tip = %(T_49_META_TYPE_418_D)\r
@ModuleID=42\r
@ModuleLib=Premium\r
enum PremiumState : Int = 418 { #%(T_46_XXJ_WS_PREMIUMSTATUS)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_418_I0_D)\r
    Expire = 0 #%(T_46_XXJ_WS_EXPIRE)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_418_I1_D)\r
    Become = 1 #%(T_46_XXJ_WS_BECOME)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_418_I2_D)\r
    Renewal = 2 #%(T_46_XXJ_WS_RENEWAL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Random\r
@Tip = %(T_49_META_TYPE_430_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
enum Random : Object = 430 { #%(T_47_XXJ_WS_RANDOM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CustomCurvePathWayPoint\r
@Tip = %(T_49_META_TYPE_432_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type CustomCurvePathWayPoint : CustomLevelObject = 432 { #%(T_48_META_TYP_432)\r
	@ApiLevel=4\r
	@ScriptName=Roll\r
	@Tip = %(T_49_META_TYP_432_I0_D)\r
    get Roll : Float = -432000 #%(T_48_META_TYP_432_I0)\r
	@ApiLevel=4\r
	@ScriptName=Tangent\r
	@Tip = %(T_49_META_TYP_432_I1_D)\r
    get Tangent : Vector3 = -432001 #%(T_48_META_TYP_432_I1)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_49_META_TYPE_433_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum CustomCurvePathType : Int = 433 { #%(T_48_META_TYP_433)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_433_I0_D)\r
    Linear = 0 #%(T_48_META_TYP_433_I0)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_433_I1_D)\r
    Smooth = 1 #%(T_48_META_TYP_433_I1)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_433_I2_D)\r
    Custom = 2 #%(T_48_META_TYP_433_I2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_UUID\r
@Tip = %(T_49_META_TYPE_435_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_UUID : List = 435 { #%(T_48_META_API_1098_P1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_ErrorCode\r
@Tip = %(T_49_META_TYPE_436_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_ErrorCode : List = 436 { #%(T_48_META_API_1098_P5)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Group\r
@Tip = %(T_49_META_TYPE_439_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Group : CustomLevelObject = 439 { #%(T_48_META_TYP_439)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CustomCurvePath\r
@Tip = %(T_49_META_TYPE_434_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type CustomCurvePath : Group = 434 { #%(T_48_META_TYP_434)\r
	@ApiLevel=4\r
	@ScriptName=PathType\r
	@Tip = %(T_49_META_TYP_434_I0_D)\r
    get PathType : CustomCurvePathType = -434000 #%(T_46_META_WS_P_TYPE)\r
	@ApiLevel=4\r
	@ScriptName=Length\r
	@Tip = %(T_49_META_TYP_434_I1_D)\r
    get Length : Float = -434001 #%(T_46_META_WS_LENGTH)\r
	@ApiLevel=4\r
	@ScriptName=ClosedLoop\r
	@Tip = %(T_49_META_TYP_434_I2_D)\r
    get ClosedLoop : Bool = -434002 #%(T_48_META_TYP_434_I2)\r
	@ApiLevel=3\r
	@ScriptName=WayPoints\r
	@Tip = %(T_49_META_TYP_434_I3_D)\r
    get WayPoints : ListT_WayPoint = -434003 #%(T_48_META_TYP_434_I3)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Performance\r
@Tip = %(T_49_META_TYPE_440_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type TimeLine : Playable = 440 { #%(T_49_XXJ_WS_PERFORMANCE)\r
	@ApiLevel=4\r
	@Default=0\r
	@Tip = %(T_49_META_TYP_335_I9_D)\r
    get ElapsedTime : Int = -440000 #%(T_49_META_TYP_335_I9)\r
	@ApiLevel=4\r
	@Tip = %(T_51_META_TYP_440_I1_D)\r
    get Resource : TimeLineID = -440001 #%(T_46_META_WS_A_RESOURCE)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_49_META_TYPE_441_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type TimeLineID : AssetID = 441 { #%(T_49_META_TYP_441)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AlongPathMotion\r
@Tip = %(T_49_META_TYPE_431_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
type AlongPathMotion : Playable = 431 { #%(T_48_META_TYP_431)\r
	@ApiLevel=4\r
	@ScriptName=TargetEntity\r
	@Tip = %(T_49_META_TYP_203_I0_D)\r
    get TargetEntity : Entity = -431000 #%(T_43_YU_WS_TARGET)\r
	@ApiLevel=4\r
	@ScriptName=Path\r
	@Tip = %(T_49_META_TYP_431_I1_D)\r
    Path : CustomCurvePath = -431001 #%(T_48_META_TYP_431_I1)\r
	@ApiLevel=4\r
	@ScriptName=TweenStyle\r
	@Tip = %(T_49_META_TYP_203_I4_D)\r
    Style : TweenStyle = -431002 #%(T_46_META_WS_P_TWEENSTYLE)\r
	@ApiLevel=4\r
	@ScriptName=Speed\r
	@Tip = %(T_49_META_TYP_431_I3_D)\r
    Speed : Float = -431003 #%(T_46_META_WS_P_SPEED)\r
	@ApiLevel=4\r
	@ScriptName=TangentFacing\r
	@Tip = %(T_49_META_TYP_431_I4_D)\r
    TangentFacing : Bool = -431004 #%(T_48_META_API_93_P4)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_431_I5_D)\r
	@ApiTarget=1\r
    get ElapsedPercentage : Float = -431005 #%(T_47_XXJ_WS_ELAPSEDPERCENTAGE)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_49_META_TYPE_444_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum LanguageType : Int = 444 { #%(T_48_META_TYP_444)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_444_I0_D)\r
    English = 1 #%(T_48_META_TYP_444_I0)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_444_I1_D)\r
    Chinese_Simplified = 2 #%(T_48_META_TYP_444_I1)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_444_I2_D)\r
    Chinese_Traditional = 3 #%(T_48_META_TYP_444_I2)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_444_I3_D)\r
    Thai = 4 #%(T_48_META_TYP_444_I3)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_444_I4_D)\r
    Vietnamese = 5 #%(T_48_META_TYP_444_I4)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_444_I5_D)\r
    Indonesian = 6 #%(T_48_META_TYP_444_I5)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_444_I6_D)\r
    Portuguese = 7 #%(T_48_META_TYP_444_I6)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_444_I7_D)\r
    Spanish = 8 #%(T_48_META_TYP_444_I7)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_444_I8_D)\r
    Russian = 9 #%(T_48_META_TYP_444_I8)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_444_I9_D)\r
    Korean = 10 #%(T_48_META_TYP_444_I9)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_444_I10_D)\r
    French = 11 #%(T_48_META_TYP_444_I10)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_444_I11_D)\r
    German = 12 #%(T_48_META_TYP_444_I11)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_444_I12_D)\r
    Turkish = 13 #%(T_48_META_TYP_444_I12)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_444_I13_D)\r
    Hindi = 14 #%(T_48_META_TYP_444_I13)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_444_I14_D)\r
    Japanese = 15 #%(T_48_META_TYP_444_I14)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_444_I15_D)\r
    Romanian = 16 #%(T_48_META_TYP_444_I15)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_444_I16_D)\r
    Arabic = 17 #%(T_48_META_TYP_444_I16)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_444_I17_D)\r
    Burmese = 18 #%(T_48_META_TYP_444_I17)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_444_I18_D)\r
    Urdu = 19 #%(T_48_META_TYP_444_I18)\r
	@ApiLevel=4\r
	@Tip = %(T_49_META_TYP_444_I19_D)\r
    Bengali = 20 #%(T_48_META_TYP_444_I19)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayableControllerAttachable\r
@Addable=["LevelObject"]\r
@Tip = %(T_49_META_TYPE_446_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type PlayableControllerAttachable : Entity = 446 { #%(T_49_META_TYP_446)\r
	@ApiLevel=4\r
	@ScriptName=PlayableController\r
	@Tip = %(T_49_META_TYP_446_I0_D)\r
    PlayableController : PlayableControllerResID = -446000 #%(T_49_META_TYP_446_I0)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CustomCamera\r
@Tip = %(T_49_META_TYPE_449_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
type BasicCamera : Transform = 449 { #%(T_49_META_TYP_449)\r
	@ApiLevel=4\r
	@ScriptName=CameraProjectionMode\r
	@Tip = %(T_49_META_TYP_148_I13_D)\r
    CameraProjectionMode : CameraProjectionMode = -449000 #%(T_46_META_WS_P_CAMERAPROJECTIONMODE)\r
	@ApiLevel=4\r
	@Default=60\r
	@ScriptName=FOV\r
	@Tip = %(T_49_META_TYP_148_I1_D)\r
    Fov : Float = -449001 #%(T_46_META_WS_P_FOV)\r
	@ApiLevel=4\r
	@Default=10\r
	@ScriptName=OrthographicSize\r
	@Tip = %(T_49_META_TYP_449_I2_D)\r
    OrthographicSize : Float = -449002 #%(T_49_META_TYP_449_I2)\r
	@ApiLevel=3\r
	@Default=65535\r
	@ScriptName=CullingMask\r
	@Tip = %(T_49_META_TYP_148_I16_D)\r
    CullingMask : Int = -449003 #%(T_40_XXJ_WS_CULLINGMASK_NAMEKEY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RenderQualityType\r
@Tip = %(T_50_META_TYP_453_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum ERenderQuality : Int = 453 { #%(T_50_META_TYP_453)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_51_META_TYP_454_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias MaterialProperty : Object&(Int|Float|Vector2|Vector3|Color|TextureID) = 454 #%(T_51_META_TYP_454)\r
\r
@ApiLevel=4\r
@ScriptName=EntityFlag\r
@Tip = %(T_51_META_TYP_455_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum EntityFlag : Int = 455 { #%(T_51_META_TYP_455)\r
	@ApiLevel=4\r
	@Tip = %(T_51_META_TYP_455_I0_D)\r
    Default = 0 #%(T_46_META_WS_E_DEFAULT)\r
	@ApiLevel=4\r
	@Tip = %(T_51_META_TYP_455_I1_D)\r
    Static = 1 #%(T_51_META_TYP_455_I1)\r
	@ApiLevel=4\r
	@Tip = %(T_51_META_TYP_455_I2_D)\r
    Locally = 2 #%(T_51_META_TYP_455_I2)\r
	@ApiLevel=4\r
	@Tip = %(T_51_META_TYP_455_I3_D)\r
    RenderOnly = 4 #%(T_51_META_TYP_455_I3)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnGameStart\r
@Tip = %(T_48_META_EVT_1_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Global\r
event OnMatchStart = 1 { #%(T_46_META_WS_ONGAMESTART)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnGameEnd\r
@Tip = %(T_48_META_EVT_3_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Global\r
event OnMatchEnd = 3 { #%(T_46_META_WS_ONGAMEEND)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnRoundStart\r
@Tip = %(T_48_META_EVT_4_D)\r
@ModuleID=2\r
@ModuleLib=Workflow\r
@Owner = Global\r
event OnRoundStart = 4 { #%(T_46_META_WS_ONROUNDSTART)\r
	@ScriptName=RoundIndex\r
	@Tip = %(T_48_META_EVT_4_P0_D)\r
    RoundIndex : Int #%(T_46_META_WS_ROUNDINDEX)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEquipArmor\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3019_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Player\r
event OnWear = 3019 { #%(T_46_META_WS_ONEQUIPARMOR)\r
	@ScriptName=EquipmentID\r
	@Tip = %(T_48_META_EVT_3019_P0_D)\r
    EquipType : Int #%(T_46_META_WS_EQUIPMENTID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEquipWeapon\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3020_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Player\r
event OnWield = 3020 { #%(T_46_META_WS_ONEQUIPWEAPON)\r
	@ScriptName=Weapon\r
	@Tip = %(T_48_META_EVT_3020_P0_D)\r
    WeaponEntity : Weapon #%(T_46_META_WS_WEAPON)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnAccessEquipment\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3113_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Player\r
event OnPlayerEquip = 3113 { #%(T_46_META_WS_ONACCESSEQUIPMENT)\r
	@ScriptName=Item\r
	@Tip = %(T_48_META_EVT_3113_P0_D)\r
    ItemEntity : Entity #%(T_46_META_WS_ITEM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnSwitchHandHeld\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3114_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Player\r
event OnPlayerHandHeld = 3114 { #%(T_46_META_WS_ONSWITCHHANDHELD)\r
	@ScriptName=Item\r
	@Tip = %(T_48_META_EVT_3114_P0_D)\r
    ItemEntity : Entity #%(T_46_META_WS_ITEM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnRoundEnd\r
@Tip = %(T_48_META_EVT_5_D)\r
@ModuleID=2\r
@ModuleLib=Workflow\r
@Owner = Global\r
event OnRoundEnd = 5 { #%(T_46_META_WS_ONROUNDEND)\r
	@ScriptName=RoundIndex\r
	@Tip = %(T_48_META_EVT_5_P0_D)\r
    RoundIndex : Int #%(T_46_META_WS_ROUNDINDEX)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPhaseStart\r
@Tip = %(T_48_META_EVT_7_D)\r
@ModuleID=1\r
@ModuleLib=Workflow\r
@Owner = Global\r
event OnPhaseStart = 7 { #%(T_46_META_WS_ONPHASESTART)\r
	@ScriptName=Phase\r
	@Tip = %(T_48_META_EVT_7_P0_D)\r
    Phase : Phase #%(T_46_META_WS_PHASE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPhaseEnd\r
@Tip = %(T_48_META_EVT_8_D)\r
@ModuleID=1\r
@ModuleLib=Workflow\r
@Owner = Global\r
event OnPhaseEnd = 8 { #%(T_46_META_WS_ONPHASEEND)\r
	@ScriptName=Phase\r
	@Tip = %(T_48_META_EVT_8_P0_D)\r
    Phase : Phase #%(T_46_META_WS_PHASE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerQuit\r
@Tip = %(T_48_META_EVT_11_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Global\r
event OnUserQuit = 11 { #%(T_46_META_WS_ONPLAYERQUIT)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_11_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnPlayerScoreChange\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_1000_D)\r
@ModuleID=5\r
@ModuleLib=GameResult\r
@Owner = Global\r
event OnPlayerRoundScoreChange = 1000 { #%(T_46_META_WS_ONPLAYERSCORECHANGE)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_1000_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=ScoreType\r
	@Tip = %(T_48_META_EVT_1000_P1_D)\r
    ScoreType : ScoreType #%(T_46_META_WS_SCORETYPE)\r
	@ScriptName=Score\r
	@Tip = %(T_48_META_EVT_1000_P2_D)\r
    Score : Int #%(T_46_META_WS_SCORE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnScoreChange\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3023_D)\r
@ModuleID=5\r
@ModuleLib=GameResult\r
@Owner = ScoreableEntity\r
event OnRoundScoreChange = 3023 { #%(T_46_META_WS_ONSCORECHANGE)\r
	@ScriptName=ScoreType\r
	@Tip = %(T_48_META_EVT_3023_P0_D)\r
    ScoreType : ScoreType #%(T_46_META_WS_SCORETYPE)\r
	@ScriptName=Score\r
	@Tip = %(T_48_META_EVT_3023_P1_D)\r
    Score : Int #%(T_46_META_WS_SCORE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnTeamScoreChange\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_1001_D)\r
@ModuleID=5\r
@ModuleLib=GameResult\r
@Owner = Global\r
event OnTeamRoundScoreChange = 1001 { #%(T_46_META_WS_ONTEAMSCORECHANGE)\r
	@ScriptName=Team\r
	@Tip = %(T_48_META_EVT_1001_P0_D)\r
    Team : Team #%(T_46_META_WS_TEAM)\r
	@ScriptName=ScoreType\r
	@Tip = %(T_48_META_EVT_1001_P1_D)\r
    ScoreType : ScoreType #%(T_46_META_WS_SCORETYPE)\r
	@ScriptName=Score\r
	@Tip = %(T_48_META_EVT_1001_P2_D)\r
    Score : Int #%(T_46_META_WS_SCORE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnPlayerRankChange\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_1002_D)\r
@ModuleID=7\r
@ModuleLib=GameResult\r
@Owner = Global\r
event OnPlayerRoundRankChange = 1002 { #%(T_46_META_WS_ONPLAYERRANKCHANGE)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_1002_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=Rank\r
	@Tip = %(T_48_META_EVT_1002_P1_D)\r
    Rank : Int #%(T_46_META_WS_RANK)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnRankChanged\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3024_D)\r
@ModuleID=7\r
@ModuleLib=GameResult\r
@Owner = RankableEntity\r
event OnRoundRankChange = 3024 { #%(T_46_META_WS_ONRANKCHANGED)\r
	@ScriptName=Rank\r
	@Tip = %(T_48_META_EVT_3024_P0_D)\r
    Rank : Int #%(T_46_META_WS_RANK)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnTeamRoundRankChange\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_1003_D)\r
@ModuleID=7\r
@ModuleLib=GameResult\r
@Owner = Global\r
event OnTeamRoundRankChange = 1003 { #%(T_46_META_WS_ONTEAMROUNDRANKCHANGE)\r
	@ScriptName=Team\r
	@Tip = %(T_48_META_EVT_1003_P0_D)\r
    Team : Team #%(T_46_META_WS_TEAM)\r
	@ScriptName=Rank\r
	@Tip = %(T_48_META_EVT_1003_P1_D)\r
    Rank : Int #%(T_46_META_WS_RANK)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerBeEliminated\r
@Tip = %(T_48_META_EVT_2002_D)\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = Global\r
event OnPlayerDead = 2002 { #%(T_46_META_WS_ONPLAYERBEELIMINATED)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_2002_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerAssist\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_2003_D)\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = Global\r
event OnPlayerAssist = 2003 { #%(T_46_META_WS_ONPLAYERASSIST)\r
	@ScriptName=AssistPlayer\r
	@Tip = %(T_48_META_EVT_2003_P0_D)\r
    AssistPlayer : Player #%(T_46_META_WS_ASSISTPLAYER)\r
	@ScriptName=EliminatedPlayer\r
	@Tip = %(T_48_META_EVT_2003_P1_D)\r
    BeKilledPlayer : Player #%(T_46_META_WS_ELIMINATEDPLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnAssist\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3025_D)\r
@ModuleID=27\r
@ModuleLib=Combat\r
@Owner = FightingEntity\r
event OnAssist = 3025 { #%(T_46_META_WS_ONASSIST)\r
	@ScriptName=EliminatedEntity\r
	@Tip = %(T_48_META_EVT_3025_P0_D)\r
    BeKilledPlayer : FightingEntity #%(T_46_META_WS_ELIMINATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerDealDamage\r
@Tip = %(T_48_META_EVT_2004_D)\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = Global\r
event OnPlayerDamage = 2004 { #%(T_46_META_WS_ONPLAYERDEALDAMAGE)\r
	@ScriptName=Attacker\r
	@Tip = %(T_48_META_EVT_2004_P0_D)\r
    Player : Player #%(T_46_META_WS_ATTACKER)\r
	@ScriptName=Target\r
	@Tip = %(T_48_META_EVT_2004_P1_D)\r
    BeDamagedPlayer : Player #%(T_46_META_WS_TARGET)\r
	@ScriptName=DamageType\r
	@Tip = %(T_48_META_EVT_2004_P2_D)\r
    DamageType : DamageType #%(T_46_META_WS_DAMAGETYPE)\r
	@ScriptName=Value\r
	@Tip = %(T_48_META_EVT_2004_P3_D)\r
    Value : Int #%(T_46_META_WS_VALUE)\r
	@ScriptName=DamagedBodyPart\r
	@Tip = %(T_48_META_EVT_2004_P4_D)\r
    HitBodyPart : HitBodyPart #%(T_46_META_WS_DAMAGEDBODYPART)\r
}\r
\r
@ApiLevel=11\r
@ScriptName=OnEntityEnterTrigger_Deprecated\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3037_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Player\r
event OnEnterTrigger = 3037 { #%(T_35_WZY_WS_ENTERTRIGGER_NAME)\r
	@ScriptName=Trigger\r
	@Tip = %(T_48_META_EVT_3037_P0_D)\r
    TargetEntity : Entity #%(T_46_META_WS_TRIGGER)\r
}\r
\r
@ApiLevel=11\r
@ScriptName=OnEntityLeaveTrigger_Deprecated\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3038_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Player\r
event OnLeaveTrigger = 3038 { #%(T_35_WZY_WS_QUITTRIGGER_NAME)\r
	@ScriptName=Trigger\r
	@Tip = %(T_48_META_EVT_3038_P0_D)\r
    TargetEntity : Entity #%(T_46_META_WS_TRIGGER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerEliminate\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_2005_D)\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = Global\r
event OnPlayerKill = 2005 { #%(T_46_META_WS_ONPLAYERELIMINATE)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_2005_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=eliminatedPlayer\r
	@Tip = %(T_48_META_EVT_2005_P1_D)\r
    BeKilledPlayer : Player #%(T_46_META_WS_ELIMINATEDPLAYER)\r
	@ScriptName=DamageType\r
	@Tip = %(T_48_META_EVT_2005_P2_D)\r
    DamageType : DamageType #%(T_46_META_WS_DAMAGETYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerJoin\r
@Tip = %(T_48_META_EVT_2006_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Global\r
event OnPlayerAdd = 2006 { #%(T_46_META_WS_ONPLAYERJOIN)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_2006_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerRevived\r
@Tip = %(T_48_META_EVT_2007_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Global\r
event OnPlayerRevive = 2007 { #%(T_46_META_WS_ONPLAYERREVIVED)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_2007_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=RevivalSource\r
	@Tip = %(T_48_META_EVT_2007_P1_D)\r
    PlayerReviveSourceType : PlayerReviveSourceType #%(T_46_META_WS_REVIVALSOURCE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerBeKnockedDown\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_2008_D)\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = Global\r
event OnPlayerKnockedDown = 2008 { #%(T_46_META_WS_ONPLAYERBEKNOCKEDDOWN)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_2008_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=Attacker\r
	@Tip = %(T_48_META_EVT_2008_P1_D)\r
    Damager : Player #%(T_46_META_WS_ATTACKER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnTeamRemove\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_2100_D)\r
@ModuleID=14\r
@ModuleLib=Hostility\r
@Owner = Global\r
event OnRemoveTeam = 2100 { #%(T_46_META_WS_ONTEAMREMOVE)\r
	@ScriptName=Team\r
	@Tip = %(T_48_META_EVT_2100_P0_D)\r
    Team : Team #%(T_46_META_WS_TEAM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnTeamAdd\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_2101_D)\r
@ModuleID=14\r
@ModuleLib=Hostility\r
@Owner = Global\r
event OnAddTeam = 2101 { #%(T_46_META_WS_ONTEAMADD)\r
	@ScriptName=Team\r
	@Tip = %(T_48_META_EVT_2101_P0_D)\r
    Team : Team #%(T_46_META_WS_TEAM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnTeamAce\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_2102_D)\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = Global\r
event OnTeamACE = 2102 { #%(T_46_META_WS_ONTEAMACE)\r
	@ScriptName=Team\r
	@Tip = %(T_48_META_EVT_2102_P0_D)\r
    Team : Team #%(T_46_META_WS_TEAM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnACE\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3018_D)\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = Team\r
event OnACE = 3018 { #%(T_46_META_WS_ONACE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnAwake\r
@Tip = %(T_48_META_EVT_3000_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Entity\r
event OnAwake = 3000 { #%(T_46_META_WS_ONAWAKE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnDestroy\r
@Tip = %(T_48_META_EVT_3001_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Entity\r
event OnDestroy = 3001 { #%(T_46_META_WS_ONDESTROY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEnable\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3007_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Entity\r
event OnEnable = 3007 { #%(T_46_META_WS_ONENABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnDisable\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3008_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Entity\r
event OnDisable = 3008 { #%(T_46_META_WS_ONDISABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEliminated\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3011_D)\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = FightingEntity\r
event OnDamaged = 3011 { #%(T_46_META_WS_ONELIMINATED)\r
	@ScriptName=Attacker\r
	@Tip = %(T_48_META_EVT_3011_P0_D)\r
    AttackerEntity : Entity #%(T_46_META_WS_ATTACKER)\r
	@ScriptName=DamageType\r
	@Tip = %(T_48_META_EVT_3011_P1_D)\r
    AttackedType : DamageType #%(T_46_META_WS_DAMAGETYPE)\r
	@ScriptName=DamagedBodyPart\r
	@Tip = %(T_48_META_EVT_3011_P2_D)\r
    HitBodyPart : HitBodyPart #%(T_46_META_WS_DAMAGEDBODYPART)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnTakeDamage\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3012_D)\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = FightingEntity\r
event OnAttacked = 3012 { #%(T_46_META_WS_ONTAKEDAMAGE)\r
	@ScriptName=Attacker\r
	@Tip = %(T_48_META_EVT_3012_P0_D)\r
    AttackerEntity : Entity #%(T_46_META_WS_ATTACKER)\r
	@ScriptName=DamageType\r
	@Tip = %(T_48_META_EVT_3012_P1_D)\r
    AttackedType : DamageType #%(T_46_META_WS_DAMAGETYPE)\r
	@ScriptName=Damage\r
	@Tip = %(T_48_META_EVT_3012_P2_D)\r
    Value : Int #%(T_46_META_WS_DAMAGE)\r
	@ScriptName=DamagedBodyPart\r
	@Tip = %(T_48_META_EVT_3012_P3_D)\r
    HitBodyPart : HitBodyPart #%(T_46_META_WS_DAMAGEDBODYPART)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPreTakeDamage\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_10_D)\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = FightingEntity\r
event OnBeforeAttacked = 10 { #%(T_46_META_WS_ONPRETAKEDAMAGE)\r
	@ScriptName=Attacker\r
	@Tip = %(T_48_META_EVT_10_P0_D)\r
    AttackerEntity : Entity #%(T_46_META_WS_ATTACKER)\r
	@ScriptName=DamageType\r
	@Tip = %(T_48_META_EVT_10_P1_D)\r
    AttackedType : DamageType #%(T_46_META_WS_DAMAGETYPE)\r
	@ScriptName=Damage\r
	@Tip = %(T_48_META_EVT_10_P2_D)\r
    Value : Int #%(T_46_META_WS_DAMAGE)\r
	@ScriptName=DamagedBodyPart\r
	@Tip = %(T_48_META_EVT_10_P3_D)\r
    HitBodyPart : HitBodyPart #%(T_46_META_WS_DAMAGEDBODYPART)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPreDealDamage\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_13_D)\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = FightingEntity\r
event OnBeforeHurt = 13 { #%(T_46_META_WS_ONPREDEALDAMAGE)\r
	@ScriptName=Target\r
	@Tip = %(T_48_META_EVT_13_P0_D)\r
    AttackTarget : FightingEntity #%(T_46_META_WS_TARGET)\r
	@ScriptName=DamageType\r
	@Tip = %(T_48_META_EVT_13_P1_D)\r
    DamageType : DamageType #%(T_46_META_WS_DAMAGETYPE)\r
	@ScriptName=Damage\r
	@Tip = %(T_48_META_EVT_13_P2_D)\r
    DamageValue : Int #%(T_46_META_WS_DAMAGE)\r
	@ScriptName=DamagedBodyPart\r
	@Tip = %(T_48_META_EVT_13_P3_D)\r
    DamagePart : HitBodyPart #%(T_46_META_WS_DAMAGEDBODYPART)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnDealDamage\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3013_D)\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = FightingEntity\r
event OnHurt = 3013 { #%(T_46_META_WS_ONDEALDAMAGE)\r
	@ScriptName=Target\r
	@Tip = %(T_48_META_EVT_3013_P0_D)\r
    TargetEntity : Entity #%(T_46_META_WS_TARGET)\r
	@ScriptName=DamageType\r
	@Tip = %(T_48_META_EVT_3013_P1_D)\r
    HurtType : DamageType #%(T_46_META_WS_DAMAGETYPE)\r
	@ScriptName=Damage\r
	@Tip = %(T_48_META_EVT_3013_P2_D)\r
    Value : Int #%(T_46_META_WS_DAMAGE)\r
	@ScriptName=DamagedBodyPart\r
	@Tip = %(T_48_META_EVT_3013_P3_D)\r
    HitBodyPart : HitBodyPart #%(T_46_META_WS_DAMAGEDBODYPART)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEliminate\r
@Tip = %(T_48_META_EVT_3014_D)\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = FightingEntity\r
event OnKill = 3014 { #%(T_46_META_WS_ONELIMINATE)\r
	@ScriptName=Target\r
	@Tip = %(T_48_META_EVT_3014_P0_D)\r
    TargetEntity : Entity #%(T_46_META_WS_TARGET)\r
	@ScriptName=DamagedBodyPart\r
	@Tip = %(T_48_META_EVT_3014_P1_D)\r
    HitBodyPart : HitBodyPart #%(T_46_META_WS_DAMAGEDBODYPART)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerEnter\r
@Tip = %(T_48_META_EVT_3002_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = CustomizeTrigger\r
event OnPlayerEnter = 3002 { #%(T_46_META_WS_ONPLAYERENTER)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3002_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerEnter\r
@Tip = %(T_48_META_EVT_3002_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = KillOrGodZoneTrigger\r
event OnPlayerEnter = 3002 { #%(T_46_META_WS_ONPLAYERENTER)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3002_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerEnter\r
@Tip = %(T_48_META_EVT_3002_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = CheckPointTrigger\r
event OnPlayerEnter = 3002 { #%(T_46_META_WS_ONPLAYERENTER)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3002_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerEnter\r
@Tip = %(T_48_META_EVT_3002_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = EndPointTrigger\r
event OnPlayerEnter = 3002 { #%(T_46_META_WS_ONPLAYERENTER)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3002_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerLeave\r
@Tip = %(T_48_META_EVT_3003_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = CustomizeTrigger\r
event OnPlayerLeave = 3003 { #%(T_46_META_WS_ONPLAYERLEAVE)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3003_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerLeave\r
@Tip = %(T_48_META_EVT_3003_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = KillOrGodZoneTrigger\r
event OnPlayerLeave = 3003 { #%(T_46_META_WS_ONPLAYERLEAVE)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3003_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBuiltInButtonTapped\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3005_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = LeaderboardButtonHud\r
event OnInternalHUDClick = 3005 { #%(T_46_META_WS_ONBUILTINBUTTONTAPPED)\r
	@ScriptName=ButtonName\r
	@Tip = %(T_48_META_EVT_3005_P0_D)\r
    ButtonName : String #%(T_46_META_WS_BUTTONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBuiltInButtonTapped\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3005_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = TwoTeamLeaderboardHud\r
event OnInternalHUDClick = 3005 { #%(T_46_META_WS_ONBUILTINBUTTONTAPPED)\r
	@ScriptName=ButtonName\r
	@Tip = %(T_48_META_EVT_3005_P0_D)\r
    ButtonName : String #%(T_46_META_WS_BUTTONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBuiltInButtonTapped\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3005_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = MoreTeamLeaderboardHud\r
event OnInternalHUDClick = 3005 { #%(T_46_META_WS_ONBUILTINBUTTONTAPPED)\r
	@ScriptName=ButtonName\r
	@Tip = %(T_48_META_EVT_3005_P0_D)\r
    ButtonName : String #%(T_46_META_WS_BUTTONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBuiltInButtonTapped\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3005_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = SingleLeaderboardHud\r
event OnInternalHUDClick = 3005 { #%(T_46_META_WS_ONBUILTINBUTTONTAPPED)\r
	@ScriptName=ButtonName\r
	@Tip = %(T_48_META_EVT_3005_P0_D)\r
    ButtonName : String #%(T_46_META_WS_BUTTONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBuiltInButtonTapped\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3005_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = ActionHud\r
event OnInternalHUDClick = 3005 { #%(T_46_META_WS_ONBUILTINBUTTONTAPPED)\r
	@ScriptName=ButtonName\r
	@Tip = %(T_48_META_EVT_3005_P0_D)\r
    ButtonName : String #%(T_46_META_WS_BUTTONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBuiltInButtonTapped\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3005_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = UGCShopHud\r
event OnInternalHUDClick = 3005 { #%(T_46_META_WS_ONBUILTINBUTTONTAPPED)\r
	@ScriptName=ButtonName\r
	@Tip = %(T_48_META_EVT_3005_P0_D)\r
    ButtonName : String #%(T_46_META_WS_BUTTONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBuiltInButtonTapped\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3005_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = ChooseCardHud\r
event OnInternalHUDClick = 3005 { #%(T_46_META_WS_ONBUILTINBUTTONTAPPED)\r
	@ScriptName=ButtonName\r
	@Tip = %(T_48_META_EVT_3005_P0_D)\r
    ButtonName : String #%(T_46_META_WS_BUTTONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBuiltInButtonTapped\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3005_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = SkillButtonHud\r
event OnInternalHUDClick = 3005 { #%(T_46_META_WS_ONBUILTINBUTTONTAPPED)\r
	@ScriptName=ButtonName\r
	@Tip = %(T_48_META_EVT_3005_P0_D)\r
    ButtonName : String #%(T_46_META_WS_BUTTONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBuiltInButtonTapped\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3005_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = ProgressCircleHud\r
event OnInternalHUDClick = 3005 { #%(T_46_META_WS_ONBUILTINBUTTONTAPPED)\r
	@ScriptName=ButtonName\r
	@Tip = %(T_48_META_EVT_3005_P0_D)\r
    ButtonName : String #%(T_46_META_WS_BUTTONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBuiltInButtonTapped\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3005_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = HintButtonHud\r
event OnInternalHUDClick = 3005 { #%(T_46_META_WS_ONBUILTINBUTTONTAPPED)\r
	@ScriptName=ButtonName\r
	@Tip = %(T_48_META_EVT_3005_P0_D)\r
    ButtonName : String #%(T_46_META_WS_BUTTONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBuiltInButtonTapped\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3005_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = ProgressSkillButtonHud\r
event OnInternalHUDClick = 3005 { #%(T_46_META_WS_ONBUILTINBUTTONTAPPED)\r
	@ScriptName=ButtonName\r
	@Tip = %(T_48_META_EVT_3005_P0_D)\r
    ButtonName : String #%(T_46_META_WS_BUTTONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBuiltInButtonTapped\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3005_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = TwoTeamLeaderboardHudV2\r
event OnInternalHUDClick = 3005 { #%(T_46_META_WS_ONBUILTINBUTTONTAPPED)\r
	@ScriptName=ButtonName\r
	@Tip = %(T_48_META_EVT_3005_P0_D)\r
    ButtonName : String #%(T_46_META_WS_BUTTONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBuiltInButtonTapped\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3005_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = MoreTeamLeaderboardHudV2\r
event OnInternalHUDClick = 3005 { #%(T_46_META_WS_ONBUILTINBUTTONTAPPED)\r
	@ScriptName=ButtonName\r
	@Tip = %(T_48_META_EVT_3005_P0_D)\r
    ButtonName : String #%(T_46_META_WS_BUTTONNAME)\r
}\r
\r
@ApiLevel=3\r
@ScriptName=OnBuiltInCloseButtonTapped\r
@ApiTarget=2\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = TwoTeamLeaderboardHudV2\r
event OnInternalHUDClose = 15 { #OnInternalHUDClose\r
}\r
\r
@ApiLevel=3\r
@ScriptName=OnBuiltInCloseButtonTapped\r
@ApiTarget=2\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = MoreTeamLeaderboardHudV2\r
event OnInternalHUDClose = 15 { #OnInternalHUDClose\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnTriggerEnter\r
@Tip = %(T_48_META_EVT_3009_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Owner = CustomizeTrigger\r
event OnTriggerEnter = 3009 { #%(T_46_META_WS_ONENTITYENTER)\r
	@ScriptName=Target\r
	@Tip = %(T_48_META_EVT_3009_P0_D)\r
    TargetEntity : Entity #%(T_46_META_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnTriggerEnter\r
@Tip = %(T_48_META_EVT_3009_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Owner = Collider\r
event OnTriggerEnter = 3009 { #%(T_46_META_WS_ONENTITYENTER)\r
	@ScriptName=Target\r
	@Tip = %(T_48_META_EVT_3009_P0_D)\r
    TargetEntity : Entity #%(T_46_META_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnTriggerLeave\r
@Tip = %(T_48_META_EVT_3010_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Owner = CustomizeTrigger\r
event OnTriggerLeave = 3010 { #%(T_46_META_WS_ONENTITYEXIT)\r
	@ScriptName=Target\r
	@Tip = %(T_48_META_EVT_3010_P0_D)\r
    TargetEntity : Entity #%(T_46_META_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnTriggerLeave\r
@Tip = %(T_48_META_EVT_3010_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Owner = Collider\r
event OnTriggerLeave = 3010 { #%(T_46_META_WS_ONENTITYEXIT)\r
	@ScriptName=Target\r
	@Tip = %(T_48_META_EVT_3010_P0_D)\r
    TargetEntity : Entity #%(T_46_META_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnCollisionEnter\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_6_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Owner = Collider\r
event OnCollisionEnter = 6 { #%(T_46_META_WS_ONCOLLISIONENTER)\r
	@ScriptName=CollidedEntity\r
	@Tip = %(T_48_META_EVT_6_P0_D)\r
    OtherEntity : Entity #%(T_46_META_WS_COLLIDEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnCollisionExit\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_9_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Owner = Collider\r
event OnCollisionExit = 9 { #%(T_46_META_WS_ONCOLLISIONEXIT)\r
	@ScriptName=CollidedEntity\r
	@Tip = %(T_48_META_EVT_9_P0_D)\r
    OtherEntity : Entity #%(T_46_META_WS_COLLIDEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnCharacterControllerHit\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_12_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Owner = PhysicalCCT\r
event OnControllerColliderHit = 12 { #%(T_46_META_WS_ONCHARACTERCONTROLLERHIT)\r
	@ScriptName=CollidedEntity\r
	@Tip = %(T_48_META_EVT_12_P0_D)\r
    OtherEntity : Entity #%(T_46_META_WS_COLLIDEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnTapped\r
@Tip = %(T_48_META_EVT_3004_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = HudButtonWidget\r
event OnClick = 3004 { #%(T_46_META_WS_ONTAPPED)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3004_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnBeKnockedDown_Deprecated\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3017_D)\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = Player\r
event OnKnockedDown = 3017 { #%(T_46_META_WS_ONBEKNOCKEDDOWN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnKnockedDown\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3129_D)\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = Player\r
event OnKnockedDownV2 = 3129 { #%(T_46_META_WS_ONBEKNOCKEDDOWN)\r
	@ScriptName=Attacker\r
	@Tip = %(T_48_META_EVT_3129_P0_D)\r
    Attaker : FightingEntity #%(T_46_META_WS_ATTACKER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnUseConsumable\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3021_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Player\r
event OnUseItem = 3021 { #%(T_46_META_WS_ONUSECONSUMABLE)\r
	@ScriptName=ConsumableID\r
	@Tip = %(T_48_META_EVT_3021_P0_D)\r
    ItemType : ItemGoodsIDType #%(T_46_META_WS_CONSUMABLEID)\r
	@ScriptName=Item\r
	@Tip = %(T_48_META_EVT_3021_P1_D)\r
    TargetEntity : Entity #%(T_46_META_WS_ITEM)\r
	@ScriptName=SpawnedItem\r
	@Tip = %(T_48_META_EVT_3021_P2_D)\r
    NewEntity : Entity #%(T_46_META_WS_SPAWNEDITEM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnAccessItem\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3022_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Player\r
event OnObtainItem = 3022 { #%(T_46_META_WS_ONACCESSITEM)\r
	@ScriptName=ItemID\r
	@Tip = %(T_48_META_EVT_3022_P0_D)\r
    ItemType : ItemGoodsIDType #%(T_46_META_WS_ITEMID)\r
	@ScriptName=Item\r
	@Tip = %(T_48_META_EVT_3022_P1_D)\r
    TargetEntity : Entity #%(T_46_META_WS_ITEM)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnEnteringVehicle_Deprecated\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3026_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Player\r
event OnEnteringVehicle = 3026 { #%(T_36_WZY_WS_PLAGETONVEH_NAME)\r
	@Tip = %(T_48_META_EVT_3026_P0_D)\r
    TargetEntity : Entity #%(T_34_WT_WS_ENTITY2_PARAM1)\r
	@Tip = %(T_48_META_EVT_3026_P1_D)\r
    Vehicle : Vehicle #%(T_36_WZY_WS_VEHENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEnterVehicle\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3065_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Player\r
event OnEnteringVehicle_V2 = 3065 { #%(T_46_META_WS_ONENTERVEHICLE)\r
	@ScriptName=Vehicle\r
	@Tip = %(T_48_META_EVT_3065_P0_D)\r
    Vehicle : Vehicle #%(T_46_META_WS_VEHICLE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnLeavingVehicle_Deprecated\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3027_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Player\r
event OnLeavingVehicle = 3027 { #%(T_36_WZY_WS_PLAGETOFFVEH_NAME)\r
	@Tip = %(T_48_META_EVT_3027_P0_D)\r
    TargetEntity : Entity #%(T_34_WT_WS_ENTITY2_PARAM1)\r
	@Tip = %(T_48_META_EVT_3027_P1_D)\r
    Vehicle : Vehicle #%(T_36_WZY_WS_VEHENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnLeaveVehicle\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3066_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Player\r
event OnLeavingVehicle_V2 = 3066 { #%(T_46_META_WS_ONLEAVEVEHICLE)\r
	@ScriptName=Vehicle\r
	@Tip = %(T_48_META_EVT_3066_P0_D)\r
    Vehicle : Vehicle #%(T_46_META_WS_VEHICLE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnDrivingVehicle_Deprecated\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3028_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Player\r
event OnDrivingVehicle = 3028 { #%(T_36_WZY_WS_PLADRIVEH_NAME)\r
	@Tip = %(T_48_META_EVT_3028_P0_D)\r
    TargetEntity : Entity #%(T_34_WT_WS_ENTITY2_PARAM1)\r
	@Tip = %(T_48_META_EVT_3028_P1_D)\r
    Vehicle : Vehicle #%(T_36_WZY_WS_VEHENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnDriveVehicle\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3067_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Player\r
event OnDrivingVehicle_V2 = 3067 { #%(T_46_META_WS_ONDRIVEVEHICLE)\r
	@ScriptName=Vehicle\r
	@Tip = %(T_48_META_EVT_3067_P0_D)\r
    Vehicle : Vehicle #%(T_46_META_WS_VEHICLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEntered\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3029_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Vehicle\r
event OnBeEnterVehicle = 3029 { #%(T_46_META_WS_ONENTERED)\r
	@ScriptName=Target\r
	@Tip = %(T_48_META_EVT_3029_P0_D)\r
    TargetEntity : Entity #%(T_46_META_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnLeft\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3030_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Vehicle\r
event OnBeLeaveVehicle = 3030 { #%(T_46_META_WS_ONLEFT)\r
	@ScriptName=Target\r
	@Tip = %(T_48_META_EVT_3030_P0_D)\r
    TargetEntity : Entity #%(T_46_META_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnDriven\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3031_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Vehicle\r
event OnBeDriveVehicle = 3031 { #%(T_46_META_WS_ONDRIVED)\r
	@ScriptName=Target\r
	@Tip = %(T_48_META_EVT_3031_P0_D)\r
    TargetEntity : Entity #%(T_46_META_WS_TARGET)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnTeleporting_Deprecated\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3032_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Player\r
event OnTeleporting = 3032 { #%(T_36_WZY_WS_PLATP_NAME)\r
	@Tip = %(T_48_META_EVT_3032_P0_D)\r
    TargetEntity : Entity #%(T_34_WT_WS_ENTITY2_PARAM1)\r
	@Tip = %(T_48_META_EVT_3032_P1_D)\r
    TeleportDoor : TeleportDoor #%(T_36_WZY_WS_PORTALENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnUsePortal\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3068_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Player\r
event OnTeleporting_V2 = 3068 { #%(T_46_META_WS_ONUSEPORTAL)\r
	@ScriptName=Portal\r
	@Tip = %(T_48_META_EVT_3068_P0_D)\r
    TeleportDoor : TeleportDoor #%(T_46_META_WS_PORTAL)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnSpringing_Deprecated\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3033_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Player\r
event OnSpringing = 3033 { #%(T_36_WZY_WS_PLAKNOFLY_NAME)\r
	@Tip = %(T_48_META_EVT_3033_P0_D)\r
    TargetEntity : Entity #%(T_34_WT_WS_ENTITY2_PARAM1)\r
	@Tip = %(T_48_META_EVT_3033_P1_D)\r
    BounceTire : BounceTire #%(T_36_WZY_WS_OBJENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBouncedByTire\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3069_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Player\r
event OnSpringing_V2 = 3069 { #%(T_46_META_WS_ONBOUNCEDBYTIRE)\r
	@ScriptName=Tire\r
	@Tip = %(T_48_META_EVT_3069_P0_D)\r
    BounceTire : BounceTire #%(T_46_META_WS_TIRE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnTeleportEntity\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3034_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = TeleportDoor\r
event OnBeTeleport = 3034 { #%(T_46_META_WS_ONTELEPORTENTITY)\r
	@ScriptName=Target\r
	@Tip = %(T_48_META_EVT_3034_P0_D)\r
    TargetEntity : Entity #%(T_46_META_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBounceEntity\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3035_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = BounceTire\r
event OnBeSpring = 3035 { #%(T_46_META_WS_ONBOUNCEENTITY)\r
	@ScriptName=Target\r
	@Tip = %(T_48_META_EVT_3035_P0_D)\r
    TargetEntity : Entity #%(T_46_META_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnHitFlyEntity\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3036_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = MoveObject\r
event OnHitFlying = 3036 { #%(T_46_META_WS_ONHITFLYENTITY)\r
	@ScriptName=Target\r
	@Tip = %(T_48_META_EVT_3036_P0_D)\r
    TargetEntity : Entity #%(T_46_META_WS_TARGET)\r
	@ScriptName=Mechanism\r
	@Tip = %(T_48_META_EVT_3036_P1_D)\r
    MoveObject : MoveObject #%(T_46_META_WS_MECHANISM)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnBeHitFly_Deprecated\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3040_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Player\r
event OnBeHitFly = 3040 { #%(T_36_WZY_WS_PLACOLLIDE_NAME)\r
	@Tip = %(T_48_META_EVT_3040_P0_D)\r
    TargetEntity : Entity #%(T_34_WT_WS_ENTITY2_PARAM1)\r
	@Tip = %(T_48_META_EVT_3040_P1_D)\r
    MoveObject : MoveObject #%(T_36_WZY_WS_OBJENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnHitFly\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3070_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Player\r
event OnBeHitFly_V2 = 3070 { #%(T_46_META_WS_ONHITFLY)\r
	@ScriptName=Mechanism\r
	@Tip = %(T_48_META_EVT_3070_P0_D)\r
    MoveObject : MoveObject #%(T_46_META_WS_MECHANISM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnRevived\r
@ApiTarget=0\r
@Tip = %(T_48_META_EVT_3015_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnRevived = 3015 { #%(T_46_META_WS_ONREVIVED)\r
	@ScriptName=RevivalSource\r
	@Tip = %(T_48_META_EVT_3015_P0_D)\r
    PlayerReviveSourceType : PlayerReviveSourceType #%(T_46_META_WS_REVIVALSOURCE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnSpawn\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3016_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = SpawnableEntity\r
event OnSpawn = 3016 { #%(T_46_META_WS_ONSPAWN)\r
	@ScriptName=Spawnables\r
	@Tip = %(T_48_META_EVT_3016_P0_D)\r
    Entities : ListT_InstanceEntity #%(T_46_META_WS_SPAWNABLES)\r
	@ScriptName=Waves\r
	@Tip = %(T_48_META_EVT_3016_P1_D)\r
    BatchCount : Int #%(T_46_META_WS_WAVES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnAccessWeapon\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3039_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Player\r
event OnObtainWeapon = 3039 { #%(T_46_META_WS_ONACCESSWEAPON)\r
	@ScriptName=Weapon\r
	@Tip = %(T_48_META_EVT_3039_P0_D)\r
    WeaponEntity : Weapon #%(T_46_META_WS_WEAPON)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnSceneLoad\r
@Tip = %(T_48_META_EVT_30_D)\r
@ModuleID=10012\r
@ModuleLib=Scene\r
@Owner = Global\r
event OnSceneLoaded = 30 { #%(T_46_META_WS_ONSCENELOAD)\r
	@ScriptName=SceneName\r
	@Tip = %(T_48_META_EVT_30_P0_D)\r
    SceneName : String #%(T_46_META_WS_SCENENAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerSwitchScene\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_32_D)\r
@ModuleID=10012\r
@ModuleLib=Scene\r
@Owner = Player\r
event OnSwitchPlayerArea = 32 { #%(T_46_META_WS_ONPLAYERSWITCHSCENE)\r
	@ScriptName=SceneName\r
	@Tip = %(T_48_META_EVT_32_P0_D)\r
    SceneName : String #%(T_46_META_WS_SCENENAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnSceneSwitch\r
@Tip = %(T_48_META_EVT_31_D)\r
@ModuleID=10012\r
@ModuleLib=Scene\r
@Owner = Global\r
event OnSceneSwitchSuccessed = 31 { #%(T_46_META_WS_ONSCENESWITCH)\r
	@ScriptName=SceneName\r
	@Tip = %(T_48_META_EVT_31_P0_D)\r
    SceneName : String #%(T_46_META_WS_SCENENAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnLevelObjectBeMorphed\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3045_D)\r
@ModuleID=22\r
@ModuleLib=Morph\r
@Owner = LevelObject\r
event OnLevelObjectToBeMorphed = 3045 { #%(T_46_META_WS_ONLEVELOBJECTBEMORPHED)\r
	@ScriptName=MorphObject\r
	@Tip = %(T_48_META_EVT_3045_P0_D)\r
    MorphObject : MorphObject #%(T_46_META_WS_MORPHOBJECT)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnClipEnd\r
@Tip = %(T_48_META_EVT_3200_D)\r
@ModuleID=35\r
@ModuleLib=Animation\r
@Owner = AnimationController\r
event OnAnimationClipEnd = 3200 { #%(T_46_META_WS_ONCLIPEND)\r
	@ScriptName=ClipName\r
	@Tip = %(T_48_META_EVT_3200_P0_D)\r
    ClipName : String #%(T_46_META_WS_CLIPNAME)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnStateEnd\r
@Tip = %(T_48_META_EVT_3201_D)\r
@ModuleID=35\r
@ModuleLib=Animation\r
@Owner = AnimationController\r
event OnAnimationStateEnd = 3201 { #%(T_46_META_WS_ONSTATEEND)\r
	@ScriptName=StateName\r
	@Tip = %(T_48_META_EVT_3201_P0_D)\r
    StateName : String #%(T_46_META_WS_STATENAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerRevivedInSpawnPos\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3046_D)\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = SpawnPos\r
event OnPlayerReviveInSpawnPos = 3046 { #%(T_46_META_WS_ONPLAYERREVIVEDINSPAWNPOS)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3046_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnDropWeapon\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3047_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Player\r
event OnDropWeapon = 3047 { #%(T_46_META_WS_ONDROPWEAPON)\r
	@ScriptName=Weapon\r
	@Tip = %(T_48_META_EVT_3047_P0_D)\r
    WeaponEntity : Weapon #%(T_46_META_WS_WEAPON)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnDropConsumable\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3048_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Player\r
event OnDropItem = 3048 { #%(T_46_META_WS_ONDROPCONSUMABLE)\r
	@ScriptName=ConsumableID\r
	@Tip = %(T_48_META_EVT_3048_P0_D)\r
    ItemType : ItemGoodsIDType #%(T_46_META_WS_CONSUMABLEID)\r
	@ScriptName=Item\r
	@Tip = %(T_48_META_EVT_3048_P1_D)\r
    ItemEntity : Entity #%(T_46_META_WS_ITEM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnShotByFootballShooter\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3049_D)\r
@ModuleID=10006\r
@ModuleLib=Football\r
@Owner = Football\r
event OnShootByGun = 3049 { #%(T_46_META_WS_ONSHOTBYFOOTBALLSHOOTER)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3049_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=Velocity\r
	@Tip = %(T_48_META_EVT_3049_P1_D)\r
    Velocity : Vector3 #%(T_46_META_WS_VELOCITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnFootBallCollided\r
@Tip = %(T_48_META_EVT_3050_D)\r
@ModuleID=10006\r
@ModuleLib=Football\r
@Owner = Football\r
event OnHitEntity = 3050 { #%(T_46_META_WS_ONFOOTBALLCOLLIDED)\r
	@ScriptName=Target\r
	@Tip = %(T_48_META_EVT_3050_P0_D)\r
    TargetEntity : LevelObject #%(T_46_META_WS_TARGET)\r
	@ScriptName=Velocity\r
	@Tip = %(T_48_META_EVT_3050_P1_D)\r
    Velocity : Vector3 #%(T_46_META_WS_VELOCITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnAiming\r
@Tip = %(T_48_META_EVT_3041_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Player\r
event OnPlayerAimEntity = 3041 { #%(T_46_META_WS_ONAIMING)\r
	@ScriptName=Target\r
	@Tip = %(T_48_META_EVT_3041_P0_D)\r
    TargetEntity : AimableEntity #%(T_46_META_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnAimed\r
@Tip = %(T_48_META_EVT_3042_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = AimableEntity\r
event OnEntityAimedByPlayer = 3042 { #%(T_46_META_WS_ONAIMED)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3042_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBulletHit\r
@Tip = %(T_48_META_EVT_3043_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Weapon\r
event OnWeaponHitEntity = 3043 { #%(T_46_META_WS_ONBULLETHIT)\r
	@ScriptName=Target\r
	@Tip = %(T_48_META_EVT_3043_P0_D)\r
    TargetEntity : AimableEntity #%(T_46_META_WS_TARGET)\r
	@ScriptName=HitPosition\r
	@Tip = %(T_48_META_EVT_3043_P1_D)\r
    HitPosition : Vector3 #%(T_46_META_WS_HITPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnWeaponBeEquiped\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3061_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Weapon\r
event OnWeaponBeEquiped = 3061 { #%(T_46_META_WS_ONWEAPONBEEQUIPED)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3061_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnWeaponEliminate\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3062_D)\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = Weapon\r
event OnWeaponKillEntity = 3062 { #%(T_46_META_WS_ONWEAPONELIMINATE)\r
	@ScriptName=Target\r
	@Tip = %(T_48_META_EVT_3062_P0_D)\r
    FightingEntity : FightingEntity #%(T_46_META_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnWeaponDealDamage\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3063_D)\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = Weapon\r
event OnWeaponTakeDamage = 3063 { #%(T_46_META_WS_ONWEAPONDEALDAMAGE)\r
	@ScriptName=Target\r
	@Tip = %(T_48_META_EVT_3063_P0_D)\r
    FightingEntity : FightingEntity #%(T_46_META_WS_TARGET)\r
	@ScriptName=Damage\r
	@Tip = %(T_48_META_EVT_3063_P1_D)\r
    Damage : Int #%(T_46_META_WS_DAMAGE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnReload\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3064_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Weapon\r
event OnWeaponReload = 3064 { #%(T_46_META_WS_ONRELOAD)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnHitByBullet\r
@Tip = %(T_48_META_EVT_3044_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = AimableEntity\r
event OnEntityHittedByWeapon = 3044 { #%(T_46_META_WS_ONHITBYBULLET)\r
	@ScriptName=Weapon\r
	@Tip = %(T_48_META_EVT_3044_P0_D)\r
    Weapon : Weapon #%(T_46_META_WS_WEAPON)\r
	@ScriptName=HitPosition\r
	@Tip = %(T_48_META_EVT_3044_P1_D)\r
    HitPosition : Vector3 #%(T_46_META_WS_HITPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnUpdate\r
@Tip = %(T_48_META_EVT_2_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Entity\r
event OnUpdate = 2 { #%(T_46_META_WS_ONUPDATE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnJoinChatChannelSuccessfully\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3051_D)\r
@ModuleID=24\r
@ModuleLib=ChatChannel\r
@Owner = Player\r
event OnJoinChatChannelSuccess = 3051 { #%(T_46_META_WS_ONJOINCHATCHANNELSUCCESSFULLY)\r
	@ScriptName=ChatChannel\r
	@Tip = %(T_48_META_EVT_3051_P0_D)\r
    ChatChannel : ChatChannel #%(T_46_META_WS_CHATCHANNEL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerJoinChatChannelFailure\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3052_D)\r
@ModuleID=24\r
@ModuleLib=ChatChannel\r
@Owner = Player\r
event OnJoinChatChannelFailure = 3052 { #%(T_46_META_WS_ONPLAYERJOINCHATCHANNELFAILURE)\r
	@ScriptName=ChatChannel\r
	@Tip = %(T_48_META_EVT_3052_P0_D)\r
    ChatChannel : ChatChannel #%(T_46_META_WS_CHATCHANNEL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnLeaveChatChannel\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3053_D)\r
@ModuleID=24\r
@ModuleLib=ChatChannel\r
@Owner = Player\r
event OnLeaveChatChannel = 3053 { #%(T_46_META_WS_ONLEAVECHATCHANNEL)\r
	@ScriptName=ChatChannel\r
	@Tip = %(T_48_META_EVT_3053_P0_D)\r
    ChatChannel : ChatChannel #%(T_46_META_WS_CHATCHANNEL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnGoal\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3054_D)\r
@ModuleID=10006\r
@ModuleLib=Football\r
@Owner = Football\r
event OnGoal = 3054 { #%(T_46_META_WS_ONGOAL)\r
	@ScriptName=FootballGoal\r
	@Tip = %(T_48_META_EVT_3054_P0_D)\r
    FootballGoal : FootballGoal #%(T_46_META_WS_FOOTBALLGOAL)\r
	@ScriptName=Scorer\r
	@Tip = %(T_48_META_EVT_3054_P1_D)\r
    LastPlayer : Player #%(T_46_META_WS_SCORER)\r
	@ScriptName=AssistPlayer\r
	@Tip = %(T_48_META_EVT_3054_P2_D)\r
    PrevPlayer : Player #%(T_46_META_WS_ASSISTPLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnDisconnect\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_2009_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerDisconnect = 2009 { #%(T_46_META_WS_ONDISCONNECT)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_2009_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnReconnect\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_2010_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerReconnect = 2010 { #%(T_46_META_WS_ONRECONNECT)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_2010_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnStartFire\r
@Tip = %(T_48_META_EVT_3055_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerFire = 3055 { #%(T_46_META_WS_ONSTARTFIRE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnJump\r
@Tip = %(T_48_META_EVT_3056_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerJump = 3056 { #%(T_46_META_WS_ONJUMP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnJumpStop\r
@Tip = %(T_48_META_EVT_3122_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerJumpStop = 3122 { #%(T_46_META_WS_ONJUMPSTOP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnFall\r
@ApiTarget=1\r
@Tip = %(T_48_META_EVT_3123_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerFall = 3123 { #%(T_46_META_WS_ONFALL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnFallStop\r
@ApiTarget=1\r
@Tip = %(T_48_META_EVT_3124_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerFallStop = 3124 { #%(T_46_META_WS_ONFALLSTOP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnCrouch\r
@Tip = %(T_48_META_EVT_3057_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerCrouch = 3057 { #%(T_46_META_WS_ONCROUCH)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnCreep\r
@Tip = %(T_48_META_EVT_3058_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerCreep = 3058 { #%(T_46_META_WS_ONCREEP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnSprint\r
@Tip = %(T_48_META_EVT_3059_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerSprint = 3059 { #%(T_46_META_WS_ONSPRINT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPurchase\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3060_D)\r
@ModuleID=19\r
@ModuleLib=Economy\r
@Owner = Shop\r
event OnShopPurchase = 3060 { #%(T_46_META_WS_ONPURCHASE)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3060_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=ShopItem\r
	@Tip = %(T_48_META_EVT_3060_P1_D)\r
    ShopItem : ShopItem #%(T_46_META_WS_SHOPITEM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPrePurchase\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3090_D)\r
@ModuleID=19\r
@ModuleLib=Economy\r
@Owner = Shop\r
event OnBeforeShopPurchase = 3090 { #%(T_46_META_WS_ONPREPURCHASE)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3090_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=ShopItem\r
	@Tip = %(T_48_META_EVT_3090_P1_D)\r
    ShopItem : ShopItem #%(T_46_META_WS_SHOPITEM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerPurchaseRequest\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3115_D)\r
@ModuleID=19\r
@ModuleLib=Economy\r
@Owner = Shop\r
event OnShopRequestPurchase = 3115 { #%(T_46_META_WS_ONPLAYERPURCHASEREQUEST)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3115_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=ShopItem\r
	@Tip = %(T_48_META_EVT_3115_P1_D)\r
    ShopItem : ShopItem #%(T_46_META_WS_SHOPITEM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerRequestForPurchaseFulfilled\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3116_D)\r
@ModuleID=19\r
@ModuleLib=Economy\r
@Owner = Shop\r
event OnShopRequestFilled = 3116 { #%(T_46_META_WS_ONPLAYERREQUESTFORPURCHASEFULFILLED)\r
	@ScriptName=HelpPlayer\r
	@Tip = %(T_48_META_EVT_3116_P0_D)\r
    HelpPlayer : Player #%(T_46_META_WS_HELPPLAYER)\r
	@ScriptName=HelpedPlayer\r
	@Tip = %(T_48_META_EVT_3116_P1_D)\r
    HelpedPlayer : Player #%(T_46_META_WS_HELPEDPLAYER)\r
	@ScriptName=ShopItem\r
	@Tip = %(T_48_META_EVT_3116_P2_D)\r
    ShopItem : ShopItem #%(T_46_META_WS_SHOPITEM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPressed\r
@Tip = %(T_48_META_EVT_3071_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudButtonWidget\r
event OnPress = 3071 { #%(T_46_META_WS_ONPRESSED)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3071_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnReleased\r
@Tip = %(T_48_META_EVT_3072_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudButtonWidget\r
event OnRelease = 3072 { #%(T_46_META_WS_ONRELEASED)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3072_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnDoubleTapped\r
@Tip = %(T_48_META_EVT_3073_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudButtonWidget\r
event OnDoubleClick = 3073 { #%(T_46_META_WS_ONDOUBLETAPPED)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3073_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnTextChange\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3077_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudInputWidget\r
event OnSyncInputText = 3077 { #%(T_46_META_WS_ONTEXTCHANGE)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3077_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=Text\r
	@Tip = %(T_48_META_EVT_3077_P1_D)\r
    Text : String #%(T_46_META_WS_TEXT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnToggle\r
@ApiTarget=0\r
@Tip = %(T_48_META_EVT_3204_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudToggle\r
event OnToggleChange = 3204 { #%(T_46_META_WS_ONTOGGLE)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3204_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=Status\r
	@Tip = %(T_48_META_EVT_3204_P1_D)\r
    State : Bool #%(T_46_META_WS_STATUS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnTouchDown\r
@ApiTarget=1\r
@Tip = %(T_48_META_EVT_3260_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudTouchPad\r
event OnTouchDown = 3260 { #%(T_46_META_WS_ONTOUCHDOWN)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3260_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=Position\r
	@Tip = %(T_48_META_EVT_3260_P1_D)\r
    TouchDownPosition : Vector2 #%(T_46_META_WS_POSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnTouchUp\r
@ApiTarget=1\r
@Tip = %(T_48_META_EVT_3261_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudTouchPad\r
event OnTouchUp = 3261 { #%(T_46_META_WS_ONTOUCHUP)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3261_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=Position\r
	@Tip = %(T_48_META_EVT_3261_P1_D)\r
    TouchUpPosition : Vector2 #%(T_46_META_WS_POSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnDragStart\r
@ApiTarget=1\r
@Tip = %(T_48_META_EVT_3262_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudTouchPad\r
event OnDragStart = 3262 { #%(T_46_META_WS_ONDRAGSTART)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3262_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=StartPosition\r
	@Tip = %(T_48_META_EVT_3262_P1_D)\r
    DragStartPosition : Vector2 #%(T_46_META_WS_STARTPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnDrag\r
@ApiTarget=1\r
@Tip = %(T_48_META_EVT_3263_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudTouchPad\r
event OnDrag = 3263 { #%(T_46_META_WS_ONDRAG)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3263_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=StartPosition\r
	@Tip = %(T_48_META_EVT_3263_P1_D)\r
    DragStartPosition : Vector2 #%(T_46_META_WS_STARTPOSITION)\r
	@ScriptName=Delta\r
	@Tip = %(T_48_META_EVT_3263_P2_D)\r
    Delta : Vector2 #%(T_46_META_WS_DELTA)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnDragEnd\r
@ApiTarget=1\r
@Tip = %(T_48_META_EVT_3264_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudTouchPad\r
event OnDragEnd = 3264 { #%(T_46_META_WS_ONDRAGEND)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3264_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=EndPosition\r
	@Tip = %(T_48_META_EVT_3264_P1_D)\r
    DragEndPosition : Vector2 #%(T_46_META_WS_ENDPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnJoyStickPressed\r
@ApiTarget=1\r
@Tip = %(T_48_META_EVT_3265_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudJoystick\r
event OnPressed = 3265 { #%(T_46_META_WS_ONJOYSTICKPRESSED)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3265_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnJoyStickReleased\r
@ApiTarget=1\r
@Tip = %(T_48_META_EVT_3266_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudJoystick\r
event OnReleased = 3266 { #%(T_46_META_WS_ONJOYSTICKRELEASED)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3266_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnJoyStickMove\r
@ApiTarget=1\r
@Tip = %(T_48_META_EVT_3267_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudJoystick\r
event OnMove = 3267 { #%(T_46_META_WS_ONJOYSTICKMOVE)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3267_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=Delta\r
	@Tip = %(T_48_META_EVT_3267_P1_D)\r
    Output : Vector2 #%(T_46_META_WS_DELTA)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnJailBreakAreaBegin\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3074_D)\r
@ModuleID=10009\r
@ModuleLib=Other\r
@Owner = JailBreakArea\r
event OnJailBreakAreaBegin = 3074 { #%(T_46_META_WS_ONJAILBREAKAREABEGIN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnJailBreakAreaEnd\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3075_D)\r
@ModuleID=10009\r
@ModuleLib=Other\r
@Owner = JailBreakArea\r
event OnJailBreakAreaEnd = 3075 { #%(T_46_META_WS_ONJAILBREAKAREAEND)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnJailBreakPlayerJoin\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3082_D)\r
@ModuleID=10009\r
@ModuleLib=Other\r
@Owner = JailBreakArea\r
event OnJailBreakPlayerJoin = 3082 { #%(T_46_META_WS_ONJAILBREAKPLAYERJOIN)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3082_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnJailBreakPlayerQuit\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3083_D)\r
@ModuleID=10009\r
@ModuleLib=Other\r
@Owner = JailBreakArea\r
event OnJailBreakPlayerQuit = 3083 { #%(T_46_META_WS_ONJAILBREAKPLAYERQUIT)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3083_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnStart\r
@Tip = %(T_48_META_EVT_3078_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
@Owner = Playable\r
event OnPlayableBegin = 3078 { #%(T_46_META_WS_ONSTART)\r
	@ScriptName=Playable\r
	@Tip = %(T_48_META_EVT_3078_P0_D)\r
    Playable : Playable #%(T_46_META_WS_C_PLAYABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEnd\r
@Tip = %(T_48_META_EVT_3079_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
@Owner = Playable\r
event OnPlayableEnd = 3079 { #%(T_46_META_WS_ONEND)\r
	@ScriptName=Playable\r
	@Tip = %(T_48_META_EVT_3079_P0_D)\r
    Playable : Playable #%(T_46_META_WS_C_PLAYABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnResume\r
@Tip = %(T_48_META_EVT_3080_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
@Owner = Playable\r
event OnPlayableResume = 3080 { #%(T_46_META_WS_ONRESUME)\r
	@ScriptName=Playable\r
	@Tip = %(T_48_META_EVT_3080_P0_D)\r
    Playable : Playable #%(T_46_META_WS_C_PLAYABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPause\r
@Tip = %(T_48_META_EVT_3081_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
@Owner = Playable\r
event OnPlayablePause = 3081 { #%(T_46_META_WS_ONPAUSE)\r
	@ScriptName=Playable\r
	@Tip = %(T_48_META_EVT_3081_P0_D)\r
    Playable : Playable #%(T_46_META_WS_C_PLAYABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEachLoop\r
@Tip = %(T_48_META_EVT_14_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
@Owner = Playable\r
event OnPlayableEachLoop = 14 { #%(T_46_META_WS_ONEACHLOOP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEachLoop\r
@Tip = %(T_48_META_EVT_14_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
@Owner = Loopable\r
event OnPlayableEachLoop = 14 { #%(T_46_META_WS_ONEACHLOOP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnCountdownFinished\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3084_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = ProgressCircleHud\r
event OnCountdownFinished = 3084 { #%(T_46_META_WS_ONCOUNTDOWNFINISHED)\r
	@ScriptName=Owner\r
	@Tip = %(T_48_META_EVT_3084_P0_D)\r
    TargetEntity : Entity #%(T_46_META_WS_OWNER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPickedUp\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3085_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = InventoryBase\r
event OnPickup = 3085 { #%(T_46_META_WS_ONPICKEDUP)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3085_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnDropped\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3086_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = InventoryBase\r
event OnDrop = 3086 { #%(T_46_META_WS_ONDROPPED)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3086_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEquiped\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3087_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Helmet\r
event OnEquip = 3087 { #%(T_46_META_WS_ONEQUIPED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEquiped\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3087_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Bag\r
event OnEquip = 3087 { #%(T_46_META_WS_ONEQUIPED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEquiped\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3087_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Vest\r
event OnEquip = 3087 { #%(T_46_META_WS_ONEQUIPED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEquiped\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3087_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = JetPack\r
event OnEquip = 3087 { #%(T_46_META_WS_ONEQUIPED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEquiped\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3087_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = DoubleJumpShoes\r
event OnEquip = 3087 { #%(T_46_META_WS_ONEQUIPED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEquiped\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3087_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = FoldWing\r
event OnEquip = 3087 { #%(T_46_META_WS_ONEQUIPED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEquiped\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3087_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Skateboard\r
event OnEquip = 3087 { #%(T_46_META_WS_ONEQUIPED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnLandmineActive\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3088_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = LandmineObj\r
event OnLandmineObjStart = 3088 { #%(T_46_META_WS_ONLANDMINEACTIVE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnLandmineTrigger\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3089_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = LandmineObj\r
event OnLandmineObjTrigger = 3089 { #%(T_46_META_WS_ONLANDMINETRIGGER)\r
	@ScriptName=Target\r
	@Tip = %(T_48_META_EVT_3089_P0_D)\r
    TargetEntity : Entity #%(T_46_META_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnUsed\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3091_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = MiniSentry\r
event OnUse = 3091 { #%(T_46_META_WS_ONUSED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnUsed\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3091_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Mushroom\r
event OnUse = 3091 { #%(T_46_META_WS_ONUSED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnUsed\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3091_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = RepairArmorKit\r
event OnUse = 3091 { #%(T_46_META_WS_ONUSED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnUsed\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3091_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = JetPack\r
event OnUse = 3091 { #%(T_46_META_WS_ONUSED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnUsed\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3091_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = DoubleJumpShoes\r
event OnUse = 3091 { #%(T_46_META_WS_ONUSED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnUsed\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3091_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = FoldWing\r
event OnUse = 3091 { #%(T_46_META_WS_ONUSED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnUsed\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3091_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Skateboard\r
event OnUse = 3091 { #%(T_46_META_WS_ONUSED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnHookGunFire\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3092_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = GrapplingHookGun\r
event OnFires = 3092 { #%(T_46_META_WS_ONHOOKGUNFIRE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnThrowableExplode\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3093_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Player\r
event OnThrowHit = 3093 { #%(T_46_META_WS_ONTHROWABLEEXPLODE)\r
	@ScriptName=HitPosition\r
	@Tip = %(T_48_META_EVT_3093_P0_D)\r
    HitPos : Vector3 #%(T_46_META_WS_HITPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnSprayed\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3094_D)\r
@ModuleID=32\r
@ModuleLib=Dyeing\r
@Owner = LevelObject\r
event OnSprayedByWeapon = 3094 { #%(T_46_META_WS_ONSPRAYED)\r
	@ScriptName=Weapon\r
	@Tip = %(T_48_META_EVT_3094_P0_D)\r
    Weapon : Weapon #%(T_46_META_WS_WEAPON)\r
	@ScriptName=HitPosition\r
	@Tip = %(T_48_META_EVT_3094_P1_D)\r
    HitPos : Vector3 #%(T_46_META_WS_HITPOSITION)\r
	@ScriptName=HitNormal\r
	@Tip = %(T_48_META_EVT_3094_P2_D)\r
    Normal : Vector3 #%(T_46_META_WS_HITNORMAL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnSpray\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3095_D)\r
@ModuleID=32\r
@ModuleLib=Dyeing\r
@Owner = LevelObject\r
event OnSprayEntity = 3095 { #%(T_46_META_WS_ONSPRAY)\r
	@ScriptName=HitObject\r
	@Tip = %(T_48_META_EVT_3095_P0_D)\r
    HitObject : LevelObject #%(T_46_META_WS_HITOBJECT)\r
	@ScriptName=HitPosition\r
	@Tip = %(T_48_META_EVT_3095_P1_D)\r
    HitPos : Vector3 #%(T_46_META_WS_HITPOSITION)\r
	@ScriptName=HitNormal\r
	@Tip = %(T_48_META_EVT_3095_P2_D)\r
    Normal : Vector3 #%(T_46_META_WS_HITNORMAL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnExplode\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3096_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Oildrum\r
event OnOildrumExplode = 3096 { #%(T_46_META_WS_ONEXPLODE)\r
	@ScriptName=Maker\r
	@Tip = %(T_48_META_EVT_3096_P0_D)\r
    Player : Player #%(T_46_META_WS_MAKER)\r
	@ScriptName=DamagedPlayers\r
	@Tip = %(T_48_META_EVT_3096_P1_D)\r
    BeDamagedPlayers : ListT_Player #%(T_46_META_WS_DAMAGEDPLAYERS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnExplode\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3096_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Vehicle\r
event OnOildrumExplode = 3096 { #%(T_46_META_WS_ONEXPLODE)\r
	@ScriptName=Maker\r
	@Tip = %(T_48_META_EVT_3096_P0_D)\r
    Player : Player #%(T_46_META_WS_MAKER)\r
	@ScriptName=DamagedPlayers\r
	@Tip = %(T_48_META_EVT_3096_P1_D)\r
    BeDamagedPlayers : ListT_Player #%(T_46_META_WS_DAMAGEDPLAYERS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnWeaponStopFiring\r
@Tip = %(T_48_META_EVT_3097_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Weapon\r
event OnStopFire = 3097 { #%(T_46_META_WS_ONWEAPONSTOPFIRING)\r
	@ScriptName=CurrentAmmoCount\r
	@Tip = %(T_48_META_EVT_3097_P0_D)\r
    AmmoInClip : Int #%(T_46_META_WS_CURRENTAMMOCOUNT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnChase\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3098_D)\r
@ModuleID=10008\r
@ModuleLib=AI\r
@Owner = AI\r
event OnAIStartChase = 3098 { #%(T_46_META_WS_ONCHASE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnChaseStop\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3099_D)\r
@ModuleID=10008\r
@ModuleLib=AI\r
@Owner = AI\r
event OnAIStopChase = 3099 { #%(T_46_META_WS_ONCHASESTOP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnAttack\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3100_D)\r
@ModuleID=10008\r
@ModuleLib=AI\r
@Owner = AI\r
event OnAIStartAttack = 3100 { #%(T_46_META_WS_ONATTACK)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnAttackStop\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3101_D)\r
@ModuleID=10008\r
@ModuleLib=AI\r
@Owner = AI\r
event OnAIStopAttack = 3101 { #%(T_46_META_WS_ONATTACKSTOP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnCameraRaycast\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3102_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = Global\r
event OnClientCameraRayCast = 3102 { #%(T_46_META_WS_ONCAMERARAYCAST)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3102_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=IsHit\r
	@Tip = %(T_48_META_EVT_3102_P1_D)\r
    IsHit : Bool #%(T_46_META_WS_ISHIT)\r
	@ScriptName=HitPosition\r
	@Tip = %(T_48_META_EVT_3102_P2_D)\r
    HitPos : Vector3 #%(T_46_META_WS_HITPOSITION)\r
	@ScriptName=CameraDirection\r
	@Tip = %(T_48_META_EVT_3102_P3_D)\r
    CameraDir : Vector3 #%(T_46_META_WS_CAMERADIRECTION)\r
	@ScriptName=CameraPosition\r
	@Tip = %(T_48_META_EVT_3102_P4_D)\r
    CameraPos : Vector3 #%(T_46_META_WS_CAMERAPOSITION)\r
	@ScriptName=HitEntity\r
	@Tip = %(T_48_META_EVT_3102_P5_D)\r
    HitEntity : Entity #%(T_46_META_WS_HITENTITY)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnUIShow\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3103_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = UGCShopHud\r
event OnShow = 3103 { #%(T_46_META_WS_ONUISHOW)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3103_P0_D)\r
    TriggerPlayer : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnUIHide\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3104_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = UGCShopHud\r
event OnHide = 3104 { #%(T_46_META_WS_ONUIHIDE)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_3104_P0_D)\r
    TriggerPlayer : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnNodeEnter\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3105_D)\r
@ModuleID=36\r
@ModuleLib=BehaviourTree\r
@Owner = BehaviourTreeNode\r
event OnNodeEnter = 3105 { #%(T_46_META_WS_ONNODEENTER)\r
	@ScriptName=NodeName\r
	@Tip = %(T_48_META_EVT_3105_P0_D)\r
    NodeName : String #%(T_46_META_WS_NODENAME)\r
	@ScriptName=Owner\r
	@Tip = %(T_48_META_EVT_3105_P1_D)\r
    Owner : BehaviourTreeAttachable #%(T_46_META_WS_OWNER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnNodeExit\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3106_D)\r
@ModuleID=36\r
@ModuleLib=BehaviourTree\r
@Owner = BehaviourTreeNode\r
event OnNodeExit = 3106 { #%(T_46_META_WS_ONNODEEXIT)\r
	@ScriptName=NodeName\r
	@Tip = %(T_48_META_EVT_3106_P0_D)\r
    NodeName : String #%(T_46_META_WS_NODENAME)\r
	@ScriptName=Owner\r
	@Tip = %(T_48_META_EVT_3106_P1_D)\r
    Owner : BehaviourTreeAttachable #%(T_46_META_WS_OWNER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnWakeUp\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3107_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Owner = Rigidbody\r
event OnWakeup = 3107 { #%(T_46_META_WS_ONWAKEUP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnSleep\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3108_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Owner = Rigidbody\r
event OnSleep = 3108 { #%(T_46_META_WS_ONSLEEP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnMove\r
@Tip = %(T_48_META_EVT_3109_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerMove = 3109 { #%(T_46_META_WS_ONMOVE)\r
	@ScriptName=Pose\r
	@Tip = %(T_48_META_EVT_3109_P0_D)\r
    PhysxPose : PlayerPhysXPoseType #%(T_46_META_WS_POSE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnIdle\r
@ApiTarget=0\r
@Tip = %(T_48_META_EVT_3110_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerIdle = 3110 { #%(T_46_META_WS_ONIDLE)\r
	@ScriptName=Pose\r
	@Tip = %(T_48_META_EVT_3110_P0_D)\r
    PhysxPose : PlayerPhysXPoseType #%(T_46_META_WS_POSE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnUseAvatarSkill\r
@ApiTarget=0\r
@Tip = %(T_48_META_EVT_3111_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerUseSkill = 3111 { #%(T_46_META_WS_ONUSEAVATARSKILL)\r
	@ScriptName=Skill\r
	@Tip = %(T_48_META_EVT_3111_P0_D)\r
    skill : PlayerSkillID #%(T_46_META_WS_SKILL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnStandUP\r
@ApiTarget=0\r
@Tip = %(T_48_META_EVT_3268_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerStand = 3268 { #%(T_46_META_WS_ONSTANDUP)\r
	@ScriptName=PrePose\r
	@Tip = %(T_48_META_EVT_3268_P0_D)\r
    PrePhysxPose : PlayerPhysXPoseType #%(T_46_META_WS_PREPOSE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnFire\r
@ApiTarget=1\r
@Tip = %(T_48_META_EVT_3269_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Weapon\r
event OnFiringEachBullet = 3269 { #%(T_46_META_WS_ONFIRE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnSurfing\r
@ApiTarget=0\r
@Tip = %(T_48_META_EVT_3006_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerSwimSurfing = 3006 { #%(T_46_META_WS_ONSURFING)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnSurfingStop\r
@ApiTarget=0\r
@Tip = %(T_48_META_EVT_3076_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerStopSwimSurfing = 3076 { #%(T_46_META_WS_ONSURFINGSTOP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnSprintStop\r
@ApiTarget=0\r
@Tip = %(T_48_META_EVT_3112_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerStopDash = 3112 { #%(T_46_META_WS_ONSPRINTSTOP)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_EVT_3117_D)\r
@ModuleID=41\r
@ModuleLib=Time\r
@Owner = Entity\r
event OnFixedUpdate = 3117 { #%(T_46_META_WS_ONFIXEDUPDATE)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_EVT_3118_D)\r
@ModuleID=41\r
@ModuleLib=Time\r
@Owner = Global\r
event OnGamePause = 3118 { #%(T_46_META_WS_ONGAMEPAUSE)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_EVT_3119_D)\r
@ModuleID=41\r
@ModuleLib=Time\r
@Owner = Global\r
event OnGameResume = 3119 { #%(T_46_META_WS_ONGAMERESUME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnFriendsUpdate\r
@ApiTarget=1\r
@Tip = %(T_48_META_EVT_3120_D)\r
@ModuleID=10013\r
@ModuleLib=FF_Platform\r
@Owner = Player\r
event OnFriendRelationChange = 3120 { #%(T_46_META_WS_ONFRIENDSUPDATE)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@Tip = %(T_50_META_EVT_19_D)\r
@ModuleID=43\r
@ModuleLib=LLM\r
@Owner = Global\r
event OnReceivePersonaCreateRoomResult = 19 { #%(T_50_META_EVT_19)\r
	@Tip = %(T_48_META_EVT_3132_P1_D)\r
    ErrorCode : ErrorCode #%(T_47_XXJ_WS_ERRORCODE)\r
	@Tip = %(T_50_META_EVT_19_P1_D)\r
    RoomID : String #%(T_50_META_EVT_19_P1)\r
}\r
\r
@ApiLevel=10\r
@ApiTarget=1\r
@Tip = %(T_48_META_EVT_3121_D)\r
@ModuleID=43\r
@ModuleLib=LLM\r
@Owner = Global\r
event OnReceiveContentFromPersona = 3121 { #%(T_47_XXJ_WS_ONRECEIVECONTENTFROMPERSONA)\r
	@ScriptName=Content\r
	@Tip = %(T_48_META_EVT_3121_P0_D)\r
    Content : String #%(T_47_XXJ_WS_CONTENT)\r
	@ScriptName=Sender\r
	@Tip = %(T_48_META_EVT_3121_P1_D)\r
    Sender : PersonaID #%(T_47_XXJ_WS_SENDER)\r
	@ScriptName=RequestID\r
	@Tip = %(T_49_META_EVT_16_P1_D)\r
    ChatID : String #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@Tip = %(T_48_META_EVT_3121_D)\r
@ModuleID=43\r
@ModuleLib=LLM\r
@Owner = Global\r
event OnReceiveContentFromPersonaV2 = 16 { #%(T_47_XXJ_WS_ONRECEIVECONTENTFROMPERSONA)\r
	@Tip = %(T_47_XXJ_WS_SENDER)\r
    Sender : PersonaID #%(T_47_XXJ_WS_SENDER)\r
	@Tip = %(T_49_META_EVT_16_P1_D)\r
    RequestID : Int64 #%(T_49_META_API_1089_P2)\r
	@Tip = %(T_49_META_EVT_16_P2_D)\r
    ResponseID : String #%(T_49_META_EVT_16_P2)\r
	@Tip = %(T_48_META_EVT_3121_P0_D)\r
    Content : String #%(T_47_XXJ_WS_CONTENT)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnReceiveActionFromPersona_Deprecated\r
@ApiTarget=1\r
@Tip = %(T_48_META_EVT_3125_D)\r
@ModuleID=43\r
@ModuleLib=LLM\r
@Owner = Global\r
event OnReceiveActionFromPersona = 3125 { #%(T_47_XXJ_WS_ONRECEIVEACTIONFROMPERSONA)\r
	@ScriptName=Action\r
	@Tip = %(T_48_META_EVT_3125_P0_D)\r
    Action : String #%(T_47_XXJ_WS_ACTION)\r
	@ScriptName=Sender\r
	@Tip = %(T_48_META_EVT_3125_P1_D)\r
    Sender : PersonaID #%(T_47_XXJ_WS_SENDER)\r
	@ScriptName=RequestID\r
	@Tip = %(T_49_META_EVT_16_P1_D)\r
    ChatID : String #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@Tip = %(T_48_META_EVT_3125_D)\r
@ModuleID=43\r
@ModuleLib=LLM\r
@Owner = Global\r
event OnReceiveActionIDFromPersona = 3270 { #%(T_47_XXJ_WS_ONRECEIVEACTIONFROMPERSONA)\r
	@ScriptName=Action\r
	@Tip = %(T_48_META_EVT_3125_P0_D)\r
    Action : String #%(T_47_XXJ_WS_ACTION)\r
	@ScriptName=Sender\r
	@Tip = %(T_48_META_EVT_3125_P1_D)\r
    Sender : PersonaID #%(T_47_XXJ_WS_SENDER)\r
	@ScriptName=RequestID\r
	@Tip = %(T_49_META_EVT_16_P1_D)\r
    ChatID : Int64 #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@Tip = %(T_48_META_EVT_3132_D)\r
@ModuleID=43\r
@ModuleLib=LLM\r
@Owner = Global\r
event OnReceiveFinishFromPersona = 3132 { #%(T_47_XXJ_WS_ONRECEIVEFINISHFROMPERSONA)\r
	@ScriptName=Sender\r
	@Tip = %(T_48_META_EVT_3132_P0_D)\r
    Sender : PersonaID #%(T_47_XXJ_WS_SENDER)\r
	@ScriptName=ErrorCode\r
	@Tip = %(T_48_META_EVT_3132_P1_D)\r
    ErrorCode : ErrorCode #%(T_47_XXJ_WS_ERRORCODE)\r
	@ScriptName=RequestID\r
	@Tip = %(T_49_META_EVT_16_P1_D)\r
    ChatID : Int64 #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=10\r
@ApiTarget=1\r
@Tip = %(T_48_META_EVT_3130_D)\r
@ModuleID=43\r
@ModuleLib=LLM\r
@Owner = Global\r
event OnReceiveStatusFromPersona = 3130 { #%(T_47_XXJ_WS_ONRECEIVESTATUSFROMPERSONA)\r
	@ScriptName=Sender\r
	@Tip = %(T_48_META_EVT_3130_P0_D)\r
    Sender : PersonaID #%(T_47_XXJ_WS_SENDER)\r
	@ScriptName=ErrorCode\r
	@Tip = %(T_48_META_EVT_3130_P1_D)\r
    ErrorCode : ErrorCode #%(T_47_XXJ_WS_ERRORCODE)\r
	@ScriptName=RequestID\r
	@Tip = %(T_49_META_EVT_16_P1_D)\r
    ChatID : String #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerSendMessageByUIPersonaChat\r
@ApiTarget=1\r
@Tip = %(T_48_META_EVT_3131_D)\r
@ModuleID=43\r
@ModuleLib=LLM\r
@Owner = Global\r
event OnHudSendMessageToPersona = 3131 { #%(T_47_XXJ_WS_ONHUDSENDMESSAGETOPERSONA)\r
	@ScriptName=Content\r
	@Tip = %(T_48_META_EVT_3131_P0_D)\r
    Text : String #%(T_47_XXJ_WS_CONTENT)\r
	@ScriptName=Sender\r
	@Tip = %(T_48_META_EVT_3131_P1_D)\r
    Sender : PersonaID #%(T_47_XXJ_WS_SENDER)\r
	@ScriptName=RequestID\r
	@Tip = %(T_49_META_EVT_16_P1_D)\r
    ChatID : Int64 #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnReceiveVoiceResponseFromPersona\r
@ApiTarget=1\r
@Tip = %(T_51_META_EVT_23_D)\r
@ModuleID=43\r
@ModuleLib=LLM\r
@Owner = Global\r
event OnReceiveVoiceFromPersona = 23 { #%(T_51_META_EVT_23)\r
	@Tip = %(T_48_META_EVT_3121_P1_D)\r
    Sender : PersonaID #%(T_47_XXJ_WS_SENDER)\r
	@Tip = %(T_49_META_EVT_16_P1_D)\r
    RequestID : Int64 #%(T_49_META_API_1089_P2)\r
	@Tip = %(T_49_META_EVT_16_P2_D)\r
    ResponseID : String #%(T_49_META_EVT_16_P2)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@Tip = %(T_51_META_EVT_24_D)\r
@ModuleID=43\r
@ModuleLib=LLM\r
@Owner = Global\r
event OnPlayVoiceFinishFromPersona = 24 { #%(T_51_META_EVT_24)\r
	@ScriptName=\r
	@Tip = %(T_48_META_EVT_3121_P1_D)\r
    Sender : PersonaID #%(T_47_XXJ_WS_SENDER)\r
	@ScriptName=\r
	@Tip = %(T_50_META_API_10073_P1_D)\r
    ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
	@ScriptName=\r
	@Tip = %(T_49_META_EVT_16_P1_D)\r
    ChatID : Int64 #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=0\r
@Tip = %(T_48_META_EVT_3126_D)\r
@ModuleID=42\r
@ModuleLib=Premium\r
@Owner = Player\r
event OnPremiumChange = 3126 { #%(T_47_XXJ_WS_ONPREMIUMCHANGE)\r
	@Tip = %(T_48_META_EVT_3126_P0_D)\r
    State : PremiumState #%(T_46_XXJ_WS_PREMIUMSTATUS)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=0\r
@Tip = %(T_48_META_EVT_3127_D)\r
@ModuleID=42\r
@ModuleLib=Premium\r
@Owner = Player\r
event OnPlayerEnterPremiumCenter = 3127 { #%(T_46_XXJ_WS_ONPLAYERENTERPREMIUMCENTER)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=0\r
@Tip = %(T_48_META_EVT_3128_D)\r
@ModuleID=42\r
@ModuleLib=Premium\r
@Owner = Player\r
event OnPlayerLeavePremiumCenter = 3128 { #%(T_46_XXJ_WS_ONPLAYERLEAVEPREMIUMCENTER)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3140_D)\r
@ModuleID=14\r
@ModuleLib=Hostility\r
@Owner = Entity\r
event OnChangeTeam = 3140 { #%(T_48_META_EVT_3140)\r
	@ScriptName=FormerTeam\r
	@Tip = %(T_48_META_EVT_3140_P0_D)\r
    FormalTeam : Team #%(T_48_META_EVT_3140_P0)\r
	@ScriptName=CurrentTeam\r
	@Tip = %(T_48_META_EVT_3140_P1_D)\r
    CurrentTeam : Team #%(T_48_META_EVT_3140_P1)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3141_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Player\r
event OnPlotStart = 3141 { #%(T_48_META_EVT_3141)\r
	@ScriptName=PlotID\r
	@Tip = %(T_48_META_EVT_3141_P1_D)\r
    PlotID : String #%(T_48_META_EVT_3141_P1)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3142_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Player\r
event OnPlotEnd = 3142 { #%(T_48_META_EVT_3142)\r
	@ScriptName=PlotID\r
	@Tip = %(T_48_META_EVT_3142_P1_D)\r
    PlotID : String #%(T_48_META_EVT_3141_P1)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=2\r
@Tip = %(T_48_META_EVT_3143_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Player\r
event OntriggerPlotOption = 3143 { #%(T_48_META_EVT_3143)\r
	@ScriptName=PlotID\r
	@Tip = %(T_48_META_EVT_3143_P1_D)\r
    PlotID : String #%(T_48_META_EVT_3141_P1)\r
	@ScriptName=OptionID\r
	@Tip = %(T_48_META_EVT_3143_P2_D)\r
    OptionID : Int #%(T_48_META_EVT_3143_P2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnScreenTouchBegin\r
@ApiTarget=1\r
@Tip = %(T_50_META_EVT_17_D)\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@Owner = Global\r
event OnScreenTouchBegan = 17 { #%(T_50_META_EVT_17)\r
	@Tip = %(T_50_META_EVT_17_P0_D)\r
    TouchIndex : Int #%(T_50_META_EVT_17_P0)\r
	@Tip = %(T_50_META_EVT_17_P1_D)\r
    Position : Vector2 #%(T_46_META_WS_A_POSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnScreenTouchEnd\r
@ApiTarget=1\r
@Tip = %(T_50_META_EVT_18_D)\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@Owner = Global\r
event OnScreenTouchEnded = 18 { #%(T_50_META_EVT_18)\r
	@Tip = %(T_50_META_EVT_18_P0_D)\r
    TouchIndex : Int #%(T_50_META_EVT_18_P0)\r
	@Tip = %(T_50_META_EVT_18_P1_D)\r
    Position : Vector2 #%(T_46_META_WS_A_POSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnUserQuitOrUserMatchEnd\r
@Tip = %(T_50_META_EVT_20_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Global\r
event OnUserQuitOrUserMacthEnd = 20 { #%(T_50_META_EVT_20)\r
	@ScriptName=Player\r
	@Tip = %(T_48_META_EVT_11_P0_D)\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=0\r
@Tip = %(T_51_META_EVT_21_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Entity\r
event OnCustomPropertyChange = 21 { #%(T_51_META_EVT_21)\r
	@Tip = %(T_51_META_EVT_21_P0_D)\r
    PropertyIndex : Property #%(T_51_META_EVT_21_P0)\r
	@Tip = %(T_51_META_EVT_21_P1_D)\r
    PropertyValue : Object #%(T_51_META_API_157_P2)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@Tip = %(T_51_META_EVT_22_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Entity\r
event OnCustomPlayerStateChanged = 22 { #%(T_51_META_EVT_22)\r
	@Tip = %(T_51_META_EVT_22_P0_D)\r
    CustomPlayerState : Int #%(T_51_META_EVT_22_P0)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetAllPlayers\r
@Tip = %(T_48_META_API_1_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_1_R_D)\r
variable AllPlayers : ListT_Player = 1 { #%(T_46_META_WS_GETALLPLAYERS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetAllTeams\r
@Tip = %(T_48_META_API_2_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_2_R_D)\r
variable AllTeams : ListT_Team = 2 { #%(T_46_META_WS_GETALLTEAMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SwitchPhase\r
@Tip = %(T_48_META_API_3_D)\r
@ModuleID=1\r
@ModuleLib=Workflow\r
@ApiTarget=2\r
action SetFSMNextPhase = 3 { #%(T_46_META_WS_SWITCHPHASE)\r
	@Tip = %(T_48_META_API_3_P0_D)\r
    PhaseIndex : Int #%(T_46_META_WS_A_PHASEINDEX)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetAllPlayersMoveStatus\r
@Tip = %(T_48_META_API_4_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action SetMatchCanMove = 4 { #%(T_46_META_WS_SETALLPLAYERSMOVESTATUS)\r
	@Tip = %(T_48_META_API_4_P0_D)\r
    MoveEnable : Bool #%(T_46_META_WS_A_STATUS)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=RemoveLevelObject_Deprecated\r
@Tip = %(T_48_META_API_5_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@ApiTarget=2\r
action RemoveLevelObject = 5 { #%(T_34_WT_WS_ENTITY14_NAME)\r
	@Tip = %(T_48_META_API_5_P0_D)\r
    LevelObjectEntity : LevelObject #%(T_34_WT_WS_ENTITY13_PARAM4)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateLevelObject\r
@Tip = %(T_48_META_API_6_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
action CreateLevelObject = 6 { #%(T_46_META_WS_CREATELEVELOBJECT)\r
	@Tip = %(T_48_META_API_6_P0_D)\r
    out EntityVarName : LevelObject #%(T_46_META_WS_A_CREATEDENTITY)\r
	@Tip = %(T_48_META_API_6_P1_D)\r
    SpawnPostion : Vector3 #%(T_46_META_WS_A_POSTION)\r
	@Tip = %(T_48_META_API_6_P2_D)\r
    ItemID : Int #%(T_46_META_WS_A_LEVELOBJECT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EnableSafeZone\r
@Tip = %(T_48_META_API_8_D)\r
@ModuleID=9\r
@ModuleLib=SafeZone\r
@ApiTarget=2\r
action OpenSafeZone = 8 { #%(T_46_META_WS_ENABLESAFEZONE)\r
	@Tip = %(T_48_META_API_8_P0_D)\r
    CenterPos : Vector3 #%(T_46_META_WS_A_CENTER)\r
	@Tip = %(T_48_META_API_8_P1_D)\r
    Radius : Float #%(T_46_META_WS_A_RADIUS)\r
	@Tip = %(T_48_META_API_8_P2_D)\r
    WaitShrinkTime : Float #%(T_46_META_WS_A_WAITTIME)\r
	@Tip = %(T_48_META_API_8_P3_D)\r
    ShrinkDuration : Float #%(T_46_META_WS_A_DURATION)\r
	@Tip = %(T_48_META_API_8_P4_D)\r
    Damage : Float #%(T_46_META_WS_A_DAMAGE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EnableMovingSafeZone\r
@Tip = %(T_48_META_API_3109_D)\r
@ModuleID=9\r
@ModuleLib=SafeZone\r
@ApiTarget=2\r
action MoveSafeZone = 3109 { #%(T_46_META_WS_ENABLEMOVINGSAFEZONE)\r
	@Tip = %(T_48_META_API_3109_P0_D)\r
    StartPos : Vector3 #%(T_46_META_WS_A_STARTPOSITION)\r
	@Tip = %(T_48_META_API_3109_P1_D)\r
    TargetPos : Vector3 #%(T_46_META_WS_A_TARGETPOSITION)\r
	@Tip = %(T_48_META_API_3109_P2_D)\r
    InitRadius : Float #%(T_46_META_WS_A_INITRADIUS)\r
	@Tip = %(T_48_META_API_3109_P3_D)\r
    FinalRadius : Float #%(T_46_META_WS_A_FINALRADIUS)\r
	@Tip = %(T_48_META_API_3109_P4_D)\r
    ShrinkDuration : Float #%(T_46_META_WS_A_DURATION)\r
	@Tip = %(T_48_META_API_3109_P5_D)\r
    Damage : Float #%(T_46_META_WS_A_DAMAGE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddItem\r
@Tip = %(T_48_META_API_3200_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action AddItemToCharacter = 3200 { #%(T_46_META_WS_ADDITEM)\r
	@Tip = %(T_48_META_API_3200_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3200_P1_D)\r
    ItemID : ItemGoodsIDType #%(T_46_META_WS_A_ITEM)\r
	@Tip = %(T_48_META_API_3200_P2_D)\r
    ItemCount : Int #%(T_46_META_WS_A_COUNT)\r
	@Tip = %(T_48_META_API_3200_P3_D)\r
    out EntityList : ListT_Entity #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetSpecialItemStatus\r
@Tip = %(T_48_META_API_23_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action ToggleSpecialItemState = 23 { #%(T_46_META_WS_SETSPECIALITEMSTATUS)\r
	@Tip = %(T_48_META_API_23_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_23_P1_D)\r
    ItemID : SpecialItemGoodsIDType #%(T_46_META_WS_A_ITEM)\r
	@Tip = %(T_48_META_API_23_P2_D)\r
    State : Bool #%(T_46_META_WS_A_STATUS)\r
	@Tip = %(T_48_META_API_23_P3_D)\r
    out IceWallMaker : IceWallMaker #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetTokenCount\r
@Tip = %(T_48_META_API_3500_D)\r
@ModuleID=10013\r
@ModuleLib=FF_Platform\r
@ApiTarget=2\r
action GetPlayerTokenNum = 3500 { #%(T_46_META_WS_GETTOKENCOUNT)\r
	@Tip = %(T_48_META_API_3500_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3500_P1_D)\r
    TokenID : Int #%(T_46_META_WS_A_TOKENID)\r
	@Tip = %(T_48_META_API_3500_P2_D)\r
    out Count : Int #%(T_46_META_WS_A_COUNT)\r
	@Tip = %(T_48_META_API_3500_P3_D)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CompleteCustomMission\r
@Tip = %(T_48_META_API_47_D)\r
@ModuleID=10013\r
@ModuleLib=FF_Platform\r
@ApiTarget=2\r
action CustomMissionComplete = 47 { #%(T_46_META_WS_COMPLETECUSTOMMISSION)\r
	@Tip = %(T_48_META_API_47_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_47_P1_D)\r
    MissionID : Int #%(T_46_META_WS_A_MISSIONID)\r
	@Tip = %(T_48_META_API_47_P2_D)\r
    MissionProgress : Int #%(T_46_META_WS_A_MISSIONPROGRESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetTokenCountToday\r
@Tip = %(T_48_META_API_32_D)\r
@ModuleID=10013\r
@ModuleLib=FF_Platform\r
@ApiTarget=2\r
action GetPlayerTokenCountToday = 32 { #%(T_46_META_WS_GETTOKENCOUNTTODAY)\r
	@Tip = %(T_48_META_API_32_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_32_P1_D)\r
    TokenID : Int #%(T_46_META_WS_A_TOKENID)\r
	@Tip = %(T_48_META_API_32_P2_D)\r
    out Count : Int #%(T_46_META_WS_A_COUNT)\r
	@Tip = %(T_48_META_API_32_P3_D)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddToken\r
@Tip = %(T_48_META_API_3501_D)\r
@ModuleID=10013\r
@ModuleLib=FF_Platform\r
@ApiTarget=2\r
action AddTokenToPlayer = 3501 { #%(T_46_META_WS_ADDTOKEN)\r
	@Tip = %(T_48_META_API_3501_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3501_P1_D)\r
    TokenID : Int #%(T_46_META_WS_A_TOKENID)\r
	@Tip = %(T_48_META_API_3501_P2_D)\r
    Count : Int #%(T_46_META_WS_A_COUNT)\r
	@Tip = %(T_48_META_API_3501_P3_D)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CostToken\r
@Tip = %(T_48_META_API_3502_D)\r
@ModuleID=10013\r
@ModuleLib=FF_Platform\r
@ApiTarget=2\r
action PlayerRemoveToken = 3502 { #%(T_46_META_WS_COSTTOKEN)\r
	@Tip = %(T_48_META_API_3502_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3502_P1_D)\r
    TokenID : Int #%(T_46_META_WS_A_TOKENID)\r
	@Tip = %(T_48_META_API_3502_P2_D)\r
    Count : Int #%(T_46_META_WS_A_TOKENCOUNT)\r
	@Tip = %(T_48_META_API_3502_P3_D)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateTokenInScene\r
@Tip = %(T_48_META_API_3503_D)\r
@ModuleID=10013\r
@ModuleLib=FF_Platform\r
@ApiTarget=2\r
action AddTokenAtPosition = 3503 { #%(T_46_META_WS_CREATETOKENINSCENE)\r
	@Tip = %(T_48_META_API_3503_P0_D)\r
    Position : Vector3 #%(T_46_META_WS_A_POSITION)\r
	@Tip = %(T_48_META_API_3503_P1_D)\r
    TokenID : Int #%(T_46_META_WS_A_TOKENID)\r
	@Tip = %(T_48_META_API_3503_P2_D)\r
    Count : Int #%(T_46_META_WS_A_COUNT)\r
	@Tip = %(T_48_META_API_3503_P3_D)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DisableSafeZone\r
@Tip = %(T_48_META_API_9_D)\r
@ModuleID=9\r
@ModuleLib=SafeZone\r
@ApiTarget=2\r
action CloseSafeZone = 9 { #%(T_46_META_WS_DISABLESAFEZONE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=FilterLevelObjects\r
@Tip = %(T_48_META_API_10_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Return = %(T_48_META_API_10_R_D)\r
variable AllLevelObjs : ListT_LevelObject = 10 { #%(T_46_META_WS_FILTERLEVELOBJECTS)\r
	@Tip = %(T_48_META_API_10_P0_D)\r
    FilterLevelObjType : LevelObjType #%(T_46_META_WS_A_FILTERTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EndCurrentPhase\r
@Tip = %(T_48_META_API_11_D)\r
@ModuleID=1\r
@ModuleLib=Workflow\r
@ApiTarget=2\r
action EndCurrentPhase = 11 { #%(T_46_META_WS_ENDCURRENTPHASE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LogInfo\r
@Tip = %(T_48_META_API_12_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action PrintString = 12 { #%(T_46_META_WS_LOGINFO)\r
	@Tip = %(T_48_META_API_12_P0_D)\r
    Context : Object #%(T_46_META_WS_A_CONTENT)\r
}\r
\r
@ApiLevel=3\r
@Tip = %(T_48_META_API_3121_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=0\r
action Assert = 3121 { #%(T_46_META_WS_ASSERT)\r
	@Tip = %(T_48_META_API_3121_P0_D)\r
    Assert : Bool #%(T_46_META_WS_A_ASSERTIONEXPRESSION)\r
	@Tip = %(T_48_META_API_3121_P1_D)\r
    Tips : String #%(T_46_META_WS_A_TIPS)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=Format\r
@Tip = %(T_48_META_API_13_D)\r
@ModuleID=10004\r
@ModuleLib=Strings\r
@ApiTarget=0\r
@Return = %(T_48_META_API_13_R_D)\r
variable FormatString : String = 13 { #%(T_46_META_WS_FORMAT)\r
	@Tip = %(T_48_META_API_13_P0_D)\r
    FormatString : String #%(T_46_META_WS_A_CONTENT)\r
	@Tip = %(T_48_META_API_13_P1_D)\r
    ParamsArray : List #%(T_46_META_WS_A_PARAMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ClearResidualLevelObjects\r
@Tip = %(T_48_META_API_14_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action ClearAllLevelObjsResidual = 14 { #%(T_46_META_WS_CLEARRESIDUALLEVELOBJECTS)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1001_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action ProcessCtlIf = 1001 { #%(T_34_WZ_WS_LOGIC5_NAME)\r
	@Tip = %(T_48_META_API_1001_P0_D)\r
    Conditions : ListT_Condition #%(T_34_WZ_WS_LOGIC5_PARAM1_NAME)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1002_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action ProcessCtlForIndex = 1002 { #%(T_34_WZ_WS_LOGIC6_NAME)\r
	@Tip = %(T_48_META_API_1002_P0_D)\r
    ElementIndexName : String #%(T_34_LY_WS_INDEX)\r
	@Tip = %(T_48_META_API_1002_P1_D)\r
    LoopStart : Int #%(T_34_WZ_WS_LOGIC6_PARAM2_NAME)\r
	@Tip = %(T_48_META_API_1002_P2_D)\r
    LoopEnd : Int #%(T_34_WZ_WS_LOGIC6_PARAM3_NAME)\r
	@Tip = %(T_48_META_API_1002_P3_D)\r
    LoopStep : Int #%(T_34_WZ_WS_LOGIC6_PARAM4_NAME)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=ProcessCtlForRange_Deprecated\r
@Tip = %(T_48_META_API_1003_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action ProcessCtlForRange = 1003 { #%(T_34_WZ_WS_LOGIC7_NAME)\r
	@Tip = %(T_48_META_API_1003_P0_D)\r
    out ElementName : Object #%(T_34_WZ_WS_LOGIC7_PARAM1_NAME)\r
	@Tip = %(T_48_META_API_1003_P1_D)\r
    out ElementIndexName : Int #%(T_34_LY_WS_INDEX)\r
	@Tip = %(T_48_META_API_1003_P2_D)\r
    LoopRange : List #%(T_34_WZ_WS_LOGIC7_PARAM3_NAME)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1020_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action ProcessCtlForLoopRange = 1020 { #%(T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_NAMEKEY)\r
	@Tip = %(T_48_META_API_1020_P0_D)\r
    out KeyName : Object #%(T_40_XXJ_WS_KEY_NAMEKEY)\r
	@Tip = %(T_48_META_API_1020_P1_D)\r
    out ValueName : Object #%(T_40_XXJ_WS_VALUE_NAMEKEY)\r
	@Tip = %(T_48_META_API_1020_P2_D)\r
    LoopRange : ListOrMap #%(T_40_XXJ_WS_MAPVALUE_NAMEKEY)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1004_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action ProcessCtlBreak = 1004 { #%(T_34_WZ_WS_LOGIC9_NAME)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1005_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action ProcessCtlContinue = 1005 { #%(T_34_WZ_WS_LOGIC10_NAME)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1006_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action ProcessCtlReturn = 1006 { #%(T_34_WZ_WS_LOGIC11_NAME)\r
	@Tip = %(T_48_META_API_1006_P0_D)\r
    ReturnValue : Object #%(T_34_WZ_WS_LOGIC11_PARAM1_NAME)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1007_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action ProcessCtlWhile = 1007 { #%(T_34_WZ_WS_LOGIC8_NAME)\r
	@Tip = %(T_48_META_API_1007_P0_D)\r
    Condition : Condition #%(T_34_WZ_WS_LOGIC8_PARAM1_NAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WaitForNextFrame\r
@Async\r
@Tip = %(T_48_META_API_1008_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action WaitForNextFrame = 1008 { #%(T_46_META_WS_WAITFORNEXTFRAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WaitForMillisecond\r
@Async\r
@Tip = %(T_48_META_API_1009_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action WaitForSeconds = 1009 { #%(T_46_META_WS_WAITFORMILESECOND)\r
	@Tip = %(T_48_META_API_1009_P0_D)\r
    WaitSeconds : Int #%(T_46_META_WS_P_PHASEDURATION)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1010_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action EventCallback = 1010 { #%(T_48_META_API_1010)\r
	@Tip = %(T_48_META_API_1010_P0_D)\r
    EventParamNames : ListT_String #%(T_48_META_API_1010_P0)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1011_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action CodeBlock = 1011 { #%(T_48_META_API_1011)\r
	@Tip = %(T_48_META_API_1011_P0_D)\r
    ParamNames : ListT_String #%(T_48_META_API_1011_P0)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1012_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action FindAndInvokeCustomAPIWithSerial = 1012 { #%(T_48_META_API_1012)\r
	@Tip = %(T_48_META_API_1012_P0_D)\r
    TargetEntity : entity #%(T_40_XXJ_WS_TARGETENTITY_NAMEKEY)\r
	@Tip = %(T_48_META_API_1012_P1_D)\r
    GraphID : String #%(T_48_META_API_1012_P1)\r
	@Tip = %(T_48_META_API_1012_P2_D)\r
    FuncID : String #%(T_48_META_API_1012_P2)\r
	@Tip = %(T_48_META_API_1012_P3_D)\r
    ParamsArray : List #%(T_42_XXJ_WS_PARAMSARRAY)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1013_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action FindAndInvokeCustomAPIWithParallel = 1013 { #%(T_48_META_API_1013)\r
	@Tip = %(T_48_META_API_1013_P0_D)\r
    TargetEntity : entity #%(T_40_XXJ_WS_TARGETENTITY_NAMEKEY)\r
	@Tip = %(T_48_META_API_1013_P1_D)\r
    GraphID : String #%(T_48_META_API_1013_P1)\r
	@Tip = %(T_48_META_API_1013_P2_D)\r
    FuncID : String #%(T_48_META_API_1013_P2)\r
	@Tip = %(T_48_META_API_1013_P3_D)\r
    ParamsArray : List #%(T_42_XXJ_WS_PARAMSARRAY)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1014_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action FindAndInvokeSelfCustomAPIWithSerial = 1014 { #%(T_48_META_API_1014)\r
	@Tip = %(T_48_META_API_1014_P0_D)\r
    FuncID : String #%(T_48_META_API_1014_P0)\r
	@Tip = %(T_48_META_API_1014_P1_D)\r
    ParamsArray : List #%(T_42_XXJ_WS_PARAMSARRAY)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1015_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action FindAndInvokeSelfCustomAPIWithParallel = 1015 { #%(T_48_META_API_1015)\r
	@Tip = %(T_48_META_API_1015_P0_D)\r
    FuncID : String #%(T_48_META_API_1015_P0)\r
	@Tip = %(T_48_META_API_1015_P1_D)\r
    ParamsArray : List #%(T_42_XXJ_WS_PARAMSARRAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Length\r
@Tip = %(T_48_META_API_1050_D)\r
@ModuleID=10001\r
@ModuleLib=List\r
@Return = %(T_48_META_API_1050_R_D)\r
variable ListLength : Int = 1050 { #%(T_46_META_WS_LENGTH)\r
	@Tip = %(T_48_META_API_1050_P0_D)\r
    ListValue : List #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1051_D)\r
@ModuleID=10001\r
@ModuleLib=List\r
@Return = %(T_48_META_API_1051_R_D)\r
variable ListGetElement : Object = 1051 { #%(T_34_LY_WS_GET)\r
	@Tip = %(T_48_META_API_1051_P0_D)\r
    ListValue : List #%(T_34_M_WS_ARRAY)\r
	@Tip = %(T_48_META_API_1051_P1_D)\r
    Index : Int #%(T_34_LY_WS_INDEX)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1602_D)\r
@ModuleID=10002\r
@ModuleLib=Map\r
@Return = %(T_48_META_API_1602_R_D)\r
variable MapGetValue : Object = 1602 { #%(T_34_LY_WS_GET)\r
	@Tip = %(T_48_META_API_1602_P0_D)\r
    MapValue : Map #%(T_40_XXJ_WS_MAPVALUE_NAMEKEY)\r
	@Tip = %(T_48_META_API_1602_P1_D)\r
    Key : Object #%(T_40_XXJ_WS_KEY_NAMEKEY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ContainKey\r
@Tip = %(T_48_META_API_1607_D)\r
@ModuleID=10002\r
@ModuleLib=Map\r
@Return = %(T_48_META_API_1607_R_D)\r
variable MapContainKey : Bool = 1607 { #%(T_46_META_WS_CONTAINKEY)\r
	@Tip = %(T_48_META_API_1607_P0_D)\r
    MapValue : Map #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1607_P1_D)\r
    Key : Object #%(T_46_META_WS_A_KEY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetAllKeys\r
@Tip = %(T_48_META_API_1608_D)\r
@ModuleID=10002\r
@ModuleLib=Map\r
@Return = %(T_48_META_API_1608_R_D)\r
variable MapGetAllKeys : ListT_Object = 1608 { #%(T_46_META_WS_GETALLKEYS)\r
	@Tip = %(T_48_META_API_1608_P0_D)\r
    MapValue : Map #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1052_D)\r
@ModuleID=10001\r
@ModuleLib=List\r
action ListSetElement = 1052 { #%(T_34_LY_WS_SET)\r
	@Tip = %(T_48_META_API_1052_P0_D)\r
    ListValue : List #%(T_34_M_WS_ARRAY)\r
	@Tip = %(T_48_META_API_1052_P1_D)\r
    Index : Int #%(T_34_LY_WS_INDEX)\r
	@Tip = %(T_48_META_API_1052_P2_D)\r
    ElementValue : Object #%(T_34_WT_WS_ENTITY2_PARAM4)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetElement\r
@Tip = %(T_48_META_API_1603_D)\r
@ModuleID=10002\r
@ModuleLib=Map\r
action MapSetValue = 1603 { #%(T_34_LY_WS_SET)\r
	@Tip = %(T_48_META_API_1603_P0_D)\r
    MapValue : Map #%(T_40_XXJ_WS_MAPVALUE_NAMEKEY)\r
	@Tip = %(T_48_META_API_1603_P1_D)\r
    Key : Object #%(T_40_XXJ_WS_KEY_NAMEKEY)\r
	@Tip = %(T_48_META_API_1603_P2_D)\r
    Value : Object #%(T_40_XXJ_WS_VALUE_NAMEKEY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Append\r
@Tip = %(T_48_META_API_1053_D)\r
@ModuleID=10001\r
@ModuleLib=List\r
action ListAppend = 1053 { #%(T_46_META_WS_APPEND)\r
	@Tip = %(T_48_META_API_1053_P0_D)\r
    ListValue : List #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1053_P1_D)\r
    ElementValue : Object #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Remove\r
@Tip = %(T_48_META_API_1604_D)\r
@ModuleID=10002\r
@ModuleLib=Map\r
action MapRemoveValue = 1604 { #%(T_46_META_WS_DELETE)\r
	@Tip = %(T_48_META_API_1604_P0_D)\r
    MapValue : Map #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1604_P1_D)\r
    Key : Object #%(T_46_META_WS_A_KEY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Clear\r
@Tip = %(T_48_META_API_1605_D)\r
@ModuleID=10002\r
@ModuleLib=Map\r
action MapClear = 1605 { #%(T_46_META_WS_CLEAR)\r
	@Tip = %(T_48_META_API_1605_P0_D)\r
    MapValue : Map #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Length\r
@Tip = %(T_48_META_API_1606_D)\r
@ModuleID=10002\r
@ModuleLib=Map\r
@Return = %(T_48_META_API_1606_R_D)\r
variable MapGetLength : Int = 1606 { #%(T_46_META_WS_LENGTH)\r
	@Tip = %(T_48_META_API_1606_P0_D)\r
    MapValue : Map #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveAt\r
@Tip = %(T_48_META_API_1054_D)\r
@ModuleID=10001\r
@ModuleLib=List\r
action ListRemoveAt = 1054 { #%(T_46_META_WS_DELETEAT)\r
	@Tip = %(T_48_META_API_1054_P0_D)\r
    ListValue : List #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1054_P1_D)\r
    Index : Int #%(T_46_META_WS_A_INDEX)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1060_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_1060_R_D)\r
variable Compare : Bool = 1060 { #%(T_34_WZ_WS_LOGIC2_NAME)\r
	@Tip = %(T_48_META_API_1060_P0_D)\r
    LeftValue : Object #%(T_34_WZ_WS_LOGIC2_PARAM1_NAME)\r
	@Tip = %(T_48_META_API_1060_P1_D)\r
    CompareType : Int #%(T_34_WZ_WS_LOGIC2_PARAM2_NAME)\r
	@Tip = %(T_48_META_API_1060_P2_D)\r
    RightValue : Object #%(T_34_WZ_WS_LOGIC2_PARAM3_NAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IsInsideSphere\r
@Tip = %(T_48_META_API_1532_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Return = %(T_48_META_API_1532_R_D)\r
variable IsEntityInsideSphere : Bool = 1532 { #%(T_46_META_WS_ISINSIDESPHERE)\r
	@Tip = %(T_48_META_API_1532_P0_D)\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1532_P1_D)\r
    CenterPos : Vector3 #%(T_46_META_WS_A_CENTER)\r
	@Tip = %(T_48_META_API_1532_P2_D)\r
    Radius : Float #%(T_46_META_WS_A_RADIUS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IsInsideCylinder\r
@Tip = %(T_48_META_API_1533_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Return = %(T_48_META_API_1533_R_D)\r
variable IsEntityInsideCylinder : Bool = 1533 { #%(T_46_META_WS_ISINSIDECYLINDER)\r
	@Tip = %(T_48_META_API_1533_P0_D)\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1533_P1_D)\r
    CenterPos : Vector3 #%(T_46_META_WS_A_CENTER)\r
	@Tip = %(T_48_META_API_1533_P2_D)\r
    Radius : Float #%(T_46_META_WS_A_RADIUS)\r
	@Tip = %(T_48_META_API_1533_P3_D)\r
    Height : Float #%(T_46_META_WS_A_HEIGHT)\r
	@Tip = %(T_48_META_API_1533_P4_D)\r
    EulerAngles : Vector3 #%(T_46_META_WS_A_ROTATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IsInsideBox\r
@Tip = %(T_48_META_API_1534_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Return = %(T_48_META_API_1534_R_D)\r
variable IsEntityInsideBox : Bool = 1534 { #%(T_46_META_WS_ISINSIDEBOX)\r
	@Tip = %(T_48_META_API_1534_P0_D)\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1534_P1_D)\r
    CenterPos : Vector3 #%(T_46_META_WS_A_CENTER)\r
	@Tip = %(T_48_META_API_1534_P2_D)\r
    Length : Float #%(T_46_META_WS_A_LENGTH)\r
	@Tip = %(T_48_META_API_1534_P3_D)\r
    Width : Float #%(T_46_META_WS_A_WIDTH)\r
	@Tip = %(T_48_META_API_1534_P4_D)\r
    Height : Float #%(T_46_META_WS_A_HEIGHT)\r
	@Tip = %(T_48_META_API_1534_P5_D)\r
    EulerAngles : Vector3 #%(T_46_META_WS_A_ROTATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IsInsideSector\r
@Tip = %(T_48_META_API_1535_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Return = %(T_48_META_API_1535_R_D)\r
variable IsEntityInsideSector : Bool = 1535 { #%(T_46_META_WS_ISINSIDESECTOR)\r
	@Tip = %(T_48_META_API_1535_P0_D)\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1535_P1_D)\r
    CenterPos : Vector3 #%(T_46_META_WS_A_CENTER)\r
	@Tip = %(T_48_META_API_1535_P2_D)\r
    Radius : Float #%(T_46_META_WS_A_RADIUS)\r
	@Tip = %(T_48_META_API_1535_P3_D)\r
    CutRadius : Float #%(T_46_META_WS_A_CUTRADIUS)\r
	@Tip = %(T_48_META_API_1535_P4_D)\r
    Height : Float #%(T_46_META_WS_A_HEIGHT)\r
	@Tip = %(T_48_META_API_1535_P5_D)\r
    Angle : Float #%(T_46_META_WS_A_ANGLE)\r
	@Tip = %(T_48_META_API_1535_P6_D)\r
    EulerAngles : Vector3 #%(T_46_META_WS_A_ROTATION)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1061_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_1061_R_D)\r
variable Arithmetic : Number = 1061 { #%(T_36_WZY_WS_ARITHMETIC_NAME)\r
	@Tip = %(T_48_META_API_1061_P0_D)\r
    LeftValue : Number #%(T_42_XXJ_WS_LEFTVALUE)\r
	@Tip = %(T_48_META_API_1061_P1_D)\r
    ArithmeticType : Int #%(T_36_WZY_WS_OPERMETHOD_NAME)\r
	@Tip = %(T_48_META_API_1061_P2_D)\r
    RightValue : Number #%(T_42_XXJ_WS_RIGHTVALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RandomInt\r
@Tip = %(T_48_META_API_1062_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1062_R_D)\r
variable RandomInt : Int = 1062 { #%(T_46_META_WS_RANDOMINT)\r
	@Tip = %(T_48_META_API_1062_P0_D)\r
    MinValue : Int #%(T_46_META_WS_A_MIN)\r
	@Tip = %(T_48_META_API_1062_P1_D)\r
    MaxValue : Int #%(T_46_META_WS_A_MAX)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RandomFloat\r
@Tip = %(T_48_META_API_1063_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1063_R_D)\r
variable RandomFloat : Float = 1063 { #%(T_46_META_WS_RANDOMFLOAT)\r
	@Tip = %(T_48_META_API_1063_P0_D)\r
    MinValue : Float #%(T_46_META_WS_A_MIN)\r
	@Tip = %(T_48_META_API_1063_P1_D)\r
    MaxValue : Float #%(T_46_META_WS_A_MAX)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1065_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_1065_R_D)\r
variable Not : Bool = 1065 { #%(T_34_WZ_WS_LOGIC3_NAME)\r
	@Tip = %(T_48_META_API_1065_P0_D)\r
    Value : Bool #%(T_34_WT_WS_ENTITY2_PARAM4)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Abs\r
@Tip = %(T_48_META_API_1066_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1066_R_D)\r
variable Abs : Number = 1066 { #%(T_46_META_WS_ABS)\r
	@Tip = %(T_48_META_API_1066_P0_D)\r
    Value : Number #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Sqrt\r
@Tip = %(T_48_META_API_1067_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1067_R_D)\r
variable Sqrt : Float = 1067 { #%(T_46_META_WS_SQRT)\r
	@Tip = %(T_48_META_API_1067_P0_D)\r
    Value : Float #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Negate\r
@Tip = %(T_48_META_API_1068_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1068_R_D)\r
variable Negate : Number = 1068 { #%(T_46_META_WS_NEGATE)\r
	@Tip = %(T_48_META_API_1068_P0_D)\r
    Value : Number #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Connect\r
@Tip = %(T_48_META_API_1069_D)\r
@ModuleID=10004\r
@ModuleLib=Strings\r
@Return = %(T_48_META_API_1069_R_D)\r
variable StrConcat : String = 1069 { #%(T_46_META_WS_CONNECT)\r
	@Tip = %(T_48_META_API_1069_P0_D)\r
    LeftStr : Object #%(T_46_META_WS_A_LEFT)\r
	@Tip = %(T_48_META_API_1069_P1_D)\r
    RightStr : Object #%(T_46_META_WS_A_RIGHT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Length\r
@Tip = %(T_48_META_API_1070_D)\r
@ModuleID=10004\r
@ModuleLib=Strings\r
@Return = %(T_48_META_API_1070_R_D)\r
variable StrLen : Int = 1070 { #%(T_46_META_WS_LENGTH)\r
	@Tip = %(T_48_META_API_1070_P0_D)\r
    Str : String #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Floor\r
@Tip = %(T_48_META_API_1071_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1071_R_D)\r
variable Floor : Int = 1071 { #%(T_46_META_WS_FLOOR)\r
	@Tip = %(T_48_META_API_1071_P0_D)\r
    Value : Float #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Ceil\r
@Tip = %(T_48_META_API_1072_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1072_R_D)\r
variable Ceil : Int = 1072 { #%(T_46_META_WS_CEIL)\r
	@Tip = %(T_48_META_API_1072_P0_D)\r
    Value : Float #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Round\r
@Tip = %(T_48_META_API_1073_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1073_R_D)\r
variable Round : Int = 1073 { #%(T_46_META_WS_ROUND)\r
	@Tip = %(T_48_META_API_1073_P0_D)\r
    Value : Float #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetX\r
@Tip = %(T_48_META_API_1500_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1500_R_D)\r
variable VectorGetX : Float = 1500 { #%(T_34_LY_WS_GVX)\r
	@Tip = %(T_48_META_API_1500_P0_D)\r
    Vector : Vector3 #%(T_48_META_API_1500_P0)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetY\r
@Tip = %(T_48_META_API_1501_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1501_R_D)\r
variable VectorGetY : Float = 1501 { #%(T_34_LY_WS_GVY)\r
	@Tip = %(T_48_META_API_1501_P0_D)\r
    Vector : Vector3 #%(T_48_META_API_1500_P0)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetZ\r
@Tip = %(T_48_META_API_1502_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1502_R_D)\r
variable VectorGetZ : Float = 1502 { #%(T_34_LY_WS_GVZ)\r
	@Tip = %(T_48_META_API_1502_P0_D)\r
    Vector : Vector3 #%(T_48_META_API_1500_P0)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetX\r
@Tip = %(T_48_META_API_1503_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=2\r
action VectorSetX = 1503 { #%(T_34_LY_WS_SVX)\r
	@Tip = %(T_48_META_API_1503_P0_D)\r
    Vector : Vector3 #%(T_48_META_API_1500_P0)\r
	@Tip = %(T_48_META_API_1503_P1_D)\r
    X : Float #%(T_46_META_WS_A_X)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetY\r
@Tip = %(T_48_META_API_1504_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=2\r
action VectorSetY = 1504 { #%(T_34_LY_WS_SVY)\r
	@Tip = %(T_48_META_API_1504_P0_D)\r
    Vector : Vector3 #%(T_48_META_API_1500_P0)\r
	@Tip = %(T_48_META_API_1504_P1_D)\r
    Y : Float #%(T_46_META_WS_A_Y)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetZ\r
@Tip = %(T_48_META_API_1505_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=2\r
action VectorSetZ = 1505 { #%(T_34_LY_WS_SVZ)\r
	@Tip = %(T_48_META_API_1505_P0_D)\r
    Vector : Vector3 #%(T_48_META_API_1500_P0)\r
	@Tip = %(T_48_META_API_1505_P1_D)\r
    Z : Float #%(T_48_META_API_1505_P1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Add\r
@Tip = %(T_48_META_API_1506_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1506_R_D)\r
variable VectorAdd : Vector3 = 1506 { #%(T_34_LY_WS_VADD)\r
	@Tip = %(T_48_META_API_1506_P0_D)\r
    VectorLeft : Vector3 #%(T_46_META_WS_A_VALUEA)\r
	@Tip = %(T_48_META_API_1506_P1_D)\r
    VectorRight : Vector3 #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Sub\r
@Tip = %(T_48_META_API_1507_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1507_R_D)\r
variable VectorSub : Vector3 = 1507 { #%(T_34_LY_WS_VSUB)\r
	@Tip = %(T_48_META_API_1507_P0_D)\r
    VectorLeft : Vector3 #%(T_46_META_WS_A_VALUEA)\r
	@Tip = %(T_48_META_API_1507_P1_D)\r
    VectorRight : Vector3 #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Mul\r
@Tip = %(T_48_META_API_1508_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1508_R_D)\r
variable VectorMul : Vector3 = 1508 { #%(T_34_LY_WS_VMUL)\r
	@Tip = %(T_48_META_API_1508_P0_D)\r
    VectorLeft : Vector3 #%(T_46_META_WS_A_VALUE)\r
	@Tip = %(T_48_META_API_1508_P1_D)\r
    Scale : Float #%(T_40_XXJ_WS_SCALE_NAMEKEY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Dot\r
@Tip = %(T_48_META_API_1509_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1509_R_D)\r
variable VectorDot : Float = 1509 { #%(T_46_META_WS_DOT)\r
	@Tip = %(T_48_META_API_1509_P0_D)\r
    VectorLeft : Vector3 #%(T_46_META_WS_A_VALUEA)\r
	@Tip = %(T_48_META_API_1509_P1_D)\r
    VectorRight : Vector3 #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Cross\r
@Tip = %(T_48_META_API_1510_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1510_R_D)\r
variable VectorCross : Vector3 = 1510 { #%(T_46_META_WS_CROSS)\r
	@Tip = %(T_48_META_API_1510_P0_D)\r
    VectorLeft : Vector3 #%(T_46_META_WS_A_VALUEA)\r
	@Tip = %(T_48_META_API_1510_P1_D)\r
    VectorRight : Vector3 #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Normalize\r
@Tip = %(T_48_META_API_1511_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1511_R_D)\r
variable VectorNormalize : Vector3 = 1511 { #%(T_46_META_WS_NORMALIZE)\r
	@Tip = %(T_48_META_API_1511_P0_D)\r
    Vector : Vector3 #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Magnitude\r
@Tip = %(T_48_META_API_1512_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1512_R_D)\r
variable VectorSize : Float = 1512 { #%(T_46_META_WS_MAGNITUDE)\r
	@Tip = %(T_48_META_API_1512_P0_D)\r
    Vector : Vector3 #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Distance\r
@Tip = %(T_48_META_API_1513_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1513_R_D)\r
variable VectorDistance : Float = 1513 { #%(T_46_META_WS_DISTANCE)\r
	@Tip = %(T_48_META_API_1513_P0_D)\r
    VectorLeft : Vector3 #%(T_46_META_WS_A_VALUEA)\r
	@Tip = %(T_48_META_API_1513_P1_D)\r
    VectorRight : Vector3 #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Angle\r
@Tip = %(T_48_META_API_1514_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1514_R_D)\r
variable VectorAngel : Float = 1514 { #%(T_46_META_WS_ANGEL)\r
	@Tip = %(T_48_META_API_1514_P0_D)\r
    VectorLeft : Vector3 #%(T_46_META_WS_A_VALUEA)\r
	@Tip = %(T_48_META_API_1514_P1_D)\r
    VectorRight : Vector3 #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Projection\r
@Tip = %(T_49_META_API_98_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
variable Vector3Projection : Vector3 = 98 { #%(T_49_META_API_98)\r
	@Tip = %(T_48_META_API_1510_P0_D)\r
    ValueA : Vector3 #%(T_46_META_WS_A_VALUEA)\r
	@Tip = %(T_48_META_API_1510_P1_D)\r
    ValueB : Vector3 #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2GetX\r
@Tip = %(T_48_META_API_3240_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_3240_R_D)\r
variable Vector2GetX : Float = 3240 { #%(T_43_YU_WS_VECTOR2GETX)\r
	@Tip = %(T_48_META_API_3240_P0_D)\r
    Vector2 : Vector2 #%(T_38_M_WS_VECTOR2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2GetY\r
@Tip = %(T_48_META_API_3241_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_3241_R_D)\r
variable Vector2GetY : Float = 3241 { #%(T_43_YU_WS_VECTOR2GETY)\r
	@Tip = %(T_48_META_API_3241_P0_D)\r
    Vector2 : Vector2 #%(T_38_M_WS_VECTOR2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2SetX\r
@Tip = %(T_48_META_API_3242_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=2\r
action Vector2SetX = 3242 { #%(T_43_YU_WS_VECTOR2SETX)\r
	@Tip = %(T_48_META_API_3242_P0_D)\r
    Vector2 : Vector2 #%(T_38_M_WS_VECTOR2)\r
	@Tip = %(T_48_META_API_3242_P1_D)\r
    X : Float #%(T_46_META_WS_A_X)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2SetY\r
@Tip = %(T_48_META_API_3243_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=2\r
action Vector2SetY = 3243 { #%(T_43_YU_WS_VECTOR2SETY)\r
	@Tip = %(T_48_META_API_3243_P0_D)\r
    Vector2 : Vector2 #%(T_38_M_WS_VECTOR2)\r
	@Tip = %(T_48_META_API_3243_P1_D)\r
    Y : Float #%(T_46_META_WS_A_Y)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2Add\r
@Tip = %(T_48_META_API_3244_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_3244_R_D)\r
variable Vector2Add : Vector2 = 3244 { #%(T_43_YU_WS_VECTOR2ADD)\r
	@Tip = %(T_48_META_API_3244_P0_D)\r
    Vector2Left : Vector2 #%(T_46_META_WS_A_VALUEA)\r
	@Tip = %(T_48_META_API_3244_P1_D)\r
    Vector2Right : Vector2 #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2Sub\r
@Tip = %(T_48_META_API_3245_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_3245_R_D)\r
variable Vector2Sub : Vector2 = 3245 { #%(T_43_YU_WS_VECTOR2SUB)\r
	@Tip = %(T_48_META_API_3245_P0_D)\r
    Vector2Left : Vector2 #%(T_46_META_WS_A_VALUEA)\r
	@Tip = %(T_48_META_API_3245_P1_D)\r
    Vector2Right : Vector2 #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2Scale\r
@Tip = %(T_48_META_API_3246_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_3246_R_D)\r
variable Vector2Scale : Vector2 = 3246 { #%(T_43_YU_WS_VECTOR2SCALE)\r
	@Tip = %(T_48_META_API_3246_P0_D)\r
    Vector2Left : Vector2 #%(T_38_M_WS_VECTOR2)\r
	@Tip = %(T_48_META_API_3246_P1_D)\r
    Scale : Float #%(T_40_XXJ_WS_SCALE_NAMEKEY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2Dot\r
@Tip = %(T_48_META_API_3247_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_3247_R_D)\r
variable Vector2Dot : Float = 3247 { #%(T_46_META_WS_VECTOR2DOT)\r
	@Tip = %(T_48_META_API_3247_P0_D)\r
    Vector2Left : Vector2 #%(T_46_META_WS_A_VALUEA)\r
	@Tip = %(T_48_META_API_3247_P1_D)\r
    Vector2Right : Vector2 #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2Distance\r
@Tip = %(T_48_META_API_3248_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_3248_R_D)\r
variable Vector2Distance : Float = 3248 { #%(T_46_META_WS_VECTOR2DISTANCE)\r
	@Tip = %(T_48_META_API_3248_P0_D)\r
    Vector2Left : Vector2 #%(T_46_META_WS_A_VALUEA)\r
	@Tip = %(T_48_META_API_3248_P1_D)\r
    Vector2Right : Vector2 #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2Angle\r
@Tip = %(T_48_META_API_3249_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_3249_R_D)\r
variable Vector2Angle : Float = 3249 { #%(T_46_META_WS_VECTOR2ANGLE)\r
	@Tip = %(T_48_META_API_3249_P0_D)\r
    Vector2Left : Vector2 #%(T_46_META_WS_A_VALUEA)\r
	@Tip = %(T_48_META_API_3249_P1_D)\r
    Vector2Right : Vector2 #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2Normalize\r
@Tip = %(T_48_META_API_3250_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_3250_R_D)\r
variable Vector2Normalize : Vector2 = 3250 { #%(T_46_META_WS_VECTOR2NORMALIZE)\r
	@Tip = %(T_48_META_API_3250_P0_D)\r
    Vector2 : Vector2 #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2Magnitude\r
@Tip = %(T_48_META_API_3251_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_3251_R_D)\r
variable Vector2Magnitude : Float = 3251 { #%(T_46_META_WS_VECTOR2MAGNITUDE)\r
	@Tip = %(T_48_META_API_3251_P0_D)\r
    Vector2 : Vector2 #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2Reflect\r
@Tip = %(T_48_META_API_3252_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_3252_R_D)\r
variable Vector2Reflect : Vector2 = 3252 { #%(T_46_META_WS_VECTOR2REFLECT)\r
	@Tip = %(T_48_META_API_3252_P0_D)\r
    Direction : Vector2 #%(T_46_META_WS_A_DIRECTION)\r
	@Tip = %(T_48_META_API_3252_P1_D)\r
    Normal : Vector2 #%(T_46_META_WS_A_NORMAL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector3Reflect\r
@Tip = %(T_48_META_API_3253_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_3253_R_D)\r
variable Vector3Reflect : Vector3 = 3253 { #%(T_46_META_WS_VECTOR3REFLECT)\r
	@Tip = %(T_48_META_API_3253_P0_D)\r
    Direction : Vector3 #%(T_46_META_WS_A_DIRECTION)\r
	@Tip = %(T_48_META_API_3253_P1_D)\r
    Normal : Vector3 #%(T_46_META_WS_A_NORMAL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector3ToVector2\r
@Tip = %(T_48_META_API_3254_D)\r
@ModuleID=10005\r
@ModuleLib=Convert\r
@Return = %(T_48_META_API_3254_R_D)\r
variable Vector3ToVector2 : Vector2 = 3254 { #%(T_46_META_WS_VECTOR3TOVECTOR2)\r
	@Tip = %(T_48_META_API_3254_P0_D)\r
    Vector3 : Vector3 #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2ToVector3\r
@Tip = %(T_48_META_API_3255_D)\r
@ModuleID=10005\r
@ModuleLib=Convert\r
@Return = %(T_48_META_API_3255_R_D)\r
variable Vector2ToVector3 : Vector3 = 3255 { #%(T_46_META_WS_VECTOR2TOVECTOR3)\r
	@Tip = %(T_48_META_API_3255_P0_D)\r
    Vector2 : Vector2 #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=NewVector2\r
@Tip = %(T_48_META_API_3256_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_3256_R_D)\r
variable NewVector2 : Vector2 = 3256 { #%(T_43_YU_WS_NEWVECTOR2)\r
	@Tip = %(T_48_META_API_3256_P0_D)\r
    X : Float #%(T_43_YU_WS_X)\r
	@Tip = %(T_48_META_API_3256_P1_D)\r
    Y : Float #%(T_43_YU_WS_Y)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=NewVector3\r
@Tip = %(T_48_META_API_1515_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1515_R_D)\r
variable NewVector : Vector3 = 1515 { #%(T_38_WZY_WS_GETVEC_NAME)\r
	@Tip = %(T_48_META_API_1515_P0_D)\r
    X : Float #%(T_43_YU_WS_X)\r
	@Tip = %(T_48_META_API_1515_P1_D)\r
    Y : Float #%(T_43_YU_WS_Y)\r
	@Tip = %(T_48_META_API_1515_P2_D)\r
    Z : Float #%(T_45_XXJ_WS_Z)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=NewDirectPoint_Deprecated\r
@Tip = %(T_48_META_API_1516_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=2\r
@Return = %(T_48_META_API_1516_R_D)\r
variable NewDirectPoint : DirectedPoint = 1516 { #%(T_36_WZY_WS_SETDIRPOINT_NAME)\r
	@Tip = %(T_48_META_API_1516_P0_D)\r
    Position : Vector3 #%(T_34_WT_WS_ENTITY13_PARAM2)\r
	@Tip = %(T_48_META_API_1516_P1_D)\r
    Forward : Vector3 #%(T_36_WZY_WS_SETDIRPOINT_PARAM2_NAME)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=DirectPointGetPos_Deprecated\r
@Tip = %(T_48_META_API_1517_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=2\r
@Return = %(T_48_META_API_1517_R_D)\r
variable DirectPointGetPos : Vector3 = 1517 { #%(T_36_WZY_WS_GETPOS_NAME)\r
	@Tip = %(T_48_META_API_1517_P0_D)\r
    DirectPoint : DirectedPoint #%(T_36_WZY_WS_DIRPOINT)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=DirectPointGetForward_Deprecated\r
@Tip = %(T_48_META_API_1518_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=2\r
@Return = %(T_48_META_API_1518_R_D)\r
variable DirectPointGetForward : Vector3 = 1518 { #%(T_36_WZY_WS_GETFOR_NAME)\r
	@Tip = %(T_48_META_API_1518_P0_D)\r
    DirectPoint : DirectedPoint #%(T_36_WZY_WS_DIRPOINT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=New\r
@Tip = %(T_48_META_API_1519_D)\r
@ModuleID=10001\r
@ModuleLib=List\r
@Return = %(T_48_META_API_1519_R_D)\r
variable NewList : List = 1519 { #%(T_46_META_WS_NEW)\r
	@Tip = %(T_48_META_API_1519_P0_D)\r
    Length : Int #%(T_46_META_WS_A_LENGTH)\r
	@Tip = %(T_48_META_API_1519_P1_D)\r
    Capicity : Int #%(T_46_META_WS_A_CAPICITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=New\r
@Tip = %(T_48_META_API_1601_D)\r
@ModuleID=10002\r
@ModuleLib=Map\r
@Return = %(T_48_META_API_1601_R_D)\r
variable NewMap : Map = 1601 { #%(T_46_META_WS_NEW)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Sin\r
@Tip = %(T_48_META_API_1525_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1525_R_D)\r
variable Sin : Float = 1525 { #%(T_46_META_WS_SIN)\r
	@Tip = %(T_48_META_API_1525_P0_D)\r
    Degree : Float #%(T_46_META_WS_A_DEGREE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Cos\r
@Tip = %(T_48_META_API_1526_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1526_R_D)\r
variable Cos : Float = 1526 { #%(T_46_META_WS_COS)\r
	@Tip = %(T_48_META_API_1526_P0_D)\r
    Degree : Float #%(T_46_META_WS_A_DEGREE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Tan\r
@Tip = %(T_48_META_API_1527_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1527_R_D)\r
variable Tan : Float = 1527 { #%(T_46_META_WS_TAN)\r
	@Tip = %(T_48_META_API_1527_P0_D)\r
    Degree : Float #%(T_46_META_WS_A_DEGREE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ColorGet\r
@Tip = %(T_48_META_API_1528_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_1528_R_D)\r
variable ColorGet : Color = 1528 { #%(T_46_META_WS_COLORGET)\r
	@Tip = %(T_48_META_API_1528_P0_D)\r
    R : Int #%(T_46_META_WS_A_R)\r
	@Tip = %(T_48_META_API_1528_P1_D)\r
    G : Int #%(T_46_META_WS_A_G)\r
	@Tip = %(T_48_META_API_1528_P2_D)\r
    B : Int #%(T_46_META_WS_A_B)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ASin\r
@Tip = %(T_48_META_API_1529_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1529_R_D)\r
variable Asin : Float = 1529 { #%(T_46_META_WS_ASIN)\r
	@Tip = %(T_48_META_API_1529_P0_D)\r
    Degree : Float #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ACos\r
@Tip = %(T_48_META_API_1530_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1530_R_D)\r
variable Acos : Float = 1530 { #%(T_46_META_WS_ACOS)\r
	@Tip = %(T_48_META_API_1530_P0_D)\r
    Degree : Float #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Value\r
@Tip = %(T_48_META_API_1531_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1531_R_D)\r
variable Atan : Float = 1531 { #%(T_46_META_WS_A_VALUE)\r
	@Tip = %(T_48_META_API_1531_P0_D)\r
    Degree : Float #%(T_46_META_WS_A_DEGREE)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1064_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_1064_R_D)\r
variable IsNil : Bool = 1064 { #%(T_34_WZ_WS_LOGIC4_NAME)\r
	@Tip = %(T_48_META_API_1064_P0_D)\r
    TargetObj : Object #%(T_34_WZ_WS_LOGIC4_PARAM1_NAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetServerTimestamp\r
@Tip = %(T_48_META_API_1598_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
@Return = %(T_48_META_API_1598_R_D)\r
variable GetServerTime : Int = 1598 { #%(T_46_META_WS_GETSERVERTIMESTAMP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetServerRegion\r
@Tip = %(T_48_META_API_1599_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
@Return = %(T_48_META_API_1599_R_D)\r
variable GetServerRegion : String = 1599 { #%(T_46_META_WS_GETSERVERREGION)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_2000_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action SetReplicationData = 2000 { #%(T_34_WT_WS_ENTITY2_NAME)\r
	@Tip = %(T_48_META_API_2000_P0_D)\r
    TargetEntity : entity #%(T_34_WT_WS_ENTITY2_PARAM1)\r
	@Tip = %(T_48_META_API_2000_P1_D)\r
    PropertyIndex : Property #%(T_34_WT_WS_ENTITY2_PARAM3)\r
	@Tip = %(T_48_META_API_2000_P2_D)\r
    PropertyValue : Object #%(T_34_WT_WS_ENTITY2_PARAM4)\r
	@Tip = %(T_48_META_API_2000_P3_D)\r
    ArithmeticType : Int #%(T_36_WZY_WS_OPERMETHOD_NAME)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_2001_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_2001_R_D)\r
variable GetReplicationData : Object = 2001 { #%(T_34_WT_WS_ENTITY4_NAME)\r
	@Tip = %(T_48_META_API_2001_P0_D)\r
    TargetEntity : entity #%(T_34_WT_WS_ENTITY2_PARAM1)\r
	@Tip = %(T_48_META_API_2001_P1_D)\r
    PropertyIndex : Property #%(T_34_WT_WS_ENTITY2_PARAM3)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_2002_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action SetGraphProperty = 2002 { #%(T_48_META_API_2002)\r
	@Tip = %(T_48_META_API_2002_P0_D)\r
    TargetEntity : entity #%(T_40_XXJ_WS_TARGETENTITY_NAMEKEY)\r
	@Tip = %(T_48_META_API_2002_P1_D)\r
    GraphID : String #%(T_48_META_API_2002_P1)\r
	@Tip = %(T_48_META_API_2002_P2_D)\r
    PropertyID : String #%(T_48_META_API_2002_P2)\r
	@Tip = %(T_48_META_API_2002_P3_D)\r
    PropertyValue : Object #%(T_48_META_API_2002_P3)\r
	@Tip = %(T_48_META_API_2002_P4_D)\r
    ArithmeticType : Int #%(T_36_WZY_WS_OPERMETHOD_NAME)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_2003_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_2003_R_D)\r
variable GetGraphProperty : Object = 2003 { #%(T_48_META_API_2003)\r
	@Tip = %(T_48_META_API_2003_P0_D)\r
    TargetEntity : entity #%(T_40_XXJ_WS_TARGETENTITY_NAMEKEY)\r
	@Tip = %(T_48_META_API_2003_P1_D)\r
    GraphID : String #%(T_48_META_API_2003_P1)\r
	@Tip = %(T_48_META_API_2003_P2_D)\r
    PropertyID : String #%(T_48_META_API_2003_P2)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_2013_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action SetSelfGraphProperty = 2013 { #%(T_48_META_API_2013)\r
	@Tip = %(T_48_META_API_2013_P0_D)\r
    PropertyID : String #%(T_48_META_API_2013_P0)\r
	@Tip = %(T_48_META_API_2013_P1_D)\r
    PropertyValue : Object #%(T_48_META_API_2013_P1)\r
	@Tip = %(T_48_META_API_2013_P2_D)\r
    ArithmeticType : Int #%(T_36_WZY_WS_OPERMETHOD_NAME)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_2014_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_2014_R_D)\r
variable GetSelfGraphProperty : Object = 2014 { #%(T_48_META_API_2014)\r
	@Tip = %(T_48_META_API_2014_P0_D)\r
    PropertyID : String #%(T_48_META_API_2014_P0)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_2004_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action DefLocalVar = 2004 { #%(T_36_M_WS_TEMPVAR)\r
	@Tip = %(T_48_META_API_2004_P0_D)\r
    VarName : String #%(T_34_M_WS_VARNAME)\r
	@Tip = %(T_48_META_API_2004_P1_D)\r
    VarValue : Object #%(T_34_WT_WS_ENTITY2_PARAM4)\r
	@Tip = %(T_48_META_API_2004_P2_D)\r
    VarType : Type #%(T_40_XXJ_WS_VARTYPE_NAMEKEY)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_2005_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action SetLocalVar = 2005 { #%(T_36_M_WS_SETTEMPVAR)\r
	@Tip = %(T_48_META_API_2005_P0_D)\r
    VarName : String #%(T_34_M_WS_VARNAME)\r
	@Tip = %(T_48_META_API_2005_P1_D)\r
    VarValue : Object #%(T_48_META_API_2005_P1)\r
	@Tip = %(T_48_META_API_2005_P2_D)\r
    ArithmeticType : Int #%(T_36_WZY_WS_OPERMETHOD_NAME)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_2006_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_2006_R_D)\r
variable GetLocalVar : Object = 2006 { #%(T_48_META_API_2006)\r
	@Tip = %(T_48_META_API_2006_P0_D)\r
    VarName : String #%(T_48_META_API_2006_P0)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_2009_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action FindAndInvokeGlobalCustomAPIWithSerial = 2009 { #%(T_48_META_API_2009)\r
	@Tip = %(T_48_META_API_2009_P0_D)\r
    GraphID : String #%(T_48_META_API_2009_P0)\r
	@Tip = %(T_48_META_API_2009_P1_D)\r
    FuncID : String #%(T_48_META_API_2009_P1)\r
	@Tip = %(T_48_META_API_2009_P2_D)\r
    ParamsArray : List #%(T_42_XXJ_WS_PARAMSARRAY)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_2010_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action FindAndInvokeGlobalCustomAPIWithParallel = 2010 { #%(T_48_META_API_2010)\r
	@Tip = %(T_48_META_API_2010_P0_D)\r
    GraphID : String #%(T_48_META_API_2010_P0)\r
	@Tip = %(T_48_META_API_2010_P1_D)\r
    FuncID : String #%(T_48_META_API_2010_P1)\r
	@Tip = %(T_48_META_API_2010_P2_D)\r
    ParamsArray : List #%(T_42_XXJ_WS_PARAMSARRAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddHP\r
@Tip = %(T_48_META_API_3201_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action PlayerAddHP = 3201 { #%(T_46_META_WS_ADDHP)\r
	@Tip = %(T_48_META_API_3201_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3201_P1_D)\r
    DeltaHP : Int #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DestroyItem\r
@Tip = %(T_48_META_API_3205_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action PlayerRemoveItem = 3205 { #%(T_46_META_WS_DESTROYITEM)\r
	@Tip = %(T_48_META_API_3205_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3205_P1_D)\r
    ItemID : ItemGoodsIDType #%(T_46_META_WS_A_ITEM)\r
	@Tip = %(T_48_META_API_3205_P2_D)\r
    Count : Int #%(T_46_META_WS_A_COUNT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetItemCount\r
@Tip = %(T_48_META_API_3206_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3206_R_D)\r
variable GetPlayerBagItemCount : Int = 3206 { #%(T_46_META_WS_GETITEMCOUNT)\r
	@Tip = %(T_48_META_API_3206_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3206_P1_D)\r
    ItemID : ItemGoodsIDType #%(T_46_META_WS_A_ITEM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateBuiltInUI\r
@Tip = %(T_48_META_API_9000_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
@ApiTarget=2\r
action CreateInternalHud = 9000 { #%(T_46_META_WS_CREATEBUILTINUI)\r
	@Tip = %(T_48_META_API_9000_P0_D)\r
    out EntityVarName : InternalHud #%(T_46_META_WS_A_CREATEDENTITY)\r
	@Tip = %(T_48_META_API_9000_P1_D)\r
    @optional\r
    OwnerPlayer : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_9000_P2_D)\r
    HudType : InternalHudType #%(T_46_META_WS_A_TYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateBuiltInUIClient\r
@Tip = %(T_48_META_API_73_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
@ApiTarget=1\r
action CreateInternalHudClient = 73 { #%(T_46_META_WS_CREATEBUILTINUICLIENT)\r
	@Tip = %(T_48_META_API_73_P0_D)\r
    out EntityVarName : InternalHud #%(T_46_META_WS_A_CREATEDENTITY)\r
	@Tip = %(T_48_META_API_73_P1_D)\r
    HudType : InternalHudType #%(T_46_META_WS_A_TYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DestroyBuiltInUI\r
@Tip = %(T_48_META_API_9001_D)\r
@ModuleID=31\r
@ModuleLib=Hud\r
action RemoveInternalHud = 9001 { #%(T_46_META_WS_DESTROYBUILTINUI)\r
	@Tip = %(T_48_META_API_9001_P0_D)\r
    HudEntity : InternalHud #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=CreateIconEntity_Deprecated\r
@Tip = %(T_48_META_API_9002_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action CreateIconEntity = 9002 { #%(T_34_WT_WS_ENTITY6_NAME)\r
	@Tip = %(T_48_META_API_9002_P0_D)\r
    out EntityVarName : PresentIcon #%(T_34_WT_WS_ICONENTITY_PARAM1)\r
	@Tip = %(T_48_META_API_9002_P1_D)\r
    OwnerPlayer : Player #%(T_34_WT_WS_ENTITY7_PARAM1)\r
	@Tip = %(T_48_META_API_9002_P2_D)\r
    IconType : IconType #%(T_34_WT_WS_ENTITY6_PARAM1)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=RemoveIconEntity_Deprecated\r
@Tip = %(T_48_META_API_9003_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action RemoveIconEntity = 9003 { #%(T_34_WT_WS_ENTITY10_NAME)\r
	@Tip = %(T_48_META_API_9003_P0_D)\r
    TargetEntity : PresentIcon #%(T_34_WT_WS_ICONENTITY_PARAM1)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=CreateTextEntity_Deprecated\r
@Tip = %(T_48_META_API_9004_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action CreateTextEntity = 9004 { #%(T_34_WT_WS_ENTITY8_NAME)\r
	@Tip = %(T_48_META_API_9004_P0_D)\r
    out EntityVarName : PresentText #%(T_34_WT_WS_TXTENTITY_PARAM1)\r
	@Tip = %(T_48_META_API_9004_P1_D)\r
    OwnerPlayer : Player #%(T_34_WT_WS_ENTITY7_PARAM1)\r
	@Tip = %(T_48_META_API_9004_P2_D)\r
    Text : Object #%(T_34_WT_WS_ENTITY8_PARAM1)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=RemoveTextEntity_Deprecated\r
@Tip = %(T_48_META_API_9005_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action RemoveTextEntity = 9005 { #%(T_34_WT_WS_ENTITY11_NAME)\r
	@Tip = %(T_48_META_API_9005_P0_D)\r
    TargetEntity : PresentText #%(T_34_WT_WS_TXTENTITY_PARAM1)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=CreateEffectEntity_Deprecated\r
@Tip = %(T_48_META_API_9006_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action CreateEffectEntity = 9006 { #%(T_34_SP_WS_BLOCK10_NAME)\r
	@Tip = %(T_48_META_API_9006_P0_D)\r
    out EntityVarName : PresentEffect #%(T_34_WT_WS_VFXENTITY_PARAM1)\r
	@Tip = %(T_48_META_API_9006_P1_D)\r
    OwnerPlayer : Player #%(T_34_SP_WS_BLOCK6_PARAM2_NAME)\r
	@Tip = %(T_48_META_API_9006_P2_D)\r
    EffectType : EffectType #%(T_34_M_WS_VFX)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=CreateEffect_Deprecated\r
@Tip = %(T_48_META_API_9023_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action CreateEffectEntityNew = 9023 { #%(T_34_SP_WS_BLOCK10_NAME)\r
	@Tip = %(T_48_META_API_9023_P0_D)\r
    out EntityVarName : EffectEntity #%(T_34_WT_WS_VFXENTITY_PARAM1)\r
	@Tip = %(T_48_META_API_9023_P1_D)\r
    OwnerPlayer : Player #%(T_34_SP_WS_BLOCK6_PARAM2_NAME)\r
	@Tip = %(T_48_META_API_9023_P2_D)\r
    EffectType : EffectType #%(T_34_M_WS_VFX)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetSkybox\r
@Tip = %(T_48_META_API_103_D)\r
@ModuleID=10012\r
@ModuleLib=Scene\r
@ApiTarget=2\r
action SetSkyboxEnv = 103 { #%(T_46_META_WS_SETSKYBOX)\r
	@Tip = %(T_48_META_API_103_P0_D)\r
    SkyboxEnv : SkyboxEnvBaseType #%(T_46_META_WS_A_TYPE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=RemoveEffectEntity_Deprecated\r
@Tip = %(T_48_META_API_9007_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action RemoveEffectEntity = 9007 { #%(T_34_SP_WS_BLOCK12_NAME)\r
	@Tip = %(T_48_META_API_9007_P0_D)\r
    TargetEntity : PresentEffect #%(T_34_SP_WS_BLOCK12_PARAM1_NAME)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=RemoveEffectEntityNew_Deprecated\r
@Tip = %(T_48_META_API_9024_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action RemoveEffectEntityNew = 9024 { #%(T_34_SP_WS_BLOCK12_NAME)\r
	@Tip = %(T_48_META_API_9024_P0_D)\r
    TargetEntity : EffectEntity #%(T_34_SP_WS_BLOCK12_PARAM1_NAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateCustomUI_Deprecated\r
@Tip = %(T_48_META_API_9008_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
@ApiTarget=2\r
action CreateCustomHud = 9008 { #%(T_46_META_WS_CREATECUSTOMUI)\r
	@Tip = %(T_48_META_API_9008_P0_D)\r
    out EntityVarName : CustomHud #%(T_46_META_WS_A_CREATEDENTITY)\r
	@Tip = %(T_48_META_API_9008_P1_D)\r
    @optional\r
    OwnerPlayer : Player #%(T_46_META_WS_A_OWNER)\r
	@Tip = %(T_48_META_API_9008_P2_D)\r
    HudID : CustomHudID #%(T_46_META_WS_A_UIID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateCustomUI\r
@Tip = %(T_50_META_API_114_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
@ApiTarget=2\r
action CreateCustomHudV2 = 114 { #%(T_46_META_WS_CREATECUSTOMUI)\r
	@Tip = %(T_50_META_API_114_P0_D)\r
    out EntityVarName : CustomHud #%(T_46_META_WS_A_CREATEDENTITY)\r
	@Tip = %(T_50_META_API_114_P1_D)\r
    @optional\r
    OwnerPlayer : Player #%(T_46_META_WS_A_OWNER)\r
	@Tip = %(T_50_META_API_114_P2_D)\r
    HudAssetID : CustomHudAssetID #%(T_50_META_API_114_P2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateCustomUIClient_Deprecated\r
@Tip = %(T_48_META_API_74_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
@ApiTarget=1\r
action CreateCustomHudClient = 74 { #%(T_46_META_WS_CREATECUSTOMUICLIENT)\r
	@Tip = %(T_48_META_API_74_P0_D)\r
    out EntityVarName : CustomHud #%(T_46_META_WS_A_CREATEDENTITY)\r
	@Tip = %(T_48_META_API_74_P1_D)\r
    HudID : CustomHudID #%(T_46_META_WS_A_UIID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateCustomUIClient\r
@Tip = %(T_50_META_API_115_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
@ApiTarget=1\r
action CreateCustomHudClientV2 = 115 { #%(T_46_META_WS_CREATECUSTOMUICLIENT)\r
	@Tip = %(T_50_META_API_114_P0_D)\r
    out EntityVarName : CustomHud #%(T_46_META_WS_A_CREATEDENTITY)\r
	@Tip = %(T_50_META_API_114_P2_D)\r
    HudAssetID : CustomHudAssetID #%(T_50_META_API_114_P2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DestroyCustomUI\r
@Tip = %(T_48_META_API_9009_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
action RemoveCustomHud = 9009 { #%(T_46_META_WS_DELETECUSTOMUI)\r
	@Tip = %(T_48_META_API_9009_P0_D)\r
    HudEntity : CustomHud #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetWidgetFromCustomUI\r
@Tip = %(T_48_META_API_9010_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Return = %(T_48_META_API_9010_R_D)\r
variable GetWidgetFromCustomHud : HudWidget = 9010 { #%(T_46_META_WS_GETWIDGETFROMCUSTOMUI)\r
	@Tip = %(T_48_META_API_9010_P0_D)\r
    @optional\r
    OwnerPlayer : Player #%(T_46_META_WS_A_OWNER)\r
	@Tip = %(T_48_META_API_9010_P1_D)\r
    HudEntity : CustomHud #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_9010_P2_D)\r
    WidgetID : CustomHudWidgetID #%(T_46_META_WS_A_WIDGETID)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=CreateSoundEntity_Deprecated\r
@Tip = %(T_48_META_API_9011_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action CreateSoundEntity = 9011 { #%(T_34_SP_WS_BLOCK14_NAME)\r
	@Tip = %(T_48_META_API_9011_P0_D)\r
    out EntityVarName : PresentSound #%(T_38_WZY_WS_SOUNDENT)\r
	@Tip = %(T_48_META_API_9011_P1_D)\r
    OwnerPlayer : Player #%(T_34_SP_WS_BLOCK6_PARAM2_NAME)\r
	@Tip = %(T_48_META_API_9011_P2_D)\r
    SoundType : AudioType #%(T_34_SP_WS_BLOCK13_PARAM2_NAME)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=PauseSoundEntity_Deprecated\r
@Tip = %(T_48_META_API_9014_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action PauseSoundEntity = 9014 { #%(T_39_WZY_WS_PAUSESOUND_NAME)\r
	@Tip = %(T_48_META_API_9014_P0_D)\r
    TargetEntity : PresentSoundOrListPresentSound #%(T_39_WZY_WS_SOUNDENTLORSENT)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=ResumeSoundEntity_Deprecated\r
@Tip = %(T_48_META_API_9015_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action ResumeSoundEntity = 9015 { #%(T_39_WZY_WS_PLAYSOUND_NAME)\r
	@Tip = %(T_48_META_API_9015_P0_D)\r
    TargetEntity : PresentSoundOrListPresentSound #%(T_39_WZY_WS_SOUNDENTLORSENT)\r
	@Tip = %(T_48_META_API_9015_P1_D)\r
    IsReplay : Bool #%(T_39_WZY_WS_WEAREPLAY)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=RemoveSoundEntity_Deprecated\r
@Tip = %(T_48_META_API_9012_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action RemoveSoundEntity = 9012 { #RemoveSoundEntity\r
	@Tip = %(T_48_META_API_9012_P0_D)\r
    TargetEntity : PresentSound #%(T_40_XXJ_WS_SOUNDNTITY_NAMEKEY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayEmote\r
@Tip = %(T_48_META_API_9503_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action NotifyPlayEmote = 9503 { #%(T_46_META_WS_PLAYEMOTE)\r
	@Tip = %(T_48_META_API_9503_P0_D)\r
    Player : PlayerOrNPC #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_9503_P1_D)\r
    EmoteType : AnimationClipID #%(T_46_META_WS_A_EMOTE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PauseEmote\r
@Tip = %(T_48_META_API_9504_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action NotifyPauseAnimation = 9504 { #%(T_46_META_WS_PAUSEEMOTE)\r
	@Tip = %(T_48_META_API_9504_P0_D)\r
    Player : PlayerOrNPC #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_9504_P1_D)\r
    IsPause : Bool #%(T_46_META_WS_A_ISPAUSE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=NotifyPlayEffect\r
@Tip = %(T_48_META_API_9500_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action NotifyPlayEffect = 9500 { #%(T_46_META_WS_NOTIFYPLAYEFFECT)\r
	@Tip = %(T_48_META_API_9500_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_9500_P1_D)\r
    ResPath : EffectType #%(T_46_META_WS_A_RESOURCE)\r
	@Tip = %(T_48_META_API_9500_P2_D)\r
    Color : Color #%(T_46_META_WS_A_COLOR)\r
	@Tip = %(T_48_META_API_9500_P3_D)\r
    Scale : Float #%(T_46_META_WS_A_SCALE)\r
	@Tip = %(T_48_META_API_9500_P4_D)\r
    BindEntity : entity #%(T_46_META_WS_A_FOLLOWTARGET)\r
	@Tip = %(T_48_META_API_9500_P5_D)\r
    Offset : Vector3 #%(T_46_META_WS_A_OFFSET)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=NotifyPlaySound\r
@Tip = %(T_48_META_API_9501_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action NotifyPlaySound = 9501 { #%(T_46_META_WS_NOTIFYPLAYSOUND)\r
	@Tip = %(T_48_META_API_9501_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_9501_P1_D)\r
    AudioType : AudioType #%(T_46_META_WS_A_RESOURCE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=NotifyShowTips\r
@Tip = %(T_48_META_API_9502_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action NotifyShowTips = 9502 { #%(T_46_META_WS_NOTIFYSHOWTIPS)\r
	@Tip = %(T_48_META_API_9502_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_9502_P1_D)\r
    Text : Object #%(T_46_META_WS_A_CONTENT)\r
	@Tip = %(T_48_META_API_9502_P2_D)\r
    Color : Color #%(T_46_META_WS_A_COLOR)\r
	@Tip = %(T_48_META_API_9502_P3_D)\r
    Duration : Int #%(T_46_META_WS_P_PHASEDURATION)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_10000_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_10000_R_D)\r
variable ThisEntity : Entity = 10000 { #%(T_47_XXJ_WS_THISENTITY)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_10001_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_10001_R_D)\r
variable FindEntityByID : Entity = 10001 { #%(T_48_META_API_10001)\r
	@Tip = %(T_48_META_API_10001_P0_D)\r
    EntityID : String #%(T_48_META_API_10001_P0)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_10002_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_10002_R_D)\r
variable GetGlobalEntity : Global = 10002 { #%(T_37_WZY_WS_GETGAMEENT_NAME)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=TeleportPlayer_Deprecated\r
@Tip = %(T_48_META_API_10003_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action TeleportPlayer = 10003 { #%(T_34_WT_WS_ENTITY25_NAME)\r
	@Tip = %(T_48_META_API_10003_P0_D)\r
    Player : Player #%(T_34_WT_WS_ENTITY7_PARAM1)\r
	@Tip = %(T_48_META_API_10003_P1_D)\r
    Pos : DirectedPoint #%(T_34_WT_WS_ENTITY13_PARAM2)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_144_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action BindCustomPlayer = 144 { #%(T_50_META_API_144)\r
	@Tip = %(T_50_META_API_144_P0_D)\r
    CustomPlayer : Entity #%(T_50_META_API_144_P0)\r
	@Tip = %(T_50_META_API_144_P1_D)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
	@Tip = %(T_51_META_API_144_P2_D)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_145_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action UnbindCustomPlayer = 145 { #%(T_50_META_API_145)\r
	@Tip = %(T_50_META_API_145_P0_D)\r
    BindedPlayer : Player #%(T_50_META_API_145_P0)\r
    out IsSuccess : Bool #IsSuccess\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_147_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
action SetCustomPlayerState = 147 { #%(T_50_META_API_147)\r
	@Tip = %(T_50_META_API_146_P0_D)\r
    CustomPlayer : Entity #%(T_50_META_API_147_P0)\r
	@Tip = %(T_50_META_API_147_P1_D)\r
    State : Int #%(T_50_META_API_147_P1)\r
	@Tip = %(T_51_META_API_144_P2_D)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_148_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
action GetCustomPlayerState = 148 { #%(T_50_META_API_148)\r
	@Tip = %(T_50_META_API_146_P0_D)\r
    CustomPlayer : Entity #%(T_50_META_API_148_P0)\r
	@Tip = %(T_51_META_API_144_P2_D)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
	@Tip = %(T_50_META_API_148_P1_D)\r
    out State : Int #%(T_50_META_API_148_P1)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetTeammateNearPos_Deprecated\r
@Tip = %(T_48_META_API_10004_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
@Return = %(T_48_META_API_10004_R_D)\r
variable GetTeammateNearPos : DirectedPoint = 10004 { #%(T_35_M_WS_GETTEAMMATEPOS)\r
	@Tip = %(T_48_META_API_10004_P0_D)\r
    Player : Player #%(T_34_WT_WS_ENTITY7_PARAM1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetOwner\r
@Tip = %(T_48_META_API_10005_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
@Return = %(T_48_META_API_10005_R_D)\r
variable GetEntityOwner : Player = 10005 { #%(T_46_META_WS_GETOWNER)\r
	@Tip = %(T_48_META_API_10005_P0_D)\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Teleport\r
@Tip = %(T_48_META_API_10056_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action TeleportPlayerPositionAndForward = 10056 { #%(T_46_META_WS_TELEPORT)\r
	@Tip = %(T_48_META_API_10056_P0_D)\r
    Player : PlayerOrVehicle #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_10056_P1_D)\r
    Pos : Vector3 #%(T_46_META_WS_A_POSITION)\r
	@Tip = %(T_48_META_API_10056_P2_D)\r
    Forward : Vector3 #%(T_46_META_WS_A_ROTATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetPositionNearTeammate\r
@Tip = %(T_48_META_API_10057_D)\r
@ModuleID=14\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
@Return = %(T_48_META_API_10057_R_D)\r
variable GetTeammateNearPosVec3 : Vector3 = 10057 { #%(T_46_META_WS_GETPOSITIONNEARTEAMMATE)\r
	@Tip = %(T_48_META_API_10057_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetRandomSpawnPos_Deprecated\r
@Tip = %(T_48_META_API_3002_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3002_R_D)\r
variable GetRandomSpawnPos : DirectedPoint = 3002 { #%(T_34_WT_WS_ENTITY18_NAME)\r
	@Tip = %(T_48_META_API_3002_P0_D)\r
    Player : Player #%(T_34_WT_WS_ENTITY7_PARAM1)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetPlayerScore_Deprecated\r
@Tip = %(T_48_META_API_3003_D)\r
@ModuleID=5\r
@ModuleLib=GameResult\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3003_R_D)\r
variable GetPlayerScoreByType : Int = 3003 { #%(T_34_WT_WS_ENTITY19_NAME)\r
	@Tip = %(T_48_META_API_3003_P0_D)\r
    Player : Player #%(T_34_WT_WS_ENTITY7_PARAM1)\r
	@Tip = %(T_48_META_API_3003_P1_D)\r
    ScoreType : ScoreType #%(T_34_WT_WS_ENTITY13_PARAM1)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=SetPlayerScore_Deprecated\r
@Tip = %(T_48_META_API_3004_D)\r
@ModuleID=5\r
@ModuleLib=GameResult\r
@ApiTarget=2\r
action SetPlayerScoreByType = 3004 { #%(T_38_WZY_WS_SETROUNDSCORE)\r
	@Tip = %(T_48_META_API_3004_P0_D)\r
    Player : Player #%(T_34_WT_WS_ENTITY7_PARAM1)\r
	@Tip = %(T_48_META_API_3004_P1_D)\r
    ScoreType : ScoreType #%(T_34_WT_WS_ENTITY13_PARAM1)\r
	@Tip = %(T_48_META_API_3004_P2_D)\r
    ScoreValue : Int #%(T_34_WT_WS_ENTITY20_PARAM3)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetTeamScore_Deprecated\r
@Tip = %(T_48_META_API_3005_D)\r
@ModuleID=5\r
@ModuleLib=GameResult\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3005_R_D)\r
variable GetTeamScoreByType : Int = 3005 { #%(T_34_WT_WS_ENTITY21_NAME)\r
	@Tip = %(T_48_META_API_3005_P0_D)\r
    Team : Team #%(T_34_WT_WS_ENTITY21_PARAM1)\r
	@Tip = %(T_48_META_API_3005_P1_D)\r
    ScoreType : ScoreType #%(T_34_WT_WS_ENTITY13_PARAM1)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=SetTeamScore_Deprecated\r
@Tip = %(T_48_META_API_3006_D)\r
@ModuleID=5\r
@ModuleLib=GameResult\r
@ApiTarget=2\r
action SetTeamScoreByType = 3006 { #%(T_34_WT_WS_ENTITY22_NAME)\r
	@Tip = %(T_48_META_API_3006_P0_D)\r
    Team : Team #%(T_34_WT_WS_ENTITY21_PARAM1)\r
	@Tip = %(T_48_META_API_3006_P1_D)\r
    ScoreType : ScoreType #%(T_34_WT_WS_ENTITY13_PARAM1)\r
	@Tip = %(T_48_META_API_3006_P2_D)\r
    ScoreValue : Int #%(T_34_WT_WS_ENTITY20_PARAM3)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetPlayerRoundScore_Deprecated\r
@Tip = %(T_48_META_API_3007_D)\r
@ModuleID=5\r
@ModuleLib=GameResult\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3007_R_D)\r
variable GetPlayerRoundScoreByType : Int = 3007 { #%(T_34_WT_WS_ENTITY23_NAME)\r
	@Tip = %(T_48_META_API_3007_P0_D)\r
    Player : Player #%(T_34_WT_WS_ENTITY7_PARAM1)\r
	@Tip = %(T_48_META_API_3007_P1_D)\r
    RoundIndex : Int #%(T_34_WT_WS_ENTITY23_PARAM2)\r
	@Tip = %(T_48_META_API_3007_P2_D)\r
    ScoreType : ScoreType #%(T_34_WT_WS_ENTITY13_PARAM1)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetTeamRoundScore_Deprecated\r
@Tip = %(T_48_META_API_3008_D)\r
@ModuleID=5\r
@ModuleLib=GameResult\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3008_R_D)\r
variable GetTeamRoundScoreByType : Int = 3008 { #%(T_34_WT_WS_ENTITY24_NAME)\r
	@Tip = %(T_48_META_API_3008_P0_D)\r
    Team : Team #%(T_34_WT_WS_ENTITY21_PARAM1)\r
	@Tip = %(T_48_META_API_3008_P1_D)\r
    RoundIndex : Int #%(T_34_WT_WS_ENTITY23_PARAM2)\r
	@Tip = %(T_48_META_API_3008_P2_D)\r
    ScoreType : ScoreType #%(T_34_WT_WS_ENTITY13_PARAM1)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetPlayerRank_Deprecated\r
@Tip = %(T_48_META_API_3009_D)\r
@ModuleID=7\r
@ModuleLib=GameResult\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3009_R_D)\r
variable GetPlayerRank : Int = 3009 { #%(T_40_XXJ_WS_GETPLAYERRANK)\r
	@Tip = %(T_48_META_API_3009_P0_D)\r
    Player : Player #%(T_34_WT_WS_ENTITY7_PARAM1)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetTeamRank_Deprecated\r
@Tip = %(T_48_META_API_3011_D)\r
@ModuleID=7\r
@ModuleLib=GameResult\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3011_R_D)\r
variable GetTeamRank : Int = 3011 { #%(T_40_XXJ_WS_GETTEAMRANK)\r
	@Tip = %(T_48_META_API_3011_P0_D)\r
    Team : Team #Team\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetPlayerRoundRank_Deprecated\r
@Tip = %(T_48_META_API_3013_D)\r
@ModuleID=7\r
@ModuleLib=GameResult\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3013_R_D)\r
variable GetPlayerRoundRank : Int = 3013 { #%(T_40_XXJ_WS_GETPLAYERROUNDRANK)\r
	@Tip = %(T_48_META_API_3013_P0_D)\r
    Player : Player #%(T_34_WT_WS_ENTITY7_PARAM1)\r
	@Tip = %(T_48_META_API_3013_P1_D)\r
    RoundIndex : Int #%(T_34_T_WS_BLOCK3_PARAM1_NAME)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetTeamRoundRank_Deprecated\r
@Tip = %(T_48_META_API_3014_D)\r
@ModuleID=7\r
@ModuleLib=GameResult\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3014_R_D)\r
variable GetTeamRoundRank : Int = 3014 { #%(T_40_XXJ_WS_GETTEAMROUNDRANK)\r
	@Tip = %(T_48_META_API_3014_P0_D)\r
    Team : Team #Team\r
	@Tip = %(T_48_META_API_3014_P1_D)\r
    RoundIndex : Int #%(T_34_T_WS_BLOCK3_PARAM1_NAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetRandomSpawnPosition\r
@Tip = %(T_48_META_API_3041_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3041_R_D)\r
variable GetRandomSpawnPosVec3 : Vector3 = 3041 { #%(T_46_META_WS_GETRANDOMSPAWNPOSITION)\r
	@Tip = %(T_48_META_API_3041_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CheckTriggerByOrder\r
@Tip = %(T_48_META_API_3207_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3207_R_D)\r
variable PlayerCheckCanTriggerLevelObjectByOrder : Bool = 3207 { #%(T_46_META_WS_CHECKTRIGGERBYORDER)\r
	@Tip = %(T_48_META_API_3207_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3207_P1_D)\r
    LevelObject : LevelObject #%(T_46_META_WS_A_TRIGGER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=InfectionZombieGrowUp\r
@Tip = %(T_48_META_API_3208_D)\r
@ModuleID=10009\r
@ModuleLib=Other\r
@ApiTarget=2\r
action InfectionZombieGrowUp = 3208 { #%(T_46_META_WS_INFECTIONZOMBIEGROWUP)\r
	@Tip = %(T_48_META_API_3208_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DealDamage\r
@Tip = %(T_48_META_API_10008_D)\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@ApiTarget=2\r
action EntityTakeDamage = 10008 { #%(T_46_META_WS_DEALDAMAGE)\r
	@Tip = %(T_48_META_API_10008_P0_D)\r
    DamageTaker : FightingEntity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_10008_P1_D)\r
    DamageMaker : FightingEntity #%(T_46_META_WS_A_ATTACKER)\r
	@Tip = %(T_48_META_API_10008_P2_D)\r
    DamageType : DamageType #%(T_46_META_WS_A_TYPE)\r
	@Tip = %(T_48_META_API_10008_P3_D)\r
    DamageValue : Int #%(T_46_META_WS_A_DAMAGE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=Revive\r
@Tip = %(T_48_META_API_10009_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action RevivePlayer = 10009 { #%(T_46_META_WS_REVIVE)\r
	@Tip = %(T_48_META_API_10009_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddItemInScene\r
@Tip = %(T_48_META_API_10010_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action AddPickUpAtPosition = 10010 { #%(T_46_META_WS_ADDITEMINSCENE)\r
	@Tip = %(T_48_META_API_10010_P0_D)\r
    Position : Vector3 #%(T_46_META_WS_A_POSITION)\r
	@Tip = %(T_48_META_API_10010_P1_D)\r
    ItemIds : IntOrListInt #%(T_46_META_WS_A_ITEMS)\r
	@Tip = %(T_48_META_API_10010_P2_D)\r
    ItemCounts : IntOrListInt #%(T_46_META_WS_A_COUNTS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Contain\r
@Tip = %(T_48_META_API_1520_D)\r
@ModuleID=10001\r
@ModuleLib=List\r
@Return = %(T_48_META_API_1520_R_D)\r
variable ListContains : Bool = 1520 { #%(T_46_META_WS_CONTAIN)\r
	@Tip = %(T_48_META_API_1520_P0_D)\r
    ListValue : List #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1520_P1_D)\r
    ElementValue : Object #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AppendRange\r
@Tip = %(T_48_META_API_1521_D)\r
@ModuleID=10001\r
@ModuleLib=List\r
action ListAppendRange = 1521 { #%(T_46_META_WS_APPENDRANGE)\r
	@Tip = %(T_48_META_API_1521_P0_D)\r
    ListValue : List #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1521_P1_D)\r
    ContentList : List #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Remove\r
@Tip = %(T_48_META_API_1522_D)\r
@ModuleID=10001\r
@ModuleLib=List\r
action ListRemove = 1522 { #%(T_46_META_WS_DELETE)\r
	@Tip = %(T_48_META_API_1522_P0_D)\r
    ListValue : List #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1522_P1_D)\r
    ElementValue : Object #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IndexOf\r
@Tip = %(T_48_META_API_1523_D)\r
@ModuleID=10001\r
@ModuleLib=List\r
@Return = %(T_48_META_API_1523_R_D)\r
variable ListIndexOf : Int = 1523 { #%(T_46_META_WS_INDEXOF)\r
	@Tip = %(T_48_META_API_1523_P0_D)\r
    ListValue : List #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1523_P1_D)\r
    ElementValue : Object #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LastIndexOf\r
@Tip = %(T_48_META_API_1524_D)\r
@ModuleID=10001\r
@ModuleLib=List\r
@Return = %(T_48_META_API_1524_R_D)\r
variable ListLastIndexOf : Int = 1524 { #%(T_46_META_WS_LASTINDEXOF)\r
	@Tip = %(T_48_META_API_1524_P0_D)\r
    ListValue : List #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1524_P1_D)\r
    ElementValue : Object #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetInvincibility\r
@Tip = %(T_48_META_API_10006_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action SetGodState = 10006 { #%(T_46_META_WS_SETINVINCIBILITY)\r
	@Tip = %(T_48_META_API_10006_P0_D)\r
    TargetEntity : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_10006_P1_D)\r
    Duration : Int #%(T_46_META_WS_A_DURATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Clone\r
@Tip = %(T_48_META_API_10007_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action CloneEntity = 10007 { #%(T_46_META_WS_CLONE)\r
	@Tip = %(T_48_META_API_10007_P0_D)\r
    out EntityVarName : Entity #%(T_46_META_WS_A_CREATEDENTITY)\r
	@Tip = %(T_48_META_API_10007_P1_D)\r
    EntityToClone : entity #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EnableDefaultBTree\r
@Tip = %(T_48_META_API_3209_D)\r
@ModuleID=10008\r
@ModuleLib=AI\r
@ApiTarget=2\r
action EnableDefaultAI = 3209 { #%(T_46_META_WS_ENABLEDEFAULTBTREE)\r
	@Tip = %(T_48_META_API_3209_P0_D)\r
    AITarget : AI #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3209_P1_D)\r
    AIEnable : Bool #%(T_46_META_WS_A_ENABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PursuitTarget\r
@Tip = %(T_48_META_API_3210_D)\r
@ModuleID=10008\r
@ModuleLib=AI\r
@ApiTarget=2\r
action AIAttackEntity = 3210 { #%(T_46_META_WS_PURSUITTARGET)\r
	@Tip = %(T_48_META_API_3210_P0_D)\r
    AITarget : AI #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3210_P1_D)\r
    TargetEntity : FightingEntity #%(T_46_META_WS_A_PURSUITTARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AttackTarget\r
@Tip = %(T_48_META_API_3226_D)\r
@ModuleID=10008\r
@ModuleLib=AI\r
@ApiTarget=2\r
action AIRealAttackEntity = 3226 { #%(T_46_META_WS_ATTACKTARGET)\r
	@Tip = %(T_48_META_API_3226_P0_D)\r
    AITarget : AI #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3226_P1_D)\r
    TargetEntity : FightingEntity #%(T_46_META_WS_A_ATTACKTARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SwitchWeapon\r
@Tip = %(T_48_META_API_3227_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action SwitchWeaponBySlot = 3227 { #%(T_46_META_WS_SWITCHWEAPON)\r
	@Tip = %(T_48_META_API_3227_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3227_P1_D)\r
    Slot : SwitchWeaponEquipSlot #%(T_46_META_WS_A_SLOT)\r
	@Tip = %(T_48_META_API_3227_P2_D)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=DestroyEquipment_Deprecated\r
@Tip = %(T_48_META_API_3211_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action DestroyEquipment = 3211 { #%(T_36_WZY_WS_DESTITEM_NAME)\r
	@Tip = %(T_48_META_API_3211_P0_D)\r
    Player : Player #%(T_34_WT_WS_ENTITY7_PARAM1)\r
	@Tip = %(T_48_META_API_3211_P1_D)\r
    ItemType : InventoryType #%(T_34_WT_WS_ENTITY13_PARAM1)\r
	@Tip = %(T_48_META_API_3211_P2_D)\r
    SlotType : EquipSlotType #%(T_13_R_PVE_WEAPON_SLOT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DestroyEquipment\r
@Tip = %(T_48_META_API_3218_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action DestroyEquipmentBySlot = 3218 { #%(T_46_META_WS_DESTROYEQUIPMENT)\r
	@Tip = %(T_48_META_API_3218_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3218_P1_D)\r
    SlotType : EquipSlotType #%(T_46_META_WS_A_SLOT)\r
	@Tip = %(T_48_META_API_3218_P2_D)\r
    Count : Int #%(T_46_META_WS_A_COUNT)\r
	@Tip = %(T_48_META_API_3218_P3_D)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PatrolTo\r
@Tip = %(T_48_META_API_10011_D)\r
@ModuleID=10008\r
@ModuleLib=AI\r
@ApiTarget=2\r
action PatrolTo = 10011 { #%(T_46_META_WS_PATROLTO)\r
	@Tip = %(T_48_META_API_10011_P0_D)\r
    TargetEntity : AI #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_10011_P1_D)\r
    Target : Vector3 #%(T_46_META_WS_A_POSITION)\r
	@Tip = %(T_48_META_API_10011_P2_D)\r
    ComeBack : Bool #%(T_46_META_WS_A_COMEBACK)\r
	@Tip = %(T_48_META_API_10011_P3_D)\r
    Style : PatrolStyleType #%(T_46_META_WS_A_STYLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PatrolAlong\r
@Tip = %(T_48_META_API_10012_D)\r
@ModuleID=10008\r
@ModuleLib=AI\r
@ApiTarget=2\r
action PatrolAlong = 10012 { #%(T_46_META_WS_PATROLALONG)\r
	@Tip = %(T_48_META_API_10012_P0_D)\r
    TargetEntity : AI #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_10012_P1_D)\r
    Points : ListT_Vector3 #%(T_46_META_WS_A_POSITIONS)\r
	@Tip = %(T_48_META_API_10012_P2_D)\r
    PatrolType : PatrolType #%(T_46_META_WS_A_COMEBACK)\r
	@Tip = %(T_48_META_API_10012_P3_D)\r
    Style : PatrolStyleType #%(T_46_META_WS_A_STYLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SpawnNextWave\r
@Tip = %(T_48_META_API_10013_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action RefreshSpawnableEntity = 10013 { #%(T_46_META_WS_SPAWNNEXTWAVE)\r
	@Tip = %(T_48_META_API_10013_P0_D)\r
    TargetEntity : SpawnableEntity #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetType\r
@Tip = %(T_48_META_API_1016_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=0\r
@Return = %(T_48_META_API_1016_R_D)\r
variable GetType : Type = 1016 { #%(T_46_META_WS_GETTYPE)\r
	@Tip = %(T_48_META_API_1016_P0_D)\r
    Variable : Object #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TypeIs\r
@Tip = %(T_48_META_API_1017_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=0\r
@Return = %(T_48_META_API_1017_R_D)\r
variable TypeIs : Bool = 1017 { #%(T_46_META_WS_TYPEIS)\r
	@Tip = %(T_48_META_API_1017_P0_D)\r
    Variable : Object #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1017_P1_D)\r
    CompareType : Type #%(T_46_META_WS_A_TYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IsSubTypeOf\r
@Tip = %(T_48_META_API_1018_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=0\r
@Return = %(T_48_META_API_1018_R_D)\r
variable IsSubClassOf : Bool = 1018 { #%(T_46_META_WS_ISSUBTYPEOF)\r
	@Tip = %(T_48_META_API_1018_P0_D)\r
    Variable : Object #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1018_P1_D)\r
    CompareType : Type #%(T_46_META_WS_A_TYPE)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_34_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_34_R_D)\r
variable HasComponent : Bool = 34 { #%(T_46_META_WS_HASCOMPONENT)\r
	@Tip = %(T_48_META_API_34_P0_D)\r
    @optional\r
    Target : entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_34_P1_D)\r
    TypeID : Type #%(T_46_META_WS_A_COMPONENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DispatchEvent\r
@Tip = %(T_48_META_API_1019_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action DispatchCustomEvent = 1019 { #%(T_46_META_WS_DISPATCHEVENT)\r
	@Tip = %(T_48_META_API_1019_P0_D)\r
    EventID : EventID #%(T_46_META_WS_A_EVENTID)\r
	@Tip = %(T_48_META_API_1019_P1_D)\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1019_P2_D)\r
    Params : List #%(T_46_META_WS_A_PARAMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddFormulaPropertyFactor\r
@Tip = %(T_48_META_API_10014_D)\r
@ModuleID=18\r
@ModuleLib=PropertyFormula\r
@ApiTarget=2\r
action ModifyPropertyFactor = 10014 { #%(T_46_META_WS_ADDFORMULAPROPERTYFACTOR)\r
	@Tip = %(T_48_META_API_10014_P0_D)\r
    TargetEntity : FormulableEntity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_10014_P1_D)\r
    PropertyID : Property #%(T_46_META_WS_A_PROPERTYID)\r
	@Tip = %(T_48_META_API_10014_P2_D)\r
    FactorType : FormulaFactorType #%(T_46_META_WS_A_FACTORTYPE)\r
	@Tip = %(T_48_META_API_10014_P3_D)\r
    Value : Float #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=11\r
@ScriptName=ClearPropertyFactor_Deprecated\r
@Tip = %(T_48_META_API_10015_D)\r
@ModuleID=18\r
@ModuleLib=PropertyFormula\r
@ApiTarget=2\r
action ClearPropertyFactor = 10015 { #%(T_38_WZY_WS_CLEARPRO)\r
	@Tip = %(T_48_META_API_10015_P0_D)\r
    TargetEntity : FormulableEntity #%(T_34_M_WS_ENTITY)\r
	@Tip = %(T_48_META_API_10015_P1_D)\r
    PropertyID : Property #%(T_36_WZY_WS_FORMUFACT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ClearFormulaPropertyFactor\r
@Tip = %(T_48_META_API_10016_D)\r
@ModuleID=18\r
@ModuleLib=PropertyFormula\r
@ApiTarget=2\r
action ClearAllPropertyFactor = 10016 { #%(T_46_META_WS_CLEARFORMULAPROPERTYFACTOR)\r
	@Tip = %(T_48_META_API_10016_P0_D)\r
    TargetEntity : FormulableEntity #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetFormulaPropertyRelative\r
@Tip = %(T_48_META_API_10017_D)\r
@ModuleID=18\r
@ModuleLib=PropertyFormula\r
@ApiTarget=2\r
action ModifyFormulaProperty = 10017 { #%(T_46_META_WS_SETFORMULAPROPERTYRELATIVE)\r
	@Tip = %(T_48_META_API_10017_P0_D)\r
    TargetEntity : FormulableEntity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_10017_P1_D)\r
    PropertyID : Property #%(T_46_META_WS_A_PROPERTY)\r
	@Tip = %(T_48_META_API_10017_P2_D)\r
    ModifyType : PropertyModifyType #%(T_46_META_WS_A_MODIFYTYPE)\r
	@Tip = %(T_48_META_API_10017_P3_D)\r
    Value : Float #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetFormulaPropertyAbsolute\r
@Tip = %(T_48_META_API_10018_D)\r
@ModuleID=18\r
@ModuleLib=PropertyFormula\r
@ApiTarget=2\r
action SetFormulaProperty = 10018 { #%(T_46_META_WS_SETFORMULAPROPERTYABSOLUTE)\r
	@Tip = %(T_48_META_API_10018_P0_D)\r
    TargetEntity : FormulableEntity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_10018_P1_D)\r
    PropertyID : Property #%(T_46_META_WS_A_PROPERTY)\r
	@Tip = %(T_48_META_API_10018_P2_D)\r
    Value : Float #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveFormulaPropertyFactor\r
@Tip = %(T_48_META_API_10019_D)\r
@ModuleID=18\r
@ModuleLib=PropertyFormula\r
@ApiTarget=2\r
action ClearSingleFormulaProperty = 10019 { #%(T_46_META_WS_REMOVEFORMULAPROPERTYFACTOR)\r
	@Tip = %(T_48_META_API_10019_P0_D)\r
    TargetEntity : FormulableEntity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_10019_P1_D)\r
    PropertyID : Property #%(T_46_META_WS_A_PROPERTY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetWallet\r
@Tip = %(T_48_META_API_3015_D)\r
@ModuleID=20\r
@ModuleLib=Economy\r
@ApiTarget=2\r
action TryGetWalletIDByEntity = 3015 { #%(T_46_META_WS_GETWALLET)\r
	@Tip = %(T_48_META_API_3015_P0_D)\r
    OwnerEntity : entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3015_P1_D)\r
    out IsExistVarName : Bool #%(T_46_META_WS_A_ISEXIST)\r
	@Tip = %(T_48_META_API_3015_P2_D)\r
    out WalletVarName : Wallet #%(T_46_META_WS_A_WALLET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateWallet\r
@Tip = %(T_48_META_API_3016_D)\r
@ModuleID=20\r
@ModuleLib=Economy\r
@ApiTarget=2\r
action NewWalletForEntity = 3016 { #%(T_46_META_WS_CREATEWALLET)\r
	@Tip = %(T_48_META_API_3016_P0_D)\r
    @optional\r
    OwnerUser : Player #%(T_46_META_WS_A_OWNER)\r
	@Tip = %(T_48_META_API_3016_P1_D)\r
    OwnerEntity : Entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3016_P2_D)\r
    out WalletVarName : Wallet #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddMoney\r
@Tip = %(T_48_META_API_3017_D)\r
@ModuleID=20\r
@ModuleLib=Economy\r
@ApiTarget=2\r
action IncreaseMoneyForWallet = 3017 { #%(T_46_META_WS_ADDMONEY)\r
	@Tip = %(T_48_META_API_3017_P0_D)\r
    @optional\r
    WalletEntity : Wallet #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3017_P1_D)\r
    MoneyType : MoneyType #%(T_46_META_WS_A_MONEYTYPE)\r
	@Tip = %(T_48_META_API_3017_P2_D)\r
    Count : Float #%(T_46_META_WS_A_COUNT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CostMoney\r
@Tip = %(T_48_META_API_3018_D)\r
@ModuleID=20\r
@ModuleLib=Economy\r
@ApiTarget=2\r
action DecreaseMoneyForWallet = 3018 { #%(T_46_META_WS_COSTMONEY)\r
	@Tip = %(T_48_META_API_3018_P0_D)\r
    @optional\r
    WalletEntity : Wallet #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3018_P1_D)\r
    MoneyType : MoneyType #%(T_46_META_WS_A_MONEYTYPE)\r
	@Tip = %(T_48_META_API_3018_P2_D)\r
    Count : Float #%(T_46_META_WS_A_COUNT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TransferMoney\r
@Tip = %(T_48_META_API_3019_D)\r
@ModuleID=20\r
@ModuleLib=Economy\r
@ApiTarget=2\r
action TransferMoneyForWallet = 3019 { #%(T_46_META_WS_TRANSFERMONEY)\r
	@Tip = %(T_48_META_API_3019_P0_D)\r
    @optional\r
    OutWalletEntity : Wallet #%(T_46_META_WS_A_OUTWALLET)\r
	@Tip = %(T_48_META_API_3019_P1_D)\r
    MoneyType : MoneyType #%(T_46_META_WS_A_MONEYTYPE)\r
	@Tip = %(T_48_META_API_3019_P2_D)\r
    Count : Float #%(T_46_META_WS_A_COUNT)\r
	@Tip = %(T_48_META_API_3019_P3_D)\r
    @optional\r
    InWalletEntity : Wallet #%(T_46_META_WS_A_INWALLET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetMoneyCount\r
@Tip = %(T_48_META_API_3020_D)\r
@ModuleID=20\r
@ModuleLib=Economy\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3020_R_D)\r
variable GetMoneyCountByWallet : Float = 3020 { #%(T_46_META_WS_GETMONEYCOUNT)\r
	@Tip = %(T_48_META_API_3020_P0_D)\r
    @optional\r
    WalletEntity : Wallet #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3020_P1_D)\r
    MoneyType : MoneyType #%(T_46_META_WS_A_MONEYTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetMoney\r
@Tip = %(T_48_META_API_3021_D)\r
@ModuleID=20\r
@ModuleLib=Economy\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3021_R_D)\r
variable GetMoneyEntityByWallet : Money = 3021 { #%(T_46_META_WS_GETMONEY)\r
	@Tip = %(T_48_META_API_3021_P0_D)\r
    @optional\r
    WalletEntity : Wallet #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3021_P1_D)\r
    MoneyType : MoneyType #%(T_46_META_WS_A_MONEYTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetAllShops\r
@Tip = %(T_48_META_API_3022_D)\r
@ModuleID=19\r
@ModuleLib=Economy\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3022_R_D)\r
variable GetAllShops : ListT_Shop = 3022 { #%(T_46_META_WS_GETALLSHOPS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetChatChannel\r
@Tip = %(T_48_META_API_3027_D)\r
@ModuleID=24\r
@ModuleLib=ChatChannel\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3027_R_D)\r
variable GetFreeChatChannel : ChatChannel = 3027 { #%(T_46_META_WS_GETCHATCHANNEL)\r
	@Tip = %(T_48_META_API_3027_P0_D)\r
    FreeChatChannel : FreeChatChannel #%(T_46_META_WS_A_INDEX)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetCurrentChatChannel\r
@Tip = %(T_48_META_API_3028_D)\r
@ModuleID=24\r
@ModuleLib=ChatChannel\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3028_R_D)\r
variable GetChatChannel : ChatChannel = 3028 { #%(T_46_META_WS_GETCURRENTCHATCHANNEL)\r
	@Tip = %(T_48_META_API_3028_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=JoinChatChannel\r
@Tip = %(T_48_META_API_3029_D)\r
@ModuleID=24\r
@ModuleLib=ChatChannel\r
@ApiTarget=2\r
action JoinChatChannel = 3029 { #%(T_46_META_WS_JOINCHATCHANNEL)\r
	@Tip = %(T_48_META_API_3029_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3029_P1_D)\r
    ChatChannel : ChatChannel #%(T_46_META_WS_A_CHANNEL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=QuitChatChannel\r
@Tip = %(T_48_META_API_3030_D)\r
@ModuleID=24\r
@ModuleLib=ChatChannel\r
@ApiTarget=2\r
action LeaveChatChannel = 3030 { #%(T_46_META_WS_QUITCHATCHANNEL)\r
	@Tip = %(T_48_META_API_3030_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IsChatChannelEmpty\r
@Tip = %(T_48_META_API_3031_D)\r
@ModuleID=24\r
@ModuleLib=ChatChannel\r
@ApiTarget=2\r
action IsChatChannelEmpty = 3031 { #%(T_46_META_WS_ISCHATCHANNELEMPTY)\r
	@Tip = %(T_48_META_API_3031_P0_D)\r
    ChatChannel : ChatChannel #%(T_46_META_WS_A_CHANNEL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetBehaviorStatus\r
@Tip = %(T_48_META_API_3032_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action SetPlayerBehaviorStatus = 3032 { #%(T_46_META_WS_SETBEHAVIORSTATUS)\r
	@Tip = %(T_48_META_API_3032_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3032_P1_D)\r
    PlayerBehaviorType : PlayerBehaviorType #%(T_46_META_WS_A_TYPE)\r
	@Tip = %(T_48_META_API_3032_P2_D)\r
    PlayerBehaviorStatus : PlayerBehaviorStatus #%(T_46_META_WS_A_STATUS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ToString\r
@Tip = %(T_48_META_API_7_D)\r
@ModuleID=10005\r
@ModuleLib=Convert\r
@Return = %(T_48_META_API_7_R_D)\r
variable ToString : String = 7 { #%(T_46_META_WS_TOSTRING)\r
	@Tip = %(T_48_META_API_7_P0_D)\r
    TargetValue : Object #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=NumToString\r
@Tip = %(T_48_META_API_1549_D)\r
@ModuleID=10005\r
@ModuleLib=Convert\r
@Return = %(T_48_META_API_1549_R_D)\r
variable NumToString : String = 1549 { #%(T_46_META_WS_NUMTOSTRING)\r
	@Tip = %(T_48_META_API_1549_P0_D)\r
    Value : Number #%(T_46_META_WS_A_VALUE)\r
	@Tip = %(T_48_META_API_1549_P1_D)\r
    Format : String #%(T_46_META_WS_A_STYLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LoadScene\r
@Tip = %(T_48_META_API_100_D)\r
@ModuleID=10012\r
@ModuleLib=Scene\r
@ApiTarget=2\r
action LoadScene = 100 { #%(T_46_META_WS_LOADSCENE)\r
	@Tip = %(T_48_META_API_100_P0_D)\r
    SceneGUID : String #%(T_46_META_WS_A_SCENEID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SwitchArea\r
@Tip = %(T_48_META_API_104_D)\r
@ModuleID=10012\r
@ModuleLib=Scene\r
@ApiTarget=2\r
action SwitchPlayerArea = 104 { #%(T_46_META_WS_SWITCHAREA)\r
	@Tip = %(T_48_META_API_104_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_104_P1_D)\r
    SceneGUID : String #%(T_46_META_WS_A_SCENEID)\r
	@Tip = %(T_48_META_API_104_P2_D)\r
    Position : Vector3 #%(T_46_META_WS_A_POSITION)\r
	@Tip = %(T_48_META_API_104_P3_D)\r
    EulerAngles : Vector3 #%(T_46_META_WS_A_FORWARD)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UnloadScene\r
@Tip = %(T_48_META_API_101_D)\r
@ModuleID=10012\r
@ModuleLib=Scene\r
@ApiTarget=2\r
action UnloadScene = 101 { #%(T_46_META_WS_UNLOADSCENE)\r
	@Tip = %(T_48_META_API_101_P0_D)\r
    SceneGUID : String #%(T_46_META_WS_A_SCENEID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SwitchScene\r
@Tip = %(T_48_META_API_102_D)\r
@ModuleID=10012\r
@ModuleLib=Scene\r
@ApiTarget=2\r
action SwitchScene = 102 { #%(T_46_META_WS_SWITCHSCENE)\r
	@Tip = %(T_48_META_API_102_P0_D)\r
    SceneGUID : String #%(T_46_META_WS_A_SCENEID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetMapID\r
@Tip = %(T_48_META_API_49_D)\r
@ModuleID=10012\r
@ModuleLib=Scene\r
@ApiTarget=2\r
@Return = %(T_48_META_API_49_R_D)\r
variable GetMapID : Int = 49 { #%(T_46_META_WS_GETMAPID)\r
	@Tip = %(T_48_META_API_49_P0_D)\r
    SceneGUID : String #%(T_46_META_WS_A_SCENEID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Clear\r
@Tip = %(T_48_META_API_1055_D)\r
@ModuleID=10001\r
@ModuleLib=List\r
action ListClear = 1055 { #%(T_46_META_WS_CLEAR)\r
	@Tip = %(T_48_META_API_1055_P0_D)\r
    ListValue : List #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Reverse\r
@Tip = %(T_48_META_API_1056_D)\r
@ModuleID=10001\r
@ModuleLib=List\r
action ListReverse = 1056 { #%(T_46_META_WS_REVERSE)\r
	@Tip = %(T_48_META_API_1056_P0_D)\r
    ListValue : List #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Clone\r
@Tip = %(T_48_META_API_1057_D)\r
@ModuleID=10001\r
@ModuleLib=List\r
@Return = %(T_48_META_API_1057_R_D)\r
variable ListClone : List = 1057 { #%(T_46_META_WS_CLONE)\r
	@Tip = %(T_48_META_API_1057_P0_D)\r
    ListValue : List #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Insert\r
@Tip = %(T_48_META_API_1058_D)\r
@ModuleID=10001\r
@ModuleLib=List\r
action ListInsert = 1058 { #%(T_46_META_WS_INSERT)\r
	@Tip = %(T_48_META_API_1058_P0_D)\r
    ListValue : List #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1058_P1_D)\r
    Index : Int #%(T_46_META_WS_A_INDEX)\r
	@Tip = %(T_48_META_API_1058_P2_D)\r
    ElementValue : Object #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Shuffle\r
@Tip = %(T_48_META_API_1059_D)\r
@ModuleID=10001\r
@ModuleLib=List\r
action ListShuffle = 1059 { #%(T_46_META_WS_SHUFFLE)\r
	@Tip = %(T_48_META_API_1059_P0_D)\r
    ListValue : List #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IsEqual\r
@Tip = %(T_48_META_API_1077_D)\r
@ModuleID=10001\r
@ModuleLib=List\r
@Return = %(T_48_META_API_1077_R_D)\r
variable ListIsEqual : Bool = 1077 { #%(T_46_META_WS_ISEQUAL)\r
	@Tip = %(T_48_META_API_1077_P0_D)\r
    LeftValue : List #%(T_46_META_WS_A_LEFTVALUE)\r
	@Tip = %(T_48_META_API_1077_P1_D)\r
    RightValue : List #%(T_46_META_WS_A_RIGHTVALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Replace\r
@Tip = %(T_48_META_API_1074_D)\r
@ModuleID=10004\r
@ModuleLib=Strings\r
@Return = %(T_48_META_API_1074_R_D)\r
variable StrReplace : String = 1074 { #%(T_46_META_WS_REPLACE)\r
	@Tip = %(T_48_META_API_1074_P0_D)\r
    SrcValue : String #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1074_P1_D)\r
    OldValue : String #%(T_46_META_WS_A_OLDVALUE)\r
	@Tip = %(T_48_META_API_1074_P2_D)\r
    NewValue : String #%(T_46_META_WS_A_NEWVALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Find\r
@Tip = %(T_48_META_API_1075_D)\r
@ModuleID=10004\r
@ModuleLib=Strings\r
@Return = %(T_48_META_API_1075_R_D)\r
variable StrFind : Int = 1075 { #%(T_46_META_WS_FIND)\r
	@Tip = %(T_48_META_API_1075_P0_D)\r
    SrcValue : String #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1075_P1_D)\r
    FindValue : String #%(T_46_META_WS_A_FINDVALUE)\r
	@Tip = %(T_48_META_API_1075_P2_D)\r
    StartIndex : Int #%(T_46_META_WS_A_STARTINDEX)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Sub\r
@Tip = %(T_48_META_API_1076_D)\r
@ModuleID=10004\r
@ModuleLib=Strings\r
@Return = %(T_48_META_API_1076_R_D)\r
variable StrSub : String = 1076 { #%(T_46_META_WS_SUB)\r
	@Tip = %(T_48_META_API_1076_P0_D)\r
    SrcValue : String #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1076_P1_D)\r
    StartIndex : Int #%(T_46_META_WS_A_STARTINDEX)\r
	@Tip = %(T_48_META_API_1076_P2_D)\r
    Length : Int #%(T_46_META_WS_A_LENGTH)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Split\r
@Tip = %(T_48_META_API_1078_D)\r
@ModuleID=10004\r
@ModuleLib=Strings\r
@Return = %(T_48_META_API_1078_R_D)\r
variable SplitString : ListT_String = 1078 { #%(T_46_META_WS_SPLIT)\r
	@Tip = %(T_48_META_API_1078_P0_D)\r
    SrcValue : String #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1078_P1_D)\r
    SepStr : String #%(T_46_META_WS_A_SEPSTR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=FindAt\r
@Tip = %(T_48_META_API_1079_D)\r
@ModuleID=10004\r
@ModuleLib=Strings\r
@Return = %(T_48_META_API_1079_R_D)\r
variable StringFindAt : String = 1079 { #%(T_46_META_WS_FINDAT)\r
	@Tip = %(T_48_META_API_1079_P0_D)\r
    SrcValue : String #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1079_P1_D)\r
    IndexList : ListT_Int #%(T_46_META_WS_A_INDEXS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ToUpper\r
@Tip = %(T_48_META_API_1080_D)\r
@ModuleID=10004\r
@ModuleLib=Strings\r
@Return = %(T_48_META_API_1080_R_D)\r
variable StringUpper : String = 1080 { #%(T_46_META_WS_TOUPPER)\r
	@Tip = %(T_48_META_API_1080_P0_D)\r
    SrcValue : String #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ToLower\r
@Tip = %(T_48_META_API_1081_D)\r
@ModuleID=10004\r
@ModuleLib=Strings\r
@Return = %(T_48_META_API_1081_R_D)\r
variable StringLower : String = 1081 { #%(T_46_META_WS_TOLOWER)\r
	@Tip = %(T_48_META_API_1081_P0_D)\r
    SrcValue : String #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Strip\r
@Tip = %(T_48_META_API_1082_D)\r
@ModuleID=10004\r
@ModuleLib=Strings\r
@Return = %(T_48_META_API_1082_R_D)\r
variable StringStrip : String = 1082 { #%(T_46_META_WS_STRIP)\r
	@Tip = %(T_48_META_API_1082_P0_D)\r
    SrcValue : String #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Join\r
@Tip = %(T_48_META_API_1083_D)\r
@ModuleID=10004\r
@ModuleLib=Strings\r
@Return = %(T_48_META_API_1083_R_D)\r
variable StringJoin : String = 1083 { #%(T_46_META_WS_JOIN)\r
	@Tip = %(T_48_META_API_1083_P0_D)\r
    StrElems : ListT_String #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1083_P1_D)\r
    SepStr : String #%(T_46_META_WS_A_SEP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=FilterEntity\r
@Tip = %(T_48_META_API_10020_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
@Return = %(T_48_META_API_10020_R_D)\r
variable FilterEntities : ListT_Entity = 10020 { #%(T_46_META_WS_FILTERENTITY)\r
	@Tip = %(T_48_META_API_10020_P0_D)\r
    Has : TypeOrListType #%(T_46_META_WS_A_MUST)\r
	@Tip = %(T_48_META_API_10020_P1_D)\r
    Not : TypeOrListType #%(T_46_META_WS_A_NOT)\r
	@Tip = %(T_48_META_API_10020_P2_D)\r
    Any : TypeOrListType #%(T_46_META_WS_A_ANY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetJersey\r
@Tip = %(T_48_META_API_3212_D)\r
@ModuleID=10006\r
@ModuleLib=Football\r
@ApiTarget=2\r
action ChangeCustomizeClothes = 3212 { #%(T_46_META_WS_SETJERSEY)\r
	@Tip = %(T_48_META_API_3212_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3212_P1_D)\r
    ClothesType : CustomizeClothesType #%(T_46_META_WS_A_JERSEYTYPE)\r
	@Tip = %(T_48_META_API_3212_P2_D)\r
    MainColor1 : Color #%(T_46_META_WS_A_MAINCOLOR1)\r
	@Tip = %(T_48_META_API_3212_P3_D)\r
    MainColor2 : Color #%(T_46_META_WS_A_MAINCOLOR2)\r
	@Tip = %(T_48_META_API_3212_P4_D)\r
    OtherColor : Color #%(T_46_META_WS_A_OTHERCOLOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ResetJersey\r
@Tip = %(T_48_META_API_3213_D)\r
@ModuleID=10006\r
@ModuleLib=Football\r
@ApiTarget=2\r
action ClearCustomizeClothes = 3213 { #%(T_46_META_WS_RESETJERSEY)\r
	@Tip = %(T_48_META_API_3213_P0_D)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddFootballVelocity\r
@Tip = %(T_48_META_API_10021_D)\r
@ModuleID=10006\r
@ModuleLib=Football\r
@ApiTarget=2\r
action AddVelocity = 10021 { #%(T_46_META_WS_ADDFOOTBALLVELOCITY)\r
	@Tip = %(T_48_META_API_10021_P0_D)\r
    Football : Football #%(T_46_META_WS_A_FOOTBALL)\r
	@Tip = %(T_48_META_API_10021_P1_D)\r
    Velocity : Vector3 #%(T_46_META_WS_A_VELOCITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetPlayerVoiceStatus\r
@Tip = %(T_48_META_API_3214_D)\r
@ModuleID=24\r
@ModuleLib=ChatChannel\r
@ApiTarget=2\r
action MutePlayerVoice = 3214 { #%(T_46_META_WS_SETPLAYERVOICESTATUS)\r
	@Tip = %(T_48_META_API_3214_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3214_P1_D)\r
    MuteVoice : Bool #%(T_46_META_WS_A_DISABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetPlayerQuickMessageStatus\r
@Tip = %(T_48_META_API_3215_D)\r
@ModuleID=24\r
@ModuleLib=ChatChannel\r
@ApiTarget=2\r
action MutePlayerQuickChat = 3215 { #%(T_46_META_WS_SETPLAYERQUICKMESSAGESTATUS)\r
	@Tip = %(T_48_META_API_3215_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3215_P1_D)\r
    MuteQuickChat : Bool #%(T_46_META_WS_A_DISABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MorphTo\r
@Tip = %(T_48_META_API_3023_D)\r
@ModuleID=22\r
@ModuleLib=Morph\r
@ApiTarget=2\r
action MorphTargetLevelObject = 3023 { #%(T_46_META_WS_MORPHTO)\r
	@Tip = %(T_48_META_API_3023_P0_D)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
	@Tip = %(T_48_META_API_3023_P1_D)\r
    LevelObject : LevelObject #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3023_P2_D)\r
    out EntityVarName : MorphObject #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayAnimation\r
@Tip = %(T_48_META_API_3100_D)\r
@ModuleID=35\r
@ModuleLib=Animation\r
action PlayAnimationByController = 3100 { #%(T_46_META_WS_PLAYANIMATION)\r
	@Tip = %(T_48_META_API_3100_P0_D)\r
    AnimationControllerAble : AnimationControllerAble #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3100_P1_D)\r
    StateName : String #%(T_46_META_WS_A_STATE)\r
	@Tip = %(T_48_META_API_3100_P2_D)\r
    PlaySpeed : Float #%(T_46_META_WS_A_PLAYSPEED)\r
	@Tip = %(T_48_META_API_3100_P3_D)\r
    OverrideLoopMode : AnimationOverrideLoopType #%(T_46_META_WS_A_LOOPTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetBodyPartWeight\r
@Tip = %(T_48_META_API_3300_D)\r
@ModuleID=35\r
@ModuleLib=Animation\r
action SetBodyPartTrackWeight = 3300 { #%(T_48_META_API_3300)\r
	@Tip = %(T_48_META_API_3300_P0_D)\r
    AnimationControllerAble : AnimationControllerAble #%(T_46_META_WS_TARGET)\r
	@Tip = %(T_48_META_API_3300_P1_D)\r
    TrackName : String #%(T_48_META_API_3300_P1)\r
	@Tip = %(T_48_META_API_3300_P2_D)\r
    Weight : Float #%(T_48_META_API_3300_P2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=StopAnimation\r
@Tip = %(T_48_META_API_3316_D)\r
@ModuleID=35\r
@ModuleLib=Animation\r
action StopAnimationByController = 3316 { #%(T_48_META_API_3316)\r
	@Tip = %(T_48_META_API_3100_P0_D)\r
    AnimationControllerAble : AnimationControllerAble #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3100_P1_D)\r
    StateName : String #%(T_46_META_WS_A_STATE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayCharacterAnimationClip\r
@Tip = %(T_48_META_API_3101_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
action PlayCharacterAnimationClip = 3101 { #%(T_46_META_WS_PLAYCHARACTERANIMATIONCLIP)\r
	@Tip = %(T_48_META_API_3101_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3101_P1_D)\r
    ClipID : AnimationClipID #%(T_46_META_WS_A_RESOURCE)\r
	@Tip = %(T_48_META_API_3101_P2_D)\r
    IsLooping : Bool #%(T_46_META_WS_A_ISLOOP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayCharacterAnimationClipOverride\r
@Tip = %(T_48_META_API_3315_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
action PlayCharacterAnimationClipOverride = 3315 { #%(T_48_META_API_3315)\r
	@Tip = %(T_48_META_API_3101_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3101_P1_D)\r
    ClipID : AnimationClipID #%(T_46_META_WS_A_RESOURCE)\r
	@Tip = %(T_48_META_API_3101_P2_D)\r
    IsLooping : Bool #%(T_46_META_WS_A_ISLOOP)\r
	@Tip = %(T_48_META_API_3315_P3_D)\r
    OverrideGamePlayControl : Bool #%(T_48_META_API_3315_P3)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetCharacter\r
@Tip = %(T_48_META_API_3102_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
action SwitchPresetCharacterType = 3102 { #%(T_46_META_WS_SETCHARACTER)\r
	@Tip = %(T_48_META_API_3102_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3102_P1_D)\r
    DataID : PlayerDataID #%(T_46_META_WS_A_RESOURCE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SwitchAppearanceGroup\r
@Tip = %(T_48_META_API_3110_D)\r
@ModuleID=38\r
@ModuleLib=Avatar\r
action ChangeAvatarPart = 3110 { #%(T_46_META_WS_SWITCHAPPEARANCEGROUP)\r
	@Tip = %(T_48_META_API_3110_P0_D)\r
    AvatarAbleEntity : AvatarAble #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3110_P1_D)\r
    PartName : String #%(T_46_META_WS_A_APPEARANCEGROUP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ShowAppearanceGroup\r
@Tip = %(T_48_META_API_3111_D)\r
@ModuleID=38\r
@ModuleLib=Avatar\r
action EnableAvatarPart = 3111 { #%(T_46_META_WS_SHOWAPPEARANCEGROUP)\r
	@Tip = %(T_48_META_API_3111_P0_D)\r
    AvatarAbleEntity : AvatarAble #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3111_P1_D)\r
    PartName : String #%(T_46_META_WS_A_APPEARANCEGROUP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=HideAppearanceGroup\r
@Tip = %(T_48_META_API_3112_D)\r
@ModuleID=38\r
@ModuleLib=Avatar\r
action DisableAvatarPart = 3112 { #%(T_46_META_WS_HIDEAPPEARANCEGROUP)\r
	@Tip = %(T_48_META_API_3112_P0_D)\r
    AvatarAbleEntity : AvatarAble #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3112_P1_D)\r
    PartName : String #%(T_46_META_WS_A_APPEARANCEGROUP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EndMorph\r
@Tip = %(T_48_META_API_3024_D)\r
@ModuleID=22\r
@ModuleLib=Morph\r
@ApiTarget=2\r
action RestoreMorphTarget = 3024 { #%(T_46_META_WS_ENDMORPH)\r
	@Tip = %(T_48_META_API_3024_P0_D)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CopyToMorph\r
@Tip = %(T_48_META_API_3025_D)\r
@ModuleID=22\r
@ModuleLib=Morph\r
@ApiTarget=2\r
action CopyTargetLevelObject = 3025 { #%(T_46_META_WS_COPYTOMORPH)\r
	@Tip = %(T_48_META_API_3025_P0_D)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
	@Tip = %(T_48_META_API_3025_P1_D)\r
    LevelObject : LevelObject #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3025_P2_D)\r
    out EntityVarName : MorphObject #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetMorph\r
@Tip = %(T_48_META_API_3026_D)\r
@ModuleID=22\r
@ModuleLib=Morph\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3026_R_D)\r
variable GetMorphObjectByPlayer : MorphObject = 3026 { #%(T_46_META_WS_GETMORPH)\r
	@Tip = %(T_48_META_API_3026_P0_D)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetWidgetByPath\r
@Tip = %(T_48_META_API_9013_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Return = %(T_48_META_API_9013_R_D)\r
variable GetWidgetFromCustomHudByString : HudWidget = 9013 { #%(T_46_META_WS_GETWIDGETBYPATH)\r
	@Tip = %(T_48_META_API_9013_P0_D)\r
    @optional\r
    OwnerPlayer : Player #%(T_46_META_WS_A_OWNER)\r
	@Tip = %(T_48_META_API_9013_P1_D)\r
    HudEntity : CustomHud #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_9013_P2_D)\r
    WidgetPathOrName : String #%(T_46_META_WS_A_PATH)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddScript\r
@Tip = %(T_48_META_API_6000_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action AddScript = 6000 { #%(T_46_META_WS_ADDSCRIPT)\r
	@Tip = %(T_48_META_API_6000_P0_D)\r
    @optional\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_6000_P1_D)\r
    ScriptID : GraphID #%(T_46_META_WS_A_SCRIPT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveScript\r
@Tip = %(T_48_META_API_6001_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action RemoveScript = 6001 { #%(T_46_META_WS_REMOVESCRIPT)\r
	@Tip = %(T_48_META_API_6001_P0_D)\r
    @optional\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_6001_P1_D)\r
    ScriptID : GraphID #%(T_46_META_WS_A_SCRIPT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=HasScript\r
@Tip = %(T_48_META_API_6002_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_6002_R_D)\r
variable ExistScript : Bool = 6002 { #%(T_46_META_WS_HASSCRIPT)\r
	@Tip = %(T_48_META_API_6002_P0_D)\r
    @optional\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_6002_P1_D)\r
    ScriptID : GraphID #%(T_46_META_WS_A_SCRIPT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetPickupStatus\r
@Tip = %(T_48_META_API_3216_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action DisablePickupItem = 3216 { #%(T_46_META_WS_SETPICKUPSTATUS)\r
	@Tip = %(T_48_META_API_3216_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3216_P1_D)\r
    Disable : Bool #%(T_46_META_WS_A_DISABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetDropStatus\r
@Tip = %(T_48_META_API_3217_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action DisableDropItem = 3217 { #%(T_46_META_WS_SETDROPSTATUS)\r
	@Tip = %(T_48_META_API_3217_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3217_P1_D)\r
    Disable : Bool #%(T_46_META_WS_A_DISABLE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=CreateFaction\r
@Tip = %(T_48_META_API_3301_D)\r
@ModuleID=25\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
action CreateFaction = 3301 { #%(T_46_META_WS_CREATEFACTION)\r
	@Tip = %(T_48_META_API_3301_P0_D)\r
    out EntityVarName : Faction #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=JoinFaction\r
@Tip = %(T_48_META_API_3302_D)\r
@ModuleID=25\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
action JoinFaction = 3302 { #%(T_46_META_WS_JOINFACTION)\r
	@Tip = %(T_48_META_API_3302_P0_D)\r
    Entity : Entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3302_P1_D)\r
    FactionEntity : Faction #%(T_46_META_WS_A_FACTION)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetAttackableFactions\r
@Tip = %(T_48_META_API_3303_D)\r
@ModuleID=26\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3303_R_D)\r
variable GetAttackableFactions : ListT_Faction = 3303 { #%(T_46_META_WS_GETATTACKABLEFACTIONS)\r
	@Tip = %(T_48_META_API_3303_P0_D)\r
    FactionEntity : Faction #%(T_46_META_WS_A_ATTACKER)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=SetAttackableFaction\r
@Tip = %(T_48_META_API_3304_D)\r
@ModuleID=26\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
action SetAttackableFaction = 3304 { #%(T_46_META_WS_SETATTACKABLEFACTION)\r
	@Tip = %(T_48_META_API_3304_P0_D)\r
    FactionSelf : Faction #%(T_46_META_WS_A_ATTACKER)\r
	@Tip = %(T_48_META_API_3304_P1_D)\r
    FactionTarget : Faction #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3304_P2_D)\r
    Attackable : Bool #%(T_46_META_WS_A_ATTACKABLE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=SetAttackablePlayer_Deprecated\r
@Tip = %(T_48_META_API_3305_D)\r
@ModuleID=26\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
action SetAttackablePlayer = 3305 { #%(T_37_WZY_WS_SETPLAHOST_NAME)\r
	@Tip = %(T_48_META_API_3305_P0_D)\r
    PlayerSelf : Player #%(T_46_META_WS_A_ATTACKER)\r
	@Tip = %(T_48_META_API_3305_P1_D)\r
    PlayerTarget : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3305_P2_D)\r
    Option : AttackableOption #%(T_46_META_WS_A_ATTACKABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetAttackableTeam\r
@Tip = %(T_48_META_API_3306_D)\r
@ModuleID=26\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
action SetAttackableTeam = 3306 { #%(T_46_META_WS_SETATTACKABLETEAM)\r
	@Tip = %(T_48_META_API_3306_P0_D)\r
    TeamSelf : Team #%(T_46_META_WS_A_ATTACKER)\r
	@Tip = %(T_48_META_API_3306_P1_D)\r
    TeamTarget : Team #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3306_P2_D)\r
    Option : Bool #%(T_46_META_WS_A_ATTACKABLE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetAttackablePlayer_Deprecated\r
@Tip = %(T_48_META_API_3307_D)\r
@ModuleID=26\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3307_R_D)\r
variable GetAttackablePlayer : ListT_Player = 3307 { #%(T_37_WZY_WS_GETHOSTPLA_NAME)\r
	@Tip = %(T_48_META_API_3307_P0_D)\r
    PlayerSelf : Player #%(T_46_META_WS_A_ATTACKER)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=QuitFaction\r
@Tip = %(T_48_META_API_3308_D)\r
@ModuleID=25\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
action QuitFaction = 3308 { #%(T_46_META_WS_QUITFACTION)\r
	@Tip = %(T_48_META_API_3308_P0_D)\r
    Entity : Entity #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetFaction\r
@Tip = %(T_48_META_API_3309_D)\r
@ModuleID=25\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3309_R_D)\r
variable GetFaction : Faction = 3309 { #%(T_46_META_WS_GETFACTION)\r
	@Tip = %(T_48_META_API_3309_P0_D)\r
    Entity : Entity #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=IsAttackAble\r
@Tip = %(T_48_META_API_3310_D)\r
@ModuleID=25\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3310_R_D)\r
variable IsActualAttackAble : Bool = 3310 { #%(T_46_META_WS_ISATTACKABLE)\r
	@Tip = %(T_48_META_API_3310_P0_D)\r
    Attacker : Entity #%(T_46_META_WS_A_ATTACKER)\r
	@Tip = %(T_48_META_API_3310_P1_D)\r
    Attackee : Entity #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetAttackableEntity\r
@Tip = %(T_48_META_API_3311_D)\r
@ModuleID=26\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
action SetActualAttackAbleEntity = 3311 { #%(T_46_META_WS_SETATTACKABLEENTITY)\r
	@Tip = %(T_48_META_API_3311_P0_D)\r
    EntitySelf : Entity #%(T_46_META_WS_A_ATTACKER)\r
	@Tip = %(T_48_META_API_3311_P1_D)\r
    EntityTarget : Entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3311_P2_D)\r
    Option : AttackableOption #%(T_46_META_WS_A_ATTACKABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetAttackableEntity\r
@Tip = %(T_48_META_API_3312_D)\r
@ModuleID=26\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3312_R_D)\r
variable GetActualAttackAbleEntity : ListT_Entity = 3312 { #%(T_46_META_WS_GETATTACKABLEENTITY)\r
	@Tip = %(T_48_META_API_3312_P0_D)\r
    EntitySelf : Entity #%(T_46_META_WS_A_ATTACKER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MorphToByItemID\r
@Tip = %(T_48_META_API_3033_D)\r
@ModuleID=22\r
@ModuleLib=Morph\r
@ApiTarget=2\r
action MorphTargetLevelObjectByItemID = 3033 { #%(T_46_META_WS_MORPHTOBYITEMID)\r
	@Tip = %(T_48_META_API_3033_P0_D)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
	@Tip = %(T_48_META_API_3033_P1_D)\r
    MorphableItemID : MorphableObject #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3033_P2_D)\r
    out EntityVarName : MorphObject #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Destroy\r
@Tip = %(T_48_META_API_10022_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action RemoveEntity = 10022 { #%(T_46_META_WS_DESTROY)\r
	@Tip = %(T_48_META_API_10022_P0_D)\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddTag\r
@Tip = %(T_48_META_API_10023_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action AddTag = 10023 { #%(T_46_META_WS_ADDTAG)\r
	@Tip = %(T_48_META_API_10023_P0_D)\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_10023_P1_D)\r
    CustomTag : String #%(T_46_META_WS_A_CUSTOMTAG)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveTag\r
@Tip = %(T_48_META_API_10024_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action RemoveTag = 10024 { #%(T_46_META_WS_DELETETAG)\r
	@Tip = %(T_48_META_API_10024_P0_D)\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_10024_P1_D)\r
    CustomTag : String #%(T_46_META_WS_A_CUSTOMTAG)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=HasTag\r
@Tip = %(T_48_META_API_10025_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_10025_R_D)\r
variable HasTag : Bool = 10025 { #%(T_46_META_WS_HASTAG)\r
	@Tip = %(T_48_META_API_10025_P0_D)\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_10025_P1_D)\r
    CustomTag : String #%(T_46_META_WS_A_CUSTOMTAG)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateMorph\r
@Tip = %(T_48_META_API_3034_D)\r
@ModuleID=22\r
@ModuleLib=Morph\r
@ApiTarget=2\r
action CopyMorphObjectBySelf = 3034 { #%(T_46_META_WS_CREATEMORPH)\r
	@Tip = %(T_48_META_API_3034_P0_D)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
	@Tip = %(T_48_META_API_3034_P1_D)\r
    out EntityVarName : MorphObject #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetFootballPosition\r
@Tip = %(T_48_META_API_10026_D)\r
@ModuleID=10006\r
@ModuleLib=Football\r
@ApiTarget=2\r
action SetFootballPosition = 10026 { #%(T_46_META_WS_SETFOOTBALLPOSITION)\r
	@Tip = %(T_48_META_API_10026_P0_D)\r
    Football : Football #%(T_46_META_WS_A_FOOTBALL)\r
	@Tip = %(T_48_META_API_10026_P1_D)\r
    Position : Vector3 #%(T_46_META_WS_A_POSITION)\r
	@Tip = %(T_48_META_API_10026_P2_D)\r
    KeepVelocity : Bool #%(T_46_META_WS_A_KEEPVELOCITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateShop\r
@Tip = %(T_48_META_API_3035_D)\r
@ModuleID=19\r
@ModuleLib=Economy\r
@ApiTarget=2\r
action CreateShop = 3035 { #%(T_46_META_WS_CREATESHOP)\r
	@Tip = %(T_48_META_API_3035_P0_D)\r
    out EntityVarName : Shop #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateShopShelf\r
@Tip = %(T_48_META_API_3036_D)\r
@ModuleID=19\r
@ModuleLib=Economy\r
@ApiTarget=2\r
action CreateShopShelf = 3036 { #%(T_46_META_WS_CREATESHOPSHELF)\r
	@Tip = %(T_48_META_API_3036_P0_D)\r
    out EntityVarName : ShopShelf #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateShopItem\r
@Tip = %(T_48_META_API_3037_D)\r
@ModuleID=19\r
@ModuleLib=Economy\r
@ApiTarget=2\r
action CreateShopItem = 3037 { #%(T_46_META_WS_CREATESHOPITEM)\r
	@Tip = %(T_48_META_API_3037_P0_D)\r
    out EntityVarName : ShopItem #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddItemToShopItem\r
@Tip = %(T_48_META_API_3038_D)\r
@ModuleID=19\r
@ModuleLib=Economy\r
@ApiTarget=2\r
action AddItemToShopItem = 3038 { #%(T_46_META_WS_ADDITEMTOSHOPITEM)\r
	@Tip = %(T_48_META_API_3038_P0_D)\r
    ShopItem : ShopItem #%(T_46_META_WS_A_SHOPITEM)\r
	@Tip = %(T_48_META_API_3038_P1_D)\r
    ItemGoodsID : ItemGoodsIDType #%(T_46_META_WS_A_ITEM)\r
	@Tip = %(T_48_META_API_3038_P2_D)\r
    ItemCnt : Int #%(T_46_META_WS_A_COUNT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetCurrentCamera\r
@Tip = %(T_48_META_API_10027_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@Return = %(T_48_META_API_10027_R_D)\r
variable GetCurrentCamera : CameraConfig = 10027 { #%(T_46_META_WS_GETCURRENTCAMERA)\r
	@Tip = %(T_48_META_API_10027_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SwitchCamera\r
@Tip = %(T_48_META_API_10028_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=2\r
action SwitchCamera = 10028 { #%(T_46_META_WS_SWITCHCAMERA)\r
	@Tip = %(T_48_META_API_10028_P0_D)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
	@Tip = %(T_48_META_API_10028_P1_D)\r
    Camera : CameraConfig #%(T_46_META_WS_A_CAMERA)\r
	@Tip = %(T_48_META_API_10028_P2_D)\r
    CameraTransitionType : CameraTransitionType #%(T_46_META_WS_A_TRANSITIONTYPE)\r
	@Tip = %(T_48_META_API_10028_P3_D)\r
    TransitionTime : Float #%(T_46_META_WS_A_TRANSITIONTIME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateCamera\r
@Tip = %(T_48_META_API_10029_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=2\r
action CreateCamera = 10029 { #%(T_46_META_WS_CREATECAMERA)\r
	@Tip = %(T_48_META_API_10029_P0_D)\r
    CameraType : CameraType #%(T_46_META_WS_A_TYPE)\r
	@Tip = %(T_48_META_API_10029_P1_D)\r
    out EntityVarName : CameraConfig #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=Eliminate\r
@Tip = %(T_48_META_API_10030_D)\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@ApiTarget=2\r
action KillFightingEntity = 10030 { #%(T_46_META_WS_ELIMINATE)\r
	@Tip = %(T_48_META_API_10030_P0_D)\r
    TargetEntity : FightingEntity #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ClearBackpack\r
@Tip = %(T_48_META_API_3219_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action ClearInventory = 3219 { #%(T_46_META_WS_CLEARBACKPACK)\r
	@Tip = %(T_48_META_API_3219_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetActive\r
@Tip = %(T_48_META_API_10031_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action SetActive = 10031 { #%(T_46_META_WS_SETACTIVE)\r
	@Tip = %(T_48_META_API_10031_P0_D)\r
    TargetEntity : Entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_10031_P1_D)\r
    Active : Bool #%(T_46_META_WS_A_ACTIVE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetCameraFollow\r
@Tip = %(T_48_META_API_10032_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
action SetFollowEntity = 10032 { #%(T_46_META_WS_SETCAMERAFOLLOW)\r
	@Tip = %(T_48_META_API_10032_P0_D)\r
    TargetEntity : Entity #%(T_46_META_WS_A_CAMERA)\r
	@Tip = %(T_48_META_API_10032_P1_D)\r
    FollowEntity : Entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_10032_P2_D)\r
    Offset : Vector3 #%(T_46_META_WS_A_OFFSET)\r
	@Tip = %(T_48_META_API_10032_P3_D)\r
    CoordinateType : CoordinateType #%(T_46_META_WS_A_COORDINATESYSTEM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetCameraFocus\r
@Tip = %(T_48_META_API_10033_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
action SetWatchEntity = 10033 { #%(T_46_META_WS_SETCAMERAFOCUS)\r
	@Tip = %(T_48_META_API_10033_P0_D)\r
    TargetEntity : Entity #%(T_46_META_WS_A_CAMERA)\r
	@Tip = %(T_48_META_API_10033_P1_D)\r
    WatchEntity : Entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_10033_P2_D)\r
    Offset : Vector3 #%(T_46_META_WS_A_OFFSET)\r
	@Tip = %(T_48_META_API_10033_P3_D)\r
    CoordinateType : CoordinateType #%(T_46_META_WS_A_COORDINATESYSTEM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DyeAtPosition\r
@Tip = %(T_48_META_API_10047_D)\r
@ModuleID=32\r
@ModuleLib=Dyeing\r
@ApiTarget=2\r
action DyeingPosition = 10047 { #%(T_46_META_WS_DYEATPOSITION)\r
	@Tip = %(T_48_META_API_10047_P0_D)\r
    Normal : Vector3 #%(T_46_META_WS_A_NORMAL)\r
	@Tip = %(T_48_META_API_10047_P1_D)\r
    Position : Vector3 #%(T_46_META_WS_A_POSITION)\r
	@Tip = %(T_48_META_API_10047_P2_D)\r
    Color : Int #%(T_46_META_WS_A_COLOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetDyedStatus\r
@Tip = %(T_48_META_API_10048_D)\r
@ModuleID=32\r
@ModuleLib=Dyeing\r
@ApiTarget=2\r
@Return = %(T_48_META_API_10048_R_D)\r
variable GetDyeingState : Int = 10048 { #%(T_46_META_WS_GETDYEDSTATUS)\r
	@Tip = %(T_48_META_API_10048_P0_D)\r
    Origion : Vector3 #%(T_46_META_WS_A_STARTPOSITION)\r
	@Tip = %(T_48_META_API_10048_P1_D)\r
    Dir : Vector3 #%(T_46_META_WS_A_DIRECTION)\r
	@Tip = %(T_48_META_API_10048_P2_D)\r
    Distance : Float #%(T_46_META_WS_A_DISTANCE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetDyedCount\r
@Tip = %(T_48_META_API_10049_D)\r
@ModuleID=32\r
@ModuleLib=Dyeing\r
@ApiTarget=2\r
@Return = %(T_48_META_API_10049_R_D)\r
variable GetDyeingCount : Int = 10049 { #%(T_46_META_WS_GETDYEDCOUNT)\r
	@Tip = %(T_48_META_API_10049_P0_D)\r
    Color : Int #%(T_46_META_WS_A_COLOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DyeAtPlane\r
@Tip = %(T_48_META_API_10050_D)\r
@ModuleID=32\r
@ModuleLib=Dyeing\r
@ApiTarget=2\r
action DyeingPlane = 10050 { #%(T_46_META_WS_DYEATPLANE)\r
	@Tip = %(T_48_META_API_10050_P0_D)\r
    Normal : Vector3 #%(T_46_META_WS_A_NORMAL)\r
	@Tip = %(T_48_META_API_10050_P1_D)\r
    Position : Vector3 #%(T_46_META_WS_A_POSITION)\r
	@Tip = %(T_48_META_API_10050_P2_D)\r
    DyeingRange : Float #%(T_46_META_WS_A_RANGE)\r
	@Tip = %(T_48_META_API_10050_P3_D)\r
    Color : Int #%(T_46_META_WS_A_COLOR)\r
	@Tip = %(T_48_META_API_10050_P4_D)\r
    out ResultValue : Int #%(T_46_META_WS_A_COUNT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DyeAtArea\r
@Tip = %(T_48_META_API_10051_D)\r
@ModuleID=32\r
@ModuleLib=Dyeing\r
@ApiTarget=2\r
action DyeingArea = 10051 { #%(T_46_META_WS_DYEATAREA)\r
	@Tip = %(T_48_META_API_10051_P0_D)\r
    Normal : Vector3 #%(T_46_META_WS_A_NORMAL)\r
	@Tip = %(T_48_META_API_10051_P1_D)\r
    Position : Vector3 #%(T_46_META_WS_A_POSITION)\r
	@Tip = %(T_48_META_API_10051_P2_D)\r
    DyeingRange : Float #%(T_46_META_WS_A_RANGE)\r
	@Tip = %(T_48_META_API_10051_P3_D)\r
    Color : Int #%(T_46_META_WS_A_COLOR)\r
	@Tip = %(T_48_META_API_10051_P4_D)\r
    FixedDyeingRange : Float #%(T_46_META_WS_A_FIXEDRANGE)\r
	@Tip = %(T_48_META_API_10051_P5_D)\r
    RandomRatio : Float #%(T_46_META_WS_A_RANDOMRATIO)\r
	@Tip = %(T_48_META_API_10051_P6_D)\r
    RandomDecay : Float #%(T_46_META_WS_A_RANDOMDECAY)\r
	@Tip = %(T_48_META_API_10051_P7_D)\r
    out ResultValue : Int #%(T_46_META_WS_A_COUNT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ResetDyeing\r
@Tip = %(T_48_META_API_10058_D)\r
@ModuleID=32\r
@ModuleLib=Dyeing\r
@ApiTarget=2\r
action DyeingReset = 10058 { #%(T_46_META_WS_RESETDYEING)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetForward\r
@Tip = %(T_48_META_API_3220_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action PlayerSetForward = 3220 { #%(T_46_META_WS_SETFORWARD)\r
	@Tip = %(T_48_META_API_3220_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3220_P1_D)\r
    Forward : Vector3 #%(T_46_META_WS_A_FORWARD)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetSkills\r
@Tip = %(T_48_META_API_3202_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action SetPlayerSkills = 3202 { #%(T_46_META_WS_SETSKILLS)\r
	@Tip = %(T_48_META_API_3202_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3202_P1_D)\r
    PlayerSkills : ListT_PlayerSkillID #%(T_46_META_WS_A_SKILLS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetSkills\r
@Tip = %(T_48_META_API_3203_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3203_R_D)\r
variable GetPlayerSkills : ListT_PlayerSkillID = 3203 { #%(T_46_META_WS_GETSKILLS)\r
	@Tip = %(T_48_META_API_3203_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetBuffs\r
@Tip = %(T_48_META_API_3236_D)\r
@ModuleID=10011\r
@ModuleLib=Buff\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3236_R_D)\r
variable GetInternalBuffs : ListT_InternalBuffType = 3236 { #%(T_46_META_WS_GETBUFFS)\r
	@Tip = %(T_48_META_API_3236_P0_D)\r
    TargetEntity : BuffableEntity #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddBuff\r
@Tip = %(T_48_META_API_3234_D)\r
@ModuleID=10011\r
@ModuleLib=Buff\r
@ApiTarget=2\r
action AddInternalBuff = 3234 { #%(T_46_META_WS_ADDBUFF)\r
	@Tip = %(T_48_META_API_3234_P0_D)\r
    TargetEntity : BuffableEntity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3234_P1_D)\r
    BuffID : InternalBuffType #%(T_46_META_WS_A_BUFF)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveBuff\r
@Tip = %(T_48_META_API_3235_D)\r
@ModuleID=10011\r
@ModuleLib=Buff\r
@ApiTarget=2\r
action RemoveInternalBuff = 3235 { #%(T_46_META_WS_REMOVEBUFF)\r
	@Tip = %(T_48_META_API_3235_P0_D)\r
    TargetEntity : BuffableEntity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3235_P1_D)\r
    BuffID : InternalBuffType #%(T_46_META_WS_A_BUFF)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetConsumables\r
@Tip = %(T_48_META_API_3237_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action GetPlayerItems = 3237 { #%(T_46_META_WS_GETCONSUMABLES)\r
	@Tip = %(T_48_META_API_3237_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3237_P1_D)\r
    out ItemList : ListT_ItemGoodsIDType #%(T_46_META_WS_A_RESULT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddAttachments\r
@Tip = %(T_48_META_API_3238_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action AddAttachmentsToPlayer = 3238 { #%(T_46_META_WS_ADDATTACHMENTS)\r
	@Tip = %(T_48_META_API_3238_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3238_P1_D)\r
    WeaponEquipSlot : SwitchWeaponEquipSlot #%(T_46_META_WS_A_SLOT)\r
	@Tip = %(T_48_META_API_3238_P2_D)\r
    ItemID : ItemGoodsIDType #%(T_46_META_WS_A_ITEM)\r
	@Tip = %(T_48_META_API_3238_P3_D)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
	@Tip = %(T_48_META_API_3238_P4_D)\r
    out Attachment : Entity #%(T_46_META_WS_A_ATTACHMENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetEquipments\r
@Tip = %(T_48_META_API_3239_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action GetPlayerEquipments = 3239 { #%(T_46_META_WS_GETEQUIPMENTS)\r
	@Tip = %(T_48_META_API_3239_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3239_P1_D)\r
    Slot : EquipmentSlot #%(T_46_META_WS_A_SLOT)\r
	@Tip = %(T_48_META_API_3239_P2_D)\r
    out EquipEntity : Entity #%(T_46_META_WS_A_EQUIPMENTS)\r
	@Tip = %(T_48_META_API_3239_P3_D)\r
    out AttachmentList : ListT_Attachment #%(T_46_META_WS_A_ATTACHMENTS)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=AddGameEventLog_Deprecated\r
@Tip = %(T_48_META_API_15_D)\r
@ModuleID=17\r
@ModuleLib=StatisticalReport\r
@ApiTarget=2\r
action CustomMatchEventLog = 15 { #%(T_44_YU_WS_ADDGAMEEVENTLOGMAP)\r
	@Tip = %(T_48_META_API_15_P0_D)\r
    Keys : List #%(T_46_META_WS_A_KEYS)\r
	@Tip = %(T_48_META_API_15_P1_D)\r
    Values : List #%(T_46_META_WS_A_VALUES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddGameEventLog\r
@Tip = %(T_48_META_API_3257_D)\r
@ModuleID=17\r
@ModuleLib=StatisticalReport\r
@ApiTarget=2\r
action AddGameEventLogMap = 3257 { #%(T_46_META_WS_ADDGAMEEVENTLOG)\r
	@Tip = %(T_48_META_API_3257_P0_D)\r
    Dictionary : Map #%(T_46_META_WS_A_LOG)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadCSV\r
@Tip = %(T_48_META_API_4000_D)\r
@ModuleID=10019\r
@ModuleLib=CSVData\r
@ApiTarget=0\r
@Return = %(T_48_META_API_4000_R_D)\r
variable ReadCSVDataAll : ListT_ListT_Object = 4000 { #%(T_46_META_WS_READCSV)\r
	@Tip = %(T_48_META_API_4000_P0_D)\r
    UUIDCSV : CsvID #%(T_46_META_WS_A_SHEETNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadCSVRow\r
@Tip = %(T_48_META_API_4001_D)\r
@ModuleID=10019\r
@ModuleLib=CSVData\r
@ApiTarget=0\r
@Return = %(T_48_META_API_4001_R_D)\r
variable ReadCSVDataRow : ListT_Object = 4001 { #%(T_46_META_WS_READCSVROW)\r
	@Tip = %(T_48_META_API_4001_P0_D)\r
    UUIDCSV : CsvID #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_4001_P1_D)\r
    Row : Int #%(T_46_META_WS_A_ROW)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadCSVColumn\r
@Tip = %(T_48_META_API_4002_D)\r
@ModuleID=10019\r
@ModuleLib=CSVData\r
@ApiTarget=0\r
@Return = %(T_48_META_API_4002_R_D)\r
variable ReadCSVDataCol : ListT_Object = 4002 { #%(T_46_META_WS_READCSVCOLUMN)\r
	@Tip = %(T_48_META_API_4002_P0_D)\r
    UUIDCSV : CsvID #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_4002_P1_D)\r
    Col : Int #%(T_46_META_WS_A_COLUMN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadCSVCell\r
@Tip = %(T_48_META_API_4003_D)\r
@ModuleID=10019\r
@ModuleLib=CSVData\r
@ApiTarget=0\r
@Return = %(T_48_META_API_4003_R_D)\r
variable ReadCSVDataCell : Object = 4003 { #%(T_46_META_WS_READCSVCELL)\r
	@Tip = %(T_48_META_API_4003_P0_D)\r
    UUIDCSV : CsvID #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_4003_P1_D)\r
    Row : Int #%(T_46_META_WS_A_ROW)\r
	@Tip = %(T_48_META_API_4003_P2_D)\r
    Col : Int #%(T_46_META_WS_A_COLUMN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadCSVCellByName\r
@Tip = %(T_48_META_API_4004_D)\r
@ModuleID=10019\r
@ModuleLib=CSVData\r
@ApiTarget=0\r
@Return = %(T_48_META_API_4004_R_D)\r
variable ReadCSVDataCellByRowAndColName : Object = 4004 { #%(T_46_META_WS_READCSVCELLBYNAME)\r
	@Tip = %(T_48_META_API_4004_P0_D)\r
    UUIDCSV : CsvID #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_4004_P1_D)\r
    Row : Int #%(T_46_META_WS_A_ROW)\r
	@Tip = %(T_48_META_API_4004_P2_D)\r
    ColName : String #%(T_46_META_WS_A_COLUMNNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadCSVFromServer\r
@Tip = %(T_48_META_API_4005_D)\r
@ModuleID=10009\r
@ModuleLib=Other\r
@ApiTarget=2\r
@Return = %(T_48_META_API_4005_R_D)\r
variable ReadCSVDataAllOverMode : ListT_ListT_Object = 4005 { #%(T_46_META_WS_READCSVFROMSERVER)\r
	@Tip = %(T_48_META_API_4005_P0_D)\r
    CSVName : String #%(T_46_META_WS_A_SHEETNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadCSVRowFromServer\r
@Tip = %(T_48_META_API_4006_D)\r
@ModuleID=10009\r
@ModuleLib=Other\r
@ApiTarget=2\r
@Return = %(T_48_META_API_4006_R_D)\r
variable ReadCSVDataRowOverMode : ListT_Object = 4006 { #%(T_46_META_WS_READCSVROWFROMSERVER)\r
	@Tip = %(T_48_META_API_4006_P0_D)\r
    CSVName : String #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_4006_P1_D)\r
    Row : Int #%(T_46_META_WS_A_ROW)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadCSVColumnFromServer\r
@Tip = %(T_48_META_API_4007_D)\r
@ModuleID=10009\r
@ModuleLib=Other\r
@ApiTarget=2\r
@Return = %(T_48_META_API_4007_R_D)\r
variable ReadCSVDataColOverMode : ListT_Object = 4007 { #%(T_46_META_WS_READCSVCOLUMNFROMSERVER)\r
	@Tip = %(T_48_META_API_4007_P0_D)\r
    CSVName : String #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_4007_P1_D)\r
    Col : Int #%(T_46_META_WS_A_COLUMN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadCSVCellFromServer\r
@Tip = %(T_48_META_API_4008_D)\r
@ModuleID=10009\r
@ModuleLib=Other\r
@ApiTarget=2\r
@Return = %(T_48_META_API_4008_R_D)\r
variable ReadCSVDataCellOverMode : Object = 4008 { #%(T_46_META_WS_READCSVCELLFROMSERVER)\r
	@Tip = %(T_48_META_API_4008_P0_D)\r
    CSVName : String #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_4008_P1_D)\r
    Row : Int #%(T_46_META_WS_A_ROW)\r
	@Tip = %(T_48_META_API_4008_P2_D)\r
    Col : Int #%(T_46_META_WS_A_COLUMN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadCSVRowByKey\r
@Tip = %(T_48_META_API_4009_D)\r
@ModuleID=10019\r
@ModuleLib=CSVData\r
@ApiTarget=0\r
@Return = %(T_48_META_API_4009_R_D)\r
variable ReadCSVDataRowByKey : ListT_Object = 4009 { #%(T_46_META_WS_READCSVROWBYKEY)\r
	@Tip = %(T_48_META_API_4009_P0_D)\r
    UUIDCSV : CsvID #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_4009_P1_D)\r
    Col : Int #%(T_46_META_WS_A_KEYCOLUMN)\r
	@Tip = %(T_48_META_API_4009_P2_D)\r
    TargetValue : Object #%(T_46_META_WS_A_KEY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CSVColumnNameToInt\r
@Tip = %(T_48_META_API_4010_D)\r
@ModuleID=10019\r
@ModuleLib=CSVData\r
@ApiTarget=0\r
@Return = %(T_48_META_API_4010_R_D)\r
variable ReadCSVDataColIntByName : Int = 4010 { #%(T_46_META_WS_CSVCOLUMNNAMETOINT)\r
	@Tip = %(T_48_META_API_4010_P0_D)\r
    UUIDCSV : CsvID #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_4010_P1_D)\r
    ColName : String #%(T_46_META_WS_A_COLUMNNAME)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=AddUserEventLog_Deprecated\r
@Tip = %(T_48_META_API_16_D)\r
@ModuleID=17\r
@ModuleLib=StatisticalReport\r
action CustomUserEventLog = 16 { #%(T_44_YU_WS_ADDUSEREVENTLOGMAP)\r
	@Tip = %(T_48_META_API_16_P0_D)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
	@Tip = %(T_48_META_API_16_P1_D)\r
    Keys : List #%(T_46_META_WS_A_KEYS)\r
	@Tip = %(T_48_META_API_16_P2_D)\r
    Values : List #%(T_46_META_WS_A_VALUES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddUserEventLog\r
@Tip = %(T_48_META_API_3258_D)\r
@ModuleID=17\r
@ModuleLib=StatisticalReport\r
@ApiTarget=2\r
action AddUserEventLogMap = 3258 { #%(T_46_META_WS_ADDUSEREVENTLOG)\r
	@Tip = %(T_48_META_API_3258_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3258_P1_D)\r
    Dictionary : Map #%(T_46_META_WS_A_LOG)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=CreateTween_Deprecated\r
@Tip = %(T_48_META_API_10034_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
@ApiTarget=2\r
action CreateTween = 10034 { #%(T_39_WZY_WS_CRETWEEN_NAME)\r
	@Tip = %(T_48_META_API_10034_P0_D)\r
    TargetEntity : Entity #%(T_34_M_WS_ENTITY)\r
	@Tip = %(T_48_META_API_10034_P1_D)\r
    PropID : Property #%(T_34_M_WS_ATT)\r
	@Tip = %(T_48_META_API_10034_P2_D)\r
    SrcVal : Object #%(T_34_WZ_WS_LOGIC6_PARAM2_NAME)\r
	@Tip = %(T_48_META_API_10034_P3_D)\r
    DestVal : Object #%(T_39_WZY_WS_TARGETVAL)\r
	@Tip = %(T_48_META_API_10034_P4_D)\r
    Style : TweenStyle #%(T_39_WZY_WS_TWEENSTYLE)\r
	@Tip = %(T_48_META_API_10034_P5_D)\r
    Curve : TweenCurve #%(T_39_WZY_WS_CURVE)\r
	@Tip = %(T_48_META_API_10034_P6_D)\r
    Duration : Float #%(TXT_OB7_ZJS_HISTORY_TIME)\r
	@Tip = %(T_48_META_API_10034_P7_D)\r
    out EntityVarName : Tween #%(T_39_WZY_WS_TWEENENT)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_31_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
action CreateSelfRelative = 31 { #%(T_46_META_WS_CREATESELFRELATIVE)\r
	@Tip = %(T_48_META_API_31_P0_D)\r
    TargetEntity : Entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_31_P1_D)\r
    PropID : Property #%(T_46_META_WS_A_PROPERTY)\r
	@Tip = %(T_48_META_API_31_P2_D)\r
    Delta : Object #%(T_46_META_WS_A_DELTA)\r
	@Tip = %(T_48_META_API_31_P3_D)\r
    ControlPoints : BezierCurve #%(T_46_META_WS_A_CURVE)\r
	@Tip = %(T_48_META_API_31_P4_D)\r
    Style : TweenStyle #%(T_46_META_WS_A_STYLE)\r
	@Tip = %(T_48_META_API_31_P5_D)\r
    Duration : Float #%(T_46_META_WS_P_PHASEDURATION)\r
	@Tip = %(T_48_META_API_31_P6_D)\r
    out EntityVarName : PlayableSelfRelative #%(T_46_META_WS_A_CREATEDENTITY)\r
	@Tip = %(T_48_META_API_31_P7_D)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateFrameSelfRelative\r
@Tip = %(T_48_META_API_50_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
action CreateSelfRelativeFrame = 50 { #%(T_46_META_WS_CREATEFRAMESELFRELATIVE)\r
	@Tip = %(T_48_META_API_50_P0_D)\r
    TargetEntity : Entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_50_P1_D)\r
    PropID : Property #%(T_46_META_WS_A_PROPERTY)\r
	@Tip = %(T_48_META_API_50_P2_D)\r
    Delta : Object #%(T_46_META_WS_A_DELTA)\r
	@Tip = %(T_48_META_API_50_P3_D)\r
    IsSwitch : Bool #%(T_46_META_WS_A_TYPE)\r
	@Tip = %(T_48_META_API_50_P4_D)\r
    out EntityVarName : PlayableRelativeFrame #%(T_46_META_WS_A_CREATEDENTITY)\r
	@Tip = %(T_48_META_API_50_P5_D)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateTween\r
@Tip = %(T_48_META_API_29_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
action CreateTweenV2 = 29 { #%(T_46_META_WS_CREATETWEEN)\r
	@Tip = %(T_48_META_API_29_P0_D)\r
    TargetEntity : Entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_29_P1_D)\r
    PropID : Property #%(T_46_META_WS_A_PROPERTY)\r
	@Tip = %(T_48_META_API_29_P2_D)\r
    SrcVal : Object #%(T_46_META_WS_A_SRCVAL)\r
	@Tip = %(T_48_META_API_29_P3_D)\r
    DestVal : Object #%(T_46_META_WS_A_DESTVAL)\r
	@Tip = %(T_48_META_API_29_P4_D)\r
    Style : TweenStyle #%(T_46_META_WS_A_STYLE)\r
	@Tip = %(T_48_META_API_29_P5_D)\r
    ControlPoints : BezierCurve #%(T_46_META_WS_A_CURVE)\r
	@Tip = %(T_48_META_API_29_P6_D)\r
    Duration : Float #%(T_46_META_WS_P_PHASEDURATION)\r
	@Tip = %(T_48_META_API_29_P7_D)\r
    out EntityVarName : Tween #%(T_46_META_WS_A_CREATEDENTITY)\r
	@Tip = %(T_48_META_API_29_P8_D)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetWidgetParent\r
@Tip = %(T_48_META_API_61_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
action SetHudWidgetParent = 61 { #%(T_46_META_WS_SETWIDGETPARENT)\r
	@Tip = %(T_48_META_API_61_P0_D)\r
    Parent : HudWidgetOrCustomHud #%(T_46_META_WS_A_PARENT)\r
	@Tip = %(T_48_META_API_61_P1_D)\r
    Child : HudWidget #%(T_46_META_WS_A_CHILD)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetParent\r
@Tip = %(T_48_META_API_10035_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action SetParent = 10035 { #%(T_46_META_WS_SETPARENT)\r
	@Tip = %(T_48_META_API_10035_P0_D)\r
    Parent : Transform #%(T_46_META_WS_A_PARENT)\r
	@Tip = %(T_48_META_API_10035_P1_D)\r
    Child : Transform #%(T_46_META_WS_A_CHILD)\r
	@Tip = %(T_48_META_API_10035_P2_D)\r
    WorldPositionStays : Bool #%(T_46_META_WS_A_WORLDPOSITIONSTAYS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetChildren\r
@Tip = %(T_48_META_API_10052_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_10052_R_D)\r
variable GetChildren : ListT_Entity = 10052 { #%(T_46_META_WS_GETCHILDREN)\r
	@Tip = %(T_48_META_API_10052_P0_D)\r
    Parent : Entity #%(T_46_META_WS_A_PARENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetChildByIndex\r
@Tip = %(T_48_META_API_10053_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_10053_R_D)\r
variable GetChildByIndex : Entity = 10053 { #%(T_46_META_WS_GETCHILDBYINDEX)\r
	@Tip = %(T_48_META_API_10053_P0_D)\r
    Parent : Entity #%(T_46_META_WS_A_PARENT)\r
	@Tip = %(T_48_META_API_10053_P1_D)\r
    Index : Int #%(T_46_META_WS_A_INDEX)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetChildByName\r
@Tip = %(T_48_META_API_83_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_83_R_D)\r
variable GetChildByName : Entity = 83 { #%(T_46_META_WS_GETCHILDBYNAME)\r
	@Tip = %(T_48_META_API_83_P0_D)\r
    Parent : Entity #%(T_46_META_WS_A_PARENT)\r
	@Tip = %(T_48_META_API_83_P1_D)\r
    EntityName : String #%(T_46_META_WS_A_NAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetParent\r
@Tip = %(T_48_META_API_10054_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_10054_R_D)\r
variable GetParent : Entity = 10054 { #%(T_46_META_WS_GETPARENT)\r
	@Tip = %(T_48_META_API_10054_P0_D)\r
    Child : Entity #%(T_46_META_WS_A_CHILD)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ClearAllChildren\r
@Tip = %(T_48_META_API_10055_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action ClearAllChildren = 10055 { #%(T_46_META_WS_CLEARALLCHILDREN)\r
	@Tip = %(T_48_META_API_10055_P0_D)\r
    Parent : Entity #%(T_46_META_WS_A_PARENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GiveJailBreakReward\r
@Tip = %(T_48_META_API_3039_D)\r
@ModuleID=10009\r
@ModuleLib=Other\r
@ApiTarget=2\r
action GiveJailBreakReward = 3039 { #%(T_46_META_WS_GIVEJAILBREAKREWARD)\r
	@Tip = %(T_48_META_API_3039_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3039_P1_D)\r
    Count : Int #%(T_46_META_WS_A_COUNT)\r
	@Tip = %(T_48_META_API_3039_P2_D)\r
    RealCoin : Bool #%(T_46_META_WS_A_REALCOIN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UpdateJailBreakMission\r
@Tip = %(T_48_META_API_3040_D)\r
@ModuleID=10009\r
@ModuleLib=Other\r
@ApiTarget=2\r
action UpdateJailBreakMission = 3040 { #%(T_46_META_WS_UPDATEJAILBREAKMISSION)\r
	@Tip = %(T_48_META_API_3040_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3040_P1_D)\r
    MissionID : Int #%(T_46_META_WS_A_MISSIONID)\r
	@Tip = %(T_48_META_API_3040_P2_D)\r
    Value : Int #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=QuitJailBreakMiniGame\r
@Tip = %(T_48_META_API_3042_D)\r
@ModuleID=10009\r
@ModuleLib=Other\r
@ApiTarget=2\r
action QuitJailBreakMiniGame = 3042 { #%(T_46_META_WS_QUITJAILBREAKMINIGAME)\r
	@Tip = %(T_48_META_API_3042_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3042_P1_D)\r
    GameID : Int #%(T_46_META_WS_A_GAMEID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GiveJailBreakItem\r
@Tip = %(T_48_META_API_3043_D)\r
@ModuleID=10009\r
@ModuleLib=Other\r
@ApiTarget=2\r
action GiveJailBreakItem = 3043 { #%(T_46_META_WS_GIVEJAILBREAKITEM)\r
	@Tip = %(T_48_META_API_3043_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3043_P1_D)\r
    ItemType : Int #%(T_46_META_WS_A_ITEMTYPE)\r
	@Tip = %(T_48_META_API_3043_P2_D)\r
    ItemID : Int #%(T_46_META_WS_A_ITEMID)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=ReadFromDatabase_Deprecate\r
@Async\r
@Tip = %(T_48_META_API_5000_D)\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action ReadDBSheetValue = 5000 { #%(T_40_XXJ_WS_DB)\r
	@Tip = %(T_48_META_API_5000_P0_D)\r
    SheetName : String #%(T_40_XXJ_WS_DBTABLENAME)\r
	@Tip = %(T_48_META_API_5000_P1_D)\r
    AccountId : UUID #%(T_40_XXJ_WS_UUID_NAMEKEY)\r
	@Tip = %(T_48_META_API_5000_P2_D)\r
    Key : String #%(T_40_XXJ_WS_DBKEY_NAMEKEY)\r
	@Tip = %(T_48_META_API_5000_P3_D)\r
    out Result : Object #%(T_40_XXJ_WS_RESULT_NAMEKEY)\r
	@Tip = %(T_48_META_API_5000_P4_D)\r
    WorkshopCode : String #%(T_42_XXJ_WS_WORKSHOPCODE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=WriteToDatabase_Deprecate\r
@Tip = %(T_48_META_API_5001_D)\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action WriteDBSheetValue = 5001 { #%(T_40_XXJ_WS_DBWRITE)\r
	@Tip = %(T_48_META_API_5001_P0_D)\r
    SheetName : String #%(T_40_XXJ_WS_DBTABLENAME)\r
	@Tip = %(T_48_META_API_5001_P1_D)\r
    AccountId : UUID #%(T_40_XXJ_WS_UUID_NAMEKEY)\r
	@Tip = %(T_48_META_API_5001_P2_D)\r
    Key : String #%(T_40_XXJ_WS_DBKEY_NAMEKEY)\r
	@Tip = %(T_48_META_API_5001_P3_D)\r
    Value : Object #%(T_40_XXJ_WS_VALUE_NAMEKEY)\r
	@Tip = %(T_48_META_API_5001_P4_D)\r
    WorkshopCode : String #%(T_42_XXJ_WS_WORKSHOPCODE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=DeleteFromDatabase_Deprecate\r
@Tip = %(T_48_META_API_5002_D)\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action DeleteDBSheetValue = 5002 { #%(T_46_META_WS_DELETEFROMDATABASE)\r
	@Tip = %(T_48_META_API_5002_P0_D)\r
    SheetName : String #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_5002_P1_D)\r
    AccountId : UUID #%(T_46_META_WS_A_ACCOUNTID)\r
	@Tip = %(T_48_META_API_5002_P2_D)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
	@Tip = %(T_48_META_API_5002_P3_D)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=ReadLeadboardFromDatabase_Deprecate\r
@Async\r
@Tip = %(T_48_META_API_5003_D)\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action ReadDBLeaderboardValue = 5003 { #%(T_40_XXJ_WS_READLEADERBOARD)\r
	@Tip = %(T_48_META_API_5003_P0_D)\r
    LeaderboardName : String #%(T_40_XXJ_WS_LEADERBOARDNAME)\r
	@Tip = %(T_48_META_API_5003_P1_D)\r
    Key : String #%(T_40_XXJ_WS_DBKEY_NAMEKEY)\r
	@Tip = %(T_48_META_API_5003_P2_D)\r
    out Result : List #%(T_40_XXJ_WS_RESULT_NAMEKEY)\r
	@Tip = %(T_48_META_API_5003_P3_D)\r
    WorkshopCode : String #%(T_42_XXJ_WS_WORKSHOPCODE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=WriteLeadboardToDatabase_Deprecate\r
@Tip = %(T_48_META_API_5004_D)\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action WriteDBLeaderboardValue = 5004 { #%(T_40_XXJ_WS_WRITELEADERBOARD)\r
	@Tip = %(T_48_META_API_5004_P0_D)\r
    LeaderboardName : String #%(T_40_XXJ_WS_LEADERBOARDNAME)\r
	@Tip = %(T_48_META_API_5004_P1_D)\r
    Key : String #%(T_40_XXJ_WS_DBKEY_NAMEKEY)\r
	@Tip = %(T_48_META_API_5004_P2_D)\r
    Value : Int #%(T_40_XXJ_WS_VALUE_NAMEKEY)\r
	@Tip = %(T_48_META_API_5004_P3_D)\r
    WorkshopCode : String #%(T_42_XXJ_WS_WORKSHOPCODE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=DeleteFromLeadboardDatabaseByKey_Deprecate\r
@Tip = %(T_48_META_API_5005_D)\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action DeleteDBLeaderboardValueByKey = 5005 { #%(T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYKEY)\r
	@Tip = %(T_48_META_API_5005_P0_D)\r
    LeaderboardName : String #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_5005_P1_D)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
	@Tip = %(T_48_META_API_5005_P2_D)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=DeleteFromLeadboardDatabaseByRank_Deprecate\r
@Tip = %(T_48_META_API_5006_D)\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action DeleteDBLeaderboardValueByOrder = 5006 { #%(T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYRANK)\r
	@Tip = %(T_48_META_API_5006_P0_D)\r
    LeaderboardName : String #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_5006_P1_D)\r
    Order : Int #%(T_46_META_WS_A_RANK)\r
	@Tip = %(T_48_META_API_5006_P2_D)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=ReadLeadboardFromDatabaseByRank_Deprecate\r
@Async\r
@Tip = %(T_48_META_API_5007_D)\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action ReadDBLeaderboardValuesByRange = 5007 { #%(T_40_XXJ_WS_READLEADERBOARD2)\r
	@Tip = %(T_48_META_API_5007_P0_D)\r
    LeaderboardName : String #%(T_40_XXJ_WS_LEADERBOARDNAME)\r
	@Tip = %(T_48_META_API_5007_P1_D)\r
    StartIndex : Int #%(T_40_XXJ_WS_ORDER1)\r
	@Tip = %(T_48_META_API_5007_P2_D)\r
    EndIndex : Int #%(T_40_XXJ_WS_ORDER2)\r
	@Tip = %(T_48_META_API_5007_P3_D)\r
    out Result : List #%(T_40_XXJ_WS_RESULT_NAMEKEY)\r
	@Tip = %(T_48_META_API_5007_P4_D)\r
    WorkshopCode : String #%(T_42_XXJ_WS_WORKSHOPCODE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=ReadAccumulatedValueFromDatabase_Deprecate\r
@Async\r
@Tip = %(T_48_META_API_5008_D)\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action ReadDBAccumulatedData = 5008 { #%(T_41_XXJ_WS_READDBACCUMULATEDDATA)\r
	@Tip = %(T_48_META_API_5008_P0_D)\r
    SheetName : String #%(T_40_XXJ_WS_DBTABLENAME)\r
	@Tip = %(T_48_META_API_5008_P1_D)\r
    Key : String #%(T_40_XXJ_WS_DBKEY_NAMEKEY)\r
	@Tip = %(T_48_META_API_5008_P2_D)\r
    out Result : Int #%(T_40_XXJ_WS_RESULT_NAMEKEY)\r
	@Tip = %(T_48_META_API_5008_P3_D)\r
    WorkshopCode : String #%(T_42_XXJ_WS_WORKSHOPCODE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=WriteAccumulatedValueToDatabase_Deprecate\r
@Tip = %(T_48_META_API_5009_D)\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action WriteDBAccumulatedDataOffset = 5009 { #%(T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET)\r
	@Tip = %(T_48_META_API_5009_P0_D)\r
    SheetName : String #%(T_40_XXJ_WS_DBTABLENAME)\r
	@Tip = %(T_48_META_API_5009_P1_D)\r
    Key : String #%(T_40_XXJ_WS_DBKEY_NAMEKEY)\r
	@Tip = %(T_48_META_API_5009_P2_D)\r
    ArithmeticType : Int #%(T_36_WZY_WS_OPERMETHOD_NAME)\r
	@Tip = %(T_48_META_API_5009_P3_D)\r
    Offset : Int #%(T_41_XXJ_WS_OFFSET)\r
	@Tip = %(T_48_META_API_5009_P4_D)\r
    WorkshopCode : String #%(T_42_XXJ_WS_WORKSHOPCODE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=NewTweenCurve_Deprecated\r
@Tip = %(T_48_META_API_10036_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
@ApiTarget=2\r
@Return = %(T_48_META_API_10036_R_D)\r
variable NewTweenCurve : TweenCurve = 10036 { #%(T_39_WZY_WS_TWEENCURVE_NAME)\r
	@Tip = %(T_48_META_API_10036_P0_D)\r
    ControlPoints : ListT_Float #%(T_36_WZY_WS_FLOATLIST)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateCurve\r
@Tip = %(T_48_META_API_48_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
@Return = %(T_48_META_API_48_R_D)\r
variable NewTweenCurveV2 : BezierCurve = 48 { #%(T_46_META_WS_CREATECURVE)\r
	@Tip = %(T_48_META_API_48_P0_D)\r
    ControlPoints : ListT_Float #%(T_46_META_WS_A_CURVE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Play\r
@Tip = %(T_48_META_API_10037_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
action PlayPlayable = 10037 { #%(T_46_META_WS_PLAY)\r
	@Tip = %(T_48_META_API_10037_P0_D)\r
    PlayableEntities : PlayableOrListPlayable #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_10037_P1_D)\r
    Reset : Bool #%(T_46_META_WS_A_RESET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Reset\r
@Tip = %(T_48_META_API_51_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
action ResetPlayable = 51 { #%(T_46_META_WS_RESET)\r
	@Tip = %(T_48_META_API_51_P0_D)\r
    PlayableEntities : PlayableOrListPlayable #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Pause\r
@Tip = %(T_48_META_API_10038_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
action PausePlayable = 10038 { #%(T_46_META_WS_PAUSE)\r
	@Tip = %(T_48_META_API_10038_P0_D)\r
    PlayableEntities : PlayableOrListPlayable #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateTrajectory\r
@Tip = %(T_48_META_API_10039_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
action CreatePlayableTrajectory = 10039 { #%(T_46_META_WS_CREATETRAJECTORY)\r
	@Tip = %(T_48_META_API_10039_P0_D)\r
    TargetEntity : Entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_10039_P1_D)\r
    InitialVelocity : Vector3 #%(T_46_META_WS_A_INITIALVELOCITY)\r
	@Tip = %(T_48_META_API_10039_P2_D)\r
    Acceleration : Vector3 #%(T_46_META_WS_A_ACCELERATION)\r
	@Tip = %(T_48_META_API_10039_P3_D)\r
    MaxDisplacement : Float #%(T_46_META_WS_A_MAXDISPLACEMENT)\r
	@Tip = %(T_48_META_API_10039_P4_D)\r
    out EntityVarName : PlayableTrajectory #%(T_46_META_WS_A_CREATEDENTITY)\r
	@Tip = %(T_48_META_API_10039_P5_D)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateFollow\r
@Tip = %(T_48_META_API_10040_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
action CreatePlayablePosFollow = 10040 { #%(T_46_META_WS_CREATEFOLLOW)\r
	@Tip = %(T_48_META_API_10040_P0_D)\r
    HostEntity : Entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_10040_P1_D)\r
    TargetEntity : Entity #%(T_46_META_WS_A_FOLLOWTARGET)\r
	@Tip = %(T_48_META_API_10040_P2_D)\r
    Offset : Vector3 #%(T_46_META_WS_A_OFFSET)\r
	@Tip = %(T_48_META_API_10040_P3_D)\r
    CoordinateType : CoordinateType #%(T_46_META_WS_A_COORDINATESYSTEM)\r
	@Tip = %(T_48_META_API_10040_P4_D)\r
    out EntityVarName : PlayablePosFollow #%(T_46_META_WS_A_CREATEDENTITY)\r
	@Tip = %(T_48_META_API_10040_P5_D)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateLookAt\r
@Tip = %(T_48_META_API_10041_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
action CreatePlayableLookAt = 10041 { #%(T_46_META_WS_CREATELOOKAT)\r
	@Tip = %(T_48_META_API_10041_P0_D)\r
    HostEntity : Entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_10041_P1_D)\r
    TargetEntity : Entity #%(T_46_META_WS_A_LOOKATTARGET)\r
	@Tip = %(T_48_META_API_10041_P2_D)\r
    Offset : Vector3 #%(T_46_META_WS_A_OFFSET)\r
	@Tip = %(T_48_META_API_10041_P3_D)\r
    CoordinateType : CoordinateType #%(T_46_META_WS_A_COORDINATESYSTEM)\r
	@Tip = %(T_48_META_API_10041_P4_D)\r
    out EntityVarName : PlayableLookAt #%(T_46_META_WS_A_CREATEDENTITY)\r
	@Tip = %(T_48_META_API_10041_P5_D)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=SetMatchResult_Deprecate\r
@Tip = %(T_48_META_API_10042_D)\r
@ModuleID=15\r
@ModuleLib=GameResult\r
@ApiTarget=2\r
action SetMatchResult = 10042 { #%(T_39_WZY_WS_LOADRESULT_NAME)\r
	@Tip = %(T_48_META_API_10042_P0_D)\r
    Player : Player #%(T_34_WT_WS_ENTITY7_PARAM1)\r
	@Tip = %(T_48_META_API_10042_P1_D)\r
    Result : MatchResultType #%(T_34_M_WS_RESULTS)\r
	@Tip = %(T_48_META_API_10042_P2_D)\r
    Rank : Int #%(TXT_PLAYER_RANK)\r
	@Tip = %(T_48_META_API_10042_P3_D)\r
    ScoreName : ListT_String #%(T_39_WZY_WS_SCORENAME)\r
	@Tip = %(T_48_META_API_10042_P4_D)\r
    ScoreValue : ListT_String #%(T_34_WT_WS_ENTITY20_PARAM3)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=QuitGame\r
@Tip = %(T_48_META_API_10060_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action KickOutPlayer = 10060 { #%(T_46_META_WS_QUITGAME)\r
	@Tip = %(T_48_META_API_10060_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_10060_P1_D)\r
    IsShowMatchResult : Bool #%(T_46_META_WS_A_SHOWMATCHRESULT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetPropertySmoothly\r
@Tip = %(T_48_META_API_10043_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action SetReplicationDataSmoothly = 10043 { #%(T_46_META_WS_SETPROPERTYSMOOTHLY)\r
	@Tip = %(T_48_META_API_10043_P0_D)\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_10043_P1_D)\r
    PropertyIndex : Property #%(T_46_META_WS_A_PROPERTY)\r
	@Tip = %(T_48_META_API_10043_P2_D)\r
    PropertyValue : Object #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateCustomUIWidget\r
@Tip = %(T_48_META_API_9016_D)\r
@ModuleID=16\r
@ModuleLib=Hud\r
action CreateCustomHudWidget = 9016 { #%(T_46_META_WS_CREATECUSTOMUIWIDGET)\r
	@Tip = %(T_48_META_API_9016_P0_D)\r
    out EntityVarName : HudWidget #%(T_46_META_WS_A_CREATEDENTITY)\r
	@Tip = %(T_48_META_API_9016_P1_D)\r
    WidgetType : HudWidgetType #%(T_46_META_WS_A_WIDGETTYPE)\r
	@Tip = %(T_48_META_API_9016_P2_D)\r
    HudEntity : CustomHud #%(T_46_META_WS_A_UI)\r
	@Tip = %(T_48_META_API_9016_P3_D)\r
    @optional\r
    ParentWidget : HudWidget #%(T_46_META_WS_A_PARENTWIDGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SingleRaycast\r
@Tip = %(T_48_META_API_10044_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
action SingleRaycast = 10044 { #%(T_46_META_WS_SINGLERAYCAST)\r
	@Tip = %(T_48_META_API_10044_P0_D)\r
    StartPos : Vector3 #%(T_46_META_WS_A_STARTPOSITION)\r
	@Tip = %(T_48_META_API_10044_P1_D)\r
    Direction : Vector3 #%(T_46_META_WS_A_DIRECTION)\r
	@Tip = %(T_48_META_API_10044_P2_D)\r
    Distance : Float #%(T_46_META_WS_A_DISTANCE)\r
	@Tip = %(T_48_META_API_10044_P3_D)\r
    LayerMask : ListT_int #%(T_46_META_WS_A_LAYERMASK)\r
	@Tip = %(T_48_META_API_10044_P4_D)\r
    IncludeTrigger : Bool #%(T_46_META_WS_A_INCLUDETRIGGER)\r
	@Tip = %(T_48_META_API_10044_P5_D)\r
    out HitEntity : Entity #%(T_46_META_WS_A_HITENTITIES)\r
	@Tip = %(T_48_META_API_10044_P6_D)\r
    out HitPosition : Vector3 #%(T_46_META_WS_A_HITPOINTS)\r
	@Tip = %(T_48_META_API_10044_P7_D)\r
    out HitDistance : Float #%(T_46_META_WS_A_HITDISTANCES)\r
	@Tip = %(T_48_META_API_10044_P8_D)\r
    out HitNormal : Vector3 #%(T_46_META_WS_A_HITNORMALS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MultiRaycast\r
@Tip = %(T_48_META_API_10045_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
action MultiRaycast = 10045 { #%(T_46_META_WS_MULTIRAYCAST)\r
	@Tip = %(T_48_META_API_10045_P0_D)\r
    StartPos : Vector3 #%(T_46_META_WS_A_STARTPOSITION)\r
	@Tip = %(T_48_META_API_10045_P1_D)\r
    Direction : Vector3 #%(T_46_META_WS_A_DIRECTION)\r
	@Tip = %(T_48_META_API_10045_P2_D)\r
    Distance : Float #%(T_46_META_WS_A_DISTANCE)\r
	@Tip = %(T_48_META_API_10045_P3_D)\r
    LayerMask : ListT_int #%(T_46_META_WS_A_LAYERMASK)\r
	@Tip = %(T_48_META_API_10045_P4_D)\r
    IncludeTrigger : Bool #%(T_46_META_WS_A_INCLUDETRIGGER)\r
	@Tip = %(T_48_META_API_10045_P5_D)\r
    out HitEntities : ListT_Entity #%(T_46_META_WS_A_HITENTITIES)\r
	@Tip = %(T_48_META_API_10045_P6_D)\r
    out HitPoints : ListT_Vector3 #%(T_46_META_WS_A_HITPOINTS)\r
	@Tip = %(T_48_META_API_10045_P7_D)\r
    out HitDistances : ListT_Float #%(T_46_META_WS_A_HITDISTANCES)\r
	@Tip = %(T_48_META_API_10045_P8_D)\r
    out HitNormals : ListT_Vector3 #%(T_46_META_WS_A_HITNORMALS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BoxCast\r
@Tip = %(T_48_META_API_17_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
action BoxCast = 17 { #%(T_46_META_WS_BOXCAST)\r
	@Tip = %(T_48_META_API_17_P0_D)\r
    HalfExtents : Vector3 #%(T_46_META_WS_A_HALFEXTENTS)\r
	@Tip = %(T_48_META_API_17_P1_D)\r
    Position : Vector3 #%(T_46_META_WS_A_CENTER)\r
	@Tip = %(T_48_META_API_17_P2_D)\r
    Rotation : Vector3 #%(T_46_META_WS_A_ROTATION)\r
	@Tip = %(T_48_META_API_17_P3_D)\r
    Direction : Vector3 #%(T_46_META_WS_A_DIRECTION)\r
	@Tip = %(T_48_META_API_17_P4_D)\r
    MaxDistance : Float #%(T_46_META_WS_A_MAXDISTANCE)\r
	@Tip = %(T_48_META_API_17_P5_D)\r
    LayerMask : ListT_int #%(T_46_META_WS_A_LAYERMASK)\r
	@Tip = %(T_48_META_API_17_P6_D)\r
    IncludeTrigger : Bool #%(T_46_META_WS_A_INCLUDETRIGGER)\r
	@Tip = %(T_48_META_API_17_P7_D)\r
    out HitEntitysName : ListT_Entity #%(T_46_META_WS_A_HITENTITIES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SphereCast\r
@Tip = %(T_48_META_API_18_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
action SphereCast = 18 { #%(T_46_META_WS_SPHERECAST)\r
	@Tip = %(T_48_META_API_18_P0_D)\r
    Radius : Float #%(T_46_META_WS_A_RADIUS)\r
	@Tip = %(T_48_META_API_18_P1_D)\r
    Position : Vector3 #%(T_46_META_WS_A_CENTER)\r
	@Tip = %(T_48_META_API_18_P2_D)\r
    Direction : Vector3 #%(T_46_META_WS_A_DIRECTION)\r
	@Tip = %(T_48_META_API_18_P3_D)\r
    MaxDistance : Float #%(T_46_META_WS_A_MAXDISTANCE)\r
	@Tip = %(T_48_META_API_18_P4_D)\r
    LayerMask : ListT_int #%(T_46_META_WS_A_LAYERMASK)\r
	@Tip = %(T_48_META_API_18_P5_D)\r
    IncludeTrigger : Bool #%(T_46_META_WS_A_INCLUDETRIGGER)\r
	@Tip = %(T_48_META_API_18_P6_D)\r
    out HitEntitysName : ListT_Entity #%(T_46_META_WS_A_HITENTITIES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CapsuleCast\r
@Tip = %(T_48_META_API_19_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
action CapsuleCast = 19 { #%(T_46_META_WS_CAPSULECAST)\r
	@Tip = %(T_48_META_API_19_P0_D)\r
    Radius : Float #%(T_46_META_WS_A_RADIUS)\r
	@Tip = %(T_48_META_API_19_P1_D)\r
    Height : Float #%(T_46_META_WS_A_HEIGHT)\r
	@Tip = %(T_48_META_API_19_P2_D)\r
    Position : Vector3 #%(T_46_META_WS_A_CENTER)\r
	@Tip = %(T_48_META_API_19_P3_D)\r
    Rotation : Vector3 #%(T_46_META_WS_A_ROTATION)\r
	@Tip = %(T_48_META_API_19_P4_D)\r
    Direction : Vector3 #%(T_46_META_WS_A_DIRECTION)\r
	@Tip = %(T_48_META_API_19_P5_D)\r
    MaxDistance : Float #%(T_46_META_WS_A_MAXDISTANCE)\r
	@Tip = %(T_48_META_API_19_P6_D)\r
    LayerMask : ListT_int #%(T_46_META_WS_A_LAYERMASK)\r
	@Tip = %(T_48_META_API_19_P7_D)\r
    IncludeTrigger : Bool #%(T_46_META_WS_A_INCLUDETRIGGER)\r
	@Tip = %(T_48_META_API_19_P8_D)\r
    out HitEntitysName : ListT_Entity #%(T_46_META_WS_A_HITENTITIES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BoxOverlap\r
@Tip = %(T_48_META_API_20_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
action BoxOverlap = 20 { #%(T_46_META_WS_BOXOVERLAP)\r
	@Tip = %(T_48_META_API_20_P0_D)\r
    HalfExtents : Vector3 #%(T_46_META_WS_A_HALFEXTENTS)\r
	@Tip = %(T_48_META_API_20_P1_D)\r
    Position : Vector3 #%(T_46_META_WS_A_CENTER)\r
	@Tip = %(T_48_META_API_20_P2_D)\r
    Rotation : Vector3 #%(T_46_META_WS_A_ROTATION)\r
	@Tip = %(T_48_META_API_20_P3_D)\r
    LayerMask : ListT_int #%(T_46_META_WS_A_LAYERMASK)\r
	@Tip = %(T_48_META_API_20_P4_D)\r
    IncludeTrigger : Bool #%(T_46_META_WS_A_INCLUDETRIGGER)\r
	@Tip = %(T_48_META_API_20_P5_D)\r
    out HitEntitysName : ListT_Entity #%(T_46_META_WS_A_HITENTITIES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SphereOverlap\r
@Tip = %(T_48_META_API_21_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
action SphereOverlap = 21 { #%(T_46_META_WS_SPHEREOVERLAP)\r
	@Tip = %(T_48_META_API_21_P0_D)\r
    Radius : Float #%(T_46_META_WS_A_RADIUS)\r
	@Tip = %(T_48_META_API_21_P1_D)\r
    Position : Vector3 #%(T_46_META_WS_A_CENTER)\r
	@Tip = %(T_48_META_API_21_P2_D)\r
    LayerMask : ListT_int #%(T_46_META_WS_A_LAYERMASK)\r
	@Tip = %(T_48_META_API_21_P3_D)\r
    IncludeTrigger : Bool #%(T_46_META_WS_A_INCLUDETRIGGER)\r
	@Tip = %(T_48_META_API_21_P4_D)\r
    out HitEntitysName : ListT_Entity #%(T_46_META_WS_A_HITENTITIES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CapsuleOverlap\r
@Tip = %(T_48_META_API_22_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
action CapsuleOverlap = 22 { #%(T_46_META_WS_CAPSULEOVERLAP)\r
	@Tip = %(T_48_META_API_22_P0_D)\r
    Radius : Float #%(T_46_META_WS_A_RADIUS)\r
	@Tip = %(T_48_META_API_22_P1_D)\r
    Height : Float #%(T_46_META_WS_A_HEIGHT)\r
	@Tip = %(T_48_META_API_22_P2_D)\r
    Position : Vector3 #%(T_46_META_WS_A_CENTER)\r
	@Tip = %(T_48_META_API_22_P3_D)\r
    Rotation : Vector3 #%(T_46_META_WS_A_ROTATION)\r
	@Tip = %(T_48_META_API_22_P4_D)\r
    LayerMask : ListT_int #%(T_46_META_WS_A_LAYERMASK)\r
	@Tip = %(T_48_META_API_22_P5_D)\r
    IncludeTrigger : Bool #%(T_46_META_WS_A_INCLUDETRIGGER)\r
	@Tip = %(T_48_META_API_22_P6_D)\r
    out HitEntitysName : ListT_Entity #%(T_46_META_WS_A_HITENTITIES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddForce\r
@Tip = %(T_48_META_API_24_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
action AddForce = 24 { #%(T_46_META_WS_ADDFORCE)\r
	@Tip = %(T_48_META_API_24_P0_D)\r
    PhysicalObject : PhysicalObject #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_24_P1_D)\r
    Force : Vector3 #%(T_46_META_WS_A_FORCE)\r
	@Tip = %(T_48_META_API_24_P2_D)\r
    ForceMode : ForceType #%(T_46_META_WS_A_FORCEMODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddForceAtPosition\r
@Tip = %(T_48_META_API_25_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
action AddForceAtPosition = 25 { #%(T_46_META_WS_ADDFORCEATPOSITION)\r
	@Tip = %(T_48_META_API_25_P0_D)\r
    RigidbodyObject : Rigidbody #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_25_P1_D)\r
    Force : Vector3 #%(T_46_META_WS_A_FORCE)\r
	@Tip = %(T_48_META_API_25_P2_D)\r
    Position : Vector3 #%(T_46_META_WS_A_POSITION)\r
	@Tip = %(T_48_META_API_25_P3_D)\r
    ForceMode : ForceType #%(T_46_META_WS_A_FORCEMODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddTorque\r
@Tip = %(T_48_META_API_26_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
action AddTorque = 26 { #%(T_46_META_WS_ADDTORQUE)\r
	@Tip = %(T_48_META_API_26_P0_D)\r
    RigidbodyObject : Rigidbody #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_26_P1_D)\r
    Torque : Vector3 #%(T_46_META_WS_A_TORQUE)\r
	@Tip = %(T_48_META_API_26_P2_D)\r
    ForceMode : ForceType #%(T_46_META_WS_A_FORCEMODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MoveCCT\r
@Tip = %(T_48_META_API_89_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
@ApiTarget=2\r
action CCTMoveV2 = 89 { #%(T_44_XXJ_WS_CCTMOVE)\r
	@Tip = %(T_48_META_API_89_P0_D)\r
    Target : PhysicalCCT #%(T_44_XXJ_WS_TARGET)\r
	@Tip = %(T_48_META_API_89_P1_D)\r
    Movement : Vector3 #%(T_44_XXJ_WS_MOVEMENT)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=MoveCCT_Deprecated\r
@Tip = %(T_48_META_API_62_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
@ApiTarget=2\r
action CCTMove = 62 { #%(T_46_META_WS_MOVECCT)\r
	@Tip = %(T_48_META_API_62_P0_D)\r
    Target : PhysicalCCT #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_62_P1_D)\r
    Movement : Vector3 #%(T_46_META_WS_A_DISPLACEMENT)\r
	@Tip = %(T_48_META_API_62_P2_D)\r
    out IsTopColliding : Bool #%(T_46_META_WS_A_ISTOPCOLLIDING)\r
	@Tip = %(T_48_META_API_62_P3_D)\r
    out IsSideColliding : Bool #%(T_46_META_WS_A_ISSIDECOLLIDING)\r
	@Tip = %(T_48_META_API_62_P4_D)\r
    out IsBottomColliding : Bool #%(T_46_META_WS_A_ISBOTTOMCOLLIDING)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TeleportCCT\r
@Tip = %(T_48_META_API_82_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
@ApiTarget=2\r
action CCTTeleport = 82 { #%(T_46_META_WS_TELEPORTCCT)\r
	@Tip = %(T_48_META_API_82_P0_D)\r
    Target : PhysicalCCT #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_82_P1_D)\r
    TargetPosition : Vector3 #%(T_46_META_WS_A_POSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MovePosition\r
@Tip = %(T_48_META_API_27_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
action MovePosition = 27 { #%(T_46_META_WS_MOVEPOSITION)\r
	@Tip = %(T_48_META_API_27_P0_D)\r
    RigidbodyObject : Rigidbody #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_27_P1_D)\r
    Position : Vector3 #%(T_46_META_WS_A_POSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MoveRotation\r
@Tip = %(T_48_META_API_28_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
action MoveRotation = 28 { #%(T_46_META_WS_MOVEROTATION)\r
	@Tip = %(T_48_META_API_28_P0_D)\r
    RigidbodyObject : Rigidbody #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_28_P1_D)\r
    Rotation : Quaternion #%(T_46_META_WS_A_POSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Sleep\r
@Tip = %(T_48_META_API_36_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
action Sleep = 36 { #%(T_46_META_WS_SLEEP)\r
	@Tip = %(T_48_META_API_36_P0_D)\r
    RigidbodyObject : Rigidbody #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Wakeup\r
@Tip = %(T_48_META_API_37_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
action Wakeup = 37 { #%(T_46_META_WS_WAKEUP)\r
	@Tip = %(T_48_META_API_37_P0_D)\r
    RigidbodyObject : Rigidbody #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IsSleeping\r
@Tip = %(T_48_META_API_38_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Return = %(T_48_META_API_38_R_D)\r
variable IsSleeping : Bool = 38 { #%(T_46_META_WS_ISSLEEPING)\r
	@Tip = %(T_48_META_API_38_P0_D)\r
    RigidbodyObject : Rigidbody #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetSleepThreshold\r
@Tip = %(T_48_META_API_39_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
action SetSleepThreshold = 39 { #%(T_46_META_WS_SETSLEEPTHRESHOLD)\r
	@Tip = %(T_48_META_API_39_P0_D)\r
    RigidbodyObject : Rigidbody #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_39_P1_D)\r
    Threshold : Float #%(T_46_META_WS_A_THRESHOLD)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetSleepThreshold\r
@Tip = %(T_48_META_API_40_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Return = %(T_48_META_API_40_R_D)\r
variable GetSleepThreshold : Float = 40 { #%(T_46_META_WS_GETSLEEPTHRESHOLD)\r
	@Tip = %(T_48_META_API_40_P0_D)\r
    RigidbodyObject : Rigidbody #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetGlobalSleepThreshold\r
@Tip = %(T_48_META_API_41_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
action SetGlobalSleepThreshold = 41 { #%(T_46_META_WS_SETGLOBALSLEEPTHRESHOLD)\r
	@Tip = %(T_48_META_API_41_P0_D)\r
    Threshold : Float #%(T_46_META_WS_A_THRESHOLD)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetGlobalSleepThreshold\r
@Tip = %(T_48_META_API_42_D)\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Return = %(T_48_META_API_42_R_D)\r
variable GetGlobalSleepThreshold : Float = 42 { #%(T_46_META_WS_GETGLOBALSLEEPTHRESHOLD)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=SetPlayerBonesScale_Deprecated\r
@Tip = %(T_48_META_API_3221_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action SetPlayerBonesScale = 3221 { #%(T_40_XXJ_WS_BONESCALE_NAMEKEY)\r
	@Tip = %(T_48_META_API_3221_P0_D)\r
    Player : Player #%(T_34_WT_WS_ENTITY7_PARAM1)\r
	@Tip = %(T_48_META_API_3221_P1_D)\r
    PlayerBonesType : PlayerBonesType #%(T_40_XXJ_WS_SKELETON)\r
	@Tip = %(T_48_META_API_3221_P2_D)\r
    Scale : Vector3 #%(T_40_XXJ_WS_SCALE_NAMEKEY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateFromPrefab\r
@Tip = %(T_48_META_API_10046_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action CreateEntityFromPrefab = 10046 { #%(T_46_META_WS_CREATEFROMPREFAB)\r
	@Tip = %(T_48_META_API_10046_P0_D)\r
    out EntityVarName : Entity #%(T_46_META_WS_A_CREATEDENTITY)\r
	@Tip = %(T_48_META_API_10046_P1_D)\r
    TargetPrefabID : PrefabID #%(T_46_META_WS_A_PREFAB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=InstantiatePrefab\r
@Tip = %(T_48_META_API_96_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action InstantiatePrefab = 96 { #%(T_48_META_API_96)\r
	@Tip = %(T_48_META_API_10046_P0_D)\r
    out EntityVarName : Entity #%(T_46_META_WS_A_CREATEDENTITY)\r
	@Tip = %(T_48_META_API_10046_P1_D)\r
    TargetPrefabID : PrefabID #%(T_46_META_WS_A_PREFAB)\r
	@Tip = %(T_48_META_API_96_P2_D)\r
    Async : Bool #%(T_48_META_API_96_P2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateMonster\r
@Tip = %(T_48_META_API_76_D)\r
@ModuleID=10008\r
@ModuleLib=AI\r
@ApiTarget=2\r
action CreateZombie = 76 { #%(T_46_META_WS_CREATEMONSTER)\r
	@Tip = %(T_48_META_API_76_P0_D)\r
    out Zombie : AI #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_76_P1_D)\r
    Position : Vector3 #%(T_46_META_WS_A_POSITION)\r
	@Tip = %(T_48_META_API_76_P2_D)\r
    AIType : AIType #%(T_46_META_WS_A_TYPE)\r
	@Tip = %(T_48_META_API_76_P3_D)\r
    TeamIndex : Int #%(T_46_META_WS_A_TEAMSEQ)\r
	@Tip = %(T_48_META_API_76_P4_D)\r
    ChaseEnemy : Bool #%(T_46_META_WS_A_CHASEENEMY)\r
	@Tip = %(T_48_META_API_76_P5_D)\r
    ActionType : ActionType #%(T_46_META_WS_A_ACTIONTYPE)\r
	@Tip = %(T_48_META_API_76_P6_D)\r
    Path : CustomPath #%(T_46_META_WS_A_PATH)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetPlayerCanQuitMidway\r
@Tip = %(T_48_META_API_90_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
action SetPlayerCanFreeQuit = 90 { #%(T_47_XXJ_WS_SETPLAYERCANQUITMIDWAY)\r
	@Tip = %(T_48_META_API_90_P0_D)\r
    PlayerEntity : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_90_P1_D)\r
    CanFreeQuit : Bool #%(T_48_META_API_90_P1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=HitFly\r
@Tip = %(T_48_META_API_3222_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action HitFlyPlayer = 3222 { #%(T_46_META_WS_HITFLY)\r
	@Tip = %(T_48_META_API_3222_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3222_P1_D)\r
    Dir : Vector3 #%(T_46_META_WS_A_DIRECTION)\r
	@Tip = %(T_48_META_API_3222_P2_D)\r
    FlyTime : Float #%(T_46_META_WS_A_DURATION)\r
	@Tip = %(T_48_META_API_3222_P3_D)\r
    VelocityY : Float #%(T_46_META_WS_A_VELOCITYY)\r
	@Tip = %(T_48_META_API_3222_P4_D)\r
    VelcityXZ : Float #%(T_46_META_WS_A_VELOCITYXZ)\r
	@Tip = %(T_48_META_API_3222_P5_D)\r
    ChangeFwd : Bool #%(T_46_META_WS_A_CHANGEROTATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetOutfit\r
@Tip = %(T_48_META_API_3223_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3223_R_D)\r
variable GetPlayerClothIDByWardrobeType : ClothID = 3223 { #%(T_46_META_WS_GETOUTFIT)\r
	@Tip = %(T_48_META_API_3223_P0_D)\r
    Player : PlayerOrNPC #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3223_P1_D)\r
    WardrobeType : WardrobeType #%(T_46_META_WS_A_TYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetOutfit\r
@Tip = %(T_48_META_API_3224_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action SetPlayerClothID = 3224 { #%(T_46_META_WS_SETOUTFIT)\r
	@Tip = %(T_48_META_API_3224_P0_D)\r
    Player : PlayerOrNPC #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3224_P1_D)\r
    ClothID : ClothID #%(T_46_META_WS_A_OUTFIT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ResetOutfit\r
@Tip = %(T_48_META_API_3225_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action ReSetPlayerClothes = 3225 { #%(T_46_META_WS_RESETOUTFIT)\r
	@Tip = %(T_48_META_API_3225_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetWeaponSkin\r
@Tip = %(T_48_META_API_3228_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3228_R_D)\r
variable GetPlayerWeaponSkinIDByWeaponID : WeaponSkinID = 3228 { #%(T_46_META_WS_GETWEAPONSKIN)\r
	@Tip = %(T_48_META_API_3228_P0_D)\r
    Player : PlayerOrNPC #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3228_P1_D)\r
    WeaponID : ItemGoodsIDType #%(T_46_META_WS_A_WEAPON)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetWeaponSkin\r
@Tip = %(T_48_META_API_3229_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action SetPlayerWeaponSkinID = 3229 { #%(T_46_META_WS_SETWEAPONSKIN)\r
	@Tip = %(T_48_META_API_3229_P0_D)\r
    Player : PlayerOrNPC #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3229_P1_D)\r
    WeaponSkinID : WeaponSkinID #%(T_46_META_WS_A_WEAPONSKIN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ResetWeaponSkin\r
@Tip = %(T_48_META_API_3230_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action ReSetPlayerWeaponSkinByWeaponID = 3230 { #%(T_46_META_WS_RESETWEAPONSKIN)\r
	@Tip = %(T_48_META_API_3230_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3230_P1_D)\r
    WeaponID : ItemGoodsIDType #%(T_46_META_WS_A_WEAPON)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetBundle\r
@Tip = %(T_48_META_API_3231_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action SetPlayerClothIDs = 3231 { #%(T_46_META_WS_SETBUNDLE)\r
	@Tip = %(T_48_META_API_3231_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3231_P1_D)\r
    Clothes : ListT_ClothID #%(T_46_META_WS_A_OUTFITS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveOutfit\r
@Tip = %(T_48_META_API_3232_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action RemovePlayerClothIDByWardrobeType = 3232 { #%(T_46_META_WS_REMOVEOUTFIT)\r
	@Tip = %(T_48_META_API_3232_P0_D)\r
    Player : PlayerOrNPC #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3232_P1_D)\r
    WardrobeType : WardrobeType #%(T_46_META_WS_A_TYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveWeaponSkin\r
@Tip = %(T_48_META_API_3233_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action RemovePlayerWeaponSkinByWeaponID = 3233 { #%(T_46_META_WS_REMOVEWEAPONSKIN)\r
	@Tip = %(T_48_META_API_3233_P0_D)\r
    Player : PlayerOrNPC #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3233_P1_D)\r
    WeaponID : ItemGoodsIDType #%(T_46_META_WS_A_WEAPON)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Max\r
@Tip = %(T_48_META_API_1536_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1536_R_D)\r
variable Max : Number = 1536 { #%(T_46_META_WS_MAX)\r
	@Tip = %(T_48_META_API_1536_P0_D)\r
    Value1 : Number #%(T_46_META_WS_A_VALUEA)\r
	@Tip = %(T_48_META_API_1536_P1_D)\r
    Value2 : Number #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Max\r
@Tip = %(T_48_META_API_1537_D)\r
@ModuleID=10001\r
@ModuleLib=List\r
action ListFindMax = 1537 { #%(T_46_META_WS_MAX)\r
	@Tip = %(T_48_META_API_1537_P0_D)\r
    Value : List #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1537_P1_D)\r
    out Result : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
	@Tip = %(T_48_META_API_1537_P2_D)\r
    out ResultValue : Number #%(T_46_META_WS_A_RESULT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Min\r
@Tip = %(T_48_META_API_1538_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1538_R_D)\r
variable Min : Number = 1538 { #%(T_46_META_WS_MIN)\r
	@Tip = %(T_48_META_API_1538_P0_D)\r
    Value1 : Number #%(T_46_META_WS_A_VALUEA)\r
	@Tip = %(T_48_META_API_1538_P1_D)\r
    Value2 : Number #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Min\r
@Tip = %(T_48_META_API_1539_D)\r
@ModuleID=10001\r
@ModuleLib=List\r
action ListFindMin = 1539 { #%(T_46_META_WS_MIN)\r
	@Tip = %(T_48_META_API_1539_P0_D)\r
    Value : List #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1539_P1_D)\r
    out Result : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
	@Tip = %(T_48_META_API_1539_P2_D)\r
    out ResultValue : Number #%(T_46_META_WS_A_RESULT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Lerp\r
@Tip = %(T_48_META_API_1540_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1540_R_D)\r
variable Lerp : Float = 1540 { #%(T_46_META_WS_LERP)\r
	@Tip = %(T_48_META_API_1540_P0_D)\r
    ValueA : Float #%(T_46_META_WS_A_VALUEA)\r
	@Tip = %(T_48_META_API_1540_P1_D)\r
    ValueB : Float #%(T_46_META_WS_A_VALUEB)\r
	@Tip = %(T_48_META_API_1540_P2_D)\r
    ValueT : Float #%(T_46_META_WS_A_VALUET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Clamp\r
@Tip = %(T_48_META_API_1541_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1541_R_D)\r
variable Clamp : Number = 1541 { #%(T_46_META_WS_CLAMP)\r
	@Tip = %(T_48_META_API_1541_P0_D)\r
    Value : Number #%(T_46_META_WS_A_VALUE)\r
	@Tip = %(T_48_META_API_1541_P1_D)\r
    Min : Number #%(T_46_META_WS_A_MIN)\r
	@Tip = %(T_48_META_API_1541_P2_D)\r
    Max : Number #%(T_46_META_WS_A_MAX)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=QuaternionToEulerAngle\r
@Tip = %(T_48_META_API_43_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_43_R_D)\r
variable QuaternionToEulerAngle : Vector3 = 43 { #Math/%(T_46_META_WS_QUATERNIONTOEULERANGLE)\r
	@Tip = %(T_48_META_API_43_P0_D)\r
    Value : Quaternion #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EulerAngleToQuaternion\r
@Tip = %(T_48_META_API_44_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_44_R_D)\r
variable EulerAngleToQuaternion : Quaternion = 44 { #Math/%(T_46_META_WS_EULERANGLETOQUATERNION)\r
	@Tip = %(T_48_META_API_44_P0_D)\r
    Value : Vector3 #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AxisAngleToQuaternion\r
@Tip = %(T_48_META_API_45_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_45_R_D)\r
variable AxisAngleToQuaternion : Quaternion = 45 { #Math/%(T_46_META_WS_AXISANGLETOQUATERNION)\r
	@Tip = %(T_48_META_API_45_P0_D)\r
    Axis : Vector3 #%(T_46_META_WS_A_AXIS)\r
	@Tip = %(T_48_META_API_45_P1_D)\r
    Angle : Float #%(T_46_META_WS_A_ANGLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=QuaternionToAxisAngle\r
@Tip = %(T_48_META_API_46_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
action QuaternionToAxisAngle = 46 { #Math/%(T_46_META_WS_QUATERNIONTOAXISANGLE)\r
	@Tip = %(T_48_META_API_46_P0_D)\r
    Value : Quaternion #%(T_46_META_WS_A_VALUE)\r
	@Tip = %(T_48_META_API_46_P1_D)\r
    out Axis : Vector3 #%(T_46_META_WS_A_AXIS)\r
	@Tip = %(T_48_META_API_46_P2_D)\r
    out Angle : Float #%(T_46_META_WS_A_ANGLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MultiplyQuaternion\r
@Tip = %(T_48_META_API_52_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_52_R_D)\r
variable MultiplyQuaternion : Quaternion = 52 { #Math/%(T_46_META_WS_MULTIPLYQUATERNION)\r
	@Tip = %(T_48_META_API_52_P0_D)\r
    Left : Quaternion #%(T_46_META_WS_A_VALUEA)\r
	@Tip = %(T_48_META_API_52_P1_D)\r
    Right : Quaternion #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LookRotation\r
@Tip = %(T_48_META_API_53_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_53_R_D)\r
variable LookRotation : Quaternion = 53 { #Math/%(T_46_META_WS_LOOKROTATION)\r
	@Tip = %(T_48_META_API_53_P0_D)\r
    Forward : Vector3 #%(T_46_META_WS_A_FORWARD)\r
	@Tip = %(T_48_META_API_53_P1_D)\r
    Upward : Vector3 #%(T_46_META_WS_A_UPWARD)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SlerpQuaternion\r
@Tip = %(T_48_META_API_54_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_54_R_D)\r
variable SlerpQuaternion : Quaternion = 54 { #Math/%(T_46_META_WS_SLERPQUATERNION)\r
	@Tip = %(T_48_META_API_54_P0_D)\r
    A : Quaternion #%(T_46_META_WS_A_VALUEA)\r
	@Tip = %(T_48_META_API_54_P1_D)\r
    B : Quaternion #%(T_46_META_WS_A_VALUEB)\r
	@Tip = %(T_48_META_API_54_P2_D)\r
    Ratio : Float #%(T_46_META_WS_A_VALUET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LerpVector3\r
@Tip = %(T_49_META_API_108_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_54_R_D)\r
variable LerpVector3 : Vector3 = 108 { #Math/%(T_49_META_API_108)\r
	@Tip = %(T_48_META_API_54_P0_D)\r
    A : Vector3 #%(T_46_META_WS_A_VALUEA)\r
	@Tip = %(T_48_META_API_54_P1_D)\r
    B : Vector3 #%(T_46_META_WS_A_VALUEB)\r
	@Tip = %(T_48_META_API_54_P2_D)\r
    Ratio : Float #%(T_46_META_WS_A_VALUET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SlerpVector3\r
@Tip = %(T_49_META_API_111_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_54_R_D)\r
variable SlerpVector3 : Vector3 = 111 { #Math/%(T_49_META_API_111)\r
	@Tip = %(T_48_META_API_54_P0_D)\r
    A : Vector3 #%(T_46_META_WS_A_VALUEA)\r
	@Tip = %(T_48_META_API_54_P1_D)\r
    B : Vector3 #%(T_46_META_WS_A_VALUEB)\r
	@Tip = %(T_48_META_API_54_P2_D)\r
    Ratio : Float #%(T_46_META_WS_A_VALUET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetColorChannel\r
@Tip = %(T_48_META_API_1542_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action ColorGetChannel = 1542 { #%(T_46_META_WS_GETCOLORCHANNEL)\r
	@Tip = %(T_48_META_API_1542_P0_D)\r
    Value : Color #%(T_46_META_WS_A_COLOR)\r
	@Tip = %(T_48_META_API_1542_P1_D)\r
    out ColorR : Int #%(T_46_META_WS_A_R)\r
	@Tip = %(T_48_META_API_1542_P2_D)\r
    out ColorG : Int #%(T_46_META_WS_A_G)\r
	@Tip = %(T_48_META_API_1542_P3_D)\r
    out ColorB : Int #%(T_46_META_WS_A_B)\r
	@Tip = %(T_48_META_API_1542_P4_D)\r
    out ColorA : Int #%(T_46_META_WS_A_A)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=StringToInt\r
@Tip = %(T_48_META_API_1700_D)\r
@ModuleID=10005\r
@ModuleLib=Convert\r
action String2Int = 1700 { #%(T_46_META_WS_STRINGTOINT)\r
	@Tip = %(T_48_META_API_1700_P0_D)\r
    Value : String #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1700_P1_D)\r
    out IntValue : Int #%(T_46_META_WS_A_RESULT)\r
	@Tip = %(T_48_META_API_1700_P2_D)\r
    out Ok : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=StringToFloat\r
@Tip = %(T_48_META_API_1701_D)\r
@ModuleID=10005\r
@ModuleLib=Convert\r
action String2Float = 1701 { #%(T_46_META_WS_STRINGTOFLOAT)\r
	@Tip = %(T_48_META_API_1701_P0_D)\r
    Value : String #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1701_P1_D)\r
    out FloatValue : Float #%(T_46_META_WS_A_RESULT)\r
	@Tip = %(T_48_META_API_1701_P2_D)\r
    out Ok : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ScreenTouchRay\r
@Tip = %(T_48_META_API_63_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=1\r
action CameraTouchRay = 63 { #%(T_46_META_WS_SCREENTOUCHRAY)\r
	@Tip = %(T_48_META_API_63_P0_D)\r
    Position : Vector2 #%(T_46_META_WS_A_TOUCHPOINT)\r
	@Tip = %(T_48_META_API_63_P1_D)\r
    out WorldPosition : Vector3 #%(T_46_META_WS_A_STARTPOSITION)\r
	@Tip = %(T_48_META_API_63_P2_D)\r
    out RayDirection : Vector3 #%(T_46_META_WS_A_DIRECTION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WorldToScreenPoint\r
@Tip = %(T_48_META_API_68_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=1\r
action WorldToScreenPoint = 68 { #%(T_46_META_WS_WORLDTOSCREENPOINT)\r
	@Tip = %(T_48_META_API_68_P0_D)\r
    WorldPosition : Vector3 #%(T_46_META_WS_A_WORLDPOSITION)\r
	@Tip = %(T_48_META_API_68_P1_D)\r
    out InScreen : Bool #%(T_46_META_WS_A_ISMAPPEDINSCREEN)\r
	@Tip = %(T_48_META_API_68_P2_D)\r
    out InScreenPosition : Vector2 #%(T_46_META_WS_A_MAPPEDPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ScreenToWorldPoint\r
@Tip = %(T_48_META_API_69_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=1\r
action ScreenToWorldPoint = 69 { #%(T_46_META_WS_SCREENTOWORLDPOINT)\r
	@Tip = %(T_48_META_API_69_P0_D)\r
    ScreenPosition : Vector2 #%(T_46_META_WS_A_SCREENPOSITION)\r
	@Tip = %(T_48_META_API_69_P1_D)\r
    Depth : Float #%(T_46_META_WS_A_DEPTH)\r
	@Tip = %(T_48_META_API_69_P2_D)\r
    out WorldPosition : Vector3 #%(T_46_META_WS_A_WORLDPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ScreenSingleRaycast\r
@Tip = %(T_48_META_API_70_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=1\r
action CameraSingleRaycast = 70 { #%(T_46_META_WS_SCREENSINGLERAYCAST)\r
	@Tip = %(T_48_META_API_70_P0_D)\r
    StartPosition : Vector2 #%(T_46_META_WS_A_STARTPOSITION)\r
	@Tip = %(T_48_META_API_70_P1_D)\r
    Distance : Float #%(T_46_META_WS_A_DISTANCE)\r
	@Tip = %(T_48_META_API_70_P2_D)\r
    LayerMask : ListT_Int #%(T_46_META_WS_A_LAYERMASK)\r
	@Tip = %(T_48_META_API_70_P3_D)\r
    IncludeTrigger : Bool #%(T_46_META_WS_A_INCLUDETRIGGER)\r
	@Tip = %(T_48_META_API_70_P4_D)\r
    out HitEntity : Entity #%(T_46_META_WS_A_HITENTITY)\r
	@Tip = %(T_48_META_API_70_P5_D)\r
    out HitPosition : Vector3 #%(T_46_META_WS_A_HITPOSITION)\r
	@Tip = %(T_48_META_API_70_P6_D)\r
    out HitDistance : Float #%(T_46_META_WS_A_HITDISTANCE)\r
	@Tip = %(T_48_META_API_70_P7_D)\r
    out HitNormal : Vector3 #%(T_46_META_WS_A_HITNORMAL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ScreenMultiRaycast\r
@Tip = %(T_48_META_API_71_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=1\r
action CameraMultiRaycast = 71 { #%(T_46_META_WS_SCREENMULTIRAYCAST)\r
	@Tip = %(T_48_META_API_71_P0_D)\r
    StartPosition : Vector2 #%(T_46_META_WS_A_STARTPOSITION)\r
	@Tip = %(T_48_META_API_71_P1_D)\r
    Distance : Float #%(T_46_META_WS_A_DISTANCE)\r
	@Tip = %(T_48_META_API_71_P2_D)\r
    LayerMask : ListT_Int #%(T_46_META_WS_A_LAYERMASK)\r
	@Tip = %(T_48_META_API_71_P3_D)\r
    IncludeTrigger : Bool #%(T_46_META_WS_A_INCLUDETRIGGER)\r
	@Tip = %(T_48_META_API_71_P4_D)\r
    out HitEntities : ListT_Entity #%(T_46_META_WS_A_HITENTITIES)\r
	@Tip = %(T_48_META_API_71_P5_D)\r
    out HitPoints : ListT_Vector3 #%(T_46_META_WS_A_HITPOINTS)\r
	@Tip = %(T_48_META_API_71_P6_D)\r
    out HitDistances : ListT_Float #%(T_46_META_WS_A_HITDISTANCES)\r
	@Tip = %(T_48_META_API_71_P7_D)\r
    out HitNormals : ListT_Vector3 #%(T_46_META_WS_A_HITNORMALS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetCullingMask\r
@Tip = %(T_48_META_API_9017_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=2\r
action SetCameraCullingMask = 9017 { #%(T_46_META_WS_SETCULLINGMASK)\r
	@Tip = %(T_48_META_API_9017_P0_D)\r
    Camera : CameraConfig #%(T_46_META_WS_A_CAMERA)\r
	@Tip = %(T_48_META_API_9017_P1_D)\r
    CullingMask : ListT_Int #%(T_46_META_WS_A_CULLINGMASK)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetCullingMask\r
@Tip = %(T_48_META_API_9018_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=2\r
@Return = %(T_48_META_API_9018_R_D)\r
variable GetCameraCullingMask : ListT_Int = 9018 { #%(T_46_META_WS_GETCULLINGMASK)\r
	@Tip = %(T_48_META_API_9018_P0_D)\r
    Camera : CameraConfig #%(T_46_META_WS_A_CAMERA)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetCullingMaskLayer\r
@Tip = %(T_48_META_API_9019_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=2\r
action AddOrRemoveCameraCullingMask = 9019 { #%(T_46_META_WS_SETCULLINGMASKLAYER)\r
	@Tip = %(T_48_META_API_9019_P0_D)\r
    Camera : CameraConfig #%(T_46_META_WS_A_CAMERA)\r
	@Tip = %(T_48_META_API_9019_P1_D)\r
    VisibilityLayer : Int #%(T_46_META_WS_A_LAYER)\r
	@Tip = %(T_48_META_API_9019_P2_D)\r
    IsInCullingMask : Bool #%(T_46_META_WS_A_VISIBLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetSceneSkybox\r
@Tip = %(T_48_META_API_105_D)\r
@ModuleID=10012\r
@ModuleLib=Scene\r
@ApiTarget=2\r
@Return = %(T_48_META_API_105_R_D)\r
variable GetSceneSkybox : SkyboxEnv = 105 { #%(T_46_META_WS_GETSCENESKYBOX)\r
	@Tip = %(T_48_META_API_105_P0_D)\r
    SceneGUID : String #%(T_46_META_WS_A_SCENEID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetDefaultUIStatus\r
@Tip = %(T_48_META_API_9020_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
action SetPlayerHubSwitch = 9020 { #%(T_46_META_WS_SETDEFAULTUISTATUS)\r
	@Tip = %(T_48_META_API_9020_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_9020_P1_D)\r
    PlayerHudSwitchType : PlayerHudSwitchType #%(T_46_META_WS_A_TYPE)\r
	@Tip = %(T_48_META_API_9020_P2_D)\r
    SwitchValue : CommonHudSwitchValue #%(T_46_META_WS_A_STATUS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetDefaultUIInfo\r
@Tip = %(T_50_META_API_151_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=1\r
action GetDefaultUIPosition = 151 { #%(T_50_META_API_151)\r
	@Tip = %(T_50_META_API_151_P0_D)\r
    Target : PlayerHudSwitchType #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_50_META_API_151_P1_D)\r
    out Enable : Bool #%(T_46_META_WS_E_ENABLE)\r
	@Tip = %(T_50_META_API_151_P2_D)\r
    out Position : Vector2 #%(T_46_META_WS_A_POSITION)\r
	@Tip = %(T_50_META_API_151_P3_D)\r
    out Size : Vector2 #%(T_50_META_API_151_P3)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TimestampToLocalString\r
@Tip = %(T_48_META_API_9021_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_9021_R_D)\r
variable CreateTimestampLocString : TimestampLocString = 9021 { #%(T_46_META_WS_TIMESTAMPTO LOCALSTRING)\r
	@Tip = %(T_48_META_API_9021_P0_D)\r
    Timestamp : Int #%(T_46_META_WS_A_TIMESTAMP)\r
	@Tip = %(T_48_META_API_9021_P1_D)\r
    Style : TimestampFormatStyle #%(T_46_META_WS_A_STYLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetLocalTimestampMs\r
@Tip = %(T_49_META_API_99_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
variable GetLocalTimestampMs : Int64 = 99 { #%(T_49_META_API_99)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetServerTimestampMs\r
@Tip = %(T_49_META_API_106_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
variable GetServerTimestampMs : Int64 = 106 { #%(T_49_META_API_106)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TimestampToLocalStringMs\r
@Tip = %(T_49_META_API_107_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
variable TimestampMsToLocalString : TimestampMsLocString = 107 { #%(T_49_META_API_107)\r
	@Tip = %(T_49_META_API_107_P0_D)\r
    TimestampMs : Int64 #%(T_49_META_API_107_P0)\r
	@Tip = %(T_48_META_API_9021_P1_D)\r
    Style : TimestampFormatStyle #%(T_46_META_WS_A_STYLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateMiniMapIcon\r
@Tip = %(T_48_META_API_9022_D)\r
@ModuleID=34\r
@ModuleLib=MiniMap\r
action CreateMapIconEntity = 9022 { #%(T_46_META_WS_CREATEMINIMAPICON)\r
	@Tip = %(T_48_META_API_9022_P0_D)\r
    out EntityVarName : MiniMapIcon #%(T_46_META_WS_A_CREATEDENTITY)\r
	@Tip = %(T_48_META_API_9022_P1_D)\r
    OwnerPlayer : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_9022_P2_D)\r
    IconType : IconType #%(T_46_META_WS_A_RESOURCE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateMiniMapPixel\r
@Tip = %(T_48_META_API_9025_D)\r
@ModuleID=34\r
@ModuleLib=MiniMap\r
action CreateMapBitEntity = 9025 { #%(T_46_META_WS_CREATEMINIMAPPIXEL)\r
	@Tip = %(T_48_META_API_9025_P0_D)\r
    out EntityVarName : MiniMapBit #%(T_46_META_WS_A_CREATEDENTITY)\r
	@Tip = %(T_48_META_API_9025_P1_D)\r
    OwnerPlayer : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_9025_P2_D)\r
    TargetEntity : Entity #%(T_46_META_WS_A_BOUNDTARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetMiniMap\r
@Tip = %(T_48_META_API_9026_D)\r
@ModuleID=34\r
@ModuleLib=MiniMap\r
@Return = %(T_48_META_API_9026_R_D)\r
variable GetPlayerMiniMap : MiniMap = 9026 { #%(T_46_META_WS_GETMINIMAP)\r
	@Tip = %(T_48_META_API_9026_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MonsterUseSkill\r
@Tip = %(T_48_META_API_3504_D)\r
@ModuleID=10008\r
@ModuleLib=AI\r
@ApiTarget=2\r
action AICastSkill = 3504 { #%(T_46_META_WS_MONSTERUSESKILL)\r
	@Tip = %(T_48_META_API_3504_P0_D)\r
    AITarget : AI #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3504_P1_D)\r
    SkillType : AISkillType #%(T_46_META_WS_A_SKILL)\r
	@Tip = %(T_48_META_API_3504_P2_D)\r
    TargetEntity : Player #%(T_46_META_WS_A_SKILLTARGET)\r
	@Tip = %(T_48_META_API_3504_P3_D)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=FindPath\r
@Async\r
@Tip = %(T_48_META_API_3505_D)\r
@ModuleID=37\r
@ModuleLib=Scene\r
@ApiTarget=2\r
action FindStraightPath = 3505 { #%(T_46_META_WS_FINDPATH)\r
	@Tip = %(T_48_META_API_3505_P0_D)\r
    StartPos : Vector3 #%(T_46_META_WS_A_STARTPOSITION)\r
	@Tip = %(T_48_META_API_3505_P1_D)\r
    TargetPos : Vector3 #%(T_46_META_WS_A_ENDPOSITION)\r
	@Tip = %(T_48_META_API_3505_P2_D)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
	@Tip = %(T_48_META_API_3505_P3_D)\r
    out Path : ListT_Vector3 #%(T_46_META_WS_A_PATHPOINTS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetBlackboardValue\r
@Tip = %(T_48_META_API_3506_D)\r
@ModuleID=36\r
@ModuleLib=BehaviourTree\r
@ApiTarget=2\r
action SetBlackBoard = 3506 { #%(T_46_META_WS_SETBLACKBOARDVALUE)\r
	@Tip = %(T_48_META_API_3506_P0_D)\r
    BTree : BehaviourTree #%(T_46_META_WS_A_BTREE)\r
	@Tip = %(T_48_META_API_3506_P1_D)\r
    BBKey : String #%(T_46_META_WS_A_KEY)\r
	@Tip = %(T_48_META_API_3506_P2_D)\r
    BBValue : Object #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetBlackboardValue\r
@Tip = %(T_48_META_API_3507_D)\r
@ModuleID=36\r
@ModuleLib=BehaviourTree\r
@ApiTarget=2\r
action GetBlackBoard = 3507 { #%(T_46_META_WS_GETBLACKBOARDVALUE)\r
	@Tip = %(T_48_META_API_3507_P0_D)\r
    BTree : BehaviourTree #%(T_46_META_WS_A_BTREE)\r
	@Tip = %(T_48_META_API_3507_P1_D)\r
    BBKey : String #%(T_46_META_WS_A_KEY)\r
	@Tip = %(T_48_META_API_3507_P2_D)\r
    out BBValue : Object #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetNodeVariable\r
@Tip = %(T_48_META_API_3508_D)\r
@ModuleID=36\r
@ModuleLib=BehaviourTree\r
@ApiTarget=2\r
action GetBTreeNodeParam = 3508 { #%(T_46_META_WS_GETNODEVARIABLE)\r
	@Tip = %(T_48_META_API_3508_P0_D)\r
    Node : BehaviourTreeNode #%(T_46_META_WS_A_NODE)\r
	@Tip = %(T_48_META_API_3508_P1_D)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
	@Tip = %(T_48_META_API_3508_P2_D)\r
    out Value : Object #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetVehicleSkin\r
@Tip = %(T_48_META_API_3509_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3509_R_D)\r
variable GetVehicleSkin : VehicleSkinID = 3509 { #%(T_46_META_WS_GETVEHICLESKIN)\r
	@Tip = %(T_48_META_API_3509_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3509_P1_D)\r
    VehicleID : VehicleID #%(T_46_META_WS_A_VEHICLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetVehicleSkin\r
@Tip = %(T_48_META_API_3510_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action SetVehicleSkin = 3510 { #%(T_46_META_WS_SETVEHICLESKIN)\r
	@Tip = %(T_48_META_API_3510_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3510_P1_D)\r
    VehicleSkinID : VehicleSkinID #%(T_46_META_WS_A_VEHICLESKIN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveVehicleSkin\r
@Tip = %(T_48_META_API_3511_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action RemoveVehicleSkin = 3511 { #%(T_46_META_WS_REMOVEVEHICLESKIN)\r
	@Tip = %(T_48_META_API_3511_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3511_P1_D)\r
    VehicleID : VehicleID #%(T_46_META_WS_A_VEHICLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ResetVehicleSkin\r
@Tip = %(T_48_META_API_3512_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action ResetVehicleSkin = 3512 { #%(T_46_META_WS_RESETVEHICLESKIN)\r
	@Tip = %(T_48_META_API_3512_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3512_P1_D)\r
    VehicleID : VehicleID #%(T_46_META_WS_A_VEHICLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EnterVehicle\r
@Tip = %(T_48_META_API_30_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@ApiTarget=2\r
action GetInTheVehicle = 30 { #%(T_46_META_WS_ENTERVEHICLE)\r
	@Tip = %(T_48_META_API_30_P0_D)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
	@Tip = %(T_48_META_API_30_P1_D)\r
    Vehicle : Vehicle #%(T_46_META_WS_A_VEHICLE)\r
	@Tip = %(T_48_META_API_30_P2_D)\r
    Seat : SeatType #%(T_46_META_WS_A_SEAT)\r
	@Tip = %(T_48_META_API_30_P3_D)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ProfanityFilter\r
@Tip = %(T_48_META_API_33_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
@Return = %(T_48_META_API_33_R_D)\r
variable DirtyWordFilter : String = 33 { #%(T_46_META_WS_PROFANITYFILTER)\r
	@Tip = %(T_48_META_API_33_P0_D)\r
    Text : String #%(T_46_META_WS_A_CONTENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RequestMatchMaking\r
@Tip = %(T_48_META_API_10061_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action RequestMatchMaking = 10061 { #%(T_46_META_WS_REQUESTMATCHMAKING)\r
	@Tip = %(T_48_META_API_10061_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_10061_P1_D)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
	@Tip = %(T_48_META_API_10061_P2_D)\r
    ShowMessageWhenCancel : Bool #%(T_46_META_WS_A_SHOWMESSAGEWHENCANCEL)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=CreateSound_Deprecated\r
@Tip = %(T_48_META_API_10059_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action CreateSoundEntityV2 = 10059 { #%(T_42_XXJ_WS_CREATESOUND)\r
	@Tip = %(T_48_META_API_10059_P0_D)\r
    out EntityVarName : SoundEntity #%(T_38_WZY_WS_SOUNDENT)\r
	@Tip = %(T_48_META_API_10059_P1_D)\r
    OwnerPlayer : Player #%(T_34_SP_WS_BLOCK6_PARAM2_NAME)\r
	@Tip = %(T_48_META_API_10059_P2_D)\r
    SoundType : AudioType #%(T_34_SP_WS_BLOCK13_PARAM2_NAME)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=PauseSound_Deprecated\r
@Tip = %(T_48_META_API_10062_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action PauseSoundEntityV2 = 10062 { #%(T_39_WZY_WS_PAUSESOUND_NAME)\r
	@Tip = %(T_48_META_API_10062_P0_D)\r
    TargetEntity : SoundEntityOrListSoundEntity #%(T_39_WZY_WS_SOUNDENTLORSENT)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=ResumeSound_Deprecated\r
@Tip = %(T_48_META_API_10063_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action ResumeSoundEntityV2 = 10063 { #%(T_39_WZY_WS_PLAYSOUND_NAME)\r
	@Tip = %(T_48_META_API_10063_P0_D)\r
    TargetEntity : SoundEntityOrListSoundEntity #%(T_39_WZY_WS_SOUNDENTLORSENT)\r
	@Tip = %(T_48_META_API_10063_P1_D)\r
    IsReplay : Bool #%(T_39_WZY_WS_WEAREPLAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetFallingDamage\r
@Tip = %(T_48_META_API_9027_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action SetPlayerFallingDamage = 9027 { #StdLibrary/%(T_46_META_WS_SETFALLINGDAMAGE)\r
	@Tip = %(T_48_META_API_9027_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_9027_P1_D)\r
    HeightList : ListT_Float #%(T_46_META_WS_A_HEIGHTSEGMENTS)\r
	@Tip = %(T_48_META_API_9027_P2_D)\r
    DamageList : ListT_int #%(T_46_META_WS_A_DAMAGESEGMENTS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateBot\r
@Tip = %(T_48_META_API_35_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action AddBot = 35 { #StdLibrary/%(T_46_META_WS_CREATEBOT)\r
	@Tip = %(T_48_META_API_35_P0_D)\r
    Difficulty : BotDifficulty #%(T_46_META_WS_A_DIFFICULTY)\r
	@Tip = %(T_48_META_API_35_P1_D)\r
    TeamSeq : Int #%(T_46_META_WS_A_TEAMSEQ)\r
	@Tip = %(T_48_META_API_35_P2_D)\r
    out BotVarName : Player #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DestroyBot\r
@Tip = %(T_48_META_API_1021_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action DeleteBot = 1021 { #StdLibrary/%(T_46_META_WS_DESTROYBOT)\r
	@Tip = %(T_48_META_API_1021_P0_D)\r
    Bot : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1543_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1543_R_D)\r
variable Exponentiation : Number = 1543 { #%(T_46_META_WS_EXPONENTIATION)\r
	@Tip = %(T_48_META_API_1543_P0_D)\r
    LeftValue : Number #%(T_46_META_WS_A_BASE)\r
	@Tip = %(T_48_META_API_1543_P1_D)\r
    RightValue : Number #%(T_46_META_WS_A_EXPONENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Logarithm\r
@Tip = %(T_48_META_API_1544_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1544_R_D)\r
variable Log : Number = 1544 { #%(T_46_META_WS_LOGARITHM)\r
	@Tip = %(T_48_META_API_1544_P0_D)\r
    Base : Number #%(T_46_META_WS_A_BASE)\r
	@Tip = %(T_48_META_API_1544_P1_D)\r
    RealNumber : Number #%(T_46_META_WS_A_REALNUMBER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DirectionToEulerAngle\r
@Tip = %(T_48_META_API_1545_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=0\r
@Return = %(T_48_META_API_1545_R_D)\r
variable Vector3ToEulerAngles : Vector3 = 1545 { #%(T_46_META_WS_DIRECTIONTOEULERANGLE)\r
	@Tip = %(T_48_META_API_1545_P0_D)\r
    Vector : Vector3 #%(T_46_META_WS_A_DIRECTION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ExitVehicle\r
@Tip = %(T_48_META_API_1022_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action GetOutTheVehicle = 1022 { #%(T_46_META_WS_EXITVEHICLE)\r
	@Tip = %(T_48_META_API_1022_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DropItem\r
@Tip = %(T_48_META_API_3001_D)\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action DropItemEntity = 3001 { #%(T_46_META_WS_DROPITEM)\r
	@Tip = %(T_48_META_API_3001_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_3001_P1_D)\r
    Item : InventoryBase #%(T_46_META_WS_A_ITEM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateAirDrop\r
@Tip = %(T_48_META_API_10064_D)\r
@ModuleID=40\r
@ModuleLib=AirDrop\r
@ApiTarget=2\r
action CreateAirDropEntity = 10064 { #%(T_46_META_WS_CREATEAIRDROP)\r
	@Tip = %(T_48_META_API_10064_P0_D)\r
    out EntityVarName : AirDrop #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateDamageNum\r
@Tip = %(T_48_META_API_1023_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
action CreateUGCDamageNum = 1023 { #%(T_46_META_WS_CREATEDAMAGENUM)\r
	@Tip = %(T_48_META_API_1023_P0_D)\r
    Value : String #%(T_46_META_WS_A_CONTENT)\r
	@Tip = %(T_48_META_API_1023_P1_D)\r
    FontSize : Int #%(T_46_META_WS_A_FONTSIZE)\r
	@Tip = %(T_48_META_API_1023_P2_D)\r
    FontColor : Color #%(T_46_META_WS_A_FONTCOLOR)\r
	@Tip = %(T_48_META_API_1023_P3_D)\r
    TimeOfStay : Int #%(T_46_META_WS_P_PHASEDURATION)\r
	@Tip = %(T_48_META_API_1023_P4_D)\r
    Target : Entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1023_P5_D)\r
    Offset : Vector3 #%(T_46_META_WS_A_OFFSET)\r
	@Tip = %(T_48_META_API_1023_P6_D)\r
    RandomRange : Vector2 #%(T_46_META_WS_A_RANDOMRANGE)\r
	@Tip = %(T_48_META_API_1023_P7_D)\r
    DoTween : Bool #%(T_46_META_WS_A_DOTWEEN)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=DispatchEventWithPlatform_Deprecated\r
@Tip = %(T_48_META_API_1024_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action DispatchCustomEventV2 = 1024 { #%(T_46_META_WS_DISPATCHEVENTWITHPLATFORM)\r
	@Tip = %(T_48_META_API_1024_P0_D)\r
    EventID : EventID #%(T_46_META_WS_A_EVENTID)\r
	@Tip = %(T_48_META_API_1024_P1_D)\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1024_P2_D)\r
    CrossPlatform : Bool #%(T_46_META_WS_A_CROSSPLATFORM)\r
	@Tip = %(T_48_META_API_1024_P3_D)\r
    Params : List #%(T_46_META_WS_A_PARAMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetCustomMissionProgress\r
@Tip = %(T_48_META_API_1025_D)\r
@ModuleID=10013\r
@ModuleLib=FF_Platform\r
@ApiTarget=2\r
@Return = %(T_48_META_API_1025_R_D)\r
variable GetCustomMissionProgress : Int = 1025 { #%(T_46_META_WS_GETCUSTOMMISSIONPROGRESS)\r
	@Tip = %(T_48_META_API_1025_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1025_P1_D)\r
    MissionID : Int #%(T_46_META_WS_A_MISSIONID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetFriends\r
@Tip = %(T_50_META_API_150_D)\r
@ModuleID=10013\r
@ModuleLib=FF_Platform\r
@ApiTarget=1\r
variable GetFriends : ListT_UUID = 150 { #%(T_50_META_API_150)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LogWarning\r
@Tip = %(T_48_META_API_57_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action PrintWarning = 57 { #%(T_46_META_WS_LOGWARNING)\r
	@Tip = %(T_48_META_API_57_P0_D)\r
    Context : Object #%(T_46_META_WS_A_CONTENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LogError\r
@Tip = %(T_48_META_API_58_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action PrintError = 58 { #%(T_46_META_WS_LOGERROR)\r
	@Tip = %(T_48_META_API_58_P0_D)\r
    Context : Object #%(T_46_META_WS_A_CONTENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SampleOnCurve\r
@Tip = %(T_48_META_API_59_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
@Return = %(T_48_META_API_59_R_D)\r
variable CurveEvaluate : Float = 59 { #%(T_46_META_WS_SAMPLEONCURVE)\r
	@Tip = %(T_48_META_API_59_P0_D)\r
    Curve : BezierCurve #%(T_46_META_WS_A_CURVE)\r
	@Tip = %(T_48_META_API_59_P1_D)\r
    Time : Float #%(T_46_META_WS_A_SAMPLEPOINT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetResultFromCurve\r
@Tip = %(T_48_META_API_60_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
@Return = %(T_48_META_API_60_R_D)\r
variable GetResultFromCurve : Object = 60 { #%(T_46_META_WS_GETRESULTFROMCURVE)\r
	@Tip = %(T_48_META_API_60_P0_D)\r
    PropType : Type #%(T_46_META_WS_A_VALUETYPE)\r
	@Tip = %(T_48_META_API_60_P1_D)\r
    SrcValue : Object #%(T_46_META_WS_A_SRCVALUE)\r
	@Tip = %(T_48_META_API_60_P2_D)\r
    DestVal : Object #%(T_46_META_WS_A_DESTVAL)\r
	@Tip = %(T_48_META_API_60_P3_D)\r
    Curve : BezierCurve #%(T_46_META_WS_A_CURVE)\r
	@Tip = %(T_48_META_API_60_P4_D)\r
    Time : Float #%(T_46_META_WS_A_SAMPLEPOINT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UploadGameResult\r
@Tip = %(T_48_META_API_64_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action UploadMatchResult = 64 { #%(T_46_META_WS_UPLOADGAMERESULT)\r
	@Tip = %(T_48_META_API_64_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_64_P1_D)\r
    Result : MatchResultType #%(T_46_META_WS_A_RESULT)\r
	@Tip = %(T_48_META_API_64_P2_D)\r
    ScoreName : ListT_String #%(T_46_META_WS_A_SCORENAME)\r
	@Tip = %(T_48_META_API_64_P3_D)\r
    ScoreValue : ListT_String #%(T_46_META_WS_A_SCORE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateSound\r
@Tip = %(T_48_META_API_65_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
@ApiTarget=2\r
action CreateSoundEntityV3 = 65 { #%(T_46_META_WS_CREATESOUND)\r
	@Tip = %(T_48_META_API_65_P0_D)\r
    out EntityVarName : SoundEntity #%(T_46_META_WS_A_CREATEDENTITY)\r
	@Tip = %(T_48_META_API_65_P1_D)\r
    OwnerPlayer : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_65_P2_D)\r
    SoundType : AudioType #%(T_46_META_WS_A_RESOURCE)\r
	@Tip = %(T_48_META_API_65_P3_D)\r
    LoopType : AnimationOverrideLoopType #%(T_46_META_WS_A_LOOPTYPE)\r
	@Tip = %(T_48_META_API_65_P4_D)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateSoundClient\r
@Tip = %(T_48_META_API_67_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
@ApiTarget=1\r
action CreateSoundEntityClient = 67 { #%(T_46_META_WS_CREATESOUNDCLIENT)\r
	@Tip = %(T_48_META_API_67_P0_D)\r
    out EntityVarName : SoundEntity #%(T_46_META_WS_A_CREATEDENTITY)\r
	@Tip = %(T_48_META_API_67_P1_D)\r
    SoundType : AudioType #%(T_46_META_WS_A_RESOURCE)\r
	@Tip = %(T_48_META_API_67_P2_D)\r
    LoopType : AnimationOverrideLoopType #%(T_46_META_WS_A_LOOPTYPE)\r
	@Tip = %(T_48_META_API_67_P3_D)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateEffect\r
@Tip = %(T_48_META_API_66_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
@ApiTarget=2\r
action CreateEffectEntityV2 = 66 { #%(T_46_META_WS_CREATEEFFECT)\r
	@Tip = %(T_48_META_API_66_P0_D)\r
    out EntityVarName : EffectEntity #%(T_46_META_WS_A_CREATEDENTITY)\r
	@Tip = %(T_48_META_API_66_P1_D)\r
    @optional\r
    OwnerPlayer : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_66_P2_D)\r
    EffectType : EffectType #%(T_46_META_WS_A_RESOURCE)\r
	@Tip = %(T_48_META_API_66_P3_D)\r
    LoopType : AnimationOverrideLoopType #%(T_46_META_WS_A_LOOPTYPE)\r
	@Tip = %(T_48_META_API_66_P4_D)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateEffectClient\r
@Tip = %(T_48_META_API_72_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
@ApiTarget=1\r
action CreateEffectEntityClient = 72 { #%(T_46_META_WS_CREATEEFFECTCLIENT)\r
	@Tip = %(T_48_META_API_72_P0_D)\r
    out EntityVarName : EffectEntity #%(T_46_META_WS_A_CREATEDENTITY)\r
	@Tip = %(T_48_META_API_72_P1_D)\r
    EffectType : EffectType #%(T_46_META_WS_A_RESOURCE)\r
	@Tip = %(T_48_META_API_72_P2_D)\r
    LoopType : AnimationOverrideLoopType #%(T_46_META_WS_A_LOOPTYPE)\r
	@Tip = %(T_48_META_API_72_P3_D)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetBackpackSkin\r
@Tip = %(T_48_META_API_1026_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
@Return = %(T_48_META_API_1026_R_D)\r
variable GetBagSkinID : BagSkinID = 1026 { #%(T_46_META_WS_GETBACKPACKSKIN)\r
	@Tip = %(T_48_META_API_1026_P0_D)\r
    Player : PlayerOrNPC #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetBackpackSkin\r
@Tip = %(T_48_META_API_1027_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action SetBagSkinID = 1027 { #%(T_46_META_WS_SETBACKPACKSKIN)\r
	@Tip = %(T_48_META_API_1027_P0_D)\r
    Player : PlayerOrNPC #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1027_P1_D)\r
    SkinID : BagSkinID #%(T_46_META_WS_A_SKIN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ResetBackpackSkin\r
@Tip = %(T_48_META_API_1028_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action ResetBagSkinID = 1028 { #%(T_46_META_WS_RESETBACKPACKSKIN)\r
	@Tip = %(T_48_META_API_1028_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveBackpackSkin\r
@Tip = %(T_48_META_API_1029_D)\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action RemoveBagSkinID = 1029 { #%(T_46_META_WS_REMOVEBACKPACKSKIN)\r
	@Tip = %(T_48_META_API_1029_P0_D)\r
    Player : PlayerOrNPC #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetSkeletonPartByName\r
@Tip = %(T_48_META_API_1030_D)\r
@ModuleID=38\r
@ModuleLib=Avatar\r
@ApiTarget=1\r
@Return = %(T_48_META_API_1030_R_D)\r
variable GetMountPoint : SkeletonPart = 1030 { #%(T_46_META_WS_GETSKELETONPARTBYNAME)\r
	@Tip = %(T_48_META_API_1030_P0_D)\r
    Target : Entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1030_P1_D)\r
    Name : String #%(T_46_META_WS_A_NAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateSkeletonPartLookAtController\r
@Tip = %(T_49_META_API_97_D)\r
@ModuleID=38\r
@ModuleLib=Avatar\r
@ApiTarget=1\r
action CreateSkeletonPartLookAtController = 97 { #%(T_49_META_API_97)\r
	@Tip = %(T_49_META_API_97_P0_D)\r
    out EntityVarName : SkeletonPartLookAtController #%(T_46_META_WS_A_CREATEDENTITY)\r
	@Tip = %(T_49_META_API_97_P1_D)\r
    ControlBone : SkeletonPart #%(T_49_META_TYP_448_I0)\r
	@Tip = %(T_49_META_API_97_P2_D)\r
    LookAt : Transform #%(T_49_META_TYP_448_I1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetParentClient\r
@Tip = %(T_48_META_API_1031_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
action SetParentClient = 1031 { #%(T_46_META_WS_SETPARENTCLIENT)\r
	@Tip = %(T_48_META_API_1031_P0_D)\r
    Parent : Mountable #%(T_46_META_WS_A_PARENT)\r
	@Tip = %(T_48_META_API_1031_P1_D)\r
    Child : Transform #%(T_46_META_WS_A_CHILD)\r
	@Tip = %(T_48_META_API_1031_P2_D)\r
    WorldPositionStays : Bool #%(T_46_META_WS_A_WORLDPOSITIONSTAYS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=NotifyPlayIconAnimation\r
@Tip = %(T_48_META_API_1032_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
action NotifyIconAnimation = 1032 { #%(T_46_META_WS_NOTIFYPLAYICONANIMATION)\r
	@Tip = %(T_48_META_API_1032_P0_D)\r
    Icon : SpriteID #%(T_46_META_WS_A_RESOURCE)\r
	@Tip = %(T_48_META_API_1032_P1_D)\r
    Color : Color #%(T_46_META_WS_A_COLOR)\r
	@Tip = %(T_48_META_API_1032_P2_D)\r
    Scale : Vector2 #%(T_46_META_WS_A_SCALE)\r
	@Tip = %(T_48_META_API_1032_P3_D)\r
    StartPosition : Vector2 #%(T_46_META_WS_A_STARTAREACENTER)\r
	@Tip = %(T_48_META_API_1032_P4_D)\r
    StartRange : Vector2 #%(T_46_META_WS_A_STARTAREARANGE)\r
	@Tip = %(T_48_META_API_1032_P5_D)\r
    EndPosition : Vector2 #%(T_46_META_WS_A_ENDAREACENTER)\r
	@Tip = %(T_48_META_API_1032_P6_D)\r
    EndRange : Vector2 #%(T_46_META_WS_A_ENDAREARANGE)\r
	@Tip = %(T_48_META_API_1032_P7_D)\r
    Speed : Float #%(T_46_META_WS_A_PLAYSPEED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ATan2\r
@Tip = %(T_48_META_API_1033_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1033_R_D)\r
variable Atan2 : Float = 1033 { #%(T_46_META_WS_ATAN2)\r
	@Tip = %(T_48_META_API_1033_P0_D)\r
    Y : Float #%(T_46_META_WS_A_Y)\r
	@Tip = %(T_48_META_API_1033_P1_D)\r
    X : Float #%(T_46_META_WS_A_X)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1034_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action AddComponent = 1034 { #%(T_46_META_WS_ADDCOMPONENT)\r
	@Tip = %(T_48_META_API_1034_P0_D)\r
    Target : entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1034_P1_D)\r
    TypeID : Type #%(T_46_META_WS_A_COMPONENT)\r
	@Tip = %(T_48_META_API_1034_P2_D)\r
    out IsSuc : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1035_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action RemoveComponent = 1035 { #%(T_46_META_WS_REMOVECOMPONENT)\r
	@Tip = %(T_48_META_API_1035_P0_D)\r
    Target : entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1035_P1_D)\r
    TypeID : Type #%(T_46_META_WS_A_COMPONENT)\r
	@Tip = %(T_48_META_API_1035_P2_D)\r
    out IsSuc : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ApplyQuitMidwayUIConfig\r
@Tip = %(T_48_META_API_1036_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action ApplyQuitMidwayHudConfig = 1036 { #%(T_46_META_WS_APPLYQUITMIDWAYUICONFIG)\r
	@Tip = %(T_48_META_API_1036_P0_D)\r
    Title : StringOrLocString #%(T_46_META_WS_A_TITLE)\r
	@Tip = %(T_48_META_API_1036_P1_D)\r
    Content : StringOrLocString #%(T_46_META_WS_A_CONTENT)\r
	@Tip = %(T_48_META_API_1036_P2_D)\r
    Options : ListT_StringOrLocString #%(T_46_META_WS_A_OPTIONS)\r
	@Tip = %(T_48_META_API_1036_P3_D)\r
    ShowBackground : Bool #%(T_46_META_WS_A_SHOWBACKGROUND)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetLocalPlayer\r
@Tip = %(T_48_META_API_75_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
@Return = %(T_48_META_API_75_R_D)\r
variable LocalPlayer : Player = 75 { #%(T_46_META_WS_GETLOCALPLAYER)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1037_D)\r
@ModuleID=10012\r
@ModuleLib=Scene\r
@ApiTarget=0\r
@Return = %(T_48_META_API_1037_R_D)\r
variable GetLoadedScenes : ListT_String = 1037 { #%(T_46_META_WS_GETLOADEDSCENES)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1038_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=1\r
@Return = %(T_48_META_API_1038_R_D)\r
variable GetLocalAimDirection : Vector3 = 1038 { #%(T_46_META_WS_GETLOCALAIMDIRECTION)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1039_D)\r
@ModuleID=41\r
@ModuleLib=Time\r
@ApiTarget=1\r
@Return = %(T_48_META_API_1039_R_D)\r
variable GetLocalTimestamp : Int = 1039 { #%(T_46_META_WS_GETLOCALTIMESTAMP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetXClient\r
@Tip = %(T_48_META_API_77_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=1\r
@Return = %(T_48_META_API_77_R_D)\r
variable VectorSetXClient : Vector3 = 77 { #%(T_34_LY_WS_SVX)\r
	@Tip = %(T_48_META_API_77_P0_D)\r
    Vector : Vector3 #%(T_48_META_API_1500_P0)\r
	@Tip = %(T_48_META_API_77_P1_D)\r
    X : Float #%(T_46_META_WS_A_X)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetYClient\r
@Tip = %(T_48_META_API_78_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=1\r
@Return = %(T_48_META_API_78_R_D)\r
variable VectorSetYClient : Vector3 = 78 { #%(T_34_LY_WS_SVY)\r
	@Tip = %(T_48_META_API_78_P0_D)\r
    Vector : Vector3 #%(T_48_META_API_1500_P0)\r
	@Tip = %(T_48_META_API_78_P1_D)\r
    Y : Float #%(T_46_META_WS_A_Y)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetZClient\r
@Tip = %(T_48_META_API_79_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=1\r
@Return = %(T_48_META_API_79_R_D)\r
variable VectorSetZClient : Vector3 = 79 { #%(T_34_LY_WS_SVZ)\r
	@Tip = %(T_48_META_API_79_P0_D)\r
    Vector : Vector3 #%(T_48_META_API_1500_P0)\r
	@Tip = %(T_48_META_API_79_P1_D)\r
    Z : Float #%(T_48_META_API_1505_P1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2SetXClient\r
@Tip = %(T_48_META_API_80_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=1\r
@Return = %(T_48_META_API_80_R_D)\r
variable Vector2SetXClient : Vector2 = 80 { #%(T_43_YU_WS_VECTOR2SETX)\r
	@Tip = %(T_48_META_API_80_P0_D)\r
    Vector2 : Vector2 #%(T_38_M_WS_VECTOR2)\r
	@Tip = %(T_48_META_API_80_P1_D)\r
    X : Float #%(T_46_META_WS_A_X)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2SetYClient\r
@Tip = %(T_48_META_API_81_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=1\r
@Return = %(T_48_META_API_81_R_D)\r
variable Vector2SetYClient : Vector2 = 81 { #%(T_43_YU_WS_VECTOR2SETY)\r
	@Tip = %(T_48_META_API_81_P0_D)\r
    Vector2 : Vector2 #%(T_38_M_WS_VECTOR2)\r
	@Tip = %(T_48_META_API_81_P1_D)\r
    Y : Float #%(T_46_META_WS_A_Y)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PauseFixedUpdate\r
@Tip = %(T_48_META_API_1040_D)\r
@ModuleID=41\r
@ModuleLib=Time\r
@ApiTarget=0\r
action PauseGame = 1040 { #%(T_46_META_WS_PAUSEFIXEDUPDATE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ResumeFixedUpdate\r
@Tip = %(T_48_META_API_1041_D)\r
@ModuleID=41\r
@ModuleLib=Time\r
@ApiTarget=0\r
action ResumeGame = 1041 { #%(T_46_META_WS_RESUMEFIXEDUPDATE)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1042_D)\r
@ModuleID=10013\r
@ModuleLib=FF_Platform\r
@ApiTarget=1\r
@Return = %(T_48_META_API_1042_R_D)\r
variable IsFriend : Bool = 1042 { #%(T_46_META_WS_ISFRIEND)\r
	@Tip = %(T_48_META_API_1042_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=DispatchEventWithPlatform\r
@Tip = %(T_48_META_API_1043_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action DispatchCustomEventV3 = 1043 { #%(T_46_META_WS_SENDEVENT)\r
	@Tip = %(T_48_META_API_1043_P0_D)\r
    EventID : EventID #%(T_46_META_WS_A_EVENTID)\r
	@Tip = %(T_48_META_API_1043_P1_D)\r
    Target : entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1043_P2_D)\r
    TargetSide : PlatformType #%(T_46_META_WS_A_PLATFORM)\r
	@Tip = %(T_48_META_API_1043_P3_D)\r
    Params : List #%(T_46_META_WS_A_PARAMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DispatchEventToEntity\r
@Tip = %(T_50_META_API_153_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action DispatchCustomEventV4 = 153 { #%(T_50_META_API_153)\r
	@Tip = %(T_48_META_API_1043_P0_D)\r
    EventID : EventID #%(T_46_META_WS_A_EVENTID)\r
	@Tip = %(T_48_META_API_1043_P1_D)\r
    Target : entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1043_P2_D)\r
    TargetSide : PlatformType #%(T_46_META_WS_A_PLATFORM)\r
	@Tip = %(T_48_META_API_1043_P3_D)\r
    Params : List #%(T_46_META_WS_A_PARAMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BroadcastCustomEvent\r
@Tip = %(T_50_META_API_152_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action BroadcastCustomEvent = 152 { #%(T_50_META_API_152)\r
	@Tip = %(T_48_META_API_1043_P0_D)\r
    EventID : EventID #%(T_46_META_WS_A_EVENTID)\r
	@Tip = %(T_48_META_API_1043_P2_D)\r
    TargetSide : PlatformType #%(T_46_META_WS_A_PLATFORM)\r
	@Tip = %(T_48_META_API_1043_P3_D)\r
    Params : List #%(T_46_META_WS_A_PARAMS)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1044_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action StartParachute = 1044 { #%(T_46_META_WS_STARTPARACHUTE)\r
	@Tip = %(T_48_META_API_1044_P0_D)\r
    Target : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1044_P1_D)\r
    ForceToParachuteHeight : Float #%(T_46_META_WS_A_FORCEDPARACHUTEHEIGHT)\r
	@Tip = %(T_48_META_API_1044_P2_D)\r
    SurfingMaxSpeed : Vector2 #%(T_46_META_WS_A_SURFINGMAXSPEED)\r
	@Tip = %(T_48_META_API_1044_P3_D)\r
    DivingMaxSpeed : Vector2 #%(T_46_META_WS_A_DIVINGMAXSPEED)\r
	@Tip = %(T_48_META_API_1044_P4_D)\r
    ParachutingMaxSpeed : Vector2 #%(T_46_META_WS_A_PARACHUTINGMAXSPEED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadFromDataStore\r
@Async\r
@Tip = %(T_48_META_API_1045_D)\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action ReadDBSheetValue_V2 = 1045 { #%(T_46_META_WS_READFROMDATASTORE)\r
	@Tip = %(T_48_META_API_1045_P0_D)\r
    SheetName : String #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_1045_P1_D)\r
    AccountId : UUID #%(T_46_META_WS_A_ACCOUNTID)\r
	@Tip = %(T_48_META_API_1045_P2_D)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
	@Tip = %(T_48_META_API_1045_P3_D)\r
    out Result : Object #%(T_46_META_WS_A_RESULT)\r
	@Tip = %(T_48_META_API_1045_P4_D)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
	@Tip = %(T_48_META_API_1045_P5_D)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@Async\r
@Tip = %(T_48_META_API_1098_D)\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action BatchReadDBSheetValue = 1098 { #%(T_48_META_API_1098)\r
	@Tip = %(T_40_XXJ_WS_DBTABLENAME_DESC)\r
    SheetName : String #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_1098_P1_D)\r
    AccountIds : ListT_UUID #%(T_48_META_API_1098_P1)\r
	@Tip = %(T_48_META_API_1098_P2_D)\r
    Keys : ListT_String #%(T_48_META_API_1098_P2)\r
	@Tip = %(T_40_XXJ_WS_RESULT_DESCKEY)\r
    out Result : ListT_Object #%(T_46_META_WS_A_RESULT)\r
	@Tip = %(T_48_META_API_1046_P3_D)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
	@Tip = %(T_48_META_API_1098_P5_D)\r
    out ErrorCodes : ListT_ErrorCode #%(T_48_META_API_1098_P5)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadFromLeaderboardDataStore\r
@Async\r
@Tip = %(T_48_META_API_1046_D)\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action ReadDBLeaderboardValue_V2 = 1046 { #%(T_46_META_WS_READFROMLEADBOARDDATASTORE)\r
	@Tip = %(T_48_META_API_1046_P0_D)\r
    LeaderboardName : String #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_1046_P1_D)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
	@Tip = %(T_48_META_API_1046_P2_D)\r
    out Result : List #%(T_46_META_WS_A_RESULT)\r
	@Tip = %(T_48_META_API_1046_P3_D)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
	@Tip = %(T_48_META_API_1046_P4_D)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadFromLeaderboardDataStoreByRank\r
@Async\r
@Tip = %(T_48_META_API_1047_D)\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action ReadDBLeaderboardValuesByRange_V2 = 1047 { #%(T_46_META_WS_READFROMLEADBOARDDATASTOREBYRANK)\r
	@Tip = %(T_48_META_API_1047_P0_D)\r
    LeaderboardName : String #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_1047_P1_D)\r
    StartIndex : Int #%(T_46_META_WS_A_STARTRANK)\r
	@Tip = %(T_48_META_API_1047_P2_D)\r
    EndIndex : Int #%(T_46_META_WS_A_ENDRANK)\r
	@Tip = %(T_48_META_API_1047_P3_D)\r
    out Result : List #%(T_46_META_WS_A_RESULT)\r
	@Tip = %(T_48_META_API_1047_P4_D)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
	@Tip = %(T_48_META_API_1047_P5_D)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadFromAccumulatedDataStore\r
@Async\r
@Tip = %(T_48_META_API_1048_D)\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action ReadDBAccumulatedData_V2 = 1048 { #%(T_46_META_WS_READFROMACCUMULATEDDATASTORE)\r
	@Tip = %(T_48_META_API_1048_P0_D)\r
    SheetName : String #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_1048_P1_D)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
	@Tip = %(T_48_META_API_1048_P2_D)\r
    out Result : Int #%(T_46_META_WS_A_RESULT)\r
	@Tip = %(T_48_META_API_1048_P3_D)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
	@Tip = %(T_48_META_API_1048_P4_D)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WriteToDataStore\r
@Tip = %(T_48_META_API_1049_D)\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action WriteDBSheetValue_V2 = 1049 { #%(T_46_META_WS_WRITETODATASTORE)\r
	@Tip = %(T_48_META_API_1049_P0_D)\r
    SheetName : String #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_1049_P1_D)\r
    AccountId : UUID #%(T_46_META_WS_A_ACCOUNTID)\r
	@Tip = %(T_48_META_API_1049_P2_D)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
	@Tip = %(T_48_META_API_1049_P3_D)\r
    Value : Object #%(T_46_META_WS_A_VALUE)\r
	@Tip = %(T_48_META_API_1049_P4_D)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
	@Tip = %(T_48_META_API_1049_P5_D)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WriteToLeaderboardDataStore\r
@Tip = %(T_48_META_API_1084_D)\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action WriteDBLeaderboardValue_V2 = 1084 { #%(T_46_META_WS_WRITETOLEADBOARDDATASTORE)\r
	@Tip = %(T_48_META_API_1084_P0_D)\r
    LeaderboardName : String #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_1084_P1_D)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
	@Tip = %(T_48_META_API_1084_P2_D)\r
    Value : Int #%(T_46_META_WS_A_VALUE)\r
	@Tip = %(T_48_META_API_1084_P3_D)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
	@Tip = %(T_48_META_API_1084_P4_D)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WriteToAccumulatedDataStore\r
@Tip = %(T_48_META_API_1085_D)\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action WriteDBAccumulatedDataOffset_V2 = 1085 { #%(T_46_META_WS_WRITETOACCUMULATEDDATASTORE)\r
	@Tip = %(T_48_META_API_1085_P0_D)\r
    SheetName : String #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_1085_P1_D)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
	@Tip = %(T_48_META_API_1085_P2_D)\r
    ArithmeticType : Int #%(T_46_META_WS_A_OPERATIOMETHOD)\r
	@Tip = %(T_48_META_API_1085_P3_D)\r
    Offset : Int #%(T_46_META_WS_A_OFFSET)\r
	@Tip = %(T_48_META_API_1085_P4_D)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
	@Tip = %(T_48_META_API_1085_P5_D)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddAOISpecialFollow\r
@Tip = %(T_48_META_API_84_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action AddSpecialFollow = 84 { #%(T_46_META_WS_ADDAOISPECIALFOLLOW)\r
	@Tip = %(T_48_META_API_84_P0_D)\r
    Target : entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_84_P1_D)\r
    Observer : Player #%(T_46_META_WS_A_OBSERVER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveAOISpecialFollow\r
@Tip = %(T_48_META_API_85_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action RemoveSpecialFollow = 85 { #%(T_46_META_WS_REMOVEAOISPECIALFOLLOW)\r
	@Tip = %(T_48_META_API_85_P0_D)\r
    Target : entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_85_P1_D)\r
    Observer : Player #%(T_46_META_WS_A_OBSERVER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ClearAOISpecialFollow\r
@Tip = %(T_48_META_API_86_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action CleanSpecialFollow = 86 { #%(T_46_META_WS_CLEARAOISPECIALFOLLOW)\r
	@Tip = %(T_48_META_API_86_P0_D)\r
    Target : entity #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=HasAOISpecialFollow\r
@Tip = %(T_48_META_API_87_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
@Return = %(T_48_META_API_87_R_D)\r
variable HasSpecialFollow : Bool = 87 { #%(T_46_META_WS_HASAOISPECIALFOLLOW)\r
	@Tip = %(T_48_META_API_87_P0_D)\r
    Target : entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_87_P1_D)\r
    Observer : Player #%(T_46_META_WS_A_OBSERVER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EulerAngleToVector3\r
@Tip = %(T_48_META_API_1546_D)\r
@ModuleID=10005\r
@ModuleLib=Convert\r
@ApiTarget=0\r
@Return = %(T_48_META_API_1546_R_D)\r
variable EularAngleToVector3 : Vector3 = 1546 { #%(T_46_XXJ_WS_EULARANGLETOVECTOR3)\r
	@Tip = %(T_48_META_API_1546_P0_D)\r
    Value : Vector3 #%(T_46_XXJ_WS_VALUE)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1547_D)\r
@ModuleID=10005\r
@ModuleLib=Convert\r
@ApiTarget=0\r
@Return = %(T_48_META_API_1547_R_D)\r
variable IntToFloat : Float = 1547 { #%(T_46_XXJ_WS_INTTOFLOAT)\r
	@Tip = %(T_48_META_API_1547_P0_D)\r
    Value : Int #%(T_46_XXJ_WS_VALUE)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1548_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=0\r
@Return = %(T_48_META_API_1548_R_D)\r
variable RotateVector : Vector3 = 1548 { #%(T_46_XXJ_WS_ROTATEVECTOR)\r
	@Tip = %(T_48_META_API_1548_P0_D)\r
    Value : Vector3 #%(T_46_XXJ_WS_VALUE)\r
	@Tip = %(T_48_META_API_1548_P1_D)\r
    Delta : Quaternion #%(T_46_XXJ_WS_DELTA)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SwitchAOIProxyObserver\r
@Tip = %(T_48_META_API_88_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action SwitchUserProxyObserver = 88 { #%(T_46_META_WS_SWITCHAOIPROXYOBSERVER)\r
	@Tip = %(T_48_META_API_88_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_88_P1_D)\r
    ProxyObserver : PlayerOrTransform #%(T_46_XXJ_WS_PROXYOBSERVER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveFromDataStore\r
@Tip = %(T_48_META_API_1086_D)\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action DeleteDBSheetValue_V2 = 1086 { #%(T_46_META_WS_DELETEFROMDATASTORE)\r
	@Tip = %(T_48_META_API_1086_P0_D)\r
    SheetName : String #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_1086_P1_D)\r
    AccountId : UUID #%(T_46_META_WS_A_ACCOUNTID)\r
	@Tip = %(T_48_META_API_1086_P2_D)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
	@Tip = %(T_48_META_API_1086_P3_D)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
	@Tip = %(T_48_META_API_1086_P4_D)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveFromLeaderboardDataStoreByKey\r
@Tip = %(T_48_META_API_1087_D)\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action DeleteDBLeaderboardValueByKey_V2 = 1087 { #%(T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYKEY)\r
	@Tip = %(T_48_META_API_1087_P0_D)\r
    LeaderboardName : String #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_1087_P1_D)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
	@Tip = %(T_48_META_API_1087_P2_D)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
	@Tip = %(T_48_META_API_1087_P3_D)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveFromLeaderboardDataStoreByRank\r
@Tip = %(T_48_META_API_1088_D)\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action DeleteDBLeaderboardValueByOrder_V2 = 1088 { #%(T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYRANK)\r
	@Tip = %(T_48_META_API_1088_P0_D)\r
    LeaderboardName : String #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_1088_P1_D)\r
    Order : Int #%(T_46_META_WS_A_RANK)\r
	@Tip = %(T_48_META_API_1088_P2_D)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
	@Tip = %(T_48_META_API_1088_P3_D)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1089_D)\r
@ModuleID=43\r
@ModuleLib=LLM\r
@ApiTarget=1\r
action UserMessageToPersona = 1089 { #%(T_47_XXJ_WS_USERMESSAGETOPERSONA)\r
	@Tip = %(T_48_META_API_1089_P0_D)\r
    Target : PersonaID #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1089_P1_D)\r
    Content : String #%(T_47_XXJ_WS_CONTENT)\r
	@Tip = %(T_49_META_EVT_16_P1_D)\r
    out ChatID : Int64 #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1090_D)\r
@ModuleID=43\r
@ModuleLib=LLM\r
@ApiTarget=1\r
action SystemMessageToPersona = 1090 { #%(T_47_XXJ_WS_SYSTEMMESSAGETOPERSONA)\r
	@Tip = %(T_48_META_API_1090_P0_D)\r
    Target : PersonaID #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1090_P1_D)\r
    Content : String #%(T_47_XXJ_WS_CONTENT)\r
	@Tip = %(T_48_META_API_1101_P2_D)\r
    ShouldReply : Bool #%(T_47_XXJ_WS_SHOULDREPLY)\r
	@Tip = %(T_49_META_EVT_16_P1_D)\r
    out ChatID : Int64 #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UserMessageToPersonaVoiceResponse\r
@Tip = %(T_51_META_API_1114_D)\r
@ModuleID=43\r
@ModuleLib=LLM\r
@ApiTarget=1\r
action UserMessageToPersonaVoice = 1114 { #%(T_51_META_API_1114)\r
	@Tip = %(T_48_META_API_1100_P0_D)\r
    Target : PersonaID #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1100_P1_D)\r
    Content : String #%(T_46_META_WS_A_CONTENT)\r
	@Tip = %(T_51_META_API_1114_P2_D)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
	@Tip = %(T_49_META_EVT_16_P1_D)\r
    out ChatID : Int64 #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SystemMessageToPersonaVoiceResponse\r
@Tip = %(T_51_META_API_1115_D)\r
@ModuleID=43\r
@ModuleLib=LLM\r
@ApiTarget=1\r
action SystemMessageToPersonaVoice = 1115 { #%(T_51_META_API_1115)\r
	@Tip = %(T_48_META_API_1100_P0_D)\r
    Target : PersonaID #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1100_P1_D)\r
    Content : String #%(T_46_META_WS_A_CONTENT)\r
	@Tip = %(T_51_META_API_1114_P2_D)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
	@Tip = %(T_49_META_EVT_16_P1_D)\r
    out ChatID : Int64 #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_51_META_API_1116_D)\r
@ModuleID=43\r
@ModuleLib=LLM\r
@ApiTarget=1\r
action PlayStoredVoiceFromPersona = 1116 { #%(T_51_META_API_1116)\r
	@Tip = %(T_49_META_EVT_16_P1_D)\r
    ChatID : Int64 #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1091_D)\r
@ModuleID=43\r
@ModuleLib=LLM\r
@ApiTarget=1\r
action ClearMemory = 1091 { #%(T_47_XXJ_WS_CLEARMEMORY)\r
	@Tip = %(T_48_META_API_1091_P0_D)\r
    out ErrorCode : ErrorCode #%(T_47_XXJ_WS_ERRORCODE)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1096_D)\r
@ModuleID=42\r
@ModuleLib=Premium\r
@ApiTarget=2\r
action IsPremium = 1096 { #%(T_46_XXJ_WS_ISPREMIUM)\r
	@Tip = %(T_48_META_API_1096_P0_D)\r
    Player : Player #%(T_45_XXJ_WS_PLAYER)\r
	@Tip = %(T_48_META_API_1096_P1_D)\r
    out Status : ErrorCode #%(T_46_XXJ_WS_STATUS)\r
	@Tip = %(T_48_META_API_1096_P2_D)\r
    out Result : Bool #%(T_40_XXJ_WS_RESULT_NAMEKEY)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1097_D)\r
@ModuleID=42\r
@ModuleLib=Premium\r
@ApiTarget=2\r
action OpenPremiumCenter = 1097 { #%(T_46_XXJ_WS_OPENPREMIUMCENTER)\r
	@Tip = %(T_48_META_API_1097_P0_D)\r
    Player : Player #%(T_45_XXJ_WS_PLAYER)\r
	@Tip = %(T_48_META_API_1097_P1_D)\r
    out Status : ErrorCode #%(T_46_XXJ_WS_STATUS)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1092_D)\r
@ModuleID=42\r
@ModuleLib=Premium\r
@ApiTarget=1\r
action OpenPremiumCenter_Client = 1092 { #%(T_46_XXJ_WS_OPENPREMIUMCENTER)\r
	@Tip = %(T_48_META_API_1092_P0_D)\r
    out Status : ErrorCode #%(T_46_XXJ_WS_STATUS)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1093_D)\r
@ModuleID=42\r
@ModuleLib=Premium\r
@ApiTarget=2\r
action GetPremiumExpireDate = 1093 { #%(T_46_XXJ_WS_GETPREMIUMEXPIREDATE)\r
	@Tip = %(T_48_META_API_1093_P0_D)\r
    Player : Player #%(T_45_XXJ_WS_PLAYER)\r
	@Tip = %(T_48_META_API_1093_P1_D)\r
    out Result : Int64 #%(T_40_XXJ_WS_RESULT_NAMEKEY)\r
	@Tip = %(T_48_META_API_1093_P2_D)\r
    out Status : ErrorCode #%(T_46_XXJ_WS_STATUS)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1094_D)\r
@ModuleID=42\r
@ModuleLib=Premium\r
@ApiTarget=1\r
action IsPremium_Client = 1094 { #%(T_46_XXJ_WS_ISPREMIUM)\r
	@Tip = %(T_48_META_API_1094_P0_D)\r
    out Status : ErrorCode #%(T_46_XXJ_WS_STATUS)\r
	@Tip = %(T_48_META_API_1094_P1_D)\r
    out Result : Bool #%(T_40_XXJ_WS_RESULT_NAMEKEY)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1095_D)\r
@ModuleID=42\r
@ModuleLib=Premium\r
@ApiTarget=1\r
action GetPremiumExpireDate_Client = 1095 { #%(T_46_XXJ_WS_GETPREMIUMEXPIREDATE)\r
	@Tip = %(T_48_META_API_1095_P0_D)\r
    out Result : Int64 #%(T_40_XXJ_WS_RESULT_NAMEKEY)\r
	@Tip = %(T_48_META_API_1095_P1_D)\r
    out Status : ErrorCode #%(T_46_XXJ_WS_STATUS)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1099_D)\r
@ModuleID=43\r
@ModuleLib=LLM\r
@ApiTarget=1\r
action SetPersonaObserver = 1099 { #%(T_47_XXJ_WS_SETPERSONAOBSERVER)\r
	@Tip = %(T_48_META_API_1099_P0_D)\r
    Target : PersonaID #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1099_P1_D)\r
    Observers : ListT_PersonaID #%(T_47_XXJ_WS_OBSERVERS)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1100_D)\r
@ModuleID=43\r
@ModuleLib=LLM\r
@ApiTarget=1\r
action UserMessageToPersonaStream = 1100 { #%(T_47_XXJ_WS_USERMESSAGETOPERSONASTREAM)\r
	@Tip = %(T_48_META_API_1100_P0_D)\r
    Target : PersonaID #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1100_P1_D)\r
    Content : String #%(T_47_XXJ_WS_CONTENT)\r
	@Tip = %(T_49_META_EVT_16_P1_D)\r
    out ChatID : Int64 #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1101_D)\r
@ModuleID=43\r
@ModuleLib=LLM\r
@ApiTarget=1\r
action SystemMessageToPersonaStream = 1101 { #%(T_47_XXJ_WS_SYSTEMMESSAGETOPERSONASTREAM)\r
	@Tip = %(T_48_META_API_1101_P0_D)\r
    Target : PersonaID #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1101_P1_D)\r
    Content : String #%(T_47_XXJ_WS_CONTENT)\r
	@Tip = %(T_48_META_API_1101_P2_D)\r
    ShouldReply : Bool #%(T_47_XXJ_WS_SHOULDREPLY)\r
	@Tip = %(T_49_META_EVT_16_P1_D)\r
    out ChatID : Int64 #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_49_META_API_109_D)\r
@ModuleID=43\r
@ModuleLib=LLM\r
@ApiTarget=1\r
action UpdateContextToPersona = 109 { #%(T_49_META_API_109)\r
	@Tip = %(T_48_META_API_1101_P0_D)\r
    Target : PersonaID #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_49_META_API_109_P1_D)\r
    Context : String #%(T_49_META_API_109_P1)\r
	@Tip = %(T_49_META_EVT_16_P1_D)\r
    out RequestID : Int64 #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_49_META_API_110_D)\r
@ModuleID=43\r
@ModuleLib=LLM\r
@ApiTarget=1\r
action FeedbackToPersonaContent = 110 { #%(T_49_META_API_110)\r
	@Tip = %(T_49_META_EVT_16_P2_D)\r
    ResponseID : String #%(T_49_META_EVT_16_P2)\r
	@Tip = %(T_49_META_API_110_P1_D)\r
    IsLiked : Bool #%(T_49_META_API_110_P1)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_49_META_API_112_D)\r
@ModuleID=43\r
@ModuleLib=LLM\r
@ApiTarget=1\r
action RollbackPersonaMemory = 112 { #%(T_49_META_API_112)\r
	@Tip = %(T_49_META_EVT_16_P2_D)\r
    ResponseID : String #%(T_49_META_EVT_16_P2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=JoinTeam\r
@Tip = %(T_48_META_API_91_D)\r
@ModuleID=14\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
action JoinTeam = 91 { #%(T_47_XXJ_WS_JOINTEAM)\r
	@Tip = %(T_48_META_API_91_P0_D)\r
    Target : Entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_91_P1_D)\r
    TargetTeam : Team #%(T_47_XXJ_WS_TARGETTEAM)\r
	@Tip = %(T_48_META_API_91_P2_D)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=JoinNewTeam\r
@Tip = %(T_48_META_API_92_D)\r
@ModuleID=14\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
action JoinNewTeam = 92 { #%(T_47_XXJ_WS_JOINNEWTEAM)\r
	@Tip = %(T_48_META_API_92_P0_D)\r
    Target : Entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_92_P1_D)\r
    out NewTeam : Team #%(T_47_XXJ_WS_NEWTEAM)\r
	@Tip = %(T_48_META_API_92_P2_D)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1103_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=0\r
@Return = %(T_48_META_API_1103_R_D)\r
variable CreateRandomSeed : Random = 1103 { #%(T_47_XXJ_WS_CREATERANDOMSEED)\r
	@Tip = %(T_48_META_API_1103_P0_D)\r
    Seed : Int #%(T_47_XXJ_WS_SEED)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1104_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=0\r
@Return = %(T_48_META_API_1104_R_D)\r
variable Next : Int = 1104 { #%(T_47_XXJ_WS_NEXT)\r
	@Tip = %(T_48_META_API_1104_P0_D)\r
    Value : Random #%(T_46_META_WS_A_VALUE)\r
	@Tip = %(T_48_META_API_1104_P1_D)\r
    Min : Int #%(T_46_META_WS_A_MIN)\r
	@Tip = %(T_48_META_API_1104_P2_D)\r
    Max : Int #%(T_46_META_WS_A_MAX)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_48_META_API_1105_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action NotifyStartPlot = 1105 { #%(T_48_META_API_1105)\r
	@Tip = %(T_48_META_EVT_3142_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_1105_P1_D)\r
    PlotID : PlotID #%(T_48_META_EVT_3141_P1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreatePerformance\r
@Tip = %(T_50_META_API_1106_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
@ApiTarget=1\r
action CreateTimeLine = 1106 { #%(T_50_META_API_1106)\r
	@Tip = %(T_50_META_API_1106_P0_D)\r
    ResID : TimeLineID #%(T_46_META_WS_A_RESOURCE)\r
	@Tip = %(T_51_META_API_1114_P2_D)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
	@Tip = %(T_48_META_API_6_P0_D)\r
    out EntityVarName : TimeLine #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateAlongPathMotion\r
@Tip = %(T_48_META_API_93_D)\r
@ModuleID=29\r
@ModuleLib=Playable\r
@ApiTarget=0\r
action CreateAlongPathMotion = 93 { #%(T_48_META_API_93)\r
	@Tip = %(T_40_XXJ_WS_TARGETENTITY_DESCKEY)\r
    TargetEntity : Entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_93_P1_D)\r
    Path : CustomCurvePath #%(T_48_META_API_93_P1)\r
	@Tip = %(T_40_XXJ_WS_STYLE_DESCKEY)\r
    Style : TweenStyle #%(T_46_META_WS_A_STYLE)\r
	@Tip = %(T_48_META_API_93_P3_D)\r
    Speed : Float #%(T_46_META_WS_P_SPEED)\r
	@Tip = %(T_48_META_API_93_P4_D)\r
    TangentFacing : Bool #%(T_48_META_API_93_P4)\r
	@Tip = %(T_34_SP_WS_BLOCK6_PARAM1_NAMEDESC)\r
    out EntityVarName : AlongPathMotion #%(T_46_META_WS_A_CREATEDENTITY)\r
	@Tip = %(T_44_XXJ_WS_AUTOPLAY_D)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
}\r
\r
@ApiLevel=3\r
@Tip = %(T_48_META_API_94_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=0\r
action SetLocalVarByIndex = 94 { #%(T_48_META_API_94)\r
	@Tip = %(T_48_META_API_94_P0_D)\r
    Index : Int #%(T_48_META_API_94_P0)\r
	@Tip = %(T_48_META_API_94_P1_D)\r
    VarValue : Object #%(T_48_META_API_94_P1)\r
	@Tip = %(T_48_META_API_94_P2_D)\r
    ArithmeticType : Int #%(T_48_META_API_94_P2)\r
	@Tip = %(T_48_META_API_94_P3_D)\r
    VarName : String #%(T_48_META_API_94_P3)\r
}\r
\r
@ApiLevel=3\r
@Tip = %(T_48_META_API_95_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=0\r
@Return = %(T_48_META_API_2006_R_D)\r
variable GetLocalVarByIndex : Object = 95 { #%(T_48_META_API_95)\r
	@Tip = %(T_48_META_API_95_P0_D)\r
    Index : Int #%(T_48_META_API_95_P0)\r
	@Tip = %(T_48_META_API_95_P1_D)\r
    VarName : String #%(T_48_META_API_95_P1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetLocalLanguage\r
@Tip = %(T_48_META_API_1108_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
variable GetLocalLanguage : LanguageType = 1108 { #%(T_48_META_API_1108)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetLocalPlayerPosition\r
@Tip = %(T_49_META_API_1109_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=1\r
action SetLocalPlayerPositon = 1109 { #%(T_49_META_API_1109)\r
	@Tip = %(T_49_META_API_1109_P0_D)\r
    Position : Vector3 #%(T_46_META_WS_A_POSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetLocalPlayerForward\r
@Tip = %(T_49_META_API_1110_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=1\r
action SetLocalPlayerForward = 1110 { #%(T_49_META_API_1110)\r
	@Tip = %(T_49_META_API_1110_P0_D)\r
    Forward : Vector3 #%(T_46_META_WS_A_FORWARD)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SwitchCustomCamera\r
@Tip = %(T_48_META_API_10028_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=2\r
action SwitchNewCamera = 10065 { #%(T_49_META_API_10065)\r
	@Tip = %(T_48_META_API_10028_P0_D)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
	@Tip = %(T_48_META_API_10028_P1_D)\r
    BasicCamera : BasicCamera #%(T_46_META_WS_A_CAMERA)\r
	@Tip = %(T_48_META_API_10028_P2_D)\r
    CameraTransitionType : CameraTransitionType #%(T_46_META_WS_A_TRANSITIONTYPE)\r
	@Tip = %(T_48_META_API_10028_P3_D)\r
    TransitionTime : Float #%(T_46_META_WS_A_TRANSITIONTIME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SwitchCustomCameraClient\r
@Tip = %(T_48_META_API_10028_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=1\r
action SwitchNewCameraForClinet = 10066 { #%(T_49_META_API_10065)\r
	@Tip = %(T_48_META_API_10028_P1_D)\r
    BasicCamera : BasicCamera #%(T_46_META_WS_A_CAMERA)\r
	@Tip = %(T_48_META_API_10028_P2_D)\r
    CameraTransitionType : CameraTransitionType #%(T_46_META_WS_A_TRANSITIONTYPE)\r
	@Tip = %(T_48_META_API_10028_P3_D)\r
    TransitionTime : Float #%(T_46_META_WS_A_TRANSITIONTIME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetCurrentNewCamera\r
@Tip = %(T_48_META_API_10027_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=2\r
variable GetCurrentNewCamera : BasicCamera = 10067 { #%(T_49_META_API_10067)\r
	@Tip = %(T_48_META_API_10027_P0_D)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetCurrentCustomCameraClient\r
@Tip = %(T_48_META_API_10027_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=1\r
variable GetCurrentNewCameraForClinet : BasicCamera = 10068 { #%(T_49_META_API_10067)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateBasicCamera\r
@Tip = %(T_48_META_API_10029_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=0\r
action CreateBasicCamera = 10069 { #%(T_49_META_API_10069)\r
	@Tip = %(T_48_META_API_10029_P1_D)\r
    out EntityVarName : BasicCamera #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetCustomCameraCullingMask\r
@Tip = %(T_49_META_API_10070_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=0\r
action SetCustomCameraCullingMask = 10070 { #%(T_49_META_API_10070)\r
	@Tip = %(T_48_META_API_9017_P0_D)\r
    BasicCamera : BasicCamera #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_9017_P1_D)\r
    CullingMask : ListT_Int #%(T_46_META_WS_A_CULLINGMASK)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetCustomCameraCullingMask\r
@Tip = %(T_49_META_API_10071_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=0\r
@Return = %(T_48_META_API_9018_R_D)\r
variable GetCustomCameraCullingMask : ListT_Int = 10071 { #%(T_49_META_API_10071)\r
	@Tip = %(T_48_META_API_9017_P0_D)\r
    BasicCamera : BasicCamera #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetCustomCameraCullingMaskLayer\r
@Tip = %(T_49_META_API_10072_D)\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=0\r
action AddOrRemoveCustomCameraCullingMask = 10072 { #%(T_49_META_API_10072)\r
	@Tip = %(T_48_META_API_9017_P0_D)\r
    BasicCamera : BasicCamera #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_48_META_API_9019_P1_D)\r
    VisibilityLayer : Int #%(T_46_META_WS_A_LAYER)\r
	@Tip = %(T_48_META_API_9019_P2_D)\r
    IsInCullingMask : Bool #%(T_46_META_WS_A_VISIBLE)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_49_META_API_10073_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
action CaptureScreenshot = 10073 { #%(T_49_META_API_10073)\r
	@Tip = %(T_50_META_API_10073_P0_D)\r
    FileName : String #%(T_50_META_API_10073_P0)\r
	@Tip = %(T_50_META_API_10073_P1_D)\r
    out Status : ErrorCode #%(T_46_META_WS_A_STATUS)\r
}\r
\r
@ApiLevel=10\r
@Tip = %(T_49_META_API_113_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
action PlayOneShotSound = 113 { #%(T_49_META_API_113)\r
	@Tip = %(T_49_META_API_113_P0_D)\r
    Resource : AudioID #%(T_46_META_WS_A_RESOURCE)\r
	@Tip = %(T_49_META_API_113_P1_D)\r
    Volume : Float #%(T_49_META_API_113_P1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetLevelObjectHighLight\r
@Tip = %(T_50_META_API_116_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@ApiTarget=1\r
action SetLevelObjHighLight = 116 { #%(T_50_META_API_116)\r
	@Tip = %(T_50_META_API_116_P0_D)\r
    Target : LevelObject #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_50_META_API_116_P1_D)\r
    Status : Bool #%(T_46_META_WS_A_STATUS)\r
}\r
\r
@ApiLevel=3\r
@ScriptName=SetLevelObjectOutlineEffect\r
@Tip = %(T_51_TYC_API_OUTLINE_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
action SetLevelObjOutlineEffect = 146 { #%(T_51_TYC_API_OUTLINE)\r
	@Tip = %(T_51_TYC_API_OUTLINE_TARGET_D)\r
    Target : Entity #%(T_51_TYC_API_OUTLINE_TARGET)\r
	@Tip = %(T_51_TYC_API_OUTLINE_WIDTH_D)\r
    Width : Float #%(T_51_TYC_API_OUTLINE_WIDTH)\r
	@Tip = %(T_51_TYC_API_OUTLINE_COLOR_D)\r
    Color : Color #%(T_51_TYC_API_OUTLINE_COLOR)\r
	@Tip = %(T_51_TYC_API_OUTLINE_ALPHA_D)\r
    Alpha : Float #%(T_51_TYC_API_OUTLINE_ALPHA)\r
	@Tip = %(T_51_TYC_API_OUTLINE_TOPMOST_D)\r
    NoBlock : Bool #%(T_51_TYC_API_OUTLINE_TOPMOST)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_117_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=0\r
variable BitwiseCommon : Int = 117 { #%(T_50_META_API_117)\r
	@Tip = %(T_50_META_API_117_P0_D)\r
    Left : Int #%(T_46_META_WS_A_LEFTVALUE)\r
	@Tip = %(T_50_META_API_117_P1_D)\r
    Right : Int #%(T_46_META_WS_A_RIGHTVALUE)\r
	@Tip = %(T_50_META_API_117_P2_D)\r
    Operation : Int #%(T_46_META_WS_A_OPERATIOMETHOD)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_118_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=0\r
variable BitwiseNot : Int = 118 { #%(T_50_META_API_118)\r
	@Tip = %(T_50_META_API_118_P0_D)\r
    Value : Int #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_119_D)\r
@ModuleID=10005\r
@ModuleLib=Convert\r
@ApiTarget=0\r
variable BitwiseListToInt : Int = 119 { #%(T_50_META_API_119)\r
	@Tip = %(T_50_META_API_119_P0_D)\r
    BitArray : ListT_Int #%(T_50_META_API_119_P0)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_120_D)\r
@ModuleID=10005\r
@ModuleLib=Convert\r
@ApiTarget=0\r
variable BitwiseIntToList : ListT_Int = 120 { #%(T_50_META_API_120)\r
	@Tip = %(T_50_META_API_120_P0_D)\r
    Value : Int #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_121_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=0\r
variable QuaternionAngle : Float = 121 { #%(T_50_META_API_121)\r
	@Tip = %(T_50_META_API_121_P0_D)\r
    Left : Quaternion #%(T_46_META_WS_A_LEFTVALUE)\r
	@Tip = %(T_50_META_API_121_P1_D)\r
    Right : Quaternion #%(T_46_META_WS_A_RIGHTVALUE)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_122_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=0\r
variable QuaternionDot : Float = 122 { #%(T_50_META_API_122)\r
	@Tip = %(T_50_META_API_121_P0_D)\r
    Left : Quaternion #%(T_46_META_WS_A_LEFTVALUE)\r
	@Tip = %(T_50_META_API_121_P1_D)\r
    Right : Quaternion #%(T_46_META_WS_A_RIGHTVALUE)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_123_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=0\r
variable QuaternionInverse : Quaternion = 123 { #%(T_50_META_API_123)\r
	@Tip = %(T_50_META_API_123_P0_D)\r
    Value : Quaternion #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_124_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=0\r
variable QuaternionFromToRotation : Quaternion = 124 { #%(T_50_META_API_124)\r
	@Tip = %(T_50_META_API_124_P0_D)\r
    From : Vector3 #%(T_50_META_API_125_P0)\r
	@Tip = %(T_50_META_API_124_P1_D)\r
    To : Vector3 #%(T_50_META_API_125_P1)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_125_D)\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=0\r
variable QuaternionRotateTowards : Quaternion = 125 { #%(T_50_META_API_125)\r
	@Tip = %(T_50_META_API_125_P0_D)\r
    From : Quaternion #%(T_50_META_API_125_P0)\r
	@Tip = %(T_50_META_API_125_P1_D)\r
    To : Quaternion #%(T_50_META_API_125_P1)\r
	@Tip = %(T_50_META_API_125_P2_D)\r
    MaxDegreesDelta : Float #%(T_50_META_API_125_P2)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_126_D)\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@ApiTarget=1\r
variable GetGyroscopeOrientation : Quaternion = 126 { #%(T_50_META_API_126)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_127_D)\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@ApiTarget=1\r
variable GetGyroscopeGravity : Vector3 = 127 { #%(T_50_META_API_127)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_128_D)\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@ApiTarget=1\r
variable GetGyroscopeRotationRate : Vector3 = 128 { #%(T_50_META_API_128)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_129_D)\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@ApiTarget=1\r
variable GetGyroscopeRotationUnbiased : Vector3 = 129 { #%(T_50_META_API_129)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetGyroscopeUserAcceleration\r
@Tip = %(T_50_META_API_130_D)\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@ApiTarget=1\r
variable GetUserAcceleration : Vector3 = 130 { #%(T_50_META_API_130)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_131_D)\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@ApiTarget=1\r
action GetTouchInfo = 131 { #%(T_50_META_API_131)\r
	@Tip = %(T_50_META_API_131_P0_D)\r
    Index : Int #%(T_46_META_WS_A_INDEX)\r
	@Tip = %(T_50_META_API_131_P1_D)\r
    out Position : Vector2 #%(T_46_META_WS_A_POSITION)\r
	@Tip = %(T_50_META_API_131_P2_D)\r
    out DeltaPosition : Vector2 #%(T_50_META_API_131_P2)\r
	@Tip = %(T_50_META_API_131_P3_D)\r
    out DeltaTime : Float #%(T_50_META_API_131_P3)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_132_D)\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@ApiTarget=1\r
variable GetScreenTouchCount : Int = 132 { #%(T_50_META_API_132)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_133_D)\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@ApiTarget=1\r
action VibrateDevice = 133 { #%(T_50_META_API_133)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_134_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action NotifyPlaySoundV2 = 134 { #%(T_46_META_WS_NOTIFYPLAYSOUND)\r
	@Tip = %(T_50_META_API_134_P0_D)\r
    Target : Player #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_50_META_API_134_P1_D)\r
    Resource : AudioID #%(T_46_META_WS_A_RESOURCE)\r
	@Tip = %(T_50_META_API_134_P2_D)\r
    Speed : Float #%(T_46_META_WS_P_SPEED)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_135_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
action PlayOneShotSoundV2 = 135 { #%(T_49_META_API_113)\r
	@Tip = %(T_50_META_API_135_P0_D)\r
    Resource : AudioID #%(T_46_META_WS_A_RESOURCE)\r
	@Tip = %(T_50_META_API_135_P1_D)\r
    Speed : Float #%(T_46_META_WS_P_SPEED)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_136_D)\r
@ModuleID=10004\r
@ModuleLib=Strings\r
@ApiTarget=0\r
variable FormatStr : String = 136 { #%(T_50_META_API_136)\r
	@Tip = %(T_50_META_API_136_P0_D)\r
    Content : String #%(T_46_META_WS_A_CONTENT)\r
	@Tip = %(T_50_META_API_136_P1_D)\r
    ParamsArray : ListT_Object #%(T_50_META_API_136_P1)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_137_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action PasteComponent = 137 { #%(T_50_META_API_137)\r
	@Tip = %(T_50_META_API_137_P0_D)\r
    Source : Entity #%(T_50_META_API_137_P0)\r
	@Tip = %(T_50_META_API_137_P1_D)\r
    Target : Entity #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_50_META_API_137_P2_D)\r
    ComponentType : Type #%(T_50_META_API_137_P2)\r
	@Tip = %(T_50_META_API_137_P3_D)\r
    out IsSuc : Bool #%(T_50_META_API_137_P3)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReviveAtNextFrame\r
@Tip = %(T_50_META_API_138_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action ReviveOnNextFrame = 138 { #%(T_50_META_API_138)\r
	@Tip = %(T_48_META_API_3207_P0_D)\r
    Target : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EliminateAtNextFrame\r
@Tip = %(T_50_META_API_139_D)\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@ApiTarget=2\r
action EliminateOnNextFrame = 139 { #%(T_50_META_API_139)\r
	@Tip = %(T_50_META_API_139_P0_D)\r
    Target : FightingEntity #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=QuitGameAtNextFrame\r
@Tip = %(T_50_META_API_140_D)\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action QuitFameOnNextFrame = 140 { #%(T_50_META_API_140)\r
	@Tip = %(T_48_META_API_3207_P0_D)\r
    Target : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_141_D)\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@ApiTarget=1\r
action GetMicrophoneVolume = 141 { #%(T_50_META_API_141)\r
	@Tip = %(T_50_META_API_141_P0_D)\r
    out Volume : Float #%(T_50_META_API_141_P0)\r
	@Tip = %(T_50_META_API_141_P1_D)\r
    out Status : Bool #%(T_46_META_WS_A_STATUS)\r
}\r
\r
@ApiLevel=4\r
@Async\r
@Tip = %(T_50_META_API_1102_D)\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action ReadDBSheetColumnValue = 1102 { #%(T_50_META_API_1102)\r
	@Tip = %(T_48_META_API_1045_P0_D)\r
    SheetName : String #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_1045_P1_D)\r
    AccountId : UUID #%(T_46_META_WS_A_ACCOUNTID)\r
	@Tip = %(T_48_META_API_1045_P2_D)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
	@Tip = %(T_50_META_API_1102_P3_D)\r
    ColumnIndex : Int #%(T_50_META_API_1102_P3)\r
	@Tip = %(T_48_META_API_1045_P3_D)\r
    out Result : List #%(T_46_META_WS_A_RESULT)\r
	@Tip = %(T_48_META_API_1045_P4_D)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
	@Tip = %(T_48_META_API_1045_P5_D)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@Async\r
@Tip = %(T_50_META_API_1111_D)\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action ReadDBLeaderboardAssociationValue = 1111 { #%(T_50_META_API_1111)\r
	@Tip = %(T_48_META_API_1046_P0_D)\r
    LeaderboardName : String #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_1046_P1_D)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
	@Tip = %(T_48_META_API_1046_P2_D)\r
    out Result : List #%(T_46_META_WS_A_RESULT)\r
	@Tip = %(T_48_META_API_1046_P3_D)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
	@Tip = %(T_48_META_API_1046_P4_D)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
	@Tip = %(T_50_META_API_1111_P5_D)\r
    out AssociationErrorCode : ErrorCode #%(T_50_META_API_1111_P5)\r
}\r
\r
@ApiLevel=4\r
@Async\r
@Tip = %(T_50_META_API_1112_D)\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action ReadDBLeaderboardAssociationValuesByRange = 1112 { #%(T_50_META_API_1112)\r
	@Tip = %(T_48_META_API_1047_P0_D)\r
    LeaderboardName : String #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_1047_P1_D)\r
    StartIndex : Int #%(T_46_META_WS_A_STARTRANK)\r
	@Tip = %(T_48_META_API_1047_P2_D)\r
    EndIndex : Int #%(T_46_META_WS_A_ENDRANK)\r
	@Tip = %(T_48_META_API_1047_P3_D)\r
    out Result : List #%(T_46_META_WS_A_RESULT)\r
	@Tip = %(T_48_META_API_1047_P4_D)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
	@Tip = %(T_48_META_API_1047_P5_D)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
	@Tip = %(T_50_META_API_1112_P6_D)\r
    out AssociationErrorCode : ErrorCode #%(T_50_META_API_1112_P6)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_1113_D)\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action WriteDBLeaderboardAssociationValue = 1113 { #%(T_50_META_API_1113)\r
	@Tip = %(T_48_META_API_1084_P0_D)\r
    LeaderboardName : String #%(T_46_META_WS_A_SHEETNAME)\r
	@Tip = %(T_48_META_API_1084_P1_D)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
	@Tip = %(T_48_META_API_1084_P2_D)\r
    Value : List #%(T_46_META_WS_A_VALUE)\r
	@Tip = %(T_48_META_API_1084_P3_D)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
	@Tip = %(T_48_META_API_1084_P4_D)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
	@Tip = %(T_50_META_API_1113_P5_D)\r
    out AssociationErrorCode : ErrorCode #%(T_50_META_API_1113_P5)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_142_D)\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@ApiTarget=1\r
variable GetRenderQuality : ERenderQuality = 142 { #%(T_50_META_API_142)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_143_D)\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@ApiTarget=1\r
variable GetRenderResolution : Vector2 = 143 { #%(T_50_META_API_143)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_50_META_API_149_D)\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@ApiTarget=0\r
action SetDistanceVolumes = 149 { #%(T_50_META_API_149)\r
	@Tip = %(T_50_META_API_149_P0_D)\r
    DistanceList : ListT_Float #%(T_50_META_API_149_P0)\r
	@Tip = %(T_50_META_API_149_P1_D)\r
    VolumeList : ListT_Int #%(T_50_META_API_149_P1)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_51_META_API_154_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=0\r
variable GetTypeName : String = 154 { #%(T_51_META_API_154)\r
	@Tip = %(T_51_META_API_154_P0_D)\r
    Variable : Object #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_51_META_API_155_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@ApiTarget=1\r
action GetBoundingBox = 155 { #%(T_51_META_API_155)\r
	@Tip = %(T_51_META_API_155_P0_D)\r
    Target : LevelObject #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_51_META_API_155_P1_D)\r
    out Center : Vector3 #%(T_46_META_WS_A_CENTER)\r
	@Tip = %(T_51_META_API_155_P2_D)\r
    out Size : Vector3 #%(T_51_META_API_155_P2)\r
}\r
\r
@ApiLevel=3\r
@Tip = %(T_51_META_API_156_D)\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action CreateEntity = 156 { #%(T_51_META_API_156)\r
	@Tip = %(T_51_META_API_156_P0_D)\r
    out CreatedEntity : Entity #%(T_46_META_WS_A_CREATEDENTITY)\r
	@Tip = %(T_51_META_API_156_P1_D)\r
    TypeID : Type #%(T_46_META_WS_C_TYPE)\r
	@Tip = %(T_51_META_API_156_P2_D)\r
    Owner : Player #%(T_46_META_WS_A_OWNER)\r
	@Tip = %(T_51_META_API_156_P3_D)\r
    Attribute : EntityFlag #%(T_51_META_API_156_P3)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_51_META_API_157_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@ApiTarget=1\r
action SetMaterialProperty = 157 { #%(T_51_META_API_157)\r
	@Tip = %(T_51_META_API_157_P0_D)\r
    Target : LevelObject #%(T_46_META_WS_A_TARGET)\r
	@Tip = %(T_51_META_API_157_P1_D)\r
    PropertyName : String #%(T_51_META_API_157_P1)\r
	@Tip = %(T_51_META_API_157_P2_D)\r
    PropertyValue : MaterialProperty #%(T_51_META_API_157_P2)\r
	@Tip = %(T_51_META_API_157_P3_D)\r
    out Success : Bool #%(T_51_META_API_157_P3)\r
}\r
\r
@ApiLevel=4\r
@Tip = %(T_51_META_API_158_D)\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@ApiTarget=1\r
action ClearMaterialProperty = 158 { #%(T_51_META_API_158)\r
	@Tip = %(T_51_META_API_158_P0_D)\r
    Target : LevelObject #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
variable GetClientRegion : String = 159 { #GetClientRegion\r
}\r
\r
//Some removed APIs\r
@Tip = Get the number of elements in the parameter array\r
@Return = number of elements\r
variable ArrayLength : int = 1050 { #obsolete/array length\r
@Tip = target array\r
     ArrayValue: List #array\r
}\r
\r
@Tip = set the element value at the specified index position in the array\r
action SetArrayElementByIndex = 1052 { # outdated/modified array element\r
@Tip = target array\r
     ArrayValue: List #array\r
@Tip = array index value, the index starts from 0\r
     Index: int #index\r
@Tip = target array element value\r
     ElementValue: any #element value\r
}\r
\r
@Tip = delete the element at the specified index position from the array\r
@Return = result array\r
variable DeleteElementFromArray : List = 1054 { # Obsolete/delete array elements\r
@Tip = target array\r
     ArrayValue: List #array\r
@Tip = array index value, the index starts from 0\r
     Index: int #index\r
}\r
`, yN = `id,comment,exports,category,order,weblink,tips,name,type,ref,is_linkable,ff_manual,ff_custom,fe_custom,param_order,param_info,dev_only,api_target,syntax_tooltip,ResourceLevel,Division,SearchKey,UtilizationFactor\r
"图元id\r
（不可重复）\r
（不可删除）",图元注释,"-1 不导出\r
1 仅在FF导出\r
2 仅在FE导出\r
\r
留空或0全部导出","分类 (支持多级分类)，\r
event\r
game/xxx\r
等\r
参考UGCBlockSubTypeConfig表",排序-数字越大越靠前,图元帮助连接(configid),"如果设置的话会覆盖meta中的描述key\r
对于手工导出的图元则必须指定","名字\r
（不可重复）\r
（改变可导致数据损坏，一旦上线后不可变）\r
（程序填写）","导出方式1-event|2-action|3-data|4-enum\r
（程序填写）","参考api\r
（程序填写）","该图元下是否能连接其他图元\r
（程序填写）","是否采用手工导出\r
（程序填写）","ff 特殊功能或图元\r
（程序填写）","fe 特殊功能或图元\r
'-' 表示fe程序原因不导出\r
（程序填写）","参数顺序\r
参数序号根据meta定义从1开始\r
竖线代表换行\r
分号代表参数分隔\r
如果是0则表示隐藏所有参数","参数信息及默认值\r
参数序号根据meta定义从1开始\r
格式为-参数序号:slot表现类型=默认值\r
默认是slot类型\r
带有Enum_表示这个枚举采用嵌入图元的方式",是否在正式版隐藏  0-不变 1-FF（仅在非线上环境显示） 2-FE（无功能） 3-Both,控制该行 API 从属于哪个端。会覆盖元数据 ApiTarget 字段。 2. 服务器 1. 客户端 0. 服务器+客户端（默认）,脚本化相关。用于悬浮显示关键字或语法糖在FCG脚本中的使用方法。,"资源权限等级\r
public（或不填）：公开资源\r
internal：仅白名单可用资源",用于配置从属分类，格式：从属大分类_从属小分类,用于搜索中对特写图元的名称匹配，另，对非特写图元，将在搜索时覆盖其label作为匹配内容,\r
1,游戏开始时,,event/1,,docs/event-1-1/,,OnMatchStart,1,OnMatchStart,TRUE,,,,,,,,,,event,,0.5\r
2,游戏结束时,,event/1,,docs/event-1-2/,,OnMatchEnd,1,OnMatchEnd,TRUE,,,,,,3,,,,event,,0.5\r
3,回合开始时,,event/1,,docs/event-18-3/,,OnRoundStart,1,OnRoundStart,TRUE,,,,,,,,,,event,,0.5\r
4,回合结束时,,event/1,,docs/event-18-4/,,OnRoundEnd,1,OnRoundEnd,TRUE,,,,,,,,,,event,,0.5\r
5,阶段开始时,,event/1,,docs/event-18-5/,,OnPhaseStart,1,OnPhaseStart,TRUE,,,,,,,,,,event,,0.5\r
6,阶段结束时,,event/1,,docs/event-18-6/,,OnPhaseEnd,1,OnPhaseEnd,TRUE,,,,,,,,,,event,,0.5\r
7,玩家退出时,,event/1,,docs/event-11-7/,,OnUserQuit,1,OnUserQuit,TRUE,,,,,,,,,,event,,0.5\r
8,【废弃】玩家积分改变时,,event/2,,docs/event-19-8/,,OnPlayerRoundScoreChange,1,OnPlayerRoundScoreChange,TRUE,,,,,,1,,,,event,,0.5\r
9,【废弃】队伍积分改变时,,event/2,,docs/event-19-9/,,OnTeamRoundScoreChange,1,OnTeamRoundScoreChange,TRUE,,,,,,1,,,,event,,0.5\r
10,玩家死亡时,,event/1,,docs/event-16-10/,,OnPlayerDead,1,OnPlayerDead,TRUE,,,,,,,,,,event,,0.5\r
11,玩家助攻时,,event/1,,docs/event-16-11/,,OnPlayerAssist,1,OnPlayerAssist,TRUE,,,,,,,,,,event,,0.5\r
12,玩家造成伤害时,,event/1,,docs/event-16-12/,,OnPlayerDamage,1,OnPlayerDamage,TRUE,,,,,,,,,,event,,0.5\r
13,玩家击杀时,,event/1,,docs/event-16-13/,,OnPlayerKill,1,OnPlayerKill,TRUE,,,,,,,,,,event,,0.5\r
14,玩家加入游戏时,,event/1,,docs/event-11-14/,,OnPlayerAdd,1,OnPlayerAdd,TRUE,,,,,,,,,,event,,0.5\r
15,玩家复活时,,event/1,,docs/event-11-15/,,OnPlayerRevive,1,OnPlayerRevive,TRUE,,,,,,,,,,event,,0.5\r
16,当移除队伍时,,event/1,,docs/event-29-16/,,OnRemoveTeam,1,OnRemoveTeam,TRUE,,,,,,3,,,,event,,0.5\r
17,当添加队伍时,,event/1,,docs/event-29-17/,,OnAddTeam,1,OnAddTeam,TRUE,,,,,,3,,,,event,,0.5\r
18,当队伍被团灭时,,event/1,,docs/event-16-18/,,OnTeamACE,1,OnTeamACE,TRUE,,,,,,,,,,event,,0.5\r
10013,If,,logic,,,,If,2,,TRUE,TRUE,,if,,,,,,,condition,T_49_SD_SEARCHKEY_IF,0.5\r
10014,IfElse,,logic,,,,IfElse,2,,TRUE,TRUE,,ifelse,,,,,,,condition,T_49_SD_SEARCHKEY_IFELSE,0.5\r
21,ForEach,,logic,,,T_34_WZ_WS_LOGIC7_NAMEDESC,ForEach,2,,TRUE,TRUE,P2=P3.T0,loop_foreach,,,,,"for index , value in range",,condition,T_49_SD_SEARCHKEY_FOREACH,0.5\r
22,For,,logic,,,T_34_WZ_WS_LOGIC6_NAMEDESC,For,2,,TRUE,TRUE,,loop_forindex,,,,,"for i = begin, max, step",,condition,T_49_SD_SEARCHKEY_FOR,0.5\r
23,While,,logic,,,T_34_WZ_WS_LOGIC8_NAMEDESC,While,2,,TRUE,TRUE,,loop_while,,,,,while,,condition,T_49_SD_SEARCHKEY_WHILE,0.5\r
24,打断-退出循环,,logic,,docs/api-1-24/,,ProcessCtlBreak,2,ProcessCtlBreak,,,,loop_break,,,,,break,,condition,T_49_SD_SEARCHKEY_BREAK,0.5\r
25,跳转到下一次循环,,logic,,docs/api-1-25/,,ProcessCtlContinue,2,ProcessCtlContinue,,,,loop_continue,,,,,continue,,condition,T_49_SD_SEARCHKEY_CONTINUE,0.5\r
26,返回,,function,,docs/api-1-26/,T_34_WZ_WS_LOGIC11_NAMEDESC,ProcessCtlReturnVoid,2,ProcessCtlReturn,,,,function_return,0,,,,,,function,T_49_SD_SEARCHKEY_RETURN,0.5\r
27,切换游戏阶段,,game/6,,docs/api-18-27/,,SetFSMNextPhase,2,SetFSMNextPhase,TRUE,,,,,FE_1:PhaseIndex,,,,,module/18,,0.5\r
28,打开毒圈,,game/1,3190970,docs/api-20-28/,,OpenSafeZone,2,OpenSafeZone,TRUE,,,,1;2|3;4;5,,,,,,module/39,,0.5\r
29,关闭毒圈,,game/1,3190960,docs/api-20-29/,,CloseSafeZone,2,CloseSafeZone,TRUE,,,,,,,,,,module/39,,0.5\r
30,等待秒,,entity/1,,docs/api-1-30/,,WaitForSeconds,2,WaitForSeconds,TRUE,,,,,,,,,,action/1,,0.5\r
31,等待下一帧,,entity/1,,docs/api-1-31/,,WaitForNextFrame,2,WaitForNextFrame,TRUE,,,,,,,,,,action/1,,0.5\r
32,创建内置HUD,,entity/4,2490990,docs/api-22-32/,,CreateInternalHud,2,CreateInternalHud,TRUE,,P3=P2.EnumToType,P1=P3.InternalHudType,,FE_3:InternalHudType,,,,,action/22,,0.5\r
33,【废弃】移除内置HUD,,entity/4,2490980,docs/api-22-33/,,RemoveInternalHud,2,RemoveInternalHud,TRUE,,,,,,3,,,,action/22,,0.5\r
34,创建自定义HUD,1,entity/4,2490970,docs/api-22-34/,,CreateCustomHud,2,CreateCustomHud,TRUE,TRUE,,,,3:Enum_CustomHud;FE_3:CustomHudID,,,,,action/22,,0.5\r
35,【废弃】移除自定义HUD,,entity/4,2490960,docs/api-22-35/,,RemoveCustomHud,2,RemoveCustomHud,TRUE,,,,,,3,,,,action/22,,0.5\r
36,【废弃】创建特效,,entity/1,,docs/api-1-36/,,CreateEffectEntityPlayer,2,CreateEffectEntity,TRUE,,,,,3:EffectType;1:PresentEffect,3,,,,action/1,,0.5\r
37,【废弃】创建特效-全体,,entity/1,,docs/api-1-37/,,CreateEffectEntity,2,CreateEffectEntity,TRUE,,,,1;3,3:EffectType;1:PresentEffect,3,,,,action/1,,0.5\r
38,【废弃】移除特效,,entity/1,,docs/api-1-38/,,RemoveEffectEntity,2,RemoveEffectEntity,TRUE,,,,,,3,,,,action/1,,0.5\r
39,【废弃】创建文本,,entity/1,,docs/api-1-39/,,CreateTextEntityPlayer,2,CreateTextEntity,TRUE,,,,,1:PresentText,3,,,,action/1,,0.5\r
40,【废弃】创建文本-全体,,entity/1,,docs/api-1-40/,,CreateTextEntity,2,CreateTextEntity,TRUE,,,,1;3,1:PresentText,3,,,,action/1,,0.5\r
41,【废弃】移除文本,,entity/1,,docs/api-1-41/,,RemoveTextEntity,2,RemoveTextEntity,TRUE,,,,,,3,,,,action/1,,0.5\r
42,【废弃】创建图标,,entity/1,,docs/api-1-42/,,CreateIconEntityPlayer,2,CreateIconEntity,TRUE,,,,,3:IconType;1:PresentIcon,3,,,,action/1,,0.5\r
43,【废弃】创建图标-全体,,entity/1,,docs/api-1-43/,,CreateIconEntity,2,CreateIconEntity,TRUE,,,,1;3,3:IconType;1:PresentIcon,3,,,,action/1,,0.5\r
44,【废弃】移除图标,,entity/1,,docs/api-1-44/,,RemoveIconEntity,2,RemoveIconEntity,TRUE,,,,,,3,,,,action/1,,0.5\r
45,设置玩家是否可以移动,,game/2,,docs/api-1-45/,,SetMatchCanMove,2,SetMatchCanMove,TRUE,,,,,,,,,,action/1,,0.5\r
46,修改元素-数组,,data/3,4390970,docs/api-2-46/,,SetArrayElementByIndex,2,ListSetElement,TRUE,,P3=P1.T0,P3=P1.T0,,,,,ListName[Index] = Value,,data/2,T_49_SD_SEARCHKEY_LISTSET,0.5\r
47,添加元素-数组,,data/3,4390990,docs/api-2-47/,,ListAppend,2,ListAppend,TRUE,,P2=P1.T0,P2=P1.T0,,,,,,,data/2,T_49_SD_SEARCHKEY_LISTAPPEND,0.5\r
48,删除元素-数组,,data/3,4390980,docs/api-2-48/,,ListRemove,2,ListRemove,TRUE,,,,,,,,,,data/2,T_49_SD_SEARCHKEY_LISTDELETE,0.5\r
49,创建物件,,entity/9,,docs/api-26-49/,,CreateLevelObject,2,CreateLevelObject,TRUE,,,P1=LevelObject P3.ItemIDToType,,3:DynamicCreateItemID,,,,,action/26,,0.5\r
50,【废弃】删除物件,,entity/9,,docs/api-26-50/,,RemoveLevelObject,2,RemoveLevelObject,TRUE,,,,,1:EntityGetter,3,,,,action/26,,0.5\r
51,打印日志,,entity/1,2190960,docs/api-1-51/,,PrintString,2,PrintString,TRUE,,,,,,2,,,,action/1,,0.5\r
52,给玩家添加道具,,entity/3,,docs/api-15-52/,,AddItemToCharacter,2,AddItemToCharacter,TRUE,,,,,2:ItemGoodsIDType;FE_2:ItemID,,,,,action/15,,0.5\r
53,播放音效,,entity/6,,docs/api-1-53/,,NotifyPlaySound,2,NotifyPlaySound,TRUE,,,,,2:AudioType;FE_2:AudioID,,,,,action/1,,0.5\r
54,ConstFloatOrInt,,data/1,4190990,,T_34_LY_WS_VAL_DESC,ConstFloatOrInt,3,,,TRUE,,-,,,,,,,data/10000,Number,0.5\r
55,ConstString,,data/1,4190980,,T_48_JH_WS_STRINGDESC,ConstString,3,,,TRUE,,input_text,,,,,,,data/10000,T_49_SD_SEARCHKEY_TEXT,0.5\r
56,ConstVector3,,data/1,4190970,docs/api-4-56/,T_34_LY_WS_VEC_DESC,ConstVector3,3,NewVector,,TRUE,,,,,,,"Vector3{x,y,z}",,data/10000,Vector3,0.5\r
57,ConstBool,,data/1,4190960,,T_36_WZY_WS_LOGOPER,ConstBool,3,,,TRUE,,logic_boolean,,,,,,,data/10000,T_49_SD_SEARCHKEY_BOOL,0.5\r
10033,FE constPI,2,data/1,,,,ConstPI,,,,,,input_pi,,,,,NaturalConst.Pi,,data/10000,T_49_SD_SEARCHKEY_PI,0.5\r
10034,FE constE,2,data/1,,,,ConstE,,,,,,input_e,,,,,NaturalConst.E,,data/10000,T_49_SD_SEARCHKEY_E,0.5\r
58,ColorGetter,,data/1,4190950,,T_34_LY_WS_COL_DESC,ColorGetter,3,,,TRUE,,input_color,,,,,#RRGGBB,,data/10000,T_49_SD_SEARCHKEY_COLOR,0.5\r
59,EntityGetter,,data/1,4190940,,EntityGetter,EntityGetter,3,,,TRUE,,EntityGetter,,,,,,,data/10000,T_49_SD_SEARCHKEY_ENTITY,0.5\r
60,Arithmetic,,data/2,4290990,,T_36_WZY_WS_ARITHMETIC_NAMEDESC,Arithmetic,3,,,TRUE,,math_arithmetic,,,,,,,data/4,T_49_SD_SEARCHKEY_MATH,0.5\r
61,Comparer,,data/1,4180992,,T_34_WZ_WS_LOGIC2_NAMEDESC,Comparer,3,,,TRUE,,logic_compare,,,,,,,data/4,T_49_SD_SEARCHKEY_COMPARER,0.5\r
62,LogicalOperation,,data/1,4180991,,T_36_WZY_WS_LOGOPER,LogicalOperation,3,,,TRUE,,logic_operation,,,,,&& ||,,data/4,T_49_SD_SEARCHKEY_LOGICAL,0.5\r
63,脚本所在对象,,entity/1,,docs/api-1-63/,,ThisEntity,3,ThisEntity,,,,this_entity,,,,,thisEntity,,action/1,T_49_SD_SEARCHKEY_THISENTITY,0.5\r
64,所有玩家,,entity/1,2190950,docs/api-1-64/,,AllPlayers,3,AllPlayers,,,,,,,,,,,action/1,,0.5\r
65,所有队伍,,entity/1,2190940,docs/api-1-65/,,AllTeams,3,AllTeams,,,,,,,,,,,action/1,,0.5\r
66,数组长度,,data/3,4390950,docs/api-2-66/,,ArrayLength,3,ListLength,,,,,,,,,,,data/2,T_49_SD_SEARCHKEY_LISTLENGTH,0.5\r
67,获取元素-数组,,data/3,4390960,docs/api-2-67/,,ArrayElementByIndex,3,ListGetElement,,,R=P1.T0,R=P1.T0,,,,,ListName[Index],,data/2,T_49_SD_SEARCHKEY_LISTGET,0.5\r
68,随机整数,,data/2,4290960,docs/api-4-68/,,RandomInt,3,RandomInt,,,,,,,,,,,data/4,,0.5\r
69,随机小数,,data/2,4290950,docs/api-4-69/,,RandomFloat,3,RandomFloat,,,,,,,,,,,data/4,,0.5\r
70,非空,,data/1,4180990,docs/api-1-70/,,IsNil,3,IsNil,,,,,,,,,if(value==nil),,action/1,,0.5\r
71,绝对值,,data/2,4290940,docs/api-4-71/,,Abs,3,Abs,,,,R=0 P1 ?number,,1:ConstFloatOrInt,,,,,data/4,,0.5\r
72,非,,data/1,4180980,docs/api-1-72/,,Not,3,Not,,,,,,,,,!,,action/1,,0.5\r
73,平方根,,data/2,4290930,docs/api-4-73/,,Sqrt,3,Sqrt,,,,,,,,,,,data/4,,0.5\r
74,负值,,data/2,4290920,docs/api-4-74/,,Negate,3,Negate,,,,R=0 P1 ?number,,1:ConstFloatOrInt,,,,,data/4,,0.5\r
75,字符串链接,,data/6,4690990,docs/api-5-75/,,StrConcat,3,StrConcat,,TRUE,,str_concat,,,,,,,data/5,T_49_SD_SEARCHKEY_CONCANT,0.5\r
76,字符串长度,,data/6,4690980,docs/api-5-76/,,StrLen,3,StrLen,,,,,,,,,,,data/5,,0.5\r
77,伤害类型,,data/8,,docs/enum/,,DamageType,4,DamageType,,,,,,,,,,,data/10001,,0.5\r
78,积分类型,,data/8,,docs/enum/,,ScoreType,4,ScoreType,,,,,,1:ScoreType=1,,,,,data/10001,,0.5\r
79,内置HUD类型,,data/8,,docs/enum/,,InternalHudType,4,InternalHudType,,,,InternalHudType,,,,,,,data/10001,T_49_SD_SEARCHKEY_INTERNALHUD,0.5\r
80,,1,data/5,4590990,docs/api-4-80/,,VectorGetX,3,VectorGetX,,,,,,,,,Vector3.X,,data/4,,0.5\r
81,,1,data/5,4590960,docs/api-4-81/,,VectorSetX,2,VectorSetX,TRUE,,,,,,,2,Vector3.X = value,,data/4,,0.5\r
82,,1,data/5,4590950,docs/api-4-82/,,VectorSetY,2,VectorSetY,TRUE,,,,,,,2,Vector3.Y = value,,data/4,,0.5\r
83,,1,data/5,4590940,docs/api-4-83/,,VectorSetZ,2,VectorSetZ,TRUE,,,,,,,2,Vector3.Z = value,,data/4,,0.5\r
84,,1,data/2,4280990,docs/api-4-84/,,VectorAdd,3,VectorAdd,,,,,,,,,"Vector3{x,y,z}+Vector3{a,b,c}",,data/4,,0.5\r
85,,1,data/2,4280980,docs/api-4-85/,,VectorSub,3,VectorSub,,,,,,,,,"Vector3{x,y,z}-Vector3{a,b,c}",,data/4,,0.5\r
86,,1,data/2,4280970,docs/api-4-86/,,VectorMul,3,VectorMul,,,,,,,,,"Vector3{x,y,z} * value",,data/4,,0.5\r
87,,1,data/2,4280960,docs/api-4-87/,,VectorDot,3,VectorDot,,,,,,,,,,,data/4,,0.5\r
88,,1,data/2,4280950,docs/api-4-88/,,VectorCross,3,VectorCross,,,,,,,,,,,data/4,,0.5\r
89,,,data/2,4280940,docs/api-4-89/,,VectorNormalize,3,VectorNormalize,,,,,,,,,,,data/4,,0.5\r
90,,,data/2,4280930,docs/api-4-90/,,VectorSize,3,VectorSize,,,,,,,,,,,data/4,,0.5\r
91,,1,data/2,4280920,docs/api-4-91/,,VectorDistance,3,VectorDistance,,,,,,,,,,,data/4,,0.5\r
92,,1,data/2,4280910,docs/api-4-92/,,VectorAngel,3,VectorAngel,,,,,,,,,,,data/4,,0.5\r
93,设置实体属性,,entity/1,2190990,,T_34_WT_WS_ENTITY2_NAMEDESC,SetEntityProperty,2,,TRUE,TRUE,,property_set,,,,,EntityName<{0}>.{1} = Value,,action/1,T_49_SD_SEARCHKEY_SETVALUE,0.5\r
94,获取实体属性,,entity/1,2190980,,T_34_WT_WS_ENTITY4_NAMEDESC,GetEntityProperty,3,,,TRUE,,property_get,,,,,EntityName<{0}>.{1},,action/1,T_49_SD_SEARCHKEY_GETVALUE,0.5\r
95,获得游戏实体,,entity/1,2190970,docs/api-1-95/,,GetGlobalEntity,3,GetGlobalEntity,,,,,,,,,globalEntity,,action/1,,0.5\r
96,图片类型,,data/8,,docs/enum/,,IconType,4,IconType,,,,SpriteID,,,,,,,data/10001,T_49_SD_SEARCHKEY_IMGENUM,0.5\r
97,特效类型,,data/8,,docs/enum/,,EffectType,4,EffectType,,,,EffectID,,,,,,,data/10001,T_49_SD_SEARCHKEY_EFFECTENUM,0.5\r
98,类型指定图元,,entity/1,,,T_34_WT_WS_ENTITY3_NAMEDESC,As,3,,,TRUE,R=P2,as_type,,,,,,,action/1,T_49_SD_SEARCHKEY_AS,0.5\r
99,声音类型,,data/8,,docs/enum/,,AudioType,4,AudioType,,,,AudioID,,,,,,,data/10001,T_49_SD_SEARCHKEY_AUDIOENUM,0.5\r
100,,,data/8,,docs/enum/,,SortType,4,SortType,,,,,,,1,,,,data/10001,,0.5\r
101,结束当前阶段,,game/6,,docs/api-18-101/,,EndCurrentPhase,2,EndCurrentPhase,TRUE,,,,,,,,,,module/18,,0.5\r
102,获取控件,,entity/4,2490950,docs/api-22-102/,T_34_M_WS_GETCONTROL2,GetWidgetFromCustomHud,3,GetWidgetFromCustomHud,,TRUE,,R=P3.T0,,,,,,,action/22,,0.5\r
103,【废弃】随机出生点,,game/2,,docs/api-11-103/,,GetRandomSpawnPos,3,GetRandomSpawnPos,,,,,,,3,,,,module/11,,0.5\r
104,【废弃】获取玩家积分,,entity/10,,docs/api-19-104/,,GetPlayerScoreByType,3,GetPlayerScoreByType,,,,,,2:ScoreType=10,,,,,action/19,,0.5\r
105,【废弃】设置玩家积分,,entity/10,,docs/api-19-105/,,SetPlayerScoreByType,2,SetPlayerScoreByType,TRUE,,,,,2:ScoreType=10,,,,,action/19,,0.5\r
106,【废弃】获取队伍积分,,entity/10,,docs/api-19-106/,,GetTeamScoreByType,3,GetTeamScoreByType,,,,,,2:ScoreType=10,,,,,action/19,,0.5\r
107,【废弃】设置队伍积分,,entity/10,,docs/api-19-107/,,SetTeamScoreByType,2,SetTeamScoreByType,TRUE,,,,,2:ScoreType=10,,,,,action/19,,0.5\r
108,【废弃】获取玩家回合积分,,entity/10,,docs/api-19-108/,,GetPlayerRoundScoreByType,3,GetPlayerRoundScoreByType,,,,,,,1,,,,action/19,,0.5\r
109,【废弃】获取队伍回合积分,,entity/10,,docs/api-19-109/,,GetTeamRoundScoreByType,3,GetTeamRoundScoreByType,,,,,,,1,,,,action/19,,0.5\r
110,【废弃】获取玩家排名,,entity/10,,docs/api-19-110/,,GetPlayerRank,3,GetPlayerRank,,,,,,,1,,,,action/19,,0.5\r
112,【废弃】获取队伍排名,,entity/10,,docs/api-19-112/,,GetTeamRank,3,GetTeamRank,,,,,,,1,,,,action/19,,0.5\r
114,【废弃】获取玩家指定回合排名,,entity/10,,docs/api-19-114/,,GetPlayerRoundRank,3,GetPlayerRoundRank,,,,,,,1,,,,action/19,,0.5\r
115,【废弃】获取队伍指定回合排名,,entity/10,,docs/api-19-115/,,GetTeamRoundRank,3,GetTeamRoundRank,,,,,,,1,,,,action/19,,0.5\r
116,检测顺序触发,,entity/9,,docs/api-26-116/,,PlayerCheckCanTriggerLevelObjectByOrder,3,PlayerCheckCanTriggerLevelObjectByOrder,,,,,,,1,,,,action/26,,0.5\r
117,【废弃】传送,,entity/1,,docs/api-1-117/,,TeleportPlayer,2,TeleportPlayer,TRUE,,,,,,3,,,,action/1,,0.5\r
118,造成伤害,,entity/5,,docs/api-16-118/,,EntityTakeSystemDamage,2,EntityTakeDamage,TRUE,,,,1;3;4,3:DamageType,,,,,action/16,,0.5\r
119,玩家造成伤害,,entity/5,,docs/api-16-119/,,EntityTakeDamage,2,EntityTakeDamage,TRUE,,,,,3:DamageType,,,,,action/16,,0.5\r
120,【废弃】获得队友附近的位置,,entity/1,,docs/api-1-120/,,GetTeammateNearPos,3,GetTeammateNearPos,,,,,,,3,,,,action/1,,0.5\r
121,获得实体的绑定玩家,,game/2,3290960,docs/api-1-121/,,GetEntityOwner,3,GetEntityOwner,,,,,,,,,,,action/1,,0.5\r
122,加血,,game/2,3290980,docs/api-11-122/,,PlayerAddHP,2,PlayerAddHP,TRUE,,,,,,,,,,module/11,,0.5\r
123,复活,,game/2,3290990,docs/api-11-123/,,RevivePlayer,2,RevivePlayer,TRUE,,,,,,,,,,module/11,,0.5\r
124,所有物件,,entity/9,,docs/api-26-124/,,AllLevelObjs,3,AllLevelObjs,,,R=P1 ListT >,R=P1.EnumToType ListT >,,1:Enum_LevelObjType=LevelObject,,,,,action/26,,0.5\r
125,GetLocalVar,,variable,,,,GetLocalVar,3,,,TRUE,,-,,,,,,,variable,GetLocalVar,0.5\r
126,SetLocalVar,,variable,,,,SetLocalVar,2,,TRUE,TRUE,,-,,,,,,,variable,SetLocalVar,0.5\r
127,GetSelfGraphProperty,,variable,,,,GetSelfGraphProperty,3,,,TRUE,,-,,,,,,,variable,GetSelfGraphProperty,0.5\r
128,SetSelfGraphProperty,,variable,,,,SetSelfGraphProperty,2,,TRUE,TRUE,,-,,,,,,,variable,SetSelfGraphProperty,0.5\r
129,GetGlobalGraphProperty,,variable,,,,GetGlobalGraphProperty,3,,,TRUE,,-,,,,,,,variable,GetGlobalGraphProperty,0.5\r
130,SetGlobalGraphProperty,,variable,,,,SetGlobalGraphProperty,2,,TRUE,TRUE,,-,,,,,,,variable,SetGlobalGraphProperty,0.5\r
131,DefFuncWithoutReturn,,function,,,,DefFuncWithoutReturn,2,,,TRUE,,function_definition_noreturn,,,,,,,function,T_49_SD_SEARCHKEY_ACTION,0.5\r
132,DefFuncWithReturn,,function,,,,DefFuncWithReturn,2,,,TRUE,,function_definition,,,,,,,function,T_49_SD_SEARCHKEY_FUNCTION,0.5\r
133,CallActionFunc,,function,,,,CallActionFunc,2,,TRUE,TRUE,,-,,,,,,,function,CallActionFunc,0.5\r
134,CallDataFunc,,function,,,,CallDataFunc,3,,,TRUE,,-,,,,,,,function,CallDataFunc,0.5\r
135,OnClickHudButton,,event/2,,docs/event-22-135/,T_35_M_WS_BUTTONCLICKDESC,OnClickHudButton,1,OnClick,,TRUE,,button_event,,,,,,,event,T_49_SD_SEARCHKEY_BUTTONCLICK,0.5\r
136,返回值 （FE=返回）,,function,,docs/api-1-136/,T_34_WZ_WS_LOGIC11_NAMEDESC,ProcessCtlReturn,2,ProcessCtlReturn,,,,-,,,,,,,action/1,,0.5\r
137,道具ID类型,,data/8,,docs/enum/,,ItemGoodsIDType,4,ItemGoodsIDType,,,,ItemID,,,,,,,data/10001,T_49_SD_SEARCHKEY_ITEMENUM,0.5\r
138,私有-创建事件,,event/2,1290990,docs/event-1-138/,,OnAwake,1,OnAwake,TRUE,,,,,,,,,,event,,0.5\r
139,私有-击杀事件,,event/2,,docs/event-16-139/,,OnKill,1,OnKill,TRUE,,,,,,,,,,event,,0.5\r
140,私有-死亡事件,,event/2,,docs/event-16-140/,,OnDamaged,1,OnDamaged,TRUE,,,,,,,,,,event,,0.5\r
141,私有-受伤事件,,event/2,,docs/event-16-141/,,OnAttacked,1,OnAttacked,TRUE,,,,,,,,,,event,,0.5\r
142,私有-造成伤害事件,,event/2,,docs/event-16-142/,,OnHurt,1,OnHurt,TRUE,,,,,,,,,,event,,0.5\r
143,私有-进入触发器事件,,event/2,,docs/event-33-143/,,OnTriggerEnter,1,OnTriggerEnter,TRUE,,,,,,,,,,event,,0.5\r
144,私有-退出触发器事件,,event/2,,docs/event-33-144/,,OnTriggerLeave,1,OnTriggerLeave,TRUE,,,,,,,,,,event,,0.5\r
145,按钮点击时,,event/2,,docs/event-22-145/,,OnClick,1,OnClick,TRUE,,,,,,,,,,event,,0.5\r
146,创建道具,,entity/3,,docs/api-15-146/,,AddPickUpAtPosition,2,AddPickUpAtPosition,TRUE,,,P2=ItemID|ListT_ItemID;P3=Int ListT_Int P2.IsList ?,,2:ItemGoodsIDType;FE_2:ItemID;3:ConstFloatOrInt;FE_3:Int,,,,,action/15,,0.5\r
147,删除道具,,entity/3,,docs/api-15-147/,,PlayerRemoveItem,2,PlayerRemoveItem,TRUE,,,,,,,,,,action/15,,0.5\r
148,,1,data/5,4590980,docs/api-4-148/,,VectorGetY,3,VectorGetY,,,,,,,,,Vector3.Y,,data/4,,0.5\r
149,,1,data/5,4590970,docs/api-4-149/,,VectorGetZ,3,VectorGetZ,,,,,,,,,Vector3.Z,,data/4,,0.5\r
150,触发私有-玩家进入事件,,event/2,,docs/event-26-150/,,OnPlayerEnter,1,OnPlayerEnter,TRUE,,,,,,,,,,event,,0.5\r
151,触发私有-玩家退出事件,,event/2,,docs/event-26-151/,,OnPlayerLeave,1,OnPlayerLeave,TRUE,,,,,,,,,,event,,0.5\r
152,移除列表元素,,data/3,4390940,docs/api-2-152/,,ListRemoveAt,2,ListRemoveAt,TRUE,,,,,,,,,,data/2,,0.5\r
153,临时变量定义,,variable,,,,DefLocalVar,2,,TRUE,TRUE,P1=P2;P3=P2,localvar_def,,,,,,,variable,T_49_SD_SEARCHKEY_LOCALVAR,0.5\r
154,向上取���,,data/2,4260990,docs/api-4-154/,,Ceil,3,Ceil,,,,,,,,,,,data/4,,0.5\r
155,向下取整,,data/2,4260980,docs/api-4-155/,,Floor,3,Floor,,,,,,,,,,,data/4,,0.5\r
156,四舍五入取整,,data/2,4260970,docs/api-4-156/,,Round,3,Round,,,,,,,,,,,data/4,,0.5\r
157,正弦函数,,data/2,4260960,docs/api-4-157/,,Sin,3,Sin,,,,,,,,,,,data/4,,0.5\r
158,余弦函数,,data/2,4260950,docs/api-4-158/,,Cos,3,Cos,,,,,,,,,,,data/4,,0.5\r
159,正切函数,,data/2,4260940,docs/api-4-159/,,Tan,3,Tan,,,,,,,,,,,data/4,,0.5\r
160,飘字,,entity/4,,docs/api-1-160/,,NotifyShowTips,2,NotifyShowTips,TRUE,,,,,,,,,,action/1,,0.5\r
161,【废弃】私有-实体进入载具,,event/2,,docs/event-26-161/,,OnEnteringVehicle,1,OnEnteringVehicle,TRUE,,,,,,3,,,,event,,0.5\r
162,【废弃】私有-实体离开载具,,event/2,,docs/event-26-162/,,OnLeavingVehicle,1,OnLeavingVehicle,TRUE,,,,,,3,,,,event,,0.5\r
163,【废弃】私有-实体驾驶载具,,event/2,,docs/event-26-163/,,OnDrivingVehicle,1,OnDrivingVehicle,TRUE,,,,,,3,,,,event,,0.5\r
164,私有-载具被实体进入,,event/2,,docs/event-26-164/,,OnBeEnterVehicle,1,OnBeEnterVehicle,TRUE,,,,,,,,,,event,,0.5\r
165,私有-载具被实体离开,,event/2,,docs/event-26-165/,,OnBeLeaveVehicle,1,OnBeLeaveVehicle,TRUE,,,,,,,,,,event,,0.5\r
166,私有-载具被实体驾驶,,event/2,,docs/event-26-166/,,OnBeDriveVehicle,1,OnBeDriveVehicle,TRUE,,,,,,,,,,event,,0.5\r
10001,输入int,2,data/1,,,,ConstInt,,,,,,input_int,,,,,,,data/10000,T_49_SD_SEARCHKEY_INT,0.5\r
10002,输入float,2,data/1,,,,ConstFloat,,,,,,input_float,,,,,,,data/10000,T_49_SD_SEARCHKEY_FLOAT,0.5\r
10003,定义LocalVar,-1,variable,,,,DefLocalVarFE,,,,,,localvar_def,,,,,,,variable,LocalVar,0.5\r
10006,NewList,2,data/3,4390991,docs/api-2-10006/,,NewList,3,NewList,,,,R=ListT_any,,,,,,,data/2,T_49_SD_SEARCHKEY_NEWLIST,0.5\r
167,【废弃】私有-实体使用传送门,,event/2,,docs/event-26-167/,,OnTeleporting,1,OnTeleporting,TRUE,,,,,,3,,,,event,,0.5\r
168,私有-实体被物件产生弹跳,,event/2,,docs/event-26-168/,,OnBeSpring,1,OnBeSpring,TRUE,,,,,,,,,,event,,0.5\r
169,私有-传送门被实体使用传送,,event/2,,docs/event-26-169/,,OnBeTeleport,1,OnBeTeleport,TRUE,,,,,,,,,,event,,0.5\r
170,【废弃】私有-物件对实体产生弹跳行为,,event/2,,docs/event-26-170/,,OnSpringing,1,OnSpringing,TRUE,,,,,,3,,,,event,,0.5\r
171,是否包含指定元素,,data/3,4390930,docs/api-2-171/,,ListContains,3,ListContains,,,,,,,,,,,data/2,T_49_SD_SEARCHKEY_LISTCONTAIN,0.5\r
172,追加多条元素,,data/3,4390920,docs/api-2-172/,,ListAppendRange,2,ListAppendRange,TRUE,,,,,,,,,,data/2,T_49_SD_SEARCHKEY_LISTAPPENDRANGE,0.5\r
173,获取元素最先出现位置,,data/3,4390910,docs/api-2-173/,,ListIndexOf,3,ListIndexOf,,,,,,,,,,,data/2,T_49_SD_SEARCHKEY_LISTINDEXOF,0.5\r
174,获取元素最后出现位置,,data/3,4390900,docs/api-2-174/,,ListLastIndexOf,3,ListLastIndexOf,,,,,,,,,,,data/2,T_49_SD_SEARCHKEY_LISTLASTINDEXOF,0.5\r
175,生成器生成单位时,,event/2,,docs/event-1-175/,,OnSpawn,1,OnSpawn,TRUE,,,,,,,,,,event,,0.5\r
176,刷新下一波,,entity/9,,docs/api-1-176/,,RefreshSpawnableEntity,2,RefreshSpawnableEntity,TRUE,,,,,,,,,,action/1,,0.5\r
177,【废弃】构造方向点,,data/2,,docs/api-4-177/,,NewDirectPoint,3,NewDirectPoint,,,,,,,3,,,,data/4,,0.5\r
178,【废弃】取方向点位置,,data/2,,docs/api-4-178/,,DirectPointGetPos,3,DirectPointGetPos,,,,,,,3,,,,data/4,,0.5\r
179,【废弃】取方向点朝向,,data/2,,docs/api-4-179/,,DirectPointGetForward,3,DirectPointGetForward,,,,,,,3,,,,data/4,,0.5\r
180,修改属性因子,2,entity/10,,docs/api-24-180/,,ModifyPropertyFactor,2,ModifyPropertyFactor,TRUE,TRUE,,P2=P1 PropertyT >,,FE_2:FormulaProperty,1,,,,action/24,,0.5\r
181,【废弃】清除单个属性因子,2,entity/10,,docs/api-24-181/,,ClearPropertyFactor,2,ClearPropertyFactor,TRUE,TRUE,,P2=P1 PropertyT >,,FE_2:FormulaProperty,3,,,,action/24,,0.5\r
182,清除所有属性因子,,entity/10,,docs/api-24-182/,T_36_WZY_WS_REMMODEDPRO_NAMEDESC1,ClearAllPropertyFactor,2,ClearAllPropertyFactor,TRUE,TRUE,,,,,,,,,action/24,,0.5\r
183,属性因子类型,,data/8,,docs/enum/,,FormulaFactorType,4,FormulaFactorType,,,,,,,1,,,,data/10001,,0.5\r
184,当换武器时,,event/2,,docs/event-15-184/,,OnWield,1,OnWield,TRUE,,,,,,,,,,event,,0.5\r
185,可动态创建物件ID,,data/8,,docs/enum/,,DynamicCreateItemID,4,DynamicCreateItemID,,,,DynamicCreateItemID,,,,,,,data/10001,T_49_SD_SEARCHKEY_DYNAMICITEMENUM,0.5\r
186,修改属性,1,entity/10,,docs/api-24-186/,T_36_WZY_WS_MODGUNPRO_NAMEDESC,ModifyFormulaProperty,2,ModifyFormulaProperty,TRUE,TRUE,,P2=P1 PropertyT >,,FE_2:FormulaProperty,,,,,action/24,,0.5\r
187,设置属性,1,entity/10,,docs/api-24-187/,T_36_WZY_WS_SETGUNPRO_NAMEDESC,SetFormulaProperty,2,SetFormulaProperty,TRUE,TRUE,,P2=P1 PropertyT >,,FE_2:FormulaProperty,,,,,action/24,,0.5\r
188,清空单个属性,1,entity/10,,docs/api-24-188/,T_36_WZY_WS_REMMODEDPRO_NAMEDESC2,ClearSingleFormulaProperty,2,ClearSingleFormulaProperty,TRUE,TRUE,,P2=P1 PropertyT >,,FE_2:FormulaProperty,,,,,action/24,,0.5\r
189,属性修改方式,,data/8,,docs/enum/,,PropertyModifyType,4,PropertyModifyType,,,,,,,,,,,data/10001,,0.5\r
190,【废弃】实体被机关击飞,,event/2,,docs/event-26-190/,,OnBeHitFly,1,OnBeHitFly,TRUE,,,,,,3,,,,event,,0.5\r
191,启用默认AI,,entity/7,,docs/api-9-191/,,EnableDefaultAI,2,EnableDefaultAI,TRUE,,,,,,,,,,action/9,,0.5\r
192,AI追击实体,,entity/7,,docs/api-9-192/,,AIAttackEntity,2,AIAttackEntity,TRUE,,,,,,,,,,action/9,,0.5\r
193,巡逻至,,entity/7,,docs/api-9-193/,,PatrolTo,2,PatrolTo,TRUE,,,,,4:PatrolStyleType,,,,,action/9,,0.5\r
194,巡逻,,entity/7,,docs/api-9-194/,,PatrolAlong,2,PatrolAlong,TRUE,,,,,3:PatrolType;4:PatrolStyleType,,,,,action/9,,0.5\r
195,获取变量类型,,entity/1,,docs/api-1-195/,,GetType,3,GetType,,,,,,,,,,,action/1,,0.5\r
196,是否类型一致,,entity/1,,docs/api-1-196/,,TypeIs,3,TypeIs,,,,,,,,,,,action/1,,0.5\r
197,是否类型一致或继承,,entity/1,,docs/api-1-197/,,IsSubClassOf,3,IsSubClassOf,,,,,,,,,,,action/1,,0.5\r
198,值转字符串,,data/7,4790990,docs/api-6-198/,,ToString,3,ToString,,,,,,,,,,,data/6,,0.5\r
199,【废弃】摧毁玩家物品,,entity/3,,docs/api-15-199/,,DestroyEquipment,2,DestroyEquipment,TRUE,,,,,2:InventoryType;3:EquipSlotType,3,,,,action/15,,0.5\r
200,当穿装备时,,event/2,,docs/event-15-200/,,OnWear,1,OnWear,TRUE,,,,,,,,,,event,,0.5\r
201,【废弃】当玩家被击倒,,event/2,,docs/event-16-201/,,OnKnockedDown,1,OnKnockedDown,TRUE,,,,,,,,,,event,,0.5\r
202,当使用物品,,event/2,,docs/event-15-202/,,OnUseItem,1,OnUseItem,TRUE,,,,,,,,,,event,,0.5\r
203,尝试获取钱包,,game/7,,docs/api-25-203/,,TryGetWalletIDByEntity,2,TryGetWalletIDByEntity,TRUE,,,,,,,,,,module/25,,0.5\r
204,创建主钱包,,game/7,,docs/api-25-204/,,NewWalletForEntity,2,NewWalletForEntity,TRUE,,,,,,,,,,module/25,,0.5\r
205,钱包增加货币,,game/7,,docs/api-25-205/,,IncreaseMoneyForWallet,2,IncreaseMoneyForWallet,TRUE,,,,,2:MoneyType,,,,,module/25,,0.5\r
206,钱包消耗货币,,game/7,,docs/api-25-206/,,DecreaseMoneyForWallet,2,DecreaseMoneyForWallet,TRUE,,,,,2:MoneyType,,,,,module/25,,0.5\r
207,钱包交易货币,,game/7,,docs/api-25-207/,,TransferMoneyForWallet,2,TransferMoneyForWallet,TRUE,,,,,2:MoneyType,,,,,module/25,,0.5\r
208,获取货币数量,,game/7,,docs/api-25-208/,,GetMoneyCountByWallet,3,GetMoneyCountByWallet,,,,,,2:MoneyType,,,,,module/25,,0.5\r
209,通过RGB获取颜色值,,data/1,4180970,docs/api-1-209/,,ColorGet,3,ColorGet,,,,,,,,,,,action/1,,0.5\r
210,私有-实体进入触发器事件,,event/2,,docs/event-1-210/,,OnEnterTrigger,1,OnEnterTrigger,TRUE,,,,,,,,,,event,,0.5\r
211,私有-实体退出触发器事件,,event/2,,docs/event-1-211/,,OnLeaveTrigger,1,OnLeaveTrigger,TRUE,,,,,,,,,,event,,0.5\r
212,获取货币实体,,game/7,,docs/api-25-212/,,GetMoneyEntityByWallet,3,GetMoneyEntityByWallet,,,,,,2:MoneyType,,,,,module/25,,0.5\r
213,当获得物品,,event/2,,docs/event-15-213/,,OnObtainItem,1,OnObtainItem,TRUE,,,,,,,,,,event,,0.5\r
214,当获得武器,,event/2,,docs/event-15-214/,,OnObtainWeapon,1,OnObtainWeapon,TRUE,,,,,,,,,,event,,0.5\r
215,私有-机关把实体击飞,,event/2,,docs/event-26-215/,,OnHitFlying,1,OnHitFlying,TRUE,,,,,,,,,,event,,0.5\r
216,私有-队伍团灭时,,event/2,,docs/event-16-216/,,OnACE,1,OnACE,TRUE,,,,,,,,,,event,,0.5\r
217,【废弃】私有-积分改变时,,event/2,,docs/event-19-217/,,OnRoundScoreChange,1,OnRoundScoreChange,TRUE,,,,,,,,,,event,,0.5\r
218,私有-复活时,,event/2,,docs/event-11-218/,,OnRevived,1,OnRevived,TRUE,,,,,,,,,,event,,0.5\r
219,物品类型,,data/8,,docs/enum/,,InventoryType,4,InventoryType,,,,,,,,,,,data/10001,,0.5\r
220,类型枚举,,data/8,,docs/enum/,,TypeEnum,4,TypeEnum,,,,,,,,,,,data/10001,,0.5\r
221,克隆物件,,entity/9,,docs/api-1-221/,,CloneEntity,2,CloneEntity,TRUE,,P2=P1,P1=P2,,2:EntityGetter;FE_2:Component,,,,,action/1,,0.5\r
222,获取所有商店,,game/7,,docs/api-25-222/,,GetAllShops,3,GetAllShops,,,,,,,,,,,module/25,,0.5\r
223,巡逻风格,,data/8,,docs/enum/,,PatrolStyleType,4,PatrolStyleType,,,,,,,,,,,data/10001,,0.5\r
224,巡逻方式,,data/8,,docs/enum/,,PatrolType,4,PatrolType,,,,,,,,,,,data/10001,,0.5\r
225,EmptyList,,data/1,4190969,docs/api--225/,T_36_M_WS_EMPTYLISTDESC,EmptyList,3,EmptyList,,TRUE,,-,,,,,,,data/2,,0.5\r
226,货币类型,,data/8,,docs/enum/,,MoneyType,4,MoneyType,,,,,,,,,,,data/10001,,0.5\r
227,列表清空,,data/3,4380990,docs/api-2-227/,,ListClear,2,ListClear,TRUE,,,,,,,,,,data/2,T_49_SD_SEARCHKEY_LISTCLEAR,0.5\r
228,列表返转,,data/3,4380980,docs/api-2-228/,,ListReverse,2,ListReverse,TRUE,,,,,,,,,,data/2,T_49_SD_SEARCHKEY_LISTREVERSE,0.5\r
229,列表克隆,,data/3,4380970,docs/api-2-229/,,ListClone,3,ListClone,,,,,,,,,,,data/2,T_49_SD_SEARCHKEY_LISTCLONE,0.5\r
230,列表插入,,data/3,4380960,docs/api-2-230/,,ListInsert,2,ListInsert,TRUE,,,,,,,,,,data/2,T_49_SD_SEARCHKEY_LISTINSERT,0.5\r
231,字符串替换,,data/6,4690970,docs/api-5-231/,,StrReplace,3,StrReplace,,,,,,,,,,,data/5,,0.5\r
232,字符串查找,,data/6,4690960,docs/api-5-232/,,StrFind,3,StrFind,,,,,,,,,,,data/5,,0.5\r
233,字符串截取,,data/6,4690950,docs/api-5-233/,,StrSub,3,StrSub,,,,,,,,,,,data/5,,0.5\r
234,列表打乱,,data/3,4380950,docs/api-2-234/,,ListShuffle,2,ListShuffle,TRUE,,,,,,,,,,data/2,T_49_SD_SEARCHKEY_LISTSHUFFLE,0.5\r
10007,获得全局实体,-1,entity/1,2190930,docs/api-1-10007/,,GetGlobalEntityFE,3,GetGlobalEntity,,,,,,,,,,,action/1,,0.5\r
10008,列表初始化,2,data/3,4390993,docs/api--10008/,,ListInit,3,ListInit,,,,list_create,,,,,,,data/2,T_49_SD_SEARCHKEY_LISTCREATE,0.5\r
240,天空盒基础类型,,data/8,,docs/enum/,,SkyboxEnvBaseType,4,SkyboxEnvBaseType,,,,,,,,,,,data/10001,,0.5\r
241,设置天空盒,,entity/2,,docs/api-13-241/,,SetSkyboxEnv,2,SetSkyboxEnv,TRUE,,,,1,1:SkyboxEnvBaseType,,,,,action/13,,0.5\r
301,场景加载成功,2,event/1,,docs/event-13-301/,,OnSceneLoaded,1,OnSceneLoaded,TRUE,,,,,,,,,,event,,0.5\r
302,场景切换成功,2,event/1,,docs/event-13-302/,,OnSceneSwitchSuccessed,1,OnSceneSwitchSuccessed,TRUE,,,,,,,,,,event,,0.5\r
303,加载场景,2,entity/2,,docs/api-13-303/,,LoadScene,2,LoadScene,TRUE,,,,1,FE_1:SceneID,,,,,action/13,,0.5\r
304,卸载场景,2,entity/2,,docs/api-13-304/,,UnloadScene,2,UnloadScene,TRUE,,,,1,FE_1:SceneID,,,,,action/13,,0.5\r
305,切换场景,2,entity/2,,docs/api-13-305/,,SwitchScene,2,SwitchScene,TRUE,,,,1,FE_1:SceneID,,,,,action/13,,0.5\r
306,玩家复活来源类型,,data/8,,docs/enum/,,PlayerReviveSourceType,4,PlayerReviveSourceType,,,,,,,,,,,data/10001,,0.5\r
307,丢弃武器实体时,,event/2,,docs/event-15-307/,,OnDropWeapon,1,OnDropWeapon,TRUE,,,,,,,,,,event,,0.5\r
308,装备槽位类型,,data/8,,docs/enum/,,EquipSlotType,4,EquipSlotType,,,,,,,,,,,data/10001,,0.5\r
309,丢弃道具时,,event/2,,docs/event-15-309/,,OnDropItem,1,OnDropItem,TRUE,,,,,,,,,,event,,0.5\r
310,瞄准辅助类型,,data/8,,docs/enum/,,AimAssistType,4,AimAssistType,,,,,,,,,,,data/10001,,0.5\r
311,控制玩家语音聊天,,entity/10,,docs/api-28-311/,,MutePlayerVoice,2,MutePlayerVoice,TRUE,,,,,,,,,,action/28,,0.5\r
312,控制玩家快捷聊天,,entity/10,,docs/api-28-312/,,MutePlayerQuickChat,2,MutePlayerQuickChat,TRUE,,,,,,,,,,action/28,,0.5\r
313,实体筛选器,,entity/1,,docs/api-1-313/,,FilterEntities,3,FilterEntities,,,,,,,,,,,action/1,,0.5\r
314,空闲语音频道,,data/8,,docs/enum/,,FreeChatChannel,4,FreeChatChannel,,,,,,,1,,,,data/10001,,0.5\r
315,获取控件,,entity/4,2490940,docs/api-22-315/,T_34_M_WS_GETCONTROL2,GetWidgetFromCustomHudByString,3,GetWidgetFromCustomHudByString,,,,,,,,,,,action/22,,0.5\r
316,是否禁止拾取物品,,entity/3,,docs/api-15-316/,,DisablePickupItem,2,DisablePickupItem,TRUE,,,,,,,,,,action/15,,0.5\r
317,是否禁止丢弃物品,,entity/3,,docs/api-15-317/,,DisableDropItem,2,DisableDropItem,TRUE,,,,,,,,,,action/15,,0.5\r
318,创建阵营,,game/3,,docs/api-29-318/,,CreateFaction,2,CreateFaction,TRUE,,,,,,,,,,module/29,,0.5\r
319,加入阵营,,game/3,,docs/api-29-319/,,JoinFaction,2,JoinFaction,TRUE,,,,,,,,,,module/29,,0.5\r
320,获得可攻击阵营,,game/3,,docs/api-29-320/,,GetAttackableFactions,3,GetAttackableFactions,,,,,,,,,,,module/29,,0.5\r
321,设置可攻击阵营,,game/3,,docs/api-29-321/,,SetAttackableFaction,2,SetAttackableFaction,TRUE,,,,,,,,,,module/29,,0.5\r
322,设置可攻击玩家,,game/3,,docs/api-29-322/,,SetAttackablePlayer,2,SetAttackablePlayer,TRUE,,,,,3:AttackableOption,,,,,module/29,,0.5\r
323,设置可攻击队伍,,game/3,,docs/api-29-323/,,SetAttackableTeam,2,SetAttackableTeam,TRUE,,,,,,,,,,module/29,,0.5\r
324,获得可攻击玩家,,game/3,,docs/api-29-324/,,GetAttackablePlayer,3,GetAttackablePlayer,,,,,,,,,,,module/29,,0.5\r
325,足球和实体碰撞,,event/2,,docs/event-7-325/,,OnHitEntity,1,OnHitEntity,TRUE,,,,,,,,,,event,,0.5\r
326,被足球枪击中,,event/2,,docs/event-7-326/,,OnShootByGun,1,OnShootByGun,TRUE,,,,,,,,,,event,,0.5\r
327,瞄准实体时,,event/2,,docs/event-15-327/,,OnPlayerAimEntity,1,OnPlayerAimEntity,TRUE,,,,,,,,,,event,,0.5\r
328,实体被瞄准时,,event/2,,docs/event-15-328/,,OnEntityAimedByPlayer,1,OnEntityAimedByPlayer,TRUE,,,,,,,,,,event,,0.5\r
329,武器击中实体,,event/2,,docs/event-15-329/,,OnWeaponHitEntity,1,OnWeaponHitEntity,TRUE,,,,,,,,,,event,,0.5\r
330,实体被武器击中,,event/2,,docs/event-15-330/,,OnEntityHittedByWeapon,1,OnEntityHittedByWeapon,TRUE,,,,,,,,,,event,,0.5\r
331,进球时,,event/2,,docs/event-7-331/,,OnGoal,1,OnGoal,TRUE,,,,,,,,,,event,,0.5\r
332,琴键音乐组件类型,,data/8,,docs/enum/,,PianoMusicElementType,4,PianoMusicElementType,,,,,,,1,,,,data/10001,,0.5\r
333,Null,,data/1,4190930,docs/api--333/,T_36_JH_WS_NULL,Null,3,Null,,TRUE,,input_null,,,,,nil,,data/10000,T_49_SD_SEARCHKEY_NULL,0.5\r
334,取消伪装,,game/12,,docs/api-27-334/,,RestoreMorphTarget,2,RestoreMorphTarget,TRUE,,,,,,,,,,module/27,,0.5\r
335,变身,,game/12,,docs/api-27-335/,,MorphTargetLevelObject,2,MorphTargetLevelObject,TRUE,,,,,,,,,,module/27,,0.5\r
336,获取伪装实体,,game/12,,docs/api-27-336/,,GetMorphObjectByPlayer,3,GetMorphObjectByPlayer,,,,,,,,,,,module/27,,0.5\r
337,获取空频道,,entity/10,,docs/api-28-337/,,GetFreeChatChannel,3,GetFreeChatChannel,,,,,,1:FreeChatChannel,,,,,action/28,,0.5\r
338,获取当前频道,,entity/10,,docs/api-28-338/,,GetChatChannel,3,GetChatChannel,,,,,,,,,,,action/28,,0.5\r
339,玩家加入频道,,entity/10,,docs/api-28-339/,,JoinChatChannel,2,JoinChatChannel,TRUE,,,,,,,,,,action/28,,0.5\r
340,玩家退出频道,,entity/10,,docs/api-28-340/,,LeaveChatChannel,2,LeaveChatChannel,TRUE,,,,,,,,,,action/28,,0.5\r
341,玩家行为类型,,data/8,,docs/enum/,,PlayerBehaviorType,4,PlayerBehaviorType,,,,,,,1,,,,data/10001,,0.5\r
342,玩家行为状态,,data/8,,docs/enum/,,PlayerBehaviorStatus,4,PlayerBehaviorStatus,,,,,,,,,,,data/10001,,0.5\r
343,设置行为状态,,game/2,,docs/api-11-343/,,SetPlayerBehaviorStatus,2,SetPlayerBehaviorStatus,TRUE,,,,,2:PlayerBehaviorType;3:PlayerBehaviorStatus,,,,,module/11,,0.5\r
344,足球增加速度,,game/12,,docs/api-7-344/,,AddVelocity,2,AddVelocity,TRUE,,,,,,,,,,module/7,,0.5\r
345,球衣样式,,data/8,,docs/enum/,,CustomizeClothesType,4,CustomizeClothesType,,,,,,,1,,,,data/10001,,0.5\r
346,更换球衣,,game/12,,docs/api-7-346/,,ChangeCustomizeClothes,2,ChangeCustomizeClothes,TRUE,,,,,2:CustomizeClothesType,,,,,module/7,,0.5\r
347,恢复默认衣饰,,game/12,,docs/api-7-347/,,ClearCustomizeClothes,2,ClearCustomizeClothes,TRUE,,,,,,,,,,module/7,,0.5\r
348,Buff类型,,data/8,,docs/enum/,,BuffType,4,BuffType,,,,,,,,,,,data/10001,,0.5\r
349,移除实体,1,entity/1,,docs/api-1-349/,,RemoveEntity,2,RemoveEntity,TRUE,,,,,,2,,,,action/1,,0.5\r
350,添加Tag,,entity/1,,docs/api-1-350/,,AddTag,2,AddTag,TRUE,,,,,FE_2:InputTag,,,,,action/1,,0.5\r
351,删除Tag,,entity/1,,docs/api-1-351/,,RemoveTag,2,RemoveTag,TRUE,,,,,FE_2:InputTag,,,,,action/1,,0.5\r
352,包含Tag,,entity/1,,docs/api-1-352/,,HasTag,3,HasTag,TRUE,,,,,FE_2:InputTag,,,,,action/1,,0.5\r
353,敌意状态,,data/8,,docs/enum/,,AttackableOption,4,AttackableOption,,,,,,,1,,,,data/10001,,0.5\r
354,删除实体,,entity/1,,docs/api-1-354/,,DeleteEntity,2,RemoveEntity,TRUE,,,,,,,,,,action/1,,0.5\r
355,鼓点音乐组件类型,,data/8,,docs/enum/,,DrumMusicElementType,4,DrumMusicElementType,,,,,,,1,,,,data/10001,,0.5\r
356,Lead1音乐组件类型,,data/8,,docs/enum/,,Lead1MusicElementType,4,Lead1MusicElementType,,,,,,,1,,,,data/10001,,0.5\r
357,Lead2音乐组件类型,,data/8,,docs/enum/,,Lead2MusicElementType,4,Lead2MusicElementType,,,,,,,1,,,,data/10001,,0.5\r
358,Lead3音乐组件类型,,data/8,,docs/enum/,,Lead3MusicElementType,4,Lead3MusicElementType,,,,,,,1,,,,data/10001,,0.5\r
359,退出阵营,,game/3,,docs/api-29-359/,,QuitFaction,2,QuitFaction,TRUE,,,,,,1,,,,module/29,,0.5\r
360,足球设置位置,,game/12,,docs/api-7-360/,,SetFootballPosition,2,SetFootballPosition,TRUE,,,,,,,,,,module/7,,0.5\r
361,Loot点武器类型,,data/8,,docs/enum/,,LootWeaponType,4,LootWeaponType,,,,,,,,,,,data/10001,,0.5\r
362,反正弦函数,,data/2,4260930,docs/api-4-362/,,Asin,3,Asin,,,,,,,,,,,data/4,,0.5\r
363,反正余弦函数,,data/2,4260920,docs/api-4-363/,,Acos,3,Acos,,,,,,,,,,,data/4,,0.5\r
364,反正切函数,,data/2,4260910,docs/api-4-364/,,Atan,3,Atan,,,,,,,,,,,data/4,,0.5\r
365,私有-玩家断线时,,event/2,,docs/event-11-365/,,OnPlayerDisconnect,1,OnPlayerDisconnect,TRUE,,,,,,,,,,event,,0.5\r
366,私有-玩家断线重连时,,event/2,,docs/event-11-366/,,OnPlayerReconnect,1,OnPlayerReconnect,TRUE,,,,,,,,,,event,,0.5\r
367,创建商店,,game/7,,docs/api-25-367/,,CreateShop,2,CreateShop,TRUE,,,,,,,,,,module/25,,0.5\r
368,创建商店货架,,game/7,,docs/api-25-368/,,CreateShopShelf,2,CreateShopShelf,TRUE,,,,,,,,,,module/25,,0.5\r
369,创建商品,,game/7,,docs/api-25-369/,,CreateShopItem,2,CreateShopItem,TRUE,,,,,,,,,,module/25,,0.5\r
370,添加物品到商品,,game/7,,docs/api-25-370/,,AddItemToShopItem,2,AddItemToShopItem,TRUE,,,,,,,,,,module/25,,0.5\r
371,游戏更新时,,event/2,1290980,docs/event-1-371/,,OnUpdate,1,OnUpdate,TRUE,,,,,,,,,,event,,0.5\r
372,杀死可战斗实体,,entity/5,,docs/api-16-372/,,KillFightingEntity,2,KillFightingEntity,TRUE,,,,,,,,,,action/16,,0.5\r
373,【废弃】创建音效,,entity/6,,docs/api-1-373/,,CreateSoundEntity,2,CreateSoundEntity,TRUE,,,,,3:AudioType,3,,,,action/1,,0.5\r
374,购买商品时,,event/2,,docs/event-25-374/,,OnShopPurchase,1,OnShopPurchase,TRUE,,,,,,,,,,event,,0.5\r
375,贴图类型枚举,,data/8,,docs/enum/,,TextureType,4,TextureType,TRUE,,,TextureID,,,,,,,data/10001,T_49_SD_SEARCHKEY_TEXTUREID,0.5\r
376,武器被装备,,event/2,,docs/event-15-376/,,OnWeaponBeEquiped,1,OnWeaponBeEquiped,TRUE,,,,,,,,,,event,,0.5\r
377,击杀单位,,event/2,,docs/event-16-377/,,OnWeaponKillEntity,1,OnWeaponKillEntity,TRUE,,,,,,,,,,event,,0.5\r
378,造成伤害,,event/2,,docs/event-16-378/,,OnWeaponTakeDamage,1,OnWeaponTakeDamage,TRUE,,,,,,,,,,event,,0.5\r
379,更换子弹,,event/2,,docs/event-15-379/,,OnWeaponReload,1,OnWeaponReload,TRUE,,,,,,,,,,event,,0.5\r
380,物件分身,,game/12,,docs/api-27-380/,,CopyTargetLevelObject,2,CopyTargetLevelObject,TRUE,,,,,,,,,,module/27,,0.5\r
381,开火时,,event/2,,docs/event-11-381/,,OnPlayerFire,1,OnPlayerFire,TRUE,,,,,,,,,,event,,0.5\r
382,蹲下时,,event/2,,docs/event-11-382/,,OnPlayerCrouch,1,OnPlayerCrouch,TRUE,,,,,,,,,,event,,0.5\r
383,趴下时,,event/2,,docs/event-11-383/,,OnPlayerCreep,1,OnPlayerCreep,TRUE,,,,,,,,,,event,,0.5\r
384,跳起时,,event/2,,docs/event-11-384/,,OnPlayerJump,1,OnPlayerJump,TRUE,,,,,,,,,,event,,0.5\r
385,加速时,,event/2,,docs/event-11-385/,,OnPlayerSprint,1,OnPlayerSprint,TRUE,,,,,,,,,,event,,0.5\r
386,武器每次发射,,event/2,,docs/event-15-386/,,OnFiringEachBullet,1,OnFiringEachBullet,TRUE,,,,,,,,,,event,,0.5\r
387,获取当前相机,,game/5,,docs/api-8-387/,,GetCurrentCamera,3,GetCurrentCamera,,,,,,,1,,,,module/8,,0.5\r
388,切换相机,,game/5,,docs/api-8-388/,,SwitchCamera,2,SwitchCamera,TRUE,,,,,3:CameraTransitionType,1,,,,module/8,,0.5\r
389,创建相机,,game/5,,docs/api-8-389/,,CreateCamera,2,CreateCamera,TRUE,,,,,1:CameraType,1,,,,module/8,,0.5\r
390,球型范围判定,,game/4,,docs/api-33-390/,,IsEntityInsideSphere,3,IsEntityInsideSphere,,,,,,,,,,,module/33,,0.5\r
391,圆柱范围判定,,game/4,,docs/api-33-391/,,IsEntityInsideCylinder,3,IsEntityInsideCylinder,,,,,,,,,,,module/33,,0.5\r
392,方型范围判定,,game/4,,docs/api-33-392/,,IsEntityInsideBox,3,IsEntityInsideBox,,,,,,,,,,,module/33,,0.5\r
393,扇形范围判定,,game/4,,docs/api-33-393/,,IsEntityInsideSector,3,IsEntityInsideSector,,,,,,,,,,,module/33,,0.5\r
394,僵尸类型,,data/8,,docs/enum/,,AIType,4,AIType,,,,,,,,,,,data/10001,,0.5\r
395,Emote类型,,data/8,,docs/enum/,,EmoteType,4,EmoteType,EmoteType,,,,,,1,,,,data/10001,,0.5\r
396,播放Emote,,game/10,,docs/api-17-396/,,NotifyPlayEmote,2,NotifyPlayEmote,TRUE,,,,,2:EmoteType,,,,,module/17,,0.5\r
397,暂停动作,,game/10,,docs/api-17-397/,,NotifyPauseAnimation,2,NotifyPauseAnimation,TRUE,,,,,,,,,,module/17,,0.5\r
398,清除背包,,entity/3,,docs/api-15-398/,,ClearInventory,2,ClearInventory,TRUE,,,,,,,,,,action/15,,0.5\r
399,获取玩家背包里某个道具的数量,,entity/3,,docs/api-15-399/,,GetPlayerBagItemCount,3,GetPlayerBagItemCount,,,,,,,,,,,action/15,,0.5\r
400,摧毁玩家物品,,entity/3,,docs/api-15-400/,,DestroyEquipmentBySlot,2,DestroyEquipmentBySlot,TRUE,,,,,2:EquipSlotType,,,,,action/15,,0.5\r
401,设置实体跟随,,game/5,,docs/api-8-401/,,SetFollowEntity,2,SetFollowEntity,TRUE,,,,,,1,,,,module/8,,0.5\r
402,设置实体朝向,,game/5,,docs/api-8-402/,,SetWatchEntity,2,SetWatchEntity,TRUE,,,,,,1,,,,module/8,,0.5\r
403,ConstructVector3,,data/5,4590991,docs/api-4-403/,,NewVector3,3,NewVector,,,,-,,,,,"Vector3{x,y,z}",,data/4,,0.5\r
10009,FE 动态枚举 PhaseIndex,2,data/8,,docs/enum/,,PhaseIndex,4,PhaseIndex,,,,,,,,,,,data/10001,,0.5\r
404,相机类型,,data/8,,docs/enum/,,CameraType,4,CameraType,,,,,,,1,,,,data/10001,,0.5\r
405,清理地图物件残留,,entity/3,,docs/api-15-405/,,ClearAllLevelObjsResidual,2,ClearAllLevelObjsResidual,TRUE,,,,,,,,,,action/15,,0.5\r
406,特效贴图枚举,,data/8,,docs/enum/,,PresentEffectTexType,4,PresentEffectTexType,TRUE,,,PresentEffectTexType,,,,,,,data/10001,T_49_SD_SEARCHKEY_PREEFFECT,0.5\r
407,玩家进入载具,,event/2,,docs/event-26-407/,,OnEnteringVehicle_V2,1,OnEnteringVehicle_V2,TRUE,,,,,,,,,,event,,0.5\r
408,玩家离开载具,,event/2,,docs/event-26-408/,,OnLeavingVehicle_V2,1,OnLeavingVehicle_V2,TRUE,,,,,,,,,,event,,0.5\r
409,玩家驾驶载具,,event/2,,docs/event-26-409/,,OnDrivingVehicle_V2,1,OnDrivingVehicle_V2,TRUE,,,,,,,,,,event,,0.5\r
410,玩家传送,,event/2,,docs/event-26-410/,,OnTeleporting_V2,1,OnTeleporting_V2,TRUE,,,,,,,,,,event,,0.5\r
411,玩家发生弹跳行为,,event/2,,docs/event-26-411/,,OnSpringing_V2,1,OnSpringing_V2,TRUE,,,,,,,,,,event,,0.5\r
412,玩家被机关击飞,,event/2,,docs/event-26-412/,,OnBeHitFly_V2,1,OnBeHitFly_V2,TRUE,,,,,,,,,,event,,0.5\r
413,设置活动状态,,entity/1,,docs/api-1-413/,,SetActive,2,SetActive,TRUE,,,,,,,,,,action/1,,0.5\r
414,相机切换类型,,data/8,,docs/enum/,,CameraTransitionType,4,CameraTransitionType,,,,,,,1,,,,data/10001,,0.5\r
10010,FE Localize Key,2,data/1,,,,LocalizeKey,3,,,,,input_localization_key,,,,,"LocString{""Key"",{""param1"", ""param2"", ""param3""}}",,data/10000,T_49_SD_SEARCHKEY_LOCALKEY,0.5\r
10011,FE KeyEnum,-1,data/1,,,,KeyEnum,3,,,,,key_enum,,,,,,,data/10000,KeyEnum,0.5\r
415,设置玩家朝向,,game/2,,docs/api-11-415/,,PlayerSetForward,2,PlayerSetForward,TURE,,,,,,,,,,module/11,,0.5\r
416,Loot点子弹类型,,data/8,,docs/enum/,,LootAmmoType,4,LootAmmoType,,,,,,,,,,,data/10001,,0.5\r
417,Loot点消耗品类型,,data/8,,docs/enum/,,LootConsumableItemType,4,LootConsumableItemType,,,,,,,,,,,data/10001,,0.5\r
418,Loot点护甲类型,,data/8,,docs/enum/,,LootArmorType,4,LootArmorType,,,,,,,,,,,data/10001,,0.5\r
419,Loot点投掷物类型,,data/8,,docs/enum/,,LootProjectileType,4,LootProjectileType,,,,,,,,,,,data/10001,,0.5\r
420,Loot点倍镜类型,,data/8,,docs/enum/,,LootSightType,4,LootSightType,,,,,,,,,,,data/10001,,0.5\r
421,物件移动方式,,data/8,,docs/enum/,,MoveObjectMotionType,4,MoveObjectMotionType,,,,,,,,,,,data/10001,,0.5\r
423,OnPressHudButton,,event/2,,docs/event-22-423/,T_39_M_WS_BUTTON_PRESSDESC,OnPressHudButton,1,OnPress,,TRUE,,button_event,,,,,,,event,T_49_SD_SEARCHKEY_BUTTONPRESS,0.5\r
424,按钮按下时,,event/2,,docs/event-22-424/,,OnPress,1,OnPress,TRUE,,,,,,,,,,event,,0.5\r
425,OnReleaseHudButton,,event/2,,docs/event-22-425/,T_39_M_WS_BUTTON_RELEASEDESC,OnReleaseHudButton,1,OnRelease,,TRUE,,button_event,,,,,,,event,T_49_SD_SEARCHKEY_BUTTONRELEASE,0.5\r
426,按钮抬起时,,event/2,,docs/event-22-426/,,OnRelease,1,OnRelease,TRUE,,,,,,,,,,event,,0.5\r
427,OnDoubleClickHudButton,,event/2,,docs/event-22-427/,T_39_M_WS_BUTTON_DOUBLECLICKDESC,OnDoubleClickHudButton,1,OnDoubleClick,,TRUE,,button_event,,,,,,,event,T_49_SD_SEARCHKEY_BUTTONDOUBLECLICK,0.5\r
428,按钮双击时,,event/2,,docs/event-22-428/,,OnDoubleClick,1,OnDoubleClick,TRUE,,,,,,,,,,event,,0.5\r
429,【废弃】Tween动画图元,,entity/6,,docs/api-30-429/,,CreateTween,2,CreateTween,TRUE,TRUE,,P2=P1 PropertyT >;P3=P2.PropertyType,1;2;3;4|5;6;7;8,FE_2:TweenProperty;FE_6:input_bezier,3,,,,action/30,,0.5\r
430,【废弃】NewTweenCurve,,entity/6,,docs/api-30-430/,,NewTweenCurve,3,NewTweenCurve,,TRUE,,input_bezier,,,3,,,,action/30,T_49_SD_SEARCHKEY_BEZIER,0.5\r
431,JailBreakAreaBegin,2,event/2,,docs/event-10-431/,,OnJailBreakAreaBegin,1,OnJailBreakAreaBegin,TRUE,,,,,,,,,,event,,0.5\r
432,JailBreakAreaEnd,2,event/2,,docs/event-10-432/,,OnJailBreakAreaEnd,1,OnJailBreakAreaEnd,TRUE,,,,,,,,,,event,,0.5\r
433,GiveJailBreakReward,2,game/12,,docs/api-10-433/,,GiveJailBreakReward,2,GiveJailBreakReward,TRUE,,,,,1:Player;2:Int;3:Bool,,,,,module/10,,0.5\r
435,设置父子关系,,entity/1,,docs/api-1-435/,,SetParent,2,SetParent,TRUE,,,,,,,,,,action/1,,0.5\r
436,读取CSV全表数据,2,data/9,,docs/api-43-436/,,ReadCSVDataAll,3,ReadCSVDataAll,,,,,,FE_1:SelectCSV,,,,,data/43,,0.5\r
437,读取CSV表某一行数据,2,data/9,,docs/api-43-437/,,ReadCSVDataRow,3,ReadCSVDataRow,,,,,,FE_1:SelectCSV;2:Int=1,,,,,data/43,,0.5\r
438,读取CSV表某一列数据,2,data/9,,docs/api-43-438/,,ReadCSVDataCol,3,ReadCSVDataCol,,,,,,FE_1:SelectCSV;2:Int=1,,,,,data/43,,0.5\r
439,读取CSV表某单元数据,2,data/9,,docs/api-43-439/,,ReadCSVDataCell,3,ReadCSVDataCell,,,,,,FE_1:SelectCSV;2:Int=1;3:Int=1,,,,,data/43,,0.5\r
440,TweenStyle,,data/8,,docs/enum/,,TweenStyle,4,TweenStyle,,,,,,,,,,,data/10001,,0.5\r
441,PlayPlayable,,entity/6,,docs/api-30-441/,,PlayPlayable,2,PlayPlayable,TRUE,,,,,,,,,,action/30,,0.5\r
442,PausePlayable,,entity/6,,docs/api-30-442/,,PausePlayable,2,PausePlayable,TRUE,,,,,,,,,,action/30,,0.5\r
443,CreatePlayableTrajectory,,entity/6,,docs/api-30-443/,,CreatePlayableTrajectory,2,CreatePlayableTrajectory,TRUE,,,,5;1;2|3;4;6,,,,,,action/30,,0.5\r
444,CreatePlayablePosFollow,,entity/6,,docs/api-30-444/,,CreatePlayablePosFollow,2,CreatePlayablePosFollow,TRUE,,,,5;1;2|3;4;6,,,,,,action/30,,0.5\r
445,CreatePlayableLookAt,,entity/6,,docs/api-30-445/,,CreatePlayableLookAt,2,CreatePlayableLookAt,TRUE,,,,5;1;2|3;4;6,,,,,,action/30,,0.5\r
446,OnPlayableBegin,,event/2,,docs/event-30-446/,,OnPlayableBegin,1,OnPlayableBegin,TRUE,,,,,,,,,,event,,0.5\r
447,OnPlayableEnd,,event/2,,docs/event-30-447/,,OnPlayableEnd,1,OnPlayableEnd,TRUE,,,,,,,,,,event,,0.5\r
448,OnPlayableResume,,event/2,,docs/event-30-448/,,OnPlayableResume,1,OnPlayableResume,TRUE,,,,,,,,,,event,,0.5\r
449,OnPlayablePause,,event/2,,docs/event-30-449/,,OnPlayablePause,1,OnPlayablePause,TRUE,,,,,,,,,,event,,0.5\r
450,比赛结果,,data/8,,docs/enum/,,MatchResultType,4,MatchResultType,,,,,,,1,,,,data/10001,,0.5\r
451,【废弃】设置比赛结果,,entity/10,,docs/api-19-451/,,SetMatchResult,2,SetMatchResult,TRUE,,,,,2:MatchResultType,,,,,action/19,,0.5\r
452,CoordinateType,,data/8,,docs/enum/,,CoordinateType,4,CoordinateType,,,,,,,,,,,data/10001,,0.5\r
453,防御塔攻击范围类型,,data/8,,docs/enum/,,MinisentryAttackRangeType,4,MinisentryAttackRangeType,,,,,,,,,,,data/10001,,0.5\r
454,Loot点足球类型,,data/8,,docs/enum/,,LootSoccerType,4,LootSoccerType,,,,,,,,,,,data/10001,,0.5\r
455,接收玩家自定义的事件,2,event/3,,docs/event--455/,,OnCustomEvent,1,OnCustomEvent,TRUE,TRUE,,,,,,,,,event,,0.5\r
456,发出玩家自定义的事件,2,event/3,,docs/api-1-456/,,DispatchCustomEvent,2,DispatchCustomEvent,TRUE,TRUE,,,,,,,,,event,,0.5\r
457,JailBreakPlayerJoin,2,event/2,,docs/event-10-457/,,OnJailBreakPlayerJoin,1,OnJailBreakPlayerJoin,TRUE,,,,,,,,,,event,,0.5\r
458,JailBreakPlayerQuit,2,event/2,,docs/event-10-458/,,OnJailBreakPlayerQuit,1,OnJailBreakPlayerQuit,TRUE,,,,,,,,,,event,,0.5\r
459,UpdateJailBreakMission,2,game/12,,docs/api-10-459/,,UpdateJailBreakMission,2,UpdateJailBreakMission,TRUE,,,,,1:Int;2:Int,,,,,module/10,,0.5\r
460,【废弃】暂停音效,,entity/6,,docs/api-1-460/,,PauseSoundEntity,2,PauseSoundEntity,TRUE,,,,,,3,,,,action/1,,0.5\r
461,【废弃】继续播放音效,,entity/6,,docs/api-1-461/,,ResumeSoundEntity,2,ResumeSoundEntity,TRUE,,,,,,3,,,,action/1,,0.5\r
462,相机投影类型,,data/8,,docs/enum/,,CameraProjectionMode,4,CameraProjectionMode,,,,,,,1,,,,data/10001,,0.5\r
463,【废弃】读取数据库值,2,game/12,,docs/api-31-463/,,ReadDBSheetValue,2,ReadDBSheetValue,TRUE,,,P4=P1.SheetType,1;2;3;4,FE_1:DataSheet,3,,,,module/31,,0.5\r
464,【废弃】写入数据库值,2,game/12,,docs/api-31-464/,,WriteDBSheetValue,2,WriteDBSheetValue,TRUE,,,P4=P1.SheetType,1;2;3;4,FE_1:DataSheet,3,,,,module/31,,0.5\r
465,【废弃】删除数据库记录,2,game/12,,docs/api-31-465/,,DeleteDBSheetValue,2,DeleteDBSheetValue,TRUE,,,,1;2;3,FE_1:DataSheet,3,,,,module/31,,0.5\r
466,【废弃】读取数据库排行榜值,2,game/12,,docs/api-31-466/,,ReadDBLeaderboardValue,2,ReadDBLeaderboardValue,TRUE,,,,1;2;3,FE_1:RankSheet,3,,,,module/31,,0.5\r
467,【废弃】写入数据库排行榜值,2,game/12,,docs/api-31-467/,,WriteDBLeaderboardValue,2,WriteDBLeaderboardValue,TRUE,,,,1;2;3,FE_1:RankSheet,3,,,,module/31,,0.5\r
468,【废弃】根据Key删除数据库排行榜值,2,game/12,,docs/api-31-468/,,DeleteDBLeaderboardValueByKey,2,DeleteDBLeaderboardValueByKey,TRUE,,,,1;2,FE_1:RankSheet,3,,,,module/31,,0.5\r
469,【废弃】根据名次删除数据库排行榜值,2,game/12,,docs/api-31-469/,,DeleteDBLeaderboardValueByOrder,2,DeleteDBLeaderboardValueByOrder,TRUE,,,,1;2,FE_1:RankSheet,3,,,,module/31,,0.5\r
470,【废弃】根据名次范围读取数据库排行榜值,2,game/12,,docs/api-31-470/,,ReadDBLeaderboardValuesByRange,2,ReadDBLeaderboardValuesByRange,TRUE,,,,1;2;3;4,FE_1:RankSheet,3,,,,module/31,,0.5\r
471,添加脚本,,entity/1,,docs/api-1-471/,,AddScript,2,AddScript,TRUE,,,,,FE_2:ScriptID,1,,,,action/1,,0.5\r
472,移除脚本,,entity/1,,docs/api-1-472/,,RemoveScript,2,RemoveScript,TRUE,,,,,FE_2:ScriptID,1,,,,action/1,,0.5\r
473,是否存在脚本,,entity/1,,docs/api-1-473/,,ExistScript,3,ExistScript,,,,,,FE_2:ScriptID,1,,,,action/1,,0.5\r
474,相机遮蔽类型,,data/8,,docs/enum/,,CameraBlockMode,4,CameraBlockMode,,,,,,,1,,,,data/10001,,0.5\r
475,SetReplicationDataSmoothly,,entity/1,,docs/api-1-475/,,SetReplicationDataSmoothly,2,SetReplicationDataSmoothly,TRUE,TRUE,,P2=P1 PropertyT >;P3=P2.PropertyType,,FE_2:TweenProperty,,,,,action/1,,0.5\r
476,人物技能枚举,,data/8,,docs/enum/,,PlayerSkillType,4,PlayerSkillType,,,,PlayerSkillID,,,,,,,data/10001,T_49_SD_SEARCHKEY_PLAYERSKILLENUM,0.5\r
477,获取人物技能列表,,game/2,,docs/api-11-477/,,GetPlayerSkills,3,GetPlayerSkills,,,,,,,,,,,module/11,,0.5\r
478,设置人物技能列表,,game/2,,docs/api-11-478/,,SetPlayerSkills,2,SetPlayerSkills,TRUE,,,,,,,,,,module/11,,0.5\r
479,创建自定义UI控件,,entity/4,2490930,docs/api-22-479/,,CreateCustomHudWidget,2,CreateCustomHudWidget,TRUE,,,P1=HudWidget P2.WidgetType,,2:Enum_HudWidgetType,,,,,action/22,,0.5\r
480,单返回射线检测,,game/4,,docs/api-33-480/,,SingleRaycast,2,SingleRaycast,TRUE,,,,1;2;3;4|5;6;7;8;9,,,,,,module/33,,0.5\r
481,多返回射线检测,,game/4,,docs/api-33-481/,,MultiRaycast,2,MultiRaycast,TRUE,,,,1;2;3;4|5;6;7;8;9,,,,,,module/33,,0.5\r
482,【废弃】玩家骨骼枚举,,data/8,,docs/enum/,,PlayerBonesType,4,PlayerBonesType,,,,,,,3,,,,data/10001,,0.5\r
483,【废弃】设置玩家骨骼大小缩放,,game/2,,docs/api-11-483/,,SetPlayerBonesScale,2,SetPlayerBonesScale,TRUE,,,,,,3,,,,module/11,,0.5\r
484,圆形进度条倒计时结束,,event/1,,docs/event-22-484/,,OnCountdownFinished,1,OnCountdownFinished,TRUE,,,,,,1,,,,event,,0.5\r
485,读取CSV表某单元数据通过行数和列名,2,data/9,,docs/api-43-485/,,ReadCSVDataCellByRowAndColName,3,ReadCSVDataCellByRowAndColName,,,,,,FE_1:SelectCSV;2:Int=1,,,,,data/43,,0.5\r
486,从Prefab创建实体,2,entity/1,,docs/api-1-486/,,CreateEntityFromPrefab,2,CreateEntityFromPrefab,TRUE,,P2=P1,P1=P2.T0,,2:PrefabGetter,,,,,action/1,,0.5\r
487,私有-当拾取时,,event/2,,docs/event-15-487/,,OnPickup,1,OnPickup,TRUE,,,,,,,,,,event,,0.5\r
488,私有-当丢下时,,event/2,,docs/event-15-488/,,OnDrop,1,OnDrop,TRUE,,,,,,,,,,event,,0.5\r
489,私有-当装备时,,event/2,,docs/event-15-489/,,OnEquip,1,OnEquip,TRUE,,,,,,,,,,event,,0.5\r
490,私有-当地雷启动时,,event/2,,docs/event-15-490/,,OnLandmineObjStart,1,OnLandmineObjStart,TRUE,,,,,,,,,,event,,0.5\r
491,私有-当地雷触发时,,event/2,,docs/event-15-491/,,OnLandmineObjTrigger,1,OnLandmineObjTrigger,TRUE,,,,,,,,,,event,,0.5\r
492,私有-当使用时,,event/2,,docs/event-15-492/,,OnUse,1,OnUse,TRUE,,,,,,,,,,event,,0.5\r
493,私有-当爆炸时,,event/2,,docs/event-15-493/,,OnThrowHit,1,OnThrowHit,TRUE,,,,,,,,,,event,,0.5\r
494,玩家【击飞】效果,,game/2,,docs/api-11-494/,,HitFlyPlayer,2,HitFlyPlayer,TRUE,,,,,,,,,,module/11,,0.5\r
495,列表内容是否相同,,data/3,4380940,docs/api-2-495/,,ListIsEqual,3,ListIsEqual,,,,,,,,,,,data/2,,0.5\r
496,私有-当钩锁枪发射时,,event/2,,docs/event-15-496/,,OnFires,1,OnFires,,,,,,,,,,,event,,0.5\r
497,获取服务器时间戳,,game/1,3190940,docs/api-1-497/,,GetServerTime,3,GetServerTime,,,,,,,,,,,module/39,,0.5\r
498,获取服务器区域,,entity/1,,docs/api-1-498/,,GetServerRegion,3,GetServerRegion,,,,,,,,,,,action/1,,0.5\r
499,喷射击中时,,event/2,,docs/event-32-499/,,OnSprayedByWeapon,1,OnSprayedByWeapon,,,,,,,1,,,,event,,0.5\r
500,染色,,game/12,,docs/api-32-500/,,DyeingPosition,2,DyeingPosition,TRUE,,,,,,1,,,,module/32,,0.5\r
501,查询token数量,2,game/12,,docs/api-14-501/,,GetPlayerTokenNum,2,GetPlayerTokenNum,TRUE,,,,,,,,,,module/14,,0.5\r
502,增加玩家token,2,game/12,,docs/api-14-502/,,AddTokenToPlayer,2,AddTokenToPlayer,TRUE,,,,,,,,,,module/14,,0.5\r
503,消耗玩家token,2,game/12,,docs/api-14-503/,,PlayerRemoveToken,2,PlayerRemoveToken,TRUE,,,,,,,,,,module/14,,0.5\r
504,位置生成token,2,game/12,,docs/api-14-504/,,AddTokenAtPosition,2,AddTokenAtPosition,TRUE,,,,,,,,,,module/14,,0.5\r
505,返回最大数值,,data/2,4270990,docs/api-4-505/,,Max,3,Max,,,,R=0 P1 P2 ?number,,,,,,,data/4,,0.5\r
506,返回列表最大数值,,data/3,4380930,docs/api-2-506/,,ListFindMax,2,ListFindMax,TRUE,,,,,,,,,,data/2,,0.5\r
507,返回最小数值,,data/2,4270980,docs/api-4-507/,,Min,3,Min,,,,R=0 P1 P2 ?number,,,,,,,data/4,,0.5\r
508,返回列表最小数值,,data/3,4380920,docs/api-2-508/,,ListFindMin,2,ListFindMin,TRUE,,,,,,,,,,data/2,,0.5\r
509,返回插值,,data/2,4270970,docs/api-4-509/,,Lerp,3,Lerp,,,,,,,,,,,data/4,,0.5\r
510,返回限制数值,,data/2,4270960,docs/api-4-510/,,Clamp,3,Clamp,,,,R=0 P1 P2 P3 ?number,,,,,,,data/4,,0.5\r
511,取得颜色(RGBA)值通道,,data/1,4180960,docs/api-1-511/,,ColorGetChannel,2,ColorGetChannel,TRUE,,,,,,1,,,,action/1,,0.5\r
512,获取玩家服装ID,,game/10,,docs/api-17-512/,,GetPlayerClothIDByWardrobeType,3,GetPlayerClothIDByWardrobeType,,,,,,,,,,,module/17,,0.5\r
513,设置玩家服装ID,,game/10,,docs/api-17-513/,,SetPlayerClothID,2,SetPlayerClothID,TRUE,,,,,FE_2:ClothID,,,,,module/17,,0.5\r
514,恢复玩家默认服装,,game/10,,docs/api-17-514/,,ReSetPlayerClothes,2,ReSetPlayerClothes,TRUE,,,,,,,,,,module/17,,0.5\r
515,根据位置获取染色状态,,game/12,,docs/api-32-515/,,GetDyeingState,3,GetDyeingState,TRUE,,,,,,1,,,,module/32,,0.5\r
516,统计染色数量图元,,game/12,,docs/api-32-516/,,GetDyeingCount,3,GetDyeingCount,TRUE,,,,,,1,,,,module/32,,0.5\r
517,对平面染色,,game/12,,docs/api-32-517/,,DyeingPlane,2,DyeingPlane,TRUE,,,,,,1,,,,module/32,,0.5\r
518,对区域染色,,game/12,,docs/api-32-518/,,DyeingArea,2,DyeingArea,TRUE,,,,,,1,,,,module/32,,0.5\r
519,切换玩家区域,,entity/2,,docs/api-13-519/,,SwitchPlayerArea,2,SwitchPlayerArea,TRUE,,,,1;2;3;4,FE_2:SceneID,1,,,,action/13,,0.5\r
520,玩家切换区域成功,,event/2,,docs/event-13-520/,,OnSwitchPlayerArea,1,OnSwitchPlayerArea,TRUE,,,,,,1,,,,event,,0.5\r
521,私有-停止开火时,,event/2,,docs/event-15-521/,,OnStopFire,1,OnStopFire,TRUE,,,,,,,,,,event,,0.5\r
522,玩家服装部件枚举,,data/8,,docs/enum/,,WardrobeType,4,WardrobeType,,,,,,,,,,,data/10001,,0.5\r
523,设置相机CullingMask,,game/5,,docs/api-8-523/,,SetCameraCullingMask,2,SetCameraCullingMask,TRUE,,,,,,1,,,,module/8,,0.5\r
524,设置相机CullingMask对某层是否可见,,game/5,,docs/api-8-524/,,AddOrRemoveCameraCullingMask,2,AddOrRemoveCameraCullingMask,TRUE,,,,,,1,,,,module/8,,0.5\r
525,染色颜色类型,,data/8,,docs/enum/,,SprayColor,4,SprayColor,,,,,,,1,,,,data/10001,,0.5\r
526,当AI开始追击时,,event/2,,docs/event-9-526/,,OnAIStartChase,1,OnAIStartChase,TRUE,,,,,,1,,,,event,,0.5\r
527,当AI停止追击时,,event/2,,docs/event-9-527/,,OnAIStopChase,1,OnAIStopChase,TRUE,,,,,,1,,,,event,,0.5\r
528,设置玩家界面显示开关,,game/2,,docs/api-11-528/,,SetPlayerHubSwitch,2,SetPlayerHubSwitch,TRUE,,,,,2:PlayerHudSwitchType;3:CommonHudSwitchValue,,,,,module/11,,0.5\r
529,玩家界面显示开关类型,,data/8,,docs/enum/,,PlayerHudSwitchType,4,PlayerHudSwitchType,,,,,,,,,,,data/10001,,0.5\r
530,获取相机CullingMask,,game/5,,docs/api-8-530/,,GetCameraCullingMask,3,GetCameraCullingMask,TRUE,,,,,,1,,,,module/8,,0.5\r
531,获取场景对应的天空盒,,entity/2,,docs/api-13-531/,,GetSceneSkybox,3,GetSceneSkybox,,,,,,FE_1:SceneID,1,,,,action/13,,0.5\r
532,字符串转整形,,data/7,4790970,docs/api-6-532/,,String2Int,2,String2Int,TRUE,,,,,,,,,,data/6,,0.5\r
533,字符串转浮点数,,data/7,4790960,docs/api-6-533/,,String2Float,2,String2Float,TRUE,,,,,,,,,,data/6,,0.5\r
534,切换玩家武器,,entity/3,,docs/api-15-534/,,SwitchWeaponBySlot,2,SwitchWeaponBySlot,TRUE,,,,,,,,,,action/15,,0.5\r
535,切换武器槽位类型,,data/8,,docs/enum/,,SwitchWeaponEquipSlot,4,SwitchWeaponEquipSlot,,,,,,,,,,,data/10001,,0.5\r
536,获取玩家枪皮,,game/10,,docs/api-17-536/,,GetPlayerWeaponSkinIDByWeaponID,3,GetPlayerWeaponSkinIDByWeaponID,,,,,,2:ItemGoodsIDType;FE_2:ItemID,,,,,module/17,,0.5\r
537,设定玩家枪皮,,game/10,,docs/api-17-537/,,SetPlayerWeaponSkinID,2,SetPlayerWeaponSkinID,TRUE,,,,,FE_2: WeaponSkinID,,,,,module/17,,0.5\r
538,恢复玩家默认枪皮,,game/10,,docs/api-17-538/,,ReSetPlayerWeaponSkinByWeaponID,2,ReSetPlayerWeaponSkinByWeaponID,TRUE,,,,,2:ItemGoodsIDType;FE_2:ItemID,,,,,module/17,,0.5\r
539,删除所有子节点,,entity/1,,docs/api-1-539/,,ClearAllChildren,2,ClearAllChildren,TRUE,,,,,,,,,,action/1,,0.5\r
540,通过ID获取子节点,,entity/1,,docs/api-1-540/,,GetChildByIndex,3,GetChildByIndex,,,,,,,,,,,action/1,,0.5\r
541,获取所有子节点,,entity/1,,docs/api-1-541/,,GetChildren,3,GetChildren,,,,,,,,,,,action/1,,0.5\r
542,获取父节点,,entity/1,,docs/api-1-542/,,GetParent,3,GetParent,,,,,,,,,,,action/1,,0.5\r
543,【已废弃】创建特效全体新,,entity/6,,docs/api-1-543/,,CreateEffectEntityNew,2,CreateEffectEntityNew,TRUE,,,,1;3,3:EffectType;FE_3:EffectID;1:EffectEntity,1,,,,action/1,,0.5\r
545,【已废弃】创建特效玩家新,,entity/6,,docs/api-1-545/,,CreateEffectEntityPlayerNew,2,CreateEffectEntityNew,TRUE,,,,,3:EffectType;FE_3:EffectID;1:EffectEntity,1,,,,action/1,,0.5\r
547,创建时间戳本地化字符串,,data/7,4790860,docs/api-1-547/,,CreateTimestampLocString,3,CreateTimestampLocString,,,,,,2:TimestampFormatStyle,1,,,,data/6,,0.5\r
548,时间戳格式化显示样式,,data/8,,docs/enum/,,TimestampFormatStyle,4,TimestampFormatStyle,,,,,,,1,,,,data/10001,,0.5\r
549,创建字典,,data/4,,docs/api-3-549/,,NewMap,3,NewMap,,,,map_dictionary,,,1,,,,data/3,T_49_SD_SEARCHKEY_MAPCREATE,0.5\r
550,按key获取字典值,,data/4,,docs/api-3-550/,,MapGetValue,3,MapGetValue,,,,R=P1.T1,,,1,,MapName[Key],,data/3,T_49_SD_SEARCHKEY_MAPGET,0.5\r
551,修改字典值,,data/4,,docs/api-3-551/,,MapSetValue,2,MapSetValue,TRUE,,,,,,1,,MapName[Key] = Value,,data/3,T_49_SD_SEARCHKEY_MAPSET,0.5\r
552,移除字典值,,data/4,,docs/api-3-552/,,MapRemoveValue,2,MapRemoveValue,,,,,,,1,,,,data/3,T_49_SD_SEARCHKEY_MAPREMOVE,0.5\r
553,清除字典,,data/4,,docs/api-3-553/,,MapClear,2,MapClear,,,,,,,1,,,,data/3,T_49_SD_SEARCHKEY_MAPCLEAR,0.5\r
554,获得Map长度,,data/4,,docs/api-3-554/,,MapGetLength,3,MapGetLength,,,,,,,1,,,,data/3,T_49_SD_SEARCHKEY_MAPLENGTH,0.5\r
555,通用HUD开关值,,data/8,,docs/enum/,,CommonHudSwitchValue,4,CommonHudSwitchValue,,,,,,,,,,,data/10001,,0.5\r
556,性别枚举,,data/8,,docs/enum/,,GenderType,4,GenderType,,,,,,,,,,,data/10001,,0.5\r
557,油桶爆炸时,,event/2,,docs/event-26-557/,,OnOildrumExplode,1,OnOildrumExplode,TRUE,,,,,,,,,,event,,0.5\r
558,创建小地图图标,,game/8,,docs/api-34-558/,,CreateMapIconEntity,2,CreateMapIconEntity,TRUE,,,,,3:IconType;1:MiniMapIcon,,,,,module/34,,0.5\r
559,OnInternalHUDClick,,event/2,,docs/event-22-559/,,OnInternalHUDClick,1,OnInternalHUDClick,TRUE,,,,,,1,,,,event,,0.5\r
560,客户端相机射线检测时,,event/1,,docs/event-22-560/,,OnClientCameraRayCast,1,OnClientCameraRayCast,TRUE,,,,,,,,,,event,,0.5\r
561,创建小地图像素,,game/8,,docs/api-34-561/,,CreateMapBitEntity,2,CreateMapBitEntity,TRUE,,,,,,,,,,module/34,,0.5\r
562,当发生碰撞时,,event/2,,docs/event-33-562/,,OnCollisionEnter,1,OnCollisionEnter,TRUE,,,,,,,,,,event,,0.5\r
563,当碰撞结束时,,event/2,,docs/event-33-563/,,OnCollisionExit,1,OnCollisionExit,TRUE,,,,,,,,,,event,,0.5\r
564,盒体扫描检测,,game/4,,docs/api-33-564/,,BoxCast,2,BoxCast,TRUE,,,,1;2;3|4;5;6;7;8,,,,,,module/33,,0.5\r
565,球体扫描检测,,game/4,,docs/api-33-565/,,SphereCast,2,SphereCast,TRUE,,,,1;2;3;4|5;6;7,,,,,,module/33,,0.5\r
566,胶囊体扫描检测,,game/4,,docs/api-33-566/,,CapsuleCast,2,CapsuleCast,TRUE,,,,1;2;3;4;5|6;7;8;9,,,,,,module/33,,0.5\r
567,盒体重叠检测,,game/4,,docs/api-33-567/,,BoxOverlap,2,BoxOverlap,TRUE,,,,1;2;3|4;5;6,,,,,,module/33,,0.5\r
568,球体重叠检测,,game/4,,docs/api-33-568/,,SphereOverlap,2,SphereOverlap,TRUE,,,,1;2;3|4;5,,,,,,module/33,,0.5\r
569,胶囊体重叠检测,,game/4,,docs/api-33-569/,,CapsuleOverlap,2,CapsuleOverlap,TRUE,,,,1;2;3;4|5;6;7,,,,,,module/33,,0.5\r
570,AI攻击实体,,entity/7,,docs/api-9-570/,,AIRealAttackEntity,2,AIRealAttackEntity,TRUE,,,,,,1,,,,action/9,,0.5\r
571,当AI开始攻击时,,event/2,,docs/event-9-571/,,OnAIStartAttack,1,OnAIStartAttack,TRUE,,,,,,1,,,,event,,0.5\r
572,当AI停止攻击时,,event/2,,docs/event-9-572/,,OnAIStopAttack,1,OnAIStopAttack,TRUE,,,,,,1,,,,event,,0.5\r
573,获得玩家小地图,,game/8,,docs/api-34-573/,,GetPlayerMiniMap,3,GetPlayerMiniMap,TRUE,,,,,,1,,,,module/34,,0.5\r
574,批量修改玩家服饰,,game/10,,docs/api-17-574/,,SetPlayerClothIDs,2,SetPlayerClothIDs,TRUE,,,,,,1,,,,module/17,,0.5\r
575,去除玩家服装,,game/10,,docs/api-17-575/,,RemovePlayerClothIDByWardrobeType,2,RemovePlayerClothIDByWardrobeType,TRUE,,,,,,,,,,module/17,,0.5\r
576,去除玩家枪皮,,game/10,,docs/api-17-576/,,RemovePlayerWeaponSkinByWeaponID,2,RemovePlayerWeaponSkinByWeaponID,TRUE,,,,,2:ItemGoodsIDType;FE_2:ItemID,,,,,module/17,,0.5\r
8000,是否循环重载,0,data/8,,docs/enum/,,AnimationOverrideLoopType,4,AnimationOverrideLoopType,,,,,,,,,,,data/10001,,0.5\r
8001,播放动画,0,game/9,,docs/api-35-8001/,,PlayAnimationByController,2,PlayAnimationByController,TRUE,,,,,FE_2:AnimationState;FE_4:AnimationOverrideLoopType;4:AnimationOverrideLoopType,,,,,action/35,,0.5\r
8002,动画片段播放结束,0,event/1,,docs/event-35-8002/,,OnAnimationClipEnd,1,OnAnimationClipEnd,TRUE,,,,,,,,,,event,,0.5\r
8003,动画状态播放结束,0,event/1,,docs/event-35-8003/,,OnAnimationStateEnd,1,OnAnimationStateEnd,TRUE,,,,,,,,,,event,,0.5\r
8004,进入行为树节点,2,event/1,,docs/event-36-8004/,,OnNodeEnter,1,OnNodeEnter,TRUE,,,,,,,,,,event,,0.5\r
8005,退出行为树节点,2,event/1,,docs/event-36-8005/,,OnNodeExit,1,OnNodeExit,TRUE,,,,,,,,,,event,,0.5\r
8006,设置动画身体部位的权重,0,game/9,,docs/api-35-8006/,,SetBodyPartTrackWeight,2,SetBodyPartTrackWeight,TRUE,,,,,,,,,,action/35,,0.5\r
8010,Avatar换装,2,entity/10,,docs/api-37-8010/,,ChangeAvatarPart,2,ChangeAvatarPart,TRUE,,,,,,,,,,action/37,,0.5\r
8011,启用Avatar部件,2,entity/10,,docs/api-37-8011/,,EnableAvatarPart,2,EnableAvatarPart,TRUE,,,,,,,,,,action/37,,0.5\r
8012,关闭Avatar部件,2,entity/10,,docs/api-37-8012/,,DisableAvatarPart,2,DisableAvatarPart,TRUE,,,,,,,,,,action/37,,0.5\r
8013,切换自定角色,2,game/2,,docs/api-11-8013/,,SwitchPresetCharacterType,2,SwitchPresetCharacterType,TRUE,,,,,,,,,,module/11,,0.5\r
8014,播放自定表情,2,game/2,,docs/api-11-8014/,,PlayCharacterAnimationClip,2,PlayCharacterAnimationClip,TRUE,,,,,,,,,,module/11,,0.5\r
8015,播放自定表情高级,2,game/2,,docs/api-11-8015/,,PlayCharacterAnimationClipOverride,2,PlayCharacterAnimationClipOverride,TRUE,,,,,,,,,,module/11,,0.5\r
8016,停止动画,0,game/9,,docs/api-35-8016/,,StopAnimationByController,2,StopAnimationByController,TRUE,,,,,FE_2:AnimationState,,,,,action/35,,0.5\r
8017,创建骨骼注视控制器,2,game/9,,docs/api-37-8017/,,CreateSkeletonPartLookAtController,2,CreateSkeletonPartLookAtController,TRUE,,,,,,,,,,action/35,,0.5\r
10015,FE 可见层级枚举 VisibilityLayer,2,data/8,,docs/enum/,,VisibilityLayer,4,VisibilityLayer,,,,,,,1,,,,data/10001,,0.5\r
10016,FE 枪皮类型枚举,2,data/8,,docs/enum/,,WeaponSkinID,4,WeaponSkinID,,,,WeaponSkinID,,,1,,,,data/10001,T_49_SD_SEARCHKEY_WEAPONSKINENUM,0.5\r
10017,FE 服装类型枚举,2,data/8,,docs/enum/,,ClothID,4,ClothID,,,,ClothID,,,1,,,,data/10001,T_49_SD_SEARCHKEY_CLOTHENUM,0.5\r
10018,添加注释,2,entity/1,2190920,,,Comment,,,,,,input_comments,,,1,,//comment,,action/1,T_49_SD_SEARCHKEY_COMMENT,0.5\r
10019,FE 选择Prefab,2,data/1,,,,PrefabGetter,,,,,,PrefabGetter,,,1,,,,data/10000,T_49_SD_SEARCHKEY_PREFAB,0.5\r
10020,FE 选择ECA 脚本,2,data/1,,,,ScriptID,,,,,,ScriptID,,,1,,,,data/10000,T_49_SD_SEARCHKEY_SCRIPTID,0.5\r
10032,FE 选择行为树,2,data/1,,,,BTreeID,,,,,,BTreeID,,,,,,,data/10000,T_49_SD_SEARCHKEY_BTREEID,0.5\r
10021,FE 物理层级枚举 PhysicalLayer,2,data/8,,docs/enum/,,PhysicalLayer,4,PhysicalLayer,,,,,,,1,,,,data/10001,,0.5\r
10022,FE 裸资源收集,2,data/1,,,,RawResource,3,,,,,RawResource,,,,,,,data/10000,T_49_SD_SEARCHKEY_RAWID,0.5\r
10023,AI技能枚举,,data/8,,docs/enum/,,AISkillType,4,AISkillType,,,,,,,1,,,,data/10001,,0.5\r
10024,行为树节点状态,2,data/8,,docs/enum/,,BTreeNodeState,4,BTreeNodeState,,,,,,,,,,,data/10001,,0.5\r
10025,FE 动画状态枚举 AnimationControllerStates,-1,data/8,,docs/enum/,,AnimationControllerStates,4,AnimationControllerStates,,,,,,,1,,,,data/10001,,0.5\r
577,字典是否存在key,,data/4,,docs/api-3-577/,,MapContainKey,3,MapContainKey,,,,,,,1,,,,data/3,T_49_SD_SEARCHKEY_MAPCONTAIN,0.5\r
578,获取随机出生点可用位置,,game/2,,docs/api-11-578/,,GetRandomSpawnPosVec3,3,GetRandomSpawnPosVec3,,,,,,,,,,,module/11,,0.5\r
579,传送玩家,,game/2,3290970,docs/api-11-579/,,TeleportPlayerPositionAndForward,2,TeleportPlayerPositionAndForward,TRUE,,,,,,,,,,module/11,,0.5\r
580,获取队友附近位置,,game/3,,docs/api-29-580/,,GetTeammateNearPosVec3,3,GetTeammateNearPosVec3,,,,,,,,,,,module/29,,0.5\r
582,实体销毁时,,event/2,1290970,docs/event-1-582/,,OnDestroy,1,OnDestroy,TRUE,,,,,,,,,,event,,0.5\r
583,清除染色,,game/12,,docs/api-32-583/,,DyeingReset,2,DyeingReset,TRUE,,,,,,1,,,,module/32,,0.5\r
584,私有-当界面被打开时,,event/2,,docs/event-22-584/,,OnShow,1,OnShow,TRUE,,,,,,,,,,event,,0.5\r
585,私有-当界面被关闭时,,event/2,,docs/event-22-585/,,OnHide,1,OnHide,TRUE,,,,,,,,,,event,,0.5\r
586,踢出玩家,,game/2,3290950,docs/api-11-586/,,KickOutPlayer,2,KickOutPlayer,TRUE,,,,,,,,,,module/11,,0.5\r
588,buf枚举,2,data/8,,docs/enum/,,InternalBuffType,4,InternalBuffType,,,,,,,,,,,data/10001,,0.5\r
589,获取玩家buff列表,2,game/12,,docs/api-12-589/,,GetInternalBuffs,3,GetInternalBuffs,,,,,,,,,,,module/12,,0.5\r
590,添加玩家buff,2,game/12,,docs/api-12-590/,,AddInternalBuff,2,AddInternalBuff,TRUE,,,,,,,,,,module/12,,0.5\r
591,移除玩家buff,2,game/12,,docs/api-12-591/,,RemoveInternalBuff,2,RemoveInternalBuff,TRUE,,,,,,,,,,module/12,,0.5\r
592,AI使用技能,,entity/7,,docs/api-9-592/,,AICastSkill,2,AICastSkill,TRUE,,,,,,1,,,,action/9,,0.5\r
593,寻路,,entity/2,,docs/api-13-593/,,FindStraightPath,2,FindStraightPath,TRUE,,,,,,,,,,action/13,,0.5\r
594,行为树设置黑板值,,entity/8,,docs/api-36-594/,,SetBlackBoard,2,SetBlackBoard,TRUE,,,,,,,,,,action/36,,0.5\r
595,行为树获取黑板值,,entity/8,,docs/api-36-595/,,GetBlackBoard,2,GetBlackBoard,TRUE,,,,,,,,,,action/36,,0.5\r
596,获取节点参数,,entity/8,,docs/api-36-596/,,GetBTreeNodeParam,2,GetBTreeNodeParam,TRUE,,,,,,,,,,action/36,,0.5\r
597,开启特殊装置,,entity/3,,docs/api-15-597/,,ToggleSpecialItemState,2,ToggleSpecialItemState,TRUE,,,,,2:SpecialItemGoodsIDType,,,,,action/15,,0.5\r
598,特殊道具ID类型,,data/8,,docs/enum/,,SpecialItemGoodsIDType,4,SpecialItemGoodsIDType,,,,SpecialItemGoodsIDType,,,,,,,data/10001,T_49_SD_SEARCHKEY_SPECIALITEMENUM,0.5\r
599,QuitJailBreakMiniGame,2,game/12,,docs/api-10-599/,,QuitJailBreakMiniGame,2,QuitJailBreakMiniGame,TRUE,,,,,1:Player;2:Int,,,,,module/10,,0.5\r
600,GiveJailBreakItem,2,game/12,,docs/api-10-600/,,GiveJailBreakItem,2,GiveJailBreakItem,TRUE,,,,,1:Player;2:Int;3:Int,,,,,module/10,,0.5\r
601,装备栏槽位枚举,,data/8,,docs/enum/,,EquipmentSlot,4,EquipmentSlot,,,,,,,,,,,data/10001,,0.5\r
602,获取背包道具栏中物品,,entity/3,,docs/api-15-602/,,GetPlayerItems,2,GetPlayerItems,TRUE,,,,,,,,,,action/15,,0.5\r
603,【废弃】读取累计数据,2,game/12,,docs/api-31-603/,,ReadDBAccumulatedData,2,ReadDBAccumulatedData,TRUE,,,ReadStatisticalSheetV2,1;2;3,,3,,,,module/31,,0.5\r
604,【废弃】写入累计数据偏移值,2,game/12,,docs/api-31-604/,,WriteDBAccumulatedDataOffset,2,WriteDBAccumulatedDataOffset,TRUE,,,WriteStatisticalSheetV2,1;2;3;4,,3,,,,module/31,,0.5\r
605,为玩家发放武器配件,,entity/3,,docs/api-15-605/,,AddAttachmentsToPlayer,2,AddAttachmentsToPlayer,TRUE,,,,,FE_3:EquipItemID_Attachment,,,,,action/15,,0.5\r
606,击中部位枚举,,data/8,,docs/enum/,,HitBodyPart,4,HitBodyPart,,,,,,,,,,,data/10001,,0.5\r
607,获取背包装备栏中物品,,entity/3,,docs/api-15-607/,,GetPlayerEquipments,2,GetPlayerEquipments,TRUE,,,,,,,,,,action/15,,0.5\r
608,读取CSV全表数据,2,game/12,,docs/api-10-608/,,ReadCSVDataAllOverMode,3,ReadCSVDataAllOverMode,,,,,,,,,,,module/10,,0.5\r
609,读取CSV表某一行数据,2,game/12,,docs/api-10-609/,,ReadCSVDataRowOverMode,3,ReadCSVDataRowOverMode,,,,,,2:Int=1,,,,,module/10,,0.5\r
610,读取CSV表某一列数据,2,game/12,,docs/api-10-610/,,ReadCSVDataColOverMode,3,ReadCSVDataColOverMode,,,,,,2:Int=1,,,,,module/10,,0.5\r
611,读取CSV表某单元数据,2,game/12,,docs/api-10-611/,,ReadCSVDataCellOverMode,3,ReadCSVDataCellOverMode,,,,,,2:Int=1;3:Int=1,,,,,module/10,,0.5\r
612,文本输入事件,,event/1,,docs/event-22-612/,,OnSyncInputText,1,OnSyncInputText,TRUE,,,,,,1,,,,event,,0.5\r
613,施加线性力,,game/4,,docs/api-33-613/,,AddForce,2,AddForce,TRUE,,,,,,1,,,,module/33,,0.5\r
614,施力于某位置,,game/4,,docs/api-33-614/,,AddForceAtPosition,2,AddForceAtPosition,TRUE,,,,,,1,,,,module/33,,0.5\r
615,施加力矩,,game/4,,docs/api-33-615/,,AddTorque,2,AddTorque,TRUE,,,,,,1,,,,module/33,,0.5\r
616,移动刚体,,game/4,,docs/api-33-616/,,MovePosition,2,MovePosition,TRUE,,,,,,1,,,,module/33,,0.5\r
617,旋转刚体,,game/4,,docs/api-33-617/,,MoveRotation,2,MoveRotation,TRUE,,,,,,1,,,,module/33,,0.5\r
10026,FE pick CustomHud ID,2,data/1,,,,CustomHudID,,,,,,CustomHudID,,,,,,,data/10000,T_49_SD_SEARCHKEY_CUSTOMHUD,0.5\r
10027,FE pick CustomHudWidget ID,2,data/1,,,,CustomHudWidgetID,,,,,,CustomHudWidgetID,,,,,,,data/10000,T_49_SD_SEARCHKEY_CUSTOMHUDWIDGET,0.5\r
618,私有-受到伤害前事件,,event/2,,docs/event-16-618/,,OnBeforeAttacked,1,OnBeforeAttacked,TRUE,,,,,,,,,,event,,0.5\r
10028,FE pick Attachment ID,2,data/1,,,,EquipItemID_Attachment,,,,,,EquipItemID_Attachment,,,,,,,data/10000,T_49_SD_SEARCHKEY_ATTACHMENTENUM,0.5\r
10029,FE pick Object3D ID,2,data/1,,,,Object3DResourceID,,,,,,Object3DResourceID,,,,,,,data/10000,T_49_SD_SEARCHKEY_RESOURCEENUM,0.5\r
619,UI控件填充方向枚举,,data/8,,docs/enum/,,FillDir,4,FillDir,,,,,,,,,,,data/10001,,0.5\r
620,UI控件填充类型枚举,,data/8,,docs/enum/,,FillType,4,FillType,,,,,,,,,,,data/10001,,0.5\r
621,Tween动画图元V2,,entity/6,,docs/api-30-621/,,CreateTweenV2,2,CreateTweenV2,TRUE,TRUE,,P2=P1 PropertyT >;P3=P2.PropertyType;P4=P2.PropertyType,8;1;2;3|4;5;6;7;9,FE_2:TweenProperty;FE_6:input_bezier,1,,,,action/30,,0.5\r
622,强制玩家上车,,entity/9,,docs/api-26-622/,,GetInTheVehicle,2,GetInTheVehicle,TRUE,,,,,3:SeatType,,,,,action/26,,0.5\r
623,载具座位枚举,,data/8,,docs/enum/,,SeatType,4,SeatType,,,,,,,,,,,data/10001,,0.5\r
624,相对自身运动动画图元,,entity/6,,docs/api-30-624/,,CreateSelfRelative,2,CreateSelfRelative,TRUE,TRUE,,P2=P1 PropertyT >;P3=P2.PropertyType,7;1;2;3|4;5;6;8,FE_2:TweenProperty;FE_4:input_bezier,1,,,,action/30,,0.5\r
625,字体枚举,,data/8,,docs/enum/,,FontType,4,FontType,,,,,,,,,,,data/10001,,0.5\r
626,脏字过滤,,entity/1,,docs/api-1-626/,,DirtyWordFilter,3,DirtyWordFilter,,,,,,,,,,,action/1,,0.5\r
627,获取玩家车皮,,game/10,,docs/api-17-627/,,GetVehicleSkin,3,GetVehicleSkin,,,,,,,,,,,module/17,,0.5\r
628,设置玩家车皮,,game/10,,docs/api-17-628/,,SetVehicleSkin,2,SetVehicleSkin,TRUE,,,,,2:VehicleSkinType;FE_2:VehicleSkinID,,,,,module/17,,0.5\r
629,去除玩家车皮,,game/10,,docs/api-17-629/,,RemoveVehicleSkin,2,RemoveVehicleSkin,TRUE,,,,,,,,,,module/17,,0.5\r
630,恢复玩家默认车皮,,game/10,,docs/api-17-630/,,ResetVehicleSkin,2,ResetVehicleSkin,TRUE,,,,,,,,,,module/17,,0.5\r
631,请求匹配,2,game/2,,docs/api-11-631/,,RequestMatchMaking,2,RequestMatchMaking,TRUE,,,,,,,,,,module/11,,0.5\r
632,创建音效(new),,entity/6,,docs/api-1-632/,,CreateSoundEntityV2,2,CreateSoundEntityV2,TRUE,,,,,3:AudioType;FE_3:AudioID,,,,,action/1,,0.5\r
633,暂停音效(new),,entity/6,,docs/api-1-633/,,PauseSoundEntityV2,2,PauseSoundEntityV2,TRUE,,,,,,1,,,,action/1,,0.5\r
634,继续播放音效(new),,entity/6,,docs/api-1-634/,,ResumeSoundEntityV2,2,ResumeSoundEntityV2,TRUE,,,,,,1,,,,action/1,,0.5\r
635,设置玩家坠落伤害,,game/2,,docs/api-11-635/,,SetPlayerFallingDamage,2,SetPlayerFallingDamage,TRUE,,,,,,,,,,module/11,,0.5\r
636,查询当天token数量限制,2,game/12,,docs/api-14-636/,,GetPlayerTokenCountToday,2,GetPlayerTokenCountToday,TRUE,,,,,,,,,,module/14,,0.5\r
637,休眠刚体,,game/4,,docs/api-33-637/,,Sleep,2,Sleep,TRUE,,,,,,1,,,,module/33,,0.5\r
638,唤醒刚体,,game/4,,docs/api-33-638/,,Wakeup,2,Wakeup,TRUE,,,,,,1,,,,module/33,,0.5\r
639,刚体是否处于休眠,,game/4,,docs/api-33-639/,,IsSleeping,3,IsSleeping,,,,,,,1,,,,module/33,,0.5\r
640,设置刚体休眠阈值,,game/4,,docs/api-33-640/,,SetSleepThreshold,2,SetSleepThreshold,TRUE,,,,,,1,,,,module/33,,0.5\r
641,获取刚体休眠阈值,,game/4,,docs/api-33-641/,,GetSleepThreshold,3,GetSleepThreshold,,,,,,,1,,,,module/33,,0.5\r
642,设置全局刚体休眠阈值,,game/4,,docs/api-33-642/,,SetGlobalSleepThreshold,2,SetGlobalSleepThreshold,TRUE,,,,,,1,,,,module/33,,0.5\r
643,获取全局刚体休眠阈值,,game/4,,docs/api-33-643/,,GetGlobalSleepThreshold,3,GetGlobalSleepThreshold,,,,,,,1,,,,module/33,,0.5\r
644,四元数转欧拉角,,data/7,4790900,docs/api-4-644/,,QuaternionToEulerAngle,3,QuaternionToEulerAngle,TRUE,,,,,,1,,,,data/4,,0.5\r
645,欧拉角转四元数,,data/7,4790890,docs/api-4-645/,,EulerAngleToQuaternion,3,EulerAngleToQuaternion,TRUE,,,,,,1,,,,data/4,,0.5\r
646,轴角转四元数,,data/7,4790880,docs/api-4-646/,,AxisAngleToQuaternion,3,AxisAngleToQuaternion,TRUE,,,,,,1,,,,data/4,,0.5\r
647,四元数转轴角,,data/7,4790870,docs/api-4-647/,,QuaternionToAxisAngle,2,QuaternionToAxisAngle,TRUE,,,,,,1,,,,data/4,,0.5\r
648,添加Bot,,entity/1,,docs/api-1-648/,,AddBot,2,AddBot,TRUE,,,,,,,,,,action/1,,0.5\r
649,删除Bot,,entity/1,,docs/api-1-649/,,DeleteBot,2,DeleteBot,TRUE,,,,,,,,,,action/1,,0.5\r
650,幂运算,,data/2,4270950,docs/api-4-650/,,Exponentiation,3,Exponentiation,,,,,,,,,,,data/4,,0.5\r
651,对数,,data/2,4270940,docs/api-4-651/,,Log,3,Log,,,,,,,,,,,data/4,,0.5\r
652,方向向量转欧拉角,,data/7,4790910,docs/api-4-652/,,Vector3ToEulerAngles,3,Vector3ToEulerAngles,,,,,,,,,,,data/4,,0.5\r
653,获取字典所有key,,data/4,,docs/api-3-653/,,MapGetAllKeys,3,MapGetAllKeys,,,,,,,1,,,,data/3,T_49_SD_SEARCHKEY_MAPALLKEYS,0.5\r
654,切割字符串,,data/6,4680990,docs/api-5-654/,,SplitString,3,SplitString,,,,,,,,,,,data/5,,0.5\r
655,访问字符串中的值,,data/6,4690940,docs/api-5-655/,,StringFindAt,3,StringFindAt,,,,,,,,,,,data/5,,0.5\r
656,字符串转换大写,,data/6,4670990,docs/api-5-656/,,StringUpper,3,StringUpper,,,,,,,,,,,data/5,,0.5\r
657,字符串转换小写,,data/6,4670980,docs/api-5-657/,,StringLower,3,StringLower,,,,,,,,,,,data/5,,0.5\r
658,移除两侧空白字符,,data/6,4670970,docs/api-5-658/,,StringStrip,3,StringStrip,,,,,,,,,,,data/5,,0.5\r
659,链接字符串,,data/6,4680980,docs/api-5-659/,,StringJoin,3,StringJoin,,,,,,,,,,,data/5,,0.5\r
660,相对自身运动动画图元,,entity/6,,docs/api-30-660/,,CreateSelfRelativeFrame,2,CreateSelfRelativeFrame,TRUE,,,P2=P1 PropertyT >;P3=P2.PropertyType,5;1;2|3;4;6,FE_2:TweenProperty,1,,,,action/30,,0.5\r
661,【废弃】按战场码读取数据库值,2,game/12,,docs/api-31-661/,,ReadDBSheetValueByWorkshopCode,2,ReadDBSheetValue,TRUE,,,,,,3,,,,module/31,,0.5\r
662,【废弃】按战场码写入数据库值,2,game/12,,docs/api-31-662/,,WriteDBSheetValueByWorkshopCode,2,WriteDBSheetValue,TRUE,,,,,,3,,,,module/31,,0.5\r
663,【废弃】按战场码删除数据库记录,2,game/12,,docs/api-31-663/,,DeleteDBSheetValueByWorkshopCode,2,DeleteDBSheetValue,TRUE,,,,,,3,,,,module/31,,0.5\r
664,【废弃】按战场码读取数据库排行榜值,2,game/12,,docs/api-31-664/,,ReadDBLeaderboardValueByWorkshopCode,2,ReadDBLeaderboardValue,TRUE,,,,,,3,,,,module/31,,0.5\r
665,【废弃】按战场码写入数据库排行榜值,2,game/12,,docs/api-31-665/,,WriteDBLeaderboardValueByWorkshopCode,2,WriteDBLeaderboardValue,TRUE,,,,,,3,,,,module/31,,0.5\r
666,【废弃】按战场码和Key删除数据库排行榜值,2,game/12,,docs/api-31-666/,,DeleteDBLeaderboardValueByKeyAndWorkshopCode,2,DeleteDBLeaderboardValueByKey,TRUE,,,,,,3,,,,module/31,,0.5\r
667,【废弃】按战场码和名次删除数据库排行榜值,2,game/12,,docs/api-31-667/,,DeleteDBLeaderboardValueByOrderAndWorkshopCode,2,DeleteDBLeaderboardValueByOrder,TRUE,,,,,,3,,,,module/31,,0.5\r
668,【废弃】按战场码和名次范围读取数据库排行榜值,2,game/12,,docs/api-31-668/,,ReadDBLeaderboardValuesByRangeAndWorkshopCode,2,ReadDBLeaderboardValuesByRange,TRUE,,,,,,3,,,,module/31,,0.5\r
669,【废弃】按战场码读取累计数据,2,game/12,,docs/api-31-669/,,ReadDBAccumulatedDataByWorkshopCode,2,ReadDBAccumulatedData,TRUE,,,,,,3,,,,module/31,,0.5\r
670,【废弃】按战场码写入累计数据偏移值,2,game/12,,docs/api-31-670/,,WriteDBAccumulatedDataOffsetByWorkshopCode,2,WriteDBAccumulatedDataOffset,TRUE,,,WriteStatisticalSheetCrossMap,,,3,,,,module/31,,0.5\r
671,四元数相乘,,data/2,4250990,docs/api-4-671/,,MultiplyQuaternion,3,MultiplyQuaternion,TRUE,,,,,,1,,,,data/4,,0.5\r
672,获取目标方向的旋转,,data/2,4250980,docs/api-4-672/,,LookRotation,3,LookRotation,TRUE,,,,,,1,,,,data/4,,0.5\r
673,四元数球形插值,,data/2,4250970,docs/api-4-673/,,SlerpQuaternion,3,SlerpQuaternion,TRUE,,,,,,1,,,,data/4,,0.5\r
674,设置完成大活动任务,,game/12,,docs/api-14-674/,,CustomMissionComplete,2,CustomMissionComplete,TRUE,,,,,,1,,,,module/14,,0.5\r
675,强制玩家下车,,game/2,,docs/api-11-675/,,GetOutTheVehicle,2,GetOutTheVehicle,TRUE,,,,,,,,,,module/11,,0.5\r
676,【废弃】自定义比赛埋点日志,2,game/12,,docs/api-23-676/,,CustomMatchEventLog,2,CustomMatchEventLog,TRUE,,,,,,3,,,,module/23,,0.5\r
677,【废弃】自定义用户埋点日志,2,game/12,,docs/api-23-677/,,CustomUserEventLog,2,CustomUserEventLog,TRUE,,,,,,3,,,,module/23,,0.5\r
678,获取场景地图ID,2,entity/2,,docs/api-13-678/,,GetMapID,3,GetMapID,,,,,,FE_1:SceneID,,,,,action/13,,0.5\r
679,当手持时,,event/2,,docs/event-15-679/,,OnPlayerHandHeld,1,OnPlayerHandHeld,TRUE,,,,,,,,,,event,,0.5\r
680,当装备进装备栏时,,event/2,,docs/event-15-680/,,OnPlayerEquip,1,OnPlayerEquip,TRUE,,,,,,,,,,event,,0.5\r
681,格式化字符串,,data/6,4670960,docs/api-5-681/,,FormatString,3,FormatString,,,,,,,,,,,data/5,,0.5\r
682,丢弃道具,,entity/3,,docs/api-15-682/,,DropItemEntity,2,DropItemEntity,TRUE,,,,,,,,,,action/15,,0.5\r
10030,FE 车辆皮肤枚举,2,data/8,,docs/enum/,,VehicleSkinID,4,VehicleSkinID,,,,VehicleSkinID,,,1,,,,data/10001,T_49_SD_SEARCHKEY_VEHICLEENUM,0.5\r
683,Toggle控件状态改变时,2,event/1,,docs/event-22-683/,,OnToggleChange,1,OnToggleChange,TRUE,,,,,,,,,,event,,0.5\r
684,创建空投箱,,entity/9,,docs/api-41-684/,,CreateAirDropEntity,2,CreateAirDropEntity,TRUE,,,,,,,,,,action/26,,0.5\r
10031,FE 三维向量运算,2,data/2,,,,Vector3Operation,3,,,,,Vector3Operation,,,,,,,data/4,T_49_SD_SEARCHKEY_V3VOPERATION,0.5\r
10035,FE 获取三维向量分量,2,data/5,,,,Vector3Getter,3,,,,,Vector3Getter,,,,,,,data/4,T_49_SD_SEARCHKEY_V3VGET,0.5\r
10036,FE 设置三维向量分量,2,data/5,,,,Vector3Setter,2,,,,,Vector3Setter,,,,2,,,data/4,T_49_SD_SEARCHKEY_V3VSET,0.5\r
685,移动毒圈,,game/1,3190950,docs/api-20-685/,,MoveSafeZone,2,MoveSafeZone,TRUE,,,,1;2|3;4;5;6,,,,,,module/39,,0.5\r
686,,1,data/5,4580990,docs/api-4-686/,,Vector2GetX,3,Vector2GetX,,,,,,,,,Vector2.X,,data/4,,0.5\r
687,,1,data/5,4580980,docs/api-4-687/,,Vector2GetY,3,Vector2GetY,,,,,,,,,Vector2.Y,,data/4,,0.5\r
688,,1,data/5,4580970,docs/api-4-688/,,Vector2SetX,2,Vector2SetX,TRUE,,,,,,,2,Vector2.X = value,,data/4,,0.5\r
689,,1,data/5,4580960,docs/api-4-689/,,Vector2SetY,2,Vector2SetY,TRUE,,,,,,,2,Vector2.Y = value,,data/4,,0.5\r
690,,1,data/2,4275990,docs/api-4-690/,,Vector2Add,3,Vector2Add,,,,,,,,,"Vector2{x,y} + Vector2{a,b}",,data/4,,0.5\r
691,,1,data/2,4275980,docs/api-4-691/,,Vector2Sub,3,Vector2Sub,,,,,,,,,"Vector2{x,y} - Vector2{a,b}",,data/4,,0.5\r
692,,1,data/2,4275970,docs/api-4-692/,,Vector2Scale,3,Vector2Scale,,,,,,,,,"Vector2{x,y} * value",,data/4,,0.5\r
693,,1,data/2,4275960,docs/api-4-693/,,Vector2Dot,3,Vector2Dot,,,,,,,,,,,data/4,,0.5\r
694,,1,data/2,4275950,docs/api-4-694/,,Vector2Distance,3,Vector2Distance,,,,,,,,,,,data/4,,0.5\r
695,,1,data/2,4275940,docs/api-4-695/,,Vector2Angle,3,Vector2Angle,,,,,,,,,,,data/4,,0.5\r
696,,,data/2,4275930,docs/api-4-696/,,Vector2Normalize,3,Vector2Normalize,,,,,,,,,,,data/4,,0.5\r
697,,,data/2,4275920,docs/api-4-697/,,Vector2Magnitude,3,Vector2Magnitude,,,,,,,,,,,data/4,,0.5\r
698,,,data/2,4275910,docs/api-4-698/,,Vector2Reflect,3,Vector2Reflect,,,,,,,,,,,data/4,,0.5\r
699,,,data/2,4275900,docs/api-4-699/,,Vector3Reflect,3,Vector3Reflect,,,,,,,,,,,data/4,,0.5\r
700,,,data/7,4790940,docs/api-6-700/,,Vector3ToVector2,3,Vector3ToVector2,,,,,,,,,,,data/6,,0.5\r
701,,,data/7,4790930,docs/api-6-701/,,Vector2ToVector3,3,Vector2ToVector3,,,,,,,,,,,data/6,,0.5\r
702,,,data/5,4580991,docs/api-4-702/,,NewVector2,3,NewVector2,,,,,,,,,"Vector2{x,y}",,data/4,,0.5\r
703,创建伤害跳字,,entity/4,,docs/api-1-703/,,CreateUGCDamageNum,2,CreateUGCDamageNum,TRUE,,,,,,,,,,action/1,,0.5\r
704,自定义比赛埋点日志,2,game/12,,docs/api-23-704/,,AddGameEventLogMap,2,AddGameEventLogMap,TRUE,,,,,,,,,,module/23,,0.5\r
705,自定义用户埋点日志,2,game/12,,docs/api-23-705/,,AddUserEventLogMap,2,AddUserEventLogMap,TRUE,,,,,,,,,,module/23,,0.5\r
10037,FE 二维向量运算,2,data/2,,,,Vector2Operation,3,,,,,Vector2Operation,,,,,,,data/4,T_49_SD_SEARCHKEY_V2VOPERATION,0.5\r
10038,FE 获取二维向量分量,2,data/5,,,,Vector2Getter,3,,,,,Vector2Getter,,,,,,,data/4,T_49_SD_SEARCHKEY_V2VGET,0.5\r
10039,FE 设置二维向量分量,2,data/5,,,,Vector2Setter,2,,,,,Vector2Setter,,,,2,,,data/4,T_49_SD_SEARCHKEY_V2VSET,0.5\r
706,请求购买类型,,data/8,,docs/enum/,,RequestPurchaseType,4,RequestPurchaseType,,,,,,,1,,,,data/10001,,0.5\r
707,开始移动时,,event/2,,docs/event-11-707/,,OnPlayerMove,1,OnPlayerMove,TRUE,,,,,,,,,,event,,0.5\r
708,进入待机时,,event/2,,docs/event-11-708/,,OnPlayerIdle,1,OnPlayerIdle,TRUE,,,,,,,,,,event,,0.5\r
709,玩家姿态枚举,,data/8,,docs/enum/,,PlayerPhysXPoseType,4,PlayerPhysXPoseType,,,,,,,,,,,data/10001,,0.5\r
710,当使用技能时,2,event/2,,docs/event-11-710/,,OnPlayerUseSkill,1,OnPlayerUseSkill,TRUE,,,,,,1,,,,event,,0.5\r
711,查询自定义任务进度,2,game/12,,docs/api-14-711/,,GetCustomMissionProgress,3,GetCustomMissionProgress,,,,,,,1,,,,module/14,,0.5\r
10040,FE 选择PlayerDataID,2,data/1,,,,PlayerDataID,3,,,,,PlayerDataID,,,,,,,data/10000,T_49_SD_SEARCHKEY_PLAYERDATAID,0.5\r
10041,FE 选择AnimationClipID,2,data/1,,,,AnimationClipID,3,,,,,AnimationClipID,,,,,,,data/10000,T_49_SD_SEARCHKEY_ANICLIPID,0.5\r
10042,FE 选择CSV文件,2,data/1,,,,SelectCSV,3,,,,,SelectCSV,,,,,,,data/10000,T_49_SD_SEARCHKEY_GETCSV,0.5\r
712,购买商品前,,event/2,,docs/event-25-712/,,OnBeforeShopPurchase,1,OnBeforeShopPurchase,TRUE,,,,,,,,,,event,,0.5\r
713,当角色控制器触碰实体时,,event/2,,docs/event-33-713/,,OnControllerColliderHit,1,OnControllerColliderHit,TRUE,,,,,,1,,,,event,,0.5\r
714,打印警告信息,1,entity/1,,docs/api-1-714/,,PrintWarning,2,PrintWarning,TRUE,,,,,,,,,,action/1,,0.5\r
715,打印错误信息,1,entity/1,,docs/api-1-715/,,PrintError,2,PrintError,TRUE,,,,,,,,,,action/1,,0.5\r
716,Curve采样,,entity/6,,docs/api-30-716/,,CurveEvaluate,3,CurveEvaluate,TRUE,,,,,FE_1:input_bezier,,,,,action/30,,0.5\r
717,TouchPad控件按下时,2,event/1,,docs/event-22-717/,,OnTouchDown,1,OnTouchDown,TRUE,,,,,,,,,,event,,0.5\r
718,TouchPad控件抬起时,2,event/1,,docs/event-22-718/,,OnTouchUp,1,OnTouchUp,TRUE,,,,,,,,,,event,,0.5\r
719,TouchPad控件开始滑动时,2,event/1,,docs/event-22-719/,,OnDragStart,1,OnDragStart,TRUE,,,,,,,,,,event,,0.5\r
720,TouchPad控件滑动时,2,event/1,,docs/event-22-720/,,OnDrag,1,OnDrag,TRUE,,,,,,,,,,event,,0.5\r
721,TouchPad控件滑动结束时,2,event/1,,docs/event-22-721/,,OnDragEnd,1,OnDragEnd,TRUE,,,,,,,,,,event,,0.5\r
723,Joystick控件按下时,2,event/1,,docs/event-22-723/,,OnPressed,1,OnPressed,TRUE,,,,,,,,,,event,,0.5\r
724,Joystick控件释放时,2,event/1,,docs/event-22-724/,,OnReleased,1,OnReleased,TRUE,,,,,,,,,,event,,0.5\r
725,Joystick控件移动时,2,event/1,,docs/event-22-725/,,OnMove,1,OnMove,TRUE,,,,,,,,,,event,,0.5\r
726,背包皮肤ID,2,game/10,,docs/api--726/,,BagSkinID,3,BagSkinID,,,,BagSkinID,,,,,,,data/10000,T_49_SD_SEARCHKEY_BAGSKINID,0.5\r
727,设置玩家背包皮肤ID,,game/10,,docs/api-17-727/,,SetBagSkinID,2,SetBagSkinID,TRUE,,,,,2:BagSkinType;FE_2:BagSkinID,,,,,module/17,,0.5\r
728,获取玩家背包皮肤ID,,game/10,,docs/api-17-728/,,GetBagSkinID,3,GetBagSkinID,,,,,,,,,,,module/17,,0.5\r
729,重置玩家背包皮肤ID,,game/10,,docs/api-17-729/,,ResetBagSkinID,2,ResetBagSkinID,TRUE,,,,,,,,,,module/17,,0.5\r
730,移除玩家背包皮肤ID,,game/10,,docs/api-17-730/,,RemoveBagSkinID,2,RemoveBagSkinID,TRUE,,,,,,,,,,module/17,,0.5\r
731,通过Curve获取运算值,,entity/6,,docs/api-30-731/,,GetResultFromCurve,3,GetResultFromCurve,,,,P2=P1.EnumToType;P3=P1.EnumToType;R=P1.EnumToType,,FE_4:input_bezier,,,,,action/30,,0.5\r
10043,FE 区分日志类型的打印,2,entity/1,,,,PrintInfo,2,,,,,PrintInfo,,,,,,,action/1,T_49_SD_SEARCHKEY_LOGINFO,0.5\r
10044,FE 设置客户端父子关系,,entity/1,,docs/api-1-10044/,,SetParentClient,2,SetParentClient,TRUE,,,,,,,,,,action/1,,0.5\r
10045,FE 获取挂载点,2,entity/10,,docs/api-37-10045/,,GetMountPoint,3,GetMountPoint,TRUE,,,,,,,,,,action/37,,0.5\r
732,站起时,,event/2,,docs/event-11-732/,,OnPlayerStand,1,OnPlayerStand,TRUE,,,,,,,,,,event,,0.5\r
733,Hud设置父子关系,,entity/4,2490920,docs/api-22-733/,,SetHudWidgetParent,2,SetHudWidgetParent,TRUE,,,,,,,,,,action/22,,0.5\r
734,根据相机和触点得到射线,,game/5,,docs/api-8-734/,,CameraTouchRay,2,CameraTouchRay,TRUE,,,,,,,,,,module/8,,0.5\r
735,播放icon动画效果,,entity/4,,docs/api-1-735/,,NotifyIconAnimation,2,NotifyIconAnimation,TRUE,,,,1;2;3;4|5;6;7;8,,,,,,action/1,,0.5\r
736,【废弃】移动角色控制器,,game/4,,docs/api-33-736/,,CCTMove,2,CCTMove,TRUE,,,,,,,,,,module/33,,0.5\r
737,上传自定义结算信息,,entity/10,,docs/api-1-737/,,UploadMatchResult,2,UploadMatchResult,TRUE,,,,,,,,,,action/19,,0.5\r
738,世界坐标转换成屏幕坐标,,game/5,,docs/api-8-738/,,WorldToScreenPoint,2,WorldToScreenPoint,TRUE,,,,,,,,,,module/8,,0.5\r
739,屏幕坐标转换成世界坐标,,game/5,,docs/api-8-739/,,ScreenToWorldPoint,2,ScreenToWorldPoint,TRUE,,,,,,,,,,module/8,,0.5\r
740,屏幕触控单反回射线检测,,game/5,,docs/api-8-740/,,CameraSingleRaycast,2,CameraSingleRaycast,TRUE,,,,,,,,,,module/8,,0.5\r
741,屏幕触控多反回射线检测,,game/5,,docs/api-8-741/,,CameraMultiRaycast,2,CameraMultiRaycast,TRUE,,,,,,,,,,module/8,,0.5\r
742,创建音效,,entity/6,,docs/api-30-742/,,CreateSoundEntityV3,2,CreateSoundEntityV3,TRUE,,,,1;2;3|4;5,,,,,,action/30,,0.5\r
743,创建特效,,entity/6,,docs/api-30-743/,,CreateEffectEntityV2,2,CreateEffectEntityV2,TRUE,,,,1;2;3|4;5,,,,,,action/30,,0.5\r
10046,FE 选择场景,2,data/1,,docs/api--10046/,,SceneID,3,SceneID,TRUE,,,SceneID,,,,,,,data/10000,T_49_SD_SEARCHKEY_SCENEENUM,0.5\r
744,反正切函数(坐标),,data/2,4260900,docs/api-4-744/,,Atan2,3,Atan2,,,,,,,,,,,data/4,,0.5\r
745,读取CSV表某一行数据通过列数和内容,2,data/9,,docs/api-43-745/,,ReadCSVDataRowByKey,3,ReadCSVDataRowByKey,,,,,,FE_1:SelectCSV;2:Int=1,,,,,data/43,,0.5\r
746,获得实体所属阵营,,game/3,,docs/api-29-746/,,GetFaction,3,GetFaction,,,,,,,,,,,module/29,,0.5\r
747,实体A是否可以攻击实体B,,game/3,,docs/api-29-747/,,IsActualAttackAble,3,IsActualAttackAble,,,,,,,,,,,module/29,,0.5\r
748,设置可攻击实体,,game/3,,docs/api-29-748/,,SetActualAttackAbleEntity,2,SetActualAttackAbleEntity,TRUE,,,,,3:AttackableOption,,,,,module/29,,0.5\r
749,获得可攻击实体列表,,game/3,,docs/api-29-749/,,GetActualAttackAbleEntity,3,GetActualAttackAbleEntity,,,,,,,,,,,module/29,,0.5\r
10047,访问资产注册属性,2,data/1,,,,FEAssetsRegister,,,,,,PickRegisteredAsset,,,,,,,data/10000,T_49_SD_SEARCHKEY_GETREGISTERED,0.5\r
10048,技能枚举,2,data/8,,,,PlayerSkillID,4,,,,,PlayerSkillID,,,,,,,data/10001,T_49_SD_SEARCHKEY_PLAYERSKILLENUM,0.5\r
750,通过列名读取CSV表某一列数,2,data/9,,docs/api-43-750/,,ReadCSVDataColIntByName,3,ReadCSVDataColIntByName,,,,,,FE_1:SelectCSV,,,,,data/43,,0.5\r
751,实体是否存在组件,,entity/1,,docs/api-1-751/,,HasComponent,3,HasComponent,,,,,,FE_2:ComponentID,,,,,action/1,,0.5\r
752,向实体添加组件,2,entity/1,,docs/api-1-752/,,AddComponent,2,AddComponent,TRUE,,,,,FE_2:ComponentID,,,,,action/1,,0.5\r
753,从实体删除组件,2,entity/1,,docs/api-1-753/,,RemoveComponent,2,RemoveComponent,TRUE,,,,,FE_2:ComponentID,,,,,action/1,,0.5\r
754,重置运动实体,,entity/6,2690990,docs/api-30-754/,,ResetPlayable,2,ResetPlayable,TRUE,,,,,,,,,,action/30,,0.5\r
755,应用中退界面配置,2,entity/4,,docs/api-1-755/,,ApplyQuitMidwayHudConfig,2,ApplyQuitMidwayHudConfig,TRUE,,,,,,,,,,action/1,,0.5\r
756,创建客户端自定义HUD,1,entity/4,2490910,docs/api-22-756/,,CreateCustomHudClient,2,CreateCustomHudClient,TRUE,TRUE,,,,2:Enum_CustomHud;FE_2:CustomHudID,,,,,action/22,,0.5\r
757,创建客户端特效,,entity/6,,docs/api-30-757/,,CreateEffectEntityClient,2,CreateEffectEntityClient,TRUE,,,,,,,,,,action/30,,0.5\r
758,创建客户端内置HUD,,entity/4,2490900,docs/api-22-758/,,CreateInternalHudClient,2,CreateInternalHudClient,TRUE,,P2=P1.EnumToType,P1=P2.InternalHudType,,FE_2:InternalHudType,1,,,,action/22,,0.5\r
759,创建客户端音效,,entity/6,,docs/api-30-759/,,CreateSoundEntityClient,2,CreateSoundEntityClient,TRUE,,,,,,,,,,action/30,,0.5\r
760,当前玩家,2,entity/1,,docs/api-1-760/,,LocalPlayer,3,LocalPlayer,,,,,,,,,,,action/1,,0.5\r
10049,组件ID,2,data/1,,,,ComponentID,2,,TRUE,,,ComponentID,,,,,,,data/10000,T_49_SD_SEARCHKEY_COMPONENTENUM,0.5\r
10050,类型ID,2,data/1,,,,TypeID,2,,TRUE,,,Type,,,,,,,data/10000,T_49_SD_SEARCHKEY_TYPEENUM,0.5\r
761,击倒状态枚举,,data/8,,docs/enum/,,KnockDownStateType,4,KnockDownStateType,,,,,,,,,,,data/10001,,0.5\r
762,当使用水上滑板时,,event/2,,docs/event-11-762/,,OnPlayerSwimSurfing,1,OnPlayerSwimSurfing,TRUE,,,,,,,,,,event,,0.5\r
763,当结束使用水上滑板时,,event/2,,docs/event-11-763/,,OnPlayerStopSwimSurfing,1,OnPlayerStopSwimSurfing,TRUE,,,,,,,,,,event,,0.5\r
764,当结束冲刺时,,event/2,,docs/event-11-764/,,OnPlayerStopDash,1,OnPlayerStopDash,TRUE,,,,,,,,,,event,,0.5\r
765,AI攻击模式枚举,,data/8,,docs/enum/,,ActionType,4,ActionType,,,,,,,,,,,data/10001,,0.5\r
766,创建僵尸,,entity/7,,docs/api-9-766/,,CreateZombie,2,CreateZombie,TRUE,,,,1;2;3;4|5;6;7,,,,,,action/9,,0.5\r
767,开火类型,,data/8,,docs/enum/,,FireType,4,FireType,,,,,,,,,,,data/10001,,0.5\r
768,造成伤害前,,event/2,,docs/event-16-768/,,OnBeforeHurt,1,OnBeforeHurt,TRUE,,,,,,,,,,event,,0.5\r
769,获取本地的瞄准方向,,game/2,,docs/api-11-769/,,GetLocalAimDirection,3,GetLocalAimDirection,,,,,,,,,,,module/11,,0.5\r
770,获取本地时间戳,,game/1,3190930,docs/api-44-770/,,GetLocalTimestamp,3,GetLocalTimestamp,,,,,,,,,,,module/39,,0.5\r
771,,1,data/5,4590961,docs/api-4-771/,,VectorSetXClient,3,VectorSetXClient,,,,,,,,1,Vector3.X = value,,data/4,,0.5\r
772,,1,data/5,4590951,docs/api-4-772/,,VectorSetYClient,3,VectorSetYClient,,,,,,,,1,Vector3.Y = value,,data/4,,0.5\r
773,,1,data/5,4590941,docs/api-4-773/,,VectorSetZClient,3,VectorSetZClient,,,,,,,,1,Vector3.Z = value,,data/4,,0.5\r
774,,1,data/5,4580971,docs/api-4-774/,,Vector2SetXClient,3,Vector2SetXClient,,,,,,,,1,Vector2.X = value,,data/4,,0.5\r
775,,1,data/5,4580961,docs/api-4-775/,,Vector2SetYClient,3,Vector2SetYClient,,,,,,,,1,Vector2.Y = value,,data/4,,0.5\r
776,固定帧更新时,,event/1,,docs/event-44-776/,,OnFixedUpdate,1,OnFixedUpdate,TRUE,,,,,,,,,,event,,0.5\r
777,游戏暂停时,,event/1,,docs/event-44-777/,,OnGamePause,1,OnGamePause,TRUE,,,,,,,,,,event,,0.5\r
778,游戏恢复时,,event/1,,docs/event-44-778/,,OnGameResume,1,OnGameResume,TRUE,,,,,,,,,,event,,0.5\r
779,暂停游戏,,game/1,3190990,docs/api-44-779/,,PauseGame,2,PauseGame,TRUE,,,,,,,,,,module/39,,0.5\r
780,判断好友关系,2,game/12,,docs/api-22-780/,,IsFriend,3,IsFriend,,,,,,,,1,,,module/14,,0.5\r
781,当好友关系更新时,2,event/3,,docs/event-22-781/,,OnFriendRelationChange,1,OnFriendRelationChange,,,,,,,,1,,,event,,0.5\r
782,Layout控件排序方式枚举,,data/8,,docs/enum/,,LayoutSortType,4,LayoutSortType,,,,,,,,,,,data/10001,,0.5\r
783,恢复游戏,,game/1,3190980,docs/api-44-783/,,ResumeGame,2,ResumeGame,TRUE,,,,,,,,,,module/39,,0.5\r
784,强制移动角色控制器,2,game/4,,docs/api-33-784/,,CCTTeleport,2,CCTTeleport,TRUE,,,,,,,,,,module/33,,0.5\r
785,开启跳伞,,entity/9,,docs/api-11-785/,,StartParachute,2,StartParachute,TRUE,,,,,,,,,,action/26,,0.5\r
786,通过ID获取子节点,,entity/1,,docs/api-1-786/,,GetChildByName,3,GetChildByName,,,,,,,,,,,action/1,,0.5\r
10056,FE 设置二维向量分量,2,data/5,,,,Vector2xySetter,3,,,,,Vector2xySetter,,,,1,,,data/4,T_49_SD_SEARCHKEY_V2VCREATE,0.5\r
10057,FE 设置三维向量分量,2,data/5,,,,Vector3xyzSetter,3,,,,,Vector3xyzSetter,,,,1,,,data/4,T_49_SD_SEARCHKEY_V3VCREATE,0.5\r
787,OnPlayableEachLoop,,event/2,,docs/event-30-787/,,OnPlayableEachLoop,1,OnPlayableEachLoop,TRUE,,,,,,,,,,event,,0.5\r
788,打印断言功能,2,entity/1,,docs/api-1-788/,,Assert,2,Assert,TRUE,,,,,,,,,,action/1,,0.5\r
789,当实体可用时,,event/2,1290960,docs/event-1-789/,,OnEnable,1,OnEnable,TRUE,,,,,,,,,,event,,0.5\r
790,当实体不可用时,,event/2,1290650,docs/event-1-790/,,OnDisable,1,OnDisable,TRUE,,,,,,,,,,event,,0.5\r
791,读取数据库值,2,game/12,,docs/api-31-791/,,ReadDBSheetValue_V2,2,ReadDBSheetValue_V2,TRUE,,,P4=P1.SheetType,1;2;3;4;6,FE_1:DataSheet,,,,,module/31,,0.5\r
792,写入数据库值,2,game/12,,docs/api-31-792/,,WriteDBSheetValue_V2,2,WriteDBSheetValue_V2,TRUE,,,P4=P1.SheetType,1;2;3;4;6,FE_1:DataSheet,,,,,module/31,,0.5\r
794,读取数据库排行榜值,2,game/12,,docs/api-31-794/,,ReadDBLeaderboardValue_V2,2,ReadDBLeaderboardValue_V2,TRUE,,,,1;2;3;5,FE_1:RankSheet,,,,,module/31,,0.5\r
795,写入数据库排行榜值,2,game/12,,docs/api-31-795/,,WriteDBLeaderboardValue_V2,2,WriteDBLeaderboardValue_V2,TRUE,,,,1;2;3;5,FE_1:RankSheet,,,,,module/31,,0.5\r
798,根据名次范围读取数据库排行榜值,2,game/12,,docs/api-31-798/,,ReadDBLeaderboardValuesByRange_V2,2,ReadDBLeaderboardValuesByRange_V2,TRUE,,,,1;2;3;4;6,FE_1:RankSheet,,,,,module/31,,0.5\r
799,读取累计数据,2,game/12,,docs/api-31-799/,,ReadDBAccumulatedData_V2,2,ReadDBAccumulatedData_V2,TRUE,,,ReadStatisticalSheet_ERR,,,,,,,module/31,T_49_SD_SEARCHKEY_READSTATIS,0.5\r
800,写入累计数据偏移值,2,game/12,,docs/api-31-800/,,WriteDBAccumulatedDataOffset_V2,2,WriteDBAccumulatedDataOffset_V2,TRUE,,,WriteStatisticalSheet_ERR,,,,,,,module/31,T_49_SD_SEARCHKEY_WRITESTATIS,0.5\r
801,按战场码读取数据库值,2,game/12,,docs/api-31-801/,,ReadDBSheetValueByWorkshopCode_V2,2,ReadDBSheetValue_V2,TRUE,,,,1;2;3;4|5;6,,,,,,module/31,,0.5\r
802,按战场码写入数据库值,2,game/12,,docs/api-31-802/,,WriteDBSheetValueByWorkshopCode_V2,2,WriteDBSheetValue_V2,TRUE,,,,1;2;3;4|5;6,,,,,,module/31,,0.5\r
804,按战场码读取数据库排行榜值,2,game/12,,docs/api-31-804/,,ReadDBLeaderboardValueByWorkshopCode_V2,2,ReadDBLeaderboardValue_V2,TRUE,,,,,,,,,,module/31,,0.5\r
805,按战场码写入数据库排行榜值,2,game/12,,docs/api-31-805/,,WriteDBLeaderboardValueByWorkshopCode_V2,2,WriteDBLeaderboardValue_V2,TRUE,,,,,,,,,,module/31,,0.5\r
808,按战场码和名次范围读取数据库排行榜值,2,game/12,,docs/api-31-808/,,ReadDBLeaderboardValuesByRangeAndWorkshopCode_V2,2,ReadDBLeaderboardValuesByRange_V2,TRUE,,,,1;2;3;4|5;6,,,,,,module/31,,0.5\r
809,按战场码读取累计数据,2,game/12,,docs/api-31-809/,,ReadDBAccumulatedDataByWorkshopCode_V2,2,ReadDBAccumulatedData_V2,TRUE,,,,,,,,,,module/31,,0.5\r
810,按战场码写入累计数据偏移值,2,game/12,,docs/api-31-810/,,WriteDBAccumulatedDataOffsetByWorkshopCode_V2,2,WriteDBAccumulatedDataOffset_V2,TRUE,,,WriteStatisticalSheetCross_ERR,,,,,,,module/31,T_49_SD_SEARCHKEY_WRITESTATISCROSS,0.5\r
811,错误码枚举,,data/8,,docs/enum/,,ErrorCode,4,ErrorCode,,,,,,,,,,,data/10001,,0.5\r
821,检查特别关注,2,game/2,,docs/api-1-821/,,HasSpecialFollow,3,HasSpecialFollow,,,,,,,3,,,,action/1,,0.5\r
822,添加特别关注,2,game/2,,docs/api-1-822/,,AddSpecialFollow,2,AddSpecialFollow,TRUE,,,,,,3,,,,action/1,,0.5\r
823,移除特别关注,2,game/2,,docs/api-1-823/,,RemoveSpecialFollow,2,RemoveSpecialFollow,TRUE,,,,,,3,,,,action/1,,0.5\r
824,清空特别关注,2,game/2,,docs/api-1-824/,,CleanSpecialFollow,2,CleanSpecialFollow,TRUE,,,,,,3,,,,action/1,,0.5\r
825,欧拉角转方向向量,,data/7,4790920,docs/api-6-825/,,EularAngleToVector3,3,EularAngleToVector3,,,,,,,,,,,data/6,,0.5\r
826,整型转浮点,,data/7,4790950,docs/api-6-826/,,IntToFloat,3,IntToFloat,,,,,,,,,,,data/6,,0.5\r
827,根据四元数旋转向量,,data/2,4275890,docs/api-4-827/,,RotateVector,3,RotateVector,,,,,,,,,,,data/4,,0.5\r
828,跳跃结束时,,event/2,,docs/event-11-828/,,OnPlayerJumpStop,1,OnPlayerJumpStop,TRUE,,,,,,,,,,event,,0.5\r
829,坠落开始时,,event/2,,docs/event-11-829/,,OnPlayerFall,1,OnPlayerFall,TRUE,,,,,,,,,,event,,0.5\r
830,坠落结束时,,event/2,,docs/event-11-830/,,OnPlayerFallStop,1,OnPlayerFallStop,TRUE,,,,,,,,,,event,,0.5\r
831,切换玩家观察者,2,game/2,,docs/api-1-831/,,SwitchUserProxyObserver,2,SwitchUserProxyObserver,TRUE,,,,,,3,,,,action/1,,0.5\r
832,镜头转动角度限制类型,,data/8,,docs/enum/,,CameraViewingAngleRestrictionType,4,CameraViewingAngleRestrictionType,,,,,,,,,,,data/10001,,0.5\r
10058,NumToString,2,data/7,4790980,,,NumToString,3,,,,,num_to_string,,,,,,,data/6,T_49_SD_SEARCHKEY_NUMTOSTRING,0.5\r
812,删除数据库记录,2,game/12,,docs/api-31-812/,,DeleteDBSheetValue_V2,2,DeleteDBSheetValue_V2,TRUE,,,,1;2;3;5,FE_1:DataSheet,,,,,module/31,,0.5\r
813,根据Key删除数据库排行榜值,2,game/12,,docs/api-31-813/,,DeleteDBLeaderboardValueByKey_V2,2,DeleteDBLeaderboardValueByKey_V2,TRUE,,,,1;2;4,FE_1:RankSheet,,,,,module/31,,0.5\r
814,根据名次删除数据库排行榜值,2,game/12,,docs/api-31-814/,,DeleteDBLeaderboardValueByOrder_V2,2,DeleteDBLeaderboardValueByOrder_V2,TRUE,,,,1;2;4,FE_1:RankSheet,,,,,module/31,,0.5\r
815,按战场码删除数据库记录,2,game/12,,docs/api-31-815/,,DeleteDBSheetValueByWorkshopCode_V2,2,DeleteDBSheetValue_V2,TRUE,,,,,,,,,,module/31,,0.5\r
816,按战场码和Key删除数据库排行榜值,2,game/12,,docs/api-31-816/,,DeleteDBLeaderboardValueByKeyAndWorkshopCode_V2,2,DeleteDBLeaderboardValueByKey_V2,TRUE,,,,,,,,,,module/31,,0.5\r
817,按战场码和名次删除数据库排行榜值,2,game/12,,docs/api-31-817/,,DeleteDBLeaderboardValueByOrderAndWorkshopCode_V2,2,DeleteDBLeaderboardValueByOrder_V2,TRUE,,,,,,,,,,module/31,,0.5\r
818,移动角色控制器,2,game/4,,docs/api-33-818/,,CCTMoveV2,2,CCTMoveV2,TRUE,,,,,,,,,,module/33,,0.5\r
820,UserMessageToPersona,2,game/12,,docs/api-46-820/,,UserMessageToPersona,2,UserMessageToPersona,TRUE,,,,,,,,,,module/46,,0.5\r
833,SystemMessageToPersona,2,game/12,,docs/api-46-833/,,SystemMessageToPersona,2,SystemMessageToPersona,TRUE,,,,,,,,,,module/46,,0.5\r
834,ClearMemory,2,game/12,,docs/api-46-834/,,ClearMemory,2,ClearMemory,TRUE,,,,,,,,,,module/46,,0.5\r
835,OnReceiveContentFromPersona,2,event/1,,docs/event-46-835/,,OnReceiveContentFromPersona,1,OnReceiveContentFromPersona,TRUE,,,,,,,,,,event,,0.5\r
836,OnReceiveActionFromPersona,2,event/1,,docs/event-46-836/,,OnReceiveActionFromPersona,1,OnReceiveActionFromPersona,TRUE,,,,,,,,,,event,,0.5\r
851,判断玩家是否是会员（服务端）,,game/12,,docs/api-45-851/,,IsPremium,2,IsPremium,TRUE,,,,,,3,2,,,module/45,,0.5\r
852,唤起会员中心（服务端）,,game/12,,docs/api-45-852/,,OpenPremiumCenter,2,OpenPremiumCenter,TRUE,,,,,,3,2,,,module/45,,0.5\r
853,唤起会员中心（客户端）,,game/12,,docs/api-45-853/,,OpenPremiumCenter_Client,2,OpenPremiumCenter_Client,TRUE,,,,,,3,1,,,module/45,,0.5\r
854,获取会员到期时间戳（服务端）,,game/12,,docs/api-45-854/,,GetPremiumExpireDate,2,GetPremiumExpireDate,TRUE,,,,,,3,2,,,module/45,,0.5\r
855,会员信息改变时,,event/1,,docs/event-45-855/,,OnPremiumChange,1,OnPremiumChange,TRUE,,,,,,3,,,,event,,0.5\r
856,进入会员中心时,,event/1,,docs/event-45-856/,,OnPlayerEnterPremiumCenter,1,OnPlayerEnterPremiumCenter,TRUE,,,,,,3,,,,event,,0.5\r
857,离开会员中心时,,event/1,,docs/event-45-857/,,OnPlayerLeavePremiumCenter,1,OnPlayerLeavePremiumCenter,TRUE,,,,,,3,,,,event,,0.5\r
858,会员状态枚举,,data/8,,docs/enum/,,PremiumState,4,PremiumState,,,,,,,3,,,,data/5,,0.5\r
859,判断玩家是否是会员（客户端）,,game/12,,docs/api-45-859/,,IsPremium_Client,2,IsPremium_Client,TRUE,,,,,,3,1,,,module/45,,0.5\r
860,获取会员到期时间戳（客户端）,,game/12,,docs/api-45-860/,,GetPremiumExpireDate_Client,2,GetPremiumExpireDate_Client,TRUE,,,,,,3,1,,,module/45,,0.5\r
861,枪械皮肤类型枚举,1,data/8,,docs/enum/,,WeaponSkinType,4,WeaponSkinType,,,,,,,,,,,data/10001,,0.5\r
862,载具皮肤类型枚举,1,data/8,,docs/enum/,,VehicleSkinType,4,VehicleSkinType,,,,,,,,,,,data/10001,,0.5\r
863,皮肤类型枚举,1,data/8,,docs/enum/,,ClothType,4,ClothType,,,,,,,,,,,data/10001,,0.5\r
864,背包皮肤类型枚举,1,data/8,,docs/enum/,,BagSkinType,4,BagSkinType,,,,,,,,,,,data/10001,,0.5\r
865,SetPersonaObserver,2,game/12,,docs/api-46-865/,,SetPersonaObserver,2,SetPersonaObserver,TRUE,,,,,,,,,,module/46,,0.5\r
866,UpdateUserNickName,2,game/12,,docs/api--866/,,UpdateUserNickName,2,UpdateUserNickName,TRUE,,,,,,,,,,module/46,,0.5\r
867,UserMessageToPersonaStream,2,game/12,,docs/api-46-867/,,UserMessageToPersonaStream,2,UserMessageToPersonaStream,TRUE,,,,,,,,,,module/46,,0.5\r
868,SystemMessageToPersonaStream,2,game/12,,docs/api-46-868/,,SystemMessageToPersonaStream,2,SystemMessageToPersonaStream,TRUE,,,,,,,,,,module/46,,0.5\r
869,设置玩家可自由退出,,game/2,,docs/api-1-869/,,SetPlayerCanFreeQuit,2,SetPlayerCanFreeQuit,TRUE,,,,,,,,,,action/1,,0.5\r
870,添加注释,1,entity/1,,,T_50_XXJ_WS_CONTENT_D,AddComment,2,,TRUE,TRUE,,,,,,,,,action/1,AddComment,0.5\r
10059,FE 选择粒子参数文件,2,data/1,,docs/api--10059/,,ParticlesID,3,ParticlesID,,,,ParticlesID,,,,,,,data/10000,T_49_SD_SEARCHKEY_PARTICLESENUM,0.5\r
871,设置 Global property,2,game/1,,docs/api-1-871/,,SetReplicationData,2,SetReplicationData,TRUE,,,globalvar_set,,,,,globalEntity<{0}>.{1} = Value,,module/39,T_49_SD_SEARCHKEY_GLOBALVARSET,0.5\r
872,获取 Global property,2,game/1,,docs/api-1-872/,,GetReplicationData,3,GetReplicationData,TRUE,,,globalvar_get,,,,,globalEntity<{0}>.{1},,module/39,T_49_SD_SEARCHKEY_GLOBALVARGET,0.5\r
10060,FE 商店枚举,2,data/8,,docs/enum/,,ShopType,4,ShopType,,,,,,,,,,,data/10001,,0.5\r
10061,FE Persona枚举,-1,data/8,,docs/enum/,,PersonaType,4,PersonaType,,,,,,,,,,,data/10001,,0.5\r
873,创建随机种子,,data/4,,docs/api-4-873/,,CreateRandomSeed,3,CreateRandomSeed,,,,,,,,,,,data/3,,0.5\r
874,获取下一个随机数,,data/4,,docs/api-4-874/,,Next,3,Next,,,,,,,,,,,data/3,,0.5\r
875,加入队伍,,game/3,,docs/api-29-875/,,JoinTeam,2,JoinTeam,TRUE,,,,,,,,,,module/29,,0.5\r
876,加入新队伍,,game/3,,docs/api-29-876/,,JoinNewTeam,2,JoinNewTeam,TRUE,,,,,,,,,,module/29,,0.5\r
877,OnReceiveFinishFromPersona,2,event/1,,docs/event-46-877/,,OnReceiveFinishFromPersona,1,OnReceiveFinishFromPersona,TRUE,,,,,,,,,,event,,0.5\r
878,OnReceiveStatusFromPersona,2,event/1,,docs/event-46-878/,,OnReceiveStatusFromPersona,1,OnReceiveStatusFromPersona,TRUE,,,,,,,,,,event,,0.5\r
879,当玩家被击倒V2,,event/2,,docs/event-16-879/,,OnKnockedDownV2,1,OnKnockedDownV2,TRUE,,,,,,,,,,event,,0.5\r
10062,FE 选择PersonaID,2,data/1,,,,PersonaID,3,,,,,PersonaID,,,,,,internal,data/10000,T_49_SD_SEARCHKEY_PERSONA,0.5\r
880,OnHudSendMessageToPersona,2,event/1,,docs/event-46-880/,,OnHudSendMessageToPersona,1,OnHudSendMessageToPersona,TRUE,,,,,,,,,,event,,0.5\r
881,雾效枚举,,data/8,,docs/enum/,,FogModeType,4,FogModeType,,,,,,,,,,,data/10001,,0.5\r
819,批量读取数据库值,2,game/12,,docs/api-31-819/,,BatchReadDBSheetValue,2,BatchReadDBSheetValue,TRUE,,,,1;2;3;4;6,FE_1:DataSheet,,,,,module/31,,0.5\r
837,按战场码批量读取数据值,2,game/12,,docs/api-31-837/,,BatchReadDBSheetValueByWorkshopCode,2,BatchReadDBSheetValue,TRUE,,,,1;2;3;4|5;6,,,,,,module/31,,0.5\r
882,开始播放剧情,1,game/11,,docs/api-1-882/,,NotifyStartPlot,2,NotifyStartPlot,TRUE,,,,,,,,,,action/1,,0.5\r
883,当实体切换队伍时,,event/2,,docs/event-29-883/,,OnChangeTeam,1,OnChangeTeam,TRUE,,,,,,,,,,event,,0.5\r
884,CreateTimeLine,,game/11,,docs/api-30-884/,,CreateTimeLine,2,CreateTimeLine,TRUE,,,,,1:Enum_TimeLineID;FE_1:PerformanceID,,,,,module/47,,0.5\r
885,SetTimeLineTrackActor,,game/11,,docs/api-30-885/,,SetTimeLineTrackActor,2,SetTimeLineTrackActor,TRUE,,,,,,3,,,,module/47,,0.5\r
886,FE 选择PerformanceID,2,game/11,,,,PerformanceID,3,,,,,PerformanceID,,,,,,,data/10000,T_49_SD_SEARCHKEY_TIMELINE,0.5\r
887,沿路径移动,,entity/6,,docs/api-30-887/,,CreateAlongPathMotion,2,CreateAlongPathMotion,TRUE,,,,,,,,,,action/30,,0.5\r
888,CF 选择PlotID,1,game/11,31190990,,,PlotID,4,,,TRUE,,,,,,,,,data/10000,PlotID,0.5\r
889,获取客户端语言,,entity/1,,docs/api-1-889/,,GetLocalLanguage,3,GetLocalLanguage,,,,,,,,1,,,action/1,,0.5\r
890,剧情对话开始播放,1,event/2,,docs/event-1-890/,,OnPlotStart,1,OnPlotStart,TRUE,,,,,,,,,,event,,0.5\r
891,剧情对话结束,1,event/2,,docs/event-1-891/,,OnPlotEnd,1,OnPlotEnd,TRUE,,,,,,,,,,event,,0.5\r
892,剧情对话选项被触发,1,event/2,,docs/event-1-892/,,OntriggerPlotOption,1,OntriggerPlotOption,TRUE,,,,,,,,,,event,,0.5\r
893,实例化prefab,2,entity/1,,docs/api-1-893/,,InstantiatePrefab,2,InstantiatePrefab,TRUE,,P2=P1,P1=P2.T0,,2:PrefabGetter,,,,,action/1,,0.5\r
894,设置本地玩家位置,,game/2,,docs/api-11-894/,,SetLocalPlayerPositon,2,SetLocalPlayerPositon,TRUE,,,,,,,,,,module/11,,0.5\r
895,设置本地玩家朝向,,game/2,,docs/api-11-895/,,SetLocalPlayerForward,2,SetLocalPlayerForward,TRUE,,,,,,,,,,module/11,,0.5\r
896,向量投影,,data/2,4280900,docs/api-4-896/,,Vector3Projection,3,Vector3Projection,,,,,,,,,,,data/4,,0.5\r
897,获取当前相机,,game/5,,docs/api-8-897/,,GetCurrentNewCamera,3,GetCurrentNewCamera,,,,,,,,,,,module/8,,0.5\r
898,获取当前相机(clinet),,game/5,,docs/api-8-898/,,GetCurrentNewCameraForClinet,3,GetCurrentNewCameraForClinet,,,,,,,,,,,module/8,,0.5\r
899,切换相机,,game/5,,docs/api-8-899/,,SwitchNewCamera,2,SwitchNewCamera,TRUE,,,,,3:CameraTransitionType,,,,,module/8,,0.5\r
900,切换相机(clinet),,game/5,,docs/api-8-900/,,SwitchNewCameraForClinet,2,SwitchNewCameraForClinet,TRUE,,,,,,,,,,module/8,,0.5\r
901,创建相机,,game/5,,docs/api-8-901/,,CreateBasicCamera,2,CreateBasicCamera,TRUE,,,,,,,,,,module/8,,0.5\r
902,获取本地时间戳(Ms),,game/1,,docs/api-1-902/,,GetLocalTimestampMs,3,GetLocalTimestampMs,,,,,,,,,,,module/39,,0.5\r
903,获取服务器时间戳(Ms),,game/1,,docs/api-1-903/,,GetServerTimestampMs,3,GetServerTimestampMs,,,,,,,,,,,module/39,,0.5\r
904,时间戳(Ms)本地化字符串,,data/7,4790850,docs/api-1-904/,,TimestampMsToLocalString,3,TimestampMsToLocalString,,,,,,2:TimestampFormatStyle,,,,,data/6,,0.5\r
905,Persona更新上下文,2,game/12,,docs/api-46-905/,,UpdateContextToPersona,2,UpdateContextToPersona,TRUE,,,,,,,,,,module/46,,0.5\r
906,Persona点赞点踩,2,game/12,,docs/api-46-906/,,FeedbackToPersonaContent,2,FeedbackToPersonaContent,TRUE,,,,,,,,,,module/46,,0.5\r
907,Persona记忆回滚,2,game/12,,docs/api-46-907/,,RollbackPersonaMemory,2,RollbackPersonaMemory,TRUE,,,,,,,,,,module/46,,0.5\r
908,收到Persona回复,2,event/1,,docs/event-46-908/,,OnReceiveContentFromPersonaV2,1,OnReceiveContentFromPersonaV2,TRUE,,,,,,,,,,event,,0.5\r
909,刚体约束枚举,,data/8,,docs/enum/,,RigidbodyConstrainType,4,RigidbodyConstrainType,,,,,,,,,,,data/10001,,0.5\r
910,三维向量线性插值,,data/2,4280890,docs/api-4-910/,,LerpVector3,3,LerpVector3,TRUE,,,,,,,,,,data/4,,0.5\r
911,三维向量球形插值,,data/2,4280880,docs/api-4-911/,,SlerpVector3,3,SlerpVector3,TRUE,,,,,,,,,,data/4,,0.5\r
912,设置Basic相机CullingMask,,game/5,,docs/api-8-912/,,SetCustomCameraCullingMask,2,SetCustomCameraCullingMask,TRUE,,,,,,1,,,,module/8,,0.5\r
913,设置Basic相机CullingMask对某层是否可见,,game/5,,docs/api-8-913/,,AddOrRemoveCustomCameraCullingMask,2,AddOrRemoveCustomCameraCullingMask,TRUE,,,,,,1,,,,module/8,,0.5\r
914,获取Basic相机CullingMask,,game/5,,docs/api-8-914/,,GetCustomCameraCullingMask,3,GetCustomCameraCullingMask,TRUE,,,,,,1,,,,module/8,,0.5\r
915,截图,,entity/1,,docs/api-1-915/,,CaptureScreenshot,2,CaptureScreenshot,TRUE,,,,,,,,,internal,action/1,,0.5\r
916,BezierGetter,,data/1,4190920,,T_48_META_API_48_D,BezierGetter,3,,,TRUE,,input_bezier,,,,,,,data/10000,T_49_SD_SEARCHKEY_BEZIER,0.5\r
917,播放一次性音效,2,entity/6,,docs/api-1-917/,,PlayOneShotSound,2,PlayOneShotSound,TRUE,,,,,,,1,,,action/30,,0.5\r
918,文字溢出时处理方式枚举,,data/8,,docs/enum/,,FondOverFlowMod,4,FondOverFlowMod,,,,,,,1,,,,data/10001,,0.5\r
919,通过UIAsset创建自定义HUD,2,entity/4,2490890,docs/api-22-919/,,CreateCustomHudV2,2,CreateCustomHudV2,TRUE,TRUE,,,,,,,,,action/22,,0.5\r
920,通过UIAsset创建客户端自定义HUD,2,entity/4,2490880,docs/api-22-920/,,CreateCustomHudClientV2,2,CreateCustomHudClientV2,TRUE,TRUE,,,,,,,,,action/22,,0.5\r
10063,Tuple Get,2,data/3,,,,TupleGet,3,,,,,tuple_get,,,,,,,data/2,T_50_HJ_SEARCHKEY_TUPLEGET,0.5\r
10064,Tuple Set,2,data/3,,,,TupleSet,2,,,,,tuple_set,,,,,,,data/2,T_50_HJ_SEARCHKEY_TUPLESET,0.5\r
10065,Tuple Create,2,data/3,,,,TupleCreate,3,,,,,tuple_create,,,,,,,data/2,T_50_HJ_SEARCHKEY_TUPLECREATE,0.5\r
921,渲染质量枚举,,data/8,,docs/enum/,,ERenderQuality,4,ERenderQuality,,,,,,,,,,,data/10001,,0.5\r
922,设置关卡物件高亮,,entity/9,,docs/api-26-922/,,SetLevelObjHighLight,2,SetLevelObjHighLight,TRUE,,,,,,,,,,action/1,,0.5\r
923,按位通用运算,-1,data/2,4240990,docs/api-1-923/,,BitwiseCommon,3,BitwiseCommon,,,,,,,,,,,data/4,,0.5\r
924,按位取反,-1,data/2,4240980,docs/api-1-924/,,BitwiseNot,3,BitwiseNot,,,,,,,,,,,data/4,,0.5\r
925,按位数组转整数,,data/7,4790840,docs/api-6-925/,,BitwiseListToInt,3,BitwiseListToInt,,,,,,,,,,,data/6,,0.5\r
926,整数转按位数组,,data/7,4790830,docs/api-6-926/,,BitwiseIntToList,3,BitwiseIntToList,,,,,,,,,,,data/6,,0.5\r
927,四元数夹角,,data/2,4250960,docs/api-4-927/,,QuaternionAngle,3,QuaternionAngle,,,,,,,,,,,data/4,,0.5\r
928,四元数点积,,data/2,4250950,docs/api-4-928/,,QuaternionDot,3,QuaternionDot,,,,,,,,,,,data/4,,0.5\r
929,四元数求逆,,data/2,4250940,docs/api-4-929/,,QuaternionInverse,3,QuaternionInverse,,,,,,,,,,,data/4,,0.5\r
930,四元数FromTo旋转,,data/2,4250930,docs/api-4-930/,,QuaternionFromToRotation,3,QuaternionFromToRotation,,,,,,,,,,,data/4,,0.5\r
931,四元数朝向插值,,data/2,4250920,docs/api-4-931/,,QuaternionRotateTowards,3,QuaternionRotateTowards,,,,,,,,,,,data/4,,0.5\r
932,获取陀螺仪朝向,,game/12,,docs/api-40-932/,,GetGyroscopeOrientation,3,GetGyroscopeOrientation,,,,,,,,,,,module/40,,0.5\r
933,获取陀螺仪重力,,game/12,,docs/api-40-933/,,GetGyroscopeGravity,3,GetGyroscopeGravity,,,,,,,,,,,module/40,,0.5\r
934,获取陀螺仪旋转速率,,game/12,,docs/api-40-934/,,GetGyroscopeRotationRate,3,GetGyroscopeRotationRate,,,,,,,,,,,module/40,,0.5\r
935,获取陀螺仪无偏旋转速率,,game/12,,docs/api-40-935/,,GetGyroscopeRotationUnbiased,3,GetGyroscopeRotationUnbiased,,,,,,,,,,,module/40,,0.5\r
936,获取用户加速度,,game/12,,docs/api-40-936/,,GetUserAcceleration,3,GetUserAcceleration,,,,,,,,,,,module/40,,0.5\r
937,获取触摸信息,,game/12,,docs/api-40-937/,,GetTouchInfo,2,GetTouchInfo,TRUE,,,,,,,,,,module/40,,0.5\r
938,获取屏幕触摸点数量,,game/12,,docs/api-40-938/,,GetScreenTouchCount,3,GetScreenTouchCount,,,,,,,,,,,module/40,,0.5\r
939,设备震动,,game/12,,docs/api-40-939/,,VibrateDevice,2,VibrateDevice,TRUE,,,,,,,,,,module/40,,0.5\r
940,获取渲染质量,,game/12,,docs/api-40-940/,,GetRenderQuality,3,GetRenderQuality,,,,,,,,,,,module/40,,0.5\r
941,获取渲染分辨率,,game/12,,docs/api-40-941/,,GetRenderResolution,3,GetRenderResolution,,,,,,,,,,,module/40,,0.5\r
942,服务端播放音效V2,,entity/6,,docs/api-1-942/,,NotifyPlaySoundV2,2,NotifyPlaySoundV2,TRUE,,,,,3:ConstFloatOrInt=1,,,,,action/1,,0.5\r
943,客户端播放一次性音效V2,,entity/6,,docs/api-1-943/,,PlayOneShotSoundV2,2,PlayOneShotSoundV2,TRUE,,,,,,,,,,action/1,,0.5\r
944,字符串格式化,,data/6,4670950,docs/api-5-944/,,FormatStr,3,FormatStr,,,,,,,,,,,data/5,,0.5\r
945,异步复活玩家,,game/2,,docs/api-11-945/,,ReviveOnNextFrame,2,ReviveOnNextFrame,TRUE,,,,,,,,,,module/11,,0.5\r
946,异步淘汰战斗实体,,game/3,,docs/api-16-946/,,EliminateOnNextFrame,2,EliminateOnNextFrame,TRUE,,,,,,,,,,module/29,,0.5\r
947,异步踢出玩家,,game/2,,docs/api-11-947/,,QuitFameOnNextFrame,2,QuitFameOnNextFrame,TRUE,,,,,,,,,,module/11,,0.5\r
948,获取麦克风音量,,game/12,,docs/api-40-948/,,GetMicrophoneVolume,2,GetMicrophoneVolume,TRUE,,,,,,,,,,module/40,,0.5\r
949,屏幕触摸开始事件,,event/1,,docs/event-40-949/,,OnScreenTouchBegan,1,OnScreenTouchBegan,TRUE,,,,,,,,,,event,,0.5\r
950,屏幕触摸结束事件,,event/1,,docs/event-40-950/,,OnScreenTouchEnded,1,OnScreenTouchEnded,TRUE,,,,,,,,,,event,,0.5\r
951,粘贴组件,2,entity/1,,docs/api-1-951/,,PasteComponent,2,PasteComponent,TRUE,,,,,,,,,,action/1,,0.5\r
952,读取数据库某列值,2,game/12,,docs/api-31-952/,,ReadDBSheetColumnValue,2,ReadDBSheetColumnValue,TRUE,,,P4=P1.SheetType TupleIndexT >;P5=P4.PropertyType,1;2;3;4|5;7,FE_1:MulticolSheet;FE_4:SheetColumn,,,,,module/31,,0.5\r
953,按战场码读取数据库某列值,2,game/12,,docs/api-31-953/,,ReadDBSheetColumnValueByWorkshopCode,2,ReadDBSheetColumnValue,TRUE,,,,1;2;3;4|5;6;7,,,,,,module/31,,0.5\r
954,读取数据库中排行榜关联表值,2,game/12,,docs/api-31-954/,,ReadDBLeaderboardAssociationValue,2,ReadDBLeaderboardAssociationValue,TRUE,,,P3=P1.SheetType,1;2;3;5;6,FE_1:RankSheet,,,,,module/31,,0.5\r
955,按战场码读取数据库中排行榜关联表值,2,game/12,,docs/api-31-955/,,ReadDBLeaderboardAssociationValueByWorkshopCode,2,ReadDBLeaderboardAssociationValue,TRUE,,,,1;2;3;4|5;6,,,,,,module/31,,0.5\r
956,根据名次区间读取数据库中排行榜表及关联表值,2,game/12,,docs/api-31-956/,,ReadDBLeaderboardAssociationValuesByRange,2,ReadDBLeaderboardAssociationValuesByRange,TRUE,,,,1;2;3;4|6;7,FE_1:RankSheet,,,,,module/31,,0.5\r
957,按战场码根据名次区间读取数据库中排行榜表及关联表值,2,game/12,,docs/api-31-957/,,ReadDBLeaderboardAssociationValuesByRangeByWorkshop,2,ReadDBLeaderboardAssociationValuesByRange,TRUE,,,,1;2;3;4|5;6;7,,,,,,module/31,,0.5\r
958,写入数据库中排行榜表和关联表值,2,game/12,,docs/api-31-958/,,WriteDBLeaderboardAssociationValue,2,WriteDBLeaderboardAssociationValue,TRUE,,,P3=P1.SheetValueType,1;2;3;5;6,FE_1:RankSheet,,,,,module/31,,0.5\r
959,绑定CustomPlayer,2,game/2,,docs/api-1-959/,,BindCustomPlayer,2,BindCustomPlayer,TRUE,,,,,,,,,,action/1,,0.5\r
960,解绑CustomPlayer,2,game/2,,docs/api-1-960/,,UnbindCustomPlayer,2,UnbindCustomPlayer,TRUE,,,,,,,,,,action/1,,0.5\r
961,设置CustomPlayer状态,2,game/2,,docs/api-1-961/,,SetCustomPlayerState,2,SetCustomPlayerState,TRUE,,,,,,,,,,action/1,,0.5\r
962,获取CustomPlayer状态,2,game/2,,docs/api-1-962/,,GetCustomPlayerState,2,GetCustomPlayerState,TRUE,,,,,,,,,,action/1,,0.5\r
963,收到persona创房结果,2,event/1,,docs/event-46-963/,,OnReceivePersonaCreateRoomResult,1,OnReceivePersonaCreateRoomResult,TRUE,,,,,,,,,,event,,0.5\r
964,收到Persona触发Action,2,event/1,,docs/event-46-964/,,OnReceiveActionIDFromPersona,1,OnReceiveActionIDFromPersona,TRUE,,,,,,,,,,event,,0.5\r
965,按战场码写入数据库中排行榜表和关联表值,2,game/12,,docs/api-31-965/,,WriteDBLeaderboardAssociationValueByWorkshopCode,2,WriteDBLeaderboardAssociationValue,TRUE,,,,1;2;3;4|5;6,,,,,,module/31,,0.5\r
966,设置玩家之间距离语音音量,,game/12,,docs/api-40-966/,,SetDistanceVolumes,2,SetDistanceVolumes,TRUE,,,,,,,,,,module/40,,0.5\r
967,获取好友ID,,game/12,,docs/api-14-967/,,GetFriends,3,GetFriends,,,,,,,,,,,module/14,,0.5\r
968,用户自定义事件,1,event/3,,docs/event--968/,,UserCustomEvent,1,UserCustomEvent,,TRUE,,,,,,,,,,,0.5\r
969,触发用户自定义事件,1,event/3,,docs/api--969/,,DispatchUserCustomEvent,2,DispatchUserCustomEvent,,TRUE,,,,,,,,,,,0.5\r
970,获取默认界面位置,,game/2,,docs/api-11-970/,,GetDefaultUIPosition,2,GetDefaultUIPosition,TRUE,,,,,,,,,,module/11,,0.5\r
972,玩家退出或玩家比赛结束时,,event/1,,docs/event-11-972/,,OnUserQuitOrUserMacthEnd,1,OnUserQuitOrUserMacthEnd,TRUE,,,,,,,,,,event,,0.5\r
973,PlayerStateType,,data/8,,docs/enum/,,PlayerStateType,4,PlayerStateType,,,,,,,,,,,data/10001,,0.5\r
10066,FE 动画状态,2,data/1,,,,AnimationState,3,,,,,AnimationState,,,,,,,data/10000,AnimationState,0.5\r
974,设置实体描边,,entity/1,,docs/api-1-974/,,SetLevelObjOutlineEffect,2,SetLevelObjOutlineEffect,TRUE,,,,,,3,,,internal,action/1,,0.5\r
975,CF 阶段索引PhaseIndex,1,data/8,,,,DynamicPhaseIndex,4,,,TRUE,,,,,,,,,data/10000,DynamicPhaseIndex,0.5\r
977,实体属性,2,data/8,,docs/enum/,,EntityFlag,4,EntityFlag,,,,,,,,,,,data/10000,,0.5\r
978,获取类型名称,,entity/1,,docs/api-1-978/,,GetTypeName,3,GetTypeName,TRUE,,,,,,,,,,action/1,,0.5\r
979,获取包围盒,,game/5,,docs/api-26-979/,,GetBoundingBox,2,GetBoundingBox,TRUE,,,,,,,,,,action/1,,0.5\r
980,设置材质属性,,game/5,,docs/api-26-980/,,SetMaterialProperty,2,SetMaterialProperty,TRUE,,,,,,,,,,action/1,,0.5\r
981,清除材质属性,,game/5,,docs/api-26-981/,,ClearMaterialProperty,2,ClearMaterialProperty,TRUE,,,,,,,,,,action/1,,0.5\r
982,自定义属性改变时,2,event,,docs/event-1-982/,,OnCustomPropertyChange,1,OnCustomPropertyChange,TRUE,,,,,,,,,,event,,0.5\r
983,CustomPlayer状态改变时,2,event/1,,docs/event-1-983/,,OnCustomPlayerStateChanged,1,OnCustomPlayerStateChanged,TRUE,,,,,,,,,,event,,0.5\r
984,获取属性id,,entity/1,,,,GetPropertyId,3,,,TRUE,,get_property_id,,,,,,,action/1,GetPropertyId,0.5\r
985,向persona发送用户消息要求有语音回复,2,game/12,,docs/api-46-985/,,UserMessageToPersonaVoice,2,UserMessageToPersonaVoice,TRUE,,,,,,,,,,module/46,,0.5\r
986,向persona发送系统消息要求有语音回复,2,game/12,,docs/api-46-986/,,SystemMessageToPersonaVoice,2,SystemMessageToPersonaVoice,TRUE,,,,,,,,,,module/46,,0.5\r
987,播放缓存的已生成语音,2,game/12,,docs/api-46-987/,,PlayStoredVoiceFromPersona,2,PlayStoredVoiceFromPersona,TRUE,,,,,,,,,,module/46,,0.5\r
988,当接收到persona的语音回复,2,event/1,,docs/event-46-988/,,OnReceiveVoiceFromPersona,1,OnReceiveVoiceFromPersona,TRUE,,,,,,,,,,event,,0.5\r
989,OnPlayVoiceFinishFromPersona,2,event/1,,docs/event-46-989/,,OnPlayVoiceFinishFromPersona,1,OnPlayVoiceFinishFromPersona,TRUE,,,,,,,,,,event,,0.5\r
10067,广播自定义事件,2,event/3,,docs/api-1-10067/,广播自定义事件到指定平台,BroadcastCustomEvent,2,BroadcastCustomEvent,,,,,,,,,,,,BroadcastCustomEvent,0.5\r
990,获取客户端区域,0,game/1,,docs/api-1-990/,,GetClientRegion,2,GetClientRegion,TRUE,,,,,,,1,,,action/1,,0.5\r
991,施力类型,,data/8,,docs/enum/,,ForceType,4,ForceType,,,,,,,,,,,data/10001,,0.5\r
`, _I = 44, Sh = 13, nS = 10, hh = 34, vN = /""/g;
class $N {
  CsvToJson(s, r = {
    hasDescription: !0
  }) {
    let i = [0], a = this.parseLine(s, i), p = [];
    for (r.hasDescription && this.parseLine(s, i); i[0] < s.length; ) {
      let E = this.parseLine(s, i), h = E[0];
      E.length == a.length && h[0] != ";" && p.push(this.BuildJsonResult(a, E, r ? r.plainText : void 0));
    }
    return p;
  }
  CsvToListArray(s) {
    let r = [], i = [0], a = this.parseLine(s, i);
    for (r.push(a); i[0] < s.length; ) {
      let p = this.parseLine(s, i);
      p.length == a.length && r.push(p);
    }
    return r;
  }
  // parse one line, and update the current index
  parseLine(s, r) {
    let i = [];
    do {
      if (i.push(this.parseCell(s, r)), this.checkNewLineOrFileEnd(s, r))
        break;
      r[0]++;
    } while (!0);
    return i;
  }
  checkNewLineOrFileEnd(s, r) {
    let i = r[0], a = s.charCodeAt(i);
    return i >= s.length ? !0 : a == Sh ? (i++, s.charCodeAt(i) == nS && i++, r[0] = i, !0) : a == nS ? (i++, r[0] = i, !0) : !1;
  }
  parseCell(s, r) {
    let i = r[0];
    if (s.charCodeAt(i) == hh)
      return r[0] = i + 1, this.parseCellComplex(s, r);
    let a = i, p, E = null;
    for (; p = s.charCodeAt(i); ) {
      if (p == _I) {
        E = s.substring(a, i);
        break;
      } else if (p == nS || p == Sh) {
        E = s.substring(a, i);
        break;
      }
      i++;
    }
    return p || (E = s.substring(a, i)), r[0] = i, E;
  }
  parseCellComplex(s, r) {
    let i = r[0], a = i, p, E = null;
    for (; p = s.charCodeAt(i); ) {
      if (p == hh) {
        if (i++, s.charCodeAt(i) == hh) {
          i++;
          continue;
        }
        E = s.substring(a, i - 1), E = E.replace(vN, '"');
        break;
      }
      i++;
    }
    for (; (p = s.charCodeAt(i)) && p != _I; ) {
      if (p == nS || p == Sh)
        break;
      i++;
    }
    return r[0] = i, E;
  }
  BuildJsonResult(s, r, i = !1) {
    let a = {};
    for (let p = 0; p < s.length; p++) {
      let E = s[p], h;
      i ? h = r[p] : h = this.GetValueFormatByType(r[p]), a[E] = h;
    }
    return a;
  }
  GetValueFormatByType(s) {
    if (s === void 0 || s === "")
      return "";
    let r = Number(s);
    return isNaN(r) ? s.localeCompare("true", void 0, { sensitivity: "accent" }) == 0 ? !0 : s.localeCompare("false", void 0, { sensitivity: "accent" }) == 0 ? !1 : s : r;
  }
}
const mM = new $N();
let iI = {
  "": "any",
  Boolean: "bool",
  Number: "number",
  String: "string",
  Colour: "Color"
};
class WN extends g.ConnectionChecker {
  constructor() {
    super(...arguments);
    N(this, "isDragging");
  }
  canConnectWithReason(r, i, a, p) {
    let E = this.isDragging;
    this.isDragging = a;
    let h = super.canConnectWithReason(r, i, a, p);
    return this.isDragging = E, h;
  }
  doTypeChecks(r, i) {
    if (r.type == g.ConnectionType.NEXT_STATEMENT || r.type == g.ConnectionType.PREVIOUS_STATEMENT)
      return super.doTypeChecks(r, i);
    let a = r.isSuperior(), p = a ? i.getSourceBlock() : r.getSourceBlock();
    if ("ReversedDetermineType" in p && p.ReversedDetermineType(), this.isDragging = p.workspace.isDragging(), this.isDragging)
      return !0;
    let E = a ? r.getCheck() : i.getCheck(), h = a ? i.getCheck() : r.getCheck();
    if (E == null || h == null)
      return p.setWarningText(null, "TYPE"), !0;
    let L = Ae.CurrentDescriptionFile, y = "", V = "";
    for (let Z of h) {
      let le = L.GetVarType(Z);
      le && (V += le.Label + " ");
    }
    for (let Z of E) {
      Z = iI[Z] || Z;
      let le = L.GetVarType(Z);
      le != null && (y += le.Label + " ");
      for (let ce of h)
        if (ce = iI[ce] || ce, Z == ce || le != null && Bn.CheckIsAssignable(le, ce, L))
          return p.setWarningText(null, "TYPE"), !0;
    }
    return (r.targetConnection == i || r.targetConnection == null) && p.setWarningText(Oe(_e.Warning_TypeAssign, [y, V]), "TYPE"), !0;
  }
}
class kN extends mS {
  constructor(r) {
    super();
    N(this, "fileDictByID", /* @__PURE__ */ new Map());
    this.pm = r;
  }
  FindGFile(r) {
    return this.fileDictByID.get(r);
  }
  AddGfile(r) {
    this.fileDictByID.set(r.fileId, r);
  }
}
class FN extends cM {
  constructor() {
    super();
    N(this, "project", new kN(this));
    this.CollectDisposalObject(this.project);
  }
  FindGFile(r) {
    return this.project.FindGFile(r);
  }
  AddGfile(r) {
    this.project.AddGfile(r);
  }
}
class wN extends cM {
  constructor() {
    super(...arguments);
    N(this, "configGroups", /* @__PURE__ */ new Map());
    N(this, "configGroupPathCache", /* @__PURE__ */ new Map());
  }
  LoadCsv(r, i, a) {
    let p = r.split("\\").pop().split("/").pop();
    if (!this.IsValidGroupName(p, r))
      return;
    let E = i;
    if (!E) {
      console.warn("Cant get csv content for path:" + r);
      return;
    }
    this.SetCsvContent(E, r, p, a);
  }
  SetCsvContent(r, i, a, p) {
    let E = mM.CsvToJson(r), h = {};
    for (let L = 0; L < E.length; L++) {
      let y = E[L][p] || L;
      h[y] = E[L];
    }
    this.configGroups.set(a, h), this.configGroupPathCache.set(a, i);
  }
  IsValidGroupName(r, i) {
    if (this.configGroupPathCache.has(r)) {
      let a = this.configGroupPathCache.get(r);
      if (a != i)
        return console.error("Duplicated ConfigGroup name:" + r + "with path1:" + a + "and path2:" + i), !1;
    }
    return !0;
  }
  GetAllDatas(r) {
    let i = this.configGroups.get(r);
    if (i == null)
      return null;
    let a = new Array();
    return Object.keys(i).forEach((p) => {
      a.push(i[p]);
    }), a;
  }
}
const Qh = aM("reserved.mod.config");
function PM(_) {
  return !(_.FEShowControl != null && (typeof _.FEShowControl == "string" && _.FEShowControl.toLocaleLowerCase() == "false" || typeof _.FEShowControl == "boolean" && _.FEShowControl == !1));
}
class qh extends mS {
  constructor(r, i) {
    super();
    N(this, "fileId", "");
    N(this, "treeViewData");
    this.fileId = r, this.treeViewData = new BN(this, i);
  }
}
class BN {
  constructor(s, r) {
    N(this, "id", "");
    N(this, "name", "");
    N(this, "gfile");
    this.gfile = s, this.id = s.fileId, this.name = r;
  }
}
const YN = `Id,ItemType,ItemTypeKey,ItemId,ItemIcon,ItemCDN,ItemKey,NoShowInUnit,EntityName,ShowControl,CraftlandShowControl,FEShowControl,IsObsolote,ResourceLevel\r
序号（对应Config\\ItemTable.csv中的id）,"道具类型:1-武器,2-子弹,3-防具与背包,4-配件,5-功能型装备,6-投掷物,7-治疗道具,8-特殊道具,9-感染模式,10-足球模式",道具类型名称,类型下的道具排序,道具icon,道具iconCDN图,道具名称key,不显示在道具生成器里,实体类型,显示控制（1为仅Craftland显示，2为仅FE显示，0或不填为双端都显示）,"Craftland显示控制\r
TRUE或不填为显示，FALSE为不显示","FE显示控制\r
TRUE或不填为显示，FALSE为不显示",是否废弃,"资源权限等级\r
public（或不填）：公开资源\r
internal：仅白名单可用资源"\r
1,1,T_32_LO_WS_LOOT_WEAPONTYPE,,Icon_slot_FIST,,TXT_ITEM_FIST,1,Weapon,,,,,\r
2,1,T_32_LO_WS_LOOT_WEAPONTYPE,1,Icon_slot_M4A1,,TXT_ITEM_M4A1,1,Weapon,,,,,\r
3,1,T_32_LO_WS_LOOT_WEAPONTYPE,27,Icon_slot_USP,,TXT_ITEM_USP,1,Weapon,,,,,\r
4,1,T_32_LO_WS_LOOT_WEAPONTYPE,23,Icon_slot_AWM,,TXT_ITEM_AWM,1,Weapon,,,,,\r
5,1,T_32_LO_WS_LOOT_WEAPONTYPE,45,Icon_slot_M1014,,TXT_ITEM_M1014,1,Weapon,,,,,\r
6,1,T_32_LO_WS_LOOT_WEAPONTYPE,2,Icon_slot_AK,,TXT_ITEM_AK,1,Weapon,,,,,\r
7,1,T_32_LO_WS_LOOT_WEAPONTYPE,35,Icon_slot_UMP,,TXT_ITEM_UMP,1,Weapon,,,,,\r
8,1,T_32_LO_WS_LOOT_WEAPONTYPE,36,Icon_slot_MP5,,TXT_ITEM_MP5,1,Weapon,,,,,\r
9,1,T_32_LO_WS_LOOT_WEAPONTYPE,28,Icon_slot_DE,,TXT_ITEM_EAGLE,1,Weapon,,,,,\r
10,1,T_32_LO_WS_LOOT_WEAPONTYPE,29,Icon_slot_G18,,TXT_ITEM_G18,1,Weapon,,,,,\r
11,1,T_32_LO_WS_LOOT_WEAPONTYPE,3,Icon_slot_M14,,TXT_ITEM_M14,1,Weapon,,,,,\r
12,1,T_32_LO_WS_LOOT_WEAPONTYPE,4,Icon_slot_SCAR,,TXT_ITEM_SCAR,1,Weapon,,,,,\r
13,1,T_32_LO_WS_LOOT_WEAPONTYPE,37,Icon_slot_VSS,,TXT_ITEM_VSS,1,Weapon,,,,,\r
14,1,T_32_LO_WS_LOOT_WEAPONTYPE,5,Icon_slot_GROZA,,TXT_ITEM_GROZA,1,Weapon,,,,,\r
15,1,T_32_LO_WS_LOOT_WEAPONTYPE,38,Icon_slot_MP40,,TXT_ITEM_MP40,1,Weapon,,,,,\r
16,1,T_32_LO_WS_LOOT_WEAPONTYPE,51,Icon_slot_Changuo,,TXT_ITEM_CHANGUO,1,Weapon,,,,,\r
17,1,T_32_LO_WS_LOOT_WEAPONTYPE,52,Icon_slot_Machete,,TXT_ITEM_MACHETE,1,Weapon,,,,,\r
18,1,T_32_LO_WS_LOOT_WEAPONTYPE,6,Icon_slot_SKS,,TXT_ITEM_SKS,1,Weapon,,,,,\r
19,1,T_32_LO_WS_LOOT_WEAPONTYPE,7,Icon_slot_M249,,TXT_ITEM_M249,1,Weapon,,,,,\r
20,1,T_32_LO_WS_LOOT_WEAPONTYPE,30,Icon_slot_M1873,,TXT_ITEM_M1873,1,Weapon,,,,,\r
21,1,T_32_LO_WS_LOOT_WEAPONTYPE,24,Icon_slot_Kar98k,,TXT_ITEM_KAR98K,1,Weapon,,,,,\r
22,1,T_32_LO_WS_LOOT_WEAPONTYPE,92,Icon_slot_Crossbow,,TXT_ITEM_CROSSBOW,1,CrossBow,,,,,\r
23,1,T_32_LO_WS_LOOT_WEAPONTYPE,93,Icon_slot_M79,,TXT_ITEM_M79,1,GrenadeLauncher,,,,,\r
24,1,T_32_LO_WS_LOOT_WEAPONTYPE,8,Icon_slot_Famas,,TXT_ITEM_FAMAS,1,Weapon,,,,,\r
25,1,T_32_LO_WS_LOOT_WEAPONTYPE,31,Icon_slot_M500,,TXT_ITEM_M500,1,Weapon,,,,,\r
26,1,T_32_LO_WS_LOOT_WEAPONTYPE,9,Icon_slot_SVD,,TXT_ITEM_SVD,1,Weapon,,,,,\r
27,1,T_32_LO_WS_LOOT_WEAPONTYPE,53,Icon_slot_BASEBALLPOLE,,TXT_ITEM_BASEBALLPOLE,1,Weapon,,,,,\r
28,1,T_32_LO_WS_LOOT_WEAPONTYPE,10,Icon_slot_Xm8,,TXT_ITEM_XM8,1,Weapon,,,,,\r
29,1,T_32_LO_WS_LOOT_WEAPONTYPE,46,Icon_slot_SPAS12,,TXT_ITEM_SPAS12,1,Weapon,,,,,\r
30,1,T_32_LO_WS_LOOT_WEAPONTYPE,11,Icon_slot_M60,,TXT_OB10_HQW_ITEM_M60,1,Weapon,,,,,\r
31,1,T_32_LO_WS_LOOT_WEAPONTYPE,94,Icon_slot_MGL140,,TXT_OB11_HQW_ITEM_MGL140,1,GrenadeLauncher,,,,,\r
32,1,T_32_LO_WS_LOOT_WEAPONTYPE,39,Icon_slot_P90,,TXT_OB11_HQW_ITEM_P90,1,Weapon,,,,,\r
33,1,T_32_LO_WS_LOOT_WEAPONTYPE,12,Icon_slot_AN94,,T_12_Q_ITEM_AN94,1,Weapon,,,,,\r
34,1,T_32_LO_WS_LOOT_WEAPONTYPE,54,Icon_slot_Katana,,T_14_G_ITEM_KATANA,1,Weapon,,,,,\r
35,1,T_32_LO_WS_LOOT_WEAPONTYPE,40,Icon_slot_CG15,,T_15_Q_ITEM_CG15,1,Weapon,,,,,\r
36,1,T_32_LO_WS_LOOT_WEAPONTYPE,95,Icon_slot_RGS50,,T_14_Q_ITEM_RGS50,1,Weapon,,,,,\r
38,1,T_32_LO_WS_LOOT_WEAPONTYPE,96,Icon_slot_GrapplingHookGun,,T_16_B_ITEM_GRAPPLINGHOOKGUN,1,GrapplingHookGun,,,,,\r
40,1,T_32_LO_WS_LOOT_WEAPONTYPE,97,Icon_slot_ThrowingKnife,,T_18_B_THROWINGKNIFE_NAME,1,Weapon,,,,,\r
41,1,T_32_LO_WS_LOOT_WEAPONTYPE,47,Icon_slot_M1887,,T_18_U_WEAPON_M1887_NAME,1,Weapon,,,,,\r
43,1,T_32_LO_WS_LOOT_WEAPONTYPE,41,Icon_slot_Thompson,,T_21_U_WEAPON_THOMPSON_NAME,1,Weapon,,,,,\r
45,1,T_32_LO_WS_LOOT_WEAPONTYPE,25,Icon_slot_BM94,,T_22_C_BLT_NAME,1,Weapon,,,,,\r
46,1,T_32_LO_WS_LOOT_WEAPONTYPE,14,Icon_slot_AUG,,T_23_U_AUG,1,Weapon,,,,,\r
47,1,T_32_LO_WS_LOOT_WEAPONTYPE,15,Icon_slot_PARAFAL,,T_24_U_PARAFAL,1,Weapon,,,,,\r
48,1,T_32_LO_WS_LOOT_WEAPONTYPE,16,Icon_slot_M21A5,,T_24_U_M21A5,1,Weapon,,,,,\r
49,1,T_32_LO_WS_LOOT_WEAPONTYPE,42,Icon_slot_VECTOR,,T_25_U_VECTOR,1,Weapon,,,,,\r
50,1,T_32_LO_WS_LOOT_WEAPONTYPE,48,Icon_slot_MAG7,,T_25_U_MAG7,1,Weapon,,,,,\r
51,1,T_32_LO_WS_LOOT_WEAPONTYPE,55,Icon_slot_Sickle,,T_25_U_SICKLE,1,Weapon,,,,,\r
53,1,T_32_LO_WS_LOOT_WEAPONTYPE,98,Icon_slot_ThrowingKnife,,T_42_XXJ_WS_THROWINGKNIFE_D,1,Weapon,,,,,\r
54,1,T_32_LO_WS_LOOT_WEAPONTYPE,17,Icon_slot_Kord,,T_27_U_KORD,1,Weapon,,,,,\r
55,1,T_32_LO_WS_LOOT_WEAPONTYPE,32,Icon_slot_M1917,,T_27_U_M1917,1,Weapon,,,,,\r
56,1,T_32_LO_WS_LOOT_WEAPONTYPE,33,Icon_slot_MUSP,,T_27_U_WSP,1,Weapon,,,,,\r
57,1,T_32_LO_WS_LOOT_WEAPONTYPE,18,UI_weapon_icon_01@Icon_slot_AR15,,T_28_YF_AR15,1,Weapon,,,,,\r
58,1,T_32_LO_WS_LOOT_WEAPONTYPE,34,Icon_slot_UZI,,T_28_HI_UZI,1,Weapon,,,,,\r
65,1,T_32_LO_WS_LOOT_WEAPONTYPE,79,Icon_slot_AWM,,T_22_U_GOLD_AWM_N,1,Weapon,,,,,\r
70,1,T_32_LO_WS_LOOT_WEAPONTYPE,19,Icon_slot_GROZA,,T_32_YF_GOLD_GROZA_N,1,Weapon,,,,,\r
71,1,T_32_LO_WS_LOOT_WEAPONTYPE,40,Icon_slot_M249,,T_32_YF_GOLD_M249_N,1,Weapon,,,,,\r
72,1,T_32_LO_WS_LOOT_WEAPONTYPE,72,Icon_slot_SVD,,T_32_YF_GOLD_SVD_N,1,Weapon,,,,,\r
73,1,T_32_LO_WS_LOOT_WEAPONTYPE,20,UI_weapon_icon_01@Icon_slot_G36,,T_33_YF_G36_N,1,Weapon,,,,,\r
75,1,T_32_LO_WS_LOOT_WEAPONTYPE,26,UI_weapon_icon_02@Icon_weapon_M24,,T_34_YF_M24_N,1,Weapon,,,,,\r
86,1,T_32_LO_WS_LOOT_WEAPONTYPE,49,UI_weapon_icon_01@Icon_ChargeShot_Render,,T_32_YF_CHARGESHOT_N,1,Weapon,,,,,\r
88,1,T_32_LO_WS_LOOT_WEAPONTYPE,43,UI_weapon_icon_01@Icon_slot_Mac10,,T_31_YF_MAC10_N,1,Weapon,,,,,\r
89,1,T_32_LO_WS_LOOT_WEAPONTYPE,21,Icon_slot_MINI,,T_29_HI_MINI14,1,Weapon,,,,,\r
95,1,T_32_LO_WS_LOOT_WEAPONTYPE,99,Icon_slot_Hand_Cannon,,TXT_ITEM_HANDCANNON,1,HandCannon,,,,,\r
97,1,T_32_LO_WS_LOOT_WEAPONTYPE,100,Icon_slot_ICE_GUN,,T_19_C_ICE_GUN_NAME,1,Weapon,,,,,\r
99,1,T_32_LO_WS_LOOT_WEAPONTYPE,22,Icon_slot_shieldgun,,T_20_U_SHIELD_GUN_NAME,1,Weapon,,,,,\r
150,1,T_32_LO_WS_LOOT_WEAPONTYPE,44,Icon_slot_PP19,,T_35_YF_PP19_N,1,Weapon,,,,,\r
181,1,T_32_LO_WS_LOOT_WEAPONTYPE,50,Icon_HUD_M1216,,T_37_JL_M1216_N,1,Weapon,,,,,\r
21002,1,T_32_LO_WS_LOOT_WEAPONTYPE,51,UI_weapon_icon_02@Icon_slot_AirBurst,,T_44_CJ_W_AIRBURST,1,Weapon,,,,,\r
80,1,T_32_LO_WS_LOOT_WEAPONTYPE,60,Icon_slot_M4A1,,T_32_U_GOLD_M4A1-I,1,Weapon,,,,,\r
81,1,T_32_LO_WS_LOOT_WEAPONTYPE,61,Icon_slot_M4A1,,T_32_U_GOLD_M4A1-II,1,Weapon,,,,,\r
82,1,T_32_LO_WS_LOOT_WEAPONTYPE,62,Icon_slot_M4A1,,T_32_U_GOLD_M4A1-III,1,Weapon,,,,,\r
60,1,T_32_LO_WS_LOOT_WEAPONTYPE,83,Icon_slot_MP5,,T_32_U_GOLD_MP5_I,1,Weapon,,,,,\r
120,1,T_32_LO_WS_LOOT_WEAPONTYPE,84,Icon_slot_MP5,,T_32_U_GOLD_MP5_II,1,Weapon,,,,,\r
121,1,T_32_LO_WS_LOOT_WEAPONTYPE,85,Icon_slot_MP5,,T_32_U_GOLD_MP5_III,1,Weapon,,,,,\r
61,1,T_32_LO_WS_LOOT_WEAPONTYPE,73,Icon_slot_M60,,T_32_U_GOLD_M60_I,1,Weapon,,,,,\r
122,1,T_32_LO_WS_LOOT_WEAPONTYPE,74,Icon_slot_M60,,T_32_U_GOLD_M60_II,1,Weapon,,,,,\r
123,1,T_32_LO_WS_LOOT_WEAPONTYPE,75,Icon_slot_M60,,T_32_U_GOLD_M60_III,1,Weapon,,,,,\r
63,1,T_32_LO_WS_LOOT_WEAPONTYPE,63,Icon_slot_M14,,T_32_U_GOLD_M14_I,1,Weapon,,,,,\r
126,1,T_32_LO_WS_LOOT_WEAPONTYPE,64,Icon_slot_M14,,T_32_U_GOLD_M14_II,1,Weapon,,,,,\r
127,1,T_32_LO_WS_LOOT_WEAPONTYPE,65,Icon_slot_M14,,T_32_U_GOLD_M14_III,1,Weapon,,,,,\r
64,1,T_32_LO_WS_LOOT_WEAPONTYPE,80,Icon_slot_Kar98k,,T_32_U_GOLD_KAR98K_I,1,Weapon,,,,,\r
128,1,T_32_LO_WS_LOOT_WEAPONTYPE,81,Icon_slot_Kar98k,,T_32_U_GOLD_KAR98K_II,1,Weapon,,,,,\r
129,1,T_32_LO_WS_LOOT_WEAPONTYPE,82,Icon_slot_Kar98k,,T_32_U_GOLD_KAR98K_III,1,Weapon,,,,,\r
67,1,T_32_LO_WS_LOOT_WEAPONTYPE,69,Icon_slot_Famas,,T_32_U_GOLD_FAMAS-I,1,Weapon,,,,,\r
130,1,T_32_LO_WS_LOOT_WEAPONTYPE,70,Icon_slot_Famas,,T_32_U_GOLD_FAMAS-II,1,Weapon,,,,,\r
131,1,T_32_LO_WS_LOOT_WEAPONTYPE,71,Icon_slot_Famas,,T_32_U_GOLD_FAMAS-III,1,Weapon,,,,,\r
178,1,T_32_LO_WS_LOOT_WEAPONTYPE,66,Icon_slot_SCAR,,T_36_JL_GOLD_SCAR_I_N,1,Weapon,,,,,\r
179,1,T_32_LO_WS_LOOT_WEAPONTYPE,67,Icon_slot_SCAR,,T_36_JL_GOLD_SCAR_II_N,1,Weapon,,,,,\r
180,1,T_32_LO_WS_LOOT_WEAPONTYPE,68,Icon_slot_SCAR,,T_36_JL_GOLD_SCAR_III_N,1,Weapon,,,,,\r
184,1,T_32_LO_WS_LOOT_WEAPONTYPE,89,Icon_slot_M1014,,T_37_JL_GOLD_M1014_I_N,1,Weapon,,,,,\r
185,1,T_32_LO_WS_LOOT_WEAPONTYPE,90,Icon_slot_M1014,,T_37_JL_GOLD_M1014_II_N,1,Weapon,,,,,\r
186,1,T_32_LO_WS_LOOT_WEAPONTYPE,91,Icon_slot_M1014,,T_37_JL_GOLD_M1014_III_N,1,Weapon,,,,,\r
119,1,T_32_LO_WS_LOOT_WEAPONTYPE,92,Icon_slot_M1887,,T_32_RW_WEAPON_M1887TD_NAME,1,Weapon,,,,,\r
39,1,T_32_LO_WS_LOOT_WEAPONTYPE,13,Icon_slot_Superheat,,T_17_Q_SUPERHEAT,1,Weapon,,,,,\r
66,1,T_32_LO_WS_LOOT_WEAPONTYPE,76,Icon_slot_Superheat,,T_32_U_GOLD_HEATGUN_I,1,Weapon,,,,,\r
132,1,T_32_LO_WS_LOOT_WEAPONTYPE,77,Icon_slot_Superheat,,T_32_U_GOLD_HEATGUN_II,1,Weapon,,,,,\r
133,1,T_32_LO_WS_LOOT_WEAPONTYPE,78,Icon_slot_Superheat,,T_32_U_GOLD_HEATGUN_III,1,Weapon,,,,,\r
199,1,T_32_LO_WS_LOOT_WEAPONTYPE,79,Icon_slot_Superheat,,T_44_WT_W_REWORKHEAT_NAME_X,1,Weapon,,,,,\r
192,1,T_32_LO_WS_LOOT_WEAPONTYPE,8,Icon_slot_AUG,,T_23_U_AUG,1,Weapon,,FALSE,FALSE,,\r
193,1,T_32_LO_WS_LOOT_WEAPONTYPE,71,Icon_slot_AUG,,T_44_HH_GOLD_AUG-I,1,Weapon,,,,,\r
194,1,T_32_LO_WS_LOOT_WEAPONTYPE,71,Icon_slot_AUG,,T_44_HH_GOLD_AUG-II,1,Weapon,,,,,\r
195,1,T_32_LO_WS_LOOT_WEAPONTYPE,71,Icon_slot_AUG,,T_44_HH_GOLD_AUG-III,1,Weapon,,,,,\r
228,1,T_32_LO_WS_LOOT_WEAPONTYPE,85,Icon_slot_Mac10,,T_45_HH_GOLD_MAC10-I,1,Weapon,,,,,\r
229,1,T_32_LO_WS_LOOT_WEAPONTYPE,85,Icon_slot_Mac10,,T_45_HH_GOLD_MAC10-II,1,Weapon,,,,,\r
230,1,T_32_LO_WS_LOOT_WEAPONTYPE,85,Icon_slot_Mac10,,T_45_HH_GOLD_MAC10-III,1,Weapon,,,,,\r
78,1,T_32_LO_WS_LOOT_WEAPONTYPE,56,Icon_slot_HealingSniper,,T_30_YF_Healinggun_Sniper_N,1,Weapon,,,,,\r
93,1,T_32_LO_WS_LOOT_WEAPONTYPE,58,Icon_slot_TREATMENTGUN,,T_12_Q_ITEM_TREATMENTGUN,1,Weapon,,,,,\r
177,1,T_32_LO_WS_LOOT_WEAPONTYPE,101,UI_weapon_icon_02@Icon_slot_FootballGun,,T_37_XYL_FOOTGUN,1,Weapon,,,,,\r
196,1,T_32_LO_WS_LOOT_WEAPONTYPE,107,UI_weapon_icon_02@Icon_slot_FlameGrenade,,T_44_WT_W_FGG,1,Weapon,,,,,\r
21001,1,T_32_LO_WS_LOOT_WEAPONTYPE,108,Icon_slot_TREATMENTGUN,,T_45_CJ_TREATMENTGUN_Y_N,1,Weapon,,,,,\r
197,1,T_32_LO_WS_LOOT_WEAPONTYPE,26,UI_weapon_icon_02@Icon_slot_VSK94,,T_43_WT_W_VSK94,1,Weapon,,,,,\r
17001,1,T_32_LO_WS_LOOT_WEAPONTYPE,103,Icon_slot_FIST,,TXT_ITEM_FIST,1,Weapon,,,,,\r
17002,1,T_32_LO_WS_LOOT_WEAPONTYPE,59,Icon_slot_FLAMETHROWER,,T_24_C_FLAMETHROWER_NAME,1,Weapon,,,,,\r
19000,1,T_32_LO_WS_LOOT_WEAPONTYPE,104,Icon_slot_RGS50,,T_40_XXJ_WS_COLORGUN,1,Weapon,,,,,\r
19001,1,T_32_LO_WS_LOOT_WEAPONTYPE,105,Icon_slot_GrapplingHookGun,,T_40_XYL_WS_NEWHOOKGUN,1,GrapplingHookGun,,,,,internal\r
52,1,T_32_LO_WS_LOOT_WEAPONTYPE,106,FF_ingame_hud_training@Icon_slot_Hammer,,T_26_V_TRAINING_BHH,1,Weapon,,,,,\r
201,2,T_32_LO_WS_LOOT_AMMOTYPE,,UI_item_icon@Icon_ammo_AR,,TXT_ITEM_ARAMMO,,Ammo,,,,,\r
202,2,T_32_LO_WS_LOOT_AMMOTYPE,,UI_item_icon@Icon_ammo_45ACP,,TXT_ITEM_HGAMMO,,Ammo,,,,,\r
203,2,T_32_LO_WS_LOOT_AMMOTYPE,,UI_item_icon@Icon_ammo_SNP,,TXT_ITEM_SNAMMO,,Ammo,,,,,\r
204,2,T_32_LO_WS_LOOT_AMMOTYPE,,UI_item_icon@Icon_ammo_SG,,TXT_ITEM_SGAMMO,,Ammo,,,,,\r
205,2,T_32_LO_WS_LOOT_AMMOTYPE,,UI_item_icon@Icon_ammo_SMG,,TXT_ITEM_SMGAMMO,,Ammo,,,,,\r
206,2,T_32_LO_WS_LOOT_AMMOTYPE,,UI_item_icon@Icon_ammo_BOW,,TXT_ITEM_BOWAMMO,,Ammo,,,,,\r
207,2,T_32_LO_WS_LOOT_AMMOTYPE,,UI_item_icon@Icon_ammo_LANUNCHER,,TXT_ITEM_LANUNCHERAMMO,,Ammo,,,,,\r
209,2,T_32_LO_WS_LOOT_AMMOTYPE,,UI_item_icon_01@Icon_ammo_GrapplingHookGun_Bullet,,T_16_B_ITEM_GRAPPLINGHOOK,,Ammo,,,,,\r
214,2,T_32_LO_WS_LOOT_AMMOTYPE,,Icon_slot_FLAMETHROWER,,T_38_WZY_WS_FLAMEAMMO,1,Ammo,,,,,\r
219,2,T_32_LO_WS_LOOT_AMMOTYPE,,UI_item_icon_07@Icon_ammo_M79_Exclusive,,T_38_JL_M79_AMMO_N,,Ammo,,,,,\r
301,3,T_41_XXJ_WS_EQUIPANDBAG,,UI_item_icon@Icon_equipment_Vest_01,,TXT_ITEM_VEST1,,Vest,,,,,\r
302,3,T_41_XXJ_WS_EQUIPANDBAG,,UI_item_icon@Icon_equipment_Vest_02,,TXT_ITEM_VEST2,,Vest,,,,,\r
303,3,T_41_XXJ_WS_EQUIPANDBAG,,UI_item_icon@Icon_equipment_Vest_03,,TXT_ITEM_VEST3,,Vest,,,,,\r
304,3,T_41_XXJ_WS_EQUIPANDBAG,,UI_item_icon@Icon_equipment_MilitaryHelmet_01,,TXT_ITEM_HELMET1,,Helmet,,,,,\r
305,3,T_41_XXJ_WS_EQUIPANDBAG,,UI_item_icon@Icon_equipment_MilitaryHelmet_02,,TXT_ITEM_HELMET2,,Helmet,,,,,\r
306,3,T_41_XXJ_WS_EQUIPANDBAG,,UI_item_icon@Icon_equipment_MilitaryHelmet_03,,TXT_ITEM_HELMET3,,Helmet,,,,,\r
309,3,T_41_XXJ_WS_EQUIPANDBAG,,UI_item_icon@Icon_equipment_Vest_04,,T_12_Q_ITEM_VEST4,,Vest,,,,,\r
401,3,T_41_XXJ_WS_EQUIPANDBAG,,UI_item_icon@Icon_equipment_Back_E_01,,TXT_ITEM_BAG1,,Bag,,,,,\r
402,3,T_41_XXJ_WS_EQUIPANDBAG,,UI_item_icon@Icon_equipment_Back_E_02,,TXT_ITEM_BAG2,,Bag,,,,,\r
403,3,T_41_XXJ_WS_EQUIPANDBAG,,UI_item_icon@Icon_equipment_Back_E_03,,TXT_ITEM_BAG3,,Bag,,,,,\r
501,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon@Icon_Muzzle_01,,TXT_ITEM_MUZZLE1,,Attachment,,,,,\r
502,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon@Icon_Muzzle_02,,TXT_ITEM_MUZZLE2,,Attachment,,,,,\r
503,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon@Icon_Muzzle_03,,TXT_ITEM_MUZZLE3,,Attachment,,,,,\r
504,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon@Icon_Silencer_01,,TXT_ITEM_SILENCER1,,Attachment,,,,,\r
505,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon_04@Icon_Muzzle_Attack,,T_29_YF_MUZZLE_CRASH_N,,Attachment,,,,,\r
506,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon_04@Icon_Muzzle_Widemuzzle,,T_29_YF_MUZZLE_WIDE_N,,Attachment,,,,,\r
511,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon@Icon_Magazine_01,,TXT_ITEM_MAGEZINE1,,Attachment,,,,,\r
512,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon@Icon_Magazine_02,,TXT_ITEM_MAGEZINE2,,Attachment,,,,,\r
513,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon@Icon_Magazine_03,,TXT_ITEM_MAGEZINE3,,Attachment,,,,,\r
516,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon_02@Icon_Magazine_Double,,T_19_U_DOUBLEMAGEZINE_ATTACHMENT_NAME,,Attachment,,,,,\r
517,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon_04@Icon_Magazine_Chainmagezine,,T_29_YF_MAGEZINE_CHAIN_N,,Attachment,,,,,\r
518,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon_09@Icon_Magezine_Fast,,T_47_CJ_MAGEZINE_FAST_N,,Attachment,,,,,\r
521,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon@Icon_Foregrip_01,,TXT_ITEM_FOREGRIP1,,Attachment,,,,,\r
522,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon@Icon_Foregrip_02,,TXT_ITEM_FOREGRIP2,,Attachment,,,,,\r
523,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon@Icon_Foregrip_03,,TXT_ITEM_FOREGRIP3,,Attachment,,,,,\r
524,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon@Icon_Bipod_01,,TXT_OB10_HQW_ITEM_BIPOD,,Attachment,,,,,\r
525,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon@Icon_Foregrip_MR,,T_36_JL_FOREGRIP_MR_N,,Attachment,,,,,\r
526,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon_09@Icon_Foregrip_Soft,,T_47_CJ_FOREGRIP_SOFT_N,,Attachment,,,,,\r
534,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon@Icon_Gunsight_04,,TXT_ITEM_SIGHT2,,Attachment,,,,,\r
535,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon@Icon_Gunsight_05,,TXT_ITEM_SIGHT4,,Attachment,,,,,\r
537,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon@Icon_Gunsight_07,,TXT_ITEM_HEATSIGHT,,Attachment,,,,,\r
541,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon@Icon_Stock_01,,T_12_Q_ITEM_STOCK1,,Attachment,,,,,\r
542,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon@Icon_Stock_02,,T_12_Q_ITEM_STOCK2,,Attachment,,,,,\r
543,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon@Icon_Stock_03,,T_12_Q_ITEM_STOCK3,,Attachment,,,,,\r
544,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon_06@Icon_Stock_SG,,T_36_JL_STOCK_SG_N,,Attachment,,,,,\r
545,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon_06@Icon_Stock_SR,,T_36_JL_STOCK_SR_N,,Attachment,,,,,\r
547,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon_09@Icon_Stock_Fast,,T_47_CJ_STOCK_FAST_N,,Attachment,,,,,\r
5601,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon_05@Icon_Attachment_Equip_1,,T_30_U_ATTACHMENT_1,,Attachment,,,,,\r
5604,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon_05@Icon_Attachment_Equip_3,,T_30_U_ATTACHMENT_4,,Attachment,,,,,\r
5605,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon_05@Icon_Attachment_Equip_7,,T_30_U_ATTACHMENT_5,,Attachment,,,,,\r
5606,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon_05@Icon_Attachment_Equip_5,,T_30_U_ATTACHMENT_6,,Attachment,,,,,\r
5607,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon_05@Icon_Attachment_Equip_4,,T_32_U_ATTACHMENT_8,,Attachment,,,,,\r
3008,4,T_24_V_TRAINING_BOX_ATTACH,,UI_item_icon_04@Icon_Strengthen_Gunchip,,T_32_U_REPLACER,,Attachment,,,,,\r
1601,5,T_41_XXJ_WS_SPEEQUIP,,UI_item_icon_01@Icon_shoe_JetShoe,,T_12_Q_ITEM_FLYSHOE,,JetPack,,,,,\r
1602,5,T_41_XXJ_WS_SPEEQUIP,,UI_item_icon_01@Icon_shoe_DoubleJumpShoe,,T_12_Q_ITEM_DOUBLEJUMPSHOE,,DoubleJumpShoes,,,,,\r
2003,5,T_41_XXJ_WS_SPEEQUIP,,UI_item_icon_01@Icon_item_foldwings,,T_17_Q_FOLDWINGS,,FoldWing,,,,,\r
2501,5,T_41_XXJ_WS_SPEEQUIP,,UI_item_icon_02@Icon_weapon_Hoverboard,,T_19_B_HB_NAME,,Skateboard,,,,,\r
1201,6,T_32_LO_WS_LOOT_JATYPE,,UI_item_icon@Icon_item_GlooShield,,TXT_OB9_SQ_ITEM_GLOOSHIELD,,IceWall,,,,,\r
601,6,T_32_LO_WS_LOOT_JATYPE,,Icon_slot_Grenade,,TXT_ITEM_GRENADE,,Grenade,,,,,\r
602,6,T_32_LO_WS_LOOT_JATYPE,,UI_weapon_icon@Icon_slot_EW_Flash,,TXT_ITEM_FLASH,,GrenadeFlash,,,,,\r
603,6,T_32_LO_WS_LOOT_JATYPE,,UI_item_icon_01@Icon_weapon_Grenade_Smoke,,T_21_B_SMOKEGRENADE_NAME,,GrenadeSmoke,,,,,\r
608,6,T_32_LO_WS_LOOT_JATYPE,,Icon_slot_Ice_Grenade,,T_28_C_G_ICE_NAME,,GrenadeFrozen,,,,,\r
617,6,T_32_LO_WS_LOOT_JATYPE,,Icon_weapon_Grenade_Countericewall,,T_36_YF_CORRODE_GRENADE_N,,GrenadeDeIceWall,,,,,\r
1401,6,T_32_LO_WS_LOOT_JATYPE,,Icon_slot_Landmine,,TXT_OB11_HQW_LANDMINE,,Landmine,,,,,\r
1006,6,T_32_LO_WS_LOOT_JATYPE,,UI_item_icon_04@Icon_equipment_UAV_Controller,,T_26_ET_CELLPHONE_NAME,,,,,,,\r
2102,6,T_32_LO_WS_LOOT_JATYPE,,Icon_weapon_MiniSentryGun_Handle,,T_16_Q_MINISENTRY,,MiniSentry,,,,,\r
2401,6,T_32_LO_WS_LOOT_JATYPE,,UI_item_icon_02@Icon_weapon_DUMMY,,T_18_C_DUMMY_NAME,,,,,,,\r
102,7,T_41_XXJ_WS_ADDHP,,UI_item_icon@Icon_item_fak,,TXT_ITEM_FAK,,FirstAidKit,,,,,\r
213,7,T_41_XXJ_WS_ADDHP,,UI_item_icon_02@Icon_weapon_INHALER,,T_20_C_INHALER_NAME,,Inhaler,,,,,\r
1205,7,T_41_XXJ_WS_ADDHP,,UI_item_icon_05@Icon_item_Superfak,,T_35_YS_ITEM_SUPERFAK,,FirstAidKit,,,,,\r
108,8,T_41_XXJ_WS_SPEITEM,,UI_item_icon_03@Icon_item_Cardiac,,T_23_B_CARDIAC_NAME,,Pacemaker,,,,,\r
106,8,T_41_XXJ_WS_SPEITEM,,UI_item_icon_01@Icon_item_ArmorRepair,,TXT_OB16_Q_ITEM_ARMORREPAIR,,RepairArmorKit,,,,,\r
701,8,T_41_XXJ_WS_SPEITEM,,UI_item_icon_03@UI_item_Mushroom_01,,T_16_P_MANUAL_MUSHROOM1,,Mushroom,,,,,\r
702,8,T_41_XXJ_WS_SPEITEM,,UI_item_icon_03@UI_item_Mushroom_02,,T_16_P_MANUAL_MUSHROOM2,,Mushroom,,,,,\r
703,8,T_41_XXJ_WS_SPEITEM,,UI_item_icon_03@UI_item_Mushroom_03,,T_16_P_MANUAL_MUSHROOM3,,Mushroom,,,,,\r
707,8,T_41_XXJ_WS_SPEITEM,,UI_item_icon_03@UI_item_Mushroom_04,,T_16_P_MANUAL_MUSHROOM4,,Mushroom,,,,,\r
2801,8,T_41_XXJ_WS_SPEITEM,,UI_item_icon_03@Icon_item_Pliers,,T_22_Q_BOMB_PLIERS,,,,,,,\r
100,9,T_36_JH_WS_OPTIONNAME,,Icon_slot_FLAMETHROWER,,T_43_XYL_WS_DROIDFLAME,,Weapon,,FALSE,FALSE,,\r
151,9,T_36_JH_WS_OPTIONNAME,,Icon_slot_FIST,,T_43_XYL_WS_DROIDFIST,,Weapon,,FALSE,FALSE,,\r
152,9,T_36_JH_WS_OPTIONNAME,,Icon_slot_ThrowingKnife,,T_37_JH_WS_NAME1,,Weapon,,FALSE,FALSE,,\r
153,9,T_36_JH_WS_OPTIONNAME,,Icon_slot_GROZA,,T_37_JH_WS_NAME2,,Weapon,,FALSE,FALSE,,\r
154,9,T_36_JH_WS_OPTIONNAME,,Icon_slot_AK,,T_37_JH_WS_NAME3,,Weapon,,FALSE,FALSE,,\r
155,9,T_36_JH_WS_OPTIONNAME,,Icon_slot_M4A1,,T_37_JH_WS_NAME4,,Weapon,,FALSE,FALSE,,\r
156,9,T_36_JH_WS_OPTIONNAME,,Icon_slot_SCAR,,T_37_JH_WS_NAME5,,Weapon,,FALSE,FALSE,,\r
157,9,T_36_JH_WS_OPTIONNAME,,Icon_slot_M14,,T_37_JH_WS_NAME6,,Weapon,,FALSE,FALSE,,\r
158,9,T_36_JH_WS_OPTIONNAME,,Icon_slot_PARAFAL,,T_37_JH_WS_NAME7,,Weapon,,FALSE,FALSE,,\r
159,9,T_36_JH_WS_OPTIONNAME,,Icon_slot_Xm8,,T_37_JH_WS_NAME8,,Weapon,,FALSE,FALSE,,\r
160,9,T_36_JH_WS_OPTIONNAME,,Icon_slot_MAG7,,T_37_JH_WS_NAME9,,Weapon,,FALSE,FALSE,,\r
161,9,T_36_JH_WS_OPTIONNAME,,Icon_slot_M1887,,T_37_JH_WS_NAME10,,Weapon,,FALSE,FALSE,,\r
162,9,T_36_JH_WS_OPTIONNAME,,Icon_slot_SPAS12,,T_37_JH_WS_NAME11,,Weapon,,FALSE,FALSE,,\r
163,9,T_36_JH_WS_OPTIONNAME,,Icon_slot_M1014,,T_37_JH_WS_NAME12,,Weapon,,FALSE,FALSE,,\r
164,9,T_36_JH_WS_OPTIONNAME,,Icon_slot_MP40,,T_37_JH_WS_NAME13,,Weapon,,FALSE,FALSE,,\r
165,9,T_36_JH_WS_OPTIONNAME,,Icon_slot_MP5,,T_37_JH_WS_NAME14,,Weapon,,FALSE,FALSE,,\r
166,9,T_36_JH_WS_OPTIONNAME,,Icon_slot_P90,,T_37_JH_WS_NAME15,,Weapon,,FALSE,FALSE,,\r
167,9,T_36_JH_WS_OPTIONNAME,,Icon_slot_M60,,T_37_JH_WS_NAME16,,Weapon,,FALSE,FALSE,,\r
168,9,T_36_JH_WS_OPTIONNAME,,Icon_slot_Thompson,,T_37_JH_WS_NAME17,,Weapon,,FALSE,FALSE,,\r
169,9,T_36_JH_WS_OPTIONNAME,,Icon_slot_UMP,,T_37_JH_WS_NAME18,,Weapon,,FALSE,FALSE,,\r
170,9,T_36_JH_WS_OPTIONNAME,,Icon_slot_SVD,,T_37_JH_WS_NAME19,,Weapon,,FALSE,FALSE,,\r
172,9,T_36_JH_WS_OPTIONNAME,,Icon_slot_AWM,,T_37_JH_WS_NAME20,,Weapon,,FALSE,FALSE,,\r
173,9,T_36_JH_WS_OPTIONNAME,,Icon_slot_BM94,,T_37_JH_WS_NAME21,,Weapon,,FALSE,FALSE,,\r
174,9,T_36_JH_WS_OPTIONNAME,,Icon_slot_M249,,T_37_JH_WS_NAME22,,Weapon,,FALSE,FALSE,,\r
175,9,T_36_JH_WS_OPTIONNAME,,Icon_slot_Kar98k,,T_37_JH_WS_NAME23,,Weapon,,FALSE,FALSE,,\r
6402,10,T_37_XYL_SOCCER,,UI_item_icon@Icon_item_GlooShield,,TXT_OB9_SQ_ITEM_GLOOSHIELD,,,,,,,\r
6403,10,T_37_XYL_SOCCER,,Icon_slot_Ice_Grenade,,T_28_C_G_ICE_NAME,,,,,,,\r
1299,8,T_41_XXJ_WS_SPEITEM,,UI_item_icon_06@UI_icewallmaker_01,,T_38_RW_NIW_NIWNAME,1,IceWallMaker,,FALSE,FALSE,,\r
610,8,T_41_XXJ_WS_SPEITEM,,FF_ingame_hud_training@Icon_slot_Snowball,,T_30_AD_TRAINING_SNOWBALL,,GrenadeSnowball,,,,,\r
2502,8,T_41_XXJ_WS_SPEITEM,,UI_item_icon_06@Icon_PropCatapult,,T_37_RW_PROPCATAPULT_NAME,,HandCatapult,,,,,\r
5611,8,T_41_XXJ_WS_SPEITEM,,FF_UI_Skill_Icon_04@ui_icon_skill_monkeygod_L,,T_12_R_SKILL_NAME_MONKEYGOD,1,,,FALSE,,TRUE,\r
5612,8,T_41_XXJ_WS_SPEITEM,,FF_UI_Skill_Icon_04@ui_icon_skill_MadeManA_L,,T_33_C_SKILL_NAME_MADEMANA,1,,,FALSE,,TRUE,\r
5613,8,T_41_XXJ_WS_SPEITEM,,FF_UI_Skill_Icon_04@ui_icon_skill_Djmale_L,,T_18_C_SKILL_NAME_DJMALE,1,,,FALSE,,TRUE,\r
5614,8,T_41_XXJ_WS_SPEITEM,,FF_UI_Skill_Icon_04@ui_icon_skill_Graffitist_L,,T_20_C_SKILL_NAME_GRAFFITIST,1,,,FALSE,,TRUE,\r
5615,8,T_41_XXJ_WS_SPEITEM,,FF_UI_Skill_Icon_04@ui_icon_skill_Detective_L,,T_22_C_SKILL_NAME_DETECTIVE,1,,,FALSE,,TRUE,\r
5616,8,T_41_XXJ_WS_SPEITEM,,FF_UI_Skill_Icon_04@ui_icon_skill_Professor_L,,T_24_C_SKILL_NAME_PROFESSOR,1,,,FALSE,,TRUE,\r
5617,8,T_41_XXJ_WS_SPEITEM,,FF_UI_Skill_Icon_04@ui_icon_skill_BountyHunter_L,,T_25_C_SKILL_NAME_BOUNTYHUNTER,1,,,FALSE,,TRUE,\r
5618,8,T_41_XXJ_WS_SPEITEM,,FF_UI_Skill_Icon_04@ui_icon_skill_Superstar_L,,T_26_C_SKILL_NAME_SUPERSTAR,1,,,FALSE,,TRUE,\r
5619,8,T_41_XXJ_WS_SPEITEM,,FF_UI_Skill_Icon_04@ui_icon_skill_Xtreme_L,,T_27_C_SKILL_NAME_XTREME,1,,,FALSE,,TRUE,\r
5620,8,T_41_XXJ_WS_SPEITEM,,FF_UI_Skill_Icon_04@ui_icon_skill_MusicBro_White_L,,T_29_C_SKILL_NAME_MUSICBRO_WHITE,1,,,FALSE,,TRUE,\r
5621,8,T_41_XXJ_WS_SPEITEM,,FF_UI_Skill_Icon_04@ui_icon_skill_Kenta_L,,T_33_C_SKILL_NAME_KENTA,1,,,FALSE,,TRUE,\r
5622,8,T_41_XXJ_WS_SPEITEM,,FF_UI_Skill_Icon_04@ui_icon_skill_TRACKER_L,,T_34_C_SKILL_NAME_TRACKER,1,,,FALSE,,TRUE,\r
5623,8,T_41_XXJ_WS_SPEITEM,,FF_UI_Skill_Icon_04@ui_icon_skill_Crazygirl_L,,T_35_JL_SKILL_NAME_CRAZYGIRL,1,,,FALSE,,TRUE,\r
5624,8,T_41_XXJ_WS_SPEITEM,,FF_UI_Skill_Icon_04@ui_icon_skill_RunSpeedUp_L,,T_32_C_SKILL_NAME_YAKUZA,1,,,FALSE,,TRUE,\r
5625,8,T_41_XXJ_WS_SPEITEM,,FF_UI_Skill_Icon_04@ui_icon_skill_Santino_L,,T_38_BQ_SKILL_NAME_DUMMY1,1,,,FALSE,,TRUE,\r
5626,8,T_41_XXJ_WS_SPEITEM,,FF_UI_Skill_Icon_04@ui_icon_skill_Villain_L,,T_39_BQ_SKILL_NAME_VILLAIN,1,,,FALSE,,TRUE,\r
91037,8,T_41_XXJ_WS_SPEITEM,,ui_icon_skill_monkeygod_L,,T_12_R_SKILL_NAME_MONKEYGOD,,,,,,,\r
91038,8,T_41_XXJ_WS_SPEITEM,,ui_icon_skill_MadeManA_L,,T_33_C_SKILL_NAME_MADEMANA,,,,,,,\r
91039,8,T_41_XXJ_WS_SPEITEM,,ui_icon_skill_Djmale_L,,T_18_C_SKILL_NAME_DJMALE,,,,,,,\r
91040,8,T_41_XXJ_WS_SPEITEM,,ui_icon_skill_Graffitist_L,,T_20_C_SKILL_NAME_GRAFFITIST,,,,,,,\r
91041,8,T_41_XXJ_WS_SPEITEM,,ui_icon_skill_Detective_L,,T_22_C_SKILL_NAME_DETECTIVE,,,,,,,\r
91042,8,T_41_XXJ_WS_SPEITEM,,ui_icon_skill_Professor_L,,T_24_C_SKILL_NAME_PROFESSOR,,,,,,,\r
91043,8,T_41_XXJ_WS_SPEITEM,,ui_icon_skill_BountyHunter_L,,T_25_C_SKILL_NAME_BOUNTYHUNTER,,,,,,,\r
91044,8,T_41_XXJ_WS_SPEITEM,,ui_icon_skill_Superstar_L,,T_26_C_SKILL_NAME_SUPERSTAR,,,,,,,\r
91045,8,T_41_XXJ_WS_SPEITEM,,ui_icon_skill_Xtreme_L,,T_27_C_SKILL_NAME_XTREME,,,,,,,\r
91046,8,T_41_XXJ_WS_SPEITEM,,ui_icon_skill_MusicBro_White_L,,T_29_C_SKILL_NAME_MUSICBRO_WHITE,,,,,,,\r
91047,8,T_41_XXJ_WS_SPEITEM,,ui_icon_skill_Kenta_L,,T_33_C_SKILL_NAME_KENTA,,,,,,,\r
91048,8,T_41_XXJ_WS_SPEITEM,,ui_icon_skill_TRACKER_L,,T_34_C_SKILL_NAME_TRACKER,,,,,,,\r
91049,8,T_41_XXJ_WS_SPEITEM,,ui_icon_skill_Crazygirl_L,,T_35_JL_SKILL_NAME_CRAZYGIRL,,,,,,,\r
91050,8,T_41_XXJ_WS_SPEITEM,,ui_icon_skill_RunSpeedUp_L,,T_32_C_SKILL_NAME_YAKUZA,,,,,,,\r
91051,8,T_41_XXJ_WS_SPEITEM,,ui_icon_skill_Santino_L,,T_38_BQ_SKILL_NAME_DUMMY1,,,,,,,\r
91052,8,T_41_XXJ_WS_SPEITEM,,ui_icon_skill_Villain_L,,T_39_BQ_SKILL_NAME_VILLAIN,,,,,,,\r
91053,8,T_41_XXJ_WS_SPEITEM,,ui_icon_skill_FireBoy_L,,T_41_WT_SKILL_NAME_FIREBOY,,,,,,,\r
91054,8,T_41_XXJ_WS_SPEITEM,,ui_icon_skill_Spider_L,,T_42_B_SKILL_NAME_GEEK,,,,,,,\r
91057,8,T_41_XXJ_WS_SPEITEM,,ui_icon_skill_AuroraBoy_L,,T_47_B_SKILL_NAME_AURORABOY,,,,,,,\r
91060,8,T_41_XXJ_WS_SPEITEM,,ui_icon_skill_Electricgirl_L,,T_44_B_SKILL_NAME_ELECTRICGIRL,,,,,,,\r
91063,8,T_41_XXJ_WS_SPEITEM,,ui_icon_skill_CityHeroBoy_L,,T_48_WT_SKILL_NAME_CITYHEROBOY,,,,,,,\r
620,8,T_41_XXJ_WS_SPEITEM,,UI_weapon_icon@Icon_slot_Grenade,,TXT_ITEM_GRENADE,1,,,FALSE,FALSE,,\r
1402,8,T_41_XXJ_WS_SPEITEM,,UI_weapon_icon@Icon_slot_Landmine,,TXT_OB11_HQW_LANDMINE,1,,,FALSE,FALSE,,\r
2103,8,T_41_XXJ_WS_SPEITEM,,UI_weapon_icon@Icon_slot_MiniSentryGun_Handle,,T_16_Q_MINISENTRY,1,,,FALSE,FALSE,,\r
2010,8,T_41_XXJ_WS_SPEITEM,,UI_weapon_icon@Icon_equipment_CombineMachine,,T_31_RW_COMBINEMACHINE_2,1,,,FALSE,FALSE,,\r
92103,8,T_41_XXJ_WS_SPEITEM,,Icon_Item_HealUAV,,T_42_WH_ITEM_HEALUAV,,,,,,,\r
1001,8,T_41_XXJ_WS_SPEITEM,,Icon_equipment_Bonfire,,TXT_OB8_HQW_NEWLOADOUT_BONFIRE,,,,,,,\r
91017,8,T_41_XXJ_WS_SPEITEM,,ui_icon_skill_FireBoy,,T_42_WH_ITEM_SKILLCARD,1,,,FALSE,,TRUE,\r
91055,8,T_41_XXJ_WS_SPEITEM,,ui_icon_skill_AuroraBoy_L,,T_42_WH_ITEM_SKILLCARD,1,,,FALSE,,TRUE,\r
624,8,T_32_LO_WS_LOOT_JATYPE,,Icon_slot_Electric_grenade,,T_44_QL_GRENADE_DRAGON,,,,,,,\r
622,8,T_32_LO_WS_LOOT_JATYPE,,Icon_item_JumpBoard,,T_37_QL_JUMPPAD_NAME,,,,,,,\r
1015,8,T_41_XXJ_WS_SPEITEM,,Icon_Item_SupplyBox,,T_43_WH_ITEM_SUPPLYBOX_NAME,,,,,,,\r
93003,8,T_41_XXJ_WS_SPEITEM,,Icon_weapon_MiniSentryGun_New,,T_16_Q_MINISENTRY,,,,,,,\r
1605,8,T_41_XXJ_WS_SPEITEM,,Icon_shoe_JetShoe,,T_44_QL_JUMPSHOESX,,,,,,,\r
92200,8,T_41_XXJ_WS_SPEITEM,,Icon_item_Vehicledrop,,T_45_ZD_VEHICLEDROP_R_NAME,,,,,,,\r
91200,8,T_41_XXJ_WS_SPEITEM,,Icon_item_PortalsforPersonal,,T_42_RW_PORTALSPERSONAL_NAME,,,,,,,\r
`, UN = `Id,HudType,HudTypeKey,Sort,ResourceId,HudCDN,HudName,HudKey,CraftlandShowControl,FEShowControl,IsObsolote,ResourceLevel\r
序号,类型,类型名称Key,排序,资源Id（typemap类型名）,展示的HUDCDN图,注释 代码不读,名称key,"Craftland显示控制\r
TRUE或不填为显示，FALSE为不显示","FE显示控制\r
TRUE或不填为显示，FALSE为不显示",是否废弃,"资源权限等级\r
public（或不填）：公开资源\r
internal：仅白名单可用资源"\r
1,1,FE_42A_HJ_HUD_TYPE,1,CountdownHud,OB42/CSH/UGC/HUD/CountdownHud.png,倒计时HUD,T_34_M_WS_TIME,FALSE,,,\r
2,1,FE_42A_HJ_HUD_TYPE,2,OpeningBannerHud,OB42/CSH/UGC/HUD/OpeningBannerHud.png,开局横幅,T_34_M_WS_STARTBANNER,FALSE,,,\r
3,1,FE_42A_HJ_HUD_TYPE,3,TwoTeamRoundStartBannerHud,OB42/CSH/UGC/HUD/TwoTeamRoundStartBannerHud.png,对抗横幅,T_34_M_WS_CONFRONBANNER,FALSE,,,\r
4,1,FE_42A_HJ_HUD_TYPE,4,NormalRoundStartBannerHud,OB42/CSH/UGC/HUD/NormalRoundStartBannerHud.png,回合横幅,T_34_M_WS_ROUNDBANNER,FALSE,,,\r
5,1,FE_42A_HJ_HUD_TYPE,5,TeamRoundScoreBannerHud,OB42/CSH/UGC/HUD/TeamRoundScoreBannerHud.png,队伍回合得分横幅,T_42_XXJ_WS_TEAMROUNDSCOREBANNERHUD,FALSE,,,\r
6,1,FE_42A_HJ_HUD_TYPE,6,CheckPointMgrHud,OB42/CSH/UGC/HUD/CheckPointMgrHud.png,检查点HUD,T_34_WT_WS_CHECKPOINTENTITY_PARAM1,FALSE,,,\r
7,1,FE_42A_HJ_HUD_TYPE,7,RoundResultShowTimeHud,OB42/CSH/UGC/HUD/RoundResultShowTimeHud.png,RoundResultShowTimeHud,FE_42A_HJ_HUD_ROUNDRESULT,FALSE,,,\r
8,1,FE_42A_HJ_HUD_TYPE,8,TwoTeamFactionHud,OB42/CSH/UGC/HUD/TwoTeamFactionHud.png,TwoTeamFactionHud,FE_42A_HJ_HUD_TWOTEAMSTART,FALSE,,,\r
9,1,FE_42A_HJ_HUD_TYPE,9,TwoTeamRoundScoreBannerHud,OB42/CSH/UGC/HUD/TwoTeamRoundScoreBannerHud.png,TwoTeamRoundScoreBannerHud,FE_42A_HJ_HUD_TWOTEAMSCORE,FALSE,,,\r
10,1,FE_42A_HJ_HUD_TYPE,10,ResultBannerHud,OB42/CSH/UGC/HUD/ResultBannerHud.png,游戏结果,T_34_M_WS_GAMERESULTS,FALSE,,,\r
11,1,FE_42A_HJ_HUD_TYPE,11,RoundNumHud,OB42/CSH/UGC/HUD/RoundNumHud.png,回合数,T_34_M_WS_ROUNDHUD,FALSE,,,\r
12,1,FE_42A_HJ_HUD_TYPE,12,PhaseCountDownHud,OB42/CSH/UGC/HUD/PhaseCountDownHud.png,PhaseCountDownHud,FE_42A_HJ_HUD_COUNTDOWN,FALSE,,,\r
13,1,FE_42A_HJ_HUD_TYPE,13,MatchInfoSubTitleHud,OB42/CSH/UGC/HUD/MatchInfoSubTitleHud.png,MatchInfoSubTitleHud,FE_42A_HJ_HUD_MATCHINFO,FALSE,,,\r
14,1,FE_42A_HJ_HUD_TYPE,14,TwoTeamMatchInfoHud,OB42/CSH/UGC/HUD/TwoTeamMatchInfo.png,TwoTeamMatchInfoHud,FE_42A_HJ_HUD_TWOTEAMMATCHINFO,FALSE,,,\r
15,1,FE_42A_HJ_HUD_TYPE,15,TwoTeamLeaderboardHud,OB42/CSH/UGC/HUD/TwoTeamLeaderboardHud.png,两队比赛详情,T_42_XXJ_WS_TWOTEAMLEADERBOARDHUD,FALSE,,TRUE,\r
16,1,FE_42A_HJ_HUD_TYPE,16,MoreTeamLeaderboardHud,OB42/CSH/UGC/HUD/MoreTeamLeaderboardHud.png,混战计分,T_34_M_WS_SCUFFLESCORING,FALSE,,TRUE,\r
17,1,FE_42A_HJ_HUD_TYPE,17,FactionInfoHud,OB42/CSH/UGC/HUD/FactionInfoHud.png,FactionInfoHud,FE_42A_HJ_HUD_FACTIONINFO,FALSE,,TRUE,\r
18,1,FE_42A_HJ_HUD_TYPE,18,TwoTeamMatchInfoSimpleHud,OB42/CSH/UGC/HUD/TwoTeamMatchInfoSimple.png,TwoTeamMatchInfoSimpleHud,FE_42A_HJ_HUD_MATCHINFOSIMPLE,FALSE,,,\r
19,1,FE_42A_HJ_HUD_TYPE,19,CountdownReminderHud,OB42/CSH/UGC/HUD/CountdownReminderHud.png,CountdownReminderHud,FE_42A_HJ_HUD_COUNTDOWNREMIND,FALSE,,,\r
20,1,FE_42A_HJ_HUD_TYPE,20,TweenTipsHud,OB42/CSH/UGC/HUD/TweenTipsHud.png,飘字提示实体,T_36_WZY_WS_TWEENTIPS,FALSE,,,\r
21,1,FE_42A_HJ_HUD_TYPE,21,RoundTransitionHud,OB42/CSH/UGC/HUD/RoundTransitionHud.png,RoundTransitionHud,FE_42A_HJ_HUD_ROUNDTRANSITION,FALSE,,,\r
22,1,FE_42A_HJ_HUD_TYPE,22,SingleLeaderboardHud,OB42/CSH/UGC/HUD/SingleLeaderboardHud.png,单人比赛详情HUD实体组件,T_40_XXJ_WS_SINGLELEADERBOARDHUD,FALSE,,TRUE,\r
23,1,FE_42A_HJ_HUD_TYPE,23,LeaderboardButtonHud,OB42/CSH/UGC/HUD/LeaderboardButtonHud.png,打开计分板按钮,T_40_XXJ_WS_LEADERBOARDBUTTONHUD,FALSE,,,\r
24,1,FE_42A_HJ_HUD_TYPE,24,TimeTweenTipsHud,OB42/CSH/UGC/HUD/TimeTweenTipsHud.png,倒计时飘字提示实体,T_36_WZY_WS_TIMETWEENTIPS,FALSE,,,\r
25,1,FE_42A_HJ_HUD_TYPE,25,FiveSecondCountDownHud,OB42/CSH/UGC/HUD/FiveSecondCountDown.png,FiveSecondCountDownHud,FE_42A_HJ_HUD_FIVECOUNTDOWN,FALSE,,,\r
26,1,FE_42A_HJ_HUD_TYPE,26,TitleBannerHud,OB42/CSH/UGC/HUD/TitleBannerHud.png,TitleBannerHud,FE_42A_HJ_HUD_TITLEBANNER,FALSE,,,\r
27,1,FE_42A_HJ_HUD_TYPE,27,CommonHudSwitchHud,OB42/CSH/UGC/HUD/CommonHudSwitchHud.png,CommonHudSwitchHud,FE_42A_HJ_HUD_COMMONHUDSWITCH,FALSE,,,\r
28,1,FE_42A_HJ_HUD_TYPE,28,HPbarHud,OB42/CSH/UGC/HUD/HPbarHud.png,血条实体,T_37_WZY_WS_BLOODBARENT,FALSE,,,\r
29,1,FE_42A_HJ_HUD_TYPE,29,HeartbeatEffectHud,OB42/CSH/UGC/HUD/HeartbeatEffectHud.png,屏幕心跳特效,T_40_XXJ_WS_HEARTBEATEFFECTHUD_NAMEKEY,FALSE,,,\r
30,1,FE_42A_HJ_HUD_TYPE,30,UGCShopHud,OB42/CSH/UGC/HUD/UGCShopHud.png,商店界面,T_36_JH_WS_CSHOPHUD,FALSE,,,\r
31,1,FE_42A_HJ_HUD_TYPE,31,WalletHud,OB42/CSH/UGC/HUD/WalletHud.png,钱包,T_36_WZY_WS_ADDCURR_PARAM1_NAME,FALSE,,,\r
32,1,FE_42A_HJ_HUD_TYPE,32,TextTipsHud,OB42/CSH/UGC/HUD/TextTipsHud.png,文本HUD组件,T_38_WZY_WS_TEXTHUD,FALSE,,,\r
33,1,FE_42A_HJ_HUD_TYPE,33,TwoTeamMatchResultHud,OB42/CSH/UGC/HUD/TwoTeamMatchResultHud.png,两队结算界面,T_39_XXJ_WS_TWOTEAMRESULTHUD,FALSE,,,\r
34,1,FE_42A_HJ_HUD_TYPE,34,MultiTeamMatchResultHud,OB42/CSH/UGC/HUD/MultiTeamMatchResultHud.png,多队结算界面,T_39_XXJ_WS_MULTITEAMRESULTHUD,FALSE,,,\r
35,1,FE_42A_HJ_HUD_TYPE,35,ProgressCircleHud,OB42/CSH/UGC/HUD/ProgressCircleHud.png,准备等待进度圈,T_39_WZY_WS_PROCIRCLE_NAME,FALSE,,,\r
36,1,FE_42A_HJ_HUD_TYPE,36,ScoreBarHud,OB42/CSH/UGC/HUD/ScoreBarHud.png,比分条,T_40_XXJ_WS_SCOREBARHUD_NAMEKEY,FALSE,,,\r
37,1,FE_42A_HJ_HUD_TYPE,37,SprayResultHud,OB42/CSH/UGC/HUD/SprayResultHud.png,喷漆结算,T_40_XXJ_WS_SPRAYRESULTHUD_NAMEKEY,FALSE,,,\r
38,1,FE_42A_HJ_HUD_TYPE,38,HintButtonHud,OB42/CSH/UGC/HUD/HintButtonHud.png,提示按钮,T_40_XXJ_WS_HINTBUTTONHUD_NAMEKEY,FALSE,,,\r
39,1,FE_42A_HJ_HUD_TYPE,39,TipHud,OB42/CSH/UGC/HUD/TipHud.png,提示,T_40_XXJ_WS_TIPHUD_NAMEKEY,FALSE,,,\r
40,1,FE_42A_HJ_HUD_TYPE,40,ProgressSkillButtonHud,OB42/CSH/UGC/HUD/ProgressSkillButtonHud.png,进度技能按钮,T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_NAMEKEY,FALSE,,,\r
41,1,FE_42A_HJ_HUD_TYPE,41,CameraRayCastHud,OB42/CSH/UGC/HUD/CameraRayCastHud.png,相机射线检测,T_40_XXJ_WS_CAMERARAYCASTHUD_NAMEKEY,FALSE,,,\r
42,1,FE_42A_HJ_HUD_TYPE,42,PlayerHeadHud,OB43/CSH/UGC/UIUGCHudHead.png,UIUGCHudHead,T_43_XXJ_WS_PLAYERHEADHUD,FALSE,,,\r
43,1,FE_42A_HJ_HUD_TYPE,43,DirectionRulerHud,OB43/CSH/UGC/DirectionRulerHud.png,UIHUDUGC_DirectionRuler,T_43_YU_WS_DIRECTIONRULERHUD,FALSE,,,\r
44,1,FE_42A_HJ_HUD_TYPE,44,CSRoundResultHud,OB43/CSH/UGC/UIHUDUGC_CSRoundResult.png,UIHUDUGC_CSRoundResult,T_43_YU_WS_CSROUNDRESULTHUD,FALSE,,,\r
45,1,FE_42A_HJ_HUD_TYPE,45,RoundInfoHud,OB43/CSH/UGC/UIHUDUGC_CSRoundInfo.png,UIHUDUGC_CSRoundInfo,T_43_YU_WS_ROUNDINFOHUD,FALSE,,,\r
46,1,FE_42A_HJ_HUD_TYPE,46,LLMChatHud,OB47/CSH/LLMChatHub/LLMChatHud.png,LLM聊天界面,T_47_XXJ_WS_LLMCHATHUD,FALSE,,,internal\r
47,1,FE_42A_HJ_HUD_TYPE,47,TwoTeamLeaderboardHudV2,OB42/CSH/UGC/HUD/TwoTeamLeaderboardHud.png,两队比赛详情,T_42_XXJ_WS_TWOTEAMLEADERBOARDHUD,FALSE,,,\r
48,1,FE_42A_HJ_HUD_TYPE,48,MoreTeamLeaderboardHudV2,OB42/CSH/UGC/HUD/MoreTeamLeaderboardHud.png,混战计分,T_34_M_WS_SCUFFLESCORING,FALSE,,,\r
49,1,FE_42A_HJ_HUD_TYPE,49,TwoTeamMatchInfoSimpleHudV2,OB42/CSH/UGC/HUD/TwoTeamMatchInfoSimple.png,TwoTeamMatchInfoSimpleHud,FE_42A_HJ_HUD_MATCHINFOSIMPLE,FALSE,,,\r
50,1,FE_42A_HJ_HUD_TYPE,50,TeamMatchInfoHud,OB42/CSH/UGC/HUD/TwoTeamMatchInfoSimple.png,单队比赛详情,T_46_META_WS_C_UITEAMMATCHINFO,FALSE,,,\r
`, VN = {
  1: "4ab9d13a-4ae8-4ea0-b46d-de26625b9e46",
  2: "6a745486d3d720c88f2a65a290427ad6",
  3: "3229cbcc6fe2d4aa22838e0659c7cf1e",
  4: "306b1fc5c17d65b50fea18a6d7af1ef7",
  5: "fffff2080fb3c3572e8889b0feb4fd13",
  6: "9cb4b297a2dc2e25384c2df19681304d",
  7: "70be3001851a98928e5da689929502ee",
  8: "d88ea9fab061296d55b79a0b518bb799",
  9: "4c0740c7b70965efd0d49a8222115bac",
  10: "d52016bc8072f982d6a6144015695aa9",
  11: "646cbb55e2475dfba2dfe57ebc9f52f1",
  12: "d9de1f1d6f42ad38141f4bf88ee5980d",
  13: "9eea43eeaba828a0f543cb07397d83b8",
  14: "e35ffb24f7f7c4b5db8628b641a27dc5",
  15: "704e20e0e58a882e20f053070dbb3e1d",
  16: "9875f069576a0051ef9922a6391da7a6",
  17: "ef84c247339f515cb913ed0d4fde24ea",
  18: "2fa2d3aeff8b07ddbcf8c66e722b3911",
  19: "d7b61db9ae596a07c09244f98d1f87d1",
  20: "761baefc5c289cc6e96afe450973c89a",
  21: "e5b521d9f2816003227fcf8941c1e49d",
  22: "750c5aa13ecf37388c808a4e9d2b4610",
  23: "d67c25aeaccd17bd361bc55b561e218f",
  24: "3d073546fd3b532be374501d62c12700",
  25: "3e402bd39402b9916233317b9909b059",
  26: "3b4c857d7276e3db27236f5080c4d2a4",
  27: "ffb777bceb363c3ed0265b9c09db715b",
  28: "6f5de8bb6efa2adb36531668f7e3965d",
  29: "dd358c49561651d827da755611d5fa74",
  30: "63ff6d2f8d2f25bbb6f1da15dca72cde",
  31: "ec2177fa5afd9211401e73c15fc685d8",
  32: "178cba65840fc196221cc99a526e39a4",
  33: "555019d04bf0cff434ff8660cfd41528",
  34: "31c39178634c59e11e42f7cc66683e70",
  35: "d6b924c773e264d38026f4c9a6368c1c",
  36: "0f4808e83c4a75887648dfbbc2d27c7f",
  37: "8ecd8a26d5b142e1b7850ca48835e4f3",
  38: "5c65a6b1287e1186d3bde416c22c0639",
  39: "868423f8476cf274a0a81cfaf99ca5b4",
  40: "6374ae9ca24f01b9e48ccde377243701",
  41: "ffc3f4b513fbe51ef58d175d5539a0e9",
  42: "3ad760c0d08c5d0f16d536404e2b7b16",
  43: "f4fbd0e3de4ca6d017bf69fd1fa9213f",
  44: "2d1488302dc3c952cb35aadd5ab0e3d3",
  45: "258391b94447d33b20cf3c8a771ca9b0",
  46: "f04914ac1c81bde3a2cc013ac5ba03c8",
  47: "128269b18e2df0b480d46aefaf96fb0c",
  48: "3c05875974f836b6897d21aa766bb2bf",
  49: "e82e0b0fec27763cc10de2d8e79cba0f",
  50: "934c8b09beb246d838e2890ff26f0ec5",
  51: "d262541087d4b7eb968e4328fd512531",
  52: "077cea470825451443c99b12507a19ec",
  53: "5563f4c27c9df1b531e2559e1d783eed",
  54: "ed00149e2525fec225b50b21c3798aac",
  55: "a18e46d9770d3d7638e06ce305f24307",
  56: "2cf580af57e381237069fd19f59e5c8a",
  57: "7d66b3b977082458cbf2269ce4ce6fc7",
  58: "07a416d03a0c9057c66ece454db769f5",
  60: "2516b5e94cb1c3955407fa1bf0c6213c",
  61: "1e9fb708e0c060d92ad8bb875c78ea67",
  62: "784ae4fa7a4844e3732e2cbe1e7886f2",
  63: "7568282f2e55e67a356e62728b4503c6",
  64: "d359426d30995d57872cb9a61698ec39",
  65: "02475282e9932326ed165668ce0dd7c9",
  66: "317348184b9a3419192b5371cbf6d968",
  67: "4e2b069dd95ce31d378df6aec5228e39",
  68: "4188c3362ec8ef62aadcdaa71c71f1f9",
  69: "1123b940f4a7e21ec9a40af57714f7d3",
  70: "40e09243ca39167877ac302d27d2a3cc",
  71: "75ba623d22de4c038eba4d7d50baf0fb",
  72: "583fa6be162564f22de08aaa469dcc2a",
  73: "47a49dc54f254b817a378186eb49b078",
  74: "6e0fb07e1c3908dd88432186b4223396",
  75: "fa2d635b1420e772d5314e4fac35f45d",
  76: "57b93d6e4435925bea6d40c7d23d1d0a",
  77: "7baec54de92bb3af49048e405cd91441",
  78: "ff994cfcb0c0eceac6d940bab790593b",
  79: "dcd782c5a2db3114ff49d38a78179b74",
  80: "1a1e0d6642eec2af8ad357ac41da11a8",
  81: "f0d3c935a315930a750f9d3042f5aaf2",
  82: "6bffee8aa3c11c0815990849a9680c40",
  83: "11e233b6ea3678797c787e5dbe449405",
  84: "52f90023e96554729a06a59de887faa2",
  85: "9354a1f8a30dea815e52a62ff940ce8b",
  86: "538edeb38894f3a7ca7089d5cbbc8fbc",
  87: "4f3a5f0e8798c52947a542858a8f3bbb",
  88: "531b87244ddb80ae183047669ea5abbb",
  89: "a117c987ff5eb5814910a96f4de76623",
  90: "333de049dbbcde2ba849adbe6ea71a44",
  91: "397af8b93c174fbf925bc4a7cc745789",
  92: "ec9318f162c725020c920cc8ddf2131a",
  93: "a419e3880446b4bf80f3d1af6615b3f6",
  94: "2e890602f5bb556148d9aec91e7c0e02",
  95: "6ea9d192f570e3be9066cbdbacc5744c",
  96: "79e2fe198f822a380e85984ae35ce26f",
  97: "8ca53853ed2b7c9dcc3eda4857294538",
  98: "a653d14318b9517a87624002c6f17382",
  99: "050127d2f2e6d4c20aac56456d44ff04",
  100: "7be2b8b0763c5302964a76402a95d9a0",
  101: "384b580398e544584439ca569ecd40d5",
  102: "b26d4b6d0017c23f98958fbb274918bd",
  103: "e97a23a2-3f7e-4632-be24-778e916ed008",
  104: "e2f097fab72c8f74c7742edbcd702973",
  105: "ff482448dc5e9b49d4f0ca0eaf8df057",
  106: "73781e2c917b6f0b26cd6db29e421018",
  107: "3066638485d65e5cd69c79bea049dea7",
  108: "d38a1b0452be91e8383a62c1f6ad0639",
  109: "29d92ee7a00f1efc5e577e68055bd0d0",
  110: "4a0ae6470ec9c5c0fc317d3163b83d27",
  111: "68777eecd9366eef906ae22d9c542502",
  119: "3098135fb9db87308e016db46557b97d",
  120: "1716952753fe8a092b07318e1ac8a94a",
  121: "5cec5ad4e5195a9ef60d9a79c7821cf8",
  122: "22e6f9c9c18e80525d997f70556e973f",
  123: "263b452a64563ea62ac3ef515b919291",
  124: "7a3bcf6e1bbe31934c4f9367532ec360",
  125: "6b34235ee3fdc127cd4b7b9932bef74c",
  126: "03587343e75c986c8fc6a09c44845c36",
  127: "b1daf1a87175bfe82e5ef97d54295c12",
  128: "307327dee7a41832492a5a5324f06fbf",
  129: "881cd2d119127732f59b536fe3746847",
  130: "83c59d9a58f885e07ae33a07e542ca39",
  131: "0ba13b1b42fcc1a588adff3ab6596a6e",
  132: "3806f08b04112feae7e3ee6e252dce80",
  133: "f9b4ee4e3c0b45732fe23206af7c9fc1",
  134: "323aebf0a1f910e2ee686b0811615989",
  135: "5e354f8eaae60e216b448ad21ad31c79",
  136: "67ef52f36622395759118b8404c9063e",
  137: "2918b9a40474ae149695d31d7d08453b",
  138: "a0df0601625169cae36aa8d14952421d",
  139: "ba93bd53862127e265265c17da5215a7",
  140: "dec8cfa2a9079c052ab1e510e901e05d",
  141: "692dc4f275f3dae23e109ea58127bf3e",
  142: "950acb7354b21fba84a243bd4d9a319b",
  143: "ce16e4f0d893fa1f907c6c462ce9dd7c",
  144: "2c95b681cd4056f4c59c36e5fa38484f",
  145: "5f42aa28a075ca685f01372606eb973b",
  146: "ce5fa5f43b3bdcf95825ece216c497f2",
  148: "7404e230389e78f4f1a1c89d9034f342",
  149: "8425bceb38807d97e6e921558183f802",
  150: "d1fd887a-899e-4da9-b865-d53d56d6d0e5",
  151: "2859dac5c8de714faea2c16fae973cb9",
  152: "62c9f834bb012cc407df02e3214b3491",
  153: "4610e658cfcb17690410e2781ebe9b46",
  154: "e1899b6cc4f502c5f056d6d09b3ad4bb",
  155: "a13b79c29cad31e700249ccba77a4252",
  156: "a1476c90855c436065e76e111d6dfd8a",
  157: "5e790d2440aab1e586cc821bef8de491",
  158: "01d2467b1b6cbf4de27e7563973ac222",
  159: "9abfd2957ce9511a0353b3db4139af08",
  160: "600ff667db23e84e41ac4021acf8aeb0",
  161: "4da838768f26655591c02fde492bd25a",
  162: "7a9d26ddd3b82e6451dad243de0c3ef6",
  163: "4536930b7311df2dd7e08bb70c880689",
  164: "3edef0610b30699f2a36bdf69b703e51",
  165: "13c8f7106222ada069d1630abfd60aa5",
  166: "2ad73336b8732e4d3f88e0038f374c56",
  167: "d991de9db33107b3546f6c58682ab940",
  168: "a265e47b3598606961b96939ec2b8c6f",
  169: "09fc3f195ad4b8ffa3deade85e50ebc1",
  170: "d93bb7d86a20c828b157f546491d95a5",
  171: "38137c7c139d94dc996a67e173f7172e",
  172: "95b6fd9225b073c6f202a253731b4652",
  173: "4af57501ffb0593ebeafcdd0a6f517fb",
  174: "9c9f21f1fe2adf52f0228e79644e1904",
  175: "7073892f4abe691ce91426f416619184",
  176: "20cede81e669a579e4be395f43879800",
  177: "a485e30df75fbe62cd3b939ad040ec5e",
  178: "7c77207a6a9b804de1c9677ec66c2769",
  179: "1cf094a500c28b351d59d1f727b11c1a",
  180: "e74e0ef33e391734a8ff7ca46894e444",
  181: "8a660d648c0bbf14953b2546874b72c8",
  182: "d7e25d48e88347ff3d73ce6844d81438",
  183: "785a1bbd170f92e38cf35bc168a014bd",
  184: "c74f8c94191df801234261c5739422ed",
  185: "9bcdb101ab880e0bd2c95257917d35fa",
  186: "b37ebe60d443c8081a59af7d33611b79",
  187: "d525fef7449f4ca70b5eda3cd60a0b73",
  188: "1009cf0c4e55f34785728dc87a1c0f61",
  189: "33790da3d5e8d097d279256aa70a1a70",
  190: "6911caeaf62293e4bdf88da51edffcb4",
  191: "b7504bd07830ed5a842510156b9d0ec6",
  192: "7acfbaac3eeade18506b3d27692e2a2c",
  193: "380cca0ebdc4e9402a9291cb1aa33fa5",
  194: "7b9bd3ec1a0ed083f3d31d52d9b602cd",
  195: "a58eaded28f06011b59b44de642cf15c",
  196: "0187338a8a98ba5bf072edd8a9214e72",
  197: "744fb6905b52d031d85c25b9e3da1bc0",
  198: "4ad0caf9d6ce4edb22ac81061bb4b544",
  199: "b2eaee0a032fbdaec8963e4570556aa8",
  200: "4c7f39e5630379d0b687fdbc62723346",
  201: "7175dfb0e48ef90da4811090570f054b",
  202: "037e568690485cfa236417fb727b250f",
  203: "2cefb22250e5cd68cd0bdb682b61a9a7",
  204: "28271f1a1a210a0998437e151ec7afe5",
  205: "3b75410b7bf4b316b46801e52c326d08",
  206: "e367eba8aef418ee64c498cf911a4baa",
  207: "050e59047741e87b909afe1dc4702dfb",
  208: "c0539bc799766933dddbcfc59751afa7",
  209: "7b48fc81d3bdd8bc4b2494af9abed5a8",
  210: "3787dae9b27855b3aa05cc98b27bd408",
  211: "8d2dedda-8c94-43f4-8f75-546f6e41d67b",
  212: "83cc1c60-b3d6-46c8-b8a8-1a3dd1267e04",
  213: "033b704ad14b987de10a8153fdfcf476",
  214: "57b44877-33a5-4bc3-b351-e727435fc04f",
  215: "ea84d87774e907fa3783b61293f7caee",
  216: "5823e9e3c1120780d038bf6075cf54ad",
  217: "843c35c594fda2b06baedb17da7261ee",
  218: "76b26586-705c-49ad-94bc-2772afeccf43",
  219: "3227e089-83ba-4211-b832-94ced25865cd",
  220: "4d90c2fd51f712da5a42c5df778fd654",
  221: "3e8d402825c6ce95719b34165ba02b4c",
  222: "e24cb4381db77a2f8256cc036ae7c1f3",
  223: "322318c9b50ee0a988c1fb21d615adf3",
  224: "ca5a58eeea41141affe3d0d942317f5a",
  225: "ed359d84ef3d485562e43c6bc4945967",
  228: "91e899cb4f9e081d4e293ca0a4c72600",
  229: "731377544753917109d090c9f9604212",
  230: "695e92e53690bca510839a0a21e138d4",
  301: "bb130e7670b2496bd471873bc1da3385",
  302: "3765013d3b24931d6c5b5c93c001eafe",
  303: "559b9fa1c2f28c6c71b1801580f3cd2c",
  304: "06e5cd65bafc4083f7291e8c2ef8e0b8",
  305: "2904a40fb0e10f5119d535035b261f28",
  306: "40e2f427910bb56d752a087cd3e815ff",
  307: "c28aa36d189fc4c01d9301970fa9fb41",
  308: "34b411fb5a7991ed9499ceaa7346d0f9",
  309: "2b335df95ee6d7618c96c2a63967b238",
  310: "438e277d5a18e54262bab2bcedc45ef9",
  311: "554557f614032e70d5e41cd0c5613742",
  312: "4364e8b65fca6fbb597ca23c8e63c9c6",
  313: "0e33a9378a64b70ba266fc687db114f9",
  314: "cbed4136373460b65b0556efa1e2983a",
  315: "6abc8c5c38ef8b460a424372f375f063",
  316: "7f55acd538485647c645e90f7f35f681",
  401: "a0980138206326f70a613264282f4a70",
  402: "ea9538d7cb77bcb6681f22f2b931ae0c",
  403: "e648583de196edd3e8257cdb066bf089",
  404: "c01fd4fa5cea3571de2c7373c380903c",
  405: "45766322d90b5b64a51635658e9aebd4",
  406: "02f27e8e60bd4a4e4d631f13962a4110",
  407: "a54606b76636518a513cc2d5ec522e10",
  408: "87a64e3693f1c43d5a3125f5f1297bef",
  409: "9b0b0e7f6a4efa2534a7290d3cca5bb4",
  501: "e42180d7a5bbe44b8fe5e19eb1357113",
  502: "cfc70f69ca69aa9c65ca18635ab9f1e5",
  503: "81ec8f407273315b5da0ff7327a3d049",
  504: "546c99322a0432090b8b13ba25b7b518",
  505: "74c134971b4adb8cd458a389431ff0cd",
  506: "0c3f66b5640f7a7de86a9027ce9c268c",
  507: "c48a1003b086943b75cef5229a76f0aa",
  511: "a938f4296e2be857889c1dfa944e6870",
  512: "f0362ca3dcdbba28f26b6006ab8b91fb",
  513: "1dc64f46da51fc8fc5c5b8b06e933bb9",
  514: "a2f1b2b84836ff52fcdc768c0ed16f4d",
  515: "ccd266e3c9489756ee3a99b3dfb96157",
  516: "2ddfd953dc024818c568e4ab4488bf1c",
  517: "2bbdb3260406b07b86015c1db27cf535",
  518: "fc40826693b3d2c082c8a2dbdfc8af48",
  521: "0af2fe11bcc82ca7582087089061cd7c",
  522: "b2b0f8b73f1f78253106a079b4662417",
  523: "1755ce65fa2161caa93a7882917bde1c",
  524: "c2fe40fed6ec0bbb56cb000ee6b6e882",
  525: "14434ba3-5fb5-45fc-81a4-8525ba04dc14",
  526: "8d3cf20e335bff6d68bb5c45ac0a7cf6",
  532: "17ed41e7fa12d4c172f7b26e887f5402",
  533: "551eaac228614538bfb4c4cc342f95e2",
  534: "98d38ce98956314fd73c9d992fe0fdd1",
  535: "1904ad2b0f3195e55a7973704383f41c",
  536: "3f2ca75bb3051f8c3a32d134dc0ac773",
  537: "7d42a873dd9bceba61ebfb182323754c",
  541: "0683ee2f9d970e82180ae55670cde923",
  542: "eab1bc692340f02e234ffdd922480ef9",
  543: "11d80e209376012c2dc07eace2975fb1",
  544: "11b6a75a-6ed0-4edb-b152-94eb6238590d",
  545: "75d5966b-80c1-4193-98af-1fba3e4d6289",
  546: "c418945d4f2abce731dc5c4d19309328",
  547: "542fa598308f2204b2e955c73d908af8",
  560: "af18e24a1258c4ad6e1ec408a528ec89",
  561: "c06a646bbed557bbfb09b27715fd81ad",
  562: "c40082fe33610cf6a6c36c3909b12cfc",
  601: "698c01f07293fdee9a72fbf3bb8def47",
  602: "84fcab56664755dddc2c11852c7a6d86",
  603: "3bda3ec15bba6e99f8e396ae1c6cab72",
  604: "e5535e4c-f6f2-4a34-86d1-66e3e445473c",
  605: "5bcdbd205efdb88b348d9166f9efaf7d",
  606: "b2d5d57a11babfbcc405553959345c17",
  607: "78d0aa00c2bac28e3aac495c770042f8",
  608: "fd115ee625367e3a2b490e24d0e28ce9",
  609: "0cddb024006ab06ae9742daa007675ae",
  610: "3a5081553a4984e779f5d3e9b3e0a38a",
  611: "e487340c-2101-41e4-9711-a1ad55e8680f",
  612: "0ca0fa19-6ff8-41ad-87c0-38e72b5c09c9",
  613: "aacf6935-8fac-46c7-92ad-8f88233dde78",
  614: "e36525f66196413e6b975d78c52cf867",
  615: "c98733369e237ada0de460821e9a01a5",
  616: "1bbd496a341cd20de2fe5a67899a61f8",
  617: "76566d3f-f2cf-4834-8fb0-5b640bba0e8f",
  618: "dd4f21aac094a5229eea13044db3607a",
  619: "3bec7fa172efb26cf2c5c4789c10d0bb",
  620: "3920cfd62e76c19000c26200525d6966",
  621: "ce851a8326c7f51bc1006f23d17fa59b",
  622: "9e135ff32e09caff2375458f2454596b",
  623: "b79c6269-e81e-4fb3-a656-7ee53a76221b",
  624: "6032f79b188e5087869cf0a47bd7ca60",
  625: "7718ffb0c860d4682f47a0ac569e3677",
  626: "c47803396bb7818ee5a25f26ccb655aa",
  627: "e21d27810cc892e86f676045a7aa91f9",
  701: "ec449e7d852ab6f1b525918d74a41c72",
  702: "7370c4ecca7c98845776b9de9716771b",
  703: "f43f5da7919484f8e53886d328fbb1f3",
  704: "4aad7aee-bf14-42f4-86e2-85d7df73aab5",
  705: "d3004923fd7c54f0e3bb84179da10d16",
  706: "3b9845680bb857d0467e4ebf15e0c2b4",
  707: "ab40387b9c8131ce0a7a2526f0c1d406",
  708: "6c530271ad8c6e9b9bc37579c0a13a3f",
  709: "0336dd6dd66b83ac49304584724562df",
  801: "2d0db672-d847-426a-8824-1f7e4c8033c9",
  802: "3b0cd217-bd17-4da7-bae6-f929ea5b7e51",
  803: "0e0c86e7-7b09-4726-b106-12265e07391d",
  804: "b61fe38d-4e85-4ff2-8a98-c12c47695d0b",
  901: "a9743dd8-b40e-4272-affa-6737b45922a2",
  902: "c1550810-5a02-4e74-a8de-9393171a97eb",
  903: "05bd8617-db8d-4a2b-b675-b310b56b4f56",
  904: "6ed62745-ae1b-4641-80fa-a5b15fc8e5ea",
  905: "163976c2-9b80-4b9a-8ff5-9f6ca7cffad2",
  906: "927a3b37-a0e5-4221-91be-6daede190e0f",
  908: "8c1df2be-dfcb-454e-87fb-65e5f4fe586e",
  909: "577dc843-664e-481b-a9e5-421ed22c981e",
  910: "301bf757-a6eb-4efa-9186-3e6bb6abdca7",
  911: "1e2d742e-c69d-49b2-8444-ce3b0d172604",
  912: "ba25a0b6-8549-45e8-bf07-341f5ac319e2",
  913: "2550ed0a-e0d0-4aa7-b847-f6ff8296f53b",
  914: "68397e72-a8af-4970-b160-72ec0e021720",
  915: "3db8475bcc08fc41567ce227470a3a9e",
  916: "882667a927f908fad462ca97e20dc6e5",
  917: "d4c9f5a5a96f528a32afd2caf4a7efb4",
  918: "f6ad3e4cf925d62bf1ae027487d1c4d9",
  919: "938f060b94b71d1f25f2cda863cba9fd",
  920: "e1982899cf02ebd873a79d4b32f7b353",
  921: "61bcd98a9b5454c8c091e071aa0f29f3",
  922: "8e8e36da454fd474dde292dad119a6c0",
  1001: "02600778b36277bb1fff930f24c9a6d6",
  1002: "589572405ec6da0992f950e56d35120f",
  1003: "e9043e1570bbe6418e0f9a3b6073d64e",
  1004: "5249f022f32c96a0968d97f435133759",
  1005: "33a22029a051c603848e99b045b27ae0",
  1006: "49a28b07f03b0e75cc94b26c5c2dd521",
  1007: "355571851e34f526886e362549c3d6f4",
  1008: "24b282f3be9210100b90dfe60bd1e612",
  1009: "0d9001bd2f642ee0d77b3df6cc763546",
  1010: "945abdec15f5d27bb1ab4805fc1206c5",
  1011: "0b368617bc9177346a5b7ef07f57c46a",
  1012: "8f70db48628f5c8219fd277588619466",
  1013: "85a1b2f13a6a3d2357d78fbdc169b512",
  1015: "f1e5b822a40e150143a3cb7620b0cb30",
  1016: "42defa4caebd7ab9400851f38a26e0e7",
  1101: "0f6112a9bdb9d72134deab34c7f5a352",
  1102: "b5cb23b8b50e7dd91606c29fbe8859d7",
  1103: "7613717c03932b9344079c982282447c",
  1104: "36f3810a75bd13dc6c3f8be6254740cd",
  1105: "6270322d6881a0f46af338cbf278a0f4",
  1201: "0d72e1119f4bb2a233503ed6d2ca8456",
  1202: "fa29b71e70ba81b60b4e755824c2e0f0",
  1203: "e883c16900010876b9d2a5f32145eeec",
  1204: "a85afafe-d639-4c41-969d-57c10f5471d3",
  1205: "5496c970a33aad3509e3bf94a8375066",
  1206: "f31c94711f4fee95db7f6f23f2bbb406",
  1287: "9b343733c24682bae9224bc72e5658a7",
  1288: "c3623b1c-3186-4960-9466-2b79dc752b72",
  1289: "891f86335201c8d22bce460524960d8b",
  1290: "1789fa2067f976a1c81f327457beb5b2",
  1291: "e8923d2c0da8b566b3bfd41e14473dea",
  1301: "ec04e5ed-b486-41fe-8cfb-b26f1831fec5",
  1302: "baa81674176e194e4a323209895eb0e8",
  1303: "a4c923e83e7ced5f0434cb6208f27ebb",
  1304: "62e7ee3a0082d3aec3b3831e71440015",
  1305: "126713992d0b0dfed079cb52228964a3",
  1306: "9eb4708be9120a48861962bc529d045e",
  1307: "12fc61409d7997fd8aaa5a30f931bc7c",
  1308: "396e287f-6292-442d-bcd5-275c7ef8b3cb",
  1309: "d50cb76b-1052-489d-9073-9b299997a7d3",
  1310: "d210a1bc-5d64-4f56-a235-aa2fc03a39b4",
  1311: "aa103686-35ae-4256-a4ae-9aaa8b73c136",
  1312: "83215d91-4534-4223-8859-2544ad2a7cec",
  1313: "09e31380-e9f5-4cd7-8603-85e731547d68",
  1314: "3906b88d-6405-453f-93c3-bfc5552c19d7",
  1315: "1b222796-36ba-4437-afad-b423db8f8e74",
  1316: "19bdd580-212f-4bfd-ad50-a0f67427de1a",
  1317: "b5300348-ef9b-4f3f-8398-6cb0e2f39907",
  1318: "8431f8ae-3f56-4344-a474-3557589514f1",
  1319: "10f792c7-a79a-471e-acf5-4ecfb6a1b380",
  1320: "a067bfd5-9f84-444f-ad87-2e8ff89f67cb",
  1321: "1946169d-f075-48d5-85e7-e3c1f8f1a891",
  1322: "7b924586-a5c4-47cf-ae2e-326a8f144c91",
  1323: "af1004dd-91a2-474f-97ea-60c967d2b86f",
  1324: "d06d7dab-3f7e-47c1-b725-36653679c3c8",
  1325: "abc8a2bb-b3de-4755-ada3-57613efa60a9",
  1326: "ca0c6353-4531-47ec-a9cf-0f9701eafdb6",
  1327: "67f63b66-ae1a-492b-b80a-d0771614dd11",
  1328: "0aeb1332-b8d6-4dec-939d-5a6cdd59932a",
  1329: "76a743e5-8d18-49b8-a81e-1843bfdddbd3",
  1330: "b1a6ef81-a37e-40d4-8dc6-e83b80eaea65",
  1331: "1c76165d-961d-4887-a108-899137abc2f2",
  1332: "cbe7de65-1b88-4531-b447-df7a7e8b5245",
  1333: "d4df9aed-b3bf-4fad-8244-b1161496b0db",
  1334: "3cb99ad7-a9a6-4314-832f-23d1e2656e3b",
  1335: "2279cf4b-39ef-42e7-9602-eeb8d22420a8",
  1336: "1816c987-af6f-4d56-ad17-3c6c5ee7499c",
  1337: "1e12eaa0-2583-43a8-840d-721631e074db",
  1338: "9f9f9af0-582c-40c8-8c3e-aa0f5cc74ffd",
  1339: "059e656c-3a5d-4898-892b-4f377992d4b4",
  1340: "afbedb53-b74b-4a76-8ed4-1409999b3179",
  1341: "4bc57b61-d523-4d1d-8ee3-1aaad5afa16d",
  1342: "15178cec-e71a-4a32-8fd8-d007c2d5288e",
  1343: "8ed115a3-e4b7-4494-89d6-ff3de62d7ee5",
  1344: "09195306-123f-40f1-85e4-bc4056cd82c7",
  1345: "39a6c4a8-ef10-4ef8-8c68-61c807712cc7",
  1346: "9de65626-9bc7-4be0-a587-6fd2f7119bdf",
  1347: "65cbd308-b984-41fc-b076-7d4c47694987",
  1348: "4d851377-e830-4cb5-97dc-f11b81c4b7af",
  1349: "05da2945-0da7-407e-8973-305fbde9c6f3",
  1350: "be3f9b5a-977b-4d56-9aa2-7e8cffb83719",
  1352: "69a8b614-293c-47c1-b693-45fe5d403e12",
  1353: "80ee7382-58fe-4d15-aca4-438f518696b1",
  1354: "5bf0af78-cf24-419d-a2d9-e4da069a2450",
  1355: "9062cf64-ee74-4799-b4ba-3e0dc5a0a76a",
  1356: "362e6298-3755-44e4-8d27-93016c110d03",
  1357: "c1334f32-60d3-42fe-88ac-cddac967fe0e",
  1358: "a58c0963-a070-4d6a-b700-ed26361b0cf8",
  1359: "4dc2b885-71fa-4620-8053-b8b63617da5b",
  1360: "8a19450f-4af0-44ed-9398-eb5ff9539fec",
  1361: "ad51bef4-1f1e-415f-af3b-9800527eeb23",
  1362: "46d6f617-e83f-4858-ad92-95cbb09325a8",
  1363: "ecbb92da-e893-4932-8a74-47e051c06e1c",
  1364: "4676f0a3-9a92-47db-821b-eaa357bd0211",
  1365: "c73d5679-a8a5-4aaa-ad67-399b543bb919",
  1366: "e8a9a076-8333-4569-86cf-49de0d1d3470",
  1367: "5a19e64c-fbad-4c70-a094-8e368fca39f8",
  1368: "0c57d049-7f33-4f6d-b05e-4db184075741",
  1369: "5d67e6f3-4a2a-48d1-9dfe-d40edba4eea7",
  1370: "2ce6baba-19d4-463f-9d30-5cf5509f43ff",
  1371: "3d621929-cc61-4c67-8fc0-598587c145d6",
  1372: "da79f618-cb2c-46c5-b45f-c80bc88ca947",
  1373: "ed8f4523-b6e0-471d-a0a8-3cd0fd0160ab",
  1374: "c15ed2ae-9469-4cde-83ed-2e78b171adcb",
  1375: "442cc5f6-9b1e-4d7a-8195-4d34aa0991be",
  1376: "28793a06-7a56-4736-a9d5-a5977f1f5a29",
  1377: "844524ad-f504-42d2-b29c-12afe3bc7110",
  1378: "4a8f0d59-3f0a-48dc-a7aa-0ee590335c4d",
  1379: "44eaef02-132f-4574-8e63-d94f1e2f94c8",
  1380: "ed822027-c938-4f6e-96b9-c4f38fa1d296",
  1381: "390211a9-aeb2-4af1-834d-bc86dfa547ad",
  1382: "4126693e-cd8e-46c0-b1a9-6e4bab6b7d6a",
  1383: "10d46013-c2ed-44f4-bf00-138198e94aca",
  1384: "5ef91cce-8a3a-4d0e-a57e-ae203c682fe1",
  1385: "37a5b0d6-e2f7-4485-ada5-97df855b6a93",
  1386: "0922535f-9582-4e55-b555-d466ea3f1625",
  1387: "2127d44a-6d96-4ae0-9ae7-ba06edcd0efb",
  1388: "94bae3fb-087d-4f92-82ef-1961ca9b82a3",
  1389: "fdd9813f-a480-4765-90e8-6b2c58722556",
  1390: "52c233ac-4310-4a80-9fb9-500793722c54",
  1391: "690571f0-6208-4bc8-a0c2-2d6c28e24748",
  1392: "0fe6ee85-c7d2-447d-8472-f072b1d0fcc6",
  1393: "26b2a0d2-9677-4925-b95f-70decadef29b",
  1394: "18d125b3-321d-4d06-b95c-a60b86a530f2",
  1395: "a1897313-8ed0-466c-864f-9e6b03428633",
  1396: "95477769-604e-4a1a-b882-52068b77296d",
  1397: "8c70b368-27ec-429c-bba9-5a2258b3fd8f",
  1398: "713a2792-80c6-4f37-b347-fb1959272723",
  1399: "931e91b2-98af-40f6-8276-72243e31b890",
  1401: "565b11bef18b3423643d272066166123",
  1402: "3928cf38e115dbc0fbad62e4fc05f9f0",
  1403: "d3c8093b705411e44b5ddeca5aa6e5de",
  1404: "f27ccaecf52b7fc734ed6b5a42a9fc41",
  1405: "b28b37060fb17f4ff3d41736d9a42971",
  1406: "f660289cdb0d04477029c3762ef79ba7",
  1407: "78e49a49d73686a62bbeeedc6575c766",
  1408: "d202a9e28d48b6c5a4ebbb864ea81ba3",
  1502: "76e9c9fe634cea643fdc97c48d54566a",
  1503: "25d7d7032b7c28b82ab728d7ff93a0a3",
  1504: "52ab5445eff3c1bd8096c77943104128",
  1505: "2cec711a579a45faa69e791c9410575a",
  1601: "6be38e4b54ccc01a6845dc6bcae006f9",
  1602: "25e5be60480f1458a6ba640a28609c29",
  1603: "3260e5aa-59ad-4c29-a8c5-643fe5d4a3d7",
  1604: "6eed0ed4-96eb-4318-8f9d-3851f869285a",
  1605: "911996695f0a12ab52cf2d3224208309",
  1801: "b181054e-3a8d-40dc-a2fe-0edb9baae3e5",
  1802: "d1742ae1-730b-4b37-842d-f3b7731f1eff",
  1803: "d345e2ec-603b-4d8f-833e-f2d1d40ada31",
  1901: "810f5709-e982-4382-b0d6-5250b03ac6ce",
  2001: "5f9a166577c2d1b7d1f4e017175c367f",
  2002: "755f3954f0842e420a46d89989616176",
  2003: "c262f7b8f080d4404c39cb200afb5250",
  2004: "5ee2d095b97933e306f1344caf71c1cb",
  2005: "3b4ee2088f2a2ebc879d69fba84e0eba",
  2006: "5324b757-d147-427d-bdac-472ca5357ec4",
  2007: "87c82aac-86ed-430a-bf65-a5295a40a0d5",
  2008: "2d2cf680-c1d4-4643-b8c0-5c8926685acd",
  2009: "6617d6f0e466f033d052a278e23c0ce9",
  2010: "f5d10df405cf07fbd94870a1b152292a",
  2012: "af9a0584e355303aad0d10fb837442b0",
  2102: "95782190aee072d8ac71edb8ece4c0db",
  2103: "bcd6161bcc8a3f255a733dfce197bdab",
  2104: "9d6cc8f9be10d948052c52e206ecaa9c",
  2209: "a5730cc1b8a3767bd1c5531eb4ac2568",
  2210: "911dc64bea6c434972a36399c0cff7f0",
  2211: "bf0f47174178f15822e638e7c01c2fc4",
  2212: "e4d79b016554c60995deb3c87c6e324f",
  2213: "0a22f372-41fb-4f53-a813-a12b9b483df1",
  2214: "74d6e03d-cff4-432e-aedb-aa72dc843ad9",
  2215: "98000497-4184-477c-8ea0-da9e5d7dafd5",
  2301: "2c710aca-9e98-4039-b53b-77e65b50ad2b",
  2401: "b132e1ba0886660aaf074a6d38d7250b",
  2501: "196de0cdf14fac82c321f74eb0d6e043",
  2502: "26b96549-ff43-46a5-97a3-8978800cef24",
  2601: "30d73c42f8a727ee3b444aced2e976c0",
  2701: "20d111a7-2288-405f-a2bc-998982414dcb",
  2801: "a570c6fcd5cc7384297af3680be2e431",
  2901: "f3b39f07-a7bb-4013-8f7e-760047e00040",
  3001: "109c167b8e8f170e4a5b6a00629f7e44",
  3002: "09d48287-c2bf-4247-b570-98deec8733e3",
  3003: "317782e6-52a8-47c6-a30d-9f547b1efd88",
  3004: "e123c5e0-5563-4471-ac39-52fbd7a18dee",
  3005: "accccb43-7905-45cd-85ed-57d13585b175",
  3006: "acc28499-3571-42ef-99b3-9e6dec63d7b7",
  3007: "1774cbc4-7ba4-4c16-9598-84f5fafe1401",
  3008: "2d1dd5a0fa4545b83fc2051a42ed9f3e",
  3009: "278d6153921ca181a218fa9c54f2b06b",
  3013: "22552e8d851e4bd523364807e1170ad9",
  3014: "18dca11a10be943363c559c055fad9bd",
  3015: "ebe3c4a399ac0018221b72095d241fa1",
  3016: "43a176e13dacb3c7d266866e1acfe286",
  3017: "8101405af82450f6b9f791e4ba1c28ca",
  3018: "d2a36c0451e7449a56cbf4fd8a64a2a8",
  3019: "d4074cd723acf5263be32c7a3165da64",
  3020: "d2e0c62d2fe609cf9b766e390b77aab8",
  3021: "dd444304145c84e9307c16450a18ce53",
  3022: "ad2f8e93546b96c114107aed550107d3",
  3023: "26340ae9da769c07d5db2665dac15bc9",
  3024: "7b01dcf14b9d3948fad46ef5f8f68f8f",
  3025: "7c68413126d257ad5c2e7eac67d323c1",
  3026: "7b5248ad765b883d45ce08f329e098d6",
  3027: "d5d5e973e368d3a26ca2b681adee9369",
  3028: "4975dabff34067664a8f1b32eb6c0bb8",
  3029: "5f09f1c37ca4841c9b1c1cafedb59aa6",
  3030: "ed109df4796146aaa4cca324ce12b475",
  3031: "5a55d19eeab451ddc1066a4cd185745c",
  3032: "be9ca29d7910aa3dfa3c46e7b1fa4974",
  3039: "7aaa7c55804cc55665abc143bc441c7a",
  3040: "5f6337605cf124906e5b3268c6a5e784",
  3041: "7494e32428ec2e212f3fa0d749adde14",
  3042: "d1e69d4f88aa213fd98a690fd5ed728a",
  3043: "6e46a169831f332cb511881938d8800e",
  3044: "4296987bfba1b901649e5487fffa348c",
  3048: "2dfb694c43ab4059e305342c2652a761",
  3049: "a3bc6b57529c77b379fa823e5d11926a",
  3050: "46284087eec7ffbe9c02564b0ab18d86",
  3051: "d1b873338e2f3ade0a4c86d315097f6d",
  3052: "a88effc7ef937637ff30a38b453b9adb",
  3053: "69bbc18a30311b68f2964995b36c30f8",
  3054: "cf80ff65dff430c66997efc2d81cef51",
  3055: "d1f9f8c5e057d5f2d3062b83e8befeec",
  3056: "3fd0ab9328d09c61e55deac2cd0e107b",
  3057: "dc09b473362bd17ec3a4b085011b64a7",
  3058: "b6f30c655088ec3b243c8eb170e98007",
  3059: "1fc56de09d2813fcad12cca117ef8bf2",
  3060: "ebfd1b0c70e2cd88d5980e57f554b29e",
  3061: "bce1083e838fe9073ecc60f67a08453d",
  3062: "a7fb41ebff4d18c4ddf238ea9df663d1",
  3063: "e396c8ac5de79211d35202cef98de3f2",
  3064: "b283a291b3add66a11e6c0d166fe58c0",
  3101: "83713571813451235386a6b3a3816ad3",
  4001: "4cbdfe0708aa3ade39e7764ac99b6f39",
  4002: "3be6a9e5f0b8e7116f5ea0d7c69ceca6",
  4003: "574a8ca2990d5dc4c09b790580bd98ba",
  5001: "83125f16a47f9c95f3f4f203c6c3d4ab",
  5002: "7c5c6531fd83e7ebaf503addc99874e6",
  5003: "38464351-a854-4e8a-99d2-7998d4aff25c",
  5004: "843f4a65-e88e-4136-b9f3-cae5b10f979f",
  5005: "3cff33e4-1d22-462a-adec-84d3a6992817",
  5010: "05410be78b2a52595978b41c7beacd3e",
  5011: "2291b0404ae4473a8885ddd5cd85c48a",
  5012: "202a241f56dda1f4dca2d8427957eaef",
  5013: "36eba060819c3ddd5bd99bc1bff0ed73",
  5014: "d3fb3a79f8490f809ffb2825ca98bad3",
  5101: "ed339a24-60c7-4931-b94e-44ac1f454842",
  5401: "93d1765d9539754c509ef1407ac6769b",
  5402: "905399a6152e841a328aec2df5863b9a",
  5403: "3822b055962d9c3895f22468322fe532",
  5404: "99316de8bc431e609a17839c5279aecf",
  5501: "2eec4a00f6194ad2f4d8af1f56722f62",
  5503: "80afe28c28950b508a88962d60c3be23",
  5504: "3c98a331275c20470746989a34b58171",
  5505: "ba0058556d35bbae7dc3d2176b9c20c9",
  5506: "c1c4590a629e6fde9162504e33eae1b3",
  5507: "72198604180fa02d8a7482a334b9ff76",
  5508: "45ad5411cfdbb9ffa8f2f36973d98313",
  5511: "3b8027b34dc020ecb9e877d2199587f3",
  5513: "1422cc092f0c37a765cd3f832c7ba94f",
  5514: "21d957bdf325d1b749514647a855345c",
  5515: "d6aa19108ac6f16e8816cb685f87f169",
  5516: "2fd2291a9114df50d61a897ed1ebeff1",
  5517: "ffb78579b667183ea8cbf69f9c0957ba",
  5518: "d92ee6b1b5d7714971d1c88ab7b53cd4",
  5519: "b3ba2f25e79457924ce00e121f41c83e",
  5520: "208bd1d1e5e851711e6104cf91c2d4d3",
  5521: "70e851d4f0e7c98f33dff33e3e1625dc",
  5522: "e68d405c914403ad3cdd0240985c94d8",
  5523: "a6abcd5ac6cf0a4b84a976dcc1fe186f",
  5524: "665bfe59f3db36845e82dac6a59897ce",
  5525: "9306b3862540c8b26120494075c64e68",
  5526: "352a701e4d71a9fc70ef95dacf1f353b",
  5527: "fc129ba50c108cbb8886d2b330984048",
  5528: "613eebc469bdc937716659c474dfa480",
  5529: "e4ca0af607ed232a36a0602f04e819ad",
  5530: "3cfe8d8c-5462-4eca-b155-84a7778027d1",
  5531: "a089e9ed-caac-4bda-9250-1fa1c507e39e",
  5532: "b93a92be163a433079eaadf11592e74a",
  5533: "35c85851bccb5756d55d18261b411476",
  5534: "922f1c3e369a65389320c6caaec28abf",
  5535: "5e3b0d4a8e51a4ca531beda2a51251f1",
  5536: "3927a48d0462f9012ecfbf0eb517ac8e",
  5537: "161a2ca254cfa745a62e502ac1aba211",
  5538: "9b1cec4450dbdf14b78b4c17487c28fe",
  5539: "9fd80bb01f3738c5cbbce44a1f8d4059",
  5540: "474b324ae4427866bebc6244c573f88b",
  5541: "1d7e4683a26099daed1dcdd9ef718b89",
  5542: "91204d54806f6254d7c044911ed8a847",
  5601: "4cebe6712dad0e75f8480b5be4965dca",
  5602: "d55b654721f5778503bf36dc933e301d",
  5603: "c996f327c533edffdea90f49b521ec48",
  5604: "18bea96c5069e36f4a7a6c702cab29a7",
  5605: "4a930316af7195309a973f173a648f79",
  5606: "181e34bff2c3da0fe626f025a1a52edc",
  5607: "d3c87391880190499e45c3e9710ac799",
  5608: "57f3ed6a7e6bf82f6291940f18e4f89b",
  5609: "9873937aef7e7143ca1aeebdb52b1257",
  5611: "4870b4dcbce67d6f4ffcf1d36e61226d",
  5612: "52d871b0ebe8c5dcf1bd3eb7bfcc5d87",
  5613: "2925004d9b613e6023dd994c9bab3a0a",
  5614: "cc917e345049f70a13a93288a3c8a200",
  5615: "c72f27523b8f60a8d6d7c09c739d694e",
  5616: "de1aa78aa49c0916306c2fa9d979f99f",
  5617: "fb681449377546783341c9a1575750ad",
  5618: "cdcf6477ace4bdf7615377563bc3e767",
  5619: "25379241d421006a3a26609ed7fab366",
  5620: "0b5cefb8efbc3c3d7753eec5a0396ac3",
  5621: "dfe0762de7d97413bee0ff6ccde4145c",
  5622: "1ded652708bcc7cf5bac86bc7659ab49",
  5623: "fceda5b9de1283a57452c497cff88faf",
  5624: "3911831efbd2ea5f42ef53b971c2cf64",
  5625: "0038bb3863b417b1ac3ec8fd638032c6",
  5626: "da1c617393fc526eec7028c618c7f5d5",
  5627: "9d73fd5091d9a7d19c524da81c254834",
  5628: "6305ff966ee0bf72c839d8689a2eabda",
  5629: "a118b18f77fe306a31cfddefdb4bb0e4",
  5630: "48732ae2d70b5f8bbb4c118a827eed61",
  5631: "e864e791aa54a5a5ee9b2871741b6cf3",
  5632: "b4b49edb89520e8da0e64ba389c26f0f",
  5633: "2691f007d58720053b3c5a595e550561",
  5634: "585651861483a1163f53807b0719e098",
  5635: "36091f7db3d04de5e169f8913ecb0d5c",
  5636: "9af96efe92fcf2e0dbb02734d6ad1764",
  5637: "ee473da66128b863b950f79cc101256b",
  5638: "67b652c20ea72343ee3ea6197363d29c",
  5639: "a3cdc301b5133de5459f92b26c686001",
  5640: "4023577c81c298ff8d53b5f0d7bd93bc",
  5650: "9632df29628775c83a91b55ba3acd7ff",
  5651: "cbfbdf8b14f7c5dba77123322e43c6a7",
  5652: "de68eb162c0cbafffeb830f5c5c45078",
  5661: "149a57cd2613cb92116dd5468283c821",
  5662: "b27af793b4ed9caae25ef521a204cbb6",
  5663: "9f852deda670a12ba91e4700cf590cb5",
  5664: "cc6971dcbf23c9aa79c8a5fc4976e477",
  5665: "2e1da4b35e3d022a654ccc96d1c37beb",
  5666: "fe4fb49b53483de63f39c230b841fec7",
  5667: "d772ff8eb308b70cc9228587e45f2feb",
  5668: "54a9689493ca066ffded3ab341e10c70",
  5669: "b8861a6b6728ce7de4522a301a54283b",
  5670: "fa2ffa2517a41f77b076be0760be5d09",
  5671: "8039f301502c7e73c6cb7c9b30366c84",
  5672: "9303213dd45799e595c44502498fd302",
  5673: "3d3002d9d576a5de28aec3247db3af1e",
  5674: "39e89f978d52c0583475728cd6398d4d",
  5675: "88e1904e1f45eec0c931243a926acb83",
  5676: "8b19d4c47566ea6a0f9c0b8e516083af",
  5677: "fc38616c67a17fd5e2470ec496f248af",
  5678: "fe51b7a14abc9508792de79f7b1c4eca",
  6001: "e63e959fc1ab7ece994a479948d50567",
  6011: "beea3eea-9379-42d9-bc3d-7d39f57c8cba",
  6111: "ddc625c8f4215468e9d1e6b926e01bea",
  6401: "7c6ef1570c7c997266a449ccba0ff32f",
  6402: "d5002a2c06a418f5e62f7007e27cbb98",
  6403: "0d4ebcc733d1d0e7167978a69666f35e",
  7001: "a1aea2342d02d5be532a1418b8c24672",
  7002: "810f152e-515b-4bd5-8b23-f14026d39c31",
  8001: "7a97ae37173df6d55b4a6cee0312f95c",
  8002: "5a69e2c24a70df9282b7820a3fee7999",
  8003: "a0c98311fcccff7169058b9e57b8074d",
  8004: "0a2c9f0691640ac88d5d401e717f3ab7",
  8005: "8354d684cc35d64c95285fbb6721b1bd",
  8006: "9d7e30f1d134e9765171eff116db16ce",
  8007: "6121658e35a73c235671f0840ba53db0",
  8008: "479ce3968f78f916bb8a4b85189ccd29",
  8009: "c14f219b70e918b39c22bd559e1aa81a",
  8010: "c8585122d0ba616a112d10f9248b6680",
  8011: "9689aa0aee4825788696bf1a7828d697",
  8012: "fc885a6555a9d16d88a4c662c7d36c18",
  8013: "1bc1e8fb-fe49-464e-834d-eb05ac47efa8",
  8014: "1df7b916-f2af-4cc0-9b3a-ecce485ffeb5",
  8015: "45722e58-106d-468b-9a18-e99b2293b8b1",
  8016: "740943d3-5da9-437a-beb4-1b0047f912ca",
  9001: "2999a17539bdf647c6ef325883064178",
  9002: "cb21c4bfa9df07d0c441b628620b1871",
  9003: "e801a5cc303e7abd59455357569e3f74",
  1e4: "dd3bb3e9098875a36cc4a3c51bb8c8d6",
  10001: "220cd400-1be6-477c-9c8b-2698d83b1a5b",
  10002: "6dc88027-d05f-4981-8ea7-d1dc00a5585c",
  10003: "cd8ed1b6-12b0-428f-938c-dec201d816de",
  10004: "9e345981-a720-4c85-b0a8-99fc536e09c8",
  10005: "82de0868-9367-4ff4-af5b-e928058d8ebb",
  10006: "17bcbcfd-43ea-4d6a-a884-a38eb3795c8f",
  10007: "0e693fa0-f01d-48a8-9285-34bbddd311f2",
  10008: "e03850ba-dec5-4898-aa91-7197197945b3",
  10009: "56094cb57b8c327ec4bc4539f26980be",
  10010: "6ee3a6fb-29ad-4250-9f88-4b1361e33cf3",
  10011: "747ec569-ae59-4661-a194-7f2413cbf4e1",
  10012: "e025fbc7-d778-424a-9590-c85c55e9f861",
  10013: "3a6b0627-1bd3-4968-a08d-a30d70dff273",
  10014: "96e6cdee-e39f-4c52-8740-c962bfcff51f",
  10015: "81376773-31fe-4817-af5b-19c504f46ac1",
  10016: "1f49bc32-66ab-4d95-8749-767a41a0906d",
  10017: "badb41bf-609e-4f1c-8876-a1a7d4b5f55e",
  10018: "9fe5b9de-9266-44c6-b6ae-9af15422a17c",
  10019: "4c0c467c-65b6-402f-83f9-810fa5b094d2",
  10020: "931bc9e1-4ccb-4190-b4b4-14ad2807ff77",
  10021: "ae606ed6-f1e3-43ba-a2af-e89db6d223dc",
  10022: "ce01c44c-2727-4e67-a7f7-321ab3e8951d",
  10023: "5ab173a4-4371-42d0-a75e-317bbd28ce0d",
  10024: "6a3e685c-0f00-44d4-a6d5-085bcd5d4738",
  10025: "90d3d575-b9f8-4a26-b86a-b621373f7e29",
  10026: "91c9a513-6827-4cb0-95a3-832076ef5c41",
  10027: "0e1c81f8-869c-4120-bcf7-faf1cc679b5d",
  10028: "63b2233c-ea4c-46ce-a6ad-a943ebb39a86",
  10029: "04937c63-aeeb-4bc5-8c77-9ce3d5011dd5",
  10030: "fabc8daa-8b0f-4951-ae9f-d1f9d77e3168",
  10031: "d68bf195-a70f-49f7-a28c-1ddc19702577",
  10049: "1648bb208067bed91b8e081300328366",
  10050: "503f9078203211d5be9eaa2cbb1206ee",
  10051: "af117860c1ae546903783085255aa74f",
  10052: "7e8b6bb5c9c9175665de991b2ffa6f27",
  10101: "48d019199a5e196b8632a7f69cacbb8e",
  10102: "6eb86b4d75206e462c0ed294e2cbf080",
  10149: "f3f6d89968aa7cd5e14a0fab08b7a4bc",
  10171: "eda94e5fddf960600d96e276dc2844a1",
  10249: "a74c77edce696cd380ca0094156084cd",
  13001: "9fe09cc1-1c85-41e7-9dbf-da87d9bdabca",
  14e3: "ce77a7d76eb10b03db101328ecdfe724",
  14001: "dbebf9f8178cb4d1009b7e72ce095fea",
  15001: "7205dd247caaab81cb5a404db2b8d08a",
  15002: "7e78a9a6527663eb3b5b1111f9afefe4",
  16001: "87d7ca2d818514f91d0d4e268f2b71f9",
  16002: "3e259540575c673f0ea001496940fba2",
  16003: "77952dac41215daf1e1209f1d90efb8b",
  16004: "a897ba7d20d285f849a9a962a218a7be",
  16005: "4a5e12753ad4a781ad5e8af22cb17e64",
  16006: "62296d63487ecaed0e76a056b0e72b1c",
  16007: "dc159b08609611623bdea5da5da2e5d1",
  16008: "ffd404655bb1035a10a9b5ab67ff2487",
  16009: "7d03dd8ee95c444678982e70eec6386f",
  16010: "d0305bcbba6557173832cc85e13c7457",
  16011: "c6957adf91b7562ee9e851423b0c6817",
  16012: "a29cf50c03563baa732c1fe144b439c0",
  16013: "c943c16dfefc0823843cc6b8fcc7db71",
  16014: "2255eee9d55954f1962545202c30a24e",
  16015: "79484ac28b1610dc9a8dab2fd0e879a7",
  16016: "e5f3c640497d7fb516e9d068d1fcd1cb",
  16017: "d54c291ecf28ed732e128eced56ffcb1",
  16018: "622fa3618cd51b612e3b224425391d09",
  16019: "61621929384d39dc27fbc3b8d470a938",
  16020: "b12d4e3ee3b0a13cec8d7bb301e7be9f",
  16021: "b3120e97475653f9d8e4486f1014fb1e",
  16022: "26587b4b8a36241ea8c97b78d2aaf64d",
  16023: "d8500e71ef6f1f6222bb18affdb89a83",
  16024: "61f5014e0f46c81009a6a766a38ea348",
  16025: "d1ae6dc28242035623228eca7cf56013",
  16026: "fa90ced3ddce28181f789ca7e812afe2",
  16027: "337e12e68897c53b35959fe5188d5cae",
  16028: "f5c07b1d1a7ba1c5ab13977e87017f5f",
  16029: "044a57edd38885bd098ca813b6c7f743",
  16030: "bcebe0d8ca4382db9305d5d47d456482",
  16031: "267904f6b313abb7061509d9998d3dd1",
  16032: "d041679f08511c5dd085313a19b27e0d",
  16033: "1de5a02511867688624f1c6382cd05d2",
  16034: "f7aa8064006f6d1951ac1d090fb21622",
  16035: "e662bd644186006ea8f140f5eeb9c067",
  16036: "56e8cd1f5c8be1bee7b8214e783c4198",
  16037: "62da65eb7420b42ae6ef4c14acdec9c3",
  16038: "6a3ee6ac7bf4f13ed40ce34f0f68d85f",
  16039: "6c94e5d58884a769bdea64bc5eb19931",
  16040: "594e6b54-819a-420f-bad6-35af1bcb15d1",
  17002: "79fd9df1-2ee7-4e39-90d7-732907cbb75d",
  18001: "4a86e75f-cd6d-4260-8621-313aae40f3a4",
  18002: "b84553ba-3570-4fc8-9e19-6ec04bcbdaaf",
  19e3: "054ee6e02084b993b7abcef9c629ed4e",
  19001: "3ed9d964e6042f095cfe8f4bca2c9045",
  19002: "7fba70ac5fc359cbb7ccd8dd513bbb56",
  20014: "af064ae3633a00696926d30f949473ad",
  20015: "955bd05e6632e62a47ce00abb5882454",
  20041: "937700332ce7b3bbb6c2da03f275731c",
  20049: "ecefa183fea3fa49c9c7fb386b62a8ff",
  20054: "c120bde8d49f7999bf5971b56c4a2d8e",
  20069: "16e1ba1a6dac8a18fd42c3c976a2781a",
  20089: "d7e1d3bfc6869633b3193917d4fbad18",
  21001: "c23b975cb53a52fda71f9da7beb6d681",
  21002: "f426d0587d254d00b2d1d3cf084149c0",
  21003: "a7cfa3d48e78f71eca7bec86fc716b9d",
  21004: "39abab92d6419899c43319214afad85a",
  30001: "762d67d4ecef4dbc417fb4535687f467",
  30003: "71652a1852d99f6d6be73b44c7119288",
  30004: "91ef67806c39f575b16baa739299dda8",
  30005: "911447fc1c358b91b9f0d83b450d2133",
  30006: "1a911b175d3f6792dad7eb285f2b039f",
  30007: "f2ca18508d8a80401c1a3c41d56489b4",
  30008: "171426b8ca81c383f3a01729d9837bfa",
  30011: "96893da00576611e99bded69983b98ef",
  30012: "56bef91ec33fc2060161588616308684",
  30013: "5849c7b5eb91c9150705f4e9965a9e6f",
  30014: "47e3b1053a14c2fe04d96ae4a0d47a0c",
  30015: "27ec4790bbf609def7333bbf61a68bd8",
  30021: "3817cf5047b3c7432e76e3f5cd6093c7",
  30022: "00ddcdb888cc063555277bcef08dc01a",
  30023: "be5e9adce5bd170276fb18b8a3158a18",
  30024: "69145126311969ccef9f3af7dded1a6c",
  30025: "f1ebbfa54db6aa714680bde653c1595c",
  30026: "a528430eff7019436f862abed4490da7",
  30027: "6f35b588de8d64e4d0d6a7f630f1fea2",
  30028: "dcb9b65e81ec8b5b8303d0484fa20022",
  30029: "3afc2f2ebddfe1fc2e65b029de265744",
  30030: "025e9b09547709744ba6c44e9043480c",
  30034: "1eed0112137a313017f5f828f07f4919",
  30035: "06000c9c56e36018209a431b4e804841",
  30036: "d8e142d035bcc804e5f6e3cf1f19ec2d",
  30037: "b05b38470031f36b1d9db11cd35fdd77",
  30038: "bb4ae8abbba7ab2238a2e1000e222cdb",
  30039: "33aee465f1e28cc0b348d55fd3b69949",
  30063: "3927cb0867dde505e7ea77c650cf9542",
  30064: "de474c24e35eb23f2231d0a98b14275f",
  43001: "142ab13551892987e7f5f25083de7e8a",
  43004: "bca037968588d0043c3ea6f683539a0d",
  43005: "bb591794908852e23dce711bf964a666",
  43006: "f2322b006d52f30984d282bf558feb9b",
  44001: "6dcb93ab14bf489e0a792bda8cc2120f",
  44002: "7d651ea3faf7f21de7fa638a14ff129d",
  44003: "c8d64f3dd11904c322a38653376cc492",
  44004: "f0caed95e16b860eac4ee9a8a82f2b78",
  44005: "07cbf1f9940d50cd6d19c67b947533b8",
  44006: "b9c7a95238bce960f325d2d67de6279d",
  45001: "28a6284ed79236bd77f8f5e84fb5de27",
  45002: "d3bc21e0ce443cd38eeb34eacbdcd705",
  45003: "1af3fbbe39e0c21c1e90d967f75bc79f",
  45004: "fed5cae6eb39d99828026901f1aec61b",
  45005: "f584a9085e2caf2a4c491ca3e9dc7be0",
  45006: "08a9b2de6410f50a94d068a076ada192",
  45008: "e80bc07fd5b15baf64445170390542b5",
  45009: "2258305a9f7d163d9c1668fb8ac4a349",
  49001: "ad2dc1824247fa1992e66c4b719bc259",
  49002: "b0c628b3d355ddfba2517e0f582a6251",
  49003: "689293a675ba23a3f3492ede2cdaf9de",
  50010: "72f7fd9f-58f8-4d38-bf98-3f3d7fd5e255",
  50011: "e662a6ae8598a128257337da01688ef1",
  50012: "d79b0be6669c6f2e43e4804ed6696d96",
  50013: "9a19534b585834f2be7ebc1a16378958",
  50014: "33b0464f47f1a325cb42ace4b85a4351",
  79001: "c54362d70a899fe832e09dd994255632",
  79002: "7cc025821abf615c8ab568d0518bed1f",
  79003: "f4b20b4cff35d8c986a9bc7c9a1a62c0",
  79004: "09f0912a0a73982dbc9bd36297a6a598",
  79005: "f013c48d6969043e6363fbf0bd0ef296",
  90001: "f5230c2be982826be045de47586bfdc2",
  90002: "46cd8e1460530c56fb959a94de5deaa1",
  90003: "c77ecd49883ab39ca1f3c71fa5f5fc2b",
  90004: "7b43320e880af5ced7e4b9ce7abb714c",
  90005: "651a8d55567ca5dcecc3aab96668b64f",
  90006: "a9247be7d80b6b23621e45b587519b64",
  90007: "c5089e5df837e1c7db299e8cb190e79b",
  90008: "64d8a6884c6fb60168edcd20a8a4fe24",
  90009: "01b27437be5c2ab349989807cf0bf1bb",
  90010: "bb4725f2b020f8fdf0a2cf7f16b413b8",
  90011: "2d4a4153d9c105cdb09645d3c7df4bf5",
  90012: "38672b531393058ff6ce98c5b0124682",
  91001: "e6da027cb7b7fccca06f18d18c27846f",
  91002: "1503f1ccc3542468e0890f1782eb01da",
  91003: "858a859c1a4fdae7fc517a0d51d66aa6",
  91004: "6cad87568dd037d3af57e1c369c48c77",
  91005: "a2ddb2efabedf5efa6ac22835a0a9dcb",
  91006: "c5055d2107676443c4ed28c72a313de7",
  91007: "691ee1c8b866390e00c36ed00bbca4c1",
  91008: "a66ebdebae54d5d60e59b886e27d5021",
  91009: "48eb90102be73518d9df3f76acf02f95",
  91010: "1c027631501f5f602729706cc956fd9f",
  91011: "a509643b30fa168c2ebf554b9a204ecb",
  91012: "cb5f4a6c2ea694b573e78f790b05df9a",
  91013: "e2ca54190f285861625d9ff4e9cf74dd",
  91014: "2b0ba16e8f32451d11cce6dba757dfa8",
  91015: "9d3128a34e0a15b1f2c7f298b47a6665",
  91016: "ad557e7b8c65c51fa66b295a92c532b4",
  91017: "61012735c97e2fc784aa51f523ae2f93",
  91018: "5e8e624fd5b6d74ca7d83ba62b4c9800",
  91019: "6e1687a37d8d79211ea68c978dda9c22",
  91020: "79e1014d940abff4817c20e212879523",
  91021: "ccc51fa457a61ef8931649431b50df82",
  91022: "0ea8bee5db8bc8c6fbad5ce1e93e4fa0",
  91023: "137eafe3ac9c3dbbae028d861136ca8b",
  91024: "c7a5e71e72f0bcc966fcb4faf465f463",
  91025: "cdf80beaf4c10dff82454084d6f97f19",
  91026: "80e2f17d9077b84725cfad56d91b8061",
  91027: "0519ca196d1d8e7f236c21f560690d14",
  91028: "f8b2c3bad1d0fc5b44c09588ad67a531",
  91029: "e6b4618cc22976fa7f15c25de8f9f09b",
  91030: "97939f187e820679886169541f213405",
  91031: "0816774ac93b6540bb05c10f9fcde8ea",
  91032: "06074ed75fd5a6786e3bc1906451a427",
  91033: "f973ae2ac243d5b36b175d3860cf1785",
  91034: "813a34d1febe49907715d7e43c51e240",
  91035: "7cad3e13c45a62065e00b03ed7b5bc24",
  91036: "ff53efc5cafb32e7940f50e6d12e696f",
  91037: "7e93a8115c23c6f822a22e7e517767b6",
  91038: "57e9d8c2d070a602eb9aaea2e9359c70",
  91039: "679e62a6fcf494a3189d6bb82bbb3d48",
  91040: "408f0dec5102d990ea1f9fe9987793d2",
  91041: "57adf29139265d230520c88c9f8649c2",
  91042: "85d9fc9d521e6d5250f4c83eae5a77c6",
  91043: "d157913116b2d82c787df22f2b944dd3",
  91044: "967ce5bfab2acc83f855d36c78b5ee1c",
  91045: "e812f802a1c89298b574b7805dbd2387",
  91046: "d65a70a6285be71d03d77c1f67254e0d",
  91047: "4d16604f731e062ca1eff31cd8ef80fd",
  91048: "8da999bc3caf04ca7303ed4c9d3260ce",
  91049: "5f1808fb1fb230ee1bb748fd07396a70",
  91050: "58e4ad1cc05dc5c66e5f9c70c28c3c6f",
  91051: "4b2800a7f3c43851c59ec8eeb31159da",
  91052: "31015d0539339d9b7e5d3a6f0cbe330d",
  91053: "dda5af2fbfad07efc31bd44912dad214",
  91054: "47be73da7e8c3530da0ffa8291df0d85",
  91200: "75cc4bae21bbc643ebcf517decbe3c47",
  92001: "43c8b3ef91522c522267f95a3b1a794d",
  92002: "a921a37b3e7a15048d4e5b691b35bce3",
  92101: "b276273f7c885a64f4be3b89b3206a09",
  92102: "8ed8a523a78f58d47162a6f195f8f2e5",
  92103: "c5b8368debb9450513e4c0c021a7fa99",
  92104: "0e57243b1e59faf0427c37f2dd70eba5",
  92105: "45f48fc52d47df435e65ed349fe00288",
  92200: "6398fa6d48cb589d7fa8825cfddfe8fc",
  92201: "128a191785ea405f0926885c6a52c293",
  92202: "6720421e9151ec96aae3fbb9a57798c0",
  92203: "b72319a884643261c6d23d6c7f63683d",
  92204: "4eb711e1ed97a843cc97ca07efdd21ff",
  92205: "a93b80dc89755efc2f068f73e53ec45b",
  92206: "15adb082d229c63ca71e88f801eea592",
  92207: "b717bb91193b154d9a110205610126c6",
  92208: "be7a7ccb7202ff6ef1c387e4acfce944",
  93001: "9ba81823cb7af9fac3196de19070de51",
  93002: "ae4afb147987ed4476bdc49d17639689",
  93003: "c69991ac69f890f6917c0809f50dcdc0",
  93004: "705dd740f12cb80390b0c09e6f25a114",
  93005: "8264b8f1b0cf7bbbf0c7a495ccf0c162",
  93006: "1ff289b005422d1b91edf763adcd56d0",
  93007: "172c762c10a04a626e377d094f6b860c",
  94001: "87045e4fe7292816c005f7c6959176dc",
  94002: "e40cdfea117b9654db8dbc5350fc7c89",
  95001: "39aae84a1c98b16a85d51953123d9a4d",
  96001: "c06214119345d30d5da6d44dd16bc622"
}, GN = [
  {
    ID: 1,
    Name: "T_28_T_WS_ITEM1"
  },
  {
    ID: 10,
    Name: "T_28_T_WS_ITEM10"
  },
  {
    ID: 100,
    Name: "T_33_LO_WS_ITEM94"
  },
  {
    ID: 101,
    Name: "T_33_LO_WS_ITEM91"
  },
  {
    ID: 102,
    Name: "T_33_LO_WS_ITEM90"
  },
  {
    ID: 103,
    Name: "T_33_LO_WS_ITEM98"
  },
  {
    ID: 104,
    Name: "T_33_LO_WS_ITEM89"
  },
  {
    ID: 105,
    Name: "T_33_LO_WS_ITEM92"
  },
  {
    ID: 106,
    Name: "T_33_LO_WS_ITEM93"
  },
  {
    ID: 107,
    Name: "T_33_LO_WS_ITEM95"
  },
  {
    ID: 108,
    Name: "T_33_LO_WS_ITEM96"
  },
  {
    ID: 109,
    Name: "T_33_LO_WS_ITEM97"
  },
  {
    ID: 11,
    Name: "T_28_T_WS_ITEM11"
  },
  {
    ID: 110,
    Name: "T_33_LO_WS_DTOWER"
  },
  {
    ID: 111,
    Name: "T_33_LO_WS_ZBSPAWNER"
  },
  {
    ID: 112,
    Name: "T_34_LY_WS_PATH"
  },
  {
    ID: 113,
    Name: "T_34_LY_WS_POINT"
  },
  {
    ID: 114,
    Name: "T_33_LO_WS_FORT"
  },
  {
    ID: 115,
    Name: "T_34_LY_WS_PATH"
  },
  {
    ID: 116,
    Name: "T_36_WZY_WS_LOOTPOINT"
  },
  {
    ID: 117,
    Name: "T_35_XYL_WS_CUSTOMTRIGGER"
  },
  {
    ID: 118,
    Name: "T_35_XYL_WS_DOUBLEDOOR"
  },
  {
    ID: 119,
    Name: "T_35_XYL_WS_ROADBLOCK"
  },
  {
    ID: 12,
    Name: "T_28_T_WS_ITEM12"
  },
  {
    ID: 120,
    Name: "T_35_XYL_WS_STAIRS"
  },
  {
    ID: 121,
    Name: "T_35_XYL_WS_STAIRSL"
  },
  {
    ID: 122,
    Name: "T_35_XYL_WS_STAIRSZ"
  },
  {
    ID: 123,
    Name: "T_35_XYL_WS_TBOOTH"
  },
  {
    ID: 124,
    Name: "T_35_XYL_WS_BISWALL"
  },
  {
    ID: 125,
    Name: "T_35_XYL_WS_BISPARTERRE"
  },
  {
    ID: 126,
    Name: "T_36_JH_WS_VENDMACHINE"
  },
  {
    ID: 127,
    Name: "T_36_XYL_WS_ZOMBIEAI"
  },
  {
    ID: 128,
    Name: "T_36_XYL_WS_AIGENERATOR"
  },
  {
    ID: 129,
    Name: "T_13_I_COLLECTION_V_ROADSTER"
  },
  {
    ID: 130,
    Name: "T_13_I_COLLECTION_V_TUTU"
  },
  {
    ID: 131,
    Name: "T_36_XYL_WS_BREAKBOX"
  },
  {
    ID: 132,
    Name: "T_16_P_MANUAL_SUV"
  },
  {
    ID: 133,
    Name: "T_13_I_COLLECTION_V_MOTOBIKE"
  },
  {
    ID: 134,
    Name: "T_16_P_MANUAL_MONSTER"
  },
  {
    ID: 135,
    Name: "T_36_JH_WS_CREATEGOLD"
  },
  {
    ID: 136,
    Name: "T_36_XYL_WS_STAIRI"
  },
  {
    ID: 137,
    Name: "T_36_XYL_WS_ARROW"
  },
  {
    ID: 138,
    Name: "T_36_XYL_WS_FENCE"
  },
  {
    ID: 139,
    Name: "T_37_XYL_CUSTOMJERSEY"
  },
  {
    ID: 14,
    Name: "T_28_T_WS_ITEM14"
  },
  {
    ID: 140,
    Name: "T_37_XYL_SOCCER"
  },
  {
    ID: 141,
    Name: "T_37_XYL_WS_PILLA001"
  },
  {
    ID: 142,
    Name: "T_37_XYL_SOCCERGOAL"
  },
  {
    ID: 143,
    Name: "T_32_LO_WS_ITEM86"
  },
  {
    ID: 144,
    Name: "T_37_KK_WS_SNOWMAN"
  },
  {
    ID: 145,
    Name: "T_37_XYL_WS_PRESENT"
  },
  {
    ID: 146,
    Name: "T_37_XYL_WS_COCONUTTREE"
  },
  {
    ID: 147,
    Name: "T_37_XYL_WS_BOUGAINVILLEA"
  },
  {
    ID: 148,
    Name: "T_37_XYL_WS_BUSHCOVER"
  },
  {
    ID: 149,
    Name: "T_37_XYL_WS_BARREL001"
  },
  {
    ID: 150,
    Name: "T_37_XYL_WS_ROADBLOCK001"
  },
  {
    ID: 151,
    Name: "T_37_XYL_WS_YELLOWDUCK001"
  },
  {
    ID: 152,
    Name: "T_37_XYL_WS_PUMPKINCUT"
  },
  {
    ID: 153,
    Name: "T_37_XYL_WS_WALL001"
  },
  {
    ID: 154,
    Name: "T_37_XYL_WS_HUGEHOUSE001"
  },
  {
    ID: 155,
    Name: "T_37_XYL_WS_HUGEHOUSE002"
  },
  {
    ID: 156,
    Name: "T_37_XYL_WS_BOOK001"
  },
  {
    ID: 157,
    Name: "T_37_XYL_WS_COMPUTER001"
  },
  {
    ID: 158,
    Name: "T_37_XYL_WS_PUMPKIN"
  },
  {
    ID: 159,
    Name: "T_37_XYL_WS_JACKSTRAW"
  },
  {
    ID: 16,
    Name: "T_28_T_WS_ITEM16"
  },
  {
    ID: 160,
    Name: "T_37_XYL_WS_CABINET001"
  },
  {
    ID: 161,
    Name: "T_37_XYL_WS_PACKBOX"
  },
  {
    ID: 162,
    Name: "T_37_XYL_WS_SOFA001"
  },
  {
    ID: 163,
    Name: "T_37_XYL_WS_TABLE001"
  },
  {
    ID: 164,
    Name: "T_37_XYL_WS_BOX001"
  },
  {
    ID: 165,
    Name: "T_37_XYL_WS_WOOD001"
  },
  {
    ID: 166,
    Name: "T_37_XYL_WS_SUPPLYBOX"
  },
  {
    ID: 167,
    Name: "T_37_XYL_WS_TARGET001"
  },
  {
    ID: 168,
    Name: "T_37_XYL_WS_FIREEX"
  },
  {
    ID: 169,
    Name: "T_37_XYL_WS_TABLE002"
  },
  {
    ID: 17,
    Name: "T_28_T_WS_ITEM17"
  },
  {
    ID: 170,
    Name: "T_37_XYL_WS_TOOLRACK"
  },
  {
    ID: 171,
    Name: "T_37_XYL_WS_BOX002"
  },
  {
    ID: 172,
    Name: "T_37_XYL_WS_OILDRUM"
  },
  {
    ID: 173,
    Name: "T_37_XYL_WS_GUIDEPOSE"
  },
  {
    ID: 174,
    Name: "T_37_XYL_WS_BAFFLE001"
  },
  {
    ID: 175,
    Name: "T_37_XYL_WS_LADDER001"
  },
  {
    ID: 176,
    Name: "T_37_XYL_WS_TIRES001"
  },
  {
    ID: 177,
    Name: "T_37_XYL_WS_AIRCONDITIONER001"
  },
  {
    ID: 178,
    Name: "T_37_XYL_WS_AMMUCHEST"
  },
  {
    ID: 179,
    Name: "T_37_XYL_WS_SHELF001"
  },
  {
    ID: 18,
    Name: "T_28_T_WS_ITEM18"
  },
  {
    ID: 180,
    Name: "T_37_XYL_WS_BOOK002"
  },
  {
    ID: 181,
    Name: "T_37_XYL_WS_ORNAMENT001"
  },
  {
    ID: 182,
    Name: "T_37_XYL_WS_CHAIR001"
  },
  {
    ID: 183,
    Name: "T_37_XYL_WS_BOARD001"
  },
  {
    ID: 184,
    Name: "T_37_XYL_SOCCERITEM"
  },
  {
    ID: 185,
    Name: "T_37_XYL_WS_TELEPORTNEW"
  },
  {
    ID: 186,
    Name: "T_37_XYL_WS_TELEPORTEND"
  },
  {
    ID: 187,
    Name: "TXT_OB10_JRW_CAMOUFLAGE_OILDRUM_NAME"
  },
  {
    ID: 188,
    Name: "T_38_XYL_WS_GRAVITYAREA"
  },
  {
    ID: 189,
    Name: "T_37_WZY_WS_WEAPONENT"
  },
  {
    ID: 19,
    Name: "T_28_T_WS_ITEM13"
  },
  {
    ID: 190,
    Name: "T_38_XXJ_WS_CUSTOMCAMARA"
  },
  {
    ID: 191,
    Name: "T_38_XYL_WS_FENCE002"
  },
  {
    ID: 192,
    Name: "T_38_XYL_WS_ENTERANCEHOUSE01"
  },
  {
    ID: 193,
    Name: "T_38_XYL_WS_DAMAGEDTRUCK"
  },
  {
    ID: 194,
    Name: "T_38_XYL_WS_BONFIRE"
  },
  {
    ID: 195,
    Name: "T_38_XYL_WS_SOFA002"
  },
  {
    ID: 196,
    Name: "T_38_XYL_WS_LIGHTTUBE001"
  },
  {
    ID: 197,
    Name: "T_38_XYL_WS_TV001"
  },
  {
    ID: 198,
    Name: "T_38_XYL_WS_CANNON01"
  },
  {
    ID: 199,
    Name: "T_38_XYL_WS_TOWNHOUSE01"
  },
  {
    ID: 2,
    Name: "T_28_T_WS_ITEM2"
  },
  {
    ID: 20,
    Name: "T_28_T_WS_ITEM15"
  },
  {
    ID: 200,
    Name: "T_38_XYL_WS_CANDLE01"
  },
  {
    ID: 201,
    Name: "T_38_XYL_WS_DOLL01"
  },
  {
    ID: 202,
    Name: "T_38_XYL_WS_FIREWORK01"
  },
  {
    ID: 203,
    Name: "T_38_XYL_WS_LOVELAMP01"
  },
  {
    ID: 204,
    Name: "T_38_XYL_WS_LOVESIGN01"
  },
  {
    ID: 205,
    Name: "T_38_XYL_WS_ROSE01"
  },
  {
    ID: 206,
    Name: "T_38_XYL_WS_ROSEN"
  },
  {
    ID: 207,
    Name: "T_38_XYL_WS_LOVEBALLOON01"
  },
  {
    ID: 208,
    Name: "T_34_M_WS_VFX"
  },
  {
    ID: 209,
    Name: "T_38_WZY_WS_SPHERENAME"
  },
  {
    ID: 21,
    Name: "T_28_T_WS_ITEM19"
  },
  {
    ID: 210,
    Name: "T_37_XYL_WS_BUSHCOVER"
  },
  {
    ID: 211,
    Name: "T_39_WZY_WS_CONENAME"
  },
  {
    ID: 212,
    Name: "T_39_WZY_WS_CYLINDERNAME"
  },
  {
    ID: 213,
    Name: "T_39_SP_WS_ITEMENTITY_01"
  },
  {
    ID: 215,
    Name: "T_39_XYL_WS_WATERZONE"
  },
  {
    ID: 216,
    Name: "T_16_P_MANUAL_STROP"
  },
  {
    ID: 217,
    Name: "T_39_XYL_WS_POINTLIGHT"
  },
  {
    ID: 218,
    Name: "T_39_HJ_WS_Arrow002"
  },
  {
    ID: 22,
    Name: "T_28_T_WS_ITEM20"
  },
  {
    ID: 220,
    Name: "T_32_LO_WS_ITEM87"
  },
  {
    ID: 221,
    Name: "TXT_OB10_JRW_CAMOUFLAGE_OILDRUM_NAME"
  },
  {
    ID: 222,
    Name: "T_40_WZY_WS_TEXTENTITY_NAME"
  },
  {
    ID: 223,
    Name: "T_40_WZY_WS_ICONENTITY_NAME"
  },
  {
    ID: 224,
    Name: "T_34_M_WS_VFX"
  },
  {
    ID: 225,
    Name: "T_40_XYL_WS_ICEDANCEDOOL"
  },
  {
    ID: 226,
    Name: "T_40_XYL_WS_FERRISWHEEL"
  },
  {
    ID: 227,
    Name: "T_34_M_WS_VFX"
  },
  {
    ID: 228,
    Name: "T_40_XYL_WS_SKYSCRAPER_A001"
  },
  {
    ID: 229,
    Name: "T_40_XYL_WS_SKYSCRAPER_A002"
  },
  {
    ID: 23,
    Name: "T_28_T_WS_ITEM21"
  },
  {
    ID: 230,
    Name: "T_40_XYL_WS_SKYSCRAPER_A003"
  },
  {
    ID: 231,
    Name: "T_40_XYL_WS_SKYSCRAPER_B001"
  },
  {
    ID: 232,
    Name: "T_40_XYL_WS_SKYSCRAPER_B002"
  },
  {
    ID: 233,
    Name: "T_40_XYL_WS_SKYSCRAPER_B003"
  },
  {
    ID: 234,
    Name: "T_40_XYL_WS_SKYSCRAPER_C001"
  },
  {
    ID: 235,
    Name: "T_40_XYL_WS_SKYSCRAPER_C002"
  },
  {
    ID: 236,
    Name: "T_40_XYL_WS_SKYSCRAPER_C003"
  },
  {
    ID: 237,
    Name: "T_40_WZY_WS_CUSTOMTRIGGER_CAPSULE"
  },
  {
    ID: 238,
    Name: "T_40_WZY_WS_CUSTOMTRIGGER_SPHERE"
  },
  {
    ID: 239,
    Name: "T_41_XYL_WS_REFCUBE"
  },
  {
    ID: 24,
    Name: "T_29_M_WS_ITEM22"
  },
  {
    ID: 240,
    Name: "T_40_XYL_WS_BUMPERFACTORY"
  },
  {
    ID: 241,
    Name: "T_41_XYL_WS_TOYCUBE"
  },
  {
    ID: 242,
    Name: "T_40_XYL_WS_SKYSCRAPER_D001"
  },
  {
    ID: 243,
    Name: "T_40_XYL_WS_SKYSCRAPER_D002"
  },
  {
    ID: 244,
    Name: "T_40_XYL_WS_SKYSCRAPER_D003"
  },
  {
    ID: 245,
    Name: "T_40_XYL_WS_SKYSCRAPER_E001"
  },
  {
    ID: 246,
    Name: "T_40_XYL_WS_SKYSCRAPER_E002"
  },
  {
    ID: 247,
    Name: "T_40_XYL_WS_SKYSCRAPER_E003"
  },
  {
    ID: 248,
    Name: "T_40_XYL_WS_ICAROUSEL003"
  },
  {
    ID: 249,
    Name: "T_40_XYL_WS_ICAROUSEL001"
  },
  {
    ID: 25,
    Name: "T_29_M_WS_ITEM23"
  },
  {
    ID: 250,
    Name: "T_40_XYL_WS_ICAROUSEL002"
  },
  {
    ID: 251,
    Name: "T_30_XH_PCMAP_P17"
  },
  {
    ID: 252,
    Name: "T_40_XYL_WS_CRANEMACHINE"
  },
  {
    ID: 253,
    Name: "T_40_XYL_WS_DISPLAYBOARD"
  },
  {
    ID: 254,
    Name: "T_40_XYL_WS_PODIUM"
  },
  {
    ID: 255,
    Name: "T_40_XYL_WS_LOLLIPOP"
  },
  {
    ID: 256,
    Name: "T_40_XYL_WS_FOODTRUCK002"
  },
  {
    ID: 257,
    Name: "T_40_WH_MP_EXCH_COIN"
  },
  {
    ID: 258,
    Name: "T_40_WH_MP_EXCH_TEMPCOIN"
  },
  {
    ID: 259,
    Name: "T_40_WH_MP_C_PACK"
  },
  {
    ID: 26,
    Name: "T_29_M_WS_ITEM24"
  },
  {
    ID: 260,
    Name: "T_40_WH_MP_PAYCHECK"
  },
  {
    ID: 261,
    Name: "T_40_WH_MP_BOXING_NAME"
  },
  {
    ID: 262,
    Name: "T_41_XYL_WS_ITEM262"
  },
  {
    ID: 263,
    Name: "T_41_XYL_WS_ITEM263"
  },
  {
    ID: 264,
    Name: "T_41_XYL_WS_ITEM264"
  },
  {
    ID: 265,
    Name: "T_41_XYL_WS_ITEM265"
  },
  {
    ID: 266,
    Name: "T_41_XYL_WS_ITEM266"
  },
  {
    ID: 267,
    Name: "T_41_XYL_WS_ITEM267"
  },
  {
    ID: 268,
    Name: "T_41_XYL_WS_ITEM268"
  },
  {
    ID: 269,
    Name: "T_41_XYL_WS_ITEM269"
  },
  {
    ID: 27,
    Name: "T_29_M_WS_ITEM25"
  },
  {
    ID: 270,
    Name: "T_41_XYL_WS_ITEM270"
  },
  {
    ID: 271,
    Name: "T_41_XYL_WS_ITEM271"
  },
  {
    ID: 272,
    Name: "T_31_Z_OB_UAV"
  },
  {
    ID: 273,
    Name: "T_42_SJ_WS_PLANENAME"
  },
  {
    ID: 274,
    Name: "T_40_XXJ_WS_SOUNDNTITY_NAMEKEY"
  },
  {
    ID: 275,
    Name: "T_42_XYL_WS_ITEM275"
  },
  {
    ID: 276,
    Name: "T_42_XYL_WS_ITEM276"
  },
  {
    ID: 277,
    Name: "T_42_XYL_WS_ITEM277"
  },
  {
    ID: 278,
    Name: "T_42_XYL_WS_ITEM278"
  },
  {
    ID: 279,
    Name: "T_42_XYL_WS_ITEM279"
  },
  {
    ID: 28,
    Name: "T_30_T_WS_ITEM26"
  },
  {
    ID: 280,
    Name: "T_42_XYL_WS_ITEM280"
  },
  {
    ID: 281,
    Name: "T_42_XYL_WS_ITEM281"
  },
  {
    ID: 282,
    Name: "T_42_XYL_WS_ITEM282"
  },
  {
    ID: 283,
    Name: "T_42_XYL_WS_ITEM283"
  },
  {
    ID: 284,
    Name: "T_42_XYL_WS_ITEM284"
  },
  {
    ID: 285,
    Name: "T_42_XYL_WS_ITEM285"
  },
  {
    ID: 286,
    Name: "T_42_XYL_WS_ITEM286"
  },
  {
    ID: 287,
    Name: "T_42_XYL_WS_ITEM287"
  },
  {
    ID: 288,
    Name: "T_42_XYL_WS_ITEM288"
  },
  {
    ID: 289,
    Name: "T_42_XYL_WS_ITEM289"
  },
  {
    ID: 29,
    Name: "T_30_T_WS_ITEM27"
  },
  {
    ID: 290,
    Name: "T_42_XYL_WS_ITEM290"
  },
  {
    ID: 291,
    Name: "T_42_XYL_WS_ITEM291"
  },
  {
    ID: 292,
    Name: "T_42_XYL_WS_ITEM292"
  },
  {
    ID: 293,
    Name: "T_42_XYL_WS_ITEM293"
  },
  {
    ID: 294,
    Name: "T_42_XYL_WS_ITEM294"
  },
  {
    ID: 295,
    Name: "T_42_XYL_WS_ITEM295"
  },
  {
    ID: 296,
    Name: "T_42_XXJ_WS_CLOCK"
  },
  {
    ID: 297,
    Name: "T_42_XYL_WS_ITEM297TRUE"
  },
  {
    ID: 298,
    Name: "T_42_XYL_WS_ITEM298"
  },
  {
    ID: 299,
    Name: "T_42_XYL_WS_ITEM299"
  },
  {
    ID: 3,
    Name: "T_28_T_WS_ITEM3"
  },
  {
    ID: 30,
    Name: "T_30_T_WS_ITEM28"
  },
  {
    ID: 300,
    Name: "T_42_XYL_WS_ITEM300"
  },
  {
    ID: 301,
    Name: "T_42_XYL_WS_ITEM301"
  },
  {
    ID: 302,
    Name: "T_42_XYL_WS_ITEM302"
  },
  {
    ID: 303,
    Name: "T_42_XYL_WS_ITEM303"
  },
  {
    ID: 304,
    Name: "T_42_XYL_WS_ITEM304"
  },
  {
    ID: 305,
    Name: "T_42_XYL_WS_ITEM305"
  },
  {
    ID: 306,
    Name: "T_42_XYL_WS_ITEM306"
  },
  {
    ID: 307,
    Name: "T_42_XYL_WS_ITEM307"
  },
  {
    ID: 308,
    Name: "T_42_XYL_WS_ITEM308"
  },
  {
    ID: 309,
    Name: "T_42_XYL_WS_ITEM309"
  },
  {
    ID: 31,
    Name: "T_30_T_WS_ITEM29"
  },
  {
    ID: 310,
    Name: "T_42_XYL_WS_ITEM310"
  },
  {
    ID: 311,
    Name: "T_42_XYL_WS_ITEM311"
  },
  {
    ID: 312,
    Name: "T_42_XYL_WS_ITEM312"
  },
  {
    ID: 313,
    Name: "T_42_XYL_WS_ITEM313"
  },
  {
    ID: 314,
    Name: "T_42_XYL_WS_ITEM314"
  },
  {
    ID: 315,
    Name: "Toilet1"
  },
  {
    ID: 316,
    Name: "Toilet2"
  },
  {
    ID: 317,
    Name: "T_43_SJ_WS_AIRDROP_NAME"
  },
  {
    ID: 318,
    Name: "T_43_SJ_WS_TRIGGER_ANIMA"
  },
  {
    ID: 319,
    Name: "T_43_ZY_WS_ITEM319"
  },
  {
    ID: 32,
    Name: "T_30_T_WS_ITEM30"
  },
  {
    ID: 320,
    Name: "T_43_ZY_WS_ITEM320"
  },
  {
    ID: 321,
    Name: "T_43_ZY_WS_ITEM321"
  },
  {
    ID: 322,
    Name: "T_43_ZY_WS_ITEM322"
  },
  {
    ID: 323,
    Name: "T_43_ZY_WS_ITEM323"
  },
  {
    ID: 324,
    Name: "T_43_ZY_WS_ITEM324"
  },
  {
    ID: 325,
    Name: "T_43_ZY_WS_ITEM325"
  },
  {
    ID: 326,
    Name: "T_43_YU_WS_ITEM363"
  },
  {
    ID: 327,
    Name: "T_43_ZY_WS_ITEM327"
  },
  {
    ID: 328,
    Name: "T_43_ZY_WS_ITEM328"
  },
  {
    ID: 329,
    Name: "T_43_ZY_WS_ITEM329"
  },
  {
    ID: 33,
    Name: "T_30_T_WS_ITEM31"
  },
  {
    ID: 330,
    Name: "T_43_ZY_WS_ITEM330"
  },
  {
    ID: 331,
    Name: "T_43_YU_WS_ITEM331"
  },
  {
    ID: 332,
    Name: "T_43_YU_WS_ITEM332"
  },
  {
    ID: 333,
    Name: "T_43_YU_WS_ITEM333"
  },
  {
    ID: 334,
    Name: "T_43_YU_WS_ITEM334"
  },
  {
    ID: 335,
    Name: "T_43_YU_WS_ITEM335"
  },
  {
    ID: 336,
    Name: "T_43_YU_WS_ITEM336"
  },
  {
    ID: 337,
    Name: "T_43_YU_WS_ITEM337"
  },
  {
    ID: 338,
    Name: "T_43_YU_WS_ITEM338"
  },
  {
    ID: 339,
    Name: "T_43_YU_WS_ITEM339"
  },
  {
    ID: 34,
    Name: "T_30_T_WS_ITEM32"
  },
  {
    ID: 340,
    Name: "T_43_YU_WS_ITEM340"
  },
  {
    ID: 341,
    Name: "T_43_YU_WS_ITEM341"
  },
  {
    ID: 342,
    Name: "T_43_YU_WS_ITEM342"
  },
  {
    ID: 343,
    Name: "T_43_YU_WS_ITEM343"
  },
  {
    ID: 344,
    Name: "T_43_YU_WS_ITEM344"
  },
  {
    ID: 345,
    Name: "T_43_YU_WS_ITEM345"
  },
  {
    ID: 346,
    Name: "T_43_YU_WS_ITEM346"
  },
  {
    ID: 347,
    Name: "T_43_YU_WS_ITEM347"
  },
  {
    ID: 348,
    Name: "T_43_YU_WS_ITEM348"
  },
  {
    ID: 349,
    Name: "T_43_YU_WS_ITEM349"
  },
  {
    ID: 35,
    Name: "T_30_T_WS_ITEM33"
  },
  {
    ID: 350,
    Name: "T_43_YU_WS_ITEM350"
  },
  {
    ID: 351,
    Name: "T_43_YU_WS_ITEM351"
  },
  {
    ID: 352,
    Name: "T_43_YU_WS_ITEM352"
  },
  {
    ID: 353,
    Name: "T_43_YU_WS_ITEM353"
  },
  {
    ID: 354,
    Name: "T_43_YU_WS_ITEM354"
  },
  {
    ID: 355,
    Name: "T_43_YU_WS_ITEM355"
  },
  {
    ID: 356,
    Name: "T_43_YU_WS_ITEM356"
  },
  {
    ID: 357,
    Name: "T_43_YU_WS_ITEM357"
  },
  {
    ID: 358,
    Name: "T_43_YU_WS_ITEM358"
  },
  {
    ID: 359,
    Name: "T_43_YU_WS_ITEM359"
  },
  {
    ID: 36,
    Name: "T_30_T_WS_ITEM34"
  },
  {
    ID: 360,
    Name: "T_43_YU_WS_ITEM360"
  },
  {
    ID: 361,
    Name: "T_43_YU_WS_ITEM361"
  },
  {
    ID: 362,
    Name: "T_43_YU_WS_ITEM362"
  },
  {
    ID: 363,
    Name: "T_43_ZY_WS_ITEM326"
  },
  {
    ID: 364,
    Name: "T_44_XYL_WS_CTZSAFEZONE"
  },
  {
    ID: 365,
    Name: "T_46_XYL_WS_CTZSAFEZONEEND"
  },
  {
    ID: 366,
    Name: "T_44_YU_WS_ITEM366"
  },
  {
    ID: 367,
    Name: "T_44_YU_WS_ITEM367"
  },
  {
    ID: 368,
    Name: "T_44_YU_WS_ITEM368"
  },
  {
    ID: 369,
    Name: "T_44_YU_WS_ITEM369"
  },
  {
    ID: 37,
    Name: "T_30_T_WS_ITEM35"
  },
  {
    ID: 370,
    Name: "T_44_YU_WS_ITEM370"
  },
  {
    ID: 371,
    Name: "T_44_YU_WS_ITEM371"
  },
  {
    ID: 372,
    Name: "T_44_YU_WS_ITEM372"
  },
  {
    ID: 373,
    Name: "T_44_YU_WS_ITEM373"
  },
  {
    ID: 374,
    Name: "T_44_YU_WS_ITEM374"
  },
  {
    ID: 375,
    Name: "T_44_YU_WS_ITEM375"
  },
  {
    ID: 376,
    Name: "T_44_YU_WS_ITEM376"
  },
  {
    ID: 377,
    Name: "T_44_YU_WS_ITEM377"
  },
  {
    ID: 378,
    Name: "T_44_YU_WS_ITEM378"
  },
  {
    ID: 379,
    Name: "T_44_YU_WS_ITEM379"
  },
  {
    ID: 38,
    Name: "T_30_T_WS_ITEM36"
  },
  {
    ID: 380,
    Name: "T_44_YU_WS_ITEM380"
  },
  {
    ID: 381,
    Name: "T_44_XYL_WS_SQUAREPYRAMID"
  },
  {
    ID: 382,
    Name: "T_44_XYL_WS_TRIANGULARPYRAMID"
  },
  {
    ID: 383,
    Name: "T_44_XYL_WS_QUARTERCYLINDER"
  },
  {
    ID: 384,
    Name: "T_44_XYL_WS_TORUS"
  },
  {
    ID: 385,
    Name: "T_44_XYL_WS_HEMISPHERICALSHELL"
  },
  {
    ID: 386,
    Name: "T_47_XYL_UGC_DONKEYCART"
  },
  {
    ID: 387,
    Name: "T_45_SJ_WS_VAULTTRIGGER_NAME"
  },
  {
    ID: 388,
    Name: "T_46_XXJ_WS_NPC"
  },
  {
    ID: 389,
    Name: "T_45_W_SPEEDMODE_FLIGHT_N"
  },
  {
    ID: 39,
    Name: "T_30_T_WS_ITEM37"
  },
  {
    ID: 390,
    Name: "T_47_XYL_UGC_SPOTLIGHT"
  },
  {
    ID: 391,
    Name: "路点"
  },
  {
    ID: 392,
    Name: "自定义曲线"
  },
  {
    ID: 4,
    Name: "T_28_T_WS_ITEM4"
  },
  {
    ID: 40,
    Name: "T_30_T_WS_ITEM38"
  },
  {
    ID: 41,
    Name: "T_30_T_WS_ITEM39"
  },
  {
    ID: 42,
    Name: "T_30_T_WS_ITEM40"
  },
  {
    ID: 43,
    Name: "T_30_T_WS_ITEM41"
  },
  {
    ID: 44,
    Name: "T_30_T_WS_ITEM42"
  },
  {
    ID: 45,
    Name: "T_30_T_WS_ITEM43"
  },
  {
    ID: 46,
    Name: "T_30_T_WS_ITEM44"
  },
  {
    ID: 47,
    Name: "T_30_T_WS_ITEM45"
  },
  {
    ID: 48,
    Name: "T_30_T_WS_ITEM46"
  },
  {
    ID: 49,
    Name: "T_30_T_WS_ITEM47"
  },
  {
    ID: 5,
    Name: "T_28_T_WS_ITEM5"
  },
  {
    ID: 50,
    Name: "T_31_T_WS_ITEM48"
  },
  {
    ID: 51,
    Name: "T_31_T_WS_ITEM49"
  },
  {
    ID: 52,
    Name: "T_31_T_WS_ITEM49"
  },
  {
    ID: 53,
    Name: "T_31_T_WS_ITEM51"
  },
  {
    ID: 54,
    Name: "T_31_T_WS_ITEM51"
  },
  {
    ID: 55,
    Name: "T_31_T_WS_ITEM53"
  },
  {
    ID: 56,
    Name: "T_31_T_WS_ITEM53"
  },
  {
    ID: 57,
    Name: "T_31_T_WS_ITEM55"
  },
  {
    ID: 58,
    Name: "T_31_T_WS_ITEM55"
  },
  {
    ID: 59,
    Name: "T_31_T_WS_ITEM57"
  },
  {
    ID: 6,
    Name: "T_28_T_WS_ITEM6"
  },
  {
    ID: 60,
    Name: "T_31_T_WS_ITEM57"
  },
  {
    ID: 61,
    Name: "T_31_T_WS_ITEM59"
  },
  {
    ID: 62,
    Name: "T_32_LO_WS_ITEM76"
  },
  {
    ID: 63,
    Name: "T_32_LO_WS_ITEM77"
  },
  {
    ID: 64,
    Name: "T_32_LO_WS_ITEM78"
  },
  {
    ID: 65,
    Name: "T_32_LO_WS_ITEM79"
  },
  {
    ID: 66,
    Name: "T_32_LO_WS_ITEM80"
  },
  {
    ID: 67,
    Name: "T_32_LO_WS_ITEM81"
  },
  {
    ID: 68,
    Name: "T_32_LO_WS_ITEM82"
  },
  {
    ID: 69,
    Name: "T_32_LO_WS_ITEM83"
  },
  {
    ID: 7,
    Name: "T_28_T_WS_ITEM7"
  },
  {
    ID: 70,
    Name: "T_32_LO_WS_ITEM84W"
  },
  {
    ID: 71,
    Name: "T_32_LO_WS_ITEM84AMMO"
  },
  {
    ID: 72,
    Name: "T_32_LO_WS_ITEM84CO"
  },
  {
    ID: 73,
    Name: "T_32_LO_WS_ITEM84JA"
  },
  {
    ID: 74,
    Name: "T_32_LO_WS_ITEM84AR"
  },
  {
    ID: 75,
    Name: "T_32_LO_WS_ITEM84TE"
  },
  {
    ID: 76,
    Name: "T_32_LO_WS_ITEM60"
  },
  {
    ID: 77,
    Name: "T_32_LO_WS_ITEM61"
  },
  {
    ID: 78,
    Name: "T_32_LO_WS_ITEM62"
  },
  {
    ID: 79,
    Name: "T_32_LO_WS_ITEM63"
  },
  {
    ID: 8,
    Name: "T_28_T_WS_ITEM8"
  },
  {
    ID: 80,
    Name: "T_32_LO_WS_ITEM65"
  },
  {
    ID: 81,
    Name: "T_32_LO_WS_ITEM66"
  },
  {
    ID: 82,
    Name: "T_32_LO_WS_ITEM67"
  },
  {
    ID: 83,
    Name: "T_32_LO_WS_ITEM68"
  },
  {
    ID: 84,
    Name: "T_32_LO_WS_ITEM69"
  },
  {
    ID: 85,
    Name: "T_32_LO_WS_ITEM70"
  },
  {
    ID: 86,
    Name: "T_32_LO_WS_ITEM71"
  },
  {
    ID: 87,
    Name: "T_32_LO_WS_ITEM72"
  },
  {
    ID: 88,
    Name: "T_32_LO_WS_ITEM73"
  },
  {
    ID: 89,
    Name: "T_32_LO_WS_ITEM74"
  },
  {
    ID: 9,
    Name: "T_28_T_WS_ITEM9"
  },
  {
    ID: 90,
    Name: "T_32_LO_WS_ITEM75"
  },
  {
    ID: 9001,
    Name: "T_47_XYL_NB_UGC_EFFECT008"
  },
  {
    ID: 9002,
    Name: "T_47_XYL_NB_UGC_EFFECT001"
  },
  {
    ID: 9003,
    Name: "T_47_XYL_NB_UGC_EFFECT001"
  },
  {
    ID: 9004,
    Name: "T_47_XYL_NB_UGC_EFFECT002"
  },
  {
    ID: 9005,
    Name: "T_47_XYL_NB_UGC_EFFECT003"
  },
  {
    ID: 9006,
    Name: "T_47_XYL_NB_UGC_EFFECT004"
  },
  {
    ID: 9007,
    Name: "T_47_XYL_NB_UGC_EFFECT005"
  },
  {
    ID: 9008,
    Name: "T_47_XYL_NB_UGC_EFFECT005"
  },
  {
    ID: 9009,
    Name: "T_47_XYL_NB_UGC_EFFECT006"
  },
  {
    ID: 9010,
    Name: "T_47_XYL_NB_UGC_EFFECT006"
  },
  {
    ID: 9011,
    Name: "T_47_XYL_NB_UGC_EFFECT007"
  },
  {
    ID: 9012,
    Name: "T_47_XYL_NB_UGC_EFFECT004"
  },
  {
    ID: 9013,
    Name: "T_47_XYL_NB_UGC_EFFECT005"
  },
  {
    ID: 9014,
    Name: "T_47_XYL_NB_UGC_EFFECT005"
  },
  {
    ID: 9015,
    Name: "T_47_XYL_NB_UGC_EFFECT005"
  },
  {
    ID: 9016,
    Name: "T_47_XYL_NB_UGC_EFFECT006"
  },
  {
    ID: 9017,
    Name: "T_47_XYL_NB_UGC_EFFECT006"
  },
  {
    ID: 9018,
    Name: "T_47_XYL_NB_UGC_EFFECT006"
  },
  {
    ID: 9019,
    Name: "T_47_XYL_NB_UGC_EFFECT007"
  },
  {
    ID: 91,
    Name: "T_32_LO_WS_ITEM87"
  },
  {
    ID: 92,
    Name: "T_32_LO_WS_ITEM88"
  },
  {
    ID: 93,
    Name: "T_32_LO_WS_ITEM86"
  },
  {
    ID: 94,
    Name: "T_32_LO_WS_ITEM86L"
  },
  {
    ID: 95,
    Name: "T_32_LO_WS_ITEM64"
  },
  {
    ID: 96,
    Name: "T_32_LO_WS_ITEM85"
  },
  {
    ID: 97,
    Name: "T_32_LO_WS_ITEM85CP"
  },
  {
    ID: 98,
    Name: "T_32_LO_WS_ITEM85TM"
  },
  {
    ID: 99,
    Name: "T_26_V_TRAINING_DICE"
  },
  {
    ID: 214,
    Name: "JailBreakArea"
  }
];
function HN() {
  xN(), XN();
}
function xN() {
  Rs.Register(KE, new FN()), Rs.Register(Qh, new wN());
}
function XN() {
  KN(), JN(), jN();
}
function KN() {
  const _ = Rs.Get(KE), s = Rs.Get(Qh);
  s.LoadCsv("WorkshopItemLibrary", YN, "Id");
  const r = s.GetAllDatas("WorkshopItemLibrary");
  for (let i of r) {
    if (!PM(i))
      continue;
    const a = i.Id, E = VN[String(a)];
    E && _.AddGfile(new qh(E, i.ItemKey));
  }
}
function JN() {
  const _ = "150d8a69-8ec4-4ac6-9137-6c6298ecb4d9_";
  GN.forEach((s) => {
    const r = _ + s.ID, i = new qh(r, s.Name);
    Rs.Get(KE).AddGfile(i);
  });
}
function jN() {
  const _ = Rs.Get(KE), s = Rs.Get(Qh);
  s.LoadCsv("WorkshopHudLibrary", UN, "Id");
  const r = s.GetAllDatas("WorkshopHudLibrary");
  for (let i of r) {
    if (!PM(i))
      continue;
    const a = `InternalHud_${i.ResourceId}`;
    _.AddGfile(new qh(a, i.HudKey));
  }
}
let zc = null, oI = !1;
async function zN(_, s, r, i) {
  let a = null;
  if (typeof _ == "string" ? a = document.querySelector(_) : a = _, !a)
    throw new Error("fe-blockly-web: invalid container");
  a.setAttribute("theme-style", "dark-theme"), oI || (HN(), oI = !0), await QN(r);
  const p = {
    theme: i ? "craftlandTheme" : "customTheme",
    renderer: "eca_renderer",
    rendererOverrides: {
      IsCraftland: i
    },
    sounds: !1,
    scrollbars: !0,
    move: {
      drag: !1
    },
    zoom: {
      minScale: 0.1,
      maxScale: 10
    },
    plugins: {
      [g.registry.Type.CONNECTION_CHECKER.toString()]: WN
    }
  }, E = g.inject(a, p);
  if (!E)
    throw new Error("fe-blockly-web: fail to create workspace");
  return E.IsCraftland = i, g.serialization.blocks.append(s, E), tb(E, a), window.addEventListener("resize", DM.bind(null, E)), E;
}
let TI = !1;
async function ZN() {
  if (TI)
    return;
  TI = !0, eb();
  let _ = ON();
  z.graphElementMap = /* @__PURE__ */ new Map();
  const s = mM.CsvToJson(yN);
  for (let r = 0; r < s.length; ++r) {
    let i = s[r], a = i.Division, p = a == null ? void 0 : a.indexOf("/");
    p >= 0 && (a = a.substring(0, p)), i.block_style = a + "_blocks", a = i.category, p = a == null ? void 0 : a.indexOf("/"), p >= 0 && (a = a.substring(0, p)), i.block_style_cl = a + "_blocks";
    let E = i.id;
    if (!E)
      continue;
    z.graphElementMap.set(E, i);
    let h = i.exports;
    if (h == 1 || h == -1)
      continue;
    let L = i.name, y = i.fe_custom;
    if (!L || L === "-" || y == "-")
      continue;
    let V;
    y && (V = _.get(y), V && (V.block_style = i.block_style));
  }
}
async function QN(_) {
  await ZN(), await qN(_);
}
let sI = null;
async function qN(_ = II.English) {
  if (zc == null && (zc = new y0(), N0(zc)), zc.hasLang(_) || await zc.init(_), Ae.CurrentDescriptionFile && sI == _)
    return Ae.CurrentDescriptionFile;
  sI = _, zc.SetLanguage(_), W0();
  const s = new Ae();
  s.SetLocalizeProxy(
    I4({
      Localize: function(h) {
        return Oe(h);
      }
    })
  ), s.SetJsonProxy(
    I4({
      Parse(h) {
        return JSON.parse(h);
      },
      Serialize(h) {
        return JSON.stringify(h);
      }
    })
  ), s.Load(RN);
  let r = new Yt("generic", "PropertyT", "Property");
  r.Attributes = new rt(), r.Attributes.Add(new N_("@Accept", "Property", "")), r.Items = new rt(), r.Items.Add(new N_("", "T0", "Component")), s.DefineType("PropertyT", r);
  let i = new Yt("generic", "$PrefabT", "PrefabID");
  i.m_Label = Oe("FE_39_ZQ_PREFAB_PREFAB"), i.Items = new rt(), i.Items.Add(new N_("", "T0", "Component")), s.DefineType("$PrefabT", i);
  let a = new Yt("generic", "$HudWidgetIDT", "CustomHudWidgetID"), p = s.GetVarType("CustomHudWidgetID");
  a.m_Label = (p == null ? void 0 : p.Label) ?? "HudWidgetID", a.Items = new rt(), a.Items.Add(new N_("", "T0", "HudWidget")), s.DefineType("$HudWidgetIDT", a);
  let E = new Yt("generic", "$InternalHudTypeT", "InternalHudType");
  return E.m_Label = Oe("T_36_WZY_WS_HUDTYPE"), E.Items = new rt(), E.Items.Add(new N_("", "T0", "Component")), s.DefineType("$InternalHudTypeT", E), Ae.CurrentDescriptionFile = s, s;
}
function eb() {
  const _ = g.BlockSvg.prototype.initSvg;
  g.BlockSvg.prototype.initSvg = function() {
    _.apply(this), this.setMovable(!1), this.setEditable(!1), this.setDeletable(!1);
  };
  const { dom: s } = g.utils;
  s.getFastTextWidth = function(i, a, p, E) {
    return s.getFastTextWidthWithSizeString(
      i,
      a + "px",
      // FE
      p,
      E
    );
  }, g.Field.prototype.updateSize_ = function(i) {
    var y;
    const a = this.getConstants(), p = i !== void 0 ? i : this.borderRect_ ? this.getConstants().FIELD_BORDER_RECT_X_PADDING : 0;
    let E = p * 2, h = a.FIELD_TEXT_HEIGHT, L = 0;
    if (this.textElement_ && (L = s.getFastTextWidth(
      this.textElement_,
      a.FIELD_TEXT_FONTSIZE,
      a.FIELD_TEXT_FONTWEIGHT,
      a.FIELD_TEXT_FONTFAMILY
    ), E += L), this.borderRect_) {
      const V = (y = this.getSourceBlock()) != null && y.isShadow() ? a.FIELD_IN_SHADOW_BORDER_RECT_HEIGHT : a.FIELD_BORDER_RECT_HEIGHT;
      h = Math.max(h, V);
    }
    this.size_.height = h, this.size_.width = E, this.positionTextElement_(p, L), this.positionBorderRect_();
  }, g.Gesture.prototype.handleWsStart = function(i, a) {
    return !1;
  }, g.WorkspaceSvg.prototype.getGesture = function() {
    return null;
  }, g.FieldDropdown.prototype.renderSelectedText = function() {
    var Z, le, ce;
    const i = this.getTextContent();
    i && (i.nodeValue = this.getDisplayText_());
    const a = this.getTextElement();
    s.addClass(a, "blocklyDropdownText"), a.setAttribute("text-anchor", "start");
    const p = !!this.borderRect_, E = Math.max(
      p ? this.getConstants().FIELD_DROPDOWN_BORDER_RECT_HEIGHT : 0,
      this.getConstants().FIELD_TEXT_HEIGHT
    ), h = s.getFastTextWidth(
      this.getTextElement(),
      this.getConstants().FIELD_TEXT_FONTSIZE,
      this.getConstants().FIELD_TEXT_FONTWEIGHT,
      this.getConstants().FIELD_TEXT_FONTFAMILY
    ), L = p ? this.getConstants().FIELD_BORDER_RECT_X_PADDING : 0;
    let y = 0;
    if (this.svgArrow && (y = this.positionSVGArrow(
      h + L,
      E / 2 - this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE / 2
    )), this.size_.width = h + y + L * 2, this.size_.height = E, this.positionTextElement_(L, h), (Z = this.getSourceBlock()) != null && Z.isInFlyout)
      return;
    const V = this.textElement_;
    if (V) {
      const ve = this.selectedOption;
      (le = ve == null ? void 0 : ve[3]) != null && le.style ? V.setAttribute("style", (ce = ve == null ? void 0 : ve[3]) == null ? void 0 : ce.style) : V.setAttribute("style", "");
    }
  }, g.blockRendering.RenderInfo.prototype.shouldStartNewRow_ = function(i, a) {
    return i.type == g.inputTypes.DUMMY && i.name.startsWith("NEW_LINE_") ? !0 : a ? i instanceof g.inputs.StatementInput || a instanceof g.inputs.StatementInput ? !0 : i instanceof g.inputs.ValueInput || i instanceof g.inputs.DummyInput ? !this.isInline : !1 : !1;
  };
  const r = g.WorkspaceSvg.prototype.dispose;
  g.WorkspaceSvg.prototype.dispose = function() {
    window.removeEventListener("resize", DM.bind(null, this)), r.apply(this);
  }, g.WorkspaceSvg.prototype.zoomToFit = function() {
    if (!this.isMovable()) {
      console.warn(
        "Tried to move a non-movable workspace. This could result in blocks becoming inaccessible."
      );
      return;
    }
    const i = this.getMetrics();
    let a = i.viewWidth, p = i.viewHeight;
    const E = this.getBlocksBoundingBox();
    let h = E.right - E.left, L = E.bottom - E.top;
    if (!h)
      return;
    const y = this.flyout;
    y && (this.horizontalLayout ? (p += y.getHeight(), L += y.getHeight() / this.scale) : (a += y.getWidth(), h += y.getWidth() / this.scale));
    const V = a / h, Z = p / L;
    g.Events.disable();
    try {
      this.setScale(Math.min(V, Z)), this.scrollCenter();
    } finally {
      g.Events.enable();
    }
    this.maybeFireViewportChangeEvent();
  }, g.Field.prototype.updateEditable = function() {
    const i = this.fieldGroup_, a = this.getSourceBlock();
    !this.EDITABLE || !i || !a || (this.enabled_ && this.EDITABLE ? (s.addClass(i, "blocklyEditableText"), s.removeClass(i, "blocklyNonEditableText")) : (s.addClass(i, "blocklyNonEditableText"), s.removeClass(i, "blocklyEditableText")), this.enabled_ && a.isEditable() ? (s.addClass(i, "blocklyCurrentEditableText"), s.removeClass(i, "blocklyCuurentNonEditableText"), i.style.cursor = this.CURSOR) : (s.addClass(i, "blocklyCurrentEditableText"), s.removeClass(i, "blocklyCuurentNonEditableText"), i.style.cursor = ""));
  }, g.Input.prototype.conditionAppendField = function(i, a, p) {
    return i && this.appendField(a, p), this;
  };
}
function tb(_, s) {
  const i = _.getCanvas().getBBox();
  let { width: a, height: p } = i;
  const E = 12, h = (a / E).toFixed(2), L = (p / E).toFixed(2);
  s.setAttribute("style", `width: ${h}rem; height: ${L}rem`), setTimeout(() => {
    g.svgResize(_);
  }, 0), setTimeout(() => {
    _.zoomToFit();
  }, 60);
}
function DM(_) {
  setTimeout(() => {
    _.zoomToFit();
  }, 0);
}
async function ib(_, s, r, i = !1) {
  let a = s;
  if (typeof s == "string")
    try {
      if (a = JSON.parse(s), typeof a != "object")
        throw new Error("fe-blockly-web: invalid state");
    } catch (E) {
      console.error(E);
      return;
    }
  let p = null;
  try {
    p = await zN(_, a, r, i);
  } catch (E) {
    console.error(E);
  }
  return p;
}
export {
  ib as loadBlocklyState
};
